/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Json: `scalar.Json` as const,
	_RelationSide: "enum" as const,
	_OnDeleteBehaviour: "enum" as const,
	_OrderByDirection: "enum" as const,
	Query:{
		getGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere"
		},
		listGeneral:{
			filter:"GeneralWhere",
			orderBy:"GeneralOrderBy"
		},
		paginateGeneral:{
			filter:"GeneralWhere",
			orderBy:"GeneralOrderBy"
		},
		validateCreateGeneral:{
			data:"GeneralCreateInput"
		},
		validateUpdateGeneral:{
			by:"GeneralUniqueWhere",
			data:"GeneralUpdateInput"
		},
		getImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		listImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		paginateImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		validateCreateImage:{
			data:"ImageCreateInput"
		},
		validateUpdateImage:{
			by:"ImageUniqueWhere",
			data:"ImageUpdateInput"
		},
		getGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere"
		},
		listGenericPage:{
			filter:"GenericPageWhere",
			orderBy:"GenericPageOrderBy"
		},
		paginateGenericPage:{
			filter:"GenericPageWhere",
			orderBy:"GenericPageOrderBy"
		},
		validateCreateGenericPage:{
			data:"GenericPageCreateInput"
		},
		validateUpdateGenericPage:{
			by:"GenericPageUniqueWhere",
			data:"GenericPageUpdateInput"
		},
		getLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		listLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		paginateLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		validateCreateLinkable:{
			data:"LinkableCreateInput"
		},
		validateUpdateLinkable:{
			by:"LinkableUniqueWhere",
			data:"LinkableUpdateInput"
		},
		getSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		listSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		paginateSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		validateCreateSeo:{
			data:"SeoCreateInput"
		},
		validateUpdateSeo:{
			by:"SeoUniqueWhere",
			data:"SeoUpdateInput"
		},
		getContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		listContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		paginateContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		validateCreateContent:{
			data:"ContentCreateInput"
		},
		validateUpdateContent:{
			by:"ContentUniqueWhere",
			data:"ContentUpdateInput"
		},
		getContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		listContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		paginateContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		validateCreateContentBlock:{
			data:"ContentBlockCreateInput"
		},
		validateUpdateContentBlock:{
			by:"ContentBlockUniqueWhere",
			data:"ContentBlockUpdateInput"
		},
		getContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		listContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		paginateContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		validateCreateContentReference:{
			data:"ContentReferenceCreateInput"
		},
		validateUpdateContentReference:{
			by:"ContentReferenceUniqueWhere",
			data:"ContentReferenceUpdateInput"
		},
		getContentReferenceLinkableItem:{
			by:"ContentReferenceLinkableItemUniqueWhere",
			filter:"ContentReferenceLinkableItemWhere"
		},
		listContentReferenceLinkableItem:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		paginateContentReferenceLinkableItem:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		getRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere"
		},
		listRedirect:{
			filter:"RedirectWhere",
			orderBy:"RedirectOrderBy"
		},
		paginateRedirect:{
			filter:"RedirectWhere",
			orderBy:"RedirectOrderBy"
		},
		validateCreateRedirect:{
			data:"RedirectCreateInput"
		},
		validateUpdateRedirect:{
			by:"RedirectUniqueWhere",
			data:"RedirectUpdateInput"
		},
		getLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		listLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		paginateLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		validateCreateLink:{
			data:"LinkCreateInput"
		},
		validateUpdateLink:{
			by:"LinkUniqueWhere",
			data:"LinkUpdateInput"
		},
		getFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere"
		},
		listFooter:{
			filter:"FooterWhere",
			orderBy:"FooterOrderBy"
		},
		paginateFooter:{
			filter:"FooterWhere",
			orderBy:"FooterOrderBy"
		},
		validateCreateFooter:{
			data:"FooterCreateInput"
		},
		validateUpdateFooter:{
			by:"FooterUniqueWhere",
			data:"FooterUpdateInput"
		},
		getFooterLink:{
			by:"FooterLinkUniqueWhere",
			filter:"FooterLinkWhere"
		},
		listFooterLink:{
			filter:"FooterLinkWhere",
			orderBy:"FooterLinkOrderBy"
		},
		paginateFooterLink:{
			filter:"FooterLinkWhere",
			orderBy:"FooterLinkOrderBy"
		},
		validateCreateFooterLink:{
			data:"FooterLinkCreateInput"
		},
		validateUpdateFooterLink:{
			by:"FooterLinkUniqueWhere",
			data:"FooterLinkUpdateInput"
		},
		getFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		listFooterLocale:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		paginateFooterLocale:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		validateCreateFooterLocale:{
			data:"FooterLocaleCreateInput"
		},
		validateUpdateFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			data:"FooterLocaleUpdateInput"
		},
		getGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		listGenericPageLocale:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		paginateGenericPageLocale:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		validateCreateGenericPageLocale:{
			data:"GenericPageLocaleCreateInput"
		},
		validateUpdateGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			data:"GenericPageLocaleUpdateInput"
		},
		getHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere"
		},
		listHeader:{
			filter:"HeaderWhere",
			orderBy:"HeaderOrderBy"
		},
		paginateHeader:{
			filter:"HeaderWhere",
			orderBy:"HeaderOrderBy"
		},
		validateCreateHeader:{
			data:"HeaderCreateInput"
		},
		validateUpdateHeader:{
			by:"HeaderUniqueWhere",
			data:"HeaderUpdateInput"
		},
		getHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		listHeaderLocale:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		paginateHeaderLocale:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		validateCreateHeaderLocale:{
			data:"HeaderLocaleCreateInput"
		},
		validateUpdateHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			data:"HeaderLocaleUpdateInput"
		},
		getLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		listLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		paginateLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		validateCreateLocale:{
			data:"LocaleCreateInput"
		},
		validateUpdateLocale:{
			by:"LocaleUniqueWhere",
			data:"LocaleUpdateInput"
		},
		getSeoDefault:{
			by:"SeoDefaultUniqueWhere",
			filter:"SeoDefaultWhere"
		},
		listSeoDefault:{
			filter:"SeoDefaultWhere",
			orderBy:"SeoDefaultOrderBy"
		},
		paginateSeoDefault:{
			filter:"SeoDefaultWhere",
			orderBy:"SeoDefaultOrderBy"
		},
		validateCreateSeoDefault:{
			data:"SeoDefaultCreateInput"
		},
		validateUpdateSeoDefault:{
			by:"SeoDefaultUniqueWhere",
			data:"SeoDefaultUpdateInput"
		},
		getSeoDefaultLocale:{
			by:"SeoDefaultLocaleUniqueWhere",
			filter:"SeoDefaultLocaleWhere"
		},
		listSeoDefaultLocale:{
			filter:"SeoDefaultLocaleWhere",
			orderBy:"SeoDefaultLocaleOrderBy"
		},
		paginateSeoDefaultLocale:{
			filter:"SeoDefaultLocaleWhere",
			orderBy:"SeoDefaultLocaleOrderBy"
		},
		validateCreateSeoDefaultLocale:{
			data:"SeoDefaultLocaleCreateInput"
		},
		validateUpdateSeoDefaultLocale:{
			by:"SeoDefaultLocaleUniqueWhere",
			data:"SeoDefaultLocaleUpdateInput"
		},
		getBusiness:{
			by:"BusinessUniqueWhere",
			filter:"BusinessWhere"
		},
		listBusiness:{
			filter:"BusinessWhere",
			orderBy:"BusinessOrderBy"
		},
		paginateBusiness:{
			filter:"BusinessWhere",
			orderBy:"BusinessOrderBy"
		},
		validateCreateBusiness:{
			data:"BusinessCreateInput"
		},
		validateUpdateBusiness:{
			by:"BusinessUniqueWhere",
			data:"BusinessUpdateInput"
		},
		getBusinessPage:{
			by:"BusinessPageUniqueWhere",
			filter:"BusinessPageWhere"
		},
		listBusinessPage:{
			filter:"BusinessPageWhere",
			orderBy:"BusinessPageOrderBy"
		},
		paginateBusinessPage:{
			filter:"BusinessPageWhere",
			orderBy:"BusinessPageOrderBy"
		},
		validateCreateBusinessPage:{
			data:"BusinessPageCreateInput"
		},
		validateUpdateBusinessPage:{
			by:"BusinessPageUniqueWhere",
			data:"BusinessPageUpdateInput"
		},
		getBusinessPageLocale:{
			by:"BusinessPageLocaleUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		listBusinessPageLocale:{
			filter:"BusinessPageLocaleWhere",
			orderBy:"BusinessPageLocaleOrderBy"
		},
		paginateBusinessPageLocale:{
			filter:"BusinessPageLocaleWhere",
			orderBy:"BusinessPageLocaleOrderBy"
		},
		validateCreateBusinessPageLocale:{
			data:"BusinessPageLocaleCreateInput"
		},
		validateUpdateBusinessPageLocale:{
			by:"BusinessPageLocaleUniqueWhere",
			data:"BusinessPageLocaleUpdateInput"
		},
		getIcon:{
			by:"IconUniqueWhere",
			filter:"IconWhere"
		},
		listIcon:{
			filter:"IconWhere",
			orderBy:"IconOrderBy"
		},
		paginateIcon:{
			filter:"IconWhere",
			orderBy:"IconOrderBy"
		},
		validateCreateIcon:{
			data:"IconCreateInput"
		},
		validateUpdateIcon:{
			by:"IconUniqueWhere",
			data:"IconUpdateInput"
		},
		getJobPage:{
			by:"JobPageUniqueWhere",
			filter:"JobPageWhere"
		},
		listJobPage:{
			filter:"JobPageWhere",
			orderBy:"JobPageOrderBy"
		},
		paginateJobPage:{
			filter:"JobPageWhere",
			orderBy:"JobPageOrderBy"
		},
		validateCreateJobPage:{
			data:"JobPageCreateInput"
		},
		validateUpdateJobPage:{
			by:"JobPageUniqueWhere",
			data:"JobPageUpdateInput"
		},
		getJobPageLocale:{
			by:"JobPageLocaleUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		listJobPageLocale:{
			filter:"JobPageLocaleWhere",
			orderBy:"JobPageLocaleOrderBy"
		},
		paginateJobPageLocale:{
			filter:"JobPageLocaleWhere",
			orderBy:"JobPageLocaleOrderBy"
		},
		validateCreateJobPageLocale:{
			data:"JobPageLocaleCreateInput"
		},
		validateUpdateJobPageLocale:{
			by:"JobPageLocaleUniqueWhere",
			data:"JobPageLocaleUpdateInput"
		},
		getKeyInfoItem:{
			by:"KeyInfoItemUniqueWhere",
			filter:"KeyInfoItemWhere"
		},
		listKeyInfoItem:{
			filter:"KeyInfoItemWhere",
			orderBy:"KeyInfoItemOrderBy"
		},
		paginateKeyInfoItem:{
			filter:"KeyInfoItemWhere",
			orderBy:"KeyInfoItemOrderBy"
		},
		validateCreateKeyInfoItem:{
			data:"KeyInfoItemCreateInput"
		},
		validateUpdateKeyInfoItem:{
			by:"KeyInfoItemUniqueWhere",
			data:"KeyInfoItemUpdateInput"
		},
		getKeyInfoList:{
			by:"KeyInfoListUniqueWhere",
			filter:"KeyInfoListWhere"
		},
		listKeyInfoList:{
			filter:"KeyInfoListWhere",
			orderBy:"KeyInfoListOrderBy"
		},
		paginateKeyInfoList:{
			filter:"KeyInfoListWhere",
			orderBy:"KeyInfoListOrderBy"
		},
		validateCreateKeyInfoList:{
			data:"KeyInfoListCreateInput"
		},
		validateUpdateKeyInfoList:{
			by:"KeyInfoListUniqueWhere",
			data:"KeyInfoListUpdateInput"
		},
		getContractType:{
			by:"ContractTypeUniqueWhere",
			filter:"ContractTypeWhere"
		},
		listContractType:{
			filter:"ContractTypeWhere",
			orderBy:"ContractTypeOrderBy"
		},
		paginateContractType:{
			filter:"ContractTypeWhere",
			orderBy:"ContractTypeOrderBy"
		},
		validateCreateContractType:{
			data:"ContractTypeCreateInput"
		},
		validateUpdateContractType:{
			by:"ContractTypeUniqueWhere",
			data:"ContractTypeUpdateInput"
		},
		getContractTypeLocale:{
			by:"ContractTypeLocaleUniqueWhere",
			filter:"ContractTypeLocaleWhere"
		},
		listContractTypeLocale:{
			filter:"ContractTypeLocaleWhere",
			orderBy:"ContractTypeLocaleOrderBy"
		},
		paginateContractTypeLocale:{
			filter:"ContractTypeLocaleWhere",
			orderBy:"ContractTypeLocaleOrderBy"
		},
		validateCreateContractTypeLocale:{
			data:"ContractTypeLocaleCreateInput"
		},
		validateUpdateContractTypeLocale:{
			by:"ContractTypeLocaleUniqueWhere",
			data:"ContractTypeLocaleUpdateInput"
		},
		getJobCity:{
			by:"JobCityUniqueWhere",
			filter:"JobCityWhere"
		},
		listJobCity:{
			filter:"JobCityWhere",
			orderBy:"JobCityOrderBy"
		},
		paginateJobCity:{
			filter:"JobCityWhere",
			orderBy:"JobCityOrderBy"
		},
		validateCreateJobCity:{
			data:"JobCityCreateInput"
		},
		validateUpdateJobCity:{
			by:"JobCityUniqueWhere",
			data:"JobCityUpdateInput"
		},
		getJobCityLocale:{
			by:"JobCityLocaleUniqueWhere",
			filter:"JobCityLocaleWhere"
		},
		listJobCityLocale:{
			filter:"JobCityLocaleWhere",
			orderBy:"JobCityLocaleOrderBy"
		},
		paginateJobCityLocale:{
			filter:"JobCityLocaleWhere",
			orderBy:"JobCityLocaleOrderBy"
		},
		validateCreateJobCityLocale:{
			data:"JobCityLocaleCreateInput"
		},
		validateUpdateJobCityLocale:{
			by:"JobCityLocaleUniqueWhere",
			data:"JobCityLocaleUpdateInput"
		},
		getJobPosition:{
			by:"JobPositionUniqueWhere",
			filter:"JobPositionWhere"
		},
		listJobPosition:{
			filter:"JobPositionWhere",
			orderBy:"JobPositionOrderBy"
		},
		paginateJobPosition:{
			filter:"JobPositionWhere",
			orderBy:"JobPositionOrderBy"
		},
		validateCreateJobPosition:{
			data:"JobPositionCreateInput"
		},
		validateUpdateJobPosition:{
			by:"JobPositionUniqueWhere",
			data:"JobPositionUpdateInput"
		},
		getJobPositionLocale:{
			by:"JobPositionLocaleUniqueWhere",
			filter:"JobPositionLocaleWhere"
		},
		listJobPositionLocale:{
			filter:"JobPositionLocaleWhere",
			orderBy:"JobPositionLocaleOrderBy"
		},
		paginateJobPositionLocale:{
			filter:"JobPositionLocaleWhere",
			orderBy:"JobPositionLocaleOrderBy"
		},
		validateCreateJobPositionLocale:{
			data:"JobPositionLocaleCreateInput"
		},
		validateUpdateJobPositionLocale:{
			by:"JobPositionLocaleUniqueWhere",
			data:"JobPositionLocaleUpdateInput"
		},
		getGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere"
		},
		listGallery:{
			filter:"GalleryWhere",
			orderBy:"GalleryOrderBy"
		},
		paginateGallery:{
			filter:"GalleryWhere",
			orderBy:"GalleryOrderBy"
		},
		validateCreateGallery:{
			data:"GalleryCreateInput"
		},
		validateUpdateGallery:{
			by:"GalleryUniqueWhere",
			data:"GalleryUpdateInput"
		},
		getHomePage:{
			by:"HomePageUniqueWhere",
			filter:"HomePageWhere"
		},
		listHomePage:{
			filter:"HomePageWhere",
			orderBy:"HomePageOrderBy"
		},
		paginateHomePage:{
			filter:"HomePageWhere",
			orderBy:"HomePageOrderBy"
		},
		validateCreateHomePage:{
			data:"HomePageCreateInput"
		},
		validateUpdateHomePage:{
			by:"HomePageUniqueWhere",
			data:"HomePageUpdateInput"
		},
		getHomePageLocale:{
			by:"HomePageLocaleUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		listHomePageLocale:{
			filter:"HomePageLocaleWhere",
			orderBy:"HomePageLocaleOrderBy"
		},
		paginateHomePageLocale:{
			filter:"HomePageLocaleWhere",
			orderBy:"HomePageLocaleOrderBy"
		},
		validateCreateHomePageLocale:{
			data:"HomePageLocaleCreateInput"
		},
		validateUpdateHomePageLocale:{
			by:"HomePageLocaleUniqueWhere",
			data:"HomePageLocaleUpdateInput"
		},
		getMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		listMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		paginateMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		validateCreateMedium:{
			data:"MediumCreateInput"
		},
		validateUpdateMedium:{
			by:"MediumUniqueWhere",
			data:"MediumUpdateInput"
		},
		getMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere"
		},
		listMediumItem:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		},
		paginateMediumItem:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		},
		validateCreateMediumItem:{
			data:"MediumItemCreateInput"
		},
		validateUpdateMediumItem:{
			by:"MediumItemUniqueWhere",
			data:"MediumItemUpdateInput"
		},
		getMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere"
		},
		listMediumList:{
			filter:"MediumListWhere",
			orderBy:"MediumListOrderBy"
		},
		paginateMediumList:{
			filter:"MediumListWhere",
			orderBy:"MediumListOrderBy"
		},
		validateCreateMediumList:{
			data:"MediumListCreateInput"
		},
		validateUpdateMediumList:{
			by:"MediumListUniqueWhere",
			data:"MediumListUpdateInput"
		},
		getVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		listVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		paginateVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		validateCreateVideo:{
			data:"VideoCreateInput"
		},
		validateUpdateVideo:{
			by:"VideoUniqueWhere",
			data:"VideoUpdateInput"
		},
		getTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere"
		},
		listTextItem:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		},
		paginateTextItem:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		},
		validateCreateTextItem:{
			data:"TextItemCreateInput"
		},
		validateUpdateTextItem:{
			by:"TextItemUniqueWhere",
			data:"TextItemUpdateInput"
		},
		getTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere"
		},
		listTextList:{
			filter:"TextListWhere",
			orderBy:"TextListOrderBy"
		},
		paginateTextList:{
			filter:"TextListWhere",
			orderBy:"TextListOrderBy"
		},
		validateCreateTextList:{
			data:"TextListCreateInput"
		},
		validateUpdateTextList:{
			by:"TextListUniqueWhere",
			data:"TextListUpdateInput"
		},
		getCarousel:{
			by:"CarouselUniqueWhere",
			filter:"CarouselWhere"
		},
		listCarousel:{
			filter:"CarouselWhere",
			orderBy:"CarouselOrderBy"
		},
		paginateCarousel:{
			filter:"CarouselWhere",
			orderBy:"CarouselOrderBy"
		},
		validateCreateCarousel:{
			data:"CarouselCreateInput"
		},
		validateUpdateCarousel:{
			by:"CarouselUniqueWhere",
			data:"CarouselUpdateInput"
		},
		getCarouselItem:{
			by:"CarouselItemUniqueWhere",
			filter:"CarouselItemWhere"
		},
		listCarouselItem:{
			filter:"CarouselItemWhere",
			orderBy:"CarouselItemOrderBy"
		},
		paginateCarouselItem:{
			filter:"CarouselItemWhere",
			orderBy:"CarouselItemOrderBy"
		},
		validateCreateCarouselItem:{
			data:"CarouselItemCreateInput"
		},
		validateUpdateCarouselItem:{
			by:"CarouselItemUniqueWhere",
			data:"CarouselItemUpdateInput"
		},
		getTheme:{
			by:"ThemeUniqueWhere",
			filter:"ThemeWhere"
		},
		listTheme:{
			filter:"ThemeWhere",
			orderBy:"ThemeOrderBy"
		},
		paginateTheme:{
			filter:"ThemeWhere",
			orderBy:"ThemeOrderBy"
		},
		validateCreateTheme:{
			data:"ThemeCreateInput"
		},
		validateUpdateTheme:{
			by:"ThemeUniqueWhere",
			data:"ThemeUpdateInput"
		},
		getBonusBanner:{
			by:"BonusBannerUniqueWhere",
			filter:"BonusBannerWhere"
		},
		listBonusBanner:{
			filter:"BonusBannerWhere",
			orderBy:"BonusBannerOrderBy"
		},
		paginateBonusBanner:{
			filter:"BonusBannerWhere",
			orderBy:"BonusBannerOrderBy"
		},
		validateCreateBonusBanner:{
			data:"BonusBannerCreateInput"
		},
		validateUpdateBonusBanner:{
			by:"BonusBannerUniqueWhere",
			data:"BonusBannerUpdateInput"
		},
		getBonusBannerLocale:{
			by:"BonusBannerLocaleUniqueWhere",
			filter:"BonusBannerLocaleWhere"
		},
		listBonusBannerLocale:{
			filter:"BonusBannerLocaleWhere",
			orderBy:"BonusBannerLocaleOrderBy"
		},
		paginateBonusBannerLocale:{
			filter:"BonusBannerLocaleWhere",
			orderBy:"BonusBannerLocaleOrderBy"
		},
		validateCreateBonusBannerLocale:{
			data:"BonusBannerLocaleCreateInput"
		},
		validateUpdateBonusBannerLocale:{
			by:"BonusBannerLocaleUniqueWhere",
			data:"BonusBannerLocaleUpdateInput"
		},
		getTile:{
			by:"TileUniqueWhere",
			filter:"TileWhere"
		},
		listTile:{
			filter:"TileWhere",
			orderBy:"TileOrderBy"
		},
		paginateTile:{
			filter:"TileWhere",
			orderBy:"TileOrderBy"
		},
		validateCreateTile:{
			data:"TileCreateInput"
		},
		validateUpdateTile:{
			by:"TileUniqueWhere",
			data:"TileUpdateInput"
		},
		getSideBySide:{
			by:"SideBySideUniqueWhere",
			filter:"SideBySideWhere"
		},
		listSideBySide:{
			filter:"SideBySideWhere",
			orderBy:"SideBySideOrderBy"
		},
		paginateSideBySide:{
			filter:"SideBySideWhere",
			orderBy:"SideBySideOrderBy"
		},
		validateCreateSideBySide:{
			data:"SideBySideCreateInput"
		},
		validateUpdateSideBySide:{
			by:"SideBySideUniqueWhere",
			data:"SideBySideUpdateInput"
		},
		getSideBySideItem:{
			by:"SideBySideItemUniqueWhere",
			filter:"SideBySideItemWhere"
		},
		listSideBySideItem:{
			filter:"SideBySideItemWhere",
			orderBy:"SideBySideItemOrderBy"
		},
		paginateSideBySideItem:{
			filter:"SideBySideItemWhere",
			orderBy:"SideBySideItemOrderBy"
		},
		validateCreateSideBySideItem:{
			data:"SideBySideItemCreateInput"
		},
		validateUpdateSideBySideItem:{
			by:"SideBySideItemUniqueWhere",
			data:"SideBySideItemUpdateInput"
		},
		getHomePageLokal:{
			by:"HomePageLokalUniqueWhere",
			filter:"HomePageLokalWhere"
		},
		listHomePageLokal:{
			filter:"HomePageLokalWhere",
			orderBy:"HomePageLokalOrderBy"
		},
		paginateHomePageLokal:{
			filter:"HomePageLokalWhere",
			orderBy:"HomePageLokalOrderBy"
		},
		validateCreateHomePageLokal:{
			data:"HomePageLokalCreateInput"
		},
		validateUpdateHomePageLokal:{
			by:"HomePageLokalUniqueWhere",
			data:"HomePageLokalUpdateInput"
		},
		getHomePageLokalLocale:{
			by:"HomePageLokalLocaleUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		listHomePageLokalLocale:{
			filter:"HomePageLokalLocaleWhere",
			orderBy:"HomePageLokalLocaleOrderBy"
		},
		paginateHomePageLokalLocale:{
			filter:"HomePageLokalLocaleWhere",
			orderBy:"HomePageLokalLocaleOrderBy"
		},
		validateCreateHomePageLokalLocale:{
			data:"HomePageLokalLocaleCreateInput"
		},
		validateUpdateHomePageLokalLocale:{
			by:"HomePageLokalLocaleUniqueWhere",
			data:"HomePageLokalLocaleUpdateInput"
		},
		getSiteSwitcher:{
			by:"SiteSwitcherUniqueWhere",
			filter:"SiteSwitcherWhere"
		},
		listSiteSwitcher:{
			filter:"SiteSwitcherWhere",
			orderBy:"SiteSwitcherOrderBy"
		},
		paginateSiteSwitcher:{
			filter:"SiteSwitcherWhere",
			orderBy:"SiteSwitcherOrderBy"
		},
		validateCreateSiteSwitcher:{
			data:"SiteSwitcherCreateInput"
		},
		validateUpdateSiteSwitcher:{
			by:"SiteSwitcherUniqueWhere",
			data:"SiteSwitcherUpdateInput"
		},
		getGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere"
		},
		listGalleryItem:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		},
		paginateGalleryItem:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		},
		validateCreateGalleryItem:{
			data:"GalleryItemCreateInput"
		},
		validateUpdateGalleryItem:{
			by:"GalleryItemUniqueWhere",
			data:"GalleryItemUpdateInput"
		},
		getJobsForm:{
			by:"JobsFormUniqueWhere",
			filter:"JobsFormWhere"
		},
		listJobsForm:{
			filter:"JobsFormWhere",
			orderBy:"JobsFormOrderBy"
		},
		paginateJobsForm:{
			filter:"JobsFormWhere",
			orderBy:"JobsFormOrderBy"
		},
		validateCreateJobsForm:{
			data:"JobsFormCreateInput"
		},
		validateUpdateJobsForm:{
			by:"JobsFormUniqueWhere",
			data:"JobsFormUpdateInput"
		},
		getJobsFormLocale:{
			by:"JobsFormLocaleUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		listJobsFormLocale:{
			filter:"JobsFormLocaleWhere",
			orderBy:"JobsFormLocaleOrderBy"
		},
		paginateJobsFormLocale:{
			filter:"JobsFormLocaleWhere",
			orderBy:"JobsFormLocaleOrderBy"
		},
		validateCreateJobsFormLocale:{
			data:"JobsFormLocaleCreateInput"
		},
		validateUpdateJobsFormLocale:{
			by:"JobsFormLocaleUniqueWhere",
			data:"JobsFormLocaleUpdateInput"
		},
		getImageTextItem:{
			by:"ImageTextItemUniqueWhere",
			filter:"ImageTextItemWhere"
		},
		listImageTextItem:{
			filter:"ImageTextItemWhere",
			orderBy:"ImageTextItemOrderBy"
		},
		paginateImageTextItem:{
			filter:"ImageTextItemWhere",
			orderBy:"ImageTextItemOrderBy"
		},
		validateCreateImageTextItem:{
			data:"ImageTextItemCreateInput"
		},
		validateUpdateImageTextItem:{
			by:"ImageTextItemUniqueWhere",
			data:"ImageTextItemUpdateInput"
		},
		getImageTextList:{
			by:"ImageTextListUniqueWhere",
			filter:"ImageTextListWhere"
		},
		listImageTextList:{
			filter:"ImageTextListWhere",
			orderBy:"ImageTextListOrderBy"
		},
		paginateImageTextList:{
			filter:"ImageTextListWhere",
			orderBy:"ImageTextListOrderBy"
		},
		validateCreateImageTextList:{
			data:"ImageTextListCreateInput"
		},
		validateUpdateImageTextList:{
			by:"ImageTextListUniqueWhere",
			data:"ImageTextListUpdateInput"
		},
		getJobsFilter:{
			by:"JobsFilterUniqueWhere",
			filter:"JobsFilterWhere"
		},
		listJobsFilter:{
			filter:"JobsFilterWhere",
			orderBy:"JobsFilterOrderBy"
		},
		paginateJobsFilter:{
			filter:"JobsFilterWhere",
			orderBy:"JobsFilterOrderBy"
		},
		validateCreateJobsFilter:{
			data:"JobsFilterCreateInput"
		},
		validateUpdateJobsFilter:{
			by:"JobsFilterUniqueWhere",
			data:"JobsFilterUpdateInput"
		},
		getJobsFilterLocale:{
			by:"JobsFilterLocaleUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		listJobsFilterLocale:{
			filter:"JobsFilterLocaleWhere",
			orderBy:"JobsFilterLocaleOrderBy"
		},
		paginateJobsFilterLocale:{
			filter:"JobsFilterLocaleWhere",
			orderBy:"JobsFilterLocaleOrderBy"
		},
		validateCreateJobsFilterLocale:{
			data:"JobsFilterLocaleCreateInput"
		},
		validateUpdateJobsFilterLocale:{
			by:"JobsFilterLocaleUniqueWhere",
			data:"JobsFilterLocaleUpdateInput"
		},
		getFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere"
		},
		listFile:{
			filter:"FileWhere",
			orderBy:"FileOrderBy"
		},
		paginateFile:{
			filter:"FileWhere",
			orderBy:"FileOrderBy"
		},
		validateCreateFile:{
			data:"FileCreateInput"
		},
		validateUpdateFile:{
			by:"FileUniqueWhere",
			data:"FileUpdateInput"
		},
		getJobFormSubscription:{
			by:"JobFormSubscriptionUniqueWhere",
			filter:"JobFormSubscriptionWhere"
		},
		listJobFormSubscription:{
			filter:"JobFormSubscriptionWhere",
			orderBy:"JobFormSubscriptionOrderBy"
		},
		paginateJobFormSubscription:{
			filter:"JobFormSubscriptionWhere",
			orderBy:"JobFormSubscriptionOrderBy"
		},
		validateCreateJobFormSubscription:{
			data:"JobFormSubscriptionCreateInput"
		},
		validateUpdateJobFormSubscription:{
			by:"JobFormSubscriptionUniqueWhere",
			data:"JobFormSubscriptionUpdateInput"
		},
		getImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere"
		},
		listImageList:{
			filter:"ImageListWhere",
			orderBy:"ImageListOrderBy"
		},
		paginateImageList:{
			filter:"ImageListWhere",
			orderBy:"ImageListOrderBy"
		},
		validateCreateImageList:{
			data:"ImageListCreateInput"
		},
		validateUpdateImageList:{
			by:"ImageListUniqueWhere",
			data:"ImageListUpdateInput"
		},
		getImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere"
		},
		listImageListItem:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		},
		paginateImageListItem:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		},
		validateCreateImageListItem:{
			data:"ImageListItemCreateInput"
		},
		validateUpdateImageListItem:{
			by:"ImageListItemUniqueWhere",
			data:"ImageListItemUpdateInput"
		},
		getJobFormSubscriptionStatus:{
			by:"JobFormSubscriptionStatusUniqueWhere",
			filter:"JobFormSubscriptionStatusWhere"
		},
		listJobFormSubscriptionStatus:{
			filter:"JobFormSubscriptionStatusWhere",
			orderBy:"JobFormSubscriptionStatusOrderBy"
		},
		paginateJobFormSubscriptionStatus:{
			filter:"JobFormSubscriptionStatusWhere",
			orderBy:"JobFormSubscriptionStatusOrderBy"
		},
		validateCreateJobFormSubscriptionStatus:{
			data:"JobFormSubscriptionStatusCreateInput"
		},
		validateUpdateJobFormSubscriptionStatus:{
			by:"JobFormSubscriptionStatusUniqueWhere",
			data:"JobFormSubscriptionStatusUpdateInput"
		},
		getGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		listGeneralLocale:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		paginateGeneralLocale:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		validateCreateGeneralLocale:{
			data:"GeneralLocaleCreateInput"
		},
		validateUpdateGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			data:"GeneralLocaleUpdateInput"
		},
		getStickyBar:{
			by:"StickyBarUniqueWhere",
			filter:"StickyBarWhere"
		},
		listStickyBar:{
			filter:"StickyBarWhere",
			orderBy:"StickyBarOrderBy"
		},
		paginateStickyBar:{
			filter:"StickyBarWhere",
			orderBy:"StickyBarOrderBy"
		},
		validateCreateStickyBar:{
			data:"StickyBarCreateInput"
		},
		validateUpdateStickyBar:{
			by:"StickyBarUniqueWhere",
			data:"StickyBarUpdateInput"
		},
		getRecommendationForm:{
			by:"RecommendationFormUniqueWhere",
			filter:"RecommendationFormWhere"
		},
		listRecommendationForm:{
			filter:"RecommendationFormWhere",
			orderBy:"RecommendationFormOrderBy"
		},
		paginateRecommendationForm:{
			filter:"RecommendationFormWhere",
			orderBy:"RecommendationFormOrderBy"
		},
		validateCreateRecommendationForm:{
			data:"RecommendationFormCreateInput"
		},
		validateUpdateRecommendationForm:{
			by:"RecommendationFormUniqueWhere",
			data:"RecommendationFormUpdateInput"
		},
		getRecommendationFormLocale:{
			by:"RecommendationFormLocaleUniqueWhere",
			filter:"RecommendationFormLocaleWhere"
		},
		listRecommendationFormLocale:{
			filter:"RecommendationFormLocaleWhere",
			orderBy:"RecommendationFormLocaleOrderBy"
		},
		paginateRecommendationFormLocale:{
			filter:"RecommendationFormLocaleWhere",
			orderBy:"RecommendationFormLocaleOrderBy"
		},
		validateCreateRecommendationFormLocale:{
			data:"RecommendationFormLocaleCreateInput"
		},
		validateUpdateRecommendationFormLocale:{
			by:"RecommendationFormLocaleUniqueWhere",
			data:"RecommendationFormLocaleUpdateInput"
		},
		getRecommendationFormSubscription:{
			by:"RecommendationFormSubscriptionUniqueWhere",
			filter:"RecommendationFormSubscriptionWhere"
		},
		listRecommendationFormSubscription:{
			filter:"RecommendationFormSubscriptionWhere",
			orderBy:"RecommendationFormSubscriptionOrderBy"
		},
		paginateRecommendationFormSubscription:{
			filter:"RecommendationFormSubscriptionWhere",
			orderBy:"RecommendationFormSubscriptionOrderBy"
		},
		validateCreateRecommendationFormSubscription:{
			data:"RecommendationFormSubscriptionCreateInput"
		},
		validateUpdateRecommendationFormSubscription:{
			by:"RecommendationFormSubscriptionUniqueWhere",
			data:"RecommendationFormSubscriptionUpdateInput"
		},
		getInfoBox:{
			by:"InfoBoxUniqueWhere",
			filter:"InfoBoxWhere"
		},
		listInfoBox:{
			filter:"InfoBoxWhere",
			orderBy:"InfoBoxOrderBy"
		},
		paginateInfoBox:{
			filter:"InfoBoxWhere",
			orderBy:"InfoBoxOrderBy"
		},
		validateCreateInfoBox:{
			data:"InfoBoxCreateInput"
		},
		validateUpdateInfoBox:{
			by:"InfoBoxUniqueWhere",
			data:"InfoBoxUpdateInput"
		},
		getInfoBoxLocale:{
			by:"InfoBoxLocaleUniqueWhere",
			filter:"InfoBoxLocaleWhere"
		},
		listInfoBoxLocale:{
			filter:"InfoBoxLocaleWhere",
			orderBy:"InfoBoxLocaleOrderBy"
		},
		paginateInfoBoxLocale:{
			filter:"InfoBoxLocaleWhere",
			orderBy:"InfoBoxLocaleOrderBy"
		},
		validateCreateInfoBoxLocale:{
			data:"InfoBoxLocaleCreateInput"
		},
		validateUpdateInfoBoxLocale:{
			by:"InfoBoxLocaleUniqueWhere",
			data:"InfoBoxLocaleUpdateInput"
		},
		getTranslation:{
			by:"TranslationUniqueWhere",
			filter:"TranslationWhere"
		},
		listTranslation:{
			filter:"TranslationWhere",
			orderBy:"TranslationOrderBy"
		},
		paginateTranslation:{
			filter:"TranslationWhere",
			orderBy:"TranslationOrderBy"
		},
		validateCreateTranslation:{
			data:"TranslationCreateInput"
		},
		validateUpdateTranslation:{
			by:"TranslationUniqueWhere",
			data:"TranslationUpdateInput"
		},
		getTranslationLocale:{
			by:"TranslationLocaleUniqueWhere",
			filter:"TranslationLocaleWhere"
		},
		listTranslationLocale:{
			filter:"TranslationLocaleWhere",
			orderBy:"TranslationLocaleOrderBy"
		},
		paginateTranslationLocale:{
			filter:"TranslationLocaleWhere",
			orderBy:"TranslationLocaleOrderBy"
		},
		validateCreateTranslationLocale:{
			data:"TranslationLocaleCreateInput"
		},
		validateUpdateTranslationLocale:{
			by:"TranslationLocaleUniqueWhere",
			data:"TranslationLocaleUpdateInput"
		},
		getCornerBanner:{
			by:"CornerBannerUniqueWhere",
			filter:"CornerBannerWhere"
		},
		listCornerBanner:{
			filter:"CornerBannerWhere",
			orderBy:"CornerBannerOrderBy"
		},
		paginateCornerBanner:{
			filter:"CornerBannerWhere",
			orderBy:"CornerBannerOrderBy"
		},
		validateCreateCornerBanner:{
			data:"CornerBannerCreateInput"
		},
		validateUpdateCornerBanner:{
			by:"CornerBannerUniqueWhere",
			data:"CornerBannerUpdateInput"
		}
	},
	General:{
		locales:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		localesByLocale:{
			by:"GeneralLocalesByLocaleUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		localesBySeo:{
			by:"GeneralLocalesBySeoUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		localesByCornerBanner:{
			by:"GeneralLocalesByCornerBannerUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		paginateLocales:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		}
	},
	UUID: `scalar.UUID` as const,
	One: "enum" as const,
	GeneralLocale:{
		root:{
			filter:"GeneralWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		cornerBanner:{
			filter:"CornerBannerWhere"
		}
	},
	GeneralWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"GeneralLocaleWhere",
		and:"GeneralWhere",
		or:"GeneralWhere",
		not:"GeneralWhere"
	},
	UUIDCondition:{
		and:"UUIDCondition",
		or:"UUIDCondition",
		not:"UUIDCondition",
		eq:"UUID",
		notEq:"UUID",
		in:"UUID",
		notIn:"UUID",
		lt:"UUID",
		lte:"UUID",
		gt:"UUID",
		gte:"UUID"
	},
	OneCondition:{
		and:"OneCondition",
		or:"OneCondition",
		not:"OneCondition",
		eq:"One",
		notEq:"One",
		in:"One",
		notIn:"One",
		lt:"One",
		lte:"One",
		gt:"One",
		gte:"One"
	},
	GeneralLocaleWhere:{
		id:"UUIDCondition",
		root:"GeneralWhere",
		locale:"LocaleWhere",
		seo:"SeoWhere",
		cornerBanner:"CornerBannerWhere",
		and:"GeneralLocaleWhere",
		or:"GeneralLocaleWhere",
		not:"GeneralLocaleWhere"
	},
	LocaleWhere:{
		id:"UUIDCondition",
		code:"StringCondition",
		label:"StringCondition",
		footers:"FooterLocaleWhere",
		genericPages:"GenericPageLocaleWhere",
		headers:"HeaderLocaleWhere",
		seoDefaults:"SeoDefaultLocaleWhere",
		businessPages:"BusinessPageLocaleWhere",
		jobPages:"JobPageLocaleWhere",
		contractTypes:"ContractTypeLocaleWhere",
		jobCities:"JobCityLocaleWhere",
		jobPositions:"JobPositionLocaleWhere",
		homePages:"HomePageLocaleWhere",
		bonusBanners:"BonusBannerLocaleWhere",
		homePageLokals:"HomePageLokalLocaleWhere",
		jobsForms:"JobsFormLocaleWhere",
		jobsFilters:"JobsFilterLocaleWhere",
		general:"GeneralLocaleWhere",
		recommendationForms:"RecommendationFormLocaleWhere",
		infoBoxes:"InfoBoxLocaleWhere",
		translations:"TranslationLocaleWhere",
		and:"LocaleWhere",
		or:"LocaleWhere",
		not:"LocaleWhere"
	},
	StringCondition:{
		and:"StringCondition",
		or:"StringCondition",
		not:"StringCondition"
	},
	FooterLocaleWhere:{
		id:"UUIDCondition",
		email:"StringCondition",
		address:"StringCondition",
		ico:"StringCondition",
		dic:"StringCondition",
		copyright:"StringCondition",
		note:"StringCondition",
		noteSecond:"StringCondition",
		root:"FooterWhere",
		locale:"LocaleWhere",
		linksFirstColumn:"FooterLinkWhere",
		linksSecondColumn:"FooterLinkWhere",
		termsAndConditions:"LinkWhere",
		form:"StringCondition",
		bannerTitle:"StringCondition",
		bannerSubtitle:"StringCondition",
		bannerImage:"ImageWhere",
		bannerLink:"LinkWhere",
		jobsForm:"JobsFormLocaleWhere",
		copyrightLink:"LinkWhere",
		bannerSecondBtn:"StringCondition",
		recommendationForm:"RecommendationFormLocaleWhere",
		bannerSecondLink:"LinkWhere",
		instagramLink:"LinkWhere",
		and:"FooterLocaleWhere",
		or:"FooterLocaleWhere",
		not:"FooterLocaleWhere"
	},
	FooterWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"FooterLocaleWhere",
		and:"FooterWhere",
		or:"FooterWhere",
		not:"FooterWhere"
	},
	FooterLinkWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		link:"LinkWhere",
		and:"FooterLinkWhere",
		or:"FooterLinkWhere",
		not:"FooterLinkWhere"
	},
	IntCondition:{
		and:"IntCondition",
		or:"IntCondition",
		not:"IntCondition"
	},
	LinkWhere:{
		id:"UUIDCondition",
		type:"LinkTypeCondition",
		title:"StringCondition",
		externalLink:"StringCondition",
		internalLink:"LinkableWhere",
		anchorLink:"StringCondition",
		and:"LinkWhere",
		or:"LinkWhere",
		not:"LinkWhere"
	},
	LinkTypeCondition:{
		and:"LinkTypeCondition",
		or:"LinkTypeCondition",
		not:"LinkTypeCondition",
		eq:"LinkType",
		notEq:"LinkType",
		in:"LinkType",
		notIn:"LinkType",
		lt:"LinkType",
		lte:"LinkType",
		gt:"LinkType",
		gte:"LinkType"
	},
	LinkType: "enum" as const,
	LinkableWhere:{
		id:"UUIDCondition",
		url:"StringCondition",
		redirect:"RedirectWhere",
		genericPage:"GenericPageLocaleWhere",
		businessPage:"BusinessPageLocaleWhere",
		jobPage:"JobPageLocaleWhere",
		homePage:"HomePageLocaleWhere",
		homePageLokal:"HomePageLokalLocaleWhere",
		and:"LinkableWhere",
		or:"LinkableWhere",
		not:"LinkableWhere"
	},
	RedirectWhere:{
		id:"UUIDCondition",
		link:"LinkableWhere",
		target:"LinkWhere",
		and:"RedirectWhere",
		or:"RedirectWhere",
		not:"RedirectWhere"
	},
	GenericPageLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		root:"GenericPageWhere",
		locale:"LocaleWhere",
		content:"ContentWhere",
		seo:"SeoWhere",
		link:"LinkableWhere",
		text:"StringCondition",
		logo:"ImageWhere",
		image:"ImageWhere",
		and:"GenericPageLocaleWhere",
		or:"GenericPageLocaleWhere",
		not:"GenericPageLocaleWhere"
	},
	GenericPageWhere:{
		id:"UUIDCondition",
		locales:"GenericPageLocaleWhere",
		theme:"ThemeWhere",
		headerColor:"StringCondition",
		and:"GenericPageWhere",
		or:"GenericPageWhere",
		not:"GenericPageWhere"
	},
	ThemeWhere:{
		id:"UUIDCondition",
		backgroundColor:"StringCondition",
		textColor:"StringCondition",
		name:"StringCondition",
		buttonBackgroundColor:"StringCondition",
		buttonTextColor:"StringCondition",
		buttonBackgroundHoverColor:"StringCondition",
		buttonTextHoverColor:"StringCondition",
		buttonBorderColor:"StringCondition",
		buttonBorderHoverColor:"StringCondition",
		headerMenuColor:"StringCondition",
		and:"ThemeWhere",
		or:"ThemeWhere",
		not:"ThemeWhere"
	},
	ContentWhere:{
		id:"UUIDCondition",
		blocks:"ContentBlockWhere",
		and:"ContentWhere",
		or:"ContentWhere",
		not:"ContentWhere"
	},
	ContentBlockWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		json:"StringCondition",
		content:"ContentWhere",
		references:"ContentReferenceWhere",
		and:"ContentBlockWhere",
		or:"ContentBlockWhere",
		not:"ContentBlockWhere"
	},
	ContentReferenceWhere:{
		id:"UUIDCondition",
		type:"ContentReferenceTypeCondition",
		primaryText:"StringCondition",
		block:"ContentBlockWhere",
		image:"ImageWhere",
		linkables:"ContentReferenceLinkableItemWhere",
		secondaryText:"StringCondition",
		link:"LinkWhere",
		media:"MediumListWhere",
		textList:"TextListWhere",
		carousel:"CarouselWhere",
		bonusBanner:"BonusBannerLocaleWhere",
		sideBySide:"SideBySideWhere",
		gallery:"GalleryWhere",
		showBoolean:"BooleanCondition",
		isRed:"BooleanCondition",
		video:"VideoWhere",
		and:"ContentReferenceWhere",
		or:"ContentReferenceWhere",
		not:"ContentReferenceWhere"
	},
	ContentReferenceTypeCondition:{
		and:"ContentReferenceTypeCondition",
		or:"ContentReferenceTypeCondition",
		not:"ContentReferenceTypeCondition",
		eq:"ContentReferenceType",
		notEq:"ContentReferenceType",
		in:"ContentReferenceType",
		notIn:"ContentReferenceType",
		lt:"ContentReferenceType",
		lte:"ContentReferenceType",
		gt:"ContentReferenceType",
		gte:"ContentReferenceType"
	},
	ContentReferenceType: "enum" as const,
	ImageWhere:{
		id:"UUIDCondition",
		url:"StringCondition",
		width:"IntCondition",
		height:"IntCondition",
		size:"IntCondition",
		type:"StringCondition",
		alt:"StringCondition",
		fileName:"StringCondition",
		focalPointX:"FloatCondition",
		focalPointY:"FloatCondition",
		and:"ImageWhere",
		or:"ImageWhere",
		not:"ImageWhere"
	},
	FloatCondition:{
		and:"FloatCondition",
		or:"FloatCondition",
		not:"FloatCondition"
	},
	ContentReferenceLinkableItemWhere:{
		id:"UUIDCondition",
		item:"LinkableWhere",
		reference:"ContentReferenceWhere",
		and:"ContentReferenceLinkableItemWhere",
		or:"ContentReferenceLinkableItemWhere",
		not:"ContentReferenceLinkableItemWhere"
	},
	MediumListWhere:{
		id:"UUIDCondition",
		items:"MediumItemWhere",
		and:"MediumListWhere",
		or:"MediumListWhere",
		not:"MediumListWhere"
	},
	MediumItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"MediumListWhere",
		medium:"MediumWhere",
		and:"MediumItemWhere",
		or:"MediumItemWhere",
		not:"MediumItemWhere"
	},
	MediumWhere:{
		id:"UUIDCondition",
		type:"MediumTypeCondition",
		image:"ImageWhere",
		video:"VideoWhere",
		and:"MediumWhere",
		or:"MediumWhere",
		not:"MediumWhere"
	},
	MediumTypeCondition:{
		and:"MediumTypeCondition",
		or:"MediumTypeCondition",
		not:"MediumTypeCondition",
		eq:"MediumType",
		notEq:"MediumType",
		in:"MediumType",
		notIn:"MediumType",
		lt:"MediumType",
		lte:"MediumType",
		gt:"MediumType",
		gte:"MediumType"
	},
	MediumType: "enum" as const,
	VideoWhere:{
		id:"UUIDCondition",
		src:"StringCondition",
		width:"IntCondition",
		height:"IntCondition",
		size:"IntCondition",
		type:"StringCondition",
		videoInfo:"StringCondition",
		duration:"FloatCondition",
		poster:"ImageWhere",
		and:"VideoWhere",
		or:"VideoWhere",
		not:"VideoWhere"
	},
	TextListWhere:{
		id:"UUIDCondition",
		items:"TextItemWhere",
		and:"TextListWhere",
		or:"TextListWhere",
		not:"TextListWhere"
	},
	TextItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		text:"StringCondition",
		list:"TextListWhere",
		title:"StringCondition",
		and:"TextItemWhere",
		or:"TextItemWhere",
		not:"TextItemWhere"
	},
	CarouselWhere:{
		id:"UUIDCondition",
		items:"CarouselItemWhere",
		background:"BackgroundCondition",
		squareImages:"BooleanCondition",
		and:"CarouselWhere",
		or:"CarouselWhere",
		not:"CarouselWhere"
	},
	CarouselItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		text:"StringCondition",
		list:"CarouselWhere",
		image:"ImageWhere",
		name:"StringCondition",
		title:"StringCondition",
		linkUrl:"LinkWhere",
		normalAspectRatio:"BooleanCondition",
		isImage:"BooleanCondition",
		video:"VideoWhere",
		and:"CarouselItemWhere",
		or:"CarouselItemWhere",
		not:"CarouselItemWhere"
	},
	BooleanCondition:{
		and:"BooleanCondition",
		or:"BooleanCondition",
		not:"BooleanCondition"
	},
	BackgroundCondition:{
		and:"BackgroundCondition",
		or:"BackgroundCondition",
		not:"BackgroundCondition",
		eq:"Background",
		notEq:"Background",
		in:"Background",
		notIn:"Background",
		lt:"Background",
		lte:"Background",
		gt:"Background",
		gte:"Background"
	},
	Background: "enum" as const,
	BonusBannerLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		text:"StringCondition",
		root:"BonusBannerWhere",
		locale:"LocaleWhere",
		tiles:"TileWhere",
		logo:"ImageWhere",
		bannerName:"StringCondition",
		and:"BonusBannerLocaleWhere",
		or:"BonusBannerLocaleWhere",
		not:"BonusBannerLocaleWhere"
	},
	BonusBannerWhere:{
		id:"UUIDCondition",
		locales:"BonusBannerLocaleWhere",
		and:"BonusBannerWhere",
		or:"BonusBannerWhere",
		not:"BonusBannerWhere"
	},
	TileWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		text:"StringCondition",
		bonusBanner:"BonusBannerLocaleWhere",
		image:"ImageWhere",
		lightBoxTitle:"StringCondition",
		lightBoxText:"StringCondition",
		ligthBoxMedia:"MediumListWhere",
		lightBoxSectionTitle:"StringCondition",
		title:"StringCondition",
		lightBoxLinkLabel:"StringCondition",
		lightBoxForm:"JobsFormLocaleWhere",
		and:"TileWhere",
		or:"TileWhere",
		not:"TileWhere"
	},
	JobsFormLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		jobText:"StringCondition",
		genericText:"StringCondition",
		nameLabel:"StringCondition",
		emailLabel:"StringCondition",
		telefonLabel:"StringCondition",
		fileTitleLabel:"StringCondition",
		fileFormatLabel:"StringCondition",
		formTextLabel:"StringCondition",
		submitLabel:"StringCondition",
		root:"JobsFormWhere",
		locale:"LocaleWhere",
		imageTextList:"ImageTextListWhere",
		minimalize:"StringCondition",
		logo:"ImageWhere",
		successTitle:"StringCondition",
		successText:"StringCondition",
		successBtnLabel:"StringCondition",
		successImage:"ImageWhere",
		successOtherJobsTitle:"StringCondition",
		successOtherJobsCategoryTitle:"StringCondition",
		successOtherJobsButtonTitle:"StringCondition",
		successOtherJobsSelectionTitle:"StringCondition",
		successOtherJobsSelectionYesButton:"StringCondition",
		successOtherJobsSelectionNoButton:"StringCondition",
		fileRemoveBtnLabel:"StringCondition",
		gdprLabel:"StringCondition",
		and:"JobsFormLocaleWhere",
		or:"JobsFormLocaleWhere",
		not:"JobsFormLocaleWhere"
	},
	JobsFormWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"JobsFormLocaleWhere",
		fileIlustration:"ImageWhere",
		and:"JobsFormWhere",
		or:"JobsFormWhere",
		not:"JobsFormWhere"
	},
	ImageTextListWhere:{
		id:"UUIDCondition",
		items:"ImageTextItemWhere",
		and:"ImageTextListWhere",
		or:"ImageTextListWhere",
		not:"ImageTextListWhere"
	},
	ImageTextItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		title:"StringCondition",
		list:"ImageTextListWhere",
		image:"ImageWhere",
		and:"ImageTextItemWhere",
		or:"ImageTextItemWhere",
		not:"ImageTextItemWhere"
	},
	SideBySideWhere:{
		id:"UUIDCondition",
		items:"SideBySideItemWhere",
		background:"BackgroundCondition",
		alignment:"ContentAlignmentCondition",
		mediumSize:"MediumSizeCondition",
		and:"SideBySideWhere",
		or:"SideBySideWhere",
		not:"SideBySideWhere"
	},
	SideBySideItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		title:"StringCondition",
		text:"StringCondition",
		list:"SideBySideWhere",
		media:"MediumListWhere",
		formButtonLabel:"StringCondition",
		type:"SideBySideItemTypeCondition",
		link:"LinkWhere",
		jobsForm:"JobsFormLocaleWhere",
		textNew:"StringCondition",
		and:"SideBySideItemWhere",
		or:"SideBySideItemWhere",
		not:"SideBySideItemWhere"
	},
	SideBySideItemTypeCondition:{
		and:"SideBySideItemTypeCondition",
		or:"SideBySideItemTypeCondition",
		not:"SideBySideItemTypeCondition",
		eq:"SideBySideItemType",
		notEq:"SideBySideItemType",
		in:"SideBySideItemType",
		notIn:"SideBySideItemType",
		lt:"SideBySideItemType",
		lte:"SideBySideItemType",
		gt:"SideBySideItemType",
		gte:"SideBySideItemType"
	},
	SideBySideItemType: "enum" as const,
	ContentAlignmentCondition:{
		and:"ContentAlignmentCondition",
		or:"ContentAlignmentCondition",
		not:"ContentAlignmentCondition",
		eq:"ContentAlignment",
		notEq:"ContentAlignment",
		in:"ContentAlignment",
		notIn:"ContentAlignment",
		lt:"ContentAlignment",
		lte:"ContentAlignment",
		gt:"ContentAlignment",
		gte:"ContentAlignment"
	},
	ContentAlignment: "enum" as const,
	MediumSizeCondition:{
		and:"MediumSizeCondition",
		or:"MediumSizeCondition",
		not:"MediumSizeCondition",
		eq:"MediumSize",
		notEq:"MediumSize",
		in:"MediumSize",
		notIn:"MediumSize",
		lt:"MediumSize",
		lte:"MediumSize",
		gt:"MediumSize",
		gte:"MediumSize"
	},
	MediumSize: "enum" as const,
	GalleryWhere:{
		id:"UUIDCondition",
		items:"GalleryItemWhere",
		and:"GalleryWhere",
		or:"GalleryWhere",
		not:"GalleryWhere"
	},
	GalleryItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"GalleryWhere",
		image:"ImageWhere",
		and:"GalleryItemWhere",
		or:"GalleryItemWhere",
		not:"GalleryItemWhere"
	},
	SeoWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		description:"StringCondition",
		ogTitle:"StringCondition",
		ogDescription:"StringCondition",
		noIndex:"BooleanCondition",
		noFollow:"BooleanCondition",
		ogImage:"ImageWhere",
		and:"SeoWhere",
		or:"SeoWhere",
		not:"SeoWhere"
	},
	BusinessPageLocaleWhere:{
		id:"UUIDCondition",
		root:"BusinessPageWhere",
		locale:"LocaleWhere",
		content:"ContentWhere",
		seo:"SeoWhere",
		link:"LinkableWhere",
		subtitle:"StringCondition",
		text:"StringCondition",
		name:"StringCondition",
		image:"ImageWhere",
		stickyBar:"StickyBarWhere",
		infoBox:"InfoBoxWhere",
		and:"BusinessPageLocaleWhere",
		or:"BusinessPageLocaleWhere",
		not:"BusinessPageLocaleWhere"
	},
	BusinessPageWhere:{
		id:"UUIDCondition",
		locales:"BusinessPageLocaleWhere",
		theme:"ThemeWhere",
		isLokal:"BooleanCondition",
		tabidooId:"StringCondition",
		headerColor:"StringCondition",
		recruitisOfficeId:"StringCondition",
		and:"BusinessPageWhere",
		or:"BusinessPageWhere",
		not:"BusinessPageWhere"
	},
	StickyBarWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		link:"LinkWhere",
		formButtonLabel:"StringCondition",
		jobsForm:"JobsFormLocaleWhere",
		and:"StickyBarWhere",
		or:"StickyBarWhere",
		not:"StickyBarWhere"
	},
	InfoBoxWhere:{
		id:"UUIDCondition",
		logoSize:"LogoSizeCondition",
		logo:"ImageWhere",
		locales:"InfoBoxLocaleWhere",
		and:"InfoBoxWhere",
		or:"InfoBoxWhere",
		not:"InfoBoxWhere"
	},
	LogoSizeCondition:{
		and:"LogoSizeCondition",
		or:"LogoSizeCondition",
		not:"LogoSizeCondition",
		eq:"LogoSize",
		notEq:"LogoSize",
		in:"LogoSize",
		notIn:"LogoSize",
		lt:"LogoSize",
		lte:"LogoSize",
		gt:"LogoSize",
		gte:"LogoSize"
	},
	LogoSize: "enum" as const,
	InfoBoxLocaleWhere:{
		id:"UUIDCondition",
		address:"StringCondition",
		web:"StringCondition",
		instagram:"StringCondition",
		facebook:"StringCondition",
		root:"InfoBoxWhere",
		locale:"LocaleWhere",
		openingHours:"TextListWhere",
		addressLink:"StringCondition",
		and:"InfoBoxLocaleWhere",
		or:"InfoBoxLocaleWhere",
		not:"InfoBoxLocaleWhere"
	},
	JobPageLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		text:"StringCondition",
		root:"JobPageWhere",
		locale:"LocaleWhere",
		image:"ImageWhere",
		keyInfo:"KeyInfoListWhere",
		content:"ContentWhere",
		seo:"SeoWhere",
		link:"LinkableWhere",
		email:"StringCondition",
		stickyBar:"StickyBarWhere",
		mobileImage:"ImageWhere",
		isSyncedToTabidoo:"BooleanCondition",
		tabidooId:"StringCondition",
		recruitisJobId:"StringCondition",
		and:"JobPageLocaleWhere",
		or:"JobPageLocaleWhere",
		not:"JobPageLocaleWhere"
	},
	JobPageWhere:{
		id:"UUIDCondition",
		locales:"JobPageLocaleWhere",
		theme:"ThemeWhere",
		contractType:"ContractTypeWhere",
		jobCity:"JobCityWhere",
		isActive:"BooleanCondition",
		jobPosition:"JobPositionWhere",
		publishedAt:"DateTimeCondition",
		order:"IntCondition",
		isSyncedToTabidoo:"BooleanCondition",
		business:"BusinessPageWhere",
		headerColor:"StringCondition",
		siteType:"SiteTypeCondition",
		isHiddenFromListing:"BooleanCondition",
		and:"JobPageWhere",
		or:"JobPageWhere",
		not:"JobPageWhere"
	},
	ContractTypeWhere:{
		id:"UUIDCondition",
		locales:"ContractTypeLocaleWhere",
		and:"ContractTypeWhere",
		or:"ContractTypeWhere",
		not:"ContractTypeWhere"
	},
	ContractTypeLocaleWhere:{
		id:"UUIDCondition",
		type:"StringCondition",
		root:"ContractTypeWhere",
		locale:"LocaleWhere",
		slug:"StringCondition",
		and:"ContractTypeLocaleWhere",
		or:"ContractTypeLocaleWhere",
		not:"ContractTypeLocaleWhere"
	},
	JobCityWhere:{
		id:"UUIDCondition",
		locales:"JobCityLocaleWhere",
		and:"JobCityWhere",
		or:"JobCityWhere",
		not:"JobCityWhere"
	},
	JobCityLocaleWhere:{
		id:"UUIDCondition",
		root:"JobCityWhere",
		locale:"LocaleWhere",
		name:"StringCondition",
		slug:"StringCondition",
		and:"JobCityLocaleWhere",
		or:"JobCityLocaleWhere",
		not:"JobCityLocaleWhere"
	},
	JobPositionWhere:{
		id:"UUIDCondition",
		locales:"JobPositionLocaleWhere",
		jobs:"JobPageWhere",
		and:"JobPositionWhere",
		or:"JobPositionWhere",
		not:"JobPositionWhere"
	},
	JobPositionLocaleWhere:{
		id:"UUIDCondition",
		type:"StringCondition",
		root:"JobPositionWhere",
		locale:"LocaleWhere",
		slug:"StringCondition",
		and:"JobPositionLocaleWhere",
		or:"JobPositionLocaleWhere",
		not:"JobPositionLocaleWhere"
	},
	DateTimeCondition:{
		and:"DateTimeCondition",
		or:"DateTimeCondition",
		not:"DateTimeCondition",
		eq:"DateTime",
		notEq:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime"
	},
	DateTime: `scalar.DateTime` as const,
	SiteTypeCondition:{
		and:"SiteTypeCondition",
		or:"SiteTypeCondition",
		not:"SiteTypeCondition",
		eq:"SiteType",
		notEq:"SiteType",
		in:"SiteType",
		notIn:"SiteType",
		lt:"SiteType",
		lte:"SiteType",
		gt:"SiteType",
		gte:"SiteType"
	},
	SiteType: "enum" as const,
	KeyInfoListWhere:{
		id:"UUIDCondition",
		items:"KeyInfoItemWhere",
		and:"KeyInfoListWhere",
		or:"KeyInfoListWhere",
		not:"KeyInfoListWhere"
	},
	KeyInfoItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		keyInfo:"StringCondition",
		list:"KeyInfoListWhere",
		icon:"IconWhere",
		and:"KeyInfoItemWhere",
		or:"KeyInfoItemWhere",
		not:"KeyInfoItemWhere"
	},
	IconWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		icon:"ImageWhere",
		and:"IconWhere",
		or:"IconWhere",
		not:"IconWhere"
	},
	HomePageLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		root:"HomePageWhere",
		locale:"LocaleWhere",
		button:"LinkWhere",
		content:"ContentWhere",
		seo:"SeoWhere",
		link:"LinkableWhere",
		logo:"ImageWhere",
		siteSwitcher:"SiteSwitcherWhere",
		gallery:"GalleryWhere",
		stickyBar:"StickyBarWhere",
		text:"StringCondition",
		ilustration:"GalleryWhere",
		and:"HomePageLocaleWhere",
		or:"HomePageLocaleWhere",
		not:"HomePageLocaleWhere"
	},
	HomePageWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"HomePageLocaleWhere",
		theme:"ThemeWhere",
		and:"HomePageWhere",
		or:"HomePageWhere",
		not:"HomePageWhere"
	},
	SiteSwitcherWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		link:"LinkWhere",
		theme:"ThemeWhere",
		headerColor:"StringCondition",
		and:"SiteSwitcherWhere",
		or:"SiteSwitcherWhere",
		not:"SiteSwitcherWhere"
	},
	HomePageLokalLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		root:"HomePageLokalWhere",
		locale:"LocaleWhere",
		logo:"ImageWhere",
		button:"LinkWhere",
		content:"ContentWhere",
		seo:"SeoWhere",
		link:"LinkableWhere",
		siteSwitcher:"SiteSwitcherWhere",
		gallery:"GalleryWhere",
		stickyBar:"StickyBarWhere",
		text:"StringCondition",
		ilustration:"GalleryWhere",
		and:"HomePageLokalLocaleWhere",
		or:"HomePageLokalLocaleWhere",
		not:"HomePageLokalLocaleWhere"
	},
	HomePageLokalWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"HomePageLokalLocaleWhere",
		theme:"ThemeWhere",
		and:"HomePageLokalWhere",
		or:"HomePageLokalWhere",
		not:"HomePageLokalWhere"
	},
	RecommendationFormLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		subtitle:"StringCondition",
		yourEmailLabel:"StringCondition",
		theirEmailLabel:"StringCondition",
		yourName:"StringCondition",
		sendBtnLabel:"StringCondition",
		successTitle:"StringCondition",
		successSubtitle:"StringCondition",
		successButtonClose:"StringCondition",
		root:"RecommendationFormWhere",
		locale:"LocaleWhere",
		and:"RecommendationFormLocaleWhere",
		or:"RecommendationFormLocaleWhere",
		not:"RecommendationFormLocaleWhere"
	},
	RecommendationFormWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"RecommendationFormLocaleWhere",
		successImage:"ImageWhere",
		and:"RecommendationFormWhere",
		or:"RecommendationFormWhere",
		not:"RecommendationFormWhere"
	},
	HeaderLocaleWhere:{
		id:"UUIDCondition",
		root:"HeaderWhere",
		locale:"LocaleWhere",
		menuLabel:"StringCondition",
		menuTitle:"StringCondition",
		menuText:"StringCondition",
		business:"BusinessWhere",
		lokalEnterprise:"BusinessWhere",
		businessSectionTitle:"StringCondition",
		lokalSectionTitle:"StringCondition",
		businessLink:"LinkWhere",
		lokalLink:"LinkWhere",
		and:"HeaderLocaleWhere",
		or:"HeaderLocaleWhere",
		not:"HeaderLocaleWhere"
	},
	HeaderWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"HeaderLocaleWhere",
		logo:"ImageWhere",
		logoMenu:"ImageWhere",
		and:"HeaderWhere",
		or:"HeaderWhere",
		not:"HeaderWhere"
	},
	BusinessWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		logo:"ImageWhere",
		link:"LinkWhere",
		and:"BusinessWhere",
		or:"BusinessWhere",
		not:"BusinessWhere"
	},
	SeoDefaultLocaleWhere:{
		id:"UUIDCondition",
		root:"SeoDefaultWhere",
		locale:"LocaleWhere",
		seo:"SeoWhere",
		and:"SeoDefaultLocaleWhere",
		or:"SeoDefaultLocaleWhere",
		not:"SeoDefaultLocaleWhere"
	},
	SeoDefaultWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"SeoDefaultLocaleWhere",
		and:"SeoDefaultWhere",
		or:"SeoDefaultWhere",
		not:"SeoDefaultWhere"
	},
	JobsFilterLocaleWhere:{
		id:"UUIDCondition",
		jobPositionLabel:"StringCondition",
		jobContractLabel:"StringCondition",
		jobCityLabel:"StringCondition",
		root:"JobsFilterWhere",
		locale:"LocaleWhere",
		bannerTitle:"StringCondition",
		bannerFormLabel:"StringCondition",
		bannerJobsForm:"JobsFormLocaleWhere",
		bannerImage:"ImageWhere",
		noJobTitle:"StringCondition",
		noJobBtnLabel:"StringCondition",
		noJobImage:"ImageWhere",
		noJobTitleForSpecificBusiness:"StringCondition",
		deactivatedJob:"StringCondition",
		and:"JobsFilterLocaleWhere",
		or:"JobsFilterLocaleWhere",
		not:"JobsFilterLocaleWhere"
	},
	JobsFilterWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"JobsFilterLocaleWhere",
		and:"JobsFilterWhere",
		or:"JobsFilterWhere",
		not:"JobsFilterWhere"
	},
	TranslationLocaleWhere:{
		id:"UUIDCondition",
		value:"StringCondition",
		root:"TranslationWhere",
		locale:"LocaleWhere",
		and:"TranslationLocaleWhere",
		or:"TranslationLocaleWhere",
		not:"TranslationLocaleWhere"
	},
	TranslationWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		key:"StringCondition",
		locales:"TranslationLocaleWhere",
		isTextarea:"BooleanCondition",
		and:"TranslationWhere",
		or:"TranslationWhere",
		not:"TranslationWhere"
	},
	CornerBannerWhere:{
		id:"UUIDCondition",
		isActive:"BooleanCondition",
		title:"StringCondition",
		text:"StringCondition",
		logo:"ImageWhere",
		link:"LinkWhere",
		and:"CornerBannerWhere",
		or:"CornerBannerWhere",
		not:"CornerBannerWhere"
	},
	Locale:{
		footers:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		genericPages:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		headers:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		seoDefaults:{
			filter:"SeoDefaultLocaleWhere",
			orderBy:"SeoDefaultLocaleOrderBy"
		},
		businessPages:{
			filter:"BusinessPageLocaleWhere",
			orderBy:"BusinessPageLocaleOrderBy"
		},
		jobPages:{
			filter:"JobPageLocaleWhere",
			orderBy:"JobPageLocaleOrderBy"
		},
		contractTypes:{
			filter:"ContractTypeLocaleWhere",
			orderBy:"ContractTypeLocaleOrderBy"
		},
		jobCities:{
			filter:"JobCityLocaleWhere",
			orderBy:"JobCityLocaleOrderBy"
		},
		jobPositions:{
			filter:"JobPositionLocaleWhere",
			orderBy:"JobPositionLocaleOrderBy"
		},
		homePages:{
			filter:"HomePageLocaleWhere",
			orderBy:"HomePageLocaleOrderBy"
		},
		bonusBanners:{
			filter:"BonusBannerLocaleWhere",
			orderBy:"BonusBannerLocaleOrderBy"
		},
		homePageLokals:{
			filter:"HomePageLokalLocaleWhere",
			orderBy:"HomePageLokalLocaleOrderBy"
		},
		jobsForms:{
			filter:"JobsFormLocaleWhere",
			orderBy:"JobsFormLocaleOrderBy"
		},
		jobsFilters:{
			filter:"JobsFilterLocaleWhere",
			orderBy:"JobsFilterLocaleOrderBy"
		},
		general:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		recommendationForms:{
			filter:"RecommendationFormLocaleWhere",
			orderBy:"RecommendationFormLocaleOrderBy"
		},
		infoBoxes:{
			filter:"InfoBoxLocaleWhere",
			orderBy:"InfoBoxLocaleOrderBy"
		},
		translations:{
			filter:"TranslationLocaleWhere",
			orderBy:"TranslationLocaleOrderBy"
		},
		footersByRoot:{
			by:"LocaleFootersByRootUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByTermsAndConditions:{
			by:"LocaleFootersByTermsAndConditionsUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByBannerImage:{
			by:"LocaleFootersByBannerImageUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByBannerLink:{
			by:"LocaleFootersByBannerLinkUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByJobsForm:{
			by:"LocaleFootersByJobsFormUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByCopyrightLink:{
			by:"LocaleFootersByCopyrightLinkUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByRecommendationForm:{
			by:"LocaleFootersByRecommendationFormUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByBannerSecondLink:{
			by:"LocaleFootersByBannerSecondLinkUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		footersByInstagramLink:{
			by:"LocaleFootersByInstagramLinkUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		genericPagesByRoot:{
			by:"LocaleGenericPagesByRootUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		genericPagesByContent:{
			by:"LocaleGenericPagesByContentUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		genericPagesBySeo:{
			by:"LocaleGenericPagesBySeoUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		genericPagesByLink:{
			by:"LocaleGenericPagesByLinkUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		genericPagesByLogo:{
			by:"LocaleGenericPagesByLogoUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		genericPagesByImage:{
			by:"LocaleGenericPagesByImageUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		headersByRoot:{
			by:"LocaleHeadersByRootUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		headersByBusinessLink:{
			by:"LocaleHeadersByBusinessLinkUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		headersByLokalLink:{
			by:"LocaleHeadersByLokalLinkUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		seoDefaultsByRoot:{
			by:"LocaleSeoDefaultsByRootUniqueWhere",
			filter:"SeoDefaultLocaleWhere"
		},
		seoDefaultsBySeo:{
			by:"LocaleSeoDefaultsBySeoUniqueWhere",
			filter:"SeoDefaultLocaleWhere"
		},
		businessPagesByRoot:{
			by:"LocaleBusinessPagesByRootUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		businessPagesByContent:{
			by:"LocaleBusinessPagesByContentUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		businessPagesBySeo:{
			by:"LocaleBusinessPagesBySeoUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		businessPagesByLink:{
			by:"LocaleBusinessPagesByLinkUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		businessPagesByImage:{
			by:"LocaleBusinessPagesByImageUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		jobPagesByRoot:{
			by:"LocaleJobPagesByRootUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		jobPagesByImage:{
			by:"LocaleJobPagesByImageUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		jobPagesByKeyInfo:{
			by:"LocaleJobPagesByKeyInfoUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		jobPagesByContent:{
			by:"LocaleJobPagesByContentUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		jobPagesBySeo:{
			by:"LocaleJobPagesBySeoUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		jobPagesByLink:{
			by:"LocaleJobPagesByLinkUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		jobPagesByMobileImage:{
			by:"LocaleJobPagesByMobileImageUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		contractTypesByRoot:{
			by:"LocaleContractTypesByRootUniqueWhere",
			filter:"ContractTypeLocaleWhere"
		},
		contractTypesBySlug:{
			by:"LocaleContractTypesBySlugUniqueWhere",
			filter:"ContractTypeLocaleWhere"
		},
		jobCitiesByRoot:{
			by:"LocaleJobCitiesByRootUniqueWhere",
			filter:"JobCityLocaleWhere"
		},
		jobCitiesBySlug:{
			by:"LocaleJobCitiesBySlugUniqueWhere",
			filter:"JobCityLocaleWhere"
		},
		jobPositionsByRoot:{
			by:"LocaleJobPositionsByRootUniqueWhere",
			filter:"JobPositionLocaleWhere"
		},
		jobPositionsBySlug:{
			by:"LocaleJobPositionsBySlugUniqueWhere",
			filter:"JobPositionLocaleWhere"
		},
		homePagesByRoot:{
			by:"LocaleHomePagesByRootUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		homePagesByButton:{
			by:"LocaleHomePagesByButtonUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		homePagesByContent:{
			by:"LocaleHomePagesByContentUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		homePagesBySeo:{
			by:"LocaleHomePagesBySeoUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		homePagesByLink:{
			by:"LocaleHomePagesByLinkUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		homePagesByLogo:{
			by:"LocaleHomePagesByLogoUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		homePagesBySiteSwitcher:{
			by:"LocaleHomePagesBySiteSwitcherUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		homePagesByIlustration:{
			by:"LocaleHomePagesByIlustrationUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		bonusBannersByRoot:{
			by:"LocaleBonusBannersByRootUniqueWhere",
			filter:"BonusBannerLocaleWhere"
		},
		bonusBannersByTiles:{
			by:"LocaleBonusBannersByTilesUniqueWhere",
			filter:"BonusBannerLocaleWhere"
		},
		bonusBannersByLogo:{
			by:"LocaleBonusBannersByLogoUniqueWhere",
			filter:"BonusBannerLocaleWhere"
		},
		homePageLokalsByRoot:{
			by:"LocaleHomePageLokalsByRootUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		homePageLokalsByLogo:{
			by:"LocaleHomePageLokalsByLogoUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		homePageLokalsByButton:{
			by:"LocaleHomePageLokalsByButtonUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		homePageLokalsByContent:{
			by:"LocaleHomePageLokalsByContentUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		homePageLokalsBySeo:{
			by:"LocaleHomePageLokalsBySeoUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		homePageLokalsByLink:{
			by:"LocaleHomePageLokalsByLinkUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		homePageLokalsBySiteSwitcher:{
			by:"LocaleHomePageLokalsBySiteSwitcherUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		homePageLokalsByIlustration:{
			by:"LocaleHomePageLokalsByIlustrationUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		jobsFormsByRoot:{
			by:"LocaleJobsFormsByRootUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		jobsFormsByImageTextList:{
			by:"LocaleJobsFormsByImageTextListUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		jobsFormsByLogo:{
			by:"LocaleJobsFormsByLogoUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		jobsFormsBySuccessImage:{
			by:"LocaleJobsFormsBySuccessImageUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		jobsFiltersByRoot:{
			by:"LocaleJobsFiltersByRootUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		jobsFiltersByBannerJobsForm:{
			by:"LocaleJobsFiltersByBannerJobsFormUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		jobsFiltersByBannerImage:{
			by:"LocaleJobsFiltersByBannerImageUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		jobsFiltersByNoJobImage:{
			by:"LocaleJobsFiltersByNoJobImageUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		generalByRoot:{
			by:"LocaleGeneralByRootUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		generalBySeo:{
			by:"LocaleGeneralBySeoUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		generalByCornerBanner:{
			by:"LocaleGeneralByCornerBannerUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		recommendationFormsByRoot:{
			by:"LocaleRecommendationFormsByRootUniqueWhere",
			filter:"RecommendationFormLocaleWhere"
		},
		infoBoxesByRoot:{
			by:"LocaleInfoBoxesByRootUniqueWhere",
			filter:"InfoBoxLocaleWhere"
		},
		translationsByRoot:{
			by:"LocaleTranslationsByRootUniqueWhere",
			filter:"TranslationLocaleWhere"
		},
		paginateFooters:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		paginateGenericPages:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		paginateHeaders:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		paginateSeoDefaults:{
			filter:"SeoDefaultLocaleWhere",
			orderBy:"SeoDefaultLocaleOrderBy"
		},
		paginateBusinessPages:{
			filter:"BusinessPageLocaleWhere",
			orderBy:"BusinessPageLocaleOrderBy"
		},
		paginateJobPages:{
			filter:"JobPageLocaleWhere",
			orderBy:"JobPageLocaleOrderBy"
		},
		paginateContractTypes:{
			filter:"ContractTypeLocaleWhere",
			orderBy:"ContractTypeLocaleOrderBy"
		},
		paginateJobCities:{
			filter:"JobCityLocaleWhere",
			orderBy:"JobCityLocaleOrderBy"
		},
		paginateJobPositions:{
			filter:"JobPositionLocaleWhere",
			orderBy:"JobPositionLocaleOrderBy"
		},
		paginateHomePages:{
			filter:"HomePageLocaleWhere",
			orderBy:"HomePageLocaleOrderBy"
		},
		paginateBonusBanners:{
			filter:"BonusBannerLocaleWhere",
			orderBy:"BonusBannerLocaleOrderBy"
		},
		paginateHomePageLokals:{
			filter:"HomePageLokalLocaleWhere",
			orderBy:"HomePageLokalLocaleOrderBy"
		},
		paginateJobsForms:{
			filter:"JobsFormLocaleWhere",
			orderBy:"JobsFormLocaleOrderBy"
		},
		paginateJobsFilters:{
			filter:"JobsFilterLocaleWhere",
			orderBy:"JobsFilterLocaleOrderBy"
		},
		paginateGeneral:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		paginateRecommendationForms:{
			filter:"RecommendationFormLocaleWhere",
			orderBy:"RecommendationFormLocaleOrderBy"
		},
		paginateInfoBoxes:{
			filter:"InfoBoxLocaleWhere",
			orderBy:"InfoBoxLocaleOrderBy"
		},
		paginateTranslations:{
			filter:"TranslationLocaleWhere",
			orderBy:"TranslationLocaleOrderBy"
		}
	},
	FooterLocale:{
		root:{
			filter:"FooterWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		linksFirstColumn:{
			filter:"FooterLinkWhere",
			orderBy:"FooterLinkOrderBy"
		},
		linksSecondColumn:{
			filter:"FooterLinkWhere",
			orderBy:"FooterLinkOrderBy"
		},
		termsAndConditions:{
			filter:"LinkWhere"
		},
		bannerImage:{
			filter:"ImageWhere"
		},
		bannerLink:{
			filter:"LinkWhere"
		},
		jobsForm:{
			filter:"JobsFormLocaleWhere"
		},
		copyrightLink:{
			filter:"LinkWhere"
		},
		recommendationForm:{
			filter:"RecommendationFormLocaleWhere"
		},
		bannerSecondLink:{
			filter:"LinkWhere"
		},
		instagramLink:{
			filter:"LinkWhere"
		},
		paginateLinksFirstColumn:{
			filter:"FooterLinkWhere",
			orderBy:"FooterLinkOrderBy"
		},
		paginateLinksSecondColumn:{
			filter:"FooterLinkWhere",
			orderBy:"FooterLinkOrderBy"
		}
	},
	Footer:{
		locales:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		localesByLocale:{
			by:"FooterLocalesByLocaleUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByTermsAndConditions:{
			by:"FooterLocalesByTermsAndConditionsUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByBannerImage:{
			by:"FooterLocalesByBannerImageUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByBannerLink:{
			by:"FooterLocalesByBannerLinkUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByJobsForm:{
			by:"FooterLocalesByJobsFormUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByCopyrightLink:{
			by:"FooterLocalesByCopyrightLinkUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByRecommendationForm:{
			by:"FooterLocalesByRecommendationFormUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByBannerSecondLink:{
			by:"FooterLocalesByBannerSecondLinkUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		localesByInstagramLink:{
			by:"FooterLocalesByInstagramLinkUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		paginateLocales:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		}
	},
	FooterLocaleOrderBy:{
		id:"OrderDirection",
		email:"OrderDirection",
		address:"OrderDirection",
		ico:"OrderDirection",
		dic:"OrderDirection",
		copyright:"OrderDirection",
		note:"OrderDirection",
		noteSecond:"OrderDirection",
		root:"FooterOrderBy",
		locale:"LocaleOrderBy",
		termsAndConditions:"LinkOrderBy",
		form:"OrderDirection",
		bannerTitle:"OrderDirection",
		bannerSubtitle:"OrderDirection",
		bannerImage:"ImageOrderBy",
		bannerLink:"LinkOrderBy",
		jobsForm:"JobsFormLocaleOrderBy",
		copyrightLink:"LinkOrderBy",
		bannerSecondBtn:"OrderDirection",
		recommendationForm:"RecommendationFormLocaleOrderBy",
		bannerSecondLink:"LinkOrderBy",
		instagramLink:"LinkOrderBy"
	},
	OrderDirection: "enum" as const,
	FooterOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	LocaleOrderBy:{
		id:"OrderDirection",
		code:"OrderDirection",
		label:"OrderDirection"
	},
	LinkOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		title:"OrderDirection",
		externalLink:"OrderDirection",
		internalLink:"LinkableOrderBy",
		anchorLink:"OrderDirection"
	},
	LinkableOrderBy:{
		id:"OrderDirection",
		url:"OrderDirection",
		redirect:"RedirectOrderBy",
		genericPage:"GenericPageLocaleOrderBy",
		businessPage:"BusinessPageLocaleOrderBy",
		jobPage:"JobPageLocaleOrderBy",
		homePage:"HomePageLocaleOrderBy",
		homePageLokal:"HomePageLokalLocaleOrderBy"
	},
	RedirectOrderBy:{
		id:"OrderDirection",
		link:"LinkableOrderBy",
		target:"LinkOrderBy"
	},
	GenericPageLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		root:"GenericPageOrderBy",
		locale:"LocaleOrderBy",
		content:"ContentOrderBy",
		seo:"SeoOrderBy",
		link:"LinkableOrderBy",
		text:"OrderDirection",
		logo:"ImageOrderBy",
		image:"ImageOrderBy"
	},
	GenericPageOrderBy:{
		id:"OrderDirection",
		theme:"ThemeOrderBy",
		headerColor:"OrderDirection"
	},
	ThemeOrderBy:{
		id:"OrderDirection",
		backgroundColor:"OrderDirection",
		textColor:"OrderDirection",
		name:"OrderDirection",
		buttonBackgroundColor:"OrderDirection",
		buttonTextColor:"OrderDirection",
		buttonBackgroundHoverColor:"OrderDirection",
		buttonTextHoverColor:"OrderDirection",
		buttonBorderColor:"OrderDirection",
		buttonBorderHoverColor:"OrderDirection",
		headerMenuColor:"OrderDirection"
	},
	ContentOrderBy:{
		id:"OrderDirection"
	},
	SeoOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		description:"OrderDirection",
		ogTitle:"OrderDirection",
		ogDescription:"OrderDirection",
		noIndex:"OrderDirection",
		noFollow:"OrderDirection",
		ogImage:"ImageOrderBy"
	},
	ImageOrderBy:{
		id:"OrderDirection",
		url:"OrderDirection",
		width:"OrderDirection",
		height:"OrderDirection",
		size:"OrderDirection",
		type:"OrderDirection",
		alt:"OrderDirection",
		fileName:"OrderDirection",
		focalPointX:"OrderDirection",
		focalPointY:"OrderDirection"
	},
	BusinessPageLocaleOrderBy:{
		id:"OrderDirection",
		root:"BusinessPageOrderBy",
		locale:"LocaleOrderBy",
		content:"ContentOrderBy",
		seo:"SeoOrderBy",
		link:"LinkableOrderBy",
		subtitle:"OrderDirection",
		text:"OrderDirection",
		name:"OrderDirection",
		image:"ImageOrderBy",
		stickyBar:"StickyBarOrderBy",
		infoBox:"InfoBoxOrderBy"
	},
	BusinessPageOrderBy:{
		id:"OrderDirection",
		theme:"ThemeOrderBy",
		isLokal:"OrderDirection",
		tabidooId:"OrderDirection",
		headerColor:"OrderDirection",
		recruitisOfficeId:"OrderDirection"
	},
	StickyBarOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		link:"LinkOrderBy",
		formButtonLabel:"OrderDirection",
		jobsForm:"JobsFormLocaleOrderBy"
	},
	JobsFormLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		jobText:"OrderDirection",
		genericText:"OrderDirection",
		nameLabel:"OrderDirection",
		emailLabel:"OrderDirection",
		telefonLabel:"OrderDirection",
		fileTitleLabel:"OrderDirection",
		fileFormatLabel:"OrderDirection",
		formTextLabel:"OrderDirection",
		submitLabel:"OrderDirection",
		root:"JobsFormOrderBy",
		locale:"LocaleOrderBy",
		imageTextList:"ImageTextListOrderBy",
		minimalize:"OrderDirection",
		logo:"ImageOrderBy",
		successTitle:"OrderDirection",
		successText:"OrderDirection",
		successBtnLabel:"OrderDirection",
		successImage:"ImageOrderBy",
		successOtherJobsTitle:"OrderDirection",
		successOtherJobsCategoryTitle:"OrderDirection",
		successOtherJobsButtonTitle:"OrderDirection",
		successOtherJobsSelectionTitle:"OrderDirection",
		successOtherJobsSelectionYesButton:"OrderDirection",
		successOtherJobsSelectionNoButton:"OrderDirection",
		fileRemoveBtnLabel:"OrderDirection",
		gdprLabel:"OrderDirection"
	},
	JobsFormOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		fileIlustration:"ImageOrderBy"
	},
	ImageTextListOrderBy:{
		id:"OrderDirection"
	},
	InfoBoxOrderBy:{
		id:"OrderDirection",
		logoSize:"OrderDirection",
		logo:"ImageOrderBy"
	},
	JobPageLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		text:"OrderDirection",
		root:"JobPageOrderBy",
		locale:"LocaleOrderBy",
		image:"ImageOrderBy",
		keyInfo:"KeyInfoListOrderBy",
		content:"ContentOrderBy",
		seo:"SeoOrderBy",
		link:"LinkableOrderBy",
		email:"OrderDirection",
		stickyBar:"StickyBarOrderBy",
		mobileImage:"ImageOrderBy",
		isSyncedToTabidoo:"OrderDirection",
		tabidooId:"OrderDirection",
		recruitisJobId:"OrderDirection"
	},
	JobPageOrderBy:{
		id:"OrderDirection",
		theme:"ThemeOrderBy",
		contractType:"ContractTypeOrderBy",
		jobCity:"JobCityOrderBy",
		isActive:"OrderDirection",
		jobPosition:"JobPositionOrderBy",
		publishedAt:"OrderDirection",
		order:"OrderDirection",
		isSyncedToTabidoo:"OrderDirection",
		business:"BusinessPageOrderBy",
		headerColor:"OrderDirection",
		siteType:"OrderDirection",
		isHiddenFromListing:"OrderDirection"
	},
	ContractTypeOrderBy:{
		id:"OrderDirection"
	},
	JobCityOrderBy:{
		id:"OrderDirection"
	},
	JobPositionOrderBy:{
		id:"OrderDirection"
	},
	KeyInfoListOrderBy:{
		id:"OrderDirection"
	},
	HomePageLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		root:"HomePageOrderBy",
		locale:"LocaleOrderBy",
		button:"LinkOrderBy",
		content:"ContentOrderBy",
		seo:"SeoOrderBy",
		link:"LinkableOrderBy",
		logo:"ImageOrderBy",
		siteSwitcher:"SiteSwitcherOrderBy",
		gallery:"GalleryOrderBy",
		stickyBar:"StickyBarOrderBy",
		text:"OrderDirection",
		ilustration:"GalleryOrderBy"
	},
	HomePageOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		theme:"ThemeOrderBy"
	},
	SiteSwitcherOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		link:"LinkOrderBy",
		theme:"ThemeOrderBy",
		headerColor:"OrderDirection"
	},
	GalleryOrderBy:{
		id:"OrderDirection"
	},
	HomePageLokalLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		root:"HomePageLokalOrderBy",
		locale:"LocaleOrderBy",
		logo:"ImageOrderBy",
		button:"LinkOrderBy",
		content:"ContentOrderBy",
		seo:"SeoOrderBy",
		link:"LinkableOrderBy",
		siteSwitcher:"SiteSwitcherOrderBy",
		gallery:"GalleryOrderBy",
		stickyBar:"StickyBarOrderBy",
		text:"OrderDirection",
		ilustration:"GalleryOrderBy"
	},
	HomePageLokalOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		theme:"ThemeOrderBy"
	},
	RecommendationFormLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		subtitle:"OrderDirection",
		yourEmailLabel:"OrderDirection",
		theirEmailLabel:"OrderDirection",
		yourName:"OrderDirection",
		sendBtnLabel:"OrderDirection",
		successTitle:"OrderDirection",
		successSubtitle:"OrderDirection",
		successButtonClose:"OrderDirection",
		root:"RecommendationFormOrderBy",
		locale:"LocaleOrderBy"
	},
	RecommendationFormOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		successImage:"ImageOrderBy"
	},
	FooterLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	LocaleUniqueWhere:{
		id:"UUID",
		footers:"FooterLocaleUniqueWhere",
		genericPages:"GenericPageLocaleUniqueWhere",
		headers:"HeaderLocaleUniqueWhere",
		seoDefaults:"SeoDefaultLocaleUniqueWhere",
		businessPages:"BusinessPageLocaleUniqueWhere",
		jobPages:"JobPageLocaleUniqueWhere",
		contractTypes:"ContractTypeLocaleUniqueWhere",
		jobCities:"JobCityLocaleUniqueWhere",
		jobPositions:"JobPositionLocaleUniqueWhere",
		homePages:"HomePageLocaleUniqueWhere",
		bonusBanners:"BonusBannerLocaleUniqueWhere",
		homePageLokals:"HomePageLokalLocaleUniqueWhere",
		jobsForms:"JobsFormLocaleUniqueWhere",
		jobsFilters:"JobsFilterLocaleUniqueWhere",
		general:"GeneralLocaleUniqueWhere",
		recommendationForms:"RecommendationFormLocaleUniqueWhere",
		infoBoxes:"InfoBoxLocaleUniqueWhere",
		translations:"TranslationLocaleUniqueWhere"
	},
	FooterLocaleUniqueWhere:{
		id:"UUID",
		root:"FooterUniqueWhere",
		locale:"LocaleUniqueWhere",
		termsAndConditions:"LinkUniqueWhere",
		bannerImage:"ImageUniqueWhere",
		bannerLink:"LinkUniqueWhere",
		jobsForm:"JobsFormLocaleUniqueWhere",
		copyrightLink:"LinkUniqueWhere",
		recommendationForm:"RecommendationFormLocaleUniqueWhere",
		bannerSecondLink:"LinkUniqueWhere",
		instagramLink:"LinkUniqueWhere"
	},
	FooterUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"FooterLocaleUniqueWhere"
	},
	LinkUniqueWhere:{
		id:"UUID"
	},
	ImageUniqueWhere:{
		id:"UUID"
	},
	JobsFormLocaleUniqueWhere:{
		id:"UUID",
		root:"JobsFormUniqueWhere",
		locale:"LocaleUniqueWhere",
		imageTextList:"ImageTextListUniqueWhere",
		logo:"ImageUniqueWhere",
		successImage:"ImageUniqueWhere"
	},
	JobsFormUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"JobsFormLocaleUniqueWhere",
		fileIlustration:"ImageUniqueWhere"
	},
	ImageTextListUniqueWhere:{
		id:"UUID",
		items:"ImageTextItemUniqueWhere"
	},
	ImageTextItemUniqueWhere:{
		id:"UUID",
		image:"ImageUniqueWhere"
	},
	RecommendationFormLocaleUniqueWhere:{
		id:"UUID",
		root:"RecommendationFormUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	RecommendationFormUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"RecommendationFormLocaleUniqueWhere",
		successImage:"ImageUniqueWhere"
	},
	GenericPageLocaleUniqueWhere:{
		id:"UUID",
		root:"GenericPageUniqueWhere",
		locale:"LocaleUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere",
		link:"LinkableUniqueWhere",
		logo:"ImageUniqueWhere",
		image:"ImageUniqueWhere"
	},
	GenericPageUniqueWhere:{
		id:"UUID",
		locales:"GenericPageLocaleUniqueWhere"
	},
	ContentUniqueWhere:{
		id:"UUID",
		blocks:"ContentBlockUniqueWhere"
	},
	ContentBlockUniqueWhere:{
		id:"UUID",
		references:"ContentReferenceUniqueWhere"
	},
	ContentReferenceUniqueWhere:{
		id:"UUID",
		linkables:"ContentReferenceLinkableItemUniqueWhere",
		link:"LinkUniqueWhere",
		media:"MediumListUniqueWhere"
	},
	ContentReferenceLinkableItemUniqueWhere:{
		id:"UUID",
		item:"LinkableUniqueWhere"
	},
	LinkableUniqueWhere:{
		id:"UUID",
		redirect:"RedirectUniqueWhere",
		genericPage:"GenericPageLocaleUniqueWhere",
		businessPage:"BusinessPageLocaleUniqueWhere",
		jobPage:"JobPageLocaleUniqueWhere",
		homePage:"HomePageLocaleUniqueWhere",
		homePageLokal:"HomePageLokalLocaleUniqueWhere"
	},
	RedirectUniqueWhere:{
		id:"UUID",
		link:"LinkableUniqueWhere",
		target:"LinkUniqueWhere"
	},
	BusinessPageLocaleUniqueWhere:{
		id:"UUID",
		root:"BusinessPageUniqueWhere",
		locale:"LocaleUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere",
		link:"LinkableUniqueWhere",
		image:"ImageUniqueWhere"
	},
	BusinessPageUniqueWhere:{
		id:"UUID",
		locales:"BusinessPageLocaleUniqueWhere"
	},
	SeoUniqueWhere:{
		id:"UUID",
		ogImage:"ImageUniqueWhere"
	},
	JobPageLocaleUniqueWhere:{
		id:"UUID",
		root:"JobPageUniqueWhere",
		locale:"LocaleUniqueWhere",
		image:"ImageUniqueWhere",
		keyInfo:"KeyInfoListUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere",
		link:"LinkableUniqueWhere",
		mobileImage:"ImageUniqueWhere"
	},
	JobPageUniqueWhere:{
		id:"UUID",
		locales:"JobPageLocaleUniqueWhere"
	},
	KeyInfoListUniqueWhere:{
		id:"UUID",
		items:"KeyInfoItemUniqueWhere"
	},
	KeyInfoItemUniqueWhere:{
		id:"UUID"
	},
	HomePageLocaleUniqueWhere:{
		id:"UUID",
		root:"HomePageUniqueWhere",
		locale:"LocaleUniqueWhere",
		button:"LinkUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere",
		link:"LinkableUniqueWhere",
		logo:"ImageUniqueWhere",
		siteSwitcher:"SiteSwitcherUniqueWhere",
		ilustration:"GalleryUniqueWhere"
	},
	HomePageUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"HomePageLocaleUniqueWhere",
		theme:"ThemeUniqueWhere"
	},
	ThemeUniqueWhere:{
		id:"UUID"
	},
	SiteSwitcherUniqueWhere:{
		id:"UUID",
		link:"LinkUniqueWhere",
		theme:"ThemeUniqueWhere"
	},
	GalleryUniqueWhere:{
		id:"UUID",
		items:"GalleryItemUniqueWhere"
	},
	GalleryItemUniqueWhere:{
		id:"UUID",
		image:"ImageUniqueWhere"
	},
	HomePageLokalLocaleUniqueWhere:{
		id:"UUID",
		root:"HomePageLokalUniqueWhere",
		locale:"LocaleUniqueWhere",
		logo:"ImageUniqueWhere",
		button:"LinkUniqueWhere",
		content:"ContentUniqueWhere",
		seo:"SeoUniqueWhere",
		link:"LinkableUniqueWhere",
		siteSwitcher:"SiteSwitcherUniqueWhere",
		ilustration:"GalleryUniqueWhere"
	},
	HomePageLokalUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"HomePageLokalLocaleUniqueWhere",
		theme:"ThemeUniqueWhere"
	},
	MediumListUniqueWhere:{
		id:"UUID",
		items:"MediumItemUniqueWhere"
	},
	MediumItemUniqueWhere:{
		id:"UUID"
	},
	HeaderLocaleUniqueWhere:{
		id:"UUID",
		root:"HeaderUniqueWhere",
		locale:"LocaleUniqueWhere",
		businessLink:"LinkUniqueWhere",
		lokalLink:"LinkUniqueWhere"
	},
	HeaderUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"HeaderLocaleUniqueWhere",
		logo:"ImageUniqueWhere",
		logoMenu:"ImageUniqueWhere"
	},
	SeoDefaultLocaleUniqueWhere:{
		id:"UUID",
		root:"SeoDefaultUniqueWhere",
		locale:"LocaleUniqueWhere",
		seo:"SeoUniqueWhere"
	},
	SeoDefaultUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"SeoDefaultLocaleUniqueWhere"
	},
	ContractTypeLocaleUniqueWhere:{
		id:"UUID",
		root:"ContractTypeUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	ContractTypeUniqueWhere:{
		id:"UUID",
		locales:"ContractTypeLocaleUniqueWhere"
	},
	JobCityLocaleUniqueWhere:{
		id:"UUID",
		root:"JobCityUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	JobCityUniqueWhere:{
		id:"UUID",
		locales:"JobCityLocaleUniqueWhere"
	},
	JobPositionLocaleUniqueWhere:{
		id:"UUID",
		root:"JobPositionUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	JobPositionUniqueWhere:{
		id:"UUID",
		locales:"JobPositionLocaleUniqueWhere",
		jobs:"JobPageUniqueWhere"
	},
	BonusBannerLocaleUniqueWhere:{
		id:"UUID",
		root:"BonusBannerUniqueWhere",
		locale:"LocaleUniqueWhere",
		tiles:"TileUniqueWhere",
		logo:"ImageUniqueWhere"
	},
	BonusBannerUniqueWhere:{
		id:"UUID",
		locales:"BonusBannerLocaleUniqueWhere"
	},
	TileUniqueWhere:{
		id:"UUID",
		image:"ImageUniqueWhere",
		ligthBoxMedia:"MediumListUniqueWhere"
	},
	JobsFilterLocaleUniqueWhere:{
		id:"UUID",
		root:"JobsFilterUniqueWhere",
		locale:"LocaleUniqueWhere",
		bannerJobsForm:"JobsFormLocaleUniqueWhere",
		bannerImage:"ImageUniqueWhere",
		noJobImage:"ImageUniqueWhere"
	},
	JobsFilterUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"JobsFilterLocaleUniqueWhere"
	},
	GeneralLocaleUniqueWhere:{
		id:"UUID",
		root:"GeneralUniqueWhere",
		locale:"LocaleUniqueWhere",
		seo:"SeoUniqueWhere",
		cornerBanner:"CornerBannerUniqueWhere"
	},
	GeneralUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"GeneralLocaleUniqueWhere"
	},
	CornerBannerUniqueWhere:{
		id:"UUID",
		logo:"ImageUniqueWhere",
		link:"LinkUniqueWhere"
	},
	InfoBoxLocaleUniqueWhere:{
		id:"UUID",
		root:"InfoBoxUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	InfoBoxUniqueWhere:{
		id:"UUID",
		logo:"ImageUniqueWhere",
		locales:"InfoBoxLocaleUniqueWhere"
	},
	TranslationLocaleUniqueWhere:{
		id:"UUID",
		root:"TranslationUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	TranslationUniqueWhere:{
		id:"UUID",
		locales:"TranslationLocaleUniqueWhere"
	},
	FooterLocalesByTermsAndConditionsUniqueWhere:{
		termsAndConditions:"LinkUniqueWhere"
	},
	FooterLocalesByBannerImageUniqueWhere:{
		bannerImage:"ImageUniqueWhere"
	},
	FooterLocalesByBannerLinkUniqueWhere:{
		bannerLink:"LinkUniqueWhere"
	},
	FooterLocalesByJobsFormUniqueWhere:{
		jobsForm:"JobsFormLocaleUniqueWhere"
	},
	FooterLocalesByCopyrightLinkUniqueWhere:{
		copyrightLink:"LinkUniqueWhere"
	},
	FooterLocalesByRecommendationFormUniqueWhere:{
		recommendationForm:"RecommendationFormLocaleUniqueWhere"
	},
	FooterLocalesByBannerSecondLinkUniqueWhere:{
		bannerSecondLink:"LinkUniqueWhere"
	},
	FooterLocalesByInstagramLinkUniqueWhere:{
		instagramLink:"LinkUniqueWhere"
	},
	FooterLink:{
		link:{
			filter:"LinkWhere"
		}
	},
	Link:{
		internalLink:{
			filter:"LinkableWhere"
		}
	},
	Linkable:{
		redirect:{
			filter:"RedirectWhere"
		},
		genericPage:{
			filter:"GenericPageLocaleWhere"
		},
		businessPage:{
			filter:"BusinessPageLocaleWhere"
		},
		jobPage:{
			filter:"JobPageLocaleWhere"
		},
		homePage:{
			filter:"HomePageLocaleWhere"
		},
		homePageLokal:{
			filter:"HomePageLokalLocaleWhere"
		}
	},
	Redirect:{
		link:{
			filter:"LinkableWhere"
		},
		target:{
			filter:"LinkWhere"
		}
	},
	GenericPageLocale:{
		root:{
			filter:"GenericPageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		link:{
			filter:"LinkableWhere"
		},
		logo:{
			filter:"ImageWhere"
		},
		image:{
			filter:"ImageWhere"
		}
	},
	GenericPage:{
		locales:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		theme:{
			filter:"ThemeWhere"
		},
		localesByLocale:{
			by:"GenericPageLocalesByLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		localesByContent:{
			by:"GenericPageLocalesByContentUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		localesBySeo:{
			by:"GenericPageLocalesBySeoUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		localesByLink:{
			by:"GenericPageLocalesByLinkUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		localesByLogo:{
			by:"GenericPageLocalesByLogoUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		localesByImage:{
			by:"GenericPageLocalesByImageUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		paginateLocales:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		}
	},
	GenericPageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	GenericPageLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	GenericPageLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	GenericPageLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	GenericPageLocalesByLogoUniqueWhere:{
		logo:"ImageUniqueWhere"
	},
	GenericPageLocalesByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	Content:{
		blocks:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		blocksByReferences:{
			by:"ContentBlocksByReferencesUniqueWhere",
			filter:"ContentBlockWhere"
		},
		paginateBlocks:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		}
	},
	ContentBlock:{
		content:{
			filter:"ContentWhere"
		},
		references:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		referencesByLinkables:{
			by:"ContentBlockReferencesByLinkablesUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByLink:{
			by:"ContentBlockReferencesByLinkUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByMedia:{
			by:"ContentBlockReferencesByMediaUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		paginateReferences:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		}
	},
	ContentReference:{
		block:{
			filter:"ContentBlockWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		linkables:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		link:{
			filter:"LinkWhere"
		},
		media:{
			filter:"MediumListWhere"
		},
		textList:{
			filter:"TextListWhere"
		},
		carousel:{
			filter:"CarouselWhere"
		},
		bonusBanner:{
			filter:"BonusBannerLocaleWhere"
		},
		sideBySide:{
			filter:"SideBySideWhere"
		},
		gallery:{
			filter:"GalleryWhere"
		},
		video:{
			filter:"VideoWhere"
		},
		linkablesByItem:{
			by:"ContentReferenceLinkablesByItemUniqueWhere",
			filter:"ContentReferenceLinkableItemWhere"
		},
		paginateLinkables:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		}
	},
	ContentReferenceLinkableItem:{
		item:{
			filter:"LinkableWhere"
		},
		reference:{
			filter:"ContentReferenceWhere"
		}
	},
	ContentReferenceLinkableItemOrderBy:{
		id:"OrderDirection",
		item:"LinkableOrderBy",
		reference:"ContentReferenceOrderBy"
	},
	ContentReferenceOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		primaryText:"OrderDirection",
		block:"ContentBlockOrderBy",
		image:"ImageOrderBy",
		secondaryText:"OrderDirection",
		link:"LinkOrderBy",
		media:"MediumListOrderBy",
		textList:"TextListOrderBy",
		carousel:"CarouselOrderBy",
		bonusBanner:"BonusBannerLocaleOrderBy",
		sideBySide:"SideBySideOrderBy",
		gallery:"GalleryOrderBy",
		showBoolean:"OrderDirection",
		isRed:"OrderDirection",
		video:"VideoOrderBy"
	},
	ContentBlockOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		json:"OrderDirection",
		content:"ContentOrderBy"
	},
	MediumListOrderBy:{
		id:"OrderDirection"
	},
	TextListOrderBy:{
		id:"OrderDirection"
	},
	CarouselOrderBy:{
		id:"OrderDirection",
		background:"OrderDirection",
		squareImages:"OrderDirection"
	},
	BonusBannerLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		text:"OrderDirection",
		root:"BonusBannerOrderBy",
		locale:"LocaleOrderBy",
		logo:"ImageOrderBy",
		bannerName:"OrderDirection"
	},
	BonusBannerOrderBy:{
		id:"OrderDirection"
	},
	SideBySideOrderBy:{
		id:"OrderDirection",
		background:"OrderDirection",
		alignment:"OrderDirection",
		mediumSize:"OrderDirection"
	},
	VideoOrderBy:{
		id:"OrderDirection",
		src:"OrderDirection",
		width:"OrderDirection",
		height:"OrderDirection",
		size:"OrderDirection",
		type:"OrderDirection",
		videoInfo:"OrderDirection",
		duration:"OrderDirection",
		poster:"ImageOrderBy"
	},
	MediumList:{
		items:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		},
		paginateItems:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		}
	},
	MediumItem:{
		list:{
			filter:"MediumListWhere"
		},
		medium:{
			filter:"MediumWhere"
		}
	},
	Medium:{
		image:{
			filter:"ImageWhere"
		},
		video:{
			filter:"VideoWhere"
		}
	},
	Video:{
		poster:{
			filter:"ImageWhere"
		}
	},
	MediumItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"MediumListOrderBy",
		medium:"MediumOrderBy"
	},
	MediumOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		image:"ImageOrderBy",
		video:"VideoOrderBy"
	},
	TextList:{
		items:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		},
		paginateItems:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		}
	},
	TextItem:{
		list:{
			filter:"TextListWhere"
		}
	},
	TextItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		text:"OrderDirection",
		list:"TextListOrderBy",
		title:"OrderDirection"
	},
	Carousel:{
		items:{
			filter:"CarouselItemWhere",
			orderBy:"CarouselItemOrderBy"
		},
		itemsByImage:{
			by:"CarouselItemsByImageUniqueWhere",
			filter:"CarouselItemWhere"
		},
		itemsByLinkUrl:{
			by:"CarouselItemsByLinkUrlUniqueWhere",
			filter:"CarouselItemWhere"
		},
		itemsByVideo:{
			by:"CarouselItemsByVideoUniqueWhere",
			filter:"CarouselItemWhere"
		},
		paginateItems:{
			filter:"CarouselItemWhere",
			orderBy:"CarouselItemOrderBy"
		}
	},
	CarouselItem:{
		list:{
			filter:"CarouselWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		linkUrl:{
			filter:"LinkWhere"
		},
		video:{
			filter:"VideoWhere"
		}
	},
	CarouselItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		text:"OrderDirection",
		list:"CarouselOrderBy",
		image:"ImageOrderBy",
		name:"OrderDirection",
		title:"OrderDirection",
		linkUrl:"LinkOrderBy",
		normalAspectRatio:"OrderDirection",
		isImage:"OrderDirection",
		video:"VideoOrderBy"
	},
	CarouselItemsByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	CarouselItemsByLinkUrlUniqueWhere:{
		linkUrl:"LinkUniqueWhere"
	},
	CarouselItemsByVideoUniqueWhere:{
		video:"VideoUniqueWhere"
	},
	VideoUniqueWhere:{
		id:"UUID"
	},
	BonusBannerLocale:{
		root:{
			filter:"BonusBannerWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		tiles:{
			filter:"TileWhere",
			orderBy:"TileOrderBy"
		},
		logo:{
			filter:"ImageWhere"
		},
		tilesByImage:{
			by:"BonusBannerLocaleTilesByImageUniqueWhere",
			filter:"TileWhere"
		},
		tilesByLigthBoxMedia:{
			by:"BonusBannerLocaleTilesByLigthBoxMediaUniqueWhere",
			filter:"TileWhere"
		},
		paginateTiles:{
			filter:"TileWhere",
			orderBy:"TileOrderBy"
		}
	},
	BonusBanner:{
		locales:{
			filter:"BonusBannerLocaleWhere",
			orderBy:"BonusBannerLocaleOrderBy"
		},
		localesByLocale:{
			by:"BonusBannerLocalesByLocaleUniqueWhere",
			filter:"BonusBannerLocaleWhere"
		},
		localesByTiles:{
			by:"BonusBannerLocalesByTilesUniqueWhere",
			filter:"BonusBannerLocaleWhere"
		},
		localesByLogo:{
			by:"BonusBannerLocalesByLogoUniqueWhere",
			filter:"BonusBannerLocaleWhere"
		},
		paginateLocales:{
			filter:"BonusBannerLocaleWhere",
			orderBy:"BonusBannerLocaleOrderBy"
		}
	},
	BonusBannerLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	BonusBannerLocalesByTilesUniqueWhere:{
		tiles:"TileUniqueWhere"
	},
	BonusBannerLocalesByLogoUniqueWhere:{
		logo:"ImageUniqueWhere"
	},
	Tile:{
		bonusBanner:{
			filter:"BonusBannerLocaleWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		ligthBoxMedia:{
			filter:"MediumListWhere"
		},
		lightBoxForm:{
			filter:"JobsFormLocaleWhere"
		}
	},
	JobsFormLocale:{
		root:{
			filter:"JobsFormWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		imageTextList:{
			filter:"ImageTextListWhere"
		},
		logo:{
			filter:"ImageWhere"
		},
		successImage:{
			filter:"ImageWhere"
		}
	},
	JobsForm:{
		locales:{
			filter:"JobsFormLocaleWhere",
			orderBy:"JobsFormLocaleOrderBy"
		},
		fileIlustration:{
			filter:"ImageWhere"
		},
		localesByLocale:{
			by:"JobsFormLocalesByLocaleUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		localesByImageTextList:{
			by:"JobsFormLocalesByImageTextListUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		localesByLogo:{
			by:"JobsFormLocalesByLogoUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		localesBySuccessImage:{
			by:"JobsFormLocalesBySuccessImageUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		paginateLocales:{
			filter:"JobsFormLocaleWhere",
			orderBy:"JobsFormLocaleOrderBy"
		}
	},
	JobsFormLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	JobsFormLocalesByImageTextListUniqueWhere:{
		imageTextList:"ImageTextListUniqueWhere"
	},
	JobsFormLocalesByLogoUniqueWhere:{
		logo:"ImageUniqueWhere"
	},
	JobsFormLocalesBySuccessImageUniqueWhere:{
		successImage:"ImageUniqueWhere"
	},
	ImageTextList:{
		items:{
			filter:"ImageTextItemWhere",
			orderBy:"ImageTextItemOrderBy"
		},
		itemsByImage:{
			by:"ImageTextListItemsByImageUniqueWhere",
			filter:"ImageTextItemWhere"
		},
		paginateItems:{
			filter:"ImageTextItemWhere",
			orderBy:"ImageTextItemOrderBy"
		}
	},
	ImageTextItem:{
		list:{
			filter:"ImageTextListWhere"
		},
		image:{
			filter:"ImageWhere"
		}
	},
	ImageTextItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		title:"OrderDirection",
		list:"ImageTextListOrderBy",
		image:"ImageOrderBy"
	},
	ImageTextListItemsByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	TileOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		text:"OrderDirection",
		bonusBanner:"BonusBannerLocaleOrderBy",
		image:"ImageOrderBy",
		lightBoxTitle:"OrderDirection",
		lightBoxText:"OrderDirection",
		ligthBoxMedia:"MediumListOrderBy",
		lightBoxSectionTitle:"OrderDirection",
		title:"OrderDirection",
		lightBoxLinkLabel:"OrderDirection",
		lightBoxForm:"JobsFormLocaleOrderBy"
	},
	BonusBannerLocaleTilesByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	BonusBannerLocaleTilesByLigthBoxMediaUniqueWhere:{
		ligthBoxMedia:"MediumListUniqueWhere"
	},
	SideBySide:{
		items:{
			filter:"SideBySideItemWhere",
			orderBy:"SideBySideItemOrderBy"
		},
		itemsByMedia:{
			by:"SideBySideItemsByMediaUniqueWhere",
			filter:"SideBySideItemWhere"
		},
		paginateItems:{
			filter:"SideBySideItemWhere",
			orderBy:"SideBySideItemOrderBy"
		}
	},
	SideBySideItem:{
		list:{
			filter:"SideBySideWhere"
		},
		media:{
			filter:"MediumListWhere"
		},
		link:{
			filter:"LinkWhere"
		},
		jobsForm:{
			filter:"JobsFormLocaleWhere"
		}
	},
	SideBySideItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		title:"OrderDirection",
		text:"OrderDirection",
		list:"SideBySideOrderBy",
		media:"MediumListOrderBy",
		formButtonLabel:"OrderDirection",
		type:"OrderDirection",
		link:"LinkOrderBy",
		jobsForm:"JobsFormLocaleOrderBy",
		textNew:"OrderDirection"
	},
	SideBySideItemsByMediaUniqueWhere:{
		media:"MediumListUniqueWhere"
	},
	Gallery:{
		items:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		},
		itemsByImage:{
			by:"GalleryItemsByImageUniqueWhere",
			filter:"GalleryItemWhere"
		},
		paginateItems:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		}
	},
	GalleryItem:{
		list:{
			filter:"GalleryWhere"
		},
		image:{
			filter:"ImageWhere"
		}
	},
	GalleryItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"GalleryOrderBy",
		image:"ImageOrderBy"
	},
	GalleryItemsByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	ContentReferenceLinkablesByItemUniqueWhere:{
		item:"LinkableUniqueWhere"
	},
	ContentBlockReferencesByLinkablesUniqueWhere:{
		linkables:"ContentReferenceLinkableItemUniqueWhere"
	},
	ContentBlockReferencesByLinkUniqueWhere:{
		link:"LinkUniqueWhere"
	},
	ContentBlockReferencesByMediaUniqueWhere:{
		media:"MediumListUniqueWhere"
	},
	ContentBlocksByReferencesUniqueWhere:{
		references:"ContentReferenceUniqueWhere"
	},
	Seo:{
		ogImage:{
			filter:"ImageWhere"
		}
	},
	BusinessPageLocale:{
		root:{
			filter:"BusinessPageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		link:{
			filter:"LinkableWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		stickyBar:{
			filter:"StickyBarWhere"
		},
		infoBox:{
			filter:"InfoBoxWhere"
		}
	},
	BusinessPage:{
		locales:{
			filter:"BusinessPageLocaleWhere",
			orderBy:"BusinessPageLocaleOrderBy"
		},
		theme:{
			filter:"ThemeWhere"
		},
		localesByLocale:{
			by:"BusinessPageLocalesByLocaleUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		localesByContent:{
			by:"BusinessPageLocalesByContentUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		localesBySeo:{
			by:"BusinessPageLocalesBySeoUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		localesByLink:{
			by:"BusinessPageLocalesByLinkUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		localesByImage:{
			by:"BusinessPageLocalesByImageUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		paginateLocales:{
			filter:"BusinessPageLocaleWhere",
			orderBy:"BusinessPageLocaleOrderBy"
		}
	},
	BusinessPageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	BusinessPageLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	BusinessPageLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	BusinessPageLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	BusinessPageLocalesByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	StickyBar:{
		link:{
			filter:"LinkWhere"
		},
		jobsForm:{
			filter:"JobsFormLocaleWhere"
		}
	},
	InfoBox:{
		logo:{
			filter:"ImageWhere"
		},
		locales:{
			filter:"InfoBoxLocaleWhere",
			orderBy:"InfoBoxLocaleOrderBy"
		},
		localesByLocale:{
			by:"InfoBoxLocalesByLocaleUniqueWhere",
			filter:"InfoBoxLocaleWhere"
		},
		paginateLocales:{
			filter:"InfoBoxLocaleWhere",
			orderBy:"InfoBoxLocaleOrderBy"
		}
	},
	InfoBoxLocale:{
		root:{
			filter:"InfoBoxWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		openingHours:{
			filter:"TextListWhere"
		}
	},
	InfoBoxLocaleOrderBy:{
		id:"OrderDirection",
		address:"OrderDirection",
		web:"OrderDirection",
		instagram:"OrderDirection",
		facebook:"OrderDirection",
		root:"InfoBoxOrderBy",
		locale:"LocaleOrderBy",
		openingHours:"TextListOrderBy",
		addressLink:"OrderDirection"
	},
	InfoBoxLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	JobPageLocale:{
		root:{
			filter:"JobPageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		keyInfo:{
			filter:"KeyInfoListWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		link:{
			filter:"LinkableWhere"
		},
		stickyBar:{
			filter:"StickyBarWhere"
		},
		mobileImage:{
			filter:"ImageWhere"
		}
	},
	JobPage:{
		locales:{
			filter:"JobPageLocaleWhere",
			orderBy:"JobPageLocaleOrderBy"
		},
		theme:{
			filter:"ThemeWhere"
		},
		contractType:{
			filter:"ContractTypeWhere"
		},
		jobCity:{
			filter:"JobCityWhere"
		},
		jobPosition:{
			filter:"JobPositionWhere"
		},
		business:{
			filter:"BusinessPageWhere"
		},
		localesByLocale:{
			by:"JobPageLocalesByLocaleUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		localesByImage:{
			by:"JobPageLocalesByImageUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		localesByKeyInfo:{
			by:"JobPageLocalesByKeyInfoUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		localesByContent:{
			by:"JobPageLocalesByContentUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		localesBySeo:{
			by:"JobPageLocalesBySeoUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		localesByLink:{
			by:"JobPageLocalesByLinkUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		localesByMobileImage:{
			by:"JobPageLocalesByMobileImageUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		paginateLocales:{
			filter:"JobPageLocaleWhere",
			orderBy:"JobPageLocaleOrderBy"
		}
	},
	ContractType:{
		locales:{
			filter:"ContractTypeLocaleWhere",
			orderBy:"ContractTypeLocaleOrderBy"
		},
		localesByLocale:{
			by:"ContractTypeLocalesByLocaleUniqueWhere",
			filter:"ContractTypeLocaleWhere"
		},
		paginateLocales:{
			filter:"ContractTypeLocaleWhere",
			orderBy:"ContractTypeLocaleOrderBy"
		}
	},
	ContractTypeLocale:{
		root:{
			filter:"ContractTypeWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	ContractTypeLocaleOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		root:"ContractTypeOrderBy",
		locale:"LocaleOrderBy",
		slug:"OrderDirection"
	},
	ContractTypeLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	JobCity:{
		locales:{
			filter:"JobCityLocaleWhere",
			orderBy:"JobCityLocaleOrderBy"
		},
		localesByLocale:{
			by:"JobCityLocalesByLocaleUniqueWhere",
			filter:"JobCityLocaleWhere"
		},
		paginateLocales:{
			filter:"JobCityLocaleWhere",
			orderBy:"JobCityLocaleOrderBy"
		}
	},
	JobCityLocale:{
		root:{
			filter:"JobCityWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	JobCityLocaleOrderBy:{
		id:"OrderDirection",
		root:"JobCityOrderBy",
		locale:"LocaleOrderBy",
		name:"OrderDirection",
		slug:"OrderDirection"
	},
	JobCityLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	JobPosition:{
		locales:{
			filter:"JobPositionLocaleWhere",
			orderBy:"JobPositionLocaleOrderBy"
		},
		jobs:{
			filter:"JobPageWhere",
			orderBy:"JobPageOrderBy"
		},
		localesByLocale:{
			by:"JobPositionLocalesByLocaleUniqueWhere",
			filter:"JobPositionLocaleWhere"
		},
		jobsByLocales:{
			by:"JobPositionJobsByLocalesUniqueWhere",
			filter:"JobPageWhere"
		},
		paginateLocales:{
			filter:"JobPositionLocaleWhere",
			orderBy:"JobPositionLocaleOrderBy"
		},
		paginateJobs:{
			filter:"JobPageWhere",
			orderBy:"JobPageOrderBy"
		}
	},
	JobPositionLocale:{
		root:{
			filter:"JobPositionWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	JobPositionLocaleOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		root:"JobPositionOrderBy",
		locale:"LocaleOrderBy",
		slug:"OrderDirection"
	},
	JobPositionLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	JobPositionJobsByLocalesUniqueWhere:{
		locales:"JobPageLocaleUniqueWhere"
	},
	JobPageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	JobPageLocalesByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	JobPageLocalesByKeyInfoUniqueWhere:{
		keyInfo:"KeyInfoListUniqueWhere"
	},
	JobPageLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	JobPageLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	JobPageLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	JobPageLocalesByMobileImageUniqueWhere:{
		mobileImage:"ImageUniqueWhere"
	},
	KeyInfoList:{
		items:{
			filter:"KeyInfoItemWhere",
			orderBy:"KeyInfoItemOrderBy"
		},
		paginateItems:{
			filter:"KeyInfoItemWhere",
			orderBy:"KeyInfoItemOrderBy"
		}
	},
	KeyInfoItem:{
		list:{
			filter:"KeyInfoListWhere"
		},
		icon:{
			filter:"IconWhere"
		}
	},
	Icon:{
		icon:{
			filter:"ImageWhere"
		}
	},
	KeyInfoItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		keyInfo:"OrderDirection",
		list:"KeyInfoListOrderBy",
		icon:"IconOrderBy"
	},
	IconOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		icon:"ImageOrderBy"
	},
	HomePageLocale:{
		root:{
			filter:"HomePageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		button:{
			filter:"LinkWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		link:{
			filter:"LinkableWhere"
		},
		logo:{
			filter:"ImageWhere"
		},
		siteSwitcher:{
			filter:"SiteSwitcherWhere"
		},
		gallery:{
			filter:"GalleryWhere"
		},
		stickyBar:{
			filter:"StickyBarWhere"
		},
		ilustration:{
			filter:"GalleryWhere"
		}
	},
	HomePage:{
		locales:{
			filter:"HomePageLocaleWhere",
			orderBy:"HomePageLocaleOrderBy"
		},
		theme:{
			filter:"ThemeWhere"
		},
		localesByLocale:{
			by:"HomePageLocalesByLocaleUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		localesByButton:{
			by:"HomePageLocalesByButtonUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		localesByContent:{
			by:"HomePageLocalesByContentUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		localesBySeo:{
			by:"HomePageLocalesBySeoUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		localesByLink:{
			by:"HomePageLocalesByLinkUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		localesByLogo:{
			by:"HomePageLocalesByLogoUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		localesBySiteSwitcher:{
			by:"HomePageLocalesBySiteSwitcherUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		localesByIlustration:{
			by:"HomePageLocalesByIlustrationUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		paginateLocales:{
			filter:"HomePageLocaleWhere",
			orderBy:"HomePageLocaleOrderBy"
		}
	},
	HomePageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	HomePageLocalesByButtonUniqueWhere:{
		button:"LinkUniqueWhere"
	},
	HomePageLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	HomePageLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	HomePageLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	HomePageLocalesByLogoUniqueWhere:{
		logo:"ImageUniqueWhere"
	},
	HomePageLocalesBySiteSwitcherUniqueWhere:{
		siteSwitcher:"SiteSwitcherUniqueWhere"
	},
	HomePageLocalesByIlustrationUniqueWhere:{
		ilustration:"GalleryUniqueWhere"
	},
	SiteSwitcher:{
		link:{
			filter:"LinkWhere"
		},
		theme:{
			filter:"ThemeWhere"
		}
	},
	HomePageLokalLocale:{
		root:{
			filter:"HomePageLokalWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		logo:{
			filter:"ImageWhere"
		},
		button:{
			filter:"LinkWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		link:{
			filter:"LinkableWhere"
		},
		siteSwitcher:{
			filter:"SiteSwitcherWhere"
		},
		gallery:{
			filter:"GalleryWhere"
		},
		stickyBar:{
			filter:"StickyBarWhere"
		},
		ilustration:{
			filter:"GalleryWhere"
		}
	},
	HomePageLokal:{
		locales:{
			filter:"HomePageLokalLocaleWhere",
			orderBy:"HomePageLokalLocaleOrderBy"
		},
		theme:{
			filter:"ThemeWhere"
		},
		localesByLocale:{
			by:"HomePageLokalLocalesByLocaleUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		localesByLogo:{
			by:"HomePageLokalLocalesByLogoUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		localesByButton:{
			by:"HomePageLokalLocalesByButtonUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		localesByContent:{
			by:"HomePageLokalLocalesByContentUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		localesBySeo:{
			by:"HomePageLokalLocalesBySeoUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		localesByLink:{
			by:"HomePageLokalLocalesByLinkUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		localesBySiteSwitcher:{
			by:"HomePageLokalLocalesBySiteSwitcherUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		localesByIlustration:{
			by:"HomePageLokalLocalesByIlustrationUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		paginateLocales:{
			filter:"HomePageLokalLocaleWhere",
			orderBy:"HomePageLokalLocaleOrderBy"
		}
	},
	HomePageLokalLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	HomePageLokalLocalesByLogoUniqueWhere:{
		logo:"ImageUniqueWhere"
	},
	HomePageLokalLocalesByButtonUniqueWhere:{
		button:"LinkUniqueWhere"
	},
	HomePageLokalLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	HomePageLokalLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	HomePageLokalLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	HomePageLokalLocalesBySiteSwitcherUniqueWhere:{
		siteSwitcher:"SiteSwitcherUniqueWhere"
	},
	HomePageLokalLocalesByIlustrationUniqueWhere:{
		ilustration:"GalleryUniqueWhere"
	},
	FooterLinkOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		link:"LinkOrderBy"
	},
	RecommendationFormLocale:{
		root:{
			filter:"RecommendationFormWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	RecommendationForm:{
		locales:{
			filter:"RecommendationFormLocaleWhere",
			orderBy:"RecommendationFormLocaleOrderBy"
		},
		successImage:{
			filter:"ImageWhere"
		},
		localesByLocale:{
			by:"RecommendationFormLocalesByLocaleUniqueWhere",
			filter:"RecommendationFormLocaleWhere"
		},
		paginateLocales:{
			filter:"RecommendationFormLocaleWhere",
			orderBy:"RecommendationFormLocaleOrderBy"
		}
	},
	RecommendationFormLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	HeaderLocale:{
		root:{
			filter:"HeaderWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		business:{
			filter:"BusinessWhere",
			orderBy:"BusinessOrderBy"
		},
		lokalEnterprise:{
			filter:"BusinessWhere",
			orderBy:"BusinessOrderBy"
		},
		businessLink:{
			filter:"LinkWhere"
		},
		lokalLink:{
			filter:"LinkWhere"
		},
		paginateBusiness:{
			filter:"BusinessWhere",
			orderBy:"BusinessOrderBy"
		},
		paginateLokalEnterprise:{
			filter:"BusinessWhere",
			orderBy:"BusinessOrderBy"
		}
	},
	Header:{
		locales:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		logo:{
			filter:"ImageWhere"
		},
		logoMenu:{
			filter:"ImageWhere"
		},
		localesByLocale:{
			by:"HeaderLocalesByLocaleUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		localesByBusinessLink:{
			by:"HeaderLocalesByBusinessLinkUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		localesByLokalLink:{
			by:"HeaderLocalesByLokalLinkUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		paginateLocales:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		}
	},
	HeaderLocaleOrderBy:{
		id:"OrderDirection",
		root:"HeaderOrderBy",
		locale:"LocaleOrderBy",
		menuLabel:"OrderDirection",
		menuTitle:"OrderDirection",
		menuText:"OrderDirection",
		businessSectionTitle:"OrderDirection",
		lokalSectionTitle:"OrderDirection",
		businessLink:"LinkOrderBy",
		lokalLink:"LinkOrderBy"
	},
	HeaderOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		logo:"ImageOrderBy",
		logoMenu:"ImageOrderBy"
	},
	HeaderLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	HeaderLocalesByBusinessLinkUniqueWhere:{
		businessLink:"LinkUniqueWhere"
	},
	HeaderLocalesByLokalLinkUniqueWhere:{
		lokalLink:"LinkUniqueWhere"
	},
	Business:{
		logo:{
			filter:"ImageWhere"
		},
		link:{
			filter:"LinkWhere"
		}
	},
	BusinessOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		logo:"ImageOrderBy",
		link:"LinkOrderBy"
	},
	SeoDefaultLocale:{
		root:{
			filter:"SeoDefaultWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		seo:{
			filter:"SeoWhere"
		}
	},
	SeoDefault:{
		locales:{
			filter:"SeoDefaultLocaleWhere",
			orderBy:"SeoDefaultLocaleOrderBy"
		},
		localesByLocale:{
			by:"SeoDefaultLocalesByLocaleUniqueWhere",
			filter:"SeoDefaultLocaleWhere"
		},
		localesBySeo:{
			by:"SeoDefaultLocalesBySeoUniqueWhere",
			filter:"SeoDefaultLocaleWhere"
		},
		paginateLocales:{
			filter:"SeoDefaultLocaleWhere",
			orderBy:"SeoDefaultLocaleOrderBy"
		}
	},
	SeoDefaultLocaleOrderBy:{
		id:"OrderDirection",
		root:"SeoDefaultOrderBy",
		locale:"LocaleOrderBy",
		seo:"SeoOrderBy"
	},
	SeoDefaultOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	SeoDefaultLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	SeoDefaultLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	JobsFilterLocale:{
		root:{
			filter:"JobsFilterWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		bannerJobsForm:{
			filter:"JobsFormLocaleWhere"
		},
		bannerImage:{
			filter:"ImageWhere"
		},
		noJobImage:{
			filter:"ImageWhere"
		}
	},
	JobsFilter:{
		locales:{
			filter:"JobsFilterLocaleWhere",
			orderBy:"JobsFilterLocaleOrderBy"
		},
		localesByLocale:{
			by:"JobsFilterLocalesByLocaleUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		localesByBannerJobsForm:{
			by:"JobsFilterLocalesByBannerJobsFormUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		localesByBannerImage:{
			by:"JobsFilterLocalesByBannerImageUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		localesByNoJobImage:{
			by:"JobsFilterLocalesByNoJobImageUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		paginateLocales:{
			filter:"JobsFilterLocaleWhere",
			orderBy:"JobsFilterLocaleOrderBy"
		}
	},
	JobsFilterLocaleOrderBy:{
		id:"OrderDirection",
		jobPositionLabel:"OrderDirection",
		jobContractLabel:"OrderDirection",
		jobCityLabel:"OrderDirection",
		root:"JobsFilterOrderBy",
		locale:"LocaleOrderBy",
		bannerTitle:"OrderDirection",
		bannerFormLabel:"OrderDirection",
		bannerJobsForm:"JobsFormLocaleOrderBy",
		bannerImage:"ImageOrderBy",
		noJobTitle:"OrderDirection",
		noJobBtnLabel:"OrderDirection",
		noJobImage:"ImageOrderBy",
		noJobTitleForSpecificBusiness:"OrderDirection",
		deactivatedJob:"OrderDirection"
	},
	JobsFilterOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	JobsFilterLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	JobsFilterLocalesByBannerJobsFormUniqueWhere:{
		bannerJobsForm:"JobsFormLocaleUniqueWhere"
	},
	JobsFilterLocalesByBannerImageUniqueWhere:{
		bannerImage:"ImageUniqueWhere"
	},
	JobsFilterLocalesByNoJobImageUniqueWhere:{
		noJobImage:"ImageUniqueWhere"
	},
	GeneralLocaleOrderBy:{
		id:"OrderDirection",
		root:"GeneralOrderBy",
		locale:"LocaleOrderBy",
		seo:"SeoOrderBy",
		cornerBanner:"CornerBannerOrderBy"
	},
	GeneralOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	CornerBannerOrderBy:{
		id:"OrderDirection",
		isActive:"OrderDirection",
		title:"OrderDirection",
		text:"OrderDirection",
		logo:"ImageOrderBy",
		link:"LinkOrderBy"
	},
	TranslationLocale:{
		root:{
			filter:"TranslationWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	Translation:{
		locales:{
			filter:"TranslationLocaleWhere",
			orderBy:"TranslationLocaleOrderBy"
		},
		localesByLocale:{
			by:"TranslationLocalesByLocaleUniqueWhere",
			filter:"TranslationLocaleWhere"
		},
		paginateLocales:{
			filter:"TranslationLocaleWhere",
			orderBy:"TranslationLocaleOrderBy"
		}
	},
	TranslationLocaleOrderBy:{
		id:"OrderDirection",
		value:"OrderDirection",
		root:"TranslationOrderBy",
		locale:"LocaleOrderBy"
	},
	TranslationOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		key:"OrderDirection",
		isTextarea:"OrderDirection"
	},
	TranslationLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	LocaleFootersByRootUniqueWhere:{
		root:"FooterUniqueWhere"
	},
	LocaleFootersByTermsAndConditionsUniqueWhere:{
		termsAndConditions:"LinkUniqueWhere"
	},
	LocaleFootersByBannerImageUniqueWhere:{
		bannerImage:"ImageUniqueWhere"
	},
	LocaleFootersByBannerLinkUniqueWhere:{
		bannerLink:"LinkUniqueWhere"
	},
	LocaleFootersByJobsFormUniqueWhere:{
		jobsForm:"JobsFormLocaleUniqueWhere"
	},
	LocaleFootersByCopyrightLinkUniqueWhere:{
		copyrightLink:"LinkUniqueWhere"
	},
	LocaleFootersByRecommendationFormUniqueWhere:{
		recommendationForm:"RecommendationFormLocaleUniqueWhere"
	},
	LocaleFootersByBannerSecondLinkUniqueWhere:{
		bannerSecondLink:"LinkUniqueWhere"
	},
	LocaleFootersByInstagramLinkUniqueWhere:{
		instagramLink:"LinkUniqueWhere"
	},
	LocaleGenericPagesByRootUniqueWhere:{
		root:"GenericPageUniqueWhere"
	},
	LocaleGenericPagesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleGenericPagesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleGenericPagesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocaleGenericPagesByLogoUniqueWhere:{
		logo:"ImageUniqueWhere"
	},
	LocaleGenericPagesByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	LocaleHeadersByRootUniqueWhere:{
		root:"HeaderUniqueWhere"
	},
	LocaleHeadersByBusinessLinkUniqueWhere:{
		businessLink:"LinkUniqueWhere"
	},
	LocaleHeadersByLokalLinkUniqueWhere:{
		lokalLink:"LinkUniqueWhere"
	},
	LocaleSeoDefaultsByRootUniqueWhere:{
		root:"SeoDefaultUniqueWhere"
	},
	LocaleSeoDefaultsBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleBusinessPagesByRootUniqueWhere:{
		root:"BusinessPageUniqueWhere"
	},
	LocaleBusinessPagesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleBusinessPagesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleBusinessPagesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocaleBusinessPagesByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	LocaleJobPagesByRootUniqueWhere:{
		root:"JobPageUniqueWhere"
	},
	LocaleJobPagesByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	LocaleJobPagesByKeyInfoUniqueWhere:{
		keyInfo:"KeyInfoListUniqueWhere"
	},
	LocaleJobPagesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleJobPagesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleJobPagesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocaleJobPagesByMobileImageUniqueWhere:{
		mobileImage:"ImageUniqueWhere"
	},
	LocaleContractTypesByRootUniqueWhere:{
		root:"ContractTypeUniqueWhere"
	},
	LocaleContractTypesBySlugUniqueWhere:{

	},
	LocaleJobCitiesByRootUniqueWhere:{
		root:"JobCityUniqueWhere"
	},
	LocaleJobCitiesBySlugUniqueWhere:{

	},
	LocaleJobPositionsByRootUniqueWhere:{
		root:"JobPositionUniqueWhere"
	},
	LocaleJobPositionsBySlugUniqueWhere:{

	},
	LocaleHomePagesByRootUniqueWhere:{
		root:"HomePageUniqueWhere"
	},
	LocaleHomePagesByButtonUniqueWhere:{
		button:"LinkUniqueWhere"
	},
	LocaleHomePagesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleHomePagesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleHomePagesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocaleHomePagesByLogoUniqueWhere:{
		logo:"ImageUniqueWhere"
	},
	LocaleHomePagesBySiteSwitcherUniqueWhere:{
		siteSwitcher:"SiteSwitcherUniqueWhere"
	},
	LocaleHomePagesByIlustrationUniqueWhere:{
		ilustration:"GalleryUniqueWhere"
	},
	LocaleBonusBannersByRootUniqueWhere:{
		root:"BonusBannerUniqueWhere"
	},
	LocaleBonusBannersByTilesUniqueWhere:{
		tiles:"TileUniqueWhere"
	},
	LocaleBonusBannersByLogoUniqueWhere:{
		logo:"ImageUniqueWhere"
	},
	LocaleHomePageLokalsByRootUniqueWhere:{
		root:"HomePageLokalUniqueWhere"
	},
	LocaleHomePageLokalsByLogoUniqueWhere:{
		logo:"ImageUniqueWhere"
	},
	LocaleHomePageLokalsByButtonUniqueWhere:{
		button:"LinkUniqueWhere"
	},
	LocaleHomePageLokalsByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleHomePageLokalsBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleHomePageLokalsByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocaleHomePageLokalsBySiteSwitcherUniqueWhere:{
		siteSwitcher:"SiteSwitcherUniqueWhere"
	},
	LocaleHomePageLokalsByIlustrationUniqueWhere:{
		ilustration:"GalleryUniqueWhere"
	},
	LocaleJobsFormsByRootUniqueWhere:{
		root:"JobsFormUniqueWhere"
	},
	LocaleJobsFormsByImageTextListUniqueWhere:{
		imageTextList:"ImageTextListUniqueWhere"
	},
	LocaleJobsFormsByLogoUniqueWhere:{
		logo:"ImageUniqueWhere"
	},
	LocaleJobsFormsBySuccessImageUniqueWhere:{
		successImage:"ImageUniqueWhere"
	},
	LocaleJobsFiltersByRootUniqueWhere:{
		root:"JobsFilterUniqueWhere"
	},
	LocaleJobsFiltersByBannerJobsFormUniqueWhere:{
		bannerJobsForm:"JobsFormLocaleUniqueWhere"
	},
	LocaleJobsFiltersByBannerImageUniqueWhere:{
		bannerImage:"ImageUniqueWhere"
	},
	LocaleJobsFiltersByNoJobImageUniqueWhere:{
		noJobImage:"ImageUniqueWhere"
	},
	LocaleGeneralByRootUniqueWhere:{
		root:"GeneralUniqueWhere"
	},
	LocaleGeneralBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleGeneralByCornerBannerUniqueWhere:{
		cornerBanner:"CornerBannerUniqueWhere"
	},
	LocaleRecommendationFormsByRootUniqueWhere:{
		root:"RecommendationFormUniqueWhere"
	},
	LocaleInfoBoxesByRootUniqueWhere:{
		root:"InfoBoxUniqueWhere"
	},
	LocaleTranslationsByRootUniqueWhere:{
		root:"TranslationUniqueWhere"
	},
	CornerBanner:{
		logo:{
			filter:"ImageWhere"
		},
		link:{
			filter:"LinkWhere"
		}
	},
	GeneralLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	GeneralLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	GeneralLocalesByCornerBannerUniqueWhere:{
		cornerBanner:"CornerBannerUniqueWhere"
	},
	GeneralCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"GeneralCreateLocalesEntityRelationInput"
	},
	GeneralCreateLocalesEntityRelationInput:{
		connect:"GeneralLocaleUniqueWhere",
		create:"GeneralLocaleWithoutRootCreateInput",
		connectOrCreate:"GeneralConnectOrCreateLocalesRelationInput"
	},
	GeneralLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"GeneralLocaleCreateLocaleEntityRelationInput",
		seo:"GeneralLocaleCreateSeoEntityRelationInput",
		cornerBanner:"GeneralLocaleCreateCornerBannerEntityRelationInput"
	},
	GeneralLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGeneralCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutGeneralCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	LocaleCreateFootersEntityRelationInput:{
		connect:"FooterLocaleUniqueWhere",
		create:"FooterLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateFootersRelationInput"
	},
	FooterLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"FooterLocaleCreateRootEntityRelationInput",
		linksFirstColumn:"FooterLocaleCreateLinksFirstColumnEntityRelationInput",
		linksSecondColumn:"FooterLocaleCreateLinksSecondColumnEntityRelationInput",
		termsAndConditions:"FooterLocaleCreateTermsAndConditionsEntityRelationInput",
		bannerImage:"FooterLocaleCreateBannerImageEntityRelationInput",
		bannerLink:"FooterLocaleCreateBannerLinkEntityRelationInput",
		jobsForm:"FooterLocaleCreateJobsFormEntityRelationInput",
		copyrightLink:"FooterLocaleCreateCopyrightLinkEntityRelationInput",
		recommendationForm:"FooterLocaleCreateRecommendationFormEntityRelationInput",
		bannerSecondLink:"FooterLocaleCreateBannerSecondLinkEntityRelationInput",
		instagramLink:"FooterLocaleCreateInstagramLinkEntityRelationInput"
	},
	FooterLocaleCreateRootEntityRelationInput:{
		connect:"FooterUniqueWhere",
		create:"FooterWithoutLocalesCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateRootRelationInput"
	},
	FooterWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	FooterLocaleConnectOrCreateRootRelationInput:{
		connect:"FooterUniqueWhere",
		create:"FooterWithoutLocalesCreateInput"
	},
	FooterLocaleCreateLinksFirstColumnEntityRelationInput:{
		connect:"FooterLinkUniqueWhere",
		create:"FooterLinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"
	},
	FooterLinkUniqueWhere:{
		id:"UUID",
		link:"LinkUniqueWhere"
	},
	FooterLinkCreateInput:{
		id:"UUID",
		link:"FooterLinkCreateLinkEntityRelationInput"
	},
	FooterLinkCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLinkConnectOrCreateLinkRelationInput"
	},
	LinkCreateInput:{
		id:"UUID",
		type:"LinkType",
		internalLink:"LinkCreateInternalLinkEntityRelationInput"
	},
	LinkCreateInternalLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableCreateInput",
		connectOrCreate:"LinkConnectOrCreateInternalLinkRelationInput"
	},
	LinkableCreateInput:{
		id:"UUID",
		redirect:"LinkableCreateRedirectEntityRelationInput",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		businessPage:"LinkableCreateBusinessPageEntityRelationInput",
		jobPage:"LinkableCreateJobPageEntityRelationInput",
		homePage:"LinkableCreateHomePageEntityRelationInput",
		homePageLokal:"LinkableCreateHomePageLokalEntityRelationInput"
	},
	LinkableCreateRedirectEntityRelationInput:{
		connect:"RedirectUniqueWhere",
		create:"RedirectWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateRedirectRelationInput"
	},
	RedirectWithoutLinkCreateInput:{
		id:"UUID",
		target:"RedirectCreateTargetEntityRelationInput"
	},
	RedirectCreateTargetEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"RedirectConnectOrCreateTargetRelationInput"
	},
	RedirectConnectOrCreateTargetRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	LinkableConnectOrCreateRedirectRelationInput:{
		connect:"RedirectUniqueWhere",
		create:"RedirectWithoutLinkCreateInput"
	},
	LinkableCreateGenericPageEntityRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateGenericPageRelationInput"
	},
	GenericPageLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"GenericPageLocaleCreateRootEntityRelationInput",
		locale:"GenericPageLocaleCreateLocaleEntityRelationInput",
		content:"GenericPageLocaleCreateContentEntityRelationInput",
		seo:"GenericPageLocaleCreateSeoEntityRelationInput",
		logo:"GenericPageLocaleCreateLogoEntityRelationInput",
		image:"GenericPageLocaleCreateImageEntityRelationInput"
	},
	GenericPageLocaleCreateRootEntityRelationInput:{
		connect:"GenericPageUniqueWhere",
		create:"GenericPageWithoutLocalesCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateRootRelationInput"
	},
	GenericPageWithoutLocalesCreateInput:{
		id:"UUID",
		theme:"GenericPageCreateThemeEntityRelationInput"
	},
	GenericPageCreateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"GenericPageConnectOrCreateThemeRelationInput"
	},
	ThemeCreateInput:{
		id:"UUID"
	},
	GenericPageConnectOrCreateThemeRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput"
	},
	GenericPageLocaleConnectOrCreateRootRelationInput:{
		connect:"GenericPageUniqueWhere",
		create:"GenericPageWithoutLocalesCreateInput"
	},
	GenericPageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGenericPagesCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutGenericPagesCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	LocaleCreateHeadersEntityRelationInput:{
		connect:"HeaderLocaleUniqueWhere",
		create:"HeaderLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateHeadersRelationInput"
	},
	HeaderLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"HeaderLocaleCreateRootEntityRelationInput",
		business:"HeaderLocaleCreateBusinessEntityRelationInput",
		lokalEnterprise:"HeaderLocaleCreateLokalEnterpriseEntityRelationInput",
		businessLink:"HeaderLocaleCreateBusinessLinkEntityRelationInput",
		lokalLink:"HeaderLocaleCreateLokalLinkEntityRelationInput"
	},
	HeaderLocaleCreateRootEntityRelationInput:{
		connect:"HeaderUniqueWhere",
		create:"HeaderWithoutLocalesCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateRootRelationInput"
	},
	HeaderWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One",
		logo:"HeaderCreateLogoEntityRelationInput",
		logoMenu:"HeaderCreateLogoMenuEntityRelationInput"
	},
	HeaderCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"HeaderConnectOrCreateLogoRelationInput"
	},
	ImageCreateInput:{
		id:"UUID"
	},
	HeaderConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	HeaderCreateLogoMenuEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"HeaderConnectOrCreateLogoMenuRelationInput"
	},
	HeaderConnectOrCreateLogoMenuRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	HeaderLocaleConnectOrCreateRootRelationInput:{
		connect:"HeaderUniqueWhere",
		create:"HeaderWithoutLocalesCreateInput"
	},
	HeaderLocaleCreateBusinessEntityRelationInput:{
		connect:"BusinessUniqueWhere",
		create:"BusinessCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateBusinessRelationInput"
	},
	BusinessUniqueWhere:{
		id:"UUID",
		logo:"ImageUniqueWhere",
		link:"LinkUniqueWhere"
	},
	BusinessCreateInput:{
		id:"UUID",
		logo:"BusinessCreateLogoEntityRelationInput",
		link:"BusinessCreateLinkEntityRelationInput"
	},
	BusinessCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"BusinessConnectOrCreateLogoRelationInput"
	},
	BusinessConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	BusinessCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"BusinessConnectOrCreateLinkRelationInput"
	},
	BusinessConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	HeaderLocaleConnectOrCreateBusinessRelationInput:{
		connect:"BusinessUniqueWhere",
		create:"BusinessCreateInput"
	},
	HeaderLocaleCreateLokalEnterpriseEntityRelationInput:{
		connect:"BusinessUniqueWhere",
		create:"BusinessCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"
	},
	HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput:{
		connect:"BusinessUniqueWhere",
		create:"BusinessCreateInput"
	},
	HeaderLocaleCreateBusinessLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateBusinessLinkRelationInput"
	},
	HeaderLocaleConnectOrCreateBusinessLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	HeaderLocaleCreateLokalLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateLokalLinkRelationInput"
	},
	HeaderLocaleConnectOrCreateLokalLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	LocaleConnectOrCreateHeadersRelationInput:{
		connect:"HeaderLocaleUniqueWhere",
		create:"HeaderLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateSeoDefaultsEntityRelationInput:{
		connect:"SeoDefaultLocaleUniqueWhere",
		create:"SeoDefaultLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateSeoDefaultsRelationInput"
	},
	SeoDefaultLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"SeoDefaultLocaleCreateRootEntityRelationInput",
		seo:"SeoDefaultLocaleCreateSeoEntityRelationInput"
	},
	SeoDefaultLocaleCreateRootEntityRelationInput:{
		connect:"SeoDefaultUniqueWhere",
		create:"SeoDefaultWithoutLocalesCreateInput",
		connectOrCreate:"SeoDefaultLocaleConnectOrCreateRootRelationInput"
	},
	SeoDefaultWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	SeoDefaultLocaleConnectOrCreateRootRelationInput:{
		connect:"SeoDefaultUniqueWhere",
		create:"SeoDefaultWithoutLocalesCreateInput"
	},
	SeoDefaultLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"SeoDefaultLocaleConnectOrCreateSeoRelationInput"
	},
	SeoCreateInput:{
		id:"UUID",
		ogImage:"SeoCreateOgImageEntityRelationInput"
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"SeoConnectOrCreateOgImageRelationInput"
	},
	SeoConnectOrCreateOgImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	SeoDefaultLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	LocaleConnectOrCreateSeoDefaultsRelationInput:{
		connect:"SeoDefaultLocaleUniqueWhere",
		create:"SeoDefaultLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateBusinessPagesEntityRelationInput:{
		connect:"BusinessPageLocaleUniqueWhere",
		create:"BusinessPageLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateBusinessPagesRelationInput"
	},
	BusinessPageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"BusinessPageLocaleCreateRootEntityRelationInput",
		content:"BusinessPageLocaleCreateContentEntityRelationInput",
		seo:"BusinessPageLocaleCreateSeoEntityRelationInput",
		link:"BusinessPageLocaleCreateLinkEntityRelationInput",
		image:"BusinessPageLocaleCreateImageEntityRelationInput",
		stickyBar:"BusinessPageLocaleCreateStickyBarEntityRelationInput",
		infoBox:"BusinessPageLocaleCreateInfoBoxEntityRelationInput"
	},
	BusinessPageLocaleCreateRootEntityRelationInput:{
		connect:"BusinessPageUniqueWhere",
		create:"BusinessPageWithoutLocalesCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateRootRelationInput"
	},
	BusinessPageWithoutLocalesCreateInput:{
		id:"UUID",
		theme:"BusinessPageCreateThemeEntityRelationInput"
	},
	BusinessPageCreateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"BusinessPageConnectOrCreateThemeRelationInput"
	},
	BusinessPageConnectOrCreateThemeRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput"
	},
	BusinessPageLocaleConnectOrCreateRootRelationInput:{
		connect:"BusinessPageUniqueWhere",
		create:"BusinessPageWithoutLocalesCreateInput"
	},
	BusinessPageLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateContentRelationInput"
	},
	ContentCreateInput:{
		id:"UUID",
		blocks:"ContentCreateBlocksEntityRelationInput"
	},
	ContentCreateBlocksEntityRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutContentCreateInput",
		connectOrCreate:"ContentConnectOrCreateBlocksRelationInput"
	},
	ContentBlockWithoutContentCreateInput:{
		id:"UUID",
		references:"ContentBlockCreateReferencesEntityRelationInput"
	},
	ContentBlockCreateReferencesEntityRelationInput:{
		connect:"ContentReferenceUniqueWhere",
		create:"ContentReferenceWithoutBlockCreateInput",
		connectOrCreate:"ContentBlockConnectOrCreateReferencesRelationInput"
	},
	ContentReferenceWithoutBlockCreateInput:{
		id:"UUID",
		type:"ContentReferenceType",
		image:"ContentReferenceCreateImageEntityRelationInput",
		linkables:"ContentReferenceCreateLinkablesEntityRelationInput",
		link:"ContentReferenceCreateLinkEntityRelationInput",
		media:"ContentReferenceCreateMediaEntityRelationInput",
		textList:"ContentReferenceCreateTextListEntityRelationInput",
		carousel:"ContentReferenceCreateCarouselEntityRelationInput",
		bonusBanner:"ContentReferenceCreateBonusBannerEntityRelationInput",
		sideBySide:"ContentReferenceCreateSideBySideEntityRelationInput",
		gallery:"ContentReferenceCreateGalleryEntityRelationInput",
		video:"ContentReferenceCreateVideoEntityRelationInput"
	},
	ContentReferenceCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateImageRelationInput"
	},
	ContentReferenceConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ContentReferenceCreateLinkablesEntityRelationInput:{
		connect:"ContentReferenceLinkableItemUniqueWhere"
	},
	ContentReferenceCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateLinkRelationInput"
	},
	ContentReferenceConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	ContentReferenceCreateMediaEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateMediaRelationInput"
	},
	MediumListCreateInput:{
		id:"UUID",
		items:"MediumListCreateItemsEntityRelationInput"
	},
	MediumListCreateItemsEntityRelationInput:{
		connect:"MediumItemUniqueWhere",
		create:"MediumItemWithoutListCreateInput",
		connectOrCreate:"MediumListConnectOrCreateItemsRelationInput"
	},
	MediumItemWithoutListCreateInput:{
		id:"UUID",
		medium:"MediumItemCreateMediumEntityRelationInput"
	},
	MediumItemCreateMediumEntityRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput",
		connectOrCreate:"MediumItemConnectOrCreateMediumRelationInput"
	},
	MediumUniqueWhere:{
		id:"UUID"
	},
	MediumCreateInput:{
		id:"UUID",
		type:"MediumType",
		image:"MediumCreateImageEntityRelationInput",
		video:"MediumCreateVideoEntityRelationInput"
	},
	MediumCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"MediumConnectOrCreateImageRelationInput"
	},
	MediumConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	MediumCreateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"MediumConnectOrCreateVideoRelationInput"
	},
	VideoCreateInput:{
		id:"UUID",
		poster:"VideoCreatePosterEntityRelationInput"
	},
	VideoCreatePosterEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"VideoConnectOrCreatePosterRelationInput"
	},
	VideoConnectOrCreatePosterRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	MediumConnectOrCreateVideoRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput"
	},
	MediumItemConnectOrCreateMediumRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput"
	},
	MediumListConnectOrCreateItemsRelationInput:{
		connect:"MediumItemUniqueWhere",
		create:"MediumItemWithoutListCreateInput"
	},
	ContentReferenceConnectOrCreateMediaRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput"
	},
	ContentReferenceCreateTextListEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateTextListRelationInput"
	},
	TextListUniqueWhere:{
		id:"UUID",
		items:"TextItemUniqueWhere"
	},
	TextItemUniqueWhere:{
		id:"UUID"
	},
	TextListCreateInput:{
		id:"UUID",
		items:"TextListCreateItemsEntityRelationInput"
	},
	TextListCreateItemsEntityRelationInput:{
		connect:"TextItemUniqueWhere",
		create:"TextItemWithoutListCreateInput",
		connectOrCreate:"TextListConnectOrCreateItemsRelationInput"
	},
	TextItemWithoutListCreateInput:{
		id:"UUID"
	},
	TextListConnectOrCreateItemsRelationInput:{
		connect:"TextItemUniqueWhere",
		create:"TextItemWithoutListCreateInput"
	},
	ContentReferenceConnectOrCreateTextListRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput"
	},
	ContentReferenceCreateCarouselEntityRelationInput:{
		connect:"CarouselUniqueWhere",
		create:"CarouselCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateCarouselRelationInput"
	},
	CarouselUniqueWhere:{
		id:"UUID",
		items:"CarouselItemUniqueWhere"
	},
	CarouselItemUniqueWhere:{
		id:"UUID",
		image:"ImageUniqueWhere",
		linkUrl:"LinkUniqueWhere",
		video:"VideoUniqueWhere"
	},
	CarouselCreateInput:{
		id:"UUID",
		items:"CarouselCreateItemsEntityRelationInput",
		background:"Background"
	},
	CarouselCreateItemsEntityRelationInput:{
		connect:"CarouselItemUniqueWhere",
		create:"CarouselItemWithoutListCreateInput",
		connectOrCreate:"CarouselConnectOrCreateItemsRelationInput"
	},
	CarouselItemWithoutListCreateInput:{
		id:"UUID",
		image:"CarouselItemCreateImageEntityRelationInput",
		linkUrl:"CarouselItemCreateLinkUrlEntityRelationInput",
		video:"CarouselItemCreateVideoEntityRelationInput"
	},
	CarouselItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"CarouselItemConnectOrCreateImageRelationInput"
	},
	CarouselItemConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	CarouselItemCreateLinkUrlEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"CarouselItemConnectOrCreateLinkUrlRelationInput"
	},
	CarouselItemConnectOrCreateLinkUrlRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	CarouselItemCreateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"CarouselItemConnectOrCreateVideoRelationInput"
	},
	CarouselItemConnectOrCreateVideoRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput"
	},
	CarouselConnectOrCreateItemsRelationInput:{
		connect:"CarouselItemUniqueWhere",
		create:"CarouselItemWithoutListCreateInput"
	},
	ContentReferenceConnectOrCreateCarouselRelationInput:{
		connect:"CarouselUniqueWhere",
		create:"CarouselCreateInput"
	},
	ContentReferenceCreateBonusBannerEntityRelationInput:{
		connect:"BonusBannerLocaleUniqueWhere",
		create:"BonusBannerLocaleCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateBonusBannerRelationInput"
	},
	BonusBannerLocaleCreateInput:{
		id:"UUID",
		root:"BonusBannerLocaleCreateRootEntityRelationInput",
		locale:"BonusBannerLocaleCreateLocaleEntityRelationInput",
		tiles:"BonusBannerLocaleCreateTilesEntityRelationInput",
		logo:"BonusBannerLocaleCreateLogoEntityRelationInput"
	},
	BonusBannerLocaleCreateRootEntityRelationInput:{
		connect:"BonusBannerUniqueWhere",
		create:"BonusBannerWithoutLocalesCreateInput",
		connectOrCreate:"BonusBannerLocaleConnectOrCreateRootRelationInput"
	},
	BonusBannerWithoutLocalesCreateInput:{
		id:"UUID"
	},
	BonusBannerLocaleConnectOrCreateRootRelationInput:{
		connect:"BonusBannerUniqueWhere",
		create:"BonusBannerWithoutLocalesCreateInput"
	},
	BonusBannerLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutBonusBannersCreateInput",
		connectOrCreate:"BonusBannerLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutBonusBannersCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	LocaleCreateGenericPagesEntityRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateGenericPagesRelationInput"
	},
	GenericPageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"GenericPageLocaleCreateRootEntityRelationInput",
		content:"GenericPageLocaleCreateContentEntityRelationInput",
		seo:"GenericPageLocaleCreateSeoEntityRelationInput",
		link:"GenericPageLocaleCreateLinkEntityRelationInput",
		logo:"GenericPageLocaleCreateLogoEntityRelationInput",
		image:"GenericPageLocaleCreateImageEntityRelationInput"
	},
	GenericPageLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateContentRelationInput"
	},
	GenericPageLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	GenericPageLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateSeoRelationInput"
	},
	GenericPageLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	GenericPageLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutGenericPageCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutGenericPageCreateInput:{
		id:"UUID",
		redirect:"LinkableCreateRedirectEntityRelationInput",
		businessPage:"LinkableCreateBusinessPageEntityRelationInput",
		jobPage:"LinkableCreateJobPageEntityRelationInput",
		homePage:"LinkableCreateHomePageEntityRelationInput",
		homePageLokal:"LinkableCreateHomePageLokalEntityRelationInput"
	},
	LinkableCreateBusinessPageEntityRelationInput:{
		connect:"BusinessPageLocaleUniqueWhere",
		create:"BusinessPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateBusinessPageRelationInput"
	},
	BusinessPageLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"BusinessPageLocaleCreateRootEntityRelationInput",
		locale:"BusinessPageLocaleCreateLocaleEntityRelationInput",
		content:"BusinessPageLocaleCreateContentEntityRelationInput",
		seo:"BusinessPageLocaleCreateSeoEntityRelationInput",
		image:"BusinessPageLocaleCreateImageEntityRelationInput",
		stickyBar:"BusinessPageLocaleCreateStickyBarEntityRelationInput",
		infoBox:"BusinessPageLocaleCreateInfoBoxEntityRelationInput"
	},
	BusinessPageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutBusinessPagesCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutBusinessPagesCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	LocaleCreateJobPagesEntityRelationInput:{
		connect:"JobPageLocaleUniqueWhere",
		create:"JobPageLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateJobPagesRelationInput"
	},
	JobPageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"JobPageLocaleCreateRootEntityRelationInput",
		image:"JobPageLocaleCreateImageEntityRelationInput",
		keyInfo:"JobPageLocaleCreateKeyInfoEntityRelationInput",
		content:"JobPageLocaleCreateContentEntityRelationInput",
		seo:"JobPageLocaleCreateSeoEntityRelationInput",
		link:"JobPageLocaleCreateLinkEntityRelationInput",
		stickyBar:"JobPageLocaleCreateStickyBarEntityRelationInput",
		mobileImage:"JobPageLocaleCreateMobileImageEntityRelationInput"
	},
	JobPageLocaleCreateRootEntityRelationInput:{
		connect:"JobPageUniqueWhere",
		create:"JobPageWithoutLocalesCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateRootRelationInput"
	},
	JobPageWithoutLocalesCreateInput:{
		id:"UUID",
		theme:"JobPageCreateThemeEntityRelationInput",
		contractType:"JobPageCreateContractTypeEntityRelationInput",
		jobCity:"JobPageCreateJobCityEntityRelationInput",
		jobPosition:"JobPageCreateJobPositionEntityRelationInput",
		publishedAt:"DateTime",
		business:"JobPageCreateBusinessEntityRelationInput",
		siteType:"SiteType"
	},
	JobPageCreateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"JobPageConnectOrCreateThemeRelationInput"
	},
	JobPageConnectOrCreateThemeRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput"
	},
	JobPageCreateContractTypeEntityRelationInput:{
		connect:"ContractTypeUniqueWhere",
		create:"ContractTypeCreateInput",
		connectOrCreate:"JobPageConnectOrCreateContractTypeRelationInput"
	},
	ContractTypeCreateInput:{
		id:"UUID",
		locales:"ContractTypeCreateLocalesEntityRelationInput"
	},
	ContractTypeCreateLocalesEntityRelationInput:{
		connect:"ContractTypeLocaleUniqueWhere",
		create:"ContractTypeLocaleWithoutRootCreateInput",
		connectOrCreate:"ContractTypeConnectOrCreateLocalesRelationInput"
	},
	ContractTypeLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"ContractTypeLocaleCreateLocaleEntityRelationInput"
	},
	ContractTypeLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutContractTypesCreateInput",
		connectOrCreate:"ContractTypeLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutContractTypesCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	LocaleCreateJobCitiesEntityRelationInput:{
		connect:"JobCityLocaleUniqueWhere",
		create:"JobCityLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateJobCitiesRelationInput"
	},
	JobCityLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"JobCityLocaleCreateRootEntityRelationInput"
	},
	JobCityLocaleCreateRootEntityRelationInput:{
		connect:"JobCityUniqueWhere",
		create:"JobCityWithoutLocalesCreateInput",
		connectOrCreate:"JobCityLocaleConnectOrCreateRootRelationInput"
	},
	JobCityWithoutLocalesCreateInput:{
		id:"UUID"
	},
	JobCityLocaleConnectOrCreateRootRelationInput:{
		connect:"JobCityUniqueWhere",
		create:"JobCityWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreateJobCitiesRelationInput:{
		connect:"JobCityLocaleUniqueWhere",
		create:"JobCityLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateJobPositionsEntityRelationInput:{
		connect:"JobPositionLocaleUniqueWhere",
		create:"JobPositionLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateJobPositionsRelationInput"
	},
	JobPositionLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"JobPositionLocaleCreateRootEntityRelationInput"
	},
	JobPositionLocaleCreateRootEntityRelationInput:{
		connect:"JobPositionUniqueWhere",
		create:"JobPositionWithoutLocalesCreateInput",
		connectOrCreate:"JobPositionLocaleConnectOrCreateRootRelationInput"
	},
	JobPositionWithoutLocalesCreateInput:{
		id:"UUID",
		jobs:"JobPositionCreateJobsEntityRelationInput"
	},
	JobPositionCreateJobsEntityRelationInput:{
		connect:"JobPageUniqueWhere",
		create:"JobPageWithoutJobPositionCreateInput",
		connectOrCreate:"JobPositionConnectOrCreateJobsRelationInput"
	},
	JobPageWithoutJobPositionCreateInput:{
		id:"UUID",
		locales:"JobPageCreateLocalesEntityRelationInput",
		theme:"JobPageCreateThemeEntityRelationInput",
		contractType:"JobPageCreateContractTypeEntityRelationInput",
		jobCity:"JobPageCreateJobCityEntityRelationInput",
		publishedAt:"DateTime",
		business:"JobPageCreateBusinessEntityRelationInput",
		siteType:"SiteType"
	},
	JobPageCreateLocalesEntityRelationInput:{
		connect:"JobPageLocaleUniqueWhere",
		create:"JobPageLocaleWithoutRootCreateInput",
		connectOrCreate:"JobPageConnectOrCreateLocalesRelationInput"
	},
	JobPageLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"JobPageLocaleCreateLocaleEntityRelationInput",
		image:"JobPageLocaleCreateImageEntityRelationInput",
		keyInfo:"JobPageLocaleCreateKeyInfoEntityRelationInput",
		content:"JobPageLocaleCreateContentEntityRelationInput",
		seo:"JobPageLocaleCreateSeoEntityRelationInput",
		link:"JobPageLocaleCreateLinkEntityRelationInput",
		stickyBar:"JobPageLocaleCreateStickyBarEntityRelationInput",
		mobileImage:"JobPageLocaleCreateMobileImageEntityRelationInput"
	},
	JobPageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobPagesCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutJobPagesCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	LocaleCreateContractTypesEntityRelationInput:{
		connect:"ContractTypeLocaleUniqueWhere",
		create:"ContractTypeLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateContractTypesRelationInput"
	},
	ContractTypeLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"ContractTypeLocaleCreateRootEntityRelationInput"
	},
	ContractTypeLocaleCreateRootEntityRelationInput:{
		connect:"ContractTypeUniqueWhere",
		create:"ContractTypeWithoutLocalesCreateInput",
		connectOrCreate:"ContractTypeLocaleConnectOrCreateRootRelationInput"
	},
	ContractTypeWithoutLocalesCreateInput:{
		id:"UUID"
	},
	ContractTypeLocaleConnectOrCreateRootRelationInput:{
		connect:"ContractTypeUniqueWhere",
		create:"ContractTypeWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreateContractTypesRelationInput:{
		connect:"ContractTypeLocaleUniqueWhere",
		create:"ContractTypeLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateHomePagesEntityRelationInput:{
		connect:"HomePageLocaleUniqueWhere",
		create:"HomePageLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateHomePagesRelationInput"
	},
	HomePageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"HomePageLocaleCreateRootEntityRelationInput",
		button:"HomePageLocaleCreateButtonEntityRelationInput",
		content:"HomePageLocaleCreateContentEntityRelationInput",
		seo:"HomePageLocaleCreateSeoEntityRelationInput",
		link:"HomePageLocaleCreateLinkEntityRelationInput",
		logo:"HomePageLocaleCreateLogoEntityRelationInput",
		siteSwitcher:"HomePageLocaleCreateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLocaleCreateGalleryEntityRelationInput",
		stickyBar:"HomePageLocaleCreateStickyBarEntityRelationInput",
		ilustration:"HomePageLocaleCreateIlustrationEntityRelationInput"
	},
	HomePageLocaleCreateRootEntityRelationInput:{
		connect:"HomePageUniqueWhere",
		create:"HomePageWithoutLocalesCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateRootRelationInput"
	},
	HomePageWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One",
		theme:"HomePageCreateThemeEntityRelationInput"
	},
	HomePageCreateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"HomePageConnectOrCreateThemeRelationInput"
	},
	HomePageConnectOrCreateThemeRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput"
	},
	HomePageLocaleConnectOrCreateRootRelationInput:{
		connect:"HomePageUniqueWhere",
		create:"HomePageWithoutLocalesCreateInput"
	},
	HomePageLocaleCreateButtonEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateButtonRelationInput"
	},
	HomePageLocaleConnectOrCreateButtonRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	HomePageLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateContentRelationInput"
	},
	HomePageLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	HomePageLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateSeoRelationInput"
	},
	HomePageLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	HomePageLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutHomePageCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutHomePageCreateInput:{
		id:"UUID",
		redirect:"LinkableCreateRedirectEntityRelationInput",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		businessPage:"LinkableCreateBusinessPageEntityRelationInput",
		jobPage:"LinkableCreateJobPageEntityRelationInput",
		homePageLokal:"LinkableCreateHomePageLokalEntityRelationInput"
	},
	LinkableCreateJobPageEntityRelationInput:{
		connect:"JobPageLocaleUniqueWhere",
		create:"JobPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateJobPageRelationInput"
	},
	JobPageLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"JobPageLocaleCreateRootEntityRelationInput",
		locale:"JobPageLocaleCreateLocaleEntityRelationInput",
		image:"JobPageLocaleCreateImageEntityRelationInput",
		keyInfo:"JobPageLocaleCreateKeyInfoEntityRelationInput",
		content:"JobPageLocaleCreateContentEntityRelationInput",
		seo:"JobPageLocaleCreateSeoEntityRelationInput",
		stickyBar:"JobPageLocaleCreateStickyBarEntityRelationInput",
		mobileImage:"JobPageLocaleCreateMobileImageEntityRelationInput"
	},
	JobPageLocaleCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateImageRelationInput"
	},
	JobPageLocaleConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	JobPageLocaleCreateKeyInfoEntityRelationInput:{
		connect:"KeyInfoListUniqueWhere",
		create:"KeyInfoListCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateKeyInfoRelationInput"
	},
	KeyInfoListCreateInput:{
		id:"UUID",
		items:"KeyInfoListCreateItemsEntityRelationInput"
	},
	KeyInfoListCreateItemsEntityRelationInput:{
		connect:"KeyInfoItemUniqueWhere",
		create:"KeyInfoItemWithoutListCreateInput",
		connectOrCreate:"KeyInfoListConnectOrCreateItemsRelationInput"
	},
	KeyInfoItemWithoutListCreateInput:{
		id:"UUID",
		icon:"KeyInfoItemCreateIconEntityRelationInput"
	},
	KeyInfoItemCreateIconEntityRelationInput:{
		connect:"IconUniqueWhere",
		create:"IconCreateInput",
		connectOrCreate:"KeyInfoItemConnectOrCreateIconRelationInput"
	},
	IconUniqueWhere:{
		id:"UUID",
		icon:"ImageUniqueWhere"
	},
	IconCreateInput:{
		id:"UUID",
		icon:"IconCreateIconEntityRelationInput"
	},
	IconCreateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"IconConnectOrCreateIconRelationInput"
	},
	IconConnectOrCreateIconRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	KeyInfoItemConnectOrCreateIconRelationInput:{
		connect:"IconUniqueWhere",
		create:"IconCreateInput"
	},
	KeyInfoListConnectOrCreateItemsRelationInput:{
		connect:"KeyInfoItemUniqueWhere",
		create:"KeyInfoItemWithoutListCreateInput"
	},
	JobPageLocaleConnectOrCreateKeyInfoRelationInput:{
		connect:"KeyInfoListUniqueWhere",
		create:"KeyInfoListCreateInput"
	},
	JobPageLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateContentRelationInput"
	},
	JobPageLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	JobPageLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateSeoRelationInput"
	},
	JobPageLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	JobPageLocaleCreateStickyBarEntityRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateStickyBarRelationInput"
	},
	StickyBarUniqueWhere:{
		id:"UUID",
		link:"LinkUniqueWhere"
	},
	StickyBarCreateInput:{
		id:"UUID",
		link:"StickyBarCreateLinkEntityRelationInput",
		jobsForm:"StickyBarCreateJobsFormEntityRelationInput"
	},
	StickyBarCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"StickyBarConnectOrCreateLinkRelationInput"
	},
	StickyBarConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	StickyBarCreateJobsFormEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput",
		connectOrCreate:"StickyBarConnectOrCreateJobsFormRelationInput"
	},
	JobsFormLocaleCreateInput:{
		id:"UUID",
		root:"JobsFormLocaleCreateRootEntityRelationInput",
		locale:"JobsFormLocaleCreateLocaleEntityRelationInput",
		imageTextList:"JobsFormLocaleCreateImageTextListEntityRelationInput",
		logo:"JobsFormLocaleCreateLogoEntityRelationInput",
		successImage:"JobsFormLocaleCreateSuccessImageEntityRelationInput"
	},
	JobsFormLocaleCreateRootEntityRelationInput:{
		connect:"JobsFormUniqueWhere",
		create:"JobsFormWithoutLocalesCreateInput",
		connectOrCreate:"JobsFormLocaleConnectOrCreateRootRelationInput"
	},
	JobsFormWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One",
		fileIlustration:"JobsFormCreateFileIlustrationEntityRelationInput"
	},
	JobsFormCreateFileIlustrationEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobsFormConnectOrCreateFileIlustrationRelationInput"
	},
	JobsFormConnectOrCreateFileIlustrationRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	JobsFormLocaleConnectOrCreateRootRelationInput:{
		connect:"JobsFormUniqueWhere",
		create:"JobsFormWithoutLocalesCreateInput"
	},
	JobsFormLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobsFormsCreateInput",
		connectOrCreate:"JobsFormLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutJobsFormsCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	LocaleCreateBonusBannersEntityRelationInput:{
		connect:"BonusBannerLocaleUniqueWhere",
		create:"BonusBannerLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateBonusBannersRelationInput"
	},
	BonusBannerLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"BonusBannerLocaleCreateRootEntityRelationInput",
		tiles:"BonusBannerLocaleCreateTilesEntityRelationInput",
		logo:"BonusBannerLocaleCreateLogoEntityRelationInput"
	},
	BonusBannerLocaleCreateTilesEntityRelationInput:{
		connect:"TileUniqueWhere",
		create:"TileWithoutBonusBannerCreateInput",
		connectOrCreate:"BonusBannerLocaleConnectOrCreateTilesRelationInput"
	},
	TileWithoutBonusBannerCreateInput:{
		id:"UUID",
		image:"TileCreateImageEntityRelationInput",
		ligthBoxMedia:"TileCreateLigthBoxMediaEntityRelationInput",
		lightBoxForm:"TileCreateLightBoxFormEntityRelationInput"
	},
	TileCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"TileConnectOrCreateImageRelationInput"
	},
	TileConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	TileCreateLigthBoxMediaEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput",
		connectOrCreate:"TileConnectOrCreateLigthBoxMediaRelationInput"
	},
	TileConnectOrCreateLigthBoxMediaRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput"
	},
	TileCreateLightBoxFormEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput",
		connectOrCreate:"TileConnectOrCreateLightBoxFormRelationInput"
	},
	TileConnectOrCreateLightBoxFormRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput"
	},
	BonusBannerLocaleConnectOrCreateTilesRelationInput:{
		connect:"TileUniqueWhere",
		create:"TileWithoutBonusBannerCreateInput"
	},
	BonusBannerLocaleCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"BonusBannerLocaleConnectOrCreateLogoRelationInput"
	},
	BonusBannerLocaleConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	LocaleConnectOrCreateBonusBannersRelationInput:{
		connect:"BonusBannerLocaleUniqueWhere",
		create:"BonusBannerLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateHomePageLokalsEntityRelationInput:{
		connect:"HomePageLokalLocaleUniqueWhere",
		create:"HomePageLokalLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateHomePageLokalsRelationInput"
	},
	HomePageLokalLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"HomePageLokalLocaleCreateRootEntityRelationInput",
		logo:"HomePageLokalLocaleCreateLogoEntityRelationInput",
		button:"HomePageLokalLocaleCreateButtonEntityRelationInput",
		content:"HomePageLokalLocaleCreateContentEntityRelationInput",
		seo:"HomePageLokalLocaleCreateSeoEntityRelationInput",
		link:"HomePageLokalLocaleCreateLinkEntityRelationInput",
		siteSwitcher:"HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLokalLocaleCreateGalleryEntityRelationInput",
		stickyBar:"HomePageLokalLocaleCreateStickyBarEntityRelationInput",
		ilustration:"HomePageLokalLocaleCreateIlustrationEntityRelationInput"
	},
	HomePageLokalLocaleCreateRootEntityRelationInput:{
		connect:"HomePageLokalUniqueWhere",
		create:"HomePageLokalWithoutLocalesCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateRootRelationInput"
	},
	HomePageLokalWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One",
		theme:"HomePageLokalCreateThemeEntityRelationInput"
	},
	HomePageLokalCreateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"HomePageLokalConnectOrCreateThemeRelationInput"
	},
	HomePageLokalConnectOrCreateThemeRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput"
	},
	HomePageLokalLocaleConnectOrCreateRootRelationInput:{
		connect:"HomePageLokalUniqueWhere",
		create:"HomePageLokalWithoutLocalesCreateInput"
	},
	HomePageLokalLocaleCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateLogoRelationInput"
	},
	HomePageLokalLocaleConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	HomePageLokalLocaleCreateButtonEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateButtonRelationInput"
	},
	HomePageLokalLocaleConnectOrCreateButtonRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	HomePageLokalLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateContentRelationInput"
	},
	HomePageLokalLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	HomePageLokalLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateSeoRelationInput"
	},
	HomePageLokalLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	HomePageLokalLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutHomePageLokalCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutHomePageLokalCreateInput:{
		id:"UUID",
		redirect:"LinkableCreateRedirectEntityRelationInput",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		businessPage:"LinkableCreateBusinessPageEntityRelationInput",
		jobPage:"LinkableCreateJobPageEntityRelationInput",
		homePage:"LinkableCreateHomePageEntityRelationInput"
	},
	LinkableCreateHomePageEntityRelationInput:{
		connect:"HomePageLocaleUniqueWhere",
		create:"HomePageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateHomePageRelationInput"
	},
	HomePageLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"HomePageLocaleCreateRootEntityRelationInput",
		locale:"HomePageLocaleCreateLocaleEntityRelationInput",
		button:"HomePageLocaleCreateButtonEntityRelationInput",
		content:"HomePageLocaleCreateContentEntityRelationInput",
		seo:"HomePageLocaleCreateSeoEntityRelationInput",
		logo:"HomePageLocaleCreateLogoEntityRelationInput",
		siteSwitcher:"HomePageLocaleCreateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLocaleCreateGalleryEntityRelationInput",
		stickyBar:"HomePageLocaleCreateStickyBarEntityRelationInput",
		ilustration:"HomePageLocaleCreateIlustrationEntityRelationInput"
	},
	HomePageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHomePagesCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutHomePagesCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	LocaleCreateJobsFormsEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateJobsFormsRelationInput"
	},
	JobsFormLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"JobsFormLocaleCreateRootEntityRelationInput",
		imageTextList:"JobsFormLocaleCreateImageTextListEntityRelationInput",
		logo:"JobsFormLocaleCreateLogoEntityRelationInput",
		successImage:"JobsFormLocaleCreateSuccessImageEntityRelationInput"
	},
	JobsFormLocaleCreateImageTextListEntityRelationInput:{
		connect:"ImageTextListUniqueWhere",
		create:"ImageTextListCreateInput",
		connectOrCreate:"JobsFormLocaleConnectOrCreateImageTextListRelationInput"
	},
	ImageTextListCreateInput:{
		id:"UUID",
		items:"ImageTextListCreateItemsEntityRelationInput"
	},
	ImageTextListCreateItemsEntityRelationInput:{
		connect:"ImageTextItemUniqueWhere",
		create:"ImageTextItemWithoutListCreateInput",
		connectOrCreate:"ImageTextListConnectOrCreateItemsRelationInput"
	},
	ImageTextItemWithoutListCreateInput:{
		id:"UUID",
		image:"ImageTextItemCreateImageEntityRelationInput"
	},
	ImageTextItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ImageTextItemConnectOrCreateImageRelationInput"
	},
	ImageTextItemConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ImageTextListConnectOrCreateItemsRelationInput:{
		connect:"ImageTextItemUniqueWhere",
		create:"ImageTextItemWithoutListCreateInput"
	},
	JobsFormLocaleConnectOrCreateImageTextListRelationInput:{
		connect:"ImageTextListUniqueWhere",
		create:"ImageTextListCreateInput"
	},
	JobsFormLocaleCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobsFormLocaleConnectOrCreateLogoRelationInput"
	},
	JobsFormLocaleConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	JobsFormLocaleCreateSuccessImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobsFormLocaleConnectOrCreateSuccessImageRelationInput"
	},
	JobsFormLocaleConnectOrCreateSuccessImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	LocaleConnectOrCreateJobsFormsRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateJobsFiltersEntityRelationInput:{
		connect:"JobsFilterLocaleUniqueWhere",
		create:"JobsFilterLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateJobsFiltersRelationInput"
	},
	JobsFilterLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"JobsFilterLocaleCreateRootEntityRelationInput",
		bannerJobsForm:"JobsFilterLocaleCreateBannerJobsFormEntityRelationInput",
		bannerImage:"JobsFilterLocaleCreateBannerImageEntityRelationInput",
		noJobImage:"JobsFilterLocaleCreateNoJobImageEntityRelationInput"
	},
	JobsFilterLocaleCreateRootEntityRelationInput:{
		connect:"JobsFilterUniqueWhere",
		create:"JobsFilterWithoutLocalesCreateInput",
		connectOrCreate:"JobsFilterLocaleConnectOrCreateRootRelationInput"
	},
	JobsFilterWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	JobsFilterLocaleConnectOrCreateRootRelationInput:{
		connect:"JobsFilterUniqueWhere",
		create:"JobsFilterWithoutLocalesCreateInput"
	},
	JobsFilterLocaleCreateBannerJobsFormEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput",
		connectOrCreate:"JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"
	},
	JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput"
	},
	JobsFilterLocaleCreateBannerImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobsFilterLocaleConnectOrCreateBannerImageRelationInput"
	},
	JobsFilterLocaleConnectOrCreateBannerImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	JobsFilterLocaleCreateNoJobImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"
	},
	JobsFilterLocaleConnectOrCreateNoJobImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	LocaleConnectOrCreateJobsFiltersRelationInput:{
		connect:"JobsFilterLocaleUniqueWhere",
		create:"JobsFilterLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateGeneralEntityRelationInput:{
		connect:"GeneralLocaleUniqueWhere",
		create:"GeneralLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateGeneralRelationInput"
	},
	GeneralLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"GeneralLocaleCreateRootEntityRelationInput",
		seo:"GeneralLocaleCreateSeoEntityRelationInput",
		cornerBanner:"GeneralLocaleCreateCornerBannerEntityRelationInput"
	},
	GeneralLocaleCreateRootEntityRelationInput:{
		connect:"GeneralUniqueWhere",
		create:"GeneralWithoutLocalesCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateRootRelationInput"
	},
	GeneralWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	GeneralLocaleConnectOrCreateRootRelationInput:{
		connect:"GeneralUniqueWhere",
		create:"GeneralWithoutLocalesCreateInput"
	},
	GeneralLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateSeoRelationInput"
	},
	GeneralLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	GeneralLocaleCreateCornerBannerEntityRelationInput:{
		connect:"CornerBannerUniqueWhere",
		create:"CornerBannerCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateCornerBannerRelationInput"
	},
	CornerBannerCreateInput:{
		id:"UUID",
		logo:"CornerBannerCreateLogoEntityRelationInput",
		link:"CornerBannerCreateLinkEntityRelationInput"
	},
	CornerBannerCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"CornerBannerConnectOrCreateLogoRelationInput"
	},
	CornerBannerConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	CornerBannerCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"CornerBannerConnectOrCreateLinkRelationInput"
	},
	CornerBannerConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	GeneralLocaleConnectOrCreateCornerBannerRelationInput:{
		connect:"CornerBannerUniqueWhere",
		create:"CornerBannerCreateInput"
	},
	LocaleConnectOrCreateGeneralRelationInput:{
		connect:"GeneralLocaleUniqueWhere",
		create:"GeneralLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateRecommendationFormsEntityRelationInput:{
		connect:"RecommendationFormLocaleUniqueWhere",
		create:"RecommendationFormLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateRecommendationFormsRelationInput"
	},
	RecommendationFormLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"RecommendationFormLocaleCreateRootEntityRelationInput"
	},
	RecommendationFormLocaleCreateRootEntityRelationInput:{
		connect:"RecommendationFormUniqueWhere",
		create:"RecommendationFormWithoutLocalesCreateInput",
		connectOrCreate:"RecommendationFormLocaleConnectOrCreateRootRelationInput"
	},
	RecommendationFormWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One",
		successImage:"RecommendationFormCreateSuccessImageEntityRelationInput"
	},
	RecommendationFormCreateSuccessImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"RecommendationFormConnectOrCreateSuccessImageRelationInput"
	},
	RecommendationFormConnectOrCreateSuccessImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	RecommendationFormLocaleConnectOrCreateRootRelationInput:{
		connect:"RecommendationFormUniqueWhere",
		create:"RecommendationFormWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreateRecommendationFormsRelationInput:{
		connect:"RecommendationFormLocaleUniqueWhere",
		create:"RecommendationFormLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateInfoBoxesEntityRelationInput:{
		connect:"InfoBoxLocaleUniqueWhere",
		create:"InfoBoxLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateInfoBoxesRelationInput"
	},
	InfoBoxLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"InfoBoxLocaleCreateRootEntityRelationInput",
		openingHours:"InfoBoxLocaleCreateOpeningHoursEntityRelationInput"
	},
	InfoBoxLocaleCreateRootEntityRelationInput:{
		connect:"InfoBoxUniqueWhere",
		create:"InfoBoxWithoutLocalesCreateInput",
		connectOrCreate:"InfoBoxLocaleConnectOrCreateRootRelationInput"
	},
	InfoBoxWithoutLocalesCreateInput:{
		id:"UUID",
		logoSize:"LogoSize",
		logo:"InfoBoxCreateLogoEntityRelationInput"
	},
	InfoBoxCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"InfoBoxConnectOrCreateLogoRelationInput"
	},
	InfoBoxConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	InfoBoxLocaleConnectOrCreateRootRelationInput:{
		connect:"InfoBoxUniqueWhere",
		create:"InfoBoxWithoutLocalesCreateInput"
	},
	InfoBoxLocaleCreateOpeningHoursEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput",
		connectOrCreate:"InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"
	},
	InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput"
	},
	LocaleConnectOrCreateInfoBoxesRelationInput:{
		connect:"InfoBoxLocaleUniqueWhere",
		create:"InfoBoxLocaleWithoutLocaleCreateInput"
	},
	LocaleCreateTranslationsEntityRelationInput:{
		connect:"TranslationLocaleUniqueWhere",
		create:"TranslationLocaleWithoutLocaleCreateInput",
		connectOrCreate:"LocaleConnectOrCreateTranslationsRelationInput"
	},
	TranslationLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"TranslationLocaleCreateRootEntityRelationInput"
	},
	TranslationLocaleCreateRootEntityRelationInput:{
		connect:"TranslationUniqueWhere",
		create:"TranslationWithoutLocalesCreateInput",
		connectOrCreate:"TranslationLocaleConnectOrCreateRootRelationInput"
	},
	TranslationWithoutLocalesCreateInput:{
		id:"UUID"
	},
	TranslationLocaleConnectOrCreateRootRelationInput:{
		connect:"TranslationUniqueWhere",
		create:"TranslationWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreateTranslationsRelationInput:{
		connect:"TranslationLocaleUniqueWhere",
		create:"TranslationLocaleWithoutLocaleCreateInput"
	},
	HomePageLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHomePagesCreateInput"
	},
	HomePageLocaleCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateLogoRelationInput"
	},
	HomePageLocaleConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	HomePageLocaleCreateSiteSwitcherEntityRelationInput:{
		connect:"SiteSwitcherUniqueWhere",
		create:"SiteSwitcherCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"
	},
	SiteSwitcherCreateInput:{
		id:"UUID",
		link:"SiteSwitcherCreateLinkEntityRelationInput",
		theme:"SiteSwitcherCreateThemeEntityRelationInput"
	},
	SiteSwitcherCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"SiteSwitcherConnectOrCreateLinkRelationInput"
	},
	SiteSwitcherConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	SiteSwitcherCreateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"SiteSwitcherConnectOrCreateThemeRelationInput"
	},
	SiteSwitcherConnectOrCreateThemeRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput"
	},
	HomePageLocaleConnectOrCreateSiteSwitcherRelationInput:{
		connect:"SiteSwitcherUniqueWhere",
		create:"SiteSwitcherCreateInput"
	},
	HomePageLocaleCreateGalleryEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateGalleryRelationInput"
	},
	GalleryCreateInput:{
		id:"UUID",
		items:"GalleryCreateItemsEntityRelationInput"
	},
	GalleryCreateItemsEntityRelationInput:{
		connect:"GalleryItemUniqueWhere",
		create:"GalleryItemWithoutListCreateInput",
		connectOrCreate:"GalleryConnectOrCreateItemsRelationInput"
	},
	GalleryItemWithoutListCreateInput:{
		id:"UUID",
		image:"GalleryItemCreateImageEntityRelationInput"
	},
	GalleryItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"GalleryItemConnectOrCreateImageRelationInput"
	},
	GalleryItemConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	GalleryConnectOrCreateItemsRelationInput:{
		connect:"GalleryItemUniqueWhere",
		create:"GalleryItemWithoutListCreateInput"
	},
	HomePageLocaleConnectOrCreateGalleryRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput"
	},
	HomePageLocaleCreateStickyBarEntityRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateStickyBarRelationInput"
	},
	HomePageLocaleConnectOrCreateStickyBarRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput"
	},
	HomePageLocaleCreateIlustrationEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateIlustrationRelationInput"
	},
	HomePageLocaleConnectOrCreateIlustrationRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput"
	},
	LinkableConnectOrCreateHomePageRelationInput:{
		connect:"HomePageLocaleUniqueWhere",
		create:"HomePageLocaleWithoutLinkCreateInput"
	},
	HomePageLokalLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutHomePageLokalCreateInput"
	},
	HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput:{
		connect:"SiteSwitcherUniqueWhere",
		create:"SiteSwitcherCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"
	},
	HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput:{
		connect:"SiteSwitcherUniqueWhere",
		create:"SiteSwitcherCreateInput"
	},
	HomePageLokalLocaleCreateGalleryEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateGalleryRelationInput"
	},
	HomePageLokalLocaleConnectOrCreateGalleryRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput"
	},
	HomePageLokalLocaleCreateStickyBarEntityRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"
	},
	HomePageLokalLocaleConnectOrCreateStickyBarRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput"
	},
	HomePageLokalLocaleCreateIlustrationEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"
	},
	HomePageLokalLocaleConnectOrCreateIlustrationRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput"
	},
	LocaleConnectOrCreateHomePageLokalsRelationInput:{
		connect:"HomePageLokalLocaleUniqueWhere",
		create:"HomePageLokalLocaleWithoutLocaleCreateInput"
	},
	JobsFormLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobsFormsCreateInput"
	},
	StickyBarConnectOrCreateJobsFormRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput"
	},
	JobPageLocaleConnectOrCreateStickyBarRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput"
	},
	JobPageLocaleCreateMobileImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateMobileImageRelationInput"
	},
	JobPageLocaleConnectOrCreateMobileImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	LinkableConnectOrCreateJobPageRelationInput:{
		connect:"JobPageLocaleUniqueWhere",
		create:"JobPageLocaleWithoutLinkCreateInput"
	},
	LinkableCreateHomePageLokalEntityRelationInput:{
		connect:"HomePageLokalLocaleUniqueWhere",
		create:"HomePageLokalLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateHomePageLokalRelationInput"
	},
	HomePageLokalLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"HomePageLokalLocaleCreateRootEntityRelationInput",
		locale:"HomePageLokalLocaleCreateLocaleEntityRelationInput",
		logo:"HomePageLokalLocaleCreateLogoEntityRelationInput",
		button:"HomePageLokalLocaleCreateButtonEntityRelationInput",
		content:"HomePageLokalLocaleCreateContentEntityRelationInput",
		seo:"HomePageLokalLocaleCreateSeoEntityRelationInput",
		siteSwitcher:"HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLokalLocaleCreateGalleryEntityRelationInput",
		stickyBar:"HomePageLokalLocaleCreateStickyBarEntityRelationInput",
		ilustration:"HomePageLokalLocaleCreateIlustrationEntityRelationInput"
	},
	HomePageLokalLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHomePageLokalsCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutHomePageLokalsCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	HomePageLokalLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHomePageLokalsCreateInput"
	},
	LinkableConnectOrCreateHomePageLokalRelationInput:{
		connect:"HomePageLokalLocaleUniqueWhere",
		create:"HomePageLokalLocaleWithoutLinkCreateInput"
	},
	HomePageLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutHomePageCreateInput"
	},
	LocaleConnectOrCreateHomePagesRelationInput:{
		connect:"HomePageLocaleUniqueWhere",
		create:"HomePageLocaleWithoutLocaleCreateInput"
	},
	JobPageLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobPagesCreateInput"
	},
	JobPageLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutJobPageCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutJobPageCreateInput:{
		id:"UUID",
		redirect:"LinkableCreateRedirectEntityRelationInput",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		businessPage:"LinkableCreateBusinessPageEntityRelationInput",
		homePage:"LinkableCreateHomePageEntityRelationInput",
		homePageLokal:"LinkableCreateHomePageLokalEntityRelationInput"
	},
	JobPageLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutJobPageCreateInput"
	},
	JobPageConnectOrCreateLocalesRelationInput:{
		connect:"JobPageLocaleUniqueWhere",
		create:"JobPageLocaleWithoutRootCreateInput"
	},
	JobPageCreateJobCityEntityRelationInput:{
		connect:"JobCityUniqueWhere",
		create:"JobCityCreateInput",
		connectOrCreate:"JobPageConnectOrCreateJobCityRelationInput"
	},
	JobCityCreateInput:{
		id:"UUID",
		locales:"JobCityCreateLocalesEntityRelationInput"
	},
	JobCityCreateLocalesEntityRelationInput:{
		connect:"JobCityLocaleUniqueWhere",
		create:"JobCityLocaleWithoutRootCreateInput",
		connectOrCreate:"JobCityConnectOrCreateLocalesRelationInput"
	},
	JobCityLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"JobCityLocaleCreateLocaleEntityRelationInput"
	},
	JobCityLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobCitiesCreateInput",
		connectOrCreate:"JobCityLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutJobCitiesCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	JobCityLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobCitiesCreateInput"
	},
	JobCityConnectOrCreateLocalesRelationInput:{
		connect:"JobCityLocaleUniqueWhere",
		create:"JobCityLocaleWithoutRootCreateInput"
	},
	JobPageConnectOrCreateJobCityRelationInput:{
		connect:"JobCityUniqueWhere",
		create:"JobCityCreateInput"
	},
	JobPageCreateBusinessEntityRelationInput:{
		connect:"BusinessPageUniqueWhere",
		create:"BusinessPageCreateInput",
		connectOrCreate:"JobPageConnectOrCreateBusinessRelationInput"
	},
	BusinessPageCreateInput:{
		id:"UUID",
		locales:"BusinessPageCreateLocalesEntityRelationInput",
		theme:"BusinessPageCreateThemeEntityRelationInput"
	},
	BusinessPageCreateLocalesEntityRelationInput:{
		connect:"BusinessPageLocaleUniqueWhere",
		create:"BusinessPageLocaleWithoutRootCreateInput",
		connectOrCreate:"BusinessPageConnectOrCreateLocalesRelationInput"
	},
	BusinessPageLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"BusinessPageLocaleCreateLocaleEntityRelationInput",
		content:"BusinessPageLocaleCreateContentEntityRelationInput",
		seo:"BusinessPageLocaleCreateSeoEntityRelationInput",
		link:"BusinessPageLocaleCreateLinkEntityRelationInput",
		image:"BusinessPageLocaleCreateImageEntityRelationInput",
		stickyBar:"BusinessPageLocaleCreateStickyBarEntityRelationInput",
		infoBox:"BusinessPageLocaleCreateInfoBoxEntityRelationInput"
	},
	BusinessPageLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateSeoRelationInput"
	},
	BusinessPageLocaleConnectOrCreateSeoRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	BusinessPageLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutBusinessPageCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutBusinessPageCreateInput:{
		id:"UUID",
		redirect:"LinkableCreateRedirectEntityRelationInput",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		jobPage:"LinkableCreateJobPageEntityRelationInput",
		homePage:"LinkableCreateHomePageEntityRelationInput",
		homePageLokal:"LinkableCreateHomePageLokalEntityRelationInput"
	},
	BusinessPageLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutBusinessPageCreateInput"
	},
	BusinessPageLocaleCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateImageRelationInput"
	},
	BusinessPageLocaleConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	BusinessPageLocaleCreateStickyBarEntityRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateStickyBarRelationInput"
	},
	BusinessPageLocaleConnectOrCreateStickyBarRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput"
	},
	BusinessPageLocaleCreateInfoBoxEntityRelationInput:{
		connect:"InfoBoxUniqueWhere",
		create:"InfoBoxCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"
	},
	InfoBoxCreateInput:{
		id:"UUID",
		logoSize:"LogoSize",
		logo:"InfoBoxCreateLogoEntityRelationInput",
		locales:"InfoBoxCreateLocalesEntityRelationInput"
	},
	InfoBoxCreateLocalesEntityRelationInput:{
		connect:"InfoBoxLocaleUniqueWhere",
		create:"InfoBoxLocaleWithoutRootCreateInput",
		connectOrCreate:"InfoBoxConnectOrCreateLocalesRelationInput"
	},
	InfoBoxLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"InfoBoxLocaleCreateLocaleEntityRelationInput",
		openingHours:"InfoBoxLocaleCreateOpeningHoursEntityRelationInput"
	},
	InfoBoxLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutInfoBoxesCreateInput",
		connectOrCreate:"InfoBoxLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutInfoBoxesCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	InfoBoxLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutInfoBoxesCreateInput"
	},
	InfoBoxConnectOrCreateLocalesRelationInput:{
		connect:"InfoBoxLocaleUniqueWhere",
		create:"InfoBoxLocaleWithoutRootCreateInput"
	},
	BusinessPageLocaleConnectOrCreateInfoBoxRelationInput:{
		connect:"InfoBoxUniqueWhere",
		create:"InfoBoxCreateInput"
	},
	BusinessPageConnectOrCreateLocalesRelationInput:{
		connect:"BusinessPageLocaleUniqueWhere",
		create:"BusinessPageLocaleWithoutRootCreateInput"
	},
	JobPageConnectOrCreateBusinessRelationInput:{
		connect:"BusinessPageUniqueWhere",
		create:"BusinessPageCreateInput"
	},
	JobPositionConnectOrCreateJobsRelationInput:{
		connect:"JobPageUniqueWhere",
		create:"JobPageWithoutJobPositionCreateInput"
	},
	JobPositionLocaleConnectOrCreateRootRelationInput:{
		connect:"JobPositionUniqueWhere",
		create:"JobPositionWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreateJobPositionsRelationInput:{
		connect:"JobPositionLocaleUniqueWhere",
		create:"JobPositionLocaleWithoutLocaleCreateInput"
	},
	ContractTypeLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutContractTypesCreateInput"
	},
	ContractTypeConnectOrCreateLocalesRelationInput:{
		connect:"ContractTypeLocaleUniqueWhere",
		create:"ContractTypeLocaleWithoutRootCreateInput"
	},
	JobPageConnectOrCreateContractTypeRelationInput:{
		connect:"ContractTypeUniqueWhere",
		create:"ContractTypeCreateInput"
	},
	JobPageCreateJobPositionEntityRelationInput:{
		connect:"JobPositionUniqueWhere",
		create:"JobPositionWithoutJobsCreateInput",
		connectOrCreate:"JobPageConnectOrCreateJobPositionRelationInput"
	},
	JobPositionWithoutJobsCreateInput:{
		id:"UUID",
		locales:"JobPositionCreateLocalesEntityRelationInput"
	},
	JobPositionCreateLocalesEntityRelationInput:{
		connect:"JobPositionLocaleUniqueWhere",
		create:"JobPositionLocaleWithoutRootCreateInput",
		connectOrCreate:"JobPositionConnectOrCreateLocalesRelationInput"
	},
	JobPositionLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"JobPositionLocaleCreateLocaleEntityRelationInput"
	},
	JobPositionLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobPositionsCreateInput",
		connectOrCreate:"JobPositionLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutJobPositionsCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	JobPositionLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobPositionsCreateInput"
	},
	JobPositionConnectOrCreateLocalesRelationInput:{
		connect:"JobPositionLocaleUniqueWhere",
		create:"JobPositionLocaleWithoutRootCreateInput"
	},
	JobPageConnectOrCreateJobPositionRelationInput:{
		connect:"JobPositionUniqueWhere",
		create:"JobPositionWithoutJobsCreateInput"
	},
	JobPageLocaleConnectOrCreateRootRelationInput:{
		connect:"JobPageUniqueWhere",
		create:"JobPageWithoutLocalesCreateInput"
	},
	LocaleConnectOrCreateJobPagesRelationInput:{
		connect:"JobPageLocaleUniqueWhere",
		create:"JobPageLocaleWithoutLocaleCreateInput"
	},
	BusinessPageLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutBusinessPagesCreateInput"
	},
	LinkableConnectOrCreateBusinessPageRelationInput:{
		connect:"BusinessPageLocaleUniqueWhere",
		create:"BusinessPageLocaleWithoutLinkCreateInput"
	},
	GenericPageLocaleConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutGenericPageCreateInput"
	},
	GenericPageLocaleCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateLogoRelationInput"
	},
	GenericPageLocaleConnectOrCreateLogoRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	GenericPageLocaleCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateImageRelationInput"
	},
	GenericPageLocaleConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	LocaleConnectOrCreateGenericPagesRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutLocaleCreateInput"
	},
	BonusBannerLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutBonusBannersCreateInput"
	},
	ContentReferenceConnectOrCreateBonusBannerRelationInput:{
		connect:"BonusBannerLocaleUniqueWhere",
		create:"BonusBannerLocaleCreateInput"
	},
	ContentReferenceCreateSideBySideEntityRelationInput:{
		connect:"SideBySideUniqueWhere",
		create:"SideBySideCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateSideBySideRelationInput"
	},
	SideBySideUniqueWhere:{
		id:"UUID",
		items:"SideBySideItemUniqueWhere"
	},
	SideBySideItemUniqueWhere:{
		id:"UUID",
		media:"MediumListUniqueWhere"
	},
	SideBySideCreateInput:{
		id:"UUID",
		items:"SideBySideCreateItemsEntityRelationInput",
		background:"Background",
		alignment:"ContentAlignment",
		mediumSize:"MediumSize"
	},
	SideBySideCreateItemsEntityRelationInput:{
		connect:"SideBySideItemUniqueWhere",
		create:"SideBySideItemWithoutListCreateInput",
		connectOrCreate:"SideBySideConnectOrCreateItemsRelationInput"
	},
	SideBySideItemWithoutListCreateInput:{
		id:"UUID",
		media:"SideBySideItemCreateMediaEntityRelationInput",
		type:"SideBySideItemType",
		link:"SideBySideItemCreateLinkEntityRelationInput",
		jobsForm:"SideBySideItemCreateJobsFormEntityRelationInput"
	},
	SideBySideItemCreateMediaEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput",
		connectOrCreate:"SideBySideItemConnectOrCreateMediaRelationInput"
	},
	SideBySideItemConnectOrCreateMediaRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput"
	},
	SideBySideItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"SideBySideItemConnectOrCreateLinkRelationInput"
	},
	SideBySideItemConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	SideBySideItemCreateJobsFormEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput",
		connectOrCreate:"SideBySideItemConnectOrCreateJobsFormRelationInput"
	},
	SideBySideItemConnectOrCreateJobsFormRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput"
	},
	SideBySideConnectOrCreateItemsRelationInput:{
		connect:"SideBySideItemUniqueWhere",
		create:"SideBySideItemWithoutListCreateInput"
	},
	ContentReferenceConnectOrCreateSideBySideRelationInput:{
		connect:"SideBySideUniqueWhere",
		create:"SideBySideCreateInput"
	},
	ContentReferenceCreateGalleryEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateGalleryRelationInput"
	},
	ContentReferenceConnectOrCreateGalleryRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput"
	},
	ContentReferenceCreateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateVideoRelationInput"
	},
	ContentReferenceConnectOrCreateVideoRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput"
	},
	ContentBlockConnectOrCreateReferencesRelationInput:{
		connect:"ContentReferenceUniqueWhere",
		create:"ContentReferenceWithoutBlockCreateInput"
	},
	ContentConnectOrCreateBlocksRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutContentCreateInput"
	},
	BusinessPageLocaleConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	LocaleConnectOrCreateBusinessPagesRelationInput:{
		connect:"BusinessPageLocaleUniqueWhere",
		create:"BusinessPageLocaleWithoutLocaleCreateInput"
	},
	GenericPageLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGenericPagesCreateInput"
	},
	LinkableConnectOrCreateGenericPageRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutLinkCreateInput"
	},
	LinkConnectOrCreateInternalLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableCreateInput"
	},
	FooterLinkConnectOrCreateLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	FooterLocaleConnectOrCreateLinksFirstColumnRelationInput:{
		connect:"FooterLinkUniqueWhere",
		create:"FooterLinkCreateInput"
	},
	FooterLocaleCreateLinksSecondColumnEntityRelationInput:{
		connect:"FooterLinkUniqueWhere",
		create:"FooterLinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"
	},
	FooterLocaleConnectOrCreateLinksSecondColumnRelationInput:{
		connect:"FooterLinkUniqueWhere",
		create:"FooterLinkCreateInput"
	},
	FooterLocaleCreateTermsAndConditionsEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"
	},
	FooterLocaleConnectOrCreateTermsAndConditionsRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	FooterLocaleCreateBannerImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateBannerImageRelationInput"
	},
	FooterLocaleConnectOrCreateBannerImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	FooterLocaleCreateBannerLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateBannerLinkRelationInput"
	},
	FooterLocaleConnectOrCreateBannerLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	FooterLocaleCreateJobsFormEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateJobsFormRelationInput"
	},
	FooterLocaleConnectOrCreateJobsFormRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput"
	},
	FooterLocaleCreateCopyrightLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateCopyrightLinkRelationInput"
	},
	FooterLocaleConnectOrCreateCopyrightLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	FooterLocaleCreateRecommendationFormEntityRelationInput:{
		connect:"RecommendationFormLocaleUniqueWhere",
		create:"RecommendationFormLocaleCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateRecommendationFormRelationInput"
	},
	RecommendationFormLocaleCreateInput:{
		id:"UUID",
		root:"RecommendationFormLocaleCreateRootEntityRelationInput",
		locale:"RecommendationFormLocaleCreateLocaleEntityRelationInput"
	},
	RecommendationFormLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutRecommendationFormsCreateInput",
		connectOrCreate:"RecommendationFormLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutRecommendationFormsCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	RecommendationFormLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutRecommendationFormsCreateInput"
	},
	FooterLocaleConnectOrCreateRecommendationFormRelationInput:{
		connect:"RecommendationFormLocaleUniqueWhere",
		create:"RecommendationFormLocaleCreateInput"
	},
	FooterLocaleCreateBannerSecondLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"
	},
	FooterLocaleConnectOrCreateBannerSecondLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	FooterLocaleCreateInstagramLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateInstagramLinkRelationInput"
	},
	FooterLocaleConnectOrCreateInstagramLinkRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	LocaleConnectOrCreateFootersRelationInput:{
		connect:"FooterLocaleUniqueWhere",
		create:"FooterLocaleWithoutLocaleCreateInput"
	},
	GeneralLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGeneralCreateInput"
	},
	GeneralConnectOrCreateLocalesRelationInput:{
		connect:"GeneralLocaleUniqueWhere",
		create:"GeneralLocaleWithoutRootCreateInput"
	},
	GeneralUpdateInput:{
		unique:"One",
		locales:"GeneralUpdateLocalesEntityRelationInput"
	},
	GeneralUpdateLocalesEntityRelationInput:{
		create:"GeneralLocaleWithoutRootCreateInput",
		update:"GeneralUpdateLocalesRelationInput",
		upsert:"GeneralUpsertLocalesRelationInput",
		connect:"GeneralLocaleUniqueWhere",
		disconnect:"GeneralLocaleUniqueWhere",
		delete:"GeneralLocaleUniqueWhere"
	},
	GeneralUpdateLocalesRelationInput:{
		by:"GeneralLocaleUniqueWhere",
		data:"GeneralLocaleWithoutRootUpdateInput"
	},
	GeneralLocaleWithoutRootUpdateInput:{
		locale:"GeneralLocaleUpdateLocaleEntityRelationInput",
		seo:"GeneralLocaleUpdateSeoEntityRelationInput",
		cornerBanner:"GeneralLocaleUpdateCornerBannerEntityRelationInput"
	},
	GeneralLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGeneralCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutGeneralUpdateInput",
		upsert:"GeneralLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutGeneralUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	LocaleUpdateFootersEntityRelationInput:{
		create:"FooterLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateFootersRelationInput",
		upsert:"LocaleUpsertFootersRelationInput",
		connect:"FooterLocaleUniqueWhere",
		disconnect:"FooterLocaleUniqueWhere",
		delete:"FooterLocaleUniqueWhere"
	},
	LocaleUpdateFootersRelationInput:{
		by:"FooterLocaleUniqueWhere",
		data:"FooterLocaleWithoutLocaleUpdateInput"
	},
	FooterLocaleWithoutLocaleUpdateInput:{
		root:"FooterLocaleUpdateRootEntityRelationInput",
		linksFirstColumn:"FooterLocaleUpdateLinksFirstColumnEntityRelationInput",
		linksSecondColumn:"FooterLocaleUpdateLinksSecondColumnEntityRelationInput",
		termsAndConditions:"FooterLocaleUpdateTermsAndConditionsEntityRelationInput",
		bannerImage:"FooterLocaleUpdateBannerImageEntityRelationInput",
		bannerLink:"FooterLocaleUpdateBannerLinkEntityRelationInput",
		jobsForm:"FooterLocaleUpdateJobsFormEntityRelationInput",
		copyrightLink:"FooterLocaleUpdateCopyrightLinkEntityRelationInput",
		recommendationForm:"FooterLocaleUpdateRecommendationFormEntityRelationInput",
		bannerSecondLink:"FooterLocaleUpdateBannerSecondLinkEntityRelationInput",
		instagramLink:"FooterLocaleUpdateInstagramLinkEntityRelationInput"
	},
	FooterLocaleUpdateRootEntityRelationInput:{
		connect:"FooterUniqueWhere",
		create:"FooterWithoutLocalesCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateRootRelationInput",
		update:"FooterWithoutLocalesUpdateInput",
		upsert:"FooterLocaleUpsertRootRelationInput"
	},
	FooterWithoutLocalesUpdateInput:{
		unique:"One"
	},
	FooterLocaleUpsertRootRelationInput:{
		update:"FooterWithoutLocalesUpdateInput",
		create:"FooterWithoutLocalesCreateInput"
	},
	FooterLocaleUpdateLinksFirstColumnEntityRelationInput:{
		create:"FooterLinkCreateInput",
		update:"FooterLocaleUpdateLinksFirstColumnRelationInput",
		upsert:"FooterLocaleUpsertLinksFirstColumnRelationInput",
		connect:"FooterLinkUniqueWhere",
		disconnect:"FooterLinkUniqueWhere",
		delete:"FooterLinkUniqueWhere"
	},
	FooterLocaleUpdateLinksFirstColumnRelationInput:{
		by:"FooterLinkUniqueWhere",
		data:"FooterLinkUpdateInput"
	},
	FooterLinkUpdateInput:{
		link:"FooterLinkUpdateLinkEntityRelationInput"
	},
	FooterLinkUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLinkConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"FooterLinkUpsertLinkRelationInput"
	},
	LinkUpdateInput:{
		type:"LinkType",
		internalLink:"LinkUpdateInternalLinkEntityRelationInput"
	},
	LinkUpdateInternalLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableCreateInput",
		connectOrCreate:"LinkConnectOrCreateInternalLinkRelationInput",
		update:"LinkableUpdateInput",
		upsert:"LinkUpsertInternalLinkRelationInput"
	},
	LinkableUpdateInput:{
		redirect:"LinkableUpdateRedirectEntityRelationInput",
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		businessPage:"LinkableUpdateBusinessPageEntityRelationInput",
		jobPage:"LinkableUpdateJobPageEntityRelationInput",
		homePage:"LinkableUpdateHomePageEntityRelationInput",
		homePageLokal:"LinkableUpdateHomePageLokalEntityRelationInput"
	},
	LinkableUpdateRedirectEntityRelationInput:{
		connect:"RedirectUniqueWhere",
		create:"RedirectWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateRedirectRelationInput",
		update:"RedirectWithoutLinkUpdateInput",
		upsert:"LinkableUpsertRedirectRelationInput"
	},
	RedirectWithoutLinkUpdateInput:{
		target:"RedirectUpdateTargetEntityRelationInput"
	},
	RedirectUpdateTargetEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"RedirectConnectOrCreateTargetRelationInput",
		update:"LinkUpdateInput",
		upsert:"RedirectUpsertTargetRelationInput"
	},
	RedirectUpsertTargetRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	LinkableUpsertRedirectRelationInput:{
		update:"RedirectWithoutLinkUpdateInput",
		create:"RedirectWithoutLinkCreateInput"
	},
	LinkableUpdateGenericPageEntityRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateGenericPageRelationInput",
		update:"GenericPageLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertGenericPageRelationInput"
	},
	GenericPageLocaleWithoutLinkUpdateInput:{
		root:"GenericPageLocaleUpdateRootEntityRelationInput",
		locale:"GenericPageLocaleUpdateLocaleEntityRelationInput",
		content:"GenericPageLocaleUpdateContentEntityRelationInput",
		seo:"GenericPageLocaleUpdateSeoEntityRelationInput",
		logo:"GenericPageLocaleUpdateLogoEntityRelationInput",
		image:"GenericPageLocaleUpdateImageEntityRelationInput"
	},
	GenericPageLocaleUpdateRootEntityRelationInput:{
		connect:"GenericPageUniqueWhere",
		create:"GenericPageWithoutLocalesCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateRootRelationInput",
		update:"GenericPageWithoutLocalesUpdateInput",
		upsert:"GenericPageLocaleUpsertRootRelationInput"
	},
	GenericPageWithoutLocalesUpdateInput:{
		theme:"GenericPageUpdateThemeEntityRelationInput"
	},
	GenericPageUpdateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"GenericPageConnectOrCreateThemeRelationInput",
		update:"ThemeUpdateInput",
		upsert:"GenericPageUpsertThemeRelationInput"
	},
	ThemeUpdateInput:{

	},
	GenericPageUpsertThemeRelationInput:{
		update:"ThemeUpdateInput",
		create:"ThemeCreateInput"
	},
	GenericPageLocaleUpsertRootRelationInput:{
		update:"GenericPageWithoutLocalesUpdateInput",
		create:"GenericPageWithoutLocalesCreateInput"
	},
	GenericPageLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutGenericPagesCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutGenericPagesUpdateInput",
		upsert:"GenericPageLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutGenericPagesUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	LocaleUpdateHeadersEntityRelationInput:{
		create:"HeaderLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateHeadersRelationInput",
		upsert:"LocaleUpsertHeadersRelationInput",
		connect:"HeaderLocaleUniqueWhere",
		disconnect:"HeaderLocaleUniqueWhere",
		delete:"HeaderLocaleUniqueWhere"
	},
	LocaleUpdateHeadersRelationInput:{
		by:"HeaderLocaleUniqueWhere",
		data:"HeaderLocaleWithoutLocaleUpdateInput"
	},
	HeaderLocaleWithoutLocaleUpdateInput:{
		root:"HeaderLocaleUpdateRootEntityRelationInput",
		business:"HeaderLocaleUpdateBusinessEntityRelationInput",
		lokalEnterprise:"HeaderLocaleUpdateLokalEnterpriseEntityRelationInput",
		businessLink:"HeaderLocaleUpdateBusinessLinkEntityRelationInput",
		lokalLink:"HeaderLocaleUpdateLokalLinkEntityRelationInput"
	},
	HeaderLocaleUpdateRootEntityRelationInput:{
		connect:"HeaderUniqueWhere",
		create:"HeaderWithoutLocalesCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateRootRelationInput",
		update:"HeaderWithoutLocalesUpdateInput",
		upsert:"HeaderLocaleUpsertRootRelationInput"
	},
	HeaderWithoutLocalesUpdateInput:{
		unique:"One",
		logo:"HeaderUpdateLogoEntityRelationInput",
		logoMenu:"HeaderUpdateLogoMenuEntityRelationInput"
	},
	HeaderUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"HeaderConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"HeaderUpsertLogoRelationInput"
	},
	ImageUpdateInput:{

	},
	HeaderUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	HeaderUpdateLogoMenuEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"HeaderConnectOrCreateLogoMenuRelationInput",
		update:"ImageUpdateInput",
		upsert:"HeaderUpsertLogoMenuRelationInput"
	},
	HeaderUpsertLogoMenuRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	HeaderLocaleUpsertRootRelationInput:{
		update:"HeaderWithoutLocalesUpdateInput",
		create:"HeaderWithoutLocalesCreateInput"
	},
	HeaderLocaleUpdateBusinessEntityRelationInput:{
		create:"BusinessCreateInput",
		update:"HeaderLocaleUpdateBusinessRelationInput",
		upsert:"HeaderLocaleUpsertBusinessRelationInput",
		connect:"BusinessUniqueWhere",
		disconnect:"BusinessUniqueWhere",
		delete:"BusinessUniqueWhere"
	},
	HeaderLocaleUpdateBusinessRelationInput:{
		by:"BusinessUniqueWhere",
		data:"BusinessUpdateInput"
	},
	BusinessUpdateInput:{
		logo:"BusinessUpdateLogoEntityRelationInput",
		link:"BusinessUpdateLinkEntityRelationInput"
	},
	BusinessUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"BusinessConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"BusinessUpsertLogoRelationInput"
	},
	BusinessUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	BusinessUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"BusinessConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"BusinessUpsertLinkRelationInput"
	},
	BusinessUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	HeaderLocaleUpsertBusinessRelationInput:{
		by:"BusinessUniqueWhere",
		update:"BusinessUpdateInput",
		create:"BusinessCreateInput"
	},
	HeaderLocaleUpdateLokalEnterpriseEntityRelationInput:{
		create:"BusinessCreateInput",
		update:"HeaderLocaleUpdateLokalEnterpriseRelationInput",
		upsert:"HeaderLocaleUpsertLokalEnterpriseRelationInput",
		connect:"BusinessUniqueWhere",
		disconnect:"BusinessUniqueWhere",
		delete:"BusinessUniqueWhere"
	},
	HeaderLocaleUpdateLokalEnterpriseRelationInput:{
		by:"BusinessUniqueWhere",
		data:"BusinessUpdateInput"
	},
	HeaderLocaleUpsertLokalEnterpriseRelationInput:{
		by:"BusinessUniqueWhere",
		update:"BusinessUpdateInput",
		create:"BusinessCreateInput"
	},
	HeaderLocaleUpdateBusinessLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateBusinessLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"HeaderLocaleUpsertBusinessLinkRelationInput"
	},
	HeaderLocaleUpsertBusinessLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	HeaderLocaleUpdateLokalLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateLokalLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"HeaderLocaleUpsertLokalLinkRelationInput"
	},
	HeaderLocaleUpsertLokalLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	LocaleUpsertHeadersRelationInput:{
		by:"HeaderLocaleUniqueWhere",
		update:"HeaderLocaleWithoutLocaleUpdateInput",
		create:"HeaderLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateSeoDefaultsEntityRelationInput:{
		create:"SeoDefaultLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateSeoDefaultsRelationInput",
		upsert:"LocaleUpsertSeoDefaultsRelationInput",
		connect:"SeoDefaultLocaleUniqueWhere",
		disconnect:"SeoDefaultLocaleUniqueWhere",
		delete:"SeoDefaultLocaleUniqueWhere"
	},
	LocaleUpdateSeoDefaultsRelationInput:{
		by:"SeoDefaultLocaleUniqueWhere",
		data:"SeoDefaultLocaleWithoutLocaleUpdateInput"
	},
	SeoDefaultLocaleWithoutLocaleUpdateInput:{
		root:"SeoDefaultLocaleUpdateRootEntityRelationInput",
		seo:"SeoDefaultLocaleUpdateSeoEntityRelationInput"
	},
	SeoDefaultLocaleUpdateRootEntityRelationInput:{
		connect:"SeoDefaultUniqueWhere",
		create:"SeoDefaultWithoutLocalesCreateInput",
		connectOrCreate:"SeoDefaultLocaleConnectOrCreateRootRelationInput",
		update:"SeoDefaultWithoutLocalesUpdateInput",
		upsert:"SeoDefaultLocaleUpsertRootRelationInput"
	},
	SeoDefaultWithoutLocalesUpdateInput:{
		unique:"One"
	},
	SeoDefaultLocaleUpsertRootRelationInput:{
		update:"SeoDefaultWithoutLocalesUpdateInput",
		create:"SeoDefaultWithoutLocalesCreateInput"
	},
	SeoDefaultLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"SeoDefaultLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"SeoDefaultLocaleUpsertSeoRelationInput"
	},
	SeoUpdateInput:{
		ogImage:"SeoUpdateOgImageEntityRelationInput"
	},
	SeoUpdateOgImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"SeoConnectOrCreateOgImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"SeoUpsertOgImageRelationInput"
	},
	SeoUpsertOgImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	SeoDefaultLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	LocaleUpsertSeoDefaultsRelationInput:{
		by:"SeoDefaultLocaleUniqueWhere",
		update:"SeoDefaultLocaleWithoutLocaleUpdateInput",
		create:"SeoDefaultLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateBusinessPagesEntityRelationInput:{
		create:"BusinessPageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateBusinessPagesRelationInput",
		upsert:"LocaleUpsertBusinessPagesRelationInput",
		connect:"BusinessPageLocaleUniqueWhere",
		disconnect:"BusinessPageLocaleUniqueWhere",
		delete:"BusinessPageLocaleUniqueWhere"
	},
	LocaleUpdateBusinessPagesRelationInput:{
		by:"BusinessPageLocaleUniqueWhere",
		data:"BusinessPageLocaleWithoutLocaleUpdateInput"
	},
	BusinessPageLocaleWithoutLocaleUpdateInput:{
		root:"BusinessPageLocaleUpdateRootEntityRelationInput",
		content:"BusinessPageLocaleUpdateContentEntityRelationInput",
		seo:"BusinessPageLocaleUpdateSeoEntityRelationInput",
		link:"BusinessPageLocaleUpdateLinkEntityRelationInput",
		image:"BusinessPageLocaleUpdateImageEntityRelationInput",
		stickyBar:"BusinessPageLocaleUpdateStickyBarEntityRelationInput",
		infoBox:"BusinessPageLocaleUpdateInfoBoxEntityRelationInput"
	},
	BusinessPageLocaleUpdateRootEntityRelationInput:{
		connect:"BusinessPageUniqueWhere",
		create:"BusinessPageWithoutLocalesCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateRootRelationInput",
		update:"BusinessPageWithoutLocalesUpdateInput",
		upsert:"BusinessPageLocaleUpsertRootRelationInput"
	},
	BusinessPageWithoutLocalesUpdateInput:{
		theme:"BusinessPageUpdateThemeEntityRelationInput"
	},
	BusinessPageUpdateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"BusinessPageConnectOrCreateThemeRelationInput",
		update:"ThemeUpdateInput",
		upsert:"BusinessPageUpsertThemeRelationInput"
	},
	BusinessPageUpsertThemeRelationInput:{
		update:"ThemeUpdateInput",
		create:"ThemeCreateInput"
	},
	BusinessPageLocaleUpsertRootRelationInput:{
		update:"BusinessPageWithoutLocalesUpdateInput",
		create:"BusinessPageWithoutLocalesCreateInput"
	},
	BusinessPageLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"BusinessPageLocaleUpsertContentRelationInput"
	},
	ContentUpdateInput:{
		blocks:"ContentUpdateBlocksEntityRelationInput"
	},
	ContentUpdateBlocksEntityRelationInput:{
		create:"ContentBlockWithoutContentCreateInput",
		update:"ContentUpdateBlocksRelationInput",
		upsert:"ContentUpsertBlocksRelationInput",
		connect:"ContentBlockUniqueWhere",
		disconnect:"ContentBlockUniqueWhere",
		delete:"ContentBlockUniqueWhere"
	},
	ContentUpdateBlocksRelationInput:{
		by:"ContentBlockUniqueWhere",
		data:"ContentBlockWithoutContentUpdateInput"
	},
	ContentBlockWithoutContentUpdateInput:{
		references:"ContentBlockUpdateReferencesEntityRelationInput"
	},
	ContentBlockUpdateReferencesEntityRelationInput:{
		create:"ContentReferenceWithoutBlockCreateInput",
		update:"ContentBlockUpdateReferencesRelationInput",
		upsert:"ContentBlockUpsertReferencesRelationInput",
		connect:"ContentReferenceUniqueWhere",
		disconnect:"ContentReferenceUniqueWhere",
		delete:"ContentReferenceUniqueWhere"
	},
	ContentBlockUpdateReferencesRelationInput:{
		by:"ContentReferenceUniqueWhere",
		data:"ContentReferenceWithoutBlockUpdateInput"
	},
	ContentReferenceWithoutBlockUpdateInput:{
		type:"ContentReferenceType",
		image:"ContentReferenceUpdateImageEntityRelationInput",
		linkables:"ContentReferenceUpdateLinkablesEntityRelationInput",
		link:"ContentReferenceUpdateLinkEntityRelationInput",
		media:"ContentReferenceUpdateMediaEntityRelationInput",
		textList:"ContentReferenceUpdateTextListEntityRelationInput",
		carousel:"ContentReferenceUpdateCarouselEntityRelationInput",
		bonusBanner:"ContentReferenceUpdateBonusBannerEntityRelationInput",
		sideBySide:"ContentReferenceUpdateSideBySideEntityRelationInput",
		gallery:"ContentReferenceUpdateGalleryEntityRelationInput",
		video:"ContentReferenceUpdateVideoEntityRelationInput"
	},
	ContentReferenceUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"ContentReferenceUpsertImageRelationInput"
	},
	ContentReferenceUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ContentReferenceUpdateLinkablesEntityRelationInput:{
		connect:"ContentReferenceLinkableItemUniqueWhere",
		disconnect:"ContentReferenceLinkableItemUniqueWhere",
		delete:"ContentReferenceLinkableItemUniqueWhere"
	},
	ContentReferenceUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"ContentReferenceUpsertLinkRelationInput"
	},
	ContentReferenceUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	ContentReferenceUpdateMediaEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateMediaRelationInput",
		update:"MediumListUpdateInput",
		upsert:"ContentReferenceUpsertMediaRelationInput"
	},
	MediumListUpdateInput:{
		items:"MediumListUpdateItemsEntityRelationInput"
	},
	MediumListUpdateItemsEntityRelationInput:{
		create:"MediumItemWithoutListCreateInput",
		update:"MediumListUpdateItemsRelationInput",
		upsert:"MediumListUpsertItemsRelationInput",
		connect:"MediumItemUniqueWhere",
		disconnect:"MediumItemUniqueWhere",
		delete:"MediumItemUniqueWhere"
	},
	MediumListUpdateItemsRelationInput:{
		by:"MediumItemUniqueWhere",
		data:"MediumItemWithoutListUpdateInput"
	},
	MediumItemWithoutListUpdateInput:{
		medium:"MediumItemUpdateMediumEntityRelationInput"
	},
	MediumItemUpdateMediumEntityRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput",
		connectOrCreate:"MediumItemConnectOrCreateMediumRelationInput",
		update:"MediumUpdateInput",
		upsert:"MediumItemUpsertMediumRelationInput"
	},
	MediumUpdateInput:{
		type:"MediumType",
		image:"MediumUpdateImageEntityRelationInput",
		video:"MediumUpdateVideoEntityRelationInput"
	},
	MediumUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"MediumConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"MediumUpsertImageRelationInput"
	},
	MediumUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	MediumUpdateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"MediumConnectOrCreateVideoRelationInput",
		update:"VideoUpdateInput",
		upsert:"MediumUpsertVideoRelationInput"
	},
	VideoUpdateInput:{
		poster:"VideoUpdatePosterEntityRelationInput"
	},
	VideoUpdatePosterEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"VideoConnectOrCreatePosterRelationInput",
		update:"ImageUpdateInput",
		upsert:"VideoUpsertPosterRelationInput"
	},
	VideoUpsertPosterRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	MediumUpsertVideoRelationInput:{
		update:"VideoUpdateInput",
		create:"VideoCreateInput"
	},
	MediumItemUpsertMediumRelationInput:{
		update:"MediumUpdateInput",
		create:"MediumCreateInput"
	},
	MediumListUpsertItemsRelationInput:{
		by:"MediumItemUniqueWhere",
		update:"MediumItemWithoutListUpdateInput",
		create:"MediumItemWithoutListCreateInput"
	},
	ContentReferenceUpsertMediaRelationInput:{
		update:"MediumListUpdateInput",
		create:"MediumListCreateInput"
	},
	ContentReferenceUpdateTextListEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateTextListRelationInput",
		update:"TextListUpdateInput",
		upsert:"ContentReferenceUpsertTextListRelationInput"
	},
	TextListUpdateInput:{
		items:"TextListUpdateItemsEntityRelationInput"
	},
	TextListUpdateItemsEntityRelationInput:{
		create:"TextItemWithoutListCreateInput",
		update:"TextListUpdateItemsRelationInput",
		upsert:"TextListUpsertItemsRelationInput",
		connect:"TextItemUniqueWhere",
		disconnect:"TextItemUniqueWhere",
		delete:"TextItemUniqueWhere"
	},
	TextListUpdateItemsRelationInput:{
		by:"TextItemUniqueWhere",
		data:"TextItemWithoutListUpdateInput"
	},
	TextItemWithoutListUpdateInput:{

	},
	TextListUpsertItemsRelationInput:{
		by:"TextItemUniqueWhere",
		update:"TextItemWithoutListUpdateInput",
		create:"TextItemWithoutListCreateInput"
	},
	ContentReferenceUpsertTextListRelationInput:{
		update:"TextListUpdateInput",
		create:"TextListCreateInput"
	},
	ContentReferenceUpdateCarouselEntityRelationInput:{
		connect:"CarouselUniqueWhere",
		create:"CarouselCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateCarouselRelationInput",
		update:"CarouselUpdateInput",
		upsert:"ContentReferenceUpsertCarouselRelationInput"
	},
	CarouselUpdateInput:{
		items:"CarouselUpdateItemsEntityRelationInput",
		background:"Background"
	},
	CarouselUpdateItemsEntityRelationInput:{
		create:"CarouselItemWithoutListCreateInput",
		update:"CarouselUpdateItemsRelationInput",
		upsert:"CarouselUpsertItemsRelationInput",
		connect:"CarouselItemUniqueWhere",
		disconnect:"CarouselItemUniqueWhere",
		delete:"CarouselItemUniqueWhere"
	},
	CarouselUpdateItemsRelationInput:{
		by:"CarouselItemUniqueWhere",
		data:"CarouselItemWithoutListUpdateInput"
	},
	CarouselItemWithoutListUpdateInput:{
		image:"CarouselItemUpdateImageEntityRelationInput",
		linkUrl:"CarouselItemUpdateLinkUrlEntityRelationInput",
		video:"CarouselItemUpdateVideoEntityRelationInput"
	},
	CarouselItemUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"CarouselItemConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"CarouselItemUpsertImageRelationInput"
	},
	CarouselItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	CarouselItemUpdateLinkUrlEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"CarouselItemConnectOrCreateLinkUrlRelationInput",
		update:"LinkUpdateInput",
		upsert:"CarouselItemUpsertLinkUrlRelationInput"
	},
	CarouselItemUpsertLinkUrlRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	CarouselItemUpdateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"CarouselItemConnectOrCreateVideoRelationInput",
		update:"VideoUpdateInput",
		upsert:"CarouselItemUpsertVideoRelationInput"
	},
	CarouselItemUpsertVideoRelationInput:{
		update:"VideoUpdateInput",
		create:"VideoCreateInput"
	},
	CarouselUpsertItemsRelationInput:{
		by:"CarouselItemUniqueWhere",
		update:"CarouselItemWithoutListUpdateInput",
		create:"CarouselItemWithoutListCreateInput"
	},
	ContentReferenceUpsertCarouselRelationInput:{
		update:"CarouselUpdateInput",
		create:"CarouselCreateInput"
	},
	ContentReferenceUpdateBonusBannerEntityRelationInput:{
		connect:"BonusBannerLocaleUniqueWhere",
		create:"BonusBannerLocaleCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateBonusBannerRelationInput",
		update:"BonusBannerLocaleUpdateInput",
		upsert:"ContentReferenceUpsertBonusBannerRelationInput"
	},
	BonusBannerLocaleUpdateInput:{
		root:"BonusBannerLocaleUpdateRootEntityRelationInput",
		locale:"BonusBannerLocaleUpdateLocaleEntityRelationInput",
		tiles:"BonusBannerLocaleUpdateTilesEntityRelationInput",
		logo:"BonusBannerLocaleUpdateLogoEntityRelationInput"
	},
	BonusBannerLocaleUpdateRootEntityRelationInput:{
		connect:"BonusBannerUniqueWhere",
		create:"BonusBannerWithoutLocalesCreateInput",
		connectOrCreate:"BonusBannerLocaleConnectOrCreateRootRelationInput",
		update:"BonusBannerWithoutLocalesUpdateInput",
		upsert:"BonusBannerLocaleUpsertRootRelationInput"
	},
	BonusBannerWithoutLocalesUpdateInput:{

	},
	BonusBannerLocaleUpsertRootRelationInput:{
		update:"BonusBannerWithoutLocalesUpdateInput",
		create:"BonusBannerWithoutLocalesCreateInput"
	},
	BonusBannerLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutBonusBannersCreateInput",
		connectOrCreate:"BonusBannerLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutBonusBannersUpdateInput",
		upsert:"BonusBannerLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutBonusBannersUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	LocaleUpdateGenericPagesEntityRelationInput:{
		create:"GenericPageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateGenericPagesRelationInput",
		upsert:"LocaleUpsertGenericPagesRelationInput",
		connect:"GenericPageLocaleUniqueWhere",
		disconnect:"GenericPageLocaleUniqueWhere",
		delete:"GenericPageLocaleUniqueWhere"
	},
	LocaleUpdateGenericPagesRelationInput:{
		by:"GenericPageLocaleUniqueWhere",
		data:"GenericPageLocaleWithoutLocaleUpdateInput"
	},
	GenericPageLocaleWithoutLocaleUpdateInput:{
		root:"GenericPageLocaleUpdateRootEntityRelationInput",
		content:"GenericPageLocaleUpdateContentEntityRelationInput",
		seo:"GenericPageLocaleUpdateSeoEntityRelationInput",
		link:"GenericPageLocaleUpdateLinkEntityRelationInput",
		logo:"GenericPageLocaleUpdateLogoEntityRelationInput",
		image:"GenericPageLocaleUpdateImageEntityRelationInput"
	},
	GenericPageLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"GenericPageLocaleUpsertContentRelationInput"
	},
	GenericPageLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	GenericPageLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"GenericPageLocaleUpsertSeoRelationInput"
	},
	GenericPageLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	GenericPageLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutGenericPageCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutGenericPageUpdateInput",
		upsert:"GenericPageLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutGenericPageUpdateInput:{
		redirect:"LinkableUpdateRedirectEntityRelationInput",
		businessPage:"LinkableUpdateBusinessPageEntityRelationInput",
		jobPage:"LinkableUpdateJobPageEntityRelationInput",
		homePage:"LinkableUpdateHomePageEntityRelationInput",
		homePageLokal:"LinkableUpdateHomePageLokalEntityRelationInput"
	},
	LinkableUpdateBusinessPageEntityRelationInput:{
		connect:"BusinessPageLocaleUniqueWhere",
		create:"BusinessPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateBusinessPageRelationInput",
		update:"BusinessPageLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertBusinessPageRelationInput"
	},
	BusinessPageLocaleWithoutLinkUpdateInput:{
		root:"BusinessPageLocaleUpdateRootEntityRelationInput",
		locale:"BusinessPageLocaleUpdateLocaleEntityRelationInput",
		content:"BusinessPageLocaleUpdateContentEntityRelationInput",
		seo:"BusinessPageLocaleUpdateSeoEntityRelationInput",
		image:"BusinessPageLocaleUpdateImageEntityRelationInput",
		stickyBar:"BusinessPageLocaleUpdateStickyBarEntityRelationInput",
		infoBox:"BusinessPageLocaleUpdateInfoBoxEntityRelationInput"
	},
	BusinessPageLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutBusinessPagesCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutBusinessPagesUpdateInput",
		upsert:"BusinessPageLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutBusinessPagesUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	LocaleUpdateJobPagesEntityRelationInput:{
		create:"JobPageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateJobPagesRelationInput",
		upsert:"LocaleUpsertJobPagesRelationInput",
		connect:"JobPageLocaleUniqueWhere",
		disconnect:"JobPageLocaleUniqueWhere",
		delete:"JobPageLocaleUniqueWhere"
	},
	LocaleUpdateJobPagesRelationInput:{
		by:"JobPageLocaleUniqueWhere",
		data:"JobPageLocaleWithoutLocaleUpdateInput"
	},
	JobPageLocaleWithoutLocaleUpdateInput:{
		root:"JobPageLocaleUpdateRootEntityRelationInput",
		image:"JobPageLocaleUpdateImageEntityRelationInput",
		keyInfo:"JobPageLocaleUpdateKeyInfoEntityRelationInput",
		content:"JobPageLocaleUpdateContentEntityRelationInput",
		seo:"JobPageLocaleUpdateSeoEntityRelationInput",
		link:"JobPageLocaleUpdateLinkEntityRelationInput",
		stickyBar:"JobPageLocaleUpdateStickyBarEntityRelationInput",
		mobileImage:"JobPageLocaleUpdateMobileImageEntityRelationInput"
	},
	JobPageLocaleUpdateRootEntityRelationInput:{
		connect:"JobPageUniqueWhere",
		create:"JobPageWithoutLocalesCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateRootRelationInput",
		update:"JobPageWithoutLocalesUpdateInput",
		upsert:"JobPageLocaleUpsertRootRelationInput"
	},
	JobPageWithoutLocalesUpdateInput:{
		theme:"JobPageUpdateThemeEntityRelationInput",
		contractType:"JobPageUpdateContractTypeEntityRelationInput",
		jobCity:"JobPageUpdateJobCityEntityRelationInput",
		jobPosition:"JobPageUpdateJobPositionEntityRelationInput",
		publishedAt:"DateTime",
		business:"JobPageUpdateBusinessEntityRelationInput",
		siteType:"SiteType"
	},
	JobPageUpdateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"JobPageConnectOrCreateThemeRelationInput",
		update:"ThemeUpdateInput",
		upsert:"JobPageUpsertThemeRelationInput"
	},
	JobPageUpsertThemeRelationInput:{
		update:"ThemeUpdateInput",
		create:"ThemeCreateInput"
	},
	JobPageUpdateContractTypeEntityRelationInput:{
		connect:"ContractTypeUniqueWhere",
		create:"ContractTypeCreateInput",
		connectOrCreate:"JobPageConnectOrCreateContractTypeRelationInput",
		update:"ContractTypeUpdateInput",
		upsert:"JobPageUpsertContractTypeRelationInput"
	},
	ContractTypeUpdateInput:{
		locales:"ContractTypeUpdateLocalesEntityRelationInput"
	},
	ContractTypeUpdateLocalesEntityRelationInput:{
		create:"ContractTypeLocaleWithoutRootCreateInput",
		update:"ContractTypeUpdateLocalesRelationInput",
		upsert:"ContractTypeUpsertLocalesRelationInput",
		connect:"ContractTypeLocaleUniqueWhere",
		disconnect:"ContractTypeLocaleUniqueWhere",
		delete:"ContractTypeLocaleUniqueWhere"
	},
	ContractTypeUpdateLocalesRelationInput:{
		by:"ContractTypeLocaleUniqueWhere",
		data:"ContractTypeLocaleWithoutRootUpdateInput"
	},
	ContractTypeLocaleWithoutRootUpdateInput:{
		locale:"ContractTypeLocaleUpdateLocaleEntityRelationInput"
	},
	ContractTypeLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutContractTypesCreateInput",
		connectOrCreate:"ContractTypeLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutContractTypesUpdateInput",
		upsert:"ContractTypeLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutContractTypesUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	LocaleUpdateJobCitiesEntityRelationInput:{
		create:"JobCityLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateJobCitiesRelationInput",
		upsert:"LocaleUpsertJobCitiesRelationInput",
		connect:"JobCityLocaleUniqueWhere",
		disconnect:"JobCityLocaleUniqueWhere",
		delete:"JobCityLocaleUniqueWhere"
	},
	LocaleUpdateJobCitiesRelationInput:{
		by:"JobCityLocaleUniqueWhere",
		data:"JobCityLocaleWithoutLocaleUpdateInput"
	},
	JobCityLocaleWithoutLocaleUpdateInput:{
		root:"JobCityLocaleUpdateRootEntityRelationInput"
	},
	JobCityLocaleUpdateRootEntityRelationInput:{
		connect:"JobCityUniqueWhere",
		create:"JobCityWithoutLocalesCreateInput",
		connectOrCreate:"JobCityLocaleConnectOrCreateRootRelationInput",
		update:"JobCityWithoutLocalesUpdateInput",
		upsert:"JobCityLocaleUpsertRootRelationInput"
	},
	JobCityWithoutLocalesUpdateInput:{

	},
	JobCityLocaleUpsertRootRelationInput:{
		update:"JobCityWithoutLocalesUpdateInput",
		create:"JobCityWithoutLocalesCreateInput"
	},
	LocaleUpsertJobCitiesRelationInput:{
		by:"JobCityLocaleUniqueWhere",
		update:"JobCityLocaleWithoutLocaleUpdateInput",
		create:"JobCityLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateJobPositionsEntityRelationInput:{
		create:"JobPositionLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateJobPositionsRelationInput",
		upsert:"LocaleUpsertJobPositionsRelationInput",
		connect:"JobPositionLocaleUniqueWhere",
		disconnect:"JobPositionLocaleUniqueWhere",
		delete:"JobPositionLocaleUniqueWhere"
	},
	LocaleUpdateJobPositionsRelationInput:{
		by:"JobPositionLocaleUniqueWhere",
		data:"JobPositionLocaleWithoutLocaleUpdateInput"
	},
	JobPositionLocaleWithoutLocaleUpdateInput:{
		root:"JobPositionLocaleUpdateRootEntityRelationInput"
	},
	JobPositionLocaleUpdateRootEntityRelationInput:{
		connect:"JobPositionUniqueWhere",
		create:"JobPositionWithoutLocalesCreateInput",
		connectOrCreate:"JobPositionLocaleConnectOrCreateRootRelationInput",
		update:"JobPositionWithoutLocalesUpdateInput",
		upsert:"JobPositionLocaleUpsertRootRelationInput"
	},
	JobPositionWithoutLocalesUpdateInput:{
		jobs:"JobPositionUpdateJobsEntityRelationInput"
	},
	JobPositionUpdateJobsEntityRelationInput:{
		create:"JobPageWithoutJobPositionCreateInput",
		update:"JobPositionUpdateJobsRelationInput",
		upsert:"JobPositionUpsertJobsRelationInput",
		connect:"JobPageUniqueWhere",
		disconnect:"JobPageUniqueWhere",
		delete:"JobPageUniqueWhere"
	},
	JobPositionUpdateJobsRelationInput:{
		by:"JobPageUniqueWhere",
		data:"JobPageWithoutJobPositionUpdateInput"
	},
	JobPageWithoutJobPositionUpdateInput:{
		locales:"JobPageUpdateLocalesEntityRelationInput",
		theme:"JobPageUpdateThemeEntityRelationInput",
		contractType:"JobPageUpdateContractTypeEntityRelationInput",
		jobCity:"JobPageUpdateJobCityEntityRelationInput",
		publishedAt:"DateTime",
		business:"JobPageUpdateBusinessEntityRelationInput",
		siteType:"SiteType"
	},
	JobPageUpdateLocalesEntityRelationInput:{
		create:"JobPageLocaleWithoutRootCreateInput",
		update:"JobPageUpdateLocalesRelationInput",
		upsert:"JobPageUpsertLocalesRelationInput",
		connect:"JobPageLocaleUniqueWhere",
		disconnect:"JobPageLocaleUniqueWhere",
		delete:"JobPageLocaleUniqueWhere"
	},
	JobPageUpdateLocalesRelationInput:{
		by:"JobPageLocaleUniqueWhere",
		data:"JobPageLocaleWithoutRootUpdateInput"
	},
	JobPageLocaleWithoutRootUpdateInput:{
		locale:"JobPageLocaleUpdateLocaleEntityRelationInput",
		image:"JobPageLocaleUpdateImageEntityRelationInput",
		keyInfo:"JobPageLocaleUpdateKeyInfoEntityRelationInput",
		content:"JobPageLocaleUpdateContentEntityRelationInput",
		seo:"JobPageLocaleUpdateSeoEntityRelationInput",
		link:"JobPageLocaleUpdateLinkEntityRelationInput",
		stickyBar:"JobPageLocaleUpdateStickyBarEntityRelationInput",
		mobileImage:"JobPageLocaleUpdateMobileImageEntityRelationInput"
	},
	JobPageLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobPagesCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutJobPagesUpdateInput",
		upsert:"JobPageLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutJobPagesUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	LocaleUpdateContractTypesEntityRelationInput:{
		create:"ContractTypeLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateContractTypesRelationInput",
		upsert:"LocaleUpsertContractTypesRelationInput",
		connect:"ContractTypeLocaleUniqueWhere",
		disconnect:"ContractTypeLocaleUniqueWhere",
		delete:"ContractTypeLocaleUniqueWhere"
	},
	LocaleUpdateContractTypesRelationInput:{
		by:"ContractTypeLocaleUniqueWhere",
		data:"ContractTypeLocaleWithoutLocaleUpdateInput"
	},
	ContractTypeLocaleWithoutLocaleUpdateInput:{
		root:"ContractTypeLocaleUpdateRootEntityRelationInput"
	},
	ContractTypeLocaleUpdateRootEntityRelationInput:{
		connect:"ContractTypeUniqueWhere",
		create:"ContractTypeWithoutLocalesCreateInput",
		connectOrCreate:"ContractTypeLocaleConnectOrCreateRootRelationInput",
		update:"ContractTypeWithoutLocalesUpdateInput",
		upsert:"ContractTypeLocaleUpsertRootRelationInput"
	},
	ContractTypeWithoutLocalesUpdateInput:{

	},
	ContractTypeLocaleUpsertRootRelationInput:{
		update:"ContractTypeWithoutLocalesUpdateInput",
		create:"ContractTypeWithoutLocalesCreateInput"
	},
	LocaleUpsertContractTypesRelationInput:{
		by:"ContractTypeLocaleUniqueWhere",
		update:"ContractTypeLocaleWithoutLocaleUpdateInput",
		create:"ContractTypeLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateHomePagesEntityRelationInput:{
		create:"HomePageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateHomePagesRelationInput",
		upsert:"LocaleUpsertHomePagesRelationInput",
		connect:"HomePageLocaleUniqueWhere",
		disconnect:"HomePageLocaleUniqueWhere",
		delete:"HomePageLocaleUniqueWhere"
	},
	LocaleUpdateHomePagesRelationInput:{
		by:"HomePageLocaleUniqueWhere",
		data:"HomePageLocaleWithoutLocaleUpdateInput"
	},
	HomePageLocaleWithoutLocaleUpdateInput:{
		root:"HomePageLocaleUpdateRootEntityRelationInput",
		button:"HomePageLocaleUpdateButtonEntityRelationInput",
		content:"HomePageLocaleUpdateContentEntityRelationInput",
		seo:"HomePageLocaleUpdateSeoEntityRelationInput",
		link:"HomePageLocaleUpdateLinkEntityRelationInput",
		logo:"HomePageLocaleUpdateLogoEntityRelationInput",
		siteSwitcher:"HomePageLocaleUpdateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLocaleUpdateGalleryEntityRelationInput",
		stickyBar:"HomePageLocaleUpdateStickyBarEntityRelationInput",
		ilustration:"HomePageLocaleUpdateIlustrationEntityRelationInput"
	},
	HomePageLocaleUpdateRootEntityRelationInput:{
		connect:"HomePageUniqueWhere",
		create:"HomePageWithoutLocalesCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateRootRelationInput",
		update:"HomePageWithoutLocalesUpdateInput",
		upsert:"HomePageLocaleUpsertRootRelationInput"
	},
	HomePageWithoutLocalesUpdateInput:{
		unique:"One",
		theme:"HomePageUpdateThemeEntityRelationInput"
	},
	HomePageUpdateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"HomePageConnectOrCreateThemeRelationInput",
		update:"ThemeUpdateInput",
		upsert:"HomePageUpsertThemeRelationInput"
	},
	HomePageUpsertThemeRelationInput:{
		update:"ThemeUpdateInput",
		create:"ThemeCreateInput"
	},
	HomePageLocaleUpsertRootRelationInput:{
		update:"HomePageWithoutLocalesUpdateInput",
		create:"HomePageWithoutLocalesCreateInput"
	},
	HomePageLocaleUpdateButtonEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateButtonRelationInput",
		update:"LinkUpdateInput",
		upsert:"HomePageLocaleUpsertButtonRelationInput"
	},
	HomePageLocaleUpsertButtonRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	HomePageLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"HomePageLocaleUpsertContentRelationInput"
	},
	HomePageLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	HomePageLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"HomePageLocaleUpsertSeoRelationInput"
	},
	HomePageLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	HomePageLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutHomePageCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutHomePageUpdateInput",
		upsert:"HomePageLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutHomePageUpdateInput:{
		redirect:"LinkableUpdateRedirectEntityRelationInput",
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		businessPage:"LinkableUpdateBusinessPageEntityRelationInput",
		jobPage:"LinkableUpdateJobPageEntityRelationInput",
		homePageLokal:"LinkableUpdateHomePageLokalEntityRelationInput"
	},
	LinkableUpdateJobPageEntityRelationInput:{
		connect:"JobPageLocaleUniqueWhere",
		create:"JobPageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateJobPageRelationInput",
		update:"JobPageLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertJobPageRelationInput"
	},
	JobPageLocaleWithoutLinkUpdateInput:{
		root:"JobPageLocaleUpdateRootEntityRelationInput",
		locale:"JobPageLocaleUpdateLocaleEntityRelationInput",
		image:"JobPageLocaleUpdateImageEntityRelationInput",
		keyInfo:"JobPageLocaleUpdateKeyInfoEntityRelationInput",
		content:"JobPageLocaleUpdateContentEntityRelationInput",
		seo:"JobPageLocaleUpdateSeoEntityRelationInput",
		stickyBar:"JobPageLocaleUpdateStickyBarEntityRelationInput",
		mobileImage:"JobPageLocaleUpdateMobileImageEntityRelationInput"
	},
	JobPageLocaleUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"JobPageLocaleUpsertImageRelationInput"
	},
	JobPageLocaleUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	JobPageLocaleUpdateKeyInfoEntityRelationInput:{
		connect:"KeyInfoListUniqueWhere",
		create:"KeyInfoListCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateKeyInfoRelationInput",
		update:"KeyInfoListUpdateInput",
		upsert:"JobPageLocaleUpsertKeyInfoRelationInput"
	},
	KeyInfoListUpdateInput:{
		items:"KeyInfoListUpdateItemsEntityRelationInput"
	},
	KeyInfoListUpdateItemsEntityRelationInput:{
		create:"KeyInfoItemWithoutListCreateInput",
		update:"KeyInfoListUpdateItemsRelationInput",
		upsert:"KeyInfoListUpsertItemsRelationInput",
		connect:"KeyInfoItemUniqueWhere",
		disconnect:"KeyInfoItemUniqueWhere",
		delete:"KeyInfoItemUniqueWhere"
	},
	KeyInfoListUpdateItemsRelationInput:{
		by:"KeyInfoItemUniqueWhere",
		data:"KeyInfoItemWithoutListUpdateInput"
	},
	KeyInfoItemWithoutListUpdateInput:{
		icon:"KeyInfoItemUpdateIconEntityRelationInput"
	},
	KeyInfoItemUpdateIconEntityRelationInput:{
		connect:"IconUniqueWhere",
		create:"IconCreateInput",
		connectOrCreate:"KeyInfoItemConnectOrCreateIconRelationInput",
		update:"IconUpdateInput",
		upsert:"KeyInfoItemUpsertIconRelationInput"
	},
	IconUpdateInput:{
		icon:"IconUpdateIconEntityRelationInput"
	},
	IconUpdateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"IconConnectOrCreateIconRelationInput",
		update:"ImageUpdateInput",
		upsert:"IconUpsertIconRelationInput"
	},
	IconUpsertIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	KeyInfoItemUpsertIconRelationInput:{
		update:"IconUpdateInput",
		create:"IconCreateInput"
	},
	KeyInfoListUpsertItemsRelationInput:{
		by:"KeyInfoItemUniqueWhere",
		update:"KeyInfoItemWithoutListUpdateInput",
		create:"KeyInfoItemWithoutListCreateInput"
	},
	JobPageLocaleUpsertKeyInfoRelationInput:{
		update:"KeyInfoListUpdateInput",
		create:"KeyInfoListCreateInput"
	},
	JobPageLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"JobPageLocaleUpsertContentRelationInput"
	},
	JobPageLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	JobPageLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"JobPageLocaleUpsertSeoRelationInput"
	},
	JobPageLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	JobPageLocaleUpdateStickyBarEntityRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateStickyBarRelationInput",
		update:"StickyBarUpdateInput",
		upsert:"JobPageLocaleUpsertStickyBarRelationInput"
	},
	StickyBarUpdateInput:{
		link:"StickyBarUpdateLinkEntityRelationInput",
		jobsForm:"StickyBarUpdateJobsFormEntityRelationInput"
	},
	StickyBarUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"StickyBarConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"StickyBarUpsertLinkRelationInput"
	},
	StickyBarUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	StickyBarUpdateJobsFormEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput",
		connectOrCreate:"StickyBarConnectOrCreateJobsFormRelationInput",
		update:"JobsFormLocaleUpdateInput",
		upsert:"StickyBarUpsertJobsFormRelationInput"
	},
	JobsFormLocaleUpdateInput:{
		root:"JobsFormLocaleUpdateRootEntityRelationInput",
		locale:"JobsFormLocaleUpdateLocaleEntityRelationInput",
		imageTextList:"JobsFormLocaleUpdateImageTextListEntityRelationInput",
		logo:"JobsFormLocaleUpdateLogoEntityRelationInput",
		successImage:"JobsFormLocaleUpdateSuccessImageEntityRelationInput"
	},
	JobsFormLocaleUpdateRootEntityRelationInput:{
		connect:"JobsFormUniqueWhere",
		create:"JobsFormWithoutLocalesCreateInput",
		connectOrCreate:"JobsFormLocaleConnectOrCreateRootRelationInput",
		update:"JobsFormWithoutLocalesUpdateInput",
		upsert:"JobsFormLocaleUpsertRootRelationInput"
	},
	JobsFormWithoutLocalesUpdateInput:{
		unique:"One",
		fileIlustration:"JobsFormUpdateFileIlustrationEntityRelationInput"
	},
	JobsFormUpdateFileIlustrationEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobsFormConnectOrCreateFileIlustrationRelationInput",
		update:"ImageUpdateInput",
		upsert:"JobsFormUpsertFileIlustrationRelationInput"
	},
	JobsFormUpsertFileIlustrationRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	JobsFormLocaleUpsertRootRelationInput:{
		update:"JobsFormWithoutLocalesUpdateInput",
		create:"JobsFormWithoutLocalesCreateInput"
	},
	JobsFormLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobsFormsCreateInput",
		connectOrCreate:"JobsFormLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutJobsFormsUpdateInput",
		upsert:"JobsFormLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutJobsFormsUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	LocaleUpdateBonusBannersEntityRelationInput:{
		create:"BonusBannerLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateBonusBannersRelationInput",
		upsert:"LocaleUpsertBonusBannersRelationInput",
		connect:"BonusBannerLocaleUniqueWhere",
		disconnect:"BonusBannerLocaleUniqueWhere",
		delete:"BonusBannerLocaleUniqueWhere"
	},
	LocaleUpdateBonusBannersRelationInput:{
		by:"BonusBannerLocaleUniqueWhere",
		data:"BonusBannerLocaleWithoutLocaleUpdateInput"
	},
	BonusBannerLocaleWithoutLocaleUpdateInput:{
		root:"BonusBannerLocaleUpdateRootEntityRelationInput",
		tiles:"BonusBannerLocaleUpdateTilesEntityRelationInput",
		logo:"BonusBannerLocaleUpdateLogoEntityRelationInput"
	},
	BonusBannerLocaleUpdateTilesEntityRelationInput:{
		create:"TileWithoutBonusBannerCreateInput",
		update:"BonusBannerLocaleUpdateTilesRelationInput",
		upsert:"BonusBannerLocaleUpsertTilesRelationInput",
		connect:"TileUniqueWhere",
		disconnect:"TileUniqueWhere",
		delete:"TileUniqueWhere"
	},
	BonusBannerLocaleUpdateTilesRelationInput:{
		by:"TileUniqueWhere",
		data:"TileWithoutBonusBannerUpdateInput"
	},
	TileWithoutBonusBannerUpdateInput:{
		image:"TileUpdateImageEntityRelationInput",
		ligthBoxMedia:"TileUpdateLigthBoxMediaEntityRelationInput",
		lightBoxForm:"TileUpdateLightBoxFormEntityRelationInput"
	},
	TileUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"TileConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"TileUpsertImageRelationInput"
	},
	TileUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	TileUpdateLigthBoxMediaEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput",
		connectOrCreate:"TileConnectOrCreateLigthBoxMediaRelationInput",
		update:"MediumListUpdateInput",
		upsert:"TileUpsertLigthBoxMediaRelationInput"
	},
	TileUpsertLigthBoxMediaRelationInput:{
		update:"MediumListUpdateInput",
		create:"MediumListCreateInput"
	},
	TileUpdateLightBoxFormEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput",
		connectOrCreate:"TileConnectOrCreateLightBoxFormRelationInput",
		update:"JobsFormLocaleUpdateInput",
		upsert:"TileUpsertLightBoxFormRelationInput"
	},
	TileUpsertLightBoxFormRelationInput:{
		update:"JobsFormLocaleUpdateInput",
		create:"JobsFormLocaleCreateInput"
	},
	BonusBannerLocaleUpsertTilesRelationInput:{
		by:"TileUniqueWhere",
		update:"TileWithoutBonusBannerUpdateInput",
		create:"TileWithoutBonusBannerCreateInput"
	},
	BonusBannerLocaleUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"BonusBannerLocaleConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"BonusBannerLocaleUpsertLogoRelationInput"
	},
	BonusBannerLocaleUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	LocaleUpsertBonusBannersRelationInput:{
		by:"BonusBannerLocaleUniqueWhere",
		update:"BonusBannerLocaleWithoutLocaleUpdateInput",
		create:"BonusBannerLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateHomePageLokalsEntityRelationInput:{
		create:"HomePageLokalLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateHomePageLokalsRelationInput",
		upsert:"LocaleUpsertHomePageLokalsRelationInput",
		connect:"HomePageLokalLocaleUniqueWhere",
		disconnect:"HomePageLokalLocaleUniqueWhere",
		delete:"HomePageLokalLocaleUniqueWhere"
	},
	LocaleUpdateHomePageLokalsRelationInput:{
		by:"HomePageLokalLocaleUniqueWhere",
		data:"HomePageLokalLocaleWithoutLocaleUpdateInput"
	},
	HomePageLokalLocaleWithoutLocaleUpdateInput:{
		root:"HomePageLokalLocaleUpdateRootEntityRelationInput",
		logo:"HomePageLokalLocaleUpdateLogoEntityRelationInput",
		button:"HomePageLokalLocaleUpdateButtonEntityRelationInput",
		content:"HomePageLokalLocaleUpdateContentEntityRelationInput",
		seo:"HomePageLokalLocaleUpdateSeoEntityRelationInput",
		link:"HomePageLokalLocaleUpdateLinkEntityRelationInput",
		siteSwitcher:"HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLokalLocaleUpdateGalleryEntityRelationInput",
		stickyBar:"HomePageLokalLocaleUpdateStickyBarEntityRelationInput",
		ilustration:"HomePageLokalLocaleUpdateIlustrationEntityRelationInput"
	},
	HomePageLokalLocaleUpdateRootEntityRelationInput:{
		connect:"HomePageLokalUniqueWhere",
		create:"HomePageLokalWithoutLocalesCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateRootRelationInput",
		update:"HomePageLokalWithoutLocalesUpdateInput",
		upsert:"HomePageLokalLocaleUpsertRootRelationInput"
	},
	HomePageLokalWithoutLocalesUpdateInput:{
		unique:"One",
		theme:"HomePageLokalUpdateThemeEntityRelationInput"
	},
	HomePageLokalUpdateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"HomePageLokalConnectOrCreateThemeRelationInput",
		update:"ThemeUpdateInput",
		upsert:"HomePageLokalUpsertThemeRelationInput"
	},
	HomePageLokalUpsertThemeRelationInput:{
		update:"ThemeUpdateInput",
		create:"ThemeCreateInput"
	},
	HomePageLokalLocaleUpsertRootRelationInput:{
		update:"HomePageLokalWithoutLocalesUpdateInput",
		create:"HomePageLokalWithoutLocalesCreateInput"
	},
	HomePageLokalLocaleUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"HomePageLokalLocaleUpsertLogoRelationInput"
	},
	HomePageLokalLocaleUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	HomePageLokalLocaleUpdateButtonEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateButtonRelationInput",
		update:"LinkUpdateInput",
		upsert:"HomePageLokalLocaleUpsertButtonRelationInput"
	},
	HomePageLokalLocaleUpsertButtonRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	HomePageLokalLocaleUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateContentRelationInput",
		update:"ContentUpdateInput",
		upsert:"HomePageLokalLocaleUpsertContentRelationInput"
	},
	HomePageLokalLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	HomePageLokalLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"HomePageLokalLocaleUpsertSeoRelationInput"
	},
	HomePageLokalLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	HomePageLokalLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutHomePageLokalCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutHomePageLokalUpdateInput",
		upsert:"HomePageLokalLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutHomePageLokalUpdateInput:{
		redirect:"LinkableUpdateRedirectEntityRelationInput",
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		businessPage:"LinkableUpdateBusinessPageEntityRelationInput",
		jobPage:"LinkableUpdateJobPageEntityRelationInput",
		homePage:"LinkableUpdateHomePageEntityRelationInput"
	},
	LinkableUpdateHomePageEntityRelationInput:{
		connect:"HomePageLocaleUniqueWhere",
		create:"HomePageLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateHomePageRelationInput",
		update:"HomePageLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertHomePageRelationInput"
	},
	HomePageLocaleWithoutLinkUpdateInput:{
		root:"HomePageLocaleUpdateRootEntityRelationInput",
		locale:"HomePageLocaleUpdateLocaleEntityRelationInput",
		button:"HomePageLocaleUpdateButtonEntityRelationInput",
		content:"HomePageLocaleUpdateContentEntityRelationInput",
		seo:"HomePageLocaleUpdateSeoEntityRelationInput",
		logo:"HomePageLocaleUpdateLogoEntityRelationInput",
		siteSwitcher:"HomePageLocaleUpdateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLocaleUpdateGalleryEntityRelationInput",
		stickyBar:"HomePageLocaleUpdateStickyBarEntityRelationInput",
		ilustration:"HomePageLocaleUpdateIlustrationEntityRelationInput"
	},
	HomePageLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHomePagesCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutHomePagesUpdateInput",
		upsert:"HomePageLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutHomePagesUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	LocaleUpdateJobsFormsEntityRelationInput:{
		create:"JobsFormLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateJobsFormsRelationInput",
		upsert:"LocaleUpsertJobsFormsRelationInput",
		connect:"JobsFormLocaleUniqueWhere",
		disconnect:"JobsFormLocaleUniqueWhere",
		delete:"JobsFormLocaleUniqueWhere"
	},
	LocaleUpdateJobsFormsRelationInput:{
		by:"JobsFormLocaleUniqueWhere",
		data:"JobsFormLocaleWithoutLocaleUpdateInput"
	},
	JobsFormLocaleWithoutLocaleUpdateInput:{
		root:"JobsFormLocaleUpdateRootEntityRelationInput",
		imageTextList:"JobsFormLocaleUpdateImageTextListEntityRelationInput",
		logo:"JobsFormLocaleUpdateLogoEntityRelationInput",
		successImage:"JobsFormLocaleUpdateSuccessImageEntityRelationInput"
	},
	JobsFormLocaleUpdateImageTextListEntityRelationInput:{
		connect:"ImageTextListUniqueWhere",
		create:"ImageTextListCreateInput",
		connectOrCreate:"JobsFormLocaleConnectOrCreateImageTextListRelationInput",
		update:"ImageTextListUpdateInput",
		upsert:"JobsFormLocaleUpsertImageTextListRelationInput"
	},
	ImageTextListUpdateInput:{
		items:"ImageTextListUpdateItemsEntityRelationInput"
	},
	ImageTextListUpdateItemsEntityRelationInput:{
		create:"ImageTextItemWithoutListCreateInput",
		update:"ImageTextListUpdateItemsRelationInput",
		upsert:"ImageTextListUpsertItemsRelationInput",
		connect:"ImageTextItemUniqueWhere",
		disconnect:"ImageTextItemUniqueWhere",
		delete:"ImageTextItemUniqueWhere"
	},
	ImageTextListUpdateItemsRelationInput:{
		by:"ImageTextItemUniqueWhere",
		data:"ImageTextItemWithoutListUpdateInput"
	},
	ImageTextItemWithoutListUpdateInput:{
		image:"ImageTextItemUpdateImageEntityRelationInput"
	},
	ImageTextItemUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ImageTextItemConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"ImageTextItemUpsertImageRelationInput"
	},
	ImageTextItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ImageTextListUpsertItemsRelationInput:{
		by:"ImageTextItemUniqueWhere",
		update:"ImageTextItemWithoutListUpdateInput",
		create:"ImageTextItemWithoutListCreateInput"
	},
	JobsFormLocaleUpsertImageTextListRelationInput:{
		update:"ImageTextListUpdateInput",
		create:"ImageTextListCreateInput"
	},
	JobsFormLocaleUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobsFormLocaleConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"JobsFormLocaleUpsertLogoRelationInput"
	},
	JobsFormLocaleUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	JobsFormLocaleUpdateSuccessImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobsFormLocaleConnectOrCreateSuccessImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"JobsFormLocaleUpsertSuccessImageRelationInput"
	},
	JobsFormLocaleUpsertSuccessImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	LocaleUpsertJobsFormsRelationInput:{
		by:"JobsFormLocaleUniqueWhere",
		update:"JobsFormLocaleWithoutLocaleUpdateInput",
		create:"JobsFormLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateJobsFiltersEntityRelationInput:{
		create:"JobsFilterLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateJobsFiltersRelationInput",
		upsert:"LocaleUpsertJobsFiltersRelationInput",
		connect:"JobsFilterLocaleUniqueWhere",
		disconnect:"JobsFilterLocaleUniqueWhere",
		delete:"JobsFilterLocaleUniqueWhere"
	},
	LocaleUpdateJobsFiltersRelationInput:{
		by:"JobsFilterLocaleUniqueWhere",
		data:"JobsFilterLocaleWithoutLocaleUpdateInput"
	},
	JobsFilterLocaleWithoutLocaleUpdateInput:{
		root:"JobsFilterLocaleUpdateRootEntityRelationInput",
		bannerJobsForm:"JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput",
		bannerImage:"JobsFilterLocaleUpdateBannerImageEntityRelationInput",
		noJobImage:"JobsFilterLocaleUpdateNoJobImageEntityRelationInput"
	},
	JobsFilterLocaleUpdateRootEntityRelationInput:{
		connect:"JobsFilterUniqueWhere",
		create:"JobsFilterWithoutLocalesCreateInput",
		connectOrCreate:"JobsFilterLocaleConnectOrCreateRootRelationInput",
		update:"JobsFilterWithoutLocalesUpdateInput",
		upsert:"JobsFilterLocaleUpsertRootRelationInput"
	},
	JobsFilterWithoutLocalesUpdateInput:{
		unique:"One"
	},
	JobsFilterLocaleUpsertRootRelationInput:{
		update:"JobsFilterWithoutLocalesUpdateInput",
		create:"JobsFilterWithoutLocalesCreateInput"
	},
	JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput",
		connectOrCreate:"JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput",
		update:"JobsFormLocaleUpdateInput",
		upsert:"JobsFilterLocaleUpsertBannerJobsFormRelationInput"
	},
	JobsFilterLocaleUpsertBannerJobsFormRelationInput:{
		update:"JobsFormLocaleUpdateInput",
		create:"JobsFormLocaleCreateInput"
	},
	JobsFilterLocaleUpdateBannerImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobsFilterLocaleConnectOrCreateBannerImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"JobsFilterLocaleUpsertBannerImageRelationInput"
	},
	JobsFilterLocaleUpsertBannerImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	JobsFilterLocaleUpdateNoJobImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobsFilterLocaleConnectOrCreateNoJobImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"JobsFilterLocaleUpsertNoJobImageRelationInput"
	},
	JobsFilterLocaleUpsertNoJobImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	LocaleUpsertJobsFiltersRelationInput:{
		by:"JobsFilterLocaleUniqueWhere",
		update:"JobsFilterLocaleWithoutLocaleUpdateInput",
		create:"JobsFilterLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateGeneralEntityRelationInput:{
		create:"GeneralLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateGeneralRelationInput",
		upsert:"LocaleUpsertGeneralRelationInput",
		connect:"GeneralLocaleUniqueWhere",
		disconnect:"GeneralLocaleUniqueWhere",
		delete:"GeneralLocaleUniqueWhere"
	},
	LocaleUpdateGeneralRelationInput:{
		by:"GeneralLocaleUniqueWhere",
		data:"GeneralLocaleWithoutLocaleUpdateInput"
	},
	GeneralLocaleWithoutLocaleUpdateInput:{
		root:"GeneralLocaleUpdateRootEntityRelationInput",
		seo:"GeneralLocaleUpdateSeoEntityRelationInput",
		cornerBanner:"GeneralLocaleUpdateCornerBannerEntityRelationInput"
	},
	GeneralLocaleUpdateRootEntityRelationInput:{
		connect:"GeneralUniqueWhere",
		create:"GeneralWithoutLocalesCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateRootRelationInput",
		update:"GeneralWithoutLocalesUpdateInput",
		upsert:"GeneralLocaleUpsertRootRelationInput"
	},
	GeneralWithoutLocalesUpdateInput:{
		unique:"One"
	},
	GeneralLocaleUpsertRootRelationInput:{
		update:"GeneralWithoutLocalesUpdateInput",
		create:"GeneralWithoutLocalesCreateInput"
	},
	GeneralLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"GeneralLocaleUpsertSeoRelationInput"
	},
	GeneralLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	GeneralLocaleUpdateCornerBannerEntityRelationInput:{
		connect:"CornerBannerUniqueWhere",
		create:"CornerBannerCreateInput",
		connectOrCreate:"GeneralLocaleConnectOrCreateCornerBannerRelationInput",
		update:"CornerBannerUpdateInput",
		upsert:"GeneralLocaleUpsertCornerBannerRelationInput"
	},
	CornerBannerUpdateInput:{
		logo:"CornerBannerUpdateLogoEntityRelationInput",
		link:"CornerBannerUpdateLinkEntityRelationInput"
	},
	CornerBannerUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"CornerBannerConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"CornerBannerUpsertLogoRelationInput"
	},
	CornerBannerUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	CornerBannerUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"CornerBannerConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"CornerBannerUpsertLinkRelationInput"
	},
	CornerBannerUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	GeneralLocaleUpsertCornerBannerRelationInput:{
		update:"CornerBannerUpdateInput",
		create:"CornerBannerCreateInput"
	},
	LocaleUpsertGeneralRelationInput:{
		by:"GeneralLocaleUniqueWhere",
		update:"GeneralLocaleWithoutLocaleUpdateInput",
		create:"GeneralLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateRecommendationFormsEntityRelationInput:{
		create:"RecommendationFormLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateRecommendationFormsRelationInput",
		upsert:"LocaleUpsertRecommendationFormsRelationInput",
		connect:"RecommendationFormLocaleUniqueWhere",
		disconnect:"RecommendationFormLocaleUniqueWhere",
		delete:"RecommendationFormLocaleUniqueWhere"
	},
	LocaleUpdateRecommendationFormsRelationInput:{
		by:"RecommendationFormLocaleUniqueWhere",
		data:"RecommendationFormLocaleWithoutLocaleUpdateInput"
	},
	RecommendationFormLocaleWithoutLocaleUpdateInput:{
		root:"RecommendationFormLocaleUpdateRootEntityRelationInput"
	},
	RecommendationFormLocaleUpdateRootEntityRelationInput:{
		connect:"RecommendationFormUniqueWhere",
		create:"RecommendationFormWithoutLocalesCreateInput",
		connectOrCreate:"RecommendationFormLocaleConnectOrCreateRootRelationInput",
		update:"RecommendationFormWithoutLocalesUpdateInput",
		upsert:"RecommendationFormLocaleUpsertRootRelationInput"
	},
	RecommendationFormWithoutLocalesUpdateInput:{
		unique:"One",
		successImage:"RecommendationFormUpdateSuccessImageEntityRelationInput"
	},
	RecommendationFormUpdateSuccessImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"RecommendationFormConnectOrCreateSuccessImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"RecommendationFormUpsertSuccessImageRelationInput"
	},
	RecommendationFormUpsertSuccessImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	RecommendationFormLocaleUpsertRootRelationInput:{
		update:"RecommendationFormWithoutLocalesUpdateInput",
		create:"RecommendationFormWithoutLocalesCreateInput"
	},
	LocaleUpsertRecommendationFormsRelationInput:{
		by:"RecommendationFormLocaleUniqueWhere",
		update:"RecommendationFormLocaleWithoutLocaleUpdateInput",
		create:"RecommendationFormLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateInfoBoxesEntityRelationInput:{
		create:"InfoBoxLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateInfoBoxesRelationInput",
		upsert:"LocaleUpsertInfoBoxesRelationInput",
		connect:"InfoBoxLocaleUniqueWhere",
		disconnect:"InfoBoxLocaleUniqueWhere",
		delete:"InfoBoxLocaleUniqueWhere"
	},
	LocaleUpdateInfoBoxesRelationInput:{
		by:"InfoBoxLocaleUniqueWhere",
		data:"InfoBoxLocaleWithoutLocaleUpdateInput"
	},
	InfoBoxLocaleWithoutLocaleUpdateInput:{
		root:"InfoBoxLocaleUpdateRootEntityRelationInput",
		openingHours:"InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"
	},
	InfoBoxLocaleUpdateRootEntityRelationInput:{
		connect:"InfoBoxUniqueWhere",
		create:"InfoBoxWithoutLocalesCreateInput",
		connectOrCreate:"InfoBoxLocaleConnectOrCreateRootRelationInput",
		update:"InfoBoxWithoutLocalesUpdateInput",
		upsert:"InfoBoxLocaleUpsertRootRelationInput"
	},
	InfoBoxWithoutLocalesUpdateInput:{
		logoSize:"LogoSize",
		logo:"InfoBoxUpdateLogoEntityRelationInput"
	},
	InfoBoxUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"InfoBoxConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"InfoBoxUpsertLogoRelationInput"
	},
	InfoBoxUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	InfoBoxLocaleUpsertRootRelationInput:{
		update:"InfoBoxWithoutLocalesUpdateInput",
		create:"InfoBoxWithoutLocalesCreateInput"
	},
	InfoBoxLocaleUpdateOpeningHoursEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput",
		connectOrCreate:"InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput",
		update:"TextListUpdateInput",
		upsert:"InfoBoxLocaleUpsertOpeningHoursRelationInput"
	},
	InfoBoxLocaleUpsertOpeningHoursRelationInput:{
		update:"TextListUpdateInput",
		create:"TextListCreateInput"
	},
	LocaleUpsertInfoBoxesRelationInput:{
		by:"InfoBoxLocaleUniqueWhere",
		update:"InfoBoxLocaleWithoutLocaleUpdateInput",
		create:"InfoBoxLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateTranslationsEntityRelationInput:{
		create:"TranslationLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateTranslationsRelationInput",
		upsert:"LocaleUpsertTranslationsRelationInput",
		connect:"TranslationLocaleUniqueWhere",
		disconnect:"TranslationLocaleUniqueWhere",
		delete:"TranslationLocaleUniqueWhere"
	},
	LocaleUpdateTranslationsRelationInput:{
		by:"TranslationLocaleUniqueWhere",
		data:"TranslationLocaleWithoutLocaleUpdateInput"
	},
	TranslationLocaleWithoutLocaleUpdateInput:{
		root:"TranslationLocaleUpdateRootEntityRelationInput"
	},
	TranslationLocaleUpdateRootEntityRelationInput:{
		connect:"TranslationUniqueWhere",
		create:"TranslationWithoutLocalesCreateInput",
		connectOrCreate:"TranslationLocaleConnectOrCreateRootRelationInput",
		update:"TranslationWithoutLocalesUpdateInput",
		upsert:"TranslationLocaleUpsertRootRelationInput"
	},
	TranslationWithoutLocalesUpdateInput:{

	},
	TranslationLocaleUpsertRootRelationInput:{
		update:"TranslationWithoutLocalesUpdateInput",
		create:"TranslationWithoutLocalesCreateInput"
	},
	LocaleUpsertTranslationsRelationInput:{
		by:"TranslationLocaleUniqueWhere",
		update:"TranslationLocaleWithoutLocaleUpdateInput",
		create:"TranslationLocaleWithoutLocaleCreateInput"
	},
	HomePageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutHomePagesUpdateInput",
		create:"LocaleWithoutHomePagesCreateInput"
	},
	HomePageLocaleUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"HomePageLocaleUpsertLogoRelationInput"
	},
	HomePageLocaleUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	HomePageLocaleUpdateSiteSwitcherEntityRelationInput:{
		connect:"SiteSwitcherUniqueWhere",
		create:"SiteSwitcherCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateSiteSwitcherRelationInput",
		update:"SiteSwitcherUpdateInput",
		upsert:"HomePageLocaleUpsertSiteSwitcherRelationInput"
	},
	SiteSwitcherUpdateInput:{
		link:"SiteSwitcherUpdateLinkEntityRelationInput",
		theme:"SiteSwitcherUpdateThemeEntityRelationInput"
	},
	SiteSwitcherUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"SiteSwitcherConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"SiteSwitcherUpsertLinkRelationInput"
	},
	SiteSwitcherUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	SiteSwitcherUpdateThemeEntityRelationInput:{
		connect:"ThemeUniqueWhere",
		create:"ThemeCreateInput",
		connectOrCreate:"SiteSwitcherConnectOrCreateThemeRelationInput",
		update:"ThemeUpdateInput",
		upsert:"SiteSwitcherUpsertThemeRelationInput"
	},
	SiteSwitcherUpsertThemeRelationInput:{
		update:"ThemeUpdateInput",
		create:"ThemeCreateInput"
	},
	HomePageLocaleUpsertSiteSwitcherRelationInput:{
		update:"SiteSwitcherUpdateInput",
		create:"SiteSwitcherCreateInput"
	},
	HomePageLocaleUpdateGalleryEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateGalleryRelationInput",
		update:"GalleryUpdateInput",
		upsert:"HomePageLocaleUpsertGalleryRelationInput"
	},
	GalleryUpdateInput:{
		items:"GalleryUpdateItemsEntityRelationInput"
	},
	GalleryUpdateItemsEntityRelationInput:{
		create:"GalleryItemWithoutListCreateInput",
		update:"GalleryUpdateItemsRelationInput",
		upsert:"GalleryUpsertItemsRelationInput",
		connect:"GalleryItemUniqueWhere",
		disconnect:"GalleryItemUniqueWhere",
		delete:"GalleryItemUniqueWhere"
	},
	GalleryUpdateItemsRelationInput:{
		by:"GalleryItemUniqueWhere",
		data:"GalleryItemWithoutListUpdateInput"
	},
	GalleryItemWithoutListUpdateInput:{
		image:"GalleryItemUpdateImageEntityRelationInput"
	},
	GalleryItemUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"GalleryItemConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"GalleryItemUpsertImageRelationInput"
	},
	GalleryItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	GalleryUpsertItemsRelationInput:{
		by:"GalleryItemUniqueWhere",
		update:"GalleryItemWithoutListUpdateInput",
		create:"GalleryItemWithoutListCreateInput"
	},
	HomePageLocaleUpsertGalleryRelationInput:{
		update:"GalleryUpdateInput",
		create:"GalleryCreateInput"
	},
	HomePageLocaleUpdateStickyBarEntityRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateStickyBarRelationInput",
		update:"StickyBarUpdateInput",
		upsert:"HomePageLocaleUpsertStickyBarRelationInput"
	},
	HomePageLocaleUpsertStickyBarRelationInput:{
		update:"StickyBarUpdateInput",
		create:"StickyBarCreateInput"
	},
	HomePageLocaleUpdateIlustrationEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput",
		connectOrCreate:"HomePageLocaleConnectOrCreateIlustrationRelationInput",
		update:"GalleryUpdateInput",
		upsert:"HomePageLocaleUpsertIlustrationRelationInput"
	},
	HomePageLocaleUpsertIlustrationRelationInput:{
		update:"GalleryUpdateInput",
		create:"GalleryCreateInput"
	},
	LinkableUpsertHomePageRelationInput:{
		update:"HomePageLocaleWithoutLinkUpdateInput",
		create:"HomePageLocaleWithoutLinkCreateInput"
	},
	HomePageLokalLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutHomePageLokalUpdateInput",
		create:"LinkableWithoutHomePageLokalCreateInput"
	},
	HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput:{
		connect:"SiteSwitcherUniqueWhere",
		create:"SiteSwitcherCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput",
		update:"SiteSwitcherUpdateInput",
		upsert:"HomePageLokalLocaleUpsertSiteSwitcherRelationInput"
	},
	HomePageLokalLocaleUpsertSiteSwitcherRelationInput:{
		update:"SiteSwitcherUpdateInput",
		create:"SiteSwitcherCreateInput"
	},
	HomePageLokalLocaleUpdateGalleryEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateGalleryRelationInput",
		update:"GalleryUpdateInput",
		upsert:"HomePageLokalLocaleUpsertGalleryRelationInput"
	},
	HomePageLokalLocaleUpsertGalleryRelationInput:{
		update:"GalleryUpdateInput",
		create:"GalleryCreateInput"
	},
	HomePageLokalLocaleUpdateStickyBarEntityRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateStickyBarRelationInput",
		update:"StickyBarUpdateInput",
		upsert:"HomePageLokalLocaleUpsertStickyBarRelationInput"
	},
	HomePageLokalLocaleUpsertStickyBarRelationInput:{
		update:"StickyBarUpdateInput",
		create:"StickyBarCreateInput"
	},
	HomePageLokalLocaleUpdateIlustrationEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateIlustrationRelationInput",
		update:"GalleryUpdateInput",
		upsert:"HomePageLokalLocaleUpsertIlustrationRelationInput"
	},
	HomePageLokalLocaleUpsertIlustrationRelationInput:{
		update:"GalleryUpdateInput",
		create:"GalleryCreateInput"
	},
	LocaleUpsertHomePageLokalsRelationInput:{
		by:"HomePageLokalLocaleUniqueWhere",
		update:"HomePageLokalLocaleWithoutLocaleUpdateInput",
		create:"HomePageLokalLocaleWithoutLocaleCreateInput"
	},
	JobsFormLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutJobsFormsUpdateInput",
		create:"LocaleWithoutJobsFormsCreateInput"
	},
	StickyBarUpsertJobsFormRelationInput:{
		update:"JobsFormLocaleUpdateInput",
		create:"JobsFormLocaleCreateInput"
	},
	JobPageLocaleUpsertStickyBarRelationInput:{
		update:"StickyBarUpdateInput",
		create:"StickyBarCreateInput"
	},
	JobPageLocaleUpdateMobileImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateMobileImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"JobPageLocaleUpsertMobileImageRelationInput"
	},
	JobPageLocaleUpsertMobileImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	LinkableUpsertJobPageRelationInput:{
		update:"JobPageLocaleWithoutLinkUpdateInput",
		create:"JobPageLocaleWithoutLinkCreateInput"
	},
	LinkableUpdateHomePageLokalEntityRelationInput:{
		connect:"HomePageLokalLocaleUniqueWhere",
		create:"HomePageLokalLocaleWithoutLinkCreateInput",
		connectOrCreate:"LinkableConnectOrCreateHomePageLokalRelationInput",
		update:"HomePageLokalLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertHomePageLokalRelationInput"
	},
	HomePageLokalLocaleWithoutLinkUpdateInput:{
		root:"HomePageLokalLocaleUpdateRootEntityRelationInput",
		locale:"HomePageLokalLocaleUpdateLocaleEntityRelationInput",
		logo:"HomePageLokalLocaleUpdateLogoEntityRelationInput",
		button:"HomePageLokalLocaleUpdateButtonEntityRelationInput",
		content:"HomePageLokalLocaleUpdateContentEntityRelationInput",
		seo:"HomePageLokalLocaleUpdateSeoEntityRelationInput",
		siteSwitcher:"HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLokalLocaleUpdateGalleryEntityRelationInput",
		stickyBar:"HomePageLokalLocaleUpdateStickyBarEntityRelationInput",
		ilustration:"HomePageLokalLocaleUpdateIlustrationEntityRelationInput"
	},
	HomePageLokalLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHomePageLokalsCreateInput",
		connectOrCreate:"HomePageLokalLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutHomePageLokalsUpdateInput",
		upsert:"HomePageLokalLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutHomePageLokalsUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	HomePageLokalLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutHomePageLokalsUpdateInput",
		create:"LocaleWithoutHomePageLokalsCreateInput"
	},
	LinkableUpsertHomePageLokalRelationInput:{
		update:"HomePageLokalLocaleWithoutLinkUpdateInput",
		create:"HomePageLokalLocaleWithoutLinkCreateInput"
	},
	HomePageLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutHomePageUpdateInput",
		create:"LinkableWithoutHomePageCreateInput"
	},
	LocaleUpsertHomePagesRelationInput:{
		by:"HomePageLocaleUniqueWhere",
		update:"HomePageLocaleWithoutLocaleUpdateInput",
		create:"HomePageLocaleWithoutLocaleCreateInput"
	},
	JobPageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutJobPagesUpdateInput",
		create:"LocaleWithoutJobPagesCreateInput"
	},
	JobPageLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutJobPageCreateInput",
		connectOrCreate:"JobPageLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutJobPageUpdateInput",
		upsert:"JobPageLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutJobPageUpdateInput:{
		redirect:"LinkableUpdateRedirectEntityRelationInput",
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		businessPage:"LinkableUpdateBusinessPageEntityRelationInput",
		homePage:"LinkableUpdateHomePageEntityRelationInput",
		homePageLokal:"LinkableUpdateHomePageLokalEntityRelationInput"
	},
	JobPageLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutJobPageUpdateInput",
		create:"LinkableWithoutJobPageCreateInput"
	},
	JobPageUpsertLocalesRelationInput:{
		by:"JobPageLocaleUniqueWhere",
		update:"JobPageLocaleWithoutRootUpdateInput",
		create:"JobPageLocaleWithoutRootCreateInput"
	},
	JobPageUpdateJobCityEntityRelationInput:{
		connect:"JobCityUniqueWhere",
		create:"JobCityCreateInput",
		connectOrCreate:"JobPageConnectOrCreateJobCityRelationInput",
		update:"JobCityUpdateInput",
		upsert:"JobPageUpsertJobCityRelationInput"
	},
	JobCityUpdateInput:{
		locales:"JobCityUpdateLocalesEntityRelationInput"
	},
	JobCityUpdateLocalesEntityRelationInput:{
		create:"JobCityLocaleWithoutRootCreateInput",
		update:"JobCityUpdateLocalesRelationInput",
		upsert:"JobCityUpsertLocalesRelationInput",
		connect:"JobCityLocaleUniqueWhere",
		disconnect:"JobCityLocaleUniqueWhere",
		delete:"JobCityLocaleUniqueWhere"
	},
	JobCityUpdateLocalesRelationInput:{
		by:"JobCityLocaleUniqueWhere",
		data:"JobCityLocaleWithoutRootUpdateInput"
	},
	JobCityLocaleWithoutRootUpdateInput:{
		locale:"JobCityLocaleUpdateLocaleEntityRelationInput"
	},
	JobCityLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobCitiesCreateInput",
		connectOrCreate:"JobCityLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutJobCitiesUpdateInput",
		upsert:"JobCityLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutJobCitiesUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	JobCityLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutJobCitiesUpdateInput",
		create:"LocaleWithoutJobCitiesCreateInput"
	},
	JobCityUpsertLocalesRelationInput:{
		by:"JobCityLocaleUniqueWhere",
		update:"JobCityLocaleWithoutRootUpdateInput",
		create:"JobCityLocaleWithoutRootCreateInput"
	},
	JobPageUpsertJobCityRelationInput:{
		update:"JobCityUpdateInput",
		create:"JobCityCreateInput"
	},
	JobPageUpdateBusinessEntityRelationInput:{
		connect:"BusinessPageUniqueWhere",
		create:"BusinessPageCreateInput",
		connectOrCreate:"JobPageConnectOrCreateBusinessRelationInput",
		update:"BusinessPageUpdateInput",
		upsert:"JobPageUpsertBusinessRelationInput"
	},
	BusinessPageUpdateInput:{
		locales:"BusinessPageUpdateLocalesEntityRelationInput",
		theme:"BusinessPageUpdateThemeEntityRelationInput"
	},
	BusinessPageUpdateLocalesEntityRelationInput:{
		create:"BusinessPageLocaleWithoutRootCreateInput",
		update:"BusinessPageUpdateLocalesRelationInput",
		upsert:"BusinessPageUpsertLocalesRelationInput",
		connect:"BusinessPageLocaleUniqueWhere",
		disconnect:"BusinessPageLocaleUniqueWhere",
		delete:"BusinessPageLocaleUniqueWhere"
	},
	BusinessPageUpdateLocalesRelationInput:{
		by:"BusinessPageLocaleUniqueWhere",
		data:"BusinessPageLocaleWithoutRootUpdateInput"
	},
	BusinessPageLocaleWithoutRootUpdateInput:{
		locale:"BusinessPageLocaleUpdateLocaleEntityRelationInput",
		content:"BusinessPageLocaleUpdateContentEntityRelationInput",
		seo:"BusinessPageLocaleUpdateSeoEntityRelationInput",
		link:"BusinessPageLocaleUpdateLinkEntityRelationInput",
		image:"BusinessPageLocaleUpdateImageEntityRelationInput",
		stickyBar:"BusinessPageLocaleUpdateStickyBarEntityRelationInput",
		infoBox:"BusinessPageLocaleUpdateInfoBoxEntityRelationInput"
	},
	BusinessPageLocaleUpdateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateSeoRelationInput",
		update:"SeoUpdateInput",
		upsert:"BusinessPageLocaleUpsertSeoRelationInput"
	},
	BusinessPageLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	BusinessPageLocaleUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutBusinessPageCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutBusinessPageUpdateInput",
		upsert:"BusinessPageLocaleUpsertLinkRelationInput"
	},
	LinkableWithoutBusinessPageUpdateInput:{
		redirect:"LinkableUpdateRedirectEntityRelationInput",
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		jobPage:"LinkableUpdateJobPageEntityRelationInput",
		homePage:"LinkableUpdateHomePageEntityRelationInput",
		homePageLokal:"LinkableUpdateHomePageLokalEntityRelationInput"
	},
	BusinessPageLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutBusinessPageUpdateInput",
		create:"LinkableWithoutBusinessPageCreateInput"
	},
	BusinessPageLocaleUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"BusinessPageLocaleUpsertImageRelationInput"
	},
	BusinessPageLocaleUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	BusinessPageLocaleUpdateStickyBarEntityRelationInput:{
		connect:"StickyBarUniqueWhere",
		create:"StickyBarCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateStickyBarRelationInput",
		update:"StickyBarUpdateInput",
		upsert:"BusinessPageLocaleUpsertStickyBarRelationInput"
	},
	BusinessPageLocaleUpsertStickyBarRelationInput:{
		update:"StickyBarUpdateInput",
		create:"StickyBarCreateInput"
	},
	BusinessPageLocaleUpdateInfoBoxEntityRelationInput:{
		connect:"InfoBoxUniqueWhere",
		create:"InfoBoxCreateInput",
		connectOrCreate:"BusinessPageLocaleConnectOrCreateInfoBoxRelationInput",
		update:"InfoBoxUpdateInput",
		upsert:"BusinessPageLocaleUpsertInfoBoxRelationInput"
	},
	InfoBoxUpdateInput:{
		logoSize:"LogoSize",
		logo:"InfoBoxUpdateLogoEntityRelationInput",
		locales:"InfoBoxUpdateLocalesEntityRelationInput"
	},
	InfoBoxUpdateLocalesEntityRelationInput:{
		create:"InfoBoxLocaleWithoutRootCreateInput",
		update:"InfoBoxUpdateLocalesRelationInput",
		upsert:"InfoBoxUpsertLocalesRelationInput",
		connect:"InfoBoxLocaleUniqueWhere",
		disconnect:"InfoBoxLocaleUniqueWhere",
		delete:"InfoBoxLocaleUniqueWhere"
	},
	InfoBoxUpdateLocalesRelationInput:{
		by:"InfoBoxLocaleUniqueWhere",
		data:"InfoBoxLocaleWithoutRootUpdateInput"
	},
	InfoBoxLocaleWithoutRootUpdateInput:{
		locale:"InfoBoxLocaleUpdateLocaleEntityRelationInput",
		openingHours:"InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"
	},
	InfoBoxLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutInfoBoxesCreateInput",
		connectOrCreate:"InfoBoxLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutInfoBoxesUpdateInput",
		upsert:"InfoBoxLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutInfoBoxesUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	InfoBoxLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutInfoBoxesUpdateInput",
		create:"LocaleWithoutInfoBoxesCreateInput"
	},
	InfoBoxUpsertLocalesRelationInput:{
		by:"InfoBoxLocaleUniqueWhere",
		update:"InfoBoxLocaleWithoutRootUpdateInput",
		create:"InfoBoxLocaleWithoutRootCreateInput"
	},
	BusinessPageLocaleUpsertInfoBoxRelationInput:{
		update:"InfoBoxUpdateInput",
		create:"InfoBoxCreateInput"
	},
	BusinessPageUpsertLocalesRelationInput:{
		by:"BusinessPageLocaleUniqueWhere",
		update:"BusinessPageLocaleWithoutRootUpdateInput",
		create:"BusinessPageLocaleWithoutRootCreateInput"
	},
	JobPageUpsertBusinessRelationInput:{
		update:"BusinessPageUpdateInput",
		create:"BusinessPageCreateInput"
	},
	JobPositionUpsertJobsRelationInput:{
		by:"JobPageUniqueWhere",
		update:"JobPageWithoutJobPositionUpdateInput",
		create:"JobPageWithoutJobPositionCreateInput"
	},
	JobPositionLocaleUpsertRootRelationInput:{
		update:"JobPositionWithoutLocalesUpdateInput",
		create:"JobPositionWithoutLocalesCreateInput"
	},
	LocaleUpsertJobPositionsRelationInput:{
		by:"JobPositionLocaleUniqueWhere",
		update:"JobPositionLocaleWithoutLocaleUpdateInput",
		create:"JobPositionLocaleWithoutLocaleCreateInput"
	},
	ContractTypeLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutContractTypesUpdateInput",
		create:"LocaleWithoutContractTypesCreateInput"
	},
	ContractTypeUpsertLocalesRelationInput:{
		by:"ContractTypeLocaleUniqueWhere",
		update:"ContractTypeLocaleWithoutRootUpdateInput",
		create:"ContractTypeLocaleWithoutRootCreateInput"
	},
	JobPageUpsertContractTypeRelationInput:{
		update:"ContractTypeUpdateInput",
		create:"ContractTypeCreateInput"
	},
	JobPageUpdateJobPositionEntityRelationInput:{
		connect:"JobPositionUniqueWhere",
		create:"JobPositionWithoutJobsCreateInput",
		connectOrCreate:"JobPageConnectOrCreateJobPositionRelationInput",
		update:"JobPositionWithoutJobsUpdateInput",
		upsert:"JobPageUpsertJobPositionRelationInput"
	},
	JobPositionWithoutJobsUpdateInput:{
		locales:"JobPositionUpdateLocalesEntityRelationInput"
	},
	JobPositionUpdateLocalesEntityRelationInput:{
		create:"JobPositionLocaleWithoutRootCreateInput",
		update:"JobPositionUpdateLocalesRelationInput",
		upsert:"JobPositionUpsertLocalesRelationInput",
		connect:"JobPositionLocaleUniqueWhere",
		disconnect:"JobPositionLocaleUniqueWhere",
		delete:"JobPositionLocaleUniqueWhere"
	},
	JobPositionUpdateLocalesRelationInput:{
		by:"JobPositionLocaleUniqueWhere",
		data:"JobPositionLocaleWithoutRootUpdateInput"
	},
	JobPositionLocaleWithoutRootUpdateInput:{
		locale:"JobPositionLocaleUpdateLocaleEntityRelationInput"
	},
	JobPositionLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobPositionsCreateInput",
		connectOrCreate:"JobPositionLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutJobPositionsUpdateInput",
		upsert:"JobPositionLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutJobPositionsUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	JobPositionLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutJobPositionsUpdateInput",
		create:"LocaleWithoutJobPositionsCreateInput"
	},
	JobPositionUpsertLocalesRelationInput:{
		by:"JobPositionLocaleUniqueWhere",
		update:"JobPositionLocaleWithoutRootUpdateInput",
		create:"JobPositionLocaleWithoutRootCreateInput"
	},
	JobPageUpsertJobPositionRelationInput:{
		update:"JobPositionWithoutJobsUpdateInput",
		create:"JobPositionWithoutJobsCreateInput"
	},
	JobPageLocaleUpsertRootRelationInput:{
		update:"JobPageWithoutLocalesUpdateInput",
		create:"JobPageWithoutLocalesCreateInput"
	},
	LocaleUpsertJobPagesRelationInput:{
		by:"JobPageLocaleUniqueWhere",
		update:"JobPageLocaleWithoutLocaleUpdateInput",
		create:"JobPageLocaleWithoutLocaleCreateInput"
	},
	BusinessPageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutBusinessPagesUpdateInput",
		create:"LocaleWithoutBusinessPagesCreateInput"
	},
	LinkableUpsertBusinessPageRelationInput:{
		update:"BusinessPageLocaleWithoutLinkUpdateInput",
		create:"BusinessPageLocaleWithoutLinkCreateInput"
	},
	GenericPageLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutGenericPageUpdateInput",
		create:"LinkableWithoutGenericPageCreateInput"
	},
	GenericPageLocaleUpdateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateLogoRelationInput",
		update:"ImageUpdateInput",
		upsert:"GenericPageLocaleUpsertLogoRelationInput"
	},
	GenericPageLocaleUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	GenericPageLocaleUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"GenericPageLocaleConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"GenericPageLocaleUpsertImageRelationInput"
	},
	GenericPageLocaleUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	LocaleUpsertGenericPagesRelationInput:{
		by:"GenericPageLocaleUniqueWhere",
		update:"GenericPageLocaleWithoutLocaleUpdateInput",
		create:"GenericPageLocaleWithoutLocaleCreateInput"
	},
	BonusBannerLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutBonusBannersUpdateInput",
		create:"LocaleWithoutBonusBannersCreateInput"
	},
	ContentReferenceUpsertBonusBannerRelationInput:{
		update:"BonusBannerLocaleUpdateInput",
		create:"BonusBannerLocaleCreateInput"
	},
	ContentReferenceUpdateSideBySideEntityRelationInput:{
		connect:"SideBySideUniqueWhere",
		create:"SideBySideCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateSideBySideRelationInput",
		update:"SideBySideUpdateInput",
		upsert:"ContentReferenceUpsertSideBySideRelationInput"
	},
	SideBySideUpdateInput:{
		items:"SideBySideUpdateItemsEntityRelationInput",
		background:"Background",
		alignment:"ContentAlignment",
		mediumSize:"MediumSize"
	},
	SideBySideUpdateItemsEntityRelationInput:{
		create:"SideBySideItemWithoutListCreateInput",
		update:"SideBySideUpdateItemsRelationInput",
		upsert:"SideBySideUpsertItemsRelationInput",
		connect:"SideBySideItemUniqueWhere",
		disconnect:"SideBySideItemUniqueWhere",
		delete:"SideBySideItemUniqueWhere"
	},
	SideBySideUpdateItemsRelationInput:{
		by:"SideBySideItemUniqueWhere",
		data:"SideBySideItemWithoutListUpdateInput"
	},
	SideBySideItemWithoutListUpdateInput:{
		media:"SideBySideItemUpdateMediaEntityRelationInput",
		type:"SideBySideItemType",
		link:"SideBySideItemUpdateLinkEntityRelationInput",
		jobsForm:"SideBySideItemUpdateJobsFormEntityRelationInput"
	},
	SideBySideItemUpdateMediaEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListCreateInput",
		connectOrCreate:"SideBySideItemConnectOrCreateMediaRelationInput",
		update:"MediumListUpdateInput",
		upsert:"SideBySideItemUpsertMediaRelationInput"
	},
	SideBySideItemUpsertMediaRelationInput:{
		update:"MediumListUpdateInput",
		create:"MediumListCreateInput"
	},
	SideBySideItemUpdateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"SideBySideItemConnectOrCreateLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"SideBySideItemUpsertLinkRelationInput"
	},
	SideBySideItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	SideBySideItemUpdateJobsFormEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput",
		connectOrCreate:"SideBySideItemConnectOrCreateJobsFormRelationInput",
		update:"JobsFormLocaleUpdateInput",
		upsert:"SideBySideItemUpsertJobsFormRelationInput"
	},
	SideBySideItemUpsertJobsFormRelationInput:{
		update:"JobsFormLocaleUpdateInput",
		create:"JobsFormLocaleCreateInput"
	},
	SideBySideUpsertItemsRelationInput:{
		by:"SideBySideItemUniqueWhere",
		update:"SideBySideItemWithoutListUpdateInput",
		create:"SideBySideItemWithoutListCreateInput"
	},
	ContentReferenceUpsertSideBySideRelationInput:{
		update:"SideBySideUpdateInput",
		create:"SideBySideCreateInput"
	},
	ContentReferenceUpdateGalleryEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateGalleryRelationInput",
		update:"GalleryUpdateInput",
		upsert:"ContentReferenceUpsertGalleryRelationInput"
	},
	ContentReferenceUpsertGalleryRelationInput:{
		update:"GalleryUpdateInput",
		create:"GalleryCreateInput"
	},
	ContentReferenceUpdateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateVideoRelationInput",
		update:"VideoUpdateInput",
		upsert:"ContentReferenceUpsertVideoRelationInput"
	},
	ContentReferenceUpsertVideoRelationInput:{
		update:"VideoUpdateInput",
		create:"VideoCreateInput"
	},
	ContentBlockUpsertReferencesRelationInput:{
		by:"ContentReferenceUniqueWhere",
		update:"ContentReferenceWithoutBlockUpdateInput",
		create:"ContentReferenceWithoutBlockCreateInput"
	},
	ContentUpsertBlocksRelationInput:{
		by:"ContentBlockUniqueWhere",
		update:"ContentBlockWithoutContentUpdateInput",
		create:"ContentBlockWithoutContentCreateInput"
	},
	BusinessPageLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	LocaleUpsertBusinessPagesRelationInput:{
		by:"BusinessPageLocaleUniqueWhere",
		update:"BusinessPageLocaleWithoutLocaleUpdateInput",
		create:"BusinessPageLocaleWithoutLocaleCreateInput"
	},
	GenericPageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutGenericPagesUpdateInput",
		create:"LocaleWithoutGenericPagesCreateInput"
	},
	LinkableUpsertGenericPageRelationInput:{
		update:"GenericPageLocaleWithoutLinkUpdateInput",
		create:"GenericPageLocaleWithoutLinkCreateInput"
	},
	LinkUpsertInternalLinkRelationInput:{
		update:"LinkableUpdateInput",
		create:"LinkableCreateInput"
	},
	FooterLinkUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	FooterLocaleUpsertLinksFirstColumnRelationInput:{
		by:"FooterLinkUniqueWhere",
		update:"FooterLinkUpdateInput",
		create:"FooterLinkCreateInput"
	},
	FooterLocaleUpdateLinksSecondColumnEntityRelationInput:{
		create:"FooterLinkCreateInput",
		update:"FooterLocaleUpdateLinksSecondColumnRelationInput",
		upsert:"FooterLocaleUpsertLinksSecondColumnRelationInput",
		connect:"FooterLinkUniqueWhere",
		disconnect:"FooterLinkUniqueWhere",
		delete:"FooterLinkUniqueWhere"
	},
	FooterLocaleUpdateLinksSecondColumnRelationInput:{
		by:"FooterLinkUniqueWhere",
		data:"FooterLinkUpdateInput"
	},
	FooterLocaleUpsertLinksSecondColumnRelationInput:{
		by:"FooterLinkUniqueWhere",
		update:"FooterLinkUpdateInput",
		create:"FooterLinkCreateInput"
	},
	FooterLocaleUpdateTermsAndConditionsEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateTermsAndConditionsRelationInput",
		update:"LinkUpdateInput",
		upsert:"FooterLocaleUpsertTermsAndConditionsRelationInput"
	},
	FooterLocaleUpsertTermsAndConditionsRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	FooterLocaleUpdateBannerImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateBannerImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"FooterLocaleUpsertBannerImageRelationInput"
	},
	FooterLocaleUpsertBannerImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	FooterLocaleUpdateBannerLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateBannerLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"FooterLocaleUpsertBannerLinkRelationInput"
	},
	FooterLocaleUpsertBannerLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	FooterLocaleUpdateJobsFormEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateJobsFormRelationInput",
		update:"JobsFormLocaleUpdateInput",
		upsert:"FooterLocaleUpsertJobsFormRelationInput"
	},
	FooterLocaleUpsertJobsFormRelationInput:{
		update:"JobsFormLocaleUpdateInput",
		create:"JobsFormLocaleCreateInput"
	},
	FooterLocaleUpdateCopyrightLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateCopyrightLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"FooterLocaleUpsertCopyrightLinkRelationInput"
	},
	FooterLocaleUpsertCopyrightLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	FooterLocaleUpdateRecommendationFormEntityRelationInput:{
		connect:"RecommendationFormLocaleUniqueWhere",
		create:"RecommendationFormLocaleCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateRecommendationFormRelationInput",
		update:"RecommendationFormLocaleUpdateInput",
		upsert:"FooterLocaleUpsertRecommendationFormRelationInput"
	},
	RecommendationFormLocaleUpdateInput:{
		root:"RecommendationFormLocaleUpdateRootEntityRelationInput",
		locale:"RecommendationFormLocaleUpdateLocaleEntityRelationInput"
	},
	RecommendationFormLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutRecommendationFormsCreateInput",
		connectOrCreate:"RecommendationFormLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutRecommendationFormsUpdateInput",
		upsert:"RecommendationFormLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutRecommendationFormsUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	RecommendationFormLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutRecommendationFormsUpdateInput",
		create:"LocaleWithoutRecommendationFormsCreateInput"
	},
	FooterLocaleUpsertRecommendationFormRelationInput:{
		update:"RecommendationFormLocaleUpdateInput",
		create:"RecommendationFormLocaleCreateInput"
	},
	FooterLocaleUpdateBannerSecondLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateBannerSecondLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"FooterLocaleUpsertBannerSecondLinkRelationInput"
	},
	FooterLocaleUpsertBannerSecondLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	FooterLocaleUpdateInstagramLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateInstagramLinkRelationInput",
		update:"LinkUpdateInput",
		upsert:"FooterLocaleUpsertInstagramLinkRelationInput"
	},
	FooterLocaleUpsertInstagramLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	LocaleUpsertFootersRelationInput:{
		by:"FooterLocaleUniqueWhere",
		update:"FooterLocaleWithoutLocaleUpdateInput",
		create:"FooterLocaleWithoutLocaleCreateInput"
	},
	GeneralLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutGeneralUpdateInput",
		create:"LocaleWithoutGeneralCreateInput"
	},
	GeneralUpsertLocalesRelationInput:{
		by:"GeneralLocaleUniqueWhere",
		update:"GeneralLocaleWithoutRootUpdateInput",
		create:"GeneralLocaleWithoutRootCreateInput"
	},
	GenericPageCreateInput:{
		id:"UUID",
		locales:"GenericPageCreateLocalesEntityRelationInput",
		theme:"GenericPageCreateThemeEntityRelationInput"
	},
	GenericPageCreateLocalesEntityRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutRootCreateInput",
		connectOrCreate:"GenericPageConnectOrCreateLocalesRelationInput"
	},
	GenericPageLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"GenericPageLocaleCreateLocaleEntityRelationInput",
		content:"GenericPageLocaleCreateContentEntityRelationInput",
		seo:"GenericPageLocaleCreateSeoEntityRelationInput",
		link:"GenericPageLocaleCreateLinkEntityRelationInput",
		logo:"GenericPageLocaleCreateLogoEntityRelationInput",
		image:"GenericPageLocaleCreateImageEntityRelationInput"
	},
	GenericPageConnectOrCreateLocalesRelationInput:{
		connect:"GenericPageLocaleUniqueWhere",
		create:"GenericPageLocaleWithoutRootCreateInput"
	},
	GenericPageUpdateInput:{
		locales:"GenericPageUpdateLocalesEntityRelationInput",
		theme:"GenericPageUpdateThemeEntityRelationInput"
	},
	GenericPageUpdateLocalesEntityRelationInput:{
		create:"GenericPageLocaleWithoutRootCreateInput",
		update:"GenericPageUpdateLocalesRelationInput",
		upsert:"GenericPageUpsertLocalesRelationInput",
		connect:"GenericPageLocaleUniqueWhere",
		disconnect:"GenericPageLocaleUniqueWhere",
		delete:"GenericPageLocaleUniqueWhere"
	},
	GenericPageUpdateLocalesRelationInput:{
		by:"GenericPageLocaleUniqueWhere",
		data:"GenericPageLocaleWithoutRootUpdateInput"
	},
	GenericPageLocaleWithoutRootUpdateInput:{
		locale:"GenericPageLocaleUpdateLocaleEntityRelationInput",
		content:"GenericPageLocaleUpdateContentEntityRelationInput",
		seo:"GenericPageLocaleUpdateSeoEntityRelationInput",
		link:"GenericPageLocaleUpdateLinkEntityRelationInput",
		logo:"GenericPageLocaleUpdateLogoEntityRelationInput",
		image:"GenericPageLocaleUpdateImageEntityRelationInput"
	},
	GenericPageUpsertLocalesRelationInput:{
		by:"GenericPageLocaleUniqueWhere",
		update:"GenericPageLocaleWithoutRootUpdateInput",
		create:"GenericPageLocaleWithoutRootCreateInput"
	},
	ContentBlockCreateInput:{
		id:"UUID",
		content:"ContentBlockCreateContentEntityRelationInput",
		references:"ContentBlockCreateReferencesEntityRelationInput"
	},
	ContentBlockCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentWithoutBlocksCreateInput",
		connectOrCreate:"ContentBlockConnectOrCreateContentRelationInput"
	},
	ContentWithoutBlocksCreateInput:{
		id:"UUID"
	},
	ContentBlockConnectOrCreateContentRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentWithoutBlocksCreateInput"
	},
	ContentBlockUpdateInput:{
		content:"ContentBlockUpdateContentEntityRelationInput",
		references:"ContentBlockUpdateReferencesEntityRelationInput"
	},
	ContentBlockUpdateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentWithoutBlocksCreateInput",
		connectOrCreate:"ContentBlockConnectOrCreateContentRelationInput",
		update:"ContentWithoutBlocksUpdateInput",
		upsert:"ContentBlockUpsertContentRelationInput"
	},
	ContentWithoutBlocksUpdateInput:{

	},
	ContentBlockUpsertContentRelationInput:{
		update:"ContentWithoutBlocksUpdateInput",
		create:"ContentWithoutBlocksCreateInput"
	},
	ContentReferenceCreateInput:{
		id:"UUID",
		type:"ContentReferenceType",
		block:"ContentReferenceCreateBlockEntityRelationInput",
		image:"ContentReferenceCreateImageEntityRelationInput",
		linkables:"ContentReferenceCreateLinkablesEntityRelationInput",
		link:"ContentReferenceCreateLinkEntityRelationInput",
		media:"ContentReferenceCreateMediaEntityRelationInput",
		textList:"ContentReferenceCreateTextListEntityRelationInput",
		carousel:"ContentReferenceCreateCarouselEntityRelationInput",
		bonusBanner:"ContentReferenceCreateBonusBannerEntityRelationInput",
		sideBySide:"ContentReferenceCreateSideBySideEntityRelationInput",
		gallery:"ContentReferenceCreateGalleryEntityRelationInput",
		video:"ContentReferenceCreateVideoEntityRelationInput"
	},
	ContentReferenceCreateBlockEntityRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutReferencesCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateBlockRelationInput"
	},
	ContentBlockWithoutReferencesCreateInput:{
		id:"UUID",
		content:"ContentBlockCreateContentEntityRelationInput"
	},
	ContentReferenceConnectOrCreateBlockRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutReferencesCreateInput"
	},
	ContentReferenceUpdateInput:{
		type:"ContentReferenceType",
		block:"ContentReferenceUpdateBlockEntityRelationInput",
		image:"ContentReferenceUpdateImageEntityRelationInput",
		linkables:"ContentReferenceUpdateLinkablesEntityRelationInput",
		link:"ContentReferenceUpdateLinkEntityRelationInput",
		media:"ContentReferenceUpdateMediaEntityRelationInput",
		textList:"ContentReferenceUpdateTextListEntityRelationInput",
		carousel:"ContentReferenceUpdateCarouselEntityRelationInput",
		bonusBanner:"ContentReferenceUpdateBonusBannerEntityRelationInput",
		sideBySide:"ContentReferenceUpdateSideBySideEntityRelationInput",
		gallery:"ContentReferenceUpdateGalleryEntityRelationInput",
		video:"ContentReferenceUpdateVideoEntityRelationInput"
	},
	ContentReferenceUpdateBlockEntityRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutReferencesCreateInput",
		connectOrCreate:"ContentReferenceConnectOrCreateBlockRelationInput",
		update:"ContentBlockWithoutReferencesUpdateInput",
		upsert:"ContentReferenceUpsertBlockRelationInput"
	},
	ContentBlockWithoutReferencesUpdateInput:{
		content:"ContentBlockUpdateContentEntityRelationInput"
	},
	ContentReferenceUpsertBlockRelationInput:{
		update:"ContentBlockWithoutReferencesUpdateInput",
		create:"ContentBlockWithoutReferencesCreateInput"
	},
	RedirectCreateInput:{
		id:"UUID",
		link:"RedirectCreateLinkEntityRelationInput",
		target:"RedirectCreateTargetEntityRelationInput"
	},
	RedirectCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutRedirectCreateInput",
		connectOrCreate:"RedirectConnectOrCreateLinkRelationInput"
	},
	LinkableWithoutRedirectCreateInput:{
		id:"UUID",
		genericPage:"LinkableCreateGenericPageEntityRelationInput",
		businessPage:"LinkableCreateBusinessPageEntityRelationInput",
		jobPage:"LinkableCreateJobPageEntityRelationInput",
		homePage:"LinkableCreateHomePageEntityRelationInput",
		homePageLokal:"LinkableCreateHomePageLokalEntityRelationInput"
	},
	RedirectConnectOrCreateLinkRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutRedirectCreateInput"
	},
	RedirectUpdateInput:{
		link:"RedirectUpdateLinkEntityRelationInput",
		target:"RedirectUpdateTargetEntityRelationInput"
	},
	RedirectUpdateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutRedirectCreateInput",
		connectOrCreate:"RedirectConnectOrCreateLinkRelationInput",
		update:"LinkableWithoutRedirectUpdateInput",
		upsert:"RedirectUpsertLinkRelationInput"
	},
	LinkableWithoutRedirectUpdateInput:{
		genericPage:"LinkableUpdateGenericPageEntityRelationInput",
		businessPage:"LinkableUpdateBusinessPageEntityRelationInput",
		jobPage:"LinkableUpdateJobPageEntityRelationInput",
		homePage:"LinkableUpdateHomePageEntityRelationInput",
		homePageLokal:"LinkableUpdateHomePageLokalEntityRelationInput"
	},
	RedirectUpsertLinkRelationInput:{
		update:"LinkableWithoutRedirectUpdateInput",
		create:"LinkableWithoutRedirectCreateInput"
	},
	FooterCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"FooterCreateLocalesEntityRelationInput"
	},
	FooterCreateLocalesEntityRelationInput:{
		connect:"FooterLocaleUniqueWhere",
		create:"FooterLocaleWithoutRootCreateInput",
		connectOrCreate:"FooterConnectOrCreateLocalesRelationInput"
	},
	FooterLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"FooterLocaleCreateLocaleEntityRelationInput",
		linksFirstColumn:"FooterLocaleCreateLinksFirstColumnEntityRelationInput",
		linksSecondColumn:"FooterLocaleCreateLinksSecondColumnEntityRelationInput",
		termsAndConditions:"FooterLocaleCreateTermsAndConditionsEntityRelationInput",
		bannerImage:"FooterLocaleCreateBannerImageEntityRelationInput",
		bannerLink:"FooterLocaleCreateBannerLinkEntityRelationInput",
		jobsForm:"FooterLocaleCreateJobsFormEntityRelationInput",
		copyrightLink:"FooterLocaleCreateCopyrightLinkEntityRelationInput",
		recommendationForm:"FooterLocaleCreateRecommendationFormEntityRelationInput",
		bannerSecondLink:"FooterLocaleCreateBannerSecondLinkEntityRelationInput",
		instagramLink:"FooterLocaleCreateInstagramLinkEntityRelationInput"
	},
	FooterLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutFootersCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutFootersCreateInput:{
		id:"UUID",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	FooterLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutFootersCreateInput"
	},
	FooterConnectOrCreateLocalesRelationInput:{
		connect:"FooterLocaleUniqueWhere",
		create:"FooterLocaleWithoutRootCreateInput"
	},
	FooterUpdateInput:{
		unique:"One",
		locales:"FooterUpdateLocalesEntityRelationInput"
	},
	FooterUpdateLocalesEntityRelationInput:{
		create:"FooterLocaleWithoutRootCreateInput",
		update:"FooterUpdateLocalesRelationInput",
		upsert:"FooterUpsertLocalesRelationInput",
		connect:"FooterLocaleUniqueWhere",
		disconnect:"FooterLocaleUniqueWhere",
		delete:"FooterLocaleUniqueWhere"
	},
	FooterUpdateLocalesRelationInput:{
		by:"FooterLocaleUniqueWhere",
		data:"FooterLocaleWithoutRootUpdateInput"
	},
	FooterLocaleWithoutRootUpdateInput:{
		locale:"FooterLocaleUpdateLocaleEntityRelationInput",
		linksFirstColumn:"FooterLocaleUpdateLinksFirstColumnEntityRelationInput",
		linksSecondColumn:"FooterLocaleUpdateLinksSecondColumnEntityRelationInput",
		termsAndConditions:"FooterLocaleUpdateTermsAndConditionsEntityRelationInput",
		bannerImage:"FooterLocaleUpdateBannerImageEntityRelationInput",
		bannerLink:"FooterLocaleUpdateBannerLinkEntityRelationInput",
		jobsForm:"FooterLocaleUpdateJobsFormEntityRelationInput",
		copyrightLink:"FooterLocaleUpdateCopyrightLinkEntityRelationInput",
		recommendationForm:"FooterLocaleUpdateRecommendationFormEntityRelationInput",
		bannerSecondLink:"FooterLocaleUpdateBannerSecondLinkEntityRelationInput",
		instagramLink:"FooterLocaleUpdateInstagramLinkEntityRelationInput"
	},
	FooterLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutFootersCreateInput",
		connectOrCreate:"FooterLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutFootersUpdateInput",
		upsert:"FooterLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutFootersUpdateInput:{
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	FooterLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutFootersUpdateInput",
		create:"LocaleWithoutFootersCreateInput"
	},
	FooterUpsertLocalesRelationInput:{
		by:"FooterLocaleUniqueWhere",
		update:"FooterLocaleWithoutRootUpdateInput",
		create:"FooterLocaleWithoutRootCreateInput"
	},
	FooterLocaleCreateInput:{
		id:"UUID",
		root:"FooterLocaleCreateRootEntityRelationInput",
		locale:"FooterLocaleCreateLocaleEntityRelationInput",
		linksFirstColumn:"FooterLocaleCreateLinksFirstColumnEntityRelationInput",
		linksSecondColumn:"FooterLocaleCreateLinksSecondColumnEntityRelationInput",
		termsAndConditions:"FooterLocaleCreateTermsAndConditionsEntityRelationInput",
		bannerImage:"FooterLocaleCreateBannerImageEntityRelationInput",
		bannerLink:"FooterLocaleCreateBannerLinkEntityRelationInput",
		jobsForm:"FooterLocaleCreateJobsFormEntityRelationInput",
		copyrightLink:"FooterLocaleCreateCopyrightLinkEntityRelationInput",
		recommendationForm:"FooterLocaleCreateRecommendationFormEntityRelationInput",
		bannerSecondLink:"FooterLocaleCreateBannerSecondLinkEntityRelationInput",
		instagramLink:"FooterLocaleCreateInstagramLinkEntityRelationInput"
	},
	FooterLocaleUpdateInput:{
		root:"FooterLocaleUpdateRootEntityRelationInput",
		locale:"FooterLocaleUpdateLocaleEntityRelationInput",
		linksFirstColumn:"FooterLocaleUpdateLinksFirstColumnEntityRelationInput",
		linksSecondColumn:"FooterLocaleUpdateLinksSecondColumnEntityRelationInput",
		termsAndConditions:"FooterLocaleUpdateTermsAndConditionsEntityRelationInput",
		bannerImage:"FooterLocaleUpdateBannerImageEntityRelationInput",
		bannerLink:"FooterLocaleUpdateBannerLinkEntityRelationInput",
		jobsForm:"FooterLocaleUpdateJobsFormEntityRelationInput",
		copyrightLink:"FooterLocaleUpdateCopyrightLinkEntityRelationInput",
		recommendationForm:"FooterLocaleUpdateRecommendationFormEntityRelationInput",
		bannerSecondLink:"FooterLocaleUpdateBannerSecondLinkEntityRelationInput",
		instagramLink:"FooterLocaleUpdateInstagramLinkEntityRelationInput"
	},
	GenericPageLocaleCreateInput:{
		id:"UUID",
		root:"GenericPageLocaleCreateRootEntityRelationInput",
		locale:"GenericPageLocaleCreateLocaleEntityRelationInput",
		content:"GenericPageLocaleCreateContentEntityRelationInput",
		seo:"GenericPageLocaleCreateSeoEntityRelationInput",
		link:"GenericPageLocaleCreateLinkEntityRelationInput",
		logo:"GenericPageLocaleCreateLogoEntityRelationInput",
		image:"GenericPageLocaleCreateImageEntityRelationInput"
	},
	GenericPageLocaleUpdateInput:{
		root:"GenericPageLocaleUpdateRootEntityRelationInput",
		locale:"GenericPageLocaleUpdateLocaleEntityRelationInput",
		content:"GenericPageLocaleUpdateContentEntityRelationInput",
		seo:"GenericPageLocaleUpdateSeoEntityRelationInput",
		link:"GenericPageLocaleUpdateLinkEntityRelationInput",
		logo:"GenericPageLocaleUpdateLogoEntityRelationInput",
		image:"GenericPageLocaleUpdateImageEntityRelationInput"
	},
	HeaderCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"HeaderCreateLocalesEntityRelationInput",
		logo:"HeaderCreateLogoEntityRelationInput",
		logoMenu:"HeaderCreateLogoMenuEntityRelationInput"
	},
	HeaderCreateLocalesEntityRelationInput:{
		connect:"HeaderLocaleUniqueWhere",
		create:"HeaderLocaleWithoutRootCreateInput",
		connectOrCreate:"HeaderConnectOrCreateLocalesRelationInput"
	},
	HeaderLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"HeaderLocaleCreateLocaleEntityRelationInput",
		business:"HeaderLocaleCreateBusinessEntityRelationInput",
		lokalEnterprise:"HeaderLocaleCreateLokalEnterpriseEntityRelationInput",
		businessLink:"HeaderLocaleCreateBusinessLinkEntityRelationInput",
		lokalLink:"HeaderLocaleCreateLokalLinkEntityRelationInput"
	},
	HeaderLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHeadersCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutHeadersCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	HeaderLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHeadersCreateInput"
	},
	HeaderConnectOrCreateLocalesRelationInput:{
		connect:"HeaderLocaleUniqueWhere",
		create:"HeaderLocaleWithoutRootCreateInput"
	},
	HeaderUpdateInput:{
		unique:"One",
		locales:"HeaderUpdateLocalesEntityRelationInput",
		logo:"HeaderUpdateLogoEntityRelationInput",
		logoMenu:"HeaderUpdateLogoMenuEntityRelationInput"
	},
	HeaderUpdateLocalesEntityRelationInput:{
		create:"HeaderLocaleWithoutRootCreateInput",
		update:"HeaderUpdateLocalesRelationInput",
		upsert:"HeaderUpsertLocalesRelationInput",
		connect:"HeaderLocaleUniqueWhere",
		disconnect:"HeaderLocaleUniqueWhere",
		delete:"HeaderLocaleUniqueWhere"
	},
	HeaderUpdateLocalesRelationInput:{
		by:"HeaderLocaleUniqueWhere",
		data:"HeaderLocaleWithoutRootUpdateInput"
	},
	HeaderLocaleWithoutRootUpdateInput:{
		locale:"HeaderLocaleUpdateLocaleEntityRelationInput",
		business:"HeaderLocaleUpdateBusinessEntityRelationInput",
		lokalEnterprise:"HeaderLocaleUpdateLokalEnterpriseEntityRelationInput",
		businessLink:"HeaderLocaleUpdateBusinessLinkEntityRelationInput",
		lokalLink:"HeaderLocaleUpdateLokalLinkEntityRelationInput"
	},
	HeaderLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutHeadersCreateInput",
		connectOrCreate:"HeaderLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutHeadersUpdateInput",
		upsert:"HeaderLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutHeadersUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	HeaderLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutHeadersUpdateInput",
		create:"LocaleWithoutHeadersCreateInput"
	},
	HeaderUpsertLocalesRelationInput:{
		by:"HeaderLocaleUniqueWhere",
		update:"HeaderLocaleWithoutRootUpdateInput",
		create:"HeaderLocaleWithoutRootCreateInput"
	},
	HeaderLocaleCreateInput:{
		id:"UUID",
		root:"HeaderLocaleCreateRootEntityRelationInput",
		locale:"HeaderLocaleCreateLocaleEntityRelationInput",
		business:"HeaderLocaleCreateBusinessEntityRelationInput",
		lokalEnterprise:"HeaderLocaleCreateLokalEnterpriseEntityRelationInput",
		businessLink:"HeaderLocaleCreateBusinessLinkEntityRelationInput",
		lokalLink:"HeaderLocaleCreateLokalLinkEntityRelationInput"
	},
	HeaderLocaleUpdateInput:{
		root:"HeaderLocaleUpdateRootEntityRelationInput",
		locale:"HeaderLocaleUpdateLocaleEntityRelationInput",
		business:"HeaderLocaleUpdateBusinessEntityRelationInput",
		lokalEnterprise:"HeaderLocaleUpdateLokalEnterpriseEntityRelationInput",
		businessLink:"HeaderLocaleUpdateBusinessLinkEntityRelationInput",
		lokalLink:"HeaderLocaleUpdateLokalLinkEntityRelationInput"
	},
	LocaleCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	LocaleUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	SeoDefaultCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"SeoDefaultCreateLocalesEntityRelationInput"
	},
	SeoDefaultCreateLocalesEntityRelationInput:{
		connect:"SeoDefaultLocaleUniqueWhere",
		create:"SeoDefaultLocaleWithoutRootCreateInput",
		connectOrCreate:"SeoDefaultConnectOrCreateLocalesRelationInput"
	},
	SeoDefaultLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"SeoDefaultLocaleCreateLocaleEntityRelationInput",
		seo:"SeoDefaultLocaleCreateSeoEntityRelationInput"
	},
	SeoDefaultLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutSeoDefaultsCreateInput",
		connectOrCreate:"SeoDefaultLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutSeoDefaultsCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	SeoDefaultLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutSeoDefaultsCreateInput"
	},
	SeoDefaultConnectOrCreateLocalesRelationInput:{
		connect:"SeoDefaultLocaleUniqueWhere",
		create:"SeoDefaultLocaleWithoutRootCreateInput"
	},
	SeoDefaultUpdateInput:{
		unique:"One",
		locales:"SeoDefaultUpdateLocalesEntityRelationInput"
	},
	SeoDefaultUpdateLocalesEntityRelationInput:{
		create:"SeoDefaultLocaleWithoutRootCreateInput",
		update:"SeoDefaultUpdateLocalesRelationInput",
		upsert:"SeoDefaultUpsertLocalesRelationInput",
		connect:"SeoDefaultLocaleUniqueWhere",
		disconnect:"SeoDefaultLocaleUniqueWhere",
		delete:"SeoDefaultLocaleUniqueWhere"
	},
	SeoDefaultUpdateLocalesRelationInput:{
		by:"SeoDefaultLocaleUniqueWhere",
		data:"SeoDefaultLocaleWithoutRootUpdateInput"
	},
	SeoDefaultLocaleWithoutRootUpdateInput:{
		locale:"SeoDefaultLocaleUpdateLocaleEntityRelationInput",
		seo:"SeoDefaultLocaleUpdateSeoEntityRelationInput"
	},
	SeoDefaultLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutSeoDefaultsCreateInput",
		connectOrCreate:"SeoDefaultLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutSeoDefaultsUpdateInput",
		upsert:"SeoDefaultLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutSeoDefaultsUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	SeoDefaultLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutSeoDefaultsUpdateInput",
		create:"LocaleWithoutSeoDefaultsCreateInput"
	},
	SeoDefaultUpsertLocalesRelationInput:{
		by:"SeoDefaultLocaleUniqueWhere",
		update:"SeoDefaultLocaleWithoutRootUpdateInput",
		create:"SeoDefaultLocaleWithoutRootCreateInput"
	},
	SeoDefaultLocaleCreateInput:{
		id:"UUID",
		root:"SeoDefaultLocaleCreateRootEntityRelationInput",
		locale:"SeoDefaultLocaleCreateLocaleEntityRelationInput",
		seo:"SeoDefaultLocaleCreateSeoEntityRelationInput"
	},
	SeoDefaultLocaleUpdateInput:{
		root:"SeoDefaultLocaleUpdateRootEntityRelationInput",
		locale:"SeoDefaultLocaleUpdateLocaleEntityRelationInput",
		seo:"SeoDefaultLocaleUpdateSeoEntityRelationInput"
	},
	BusinessPageLocaleCreateInput:{
		id:"UUID",
		root:"BusinessPageLocaleCreateRootEntityRelationInput",
		locale:"BusinessPageLocaleCreateLocaleEntityRelationInput",
		content:"BusinessPageLocaleCreateContentEntityRelationInput",
		seo:"BusinessPageLocaleCreateSeoEntityRelationInput",
		link:"BusinessPageLocaleCreateLinkEntityRelationInput",
		image:"BusinessPageLocaleCreateImageEntityRelationInput",
		stickyBar:"BusinessPageLocaleCreateStickyBarEntityRelationInput",
		infoBox:"BusinessPageLocaleCreateInfoBoxEntityRelationInput"
	},
	BusinessPageLocaleUpdateInput:{
		root:"BusinessPageLocaleUpdateRootEntityRelationInput",
		locale:"BusinessPageLocaleUpdateLocaleEntityRelationInput",
		content:"BusinessPageLocaleUpdateContentEntityRelationInput",
		seo:"BusinessPageLocaleUpdateSeoEntityRelationInput",
		link:"BusinessPageLocaleUpdateLinkEntityRelationInput",
		image:"BusinessPageLocaleUpdateImageEntityRelationInput",
		stickyBar:"BusinessPageLocaleUpdateStickyBarEntityRelationInput",
		infoBox:"BusinessPageLocaleUpdateInfoBoxEntityRelationInput"
	},
	JobPageCreateInput:{
		id:"UUID",
		locales:"JobPageCreateLocalesEntityRelationInput",
		theme:"JobPageCreateThemeEntityRelationInput",
		contractType:"JobPageCreateContractTypeEntityRelationInput",
		jobCity:"JobPageCreateJobCityEntityRelationInput",
		jobPosition:"JobPageCreateJobPositionEntityRelationInput",
		publishedAt:"DateTime",
		business:"JobPageCreateBusinessEntityRelationInput",
		siteType:"SiteType"
	},
	JobPageUpdateInput:{
		locales:"JobPageUpdateLocalesEntityRelationInput",
		theme:"JobPageUpdateThemeEntityRelationInput",
		contractType:"JobPageUpdateContractTypeEntityRelationInput",
		jobCity:"JobPageUpdateJobCityEntityRelationInput",
		jobPosition:"JobPageUpdateJobPositionEntityRelationInput",
		publishedAt:"DateTime",
		business:"JobPageUpdateBusinessEntityRelationInput",
		siteType:"SiteType"
	},
	JobPageLocaleCreateInput:{
		id:"UUID",
		root:"JobPageLocaleCreateRootEntityRelationInput",
		locale:"JobPageLocaleCreateLocaleEntityRelationInput",
		image:"JobPageLocaleCreateImageEntityRelationInput",
		keyInfo:"JobPageLocaleCreateKeyInfoEntityRelationInput",
		content:"JobPageLocaleCreateContentEntityRelationInput",
		seo:"JobPageLocaleCreateSeoEntityRelationInput",
		link:"JobPageLocaleCreateLinkEntityRelationInput",
		stickyBar:"JobPageLocaleCreateStickyBarEntityRelationInput",
		mobileImage:"JobPageLocaleCreateMobileImageEntityRelationInput"
	},
	JobPageLocaleUpdateInput:{
		root:"JobPageLocaleUpdateRootEntityRelationInput",
		locale:"JobPageLocaleUpdateLocaleEntityRelationInput",
		image:"JobPageLocaleUpdateImageEntityRelationInput",
		keyInfo:"JobPageLocaleUpdateKeyInfoEntityRelationInput",
		content:"JobPageLocaleUpdateContentEntityRelationInput",
		seo:"JobPageLocaleUpdateSeoEntityRelationInput",
		link:"JobPageLocaleUpdateLinkEntityRelationInput",
		stickyBar:"JobPageLocaleUpdateStickyBarEntityRelationInput",
		mobileImage:"JobPageLocaleUpdateMobileImageEntityRelationInput"
	},
	KeyInfoItemCreateInput:{
		id:"UUID",
		list:"KeyInfoItemCreateListEntityRelationInput",
		icon:"KeyInfoItemCreateIconEntityRelationInput"
	},
	KeyInfoItemCreateListEntityRelationInput:{
		connect:"KeyInfoListUniqueWhere",
		create:"KeyInfoListWithoutItemsCreateInput",
		connectOrCreate:"KeyInfoItemConnectOrCreateListRelationInput"
	},
	KeyInfoListWithoutItemsCreateInput:{
		id:"UUID"
	},
	KeyInfoItemConnectOrCreateListRelationInput:{
		connect:"KeyInfoListUniqueWhere",
		create:"KeyInfoListWithoutItemsCreateInput"
	},
	KeyInfoItemUpdateInput:{
		list:"KeyInfoItemUpdateListEntityRelationInput",
		icon:"KeyInfoItemUpdateIconEntityRelationInput"
	},
	KeyInfoItemUpdateListEntityRelationInput:{
		connect:"KeyInfoListUniqueWhere",
		create:"KeyInfoListWithoutItemsCreateInput",
		connectOrCreate:"KeyInfoItemConnectOrCreateListRelationInput",
		update:"KeyInfoListWithoutItemsUpdateInput",
		upsert:"KeyInfoItemUpsertListRelationInput"
	},
	KeyInfoListWithoutItemsUpdateInput:{

	},
	KeyInfoItemUpsertListRelationInput:{
		update:"KeyInfoListWithoutItemsUpdateInput",
		create:"KeyInfoListWithoutItemsCreateInput"
	},
	ContractTypeLocaleCreateInput:{
		id:"UUID",
		root:"ContractTypeLocaleCreateRootEntityRelationInput",
		locale:"ContractTypeLocaleCreateLocaleEntityRelationInput"
	},
	ContractTypeLocaleUpdateInput:{
		root:"ContractTypeLocaleUpdateRootEntityRelationInput",
		locale:"ContractTypeLocaleUpdateLocaleEntityRelationInput"
	},
	JobCityLocaleCreateInput:{
		id:"UUID",
		root:"JobCityLocaleCreateRootEntityRelationInput",
		locale:"JobCityLocaleCreateLocaleEntityRelationInput"
	},
	JobCityLocaleUpdateInput:{
		root:"JobCityLocaleUpdateRootEntityRelationInput",
		locale:"JobCityLocaleUpdateLocaleEntityRelationInput"
	},
	JobPositionCreateInput:{
		id:"UUID",
		locales:"JobPositionCreateLocalesEntityRelationInput",
		jobs:"JobPositionCreateJobsEntityRelationInput"
	},
	JobPositionUpdateInput:{
		locales:"JobPositionUpdateLocalesEntityRelationInput",
		jobs:"JobPositionUpdateJobsEntityRelationInput"
	},
	JobPositionLocaleCreateInput:{
		id:"UUID",
		root:"JobPositionLocaleCreateRootEntityRelationInput",
		locale:"JobPositionLocaleCreateLocaleEntityRelationInput"
	},
	JobPositionLocaleUpdateInput:{
		root:"JobPositionLocaleUpdateRootEntityRelationInput",
		locale:"JobPositionLocaleUpdateLocaleEntityRelationInput"
	},
	HomePageCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"HomePageCreateLocalesEntityRelationInput",
		theme:"HomePageCreateThemeEntityRelationInput"
	},
	HomePageCreateLocalesEntityRelationInput:{
		connect:"HomePageLocaleUniqueWhere",
		create:"HomePageLocaleWithoutRootCreateInput",
		connectOrCreate:"HomePageConnectOrCreateLocalesRelationInput"
	},
	HomePageLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"HomePageLocaleCreateLocaleEntityRelationInput",
		button:"HomePageLocaleCreateButtonEntityRelationInput",
		content:"HomePageLocaleCreateContentEntityRelationInput",
		seo:"HomePageLocaleCreateSeoEntityRelationInput",
		link:"HomePageLocaleCreateLinkEntityRelationInput",
		logo:"HomePageLocaleCreateLogoEntityRelationInput",
		siteSwitcher:"HomePageLocaleCreateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLocaleCreateGalleryEntityRelationInput",
		stickyBar:"HomePageLocaleCreateStickyBarEntityRelationInput",
		ilustration:"HomePageLocaleCreateIlustrationEntityRelationInput"
	},
	HomePageConnectOrCreateLocalesRelationInput:{
		connect:"HomePageLocaleUniqueWhere",
		create:"HomePageLocaleWithoutRootCreateInput"
	},
	HomePageUpdateInput:{
		unique:"One",
		locales:"HomePageUpdateLocalesEntityRelationInput",
		theme:"HomePageUpdateThemeEntityRelationInput"
	},
	HomePageUpdateLocalesEntityRelationInput:{
		create:"HomePageLocaleWithoutRootCreateInput",
		update:"HomePageUpdateLocalesRelationInput",
		upsert:"HomePageUpsertLocalesRelationInput",
		connect:"HomePageLocaleUniqueWhere",
		disconnect:"HomePageLocaleUniqueWhere",
		delete:"HomePageLocaleUniqueWhere"
	},
	HomePageUpdateLocalesRelationInput:{
		by:"HomePageLocaleUniqueWhere",
		data:"HomePageLocaleWithoutRootUpdateInput"
	},
	HomePageLocaleWithoutRootUpdateInput:{
		locale:"HomePageLocaleUpdateLocaleEntityRelationInput",
		button:"HomePageLocaleUpdateButtonEntityRelationInput",
		content:"HomePageLocaleUpdateContentEntityRelationInput",
		seo:"HomePageLocaleUpdateSeoEntityRelationInput",
		link:"HomePageLocaleUpdateLinkEntityRelationInput",
		logo:"HomePageLocaleUpdateLogoEntityRelationInput",
		siteSwitcher:"HomePageLocaleUpdateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLocaleUpdateGalleryEntityRelationInput",
		stickyBar:"HomePageLocaleUpdateStickyBarEntityRelationInput",
		ilustration:"HomePageLocaleUpdateIlustrationEntityRelationInput"
	},
	HomePageUpsertLocalesRelationInput:{
		by:"HomePageLocaleUniqueWhere",
		update:"HomePageLocaleWithoutRootUpdateInput",
		create:"HomePageLocaleWithoutRootCreateInput"
	},
	HomePageLocaleCreateInput:{
		id:"UUID",
		root:"HomePageLocaleCreateRootEntityRelationInput",
		locale:"HomePageLocaleCreateLocaleEntityRelationInput",
		button:"HomePageLocaleCreateButtonEntityRelationInput",
		content:"HomePageLocaleCreateContentEntityRelationInput",
		seo:"HomePageLocaleCreateSeoEntityRelationInput",
		link:"HomePageLocaleCreateLinkEntityRelationInput",
		logo:"HomePageLocaleCreateLogoEntityRelationInput",
		siteSwitcher:"HomePageLocaleCreateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLocaleCreateGalleryEntityRelationInput",
		stickyBar:"HomePageLocaleCreateStickyBarEntityRelationInput",
		ilustration:"HomePageLocaleCreateIlustrationEntityRelationInput"
	},
	HomePageLocaleUpdateInput:{
		root:"HomePageLocaleUpdateRootEntityRelationInput",
		locale:"HomePageLocaleUpdateLocaleEntityRelationInput",
		button:"HomePageLocaleUpdateButtonEntityRelationInput",
		content:"HomePageLocaleUpdateContentEntityRelationInput",
		seo:"HomePageLocaleUpdateSeoEntityRelationInput",
		link:"HomePageLocaleUpdateLinkEntityRelationInput",
		logo:"HomePageLocaleUpdateLogoEntityRelationInput",
		siteSwitcher:"HomePageLocaleUpdateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLocaleUpdateGalleryEntityRelationInput",
		stickyBar:"HomePageLocaleUpdateStickyBarEntityRelationInput",
		ilustration:"HomePageLocaleUpdateIlustrationEntityRelationInput"
	},
	MediumItemCreateInput:{
		id:"UUID",
		list:"MediumItemCreateListEntityRelationInput",
		medium:"MediumItemCreateMediumEntityRelationInput"
	},
	MediumItemCreateListEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListWithoutItemsCreateInput",
		connectOrCreate:"MediumItemConnectOrCreateListRelationInput"
	},
	MediumListWithoutItemsCreateInput:{
		id:"UUID"
	},
	MediumItemConnectOrCreateListRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListWithoutItemsCreateInput"
	},
	MediumItemUpdateInput:{
		list:"MediumItemUpdateListEntityRelationInput",
		medium:"MediumItemUpdateMediumEntityRelationInput"
	},
	MediumItemUpdateListEntityRelationInput:{
		connect:"MediumListUniqueWhere",
		create:"MediumListWithoutItemsCreateInput",
		connectOrCreate:"MediumItemConnectOrCreateListRelationInput",
		update:"MediumListWithoutItemsUpdateInput",
		upsert:"MediumItemUpsertListRelationInput"
	},
	MediumListWithoutItemsUpdateInput:{

	},
	MediumItemUpsertListRelationInput:{
		update:"MediumListWithoutItemsUpdateInput",
		create:"MediumListWithoutItemsCreateInput"
	},
	TextItemCreateInput:{
		id:"UUID",
		list:"TextItemCreateListEntityRelationInput"
	},
	TextItemCreateListEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListWithoutItemsCreateInput",
		connectOrCreate:"TextItemConnectOrCreateListRelationInput"
	},
	TextListWithoutItemsCreateInput:{
		id:"UUID"
	},
	TextItemConnectOrCreateListRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListWithoutItemsCreateInput"
	},
	TextItemUpdateInput:{
		list:"TextItemUpdateListEntityRelationInput"
	},
	TextItemUpdateListEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListWithoutItemsCreateInput",
		connectOrCreate:"TextItemConnectOrCreateListRelationInput",
		update:"TextListWithoutItemsUpdateInput",
		upsert:"TextItemUpsertListRelationInput"
	},
	TextListWithoutItemsUpdateInput:{

	},
	TextItemUpsertListRelationInput:{
		update:"TextListWithoutItemsUpdateInput",
		create:"TextListWithoutItemsCreateInput"
	},
	CarouselItemCreateInput:{
		id:"UUID",
		list:"CarouselItemCreateListEntityRelationInput",
		image:"CarouselItemCreateImageEntityRelationInput",
		linkUrl:"CarouselItemCreateLinkUrlEntityRelationInput",
		video:"CarouselItemCreateVideoEntityRelationInput"
	},
	CarouselItemCreateListEntityRelationInput:{
		connect:"CarouselUniqueWhere",
		create:"CarouselWithoutItemsCreateInput",
		connectOrCreate:"CarouselItemConnectOrCreateListRelationInput"
	},
	CarouselWithoutItemsCreateInput:{
		id:"UUID",
		background:"Background"
	},
	CarouselItemConnectOrCreateListRelationInput:{
		connect:"CarouselUniqueWhere",
		create:"CarouselWithoutItemsCreateInput"
	},
	CarouselItemUpdateInput:{
		list:"CarouselItemUpdateListEntityRelationInput",
		image:"CarouselItemUpdateImageEntityRelationInput",
		linkUrl:"CarouselItemUpdateLinkUrlEntityRelationInput",
		video:"CarouselItemUpdateVideoEntityRelationInput"
	},
	CarouselItemUpdateListEntityRelationInput:{
		connect:"CarouselUniqueWhere",
		create:"CarouselWithoutItemsCreateInput",
		connectOrCreate:"CarouselItemConnectOrCreateListRelationInput",
		update:"CarouselWithoutItemsUpdateInput",
		upsert:"CarouselItemUpsertListRelationInput"
	},
	CarouselWithoutItemsUpdateInput:{
		background:"Background"
	},
	CarouselItemUpsertListRelationInput:{
		update:"CarouselWithoutItemsUpdateInput",
		create:"CarouselWithoutItemsCreateInput"
	},
	BonusBannerCreateInput:{
		id:"UUID",
		locales:"BonusBannerCreateLocalesEntityRelationInput"
	},
	BonusBannerCreateLocalesEntityRelationInput:{
		connect:"BonusBannerLocaleUniqueWhere",
		create:"BonusBannerLocaleWithoutRootCreateInput",
		connectOrCreate:"BonusBannerConnectOrCreateLocalesRelationInput"
	},
	BonusBannerLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"BonusBannerLocaleCreateLocaleEntityRelationInput",
		tiles:"BonusBannerLocaleCreateTilesEntityRelationInput",
		logo:"BonusBannerLocaleCreateLogoEntityRelationInput"
	},
	BonusBannerConnectOrCreateLocalesRelationInput:{
		connect:"BonusBannerLocaleUniqueWhere",
		create:"BonusBannerLocaleWithoutRootCreateInput"
	},
	BonusBannerUpdateInput:{
		locales:"BonusBannerUpdateLocalesEntityRelationInput"
	},
	BonusBannerUpdateLocalesEntityRelationInput:{
		create:"BonusBannerLocaleWithoutRootCreateInput",
		update:"BonusBannerUpdateLocalesRelationInput",
		upsert:"BonusBannerUpsertLocalesRelationInput",
		connect:"BonusBannerLocaleUniqueWhere",
		disconnect:"BonusBannerLocaleUniqueWhere",
		delete:"BonusBannerLocaleUniqueWhere"
	},
	BonusBannerUpdateLocalesRelationInput:{
		by:"BonusBannerLocaleUniqueWhere",
		data:"BonusBannerLocaleWithoutRootUpdateInput"
	},
	BonusBannerLocaleWithoutRootUpdateInput:{
		locale:"BonusBannerLocaleUpdateLocaleEntityRelationInput",
		tiles:"BonusBannerLocaleUpdateTilesEntityRelationInput",
		logo:"BonusBannerLocaleUpdateLogoEntityRelationInput"
	},
	BonusBannerUpsertLocalesRelationInput:{
		by:"BonusBannerLocaleUniqueWhere",
		update:"BonusBannerLocaleWithoutRootUpdateInput",
		create:"BonusBannerLocaleWithoutRootCreateInput"
	},
	TileCreateInput:{
		id:"UUID",
		bonusBanner:"TileCreateBonusBannerEntityRelationInput",
		image:"TileCreateImageEntityRelationInput",
		ligthBoxMedia:"TileCreateLigthBoxMediaEntityRelationInput",
		lightBoxForm:"TileCreateLightBoxFormEntityRelationInput"
	},
	TileCreateBonusBannerEntityRelationInput:{
		connect:"BonusBannerLocaleUniqueWhere",
		create:"BonusBannerLocaleWithoutTilesCreateInput",
		connectOrCreate:"TileConnectOrCreateBonusBannerRelationInput"
	},
	BonusBannerLocaleWithoutTilesCreateInput:{
		id:"UUID",
		root:"BonusBannerLocaleCreateRootEntityRelationInput",
		locale:"BonusBannerLocaleCreateLocaleEntityRelationInput",
		logo:"BonusBannerLocaleCreateLogoEntityRelationInput"
	},
	TileConnectOrCreateBonusBannerRelationInput:{
		connect:"BonusBannerLocaleUniqueWhere",
		create:"BonusBannerLocaleWithoutTilesCreateInput"
	},
	TileUpdateInput:{
		bonusBanner:"TileUpdateBonusBannerEntityRelationInput",
		image:"TileUpdateImageEntityRelationInput",
		ligthBoxMedia:"TileUpdateLigthBoxMediaEntityRelationInput",
		lightBoxForm:"TileUpdateLightBoxFormEntityRelationInput"
	},
	TileUpdateBonusBannerEntityRelationInput:{
		connect:"BonusBannerLocaleUniqueWhere",
		create:"BonusBannerLocaleWithoutTilesCreateInput",
		connectOrCreate:"TileConnectOrCreateBonusBannerRelationInput",
		update:"BonusBannerLocaleWithoutTilesUpdateInput",
		upsert:"TileUpsertBonusBannerRelationInput"
	},
	BonusBannerLocaleWithoutTilesUpdateInput:{
		root:"BonusBannerLocaleUpdateRootEntityRelationInput",
		locale:"BonusBannerLocaleUpdateLocaleEntityRelationInput",
		logo:"BonusBannerLocaleUpdateLogoEntityRelationInput"
	},
	TileUpsertBonusBannerRelationInput:{
		update:"BonusBannerLocaleWithoutTilesUpdateInput",
		create:"BonusBannerLocaleWithoutTilesCreateInput"
	},
	SideBySideItemCreateInput:{
		id:"UUID",
		list:"SideBySideItemCreateListEntityRelationInput",
		media:"SideBySideItemCreateMediaEntityRelationInput",
		type:"SideBySideItemType",
		link:"SideBySideItemCreateLinkEntityRelationInput",
		jobsForm:"SideBySideItemCreateJobsFormEntityRelationInput"
	},
	SideBySideItemCreateListEntityRelationInput:{
		connect:"SideBySideUniqueWhere",
		create:"SideBySideWithoutItemsCreateInput",
		connectOrCreate:"SideBySideItemConnectOrCreateListRelationInput"
	},
	SideBySideWithoutItemsCreateInput:{
		id:"UUID",
		background:"Background",
		alignment:"ContentAlignment",
		mediumSize:"MediumSize"
	},
	SideBySideItemConnectOrCreateListRelationInput:{
		connect:"SideBySideUniqueWhere",
		create:"SideBySideWithoutItemsCreateInput"
	},
	SideBySideItemUpdateInput:{
		list:"SideBySideItemUpdateListEntityRelationInput",
		media:"SideBySideItemUpdateMediaEntityRelationInput",
		type:"SideBySideItemType",
		link:"SideBySideItemUpdateLinkEntityRelationInput",
		jobsForm:"SideBySideItemUpdateJobsFormEntityRelationInput"
	},
	SideBySideItemUpdateListEntityRelationInput:{
		connect:"SideBySideUniqueWhere",
		create:"SideBySideWithoutItemsCreateInput",
		connectOrCreate:"SideBySideItemConnectOrCreateListRelationInput",
		update:"SideBySideWithoutItemsUpdateInput",
		upsert:"SideBySideItemUpsertListRelationInput"
	},
	SideBySideWithoutItemsUpdateInput:{
		background:"Background",
		alignment:"ContentAlignment",
		mediumSize:"MediumSize"
	},
	SideBySideItemUpsertListRelationInput:{
		update:"SideBySideWithoutItemsUpdateInput",
		create:"SideBySideWithoutItemsCreateInput"
	},
	HomePageLokalCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"HomePageLokalCreateLocalesEntityRelationInput",
		theme:"HomePageLokalCreateThemeEntityRelationInput"
	},
	HomePageLokalCreateLocalesEntityRelationInput:{
		connect:"HomePageLokalLocaleUniqueWhere",
		create:"HomePageLokalLocaleWithoutRootCreateInput",
		connectOrCreate:"HomePageLokalConnectOrCreateLocalesRelationInput"
	},
	HomePageLokalLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"HomePageLokalLocaleCreateLocaleEntityRelationInput",
		logo:"HomePageLokalLocaleCreateLogoEntityRelationInput",
		button:"HomePageLokalLocaleCreateButtonEntityRelationInput",
		content:"HomePageLokalLocaleCreateContentEntityRelationInput",
		seo:"HomePageLokalLocaleCreateSeoEntityRelationInput",
		link:"HomePageLokalLocaleCreateLinkEntityRelationInput",
		siteSwitcher:"HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLokalLocaleCreateGalleryEntityRelationInput",
		stickyBar:"HomePageLokalLocaleCreateStickyBarEntityRelationInput",
		ilustration:"HomePageLokalLocaleCreateIlustrationEntityRelationInput"
	},
	HomePageLokalConnectOrCreateLocalesRelationInput:{
		connect:"HomePageLokalLocaleUniqueWhere",
		create:"HomePageLokalLocaleWithoutRootCreateInput"
	},
	HomePageLokalUpdateInput:{
		unique:"One",
		locales:"HomePageLokalUpdateLocalesEntityRelationInput",
		theme:"HomePageLokalUpdateThemeEntityRelationInput"
	},
	HomePageLokalUpdateLocalesEntityRelationInput:{
		create:"HomePageLokalLocaleWithoutRootCreateInput",
		update:"HomePageLokalUpdateLocalesRelationInput",
		upsert:"HomePageLokalUpsertLocalesRelationInput",
		connect:"HomePageLokalLocaleUniqueWhere",
		disconnect:"HomePageLokalLocaleUniqueWhere",
		delete:"HomePageLokalLocaleUniqueWhere"
	},
	HomePageLokalUpdateLocalesRelationInput:{
		by:"HomePageLokalLocaleUniqueWhere",
		data:"HomePageLokalLocaleWithoutRootUpdateInput"
	},
	HomePageLokalLocaleWithoutRootUpdateInput:{
		locale:"HomePageLokalLocaleUpdateLocaleEntityRelationInput",
		logo:"HomePageLokalLocaleUpdateLogoEntityRelationInput",
		button:"HomePageLokalLocaleUpdateButtonEntityRelationInput",
		content:"HomePageLokalLocaleUpdateContentEntityRelationInput",
		seo:"HomePageLokalLocaleUpdateSeoEntityRelationInput",
		link:"HomePageLokalLocaleUpdateLinkEntityRelationInput",
		siteSwitcher:"HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLokalLocaleUpdateGalleryEntityRelationInput",
		stickyBar:"HomePageLokalLocaleUpdateStickyBarEntityRelationInput",
		ilustration:"HomePageLokalLocaleUpdateIlustrationEntityRelationInput"
	},
	HomePageLokalUpsertLocalesRelationInput:{
		by:"HomePageLokalLocaleUniqueWhere",
		update:"HomePageLokalLocaleWithoutRootUpdateInput",
		create:"HomePageLokalLocaleWithoutRootCreateInput"
	},
	HomePageLokalLocaleCreateInput:{
		id:"UUID",
		root:"HomePageLokalLocaleCreateRootEntityRelationInput",
		locale:"HomePageLokalLocaleCreateLocaleEntityRelationInput",
		logo:"HomePageLokalLocaleCreateLogoEntityRelationInput",
		button:"HomePageLokalLocaleCreateButtonEntityRelationInput",
		content:"HomePageLokalLocaleCreateContentEntityRelationInput",
		seo:"HomePageLokalLocaleCreateSeoEntityRelationInput",
		link:"HomePageLokalLocaleCreateLinkEntityRelationInput",
		siteSwitcher:"HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLokalLocaleCreateGalleryEntityRelationInput",
		stickyBar:"HomePageLokalLocaleCreateStickyBarEntityRelationInput",
		ilustration:"HomePageLokalLocaleCreateIlustrationEntityRelationInput"
	},
	HomePageLokalLocaleUpdateInput:{
		root:"HomePageLokalLocaleUpdateRootEntityRelationInput",
		locale:"HomePageLokalLocaleUpdateLocaleEntityRelationInput",
		logo:"HomePageLokalLocaleUpdateLogoEntityRelationInput",
		button:"HomePageLokalLocaleUpdateButtonEntityRelationInput",
		content:"HomePageLokalLocaleUpdateContentEntityRelationInput",
		seo:"HomePageLokalLocaleUpdateSeoEntityRelationInput",
		link:"HomePageLokalLocaleUpdateLinkEntityRelationInput",
		siteSwitcher:"HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput",
		gallery:"HomePageLokalLocaleUpdateGalleryEntityRelationInput",
		stickyBar:"HomePageLokalLocaleUpdateStickyBarEntityRelationInput",
		ilustration:"HomePageLokalLocaleUpdateIlustrationEntityRelationInput"
	},
	GalleryItemCreateInput:{
		id:"UUID",
		list:"GalleryItemCreateListEntityRelationInput",
		image:"GalleryItemCreateImageEntityRelationInput"
	},
	GalleryItemCreateListEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryWithoutItemsCreateInput",
		connectOrCreate:"GalleryItemConnectOrCreateListRelationInput"
	},
	GalleryWithoutItemsCreateInput:{
		id:"UUID"
	},
	GalleryItemConnectOrCreateListRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryWithoutItemsCreateInput"
	},
	GalleryItemUpdateInput:{
		list:"GalleryItemUpdateListEntityRelationInput",
		image:"GalleryItemUpdateImageEntityRelationInput"
	},
	GalleryItemUpdateListEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryWithoutItemsCreateInput",
		connectOrCreate:"GalleryItemConnectOrCreateListRelationInput",
		update:"GalleryWithoutItemsUpdateInput",
		upsert:"GalleryItemUpsertListRelationInput"
	},
	GalleryWithoutItemsUpdateInput:{

	},
	GalleryItemUpsertListRelationInput:{
		update:"GalleryWithoutItemsUpdateInput",
		create:"GalleryWithoutItemsCreateInput"
	},
	JobsFormCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"JobsFormCreateLocalesEntityRelationInput",
		fileIlustration:"JobsFormCreateFileIlustrationEntityRelationInput"
	},
	JobsFormCreateLocalesEntityRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleWithoutRootCreateInput",
		connectOrCreate:"JobsFormConnectOrCreateLocalesRelationInput"
	},
	JobsFormLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"JobsFormLocaleCreateLocaleEntityRelationInput",
		imageTextList:"JobsFormLocaleCreateImageTextListEntityRelationInput",
		logo:"JobsFormLocaleCreateLogoEntityRelationInput",
		successImage:"JobsFormLocaleCreateSuccessImageEntityRelationInput"
	},
	JobsFormConnectOrCreateLocalesRelationInput:{
		connect:"JobsFormLocaleUniqueWhere",
		create:"JobsFormLocaleWithoutRootCreateInput"
	},
	JobsFormUpdateInput:{
		unique:"One",
		locales:"JobsFormUpdateLocalesEntityRelationInput",
		fileIlustration:"JobsFormUpdateFileIlustrationEntityRelationInput"
	},
	JobsFormUpdateLocalesEntityRelationInput:{
		create:"JobsFormLocaleWithoutRootCreateInput",
		update:"JobsFormUpdateLocalesRelationInput",
		upsert:"JobsFormUpsertLocalesRelationInput",
		connect:"JobsFormLocaleUniqueWhere",
		disconnect:"JobsFormLocaleUniqueWhere",
		delete:"JobsFormLocaleUniqueWhere"
	},
	JobsFormUpdateLocalesRelationInput:{
		by:"JobsFormLocaleUniqueWhere",
		data:"JobsFormLocaleWithoutRootUpdateInput"
	},
	JobsFormLocaleWithoutRootUpdateInput:{
		locale:"JobsFormLocaleUpdateLocaleEntityRelationInput",
		imageTextList:"JobsFormLocaleUpdateImageTextListEntityRelationInput",
		logo:"JobsFormLocaleUpdateLogoEntityRelationInput",
		successImage:"JobsFormLocaleUpdateSuccessImageEntityRelationInput"
	},
	JobsFormUpsertLocalesRelationInput:{
		by:"JobsFormLocaleUniqueWhere",
		update:"JobsFormLocaleWithoutRootUpdateInput",
		create:"JobsFormLocaleWithoutRootCreateInput"
	},
	ImageTextItemCreateInput:{
		id:"UUID",
		list:"ImageTextItemCreateListEntityRelationInput",
		image:"ImageTextItemCreateImageEntityRelationInput"
	},
	ImageTextItemCreateListEntityRelationInput:{
		connect:"ImageTextListUniqueWhere",
		create:"ImageTextListWithoutItemsCreateInput",
		connectOrCreate:"ImageTextItemConnectOrCreateListRelationInput"
	},
	ImageTextListWithoutItemsCreateInput:{
		id:"UUID"
	},
	ImageTextItemConnectOrCreateListRelationInput:{
		connect:"ImageTextListUniqueWhere",
		create:"ImageTextListWithoutItemsCreateInput"
	},
	ImageTextItemUpdateInput:{
		list:"ImageTextItemUpdateListEntityRelationInput",
		image:"ImageTextItemUpdateImageEntityRelationInput"
	},
	ImageTextItemUpdateListEntityRelationInput:{
		connect:"ImageTextListUniqueWhere",
		create:"ImageTextListWithoutItemsCreateInput",
		connectOrCreate:"ImageTextItemConnectOrCreateListRelationInput",
		update:"ImageTextListWithoutItemsUpdateInput",
		upsert:"ImageTextItemUpsertListRelationInput"
	},
	ImageTextListWithoutItemsUpdateInput:{

	},
	ImageTextItemUpsertListRelationInput:{
		update:"ImageTextListWithoutItemsUpdateInput",
		create:"ImageTextListWithoutItemsCreateInput"
	},
	JobsFilterCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"JobsFilterCreateLocalesEntityRelationInput"
	},
	JobsFilterCreateLocalesEntityRelationInput:{
		connect:"JobsFilterLocaleUniqueWhere",
		create:"JobsFilterLocaleWithoutRootCreateInput",
		connectOrCreate:"JobsFilterConnectOrCreateLocalesRelationInput"
	},
	JobsFilterLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"JobsFilterLocaleCreateLocaleEntityRelationInput",
		bannerJobsForm:"JobsFilterLocaleCreateBannerJobsFormEntityRelationInput",
		bannerImage:"JobsFilterLocaleCreateBannerImageEntityRelationInput",
		noJobImage:"JobsFilterLocaleCreateNoJobImageEntityRelationInput"
	},
	JobsFilterLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobsFiltersCreateInput",
		connectOrCreate:"JobsFilterLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutJobsFiltersCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput",
		translations:"LocaleCreateTranslationsEntityRelationInput"
	},
	JobsFilterLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobsFiltersCreateInput"
	},
	JobsFilterConnectOrCreateLocalesRelationInput:{
		connect:"JobsFilterLocaleUniqueWhere",
		create:"JobsFilterLocaleWithoutRootCreateInput"
	},
	JobsFilterUpdateInput:{
		unique:"One",
		locales:"JobsFilterUpdateLocalesEntityRelationInput"
	},
	JobsFilterUpdateLocalesEntityRelationInput:{
		create:"JobsFilterLocaleWithoutRootCreateInput",
		update:"JobsFilterUpdateLocalesRelationInput",
		upsert:"JobsFilterUpsertLocalesRelationInput",
		connect:"JobsFilterLocaleUniqueWhere",
		disconnect:"JobsFilterLocaleUniqueWhere",
		delete:"JobsFilterLocaleUniqueWhere"
	},
	JobsFilterUpdateLocalesRelationInput:{
		by:"JobsFilterLocaleUniqueWhere",
		data:"JobsFilterLocaleWithoutRootUpdateInput"
	},
	JobsFilterLocaleWithoutRootUpdateInput:{
		locale:"JobsFilterLocaleUpdateLocaleEntityRelationInput",
		bannerJobsForm:"JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput",
		bannerImage:"JobsFilterLocaleUpdateBannerImageEntityRelationInput",
		noJobImage:"JobsFilterLocaleUpdateNoJobImageEntityRelationInput"
	},
	JobsFilterLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutJobsFiltersCreateInput",
		connectOrCreate:"JobsFilterLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutJobsFiltersUpdateInput",
		upsert:"JobsFilterLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutJobsFiltersUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput",
		translations:"LocaleUpdateTranslationsEntityRelationInput"
	},
	JobsFilterLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutJobsFiltersUpdateInput",
		create:"LocaleWithoutJobsFiltersCreateInput"
	},
	JobsFilterUpsertLocalesRelationInput:{
		by:"JobsFilterLocaleUniqueWhere",
		update:"JobsFilterLocaleWithoutRootUpdateInput",
		create:"JobsFilterLocaleWithoutRootCreateInput"
	},
	JobsFilterLocaleCreateInput:{
		id:"UUID",
		root:"JobsFilterLocaleCreateRootEntityRelationInput",
		locale:"JobsFilterLocaleCreateLocaleEntityRelationInput",
		bannerJobsForm:"JobsFilterLocaleCreateBannerJobsFormEntityRelationInput",
		bannerImage:"JobsFilterLocaleCreateBannerImageEntityRelationInput",
		noJobImage:"JobsFilterLocaleCreateNoJobImageEntityRelationInput"
	},
	JobsFilterLocaleUpdateInput:{
		root:"JobsFilterLocaleUpdateRootEntityRelationInput",
		locale:"JobsFilterLocaleUpdateLocaleEntityRelationInput",
		bannerJobsForm:"JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput",
		bannerImage:"JobsFilterLocaleUpdateBannerImageEntityRelationInput",
		noJobImage:"JobsFilterLocaleUpdateNoJobImageEntityRelationInput"
	},
	FileUniqueWhere:{
		id:"UUID"
	},
	FileWhere:{
		id:"UUIDCondition",
		url:"StringCondition",
		size:"IntCondition",
		type:"StringCondition",
		and:"FileWhere",
		or:"FileWhere",
		not:"FileWhere"
	},
	FileOrderBy:{
		id:"OrderDirection",
		url:"OrderDirection",
		size:"OrderDirection",
		type:"OrderDirection"
	},
	FileCreateInput:{
		id:"UUID"
	},
	FileUpdateInput:{

	},
	JobFormSubscription:{
		file:{
			filter:"FileWhere"
		},
		job:{
			filter:"JobPageLocaleWhere"
		},
		status:{
			filter:"JobFormSubscriptionStatusWhere"
		}
	},
	JobFormSubscriptionStatusWhere:{
		id:"UUIDCondition",
		statusTitle:"StringCondition",
		statusColor:"StringCondition",
		and:"JobFormSubscriptionStatusWhere",
		or:"JobFormSubscriptionStatusWhere",
		not:"JobFormSubscriptionStatusWhere"
	},
	JobFormSubscriptionUniqueWhere:{
		id:"UUID",
		file:"FileUniqueWhere"
	},
	JobFormSubscriptionWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		name:"StringCondition",
		phone:"StringCondition",
		email:"StringCondition",
		message:"StringCondition",
		file:"FileWhere",
		job:"JobPageLocaleWhere",
		status:"JobFormSubscriptionStatusWhere",
		isSyncedToTabidoo:"BooleanCondition",
		tabidooId:"StringCondition",
		isGdprSyncedToTabidoo:"BooleanCondition",
		recruitisAnswerId:"StringCondition",
		and:"JobFormSubscriptionWhere",
		or:"JobFormSubscriptionWhere",
		not:"JobFormSubscriptionWhere"
	},
	JobFormSubscriptionOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		name:"OrderDirection",
		phone:"OrderDirection",
		email:"OrderDirection",
		message:"OrderDirection",
		file:"FileOrderBy",
		job:"JobPageLocaleOrderBy",
		status:"JobFormSubscriptionStatusOrderBy",
		isSyncedToTabidoo:"OrderDirection",
		tabidooId:"OrderDirection",
		isGdprSyncedToTabidoo:"OrderDirection",
		recruitisAnswerId:"OrderDirection"
	},
	JobFormSubscriptionStatusOrderBy:{
		id:"OrderDirection",
		statusTitle:"OrderDirection",
		statusColor:"OrderDirection"
	},
	JobFormSubscriptionCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		file:"JobFormSubscriptionCreateFileEntityRelationInput",
		job:"JobFormSubscriptionCreateJobEntityRelationInput",
		status:"JobFormSubscriptionCreateStatusEntityRelationInput"
	},
	JobFormSubscriptionCreateFileEntityRelationInput:{
		connect:"FileUniqueWhere",
		create:"FileCreateInput",
		connectOrCreate:"JobFormSubscriptionConnectOrCreateFileRelationInput"
	},
	JobFormSubscriptionConnectOrCreateFileRelationInput:{
		connect:"FileUniqueWhere",
		create:"FileCreateInput"
	},
	JobFormSubscriptionCreateJobEntityRelationInput:{
		connect:"JobPageLocaleUniqueWhere",
		create:"JobPageLocaleCreateInput",
		connectOrCreate:"JobFormSubscriptionConnectOrCreateJobRelationInput"
	},
	JobFormSubscriptionConnectOrCreateJobRelationInput:{
		connect:"JobPageLocaleUniqueWhere",
		create:"JobPageLocaleCreateInput"
	},
	JobFormSubscriptionCreateStatusEntityRelationInput:{
		connect:"JobFormSubscriptionStatusUniqueWhere",
		create:"JobFormSubscriptionStatusCreateInput",
		connectOrCreate:"JobFormSubscriptionConnectOrCreateStatusRelationInput"
	},
	JobFormSubscriptionStatusUniqueWhere:{
		id:"UUID"
	},
	JobFormSubscriptionStatusCreateInput:{
		id:"UUID"
	},
	JobFormSubscriptionConnectOrCreateStatusRelationInput:{
		connect:"JobFormSubscriptionStatusUniqueWhere",
		create:"JobFormSubscriptionStatusCreateInput"
	},
	JobFormSubscriptionUpdateInput:{
		createdAt:"DateTime",
		file:"JobFormSubscriptionUpdateFileEntityRelationInput",
		job:"JobFormSubscriptionUpdateJobEntityRelationInput",
		status:"JobFormSubscriptionUpdateStatusEntityRelationInput"
	},
	JobFormSubscriptionUpdateFileEntityRelationInput:{
		connect:"FileUniqueWhere",
		create:"FileCreateInput",
		connectOrCreate:"JobFormSubscriptionConnectOrCreateFileRelationInput",
		update:"FileUpdateInput",
		upsert:"JobFormSubscriptionUpsertFileRelationInput"
	},
	JobFormSubscriptionUpsertFileRelationInput:{
		update:"FileUpdateInput",
		create:"FileCreateInput"
	},
	JobFormSubscriptionUpdateJobEntityRelationInput:{
		connect:"JobPageLocaleUniqueWhere",
		create:"JobPageLocaleCreateInput",
		connectOrCreate:"JobFormSubscriptionConnectOrCreateJobRelationInput",
		update:"JobPageLocaleUpdateInput",
		upsert:"JobFormSubscriptionUpsertJobRelationInput"
	},
	JobFormSubscriptionUpsertJobRelationInput:{
		update:"JobPageLocaleUpdateInput",
		create:"JobPageLocaleCreateInput"
	},
	JobFormSubscriptionUpdateStatusEntityRelationInput:{
		connect:"JobFormSubscriptionStatusUniqueWhere",
		create:"JobFormSubscriptionStatusCreateInput",
		connectOrCreate:"JobFormSubscriptionConnectOrCreateStatusRelationInput",
		update:"JobFormSubscriptionStatusUpdateInput",
		upsert:"JobFormSubscriptionUpsertStatusRelationInput"
	},
	JobFormSubscriptionStatusUpdateInput:{

	},
	JobFormSubscriptionUpsertStatusRelationInput:{
		update:"JobFormSubscriptionStatusUpdateInput",
		create:"JobFormSubscriptionStatusCreateInput"
	},
	ImageList:{
		items:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		},
		itemsByImage:{
			by:"ImageListItemsByImageUniqueWhere",
			filter:"ImageListItemWhere"
		},
		paginateItems:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		}
	},
	ImageListItem:{
		list:{
			filter:"ImageListWhere"
		},
		image:{
			filter:"ImageWhere"
		}
	},
	ImageListWhere:{
		id:"UUIDCondition",
		items:"ImageListItemWhere",
		and:"ImageListWhere",
		or:"ImageListWhere",
		not:"ImageListWhere"
	},
	ImageListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"ImageListWhere",
		image:"ImageWhere",
		and:"ImageListItemWhere",
		or:"ImageListItemWhere",
		not:"ImageListItemWhere"
	},
	ImageListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"ImageListOrderBy",
		image:"ImageOrderBy"
	},
	ImageListOrderBy:{
		id:"OrderDirection"
	},
	ImageListItemsByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	ImageListUniqueWhere:{
		id:"UUID",
		items:"ImageListItemUniqueWhere"
	},
	ImageListItemUniqueWhere:{
		id:"UUID",
		image:"ImageUniqueWhere"
	},
	ImageListCreateInput:{
		id:"UUID",
		items:"ImageListCreateItemsEntityRelationInput"
	},
	ImageListCreateItemsEntityRelationInput:{
		connect:"ImageListItemUniqueWhere",
		create:"ImageListItemWithoutListCreateInput",
		connectOrCreate:"ImageListConnectOrCreateItemsRelationInput"
	},
	ImageListItemWithoutListCreateInput:{
		id:"UUID",
		image:"ImageListItemCreateImageEntityRelationInput"
	},
	ImageListItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ImageListItemConnectOrCreateImageRelationInput"
	},
	ImageListItemConnectOrCreateImageRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ImageListConnectOrCreateItemsRelationInput:{
		connect:"ImageListItemUniqueWhere",
		create:"ImageListItemWithoutListCreateInput"
	},
	ImageListUpdateInput:{
		items:"ImageListUpdateItemsEntityRelationInput"
	},
	ImageListUpdateItemsEntityRelationInput:{
		create:"ImageListItemWithoutListCreateInput",
		update:"ImageListUpdateItemsRelationInput",
		upsert:"ImageListUpsertItemsRelationInput",
		connect:"ImageListItemUniqueWhere",
		disconnect:"ImageListItemUniqueWhere",
		delete:"ImageListItemUniqueWhere"
	},
	ImageListUpdateItemsRelationInput:{
		by:"ImageListItemUniqueWhere",
		data:"ImageListItemWithoutListUpdateInput"
	},
	ImageListItemWithoutListUpdateInput:{
		image:"ImageListItemUpdateImageEntityRelationInput"
	},
	ImageListItemUpdateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput",
		connectOrCreate:"ImageListItemConnectOrCreateImageRelationInput",
		update:"ImageUpdateInput",
		upsert:"ImageListItemUpsertImageRelationInput"
	},
	ImageListItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ImageListUpsertItemsRelationInput:{
		by:"ImageListItemUniqueWhere",
		update:"ImageListItemWithoutListUpdateInput",
		create:"ImageListItemWithoutListCreateInput"
	},
	ImageListItemCreateInput:{
		id:"UUID",
		list:"ImageListItemCreateListEntityRelationInput",
		image:"ImageListItemCreateImageEntityRelationInput"
	},
	ImageListItemCreateListEntityRelationInput:{
		connect:"ImageListUniqueWhere",
		create:"ImageListWithoutItemsCreateInput",
		connectOrCreate:"ImageListItemConnectOrCreateListRelationInput"
	},
	ImageListWithoutItemsCreateInput:{
		id:"UUID"
	},
	ImageListItemConnectOrCreateListRelationInput:{
		connect:"ImageListUniqueWhere",
		create:"ImageListWithoutItemsCreateInput"
	},
	ImageListItemUpdateInput:{
		list:"ImageListItemUpdateListEntityRelationInput",
		image:"ImageListItemUpdateImageEntityRelationInput"
	},
	ImageListItemUpdateListEntityRelationInput:{
		connect:"ImageListUniqueWhere",
		create:"ImageListWithoutItemsCreateInput",
		connectOrCreate:"ImageListItemConnectOrCreateListRelationInput",
		update:"ImageListWithoutItemsUpdateInput",
		upsert:"ImageListItemUpsertListRelationInput"
	},
	ImageListWithoutItemsUpdateInput:{

	},
	ImageListItemUpsertListRelationInput:{
		update:"ImageListWithoutItemsUpdateInput",
		create:"ImageListWithoutItemsCreateInput"
	},
	GeneralLocaleCreateInput:{
		id:"UUID",
		root:"GeneralLocaleCreateRootEntityRelationInput",
		locale:"GeneralLocaleCreateLocaleEntityRelationInput",
		seo:"GeneralLocaleCreateSeoEntityRelationInput",
		cornerBanner:"GeneralLocaleCreateCornerBannerEntityRelationInput"
	},
	GeneralLocaleUpdateInput:{
		root:"GeneralLocaleUpdateRootEntityRelationInput",
		locale:"GeneralLocaleUpdateLocaleEntityRelationInput",
		seo:"GeneralLocaleUpdateSeoEntityRelationInput",
		cornerBanner:"GeneralLocaleUpdateCornerBannerEntityRelationInput"
	},
	RecommendationFormCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"RecommendationFormCreateLocalesEntityRelationInput",
		successImage:"RecommendationFormCreateSuccessImageEntityRelationInput"
	},
	RecommendationFormCreateLocalesEntityRelationInput:{
		connect:"RecommendationFormLocaleUniqueWhere",
		create:"RecommendationFormLocaleWithoutRootCreateInput",
		connectOrCreate:"RecommendationFormConnectOrCreateLocalesRelationInput"
	},
	RecommendationFormLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"RecommendationFormLocaleCreateLocaleEntityRelationInput"
	},
	RecommendationFormConnectOrCreateLocalesRelationInput:{
		connect:"RecommendationFormLocaleUniqueWhere",
		create:"RecommendationFormLocaleWithoutRootCreateInput"
	},
	RecommendationFormUpdateInput:{
		unique:"One",
		locales:"RecommendationFormUpdateLocalesEntityRelationInput",
		successImage:"RecommendationFormUpdateSuccessImageEntityRelationInput"
	},
	RecommendationFormUpdateLocalesEntityRelationInput:{
		create:"RecommendationFormLocaleWithoutRootCreateInput",
		update:"RecommendationFormUpdateLocalesRelationInput",
		upsert:"RecommendationFormUpsertLocalesRelationInput",
		connect:"RecommendationFormLocaleUniqueWhere",
		disconnect:"RecommendationFormLocaleUniqueWhere",
		delete:"RecommendationFormLocaleUniqueWhere"
	},
	RecommendationFormUpdateLocalesRelationInput:{
		by:"RecommendationFormLocaleUniqueWhere",
		data:"RecommendationFormLocaleWithoutRootUpdateInput"
	},
	RecommendationFormLocaleWithoutRootUpdateInput:{
		locale:"RecommendationFormLocaleUpdateLocaleEntityRelationInput"
	},
	RecommendationFormUpsertLocalesRelationInput:{
		by:"RecommendationFormLocaleUniqueWhere",
		update:"RecommendationFormLocaleWithoutRootUpdateInput",
		create:"RecommendationFormLocaleWithoutRootCreateInput"
	},
	RecommendationFormSubscriptionUniqueWhere:{
		id:"UUID"
	},
	RecommendationFormSubscriptionWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		yourEmail:"StringCondition",
		theirEmail:"StringCondition",
		yourName:"StringCondition",
		and:"RecommendationFormSubscriptionWhere",
		or:"RecommendationFormSubscriptionWhere",
		not:"RecommendationFormSubscriptionWhere"
	},
	RecommendationFormSubscriptionOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		yourEmail:"OrderDirection",
		theirEmail:"OrderDirection",
		yourName:"OrderDirection"
	},
	RecommendationFormSubscriptionCreateInput:{
		id:"UUID",
		createdAt:"DateTime"
	},
	RecommendationFormSubscriptionUpdateInput:{
		createdAt:"DateTime"
	},
	InfoBoxLocaleCreateInput:{
		id:"UUID",
		root:"InfoBoxLocaleCreateRootEntityRelationInput",
		locale:"InfoBoxLocaleCreateLocaleEntityRelationInput",
		openingHours:"InfoBoxLocaleCreateOpeningHoursEntityRelationInput"
	},
	InfoBoxLocaleUpdateInput:{
		root:"InfoBoxLocaleUpdateRootEntityRelationInput",
		locale:"InfoBoxLocaleUpdateLocaleEntityRelationInput",
		openingHours:"InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"
	},
	TranslationCreateInput:{
		id:"UUID",
		locales:"TranslationCreateLocalesEntityRelationInput"
	},
	TranslationCreateLocalesEntityRelationInput:{
		connect:"TranslationLocaleUniqueWhere",
		create:"TranslationLocaleWithoutRootCreateInput",
		connectOrCreate:"TranslationConnectOrCreateLocalesRelationInput"
	},
	TranslationLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"TranslationLocaleCreateLocaleEntityRelationInput"
	},
	TranslationLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutTranslationsCreateInput",
		connectOrCreate:"TranslationLocaleConnectOrCreateLocaleRelationInput"
	},
	LocaleWithoutTranslationsCreateInput:{
		id:"UUID",
		footers:"LocaleCreateFootersEntityRelationInput",
		genericPages:"LocaleCreateGenericPagesEntityRelationInput",
		headers:"LocaleCreateHeadersEntityRelationInput",
		seoDefaults:"LocaleCreateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleCreateBusinessPagesEntityRelationInput",
		jobPages:"LocaleCreateJobPagesEntityRelationInput",
		contractTypes:"LocaleCreateContractTypesEntityRelationInput",
		jobCities:"LocaleCreateJobCitiesEntityRelationInput",
		jobPositions:"LocaleCreateJobPositionsEntityRelationInput",
		homePages:"LocaleCreateHomePagesEntityRelationInput",
		bonusBanners:"LocaleCreateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleCreateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleCreateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleCreateJobsFiltersEntityRelationInput",
		general:"LocaleCreateGeneralEntityRelationInput",
		recommendationForms:"LocaleCreateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleCreateInfoBoxesEntityRelationInput"
	},
	TranslationLocaleConnectOrCreateLocaleRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutTranslationsCreateInput"
	},
	TranslationConnectOrCreateLocalesRelationInput:{
		connect:"TranslationLocaleUniqueWhere",
		create:"TranslationLocaleWithoutRootCreateInput"
	},
	TranslationUpdateInput:{
		locales:"TranslationUpdateLocalesEntityRelationInput"
	},
	TranslationUpdateLocalesEntityRelationInput:{
		create:"TranslationLocaleWithoutRootCreateInput",
		update:"TranslationUpdateLocalesRelationInput",
		upsert:"TranslationUpsertLocalesRelationInput",
		connect:"TranslationLocaleUniqueWhere",
		disconnect:"TranslationLocaleUniqueWhere",
		delete:"TranslationLocaleUniqueWhere"
	},
	TranslationUpdateLocalesRelationInput:{
		by:"TranslationLocaleUniqueWhere",
		data:"TranslationLocaleWithoutRootUpdateInput"
	},
	TranslationLocaleWithoutRootUpdateInput:{
		locale:"TranslationLocaleUpdateLocaleEntityRelationInput"
	},
	TranslationLocaleUpdateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutTranslationsCreateInput",
		connectOrCreate:"TranslationLocaleConnectOrCreateLocaleRelationInput",
		update:"LocaleWithoutTranslationsUpdateInput",
		upsert:"TranslationLocaleUpsertLocaleRelationInput"
	},
	LocaleWithoutTranslationsUpdateInput:{
		footers:"LocaleUpdateFootersEntityRelationInput",
		genericPages:"LocaleUpdateGenericPagesEntityRelationInput",
		headers:"LocaleUpdateHeadersEntityRelationInput",
		seoDefaults:"LocaleUpdateSeoDefaultsEntityRelationInput",
		businessPages:"LocaleUpdateBusinessPagesEntityRelationInput",
		jobPages:"LocaleUpdateJobPagesEntityRelationInput",
		contractTypes:"LocaleUpdateContractTypesEntityRelationInput",
		jobCities:"LocaleUpdateJobCitiesEntityRelationInput",
		jobPositions:"LocaleUpdateJobPositionsEntityRelationInput",
		homePages:"LocaleUpdateHomePagesEntityRelationInput",
		bonusBanners:"LocaleUpdateBonusBannersEntityRelationInput",
		homePageLokals:"LocaleUpdateHomePageLokalsEntityRelationInput",
		jobsForms:"LocaleUpdateJobsFormsEntityRelationInput",
		jobsFilters:"LocaleUpdateJobsFiltersEntityRelationInput",
		general:"LocaleUpdateGeneralEntityRelationInput",
		recommendationForms:"LocaleUpdateRecommendationFormsEntityRelationInput",
		infoBoxes:"LocaleUpdateInfoBoxesEntityRelationInput"
	},
	TranslationLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutTranslationsUpdateInput",
		create:"LocaleWithoutTranslationsCreateInput"
	},
	TranslationUpsertLocalesRelationInput:{
		by:"TranslationLocaleUniqueWhere",
		update:"TranslationLocaleWithoutRootUpdateInput",
		create:"TranslationLocaleWithoutRootCreateInput"
	},
	TranslationLocaleCreateInput:{
		id:"UUID",
		root:"TranslationLocaleCreateRootEntityRelationInput",
		locale:"TranslationLocaleCreateLocaleEntityRelationInput"
	},
	TranslationLocaleUpdateInput:{
		root:"TranslationLocaleUpdateRootEntityRelationInput",
		locale:"TranslationLocaleUpdateLocaleEntityRelationInput"
	},
	QueryTransaction:{
		getGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere"
		},
		listGeneral:{
			filter:"GeneralWhere",
			orderBy:"GeneralOrderBy"
		},
		paginateGeneral:{
			filter:"GeneralWhere",
			orderBy:"GeneralOrderBy"
		},
		validateCreateGeneral:{
			data:"GeneralCreateInput"
		},
		validateUpdateGeneral:{
			by:"GeneralUniqueWhere",
			data:"GeneralUpdateInput"
		},
		getImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		listImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		paginateImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		validateCreateImage:{
			data:"ImageCreateInput"
		},
		validateUpdateImage:{
			by:"ImageUniqueWhere",
			data:"ImageUpdateInput"
		},
		getGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere"
		},
		listGenericPage:{
			filter:"GenericPageWhere",
			orderBy:"GenericPageOrderBy"
		},
		paginateGenericPage:{
			filter:"GenericPageWhere",
			orderBy:"GenericPageOrderBy"
		},
		validateCreateGenericPage:{
			data:"GenericPageCreateInput"
		},
		validateUpdateGenericPage:{
			by:"GenericPageUniqueWhere",
			data:"GenericPageUpdateInput"
		},
		getLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		listLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		paginateLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		validateCreateLinkable:{
			data:"LinkableCreateInput"
		},
		validateUpdateLinkable:{
			by:"LinkableUniqueWhere",
			data:"LinkableUpdateInput"
		},
		getSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		listSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		paginateSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		validateCreateSeo:{
			data:"SeoCreateInput"
		},
		validateUpdateSeo:{
			by:"SeoUniqueWhere",
			data:"SeoUpdateInput"
		},
		getContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		listContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		paginateContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		validateCreateContent:{
			data:"ContentCreateInput"
		},
		validateUpdateContent:{
			by:"ContentUniqueWhere",
			data:"ContentUpdateInput"
		},
		getContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		listContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		paginateContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		validateCreateContentBlock:{
			data:"ContentBlockCreateInput"
		},
		validateUpdateContentBlock:{
			by:"ContentBlockUniqueWhere",
			data:"ContentBlockUpdateInput"
		},
		getContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		listContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		paginateContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		validateCreateContentReference:{
			data:"ContentReferenceCreateInput"
		},
		validateUpdateContentReference:{
			by:"ContentReferenceUniqueWhere",
			data:"ContentReferenceUpdateInput"
		},
		getContentReferenceLinkableItem:{
			by:"ContentReferenceLinkableItemUniqueWhere",
			filter:"ContentReferenceLinkableItemWhere"
		},
		listContentReferenceLinkableItem:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		paginateContentReferenceLinkableItem:{
			filter:"ContentReferenceLinkableItemWhere",
			orderBy:"ContentReferenceLinkableItemOrderBy"
		},
		getRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere"
		},
		listRedirect:{
			filter:"RedirectWhere",
			orderBy:"RedirectOrderBy"
		},
		paginateRedirect:{
			filter:"RedirectWhere",
			orderBy:"RedirectOrderBy"
		},
		validateCreateRedirect:{
			data:"RedirectCreateInput"
		},
		validateUpdateRedirect:{
			by:"RedirectUniqueWhere",
			data:"RedirectUpdateInput"
		},
		getLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		listLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		paginateLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		validateCreateLink:{
			data:"LinkCreateInput"
		},
		validateUpdateLink:{
			by:"LinkUniqueWhere",
			data:"LinkUpdateInput"
		},
		getFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere"
		},
		listFooter:{
			filter:"FooterWhere",
			orderBy:"FooterOrderBy"
		},
		paginateFooter:{
			filter:"FooterWhere",
			orderBy:"FooterOrderBy"
		},
		validateCreateFooter:{
			data:"FooterCreateInput"
		},
		validateUpdateFooter:{
			by:"FooterUniqueWhere",
			data:"FooterUpdateInput"
		},
		getFooterLink:{
			by:"FooterLinkUniqueWhere",
			filter:"FooterLinkWhere"
		},
		listFooterLink:{
			filter:"FooterLinkWhere",
			orderBy:"FooterLinkOrderBy"
		},
		paginateFooterLink:{
			filter:"FooterLinkWhere",
			orderBy:"FooterLinkOrderBy"
		},
		validateCreateFooterLink:{
			data:"FooterLinkCreateInput"
		},
		validateUpdateFooterLink:{
			by:"FooterLinkUniqueWhere",
			data:"FooterLinkUpdateInput"
		},
		getFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		listFooterLocale:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		paginateFooterLocale:{
			filter:"FooterLocaleWhere",
			orderBy:"FooterLocaleOrderBy"
		},
		validateCreateFooterLocale:{
			data:"FooterLocaleCreateInput"
		},
		validateUpdateFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			data:"FooterLocaleUpdateInput"
		},
		getGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		listGenericPageLocale:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		paginateGenericPageLocale:{
			filter:"GenericPageLocaleWhere",
			orderBy:"GenericPageLocaleOrderBy"
		},
		validateCreateGenericPageLocale:{
			data:"GenericPageLocaleCreateInput"
		},
		validateUpdateGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			data:"GenericPageLocaleUpdateInput"
		},
		getHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere"
		},
		listHeader:{
			filter:"HeaderWhere",
			orderBy:"HeaderOrderBy"
		},
		paginateHeader:{
			filter:"HeaderWhere",
			orderBy:"HeaderOrderBy"
		},
		validateCreateHeader:{
			data:"HeaderCreateInput"
		},
		validateUpdateHeader:{
			by:"HeaderUniqueWhere",
			data:"HeaderUpdateInput"
		},
		getHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		listHeaderLocale:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		paginateHeaderLocale:{
			filter:"HeaderLocaleWhere",
			orderBy:"HeaderLocaleOrderBy"
		},
		validateCreateHeaderLocale:{
			data:"HeaderLocaleCreateInput"
		},
		validateUpdateHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			data:"HeaderLocaleUpdateInput"
		},
		getLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		listLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		paginateLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		validateCreateLocale:{
			data:"LocaleCreateInput"
		},
		validateUpdateLocale:{
			by:"LocaleUniqueWhere",
			data:"LocaleUpdateInput"
		},
		getSeoDefault:{
			by:"SeoDefaultUniqueWhere",
			filter:"SeoDefaultWhere"
		},
		listSeoDefault:{
			filter:"SeoDefaultWhere",
			orderBy:"SeoDefaultOrderBy"
		},
		paginateSeoDefault:{
			filter:"SeoDefaultWhere",
			orderBy:"SeoDefaultOrderBy"
		},
		validateCreateSeoDefault:{
			data:"SeoDefaultCreateInput"
		},
		validateUpdateSeoDefault:{
			by:"SeoDefaultUniqueWhere",
			data:"SeoDefaultUpdateInput"
		},
		getSeoDefaultLocale:{
			by:"SeoDefaultLocaleUniqueWhere",
			filter:"SeoDefaultLocaleWhere"
		},
		listSeoDefaultLocale:{
			filter:"SeoDefaultLocaleWhere",
			orderBy:"SeoDefaultLocaleOrderBy"
		},
		paginateSeoDefaultLocale:{
			filter:"SeoDefaultLocaleWhere",
			orderBy:"SeoDefaultLocaleOrderBy"
		},
		validateCreateSeoDefaultLocale:{
			data:"SeoDefaultLocaleCreateInput"
		},
		validateUpdateSeoDefaultLocale:{
			by:"SeoDefaultLocaleUniqueWhere",
			data:"SeoDefaultLocaleUpdateInput"
		},
		getBusiness:{
			by:"BusinessUniqueWhere",
			filter:"BusinessWhere"
		},
		listBusiness:{
			filter:"BusinessWhere",
			orderBy:"BusinessOrderBy"
		},
		paginateBusiness:{
			filter:"BusinessWhere",
			orderBy:"BusinessOrderBy"
		},
		validateCreateBusiness:{
			data:"BusinessCreateInput"
		},
		validateUpdateBusiness:{
			by:"BusinessUniqueWhere",
			data:"BusinessUpdateInput"
		},
		getBusinessPage:{
			by:"BusinessPageUniqueWhere",
			filter:"BusinessPageWhere"
		},
		listBusinessPage:{
			filter:"BusinessPageWhere",
			orderBy:"BusinessPageOrderBy"
		},
		paginateBusinessPage:{
			filter:"BusinessPageWhere",
			orderBy:"BusinessPageOrderBy"
		},
		validateCreateBusinessPage:{
			data:"BusinessPageCreateInput"
		},
		validateUpdateBusinessPage:{
			by:"BusinessPageUniqueWhere",
			data:"BusinessPageUpdateInput"
		},
		getBusinessPageLocale:{
			by:"BusinessPageLocaleUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		listBusinessPageLocale:{
			filter:"BusinessPageLocaleWhere",
			orderBy:"BusinessPageLocaleOrderBy"
		},
		paginateBusinessPageLocale:{
			filter:"BusinessPageLocaleWhere",
			orderBy:"BusinessPageLocaleOrderBy"
		},
		validateCreateBusinessPageLocale:{
			data:"BusinessPageLocaleCreateInput"
		},
		validateUpdateBusinessPageLocale:{
			by:"BusinessPageLocaleUniqueWhere",
			data:"BusinessPageLocaleUpdateInput"
		},
		getIcon:{
			by:"IconUniqueWhere",
			filter:"IconWhere"
		},
		listIcon:{
			filter:"IconWhere",
			orderBy:"IconOrderBy"
		},
		paginateIcon:{
			filter:"IconWhere",
			orderBy:"IconOrderBy"
		},
		validateCreateIcon:{
			data:"IconCreateInput"
		},
		validateUpdateIcon:{
			by:"IconUniqueWhere",
			data:"IconUpdateInput"
		},
		getJobPage:{
			by:"JobPageUniqueWhere",
			filter:"JobPageWhere"
		},
		listJobPage:{
			filter:"JobPageWhere",
			orderBy:"JobPageOrderBy"
		},
		paginateJobPage:{
			filter:"JobPageWhere",
			orderBy:"JobPageOrderBy"
		},
		validateCreateJobPage:{
			data:"JobPageCreateInput"
		},
		validateUpdateJobPage:{
			by:"JobPageUniqueWhere",
			data:"JobPageUpdateInput"
		},
		getJobPageLocale:{
			by:"JobPageLocaleUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		listJobPageLocale:{
			filter:"JobPageLocaleWhere",
			orderBy:"JobPageLocaleOrderBy"
		},
		paginateJobPageLocale:{
			filter:"JobPageLocaleWhere",
			orderBy:"JobPageLocaleOrderBy"
		},
		validateCreateJobPageLocale:{
			data:"JobPageLocaleCreateInput"
		},
		validateUpdateJobPageLocale:{
			by:"JobPageLocaleUniqueWhere",
			data:"JobPageLocaleUpdateInput"
		},
		getKeyInfoItem:{
			by:"KeyInfoItemUniqueWhere",
			filter:"KeyInfoItemWhere"
		},
		listKeyInfoItem:{
			filter:"KeyInfoItemWhere",
			orderBy:"KeyInfoItemOrderBy"
		},
		paginateKeyInfoItem:{
			filter:"KeyInfoItemWhere",
			orderBy:"KeyInfoItemOrderBy"
		},
		validateCreateKeyInfoItem:{
			data:"KeyInfoItemCreateInput"
		},
		validateUpdateKeyInfoItem:{
			by:"KeyInfoItemUniqueWhere",
			data:"KeyInfoItemUpdateInput"
		},
		getKeyInfoList:{
			by:"KeyInfoListUniqueWhere",
			filter:"KeyInfoListWhere"
		},
		listKeyInfoList:{
			filter:"KeyInfoListWhere",
			orderBy:"KeyInfoListOrderBy"
		},
		paginateKeyInfoList:{
			filter:"KeyInfoListWhere",
			orderBy:"KeyInfoListOrderBy"
		},
		validateCreateKeyInfoList:{
			data:"KeyInfoListCreateInput"
		},
		validateUpdateKeyInfoList:{
			by:"KeyInfoListUniqueWhere",
			data:"KeyInfoListUpdateInput"
		},
		getContractType:{
			by:"ContractTypeUniqueWhere",
			filter:"ContractTypeWhere"
		},
		listContractType:{
			filter:"ContractTypeWhere",
			orderBy:"ContractTypeOrderBy"
		},
		paginateContractType:{
			filter:"ContractTypeWhere",
			orderBy:"ContractTypeOrderBy"
		},
		validateCreateContractType:{
			data:"ContractTypeCreateInput"
		},
		validateUpdateContractType:{
			by:"ContractTypeUniqueWhere",
			data:"ContractTypeUpdateInput"
		},
		getContractTypeLocale:{
			by:"ContractTypeLocaleUniqueWhere",
			filter:"ContractTypeLocaleWhere"
		},
		listContractTypeLocale:{
			filter:"ContractTypeLocaleWhere",
			orderBy:"ContractTypeLocaleOrderBy"
		},
		paginateContractTypeLocale:{
			filter:"ContractTypeLocaleWhere",
			orderBy:"ContractTypeLocaleOrderBy"
		},
		validateCreateContractTypeLocale:{
			data:"ContractTypeLocaleCreateInput"
		},
		validateUpdateContractTypeLocale:{
			by:"ContractTypeLocaleUniqueWhere",
			data:"ContractTypeLocaleUpdateInput"
		},
		getJobCity:{
			by:"JobCityUniqueWhere",
			filter:"JobCityWhere"
		},
		listJobCity:{
			filter:"JobCityWhere",
			orderBy:"JobCityOrderBy"
		},
		paginateJobCity:{
			filter:"JobCityWhere",
			orderBy:"JobCityOrderBy"
		},
		validateCreateJobCity:{
			data:"JobCityCreateInput"
		},
		validateUpdateJobCity:{
			by:"JobCityUniqueWhere",
			data:"JobCityUpdateInput"
		},
		getJobCityLocale:{
			by:"JobCityLocaleUniqueWhere",
			filter:"JobCityLocaleWhere"
		},
		listJobCityLocale:{
			filter:"JobCityLocaleWhere",
			orderBy:"JobCityLocaleOrderBy"
		},
		paginateJobCityLocale:{
			filter:"JobCityLocaleWhere",
			orderBy:"JobCityLocaleOrderBy"
		},
		validateCreateJobCityLocale:{
			data:"JobCityLocaleCreateInput"
		},
		validateUpdateJobCityLocale:{
			by:"JobCityLocaleUniqueWhere",
			data:"JobCityLocaleUpdateInput"
		},
		getJobPosition:{
			by:"JobPositionUniqueWhere",
			filter:"JobPositionWhere"
		},
		listJobPosition:{
			filter:"JobPositionWhere",
			orderBy:"JobPositionOrderBy"
		},
		paginateJobPosition:{
			filter:"JobPositionWhere",
			orderBy:"JobPositionOrderBy"
		},
		validateCreateJobPosition:{
			data:"JobPositionCreateInput"
		},
		validateUpdateJobPosition:{
			by:"JobPositionUniqueWhere",
			data:"JobPositionUpdateInput"
		},
		getJobPositionLocale:{
			by:"JobPositionLocaleUniqueWhere",
			filter:"JobPositionLocaleWhere"
		},
		listJobPositionLocale:{
			filter:"JobPositionLocaleWhere",
			orderBy:"JobPositionLocaleOrderBy"
		},
		paginateJobPositionLocale:{
			filter:"JobPositionLocaleWhere",
			orderBy:"JobPositionLocaleOrderBy"
		},
		validateCreateJobPositionLocale:{
			data:"JobPositionLocaleCreateInput"
		},
		validateUpdateJobPositionLocale:{
			by:"JobPositionLocaleUniqueWhere",
			data:"JobPositionLocaleUpdateInput"
		},
		getGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere"
		},
		listGallery:{
			filter:"GalleryWhere",
			orderBy:"GalleryOrderBy"
		},
		paginateGallery:{
			filter:"GalleryWhere",
			orderBy:"GalleryOrderBy"
		},
		validateCreateGallery:{
			data:"GalleryCreateInput"
		},
		validateUpdateGallery:{
			by:"GalleryUniqueWhere",
			data:"GalleryUpdateInput"
		},
		getHomePage:{
			by:"HomePageUniqueWhere",
			filter:"HomePageWhere"
		},
		listHomePage:{
			filter:"HomePageWhere",
			orderBy:"HomePageOrderBy"
		},
		paginateHomePage:{
			filter:"HomePageWhere",
			orderBy:"HomePageOrderBy"
		},
		validateCreateHomePage:{
			data:"HomePageCreateInput"
		},
		validateUpdateHomePage:{
			by:"HomePageUniqueWhere",
			data:"HomePageUpdateInput"
		},
		getHomePageLocale:{
			by:"HomePageLocaleUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		listHomePageLocale:{
			filter:"HomePageLocaleWhere",
			orderBy:"HomePageLocaleOrderBy"
		},
		paginateHomePageLocale:{
			filter:"HomePageLocaleWhere",
			orderBy:"HomePageLocaleOrderBy"
		},
		validateCreateHomePageLocale:{
			data:"HomePageLocaleCreateInput"
		},
		validateUpdateHomePageLocale:{
			by:"HomePageLocaleUniqueWhere",
			data:"HomePageLocaleUpdateInput"
		},
		getMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		listMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		paginateMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		validateCreateMedium:{
			data:"MediumCreateInput"
		},
		validateUpdateMedium:{
			by:"MediumUniqueWhere",
			data:"MediumUpdateInput"
		},
		getMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere"
		},
		listMediumItem:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		},
		paginateMediumItem:{
			filter:"MediumItemWhere",
			orderBy:"MediumItemOrderBy"
		},
		validateCreateMediumItem:{
			data:"MediumItemCreateInput"
		},
		validateUpdateMediumItem:{
			by:"MediumItemUniqueWhere",
			data:"MediumItemUpdateInput"
		},
		getMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere"
		},
		listMediumList:{
			filter:"MediumListWhere",
			orderBy:"MediumListOrderBy"
		},
		paginateMediumList:{
			filter:"MediumListWhere",
			orderBy:"MediumListOrderBy"
		},
		validateCreateMediumList:{
			data:"MediumListCreateInput"
		},
		validateUpdateMediumList:{
			by:"MediumListUniqueWhere",
			data:"MediumListUpdateInput"
		},
		getVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		listVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		paginateVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		validateCreateVideo:{
			data:"VideoCreateInput"
		},
		validateUpdateVideo:{
			by:"VideoUniqueWhere",
			data:"VideoUpdateInput"
		},
		getTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere"
		},
		listTextItem:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		},
		paginateTextItem:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		},
		validateCreateTextItem:{
			data:"TextItemCreateInput"
		},
		validateUpdateTextItem:{
			by:"TextItemUniqueWhere",
			data:"TextItemUpdateInput"
		},
		getTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere"
		},
		listTextList:{
			filter:"TextListWhere",
			orderBy:"TextListOrderBy"
		},
		paginateTextList:{
			filter:"TextListWhere",
			orderBy:"TextListOrderBy"
		},
		validateCreateTextList:{
			data:"TextListCreateInput"
		},
		validateUpdateTextList:{
			by:"TextListUniqueWhere",
			data:"TextListUpdateInput"
		},
		getCarousel:{
			by:"CarouselUniqueWhere",
			filter:"CarouselWhere"
		},
		listCarousel:{
			filter:"CarouselWhere",
			orderBy:"CarouselOrderBy"
		},
		paginateCarousel:{
			filter:"CarouselWhere",
			orderBy:"CarouselOrderBy"
		},
		validateCreateCarousel:{
			data:"CarouselCreateInput"
		},
		validateUpdateCarousel:{
			by:"CarouselUniqueWhere",
			data:"CarouselUpdateInput"
		},
		getCarouselItem:{
			by:"CarouselItemUniqueWhere",
			filter:"CarouselItemWhere"
		},
		listCarouselItem:{
			filter:"CarouselItemWhere",
			orderBy:"CarouselItemOrderBy"
		},
		paginateCarouselItem:{
			filter:"CarouselItemWhere",
			orderBy:"CarouselItemOrderBy"
		},
		validateCreateCarouselItem:{
			data:"CarouselItemCreateInput"
		},
		validateUpdateCarouselItem:{
			by:"CarouselItemUniqueWhere",
			data:"CarouselItemUpdateInput"
		},
		getTheme:{
			by:"ThemeUniqueWhere",
			filter:"ThemeWhere"
		},
		listTheme:{
			filter:"ThemeWhere",
			orderBy:"ThemeOrderBy"
		},
		paginateTheme:{
			filter:"ThemeWhere",
			orderBy:"ThemeOrderBy"
		},
		validateCreateTheme:{
			data:"ThemeCreateInput"
		},
		validateUpdateTheme:{
			by:"ThemeUniqueWhere",
			data:"ThemeUpdateInput"
		},
		getBonusBanner:{
			by:"BonusBannerUniqueWhere",
			filter:"BonusBannerWhere"
		},
		listBonusBanner:{
			filter:"BonusBannerWhere",
			orderBy:"BonusBannerOrderBy"
		},
		paginateBonusBanner:{
			filter:"BonusBannerWhere",
			orderBy:"BonusBannerOrderBy"
		},
		validateCreateBonusBanner:{
			data:"BonusBannerCreateInput"
		},
		validateUpdateBonusBanner:{
			by:"BonusBannerUniqueWhere",
			data:"BonusBannerUpdateInput"
		},
		getBonusBannerLocale:{
			by:"BonusBannerLocaleUniqueWhere",
			filter:"BonusBannerLocaleWhere"
		},
		listBonusBannerLocale:{
			filter:"BonusBannerLocaleWhere",
			orderBy:"BonusBannerLocaleOrderBy"
		},
		paginateBonusBannerLocale:{
			filter:"BonusBannerLocaleWhere",
			orderBy:"BonusBannerLocaleOrderBy"
		},
		validateCreateBonusBannerLocale:{
			data:"BonusBannerLocaleCreateInput"
		},
		validateUpdateBonusBannerLocale:{
			by:"BonusBannerLocaleUniqueWhere",
			data:"BonusBannerLocaleUpdateInput"
		},
		getTile:{
			by:"TileUniqueWhere",
			filter:"TileWhere"
		},
		listTile:{
			filter:"TileWhere",
			orderBy:"TileOrderBy"
		},
		paginateTile:{
			filter:"TileWhere",
			orderBy:"TileOrderBy"
		},
		validateCreateTile:{
			data:"TileCreateInput"
		},
		validateUpdateTile:{
			by:"TileUniqueWhere",
			data:"TileUpdateInput"
		},
		getSideBySide:{
			by:"SideBySideUniqueWhere",
			filter:"SideBySideWhere"
		},
		listSideBySide:{
			filter:"SideBySideWhere",
			orderBy:"SideBySideOrderBy"
		},
		paginateSideBySide:{
			filter:"SideBySideWhere",
			orderBy:"SideBySideOrderBy"
		},
		validateCreateSideBySide:{
			data:"SideBySideCreateInput"
		},
		validateUpdateSideBySide:{
			by:"SideBySideUniqueWhere",
			data:"SideBySideUpdateInput"
		},
		getSideBySideItem:{
			by:"SideBySideItemUniqueWhere",
			filter:"SideBySideItemWhere"
		},
		listSideBySideItem:{
			filter:"SideBySideItemWhere",
			orderBy:"SideBySideItemOrderBy"
		},
		paginateSideBySideItem:{
			filter:"SideBySideItemWhere",
			orderBy:"SideBySideItemOrderBy"
		},
		validateCreateSideBySideItem:{
			data:"SideBySideItemCreateInput"
		},
		validateUpdateSideBySideItem:{
			by:"SideBySideItemUniqueWhere",
			data:"SideBySideItemUpdateInput"
		},
		getHomePageLokal:{
			by:"HomePageLokalUniqueWhere",
			filter:"HomePageLokalWhere"
		},
		listHomePageLokal:{
			filter:"HomePageLokalWhere",
			orderBy:"HomePageLokalOrderBy"
		},
		paginateHomePageLokal:{
			filter:"HomePageLokalWhere",
			orderBy:"HomePageLokalOrderBy"
		},
		validateCreateHomePageLokal:{
			data:"HomePageLokalCreateInput"
		},
		validateUpdateHomePageLokal:{
			by:"HomePageLokalUniqueWhere",
			data:"HomePageLokalUpdateInput"
		},
		getHomePageLokalLocale:{
			by:"HomePageLokalLocaleUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		listHomePageLokalLocale:{
			filter:"HomePageLokalLocaleWhere",
			orderBy:"HomePageLokalLocaleOrderBy"
		},
		paginateHomePageLokalLocale:{
			filter:"HomePageLokalLocaleWhere",
			orderBy:"HomePageLokalLocaleOrderBy"
		},
		validateCreateHomePageLokalLocale:{
			data:"HomePageLokalLocaleCreateInput"
		},
		validateUpdateHomePageLokalLocale:{
			by:"HomePageLokalLocaleUniqueWhere",
			data:"HomePageLokalLocaleUpdateInput"
		},
		getSiteSwitcher:{
			by:"SiteSwitcherUniqueWhere",
			filter:"SiteSwitcherWhere"
		},
		listSiteSwitcher:{
			filter:"SiteSwitcherWhere",
			orderBy:"SiteSwitcherOrderBy"
		},
		paginateSiteSwitcher:{
			filter:"SiteSwitcherWhere",
			orderBy:"SiteSwitcherOrderBy"
		},
		validateCreateSiteSwitcher:{
			data:"SiteSwitcherCreateInput"
		},
		validateUpdateSiteSwitcher:{
			by:"SiteSwitcherUniqueWhere",
			data:"SiteSwitcherUpdateInput"
		},
		getGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere"
		},
		listGalleryItem:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		},
		paginateGalleryItem:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		},
		validateCreateGalleryItem:{
			data:"GalleryItemCreateInput"
		},
		validateUpdateGalleryItem:{
			by:"GalleryItemUniqueWhere",
			data:"GalleryItemUpdateInput"
		},
		getJobsForm:{
			by:"JobsFormUniqueWhere",
			filter:"JobsFormWhere"
		},
		listJobsForm:{
			filter:"JobsFormWhere",
			orderBy:"JobsFormOrderBy"
		},
		paginateJobsForm:{
			filter:"JobsFormWhere",
			orderBy:"JobsFormOrderBy"
		},
		validateCreateJobsForm:{
			data:"JobsFormCreateInput"
		},
		validateUpdateJobsForm:{
			by:"JobsFormUniqueWhere",
			data:"JobsFormUpdateInput"
		},
		getJobsFormLocale:{
			by:"JobsFormLocaleUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		listJobsFormLocale:{
			filter:"JobsFormLocaleWhere",
			orderBy:"JobsFormLocaleOrderBy"
		},
		paginateJobsFormLocale:{
			filter:"JobsFormLocaleWhere",
			orderBy:"JobsFormLocaleOrderBy"
		},
		validateCreateJobsFormLocale:{
			data:"JobsFormLocaleCreateInput"
		},
		validateUpdateJobsFormLocale:{
			by:"JobsFormLocaleUniqueWhere",
			data:"JobsFormLocaleUpdateInput"
		},
		getImageTextItem:{
			by:"ImageTextItemUniqueWhere",
			filter:"ImageTextItemWhere"
		},
		listImageTextItem:{
			filter:"ImageTextItemWhere",
			orderBy:"ImageTextItemOrderBy"
		},
		paginateImageTextItem:{
			filter:"ImageTextItemWhere",
			orderBy:"ImageTextItemOrderBy"
		},
		validateCreateImageTextItem:{
			data:"ImageTextItemCreateInput"
		},
		validateUpdateImageTextItem:{
			by:"ImageTextItemUniqueWhere",
			data:"ImageTextItemUpdateInput"
		},
		getImageTextList:{
			by:"ImageTextListUniqueWhere",
			filter:"ImageTextListWhere"
		},
		listImageTextList:{
			filter:"ImageTextListWhere",
			orderBy:"ImageTextListOrderBy"
		},
		paginateImageTextList:{
			filter:"ImageTextListWhere",
			orderBy:"ImageTextListOrderBy"
		},
		validateCreateImageTextList:{
			data:"ImageTextListCreateInput"
		},
		validateUpdateImageTextList:{
			by:"ImageTextListUniqueWhere",
			data:"ImageTextListUpdateInput"
		},
		getJobsFilter:{
			by:"JobsFilterUniqueWhere",
			filter:"JobsFilterWhere"
		},
		listJobsFilter:{
			filter:"JobsFilterWhere",
			orderBy:"JobsFilterOrderBy"
		},
		paginateJobsFilter:{
			filter:"JobsFilterWhere",
			orderBy:"JobsFilterOrderBy"
		},
		validateCreateJobsFilter:{
			data:"JobsFilterCreateInput"
		},
		validateUpdateJobsFilter:{
			by:"JobsFilterUniqueWhere",
			data:"JobsFilterUpdateInput"
		},
		getJobsFilterLocale:{
			by:"JobsFilterLocaleUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		listJobsFilterLocale:{
			filter:"JobsFilterLocaleWhere",
			orderBy:"JobsFilterLocaleOrderBy"
		},
		paginateJobsFilterLocale:{
			filter:"JobsFilterLocaleWhere",
			orderBy:"JobsFilterLocaleOrderBy"
		},
		validateCreateJobsFilterLocale:{
			data:"JobsFilterLocaleCreateInput"
		},
		validateUpdateJobsFilterLocale:{
			by:"JobsFilterLocaleUniqueWhere",
			data:"JobsFilterLocaleUpdateInput"
		},
		getFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere"
		},
		listFile:{
			filter:"FileWhere",
			orderBy:"FileOrderBy"
		},
		paginateFile:{
			filter:"FileWhere",
			orderBy:"FileOrderBy"
		},
		validateCreateFile:{
			data:"FileCreateInput"
		},
		validateUpdateFile:{
			by:"FileUniqueWhere",
			data:"FileUpdateInput"
		},
		getJobFormSubscription:{
			by:"JobFormSubscriptionUniqueWhere",
			filter:"JobFormSubscriptionWhere"
		},
		listJobFormSubscription:{
			filter:"JobFormSubscriptionWhere",
			orderBy:"JobFormSubscriptionOrderBy"
		},
		paginateJobFormSubscription:{
			filter:"JobFormSubscriptionWhere",
			orderBy:"JobFormSubscriptionOrderBy"
		},
		validateCreateJobFormSubscription:{
			data:"JobFormSubscriptionCreateInput"
		},
		validateUpdateJobFormSubscription:{
			by:"JobFormSubscriptionUniqueWhere",
			data:"JobFormSubscriptionUpdateInput"
		},
		getImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere"
		},
		listImageList:{
			filter:"ImageListWhere",
			orderBy:"ImageListOrderBy"
		},
		paginateImageList:{
			filter:"ImageListWhere",
			orderBy:"ImageListOrderBy"
		},
		validateCreateImageList:{
			data:"ImageListCreateInput"
		},
		validateUpdateImageList:{
			by:"ImageListUniqueWhere",
			data:"ImageListUpdateInput"
		},
		getImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere"
		},
		listImageListItem:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		},
		paginateImageListItem:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		},
		validateCreateImageListItem:{
			data:"ImageListItemCreateInput"
		},
		validateUpdateImageListItem:{
			by:"ImageListItemUniqueWhere",
			data:"ImageListItemUpdateInput"
		},
		getJobFormSubscriptionStatus:{
			by:"JobFormSubscriptionStatusUniqueWhere",
			filter:"JobFormSubscriptionStatusWhere"
		},
		listJobFormSubscriptionStatus:{
			filter:"JobFormSubscriptionStatusWhere",
			orderBy:"JobFormSubscriptionStatusOrderBy"
		},
		paginateJobFormSubscriptionStatus:{
			filter:"JobFormSubscriptionStatusWhere",
			orderBy:"JobFormSubscriptionStatusOrderBy"
		},
		validateCreateJobFormSubscriptionStatus:{
			data:"JobFormSubscriptionStatusCreateInput"
		},
		validateUpdateJobFormSubscriptionStatus:{
			by:"JobFormSubscriptionStatusUniqueWhere",
			data:"JobFormSubscriptionStatusUpdateInput"
		},
		getGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		listGeneralLocale:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		paginateGeneralLocale:{
			filter:"GeneralLocaleWhere",
			orderBy:"GeneralLocaleOrderBy"
		},
		validateCreateGeneralLocale:{
			data:"GeneralLocaleCreateInput"
		},
		validateUpdateGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			data:"GeneralLocaleUpdateInput"
		},
		getStickyBar:{
			by:"StickyBarUniqueWhere",
			filter:"StickyBarWhere"
		},
		listStickyBar:{
			filter:"StickyBarWhere",
			orderBy:"StickyBarOrderBy"
		},
		paginateStickyBar:{
			filter:"StickyBarWhere",
			orderBy:"StickyBarOrderBy"
		},
		validateCreateStickyBar:{
			data:"StickyBarCreateInput"
		},
		validateUpdateStickyBar:{
			by:"StickyBarUniqueWhere",
			data:"StickyBarUpdateInput"
		},
		getRecommendationForm:{
			by:"RecommendationFormUniqueWhere",
			filter:"RecommendationFormWhere"
		},
		listRecommendationForm:{
			filter:"RecommendationFormWhere",
			orderBy:"RecommendationFormOrderBy"
		},
		paginateRecommendationForm:{
			filter:"RecommendationFormWhere",
			orderBy:"RecommendationFormOrderBy"
		},
		validateCreateRecommendationForm:{
			data:"RecommendationFormCreateInput"
		},
		validateUpdateRecommendationForm:{
			by:"RecommendationFormUniqueWhere",
			data:"RecommendationFormUpdateInput"
		},
		getRecommendationFormLocale:{
			by:"RecommendationFormLocaleUniqueWhere",
			filter:"RecommendationFormLocaleWhere"
		},
		listRecommendationFormLocale:{
			filter:"RecommendationFormLocaleWhere",
			orderBy:"RecommendationFormLocaleOrderBy"
		},
		paginateRecommendationFormLocale:{
			filter:"RecommendationFormLocaleWhere",
			orderBy:"RecommendationFormLocaleOrderBy"
		},
		validateCreateRecommendationFormLocale:{
			data:"RecommendationFormLocaleCreateInput"
		},
		validateUpdateRecommendationFormLocale:{
			by:"RecommendationFormLocaleUniqueWhere",
			data:"RecommendationFormLocaleUpdateInput"
		},
		getRecommendationFormSubscription:{
			by:"RecommendationFormSubscriptionUniqueWhere",
			filter:"RecommendationFormSubscriptionWhere"
		},
		listRecommendationFormSubscription:{
			filter:"RecommendationFormSubscriptionWhere",
			orderBy:"RecommendationFormSubscriptionOrderBy"
		},
		paginateRecommendationFormSubscription:{
			filter:"RecommendationFormSubscriptionWhere",
			orderBy:"RecommendationFormSubscriptionOrderBy"
		},
		validateCreateRecommendationFormSubscription:{
			data:"RecommendationFormSubscriptionCreateInput"
		},
		validateUpdateRecommendationFormSubscription:{
			by:"RecommendationFormSubscriptionUniqueWhere",
			data:"RecommendationFormSubscriptionUpdateInput"
		},
		getInfoBox:{
			by:"InfoBoxUniqueWhere",
			filter:"InfoBoxWhere"
		},
		listInfoBox:{
			filter:"InfoBoxWhere",
			orderBy:"InfoBoxOrderBy"
		},
		paginateInfoBox:{
			filter:"InfoBoxWhere",
			orderBy:"InfoBoxOrderBy"
		},
		validateCreateInfoBox:{
			data:"InfoBoxCreateInput"
		},
		validateUpdateInfoBox:{
			by:"InfoBoxUniqueWhere",
			data:"InfoBoxUpdateInput"
		},
		getInfoBoxLocale:{
			by:"InfoBoxLocaleUniqueWhere",
			filter:"InfoBoxLocaleWhere"
		},
		listInfoBoxLocale:{
			filter:"InfoBoxLocaleWhere",
			orderBy:"InfoBoxLocaleOrderBy"
		},
		paginateInfoBoxLocale:{
			filter:"InfoBoxLocaleWhere",
			orderBy:"InfoBoxLocaleOrderBy"
		},
		validateCreateInfoBoxLocale:{
			data:"InfoBoxLocaleCreateInput"
		},
		validateUpdateInfoBoxLocale:{
			by:"InfoBoxLocaleUniqueWhere",
			data:"InfoBoxLocaleUpdateInput"
		},
		getTranslation:{
			by:"TranslationUniqueWhere",
			filter:"TranslationWhere"
		},
		listTranslation:{
			filter:"TranslationWhere",
			orderBy:"TranslationOrderBy"
		},
		paginateTranslation:{
			filter:"TranslationWhere",
			orderBy:"TranslationOrderBy"
		},
		validateCreateTranslation:{
			data:"TranslationCreateInput"
		},
		validateUpdateTranslation:{
			by:"TranslationUniqueWhere",
			data:"TranslationUpdateInput"
		},
		getTranslationLocale:{
			by:"TranslationLocaleUniqueWhere",
			filter:"TranslationLocaleWhere"
		},
		listTranslationLocale:{
			filter:"TranslationLocaleWhere",
			orderBy:"TranslationLocaleOrderBy"
		},
		paginateTranslationLocale:{
			filter:"TranslationLocaleWhere",
			orderBy:"TranslationLocaleOrderBy"
		},
		validateCreateTranslationLocale:{
			data:"TranslationLocaleCreateInput"
		},
		validateUpdateTranslationLocale:{
			by:"TranslationLocaleUniqueWhere",
			data:"TranslationLocaleUpdateInput"
		},
		getCornerBanner:{
			by:"CornerBannerUniqueWhere",
			filter:"CornerBannerWhere"
		},
		listCornerBanner:{
			filter:"CornerBannerWhere",
			orderBy:"CornerBannerOrderBy"
		},
		paginateCornerBanner:{
			filter:"CornerBannerWhere",
			orderBy:"CornerBannerOrderBy"
		},
		validateCreateCornerBanner:{
			data:"CornerBannerCreateInput"
		},
		validateUpdateCornerBanner:{
			by:"CornerBannerUniqueWhere",
			data:"CornerBannerUpdateInput"
		}
	},
	Mutation:{
		generateUploadUrl:{
			input:"S3GenerateSignedUploadInput"
		},
		generateReadUrl:{

		},
		createGeneral:{
			data:"GeneralCreateInput"
		},
		deleteGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere"
		},
		updateGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere",
			data:"GeneralUpdateInput"
		},
		upsertGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere",
			update:"GeneralUpdateInput",
			create:"GeneralCreateInput"
		},
		createImage:{
			data:"ImageCreateInput"
		},
		deleteImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		updateImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			data:"ImageUpdateInput"
		},
		upsertImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			update:"ImageUpdateInput",
			create:"ImageCreateInput"
		},
		createGenericPage:{
			data:"GenericPageCreateInput"
		},
		deleteGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere"
		},
		updateGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere",
			data:"GenericPageUpdateInput"
		},
		upsertGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere",
			update:"GenericPageUpdateInput",
			create:"GenericPageCreateInput"
		},
		createLinkable:{
			data:"LinkableCreateInput"
		},
		deleteLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		updateLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			data:"LinkableUpdateInput"
		},
		upsertLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			update:"LinkableUpdateInput",
			create:"LinkableCreateInput"
		},
		createSeo:{
			data:"SeoCreateInput"
		},
		deleteSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		updateSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			data:"SeoUpdateInput"
		},
		upsertSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			update:"SeoUpdateInput",
			create:"SeoCreateInput"
		},
		createContent:{
			data:"ContentCreateInput"
		},
		deleteContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		updateContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			data:"ContentUpdateInput"
		},
		upsertContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			update:"ContentUpdateInput",
			create:"ContentCreateInput"
		},
		createContentBlock:{
			data:"ContentBlockCreateInput"
		},
		deleteContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		updateContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			data:"ContentBlockUpdateInput"
		},
		upsertContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			update:"ContentBlockUpdateInput",
			create:"ContentBlockCreateInput"
		},
		createContentReference:{
			data:"ContentReferenceCreateInput"
		},
		deleteContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		updateContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			data:"ContentReferenceUpdateInput"
		},
		upsertContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			update:"ContentReferenceUpdateInput",
			create:"ContentReferenceCreateInput"
		},
		createRedirect:{
			data:"RedirectCreateInput"
		},
		deleteRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere"
		},
		updateRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere",
			data:"RedirectUpdateInput"
		},
		upsertRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere",
			update:"RedirectUpdateInput",
			create:"RedirectCreateInput"
		},
		createLink:{
			data:"LinkCreateInput"
		},
		deleteLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		updateLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			data:"LinkUpdateInput"
		},
		upsertLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			update:"LinkUpdateInput",
			create:"LinkCreateInput"
		},
		createFooter:{
			data:"FooterCreateInput"
		},
		deleteFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere"
		},
		updateFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere",
			data:"FooterUpdateInput"
		},
		upsertFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere",
			update:"FooterUpdateInput",
			create:"FooterCreateInput"
		},
		createFooterLink:{
			data:"FooterLinkCreateInput"
		},
		deleteFooterLink:{
			by:"FooterLinkUniqueWhere",
			filter:"FooterLinkWhere"
		},
		updateFooterLink:{
			by:"FooterLinkUniqueWhere",
			filter:"FooterLinkWhere",
			data:"FooterLinkUpdateInput"
		},
		upsertFooterLink:{
			by:"FooterLinkUniqueWhere",
			filter:"FooterLinkWhere",
			update:"FooterLinkUpdateInput",
			create:"FooterLinkCreateInput"
		},
		createFooterLocale:{
			data:"FooterLocaleCreateInput"
		},
		deleteFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		updateFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere",
			data:"FooterLocaleUpdateInput"
		},
		upsertFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere",
			update:"FooterLocaleUpdateInput",
			create:"FooterLocaleCreateInput"
		},
		createGenericPageLocale:{
			data:"GenericPageLocaleCreateInput"
		},
		deleteGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		updateGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere",
			data:"GenericPageLocaleUpdateInput"
		},
		upsertGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere",
			update:"GenericPageLocaleUpdateInput",
			create:"GenericPageLocaleCreateInput"
		},
		createHeader:{
			data:"HeaderCreateInput"
		},
		deleteHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere"
		},
		updateHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere",
			data:"HeaderUpdateInput"
		},
		upsertHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere",
			update:"HeaderUpdateInput",
			create:"HeaderCreateInput"
		},
		createHeaderLocale:{
			data:"HeaderLocaleCreateInput"
		},
		deleteHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		updateHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere",
			data:"HeaderLocaleUpdateInput"
		},
		upsertHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere",
			update:"HeaderLocaleUpdateInput",
			create:"HeaderLocaleCreateInput"
		},
		createLocale:{
			data:"LocaleCreateInput"
		},
		deleteLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		updateLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			data:"LocaleUpdateInput"
		},
		upsertLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			update:"LocaleUpdateInput",
			create:"LocaleCreateInput"
		},
		createSeoDefault:{
			data:"SeoDefaultCreateInput"
		},
		deleteSeoDefault:{
			by:"SeoDefaultUniqueWhere",
			filter:"SeoDefaultWhere"
		},
		updateSeoDefault:{
			by:"SeoDefaultUniqueWhere",
			filter:"SeoDefaultWhere",
			data:"SeoDefaultUpdateInput"
		},
		upsertSeoDefault:{
			by:"SeoDefaultUniqueWhere",
			filter:"SeoDefaultWhere",
			update:"SeoDefaultUpdateInput",
			create:"SeoDefaultCreateInput"
		},
		createSeoDefaultLocale:{
			data:"SeoDefaultLocaleCreateInput"
		},
		deleteSeoDefaultLocale:{
			by:"SeoDefaultLocaleUniqueWhere",
			filter:"SeoDefaultLocaleWhere"
		},
		updateSeoDefaultLocale:{
			by:"SeoDefaultLocaleUniqueWhere",
			filter:"SeoDefaultLocaleWhere",
			data:"SeoDefaultLocaleUpdateInput"
		},
		upsertSeoDefaultLocale:{
			by:"SeoDefaultLocaleUniqueWhere",
			filter:"SeoDefaultLocaleWhere",
			update:"SeoDefaultLocaleUpdateInput",
			create:"SeoDefaultLocaleCreateInput"
		},
		createBusiness:{
			data:"BusinessCreateInput"
		},
		deleteBusiness:{
			by:"BusinessUniqueWhere",
			filter:"BusinessWhere"
		},
		updateBusiness:{
			by:"BusinessUniqueWhere",
			filter:"BusinessWhere",
			data:"BusinessUpdateInput"
		},
		upsertBusiness:{
			by:"BusinessUniqueWhere",
			filter:"BusinessWhere",
			update:"BusinessUpdateInput",
			create:"BusinessCreateInput"
		},
		createBusinessPage:{
			data:"BusinessPageCreateInput"
		},
		deleteBusinessPage:{
			by:"BusinessPageUniqueWhere",
			filter:"BusinessPageWhere"
		},
		updateBusinessPage:{
			by:"BusinessPageUniqueWhere",
			filter:"BusinessPageWhere",
			data:"BusinessPageUpdateInput"
		},
		upsertBusinessPage:{
			by:"BusinessPageUniqueWhere",
			filter:"BusinessPageWhere",
			update:"BusinessPageUpdateInput",
			create:"BusinessPageCreateInput"
		},
		createBusinessPageLocale:{
			data:"BusinessPageLocaleCreateInput"
		},
		deleteBusinessPageLocale:{
			by:"BusinessPageLocaleUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		updateBusinessPageLocale:{
			by:"BusinessPageLocaleUniqueWhere",
			filter:"BusinessPageLocaleWhere",
			data:"BusinessPageLocaleUpdateInput"
		},
		upsertBusinessPageLocale:{
			by:"BusinessPageLocaleUniqueWhere",
			filter:"BusinessPageLocaleWhere",
			update:"BusinessPageLocaleUpdateInput",
			create:"BusinessPageLocaleCreateInput"
		},
		createIcon:{
			data:"IconCreateInput"
		},
		deleteIcon:{
			by:"IconUniqueWhere",
			filter:"IconWhere"
		},
		updateIcon:{
			by:"IconUniqueWhere",
			filter:"IconWhere",
			data:"IconUpdateInput"
		},
		upsertIcon:{
			by:"IconUniqueWhere",
			filter:"IconWhere",
			update:"IconUpdateInput",
			create:"IconCreateInput"
		},
		createJobPage:{
			data:"JobPageCreateInput"
		},
		deleteJobPage:{
			by:"JobPageUniqueWhere",
			filter:"JobPageWhere"
		},
		updateJobPage:{
			by:"JobPageUniqueWhere",
			filter:"JobPageWhere",
			data:"JobPageUpdateInput"
		},
		upsertJobPage:{
			by:"JobPageUniqueWhere",
			filter:"JobPageWhere",
			update:"JobPageUpdateInput",
			create:"JobPageCreateInput"
		},
		createJobPageLocale:{
			data:"JobPageLocaleCreateInput"
		},
		deleteJobPageLocale:{
			by:"JobPageLocaleUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		updateJobPageLocale:{
			by:"JobPageLocaleUniqueWhere",
			filter:"JobPageLocaleWhere",
			data:"JobPageLocaleUpdateInput"
		},
		upsertJobPageLocale:{
			by:"JobPageLocaleUniqueWhere",
			filter:"JobPageLocaleWhere",
			update:"JobPageLocaleUpdateInput",
			create:"JobPageLocaleCreateInput"
		},
		createKeyInfoItem:{
			data:"KeyInfoItemCreateInput"
		},
		deleteKeyInfoItem:{
			by:"KeyInfoItemUniqueWhere",
			filter:"KeyInfoItemWhere"
		},
		updateKeyInfoItem:{
			by:"KeyInfoItemUniqueWhere",
			filter:"KeyInfoItemWhere",
			data:"KeyInfoItemUpdateInput"
		},
		upsertKeyInfoItem:{
			by:"KeyInfoItemUniqueWhere",
			filter:"KeyInfoItemWhere",
			update:"KeyInfoItemUpdateInput",
			create:"KeyInfoItemCreateInput"
		},
		createKeyInfoList:{
			data:"KeyInfoListCreateInput"
		},
		deleteKeyInfoList:{
			by:"KeyInfoListUniqueWhere",
			filter:"KeyInfoListWhere"
		},
		updateKeyInfoList:{
			by:"KeyInfoListUniqueWhere",
			filter:"KeyInfoListWhere",
			data:"KeyInfoListUpdateInput"
		},
		upsertKeyInfoList:{
			by:"KeyInfoListUniqueWhere",
			filter:"KeyInfoListWhere",
			update:"KeyInfoListUpdateInput",
			create:"KeyInfoListCreateInput"
		},
		createContractType:{
			data:"ContractTypeCreateInput"
		},
		deleteContractType:{
			by:"ContractTypeUniqueWhere",
			filter:"ContractTypeWhere"
		},
		updateContractType:{
			by:"ContractTypeUniqueWhere",
			filter:"ContractTypeWhere",
			data:"ContractTypeUpdateInput"
		},
		upsertContractType:{
			by:"ContractTypeUniqueWhere",
			filter:"ContractTypeWhere",
			update:"ContractTypeUpdateInput",
			create:"ContractTypeCreateInput"
		},
		createContractTypeLocale:{
			data:"ContractTypeLocaleCreateInput"
		},
		deleteContractTypeLocale:{
			by:"ContractTypeLocaleUniqueWhere",
			filter:"ContractTypeLocaleWhere"
		},
		updateContractTypeLocale:{
			by:"ContractTypeLocaleUniqueWhere",
			filter:"ContractTypeLocaleWhere",
			data:"ContractTypeLocaleUpdateInput"
		},
		upsertContractTypeLocale:{
			by:"ContractTypeLocaleUniqueWhere",
			filter:"ContractTypeLocaleWhere",
			update:"ContractTypeLocaleUpdateInput",
			create:"ContractTypeLocaleCreateInput"
		},
		createJobCity:{
			data:"JobCityCreateInput"
		},
		deleteJobCity:{
			by:"JobCityUniqueWhere",
			filter:"JobCityWhere"
		},
		updateJobCity:{
			by:"JobCityUniqueWhere",
			filter:"JobCityWhere",
			data:"JobCityUpdateInput"
		},
		upsertJobCity:{
			by:"JobCityUniqueWhere",
			filter:"JobCityWhere",
			update:"JobCityUpdateInput",
			create:"JobCityCreateInput"
		},
		createJobCityLocale:{
			data:"JobCityLocaleCreateInput"
		},
		deleteJobCityLocale:{
			by:"JobCityLocaleUniqueWhere",
			filter:"JobCityLocaleWhere"
		},
		updateJobCityLocale:{
			by:"JobCityLocaleUniqueWhere",
			filter:"JobCityLocaleWhere",
			data:"JobCityLocaleUpdateInput"
		},
		upsertJobCityLocale:{
			by:"JobCityLocaleUniqueWhere",
			filter:"JobCityLocaleWhere",
			update:"JobCityLocaleUpdateInput",
			create:"JobCityLocaleCreateInput"
		},
		createJobPosition:{
			data:"JobPositionCreateInput"
		},
		deleteJobPosition:{
			by:"JobPositionUniqueWhere",
			filter:"JobPositionWhere"
		},
		updateJobPosition:{
			by:"JobPositionUniqueWhere",
			filter:"JobPositionWhere",
			data:"JobPositionUpdateInput"
		},
		upsertJobPosition:{
			by:"JobPositionUniqueWhere",
			filter:"JobPositionWhere",
			update:"JobPositionUpdateInput",
			create:"JobPositionCreateInput"
		},
		createJobPositionLocale:{
			data:"JobPositionLocaleCreateInput"
		},
		deleteJobPositionLocale:{
			by:"JobPositionLocaleUniqueWhere",
			filter:"JobPositionLocaleWhere"
		},
		updateJobPositionLocale:{
			by:"JobPositionLocaleUniqueWhere",
			filter:"JobPositionLocaleWhere",
			data:"JobPositionLocaleUpdateInput"
		},
		upsertJobPositionLocale:{
			by:"JobPositionLocaleUniqueWhere",
			filter:"JobPositionLocaleWhere",
			update:"JobPositionLocaleUpdateInput",
			create:"JobPositionLocaleCreateInput"
		},
		createGallery:{
			data:"GalleryCreateInput"
		},
		deleteGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere"
		},
		updateGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere",
			data:"GalleryUpdateInput"
		},
		upsertGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere",
			update:"GalleryUpdateInput",
			create:"GalleryCreateInput"
		},
		createHomePage:{
			data:"HomePageCreateInput"
		},
		deleteHomePage:{
			by:"HomePageUniqueWhere",
			filter:"HomePageWhere"
		},
		updateHomePage:{
			by:"HomePageUniqueWhere",
			filter:"HomePageWhere",
			data:"HomePageUpdateInput"
		},
		upsertHomePage:{
			by:"HomePageUniqueWhere",
			filter:"HomePageWhere",
			update:"HomePageUpdateInput",
			create:"HomePageCreateInput"
		},
		createHomePageLocale:{
			data:"HomePageLocaleCreateInput"
		},
		deleteHomePageLocale:{
			by:"HomePageLocaleUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		updateHomePageLocale:{
			by:"HomePageLocaleUniqueWhere",
			filter:"HomePageLocaleWhere",
			data:"HomePageLocaleUpdateInput"
		},
		upsertHomePageLocale:{
			by:"HomePageLocaleUniqueWhere",
			filter:"HomePageLocaleWhere",
			update:"HomePageLocaleUpdateInput",
			create:"HomePageLocaleCreateInput"
		},
		createMedium:{
			data:"MediumCreateInput"
		},
		deleteMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		updateMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			data:"MediumUpdateInput"
		},
		upsertMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			update:"MediumUpdateInput",
			create:"MediumCreateInput"
		},
		createMediumItem:{
			data:"MediumItemCreateInput"
		},
		deleteMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere"
		},
		updateMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere",
			data:"MediumItemUpdateInput"
		},
		upsertMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere",
			update:"MediumItemUpdateInput",
			create:"MediumItemCreateInput"
		},
		createMediumList:{
			data:"MediumListCreateInput"
		},
		deleteMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere"
		},
		updateMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere",
			data:"MediumListUpdateInput"
		},
		upsertMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere",
			update:"MediumListUpdateInput",
			create:"MediumListCreateInput"
		},
		createVideo:{
			data:"VideoCreateInput"
		},
		deleteVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		updateVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			data:"VideoUpdateInput"
		},
		upsertVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			update:"VideoUpdateInput",
			create:"VideoCreateInput"
		},
		createTextItem:{
			data:"TextItemCreateInput"
		},
		deleteTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere"
		},
		updateTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere",
			data:"TextItemUpdateInput"
		},
		upsertTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere",
			update:"TextItemUpdateInput",
			create:"TextItemCreateInput"
		},
		createTextList:{
			data:"TextListCreateInput"
		},
		deleteTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere"
		},
		updateTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere",
			data:"TextListUpdateInput"
		},
		upsertTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere",
			update:"TextListUpdateInput",
			create:"TextListCreateInput"
		},
		createCarousel:{
			data:"CarouselCreateInput"
		},
		deleteCarousel:{
			by:"CarouselUniqueWhere",
			filter:"CarouselWhere"
		},
		updateCarousel:{
			by:"CarouselUniqueWhere",
			filter:"CarouselWhere",
			data:"CarouselUpdateInput"
		},
		upsertCarousel:{
			by:"CarouselUniqueWhere",
			filter:"CarouselWhere",
			update:"CarouselUpdateInput",
			create:"CarouselCreateInput"
		},
		createCarouselItem:{
			data:"CarouselItemCreateInput"
		},
		deleteCarouselItem:{
			by:"CarouselItemUniqueWhere",
			filter:"CarouselItemWhere"
		},
		updateCarouselItem:{
			by:"CarouselItemUniqueWhere",
			filter:"CarouselItemWhere",
			data:"CarouselItemUpdateInput"
		},
		upsertCarouselItem:{
			by:"CarouselItemUniqueWhere",
			filter:"CarouselItemWhere",
			update:"CarouselItemUpdateInput",
			create:"CarouselItemCreateInput"
		},
		createTheme:{
			data:"ThemeCreateInput"
		},
		deleteTheme:{
			by:"ThemeUniqueWhere",
			filter:"ThemeWhere"
		},
		updateTheme:{
			by:"ThemeUniqueWhere",
			filter:"ThemeWhere",
			data:"ThemeUpdateInput"
		},
		upsertTheme:{
			by:"ThemeUniqueWhere",
			filter:"ThemeWhere",
			update:"ThemeUpdateInput",
			create:"ThemeCreateInput"
		},
		createBonusBanner:{
			data:"BonusBannerCreateInput"
		},
		deleteBonusBanner:{
			by:"BonusBannerUniqueWhere",
			filter:"BonusBannerWhere"
		},
		updateBonusBanner:{
			by:"BonusBannerUniqueWhere",
			filter:"BonusBannerWhere",
			data:"BonusBannerUpdateInput"
		},
		upsertBonusBanner:{
			by:"BonusBannerUniqueWhere",
			filter:"BonusBannerWhere",
			update:"BonusBannerUpdateInput",
			create:"BonusBannerCreateInput"
		},
		createBonusBannerLocale:{
			data:"BonusBannerLocaleCreateInput"
		},
		deleteBonusBannerLocale:{
			by:"BonusBannerLocaleUniqueWhere",
			filter:"BonusBannerLocaleWhere"
		},
		updateBonusBannerLocale:{
			by:"BonusBannerLocaleUniqueWhere",
			filter:"BonusBannerLocaleWhere",
			data:"BonusBannerLocaleUpdateInput"
		},
		upsertBonusBannerLocale:{
			by:"BonusBannerLocaleUniqueWhere",
			filter:"BonusBannerLocaleWhere",
			update:"BonusBannerLocaleUpdateInput",
			create:"BonusBannerLocaleCreateInput"
		},
		createTile:{
			data:"TileCreateInput"
		},
		deleteTile:{
			by:"TileUniqueWhere",
			filter:"TileWhere"
		},
		updateTile:{
			by:"TileUniqueWhere",
			filter:"TileWhere",
			data:"TileUpdateInput"
		},
		upsertTile:{
			by:"TileUniqueWhere",
			filter:"TileWhere",
			update:"TileUpdateInput",
			create:"TileCreateInput"
		},
		createSideBySide:{
			data:"SideBySideCreateInput"
		},
		deleteSideBySide:{
			by:"SideBySideUniqueWhere",
			filter:"SideBySideWhere"
		},
		updateSideBySide:{
			by:"SideBySideUniqueWhere",
			filter:"SideBySideWhere",
			data:"SideBySideUpdateInput"
		},
		upsertSideBySide:{
			by:"SideBySideUniqueWhere",
			filter:"SideBySideWhere",
			update:"SideBySideUpdateInput",
			create:"SideBySideCreateInput"
		},
		createSideBySideItem:{
			data:"SideBySideItemCreateInput"
		},
		deleteSideBySideItem:{
			by:"SideBySideItemUniqueWhere",
			filter:"SideBySideItemWhere"
		},
		updateSideBySideItem:{
			by:"SideBySideItemUniqueWhere",
			filter:"SideBySideItemWhere",
			data:"SideBySideItemUpdateInput"
		},
		upsertSideBySideItem:{
			by:"SideBySideItemUniqueWhere",
			filter:"SideBySideItemWhere",
			update:"SideBySideItemUpdateInput",
			create:"SideBySideItemCreateInput"
		},
		createHomePageLokal:{
			data:"HomePageLokalCreateInput"
		},
		deleteHomePageLokal:{
			by:"HomePageLokalUniqueWhere",
			filter:"HomePageLokalWhere"
		},
		updateHomePageLokal:{
			by:"HomePageLokalUniqueWhere",
			filter:"HomePageLokalWhere",
			data:"HomePageLokalUpdateInput"
		},
		upsertHomePageLokal:{
			by:"HomePageLokalUniqueWhere",
			filter:"HomePageLokalWhere",
			update:"HomePageLokalUpdateInput",
			create:"HomePageLokalCreateInput"
		},
		createHomePageLokalLocale:{
			data:"HomePageLokalLocaleCreateInput"
		},
		deleteHomePageLokalLocale:{
			by:"HomePageLokalLocaleUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		updateHomePageLokalLocale:{
			by:"HomePageLokalLocaleUniqueWhere",
			filter:"HomePageLokalLocaleWhere",
			data:"HomePageLokalLocaleUpdateInput"
		},
		upsertHomePageLokalLocale:{
			by:"HomePageLokalLocaleUniqueWhere",
			filter:"HomePageLokalLocaleWhere",
			update:"HomePageLokalLocaleUpdateInput",
			create:"HomePageLokalLocaleCreateInput"
		},
		createSiteSwitcher:{
			data:"SiteSwitcherCreateInput"
		},
		deleteSiteSwitcher:{
			by:"SiteSwitcherUniqueWhere",
			filter:"SiteSwitcherWhere"
		},
		updateSiteSwitcher:{
			by:"SiteSwitcherUniqueWhere",
			filter:"SiteSwitcherWhere",
			data:"SiteSwitcherUpdateInput"
		},
		upsertSiteSwitcher:{
			by:"SiteSwitcherUniqueWhere",
			filter:"SiteSwitcherWhere",
			update:"SiteSwitcherUpdateInput",
			create:"SiteSwitcherCreateInput"
		},
		createGalleryItem:{
			data:"GalleryItemCreateInput"
		},
		deleteGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere"
		},
		updateGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere",
			data:"GalleryItemUpdateInput"
		},
		upsertGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere",
			update:"GalleryItemUpdateInput",
			create:"GalleryItemCreateInput"
		},
		createJobsForm:{
			data:"JobsFormCreateInput"
		},
		deleteJobsForm:{
			by:"JobsFormUniqueWhere",
			filter:"JobsFormWhere"
		},
		updateJobsForm:{
			by:"JobsFormUniqueWhere",
			filter:"JobsFormWhere",
			data:"JobsFormUpdateInput"
		},
		upsertJobsForm:{
			by:"JobsFormUniqueWhere",
			filter:"JobsFormWhere",
			update:"JobsFormUpdateInput",
			create:"JobsFormCreateInput"
		},
		createJobsFormLocale:{
			data:"JobsFormLocaleCreateInput"
		},
		deleteJobsFormLocale:{
			by:"JobsFormLocaleUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		updateJobsFormLocale:{
			by:"JobsFormLocaleUniqueWhere",
			filter:"JobsFormLocaleWhere",
			data:"JobsFormLocaleUpdateInput"
		},
		upsertJobsFormLocale:{
			by:"JobsFormLocaleUniqueWhere",
			filter:"JobsFormLocaleWhere",
			update:"JobsFormLocaleUpdateInput",
			create:"JobsFormLocaleCreateInput"
		},
		createImageTextItem:{
			data:"ImageTextItemCreateInput"
		},
		deleteImageTextItem:{
			by:"ImageTextItemUniqueWhere",
			filter:"ImageTextItemWhere"
		},
		updateImageTextItem:{
			by:"ImageTextItemUniqueWhere",
			filter:"ImageTextItemWhere",
			data:"ImageTextItemUpdateInput"
		},
		upsertImageTextItem:{
			by:"ImageTextItemUniqueWhere",
			filter:"ImageTextItemWhere",
			update:"ImageTextItemUpdateInput",
			create:"ImageTextItemCreateInput"
		},
		createImageTextList:{
			data:"ImageTextListCreateInput"
		},
		deleteImageTextList:{
			by:"ImageTextListUniqueWhere",
			filter:"ImageTextListWhere"
		},
		updateImageTextList:{
			by:"ImageTextListUniqueWhere",
			filter:"ImageTextListWhere",
			data:"ImageTextListUpdateInput"
		},
		upsertImageTextList:{
			by:"ImageTextListUniqueWhere",
			filter:"ImageTextListWhere",
			update:"ImageTextListUpdateInput",
			create:"ImageTextListCreateInput"
		},
		createJobsFilter:{
			data:"JobsFilterCreateInput"
		},
		deleteJobsFilter:{
			by:"JobsFilterUniqueWhere",
			filter:"JobsFilterWhere"
		},
		updateJobsFilter:{
			by:"JobsFilterUniqueWhere",
			filter:"JobsFilterWhere",
			data:"JobsFilterUpdateInput"
		},
		upsertJobsFilter:{
			by:"JobsFilterUniqueWhere",
			filter:"JobsFilterWhere",
			update:"JobsFilterUpdateInput",
			create:"JobsFilterCreateInput"
		},
		createJobsFilterLocale:{
			data:"JobsFilterLocaleCreateInput"
		},
		deleteJobsFilterLocale:{
			by:"JobsFilterLocaleUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		updateJobsFilterLocale:{
			by:"JobsFilterLocaleUniqueWhere",
			filter:"JobsFilterLocaleWhere",
			data:"JobsFilterLocaleUpdateInput"
		},
		upsertJobsFilterLocale:{
			by:"JobsFilterLocaleUniqueWhere",
			filter:"JobsFilterLocaleWhere",
			update:"JobsFilterLocaleUpdateInput",
			create:"JobsFilterLocaleCreateInput"
		},
		createFile:{
			data:"FileCreateInput"
		},
		deleteFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere"
		},
		updateFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere",
			data:"FileUpdateInput"
		},
		upsertFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere",
			update:"FileUpdateInput",
			create:"FileCreateInput"
		},
		createJobFormSubscription:{
			data:"JobFormSubscriptionCreateInput"
		},
		deleteJobFormSubscription:{
			by:"JobFormSubscriptionUniqueWhere",
			filter:"JobFormSubscriptionWhere"
		},
		updateJobFormSubscription:{
			by:"JobFormSubscriptionUniqueWhere",
			filter:"JobFormSubscriptionWhere",
			data:"JobFormSubscriptionUpdateInput"
		},
		upsertJobFormSubscription:{
			by:"JobFormSubscriptionUniqueWhere",
			filter:"JobFormSubscriptionWhere",
			update:"JobFormSubscriptionUpdateInput",
			create:"JobFormSubscriptionCreateInput"
		},
		createImageList:{
			data:"ImageListCreateInput"
		},
		deleteImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere"
		},
		updateImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere",
			data:"ImageListUpdateInput"
		},
		upsertImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere",
			update:"ImageListUpdateInput",
			create:"ImageListCreateInput"
		},
		createImageListItem:{
			data:"ImageListItemCreateInput"
		},
		deleteImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere"
		},
		updateImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere",
			data:"ImageListItemUpdateInput"
		},
		upsertImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere",
			update:"ImageListItemUpdateInput",
			create:"ImageListItemCreateInput"
		},
		createJobFormSubscriptionStatus:{
			data:"JobFormSubscriptionStatusCreateInput"
		},
		deleteJobFormSubscriptionStatus:{
			by:"JobFormSubscriptionStatusUniqueWhere",
			filter:"JobFormSubscriptionStatusWhere"
		},
		updateJobFormSubscriptionStatus:{
			by:"JobFormSubscriptionStatusUniqueWhere",
			filter:"JobFormSubscriptionStatusWhere",
			data:"JobFormSubscriptionStatusUpdateInput"
		},
		upsertJobFormSubscriptionStatus:{
			by:"JobFormSubscriptionStatusUniqueWhere",
			filter:"JobFormSubscriptionStatusWhere",
			update:"JobFormSubscriptionStatusUpdateInput",
			create:"JobFormSubscriptionStatusCreateInput"
		},
		createGeneralLocale:{
			data:"GeneralLocaleCreateInput"
		},
		deleteGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		updateGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere",
			data:"GeneralLocaleUpdateInput"
		},
		upsertGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere",
			update:"GeneralLocaleUpdateInput",
			create:"GeneralLocaleCreateInput"
		},
		createStickyBar:{
			data:"StickyBarCreateInput"
		},
		deleteStickyBar:{
			by:"StickyBarUniqueWhere",
			filter:"StickyBarWhere"
		},
		updateStickyBar:{
			by:"StickyBarUniqueWhere",
			filter:"StickyBarWhere",
			data:"StickyBarUpdateInput"
		},
		upsertStickyBar:{
			by:"StickyBarUniqueWhere",
			filter:"StickyBarWhere",
			update:"StickyBarUpdateInput",
			create:"StickyBarCreateInput"
		},
		createRecommendationForm:{
			data:"RecommendationFormCreateInput"
		},
		deleteRecommendationForm:{
			by:"RecommendationFormUniqueWhere",
			filter:"RecommendationFormWhere"
		},
		updateRecommendationForm:{
			by:"RecommendationFormUniqueWhere",
			filter:"RecommendationFormWhere",
			data:"RecommendationFormUpdateInput"
		},
		upsertRecommendationForm:{
			by:"RecommendationFormUniqueWhere",
			filter:"RecommendationFormWhere",
			update:"RecommendationFormUpdateInput",
			create:"RecommendationFormCreateInput"
		},
		createRecommendationFormLocale:{
			data:"RecommendationFormLocaleCreateInput"
		},
		deleteRecommendationFormLocale:{
			by:"RecommendationFormLocaleUniqueWhere",
			filter:"RecommendationFormLocaleWhere"
		},
		updateRecommendationFormLocale:{
			by:"RecommendationFormLocaleUniqueWhere",
			filter:"RecommendationFormLocaleWhere",
			data:"RecommendationFormLocaleUpdateInput"
		},
		upsertRecommendationFormLocale:{
			by:"RecommendationFormLocaleUniqueWhere",
			filter:"RecommendationFormLocaleWhere",
			update:"RecommendationFormLocaleUpdateInput",
			create:"RecommendationFormLocaleCreateInput"
		},
		createRecommendationFormSubscription:{
			data:"RecommendationFormSubscriptionCreateInput"
		},
		deleteRecommendationFormSubscription:{
			by:"RecommendationFormSubscriptionUniqueWhere",
			filter:"RecommendationFormSubscriptionWhere"
		},
		updateRecommendationFormSubscription:{
			by:"RecommendationFormSubscriptionUniqueWhere",
			filter:"RecommendationFormSubscriptionWhere",
			data:"RecommendationFormSubscriptionUpdateInput"
		},
		upsertRecommendationFormSubscription:{
			by:"RecommendationFormSubscriptionUniqueWhere",
			filter:"RecommendationFormSubscriptionWhere",
			update:"RecommendationFormSubscriptionUpdateInput",
			create:"RecommendationFormSubscriptionCreateInput"
		},
		createInfoBox:{
			data:"InfoBoxCreateInput"
		},
		deleteInfoBox:{
			by:"InfoBoxUniqueWhere",
			filter:"InfoBoxWhere"
		},
		updateInfoBox:{
			by:"InfoBoxUniqueWhere",
			filter:"InfoBoxWhere",
			data:"InfoBoxUpdateInput"
		},
		upsertInfoBox:{
			by:"InfoBoxUniqueWhere",
			filter:"InfoBoxWhere",
			update:"InfoBoxUpdateInput",
			create:"InfoBoxCreateInput"
		},
		createInfoBoxLocale:{
			data:"InfoBoxLocaleCreateInput"
		},
		deleteInfoBoxLocale:{
			by:"InfoBoxLocaleUniqueWhere",
			filter:"InfoBoxLocaleWhere"
		},
		updateInfoBoxLocale:{
			by:"InfoBoxLocaleUniqueWhere",
			filter:"InfoBoxLocaleWhere",
			data:"InfoBoxLocaleUpdateInput"
		},
		upsertInfoBoxLocale:{
			by:"InfoBoxLocaleUniqueWhere",
			filter:"InfoBoxLocaleWhere",
			update:"InfoBoxLocaleUpdateInput",
			create:"InfoBoxLocaleCreateInput"
		},
		createTranslation:{
			data:"TranslationCreateInput"
		},
		deleteTranslation:{
			by:"TranslationUniqueWhere",
			filter:"TranslationWhere"
		},
		updateTranslation:{
			by:"TranslationUniqueWhere",
			filter:"TranslationWhere",
			data:"TranslationUpdateInput"
		},
		upsertTranslation:{
			by:"TranslationUniqueWhere",
			filter:"TranslationWhere",
			update:"TranslationUpdateInput",
			create:"TranslationCreateInput"
		},
		createTranslationLocale:{
			data:"TranslationLocaleCreateInput"
		},
		deleteTranslationLocale:{
			by:"TranslationLocaleUniqueWhere",
			filter:"TranslationLocaleWhere"
		},
		updateTranslationLocale:{
			by:"TranslationLocaleUniqueWhere",
			filter:"TranslationLocaleWhere",
			data:"TranslationLocaleUpdateInput"
		},
		upsertTranslationLocale:{
			by:"TranslationLocaleUniqueWhere",
			filter:"TranslationLocaleWhere",
			update:"TranslationLocaleUpdateInput",
			create:"TranslationLocaleCreateInput"
		},
		createCornerBanner:{
			data:"CornerBannerCreateInput"
		},
		deleteCornerBanner:{
			by:"CornerBannerUniqueWhere",
			filter:"CornerBannerWhere"
		},
		updateCornerBanner:{
			by:"CornerBannerUniqueWhere",
			filter:"CornerBannerWhere",
			data:"CornerBannerUpdateInput"
		},
		upsertCornerBanner:{
			by:"CornerBannerUniqueWhere",
			filter:"CornerBannerWhere",
			update:"CornerBannerUpdateInput",
			create:"CornerBannerCreateInput"
		},
		transaction:{
			options:"MutationTransactionOptions"
		}
	},
	S3GenerateSignedUploadInput:{
		contentDisposition:"S33ContentDisposition",
		acl:"S3Acl"
	},
	S33ContentDisposition: "enum" as const,
	S3Acl: "enum" as const,
	_MutationErrorType: "enum" as const,
	MutationTransaction:{
		generateUploadUrl:{
			input:"S3GenerateSignedUploadInput"
		},
		generateReadUrl:{

		},
		createGeneral:{
			data:"GeneralCreateInput"
		},
		deleteGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere"
		},
		updateGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere",
			data:"GeneralUpdateInput"
		},
		upsertGeneral:{
			by:"GeneralUniqueWhere",
			filter:"GeneralWhere",
			update:"GeneralUpdateInput",
			create:"GeneralCreateInput"
		},
		createImage:{
			data:"ImageCreateInput"
		},
		deleteImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		updateImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			data:"ImageUpdateInput"
		},
		upsertImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			update:"ImageUpdateInput",
			create:"ImageCreateInput"
		},
		createGenericPage:{
			data:"GenericPageCreateInput"
		},
		deleteGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere"
		},
		updateGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere",
			data:"GenericPageUpdateInput"
		},
		upsertGenericPage:{
			by:"GenericPageUniqueWhere",
			filter:"GenericPageWhere",
			update:"GenericPageUpdateInput",
			create:"GenericPageCreateInput"
		},
		createLinkable:{
			data:"LinkableCreateInput"
		},
		deleteLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		updateLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			data:"LinkableUpdateInput"
		},
		upsertLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			update:"LinkableUpdateInput",
			create:"LinkableCreateInput"
		},
		createSeo:{
			data:"SeoCreateInput"
		},
		deleteSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		updateSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			data:"SeoUpdateInput"
		},
		upsertSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			update:"SeoUpdateInput",
			create:"SeoCreateInput"
		},
		createContent:{
			data:"ContentCreateInput"
		},
		deleteContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		updateContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			data:"ContentUpdateInput"
		},
		upsertContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			update:"ContentUpdateInput",
			create:"ContentCreateInput"
		},
		createContentBlock:{
			data:"ContentBlockCreateInput"
		},
		deleteContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		updateContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			data:"ContentBlockUpdateInput"
		},
		upsertContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			update:"ContentBlockUpdateInput",
			create:"ContentBlockCreateInput"
		},
		createContentReference:{
			data:"ContentReferenceCreateInput"
		},
		deleteContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		updateContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			data:"ContentReferenceUpdateInput"
		},
		upsertContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			update:"ContentReferenceUpdateInput",
			create:"ContentReferenceCreateInput"
		},
		createRedirect:{
			data:"RedirectCreateInput"
		},
		deleteRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere"
		},
		updateRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere",
			data:"RedirectUpdateInput"
		},
		upsertRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere",
			update:"RedirectUpdateInput",
			create:"RedirectCreateInput"
		},
		createLink:{
			data:"LinkCreateInput"
		},
		deleteLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		updateLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			data:"LinkUpdateInput"
		},
		upsertLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			update:"LinkUpdateInput",
			create:"LinkCreateInput"
		},
		createFooter:{
			data:"FooterCreateInput"
		},
		deleteFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere"
		},
		updateFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere",
			data:"FooterUpdateInput"
		},
		upsertFooter:{
			by:"FooterUniqueWhere",
			filter:"FooterWhere",
			update:"FooterUpdateInput",
			create:"FooterCreateInput"
		},
		createFooterLink:{
			data:"FooterLinkCreateInput"
		},
		deleteFooterLink:{
			by:"FooterLinkUniqueWhere",
			filter:"FooterLinkWhere"
		},
		updateFooterLink:{
			by:"FooterLinkUniqueWhere",
			filter:"FooterLinkWhere",
			data:"FooterLinkUpdateInput"
		},
		upsertFooterLink:{
			by:"FooterLinkUniqueWhere",
			filter:"FooterLinkWhere",
			update:"FooterLinkUpdateInput",
			create:"FooterLinkCreateInput"
		},
		createFooterLocale:{
			data:"FooterLocaleCreateInput"
		},
		deleteFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere"
		},
		updateFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere",
			data:"FooterLocaleUpdateInput"
		},
		upsertFooterLocale:{
			by:"FooterLocaleUniqueWhere",
			filter:"FooterLocaleWhere",
			update:"FooterLocaleUpdateInput",
			create:"FooterLocaleCreateInput"
		},
		createGenericPageLocale:{
			data:"GenericPageLocaleCreateInput"
		},
		deleteGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere"
		},
		updateGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere",
			data:"GenericPageLocaleUpdateInput"
		},
		upsertGenericPageLocale:{
			by:"GenericPageLocaleUniqueWhere",
			filter:"GenericPageLocaleWhere",
			update:"GenericPageLocaleUpdateInput",
			create:"GenericPageLocaleCreateInput"
		},
		createHeader:{
			data:"HeaderCreateInput"
		},
		deleteHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere"
		},
		updateHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere",
			data:"HeaderUpdateInput"
		},
		upsertHeader:{
			by:"HeaderUniqueWhere",
			filter:"HeaderWhere",
			update:"HeaderUpdateInput",
			create:"HeaderCreateInput"
		},
		createHeaderLocale:{
			data:"HeaderLocaleCreateInput"
		},
		deleteHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere"
		},
		updateHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere",
			data:"HeaderLocaleUpdateInput"
		},
		upsertHeaderLocale:{
			by:"HeaderLocaleUniqueWhere",
			filter:"HeaderLocaleWhere",
			update:"HeaderLocaleUpdateInput",
			create:"HeaderLocaleCreateInput"
		},
		createLocale:{
			data:"LocaleCreateInput"
		},
		deleteLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		updateLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			data:"LocaleUpdateInput"
		},
		upsertLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			update:"LocaleUpdateInput",
			create:"LocaleCreateInput"
		},
		createSeoDefault:{
			data:"SeoDefaultCreateInput"
		},
		deleteSeoDefault:{
			by:"SeoDefaultUniqueWhere",
			filter:"SeoDefaultWhere"
		},
		updateSeoDefault:{
			by:"SeoDefaultUniqueWhere",
			filter:"SeoDefaultWhere",
			data:"SeoDefaultUpdateInput"
		},
		upsertSeoDefault:{
			by:"SeoDefaultUniqueWhere",
			filter:"SeoDefaultWhere",
			update:"SeoDefaultUpdateInput",
			create:"SeoDefaultCreateInput"
		},
		createSeoDefaultLocale:{
			data:"SeoDefaultLocaleCreateInput"
		},
		deleteSeoDefaultLocale:{
			by:"SeoDefaultLocaleUniqueWhere",
			filter:"SeoDefaultLocaleWhere"
		},
		updateSeoDefaultLocale:{
			by:"SeoDefaultLocaleUniqueWhere",
			filter:"SeoDefaultLocaleWhere",
			data:"SeoDefaultLocaleUpdateInput"
		},
		upsertSeoDefaultLocale:{
			by:"SeoDefaultLocaleUniqueWhere",
			filter:"SeoDefaultLocaleWhere",
			update:"SeoDefaultLocaleUpdateInput",
			create:"SeoDefaultLocaleCreateInput"
		},
		createBusiness:{
			data:"BusinessCreateInput"
		},
		deleteBusiness:{
			by:"BusinessUniqueWhere",
			filter:"BusinessWhere"
		},
		updateBusiness:{
			by:"BusinessUniqueWhere",
			filter:"BusinessWhere",
			data:"BusinessUpdateInput"
		},
		upsertBusiness:{
			by:"BusinessUniqueWhere",
			filter:"BusinessWhere",
			update:"BusinessUpdateInput",
			create:"BusinessCreateInput"
		},
		createBusinessPage:{
			data:"BusinessPageCreateInput"
		},
		deleteBusinessPage:{
			by:"BusinessPageUniqueWhere",
			filter:"BusinessPageWhere"
		},
		updateBusinessPage:{
			by:"BusinessPageUniqueWhere",
			filter:"BusinessPageWhere",
			data:"BusinessPageUpdateInput"
		},
		upsertBusinessPage:{
			by:"BusinessPageUniqueWhere",
			filter:"BusinessPageWhere",
			update:"BusinessPageUpdateInput",
			create:"BusinessPageCreateInput"
		},
		createBusinessPageLocale:{
			data:"BusinessPageLocaleCreateInput"
		},
		deleteBusinessPageLocale:{
			by:"BusinessPageLocaleUniqueWhere",
			filter:"BusinessPageLocaleWhere"
		},
		updateBusinessPageLocale:{
			by:"BusinessPageLocaleUniqueWhere",
			filter:"BusinessPageLocaleWhere",
			data:"BusinessPageLocaleUpdateInput"
		},
		upsertBusinessPageLocale:{
			by:"BusinessPageLocaleUniqueWhere",
			filter:"BusinessPageLocaleWhere",
			update:"BusinessPageLocaleUpdateInput",
			create:"BusinessPageLocaleCreateInput"
		},
		createIcon:{
			data:"IconCreateInput"
		},
		deleteIcon:{
			by:"IconUniqueWhere",
			filter:"IconWhere"
		},
		updateIcon:{
			by:"IconUniqueWhere",
			filter:"IconWhere",
			data:"IconUpdateInput"
		},
		upsertIcon:{
			by:"IconUniqueWhere",
			filter:"IconWhere",
			update:"IconUpdateInput",
			create:"IconCreateInput"
		},
		createJobPage:{
			data:"JobPageCreateInput"
		},
		deleteJobPage:{
			by:"JobPageUniqueWhere",
			filter:"JobPageWhere"
		},
		updateJobPage:{
			by:"JobPageUniqueWhere",
			filter:"JobPageWhere",
			data:"JobPageUpdateInput"
		},
		upsertJobPage:{
			by:"JobPageUniqueWhere",
			filter:"JobPageWhere",
			update:"JobPageUpdateInput",
			create:"JobPageCreateInput"
		},
		createJobPageLocale:{
			data:"JobPageLocaleCreateInput"
		},
		deleteJobPageLocale:{
			by:"JobPageLocaleUniqueWhere",
			filter:"JobPageLocaleWhere"
		},
		updateJobPageLocale:{
			by:"JobPageLocaleUniqueWhere",
			filter:"JobPageLocaleWhere",
			data:"JobPageLocaleUpdateInput"
		},
		upsertJobPageLocale:{
			by:"JobPageLocaleUniqueWhere",
			filter:"JobPageLocaleWhere",
			update:"JobPageLocaleUpdateInput",
			create:"JobPageLocaleCreateInput"
		},
		createKeyInfoItem:{
			data:"KeyInfoItemCreateInput"
		},
		deleteKeyInfoItem:{
			by:"KeyInfoItemUniqueWhere",
			filter:"KeyInfoItemWhere"
		},
		updateKeyInfoItem:{
			by:"KeyInfoItemUniqueWhere",
			filter:"KeyInfoItemWhere",
			data:"KeyInfoItemUpdateInput"
		},
		upsertKeyInfoItem:{
			by:"KeyInfoItemUniqueWhere",
			filter:"KeyInfoItemWhere",
			update:"KeyInfoItemUpdateInput",
			create:"KeyInfoItemCreateInput"
		},
		createKeyInfoList:{
			data:"KeyInfoListCreateInput"
		},
		deleteKeyInfoList:{
			by:"KeyInfoListUniqueWhere",
			filter:"KeyInfoListWhere"
		},
		updateKeyInfoList:{
			by:"KeyInfoListUniqueWhere",
			filter:"KeyInfoListWhere",
			data:"KeyInfoListUpdateInput"
		},
		upsertKeyInfoList:{
			by:"KeyInfoListUniqueWhere",
			filter:"KeyInfoListWhere",
			update:"KeyInfoListUpdateInput",
			create:"KeyInfoListCreateInput"
		},
		createContractType:{
			data:"ContractTypeCreateInput"
		},
		deleteContractType:{
			by:"ContractTypeUniqueWhere",
			filter:"ContractTypeWhere"
		},
		updateContractType:{
			by:"ContractTypeUniqueWhere",
			filter:"ContractTypeWhere",
			data:"ContractTypeUpdateInput"
		},
		upsertContractType:{
			by:"ContractTypeUniqueWhere",
			filter:"ContractTypeWhere",
			update:"ContractTypeUpdateInput",
			create:"ContractTypeCreateInput"
		},
		createContractTypeLocale:{
			data:"ContractTypeLocaleCreateInput"
		},
		deleteContractTypeLocale:{
			by:"ContractTypeLocaleUniqueWhere",
			filter:"ContractTypeLocaleWhere"
		},
		updateContractTypeLocale:{
			by:"ContractTypeLocaleUniqueWhere",
			filter:"ContractTypeLocaleWhere",
			data:"ContractTypeLocaleUpdateInput"
		},
		upsertContractTypeLocale:{
			by:"ContractTypeLocaleUniqueWhere",
			filter:"ContractTypeLocaleWhere",
			update:"ContractTypeLocaleUpdateInput",
			create:"ContractTypeLocaleCreateInput"
		},
		createJobCity:{
			data:"JobCityCreateInput"
		},
		deleteJobCity:{
			by:"JobCityUniqueWhere",
			filter:"JobCityWhere"
		},
		updateJobCity:{
			by:"JobCityUniqueWhere",
			filter:"JobCityWhere",
			data:"JobCityUpdateInput"
		},
		upsertJobCity:{
			by:"JobCityUniqueWhere",
			filter:"JobCityWhere",
			update:"JobCityUpdateInput",
			create:"JobCityCreateInput"
		},
		createJobCityLocale:{
			data:"JobCityLocaleCreateInput"
		},
		deleteJobCityLocale:{
			by:"JobCityLocaleUniqueWhere",
			filter:"JobCityLocaleWhere"
		},
		updateJobCityLocale:{
			by:"JobCityLocaleUniqueWhere",
			filter:"JobCityLocaleWhere",
			data:"JobCityLocaleUpdateInput"
		},
		upsertJobCityLocale:{
			by:"JobCityLocaleUniqueWhere",
			filter:"JobCityLocaleWhere",
			update:"JobCityLocaleUpdateInput",
			create:"JobCityLocaleCreateInput"
		},
		createJobPosition:{
			data:"JobPositionCreateInput"
		},
		deleteJobPosition:{
			by:"JobPositionUniqueWhere",
			filter:"JobPositionWhere"
		},
		updateJobPosition:{
			by:"JobPositionUniqueWhere",
			filter:"JobPositionWhere",
			data:"JobPositionUpdateInput"
		},
		upsertJobPosition:{
			by:"JobPositionUniqueWhere",
			filter:"JobPositionWhere",
			update:"JobPositionUpdateInput",
			create:"JobPositionCreateInput"
		},
		createJobPositionLocale:{
			data:"JobPositionLocaleCreateInput"
		},
		deleteJobPositionLocale:{
			by:"JobPositionLocaleUniqueWhere",
			filter:"JobPositionLocaleWhere"
		},
		updateJobPositionLocale:{
			by:"JobPositionLocaleUniqueWhere",
			filter:"JobPositionLocaleWhere",
			data:"JobPositionLocaleUpdateInput"
		},
		upsertJobPositionLocale:{
			by:"JobPositionLocaleUniqueWhere",
			filter:"JobPositionLocaleWhere",
			update:"JobPositionLocaleUpdateInput",
			create:"JobPositionLocaleCreateInput"
		},
		createGallery:{
			data:"GalleryCreateInput"
		},
		deleteGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere"
		},
		updateGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere",
			data:"GalleryUpdateInput"
		},
		upsertGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere",
			update:"GalleryUpdateInput",
			create:"GalleryCreateInput"
		},
		createHomePage:{
			data:"HomePageCreateInput"
		},
		deleteHomePage:{
			by:"HomePageUniqueWhere",
			filter:"HomePageWhere"
		},
		updateHomePage:{
			by:"HomePageUniqueWhere",
			filter:"HomePageWhere",
			data:"HomePageUpdateInput"
		},
		upsertHomePage:{
			by:"HomePageUniqueWhere",
			filter:"HomePageWhere",
			update:"HomePageUpdateInput",
			create:"HomePageCreateInput"
		},
		createHomePageLocale:{
			data:"HomePageLocaleCreateInput"
		},
		deleteHomePageLocale:{
			by:"HomePageLocaleUniqueWhere",
			filter:"HomePageLocaleWhere"
		},
		updateHomePageLocale:{
			by:"HomePageLocaleUniqueWhere",
			filter:"HomePageLocaleWhere",
			data:"HomePageLocaleUpdateInput"
		},
		upsertHomePageLocale:{
			by:"HomePageLocaleUniqueWhere",
			filter:"HomePageLocaleWhere",
			update:"HomePageLocaleUpdateInput",
			create:"HomePageLocaleCreateInput"
		},
		createMedium:{
			data:"MediumCreateInput"
		},
		deleteMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		updateMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			data:"MediumUpdateInput"
		},
		upsertMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			update:"MediumUpdateInput",
			create:"MediumCreateInput"
		},
		createMediumItem:{
			data:"MediumItemCreateInput"
		},
		deleteMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere"
		},
		updateMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere",
			data:"MediumItemUpdateInput"
		},
		upsertMediumItem:{
			by:"MediumItemUniqueWhere",
			filter:"MediumItemWhere",
			update:"MediumItemUpdateInput",
			create:"MediumItemCreateInput"
		},
		createMediumList:{
			data:"MediumListCreateInput"
		},
		deleteMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere"
		},
		updateMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere",
			data:"MediumListUpdateInput"
		},
		upsertMediumList:{
			by:"MediumListUniqueWhere",
			filter:"MediumListWhere",
			update:"MediumListUpdateInput",
			create:"MediumListCreateInput"
		},
		createVideo:{
			data:"VideoCreateInput"
		},
		deleteVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		updateVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			data:"VideoUpdateInput"
		},
		upsertVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			update:"VideoUpdateInput",
			create:"VideoCreateInput"
		},
		createTextItem:{
			data:"TextItemCreateInput"
		},
		deleteTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere"
		},
		updateTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere",
			data:"TextItemUpdateInput"
		},
		upsertTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere",
			update:"TextItemUpdateInput",
			create:"TextItemCreateInput"
		},
		createTextList:{
			data:"TextListCreateInput"
		},
		deleteTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere"
		},
		updateTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere",
			data:"TextListUpdateInput"
		},
		upsertTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere",
			update:"TextListUpdateInput",
			create:"TextListCreateInput"
		},
		createCarousel:{
			data:"CarouselCreateInput"
		},
		deleteCarousel:{
			by:"CarouselUniqueWhere",
			filter:"CarouselWhere"
		},
		updateCarousel:{
			by:"CarouselUniqueWhere",
			filter:"CarouselWhere",
			data:"CarouselUpdateInput"
		},
		upsertCarousel:{
			by:"CarouselUniqueWhere",
			filter:"CarouselWhere",
			update:"CarouselUpdateInput",
			create:"CarouselCreateInput"
		},
		createCarouselItem:{
			data:"CarouselItemCreateInput"
		},
		deleteCarouselItem:{
			by:"CarouselItemUniqueWhere",
			filter:"CarouselItemWhere"
		},
		updateCarouselItem:{
			by:"CarouselItemUniqueWhere",
			filter:"CarouselItemWhere",
			data:"CarouselItemUpdateInput"
		},
		upsertCarouselItem:{
			by:"CarouselItemUniqueWhere",
			filter:"CarouselItemWhere",
			update:"CarouselItemUpdateInput",
			create:"CarouselItemCreateInput"
		},
		createTheme:{
			data:"ThemeCreateInput"
		},
		deleteTheme:{
			by:"ThemeUniqueWhere",
			filter:"ThemeWhere"
		},
		updateTheme:{
			by:"ThemeUniqueWhere",
			filter:"ThemeWhere",
			data:"ThemeUpdateInput"
		},
		upsertTheme:{
			by:"ThemeUniqueWhere",
			filter:"ThemeWhere",
			update:"ThemeUpdateInput",
			create:"ThemeCreateInput"
		},
		createBonusBanner:{
			data:"BonusBannerCreateInput"
		},
		deleteBonusBanner:{
			by:"BonusBannerUniqueWhere",
			filter:"BonusBannerWhere"
		},
		updateBonusBanner:{
			by:"BonusBannerUniqueWhere",
			filter:"BonusBannerWhere",
			data:"BonusBannerUpdateInput"
		},
		upsertBonusBanner:{
			by:"BonusBannerUniqueWhere",
			filter:"BonusBannerWhere",
			update:"BonusBannerUpdateInput",
			create:"BonusBannerCreateInput"
		},
		createBonusBannerLocale:{
			data:"BonusBannerLocaleCreateInput"
		},
		deleteBonusBannerLocale:{
			by:"BonusBannerLocaleUniqueWhere",
			filter:"BonusBannerLocaleWhere"
		},
		updateBonusBannerLocale:{
			by:"BonusBannerLocaleUniqueWhere",
			filter:"BonusBannerLocaleWhere",
			data:"BonusBannerLocaleUpdateInput"
		},
		upsertBonusBannerLocale:{
			by:"BonusBannerLocaleUniqueWhere",
			filter:"BonusBannerLocaleWhere",
			update:"BonusBannerLocaleUpdateInput",
			create:"BonusBannerLocaleCreateInput"
		},
		createTile:{
			data:"TileCreateInput"
		},
		deleteTile:{
			by:"TileUniqueWhere",
			filter:"TileWhere"
		},
		updateTile:{
			by:"TileUniqueWhere",
			filter:"TileWhere",
			data:"TileUpdateInput"
		},
		upsertTile:{
			by:"TileUniqueWhere",
			filter:"TileWhere",
			update:"TileUpdateInput",
			create:"TileCreateInput"
		},
		createSideBySide:{
			data:"SideBySideCreateInput"
		},
		deleteSideBySide:{
			by:"SideBySideUniqueWhere",
			filter:"SideBySideWhere"
		},
		updateSideBySide:{
			by:"SideBySideUniqueWhere",
			filter:"SideBySideWhere",
			data:"SideBySideUpdateInput"
		},
		upsertSideBySide:{
			by:"SideBySideUniqueWhere",
			filter:"SideBySideWhere",
			update:"SideBySideUpdateInput",
			create:"SideBySideCreateInput"
		},
		createSideBySideItem:{
			data:"SideBySideItemCreateInput"
		},
		deleteSideBySideItem:{
			by:"SideBySideItemUniqueWhere",
			filter:"SideBySideItemWhere"
		},
		updateSideBySideItem:{
			by:"SideBySideItemUniqueWhere",
			filter:"SideBySideItemWhere",
			data:"SideBySideItemUpdateInput"
		},
		upsertSideBySideItem:{
			by:"SideBySideItemUniqueWhere",
			filter:"SideBySideItemWhere",
			update:"SideBySideItemUpdateInput",
			create:"SideBySideItemCreateInput"
		},
		createHomePageLokal:{
			data:"HomePageLokalCreateInput"
		},
		deleteHomePageLokal:{
			by:"HomePageLokalUniqueWhere",
			filter:"HomePageLokalWhere"
		},
		updateHomePageLokal:{
			by:"HomePageLokalUniqueWhere",
			filter:"HomePageLokalWhere",
			data:"HomePageLokalUpdateInput"
		},
		upsertHomePageLokal:{
			by:"HomePageLokalUniqueWhere",
			filter:"HomePageLokalWhere",
			update:"HomePageLokalUpdateInput",
			create:"HomePageLokalCreateInput"
		},
		createHomePageLokalLocale:{
			data:"HomePageLokalLocaleCreateInput"
		},
		deleteHomePageLokalLocale:{
			by:"HomePageLokalLocaleUniqueWhere",
			filter:"HomePageLokalLocaleWhere"
		},
		updateHomePageLokalLocale:{
			by:"HomePageLokalLocaleUniqueWhere",
			filter:"HomePageLokalLocaleWhere",
			data:"HomePageLokalLocaleUpdateInput"
		},
		upsertHomePageLokalLocale:{
			by:"HomePageLokalLocaleUniqueWhere",
			filter:"HomePageLokalLocaleWhere",
			update:"HomePageLokalLocaleUpdateInput",
			create:"HomePageLokalLocaleCreateInput"
		},
		createSiteSwitcher:{
			data:"SiteSwitcherCreateInput"
		},
		deleteSiteSwitcher:{
			by:"SiteSwitcherUniqueWhere",
			filter:"SiteSwitcherWhere"
		},
		updateSiteSwitcher:{
			by:"SiteSwitcherUniqueWhere",
			filter:"SiteSwitcherWhere",
			data:"SiteSwitcherUpdateInput"
		},
		upsertSiteSwitcher:{
			by:"SiteSwitcherUniqueWhere",
			filter:"SiteSwitcherWhere",
			update:"SiteSwitcherUpdateInput",
			create:"SiteSwitcherCreateInput"
		},
		createGalleryItem:{
			data:"GalleryItemCreateInput"
		},
		deleteGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere"
		},
		updateGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere",
			data:"GalleryItemUpdateInput"
		},
		upsertGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere",
			update:"GalleryItemUpdateInput",
			create:"GalleryItemCreateInput"
		},
		createJobsForm:{
			data:"JobsFormCreateInput"
		},
		deleteJobsForm:{
			by:"JobsFormUniqueWhere",
			filter:"JobsFormWhere"
		},
		updateJobsForm:{
			by:"JobsFormUniqueWhere",
			filter:"JobsFormWhere",
			data:"JobsFormUpdateInput"
		},
		upsertJobsForm:{
			by:"JobsFormUniqueWhere",
			filter:"JobsFormWhere",
			update:"JobsFormUpdateInput",
			create:"JobsFormCreateInput"
		},
		createJobsFormLocale:{
			data:"JobsFormLocaleCreateInput"
		},
		deleteJobsFormLocale:{
			by:"JobsFormLocaleUniqueWhere",
			filter:"JobsFormLocaleWhere"
		},
		updateJobsFormLocale:{
			by:"JobsFormLocaleUniqueWhere",
			filter:"JobsFormLocaleWhere",
			data:"JobsFormLocaleUpdateInput"
		},
		upsertJobsFormLocale:{
			by:"JobsFormLocaleUniqueWhere",
			filter:"JobsFormLocaleWhere",
			update:"JobsFormLocaleUpdateInput",
			create:"JobsFormLocaleCreateInput"
		},
		createImageTextItem:{
			data:"ImageTextItemCreateInput"
		},
		deleteImageTextItem:{
			by:"ImageTextItemUniqueWhere",
			filter:"ImageTextItemWhere"
		},
		updateImageTextItem:{
			by:"ImageTextItemUniqueWhere",
			filter:"ImageTextItemWhere",
			data:"ImageTextItemUpdateInput"
		},
		upsertImageTextItem:{
			by:"ImageTextItemUniqueWhere",
			filter:"ImageTextItemWhere",
			update:"ImageTextItemUpdateInput",
			create:"ImageTextItemCreateInput"
		},
		createImageTextList:{
			data:"ImageTextListCreateInput"
		},
		deleteImageTextList:{
			by:"ImageTextListUniqueWhere",
			filter:"ImageTextListWhere"
		},
		updateImageTextList:{
			by:"ImageTextListUniqueWhere",
			filter:"ImageTextListWhere",
			data:"ImageTextListUpdateInput"
		},
		upsertImageTextList:{
			by:"ImageTextListUniqueWhere",
			filter:"ImageTextListWhere",
			update:"ImageTextListUpdateInput",
			create:"ImageTextListCreateInput"
		},
		createJobsFilter:{
			data:"JobsFilterCreateInput"
		},
		deleteJobsFilter:{
			by:"JobsFilterUniqueWhere",
			filter:"JobsFilterWhere"
		},
		updateJobsFilter:{
			by:"JobsFilterUniqueWhere",
			filter:"JobsFilterWhere",
			data:"JobsFilterUpdateInput"
		},
		upsertJobsFilter:{
			by:"JobsFilterUniqueWhere",
			filter:"JobsFilterWhere",
			update:"JobsFilterUpdateInput",
			create:"JobsFilterCreateInput"
		},
		createJobsFilterLocale:{
			data:"JobsFilterLocaleCreateInput"
		},
		deleteJobsFilterLocale:{
			by:"JobsFilterLocaleUniqueWhere",
			filter:"JobsFilterLocaleWhere"
		},
		updateJobsFilterLocale:{
			by:"JobsFilterLocaleUniqueWhere",
			filter:"JobsFilterLocaleWhere",
			data:"JobsFilterLocaleUpdateInput"
		},
		upsertJobsFilterLocale:{
			by:"JobsFilterLocaleUniqueWhere",
			filter:"JobsFilterLocaleWhere",
			update:"JobsFilterLocaleUpdateInput",
			create:"JobsFilterLocaleCreateInput"
		},
		createFile:{
			data:"FileCreateInput"
		},
		deleteFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere"
		},
		updateFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere",
			data:"FileUpdateInput"
		},
		upsertFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere",
			update:"FileUpdateInput",
			create:"FileCreateInput"
		},
		createJobFormSubscription:{
			data:"JobFormSubscriptionCreateInput"
		},
		deleteJobFormSubscription:{
			by:"JobFormSubscriptionUniqueWhere",
			filter:"JobFormSubscriptionWhere"
		},
		updateJobFormSubscription:{
			by:"JobFormSubscriptionUniqueWhere",
			filter:"JobFormSubscriptionWhere",
			data:"JobFormSubscriptionUpdateInput"
		},
		upsertJobFormSubscription:{
			by:"JobFormSubscriptionUniqueWhere",
			filter:"JobFormSubscriptionWhere",
			update:"JobFormSubscriptionUpdateInput",
			create:"JobFormSubscriptionCreateInput"
		},
		createImageList:{
			data:"ImageListCreateInput"
		},
		deleteImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere"
		},
		updateImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere",
			data:"ImageListUpdateInput"
		},
		upsertImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere",
			update:"ImageListUpdateInput",
			create:"ImageListCreateInput"
		},
		createImageListItem:{
			data:"ImageListItemCreateInput"
		},
		deleteImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere"
		},
		updateImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere",
			data:"ImageListItemUpdateInput"
		},
		upsertImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere",
			update:"ImageListItemUpdateInput",
			create:"ImageListItemCreateInput"
		},
		createJobFormSubscriptionStatus:{
			data:"JobFormSubscriptionStatusCreateInput"
		},
		deleteJobFormSubscriptionStatus:{
			by:"JobFormSubscriptionStatusUniqueWhere",
			filter:"JobFormSubscriptionStatusWhere"
		},
		updateJobFormSubscriptionStatus:{
			by:"JobFormSubscriptionStatusUniqueWhere",
			filter:"JobFormSubscriptionStatusWhere",
			data:"JobFormSubscriptionStatusUpdateInput"
		},
		upsertJobFormSubscriptionStatus:{
			by:"JobFormSubscriptionStatusUniqueWhere",
			filter:"JobFormSubscriptionStatusWhere",
			update:"JobFormSubscriptionStatusUpdateInput",
			create:"JobFormSubscriptionStatusCreateInput"
		},
		createGeneralLocale:{
			data:"GeneralLocaleCreateInput"
		},
		deleteGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere"
		},
		updateGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere",
			data:"GeneralLocaleUpdateInput"
		},
		upsertGeneralLocale:{
			by:"GeneralLocaleUniqueWhere",
			filter:"GeneralLocaleWhere",
			update:"GeneralLocaleUpdateInput",
			create:"GeneralLocaleCreateInput"
		},
		createStickyBar:{
			data:"StickyBarCreateInput"
		},
		deleteStickyBar:{
			by:"StickyBarUniqueWhere",
			filter:"StickyBarWhere"
		},
		updateStickyBar:{
			by:"StickyBarUniqueWhere",
			filter:"StickyBarWhere",
			data:"StickyBarUpdateInput"
		},
		upsertStickyBar:{
			by:"StickyBarUniqueWhere",
			filter:"StickyBarWhere",
			update:"StickyBarUpdateInput",
			create:"StickyBarCreateInput"
		},
		createRecommendationForm:{
			data:"RecommendationFormCreateInput"
		},
		deleteRecommendationForm:{
			by:"RecommendationFormUniqueWhere",
			filter:"RecommendationFormWhere"
		},
		updateRecommendationForm:{
			by:"RecommendationFormUniqueWhere",
			filter:"RecommendationFormWhere",
			data:"RecommendationFormUpdateInput"
		},
		upsertRecommendationForm:{
			by:"RecommendationFormUniqueWhere",
			filter:"RecommendationFormWhere",
			update:"RecommendationFormUpdateInput",
			create:"RecommendationFormCreateInput"
		},
		createRecommendationFormLocale:{
			data:"RecommendationFormLocaleCreateInput"
		},
		deleteRecommendationFormLocale:{
			by:"RecommendationFormLocaleUniqueWhere",
			filter:"RecommendationFormLocaleWhere"
		},
		updateRecommendationFormLocale:{
			by:"RecommendationFormLocaleUniqueWhere",
			filter:"RecommendationFormLocaleWhere",
			data:"RecommendationFormLocaleUpdateInput"
		},
		upsertRecommendationFormLocale:{
			by:"RecommendationFormLocaleUniqueWhere",
			filter:"RecommendationFormLocaleWhere",
			update:"RecommendationFormLocaleUpdateInput",
			create:"RecommendationFormLocaleCreateInput"
		},
		createRecommendationFormSubscription:{
			data:"RecommendationFormSubscriptionCreateInput"
		},
		deleteRecommendationFormSubscription:{
			by:"RecommendationFormSubscriptionUniqueWhere",
			filter:"RecommendationFormSubscriptionWhere"
		},
		updateRecommendationFormSubscription:{
			by:"RecommendationFormSubscriptionUniqueWhere",
			filter:"RecommendationFormSubscriptionWhere",
			data:"RecommendationFormSubscriptionUpdateInput"
		},
		upsertRecommendationFormSubscription:{
			by:"RecommendationFormSubscriptionUniqueWhere",
			filter:"RecommendationFormSubscriptionWhere",
			update:"RecommendationFormSubscriptionUpdateInput",
			create:"RecommendationFormSubscriptionCreateInput"
		},
		createInfoBox:{
			data:"InfoBoxCreateInput"
		},
		deleteInfoBox:{
			by:"InfoBoxUniqueWhere",
			filter:"InfoBoxWhere"
		},
		updateInfoBox:{
			by:"InfoBoxUniqueWhere",
			filter:"InfoBoxWhere",
			data:"InfoBoxUpdateInput"
		},
		upsertInfoBox:{
			by:"InfoBoxUniqueWhere",
			filter:"InfoBoxWhere",
			update:"InfoBoxUpdateInput",
			create:"InfoBoxCreateInput"
		},
		createInfoBoxLocale:{
			data:"InfoBoxLocaleCreateInput"
		},
		deleteInfoBoxLocale:{
			by:"InfoBoxLocaleUniqueWhere",
			filter:"InfoBoxLocaleWhere"
		},
		updateInfoBoxLocale:{
			by:"InfoBoxLocaleUniqueWhere",
			filter:"InfoBoxLocaleWhere",
			data:"InfoBoxLocaleUpdateInput"
		},
		upsertInfoBoxLocale:{
			by:"InfoBoxLocaleUniqueWhere",
			filter:"InfoBoxLocaleWhere",
			update:"InfoBoxLocaleUpdateInput",
			create:"InfoBoxLocaleCreateInput"
		},
		createTranslation:{
			data:"TranslationCreateInput"
		},
		deleteTranslation:{
			by:"TranslationUniqueWhere",
			filter:"TranslationWhere"
		},
		updateTranslation:{
			by:"TranslationUniqueWhere",
			filter:"TranslationWhere",
			data:"TranslationUpdateInput"
		},
		upsertTranslation:{
			by:"TranslationUniqueWhere",
			filter:"TranslationWhere",
			update:"TranslationUpdateInput",
			create:"TranslationCreateInput"
		},
		createTranslationLocale:{
			data:"TranslationLocaleCreateInput"
		},
		deleteTranslationLocale:{
			by:"TranslationLocaleUniqueWhere",
			filter:"TranslationLocaleWhere"
		},
		updateTranslationLocale:{
			by:"TranslationLocaleUniqueWhere",
			filter:"TranslationLocaleWhere",
			data:"TranslationLocaleUpdateInput"
		},
		upsertTranslationLocale:{
			by:"TranslationLocaleUniqueWhere",
			filter:"TranslationLocaleWhere",
			update:"TranslationLocaleUpdateInput",
			create:"TranslationLocaleCreateInput"
		},
		createCornerBanner:{
			data:"CornerBannerCreateInput"
		},
		deleteCornerBanner:{
			by:"CornerBannerUniqueWhere",
			filter:"CornerBannerWhere"
		},
		updateCornerBanner:{
			by:"CornerBannerUniqueWhere",
			filter:"CornerBannerWhere",
			data:"CornerBannerUpdateInput"
		},
		upsertCornerBanner:{
			by:"CornerBannerUniqueWhere",
			filter:"CornerBannerWhere",
			update:"CornerBannerUpdateInput",
			create:"CornerBannerCreateInput"
		}
	},
	MutationTransactionOptions:{

	}
}

export const ReturnTypes: Record<string,any> = {
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_RuleMessage:{
		text:"String"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	Json: `scalar.Json` as const,
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	Query:{
		schema:"_Schema",
		s3DummyQuery:"String",
		getGeneral:"General",
		listGeneral:"General",
		paginateGeneral:"GeneralConnection",
		validateCreateGeneral:"_ValidationResult",
		validateUpdateGeneral:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getGenericPage:"GenericPage",
		listGenericPage:"GenericPage",
		paginateGenericPage:"GenericPageConnection",
		validateCreateGenericPage:"_ValidationResult",
		validateUpdateGenericPage:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getContentReferenceLinkableItem:"ContentReferenceLinkableItem",
		listContentReferenceLinkableItem:"ContentReferenceLinkableItem",
		paginateContentReferenceLinkableItem:"ContentReferenceLinkableItemConnection",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getFooterLink:"FooterLink",
		listFooterLink:"FooterLink",
		paginateFooterLink:"FooterLinkConnection",
		validateCreateFooterLink:"_ValidationResult",
		validateUpdateFooterLink:"_ValidationResult",
		getFooterLocale:"FooterLocale",
		listFooterLocale:"FooterLocale",
		paginateFooterLocale:"FooterLocaleConnection",
		validateCreateFooterLocale:"_ValidationResult",
		validateUpdateFooterLocale:"_ValidationResult",
		getGenericPageLocale:"GenericPageLocale",
		listGenericPageLocale:"GenericPageLocale",
		paginateGenericPageLocale:"GenericPageLocaleConnection",
		validateCreateGenericPageLocale:"_ValidationResult",
		validateUpdateGenericPageLocale:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHeaderLocale:"HeaderLocale",
		listHeaderLocale:"HeaderLocale",
		paginateHeaderLocale:"HeaderLocaleConnection",
		validateCreateHeaderLocale:"_ValidationResult",
		validateUpdateHeaderLocale:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getSeoDefault:"SeoDefault",
		listSeoDefault:"SeoDefault",
		paginateSeoDefault:"SeoDefaultConnection",
		validateCreateSeoDefault:"_ValidationResult",
		validateUpdateSeoDefault:"_ValidationResult",
		getSeoDefaultLocale:"SeoDefaultLocale",
		listSeoDefaultLocale:"SeoDefaultLocale",
		paginateSeoDefaultLocale:"SeoDefaultLocaleConnection",
		validateCreateSeoDefaultLocale:"_ValidationResult",
		validateUpdateSeoDefaultLocale:"_ValidationResult",
		getBusiness:"Business",
		listBusiness:"Business",
		paginateBusiness:"BusinessConnection",
		validateCreateBusiness:"_ValidationResult",
		validateUpdateBusiness:"_ValidationResult",
		getBusinessPage:"BusinessPage",
		listBusinessPage:"BusinessPage",
		paginateBusinessPage:"BusinessPageConnection",
		validateCreateBusinessPage:"_ValidationResult",
		validateUpdateBusinessPage:"_ValidationResult",
		getBusinessPageLocale:"BusinessPageLocale",
		listBusinessPageLocale:"BusinessPageLocale",
		paginateBusinessPageLocale:"BusinessPageLocaleConnection",
		validateCreateBusinessPageLocale:"_ValidationResult",
		validateUpdateBusinessPageLocale:"_ValidationResult",
		getIcon:"Icon",
		listIcon:"Icon",
		paginateIcon:"IconConnection",
		validateCreateIcon:"_ValidationResult",
		validateUpdateIcon:"_ValidationResult",
		getJobPage:"JobPage",
		listJobPage:"JobPage",
		paginateJobPage:"JobPageConnection",
		validateCreateJobPage:"_ValidationResult",
		validateUpdateJobPage:"_ValidationResult",
		getJobPageLocale:"JobPageLocale",
		listJobPageLocale:"JobPageLocale",
		paginateJobPageLocale:"JobPageLocaleConnection",
		validateCreateJobPageLocale:"_ValidationResult",
		validateUpdateJobPageLocale:"_ValidationResult",
		getKeyInfoItem:"KeyInfoItem",
		listKeyInfoItem:"KeyInfoItem",
		paginateKeyInfoItem:"KeyInfoItemConnection",
		validateCreateKeyInfoItem:"_ValidationResult",
		validateUpdateKeyInfoItem:"_ValidationResult",
		getKeyInfoList:"KeyInfoList",
		listKeyInfoList:"KeyInfoList",
		paginateKeyInfoList:"KeyInfoListConnection",
		validateCreateKeyInfoList:"_ValidationResult",
		validateUpdateKeyInfoList:"_ValidationResult",
		getContractType:"ContractType",
		listContractType:"ContractType",
		paginateContractType:"ContractTypeConnection",
		validateCreateContractType:"_ValidationResult",
		validateUpdateContractType:"_ValidationResult",
		getContractTypeLocale:"ContractTypeLocale",
		listContractTypeLocale:"ContractTypeLocale",
		paginateContractTypeLocale:"ContractTypeLocaleConnection",
		validateCreateContractTypeLocale:"_ValidationResult",
		validateUpdateContractTypeLocale:"_ValidationResult",
		getJobCity:"JobCity",
		listJobCity:"JobCity",
		paginateJobCity:"JobCityConnection",
		validateCreateJobCity:"_ValidationResult",
		validateUpdateJobCity:"_ValidationResult",
		getJobCityLocale:"JobCityLocale",
		listJobCityLocale:"JobCityLocale",
		paginateJobCityLocale:"JobCityLocaleConnection",
		validateCreateJobCityLocale:"_ValidationResult",
		validateUpdateJobCityLocale:"_ValidationResult",
		getJobPosition:"JobPosition",
		listJobPosition:"JobPosition",
		paginateJobPosition:"JobPositionConnection",
		validateCreateJobPosition:"_ValidationResult",
		validateUpdateJobPosition:"_ValidationResult",
		getJobPositionLocale:"JobPositionLocale",
		listJobPositionLocale:"JobPositionLocale",
		paginateJobPositionLocale:"JobPositionLocaleConnection",
		validateCreateJobPositionLocale:"_ValidationResult",
		validateUpdateJobPositionLocale:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getHomePage:"HomePage",
		listHomePage:"HomePage",
		paginateHomePage:"HomePageConnection",
		validateCreateHomePage:"_ValidationResult",
		validateUpdateHomePage:"_ValidationResult",
		getHomePageLocale:"HomePageLocale",
		listHomePageLocale:"HomePageLocale",
		paginateHomePageLocale:"HomePageLocaleConnection",
		validateCreateHomePageLocale:"_ValidationResult",
		validateUpdateHomePageLocale:"_ValidationResult",
		getMedium:"Medium",
		listMedium:"Medium",
		paginateMedium:"MediumConnection",
		validateCreateMedium:"_ValidationResult",
		validateUpdateMedium:"_ValidationResult",
		getMediumItem:"MediumItem",
		listMediumItem:"MediumItem",
		paginateMediumItem:"MediumItemConnection",
		validateCreateMediumItem:"_ValidationResult",
		validateUpdateMediumItem:"_ValidationResult",
		getMediumList:"MediumList",
		listMediumList:"MediumList",
		paginateMediumList:"MediumListConnection",
		validateCreateMediumList:"_ValidationResult",
		validateUpdateMediumList:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getTextItem:"TextItem",
		listTextItem:"TextItem",
		paginateTextItem:"TextItemConnection",
		validateCreateTextItem:"_ValidationResult",
		validateUpdateTextItem:"_ValidationResult",
		getTextList:"TextList",
		listTextList:"TextList",
		paginateTextList:"TextListConnection",
		validateCreateTextList:"_ValidationResult",
		validateUpdateTextList:"_ValidationResult",
		getCarousel:"Carousel",
		listCarousel:"Carousel",
		paginateCarousel:"CarouselConnection",
		validateCreateCarousel:"_ValidationResult",
		validateUpdateCarousel:"_ValidationResult",
		getCarouselItem:"CarouselItem",
		listCarouselItem:"CarouselItem",
		paginateCarouselItem:"CarouselItemConnection",
		validateCreateCarouselItem:"_ValidationResult",
		validateUpdateCarouselItem:"_ValidationResult",
		getTheme:"Theme",
		listTheme:"Theme",
		paginateTheme:"ThemeConnection",
		validateCreateTheme:"_ValidationResult",
		validateUpdateTheme:"_ValidationResult",
		getBonusBanner:"BonusBanner",
		listBonusBanner:"BonusBanner",
		paginateBonusBanner:"BonusBannerConnection",
		validateCreateBonusBanner:"_ValidationResult",
		validateUpdateBonusBanner:"_ValidationResult",
		getBonusBannerLocale:"BonusBannerLocale",
		listBonusBannerLocale:"BonusBannerLocale",
		paginateBonusBannerLocale:"BonusBannerLocaleConnection",
		validateCreateBonusBannerLocale:"_ValidationResult",
		validateUpdateBonusBannerLocale:"_ValidationResult",
		getTile:"Tile",
		listTile:"Tile",
		paginateTile:"TileConnection",
		validateCreateTile:"_ValidationResult",
		validateUpdateTile:"_ValidationResult",
		getSideBySide:"SideBySide",
		listSideBySide:"SideBySide",
		paginateSideBySide:"SideBySideConnection",
		validateCreateSideBySide:"_ValidationResult",
		validateUpdateSideBySide:"_ValidationResult",
		getSideBySideItem:"SideBySideItem",
		listSideBySideItem:"SideBySideItem",
		paginateSideBySideItem:"SideBySideItemConnection",
		validateCreateSideBySideItem:"_ValidationResult",
		validateUpdateSideBySideItem:"_ValidationResult",
		getHomePageLokal:"HomePageLokal",
		listHomePageLokal:"HomePageLokal",
		paginateHomePageLokal:"HomePageLokalConnection",
		validateCreateHomePageLokal:"_ValidationResult",
		validateUpdateHomePageLokal:"_ValidationResult",
		getHomePageLokalLocale:"HomePageLokalLocale",
		listHomePageLokalLocale:"HomePageLokalLocale",
		paginateHomePageLokalLocale:"HomePageLokalLocaleConnection",
		validateCreateHomePageLokalLocale:"_ValidationResult",
		validateUpdateHomePageLokalLocale:"_ValidationResult",
		getSiteSwitcher:"SiteSwitcher",
		listSiteSwitcher:"SiteSwitcher",
		paginateSiteSwitcher:"SiteSwitcherConnection",
		validateCreateSiteSwitcher:"_ValidationResult",
		validateUpdateSiteSwitcher:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getJobsForm:"JobsForm",
		listJobsForm:"JobsForm",
		paginateJobsForm:"JobsFormConnection",
		validateCreateJobsForm:"_ValidationResult",
		validateUpdateJobsForm:"_ValidationResult",
		getJobsFormLocale:"JobsFormLocale",
		listJobsFormLocale:"JobsFormLocale",
		paginateJobsFormLocale:"JobsFormLocaleConnection",
		validateCreateJobsFormLocale:"_ValidationResult",
		validateUpdateJobsFormLocale:"_ValidationResult",
		getImageTextItem:"ImageTextItem",
		listImageTextItem:"ImageTextItem",
		paginateImageTextItem:"ImageTextItemConnection",
		validateCreateImageTextItem:"_ValidationResult",
		validateUpdateImageTextItem:"_ValidationResult",
		getImageTextList:"ImageTextList",
		listImageTextList:"ImageTextList",
		paginateImageTextList:"ImageTextListConnection",
		validateCreateImageTextList:"_ValidationResult",
		validateUpdateImageTextList:"_ValidationResult",
		getJobsFilter:"JobsFilter",
		listJobsFilter:"JobsFilter",
		paginateJobsFilter:"JobsFilterConnection",
		validateCreateJobsFilter:"_ValidationResult",
		validateUpdateJobsFilter:"_ValidationResult",
		getJobsFilterLocale:"JobsFilterLocale",
		listJobsFilterLocale:"JobsFilterLocale",
		paginateJobsFilterLocale:"JobsFilterLocaleConnection",
		validateCreateJobsFilterLocale:"_ValidationResult",
		validateUpdateJobsFilterLocale:"_ValidationResult",
		getFile:"File",
		listFile:"File",
		paginateFile:"FileConnection",
		validateCreateFile:"_ValidationResult",
		validateUpdateFile:"_ValidationResult",
		getJobFormSubscription:"JobFormSubscription",
		listJobFormSubscription:"JobFormSubscription",
		paginateJobFormSubscription:"JobFormSubscriptionConnection",
		validateCreateJobFormSubscription:"_ValidationResult",
		validateUpdateJobFormSubscription:"_ValidationResult",
		getImageList:"ImageList",
		listImageList:"ImageList",
		paginateImageList:"ImageListConnection",
		validateCreateImageList:"_ValidationResult",
		validateUpdateImageList:"_ValidationResult",
		getImageListItem:"ImageListItem",
		listImageListItem:"ImageListItem",
		paginateImageListItem:"ImageListItemConnection",
		validateCreateImageListItem:"_ValidationResult",
		validateUpdateImageListItem:"_ValidationResult",
		getJobFormSubscriptionStatus:"JobFormSubscriptionStatus",
		listJobFormSubscriptionStatus:"JobFormSubscriptionStatus",
		paginateJobFormSubscriptionStatus:"JobFormSubscriptionStatusConnection",
		validateCreateJobFormSubscriptionStatus:"_ValidationResult",
		validateUpdateJobFormSubscriptionStatus:"_ValidationResult",
		getGeneralLocale:"GeneralLocale",
		listGeneralLocale:"GeneralLocale",
		paginateGeneralLocale:"GeneralLocaleConnection",
		validateCreateGeneralLocale:"_ValidationResult",
		validateUpdateGeneralLocale:"_ValidationResult",
		getStickyBar:"StickyBar",
		listStickyBar:"StickyBar",
		paginateStickyBar:"StickyBarConnection",
		validateCreateStickyBar:"_ValidationResult",
		validateUpdateStickyBar:"_ValidationResult",
		getRecommendationForm:"RecommendationForm",
		listRecommendationForm:"RecommendationForm",
		paginateRecommendationForm:"RecommendationFormConnection",
		validateCreateRecommendationForm:"_ValidationResult",
		validateUpdateRecommendationForm:"_ValidationResult",
		getRecommendationFormLocale:"RecommendationFormLocale",
		listRecommendationFormLocale:"RecommendationFormLocale",
		paginateRecommendationFormLocale:"RecommendationFormLocaleConnection",
		validateCreateRecommendationFormLocale:"_ValidationResult",
		validateUpdateRecommendationFormLocale:"_ValidationResult",
		getRecommendationFormSubscription:"RecommendationFormSubscription",
		listRecommendationFormSubscription:"RecommendationFormSubscription",
		paginateRecommendationFormSubscription:"RecommendationFormSubscriptionConnection",
		validateCreateRecommendationFormSubscription:"_ValidationResult",
		validateUpdateRecommendationFormSubscription:"_ValidationResult",
		getInfoBox:"InfoBox",
		listInfoBox:"InfoBox",
		paginateInfoBox:"InfoBoxConnection",
		validateCreateInfoBox:"_ValidationResult",
		validateUpdateInfoBox:"_ValidationResult",
		getInfoBoxLocale:"InfoBoxLocale",
		listInfoBoxLocale:"InfoBoxLocale",
		paginateInfoBoxLocale:"InfoBoxLocaleConnection",
		validateCreateInfoBoxLocale:"_ValidationResult",
		validateUpdateInfoBoxLocale:"_ValidationResult",
		getTranslation:"Translation",
		listTranslation:"Translation",
		paginateTranslation:"TranslationConnection",
		validateCreateTranslation:"_ValidationResult",
		validateUpdateTranslation:"_ValidationResult",
		getTranslationLocale:"TranslationLocale",
		listTranslationLocale:"TranslationLocale",
		paginateTranslationLocale:"TranslationLocaleConnection",
		validateCreateTranslationLocale:"_ValidationResult",
		validateUpdateTranslationLocale:"_ValidationResult",
		getCornerBanner:"CornerBanner",
		listCornerBanner:"CornerBanner",
		paginateCornerBanner:"CornerBannerConnection",
		validateCreateCornerBanner:"_ValidationResult",
		validateUpdateCornerBanner:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	General:{
		_meta:"GeneralMeta",
		id:"UUID",
		unique:"One",
		locales:"GeneralLocale",
		localesByLocale:"GeneralLocale",
		localesBySeo:"GeneralLocale",
		localesByCornerBanner:"GeneralLocale",
		paginateLocales:"GeneralLocaleConnection"
	},
	GeneralMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	UUID: `scalar.UUID` as const,
	GeneralLocale:{
		_meta:"GeneralLocaleMeta",
		id:"UUID",
		root:"General",
		locale:"Locale",
		seo:"Seo",
		cornerBanner:"CornerBanner"
	},
	GeneralLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		seo:"FieldMeta",
		cornerBanner:"FieldMeta"
	},
	DateTime: `scalar.DateTime` as const,
	Locale:{
		_meta:"LocaleMeta",
		id:"UUID",
		code:"String",
		label:"String",
		footers:"FooterLocale",
		genericPages:"GenericPageLocale",
		headers:"HeaderLocale",
		seoDefaults:"SeoDefaultLocale",
		businessPages:"BusinessPageLocale",
		jobPages:"JobPageLocale",
		contractTypes:"ContractTypeLocale",
		jobCities:"JobCityLocale",
		jobPositions:"JobPositionLocale",
		homePages:"HomePageLocale",
		bonusBanners:"BonusBannerLocale",
		homePageLokals:"HomePageLokalLocale",
		jobsForms:"JobsFormLocale",
		jobsFilters:"JobsFilterLocale",
		general:"GeneralLocale",
		recommendationForms:"RecommendationFormLocale",
		infoBoxes:"InfoBoxLocale",
		translations:"TranslationLocale",
		footersByRoot:"FooterLocale",
		footersByTermsAndConditions:"FooterLocale",
		footersByBannerImage:"FooterLocale",
		footersByBannerLink:"FooterLocale",
		footersByJobsForm:"FooterLocale",
		footersByCopyrightLink:"FooterLocale",
		footersByRecommendationForm:"FooterLocale",
		footersByBannerSecondLink:"FooterLocale",
		footersByInstagramLink:"FooterLocale",
		genericPagesByRoot:"GenericPageLocale",
		genericPagesByContent:"GenericPageLocale",
		genericPagesBySeo:"GenericPageLocale",
		genericPagesByLink:"GenericPageLocale",
		genericPagesByLogo:"GenericPageLocale",
		genericPagesByImage:"GenericPageLocale",
		headersByRoot:"HeaderLocale",
		headersByBusinessLink:"HeaderLocale",
		headersByLokalLink:"HeaderLocale",
		seoDefaultsByRoot:"SeoDefaultLocale",
		seoDefaultsBySeo:"SeoDefaultLocale",
		businessPagesByRoot:"BusinessPageLocale",
		businessPagesByContent:"BusinessPageLocale",
		businessPagesBySeo:"BusinessPageLocale",
		businessPagesByLink:"BusinessPageLocale",
		businessPagesByImage:"BusinessPageLocale",
		jobPagesByRoot:"JobPageLocale",
		jobPagesByImage:"JobPageLocale",
		jobPagesByKeyInfo:"JobPageLocale",
		jobPagesByContent:"JobPageLocale",
		jobPagesBySeo:"JobPageLocale",
		jobPagesByLink:"JobPageLocale",
		jobPagesByMobileImage:"JobPageLocale",
		contractTypesByRoot:"ContractTypeLocale",
		contractTypesBySlug:"ContractTypeLocale",
		jobCitiesByRoot:"JobCityLocale",
		jobCitiesBySlug:"JobCityLocale",
		jobPositionsByRoot:"JobPositionLocale",
		jobPositionsBySlug:"JobPositionLocale",
		homePagesByRoot:"HomePageLocale",
		homePagesByButton:"HomePageLocale",
		homePagesByContent:"HomePageLocale",
		homePagesBySeo:"HomePageLocale",
		homePagesByLink:"HomePageLocale",
		homePagesByLogo:"HomePageLocale",
		homePagesBySiteSwitcher:"HomePageLocale",
		homePagesByIlustration:"HomePageLocale",
		bonusBannersByRoot:"BonusBannerLocale",
		bonusBannersByTiles:"BonusBannerLocale",
		bonusBannersByLogo:"BonusBannerLocale",
		homePageLokalsByRoot:"HomePageLokalLocale",
		homePageLokalsByLogo:"HomePageLokalLocale",
		homePageLokalsByButton:"HomePageLokalLocale",
		homePageLokalsByContent:"HomePageLokalLocale",
		homePageLokalsBySeo:"HomePageLokalLocale",
		homePageLokalsByLink:"HomePageLokalLocale",
		homePageLokalsBySiteSwitcher:"HomePageLokalLocale",
		homePageLokalsByIlustration:"HomePageLokalLocale",
		jobsFormsByRoot:"JobsFormLocale",
		jobsFormsByImageTextList:"JobsFormLocale",
		jobsFormsByLogo:"JobsFormLocale",
		jobsFormsBySuccessImage:"JobsFormLocale",
		jobsFiltersByRoot:"JobsFilterLocale",
		jobsFiltersByBannerJobsForm:"JobsFilterLocale",
		jobsFiltersByBannerImage:"JobsFilterLocale",
		jobsFiltersByNoJobImage:"JobsFilterLocale",
		generalByRoot:"GeneralLocale",
		generalBySeo:"GeneralLocale",
		generalByCornerBanner:"GeneralLocale",
		recommendationFormsByRoot:"RecommendationFormLocale",
		infoBoxesByRoot:"InfoBoxLocale",
		translationsByRoot:"TranslationLocale",
		paginateFooters:"FooterLocaleConnection",
		paginateGenericPages:"GenericPageLocaleConnection",
		paginateHeaders:"HeaderLocaleConnection",
		paginateSeoDefaults:"SeoDefaultLocaleConnection",
		paginateBusinessPages:"BusinessPageLocaleConnection",
		paginateJobPages:"JobPageLocaleConnection",
		paginateContractTypes:"ContractTypeLocaleConnection",
		paginateJobCities:"JobCityLocaleConnection",
		paginateJobPositions:"JobPositionLocaleConnection",
		paginateHomePages:"HomePageLocaleConnection",
		paginateBonusBanners:"BonusBannerLocaleConnection",
		paginateHomePageLokals:"HomePageLokalLocaleConnection",
		paginateJobsForms:"JobsFormLocaleConnection",
		paginateJobsFilters:"JobsFilterLocaleConnection",
		paginateGeneral:"GeneralLocaleConnection",
		paginateRecommendationForms:"RecommendationFormLocaleConnection",
		paginateInfoBoxes:"InfoBoxLocaleConnection",
		paginateTranslations:"TranslationLocaleConnection"
	},
	LocaleMeta:{
		id:"FieldMeta",
		code:"FieldMeta",
		label:"FieldMeta",
		footers:"FieldMeta",
		genericPages:"FieldMeta",
		headers:"FieldMeta",
		seoDefaults:"FieldMeta",
		businessPages:"FieldMeta",
		jobPages:"FieldMeta",
		contractTypes:"FieldMeta",
		jobCities:"FieldMeta",
		jobPositions:"FieldMeta",
		homePages:"FieldMeta",
		bonusBanners:"FieldMeta",
		homePageLokals:"FieldMeta",
		jobsForms:"FieldMeta",
		jobsFilters:"FieldMeta",
		general:"FieldMeta",
		recommendationForms:"FieldMeta",
		infoBoxes:"FieldMeta",
		translations:"FieldMeta"
	},
	FooterLocale:{
		_meta:"FooterLocaleMeta",
		id:"UUID",
		email:"String",
		address:"String",
		ico:"String",
		dic:"String",
		copyright:"String",
		note:"String",
		noteSecond:"String",
		root:"Footer",
		locale:"Locale",
		linksFirstColumn:"FooterLink",
		linksSecondColumn:"FooterLink",
		termsAndConditions:"Link",
		form:"String",
		bannerTitle:"String",
		bannerSubtitle:"String",
		bannerImage:"Image",
		bannerLink:"Link",
		jobsForm:"JobsFormLocale",
		copyrightLink:"Link",
		bannerSecondBtn:"String",
		recommendationForm:"RecommendationFormLocale",
		bannerSecondLink:"Link",
		instagramLink:"Link",
		paginateLinksFirstColumn:"FooterLinkConnection",
		paginateLinksSecondColumn:"FooterLinkConnection"
	},
	FooterLocaleMeta:{
		id:"FieldMeta",
		email:"FieldMeta",
		address:"FieldMeta",
		ico:"FieldMeta",
		dic:"FieldMeta",
		copyright:"FieldMeta",
		note:"FieldMeta",
		noteSecond:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		linksFirstColumn:"FieldMeta",
		linksSecondColumn:"FieldMeta",
		termsAndConditions:"FieldMeta",
		form:"FieldMeta",
		bannerTitle:"FieldMeta",
		bannerSubtitle:"FieldMeta",
		bannerImage:"FieldMeta",
		bannerLink:"FieldMeta",
		jobsForm:"FieldMeta",
		copyrightLink:"FieldMeta",
		bannerSecondBtn:"FieldMeta",
		recommendationForm:"FieldMeta",
		bannerSecondLink:"FieldMeta",
		instagramLink:"FieldMeta"
	},
	Footer:{
		_meta:"FooterMeta",
		id:"UUID",
		unique:"One",
		locales:"FooterLocale",
		localesByLocale:"FooterLocale",
		localesByTermsAndConditions:"FooterLocale",
		localesByBannerImage:"FooterLocale",
		localesByBannerLink:"FooterLocale",
		localesByJobsForm:"FooterLocale",
		localesByCopyrightLink:"FooterLocale",
		localesByRecommendationForm:"FooterLocale",
		localesByBannerSecondLink:"FooterLocale",
		localesByInstagramLink:"FooterLocale",
		paginateLocales:"FooterLocaleConnection"
	},
	FooterMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	FooterLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"FooterLocaleEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	FooterLocaleEdge:{
		node:"FooterLocale"
	},
	FooterLink:{
		_meta:"FooterLinkMeta",
		id:"UUID",
		order:"Int",
		link:"Link"
	},
	FooterLinkMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkType",
		title:"String",
		externalLink:"String",
		internalLink:"Linkable",
		anchorLink:"String"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		externalLink:"FieldMeta",
		internalLink:"FieldMeta",
		anchorLink:"FieldMeta"
	},
	Linkable:{
		_meta:"LinkableMeta",
		id:"UUID",
		url:"String",
		redirect:"Redirect",
		genericPage:"GenericPageLocale",
		businessPage:"BusinessPageLocale",
		jobPage:"JobPageLocale",
		homePage:"HomePageLocale",
		homePageLokal:"HomePageLokalLocale"
	},
	LinkableMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		redirect:"FieldMeta",
		genericPage:"FieldMeta",
		businessPage:"FieldMeta",
		jobPage:"FieldMeta",
		homePage:"FieldMeta",
		homePageLokal:"FieldMeta"
	},
	Redirect:{
		_meta:"RedirectMeta",
		id:"UUID",
		link:"Linkable",
		target:"Link"
	},
	RedirectMeta:{
		id:"FieldMeta",
		link:"FieldMeta",
		target:"FieldMeta"
	},
	GenericPageLocale:{
		_meta:"GenericPageLocaleMeta",
		id:"UUID",
		title:"String",
		root:"GenericPage",
		locale:"Locale",
		content:"Content",
		seo:"Seo",
		link:"Linkable",
		text:"String",
		logo:"Image",
		image:"Image"
	},
	GenericPageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		text:"FieldMeta",
		logo:"FieldMeta",
		image:"FieldMeta"
	},
	GenericPage:{
		_meta:"GenericPageMeta",
		id:"UUID",
		locales:"GenericPageLocale",
		theme:"Theme",
		headerColor:"String",
		localesByLocale:"GenericPageLocale",
		localesByContent:"GenericPageLocale",
		localesBySeo:"GenericPageLocale",
		localesByLink:"GenericPageLocale",
		localesByLogo:"GenericPageLocale",
		localesByImage:"GenericPageLocale",
		paginateLocales:"GenericPageLocaleConnection"
	},
	GenericPageMeta:{
		id:"FieldMeta",
		locales:"FieldMeta",
		theme:"FieldMeta",
		headerColor:"FieldMeta"
	},
	Theme:{
		_meta:"ThemeMeta",
		id:"UUID",
		backgroundColor:"String",
		textColor:"String",
		name:"String",
		buttonBackgroundColor:"String",
		buttonTextColor:"String",
		buttonBackgroundHoverColor:"String",
		buttonTextHoverColor:"String",
		buttonBorderColor:"String",
		buttonBorderHoverColor:"String",
		headerMenuColor:"String"
	},
	ThemeMeta:{
		id:"FieldMeta",
		backgroundColor:"FieldMeta",
		textColor:"FieldMeta",
		name:"FieldMeta",
		buttonBackgroundColor:"FieldMeta",
		buttonTextColor:"FieldMeta",
		buttonBackgroundHoverColor:"FieldMeta",
		buttonTextHoverColor:"FieldMeta",
		buttonBorderColor:"FieldMeta",
		buttonBorderHoverColor:"FieldMeta",
		headerMenuColor:"FieldMeta"
	},
	GenericPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"GenericPageLocaleEdge"
	},
	GenericPageLocaleEdge:{
		node:"GenericPageLocale"
	},
	Content:{
		_meta:"ContentMeta",
		id:"UUID",
		blocks:"ContentBlock",
		blocksByReferences:"ContentBlock",
		paginateBlocks:"ContentBlockConnection"
	},
	ContentMeta:{
		id:"FieldMeta",
		blocks:"FieldMeta"
	},
	ContentBlock:{
		_meta:"ContentBlockMeta",
		id:"UUID",
		order:"Int",
		json:"String",
		content:"Content",
		references:"ContentReference",
		referencesByLinkables:"ContentReference",
		referencesByLink:"ContentReference",
		referencesByMedia:"ContentReference",
		paginateReferences:"ContentReferenceConnection"
	},
	ContentBlockMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		json:"FieldMeta",
		content:"FieldMeta",
		references:"FieldMeta"
	},
	ContentReference:{
		_meta:"ContentReferenceMeta",
		id:"UUID",
		type:"ContentReferenceType",
		primaryText:"String",
		block:"ContentBlock",
		image:"Image",
		linkables:"ContentReferenceLinkableItem",
		secondaryText:"String",
		link:"Link",
		media:"MediumList",
		textList:"TextList",
		carousel:"Carousel",
		bonusBanner:"BonusBannerLocale",
		sideBySide:"SideBySide",
		gallery:"Gallery",
		showBoolean:"Boolean",
		isRed:"Boolean",
		video:"Video",
		linkablesByItem:"ContentReferenceLinkableItem",
		paginateLinkables:"ContentReferenceLinkableItemConnection"
	},
	ContentReferenceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		primaryText:"FieldMeta",
		block:"FieldMeta",
		image:"FieldMeta",
		linkables:"FieldMeta",
		secondaryText:"FieldMeta",
		link:"FieldMeta",
		media:"FieldMeta",
		textList:"FieldMeta",
		carousel:"FieldMeta",
		bonusBanner:"FieldMeta",
		sideBySide:"FieldMeta",
		gallery:"FieldMeta",
		showBoolean:"FieldMeta",
		isRed:"FieldMeta",
		video:"FieldMeta"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		alt:"String",
		fileName:"String",
		focalPointX:"Float",
		focalPointY:"Float"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		alt:"FieldMeta",
		fileName:"FieldMeta",
		focalPointX:"FieldMeta",
		focalPointY:"FieldMeta"
	},
	ContentReferenceLinkableItem:{
		_meta:"ContentReferenceLinkableItemMeta",
		id:"UUID",
		item:"Linkable",
		reference:"ContentReference"
	},
	ContentReferenceLinkableItemMeta:{
		id:"FieldMeta",
		item:"FieldMeta",
		reference:"FieldMeta"
	},
	MediumList:{
		_meta:"MediumListMeta",
		id:"UUID",
		items:"MediumItem",
		paginateItems:"MediumItemConnection"
	},
	MediumListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	MediumItem:{
		_meta:"MediumItemMeta",
		id:"UUID",
		order:"Int",
		list:"MediumList",
		medium:"Medium"
	},
	MediumItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		medium:"FieldMeta"
	},
	Medium:{
		_meta:"MediumMeta",
		id:"UUID",
		type:"MediumType",
		image:"Image",
		video:"Video"
	},
	MediumMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		image:"FieldMeta",
		video:"FieldMeta"
	},
	Video:{
		_meta:"VideoMeta",
		id:"UUID",
		src:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		videoInfo:"String",
		duration:"Float",
		poster:"Image"
	},
	VideoMeta:{
		id:"FieldMeta",
		src:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		videoInfo:"FieldMeta",
		duration:"FieldMeta",
		poster:"FieldMeta"
	},
	MediumItemConnection:{
		pageInfo:"PageInfo",
		edges:"MediumItemEdge"
	},
	MediumItemEdge:{
		node:"MediumItem"
	},
	TextList:{
		_meta:"TextListMeta",
		id:"UUID",
		items:"TextItem",
		paginateItems:"TextItemConnection"
	},
	TextListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	TextItem:{
		_meta:"TextItemMeta",
		id:"UUID",
		order:"Int",
		text:"String",
		list:"TextList",
		title:"String"
	},
	TextItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta",
		title:"FieldMeta"
	},
	TextItemConnection:{
		pageInfo:"PageInfo",
		edges:"TextItemEdge"
	},
	TextItemEdge:{
		node:"TextItem"
	},
	Carousel:{
		_meta:"CarouselMeta",
		id:"UUID",
		items:"CarouselItem",
		background:"Background",
		squareImages:"Boolean",
		itemsByImage:"CarouselItem",
		itemsByLinkUrl:"CarouselItem",
		itemsByVideo:"CarouselItem",
		paginateItems:"CarouselItemConnection"
	},
	CarouselMeta:{
		id:"FieldMeta",
		items:"FieldMeta",
		background:"FieldMeta",
		squareImages:"FieldMeta"
	},
	CarouselItem:{
		_meta:"CarouselItemMeta",
		id:"UUID",
		order:"Int",
		text:"String",
		list:"Carousel",
		image:"Image",
		name:"String",
		title:"String",
		linkUrl:"Link",
		normalAspectRatio:"Boolean",
		isImage:"Boolean",
		video:"Video"
	},
	CarouselItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta",
		name:"FieldMeta",
		title:"FieldMeta",
		linkUrl:"FieldMeta",
		normalAspectRatio:"FieldMeta",
		isImage:"FieldMeta",
		video:"FieldMeta"
	},
	CarouselItemConnection:{
		pageInfo:"PageInfo",
		edges:"CarouselItemEdge"
	},
	CarouselItemEdge:{
		node:"CarouselItem"
	},
	BonusBannerLocale:{
		_meta:"BonusBannerLocaleMeta",
		id:"UUID",
		title:"String",
		text:"String",
		root:"BonusBanner",
		locale:"Locale",
		tiles:"Tile",
		logo:"Image",
		bannerName:"String",
		tilesByImage:"Tile",
		tilesByLigthBoxMedia:"Tile",
		paginateTiles:"TileConnection"
	},
	BonusBannerLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		tiles:"FieldMeta",
		logo:"FieldMeta",
		bannerName:"FieldMeta"
	},
	BonusBanner:{
		_meta:"BonusBannerMeta",
		id:"UUID",
		locales:"BonusBannerLocale",
		localesByLocale:"BonusBannerLocale",
		localesByTiles:"BonusBannerLocale",
		localesByLogo:"BonusBannerLocale",
		paginateLocales:"BonusBannerLocaleConnection"
	},
	BonusBannerMeta:{
		id:"FieldMeta",
		locales:"FieldMeta"
	},
	BonusBannerLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"BonusBannerLocaleEdge"
	},
	BonusBannerLocaleEdge:{
		node:"BonusBannerLocale"
	},
	Tile:{
		_meta:"TileMeta",
		id:"UUID",
		order:"Int",
		text:"String",
		bonusBanner:"BonusBannerLocale",
		image:"Image",
		lightBoxTitle:"String",
		lightBoxText:"String",
		ligthBoxMedia:"MediumList",
		lightBoxSectionTitle:"String",
		title:"String",
		lightBoxLinkLabel:"String",
		lightBoxForm:"JobsFormLocale"
	},
	TileMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		text:"FieldMeta",
		bonusBanner:"FieldMeta",
		image:"FieldMeta",
		lightBoxTitle:"FieldMeta",
		lightBoxText:"FieldMeta",
		ligthBoxMedia:"FieldMeta",
		lightBoxSectionTitle:"FieldMeta",
		title:"FieldMeta",
		lightBoxLinkLabel:"FieldMeta",
		lightBoxForm:"FieldMeta"
	},
	JobsFormLocale:{
		_meta:"JobsFormLocaleMeta",
		id:"UUID",
		title:"String",
		jobText:"String",
		genericText:"String",
		nameLabel:"String",
		emailLabel:"String",
		telefonLabel:"String",
		fileTitleLabel:"String",
		fileFormatLabel:"String",
		formTextLabel:"String",
		submitLabel:"String",
		root:"JobsForm",
		locale:"Locale",
		imageTextList:"ImageTextList",
		minimalize:"String",
		logo:"Image",
		successTitle:"String",
		successText:"String",
		successBtnLabel:"String",
		successImage:"Image",
		successOtherJobsTitle:"String",
		successOtherJobsCategoryTitle:"String",
		successOtherJobsButtonTitle:"String",
		successOtherJobsSelectionTitle:"String",
		successOtherJobsSelectionYesButton:"String",
		successOtherJobsSelectionNoButton:"String",
		fileRemoveBtnLabel:"String",
		gdprLabel:"String"
	},
	JobsFormLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		jobText:"FieldMeta",
		genericText:"FieldMeta",
		nameLabel:"FieldMeta",
		emailLabel:"FieldMeta",
		telefonLabel:"FieldMeta",
		fileTitleLabel:"FieldMeta",
		fileFormatLabel:"FieldMeta",
		formTextLabel:"FieldMeta",
		submitLabel:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		imageTextList:"FieldMeta",
		minimalize:"FieldMeta",
		logo:"FieldMeta",
		successTitle:"FieldMeta",
		successText:"FieldMeta",
		successBtnLabel:"FieldMeta",
		successImage:"FieldMeta",
		successOtherJobsTitle:"FieldMeta",
		successOtherJobsCategoryTitle:"FieldMeta",
		successOtherJobsButtonTitle:"FieldMeta",
		successOtherJobsSelectionTitle:"FieldMeta",
		successOtherJobsSelectionYesButton:"FieldMeta",
		successOtherJobsSelectionNoButton:"FieldMeta",
		fileRemoveBtnLabel:"FieldMeta",
		gdprLabel:"FieldMeta"
	},
	JobsForm:{
		_meta:"JobsFormMeta",
		id:"UUID",
		unique:"One",
		locales:"JobsFormLocale",
		fileIlustration:"Image",
		localesByLocale:"JobsFormLocale",
		localesByImageTextList:"JobsFormLocale",
		localesByLogo:"JobsFormLocale",
		localesBySuccessImage:"JobsFormLocale",
		paginateLocales:"JobsFormLocaleConnection"
	},
	JobsFormMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta",
		fileIlustration:"FieldMeta"
	},
	JobsFormLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"JobsFormLocaleEdge"
	},
	JobsFormLocaleEdge:{
		node:"JobsFormLocale"
	},
	ImageTextList:{
		_meta:"ImageTextListMeta",
		id:"UUID",
		items:"ImageTextItem",
		itemsByImage:"ImageTextItem",
		paginateItems:"ImageTextItemConnection"
	},
	ImageTextListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ImageTextItem:{
		_meta:"ImageTextItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		list:"ImageTextList",
		image:"Image"
	},
	ImageTextItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	ImageTextItemConnection:{
		pageInfo:"PageInfo",
		edges:"ImageTextItemEdge"
	},
	ImageTextItemEdge:{
		node:"ImageTextItem"
	},
	TileConnection:{
		pageInfo:"PageInfo",
		edges:"TileEdge"
	},
	TileEdge:{
		node:"Tile"
	},
	SideBySide:{
		_meta:"SideBySideMeta",
		id:"UUID",
		items:"SideBySideItem",
		background:"Background",
		alignment:"ContentAlignment",
		mediumSize:"MediumSize",
		itemsByMedia:"SideBySideItem",
		paginateItems:"SideBySideItemConnection"
	},
	SideBySideMeta:{
		id:"FieldMeta",
		items:"FieldMeta",
		background:"FieldMeta",
		alignment:"FieldMeta",
		mediumSize:"FieldMeta"
	},
	SideBySideItem:{
		_meta:"SideBySideItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		text:"String",
		list:"SideBySide",
		media:"MediumList",
		formButtonLabel:"String",
		type:"SideBySideItemType",
		link:"Link",
		jobsForm:"JobsFormLocale",
		textNew:"String"
	},
	SideBySideItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta",
		media:"FieldMeta",
		formButtonLabel:"FieldMeta",
		type:"FieldMeta",
		link:"FieldMeta",
		jobsForm:"FieldMeta",
		textNew:"FieldMeta"
	},
	SideBySideItemConnection:{
		pageInfo:"PageInfo",
		edges:"SideBySideItemEdge"
	},
	SideBySideItemEdge:{
		node:"SideBySideItem"
	},
	Gallery:{
		_meta:"GalleryMeta",
		id:"UUID",
		items:"GalleryItem",
		itemsByImage:"GalleryItem",
		paginateItems:"GalleryItemConnection"
	},
	GalleryMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	GalleryItem:{
		_meta:"GalleryItemMeta",
		id:"UUID",
		order:"Int",
		list:"Gallery",
		image:"Image"
	},
	GalleryItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	GalleryItemConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryItemEdge"
	},
	GalleryItemEdge:{
		node:"GalleryItem"
	},
	ContentReferenceLinkableItemConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceLinkableItemEdge"
	},
	ContentReferenceLinkableItemEdge:{
		node:"ContentReferenceLinkableItem"
	},
	ContentReferenceConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceEdge"
	},
	ContentReferenceEdge:{
		node:"ContentReference"
	},
	ContentBlockConnection:{
		pageInfo:"PageInfo",
		edges:"ContentBlockEdge"
	},
	ContentBlockEdge:{
		node:"ContentBlock"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		noIndex:"Boolean",
		noFollow:"Boolean",
		ogImage:"Image"
	},
	SeoMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		noIndex:"FieldMeta",
		noFollow:"FieldMeta",
		ogImage:"FieldMeta"
	},
	BusinessPageLocale:{
		_meta:"BusinessPageLocaleMeta",
		id:"UUID",
		root:"BusinessPage",
		locale:"Locale",
		content:"Content",
		seo:"Seo",
		link:"Linkable",
		subtitle:"String",
		text:"String",
		name:"String",
		image:"Image",
		stickyBar:"StickyBar",
		infoBox:"InfoBox"
	},
	BusinessPageLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		subtitle:"FieldMeta",
		text:"FieldMeta",
		name:"FieldMeta",
		image:"FieldMeta",
		stickyBar:"FieldMeta",
		infoBox:"FieldMeta"
	},
	BusinessPage:{
		_meta:"BusinessPageMeta",
		id:"UUID",
		locales:"BusinessPageLocale",
		theme:"Theme",
		isLokal:"Boolean",
		tabidooId:"String",
		headerColor:"String",
		recruitisOfficeId:"String",
		localesByLocale:"BusinessPageLocale",
		localesByContent:"BusinessPageLocale",
		localesBySeo:"BusinessPageLocale",
		localesByLink:"BusinessPageLocale",
		localesByImage:"BusinessPageLocale",
		paginateLocales:"BusinessPageLocaleConnection"
	},
	BusinessPageMeta:{
		id:"FieldMeta",
		locales:"FieldMeta",
		theme:"FieldMeta",
		isLokal:"FieldMeta",
		tabidooId:"FieldMeta",
		headerColor:"FieldMeta",
		recruitisOfficeId:"FieldMeta"
	},
	BusinessPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessPageLocaleEdge"
	},
	BusinessPageLocaleEdge:{
		node:"BusinessPageLocale"
	},
	StickyBar:{
		_meta:"StickyBarMeta",
		id:"UUID",
		title:"String",
		link:"Link",
		formButtonLabel:"String",
		jobsForm:"JobsFormLocale"
	},
	StickyBarMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		formButtonLabel:"FieldMeta",
		jobsForm:"FieldMeta"
	},
	InfoBox:{
		_meta:"InfoBoxMeta",
		id:"UUID",
		logoSize:"LogoSize",
		logo:"Image",
		locales:"InfoBoxLocale",
		localesByLocale:"InfoBoxLocale",
		paginateLocales:"InfoBoxLocaleConnection"
	},
	InfoBoxMeta:{
		id:"FieldMeta",
		logoSize:"FieldMeta",
		logo:"FieldMeta",
		locales:"FieldMeta"
	},
	InfoBoxLocale:{
		_meta:"InfoBoxLocaleMeta",
		id:"UUID",
		address:"String",
		web:"String",
		instagram:"String",
		facebook:"String",
		root:"InfoBox",
		locale:"Locale",
		openingHours:"TextList",
		addressLink:"String"
	},
	InfoBoxLocaleMeta:{
		id:"FieldMeta",
		address:"FieldMeta",
		web:"FieldMeta",
		instagram:"FieldMeta",
		facebook:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		openingHours:"FieldMeta",
		addressLink:"FieldMeta"
	},
	InfoBoxLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"InfoBoxLocaleEdge"
	},
	InfoBoxLocaleEdge:{
		node:"InfoBoxLocale"
	},
	JobPageLocale:{
		_meta:"JobPageLocaleMeta",
		id:"UUID",
		title:"String",
		text:"String",
		root:"JobPage",
		locale:"Locale",
		image:"Image",
		keyInfo:"KeyInfoList",
		content:"Content",
		seo:"Seo",
		link:"Linkable",
		email:"String",
		stickyBar:"StickyBar",
		mobileImage:"Image",
		isSyncedToTabidoo:"Boolean",
		tabidooId:"String",
		recruitisJobId:"String"
	},
	JobPageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		image:"FieldMeta",
		keyInfo:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		email:"FieldMeta",
		stickyBar:"FieldMeta",
		mobileImage:"FieldMeta",
		isSyncedToTabidoo:"FieldMeta",
		tabidooId:"FieldMeta",
		recruitisJobId:"FieldMeta"
	},
	JobPage:{
		_meta:"JobPageMeta",
		id:"UUID",
		locales:"JobPageLocale",
		theme:"Theme",
		contractType:"ContractType",
		jobCity:"JobCity",
		isActive:"Boolean",
		jobPosition:"JobPosition",
		publishedAt:"DateTime",
		order:"Int",
		isSyncedToTabidoo:"Boolean",
		business:"BusinessPage",
		headerColor:"String",
		siteType:"SiteType",
		isHiddenFromListing:"Boolean",
		localesByLocale:"JobPageLocale",
		localesByImage:"JobPageLocale",
		localesByKeyInfo:"JobPageLocale",
		localesByContent:"JobPageLocale",
		localesBySeo:"JobPageLocale",
		localesByLink:"JobPageLocale",
		localesByMobileImage:"JobPageLocale",
		paginateLocales:"JobPageLocaleConnection"
	},
	JobPageMeta:{
		id:"FieldMeta",
		locales:"FieldMeta",
		theme:"FieldMeta",
		contractType:"FieldMeta",
		jobCity:"FieldMeta",
		isActive:"FieldMeta",
		jobPosition:"FieldMeta",
		publishedAt:"FieldMeta",
		order:"FieldMeta",
		isSyncedToTabidoo:"FieldMeta",
		business:"FieldMeta",
		headerColor:"FieldMeta",
		siteType:"FieldMeta",
		isHiddenFromListing:"FieldMeta"
	},
	ContractType:{
		_meta:"ContractTypeMeta",
		id:"UUID",
		locales:"ContractTypeLocale",
		localesByLocale:"ContractTypeLocale",
		paginateLocales:"ContractTypeLocaleConnection"
	},
	ContractTypeMeta:{
		id:"FieldMeta",
		locales:"FieldMeta"
	},
	ContractTypeLocale:{
		_meta:"ContractTypeLocaleMeta",
		id:"UUID",
		type:"String",
		root:"ContractType",
		locale:"Locale",
		slug:"String"
	},
	ContractTypeLocaleMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		slug:"FieldMeta"
	},
	ContractTypeLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ContractTypeLocaleEdge"
	},
	ContractTypeLocaleEdge:{
		node:"ContractTypeLocale"
	},
	JobCity:{
		_meta:"JobCityMeta",
		id:"UUID",
		locales:"JobCityLocale",
		localesByLocale:"JobCityLocale",
		paginateLocales:"JobCityLocaleConnection"
	},
	JobCityMeta:{
		id:"FieldMeta",
		locales:"FieldMeta"
	},
	JobCityLocale:{
		_meta:"JobCityLocaleMeta",
		id:"UUID",
		root:"JobCity",
		locale:"Locale",
		name:"String",
		slug:"String"
	},
	JobCityLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		name:"FieldMeta",
		slug:"FieldMeta"
	},
	JobCityLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"JobCityLocaleEdge"
	},
	JobCityLocaleEdge:{
		node:"JobCityLocale"
	},
	JobPosition:{
		_meta:"JobPositionMeta",
		id:"UUID",
		locales:"JobPositionLocale",
		jobs:"JobPage",
		localesByLocale:"JobPositionLocale",
		jobsByLocales:"JobPage",
		paginateLocales:"JobPositionLocaleConnection",
		paginateJobs:"JobPageConnection"
	},
	JobPositionMeta:{
		id:"FieldMeta",
		locales:"FieldMeta",
		jobs:"FieldMeta"
	},
	JobPositionLocale:{
		_meta:"JobPositionLocaleMeta",
		id:"UUID",
		type:"String",
		root:"JobPosition",
		locale:"Locale",
		slug:"String"
	},
	JobPositionLocaleMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		slug:"FieldMeta"
	},
	JobPositionLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"JobPositionLocaleEdge"
	},
	JobPositionLocaleEdge:{
		node:"JobPositionLocale"
	},
	JobPageConnection:{
		pageInfo:"PageInfo",
		edges:"JobPageEdge"
	},
	JobPageEdge:{
		node:"JobPage"
	},
	JobPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"JobPageLocaleEdge"
	},
	JobPageLocaleEdge:{
		node:"JobPageLocale"
	},
	KeyInfoList:{
		_meta:"KeyInfoListMeta",
		id:"UUID",
		items:"KeyInfoItem",
		paginateItems:"KeyInfoItemConnection"
	},
	KeyInfoListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	KeyInfoItem:{
		_meta:"KeyInfoItemMeta",
		id:"UUID",
		order:"Int",
		keyInfo:"String",
		list:"KeyInfoList",
		icon:"Icon"
	},
	KeyInfoItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		keyInfo:"FieldMeta",
		list:"FieldMeta",
		icon:"FieldMeta"
	},
	Icon:{
		_meta:"IconMeta",
		id:"UUID",
		name:"String",
		icon:"Image"
	},
	IconMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		icon:"FieldMeta"
	},
	KeyInfoItemConnection:{
		pageInfo:"PageInfo",
		edges:"KeyInfoItemEdge"
	},
	KeyInfoItemEdge:{
		node:"KeyInfoItem"
	},
	HomePageLocale:{
		_meta:"HomePageLocaleMeta",
		id:"UUID",
		title:"String",
		root:"HomePage",
		locale:"Locale",
		button:"Link",
		content:"Content",
		seo:"Seo",
		link:"Linkable",
		logo:"Image",
		siteSwitcher:"SiteSwitcher",
		gallery:"Gallery",
		stickyBar:"StickyBar",
		text:"String",
		ilustration:"Gallery"
	},
	HomePageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		button:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		logo:"FieldMeta",
		siteSwitcher:"FieldMeta",
		gallery:"FieldMeta",
		stickyBar:"FieldMeta",
		text:"FieldMeta",
		ilustration:"FieldMeta"
	},
	HomePage:{
		_meta:"HomePageMeta",
		id:"UUID",
		unique:"One",
		locales:"HomePageLocale",
		theme:"Theme",
		localesByLocale:"HomePageLocale",
		localesByButton:"HomePageLocale",
		localesByContent:"HomePageLocale",
		localesBySeo:"HomePageLocale",
		localesByLink:"HomePageLocale",
		localesByLogo:"HomePageLocale",
		localesBySiteSwitcher:"HomePageLocale",
		localesByIlustration:"HomePageLocale",
		paginateLocales:"HomePageLocaleConnection"
	},
	HomePageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta",
		theme:"FieldMeta"
	},
	HomePageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"HomePageLocaleEdge"
	},
	HomePageLocaleEdge:{
		node:"HomePageLocale"
	},
	SiteSwitcher:{
		_meta:"SiteSwitcherMeta",
		id:"UUID",
		title:"String",
		link:"Link",
		theme:"Theme",
		headerColor:"String"
	},
	SiteSwitcherMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		theme:"FieldMeta",
		headerColor:"FieldMeta"
	},
	HomePageLokalLocale:{
		_meta:"HomePageLokalLocaleMeta",
		id:"UUID",
		title:"String",
		root:"HomePageLokal",
		locale:"Locale",
		logo:"Image",
		button:"Link",
		content:"Content",
		seo:"Seo",
		link:"Linkable",
		siteSwitcher:"SiteSwitcher",
		gallery:"Gallery",
		stickyBar:"StickyBar",
		text:"String",
		ilustration:"Gallery"
	},
	HomePageLokalLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		logo:"FieldMeta",
		button:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		siteSwitcher:"FieldMeta",
		gallery:"FieldMeta",
		stickyBar:"FieldMeta",
		text:"FieldMeta",
		ilustration:"FieldMeta"
	},
	HomePageLokal:{
		_meta:"HomePageLokalMeta",
		id:"UUID",
		unique:"One",
		locales:"HomePageLokalLocale",
		theme:"Theme",
		localesByLocale:"HomePageLokalLocale",
		localesByLogo:"HomePageLokalLocale",
		localesByButton:"HomePageLokalLocale",
		localesByContent:"HomePageLokalLocale",
		localesBySeo:"HomePageLokalLocale",
		localesByLink:"HomePageLokalLocale",
		localesBySiteSwitcher:"HomePageLokalLocale",
		localesByIlustration:"HomePageLokalLocale",
		paginateLocales:"HomePageLokalLocaleConnection"
	},
	HomePageLokalMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta",
		theme:"FieldMeta"
	},
	HomePageLokalLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"HomePageLokalLocaleEdge"
	},
	HomePageLokalLocaleEdge:{
		node:"HomePageLokalLocale"
	},
	RecommendationFormLocale:{
		_meta:"RecommendationFormLocaleMeta",
		id:"UUID",
		title:"String",
		subtitle:"String",
		yourEmailLabel:"String",
		theirEmailLabel:"String",
		yourName:"String",
		sendBtnLabel:"String",
		successTitle:"String",
		successSubtitle:"String",
		successButtonClose:"String",
		root:"RecommendationForm",
		locale:"Locale"
	},
	RecommendationFormLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		subtitle:"FieldMeta",
		yourEmailLabel:"FieldMeta",
		theirEmailLabel:"FieldMeta",
		yourName:"FieldMeta",
		sendBtnLabel:"FieldMeta",
		successTitle:"FieldMeta",
		successSubtitle:"FieldMeta",
		successButtonClose:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	RecommendationForm:{
		_meta:"RecommendationFormMeta",
		id:"UUID",
		unique:"One",
		locales:"RecommendationFormLocale",
		successImage:"Image",
		localesByLocale:"RecommendationFormLocale",
		paginateLocales:"RecommendationFormLocaleConnection"
	},
	RecommendationFormMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta",
		successImage:"FieldMeta"
	},
	RecommendationFormLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"RecommendationFormLocaleEdge"
	},
	RecommendationFormLocaleEdge:{
		node:"RecommendationFormLocale"
	},
	FooterLinkConnection:{
		pageInfo:"PageInfo",
		edges:"FooterLinkEdge"
	},
	FooterLinkEdge:{
		node:"FooterLink"
	},
	HeaderLocale:{
		_meta:"HeaderLocaleMeta",
		id:"UUID",
		root:"Header",
		locale:"Locale",
		menuLabel:"String",
		menuTitle:"String",
		menuText:"String",
		business:"Business",
		lokalEnterprise:"Business",
		businessSectionTitle:"String",
		lokalSectionTitle:"String",
		businessLink:"Link",
		lokalLink:"Link",
		paginateBusiness:"BusinessConnection",
		paginateLokalEnterprise:"BusinessConnection"
	},
	HeaderLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		menuLabel:"FieldMeta",
		menuTitle:"FieldMeta",
		menuText:"FieldMeta",
		business:"FieldMeta",
		lokalEnterprise:"FieldMeta",
		businessSectionTitle:"FieldMeta",
		lokalSectionTitle:"FieldMeta",
		businessLink:"FieldMeta",
		lokalLink:"FieldMeta"
	},
	Header:{
		_meta:"HeaderMeta",
		id:"UUID",
		unique:"One",
		locales:"HeaderLocale",
		logo:"Image",
		logoMenu:"Image",
		localesByLocale:"HeaderLocale",
		localesByBusinessLink:"HeaderLocale",
		localesByLokalLink:"HeaderLocale",
		paginateLocales:"HeaderLocaleConnection"
	},
	HeaderMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta",
		logo:"FieldMeta",
		logoMenu:"FieldMeta"
	},
	HeaderLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderLocaleEdge"
	},
	HeaderLocaleEdge:{
		node:"HeaderLocale"
	},
	Business:{
		_meta:"BusinessMeta",
		id:"UUID",
		order:"Int",
		logo:"Image",
		link:"Link"
	},
	BusinessMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		logo:"FieldMeta",
		link:"FieldMeta"
	},
	BusinessConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessEdge"
	},
	BusinessEdge:{
		node:"Business"
	},
	SeoDefaultLocale:{
		_meta:"SeoDefaultLocaleMeta",
		id:"UUID",
		root:"SeoDefault",
		locale:"Locale",
		seo:"Seo"
	},
	SeoDefaultLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		seo:"FieldMeta"
	},
	SeoDefault:{
		_meta:"SeoDefaultMeta",
		id:"UUID",
		unique:"One",
		locales:"SeoDefaultLocale",
		localesByLocale:"SeoDefaultLocale",
		localesBySeo:"SeoDefaultLocale",
		paginateLocales:"SeoDefaultLocaleConnection"
	},
	SeoDefaultMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	SeoDefaultLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"SeoDefaultLocaleEdge"
	},
	SeoDefaultLocaleEdge:{
		node:"SeoDefaultLocale"
	},
	JobsFilterLocale:{
		_meta:"JobsFilterLocaleMeta",
		id:"UUID",
		jobPositionLabel:"String",
		jobContractLabel:"String",
		jobCityLabel:"String",
		root:"JobsFilter",
		locale:"Locale",
		bannerTitle:"String",
		bannerFormLabel:"String",
		bannerJobsForm:"JobsFormLocale",
		bannerImage:"Image",
		noJobTitle:"String",
		noJobBtnLabel:"String",
		noJobImage:"Image",
		noJobTitleForSpecificBusiness:"String",
		deactivatedJob:"String"
	},
	JobsFilterLocaleMeta:{
		id:"FieldMeta",
		jobPositionLabel:"FieldMeta",
		jobContractLabel:"FieldMeta",
		jobCityLabel:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		bannerTitle:"FieldMeta",
		bannerFormLabel:"FieldMeta",
		bannerJobsForm:"FieldMeta",
		bannerImage:"FieldMeta",
		noJobTitle:"FieldMeta",
		noJobBtnLabel:"FieldMeta",
		noJobImage:"FieldMeta",
		noJobTitleForSpecificBusiness:"FieldMeta",
		deactivatedJob:"FieldMeta"
	},
	JobsFilter:{
		_meta:"JobsFilterMeta",
		id:"UUID",
		unique:"One",
		locales:"JobsFilterLocale",
		localesByLocale:"JobsFilterLocale",
		localesByBannerJobsForm:"JobsFilterLocale",
		localesByBannerImage:"JobsFilterLocale",
		localesByNoJobImage:"JobsFilterLocale",
		paginateLocales:"JobsFilterLocaleConnection"
	},
	JobsFilterMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	JobsFilterLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"JobsFilterLocaleEdge"
	},
	JobsFilterLocaleEdge:{
		node:"JobsFilterLocale"
	},
	TranslationLocale:{
		_meta:"TranslationLocaleMeta",
		id:"UUID",
		value:"String",
		root:"Translation",
		locale:"Locale"
	},
	TranslationLocaleMeta:{
		id:"FieldMeta",
		value:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	Translation:{
		_meta:"TranslationMeta",
		id:"UUID",
		order:"Int",
		key:"String",
		locales:"TranslationLocale",
		isTextarea:"Boolean",
		localesByLocale:"TranslationLocale",
		paginateLocales:"TranslationLocaleConnection"
	},
	TranslationMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		key:"FieldMeta",
		locales:"FieldMeta",
		isTextarea:"FieldMeta"
	},
	TranslationLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationLocaleEdge"
	},
	TranslationLocaleEdge:{
		node:"TranslationLocale"
	},
	GeneralLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"GeneralLocaleEdge"
	},
	GeneralLocaleEdge:{
		node:"GeneralLocale"
	},
	CornerBanner:{
		_meta:"CornerBannerMeta",
		id:"UUID",
		isActive:"Boolean",
		title:"String",
		text:"String",
		logo:"Image",
		link:"Link"
	},
	CornerBannerMeta:{
		id:"FieldMeta",
		isActive:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta",
		logo:"FieldMeta",
		link:"FieldMeta"
	},
	GeneralConnection:{
		pageInfo:"PageInfo",
		edges:"GeneralEdge"
	},
	GeneralEdge:{
		node:"General"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	GenericPageConnection:{
		pageInfo:"PageInfo",
		edges:"GenericPageEdge"
	},
	GenericPageEdge:{
		node:"GenericPage"
	},
	LinkableConnection:{
		pageInfo:"PageInfo",
		edges:"LinkableEdge"
	},
	LinkableEdge:{
		node:"Linkable"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	ContentConnection:{
		pageInfo:"PageInfo",
		edges:"ContentEdge"
	},
	ContentEdge:{
		node:"Content"
	},
	RedirectConnection:{
		pageInfo:"PageInfo",
		edges:"RedirectEdge"
	},
	RedirectEdge:{
		node:"Redirect"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	FooterConnection:{
		pageInfo:"PageInfo",
		edges:"FooterEdge"
	},
	FooterEdge:{
		node:"Footer"
	},
	HeaderConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderEdge"
	},
	HeaderEdge:{
		node:"Header"
	},
	LocaleConnection:{
		pageInfo:"PageInfo",
		edges:"LocaleEdge"
	},
	LocaleEdge:{
		node:"Locale"
	},
	SeoDefaultConnection:{
		pageInfo:"PageInfo",
		edges:"SeoDefaultEdge"
	},
	SeoDefaultEdge:{
		node:"SeoDefault"
	},
	BusinessPageConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessPageEdge"
	},
	BusinessPageEdge:{
		node:"BusinessPage"
	},
	IconConnection:{
		pageInfo:"PageInfo",
		edges:"IconEdge"
	},
	IconEdge:{
		node:"Icon"
	},
	KeyInfoListConnection:{
		pageInfo:"PageInfo",
		edges:"KeyInfoListEdge"
	},
	KeyInfoListEdge:{
		node:"KeyInfoList"
	},
	ContractTypeConnection:{
		pageInfo:"PageInfo",
		edges:"ContractTypeEdge"
	},
	ContractTypeEdge:{
		node:"ContractType"
	},
	JobCityConnection:{
		pageInfo:"PageInfo",
		edges:"JobCityEdge"
	},
	JobCityEdge:{
		node:"JobCity"
	},
	JobPositionConnection:{
		pageInfo:"PageInfo",
		edges:"JobPositionEdge"
	},
	JobPositionEdge:{
		node:"JobPosition"
	},
	GalleryConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryEdge"
	},
	GalleryEdge:{
		node:"Gallery"
	},
	HomePageConnection:{
		pageInfo:"PageInfo",
		edges:"HomePageEdge"
	},
	HomePageEdge:{
		node:"HomePage"
	},
	MediumConnection:{
		pageInfo:"PageInfo",
		edges:"MediumEdge"
	},
	MediumEdge:{
		node:"Medium"
	},
	MediumListConnection:{
		pageInfo:"PageInfo",
		edges:"MediumListEdge"
	},
	MediumListEdge:{
		node:"MediumList"
	},
	VideoConnection:{
		pageInfo:"PageInfo",
		edges:"VideoEdge"
	},
	VideoEdge:{
		node:"Video"
	},
	TextListConnection:{
		pageInfo:"PageInfo",
		edges:"TextListEdge"
	},
	TextListEdge:{
		node:"TextList"
	},
	CarouselConnection:{
		pageInfo:"PageInfo",
		edges:"CarouselEdge"
	},
	CarouselEdge:{
		node:"Carousel"
	},
	ThemeConnection:{
		pageInfo:"PageInfo",
		edges:"ThemeEdge"
	},
	ThemeEdge:{
		node:"Theme"
	},
	BonusBannerConnection:{
		pageInfo:"PageInfo",
		edges:"BonusBannerEdge"
	},
	BonusBannerEdge:{
		node:"BonusBanner"
	},
	SideBySideConnection:{
		pageInfo:"PageInfo",
		edges:"SideBySideEdge"
	},
	SideBySideEdge:{
		node:"SideBySide"
	},
	HomePageLokalConnection:{
		pageInfo:"PageInfo",
		edges:"HomePageLokalEdge"
	},
	HomePageLokalEdge:{
		node:"HomePageLokal"
	},
	SiteSwitcherConnection:{
		pageInfo:"PageInfo",
		edges:"SiteSwitcherEdge"
	},
	SiteSwitcherEdge:{
		node:"SiteSwitcher"
	},
	JobsFormConnection:{
		pageInfo:"PageInfo",
		edges:"JobsFormEdge"
	},
	JobsFormEdge:{
		node:"JobsForm"
	},
	ImageTextListConnection:{
		pageInfo:"PageInfo",
		edges:"ImageTextListEdge"
	},
	ImageTextListEdge:{
		node:"ImageTextList"
	},
	JobsFilterConnection:{
		pageInfo:"PageInfo",
		edges:"JobsFilterEdge"
	},
	JobsFilterEdge:{
		node:"JobsFilter"
	},
	File:{
		_meta:"FileMeta",
		id:"UUID",
		url:"String",
		size:"Int",
		type:"String"
	},
	FileMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta"
	},
	FileConnection:{
		pageInfo:"PageInfo",
		edges:"FileEdge"
	},
	FileEdge:{
		node:"File"
	},
	JobFormSubscription:{
		_meta:"JobFormSubscriptionMeta",
		id:"UUID",
		createdAt:"DateTime",
		name:"String",
		phone:"String",
		email:"String",
		message:"String",
		file:"File",
		job:"JobPageLocale",
		status:"JobFormSubscriptionStatus",
		isSyncedToTabidoo:"Boolean",
		tabidooId:"String",
		isGdprSyncedToTabidoo:"Boolean",
		recruitisAnswerId:"String"
	},
	JobFormSubscriptionMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		name:"FieldMeta",
		phone:"FieldMeta",
		email:"FieldMeta",
		message:"FieldMeta",
		file:"FieldMeta",
		job:"FieldMeta",
		status:"FieldMeta",
		isSyncedToTabidoo:"FieldMeta",
		tabidooId:"FieldMeta",
		isGdprSyncedToTabidoo:"FieldMeta",
		recruitisAnswerId:"FieldMeta"
	},
	JobFormSubscriptionStatus:{
		_meta:"JobFormSubscriptionStatusMeta",
		id:"UUID",
		statusTitle:"String",
		statusColor:"String"
	},
	JobFormSubscriptionStatusMeta:{
		id:"FieldMeta",
		statusTitle:"FieldMeta",
		statusColor:"FieldMeta"
	},
	JobFormSubscriptionConnection:{
		pageInfo:"PageInfo",
		edges:"JobFormSubscriptionEdge"
	},
	JobFormSubscriptionEdge:{
		node:"JobFormSubscription"
	},
	ImageList:{
		_meta:"ImageListMeta",
		id:"UUID",
		items:"ImageListItem",
		itemsByImage:"ImageListItem",
		paginateItems:"ImageListItemConnection"
	},
	ImageListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ImageListItem:{
		_meta:"ImageListItemMeta",
		id:"UUID",
		order:"Int",
		list:"ImageList",
		image:"Image"
	},
	ImageListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	ImageListItemConnection:{
		pageInfo:"PageInfo",
		edges:"ImageListItemEdge"
	},
	ImageListItemEdge:{
		node:"ImageListItem"
	},
	ImageListConnection:{
		pageInfo:"PageInfo",
		edges:"ImageListEdge"
	},
	ImageListEdge:{
		node:"ImageList"
	},
	JobFormSubscriptionStatusConnection:{
		pageInfo:"PageInfo",
		edges:"JobFormSubscriptionStatusEdge"
	},
	JobFormSubscriptionStatusEdge:{
		node:"JobFormSubscriptionStatus"
	},
	StickyBarConnection:{
		pageInfo:"PageInfo",
		edges:"StickyBarEdge"
	},
	StickyBarEdge:{
		node:"StickyBar"
	},
	RecommendationFormConnection:{
		pageInfo:"PageInfo",
		edges:"RecommendationFormEdge"
	},
	RecommendationFormEdge:{
		node:"RecommendationForm"
	},
	RecommendationFormSubscription:{
		_meta:"RecommendationFormSubscriptionMeta",
		id:"UUID",
		createdAt:"DateTime",
		yourEmail:"String",
		theirEmail:"String",
		yourName:"String"
	},
	RecommendationFormSubscriptionMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		yourEmail:"FieldMeta",
		theirEmail:"FieldMeta",
		yourName:"FieldMeta"
	},
	RecommendationFormSubscriptionConnection:{
		pageInfo:"PageInfo",
		edges:"RecommendationFormSubscriptionEdge"
	},
	RecommendationFormSubscriptionEdge:{
		node:"RecommendationFormSubscription"
	},
	InfoBoxConnection:{
		pageInfo:"PageInfo",
		edges:"InfoBoxEdge"
	},
	InfoBoxEdge:{
		node:"InfoBox"
	},
	TranslationConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationEdge"
	},
	TranslationEdge:{
		node:"Translation"
	},
	CornerBannerConnection:{
		pageInfo:"PageInfo",
		edges:"CornerBannerEdge"
	},
	CornerBannerEdge:{
		node:"CornerBanner"
	},
	QueryTransaction:{
		schema:"_Schema",
		s3DummyQuery:"String",
		getGeneral:"General",
		listGeneral:"General",
		paginateGeneral:"GeneralConnection",
		validateCreateGeneral:"_ValidationResult",
		validateUpdateGeneral:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getGenericPage:"GenericPage",
		listGenericPage:"GenericPage",
		paginateGenericPage:"GenericPageConnection",
		validateCreateGenericPage:"_ValidationResult",
		validateUpdateGenericPage:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getContentReferenceLinkableItem:"ContentReferenceLinkableItem",
		listContentReferenceLinkableItem:"ContentReferenceLinkableItem",
		paginateContentReferenceLinkableItem:"ContentReferenceLinkableItemConnection",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getFooterLink:"FooterLink",
		listFooterLink:"FooterLink",
		paginateFooterLink:"FooterLinkConnection",
		validateCreateFooterLink:"_ValidationResult",
		validateUpdateFooterLink:"_ValidationResult",
		getFooterLocale:"FooterLocale",
		listFooterLocale:"FooterLocale",
		paginateFooterLocale:"FooterLocaleConnection",
		validateCreateFooterLocale:"_ValidationResult",
		validateUpdateFooterLocale:"_ValidationResult",
		getGenericPageLocale:"GenericPageLocale",
		listGenericPageLocale:"GenericPageLocale",
		paginateGenericPageLocale:"GenericPageLocaleConnection",
		validateCreateGenericPageLocale:"_ValidationResult",
		validateUpdateGenericPageLocale:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHeaderLocale:"HeaderLocale",
		listHeaderLocale:"HeaderLocale",
		paginateHeaderLocale:"HeaderLocaleConnection",
		validateCreateHeaderLocale:"_ValidationResult",
		validateUpdateHeaderLocale:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getSeoDefault:"SeoDefault",
		listSeoDefault:"SeoDefault",
		paginateSeoDefault:"SeoDefaultConnection",
		validateCreateSeoDefault:"_ValidationResult",
		validateUpdateSeoDefault:"_ValidationResult",
		getSeoDefaultLocale:"SeoDefaultLocale",
		listSeoDefaultLocale:"SeoDefaultLocale",
		paginateSeoDefaultLocale:"SeoDefaultLocaleConnection",
		validateCreateSeoDefaultLocale:"_ValidationResult",
		validateUpdateSeoDefaultLocale:"_ValidationResult",
		getBusiness:"Business",
		listBusiness:"Business",
		paginateBusiness:"BusinessConnection",
		validateCreateBusiness:"_ValidationResult",
		validateUpdateBusiness:"_ValidationResult",
		getBusinessPage:"BusinessPage",
		listBusinessPage:"BusinessPage",
		paginateBusinessPage:"BusinessPageConnection",
		validateCreateBusinessPage:"_ValidationResult",
		validateUpdateBusinessPage:"_ValidationResult",
		getBusinessPageLocale:"BusinessPageLocale",
		listBusinessPageLocale:"BusinessPageLocale",
		paginateBusinessPageLocale:"BusinessPageLocaleConnection",
		validateCreateBusinessPageLocale:"_ValidationResult",
		validateUpdateBusinessPageLocale:"_ValidationResult",
		getIcon:"Icon",
		listIcon:"Icon",
		paginateIcon:"IconConnection",
		validateCreateIcon:"_ValidationResult",
		validateUpdateIcon:"_ValidationResult",
		getJobPage:"JobPage",
		listJobPage:"JobPage",
		paginateJobPage:"JobPageConnection",
		validateCreateJobPage:"_ValidationResult",
		validateUpdateJobPage:"_ValidationResult",
		getJobPageLocale:"JobPageLocale",
		listJobPageLocale:"JobPageLocale",
		paginateJobPageLocale:"JobPageLocaleConnection",
		validateCreateJobPageLocale:"_ValidationResult",
		validateUpdateJobPageLocale:"_ValidationResult",
		getKeyInfoItem:"KeyInfoItem",
		listKeyInfoItem:"KeyInfoItem",
		paginateKeyInfoItem:"KeyInfoItemConnection",
		validateCreateKeyInfoItem:"_ValidationResult",
		validateUpdateKeyInfoItem:"_ValidationResult",
		getKeyInfoList:"KeyInfoList",
		listKeyInfoList:"KeyInfoList",
		paginateKeyInfoList:"KeyInfoListConnection",
		validateCreateKeyInfoList:"_ValidationResult",
		validateUpdateKeyInfoList:"_ValidationResult",
		getContractType:"ContractType",
		listContractType:"ContractType",
		paginateContractType:"ContractTypeConnection",
		validateCreateContractType:"_ValidationResult",
		validateUpdateContractType:"_ValidationResult",
		getContractTypeLocale:"ContractTypeLocale",
		listContractTypeLocale:"ContractTypeLocale",
		paginateContractTypeLocale:"ContractTypeLocaleConnection",
		validateCreateContractTypeLocale:"_ValidationResult",
		validateUpdateContractTypeLocale:"_ValidationResult",
		getJobCity:"JobCity",
		listJobCity:"JobCity",
		paginateJobCity:"JobCityConnection",
		validateCreateJobCity:"_ValidationResult",
		validateUpdateJobCity:"_ValidationResult",
		getJobCityLocale:"JobCityLocale",
		listJobCityLocale:"JobCityLocale",
		paginateJobCityLocale:"JobCityLocaleConnection",
		validateCreateJobCityLocale:"_ValidationResult",
		validateUpdateJobCityLocale:"_ValidationResult",
		getJobPosition:"JobPosition",
		listJobPosition:"JobPosition",
		paginateJobPosition:"JobPositionConnection",
		validateCreateJobPosition:"_ValidationResult",
		validateUpdateJobPosition:"_ValidationResult",
		getJobPositionLocale:"JobPositionLocale",
		listJobPositionLocale:"JobPositionLocale",
		paginateJobPositionLocale:"JobPositionLocaleConnection",
		validateCreateJobPositionLocale:"_ValidationResult",
		validateUpdateJobPositionLocale:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getHomePage:"HomePage",
		listHomePage:"HomePage",
		paginateHomePage:"HomePageConnection",
		validateCreateHomePage:"_ValidationResult",
		validateUpdateHomePage:"_ValidationResult",
		getHomePageLocale:"HomePageLocale",
		listHomePageLocale:"HomePageLocale",
		paginateHomePageLocale:"HomePageLocaleConnection",
		validateCreateHomePageLocale:"_ValidationResult",
		validateUpdateHomePageLocale:"_ValidationResult",
		getMedium:"Medium",
		listMedium:"Medium",
		paginateMedium:"MediumConnection",
		validateCreateMedium:"_ValidationResult",
		validateUpdateMedium:"_ValidationResult",
		getMediumItem:"MediumItem",
		listMediumItem:"MediumItem",
		paginateMediumItem:"MediumItemConnection",
		validateCreateMediumItem:"_ValidationResult",
		validateUpdateMediumItem:"_ValidationResult",
		getMediumList:"MediumList",
		listMediumList:"MediumList",
		paginateMediumList:"MediumListConnection",
		validateCreateMediumList:"_ValidationResult",
		validateUpdateMediumList:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getTextItem:"TextItem",
		listTextItem:"TextItem",
		paginateTextItem:"TextItemConnection",
		validateCreateTextItem:"_ValidationResult",
		validateUpdateTextItem:"_ValidationResult",
		getTextList:"TextList",
		listTextList:"TextList",
		paginateTextList:"TextListConnection",
		validateCreateTextList:"_ValidationResult",
		validateUpdateTextList:"_ValidationResult",
		getCarousel:"Carousel",
		listCarousel:"Carousel",
		paginateCarousel:"CarouselConnection",
		validateCreateCarousel:"_ValidationResult",
		validateUpdateCarousel:"_ValidationResult",
		getCarouselItem:"CarouselItem",
		listCarouselItem:"CarouselItem",
		paginateCarouselItem:"CarouselItemConnection",
		validateCreateCarouselItem:"_ValidationResult",
		validateUpdateCarouselItem:"_ValidationResult",
		getTheme:"Theme",
		listTheme:"Theme",
		paginateTheme:"ThemeConnection",
		validateCreateTheme:"_ValidationResult",
		validateUpdateTheme:"_ValidationResult",
		getBonusBanner:"BonusBanner",
		listBonusBanner:"BonusBanner",
		paginateBonusBanner:"BonusBannerConnection",
		validateCreateBonusBanner:"_ValidationResult",
		validateUpdateBonusBanner:"_ValidationResult",
		getBonusBannerLocale:"BonusBannerLocale",
		listBonusBannerLocale:"BonusBannerLocale",
		paginateBonusBannerLocale:"BonusBannerLocaleConnection",
		validateCreateBonusBannerLocale:"_ValidationResult",
		validateUpdateBonusBannerLocale:"_ValidationResult",
		getTile:"Tile",
		listTile:"Tile",
		paginateTile:"TileConnection",
		validateCreateTile:"_ValidationResult",
		validateUpdateTile:"_ValidationResult",
		getSideBySide:"SideBySide",
		listSideBySide:"SideBySide",
		paginateSideBySide:"SideBySideConnection",
		validateCreateSideBySide:"_ValidationResult",
		validateUpdateSideBySide:"_ValidationResult",
		getSideBySideItem:"SideBySideItem",
		listSideBySideItem:"SideBySideItem",
		paginateSideBySideItem:"SideBySideItemConnection",
		validateCreateSideBySideItem:"_ValidationResult",
		validateUpdateSideBySideItem:"_ValidationResult",
		getHomePageLokal:"HomePageLokal",
		listHomePageLokal:"HomePageLokal",
		paginateHomePageLokal:"HomePageLokalConnection",
		validateCreateHomePageLokal:"_ValidationResult",
		validateUpdateHomePageLokal:"_ValidationResult",
		getHomePageLokalLocale:"HomePageLokalLocale",
		listHomePageLokalLocale:"HomePageLokalLocale",
		paginateHomePageLokalLocale:"HomePageLokalLocaleConnection",
		validateCreateHomePageLokalLocale:"_ValidationResult",
		validateUpdateHomePageLokalLocale:"_ValidationResult",
		getSiteSwitcher:"SiteSwitcher",
		listSiteSwitcher:"SiteSwitcher",
		paginateSiteSwitcher:"SiteSwitcherConnection",
		validateCreateSiteSwitcher:"_ValidationResult",
		validateUpdateSiteSwitcher:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getJobsForm:"JobsForm",
		listJobsForm:"JobsForm",
		paginateJobsForm:"JobsFormConnection",
		validateCreateJobsForm:"_ValidationResult",
		validateUpdateJobsForm:"_ValidationResult",
		getJobsFormLocale:"JobsFormLocale",
		listJobsFormLocale:"JobsFormLocale",
		paginateJobsFormLocale:"JobsFormLocaleConnection",
		validateCreateJobsFormLocale:"_ValidationResult",
		validateUpdateJobsFormLocale:"_ValidationResult",
		getImageTextItem:"ImageTextItem",
		listImageTextItem:"ImageTextItem",
		paginateImageTextItem:"ImageTextItemConnection",
		validateCreateImageTextItem:"_ValidationResult",
		validateUpdateImageTextItem:"_ValidationResult",
		getImageTextList:"ImageTextList",
		listImageTextList:"ImageTextList",
		paginateImageTextList:"ImageTextListConnection",
		validateCreateImageTextList:"_ValidationResult",
		validateUpdateImageTextList:"_ValidationResult",
		getJobsFilter:"JobsFilter",
		listJobsFilter:"JobsFilter",
		paginateJobsFilter:"JobsFilterConnection",
		validateCreateJobsFilter:"_ValidationResult",
		validateUpdateJobsFilter:"_ValidationResult",
		getJobsFilterLocale:"JobsFilterLocale",
		listJobsFilterLocale:"JobsFilterLocale",
		paginateJobsFilterLocale:"JobsFilterLocaleConnection",
		validateCreateJobsFilterLocale:"_ValidationResult",
		validateUpdateJobsFilterLocale:"_ValidationResult",
		getFile:"File",
		listFile:"File",
		paginateFile:"FileConnection",
		validateCreateFile:"_ValidationResult",
		validateUpdateFile:"_ValidationResult",
		getJobFormSubscription:"JobFormSubscription",
		listJobFormSubscription:"JobFormSubscription",
		paginateJobFormSubscription:"JobFormSubscriptionConnection",
		validateCreateJobFormSubscription:"_ValidationResult",
		validateUpdateJobFormSubscription:"_ValidationResult",
		getImageList:"ImageList",
		listImageList:"ImageList",
		paginateImageList:"ImageListConnection",
		validateCreateImageList:"_ValidationResult",
		validateUpdateImageList:"_ValidationResult",
		getImageListItem:"ImageListItem",
		listImageListItem:"ImageListItem",
		paginateImageListItem:"ImageListItemConnection",
		validateCreateImageListItem:"_ValidationResult",
		validateUpdateImageListItem:"_ValidationResult",
		getJobFormSubscriptionStatus:"JobFormSubscriptionStatus",
		listJobFormSubscriptionStatus:"JobFormSubscriptionStatus",
		paginateJobFormSubscriptionStatus:"JobFormSubscriptionStatusConnection",
		validateCreateJobFormSubscriptionStatus:"_ValidationResult",
		validateUpdateJobFormSubscriptionStatus:"_ValidationResult",
		getGeneralLocale:"GeneralLocale",
		listGeneralLocale:"GeneralLocale",
		paginateGeneralLocale:"GeneralLocaleConnection",
		validateCreateGeneralLocale:"_ValidationResult",
		validateUpdateGeneralLocale:"_ValidationResult",
		getStickyBar:"StickyBar",
		listStickyBar:"StickyBar",
		paginateStickyBar:"StickyBarConnection",
		validateCreateStickyBar:"_ValidationResult",
		validateUpdateStickyBar:"_ValidationResult",
		getRecommendationForm:"RecommendationForm",
		listRecommendationForm:"RecommendationForm",
		paginateRecommendationForm:"RecommendationFormConnection",
		validateCreateRecommendationForm:"_ValidationResult",
		validateUpdateRecommendationForm:"_ValidationResult",
		getRecommendationFormLocale:"RecommendationFormLocale",
		listRecommendationFormLocale:"RecommendationFormLocale",
		paginateRecommendationFormLocale:"RecommendationFormLocaleConnection",
		validateCreateRecommendationFormLocale:"_ValidationResult",
		validateUpdateRecommendationFormLocale:"_ValidationResult",
		getRecommendationFormSubscription:"RecommendationFormSubscription",
		listRecommendationFormSubscription:"RecommendationFormSubscription",
		paginateRecommendationFormSubscription:"RecommendationFormSubscriptionConnection",
		validateCreateRecommendationFormSubscription:"_ValidationResult",
		validateUpdateRecommendationFormSubscription:"_ValidationResult",
		getInfoBox:"InfoBox",
		listInfoBox:"InfoBox",
		paginateInfoBox:"InfoBoxConnection",
		validateCreateInfoBox:"_ValidationResult",
		validateUpdateInfoBox:"_ValidationResult",
		getInfoBoxLocale:"InfoBoxLocale",
		listInfoBoxLocale:"InfoBoxLocale",
		paginateInfoBoxLocale:"InfoBoxLocaleConnection",
		validateCreateInfoBoxLocale:"_ValidationResult",
		validateUpdateInfoBoxLocale:"_ValidationResult",
		getTranslation:"Translation",
		listTranslation:"Translation",
		paginateTranslation:"TranslationConnection",
		validateCreateTranslation:"_ValidationResult",
		validateUpdateTranslation:"_ValidationResult",
		getTranslationLocale:"TranslationLocale",
		listTranslationLocale:"TranslationLocale",
		paginateTranslationLocale:"TranslationLocaleConnection",
		validateCreateTranslationLocale:"_ValidationResult",
		validateUpdateTranslationLocale:"_ValidationResult",
		getCornerBanner:"CornerBanner",
		listCornerBanner:"CornerBanner",
		paginateCornerBanner:"CornerBannerConnection",
		validateCreateCornerBanner:"_ValidationResult",
		validateUpdateCornerBanner:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead",
		createGeneral:"GeneralCreateResult",
		deleteGeneral:"GeneralDeleteResult",
		updateGeneral:"GeneralUpdateResult",
		upsertGeneral:"GeneralUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createGenericPage:"GenericPageCreateResult",
		deleteGenericPage:"GenericPageDeleteResult",
		updateGenericPage:"GenericPageUpdateResult",
		upsertGenericPage:"GenericPageUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createFooterLink:"FooterLinkCreateResult",
		deleteFooterLink:"FooterLinkDeleteResult",
		updateFooterLink:"FooterLinkUpdateResult",
		upsertFooterLink:"FooterLinkUpsertResult",
		createFooterLocale:"FooterLocaleCreateResult",
		deleteFooterLocale:"FooterLocaleDeleteResult",
		updateFooterLocale:"FooterLocaleUpdateResult",
		upsertFooterLocale:"FooterLocaleUpsertResult",
		createGenericPageLocale:"GenericPageLocaleCreateResult",
		deleteGenericPageLocale:"GenericPageLocaleDeleteResult",
		updateGenericPageLocale:"GenericPageLocaleUpdateResult",
		upsertGenericPageLocale:"GenericPageLocaleUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHeaderLocale:"HeaderLocaleCreateResult",
		deleteHeaderLocale:"HeaderLocaleDeleteResult",
		updateHeaderLocale:"HeaderLocaleUpdateResult",
		upsertHeaderLocale:"HeaderLocaleUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createSeoDefault:"SeoDefaultCreateResult",
		deleteSeoDefault:"SeoDefaultDeleteResult",
		updateSeoDefault:"SeoDefaultUpdateResult",
		upsertSeoDefault:"SeoDefaultUpsertResult",
		createSeoDefaultLocale:"SeoDefaultLocaleCreateResult",
		deleteSeoDefaultLocale:"SeoDefaultLocaleDeleteResult",
		updateSeoDefaultLocale:"SeoDefaultLocaleUpdateResult",
		upsertSeoDefaultLocale:"SeoDefaultLocaleUpsertResult",
		createBusiness:"BusinessCreateResult",
		deleteBusiness:"BusinessDeleteResult",
		updateBusiness:"BusinessUpdateResult",
		upsertBusiness:"BusinessUpsertResult",
		createBusinessPage:"BusinessPageCreateResult",
		deleteBusinessPage:"BusinessPageDeleteResult",
		updateBusinessPage:"BusinessPageUpdateResult",
		upsertBusinessPage:"BusinessPageUpsertResult",
		createBusinessPageLocale:"BusinessPageLocaleCreateResult",
		deleteBusinessPageLocale:"BusinessPageLocaleDeleteResult",
		updateBusinessPageLocale:"BusinessPageLocaleUpdateResult",
		upsertBusinessPageLocale:"BusinessPageLocaleUpsertResult",
		createIcon:"IconCreateResult",
		deleteIcon:"IconDeleteResult",
		updateIcon:"IconUpdateResult",
		upsertIcon:"IconUpsertResult",
		createJobPage:"JobPageCreateResult",
		deleteJobPage:"JobPageDeleteResult",
		updateJobPage:"JobPageUpdateResult",
		upsertJobPage:"JobPageUpsertResult",
		createJobPageLocale:"JobPageLocaleCreateResult",
		deleteJobPageLocale:"JobPageLocaleDeleteResult",
		updateJobPageLocale:"JobPageLocaleUpdateResult",
		upsertJobPageLocale:"JobPageLocaleUpsertResult",
		createKeyInfoItem:"KeyInfoItemCreateResult",
		deleteKeyInfoItem:"KeyInfoItemDeleteResult",
		updateKeyInfoItem:"KeyInfoItemUpdateResult",
		upsertKeyInfoItem:"KeyInfoItemUpsertResult",
		createKeyInfoList:"KeyInfoListCreateResult",
		deleteKeyInfoList:"KeyInfoListDeleteResult",
		updateKeyInfoList:"KeyInfoListUpdateResult",
		upsertKeyInfoList:"KeyInfoListUpsertResult",
		createContractType:"ContractTypeCreateResult",
		deleteContractType:"ContractTypeDeleteResult",
		updateContractType:"ContractTypeUpdateResult",
		upsertContractType:"ContractTypeUpsertResult",
		createContractTypeLocale:"ContractTypeLocaleCreateResult",
		deleteContractTypeLocale:"ContractTypeLocaleDeleteResult",
		updateContractTypeLocale:"ContractTypeLocaleUpdateResult",
		upsertContractTypeLocale:"ContractTypeLocaleUpsertResult",
		createJobCity:"JobCityCreateResult",
		deleteJobCity:"JobCityDeleteResult",
		updateJobCity:"JobCityUpdateResult",
		upsertJobCity:"JobCityUpsertResult",
		createJobCityLocale:"JobCityLocaleCreateResult",
		deleteJobCityLocale:"JobCityLocaleDeleteResult",
		updateJobCityLocale:"JobCityLocaleUpdateResult",
		upsertJobCityLocale:"JobCityLocaleUpsertResult",
		createJobPosition:"JobPositionCreateResult",
		deleteJobPosition:"JobPositionDeleteResult",
		updateJobPosition:"JobPositionUpdateResult",
		upsertJobPosition:"JobPositionUpsertResult",
		createJobPositionLocale:"JobPositionLocaleCreateResult",
		deleteJobPositionLocale:"JobPositionLocaleDeleteResult",
		updateJobPositionLocale:"JobPositionLocaleUpdateResult",
		upsertJobPositionLocale:"JobPositionLocaleUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createHomePage:"HomePageCreateResult",
		deleteHomePage:"HomePageDeleteResult",
		updateHomePage:"HomePageUpdateResult",
		upsertHomePage:"HomePageUpsertResult",
		createHomePageLocale:"HomePageLocaleCreateResult",
		deleteHomePageLocale:"HomePageLocaleDeleteResult",
		updateHomePageLocale:"HomePageLocaleUpdateResult",
		upsertHomePageLocale:"HomePageLocaleUpsertResult",
		createMedium:"MediumCreateResult",
		deleteMedium:"MediumDeleteResult",
		updateMedium:"MediumUpdateResult",
		upsertMedium:"MediumUpsertResult",
		createMediumItem:"MediumItemCreateResult",
		deleteMediumItem:"MediumItemDeleteResult",
		updateMediumItem:"MediumItemUpdateResult",
		upsertMediumItem:"MediumItemUpsertResult",
		createMediumList:"MediumListCreateResult",
		deleteMediumList:"MediumListDeleteResult",
		updateMediumList:"MediumListUpdateResult",
		upsertMediumList:"MediumListUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createTextItem:"TextItemCreateResult",
		deleteTextItem:"TextItemDeleteResult",
		updateTextItem:"TextItemUpdateResult",
		upsertTextItem:"TextItemUpsertResult",
		createTextList:"TextListCreateResult",
		deleteTextList:"TextListDeleteResult",
		updateTextList:"TextListUpdateResult",
		upsertTextList:"TextListUpsertResult",
		createCarousel:"CarouselCreateResult",
		deleteCarousel:"CarouselDeleteResult",
		updateCarousel:"CarouselUpdateResult",
		upsertCarousel:"CarouselUpsertResult",
		createCarouselItem:"CarouselItemCreateResult",
		deleteCarouselItem:"CarouselItemDeleteResult",
		updateCarouselItem:"CarouselItemUpdateResult",
		upsertCarouselItem:"CarouselItemUpsertResult",
		createTheme:"ThemeCreateResult",
		deleteTheme:"ThemeDeleteResult",
		updateTheme:"ThemeUpdateResult",
		upsertTheme:"ThemeUpsertResult",
		createBonusBanner:"BonusBannerCreateResult",
		deleteBonusBanner:"BonusBannerDeleteResult",
		updateBonusBanner:"BonusBannerUpdateResult",
		upsertBonusBanner:"BonusBannerUpsertResult",
		createBonusBannerLocale:"BonusBannerLocaleCreateResult",
		deleteBonusBannerLocale:"BonusBannerLocaleDeleteResult",
		updateBonusBannerLocale:"BonusBannerLocaleUpdateResult",
		upsertBonusBannerLocale:"BonusBannerLocaleUpsertResult",
		createTile:"TileCreateResult",
		deleteTile:"TileDeleteResult",
		updateTile:"TileUpdateResult",
		upsertTile:"TileUpsertResult",
		createSideBySide:"SideBySideCreateResult",
		deleteSideBySide:"SideBySideDeleteResult",
		updateSideBySide:"SideBySideUpdateResult",
		upsertSideBySide:"SideBySideUpsertResult",
		createSideBySideItem:"SideBySideItemCreateResult",
		deleteSideBySideItem:"SideBySideItemDeleteResult",
		updateSideBySideItem:"SideBySideItemUpdateResult",
		upsertSideBySideItem:"SideBySideItemUpsertResult",
		createHomePageLokal:"HomePageLokalCreateResult",
		deleteHomePageLokal:"HomePageLokalDeleteResult",
		updateHomePageLokal:"HomePageLokalUpdateResult",
		upsertHomePageLokal:"HomePageLokalUpsertResult",
		createHomePageLokalLocale:"HomePageLokalLocaleCreateResult",
		deleteHomePageLokalLocale:"HomePageLokalLocaleDeleteResult",
		updateHomePageLokalLocale:"HomePageLokalLocaleUpdateResult",
		upsertHomePageLokalLocale:"HomePageLokalLocaleUpsertResult",
		createSiteSwitcher:"SiteSwitcherCreateResult",
		deleteSiteSwitcher:"SiteSwitcherDeleteResult",
		updateSiteSwitcher:"SiteSwitcherUpdateResult",
		upsertSiteSwitcher:"SiteSwitcherUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createJobsForm:"JobsFormCreateResult",
		deleteJobsForm:"JobsFormDeleteResult",
		updateJobsForm:"JobsFormUpdateResult",
		upsertJobsForm:"JobsFormUpsertResult",
		createJobsFormLocale:"JobsFormLocaleCreateResult",
		deleteJobsFormLocale:"JobsFormLocaleDeleteResult",
		updateJobsFormLocale:"JobsFormLocaleUpdateResult",
		upsertJobsFormLocale:"JobsFormLocaleUpsertResult",
		createImageTextItem:"ImageTextItemCreateResult",
		deleteImageTextItem:"ImageTextItemDeleteResult",
		updateImageTextItem:"ImageTextItemUpdateResult",
		upsertImageTextItem:"ImageTextItemUpsertResult",
		createImageTextList:"ImageTextListCreateResult",
		deleteImageTextList:"ImageTextListDeleteResult",
		updateImageTextList:"ImageTextListUpdateResult",
		upsertImageTextList:"ImageTextListUpsertResult",
		createJobsFilter:"JobsFilterCreateResult",
		deleteJobsFilter:"JobsFilterDeleteResult",
		updateJobsFilter:"JobsFilterUpdateResult",
		upsertJobsFilter:"JobsFilterUpsertResult",
		createJobsFilterLocale:"JobsFilterLocaleCreateResult",
		deleteJobsFilterLocale:"JobsFilterLocaleDeleteResult",
		updateJobsFilterLocale:"JobsFilterLocaleUpdateResult",
		upsertJobsFilterLocale:"JobsFilterLocaleUpsertResult",
		createFile:"FileCreateResult",
		deleteFile:"FileDeleteResult",
		updateFile:"FileUpdateResult",
		upsertFile:"FileUpsertResult",
		createJobFormSubscription:"JobFormSubscriptionCreateResult",
		deleteJobFormSubscription:"JobFormSubscriptionDeleteResult",
		updateJobFormSubscription:"JobFormSubscriptionUpdateResult",
		upsertJobFormSubscription:"JobFormSubscriptionUpsertResult",
		createImageList:"ImageListCreateResult",
		deleteImageList:"ImageListDeleteResult",
		updateImageList:"ImageListUpdateResult",
		upsertImageList:"ImageListUpsertResult",
		createImageListItem:"ImageListItemCreateResult",
		deleteImageListItem:"ImageListItemDeleteResult",
		updateImageListItem:"ImageListItemUpdateResult",
		upsertImageListItem:"ImageListItemUpsertResult",
		createJobFormSubscriptionStatus:"JobFormSubscriptionStatusCreateResult",
		deleteJobFormSubscriptionStatus:"JobFormSubscriptionStatusDeleteResult",
		updateJobFormSubscriptionStatus:"JobFormSubscriptionStatusUpdateResult",
		upsertJobFormSubscriptionStatus:"JobFormSubscriptionStatusUpsertResult",
		createGeneralLocale:"GeneralLocaleCreateResult",
		deleteGeneralLocale:"GeneralLocaleDeleteResult",
		updateGeneralLocale:"GeneralLocaleUpdateResult",
		upsertGeneralLocale:"GeneralLocaleUpsertResult",
		createStickyBar:"StickyBarCreateResult",
		deleteStickyBar:"StickyBarDeleteResult",
		updateStickyBar:"StickyBarUpdateResult",
		upsertStickyBar:"StickyBarUpsertResult",
		createRecommendationForm:"RecommendationFormCreateResult",
		deleteRecommendationForm:"RecommendationFormDeleteResult",
		updateRecommendationForm:"RecommendationFormUpdateResult",
		upsertRecommendationForm:"RecommendationFormUpsertResult",
		createRecommendationFormLocale:"RecommendationFormLocaleCreateResult",
		deleteRecommendationFormLocale:"RecommendationFormLocaleDeleteResult",
		updateRecommendationFormLocale:"RecommendationFormLocaleUpdateResult",
		upsertRecommendationFormLocale:"RecommendationFormLocaleUpsertResult",
		createRecommendationFormSubscription:"RecommendationFormSubscriptionCreateResult",
		deleteRecommendationFormSubscription:"RecommendationFormSubscriptionDeleteResult",
		updateRecommendationFormSubscription:"RecommendationFormSubscriptionUpdateResult",
		upsertRecommendationFormSubscription:"RecommendationFormSubscriptionUpsertResult",
		createInfoBox:"InfoBoxCreateResult",
		deleteInfoBox:"InfoBoxDeleteResult",
		updateInfoBox:"InfoBoxUpdateResult",
		upsertInfoBox:"InfoBoxUpsertResult",
		createInfoBoxLocale:"InfoBoxLocaleCreateResult",
		deleteInfoBoxLocale:"InfoBoxLocaleDeleteResult",
		updateInfoBoxLocale:"InfoBoxLocaleUpdateResult",
		upsertInfoBoxLocale:"InfoBoxLocaleUpsertResult",
		createTranslation:"TranslationCreateResult",
		deleteTranslation:"TranslationDeleteResult",
		updateTranslation:"TranslationUpdateResult",
		upsertTranslation:"TranslationUpsertResult",
		createTranslationLocale:"TranslationLocaleCreateResult",
		deleteTranslationLocale:"TranslationLocaleDeleteResult",
		updateTranslationLocale:"TranslationLocaleUpdateResult",
		upsertTranslationLocale:"TranslationLocaleUpsertResult",
		createCornerBanner:"CornerBannerCreateResult",
		deleteCornerBanner:"CornerBannerDeleteResult",
		updateCornerBanner:"CornerBannerUpdateResult",
		upsertCornerBanner:"CornerBannerUpsertResult",
		transaction:"MutationTransaction",
		query:"Query"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	},
	GeneralCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"General",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on GeneralCreateResult": "GeneralCreateResult",
		"...on GeneralDeleteResult": "GeneralDeleteResult",
		"...on GeneralUpdateResult": "GeneralUpdateResult",
		"...on GeneralUpsertResult": "GeneralUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on GenericPageCreateResult": "GenericPageCreateResult",
		"...on GenericPageDeleteResult": "GenericPageDeleteResult",
		"...on GenericPageUpdateResult": "GenericPageUpdateResult",
		"...on GenericPageUpsertResult": "GenericPageUpsertResult",
		"...on LinkableCreateResult": "LinkableCreateResult",
		"...on LinkableDeleteResult": "LinkableDeleteResult",
		"...on LinkableUpdateResult": "LinkableUpdateResult",
		"...on LinkableUpsertResult": "LinkableUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on ContentCreateResult": "ContentCreateResult",
		"...on ContentDeleteResult": "ContentDeleteResult",
		"...on ContentUpdateResult": "ContentUpdateResult",
		"...on ContentUpsertResult": "ContentUpsertResult",
		"...on ContentBlockCreateResult": "ContentBlockCreateResult",
		"...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
		"...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
		"...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
		"...on ContentReferenceCreateResult": "ContentReferenceCreateResult",
		"...on ContentReferenceDeleteResult": "ContentReferenceDeleteResult",
		"...on ContentReferenceUpdateResult": "ContentReferenceUpdateResult",
		"...on ContentReferenceUpsertResult": "ContentReferenceUpsertResult",
		"...on RedirectCreateResult": "RedirectCreateResult",
		"...on RedirectDeleteResult": "RedirectDeleteResult",
		"...on RedirectUpdateResult": "RedirectUpdateResult",
		"...on RedirectUpsertResult": "RedirectUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on FooterCreateResult": "FooterCreateResult",
		"...on FooterDeleteResult": "FooterDeleteResult",
		"...on FooterUpdateResult": "FooterUpdateResult",
		"...on FooterUpsertResult": "FooterUpsertResult",
		"...on FooterLinkCreateResult": "FooterLinkCreateResult",
		"...on FooterLinkDeleteResult": "FooterLinkDeleteResult",
		"...on FooterLinkUpdateResult": "FooterLinkUpdateResult",
		"...on FooterLinkUpsertResult": "FooterLinkUpsertResult",
		"...on FooterLocaleCreateResult": "FooterLocaleCreateResult",
		"...on FooterLocaleDeleteResult": "FooterLocaleDeleteResult",
		"...on FooterLocaleUpdateResult": "FooterLocaleUpdateResult",
		"...on FooterLocaleUpsertResult": "FooterLocaleUpsertResult",
		"...on GenericPageLocaleCreateResult": "GenericPageLocaleCreateResult",
		"...on GenericPageLocaleDeleteResult": "GenericPageLocaleDeleteResult",
		"...on GenericPageLocaleUpdateResult": "GenericPageLocaleUpdateResult",
		"...on GenericPageLocaleUpsertResult": "GenericPageLocaleUpsertResult",
		"...on HeaderCreateResult": "HeaderCreateResult",
		"...on HeaderDeleteResult": "HeaderDeleteResult",
		"...on HeaderUpdateResult": "HeaderUpdateResult",
		"...on HeaderUpsertResult": "HeaderUpsertResult",
		"...on HeaderLocaleCreateResult": "HeaderLocaleCreateResult",
		"...on HeaderLocaleDeleteResult": "HeaderLocaleDeleteResult",
		"...on HeaderLocaleUpdateResult": "HeaderLocaleUpdateResult",
		"...on HeaderLocaleUpsertResult": "HeaderLocaleUpsertResult",
		"...on LocaleCreateResult": "LocaleCreateResult",
		"...on LocaleDeleteResult": "LocaleDeleteResult",
		"...on LocaleUpdateResult": "LocaleUpdateResult",
		"...on LocaleUpsertResult": "LocaleUpsertResult",
		"...on SeoDefaultCreateResult": "SeoDefaultCreateResult",
		"...on SeoDefaultDeleteResult": "SeoDefaultDeleteResult",
		"...on SeoDefaultUpdateResult": "SeoDefaultUpdateResult",
		"...on SeoDefaultUpsertResult": "SeoDefaultUpsertResult",
		"...on SeoDefaultLocaleCreateResult": "SeoDefaultLocaleCreateResult",
		"...on SeoDefaultLocaleDeleteResult": "SeoDefaultLocaleDeleteResult",
		"...on SeoDefaultLocaleUpdateResult": "SeoDefaultLocaleUpdateResult",
		"...on SeoDefaultLocaleUpsertResult": "SeoDefaultLocaleUpsertResult",
		"...on BusinessCreateResult": "BusinessCreateResult",
		"...on BusinessDeleteResult": "BusinessDeleteResult",
		"...on BusinessUpdateResult": "BusinessUpdateResult",
		"...on BusinessUpsertResult": "BusinessUpsertResult",
		"...on BusinessPageCreateResult": "BusinessPageCreateResult",
		"...on BusinessPageDeleteResult": "BusinessPageDeleteResult",
		"...on BusinessPageUpdateResult": "BusinessPageUpdateResult",
		"...on BusinessPageUpsertResult": "BusinessPageUpsertResult",
		"...on BusinessPageLocaleCreateResult": "BusinessPageLocaleCreateResult",
		"...on BusinessPageLocaleDeleteResult": "BusinessPageLocaleDeleteResult",
		"...on BusinessPageLocaleUpdateResult": "BusinessPageLocaleUpdateResult",
		"...on BusinessPageLocaleUpsertResult": "BusinessPageLocaleUpsertResult",
		"...on IconCreateResult": "IconCreateResult",
		"...on IconDeleteResult": "IconDeleteResult",
		"...on IconUpdateResult": "IconUpdateResult",
		"...on IconUpsertResult": "IconUpsertResult",
		"...on JobPageCreateResult": "JobPageCreateResult",
		"...on JobPageDeleteResult": "JobPageDeleteResult",
		"...on JobPageUpdateResult": "JobPageUpdateResult",
		"...on JobPageUpsertResult": "JobPageUpsertResult",
		"...on JobPageLocaleCreateResult": "JobPageLocaleCreateResult",
		"...on JobPageLocaleDeleteResult": "JobPageLocaleDeleteResult",
		"...on JobPageLocaleUpdateResult": "JobPageLocaleUpdateResult",
		"...on JobPageLocaleUpsertResult": "JobPageLocaleUpsertResult",
		"...on KeyInfoItemCreateResult": "KeyInfoItemCreateResult",
		"...on KeyInfoItemDeleteResult": "KeyInfoItemDeleteResult",
		"...on KeyInfoItemUpdateResult": "KeyInfoItemUpdateResult",
		"...on KeyInfoItemUpsertResult": "KeyInfoItemUpsertResult",
		"...on KeyInfoListCreateResult": "KeyInfoListCreateResult",
		"...on KeyInfoListDeleteResult": "KeyInfoListDeleteResult",
		"...on KeyInfoListUpdateResult": "KeyInfoListUpdateResult",
		"...on KeyInfoListUpsertResult": "KeyInfoListUpsertResult",
		"...on ContractTypeCreateResult": "ContractTypeCreateResult",
		"...on ContractTypeDeleteResult": "ContractTypeDeleteResult",
		"...on ContractTypeUpdateResult": "ContractTypeUpdateResult",
		"...on ContractTypeUpsertResult": "ContractTypeUpsertResult",
		"...on ContractTypeLocaleCreateResult": "ContractTypeLocaleCreateResult",
		"...on ContractTypeLocaleDeleteResult": "ContractTypeLocaleDeleteResult",
		"...on ContractTypeLocaleUpdateResult": "ContractTypeLocaleUpdateResult",
		"...on ContractTypeLocaleUpsertResult": "ContractTypeLocaleUpsertResult",
		"...on JobCityCreateResult": "JobCityCreateResult",
		"...on JobCityDeleteResult": "JobCityDeleteResult",
		"...on JobCityUpdateResult": "JobCityUpdateResult",
		"...on JobCityUpsertResult": "JobCityUpsertResult",
		"...on JobCityLocaleCreateResult": "JobCityLocaleCreateResult",
		"...on JobCityLocaleDeleteResult": "JobCityLocaleDeleteResult",
		"...on JobCityLocaleUpdateResult": "JobCityLocaleUpdateResult",
		"...on JobCityLocaleUpsertResult": "JobCityLocaleUpsertResult",
		"...on JobPositionCreateResult": "JobPositionCreateResult",
		"...on JobPositionDeleteResult": "JobPositionDeleteResult",
		"...on JobPositionUpdateResult": "JobPositionUpdateResult",
		"...on JobPositionUpsertResult": "JobPositionUpsertResult",
		"...on JobPositionLocaleCreateResult": "JobPositionLocaleCreateResult",
		"...on JobPositionLocaleDeleteResult": "JobPositionLocaleDeleteResult",
		"...on JobPositionLocaleUpdateResult": "JobPositionLocaleUpdateResult",
		"...on JobPositionLocaleUpsertResult": "JobPositionLocaleUpsertResult",
		"...on GalleryCreateResult": "GalleryCreateResult",
		"...on GalleryDeleteResult": "GalleryDeleteResult",
		"...on GalleryUpdateResult": "GalleryUpdateResult",
		"...on GalleryUpsertResult": "GalleryUpsertResult",
		"...on HomePageCreateResult": "HomePageCreateResult",
		"...on HomePageDeleteResult": "HomePageDeleteResult",
		"...on HomePageUpdateResult": "HomePageUpdateResult",
		"...on HomePageUpsertResult": "HomePageUpsertResult",
		"...on HomePageLocaleCreateResult": "HomePageLocaleCreateResult",
		"...on HomePageLocaleDeleteResult": "HomePageLocaleDeleteResult",
		"...on HomePageLocaleUpdateResult": "HomePageLocaleUpdateResult",
		"...on HomePageLocaleUpsertResult": "HomePageLocaleUpsertResult",
		"...on MediumCreateResult": "MediumCreateResult",
		"...on MediumDeleteResult": "MediumDeleteResult",
		"...on MediumUpdateResult": "MediumUpdateResult",
		"...on MediumUpsertResult": "MediumUpsertResult",
		"...on MediumItemCreateResult": "MediumItemCreateResult",
		"...on MediumItemDeleteResult": "MediumItemDeleteResult",
		"...on MediumItemUpdateResult": "MediumItemUpdateResult",
		"...on MediumItemUpsertResult": "MediumItemUpsertResult",
		"...on MediumListCreateResult": "MediumListCreateResult",
		"...on MediumListDeleteResult": "MediumListDeleteResult",
		"...on MediumListUpdateResult": "MediumListUpdateResult",
		"...on MediumListUpsertResult": "MediumListUpsertResult",
		"...on VideoCreateResult": "VideoCreateResult",
		"...on VideoDeleteResult": "VideoDeleteResult",
		"...on VideoUpdateResult": "VideoUpdateResult",
		"...on VideoUpsertResult": "VideoUpsertResult",
		"...on TextItemCreateResult": "TextItemCreateResult",
		"...on TextItemDeleteResult": "TextItemDeleteResult",
		"...on TextItemUpdateResult": "TextItemUpdateResult",
		"...on TextItemUpsertResult": "TextItemUpsertResult",
		"...on TextListCreateResult": "TextListCreateResult",
		"...on TextListDeleteResult": "TextListDeleteResult",
		"...on TextListUpdateResult": "TextListUpdateResult",
		"...on TextListUpsertResult": "TextListUpsertResult",
		"...on CarouselCreateResult": "CarouselCreateResult",
		"...on CarouselDeleteResult": "CarouselDeleteResult",
		"...on CarouselUpdateResult": "CarouselUpdateResult",
		"...on CarouselUpsertResult": "CarouselUpsertResult",
		"...on CarouselItemCreateResult": "CarouselItemCreateResult",
		"...on CarouselItemDeleteResult": "CarouselItemDeleteResult",
		"...on CarouselItemUpdateResult": "CarouselItemUpdateResult",
		"...on CarouselItemUpsertResult": "CarouselItemUpsertResult",
		"...on ThemeCreateResult": "ThemeCreateResult",
		"...on ThemeDeleteResult": "ThemeDeleteResult",
		"...on ThemeUpdateResult": "ThemeUpdateResult",
		"...on ThemeUpsertResult": "ThemeUpsertResult",
		"...on BonusBannerCreateResult": "BonusBannerCreateResult",
		"...on BonusBannerDeleteResult": "BonusBannerDeleteResult",
		"...on BonusBannerUpdateResult": "BonusBannerUpdateResult",
		"...on BonusBannerUpsertResult": "BonusBannerUpsertResult",
		"...on BonusBannerLocaleCreateResult": "BonusBannerLocaleCreateResult",
		"...on BonusBannerLocaleDeleteResult": "BonusBannerLocaleDeleteResult",
		"...on BonusBannerLocaleUpdateResult": "BonusBannerLocaleUpdateResult",
		"...on BonusBannerLocaleUpsertResult": "BonusBannerLocaleUpsertResult",
		"...on TileCreateResult": "TileCreateResult",
		"...on TileDeleteResult": "TileDeleteResult",
		"...on TileUpdateResult": "TileUpdateResult",
		"...on TileUpsertResult": "TileUpsertResult",
		"...on SideBySideCreateResult": "SideBySideCreateResult",
		"...on SideBySideDeleteResult": "SideBySideDeleteResult",
		"...on SideBySideUpdateResult": "SideBySideUpdateResult",
		"...on SideBySideUpsertResult": "SideBySideUpsertResult",
		"...on SideBySideItemCreateResult": "SideBySideItemCreateResult",
		"...on SideBySideItemDeleteResult": "SideBySideItemDeleteResult",
		"...on SideBySideItemUpdateResult": "SideBySideItemUpdateResult",
		"...on SideBySideItemUpsertResult": "SideBySideItemUpsertResult",
		"...on HomePageLokalCreateResult": "HomePageLokalCreateResult",
		"...on HomePageLokalDeleteResult": "HomePageLokalDeleteResult",
		"...on HomePageLokalUpdateResult": "HomePageLokalUpdateResult",
		"...on HomePageLokalUpsertResult": "HomePageLokalUpsertResult",
		"...on HomePageLokalLocaleCreateResult": "HomePageLokalLocaleCreateResult",
		"...on HomePageLokalLocaleDeleteResult": "HomePageLokalLocaleDeleteResult",
		"...on HomePageLokalLocaleUpdateResult": "HomePageLokalLocaleUpdateResult",
		"...on HomePageLokalLocaleUpsertResult": "HomePageLokalLocaleUpsertResult",
		"...on SiteSwitcherCreateResult": "SiteSwitcherCreateResult",
		"...on SiteSwitcherDeleteResult": "SiteSwitcherDeleteResult",
		"...on SiteSwitcherUpdateResult": "SiteSwitcherUpdateResult",
		"...on SiteSwitcherUpsertResult": "SiteSwitcherUpsertResult",
		"...on GalleryItemCreateResult": "GalleryItemCreateResult",
		"...on GalleryItemDeleteResult": "GalleryItemDeleteResult",
		"...on GalleryItemUpdateResult": "GalleryItemUpdateResult",
		"...on GalleryItemUpsertResult": "GalleryItemUpsertResult",
		"...on JobsFormCreateResult": "JobsFormCreateResult",
		"...on JobsFormDeleteResult": "JobsFormDeleteResult",
		"...on JobsFormUpdateResult": "JobsFormUpdateResult",
		"...on JobsFormUpsertResult": "JobsFormUpsertResult",
		"...on JobsFormLocaleCreateResult": "JobsFormLocaleCreateResult",
		"...on JobsFormLocaleDeleteResult": "JobsFormLocaleDeleteResult",
		"...on JobsFormLocaleUpdateResult": "JobsFormLocaleUpdateResult",
		"...on JobsFormLocaleUpsertResult": "JobsFormLocaleUpsertResult",
		"...on ImageTextItemCreateResult": "ImageTextItemCreateResult",
		"...on ImageTextItemDeleteResult": "ImageTextItemDeleteResult",
		"...on ImageTextItemUpdateResult": "ImageTextItemUpdateResult",
		"...on ImageTextItemUpsertResult": "ImageTextItemUpsertResult",
		"...on ImageTextListCreateResult": "ImageTextListCreateResult",
		"...on ImageTextListDeleteResult": "ImageTextListDeleteResult",
		"...on ImageTextListUpdateResult": "ImageTextListUpdateResult",
		"...on ImageTextListUpsertResult": "ImageTextListUpsertResult",
		"...on JobsFilterCreateResult": "JobsFilterCreateResult",
		"...on JobsFilterDeleteResult": "JobsFilterDeleteResult",
		"...on JobsFilterUpdateResult": "JobsFilterUpdateResult",
		"...on JobsFilterUpsertResult": "JobsFilterUpsertResult",
		"...on JobsFilterLocaleCreateResult": "JobsFilterLocaleCreateResult",
		"...on JobsFilterLocaleDeleteResult": "JobsFilterLocaleDeleteResult",
		"...on JobsFilterLocaleUpdateResult": "JobsFilterLocaleUpdateResult",
		"...on JobsFilterLocaleUpsertResult": "JobsFilterLocaleUpsertResult",
		"...on FileCreateResult": "FileCreateResult",
		"...on FileDeleteResult": "FileDeleteResult",
		"...on FileUpdateResult": "FileUpdateResult",
		"...on FileUpsertResult": "FileUpsertResult",
		"...on JobFormSubscriptionCreateResult": "JobFormSubscriptionCreateResult",
		"...on JobFormSubscriptionDeleteResult": "JobFormSubscriptionDeleteResult",
		"...on JobFormSubscriptionUpdateResult": "JobFormSubscriptionUpdateResult",
		"...on JobFormSubscriptionUpsertResult": "JobFormSubscriptionUpsertResult",
		"...on ImageListCreateResult": "ImageListCreateResult",
		"...on ImageListDeleteResult": "ImageListDeleteResult",
		"...on ImageListUpdateResult": "ImageListUpdateResult",
		"...on ImageListUpsertResult": "ImageListUpsertResult",
		"...on ImageListItemCreateResult": "ImageListItemCreateResult",
		"...on ImageListItemDeleteResult": "ImageListItemDeleteResult",
		"...on ImageListItemUpdateResult": "ImageListItemUpdateResult",
		"...on ImageListItemUpsertResult": "ImageListItemUpsertResult",
		"...on JobFormSubscriptionStatusCreateResult": "JobFormSubscriptionStatusCreateResult",
		"...on JobFormSubscriptionStatusDeleteResult": "JobFormSubscriptionStatusDeleteResult",
		"...on JobFormSubscriptionStatusUpdateResult": "JobFormSubscriptionStatusUpdateResult",
		"...on JobFormSubscriptionStatusUpsertResult": "JobFormSubscriptionStatusUpsertResult",
		"...on GeneralLocaleCreateResult": "GeneralLocaleCreateResult",
		"...on GeneralLocaleDeleteResult": "GeneralLocaleDeleteResult",
		"...on GeneralLocaleUpdateResult": "GeneralLocaleUpdateResult",
		"...on GeneralLocaleUpsertResult": "GeneralLocaleUpsertResult",
		"...on StickyBarCreateResult": "StickyBarCreateResult",
		"...on StickyBarDeleteResult": "StickyBarDeleteResult",
		"...on StickyBarUpdateResult": "StickyBarUpdateResult",
		"...on StickyBarUpsertResult": "StickyBarUpsertResult",
		"...on RecommendationFormCreateResult": "RecommendationFormCreateResult",
		"...on RecommendationFormDeleteResult": "RecommendationFormDeleteResult",
		"...on RecommendationFormUpdateResult": "RecommendationFormUpdateResult",
		"...on RecommendationFormUpsertResult": "RecommendationFormUpsertResult",
		"...on RecommendationFormLocaleCreateResult": "RecommendationFormLocaleCreateResult",
		"...on RecommendationFormLocaleDeleteResult": "RecommendationFormLocaleDeleteResult",
		"...on RecommendationFormLocaleUpdateResult": "RecommendationFormLocaleUpdateResult",
		"...on RecommendationFormLocaleUpsertResult": "RecommendationFormLocaleUpsertResult",
		"...on RecommendationFormSubscriptionCreateResult": "RecommendationFormSubscriptionCreateResult",
		"...on RecommendationFormSubscriptionDeleteResult": "RecommendationFormSubscriptionDeleteResult",
		"...on RecommendationFormSubscriptionUpdateResult": "RecommendationFormSubscriptionUpdateResult",
		"...on RecommendationFormSubscriptionUpsertResult": "RecommendationFormSubscriptionUpsertResult",
		"...on InfoBoxCreateResult": "InfoBoxCreateResult",
		"...on InfoBoxDeleteResult": "InfoBoxDeleteResult",
		"...on InfoBoxUpdateResult": "InfoBoxUpdateResult",
		"...on InfoBoxUpsertResult": "InfoBoxUpsertResult",
		"...on InfoBoxLocaleCreateResult": "InfoBoxLocaleCreateResult",
		"...on InfoBoxLocaleDeleteResult": "InfoBoxLocaleDeleteResult",
		"...on InfoBoxLocaleUpdateResult": "InfoBoxLocaleUpdateResult",
		"...on InfoBoxLocaleUpsertResult": "InfoBoxLocaleUpsertResult",
		"...on TranslationCreateResult": "TranslationCreateResult",
		"...on TranslationDeleteResult": "TranslationDeleteResult",
		"...on TranslationUpdateResult": "TranslationUpdateResult",
		"...on TranslationUpsertResult": "TranslationUpsertResult",
		"...on TranslationLocaleCreateResult": "TranslationLocaleCreateResult",
		"...on TranslationLocaleDeleteResult": "TranslationLocaleDeleteResult",
		"...on TranslationLocaleUpdateResult": "TranslationLocaleUpdateResult",
		"...on TranslationLocaleUpsertResult": "TranslationLocaleUpsertResult",
		"...on CornerBannerCreateResult": "CornerBannerCreateResult",
		"...on CornerBannerDeleteResult": "CornerBannerDeleteResult",
		"...on CornerBannerUpdateResult": "CornerBannerUpdateResult",
		"...on CornerBannerUpsertResult": "CornerBannerUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	GeneralDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"General"
	},
	GeneralUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"General",
		validation:"_ValidationResult"
	},
	GeneralUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"General",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	GenericPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage",
		validation:"_ValidationResult"
	},
	GenericPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage"
	},
	GenericPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage",
		validation:"_ValidationResult"
	},
	GenericPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPage",
		validation:"_ValidationResult"
	},
	LinkableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable"
	},
	LinkableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	ContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content"
	},
	ContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentBlockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock"
	},
	ContentBlockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentReferenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference"
	},
	ContentReferenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	RedirectCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect"
	},
	RedirectUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	FooterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer"
	},
	FooterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLink",
		validation:"_ValidationResult"
	},
	FooterLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLink"
	},
	FooterLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLink",
		validation:"_ValidationResult"
	},
	FooterLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLink",
		validation:"_ValidationResult"
	},
	FooterLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	FooterLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale"
	},
	FooterLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	FooterLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	GenericPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageLocale",
		validation:"_ValidationResult"
	},
	GenericPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageLocale"
	},
	GenericPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageLocale",
		validation:"_ValidationResult"
	},
	GenericPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GenericPageLocale",
		validation:"_ValidationResult"
	},
	HeaderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header"
	},
	HeaderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	HeaderLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale"
	},
	HeaderLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	HeaderLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	LocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale"
	},
	LocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	SeoDefaultCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefault",
		validation:"_ValidationResult"
	},
	SeoDefaultDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefault"
	},
	SeoDefaultUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefault",
		validation:"_ValidationResult"
	},
	SeoDefaultUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefault",
		validation:"_ValidationResult"
	},
	SeoDefaultLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefaultLocale",
		validation:"_ValidationResult"
	},
	SeoDefaultLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefaultLocale"
	},
	SeoDefaultLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefaultLocale",
		validation:"_ValidationResult"
	},
	SeoDefaultLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefaultLocale",
		validation:"_ValidationResult"
	},
	BusinessCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Business",
		validation:"_ValidationResult"
	},
	BusinessDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Business"
	},
	BusinessUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Business",
		validation:"_ValidationResult"
	},
	BusinessUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Business",
		validation:"_ValidationResult"
	},
	BusinessPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessPage",
		validation:"_ValidationResult"
	},
	BusinessPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessPage"
	},
	BusinessPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessPage",
		validation:"_ValidationResult"
	},
	BusinessPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessPage",
		validation:"_ValidationResult"
	},
	BusinessPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessPageLocale",
		validation:"_ValidationResult"
	},
	BusinessPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessPageLocale"
	},
	BusinessPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessPageLocale",
		validation:"_ValidationResult"
	},
	BusinessPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessPageLocale",
		validation:"_ValidationResult"
	},
	IconCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Icon",
		validation:"_ValidationResult"
	},
	IconDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Icon"
	},
	IconUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Icon",
		validation:"_ValidationResult"
	},
	IconUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Icon",
		validation:"_ValidationResult"
	},
	JobPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPage",
		validation:"_ValidationResult"
	},
	JobPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPage"
	},
	JobPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPage",
		validation:"_ValidationResult"
	},
	JobPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPage",
		validation:"_ValidationResult"
	},
	JobPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPageLocale",
		validation:"_ValidationResult"
	},
	JobPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPageLocale"
	},
	JobPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPageLocale",
		validation:"_ValidationResult"
	},
	JobPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPageLocale",
		validation:"_ValidationResult"
	},
	KeyInfoItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"KeyInfoItem",
		validation:"_ValidationResult"
	},
	KeyInfoItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"KeyInfoItem"
	},
	KeyInfoItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"KeyInfoItem",
		validation:"_ValidationResult"
	},
	KeyInfoItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"KeyInfoItem",
		validation:"_ValidationResult"
	},
	KeyInfoListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"KeyInfoList",
		validation:"_ValidationResult"
	},
	KeyInfoListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"KeyInfoList"
	},
	KeyInfoListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"KeyInfoList",
		validation:"_ValidationResult"
	},
	KeyInfoListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"KeyInfoList",
		validation:"_ValidationResult"
	},
	ContractTypeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContractType",
		validation:"_ValidationResult"
	},
	ContractTypeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContractType"
	},
	ContractTypeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContractType",
		validation:"_ValidationResult"
	},
	ContractTypeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContractType",
		validation:"_ValidationResult"
	},
	ContractTypeLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContractTypeLocale",
		validation:"_ValidationResult"
	},
	ContractTypeLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContractTypeLocale"
	},
	ContractTypeLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContractTypeLocale",
		validation:"_ValidationResult"
	},
	ContractTypeLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContractTypeLocale",
		validation:"_ValidationResult"
	},
	JobCityCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobCity",
		validation:"_ValidationResult"
	},
	JobCityDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobCity"
	},
	JobCityUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobCity",
		validation:"_ValidationResult"
	},
	JobCityUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobCity",
		validation:"_ValidationResult"
	},
	JobCityLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobCityLocale",
		validation:"_ValidationResult"
	},
	JobCityLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobCityLocale"
	},
	JobCityLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobCityLocale",
		validation:"_ValidationResult"
	},
	JobCityLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobCityLocale",
		validation:"_ValidationResult"
	},
	JobPositionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPosition",
		validation:"_ValidationResult"
	},
	JobPositionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPosition"
	},
	JobPositionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPosition",
		validation:"_ValidationResult"
	},
	JobPositionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPosition",
		validation:"_ValidationResult"
	},
	JobPositionLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPositionLocale",
		validation:"_ValidationResult"
	},
	JobPositionLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPositionLocale"
	},
	JobPositionLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPositionLocale",
		validation:"_ValidationResult"
	},
	JobPositionLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobPositionLocale",
		validation:"_ValidationResult"
	},
	GalleryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery"
	},
	GalleryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	HomePageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage"
	},
	HomePageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLocale",
		validation:"_ValidationResult"
	},
	HomePageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLocale"
	},
	HomePageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLocale",
		validation:"_ValidationResult"
	},
	HomePageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLocale",
		validation:"_ValidationResult"
	},
	MediumCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium"
	},
	MediumUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem",
		validation:"_ValidationResult"
	},
	MediumItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem"
	},
	MediumItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem",
		validation:"_ValidationResult"
	},
	MediumItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem",
		validation:"_ValidationResult"
	},
	MediumListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList",
		validation:"_ValidationResult"
	},
	MediumListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList"
	},
	MediumListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList",
		validation:"_ValidationResult"
	},
	MediumListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList",
		validation:"_ValidationResult"
	},
	VideoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video"
	},
	VideoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	TextItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem",
		validation:"_ValidationResult"
	},
	TextItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem"
	},
	TextItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem",
		validation:"_ValidationResult"
	},
	TextItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem",
		validation:"_ValidationResult"
	},
	TextListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList",
		validation:"_ValidationResult"
	},
	TextListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList"
	},
	TextListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList",
		validation:"_ValidationResult"
	},
	TextListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList",
		validation:"_ValidationResult"
	},
	CarouselCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Carousel",
		validation:"_ValidationResult"
	},
	CarouselDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Carousel"
	},
	CarouselUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Carousel",
		validation:"_ValidationResult"
	},
	CarouselUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Carousel",
		validation:"_ValidationResult"
	},
	CarouselItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CarouselItem",
		validation:"_ValidationResult"
	},
	CarouselItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CarouselItem"
	},
	CarouselItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CarouselItem",
		validation:"_ValidationResult"
	},
	CarouselItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CarouselItem",
		validation:"_ValidationResult"
	},
	ThemeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Theme",
		validation:"_ValidationResult"
	},
	ThemeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Theme"
	},
	ThemeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Theme",
		validation:"_ValidationResult"
	},
	ThemeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Theme",
		validation:"_ValidationResult"
	},
	BonusBannerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BonusBanner",
		validation:"_ValidationResult"
	},
	BonusBannerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BonusBanner"
	},
	BonusBannerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BonusBanner",
		validation:"_ValidationResult"
	},
	BonusBannerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BonusBanner",
		validation:"_ValidationResult"
	},
	BonusBannerLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BonusBannerLocale",
		validation:"_ValidationResult"
	},
	BonusBannerLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BonusBannerLocale"
	},
	BonusBannerLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BonusBannerLocale",
		validation:"_ValidationResult"
	},
	BonusBannerLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BonusBannerLocale",
		validation:"_ValidationResult"
	},
	TileCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tile",
		validation:"_ValidationResult"
	},
	TileDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tile"
	},
	TileUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tile",
		validation:"_ValidationResult"
	},
	TileUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tile",
		validation:"_ValidationResult"
	},
	SideBySideCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SideBySide",
		validation:"_ValidationResult"
	},
	SideBySideDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SideBySide"
	},
	SideBySideUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SideBySide",
		validation:"_ValidationResult"
	},
	SideBySideUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SideBySide",
		validation:"_ValidationResult"
	},
	SideBySideItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SideBySideItem",
		validation:"_ValidationResult"
	},
	SideBySideItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SideBySideItem"
	},
	SideBySideItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SideBySideItem",
		validation:"_ValidationResult"
	},
	SideBySideItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SideBySideItem",
		validation:"_ValidationResult"
	},
	HomePageLokalCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLokal",
		validation:"_ValidationResult"
	},
	HomePageLokalDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLokal"
	},
	HomePageLokalUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLokal",
		validation:"_ValidationResult"
	},
	HomePageLokalUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLokal",
		validation:"_ValidationResult"
	},
	HomePageLokalLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLokalLocale",
		validation:"_ValidationResult"
	},
	HomePageLokalLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLokalLocale"
	},
	HomePageLokalLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLokalLocale",
		validation:"_ValidationResult"
	},
	HomePageLokalLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLokalLocale",
		validation:"_ValidationResult"
	},
	SiteSwitcherCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteSwitcher",
		validation:"_ValidationResult"
	},
	SiteSwitcherDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteSwitcher"
	},
	SiteSwitcherUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteSwitcher",
		validation:"_ValidationResult"
	},
	SiteSwitcherUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteSwitcher",
		validation:"_ValidationResult"
	},
	GalleryItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem"
	},
	GalleryItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	JobsFormCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsForm",
		validation:"_ValidationResult"
	},
	JobsFormDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsForm"
	},
	JobsFormUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsForm",
		validation:"_ValidationResult"
	},
	JobsFormUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsForm",
		validation:"_ValidationResult"
	},
	JobsFormLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFormLocale",
		validation:"_ValidationResult"
	},
	JobsFormLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFormLocale"
	},
	JobsFormLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFormLocale",
		validation:"_ValidationResult"
	},
	JobsFormLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFormLocale",
		validation:"_ValidationResult"
	},
	ImageTextItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTextItem",
		validation:"_ValidationResult"
	},
	ImageTextItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTextItem"
	},
	ImageTextItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTextItem",
		validation:"_ValidationResult"
	},
	ImageTextItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTextItem",
		validation:"_ValidationResult"
	},
	ImageTextListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTextList",
		validation:"_ValidationResult"
	},
	ImageTextListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTextList"
	},
	ImageTextListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTextList",
		validation:"_ValidationResult"
	},
	ImageTextListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTextList",
		validation:"_ValidationResult"
	},
	JobsFilterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFilter",
		validation:"_ValidationResult"
	},
	JobsFilterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFilter"
	},
	JobsFilterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFilter",
		validation:"_ValidationResult"
	},
	JobsFilterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFilter",
		validation:"_ValidationResult"
	},
	JobsFilterLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFilterLocale",
		validation:"_ValidationResult"
	},
	JobsFilterLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFilterLocale"
	},
	JobsFilterLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFilterLocale",
		validation:"_ValidationResult"
	},
	JobsFilterLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobsFilterLocale",
		validation:"_ValidationResult"
	},
	FileCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	FileDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File"
	},
	FileUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	FileUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	JobFormSubscriptionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobFormSubscription",
		validation:"_ValidationResult"
	},
	JobFormSubscriptionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobFormSubscription"
	},
	JobFormSubscriptionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobFormSubscription",
		validation:"_ValidationResult"
	},
	JobFormSubscriptionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobFormSubscription",
		validation:"_ValidationResult"
	},
	ImageListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList"
	},
	ImageListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	ImageListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem"
	},
	ImageListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	ImageListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	JobFormSubscriptionStatusCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobFormSubscriptionStatus",
		validation:"_ValidationResult"
	},
	JobFormSubscriptionStatusDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobFormSubscriptionStatus"
	},
	JobFormSubscriptionStatusUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobFormSubscriptionStatus",
		validation:"_ValidationResult"
	},
	JobFormSubscriptionStatusUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"JobFormSubscriptionStatus",
		validation:"_ValidationResult"
	},
	GeneralLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GeneralLocale",
		validation:"_ValidationResult"
	},
	GeneralLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GeneralLocale"
	},
	GeneralLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GeneralLocale",
		validation:"_ValidationResult"
	},
	GeneralLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GeneralLocale",
		validation:"_ValidationResult"
	},
	StickyBarCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StickyBar",
		validation:"_ValidationResult"
	},
	StickyBarDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StickyBar"
	},
	StickyBarUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StickyBar",
		validation:"_ValidationResult"
	},
	StickyBarUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StickyBar",
		validation:"_ValidationResult"
	},
	RecommendationFormCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationForm",
		validation:"_ValidationResult"
	},
	RecommendationFormDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationForm"
	},
	RecommendationFormUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationForm",
		validation:"_ValidationResult"
	},
	RecommendationFormUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationForm",
		validation:"_ValidationResult"
	},
	RecommendationFormLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationFormLocale",
		validation:"_ValidationResult"
	},
	RecommendationFormLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationFormLocale"
	},
	RecommendationFormLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationFormLocale",
		validation:"_ValidationResult"
	},
	RecommendationFormLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationFormLocale",
		validation:"_ValidationResult"
	},
	RecommendationFormSubscriptionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationFormSubscription",
		validation:"_ValidationResult"
	},
	RecommendationFormSubscriptionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationFormSubscription"
	},
	RecommendationFormSubscriptionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationFormSubscription",
		validation:"_ValidationResult"
	},
	RecommendationFormSubscriptionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RecommendationFormSubscription",
		validation:"_ValidationResult"
	},
	InfoBoxCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoBox",
		validation:"_ValidationResult"
	},
	InfoBoxDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoBox"
	},
	InfoBoxUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoBox",
		validation:"_ValidationResult"
	},
	InfoBoxUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoBox",
		validation:"_ValidationResult"
	},
	InfoBoxLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoBoxLocale",
		validation:"_ValidationResult"
	},
	InfoBoxLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoBoxLocale"
	},
	InfoBoxLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoBoxLocale",
		validation:"_ValidationResult"
	},
	InfoBoxLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InfoBoxLocale",
		validation:"_ValidationResult"
	},
	TranslationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Translation",
		validation:"_ValidationResult"
	},
	TranslationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Translation"
	},
	TranslationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Translation",
		validation:"_ValidationResult"
	},
	TranslationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Translation",
		validation:"_ValidationResult"
	},
	TranslationLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationLocale",
		validation:"_ValidationResult"
	},
	TranslationLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationLocale"
	},
	TranslationLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationLocale",
		validation:"_ValidationResult"
	},
	TranslationLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationLocale",
		validation:"_ValidationResult"
	},
	CornerBannerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CornerBanner",
		validation:"_ValidationResult"
	},
	CornerBannerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CornerBanner"
	},
	CornerBannerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CornerBanner",
		validation:"_ValidationResult"
	},
	CornerBannerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CornerBanner",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead",
		createGeneral:"GeneralCreateResult",
		deleteGeneral:"GeneralDeleteResult",
		updateGeneral:"GeneralUpdateResult",
		upsertGeneral:"GeneralUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createGenericPage:"GenericPageCreateResult",
		deleteGenericPage:"GenericPageDeleteResult",
		updateGenericPage:"GenericPageUpdateResult",
		upsertGenericPage:"GenericPageUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createFooterLink:"FooterLinkCreateResult",
		deleteFooterLink:"FooterLinkDeleteResult",
		updateFooterLink:"FooterLinkUpdateResult",
		upsertFooterLink:"FooterLinkUpsertResult",
		createFooterLocale:"FooterLocaleCreateResult",
		deleteFooterLocale:"FooterLocaleDeleteResult",
		updateFooterLocale:"FooterLocaleUpdateResult",
		upsertFooterLocale:"FooterLocaleUpsertResult",
		createGenericPageLocale:"GenericPageLocaleCreateResult",
		deleteGenericPageLocale:"GenericPageLocaleDeleteResult",
		updateGenericPageLocale:"GenericPageLocaleUpdateResult",
		upsertGenericPageLocale:"GenericPageLocaleUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHeaderLocale:"HeaderLocaleCreateResult",
		deleteHeaderLocale:"HeaderLocaleDeleteResult",
		updateHeaderLocale:"HeaderLocaleUpdateResult",
		upsertHeaderLocale:"HeaderLocaleUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createSeoDefault:"SeoDefaultCreateResult",
		deleteSeoDefault:"SeoDefaultDeleteResult",
		updateSeoDefault:"SeoDefaultUpdateResult",
		upsertSeoDefault:"SeoDefaultUpsertResult",
		createSeoDefaultLocale:"SeoDefaultLocaleCreateResult",
		deleteSeoDefaultLocale:"SeoDefaultLocaleDeleteResult",
		updateSeoDefaultLocale:"SeoDefaultLocaleUpdateResult",
		upsertSeoDefaultLocale:"SeoDefaultLocaleUpsertResult",
		createBusiness:"BusinessCreateResult",
		deleteBusiness:"BusinessDeleteResult",
		updateBusiness:"BusinessUpdateResult",
		upsertBusiness:"BusinessUpsertResult",
		createBusinessPage:"BusinessPageCreateResult",
		deleteBusinessPage:"BusinessPageDeleteResult",
		updateBusinessPage:"BusinessPageUpdateResult",
		upsertBusinessPage:"BusinessPageUpsertResult",
		createBusinessPageLocale:"BusinessPageLocaleCreateResult",
		deleteBusinessPageLocale:"BusinessPageLocaleDeleteResult",
		updateBusinessPageLocale:"BusinessPageLocaleUpdateResult",
		upsertBusinessPageLocale:"BusinessPageLocaleUpsertResult",
		createIcon:"IconCreateResult",
		deleteIcon:"IconDeleteResult",
		updateIcon:"IconUpdateResult",
		upsertIcon:"IconUpsertResult",
		createJobPage:"JobPageCreateResult",
		deleteJobPage:"JobPageDeleteResult",
		updateJobPage:"JobPageUpdateResult",
		upsertJobPage:"JobPageUpsertResult",
		createJobPageLocale:"JobPageLocaleCreateResult",
		deleteJobPageLocale:"JobPageLocaleDeleteResult",
		updateJobPageLocale:"JobPageLocaleUpdateResult",
		upsertJobPageLocale:"JobPageLocaleUpsertResult",
		createKeyInfoItem:"KeyInfoItemCreateResult",
		deleteKeyInfoItem:"KeyInfoItemDeleteResult",
		updateKeyInfoItem:"KeyInfoItemUpdateResult",
		upsertKeyInfoItem:"KeyInfoItemUpsertResult",
		createKeyInfoList:"KeyInfoListCreateResult",
		deleteKeyInfoList:"KeyInfoListDeleteResult",
		updateKeyInfoList:"KeyInfoListUpdateResult",
		upsertKeyInfoList:"KeyInfoListUpsertResult",
		createContractType:"ContractTypeCreateResult",
		deleteContractType:"ContractTypeDeleteResult",
		updateContractType:"ContractTypeUpdateResult",
		upsertContractType:"ContractTypeUpsertResult",
		createContractTypeLocale:"ContractTypeLocaleCreateResult",
		deleteContractTypeLocale:"ContractTypeLocaleDeleteResult",
		updateContractTypeLocale:"ContractTypeLocaleUpdateResult",
		upsertContractTypeLocale:"ContractTypeLocaleUpsertResult",
		createJobCity:"JobCityCreateResult",
		deleteJobCity:"JobCityDeleteResult",
		updateJobCity:"JobCityUpdateResult",
		upsertJobCity:"JobCityUpsertResult",
		createJobCityLocale:"JobCityLocaleCreateResult",
		deleteJobCityLocale:"JobCityLocaleDeleteResult",
		updateJobCityLocale:"JobCityLocaleUpdateResult",
		upsertJobCityLocale:"JobCityLocaleUpsertResult",
		createJobPosition:"JobPositionCreateResult",
		deleteJobPosition:"JobPositionDeleteResult",
		updateJobPosition:"JobPositionUpdateResult",
		upsertJobPosition:"JobPositionUpsertResult",
		createJobPositionLocale:"JobPositionLocaleCreateResult",
		deleteJobPositionLocale:"JobPositionLocaleDeleteResult",
		updateJobPositionLocale:"JobPositionLocaleUpdateResult",
		upsertJobPositionLocale:"JobPositionLocaleUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createHomePage:"HomePageCreateResult",
		deleteHomePage:"HomePageDeleteResult",
		updateHomePage:"HomePageUpdateResult",
		upsertHomePage:"HomePageUpsertResult",
		createHomePageLocale:"HomePageLocaleCreateResult",
		deleteHomePageLocale:"HomePageLocaleDeleteResult",
		updateHomePageLocale:"HomePageLocaleUpdateResult",
		upsertHomePageLocale:"HomePageLocaleUpsertResult",
		createMedium:"MediumCreateResult",
		deleteMedium:"MediumDeleteResult",
		updateMedium:"MediumUpdateResult",
		upsertMedium:"MediumUpsertResult",
		createMediumItem:"MediumItemCreateResult",
		deleteMediumItem:"MediumItemDeleteResult",
		updateMediumItem:"MediumItemUpdateResult",
		upsertMediumItem:"MediumItemUpsertResult",
		createMediumList:"MediumListCreateResult",
		deleteMediumList:"MediumListDeleteResult",
		updateMediumList:"MediumListUpdateResult",
		upsertMediumList:"MediumListUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createTextItem:"TextItemCreateResult",
		deleteTextItem:"TextItemDeleteResult",
		updateTextItem:"TextItemUpdateResult",
		upsertTextItem:"TextItemUpsertResult",
		createTextList:"TextListCreateResult",
		deleteTextList:"TextListDeleteResult",
		updateTextList:"TextListUpdateResult",
		upsertTextList:"TextListUpsertResult",
		createCarousel:"CarouselCreateResult",
		deleteCarousel:"CarouselDeleteResult",
		updateCarousel:"CarouselUpdateResult",
		upsertCarousel:"CarouselUpsertResult",
		createCarouselItem:"CarouselItemCreateResult",
		deleteCarouselItem:"CarouselItemDeleteResult",
		updateCarouselItem:"CarouselItemUpdateResult",
		upsertCarouselItem:"CarouselItemUpsertResult",
		createTheme:"ThemeCreateResult",
		deleteTheme:"ThemeDeleteResult",
		updateTheme:"ThemeUpdateResult",
		upsertTheme:"ThemeUpsertResult",
		createBonusBanner:"BonusBannerCreateResult",
		deleteBonusBanner:"BonusBannerDeleteResult",
		updateBonusBanner:"BonusBannerUpdateResult",
		upsertBonusBanner:"BonusBannerUpsertResult",
		createBonusBannerLocale:"BonusBannerLocaleCreateResult",
		deleteBonusBannerLocale:"BonusBannerLocaleDeleteResult",
		updateBonusBannerLocale:"BonusBannerLocaleUpdateResult",
		upsertBonusBannerLocale:"BonusBannerLocaleUpsertResult",
		createTile:"TileCreateResult",
		deleteTile:"TileDeleteResult",
		updateTile:"TileUpdateResult",
		upsertTile:"TileUpsertResult",
		createSideBySide:"SideBySideCreateResult",
		deleteSideBySide:"SideBySideDeleteResult",
		updateSideBySide:"SideBySideUpdateResult",
		upsertSideBySide:"SideBySideUpsertResult",
		createSideBySideItem:"SideBySideItemCreateResult",
		deleteSideBySideItem:"SideBySideItemDeleteResult",
		updateSideBySideItem:"SideBySideItemUpdateResult",
		upsertSideBySideItem:"SideBySideItemUpsertResult",
		createHomePageLokal:"HomePageLokalCreateResult",
		deleteHomePageLokal:"HomePageLokalDeleteResult",
		updateHomePageLokal:"HomePageLokalUpdateResult",
		upsertHomePageLokal:"HomePageLokalUpsertResult",
		createHomePageLokalLocale:"HomePageLokalLocaleCreateResult",
		deleteHomePageLokalLocale:"HomePageLokalLocaleDeleteResult",
		updateHomePageLokalLocale:"HomePageLokalLocaleUpdateResult",
		upsertHomePageLokalLocale:"HomePageLokalLocaleUpsertResult",
		createSiteSwitcher:"SiteSwitcherCreateResult",
		deleteSiteSwitcher:"SiteSwitcherDeleteResult",
		updateSiteSwitcher:"SiteSwitcherUpdateResult",
		upsertSiteSwitcher:"SiteSwitcherUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createJobsForm:"JobsFormCreateResult",
		deleteJobsForm:"JobsFormDeleteResult",
		updateJobsForm:"JobsFormUpdateResult",
		upsertJobsForm:"JobsFormUpsertResult",
		createJobsFormLocale:"JobsFormLocaleCreateResult",
		deleteJobsFormLocale:"JobsFormLocaleDeleteResult",
		updateJobsFormLocale:"JobsFormLocaleUpdateResult",
		upsertJobsFormLocale:"JobsFormLocaleUpsertResult",
		createImageTextItem:"ImageTextItemCreateResult",
		deleteImageTextItem:"ImageTextItemDeleteResult",
		updateImageTextItem:"ImageTextItemUpdateResult",
		upsertImageTextItem:"ImageTextItemUpsertResult",
		createImageTextList:"ImageTextListCreateResult",
		deleteImageTextList:"ImageTextListDeleteResult",
		updateImageTextList:"ImageTextListUpdateResult",
		upsertImageTextList:"ImageTextListUpsertResult",
		createJobsFilter:"JobsFilterCreateResult",
		deleteJobsFilter:"JobsFilterDeleteResult",
		updateJobsFilter:"JobsFilterUpdateResult",
		upsertJobsFilter:"JobsFilterUpsertResult",
		createJobsFilterLocale:"JobsFilterLocaleCreateResult",
		deleteJobsFilterLocale:"JobsFilterLocaleDeleteResult",
		updateJobsFilterLocale:"JobsFilterLocaleUpdateResult",
		upsertJobsFilterLocale:"JobsFilterLocaleUpsertResult",
		createFile:"FileCreateResult",
		deleteFile:"FileDeleteResult",
		updateFile:"FileUpdateResult",
		upsertFile:"FileUpsertResult",
		createJobFormSubscription:"JobFormSubscriptionCreateResult",
		deleteJobFormSubscription:"JobFormSubscriptionDeleteResult",
		updateJobFormSubscription:"JobFormSubscriptionUpdateResult",
		upsertJobFormSubscription:"JobFormSubscriptionUpsertResult",
		createImageList:"ImageListCreateResult",
		deleteImageList:"ImageListDeleteResult",
		updateImageList:"ImageListUpdateResult",
		upsertImageList:"ImageListUpsertResult",
		createImageListItem:"ImageListItemCreateResult",
		deleteImageListItem:"ImageListItemDeleteResult",
		updateImageListItem:"ImageListItemUpdateResult",
		upsertImageListItem:"ImageListItemUpsertResult",
		createJobFormSubscriptionStatus:"JobFormSubscriptionStatusCreateResult",
		deleteJobFormSubscriptionStatus:"JobFormSubscriptionStatusDeleteResult",
		updateJobFormSubscriptionStatus:"JobFormSubscriptionStatusUpdateResult",
		upsertJobFormSubscriptionStatus:"JobFormSubscriptionStatusUpsertResult",
		createGeneralLocale:"GeneralLocaleCreateResult",
		deleteGeneralLocale:"GeneralLocaleDeleteResult",
		updateGeneralLocale:"GeneralLocaleUpdateResult",
		upsertGeneralLocale:"GeneralLocaleUpsertResult",
		createStickyBar:"StickyBarCreateResult",
		deleteStickyBar:"StickyBarDeleteResult",
		updateStickyBar:"StickyBarUpdateResult",
		upsertStickyBar:"StickyBarUpsertResult",
		createRecommendationForm:"RecommendationFormCreateResult",
		deleteRecommendationForm:"RecommendationFormDeleteResult",
		updateRecommendationForm:"RecommendationFormUpdateResult",
		upsertRecommendationForm:"RecommendationFormUpsertResult",
		createRecommendationFormLocale:"RecommendationFormLocaleCreateResult",
		deleteRecommendationFormLocale:"RecommendationFormLocaleDeleteResult",
		updateRecommendationFormLocale:"RecommendationFormLocaleUpdateResult",
		upsertRecommendationFormLocale:"RecommendationFormLocaleUpsertResult",
		createRecommendationFormSubscription:"RecommendationFormSubscriptionCreateResult",
		deleteRecommendationFormSubscription:"RecommendationFormSubscriptionDeleteResult",
		updateRecommendationFormSubscription:"RecommendationFormSubscriptionUpdateResult",
		upsertRecommendationFormSubscription:"RecommendationFormSubscriptionUpsertResult",
		createInfoBox:"InfoBoxCreateResult",
		deleteInfoBox:"InfoBoxDeleteResult",
		updateInfoBox:"InfoBoxUpdateResult",
		upsertInfoBox:"InfoBoxUpsertResult",
		createInfoBoxLocale:"InfoBoxLocaleCreateResult",
		deleteInfoBoxLocale:"InfoBoxLocaleDeleteResult",
		updateInfoBoxLocale:"InfoBoxLocaleUpdateResult",
		upsertInfoBoxLocale:"InfoBoxLocaleUpsertResult",
		createTranslation:"TranslationCreateResult",
		deleteTranslation:"TranslationDeleteResult",
		updateTranslation:"TranslationUpdateResult",
		upsertTranslation:"TranslationUpsertResult",
		createTranslationLocale:"TranslationLocaleCreateResult",
		deleteTranslationLocale:"TranslationLocaleDeleteResult",
		updateTranslationLocale:"TranslationLocaleUpdateResult",
		upsertTranslationLocale:"TranslationLocaleUpsertResult",
		createCornerBanner:"CornerBannerCreateResult",
		deleteCornerBanner:"CornerBannerDeleteResult",
		updateCornerBanner:"CornerBannerUpdateResult",
		upsertCornerBanner:"CornerBannerUpsertResult",
		query:"Query"
	}
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const
}


export const HOST="Specify host"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json();
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

export const Thunder =
  (fn: FetchFunction) =>
  <O extends keyof typeof Ops, SCLR extends ScalarDefinition, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<SCLR>,
  ) =>
  <Z extends ValueTypes[R]>(o: Z | ValueTypes[R], ops?: OperationOptions & { variables?: Record<string, unknown> }) =>
    fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: graphqlOptions?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (graphqlOptions?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: graphqlOptions.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, SCLR>>;

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  (fn: SubscriptionFunction) =>
  <O extends keyof typeof Ops, SCLR extends ScalarDefinition, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<SCLR>,
  ) =>
  <Z extends ValueTypes[R]>(o: Z | ValueTypes[R], ops?: OperationOptions & { variables?: ExtractVariables<Z> }) => {
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: graphqlOptions?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], SCLR>;
    if (returnedFunction?.on && graphqlOptions?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, SCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, SCLR>) => {
          if (graphqlOptions?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: graphqlOptions.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z | ValueTypes[R],
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    return Object.fromEntries(Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])]));
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  type: T,
  field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any, source?: any) => any;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S;
type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : Record<string, unknown>
        : never;
    }[keyof DST] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <T>(t: T | V) => T;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['ID']: unknown;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariables<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = GraphQLTypes["_Field"] | GraphQLTypes["MutationResult"]
export type ScalarCoders = {
	Json?: ScalarResolver;
	UUID?: ScalarResolver;
	DateTime?: ScalarResolver;
}
type ZEUS_UNIONS = GraphQLTypes["_Argument"] | GraphQLTypes["_PathFragment"]

export type ValueTypes = {
    ["_Column"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	enumName?:boolean | `@${string}`,
	defaultValue?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean | `@${string}`
}>;
	["_Field"]:AliasType<{
		name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: boolean | `@${string}`
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_RuleMessage"]: AliasType<{
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Validator"]: AliasType<{
	operation?:boolean | `@${string}`,
	arguments?:ValueTypes["_Argument"],
		__typename?: boolean | `@${string}`
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: boolean | `@${string}`
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_PathArgument"]: AliasType<{
	path?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_LiteralArgument"]: AliasType<{
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Json custom scalar type */
["Json"]:unknown;
	["_Relation"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	side?:boolean | `@${string}`,
	targetEntity?:boolean | `@${string}`,
	ownedBy?:boolean | `@${string}`,
	inversedBy?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	onDelete?:boolean | `@${string}`,
	orphanRemoval?:boolean | `@${string}`,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean | `@${string}`
}>;
	["_RelationSide"]:_RelationSide;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_OrderBy"]: AliasType<{
	path?:boolean | `@${string}`,
	direction?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_OrderByDirection"]:_OrderByDirection;
	["Query"]: AliasType<{
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:boolean | `@${string}`,
getGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>},ValueTypes["General"]],
listGeneral?: [{	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["General"]],
paginateGeneral?: [{	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralConnection"]],
validateCreateGeneral?: [{	data: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GeneralUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
listImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Image"]],
paginateImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
listGenericPage?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
paginateGenericPage?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
listLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkableUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
listSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
paginateSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SeoUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
listContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Content"]],
paginateContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentReferenceLinkableItem?: [{	by: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
listContentReferenceLinkableItem?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
paginateContentReferenceLinkableItem?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItemConnection"]],
getRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>},ValueTypes["Redirect"]],
listRedirect?: [{	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RedirectOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RedirectOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data: ValueTypes["RedirectCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RedirectUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
listLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Link"]],
paginateLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>},ValueTypes["Footer"]],
listFooter?: [{	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Footer"]],
paginateFooter?: [{	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FooterUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFooterLink?: [{	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLink"]],
listFooterLink?: [{	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLinkOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLink"]],
paginateFooterLink?: [{	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLinkOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLinkConnection"]],
validateCreateFooterLink?: [{	data: ValueTypes["FooterLinkCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFooterLink?: [{	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FooterLinkUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
listFooterLocale?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
listGenericPageLocale?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
paginateGenericPageLocale?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleConnection"]],
validateCreateGenericPageLocale?: [{	data: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>},ValueTypes["Header"]],
listHeader?: [{	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Header"]],
paginateHeader?: [{	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeaderUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
listLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
paginateLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSeoDefault?: [{	by: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefault"]],
listSeoDefault?: [{	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefault"]],
paginateSeoDefault?: [{	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultConnection"]],
validateCreateSeoDefault?: [{	data: ValueTypes["SeoDefaultCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSeoDefault?: [{	by: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SeoDefaultUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSeoDefaultLocale?: [{	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocale"]],
listSeoDefaultLocale?: [{	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocale"]],
paginateSeoDefaultLocale?: [{	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocaleConnection"]],
validateCreateSeoDefaultLocale?: [{	data: ValueTypes["SeoDefaultLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSeoDefaultLocale?: [{	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SeoDefaultLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getBusiness?: [{	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>},ValueTypes["Business"]],
listBusiness?: [{	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Business"]],
paginateBusiness?: [{	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessConnection"]],
validateCreateBusiness?: [{	data: ValueTypes["BusinessCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateBusiness?: [{	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,	data: ValueTypes["BusinessUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getBusinessPage?: [{	by: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPage"]],
listBusinessPage?: [{	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPage"]],
paginateBusinessPage?: [{	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPageConnection"]],
validateCreateBusinessPage?: [{	data: ValueTypes["BusinessPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateBusinessPage?: [{	by: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["BusinessPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getBusinessPageLocale?: [{	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
listBusinessPageLocale?: [{	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
paginateBusinessPageLocale?: [{	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocaleConnection"]],
validateCreateBusinessPageLocale?: [{	data: ValueTypes["BusinessPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateBusinessPageLocale?: [{	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["BusinessPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getIcon?: [{	by: ValueTypes["IconUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>},ValueTypes["Icon"]],
listIcon?: [{	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["IconOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Icon"]],
paginateIcon?: [{	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["IconOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["IconConnection"]],
validateCreateIcon?: [{	data: ValueTypes["IconCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateIcon?: [{	by: ValueTypes["IconUniqueWhere"] | Variable<any, string>,	data: ValueTypes["IconUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobPage?: [{	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPage"]],
listJobPage?: [{	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPage"]],
paginateJobPage?: [{	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageConnection"]],
validateCreateJobPage?: [{	data: ValueTypes["JobPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobPage?: [{	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobPageLocale?: [{	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
listJobPageLocale?: [{	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
paginateJobPageLocale?: [{	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageLocaleConnection"]],
validateCreateJobPageLocale?: [{	data: ValueTypes["JobPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobPageLocale?: [{	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getKeyInfoItem?: [{	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["KeyInfoItem"]],
listKeyInfoItem?: [{	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["KeyInfoItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["KeyInfoItem"]],
paginateKeyInfoItem?: [{	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["KeyInfoItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["KeyInfoItemConnection"]],
validateCreateKeyInfoItem?: [{	data: ValueTypes["KeyInfoItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateKeyInfoItem?: [{	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["KeyInfoItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getKeyInfoList?: [{	by: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>},ValueTypes["KeyInfoList"]],
listKeyInfoList?: [{	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["KeyInfoListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["KeyInfoList"]],
paginateKeyInfoList?: [{	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["KeyInfoListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["KeyInfoListConnection"]],
validateCreateKeyInfoList?: [{	data: ValueTypes["KeyInfoListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateKeyInfoList?: [{	by: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["KeyInfoListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContractType?: [{	by: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractType"]],
listContractType?: [{	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContractType"]],
paginateContractType?: [{	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContractTypeConnection"]],
validateCreateContractType?: [{	data: ValueTypes["ContractTypeCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContractType?: [{	by: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContractTypeUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContractTypeLocale?: [{	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocale"]],
listContractTypeLocale?: [{	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocale"]],
paginateContractTypeLocale?: [{	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocaleConnection"]],
validateCreateContractTypeLocale?: [{	data: ValueTypes["ContractTypeLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContractTypeLocale?: [{	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContractTypeLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobCity?: [{	by: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCity"]],
listJobCity?: [{	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobCity"]],
paginateJobCity?: [{	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobCityConnection"]],
validateCreateJobCity?: [{	data: ValueTypes["JobCityCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobCity?: [{	by: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobCityUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobCityLocale?: [{	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCityLocale"]],
listJobCityLocale?: [{	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobCityLocale"]],
paginateJobCityLocale?: [{	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobCityLocaleConnection"]],
validateCreateJobCityLocale?: [{	data: ValueTypes["JobCityLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobCityLocale?: [{	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobCityLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobPosition?: [{	by: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPosition"]],
listJobPosition?: [{	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPosition"]],
paginateJobPosition?: [{	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPositionConnection"]],
validateCreateJobPosition?: [{	data: ValueTypes["JobPositionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobPosition?: [{	by: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobPositionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobPositionLocale?: [{	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocale"]],
listJobPositionLocale?: [{	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocale"]],
paginateJobPositionLocale?: [{	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocaleConnection"]],
validateCreateJobPositionLocale?: [{	data: ValueTypes["JobPositionLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobPositionLocale?: [{	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobPositionLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGallery?: [{	by: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>},ValueTypes["Gallery"]],
listGallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GalleryOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GalleryOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data: ValueTypes["GalleryCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GalleryUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePage"]],
listHomePage?: [{	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data: ValueTypes["HomePageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HomePageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHomePageLocale?: [{	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
listHomePageLocale?: [{	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
paginateHomePageLocale?: [{	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLocaleConnection"]],
validateCreateHomePageLocale?: [{	data: ValueTypes["HomePageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHomePageLocale?: [{	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HomePageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>},ValueTypes["Medium"]],
listMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Medium"]],
paginateMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumItem"]],
listMediumItem?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItem"]],
paginateMediumItem?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItemConnection"]],
validateCreateMediumItem?: [{	data: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
listMediumList?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
paginateMediumList?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumListConnection"]],
validateCreateMediumList?: [{	data: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Video"]],
listVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Video"]],
paginateVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	data: ValueTypes["VideoUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextItem"]],
listTextItem?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TextItem"]],
paginateTextItem?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TextItemConnection"]],
validateCreateTextItem?: [{	data: ValueTypes["TextItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TextItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTextList?: [{	by: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextList"]],
listTextList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TextList"]],
paginateTextList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TextListConnection"]],
validateCreateTextList?: [{	data: ValueTypes["TextListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTextList?: [{	by: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TextListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCarousel?: [{	by: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["Carousel"]],
listCarousel?: [{	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CarouselOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Carousel"]],
paginateCarousel?: [{	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CarouselOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CarouselConnection"]],
validateCreateCarousel?: [{	data: ValueTypes["CarouselCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCarousel?: [{	by: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CarouselUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCarouselItem?: [{	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CarouselItem"]],
listCarouselItem?: [{	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CarouselItem"]],
paginateCarouselItem?: [{	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CarouselItemConnection"]],
validateCreateCarouselItem?: [{	data: ValueTypes["CarouselItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCarouselItem?: [{	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTheme?: [{	by: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>},ValueTypes["Theme"]],
listTheme?: [{	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ThemeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Theme"]],
paginateTheme?: [{	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ThemeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ThemeConnection"]],
validateCreateTheme?: [{	data: ValueTypes["ThemeCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTheme?: [{	by: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ThemeUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getBonusBanner?: [{	by: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBanner"]],
listBonusBanner?: [{	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBanner"]],
paginateBonusBanner?: [{	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBannerConnection"]],
validateCreateBonusBanner?: [{	data: ValueTypes["BonusBannerCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateBonusBanner?: [{	by: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,	data: ValueTypes["BonusBannerUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getBonusBannerLocale?: [{	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
listBonusBannerLocale?: [{	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
paginateBonusBannerLocale?: [{	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocaleConnection"]],
validateCreateBonusBannerLocale?: [{	data: ValueTypes["BonusBannerLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateBonusBannerLocale?: [{	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["BonusBannerLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTile?: [{	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>},ValueTypes["Tile"]],
listTile?: [{	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Tile"]],
paginateTile?: [{	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TileConnection"]],
validateCreateTile?: [{	data: ValueTypes["TileCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTile?: [{	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TileUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSideBySide?: [{	by: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySide"]],
listSideBySide?: [{	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SideBySideOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SideBySide"]],
paginateSideBySide?: [{	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SideBySideOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SideBySideConnection"]],
validateCreateSideBySide?: [{	data: ValueTypes["SideBySideCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSideBySide?: [{	by: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SideBySideUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSideBySideItem?: [{	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySideItem"]],
listSideBySideItem?: [{	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SideBySideItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SideBySideItem"]],
paginateSideBySideItem?: [{	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SideBySideItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SideBySideItemConnection"]],
validateCreateSideBySideItem?: [{	data: ValueTypes["SideBySideItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSideBySideItem?: [{	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SideBySideItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHomePageLokal?: [{	by: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokal"]],
listHomePageLokal?: [{	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokal"]],
paginateHomePageLokal?: [{	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalConnection"]],
validateCreateHomePageLokal?: [{	data: ValueTypes["HomePageLokalCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHomePageLokal?: [{	by: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HomePageLokalUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHomePageLokalLocale?: [{	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
listHomePageLokalLocale?: [{	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
paginateHomePageLokalLocale?: [{	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocaleConnection"]],
validateCreateHomePageLokalLocale?: [{	data: ValueTypes["HomePageLokalLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHomePageLokalLocale?: [{	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HomePageLokalLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSiteSwitcher?: [{	by: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>},ValueTypes["SiteSwitcher"]],
listSiteSwitcher?: [{	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SiteSwitcherOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SiteSwitcher"]],
paginateSiteSwitcher?: [{	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SiteSwitcherOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SiteSwitcherConnection"]],
validateCreateSiteSwitcher?: [{	data: ValueTypes["SiteSwitcherCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSiteSwitcher?: [{	by: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SiteSwitcherUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data: ValueTypes["GalleryItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GalleryItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobsForm?: [{	by: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsForm"]],
listJobsForm?: [{	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsForm"]],
paginateJobsForm?: [{	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFormConnection"]],
validateCreateJobsForm?: [{	data: ValueTypes["JobsFormCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobsForm?: [{	by: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobsFormUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobsFormLocale?: [{	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
listJobsFormLocale?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
paginateJobsFormLocale?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocaleConnection"]],
validateCreateJobsFormLocale?: [{	data: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobsFormLocale?: [{	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageTextItem?: [{	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextItem"]],
listImageTextItem?: [{	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageTextItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageTextItem"]],
paginateImageTextItem?: [{	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageTextItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageTextItemConnection"]],
validateCreateImageTextItem?: [{	data: ValueTypes["ImageTextItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageTextItem?: [{	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageTextItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageTextList?: [{	by: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextList"]],
listImageTextList?: [{	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageTextListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageTextList"]],
paginateImageTextList?: [{	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageTextListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageTextListConnection"]],
validateCreateImageTextList?: [{	data: ValueTypes["ImageTextListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageTextList?: [{	by: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageTextListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobsFilter?: [{	by: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilter"]],
listJobsFilter?: [{	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilter"]],
paginateJobsFilter?: [{	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilterConnection"]],
validateCreateJobsFilter?: [{	data: ValueTypes["JobsFilterCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobsFilter?: [{	by: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobsFilterUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobsFilterLocale?: [{	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
listJobsFilterLocale?: [{	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
paginateJobsFilterLocale?: [{	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocaleConnection"]],
validateCreateJobsFilterLocale?: [{	data: ValueTypes["JobsFilterLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobsFilterLocale?: [{	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobsFilterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFile?: [{	by: ValueTypes["FileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>},ValueTypes["File"]],
listFile?: [{	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FileOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["File"]],
paginateFile?: [{	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FileOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FileConnection"]],
validateCreateFile?: [{	data: ValueTypes["FileCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFile?: [{	by: ValueTypes["FileUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FileUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobFormSubscription?: [{	by: ValueTypes["JobFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscription"]],
listJobFormSubscription?: [{	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobFormSubscriptionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscription"]],
paginateJobFormSubscription?: [{	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobFormSubscriptionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionConnection"]],
validateCreateJobFormSubscription?: [{	data: ValueTypes["JobFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobFormSubscription?: [{	by: ValueTypes["JobFormSubscriptionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobFormSubscriptionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageList?: [{	by: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageList"]],
listImageList?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageList"]],
paginateImageList?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageListConnection"]],
validateCreateImageList?: [{	data: ValueTypes["ImageListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageListItem"]],
listImageListItem?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageListItem"]],
paginateImageListItem?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageListItemConnection"]],
validateCreateImageListItem?: [{	data: ValueTypes["ImageListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobFormSubscriptionStatus?: [{	by: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionStatus"]],
listJobFormSubscriptionStatus?: [{	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobFormSubscriptionStatusOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionStatus"]],
paginateJobFormSubscriptionStatus?: [{	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobFormSubscriptionStatusOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionStatusConnection"]],
validateCreateJobFormSubscriptionStatus?: [{	data: ValueTypes["JobFormSubscriptionStatusCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobFormSubscriptionStatus?: [{	by: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobFormSubscriptionStatusUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
listGeneralLocale?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
paginateGeneralLocale?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleConnection"]],
validateCreateGeneralLocale?: [{	data: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStickyBar?: [{	by: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>},ValueTypes["StickyBar"]],
listStickyBar?: [{	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StickyBarOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StickyBar"]],
paginateStickyBar?: [{	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StickyBarOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StickyBarConnection"]],
validateCreateStickyBar?: [{	data: ValueTypes["StickyBarCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStickyBar?: [{	by: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StickyBarUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRecommendationForm?: [{	by: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationForm"]],
listRecommendationForm?: [{	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationForm"]],
paginateRecommendationForm?: [{	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormConnection"]],
validateCreateRecommendationForm?: [{	data: ValueTypes["RecommendationFormCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRecommendationForm?: [{	by: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RecommendationFormUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRecommendationFormLocale?: [{	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocale"]],
listRecommendationFormLocale?: [{	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocale"]],
paginateRecommendationFormLocale?: [{	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocaleConnection"]],
validateCreateRecommendationFormLocale?: [{	data: ValueTypes["RecommendationFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRecommendationFormLocale?: [{	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RecommendationFormLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRecommendationFormSubscription?: [{	by: ValueTypes["RecommendationFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormSubscription"]],
listRecommendationFormSubscription?: [{	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormSubscriptionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormSubscription"]],
paginateRecommendationFormSubscription?: [{	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormSubscriptionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormSubscriptionConnection"]],
validateCreateRecommendationFormSubscription?: [{	data: ValueTypes["RecommendationFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRecommendationFormSubscription?: [{	by: ValueTypes["RecommendationFormSubscriptionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RecommendationFormSubscriptionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getInfoBox?: [{	by: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBox"]],
listInfoBox?: [{	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBox"]],
paginateInfoBox?: [{	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBoxConnection"]],
validateCreateInfoBox?: [{	data: ValueTypes["InfoBoxCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateInfoBox?: [{	by: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,	data: ValueTypes["InfoBoxUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getInfoBoxLocale?: [{	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocale"]],
listInfoBoxLocale?: [{	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocale"]],
paginateInfoBoxLocale?: [{	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocaleConnection"]],
validateCreateInfoBoxLocale?: [{	data: ValueTypes["InfoBoxLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateInfoBoxLocale?: [{	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["InfoBoxLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslation?: [{	by: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>},ValueTypes["Translation"]],
listTranslation?: [{	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Translation"]],
paginateTranslation?: [{	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationConnection"]],
validateCreateTranslation?: [{	data: ValueTypes["TranslationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslation?: [{	by: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationLocale?: [{	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationLocale"]],
listTranslationLocale?: [{	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationLocale"]],
paginateTranslationLocale?: [{	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationLocaleConnection"]],
validateCreateTranslationLocale?: [{	data: ValueTypes["TranslationLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationLocale?: [{	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCornerBanner?: [{	by: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["CornerBanner"]],
listCornerBanner?: [{	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CornerBannerOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CornerBanner"]],
paginateCornerBanner?: [{	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CornerBannerOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CornerBannerConnection"]],
validateCreateCornerBanner?: [{	data: ValueTypes["CornerBannerCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCornerBanner?: [{	by: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CornerBannerUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
		__typename?: boolean | `@${string}`
}>;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: boolean | `@${string}`
}>;
	["_Enum"]: AliasType<{
	name?:boolean | `@${string}`,
	values?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Entity"]: AliasType<{
	name?:boolean | `@${string}`,
	customPrimaryAllowed?:boolean | `@${string}`,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: boolean | `@${string}`
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["General"]: AliasType<{
	_meta?:ValueTypes["GeneralMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
localesByLocale?: [{	by: ValueTypes["GeneralLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
localesBySeo?: [{	by: ValueTypes["GeneralLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
localesByCornerBanner?: [{	by: ValueTypes["GeneralLocalesByCornerBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
paginateLocales?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GeneralMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FieldMeta"]: AliasType<{
	readable?:boolean | `@${string}`,
	updatable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UUID"]:unknown;
	["One"]:One;
	["GeneralLocale"]: AliasType<{
	_meta?:ValueTypes["GeneralLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>},ValueTypes["General"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
cornerBanner?: [{	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["CornerBanner"]],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	cornerBanner?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GeneralWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GeneralWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>
};
	["UUIDCondition"]: {
	and?: Array<ValueTypes["UUIDCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["UUIDCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["UUID"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["UUID"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["OneCondition"]: {
	and?: Array<ValueTypes["OneCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["OneCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["One"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["One"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["One"] | undefined | null | Variable<any, string>
};
	["GeneralLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	cornerBanner?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GeneralLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GeneralLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>
};
	["LocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	code?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	label?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	footers?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,
	genericPages?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,
	headers?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,
	seoDefaults?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,
	businessPages?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,
	jobPages?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,
	contractTypes?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,
	jobCities?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,
	jobPositions?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,
	homePages?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,
	bonusBanners?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,
	homePageLokals?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,
	jobsForms?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,
	jobsFilters?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,
	general?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,
	recommendationForms?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,
	infoBoxes?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,
	translations?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["LocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>
};
	["StringCondition"]: {
	and?: Array<ValueTypes["StringCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StringCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: string | undefined | null | Variable<any, string>,
	notEq?: string | undefined | null | Variable<any, string>,
	in?: Array<string> | undefined | null | Variable<any, string>,
	notIn?: Array<string> | undefined | null | Variable<any, string>,
	lt?: string | undefined | null | Variable<any, string>,
	lte?: string | undefined | null | Variable<any, string>,
	gt?: string | undefined | null | Variable<any, string>,
	gte?: string | undefined | null | Variable<any, string>,
	contains?: string | undefined | null | Variable<any, string>,
	startsWith?: string | undefined | null | Variable<any, string>,
	endsWith?: string | undefined | null | Variable<any, string>,
	containsCI?: string | undefined | null | Variable<any, string>,
	startsWithCI?: string | undefined | null | Variable<any, string>,
	endsWithCI?: string | undefined | null | Variable<any, string>
};
	["FooterLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	address?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	ico?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	dic?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	copyright?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	note?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	noteSecond?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	linksFirstColumn?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,
	linksSecondColumn?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,
	termsAndConditions?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	form?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	bannerTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	bannerSubtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	bannerLink?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,
	copyrightLink?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	bannerSecondBtn?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	recommendationForm?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,
	bannerSecondLink?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	instagramLink?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FooterLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FooterLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>
};
	["FooterWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FooterWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FooterWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>
};
	["FooterLinkWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FooterLinkWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FooterLinkWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>
};
	["IntCondition"]: {
	and?: Array<ValueTypes["IntCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["IntCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: number | undefined | null | Variable<any, string>,
	notEq?: number | undefined | null | Variable<any, string>,
	in?: Array<number> | undefined | null | Variable<any, string>,
	notIn?: Array<number> | undefined | null | Variable<any, string>,
	lt?: number | undefined | null | Variable<any, string>,
	lte?: number | undefined | null | Variable<any, string>,
	gt?: number | undefined | null | Variable<any, string>,
	gte?: number | undefined | null | Variable<any, string>
};
	["LinkWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["LinkTypeCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	externalLink?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	internalLink?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	anchorLink?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["LinkWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LinkWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>
};
	["LinkTypeCondition"]: {
	and?: Array<ValueTypes["LinkTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LinkTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LinkTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["LinkType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["LinkType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["LinkType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["LinkType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["LinkType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["LinkType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["LinkType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["LinkType"] | undefined | null | Variable<any, string>
};
	["LinkType"]:LinkType;
	["LinkableWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["LinkableWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LinkableWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>
};
	["RedirectWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	target?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["RedirectWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["RedirectWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GenericPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GenericPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,
	headerColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GenericPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GenericPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>
};
	["ThemeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	backgroundColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	textColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	buttonBackgroundColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	buttonTextColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	buttonBackgroundHoverColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	buttonTextHoverColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	buttonBorderColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	buttonBorderHoverColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	headerMenuColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ThemeWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ThemeWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>
};
	["ContentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	blocks?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ContentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	json?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	references?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ContentBlockWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentBlockWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ContentReferenceTypeCondition"] | undefined | null | Variable<any, string>,
	primaryText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	block?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	linkables?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,
	secondaryText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,
	textList?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>,
	bonusBanner?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,
	sideBySide?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,
	showBoolean?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	isRed?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ContentReferenceWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentReferenceWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceTypeCondition"]: {
	and?: Array<ValueTypes["ContentReferenceTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentReferenceTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentReferenceTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["ContentReferenceType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["ContentReferenceType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>
};
	["ContentReferenceType"]:ContentReferenceType;
	["ImageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	width?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	height?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	alt?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	fileName?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	focalPointX?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	focalPointY?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ImageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ImageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>
};
	["FloatCondition"]: {
	and?: Array<ValueTypes["FloatCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FloatCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: number | undefined | null | Variable<any, string>,
	notEq?: number | undefined | null | Variable<any, string>,
	in?: Array<number> | undefined | null | Variable<any, string>,
	notIn?: Array<number> | undefined | null | Variable<any, string>,
	lt?: number | undefined | null | Variable<any, string>,
	lte?: number | undefined | null | Variable<any, string>,
	gt?: number | undefined | null | Variable<any, string>,
	gte?: number | undefined | null | Variable<any, string>
};
	["ContentReferenceLinkableItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	reference?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>
};
	["MediumListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["MediumListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MediumListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>
};
	["MediumItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["MediumItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MediumItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>
};
	["MediumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["MediumTypeCondition"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["MediumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MediumWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>
};
	["MediumTypeCondition"]: {
	and?: Array<ValueTypes["MediumTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MediumTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MediumTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["MediumType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["MediumType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>
};
	["MediumType"]:MediumType;
	["VideoWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	src?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	width?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	height?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	videoInfo?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	duration?: ValueTypes["FloatCondition"] | undefined | null | Variable<any, string>,
	poster?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["VideoWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["VideoWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>
};
	["TextListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TextListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TextListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>
};
	["TextItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TextItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TextItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>
};
	["CarouselWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,
	background?: ValueTypes["BackgroundCondition"] | undefined | null | Variable<any, string>,
	squareImages?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["CarouselWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CarouselWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>
};
	["CarouselItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	linkUrl?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	normalAspectRatio?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	isImage?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["CarouselItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CarouselItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>
};
	["BooleanCondition"]: {
	and?: Array<ValueTypes["BooleanCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["BooleanCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: boolean | undefined | null | Variable<any, string>,
	notEq?: boolean | undefined | null | Variable<any, string>,
	in?: Array<boolean> | undefined | null | Variable<any, string>,
	notIn?: Array<boolean> | undefined | null | Variable<any, string>,
	lt?: boolean | undefined | null | Variable<any, string>,
	lte?: boolean | undefined | null | Variable<any, string>,
	gt?: boolean | undefined | null | Variable<any, string>,
	gte?: boolean | undefined | null | Variable<any, string>
};
	["BackgroundCondition"]: {
	and?: Array<ValueTypes["BackgroundCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["BackgroundCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["BackgroundCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["Background"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["Background"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["Background"] | undefined | null | Variable<any, string>
};
	["Background"]:Background;
	["BonusBannerLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	tiles?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	bannerName?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["BonusBannerLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["BonusBannerLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>
};
	["BonusBannerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["BonusBannerWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["BonusBannerWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>
};
	["TileWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	bonusBanner?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	lightBoxTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	lightBoxText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	ligthBoxMedia?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,
	lightBoxSectionTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	lightBoxLinkLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	lightBoxForm?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TileWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TileWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>
};
	["JobsFormLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	jobText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	genericText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	nameLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	emailLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	telefonLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	fileTitleLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	fileFormatLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	formTextLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	submitLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	imageTextList?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>,
	minimalize?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	successTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successBtnLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	successOtherJobsTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successOtherJobsCategoryTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successOtherJobsButtonTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successOtherJobsSelectionTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successOtherJobsSelectionYesButton?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successOtherJobsSelectionNoButton?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	fileRemoveBtnLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	gdprLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobsFormLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobsFormLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>
};
	["JobsFormWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,
	fileIlustration?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobsFormWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobsFormWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>
};
	["ImageTextListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ImageTextListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ImageTextListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>
};
	["ImageTextItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ImageTextItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ImageTextItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>
};
	["SideBySideWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,
	background?: ValueTypes["BackgroundCondition"] | undefined | null | Variable<any, string>,
	alignment?: ValueTypes["ContentAlignmentCondition"] | undefined | null | Variable<any, string>,
	mediumSize?: ValueTypes["MediumSizeCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["SideBySideWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SideBySideWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>
};
	["SideBySideItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,
	formButtonLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["SideBySideItemTypeCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,
	textNew?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["SideBySideItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SideBySideItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>
};
	["SideBySideItemTypeCondition"]: {
	and?: Array<ValueTypes["SideBySideItemTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SideBySideItemTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SideBySideItemTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["SideBySideItemType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["SideBySideItemType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["SideBySideItemType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["SideBySideItemType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["SideBySideItemType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["SideBySideItemType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["SideBySideItemType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["SideBySideItemType"] | undefined | null | Variable<any, string>
};
	["SideBySideItemType"]:SideBySideItemType;
	["ContentAlignmentCondition"]: {
	and?: Array<ValueTypes["ContentAlignmentCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContentAlignmentCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContentAlignmentCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["ContentAlignment"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["ContentAlignment"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>
};
	["ContentAlignment"]:ContentAlignment;
	["MediumSizeCondition"]: {
	and?: Array<ValueTypes["MediumSizeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["MediumSizeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["MediumSizeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["MediumSize"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["MediumSize"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["MediumSize"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["MediumSize"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["MediumSize"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["MediumSize"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["MediumSize"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["MediumSize"] | undefined | null | Variable<any, string>
};
	["MediumSize"]:MediumSize;
	["GalleryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GalleryWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GalleryWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>
};
	["GalleryItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["GalleryItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["GalleryItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>
};
	["SeoWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	ogTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	ogDescription?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	noIndex?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	noFollow?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	ogImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["SeoWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SeoWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,
	infoBox?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["BusinessPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["BusinessPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>
};
	["BusinessPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,
	isLokal?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	tabidooId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	headerColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	recruitisOfficeId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["BusinessPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["BusinessPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>
};
	["StickyBarWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	formButtonLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["StickyBarWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["StickyBarWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>
};
	["InfoBoxWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	logoSize?: ValueTypes["LogoSizeCondition"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["InfoBoxWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["InfoBoxWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>
};
	["LogoSizeCondition"]: {
	and?: Array<ValueTypes["LogoSizeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["LogoSizeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["LogoSizeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["LogoSize"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["LogoSize"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["LogoSize"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["LogoSize"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["LogoSize"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["LogoSize"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["LogoSize"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["LogoSize"] | undefined | null | Variable<any, string>
};
	["LogoSize"]:LogoSize;
	["InfoBoxLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	address?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	web?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	instagram?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	facebook?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	openingHours?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,
	addressLink?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["InfoBoxLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["InfoBoxLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>
};
	["JobPageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	tabidooId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	recruitisJobId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobPageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>
};
	["JobPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,
	contractType?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>,
	jobCity?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>,
	isActive?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	jobPosition?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	business?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>,
	headerColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	siteType?: ValueTypes["SiteTypeCondition"] | undefined | null | Variable<any, string>,
	isHiddenFromListing?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobPageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>
};
	["ContractTypeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ContractTypeWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContractTypeWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	slug?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ContractTypeLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ContractTypeLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>
};
	["JobCityWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobCityWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobCityWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>
};
	["JobCityLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	slug?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobCityLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobCityLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>
};
	["JobPositionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,
	jobs?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobPositionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobPositionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>
};
	["JobPositionLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	slug?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobPositionLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobPositionLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>
};
	["DateTimeCondition"]: {
	and?: Array<ValueTypes["DateTimeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["DateTimeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["DateTime"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["DateTime"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>
};
	["DateTime"]:unknown;
	["SiteTypeCondition"]: {
	and?: Array<ValueTypes["SiteTypeCondition"]> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SiteTypeCondition"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SiteTypeCondition"] | undefined | null | Variable<any, string>,
	null?: boolean | undefined | null | Variable<any, string>,
	isNull?: boolean | undefined | null | Variable<any, string>,
	eq?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	notEq?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["SiteType"]> | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["SiteType"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>
};
	["SiteType"]:SiteType;
	["KeyInfoListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["KeyInfoListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["KeyInfoListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>
};
	["KeyInfoItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["KeyInfoItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["KeyInfoItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>
};
	["IconWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["IconWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["IconWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["HomePageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["HomePageLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>
};
	["HomePageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["HomePageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["HomePageWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>
};
	["SiteSwitcherWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,
	headerColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["SiteSwitcherWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SiteSwitcherWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["HomePageLokalLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["HomePageLokalLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["HomePageLokalWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["HomePageLokalWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	yourEmailLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	theirEmailLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	yourName?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	sendBtnLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successSubtitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	successButtonClose?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["RecommendationFormLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["RecommendationFormLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>
};
	["RecommendationFormWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["RecommendationFormWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["RecommendationFormWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>
};
	["HeaderLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	menuLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	menuTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	menuText?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	business?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,
	lokalEnterprise?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,
	businessSectionTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	lokalSectionTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	businessLink?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	lokalLink?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["HeaderLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["HeaderLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>
};
	["HeaderWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	logoMenu?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["HeaderWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["HeaderWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>
};
	["BusinessWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["BusinessWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["BusinessWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["SeoDefaultLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SeoDefaultLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>
};
	["SeoDefaultWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["SeoDefaultWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["SeoDefaultWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	jobPositionLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	jobContractLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	jobCityLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	bannerTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	bannerFormLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	bannerJobsForm?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	noJobTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	noJobBtnLabel?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	noJobImage?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	noJobTitleForSpecificBusiness?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	deactivatedJob?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobsFilterLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobsFilterLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>
};
	["JobsFilterWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OneCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobsFilterWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobsFilterWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>
};
	["TranslationLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	value?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TranslationLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TranslationLocaleWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>
};
	["TranslationWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	key?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,
	isTextarea?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["TranslationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["TranslationWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>
};
	["CornerBannerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	isActive?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["CornerBannerWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["CornerBannerWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>
};
	["Locale"]: AliasType<{
	_meta?:ValueTypes["LocaleMeta"],
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
footers?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
genericPages?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
headers?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
seoDefaults?: [{	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocale"]],
businessPages?: [{	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
jobPages?: [{	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
contractTypes?: [{	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocale"]],
jobCities?: [{	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobCityLocale"]],
jobPositions?: [{	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocale"]],
homePages?: [{	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
bonusBanners?: [{	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
homePageLokals?: [{	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
jobsForms?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
jobsFilters?: [{	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
general?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
recommendationForms?: [{	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocale"]],
infoBoxes?: [{	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocale"]],
translations?: [{	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationLocale"]],
footersByRoot?: [{	by: ValueTypes["LocaleFootersByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByTermsAndConditions?: [{	by: ValueTypes["LocaleFootersByTermsAndConditionsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByBannerImage?: [{	by: ValueTypes["LocaleFootersByBannerImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByBannerLink?: [{	by: ValueTypes["LocaleFootersByBannerLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByJobsForm?: [{	by: ValueTypes["LocaleFootersByJobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByCopyrightLink?: [{	by: ValueTypes["LocaleFootersByCopyrightLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByRecommendationForm?: [{	by: ValueTypes["LocaleFootersByRecommendationFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByBannerSecondLink?: [{	by: ValueTypes["LocaleFootersByBannerSecondLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
footersByInstagramLink?: [{	by: ValueTypes["LocaleFootersByInstagramLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
genericPagesByRoot?: [{	by: ValueTypes["LocaleGenericPagesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
genericPagesByContent?: [{	by: ValueTypes["LocaleGenericPagesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
genericPagesBySeo?: [{	by: ValueTypes["LocaleGenericPagesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
genericPagesByLink?: [{	by: ValueTypes["LocaleGenericPagesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
genericPagesByLogo?: [{	by: ValueTypes["LocaleGenericPagesByLogoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
genericPagesByImage?: [{	by: ValueTypes["LocaleGenericPagesByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
headersByRoot?: [{	by: ValueTypes["LocaleHeadersByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
headersByBusinessLink?: [{	by: ValueTypes["LocaleHeadersByBusinessLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
headersByLokalLink?: [{	by: ValueTypes["LocaleHeadersByLokalLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
seoDefaultsByRoot?: [{	by: ValueTypes["LocaleSeoDefaultsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocale"]],
seoDefaultsBySeo?: [{	by: ValueTypes["LocaleSeoDefaultsBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocale"]],
businessPagesByRoot?: [{	by: ValueTypes["LocaleBusinessPagesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
businessPagesByContent?: [{	by: ValueTypes["LocaleBusinessPagesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
businessPagesBySeo?: [{	by: ValueTypes["LocaleBusinessPagesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
businessPagesByLink?: [{	by: ValueTypes["LocaleBusinessPagesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
businessPagesByImage?: [{	by: ValueTypes["LocaleBusinessPagesByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
jobPagesByRoot?: [{	by: ValueTypes["LocaleJobPagesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
jobPagesByImage?: [{	by: ValueTypes["LocaleJobPagesByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
jobPagesByKeyInfo?: [{	by: ValueTypes["LocaleJobPagesByKeyInfoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
jobPagesByContent?: [{	by: ValueTypes["LocaleJobPagesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
jobPagesBySeo?: [{	by: ValueTypes["LocaleJobPagesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
jobPagesByLink?: [{	by: ValueTypes["LocaleJobPagesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
jobPagesByMobileImage?: [{	by: ValueTypes["LocaleJobPagesByMobileImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
contractTypesByRoot?: [{	by: ValueTypes["LocaleContractTypesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocale"]],
contractTypesBySlug?: [{	by: ValueTypes["LocaleContractTypesBySlugUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocale"]],
jobCitiesByRoot?: [{	by: ValueTypes["LocaleJobCitiesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCityLocale"]],
jobCitiesBySlug?: [{	by: ValueTypes["LocaleJobCitiesBySlugUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCityLocale"]],
jobPositionsByRoot?: [{	by: ValueTypes["LocaleJobPositionsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocale"]],
jobPositionsBySlug?: [{	by: ValueTypes["LocaleJobPositionsBySlugUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocale"]],
homePagesByRoot?: [{	by: ValueTypes["LocaleHomePagesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
homePagesByButton?: [{	by: ValueTypes["LocaleHomePagesByButtonUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
homePagesByContent?: [{	by: ValueTypes["LocaleHomePagesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
homePagesBySeo?: [{	by: ValueTypes["LocaleHomePagesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
homePagesByLink?: [{	by: ValueTypes["LocaleHomePagesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
homePagesByLogo?: [{	by: ValueTypes["LocaleHomePagesByLogoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
homePagesBySiteSwitcher?: [{	by: ValueTypes["LocaleHomePagesBySiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
homePagesByIlustration?: [{	by: ValueTypes["LocaleHomePagesByIlustrationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
bonusBannersByRoot?: [{	by: ValueTypes["LocaleBonusBannersByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
bonusBannersByTiles?: [{	by: ValueTypes["LocaleBonusBannersByTilesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
bonusBannersByLogo?: [{	by: ValueTypes["LocaleBonusBannersByLogoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
homePageLokalsByRoot?: [{	by: ValueTypes["LocaleHomePageLokalsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
homePageLokalsByLogo?: [{	by: ValueTypes["LocaleHomePageLokalsByLogoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
homePageLokalsByButton?: [{	by: ValueTypes["LocaleHomePageLokalsByButtonUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
homePageLokalsByContent?: [{	by: ValueTypes["LocaleHomePageLokalsByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
homePageLokalsBySeo?: [{	by: ValueTypes["LocaleHomePageLokalsBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
homePageLokalsByLink?: [{	by: ValueTypes["LocaleHomePageLokalsByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
homePageLokalsBySiteSwitcher?: [{	by: ValueTypes["LocaleHomePageLokalsBySiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
homePageLokalsByIlustration?: [{	by: ValueTypes["LocaleHomePageLokalsByIlustrationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
jobsFormsByRoot?: [{	by: ValueTypes["LocaleJobsFormsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
jobsFormsByImageTextList?: [{	by: ValueTypes["LocaleJobsFormsByImageTextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
jobsFormsByLogo?: [{	by: ValueTypes["LocaleJobsFormsByLogoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
jobsFormsBySuccessImage?: [{	by: ValueTypes["LocaleJobsFormsBySuccessImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
jobsFiltersByRoot?: [{	by: ValueTypes["LocaleJobsFiltersByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
jobsFiltersByBannerJobsForm?: [{	by: ValueTypes["LocaleJobsFiltersByBannerJobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
jobsFiltersByBannerImage?: [{	by: ValueTypes["LocaleJobsFiltersByBannerImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
jobsFiltersByNoJobImage?: [{	by: ValueTypes["LocaleJobsFiltersByNoJobImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
generalByRoot?: [{	by: ValueTypes["LocaleGeneralByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
generalBySeo?: [{	by: ValueTypes["LocaleGeneralBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
generalByCornerBanner?: [{	by: ValueTypes["LocaleGeneralByCornerBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
recommendationFormsByRoot?: [{	by: ValueTypes["LocaleRecommendationFormsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocale"]],
infoBoxesByRoot?: [{	by: ValueTypes["LocaleInfoBoxesByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocale"]],
translationsByRoot?: [{	by: ValueTypes["LocaleTranslationsByRootUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationLocale"]],
paginateFooters?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleConnection"]],
paginateGenericPages?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleConnection"]],
paginateHeaders?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleConnection"]],
paginateSeoDefaults?: [{	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocaleConnection"]],
paginateBusinessPages?: [{	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocaleConnection"]],
paginateJobPages?: [{	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageLocaleConnection"]],
paginateContractTypes?: [{	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocaleConnection"]],
paginateJobCities?: [{	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobCityLocaleConnection"]],
paginateJobPositions?: [{	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocaleConnection"]],
paginateHomePages?: [{	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLocaleConnection"]],
paginateBonusBanners?: [{	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocaleConnection"]],
paginateHomePageLokals?: [{	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocaleConnection"]],
paginateJobsForms?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocaleConnection"]],
paginateJobsFilters?: [{	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocaleConnection"]],
paginateGeneral?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleConnection"]],
paginateRecommendationForms?: [{	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocaleConnection"]],
paginateInfoBoxes?: [{	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocaleConnection"]],
paginateTranslations?: [{	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["LocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	footers?:ValueTypes["FieldMeta"],
	genericPages?:ValueTypes["FieldMeta"],
	headers?:ValueTypes["FieldMeta"],
	seoDefaults?:ValueTypes["FieldMeta"],
	businessPages?:ValueTypes["FieldMeta"],
	jobPages?:ValueTypes["FieldMeta"],
	contractTypes?:ValueTypes["FieldMeta"],
	jobCities?:ValueTypes["FieldMeta"],
	jobPositions?:ValueTypes["FieldMeta"],
	homePages?:ValueTypes["FieldMeta"],
	bonusBanners?:ValueTypes["FieldMeta"],
	homePageLokals?:ValueTypes["FieldMeta"],
	jobsForms?:ValueTypes["FieldMeta"],
	jobsFilters?:ValueTypes["FieldMeta"],
	general?:ValueTypes["FieldMeta"],
	recommendationForms?:ValueTypes["FieldMeta"],
	infoBoxes?:ValueTypes["FieldMeta"],
	translations?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocale"]: AliasType<{
	_meta?:ValueTypes["FooterLocaleMeta"],
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	address?:boolean | `@${string}`,
	ico?:boolean | `@${string}`,
	dic?:boolean | `@${string}`,
	copyright?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	noteSecond?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>},ValueTypes["Footer"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
linksFirstColumn?: [{	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLinkOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLink"]],
linksSecondColumn?: [{	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLinkOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLink"]],
termsAndConditions?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
	form?:boolean | `@${string}`,
	bannerTitle?:boolean | `@${string}`,
	bannerSubtitle?:boolean | `@${string}`,
bannerImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
bannerLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
jobsForm?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
copyrightLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
	bannerSecondBtn?:boolean | `@${string}`,
recommendationForm?: [{	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocale"]],
bannerSecondLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
instagramLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
paginateLinksFirstColumn?: [{	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLinkOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLinkConnection"]],
paginateLinksSecondColumn?: [{	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLinkOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLinkConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	ico?:ValueTypes["FieldMeta"],
	dic?:ValueTypes["FieldMeta"],
	copyright?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	noteSecond?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	linksFirstColumn?:ValueTypes["FieldMeta"],
	linksSecondColumn?:ValueTypes["FieldMeta"],
	termsAndConditions?:ValueTypes["FieldMeta"],
	form?:ValueTypes["FieldMeta"],
	bannerTitle?:ValueTypes["FieldMeta"],
	bannerSubtitle?:ValueTypes["FieldMeta"],
	bannerImage?:ValueTypes["FieldMeta"],
	bannerLink?:ValueTypes["FieldMeta"],
	jobsForm?:ValueTypes["FieldMeta"],
	copyrightLink?:ValueTypes["FieldMeta"],
	bannerSecondBtn?:ValueTypes["FieldMeta"],
	recommendationForm?:ValueTypes["FieldMeta"],
	bannerSecondLink?:ValueTypes["FieldMeta"],
	instagramLink?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Footer"]: AliasType<{
	_meta?:ValueTypes["FooterMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByLocale?: [{	by: ValueTypes["FooterLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByTermsAndConditions?: [{	by: ValueTypes["FooterLocalesByTermsAndConditionsUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByBannerImage?: [{	by: ValueTypes["FooterLocalesByBannerImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByBannerLink?: [{	by: ValueTypes["FooterLocalesByBannerLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByJobsForm?: [{	by: ValueTypes["FooterLocalesByJobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByCopyrightLink?: [{	by: ValueTypes["FooterLocalesByCopyrightLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByRecommendationForm?: [{	by: ValueTypes["FooterLocalesByRecommendationFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByBannerSecondLink?: [{	by: ValueTypes["FooterLocalesByBannerSecondLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
localesByInstagramLink?: [{	by: ValueTypes["FooterLocalesByInstagramLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
paginateLocales?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FooterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	address?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ico?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	dic?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	copyright?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	note?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	noteSecond?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	termsAndConditions?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	form?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	bannerTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	bannerSubtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	bannerLink?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["JobsFormLocaleOrderBy"] | undefined | null | Variable<any, string>,
	copyrightLink?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	bannerSecondBtn?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	recommendationForm?: ValueTypes["RecommendationFormLocaleOrderBy"] | undefined | null | Variable<any, string>,
	bannerSecondLink?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	instagramLink?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>
};
	["OrderDirection"]:OrderDirection;
	["FooterOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["LocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	code?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	label?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["LinkOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	externalLink?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	internalLink?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	anchorLink?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["LinkableOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["RedirectOrderBy"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["GenericPageLocaleOrderBy"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["BusinessPageLocaleOrderBy"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["JobPageLocaleOrderBy"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["HomePageLocaleOrderBy"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["HomePageLokalLocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["RedirectOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	target?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["GenericPageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeOrderBy"] | undefined | null | Variable<any, string>,
	headerColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ThemeOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	backgroundColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	textColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	buttonBackgroundColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	buttonTextColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	buttonBackgroundHoverColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	buttonTextHoverColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	buttonBorderColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	buttonBorderHoverColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	headerMenuColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ContentOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["SeoOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	description?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ogTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ogDescription?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	noIndex?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	noFollow?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ogImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["ImageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	width?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	height?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	alt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fileName?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	focalPointX?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	focalPointY?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["BusinessPageOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["StickyBarOrderBy"] | undefined | null | Variable<any, string>,
	infoBox?: ValueTypes["InfoBoxOrderBy"] | undefined | null | Variable<any, string>
};
	["BusinessPageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeOrderBy"] | undefined | null | Variable<any, string>,
	isLokal?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	tabidooId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	headerColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	recruitisOfficeId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["StickyBarOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	formButtonLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["JobsFormLocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["JobsFormLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	jobText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	genericText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	nameLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	emailLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	telefonLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fileTitleLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fileFormatLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	formTextLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	submitLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFormOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	imageTextList?: ValueTypes["ImageTextListOrderBy"] | undefined | null | Variable<any, string>,
	minimalize?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	successTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successBtnLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	successOtherJobsTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successOtherJobsCategoryTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successOtherJobsButtonTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successOtherJobsSelectionTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successOtherJobsSelectionYesButton?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successOtherJobsSelectionNoButton?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fileRemoveBtnLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	gdprLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["JobsFormOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	fileIlustration?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["ImageTextListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["InfoBoxOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	logoSize?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["JobPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPageOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["KeyInfoListOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["StickyBarOrderBy"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	tabidooId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	recruitisJobId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["JobPageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeOrderBy"] | undefined | null | Variable<any, string>,
	contractType?: ValueTypes["ContractTypeOrderBy"] | undefined | null | Variable<any, string>,
	jobCity?: ValueTypes["JobCityOrderBy"] | undefined | null | Variable<any, string>,
	isActive?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	jobPosition?: ValueTypes["JobPositionOrderBy"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	business?: ValueTypes["BusinessPageOrderBy"] | undefined | null | Variable<any, string>,
	headerColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	siteType?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isHiddenFromListing?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ContractTypeOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["JobCityOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["JobPositionOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["KeyInfoListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["SiteSwitcherOrderBy"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["GalleryOrderBy"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["StickyBarOrderBy"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["GalleryOrderBy"] | undefined | null | Variable<any, string>
};
	["HomePageOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeOrderBy"] | undefined | null | Variable<any, string>
};
	["SiteSwitcherOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeOrderBy"] | undefined | null | Variable<any, string>,
	headerColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["GalleryOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLokalOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["SiteSwitcherOrderBy"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["GalleryOrderBy"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["StickyBarOrderBy"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["GalleryOrderBy"] | undefined | null | Variable<any, string>
};
	["HomePageLokalOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeOrderBy"] | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	subtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	yourEmailLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	theirEmailLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	yourName?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	sendBtnLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successSubtitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successButtonClose?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecommendationFormOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["RecommendationFormOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	footers?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	genericPages?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	headers?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	seoDefaults?: ValueTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	businessPages?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	jobPages?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	contractTypes?: ValueTypes["ContractTypeLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	jobCities?: ValueTypes["JobCityLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	jobPositions?: ValueTypes["JobPositionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	homePages?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	bonusBanners?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	homePageLokals?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	jobsForms?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	jobsFilters?: ValueTypes["JobsFilterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	general?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	recommendationForms?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	infoBoxes?: ValueTypes["InfoBoxLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	translations?: ValueTypes["TranslationLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	termsAndConditions?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	bannerLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	copyrightLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	recommendationForm?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	bannerSecondLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	instagramLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LinkUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["ImageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["JobsFormLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFormUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	imageTextList?: ValueTypes["ImageTextListUniqueWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFormUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	fileIlustration?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ImageTextListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["ImageTextItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ImageTextItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecommendationFormUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RecommendationFormUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	blocks?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	references?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	linkables?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceLinkableItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LinkableUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["RedirectUniqueWhere"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RedirectUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	target?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["BusinessPageUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BusinessPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SeoUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	ogImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPageUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["KeyInfoListUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["KeyInfoListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["KeyInfoItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["KeyInfoItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["SiteSwitcherUniqueWhere"] | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ThemeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["SiteSwitcherUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GalleryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GalleryItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLokalUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["SiteSwitcherUniqueWhere"] | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>
};
	["MediumListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["MediumItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["MediumItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["HeaderLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HeaderUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	businessLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	lokalLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HeaderUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	logoMenu?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["SeoDefaultUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SeoDefaultUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ContractTypeUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>
};
	["ContractTypeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["ContractTypeLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobCityLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobCityUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>
};
	["JobCityUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["JobCityLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPositionLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPositionUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>
};
	["JobPositionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["JobPositionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	jobs?: ValueTypes["JobPageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["BonusBannerUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	tiles?: ValueTypes["TileUniqueWhere"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BonusBannerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TileUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	ligthBoxMedia?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFilterUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	bannerJobsForm?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	noJobImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFilterUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["JobsFilterLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GeneralUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	cornerBanner?: ValueTypes["CornerBannerUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["CornerBannerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoBoxUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["InfoBoxUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["InfoBoxLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["TranslationUniqueWhere"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: ValueTypes["TranslationLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByTermsAndConditionsUniqueWhere"]: {
	termsAndConditions?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByBannerImageUniqueWhere"]: {
	bannerImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByBannerLinkUniqueWhere"]: {
	bannerLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByJobsFormUniqueWhere"]: {
	jobsForm?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByCopyrightLinkUniqueWhere"]: {
	copyrightLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByRecommendationFormUniqueWhere"]: {
	recommendationForm?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByBannerSecondLinkUniqueWhere"]: {
	bannerSecondLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocalesByInstagramLinkUniqueWhere"]: {
	instagramLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PageInfo"]: AliasType<{
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleEdge"]: AliasType<{
	node?:ValueTypes["FooterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLink"]: AliasType<{
	_meta?:ValueTypes["FooterLinkMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	externalLink?:boolean | `@${string}`,
internalLink?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
	anchorLink?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	internalLink?:ValueTypes["FieldMeta"],
	anchorLink?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
redirect?: [{	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>},ValueTypes["Redirect"]],
genericPage?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
businessPage?: [{	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
jobPage?: [{	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
homePage?: [{	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
homePageLokal?: [{	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	redirect?:ValueTypes["FieldMeta"],
	genericPage?:ValueTypes["FieldMeta"],
	businessPage?:ValueTypes["FieldMeta"],
	jobPage?:ValueTypes["FieldMeta"],
	homePage?:ValueTypes["FieldMeta"],
	homePageLokal?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Redirect"]: AliasType<{
	_meta?:ValueTypes["RedirectMeta"],
	id?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
target?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["RedirectMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocale"]: AliasType<{
	_meta?:ValueTypes["GenericPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
	text?:boolean | `@${string}`,
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPage"]: AliasType<{
	_meta?:ValueTypes["GenericPageMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
theme?: [{	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>},ValueTypes["Theme"]],
	headerColor?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["GenericPageLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
localesByContent?: [{	by: ValueTypes["GenericPageLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
localesBySeo?: [{	by: ValueTypes["GenericPageLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
localesByLink?: [{	by: ValueTypes["GenericPageLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
localesByLogo?: [{	by: ValueTypes["GenericPageLocalesByLogoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
localesByImage?: [{	by: ValueTypes["GenericPageLocalesByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	theme?:ValueTypes["FieldMeta"],
	headerColor?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Theme"]: AliasType<{
	_meta?:ValueTypes["ThemeMeta"],
	id?:boolean | `@${string}`,
	backgroundColor?:boolean | `@${string}`,
	textColor?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	buttonBackgroundColor?:boolean | `@${string}`,
	buttonTextColor?:boolean | `@${string}`,
	buttonBackgroundHoverColor?:boolean | `@${string}`,
	buttonTextHoverColor?:boolean | `@${string}`,
	buttonBorderColor?:boolean | `@${string}`,
	buttonBorderHoverColor?:boolean | `@${string}`,
	headerMenuColor?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ThemeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	backgroundColor?:ValueTypes["FieldMeta"],
	textColor?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	buttonBackgroundColor?:ValueTypes["FieldMeta"],
	buttonTextColor?:ValueTypes["FieldMeta"],
	buttonBackgroundHoverColor?:ValueTypes["FieldMeta"],
	buttonTextHoverColor?:ValueTypes["FieldMeta"],
	buttonBorderColor?:ValueTypes["FieldMeta"],
	buttonBorderHoverColor?:ValueTypes["FieldMeta"],
	headerMenuColor?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocalesByLogoUniqueWhere"]: {
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocalesByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GenericPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["GenericPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Content"]: AliasType<{
	_meta?:ValueTypes["ContentMeta"],
	id?:boolean | `@${string}`,
blocks?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
blocksByReferences?: [{	by: ValueTypes["ContentBlocksByReferencesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
paginateBlocks?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlockConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	json?:boolean | `@${string}`,
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
references?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByLinkables?: [{	by: ValueTypes["ContentBlockReferencesByLinkablesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByLink?: [{	by: ValueTypes["ContentBlockReferencesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
referencesByMedia?: [{	by: ValueTypes["ContentBlockReferencesByMediaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
paginateReferences?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReference"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	primaryText?:boolean | `@${string}`,
block?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
linkables?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
	secondaryText?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
media?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
textList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextList"]],
carousel?: [{	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["Carousel"]],
bonusBanner?: [{	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
sideBySide?: [{	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySide"]],
gallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>},ValueTypes["Gallery"]],
	showBoolean?:boolean | `@${string}`,
	isRed?:boolean | `@${string}`,
video?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Video"]],
linkablesByItem?: [{	by: ValueTypes["ContentReferenceLinkablesByItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
paginateLinkables?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	primaryText?:ValueTypes["FieldMeta"],
	block?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	linkables?:ValueTypes["FieldMeta"],
	secondaryText?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	media?:ValueTypes["FieldMeta"],
	textList?:ValueTypes["FieldMeta"],
	carousel?:ValueTypes["FieldMeta"],
	bonusBanner?:ValueTypes["FieldMeta"],
	sideBySide?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	showBoolean?:ValueTypes["FieldMeta"],
	isRed?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	alt?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	focalPointX?:boolean | `@${string}`,
	focalPointY?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
	fileName?:ValueTypes["FieldMeta"],
	focalPointX?:ValueTypes["FieldMeta"],
	focalPointY?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItem"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceLinkableItemMeta"],
	id?:boolean | `@${string}`,
item?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
reference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
	reference?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	item?: ValueTypes["LinkableOrderBy"] | undefined | null | Variable<any, string>,
	reference?: ValueTypes["ContentReferenceOrderBy"] | undefined | null | Variable<any, string>
};
	["ContentReferenceOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	primaryText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	block?: ValueTypes["ContentBlockOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	secondaryText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["MediumListOrderBy"] | undefined | null | Variable<any, string>,
	textList?: ValueTypes["TextListOrderBy"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["CarouselOrderBy"] | undefined | null | Variable<any, string>,
	bonusBanner?: ValueTypes["BonusBannerLocaleOrderBy"] | undefined | null | Variable<any, string>,
	sideBySide?: ValueTypes["SideBySideOrderBy"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["GalleryOrderBy"] | undefined | null | Variable<any, string>,
	showBoolean?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isRed?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoOrderBy"] | undefined | null | Variable<any, string>
};
	["ContentBlockOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	json?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentOrderBy"] | undefined | null | Variable<any, string>
};
	["MediumListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["TextListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["CarouselOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	background?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	squareImages?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["BonusBannerOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	bannerName?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["BonusBannerOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["SideBySideOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	background?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	alignment?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	mediumSize?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["VideoOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	src?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	width?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	height?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	videoInfo?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	duration?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	poster?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["MediumList"]: AliasType<{
	_meta?:ValueTypes["MediumListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItem"]],
paginateItems?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItem"]: AliasType<{
	_meta?:ValueTypes["MediumItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
medium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>},ValueTypes["Medium"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Medium"]: AliasType<{
	_meta?:ValueTypes["MediumMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
video?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Video"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Video"]: AliasType<{
	_meta?:ValueTypes["VideoMeta"],
	id?:boolean | `@${string}`,
	src?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	videoInfo?:boolean | `@${string}`,
	duration?:boolean | `@${string}`,
poster?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["VideoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	src?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	videoInfo?:ValueTypes["FieldMeta"],
	duration?:ValueTypes["FieldMeta"],
	poster?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["MediumListOrderBy"] | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumOrderBy"] | undefined | null | Variable<any, string>
};
	["MediumOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoOrderBy"] | undefined | null | Variable<any, string>
};
	["MediumItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemEdge"]: AliasType<{
	node?:ValueTypes["MediumItem"],
		__typename?: boolean | `@${string}`
}>;
	["TextList"]: AliasType<{
	_meta?:ValueTypes["TextListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TextItem"]],
paginateItems?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TextItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TextListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextItem"]: AliasType<{
	_meta?:ValueTypes["TextItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextList"]],
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TextItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["TextListOrderBy"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["TextItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemEdge"]: AliasType<{
	node?:ValueTypes["TextItem"],
		__typename?: boolean | `@${string}`
}>;
	["Carousel"]: AliasType<{
	_meta?:ValueTypes["CarouselMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CarouselItem"]],
	background?:boolean | `@${string}`,
	squareImages?:boolean | `@${string}`,
itemsByImage?: [{	by: ValueTypes["CarouselItemsByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CarouselItem"]],
itemsByLinkUrl?: [{	by: ValueTypes["CarouselItemsByLinkUrlUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CarouselItem"]],
itemsByVideo?: [{	by: ValueTypes["CarouselItemsByVideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CarouselItem"]],
paginateItems?: [{	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CarouselItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CarouselMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	background?:ValueTypes["FieldMeta"],
	squareImages?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItem"]: AliasType<{
	_meta?:ValueTypes["CarouselItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["Carousel"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	name?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
linkUrl?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
	normalAspectRatio?:boolean | `@${string}`,
	isImage?:boolean | `@${string}`,
video?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Video"]],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	linkUrl?:ValueTypes["FieldMeta"],
	normalAspectRatio?:ValueTypes["FieldMeta"],
	isImage?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["CarouselOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	linkUrl?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	normalAspectRatio?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isImage?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoOrderBy"] | undefined | null | Variable<any, string>
};
	["CarouselItemsByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["CarouselItemsByLinkUrlUniqueWhere"]: {
	linkUrl?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["CarouselItemsByVideoUniqueWhere"]: {
	video?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["VideoUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["CarouselItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CarouselItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemEdge"]: AliasType<{
	node?:ValueTypes["CarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocale"]: AliasType<{
	_meta?:ValueTypes["BonusBannerLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBanner"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
tiles?: [{	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Tile"]],
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	bannerName?:boolean | `@${string}`,
tilesByImage?: [{	by: ValueTypes["BonusBannerLocaleTilesByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>},ValueTypes["Tile"]],
tilesByLigthBoxMedia?: [{	by: ValueTypes["BonusBannerLocaleTilesByLigthBoxMediaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>},ValueTypes["Tile"]],
paginateTiles?: [{	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TileConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	tiles?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	bannerName?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBanner"]: AliasType<{
	_meta?:ValueTypes["BonusBannerMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
localesByLocale?: [{	by: ValueTypes["BonusBannerLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
localesByTiles?: [{	by: ValueTypes["BonusBannerLocalesByTilesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
localesByLogo?: [{	by: ValueTypes["BonusBannerLocalesByLogoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
paginateLocales?: [{	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BonusBannerLocalesByTilesUniqueWhere"]: {
	tiles?: ValueTypes["TileUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BonusBannerLocalesByLogoUniqueWhere"]: {
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BonusBannerLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleEdge"]: AliasType<{
	node?:ValueTypes["BonusBannerLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Tile"]: AliasType<{
	_meta?:ValueTypes["TileMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
bonusBanner?: [{	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	lightBoxTitle?:boolean | `@${string}`,
	lightBoxText?:boolean | `@${string}`,
ligthBoxMedia?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
	lightBoxSectionTitle?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	lightBoxLinkLabel?:boolean | `@${string}`,
lightBoxForm?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
		__typename?: boolean | `@${string}`
}>;
	["TileMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	bonusBanner?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	lightBoxTitle?:ValueTypes["FieldMeta"],
	lightBoxText?:ValueTypes["FieldMeta"],
	ligthBoxMedia?:ValueTypes["FieldMeta"],
	lightBoxSectionTitle?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	lightBoxLinkLabel?:ValueTypes["FieldMeta"],
	lightBoxForm?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocale"]: AliasType<{
	_meta?:ValueTypes["JobsFormLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	jobText?:boolean | `@${string}`,
	genericText?:boolean | `@${string}`,
	nameLabel?:boolean | `@${string}`,
	emailLabel?:boolean | `@${string}`,
	telefonLabel?:boolean | `@${string}`,
	fileTitleLabel?:boolean | `@${string}`,
	fileFormatLabel?:boolean | `@${string}`,
	formTextLabel?:boolean | `@${string}`,
	submitLabel?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsForm"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
imageTextList?: [{	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextList"]],
	minimalize?:boolean | `@${string}`,
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	successTitle?:boolean | `@${string}`,
	successText?:boolean | `@${string}`,
	successBtnLabel?:boolean | `@${string}`,
successImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	successOtherJobsTitle?:boolean | `@${string}`,
	successOtherJobsCategoryTitle?:boolean | `@${string}`,
	successOtherJobsButtonTitle?:boolean | `@${string}`,
	successOtherJobsSelectionTitle?:boolean | `@${string}`,
	successOtherJobsSelectionYesButton?:boolean | `@${string}`,
	successOtherJobsSelectionNoButton?:boolean | `@${string}`,
	fileRemoveBtnLabel?:boolean | `@${string}`,
	gdprLabel?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	jobText?:ValueTypes["FieldMeta"],
	genericText?:ValueTypes["FieldMeta"],
	nameLabel?:ValueTypes["FieldMeta"],
	emailLabel?:ValueTypes["FieldMeta"],
	telefonLabel?:ValueTypes["FieldMeta"],
	fileTitleLabel?:ValueTypes["FieldMeta"],
	fileFormatLabel?:ValueTypes["FieldMeta"],
	formTextLabel?:ValueTypes["FieldMeta"],
	submitLabel?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	imageTextList?:ValueTypes["FieldMeta"],
	minimalize?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	successTitle?:ValueTypes["FieldMeta"],
	successText?:ValueTypes["FieldMeta"],
	successBtnLabel?:ValueTypes["FieldMeta"],
	successImage?:ValueTypes["FieldMeta"],
	successOtherJobsTitle?:ValueTypes["FieldMeta"],
	successOtherJobsCategoryTitle?:ValueTypes["FieldMeta"],
	successOtherJobsButtonTitle?:ValueTypes["FieldMeta"],
	successOtherJobsSelectionTitle?:ValueTypes["FieldMeta"],
	successOtherJobsSelectionYesButton?:ValueTypes["FieldMeta"],
	successOtherJobsSelectionNoButton?:ValueTypes["FieldMeta"],
	fileRemoveBtnLabel?:ValueTypes["FieldMeta"],
	gdprLabel?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobsForm"]: AliasType<{
	_meta?:ValueTypes["JobsFormMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
fileIlustration?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
localesByLocale?: [{	by: ValueTypes["JobsFormLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
localesByImageTextList?: [{	by: ValueTypes["JobsFormLocalesByImageTextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
localesByLogo?: [{	by: ValueTypes["JobsFormLocalesByLogoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
localesBySuccessImage?: [{	by: ValueTypes["JobsFormLocalesBySuccessImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
paginateLocales?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	fileIlustration?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFormLocalesByImageTextListUniqueWhere"]: {
	imageTextList?: ValueTypes["ImageTextListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFormLocalesByLogoUniqueWhere"]: {
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFormLocalesBySuccessImageUniqueWhere"]: {
	successImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFormLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobsFormLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleEdge"]: AliasType<{
	node?:ValueTypes["JobsFormLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextList"]: AliasType<{
	_meta?:ValueTypes["ImageTextListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageTextItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageTextItem"]],
itemsByImage?: [{	by: ValueTypes["ImageTextListItemsByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextItem"]],
paginateItems?: [{	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageTextItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageTextItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItem"]: AliasType<{
	_meta?:ValueTypes["ImageTextItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextList"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageTextListOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["ImageTextListItemsByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ImageTextItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageTextItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemEdge"]: AliasType<{
	node?:ValueTypes["ImageTextItem"],
		__typename?: boolean | `@${string}`
}>;
	["TileOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	bonusBanner?: ValueTypes["BonusBannerLocaleOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	lightBoxTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	lightBoxText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	ligthBoxMedia?: ValueTypes["MediumListOrderBy"] | undefined | null | Variable<any, string>,
	lightBoxSectionTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	lightBoxLinkLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	lightBoxForm?: ValueTypes["JobsFormLocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleTilesByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleTilesByLigthBoxMediaUniqueWhere"]: {
	ligthBoxMedia?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TileConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TileEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TileEdge"]: AliasType<{
	node?:ValueTypes["Tile"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySide"]: AliasType<{
	_meta?:ValueTypes["SideBySideMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SideBySideItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SideBySideItem"]],
	background?:boolean | `@${string}`,
	alignment?:boolean | `@${string}`,
	mediumSize?:boolean | `@${string}`,
itemsByMedia?: [{	by: ValueTypes["SideBySideItemsByMediaUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySideItem"]],
paginateItems?: [{	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SideBySideItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SideBySideItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	background?:ValueTypes["FieldMeta"],
	alignment?:ValueTypes["FieldMeta"],
	mediumSize?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItem"]: AliasType<{
	_meta?:ValueTypes["SideBySideItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySide"]],
media?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
	formButtonLabel?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
jobsForm?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
	textNew?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	media?:ValueTypes["FieldMeta"],
	formButtonLabel?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	jobsForm?:ValueTypes["FieldMeta"],
	textNew?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["SideBySideOrderBy"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["MediumListOrderBy"] | undefined | null | Variable<any, string>,
	formButtonLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["JobsFormLocaleOrderBy"] | undefined | null | Variable<any, string>,
	textNew?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["SideBySideItemsByMediaUniqueWhere"]: {
	media?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SideBySideItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SideBySideItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemEdge"]: AliasType<{
	node?:ValueTypes["SideBySideItem"],
		__typename?: boolean | `@${string}`
}>;
	["Gallery"]: AliasType<{
	_meta?:ValueTypes["GalleryMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GalleryItem"]],
itemsByImage?: [{	by: ValueTypes["GalleryItemsByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["GalleryItem"]],
paginateItems?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GalleryItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GalleryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItem"]: AliasType<{
	_meta?:ValueTypes["GalleryItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>},ValueTypes["Gallery"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["GalleryOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["GalleryItemsByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GalleryItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemEdge"]: AliasType<{
	node?:ValueTypes["GalleryItem"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkablesByItemUniqueWhere"]: {
	item?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceLinkableItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceLinkableItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemEdge"]: AliasType<{
	node?:ValueTypes["ContentReferenceLinkableItem"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockReferencesByLinkablesUniqueWhere"]: {
	linkables?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockReferencesByMediaUniqueWhere"]: {
	media?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["ContentReference"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: boolean | `@${string}`
}>;
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	ogTitle?:boolean | `@${string}`,
	ogDescription?:boolean | `@${string}`,
	noIndex?:boolean | `@${string}`,
	noFollow?:boolean | `@${string}`,
ogImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	noIndex?:ValueTypes["FieldMeta"],
	noFollow?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocale"]: AliasType<{
	_meta?:ValueTypes["BusinessPageLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
	subtitle?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
stickyBar?: [{	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>},ValueTypes["StickyBar"]],
infoBox?: [{	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBox"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	stickyBar?:ValueTypes["FieldMeta"],
	infoBox?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPage"]: AliasType<{
	_meta?:ValueTypes["BusinessPageMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
theme?: [{	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>},ValueTypes["Theme"]],
	isLokal?:boolean | `@${string}`,
	tabidooId?:boolean | `@${string}`,
	headerColor?:boolean | `@${string}`,
	recruitisOfficeId?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["BusinessPageLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
localesByContent?: [{	by: ValueTypes["BusinessPageLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
localesBySeo?: [{	by: ValueTypes["BusinessPageLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
localesByLink?: [{	by: ValueTypes["BusinessPageLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
localesByImage?: [{	by: ValueTypes["BusinessPageLocalesByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	theme?:ValueTypes["FieldMeta"],
	isLokal?:ValueTypes["FieldMeta"],
	tabidooId?:ValueTypes["FieldMeta"],
	headerColor?:ValueTypes["FieldMeta"],
	recruitisOfficeId?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocalesByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["BusinessPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBar"]: AliasType<{
	_meta?:ValueTypes["StickyBarMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
	formButtonLabel?:boolean | `@${string}`,
jobsForm?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	formButtonLabel?:ValueTypes["FieldMeta"],
	jobsForm?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBox"]: AliasType<{
	_meta?:ValueTypes["InfoBoxMeta"],
	id?:boolean | `@${string}`,
	logoSize?:boolean | `@${string}`,
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
locales?: [{	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocale"]],
localesByLocale?: [{	by: ValueTypes["InfoBoxLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocale"]],
paginateLocales?: [{	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	logoSize?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocale"]: AliasType<{
	_meta?:ValueTypes["InfoBoxLocaleMeta"],
	id?:boolean | `@${string}`,
	address?:boolean | `@${string}`,
	web?:boolean | `@${string}`,
	instagram?:boolean | `@${string}`,
	facebook?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBox"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
openingHours?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextList"]],
	addressLink?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	web?:ValueTypes["FieldMeta"],
	instagram?:ValueTypes["FieldMeta"],
	facebook?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	openingHours?:ValueTypes["FieldMeta"],
	addressLink?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	address?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	web?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	instagram?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	facebook?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoBoxOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	openingHours?: ValueTypes["TextListOrderBy"] | undefined | null | Variable<any, string>,
	addressLink?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["InfoBoxLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InfoBoxLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleEdge"]: AliasType<{
	node?:ValueTypes["InfoBoxLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocale"]: AliasType<{
	_meta?:ValueTypes["JobPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
keyInfo?: [{	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>},ValueTypes["KeyInfoList"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
	email?:boolean | `@${string}`,
stickyBar?: [{	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>},ValueTypes["StickyBar"]],
mobileImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	isSyncedToTabidoo?:boolean | `@${string}`,
	tabidooId?:boolean | `@${string}`,
	recruitisJobId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	keyInfo?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	stickyBar?:ValueTypes["FieldMeta"],
	mobileImage?:ValueTypes["FieldMeta"],
	isSyncedToTabidoo?:ValueTypes["FieldMeta"],
	tabidooId?:ValueTypes["FieldMeta"],
	recruitisJobId?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobPage"]: AliasType<{
	_meta?:ValueTypes["JobPageMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
theme?: [{	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>},ValueTypes["Theme"]],
contractType?: [{	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractType"]],
jobCity?: [{	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCity"]],
	isActive?:boolean | `@${string}`,
jobPosition?: [{	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPosition"]],
	publishedAt?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	isSyncedToTabidoo?:boolean | `@${string}`,
business?: [{	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPage"]],
	headerColor?:boolean | `@${string}`,
	siteType?:boolean | `@${string}`,
	isHiddenFromListing?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["JobPageLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
localesByImage?: [{	by: ValueTypes["JobPageLocalesByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
localesByKeyInfo?: [{	by: ValueTypes["JobPageLocalesByKeyInfoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
localesByContent?: [{	by: ValueTypes["JobPageLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
localesBySeo?: [{	by: ValueTypes["JobPageLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
localesByLink?: [{	by: ValueTypes["JobPageLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
localesByMobileImage?: [{	by: ValueTypes["JobPageLocalesByMobileImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["JobPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	theme?:ValueTypes["FieldMeta"],
	contractType?:ValueTypes["FieldMeta"],
	jobCity?:ValueTypes["FieldMeta"],
	isActive?:ValueTypes["FieldMeta"],
	jobPosition?:ValueTypes["FieldMeta"],
	publishedAt?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	isSyncedToTabidoo?:ValueTypes["FieldMeta"],
	business?:ValueTypes["FieldMeta"],
	headerColor?:ValueTypes["FieldMeta"],
	siteType?:ValueTypes["FieldMeta"],
	isHiddenFromListing?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContractType"]: AliasType<{
	_meta?:ValueTypes["ContractTypeMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocale"]],
localesByLocale?: [{	by: ValueTypes["ContractTypeLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocale"]],
paginateLocales?: [{	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocale"]: AliasType<{
	_meta?:ValueTypes["ContractTypeLocaleMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractType"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["ContractTypeOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	slug?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ContractTypeLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContractTypeLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleEdge"]: AliasType<{
	node?:ValueTypes["ContractTypeLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobCity"]: AliasType<{
	_meta?:ValueTypes["JobCityMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobCityLocale"]],
localesByLocale?: [{	by: ValueTypes["JobCityLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCityLocale"]],
paginateLocales?: [{	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobCityLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["JobCityMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocale"]: AliasType<{
	_meta?:ValueTypes["JobCityLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCity"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
	name?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobCityOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	slug?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["JobCityLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobCityLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobCityLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleEdge"]: AliasType<{
	node?:ValueTypes["JobCityLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobPosition"]: AliasType<{
	_meta?:ValueTypes["JobPositionMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocale"]],
jobs?: [{	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPage"]],
localesByLocale?: [{	by: ValueTypes["JobPositionLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocale"]],
jobsByLocales?: [{	by: ValueTypes["JobPositionJobsByLocalesUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPage"]],
paginateLocales?: [{	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocaleConnection"]],
paginateJobs?: [{	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	jobs?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocale"]: AliasType<{
	_meta?:ValueTypes["JobPositionLocaleMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPosition"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPositionOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	slug?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["JobPositionLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPositionJobsByLocalesUniqueWhere"]: {
	locales?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPositionLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobPositionLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleEdge"]: AliasType<{
	node?:ValueTypes["JobPositionLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageEdge"]: AliasType<{
	node?:ValueTypes["JobPage"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPageLocalesByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPageLocalesByKeyInfoUniqueWhere"]: {
	keyInfo?: ValueTypes["KeyInfoListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPageLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPageLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPageLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPageLocalesByMobileImageUniqueWhere"]: {
	mobileImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["JobPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoList"]: AliasType<{
	_meta?:ValueTypes["KeyInfoListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["KeyInfoItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["KeyInfoItem"]],
paginateItems?: [{	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["KeyInfoItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["KeyInfoItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItem"]: AliasType<{
	_meta?:ValueTypes["KeyInfoItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	keyInfo?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>},ValueTypes["KeyInfoList"]],
icon?: [{	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>},ValueTypes["Icon"]],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	keyInfo?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Icon"]: AliasType<{
	_meta?:ValueTypes["IconMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
icon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["IconMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["KeyInfoListOrderBy"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["IconOrderBy"] | undefined | null | Variable<any, string>
};
	["IconOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["KeyInfoItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["KeyInfoItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemEdge"]: AliasType<{
	node?:ValueTypes["KeyInfoItem"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocale"]: AliasType<{
	_meta?:ValueTypes["HomePageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
button?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
siteSwitcher?: [{	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>},ValueTypes["SiteSwitcher"]],
gallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>},ValueTypes["Gallery"]],
stickyBar?: [{	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>},ValueTypes["StickyBar"]],
	text?:boolean | `@${string}`,
ilustration?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>},ValueTypes["Gallery"]],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	button?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	siteSwitcher?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	stickyBar?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	ilustration?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HomePage"]: AliasType<{
	_meta?:ValueTypes["HomePageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
theme?: [{	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>},ValueTypes["Theme"]],
localesByLocale?: [{	by: ValueTypes["HomePageLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
localesByButton?: [{	by: ValueTypes["HomePageLocalesByButtonUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
localesByContent?: [{	by: ValueTypes["HomePageLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
localesBySeo?: [{	by: ValueTypes["HomePageLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
localesByLink?: [{	by: ValueTypes["HomePageLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
localesByLogo?: [{	by: ValueTypes["HomePageLocalesByLogoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
localesBySiteSwitcher?: [{	by: ValueTypes["HomePageLocalesBySiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
localesByIlustration?: [{	by: ValueTypes["HomePageLocalesByIlustrationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HomePageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	theme?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLocalesByButtonUniqueWhere"]: {
	button?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLocalesByLogoUniqueWhere"]: {
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLocalesBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ValueTypes["SiteSwitcherUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLocalesByIlustrationUniqueWhere"]: {
	ilustration?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleEdge"]: AliasType<{
	node?:ValueTypes["HomePageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcher"]: AliasType<{
	_meta?:ValueTypes["SiteSwitcherMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
theme?: [{	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>},ValueTypes["Theme"]],
	headerColor?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	theme?:ValueTypes["FieldMeta"],
	headerColor?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocale"]: AliasType<{
	_meta?:ValueTypes["HomePageLokalLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokal"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
button?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
siteSwitcher?: [{	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>},ValueTypes["SiteSwitcher"]],
gallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>},ValueTypes["Gallery"]],
stickyBar?: [{	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>},ValueTypes["StickyBar"]],
	text?:boolean | `@${string}`,
ilustration?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>},ValueTypes["Gallery"]],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	button?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	siteSwitcher?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	stickyBar?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	ilustration?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokal"]: AliasType<{
	_meta?:ValueTypes["HomePageLokalMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
theme?: [{	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>},ValueTypes["Theme"]],
localesByLocale?: [{	by: ValueTypes["HomePageLokalLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
localesByLogo?: [{	by: ValueTypes["HomePageLokalLocalesByLogoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
localesByButton?: [{	by: ValueTypes["HomePageLokalLocalesByButtonUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
localesByContent?: [{	by: ValueTypes["HomePageLokalLocalesByContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
localesBySeo?: [{	by: ValueTypes["HomePageLokalLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
localesByLink?: [{	by: ValueTypes["HomePageLokalLocalesByLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
localesBySiteSwitcher?: [{	by: ValueTypes["HomePageLokalLocalesBySiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
localesByIlustration?: [{	by: ValueTypes["HomePageLokalLocalesByIlustrationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
paginateLocales?: [{	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	theme?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocalesByLogoUniqueWhere"]: {
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocalesByButtonUniqueWhere"]: {
	button?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocalesBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ValueTypes["SiteSwitcherUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocalesByIlustrationUniqueWhere"]: {
	ilustration?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageLokalLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleEdge"]: AliasType<{
	node?:ValueTypes["HomePageLokalLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>
};
	["RecommendationFormLocale"]: AliasType<{
	_meta?:ValueTypes["RecommendationFormLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
	yourEmailLabel?:boolean | `@${string}`,
	theirEmailLabel?:boolean | `@${string}`,
	yourName?:boolean | `@${string}`,
	sendBtnLabel?:boolean | `@${string}`,
	successTitle?:boolean | `@${string}`,
	successSubtitle?:boolean | `@${string}`,
	successButtonClose?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationForm"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	yourEmailLabel?:ValueTypes["FieldMeta"],
	theirEmailLabel?:ValueTypes["FieldMeta"],
	yourName?:ValueTypes["FieldMeta"],
	sendBtnLabel?:ValueTypes["FieldMeta"],
	successTitle?:ValueTypes["FieldMeta"],
	successSubtitle?:ValueTypes["FieldMeta"],
	successButtonClose?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationForm"]: AliasType<{
	_meta?:ValueTypes["RecommendationFormMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocale"]],
successImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
localesByLocale?: [{	by: ValueTypes["RecommendationFormLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocale"]],
paginateLocales?: [{	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	successImage?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RecommendationFormLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleEdge"]: AliasType<{
	node?:ValueTypes["RecommendationFormLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterLinkEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkEdge"]: AliasType<{
	node?:ValueTypes["FooterLink"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocale"]: AliasType<{
	_meta?:ValueTypes["HeaderLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>},ValueTypes["Header"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
	menuLabel?:boolean | `@${string}`,
	menuTitle?:boolean | `@${string}`,
	menuText?:boolean | `@${string}`,
business?: [{	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Business"]],
lokalEnterprise?: [{	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Business"]],
	businessSectionTitle?:boolean | `@${string}`,
	lokalSectionTitle?:boolean | `@${string}`,
businessLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
lokalLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
paginateBusiness?: [{	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessConnection"]],
paginateLokalEnterprise?: [{	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	menuLabel?:ValueTypes["FieldMeta"],
	menuTitle?:ValueTypes["FieldMeta"],
	menuText?:ValueTypes["FieldMeta"],
	business?:ValueTypes["FieldMeta"],
	lokalEnterprise?:ValueTypes["FieldMeta"],
	businessSectionTitle?:ValueTypes["FieldMeta"],
	lokalSectionTitle?:ValueTypes["FieldMeta"],
	businessLink?:ValueTypes["FieldMeta"],
	lokalLink?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Header"]: AliasType<{
	_meta?:ValueTypes["HeaderMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
logoMenu?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
localesByLocale?: [{	by: ValueTypes["HeaderLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
localesByBusinessLink?: [{	by: ValueTypes["HeaderLocalesByBusinessLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
localesByLokalLink?: [{	by: ValueTypes["HeaderLocalesByLokalLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
paginateLocales?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HeaderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	logoMenu?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HeaderOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	menuLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	menuTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	menuText?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	businessSectionTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	lokalSectionTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	businessLink?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>,
	lokalLink?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>
};
	["HeaderOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	logoMenu?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HeaderLocalesByBusinessLinkUniqueWhere"]: {
	businessLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HeaderLocalesByLokalLinkUniqueWhere"]: {
	lokalLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["HeaderLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleEdge"]: AliasType<{
	node?:ValueTypes["HeaderLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Business"]: AliasType<{
	_meta?:ValueTypes["BusinessMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>
};
	["BusinessConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessEdge"]: AliasType<{
	node?:ValueTypes["Business"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocale"]: AliasType<{
	_meta?:ValueTypes["SeoDefaultLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefault"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefault"]: AliasType<{
	_meta?:ValueTypes["SeoDefaultMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocale"]],
localesByLocale?: [{	by: ValueTypes["SeoDefaultLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocale"]],
localesBySeo?: [{	by: ValueTypes["SeoDefaultLocalesBySeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocale"]],
paginateLocales?: [{	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["SeoDefaultOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>
};
	["SeoDefaultOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["SeoDefaultLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SeoDefaultLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoDefaultLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleEdge"]: AliasType<{
	node?:ValueTypes["SeoDefaultLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocale"]: AliasType<{
	_meta?:ValueTypes["JobsFilterLocaleMeta"],
	id?:boolean | `@${string}`,
	jobPositionLabel?:boolean | `@${string}`,
	jobContractLabel?:boolean | `@${string}`,
	jobCityLabel?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilter"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
	bannerTitle?:boolean | `@${string}`,
	bannerFormLabel?:boolean | `@${string}`,
bannerJobsForm?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
bannerImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	noJobTitle?:boolean | `@${string}`,
	noJobBtnLabel?:boolean | `@${string}`,
noJobImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
	noJobTitleForSpecificBusiness?:boolean | `@${string}`,
	deactivatedJob?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	jobPositionLabel?:ValueTypes["FieldMeta"],
	jobContractLabel?:ValueTypes["FieldMeta"],
	jobCityLabel?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	bannerTitle?:ValueTypes["FieldMeta"],
	bannerFormLabel?:ValueTypes["FieldMeta"],
	bannerJobsForm?:ValueTypes["FieldMeta"],
	bannerImage?:ValueTypes["FieldMeta"],
	noJobTitle?:ValueTypes["FieldMeta"],
	noJobBtnLabel?:ValueTypes["FieldMeta"],
	noJobImage?:ValueTypes["FieldMeta"],
	noJobTitleForSpecificBusiness?:ValueTypes["FieldMeta"],
	deactivatedJob?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilter"]: AliasType<{
	_meta?:ValueTypes["JobsFilterMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
localesByLocale?: [{	by: ValueTypes["JobsFilterLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
localesByBannerJobsForm?: [{	by: ValueTypes["JobsFilterLocalesByBannerJobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
localesByBannerImage?: [{	by: ValueTypes["JobsFilterLocalesByBannerImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
localesByNoJobImage?: [{	by: ValueTypes["JobsFilterLocalesByNoJobImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
paginateLocales?: [{	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	jobPositionLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	jobContractLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	jobCityLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFilterOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	bannerTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	bannerFormLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	bannerJobsForm?: ValueTypes["JobsFormLocaleOrderBy"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	noJobTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	noJobBtnLabel?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	noJobImage?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	noJobTitleForSpecificBusiness?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	deactivatedJob?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["JobsFilterOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["JobsFilterLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFilterLocalesByBannerJobsFormUniqueWhere"]: {
	bannerJobsForm?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFilterLocalesByBannerImageUniqueWhere"]: {
	bannerImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFilterLocalesByNoJobImageUniqueWhere"]: {
	noJobImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobsFilterLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleEdge"]: AliasType<{
	node?:ValueTypes["JobsFilterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GeneralOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null | Variable<any, string>,
	cornerBanner?: ValueTypes["CornerBannerOrderBy"] | undefined | null | Variable<any, string>
};
	["GeneralOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["CornerBannerOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isActive?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	title?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	text?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkOrderBy"] | undefined | null | Variable<any, string>
};
	["TranslationLocale"]: AliasType<{
	_meta?:ValueTypes["TranslationLocaleMeta"],
	id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>},ValueTypes["Translation"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Translation"]: AliasType<{
	_meta?:ValueTypes["TranslationMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationLocale"]],
	isTextarea?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["TranslationLocalesByLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationLocale"]],
paginateLocales?: [{	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	key?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	isTextarea?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	value?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["TranslationOrderBy"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null | Variable<any, string>
};
	["TranslationOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	key?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isTextarea?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["TranslationLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TranslationLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleEdge"]: AliasType<{
	node?:ValueTypes["TranslationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleFootersByRootUniqueWhere"]: {
	root?: ValueTypes["FooterUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByTermsAndConditionsUniqueWhere"]: {
	termsAndConditions?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByBannerImageUniqueWhere"]: {
	bannerImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByBannerLinkUniqueWhere"]: {
	bannerLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByJobsFormUniqueWhere"]: {
	jobsForm?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByCopyrightLinkUniqueWhere"]: {
	copyrightLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByRecommendationFormUniqueWhere"]: {
	recommendationForm?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByBannerSecondLinkUniqueWhere"]: {
	bannerSecondLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleFootersByInstagramLinkUniqueWhere"]: {
	instagramLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPagesByRootUniqueWhere"]: {
	root?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPagesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPagesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPagesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPagesByLogoUniqueWhere"]: {
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGenericPagesByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHeadersByRootUniqueWhere"]: {
	root?: ValueTypes["HeaderUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHeadersByBusinessLinkUniqueWhere"]: {
	businessLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHeadersByLokalLinkUniqueWhere"]: {
	lokalLink?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleSeoDefaultsByRootUniqueWhere"]: {
	root?: ValueTypes["SeoDefaultUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleSeoDefaultsBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleBusinessPagesByRootUniqueWhere"]: {
	root?: ValueTypes["BusinessPageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleBusinessPagesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleBusinessPagesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleBusinessPagesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleBusinessPagesByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobPagesByRootUniqueWhere"]: {
	root?: ValueTypes["JobPageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobPagesByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobPagesByKeyInfoUniqueWhere"]: {
	keyInfo?: ValueTypes["KeyInfoListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobPagesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobPagesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobPagesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobPagesByMobileImageUniqueWhere"]: {
	mobileImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleContractTypesByRootUniqueWhere"]: {
	root?: ValueTypes["ContractTypeUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleContractTypesBySlugUniqueWhere"]: {
	slug?: string | undefined | null | Variable<any, string>
};
	["LocaleJobCitiesByRootUniqueWhere"]: {
	root?: ValueTypes["JobCityUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobCitiesBySlugUniqueWhere"]: {
	slug?: string | undefined | null | Variable<any, string>
};
	["LocaleJobPositionsByRootUniqueWhere"]: {
	root?: ValueTypes["JobPositionUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobPositionsBySlugUniqueWhere"]: {
	slug?: string | undefined | null | Variable<any, string>
};
	["LocaleHomePagesByRootUniqueWhere"]: {
	root?: ValueTypes["HomePageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePagesByButtonUniqueWhere"]: {
	button?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePagesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePagesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePagesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePagesByLogoUniqueWhere"]: {
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePagesBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ValueTypes["SiteSwitcherUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePagesByIlustrationUniqueWhere"]: {
	ilustration?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleBonusBannersByRootUniqueWhere"]: {
	root?: ValueTypes["BonusBannerUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleBonusBannersByTilesUniqueWhere"]: {
	tiles?: ValueTypes["TileUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleBonusBannersByLogoUniqueWhere"]: {
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePageLokalsByRootUniqueWhere"]: {
	root?: ValueTypes["HomePageLokalUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePageLokalsByLogoUniqueWhere"]: {
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePageLokalsByButtonUniqueWhere"]: {
	button?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePageLokalsByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePageLokalsBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePageLokalsByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePageLokalsBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ValueTypes["SiteSwitcherUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleHomePageLokalsByIlustrationUniqueWhere"]: {
	ilustration?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobsFormsByRootUniqueWhere"]: {
	root?: ValueTypes["JobsFormUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobsFormsByImageTextListUniqueWhere"]: {
	imageTextList?: ValueTypes["ImageTextListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobsFormsByLogoUniqueWhere"]: {
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobsFormsBySuccessImageUniqueWhere"]: {
	successImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobsFiltersByRootUniqueWhere"]: {
	root?: ValueTypes["JobsFilterUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobsFiltersByBannerJobsFormUniqueWhere"]: {
	bannerJobsForm?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobsFiltersByBannerImageUniqueWhere"]: {
	bannerImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleJobsFiltersByNoJobImageUniqueWhere"]: {
	noJobImage?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGeneralByRootUniqueWhere"]: {
	root?: ValueTypes["GeneralUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGeneralBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleGeneralByCornerBannerUniqueWhere"]: {
	cornerBanner?: ValueTypes["CornerBannerUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleRecommendationFormsByRootUniqueWhere"]: {
	root?: ValueTypes["RecommendationFormUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleInfoBoxesByRootUniqueWhere"]: {
	root?: ValueTypes["InfoBoxUniqueWhere"] | undefined | null | Variable<any, string>
};
	["LocaleTranslationsByRootUniqueWhere"]: {
	root?: ValueTypes["TranslationUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GeneralLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleEdge"]: AliasType<{
	node?:ValueTypes["GeneralLocale"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBanner"]: AliasType<{
	_meta?:ValueTypes["CornerBannerMeta"],
	id?:boolean | `@${string}`,
	isActive?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	isActive?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralLocalesByCornerBannerUniqueWhere"]: {
	cornerBanner?: ValueTypes["CornerBannerUniqueWhere"] | undefined | null | Variable<any, string>
};
	["GeneralConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GeneralEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralEdge"]: AliasType<{
	node?:ValueTypes["General"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidationResult"]: AliasType<{
	valid?:boolean | `@${string}`,
	errors?:ValueTypes["_ValidationError"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: boolean | `@${string}`
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: boolean | `@${string}`
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:boolean | `@${string}`,
	alias?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_ValidationMessage"]: AliasType<{
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GeneralCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GeneralCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GeneralLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GeneralLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	cornerBanner?: ValueTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGeneralCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutGeneralCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateFootersEntityRelationInput"]: {
	connect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateFootersRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	address?: string | undefined | null | Variable<any, string>,
	ico?: string | undefined | null | Variable<any, string>,
	dic?: string | undefined | null | Variable<any, string>,
	copyright?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	noteSecond?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	linksFirstColumn?: Array<ValueTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	linksSecondColumn?: Array<ValueTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	termsAndConditions?: ValueTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined | null | Variable<any, string>,
	form?: string | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerSubtitle?: string | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerLink?: ValueTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	copyrightLink?: ValueTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondBtn?: string | undefined | null | Variable<any, string>,
	recommendationForm?: ValueTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondLink?: ValueTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	instagramLink?: ValueTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["FooterUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FooterWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FooterWithoutLocalesCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]: {
	connect?: ValueTypes["FooterLinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FooterLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FooterLinkUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["FooterLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	link?: ValueTypes["FooterLinkCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLinkCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLinkConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["LinkType"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	externalLink?: string | undefined | null | Variable<any, string>,
	internalLink?: ValueTypes["LinkCreateInternalLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	anchorLink?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreateRedirectEntityRelationInput"]: {
	connect?: ValueTypes["RedirectUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RedirectWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateRedirectRelationInput"] | undefined | null | Variable<any, string>
};
	["RedirectWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	target?: ValueTypes["RedirectCreateTargetEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RedirectCreateTargetEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RedirectConnectOrCreateTargetRelationInput"] | undefined | null | Variable<any, string>
};
	["RedirectConnectOrCreateTargetRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreateRedirectRelationInput"]: {
	connect: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RedirectWithoutLinkCreateInput"] | Variable<any, string>
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["GenericPageCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageCreateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>
};
	["ThemeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	backgroundColor?: string | undefined | null | Variable<any, string>,
	textColor?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	buttonBackgroundColor?: string | undefined | null | Variable<any, string>,
	buttonTextColor?: string | undefined | null | Variable<any, string>,
	buttonBackgroundHoverColor?: string | undefined | null | Variable<any, string>,
	buttonTextHoverColor?: string | undefined | null | Variable<any, string>,
	buttonBorderColor?: string | undefined | null | Variable<any, string>,
	buttonBorderHoverColor?: string | undefined | null | Variable<any, string>,
	headerMenuColor?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageConnectOrCreateThemeRelationInput"]: {
	connect: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGenericPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutGenericPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateHeadersEntityRelationInput"]: {
	connect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateHeadersRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	menuLabel?: string | undefined | null | Variable<any, string>,
	menuTitle?: string | undefined | null | Variable<any, string>,
	menuText?: string | undefined | null | Variable<any, string>,
	business?: Array<ValueTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined | null | Variable<any, string>,
	lokalEnterprise?: Array<ValueTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessSectionTitle?: string | undefined | null | Variable<any, string>,
	lokalSectionTitle?: string | undefined | null | Variable<any, string>,
	businessLink?: ValueTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	lokalLink?: ValueTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["HeaderUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeaderWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["HeaderWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HeaderCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	logoMenu?: ValueTypes["HeaderCreateLogoMenuEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	width?: number | undefined | null | Variable<any, string>,
	height?: number | undefined | null | Variable<any, string>,
	size?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	alt?: string | undefined | null | Variable<any, string>,
	fileName?: string | undefined | null | Variable<any, string>,
	focalPointX?: number | undefined | null | Variable<any, string>,
	focalPointY?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["HeaderCreateLogoMenuEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderConnectOrCreateLogoMenuRelationInput"] | undefined | null | Variable<any, string>
};
	["HeaderConnectOrCreateLogoMenuRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["HeaderLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HeaderWithoutLocalesCreateInput"] | Variable<any, string>
};
	["HeaderLocaleCreateBusinessEntityRelationInput"]: {
	connect?: ValueTypes["BusinessUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BusinessCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateBusinessRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["BusinessUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["BusinessCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	logo?: ValueTypes["BusinessCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["BusinessCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["BusinessConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["BusinessCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["BusinessConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["HeaderLocaleConnectOrCreateBusinessRelationInput"]: {
	connect: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BusinessCreateInput"] | Variable<any, string>
};
	["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]: {
	connect?: ValueTypes["BusinessUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BusinessCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"]: {
	connect: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BusinessCreateInput"] | Variable<any, string>
};
	["HeaderLocaleCreateBusinessLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["HeaderLocaleCreateLokalLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateLokalLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["HeaderLocaleConnectOrCreateLokalLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateHeadersRelationInput"]: {
	connect: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateSeoDefaultsEntityRelationInput"]: {
	connect?: ValueTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateSeoDefaultsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["SeoDefaultLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["SeoDefaultUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoDefaultWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoDefaultLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["SeoDefaultWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoDefaultWithoutLocalesCreateInput"] | Variable<any, string>
};
	["SeoDefaultLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoDefaultLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["SeoCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	ogTitle?: string | undefined | null | Variable<any, string>,
	ogDescription?: string | undefined | null | Variable<any, string>,
	noIndex?: boolean | undefined | null | Variable<any, string>,
	noFollow?: boolean | undefined | null | Variable<any, string>,
	ogImage?: ValueTypes["SeoCreateOgImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined | null | Variable<any, string>
};
	["SeoConnectOrCreateOgImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["SeoDefaultLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateSeoDefaultsRelationInput"]: {
	connect: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateBusinessPagesEntityRelationInput"]: {
	connect?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BusinessPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateBusinessPagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	infoBox?: ValueTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["BusinessPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BusinessPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["BusinessPageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["BusinessPageCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	isLokal?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	recruitisOfficeId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageCreateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>
};
	["BusinessPageConnectOrCreateThemeRelationInput"]: {
	connect: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BusinessPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	blocks?: Array<ValueTypes["ContentCreateBlocksEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentBlockWithoutContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentConnectOrCreateBlocksRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	references?: Array<ValueTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentBlockConnectOrCreateReferencesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	primaryText?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkables?: Array<ValueTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	secondaryText?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	textList?: ValueTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["ContentReferenceCreateCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	bonusBanner?: ValueTypes["ContentReferenceCreateBonusBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	sideBySide?: ValueTypes["ContentReferenceCreateSideBySideEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	showBoolean?: boolean | undefined | null | Variable<any, string>,
	isRed?: boolean | undefined | null | Variable<any, string>,
	video?: ValueTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentReferenceConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateLinkablesEntityRelationInput"]: {
	connect?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentReferenceConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateMediaEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined | null | Variable<any, string>
};
	["MediumListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["MediumListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["MediumItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["MediumItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumItemCreateMediumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemCreateMediumEntityRelationInput"]: {
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined | null | Variable<any, string>
};
	["MediumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["MediumCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["MediumCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["MediumCreateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["MediumConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["MediumCreateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumConnectOrCreateVideoRelationInput"] | undefined | null | Variable<any, string>
};
	["VideoCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	src?: string | undefined | null | Variable<any, string>,
	width?: number | undefined | null | Variable<any, string>,
	height?: number | undefined | null | Variable<any, string>,
	size?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	videoInfo?: string | undefined | null | Variable<any, string>,
	duration?: number | undefined | null | Variable<any, string>,
	poster?: ValueTypes["VideoCreatePosterEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["VideoConnectOrCreatePosterRelationInput"] | undefined | null | Variable<any, string>
};
	["VideoConnectOrCreatePosterRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["MediumConnectOrCreateVideoRelationInput"]: {
	connect: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["MediumItemConnectOrCreateMediumRelationInput"]: {
	connect: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MediumCreateInput"] | Variable<any, string>
};
	["MediumListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MediumItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateMediaRelationInput"]: {
	connect: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateTextListEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateTextListRelationInput"] | undefined | null | Variable<any, string>
};
	["TextListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["TextItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["TextItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["TextListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["TextListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["TextItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TextListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TextItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TextItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateTextListRelationInput"]: {
	connect: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TextListCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateCarouselEntityRelationInput"]: {
	connect?: ValueTypes["CarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CarouselCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateCarouselRelationInput"] | undefined | null | Variable<any, string>
};
	["CarouselUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["CarouselItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["CarouselItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	linkUrl?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>
};
	["CarouselCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["CarouselCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	background?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	squareImages?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CarouselCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["CarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CarouselItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CarouselConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CarouselItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["CarouselItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	linkUrl?: ValueTypes["CarouselItemCreateLinkUrlEntityRelationInput"] | undefined | null | Variable<any, string>,
	normalAspectRatio?: boolean | undefined | null | Variable<any, string>,
	isImage?: boolean | undefined | null | Variable<any, string>,
	video?: ValueTypes["CarouselItemCreateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CarouselItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CarouselItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["CarouselItemConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["CarouselItemCreateLinkUrlEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CarouselItemConnectOrCreateLinkUrlRelationInput"] | undefined | null | Variable<any, string>
};
	["CarouselItemConnectOrCreateLinkUrlRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["CarouselItemCreateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CarouselItemConnectOrCreateVideoRelationInput"] | undefined | null | Variable<any, string>
};
	["CarouselItemConnectOrCreateVideoRelationInput"]: {
	connect: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["CarouselConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CarouselItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateCarouselRelationInput"]: {
	connect: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CarouselCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateBonusBannerEntityRelationInput"]: {
	connect?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BonusBannerLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateBonusBannerRelationInput"] | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	tiles?: Array<ValueTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	logo?: ValueTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerName?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["BonusBannerUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BonusBannerWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BonusBannerLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["BonusBannerWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BonusBannerWithoutLocalesCreateInput"] | Variable<any, string>
};
	["BonusBannerLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutBonusBannersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BonusBannerLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutBonusBannersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateGenericPagesEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateGenericPagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutGenericPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutGenericPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreateBusinessPageEntityRelationInput"]: {
	connect?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BusinessPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateBusinessPageRelationInput"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	infoBox?: ValueTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutBusinessPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutBusinessPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateJobPagesEntityRelationInput"]: {
	connect?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateJobPagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobPageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	recruitisJobId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["JobPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["JobPageCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	contractType?: ValueTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobCity?: ValueTypes["JobPageCreateJobCityEntityRelationInput"] | undefined | null | Variable<any, string>,
	isActive?: boolean | undefined | null | Variable<any, string>,
	jobPosition?: ValueTypes["JobPageCreateJobPositionEntityRelationInput"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	business?: ValueTypes["JobPageCreateBusinessEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	siteType?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	isHiddenFromListing?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageCreateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPageConnectOrCreateThemeRelationInput"]: {
	connect: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["JobPageCreateContractTypeEntityRelationInput"]: {
	connect?: ValueTypes["ContractTypeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContractTypeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateContractTypeRelationInput"] | undefined | null | Variable<any, string>
};
	["ContractTypeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["ContractTypeCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContractTypeCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ContractTypeLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContractTypeLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContractTypeConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ContractTypeLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutContractTypesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContractTypeLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutContractTypesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateJobCitiesEntityRelationInput"]: {
	connect?: ValueTypes["JobCityLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobCityLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateJobCitiesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobCityLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobCityLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["JobCityUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobCityWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobCityLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["JobCityWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobCityWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateJobCitiesRelationInput"]: {
	connect: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobCityLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateJobPositionsEntityRelationInput"]: {
	connect?: ValueTypes["JobPositionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPositionLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateJobPositionsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobPositionLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPositionLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["JobPositionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPositionWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPositionLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPositionWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	jobs?: Array<ValueTypes["JobPositionCreateJobsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionCreateJobsEntityRelationInput"]: {
	connect?: ValueTypes["JobPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPageWithoutJobPositionCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPositionConnectOrCreateJobsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobPageWithoutJobPositionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["JobPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["JobPageCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	contractType?: ValueTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobCity?: ValueTypes["JobPageCreateJobCityEntityRelationInput"] | undefined | null | Variable<any, string>,
	isActive?: boolean | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	business?: ValueTypes["JobPageCreateBusinessEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	siteType?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	isHiddenFromListing?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobPageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	recruitisJobId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutJobPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutJobPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateContractTypesEntityRelationInput"]: {
	connect?: ValueTypes["ContractTypeLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContractTypeLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateContractTypesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ContractTypeLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ContractTypeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContractTypeWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContractTypeLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["ContractTypeWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContractTypeWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateContractTypesRelationInput"]: {
	connect: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContractTypeLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateHomePagesEntityRelationInput"]: {
	connect?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateHomePagesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HomePageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["HomePageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["HomePageCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageCreateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageConnectOrCreateThemeRelationInput"]: {
	connect: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HomePageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["HomePageLocaleCreateButtonEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateButtonRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateButtonRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["HomePageLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["HomePageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["HomePageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutHomePageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutHomePageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreateJobPageEntityRelationInput"]: {
	connect?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateJobPageRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPageLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	recruitisJobId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPageLocaleConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["JobPageLocaleCreateKeyInfoEntityRelationInput"]: {
	connect?: ValueTypes["KeyInfoListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["KeyInfoListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateKeyInfoRelationInput"] | undefined | null | Variable<any, string>
};
	["KeyInfoListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["KeyInfoListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["KeyInfoItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["KeyInfoItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["KeyInfoListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["KeyInfoItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	keyInfo?: string | undefined | null | Variable<any, string>,
	icon?: ValueTypes["KeyInfoItemCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoItemCreateIconEntityRelationInput"]: {
	connect?: ValueTypes["IconUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["IconCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["KeyInfoItemConnectOrCreateIconRelationInput"] | undefined | null | Variable<any, string>
};
	["IconUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["IconCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	icon?: ValueTypes["IconCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["IconCreateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["IconConnectOrCreateIconRelationInput"] | undefined | null | Variable<any, string>
};
	["IconConnectOrCreateIconRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["KeyInfoItemConnectOrCreateIconRelationInput"]: {
	connect: ValueTypes["IconUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["IconCreateInput"] | Variable<any, string>
};
	["KeyInfoListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["KeyInfoItemWithoutListCreateInput"] | Variable<any, string>
};
	["JobPageLocaleConnectOrCreateKeyInfoRelationInput"]: {
	connect: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["KeyInfoListCreateInput"] | Variable<any, string>
};
	["JobPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["JobPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["JobPageLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ValueTypes["StickyBarUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StickyBarCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null | Variable<any, string>
};
	["StickyBarUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>
};
	["StickyBarCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["StickyBarCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	formButtonLabel?: string | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["StickyBarCreateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StickyBarCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StickyBarConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["StickyBarConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["StickyBarCreateJobsFormEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StickyBarConnectOrCreateJobsFormRelationInput"] | undefined | null | Variable<any, string>
};
	["JobsFormLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	jobText?: string | undefined | null | Variable<any, string>,
	genericText?: string | undefined | null | Variable<any, string>,
	nameLabel?: string | undefined | null | Variable<any, string>,
	emailLabel?: string | undefined | null | Variable<any, string>,
	telefonLabel?: string | undefined | null | Variable<any, string>,
	fileTitleLabel?: string | undefined | null | Variable<any, string>,
	fileFormatLabel?: string | undefined | null | Variable<any, string>,
	formTextLabel?: string | undefined | null | Variable<any, string>,
	submitLabel?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFormLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobsFormLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageTextList?: ValueTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimalize?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successText?: string | undefined | null | Variable<any, string>,
	successBtnLabel?: string | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	successOtherJobsTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsCategoryTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsButtonTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionYesButton?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionNoButton?: string | undefined | null | Variable<any, string>,
	fileRemoveBtnLabel?: string | undefined | null | Variable<any, string>,
	gdprLabel?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["JobsFormWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	fileIlustration?: ValueTypes["JobsFormCreateFileIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormCreateFileIlustrationEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormConnectOrCreateFileIlustrationRelationInput"] | undefined | null | Variable<any, string>
};
	["JobsFormConnectOrCreateFileIlustrationRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFormWithoutLocalesCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutJobsFormsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutJobsFormsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateBonusBannersEntityRelationInput"]: {
	connect?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BonusBannerLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateBonusBannersRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	tiles?: Array<ValueTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	logo?: ValueTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerName?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleCreateTilesEntityRelationInput"]: {
	connect?: ValueTypes["TileUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TileWithoutBonusBannerCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BonusBannerLocaleConnectOrCreateTilesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TileWithoutBonusBannerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["TileCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	lightBoxTitle?: string | undefined | null | Variable<any, string>,
	lightBoxText?: string | undefined | null | Variable<any, string>,
	ligthBoxMedia?: ValueTypes["TileCreateLigthBoxMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	lightBoxSectionTitle?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	lightBoxLinkLabel?: string | undefined | null | Variable<any, string>,
	lightBoxForm?: ValueTypes["TileCreateLightBoxFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["TileConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["TileCreateLigthBoxMediaEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileConnectOrCreateLigthBoxMediaRelationInput"] | undefined | null | Variable<any, string>
};
	["TileConnectOrCreateLigthBoxMediaRelationInput"]: {
	connect: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>
};
	["TileCreateLightBoxFormEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileConnectOrCreateLightBoxFormRelationInput"] | undefined | null | Variable<any, string>
};
	["TileConnectOrCreateLightBoxFormRelationInput"]: {
	connect: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>
};
	["BonusBannerLocaleConnectOrCreateTilesRelationInput"]: {
	connect: ValueTypes["TileUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TileWithoutBonusBannerCreateInput"] | Variable<any, string>
};
	["BonusBannerLocaleCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BonusBannerLocaleConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateBonusBannersRelationInput"]: {
	connect: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BonusBannerLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateHomePageLokalsEntityRelationInput"]: {
	connect?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageLokalLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateHomePageLokalsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["HomePageLokalUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageLokalWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["HomePageLokalCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalCreateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalConnectOrCreateThemeRelationInput"]: {
	connect: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HomePageLokalWithoutLocalesCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleCreateButtonEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateButtonRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateButtonRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutHomePageLokalCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutHomePageLokalCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableCreateHomePageEntityRelationInput"]: {
	connect?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateHomePageRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutHomePagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutHomePagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleCreateJobsFormsEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateJobsFormsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobsFormLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	jobText?: string | undefined | null | Variable<any, string>,
	genericText?: string | undefined | null | Variable<any, string>,
	nameLabel?: string | undefined | null | Variable<any, string>,
	emailLabel?: string | undefined | null | Variable<any, string>,
	telefonLabel?: string | undefined | null | Variable<any, string>,
	fileTitleLabel?: string | undefined | null | Variable<any, string>,
	fileFormatLabel?: string | undefined | null | Variable<any, string>,
	formTextLabel?: string | undefined | null | Variable<any, string>,
	submitLabel?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFormLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageTextList?: ValueTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimalize?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successText?: string | undefined | null | Variable<any, string>,
	successBtnLabel?: string | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	successOtherJobsTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsCategoryTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsButtonTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionYesButton?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionNoButton?: string | undefined | null | Variable<any, string>,
	fileRemoveBtnLabel?: string | undefined | null | Variable<any, string>,
	gdprLabel?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormLocaleCreateImageTextListEntityRelationInput"]: {
	connect?: ValueTypes["ImageTextListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageTextListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormLocaleConnectOrCreateImageTextListRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageTextListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["ImageTextListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ImageTextItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageTextItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageTextListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ImageTextItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageTextItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageTextItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageTextItemConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ImageTextListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageTextItemWithoutListCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleConnectOrCreateImageTextListRelationInput"]: {
	connect: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageTextListCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormLocaleConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["JobsFormLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleCreateSuccessImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"] | undefined | null | Variable<any, string>
};
	["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateJobsFormsRelationInput"]: {
	connect: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateJobsFiltersEntityRelationInput"]: {
	connect?: ValueTypes["JobsFilterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFilterLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateJobsFiltersRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	jobPositionLabel?: string | undefined | null | Variable<any, string>,
	jobContractLabel?: string | undefined | null | Variable<any, string>,
	jobCityLabel?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFilterLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerFormLabel?: string | undefined | null | Variable<any, string>,
	bannerJobsForm?: ValueTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitle?: string | undefined | null | Variable<any, string>,
	noJobBtnLabel?: string | undefined | null | Variable<any, string>,
	noJobImage?: ValueTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitleForSpecificBusiness?: string | undefined | null | Variable<any, string>,
	deactivatedJob?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["JobsFilterUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFilterWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["JobsFilterWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFilterWithoutLocalesCreateInput"] | Variable<any, string>
};
	["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"] | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"]: {
	connect: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>
};
	["JobsFilterLocaleCreateBannerImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"] | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["JobsFilterLocaleCreateNoJobImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"] | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateJobsFiltersRelationInput"]: {
	connect: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFilterLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateGeneralEntityRelationInput"]: {
	connect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateGeneralRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GeneralLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	cornerBanner?: ValueTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["GeneralUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GeneralWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["GeneralWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GeneralWithoutLocalesCreateInput"] | Variable<any, string>
};
	["GeneralLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["GeneralLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["GeneralLocaleCreateCornerBannerEntityRelationInput"]: {
	connect?: ValueTypes["CornerBannerUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CornerBannerCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateCornerBannerRelationInput"] | undefined | null | Variable<any, string>
};
	["CornerBannerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	isActive?: boolean | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["CornerBannerCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["CornerBannerCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CornerBannerCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CornerBannerConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["CornerBannerConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["CornerBannerCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CornerBannerConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["CornerBannerConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["GeneralLocaleConnectOrCreateCornerBannerRelationInput"]: {
	connect: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CornerBannerCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateGeneralRelationInput"]: {
	connect: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GeneralLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateRecommendationFormsEntityRelationInput"]: {
	connect?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RecommendationFormLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateRecommendationFormsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	yourEmailLabel?: string | undefined | null | Variable<any, string>,
	theirEmailLabel?: string | undefined | null | Variable<any, string>,
	yourName?: string | undefined | null | Variable<any, string>,
	sendBtnLabel?: string | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successSubtitle?: string | undefined | null | Variable<any, string>,
	successButtonClose?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecommendationFormLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["RecommendationFormUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RecommendationFormWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecommendationFormLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["RecommendationFormWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["RecommendationFormCreateSuccessImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormCreateSuccessImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecommendationFormConnectOrCreateSuccessImageRelationInput"] | undefined | null | Variable<any, string>
};
	["RecommendationFormConnectOrCreateSuccessImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["RecommendationFormLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RecommendationFormWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateRecommendationFormsRelationInput"]: {
	connect: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RecommendationFormLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateInfoBoxesEntityRelationInput"]: {
	connect?: ValueTypes["InfoBoxLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoBoxLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateInfoBoxesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	address?: string | undefined | null | Variable<any, string>,
	web?: string | undefined | null | Variable<any, string>,
	instagram?: string | undefined | null | Variable<any, string>,
	facebook?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoBoxLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	openingHours?: ValueTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined | null | Variable<any, string>,
	addressLink?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["InfoBoxUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoBoxWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoBoxLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["InfoBoxWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	logoSize?: ValueTypes["LogoSize"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["InfoBoxCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoBoxConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["InfoBoxConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["InfoBoxLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["InfoBoxWithoutLocalesCreateInput"] | Variable<any, string>
};
	["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"] | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"]: {
	connect: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TextListCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateInfoBoxesRelationInput"]: {
	connect: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["InfoBoxLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleCreateTranslationsEntityRelationInput"]: {
	connect?: ValueTypes["TranslationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LocaleConnectOrCreateTranslationsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	value?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["TranslationLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["TranslationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>
};
	["TranslationWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	key?: string | undefined | null | Variable<any, string>,
	isTextarea?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateTranslationsRelationInput"]: {
	connect: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutHomePagesCreateInput"] | Variable<any, string>
};
	["HomePageLocaleCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["HomePageLocaleCreateSiteSwitcherEntityRelationInput"]: {
	connect?: ValueTypes["SiteSwitcherUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SiteSwitcherCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined | null | Variable<any, string>
};
	["SiteSwitcherCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["SiteSwitcherCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["SiteSwitcherCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SiteSwitcherCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SiteSwitcherConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["SiteSwitcherConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["SiteSwitcherCreateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SiteSwitcherConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>
};
	["SiteSwitcherConnectOrCreateThemeRelationInput"]: {
	connect: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"]: {
	connect: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SiteSwitcherCreateInput"] | Variable<any, string>
};
	["HomePageLocaleCreateGalleryEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateGalleryRelationInput"] | undefined | null | Variable<any, string>
};
	["GalleryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["GalleryCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GalleryCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GalleryConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GalleryItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	image?: ValueTypes["GalleryItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GalleryItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GalleryItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["GalleryItemConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["GalleryConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GalleryItemWithoutListCreateInput"] | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateGalleryRelationInput"]: {
	connect: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>
};
	["HomePageLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ValueTypes["StickyBarUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StickyBarCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StickyBarCreateInput"] | Variable<any, string>
};
	["HomePageLocaleCreateIlustrationEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateIlustrationRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateIlustrationRelationInput"]: {
	connect: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreateHomePageRelationInput"]: {
	connect: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HomePageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutHomePageLokalCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"]: {
	connect?: ValueTypes["SiteSwitcherUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SiteSwitcherCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"]: {
	connect: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SiteSwitcherCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleCreateGalleryEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"]: {
	connect: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ValueTypes["StickyBarUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StickyBarCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StickyBarCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleCreateIlustrationEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"]: {
	connect: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateHomePageLokalsRelationInput"]: {
	connect: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HomePageLokalLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutJobsFormsCreateInput"] | Variable<any, string>
};
	["StickyBarConnectOrCreateJobsFormRelationInput"]: {
	connect: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>
};
	["JobPageLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StickyBarCreateInput"] | Variable<any, string>
};
	["JobPageLocaleCreateMobileImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateMobileImageRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPageLocaleConnectOrCreateMobileImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreateJobPageRelationInput"]: {
	connect: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["LinkableCreateHomePageLokalEntityRelationInput"]: {
	connect?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageLokalLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateHomePageLokalRelationInput"] | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutHomePageLokalsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutHomePageLokalsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutHomePageLokalsCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreateHomePageLokalRelationInput"]: {
	connect: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HomePageLokalLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["HomePageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutHomePageCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateHomePagesRelationInput"]: {
	connect: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HomePageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["JobPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutJobPagesCreateInput"] | Variable<any, string>
};
	["JobPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutJobPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutJobPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutJobPageCreateInput"] | Variable<any, string>
};
	["JobPageConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobPageCreateJobCityEntityRelationInput"]: {
	connect?: ValueTypes["JobCityUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobCityCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateJobCityRelationInput"] | undefined | null | Variable<any, string>
};
	["JobCityCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["JobCityCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["JobCityLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobCityLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobCityConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobCityLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobCityLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutJobCitiesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobCityLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutJobCitiesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutJobCitiesCreateInput"] | Variable<any, string>
};
	["JobCityConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobCityLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobPageConnectOrCreateJobCityRelationInput"]: {
	connect: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobCityCreateInput"] | Variable<any, string>
};
	["JobPageCreateBusinessEntityRelationInput"]: {
	connect?: ValueTypes["BusinessPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BusinessPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateBusinessRelationInput"] | undefined | null | Variable<any, string>
};
	["BusinessPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["BusinessPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["BusinessPageCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	isLokal?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	recruitisOfficeId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BusinessPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	infoBox?: ValueTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutBusinessPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutBusinessPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutBusinessPageCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ValueTypes["StickyBarUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StickyBarCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["StickyBarCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleCreateInfoBoxEntityRelationInput"]: {
	connect?: ValueTypes["InfoBoxUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoBoxCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"] | undefined | null | Variable<any, string>
};
	["InfoBoxCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	logoSize?: ValueTypes["LogoSize"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["InfoBoxCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["InfoBoxCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["InfoBoxLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoBoxLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoBoxConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	address?: string | undefined | null | Variable<any, string>,
	web?: string | undefined | null | Variable<any, string>,
	instagram?: string | undefined | null | Variable<any, string>,
	facebook?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["InfoBoxLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	openingHours?: ValueTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined | null | Variable<any, string>,
	addressLink?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutInfoBoxesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoBoxLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutInfoBoxesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutInfoBoxesCreateInput"] | Variable<any, string>
};
	["InfoBoxConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["InfoBoxLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"]: {
	connect: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["InfoBoxCreateInput"] | Variable<any, string>
};
	["BusinessPageConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BusinessPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobPageConnectOrCreateBusinessRelationInput"]: {
	connect: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BusinessPageCreateInput"] | Variable<any, string>
};
	["JobPositionConnectOrCreateJobsRelationInput"]: {
	connect: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobPageWithoutJobPositionCreateInput"] | Variable<any, string>
};
	["JobPositionLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobPositionWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateJobPositionsRelationInput"]: {
	connect: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobPositionLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["ContractTypeLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutContractTypesCreateInput"] | Variable<any, string>
};
	["ContractTypeConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContractTypeLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobPageConnectOrCreateContractTypeRelationInput"]: {
	connect: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContractTypeCreateInput"] | Variable<any, string>
};
	["JobPageCreateJobPositionEntityRelationInput"]: {
	connect?: ValueTypes["JobPositionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPositionWithoutJobsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateJobPositionRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPositionWithoutJobsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["JobPositionCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["JobPositionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPositionLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPositionConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobPositionLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobPositionLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutJobPositionsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPositionLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutJobPositionsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutJobPositionsCreateInput"] | Variable<any, string>
};
	["JobPositionConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobPositionLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobPageConnectOrCreateJobPositionRelationInput"]: {
	connect: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobPositionWithoutJobsCreateInput"] | Variable<any, string>
};
	["JobPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateJobPagesRelationInput"]: {
	connect: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutBusinessPagesCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreateBusinessPageRelationInput"]: {
	connect: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BusinessPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutGenericPageCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateGenericPagesRelationInput"]: {
	connect: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["BonusBannerLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutBonusBannersCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateBonusBannerRelationInput"]: {
	connect: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BonusBannerLocaleCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateSideBySideEntityRelationInput"]: {
	connect?: ValueTypes["SideBySideUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SideBySideCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateSideBySideRelationInput"] | undefined | null | Variable<any, string>
};
	["SideBySideUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["SideBySideItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SideBySideItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>
};
	["SideBySideCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["SideBySideCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	background?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	alignment?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	mediumSize?: ValueTypes["MediumSize"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["SideBySideItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SideBySideItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SideBySideConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["SideBySideItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	media?: ValueTypes["SideBySideItemCreateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	formButtonLabel?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["SideBySideItemType"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["SideBySideItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["SideBySideItemCreateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	textNew?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideItemCreateMediaEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SideBySideItemConnectOrCreateMediaRelationInput"] | undefined | null | Variable<any, string>
};
	["SideBySideItemConnectOrCreateMediaRelationInput"]: {
	connect: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>
};
	["SideBySideItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SideBySideItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["SideBySideItemConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["SideBySideItemCreateJobsFormEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SideBySideItemConnectOrCreateJobsFormRelationInput"] | undefined | null | Variable<any, string>
};
	["SideBySideItemConnectOrCreateJobsFormRelationInput"]: {
	connect: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>
};
	["SideBySideConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SideBySideItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceConnectOrCreateSideBySideRelationInput"]: {
	connect: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SideBySideCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateGalleryEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateGalleryRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentReferenceConnectOrCreateGalleryRelationInput"]: {
	connect: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentReferenceConnectOrCreateVideoRelationInput"]: {
	connect: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["ContentBlockConnectOrCreateReferencesRelationInput"]: {
	connect: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | Variable<any, string>
};
	["ContentConnectOrCreateBlocksRelationInput"]: {
	connect: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentBlockWithoutContentCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateBusinessPagesRelationInput"]: {
	connect: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BusinessPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGenericPagesCreateInput"] | Variable<any, string>
};
	["LinkableConnectOrCreateGenericPageRelationInput"]: {
	connect: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["LinkConnectOrCreateInternalLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableCreateInput"] | Variable<any, string>
};
	["FooterLinkConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"]: {
	connect: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FooterLinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]: {
	connect?: ValueTypes["FooterLinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FooterLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"]: {
	connect: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FooterLinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateTermsAndConditionsEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateBannerImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateBannerImageRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateBannerImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateBannerLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateBannerLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateBannerLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateJobsFormEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateJobsFormRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateJobsFormRelationInput"]: {
	connect: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateCopyrightLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateRecommendationFormEntityRelationInput"]: {
	connect?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RecommendationFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateRecommendationFormRelationInput"] | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	yourEmailLabel?: string | undefined | null | Variable<any, string>,
	theirEmailLabel?: string | undefined | null | Variable<any, string>,
	yourName?: string | undefined | null | Variable<any, string>,
	sendBtnLabel?: string | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successSubtitle?: string | undefined | null | Variable<any, string>,
	successButtonClose?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecommendationFormLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["RecommendationFormLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutRecommendationFormsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutRecommendationFormsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutRecommendationFormsCreateInput"] | Variable<any, string>
};
	["FooterLocaleConnectOrCreateRecommendationFormRelationInput"]: {
	connect: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RecommendationFormLocaleCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateBannerSecondLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateInstagramLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateInstagramLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateInstagramLinkRelationInput"]: {
	connect: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["LocaleConnectOrCreateFootersRelationInput"]: {
	connect: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["GeneralLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGeneralCreateInput"] | Variable<any, string>
};
	["GeneralConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GeneralLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["GeneralUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GeneralUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["GeneralLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GeneralUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GeneralUpdateLocalesRelationInput"]: {
	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GeneralLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["GeneralLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	cornerBanner?: ValueTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGeneralCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutGeneralUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutGeneralUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateFootersEntityRelationInput"]: {
	create?: ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateFootersRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertFootersRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateFootersRelationInput"]: {
	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["FooterLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
	email?: string | undefined | null | Variable<any, string>,
	address?: string | undefined | null | Variable<any, string>,
	ico?: string | undefined | null | Variable<any, string>,
	dic?: string | undefined | null | Variable<any, string>,
	copyright?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	noteSecond?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	linksFirstColumn?: Array<ValueTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	linksSecondColumn?: Array<ValueTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	termsAndConditions?: ValueTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined | null | Variable<any, string>,
	form?: string | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerSubtitle?: string | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerLink?: ValueTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	copyrightLink?: ValueTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondBtn?: string | undefined | null | Variable<any, string>,
	recommendationForm?: ValueTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondLink?: ValueTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	instagramLink?: ValueTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["FooterUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FooterWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FooterWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["FooterWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FooterWithoutLocalesCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]: {
	create?: ValueTypes["FooterLinkCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FooterLocaleUpdateLinksFirstColumnRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertLinksFirstColumnRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["FooterLinkUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["FooterLinkUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["FooterLinkUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FooterLocaleUpdateLinksFirstColumnRelationInput"]: {
	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["FooterLinkUpdateInput"] | Variable<any, string>
};
	["FooterLinkUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	link?: ValueTypes["FooterLinkUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLinkUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLinkConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLinkUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkUpdateInput"]: {
	type?: ValueTypes["LinkType"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	externalLink?: string | undefined | null | Variable<any, string>,
	internalLink?: ValueTypes["LinkUpdateInternalLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	anchorLink?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkUpsertInternalLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
	connect?: ValueTypes["RedirectUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RedirectWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateRedirectRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RedirectWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertRedirectRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["RedirectWithoutLinkUpdateInput"]: {
	target?: ValueTypes["RedirectUpdateTargetEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RedirectUpdateTargetEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RedirectConnectOrCreateTargetRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RedirectUpsertTargetRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["RedirectUpsertTargetRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["LinkableUpsertRedirectRelationInput"]: {
	update: ValueTypes["RedirectWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RedirectWithoutLinkCreateInput"] | Variable<any, string>
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertGenericPageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageWithoutLocalesUpdateInput"]: {
	theme?: ValueTypes["GenericPageUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageUpdateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ThemeUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageUpsertThemeRelationInput"] | undefined | null | Variable<any, string>
};
	["ThemeUpdateInput"]: {
	backgroundColor?: string | undefined | null | Variable<any, string>,
	textColor?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	buttonBackgroundColor?: string | undefined | null | Variable<any, string>,
	buttonTextColor?: string | undefined | null | Variable<any, string>,
	buttonBackgroundHoverColor?: string | undefined | null | Variable<any, string>,
	buttonTextHoverColor?: string | undefined | null | Variable<any, string>,
	buttonBorderColor?: string | undefined | null | Variable<any, string>,
	buttonBorderHoverColor?: string | undefined | null | Variable<any, string>,
	headerMenuColor?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageUpsertThemeRelationInput"]: {
	update: ValueTypes["ThemeUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["GenericPageWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutGenericPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutGenericPagesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutGenericPagesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
	create?: ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateHeadersRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertHeadersRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateHeadersRelationInput"]: {
	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["HeaderLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	menuLabel?: string | undefined | null | Variable<any, string>,
	menuTitle?: string | undefined | null | Variable<any, string>,
	menuText?: string | undefined | null | Variable<any, string>,
	business?: Array<ValueTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined | null | Variable<any, string>,
	lokalEnterprise?: Array<ValueTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessSectionTitle?: string | undefined | null | Variable<any, string>,
	lokalSectionTitle?: string | undefined | null | Variable<any, string>,
	businessLink?: ValueTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	lokalLink?: ValueTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["HeaderUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeaderWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HeaderWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeaderWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HeaderUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	logoMenu?: ValueTypes["HeaderUpdateLogoMenuEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	width?: number | undefined | null | Variable<any, string>,
	height?: number | undefined | null | Variable<any, string>,
	size?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	alt?: string | undefined | null | Variable<any, string>,
	fileName?: string | undefined | null | Variable<any, string>,
	focalPointX?: number | undefined | null | Variable<any, string>,
	focalPointY?: number | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["HeaderUpdateLogoMenuEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderConnectOrCreateLogoMenuRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderUpsertLogoMenuRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeaderUpsertLogoMenuRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["HeaderLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["HeaderWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HeaderWithoutLocalesCreateInput"] | Variable<any, string>
};
	["HeaderLocaleUpdateBusinessEntityRelationInput"]: {
	create?: ValueTypes["BusinessCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HeaderLocaleUpdateBusinessRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderLocaleUpsertBusinessRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["BusinessUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["BusinessUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["BusinessUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpdateBusinessRelationInput"]: {
	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["BusinessUpdateInput"] | Variable<any, string>
};
	["BusinessUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	logo?: ValueTypes["BusinessUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["BusinessUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BusinessUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["BusinessUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BusinessUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["HeaderLocaleUpsertBusinessRelationInput"]: {
	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["BusinessUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BusinessCreateInput"] | Variable<any, string>
};
	["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]: {
	create?: ValueTypes["BusinessCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HeaderLocaleUpdateLokalEnterpriseRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderLocaleUpsertLokalEnterpriseRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["BusinessUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["BusinessUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["BusinessUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpdateLokalEnterpriseRelationInput"]: {
	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["BusinessUpdateInput"] | Variable<any, string>
};
	["HeaderLocaleUpsertLokalEnterpriseRelationInput"]: {
	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["BusinessUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BusinessCreateInput"] | Variable<any, string>
};
	["HeaderLocaleUpdateBusinessLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderLocaleUpsertBusinessLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpsertBusinessLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["HeaderLocaleUpdateLokalLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateLokalLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderLocaleUpsertLokalLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpsertLokalLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["LocaleUpsertHeadersRelationInput"]: {
	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["HeaderLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateSeoDefaultsEntityRelationInput"]: {
	create?: ValueTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateSeoDefaultsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertSeoDefaultsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateSeoDefaultsRelationInput"]: {
	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["SeoDefaultLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["SeoDefaultUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoDefaultWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoDefaultLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoDefaultWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SeoDefaultLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["SeoDefaultWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoDefaultWithoutLocalesCreateInput"] | Variable<any, string>
};
	["SeoDefaultLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoDefaultLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SeoDefaultLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SeoUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	ogTitle?: string | undefined | null | Variable<any, string>,
	ogDescription?: string | undefined | null | Variable<any, string>,
	noIndex?: boolean | undefined | null | Variable<any, string>,
	noFollow?: boolean | undefined | null | Variable<any, string>,
	ogImage?: ValueTypes["SeoUpdateOgImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SeoUpsertOgImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SeoUpsertOgImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["SeoDefaultLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["LocaleUpsertSeoDefaultsRelationInput"]: {
	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateBusinessPagesEntityRelationInput"]: {
	create?: ValueTypes["BusinessPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateBusinessPagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertBusinessPagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateBusinessPagesRelationInput"]: {
	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["BusinessPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["BusinessPageLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	infoBox?: ValueTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["BusinessPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BusinessPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["BusinessPageWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessPageLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageWithoutLocalesUpdateInput"]: {
	theme?: ValueTypes["BusinessPageUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	isLokal?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	recruitisOfficeId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageUpdateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ThemeUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessPageUpsertThemeRelationInput"] | undefined | null | Variable<any, string>
};
	["BusinessPageUpsertThemeRelationInput"]: {
	update: ValueTypes["ThemeUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["BusinessPageWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BusinessPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessPageLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentUpdateInput"]: {
	blocks?: Array<ValueTypes["ContentUpdateBlocksEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?: ValueTypes["ContentBlockWithoutContentCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateBlocksRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentUpsertBlocksRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentUpdateBlocksRelationInput"]: {
	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ContentBlockWithoutContentUpdateInput"] | Variable<any, string>
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	references?: Array<ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentBlockUpdateReferencesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentBlockUpsertReferencesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | Variable<any, string>
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	primaryText?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkables?: Array<ValueTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	secondaryText?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	textList?: ValueTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["ContentReferenceUpdateCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	bonusBanner?: ValueTypes["ContentReferenceUpdateBonusBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	sideBySide?: ValueTypes["ContentReferenceUpdateSideBySideEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	showBoolean?: boolean | undefined | null | Variable<any, string>,
	isRed?: boolean | undefined | null | Variable<any, string>,
	video?: ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateLinkablesEntityRelationInput"]: {
	connect?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateMediaEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MediumListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertMediaRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MediumListUpdateInput"]: {
	items?: Array<ValueTypes["MediumListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["MediumItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MediumListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MediumListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["MediumItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["MediumItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["MediumItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["MediumListUpdateItemsRelationInput"]: {
	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["MediumItemWithoutListUpdateInput"] | Variable<any, string>
};
	["MediumItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemUpdateMediumEntityRelationInput"]: {
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MediumUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MediumItemUpsertMediumRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MediumUpdateInput"]: {
	type?: ValueTypes["MediumType"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["MediumUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	video?: ValueTypes["MediumUpdateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MediumUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MediumUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["MediumUpdateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumConnectOrCreateVideoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["VideoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MediumUpsertVideoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["VideoUpdateInput"]: {
	src?: string | undefined | null | Variable<any, string>,
	width?: number | undefined | null | Variable<any, string>,
	height?: number | undefined | null | Variable<any, string>,
	size?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	videoInfo?: string | undefined | null | Variable<any, string>,
	duration?: number | undefined | null | Variable<any, string>,
	poster?: ValueTypes["VideoUpdatePosterEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["VideoUpdatePosterEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["VideoConnectOrCreatePosterRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["VideoUpsertPosterRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["VideoUpsertPosterRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["MediumUpsertVideoRelationInput"]: {
	update: ValueTypes["VideoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["MediumItemUpsertMediumRelationInput"]: {
	update: ValueTypes["MediumUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MediumCreateInput"] | Variable<any, string>
};
	["MediumListUpsertItemsRelationInput"]: {
	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["MediumItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MediumItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertMediaRelationInput"]: {
	update: ValueTypes["MediumListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateTextListEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateTextListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TextListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertTextListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TextListUpdateInput"]: {
	items?: Array<ValueTypes["TextListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["TextItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TextListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TextListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TextItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TextItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TextItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TextListUpdateItemsRelationInput"]: {
	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TextItemWithoutListUpdateInput"] | Variable<any, string>
};
	["TextItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextListUpsertItemsRelationInput"]: {
	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TextItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TextItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertTextListRelationInput"]: {
	update: ValueTypes["TextListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TextListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateCarouselEntityRelationInput"]: {
	connect?: ValueTypes["CarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CarouselCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateCarouselRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CarouselUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertCarouselRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CarouselUpdateInput"]: {
	items?: Array<ValueTypes["CarouselUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	background?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	squareImages?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CarouselUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["CarouselItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CarouselUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CarouselUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["CarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["CarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["CarouselItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["CarouselUpdateItemsRelationInput"]: {
	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["CarouselItemWithoutListUpdateInput"] | Variable<any, string>
};
	["CarouselItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["CarouselItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	linkUrl?: ValueTypes["CarouselItemUpdateLinkUrlEntityRelationInput"] | undefined | null | Variable<any, string>,
	normalAspectRatio?: boolean | undefined | null | Variable<any, string>,
	isImage?: boolean | undefined | null | Variable<any, string>,
	video?: ValueTypes["CarouselItemUpdateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CarouselItemUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CarouselItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CarouselItemUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CarouselItemUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["CarouselItemUpdateLinkUrlEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CarouselItemConnectOrCreateLinkUrlRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CarouselItemUpsertLinkUrlRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CarouselItemUpsertLinkUrlRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["CarouselItemUpdateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CarouselItemConnectOrCreateVideoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["VideoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CarouselItemUpsertVideoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CarouselItemUpsertVideoRelationInput"]: {
	update: ValueTypes["VideoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["CarouselUpsertItemsRelationInput"]: {
	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["CarouselItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CarouselItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertCarouselRelationInput"]: {
	update: ValueTypes["CarouselUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CarouselCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateBonusBannerEntityRelationInput"]: {
	connect?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BonusBannerLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateBonusBannerRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["BonusBannerLocaleUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertBonusBannerRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	tiles?: Array<ValueTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	logo?: ValueTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerName?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["BonusBannerUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BonusBannerWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BonusBannerLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["BonusBannerWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BonusBannerLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerWithoutLocalesUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["BonusBannerWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BonusBannerWithoutLocalesCreateInput"] | Variable<any, string>
};
	["BonusBannerLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutBonusBannersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BonusBannerLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutBonusBannersUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BonusBannerLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutBonusBannersUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateGenericPagesEntityRelationInput"]: {
	create?: ValueTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateGenericPagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertGenericPagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateGenericPagesRelationInput"]: {
	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GenericPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["GenericPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutGenericPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutGenericPageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutGenericPageUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdateBusinessPageEntityRelationInput"]: {
	connect?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BusinessPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateBusinessPageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["BusinessPageLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertBusinessPageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleWithoutLinkUpdateInput"]: {
	root?: ValueTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	infoBox?: ValueTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutBusinessPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutBusinessPagesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessPageLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutBusinessPagesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateJobPagesEntityRelationInput"]: {
	create?: ValueTypes["JobPageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateJobPagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertJobPagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateJobPagesRelationInput"]: {
	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["JobPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	recruitisJobId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["JobPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobPageWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobPageWithoutLocalesUpdateInput"]: {
	theme?: ValueTypes["JobPageUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	contractType?: ValueTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobCity?: ValueTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined | null | Variable<any, string>,
	isActive?: boolean | undefined | null | Variable<any, string>,
	jobPosition?: ValueTypes["JobPageUpdateJobPositionEntityRelationInput"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	business?: ValueTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	siteType?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	isHiddenFromListing?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageUpdateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ThemeUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageUpsertThemeRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPageUpsertThemeRelationInput"]: {
	update: ValueTypes["ThemeUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["JobPageUpdateContractTypeEntityRelationInput"]: {
	connect?: ValueTypes["ContractTypeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContractTypeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateContractTypeRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContractTypeUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageUpsertContractTypeRelationInput"] | undefined | null | Variable<any, string>
};
	["ContractTypeUpdateInput"]: {
	locales?: Array<ValueTypes["ContractTypeUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContractTypeUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ContractTypeLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContractTypeUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContractTypeUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ContractTypeLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ContractTypeLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ContractTypeLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ContractTypeUpdateLocalesRelationInput"]: {
	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ContractTypeLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["ContractTypeLocaleWithoutRootUpdateInput"]: {
	type?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ContractTypeLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutContractTypesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContractTypeLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutContractTypesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContractTypeLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutContractTypesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateJobCitiesEntityRelationInput"]: {
	create?: ValueTypes["JobCityLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateJobCitiesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertJobCitiesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobCityLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobCityLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobCityLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateJobCitiesRelationInput"]: {
	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobCityLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["JobCityLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["JobCityLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["JobCityUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobCityWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobCityLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobCityWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobCityLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobCityWithoutLocalesUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["JobCityWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobCityWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertJobCitiesRelationInput"]: {
	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobCityLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobCityLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateJobPositionsEntityRelationInput"]: {
	create?: ValueTypes["JobPositionLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateJobPositionsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertJobPositionsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobPositionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobPositionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobPositionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateJobPositionsRelationInput"]: {
	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobPositionLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["JobPositionLocaleWithoutLocaleUpdateInput"]: {
	type?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPositionLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["JobPositionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPositionWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPositionLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobPositionWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPositionLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionWithoutLocalesUpdateInput"]: {
	jobs?: Array<ValueTypes["JobPositionUpdateJobsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionUpdateJobsEntityRelationInput"]: {
	create?: ValueTypes["JobPageWithoutJobPositionCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobPositionUpdateJobsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPositionUpsertJobsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobPageUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobPageUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobPageUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobPositionUpdateJobsRelationInput"]: {
	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobPageWithoutJobPositionUpdateInput"] | Variable<any, string>
};
	["JobPageWithoutJobPositionUpdateInput"]: {
	locales?: Array<ValueTypes["JobPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["JobPageUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	contractType?: ValueTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobCity?: ValueTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined | null | Variable<any, string>,
	isActive?: boolean | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	business?: ValueTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	siteType?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	isHiddenFromListing?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["JobPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobPageUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobPageUpdateLocalesRelationInput"]: {
	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobPageLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["JobPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	recruitisJobId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutJobPagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutJobPagesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutJobPagesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateContractTypesEntityRelationInput"]: {
	create?: ValueTypes["ContractTypeLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateContractTypesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertContractTypesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ContractTypeLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ContractTypeLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ContractTypeLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateContractTypesRelationInput"]: {
	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ContractTypeLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["ContractTypeLocaleWithoutLocaleUpdateInput"]: {
	type?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ContractTypeLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["ContractTypeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContractTypeWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContractTypeLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContractTypeWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContractTypeLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContractTypeWithoutLocalesUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["ContractTypeWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContractTypeWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertContractTypesRelationInput"]: {
	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ContractTypeLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContractTypeLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateHomePagesEntityRelationInput"]: {
	create?: ValueTypes["HomePageLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateHomePagesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertHomePagesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateHomePagesRelationInput"]: {
	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["HomePageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["HomePageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["HomePageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HomePageWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["HomePageUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageUpdateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ThemeUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageUpsertThemeRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageUpsertThemeRelationInput"]: {
	update: ValueTypes["ThemeUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["HomePageWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HomePageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpdateButtonEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateButtonRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertButtonRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleUpsertButtonRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutHomePageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutHomePageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutHomePageUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdateJobPageEntityRelationInput"]: {
	connect?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateJobPageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobPageLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertJobPageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	recruitisJobId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageLocaleUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["JobPageLocaleUpdateKeyInfoEntityRelationInput"]: {
	connect?: ValueTypes["KeyInfoListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["KeyInfoListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateKeyInfoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["KeyInfoListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageLocaleUpsertKeyInfoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoListUpdateInput"]: {
	items?: Array<ValueTypes["KeyInfoListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["KeyInfoItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["KeyInfoListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["KeyInfoListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["KeyInfoItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["KeyInfoItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["KeyInfoItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["KeyInfoListUpdateItemsRelationInput"]: {
	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["KeyInfoItemWithoutListUpdateInput"] | Variable<any, string>
};
	["KeyInfoItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	keyInfo?: string | undefined | null | Variable<any, string>,
	icon?: ValueTypes["KeyInfoItemUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoItemUpdateIconEntityRelationInput"]: {
	connect?: ValueTypes["IconUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["IconCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["KeyInfoItemConnectOrCreateIconRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["IconUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["KeyInfoItemUpsertIconRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["IconUpdateInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	icon?: ValueTypes["IconUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["IconUpdateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["IconConnectOrCreateIconRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["IconUpsertIconRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["IconUpsertIconRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["KeyInfoItemUpsertIconRelationInput"]: {
	update: ValueTypes["IconUpdateInput"] | Variable<any, string>,
	create: ValueTypes["IconCreateInput"] | Variable<any, string>
};
	["KeyInfoListUpsertItemsRelationInput"]: {
	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["KeyInfoItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["KeyInfoItemWithoutListCreateInput"] | Variable<any, string>
};
	["JobPageLocaleUpsertKeyInfoRelationInput"]: {
	update: ValueTypes["KeyInfoListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["KeyInfoListCreateInput"] | Variable<any, string>
};
	["JobPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["JobPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["JobPageLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ValueTypes["StickyBarUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StickyBarCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StickyBarUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageLocaleUpsertStickyBarRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["StickyBarUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["StickyBarUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	formButtonLabel?: string | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["StickyBarUpdateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StickyBarUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StickyBarConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["StickyBarUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["StickyBarUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["StickyBarUpdateJobsFormEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["StickyBarConnectOrCreateJobsFormRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobsFormLocaleUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["StickyBarUpsertJobsFormRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	jobText?: string | undefined | null | Variable<any, string>,
	genericText?: string | undefined | null | Variable<any, string>,
	nameLabel?: string | undefined | null | Variable<any, string>,
	emailLabel?: string | undefined | null | Variable<any, string>,
	telefonLabel?: string | undefined | null | Variable<any, string>,
	fileTitleLabel?: string | undefined | null | Variable<any, string>,
	fileFormatLabel?: string | undefined | null | Variable<any, string>,
	formTextLabel?: string | undefined | null | Variable<any, string>,
	submitLabel?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFormLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobsFormLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageTextList?: ValueTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimalize?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successText?: string | undefined | null | Variable<any, string>,
	successBtnLabel?: string | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	successOtherJobsTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsCategoryTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsButtonTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionYesButton?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionNoButton?: string | undefined | null | Variable<any, string>,
	fileRemoveBtnLabel?: string | undefined | null | Variable<any, string>,
	gdprLabel?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobsFormWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFormLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	fileIlustration?: ValueTypes["JobsFormUpdateFileIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormUpdateFileIlustrationEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormConnectOrCreateFileIlustrationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFormUpsertFileIlustrationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormUpsertFileIlustrationRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["JobsFormWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFormWithoutLocalesCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutJobsFormsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutJobsFormsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFormLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutJobsFormsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateBonusBannersEntityRelationInput"]: {
	create?: ValueTypes["BonusBannerLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateBonusBannersRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertBonusBannersRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateBonusBannersRelationInput"]: {
	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["BonusBannerLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["BonusBannerLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	tiles?: Array<ValueTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	logo?: ValueTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerName?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleUpdateTilesEntityRelationInput"]: {
	create?: ValueTypes["TileWithoutBonusBannerCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["BonusBannerLocaleUpdateTilesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BonusBannerLocaleUpsertTilesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TileUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TileUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TileUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleUpdateTilesRelationInput"]: {
	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TileWithoutBonusBannerUpdateInput"] | Variable<any, string>
};
	["TileWithoutBonusBannerUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["TileUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	lightBoxTitle?: string | undefined | null | Variable<any, string>,
	lightBoxText?: string | undefined | null | Variable<any, string>,
	ligthBoxMedia?: ValueTypes["TileUpdateLigthBoxMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	lightBoxSectionTitle?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	lightBoxLinkLabel?: string | undefined | null | Variable<any, string>,
	lightBoxForm?: ValueTypes["TileUpdateLightBoxFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TileUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["TileUpdateLigthBoxMediaEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileConnectOrCreateLigthBoxMediaRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MediumListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileUpsertLigthBoxMediaRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TileUpsertLigthBoxMediaRelationInput"]: {
	update: ValueTypes["MediumListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>
};
	["TileUpdateLightBoxFormEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileConnectOrCreateLightBoxFormRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobsFormLocaleUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileUpsertLightBoxFormRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TileUpsertLightBoxFormRelationInput"]: {
	update: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>
};
	["BonusBannerLocaleUpsertTilesRelationInput"]: {
	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TileWithoutBonusBannerUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TileWithoutBonusBannerCreateInput"] | Variable<any, string>
};
	["BonusBannerLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BonusBannerLocaleConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BonusBannerLocaleUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LocaleUpsertBonusBannersRelationInput"]: {
	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["BonusBannerLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BonusBannerLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateHomePageLokalsEntityRelationInput"]: {
	create?: ValueTypes["HomePageLokalLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateHomePageLokalsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertHomePageLokalsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateHomePageLokalsRelationInput"]: {
	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["HomePageLokalLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["HomePageLokalUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageLokalWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HomePageLokalWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["HomePageLokalUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalUpdateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ThemeUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalUpsertThemeRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalUpsertThemeRelationInput"]: {
	update: ValueTypes["ThemeUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["HomePageLokalWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HomePageLokalWithoutLocalesCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpdateButtonEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateButtonRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertButtonRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpsertButtonRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutHomePageLokalCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutHomePageLokalUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutHomePageLokalUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
	connect?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateHomePageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HomePageLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertHomePageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutHomePagesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutHomePagesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutHomePagesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateJobsFormsEntityRelationInput"]: {
	create?: ValueTypes["JobsFormLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateJobsFormsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertJobsFormsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateJobsFormsRelationInput"]: {
	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobsFormLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["JobsFormLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	jobText?: string | undefined | null | Variable<any, string>,
	genericText?: string | undefined | null | Variable<any, string>,
	nameLabel?: string | undefined | null | Variable<any, string>,
	emailLabel?: string | undefined | null | Variable<any, string>,
	telefonLabel?: string | undefined | null | Variable<any, string>,
	fileTitleLabel?: string | undefined | null | Variable<any, string>,
	fileFormatLabel?: string | undefined | null | Variable<any, string>,
	formTextLabel?: string | undefined | null | Variable<any, string>,
	submitLabel?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFormLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageTextList?: ValueTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimalize?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successText?: string | undefined | null | Variable<any, string>,
	successBtnLabel?: string | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	successOtherJobsTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsCategoryTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsButtonTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionYesButton?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionNoButton?: string | undefined | null | Variable<any, string>,
	fileRemoveBtnLabel?: string | undefined | null | Variable<any, string>,
	gdprLabel?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormLocaleUpdateImageTextListEntityRelationInput"]: {
	connect?: ValueTypes["ImageTextListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageTextListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormLocaleConnectOrCreateImageTextListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageTextListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFormLocaleUpsertImageTextListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextListUpdateInput"]: {
	items?: Array<ValueTypes["ImageTextListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ImageTextItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageTextListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageTextListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ImageTextItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ImageTextItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ImageTextItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ImageTextListUpdateItemsRelationInput"]: {
	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ImageTextItemWithoutListUpdateInput"] | Variable<any, string>
};
	["ImageTextItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageTextItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextItemUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageTextItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageTextItemUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextItemUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ImageTextListUpsertItemsRelationInput"]: {
	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ImageTextItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageTextItemWithoutListCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleUpsertImageTextListRelationInput"]: {
	update: ValueTypes["ImageTextListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageTextListCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormLocaleConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFormLocaleUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormLocaleUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleUpdateSuccessImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFormLocaleUpsertSuccessImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormLocaleUpsertSuccessImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LocaleUpsertJobsFormsRelationInput"]: {
	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobsFormLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateJobsFiltersEntityRelationInput"]: {
	create?: ValueTypes["JobsFilterLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateJobsFiltersRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertJobsFiltersRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobsFilterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobsFilterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobsFilterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateJobsFiltersRelationInput"]: {
	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobsFilterLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["JobsFilterLocaleWithoutLocaleUpdateInput"]: {
	jobPositionLabel?: string | undefined | null | Variable<any, string>,
	jobContractLabel?: string | undefined | null | Variable<any, string>,
	jobCityLabel?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFilterLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerFormLabel?: string | undefined | null | Variable<any, string>,
	bannerJobsForm?: ValueTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitle?: string | undefined | null | Variable<any, string>,
	noJobBtnLabel?: string | undefined | null | Variable<any, string>,
	noJobImage?: ValueTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitleForSpecificBusiness?: string | undefined | null | Variable<any, string>,
	deactivatedJob?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["JobsFilterUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFilterWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobsFilterWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFilterLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["JobsFilterWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFilterWithoutLocalesCreateInput"] | Variable<any, string>
};
	["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobsFormLocaleUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFilterLocaleUpsertBannerJobsFormRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleUpsertBannerJobsFormRelationInput"]: {
	update: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>
};
	["JobsFilterLocaleUpdateBannerImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFilterLocaleUpsertBannerImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleUpsertBannerImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFilterLocaleUpsertNoJobImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleUpsertNoJobImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LocaleUpsertJobsFiltersRelationInput"]: {
	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobsFilterLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFilterLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateGeneralEntityRelationInput"]: {
	create?: ValueTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateGeneralRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertGeneralRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GeneralLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateGeneralRelationInput"]: {
	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GeneralLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["GeneralLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	cornerBanner?: ValueTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["GeneralUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GeneralWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GeneralWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GeneralWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["GeneralWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GeneralWithoutLocalesCreateInput"] | Variable<any, string>
};
	["GeneralLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["GeneralLocaleUpdateCornerBannerEntityRelationInput"]: {
	connect?: ValueTypes["CornerBannerUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CornerBannerCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GeneralLocaleConnectOrCreateCornerBannerRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CornerBannerUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GeneralLocaleUpsertCornerBannerRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CornerBannerUpdateInput"]: {
	isActive?: boolean | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["CornerBannerUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["CornerBannerUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CornerBannerUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CornerBannerConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CornerBannerUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CornerBannerUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["CornerBannerUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CornerBannerConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CornerBannerUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CornerBannerUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["GeneralLocaleUpsertCornerBannerRelationInput"]: {
	update: ValueTypes["CornerBannerUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CornerBannerCreateInput"] | Variable<any, string>
};
	["LocaleUpsertGeneralRelationInput"]: {
	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GeneralLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GeneralLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateRecommendationFormsEntityRelationInput"]: {
	create?: ValueTypes["RecommendationFormLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateRecommendationFormsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertRecommendationFormsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateRecommendationFormsRelationInput"]: {
	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["RecommendationFormLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["RecommendationFormLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	yourEmailLabel?: string | undefined | null | Variable<any, string>,
	theirEmailLabel?: string | undefined | null | Variable<any, string>,
	yourName?: string | undefined | null | Variable<any, string>,
	sendBtnLabel?: string | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successSubtitle?: string | undefined | null | Variable<any, string>,
	successButtonClose?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecommendationFormLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["RecommendationFormUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RecommendationFormWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecommendationFormLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RecommendationFormWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RecommendationFormLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["RecommendationFormUpdateSuccessImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormUpdateSuccessImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecommendationFormConnectOrCreateSuccessImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RecommendationFormUpsertSuccessImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormUpsertSuccessImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["RecommendationFormLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["RecommendationFormWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RecommendationFormWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertRecommendationFormsRelationInput"]: {
	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["RecommendationFormLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RecommendationFormLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateInfoBoxesEntityRelationInput"]: {
	create?: ValueTypes["InfoBoxLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateInfoBoxesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertInfoBoxesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["InfoBoxLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["InfoBoxLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["InfoBoxLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateInfoBoxesRelationInput"]: {
	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["InfoBoxLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["InfoBoxLocaleWithoutLocaleUpdateInput"]: {
	address?: string | undefined | null | Variable<any, string>,
	web?: string | undefined | null | Variable<any, string>,
	instagram?: string | undefined | null | Variable<any, string>,
	facebook?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoBoxLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	openingHours?: ValueTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined | null | Variable<any, string>,
	addressLink?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["InfoBoxUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoBoxWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoBoxLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["InfoBoxWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoBoxLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxWithoutLocalesUpdateInput"]: {
	logoSize?: ValueTypes["LogoSize"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["InfoBoxUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoBoxConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoBoxUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["InfoBoxLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["InfoBoxWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["InfoBoxWithoutLocalesCreateInput"] | Variable<any, string>
};
	["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TextListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoBoxLocaleUpsertOpeningHoursRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleUpsertOpeningHoursRelationInput"]: {
	update: ValueTypes["TextListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TextListCreateInput"] | Variable<any, string>
};
	["LocaleUpsertInfoBoxesRelationInput"]: {
	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["InfoBoxLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["InfoBoxLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["LocaleUpdateTranslationsEntityRelationInput"]: {
	create?: ValueTypes["TranslationLocaleWithoutLocaleCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleUpdateTranslationsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LocaleUpsertTranslationsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TranslationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TranslationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TranslationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["LocaleUpdateTranslationsRelationInput"]: {
	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TranslationLocaleWithoutLocaleUpdateInput"] | Variable<any, string>
};
	["TranslationLocaleWithoutLocaleUpdateInput"]: {
	value?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["TranslationLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ValueTypes["TranslationUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationWithoutLocalesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationLocaleConnectOrCreateRootRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationWithoutLocalesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationLocaleUpsertRootRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TranslationWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	key?: string | undefined | null | Variable<any, string>,
	isTextarea?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["TranslationWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertTranslationsRelationInput"]: {
	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TranslationLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutHomePagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutHomePagesCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"]: {
	connect?: ValueTypes["SiteSwitcherUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SiteSwitcherCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SiteSwitcherUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertSiteSwitcherRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SiteSwitcherUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["SiteSwitcherUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	theme?: ValueTypes["SiteSwitcherUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SiteSwitcherUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SiteSwitcherConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SiteSwitcherUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SiteSwitcherUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["SiteSwitcherUpdateThemeEntityRelationInput"]: {
	connect?: ValueTypes["ThemeUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ThemeCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SiteSwitcherConnectOrCreateThemeRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ThemeUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SiteSwitcherUpsertThemeRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SiteSwitcherUpsertThemeRelationInput"]: {
	update: ValueTypes["ThemeUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpsertSiteSwitcherRelationInput"]: {
	update: ValueTypes["SiteSwitcherUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SiteSwitcherCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpdateGalleryEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateGalleryRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GalleryUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertGalleryRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GalleryUpdateInput"]: {
	items?: Array<ValueTypes["GalleryUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GalleryUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["GalleryItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GalleryUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GalleryUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GalleryUpdateItemsRelationInput"]: {
	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GalleryItemWithoutListUpdateInput"] | Variable<any, string>
};
	["GalleryItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	image?: ValueTypes["GalleryItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GalleryItemUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GalleryItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GalleryItemUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GalleryItemUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["GalleryUpsertItemsRelationInput"]: {
	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GalleryItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GalleryItemWithoutListCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpsertGalleryRelationInput"]: {
	update: ValueTypes["GalleryUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ValueTypes["StickyBarUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StickyBarCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StickyBarUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertStickyBarRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleUpsertStickyBarRelationInput"]: {
	update: ValueTypes["StickyBarUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StickyBarCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpdateIlustrationEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLocaleConnectOrCreateIlustrationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GalleryUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLocaleUpsertIlustrationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleUpsertIlustrationRelationInput"]: {
	update: ValueTypes["GalleryUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>
};
	["LinkableUpsertHomePageRelationInput"]: {
	update: ValueTypes["HomePageLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HomePageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutHomePageLokalUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutHomePageLokalCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"]: {
	connect?: ValueTypes["SiteSwitcherUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SiteSwitcherCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SiteSwitcherUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertSiteSwitcherRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpsertSiteSwitcherRelationInput"]: {
	update: ValueTypes["SiteSwitcherUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SiteSwitcherCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpdateGalleryEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GalleryUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertGalleryRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpsertGalleryRelationInput"]: {
	update: ValueTypes["GalleryUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ValueTypes["StickyBarUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StickyBarCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StickyBarUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertStickyBarRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpsertStickyBarRelationInput"]: {
	update: ValueTypes["StickyBarUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StickyBarCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GalleryUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertIlustrationRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpsertIlustrationRelationInput"]: {
	update: ValueTypes["GalleryUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>
};
	["LocaleUpsertHomePageLokalsRelationInput"]: {
	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["HomePageLokalLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HomePageLokalLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["JobsFormLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutJobsFormsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutJobsFormsCreateInput"] | Variable<any, string>
};
	["StickyBarUpsertJobsFormRelationInput"]: {
	update: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>
};
	["JobPageLocaleUpsertStickyBarRelationInput"]: {
	update: ValueTypes["StickyBarUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StickyBarCreateInput"] | Variable<any, string>
};
	["JobPageLocaleUpdateMobileImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateMobileImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageLocaleUpsertMobileImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleUpsertMobileImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LinkableUpsertJobPageRelationInput"]: {
	update: ValueTypes["JobPageLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["LinkableUpdateHomePageLokalEntityRelationInput"]: {
	connect?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageLokalLocaleWithoutLinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["LinkableConnectOrCreateHomePageLokalRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HomePageLokalLocaleWithoutLinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["LinkableUpsertHomePageLokalRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutHomePageLokalsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutHomePageLokalsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutHomePageLokalsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutHomePageLokalsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutHomePageLokalsCreateInput"] | Variable<any, string>
};
	["LinkableUpsertHomePageLokalRelationInput"]: {
	update: ValueTypes["HomePageLokalLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HomePageLokalLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["HomePageLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutHomePageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutHomePageCreateInput"] | Variable<any, string>
};
	["LocaleUpsertHomePagesRelationInput"]: {
	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["HomePageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HomePageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["JobPageLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutJobPagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutJobPagesCreateInput"] | Variable<any, string>
};
	["JobPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutJobPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutJobPageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutJobPageUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutJobPageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutJobPageCreateInput"] | Variable<any, string>
};
	["JobPageUpsertLocalesRelationInput"]: {
	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobPageLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobPageUpdateJobCityEntityRelationInput"]: {
	connect?: ValueTypes["JobCityUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobCityCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateJobCityRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobCityUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageUpsertJobCityRelationInput"] | undefined | null | Variable<any, string>
};
	["JobCityUpdateInput"]: {
	locales?: Array<ValueTypes["JobCityUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["JobCityLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobCityUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobCityUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobCityLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobCityLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobCityLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobCityUpdateLocalesRelationInput"]: {
	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobCityLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["JobCityLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["JobCityLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutJobCitiesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobCityLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutJobCitiesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobCityLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutJobCitiesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutJobCitiesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutJobCitiesCreateInput"] | Variable<any, string>
};
	["JobCityUpsertLocalesRelationInput"]: {
	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobCityLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobCityLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobPageUpsertJobCityRelationInput"]: {
	update: ValueTypes["JobCityUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobCityCreateInput"] | Variable<any, string>
};
	["JobPageUpdateBusinessEntityRelationInput"]: {
	connect?: ValueTypes["BusinessPageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BusinessPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateBusinessRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["BusinessPageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageUpsertBusinessRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageUpdateInput"]: {
	locales?: Array<ValueTypes["BusinessPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["BusinessPageUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	isLokal?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	recruitisOfficeId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["BusinessPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["BusinessPageUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessPageUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["BusinessPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["BusinessPageUpdateLocalesRelationInput"]: {
	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["BusinessPageLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["BusinessPageLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	infoBox?: ValueTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessPageLocaleUpsertSeoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleUpsertSeoRelationInput"]: {
	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutBusinessPageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutBusinessPageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessPageLocaleUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutBusinessPageUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	redirect?: ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutBusinessPageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutBusinessPageCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessPageLocaleUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ValueTypes["StickyBarUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["StickyBarCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["StickyBarUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessPageLocaleUpsertStickyBarRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleUpsertStickyBarRelationInput"]: {
	update: ValueTypes["StickyBarUpdateInput"] | Variable<any, string>,
	create: ValueTypes["StickyBarCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"]: {
	connect?: ValueTypes["InfoBoxUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["InfoBoxCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["InfoBoxUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BusinessPageLocaleUpsertInfoBoxRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxUpdateInput"]: {
	logoSize?: ValueTypes["LogoSize"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["InfoBoxUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["InfoBoxUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["InfoBoxLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["InfoBoxUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoBoxUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["InfoBoxLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["InfoBoxLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["InfoBoxLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["InfoBoxUpdateLocalesRelationInput"]: {
	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["InfoBoxLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["InfoBoxLocaleWithoutRootUpdateInput"]: {
	address?: string | undefined | null | Variable<any, string>,
	web?: string | undefined | null | Variable<any, string>,
	instagram?: string | undefined | null | Variable<any, string>,
	facebook?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["InfoBoxLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	openingHours?: ValueTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined | null | Variable<any, string>,
	addressLink?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutInfoBoxesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["InfoBoxLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutInfoBoxesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["InfoBoxLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutInfoBoxesUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutInfoBoxesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutInfoBoxesCreateInput"] | Variable<any, string>
};
	["InfoBoxUpsertLocalesRelationInput"]: {
	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["InfoBoxLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["InfoBoxLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleUpsertInfoBoxRelationInput"]: {
	update: ValueTypes["InfoBoxUpdateInput"] | Variable<any, string>,
	create: ValueTypes["InfoBoxCreateInput"] | Variable<any, string>
};
	["BusinessPageUpsertLocalesRelationInput"]: {
	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["BusinessPageLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BusinessPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobPageUpsertBusinessRelationInput"]: {
	update: ValueTypes["BusinessPageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BusinessPageCreateInput"] | Variable<any, string>
};
	["JobPositionUpsertJobsRelationInput"]: {
	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobPageWithoutJobPositionUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobPageWithoutJobPositionCreateInput"] | Variable<any, string>
};
	["JobPositionLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["JobPositionWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobPositionWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertJobPositionsRelationInput"]: {
	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobPositionLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobPositionLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["ContractTypeLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutContractTypesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutContractTypesCreateInput"] | Variable<any, string>
};
	["ContractTypeUpsertLocalesRelationInput"]: {
	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ContractTypeLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContractTypeLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobPageUpsertContractTypeRelationInput"]: {
	update: ValueTypes["ContractTypeUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContractTypeCreateInput"] | Variable<any, string>
};
	["JobPageUpdateJobPositionEntityRelationInput"]: {
	connect?: ValueTypes["JobPositionUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPositionWithoutJobsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPageConnectOrCreateJobPositionRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobPositionWithoutJobsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPageUpsertJobPositionRelationInput"] | undefined | null | Variable<any, string>
};
	["JobPositionWithoutJobsUpdateInput"]: {
	locales?: Array<ValueTypes["JobPositionUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["JobPositionLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobPositionUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPositionUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobPositionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobPositionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobPositionLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobPositionUpdateLocalesRelationInput"]: {
	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobPositionLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["JobPositionLocaleWithoutRootUpdateInput"]: {
	type?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobPositionLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutJobPositionsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobPositionLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutJobPositionsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobPositionLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutJobPositionsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutJobPositionsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutJobPositionsCreateInput"] | Variable<any, string>
};
	["JobPositionUpsertLocalesRelationInput"]: {
	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobPositionLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobPositionLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobPageUpsertJobPositionRelationInput"]: {
	update: ValueTypes["JobPositionWithoutJobsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobPositionWithoutJobsCreateInput"] | Variable<any, string>
};
	["JobPageLocaleUpsertRootRelationInput"]: {
	update: ValueTypes["JobPageWithoutLocalesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobPageWithoutLocalesCreateInput"] | Variable<any, string>
};
	["LocaleUpsertJobPagesRelationInput"]: {
	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutBusinessPagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutBusinessPagesCreateInput"] | Variable<any, string>
};
	["LinkableUpsertBusinessPageRelationInput"]: {
	update: ValueTypes["BusinessPageLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BusinessPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutGenericPageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutGenericPageCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateLogoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertLogoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpsertLogoRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageLocaleConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageLocaleUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["LocaleUpsertGenericPagesRelationInput"]: {
	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GenericPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["BonusBannerLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutBonusBannersUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutBonusBannersCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertBonusBannerRelationInput"]: {
	update: ValueTypes["BonusBannerLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BonusBannerLocaleCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateSideBySideEntityRelationInput"]: {
	connect?: ValueTypes["SideBySideUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SideBySideCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateSideBySideRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SideBySideUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertSideBySideRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideUpdateInput"]: {
	items?: Array<ValueTypes["SideBySideUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	background?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	alignment?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	mediumSize?: ValueTypes["MediumSize"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["SideBySideItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SideBySideUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SideBySideUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["SideBySideItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["SideBySideItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["SideBySideItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["SideBySideUpdateItemsRelationInput"]: {
	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["SideBySideItemWithoutListUpdateInput"] | Variable<any, string>
};
	["SideBySideItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	media?: ValueTypes["SideBySideItemUpdateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	formButtonLabel?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["SideBySideItemType"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["SideBySideItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["SideBySideItemUpdateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	textNew?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideItemUpdateMediaEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SideBySideItemConnectOrCreateMediaRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MediumListUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SideBySideItemUpsertMediaRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideItemUpsertMediaRelationInput"]: {
	update: ValueTypes["MediumListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>
};
	["SideBySideItemUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SideBySideItemConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SideBySideItemUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideItemUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["SideBySideItemUpdateJobsFormEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SideBySideItemConnectOrCreateJobsFormRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobsFormLocaleUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SideBySideItemUpsertJobsFormRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideItemUpsertJobsFormRelationInput"]: {
	update: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>
};
	["SideBySideUpsertItemsRelationInput"]: {
	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["SideBySideItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SideBySideItemWithoutListCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpsertSideBySideRelationInput"]: {
	update: ValueTypes["SideBySideUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SideBySideCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateGalleryEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateGalleryRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GalleryUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertGalleryRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpsertGalleryRelationInput"]: {
	update: ValueTypes["GalleryUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["VideoCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["VideoUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertVideoRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpsertVideoRelationInput"]: {
	update: ValueTypes["VideoUpdateInput"] | Variable<any, string>,
	create: ValueTypes["VideoCreateInput"] | Variable<any, string>
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | Variable<any, string>
};
	["ContentUpsertBlocksRelationInput"]: {
	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ContentBlockWithoutContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentBlockWithoutContentCreateInput"] | Variable<any, string>
};
	["BusinessPageLocaleUpsertContentRelationInput"]: {
	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentCreateInput"] | Variable<any, string>
};
	["LocaleUpsertBusinessPagesRelationInput"]: {
	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["BusinessPageLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BusinessPageLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["GenericPageLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutGenericPagesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGenericPagesCreateInput"] | Variable<any, string>
};
	["LinkableUpsertGenericPageRelationInput"]: {
	update: ValueTypes["GenericPageLocaleWithoutLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutLinkCreateInput"] | Variable<any, string>
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update: ValueTypes["LinkableUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableCreateInput"] | Variable<any, string>
};
	["FooterLinkUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpsertLinksFirstColumnRelationInput"]: {
	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["FooterLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FooterLinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]: {
	create?: ValueTypes["FooterLinkCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FooterLocaleUpdateLinksSecondColumnRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertLinksSecondColumnRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["FooterLinkUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["FooterLinkUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["FooterLinkUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FooterLocaleUpdateLinksSecondColumnRelationInput"]: {
	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["FooterLinkUpdateInput"] | Variable<any, string>
};
	["FooterLocaleUpsertLinksSecondColumnRelationInput"]: {
	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["FooterLinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FooterLinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertTermsAndConditionsRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertTermsAndConditionsRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateBannerImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateBannerImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertBannerImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertBannerImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateBannerLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateBannerLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertBannerLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertBannerLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateJobsFormEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateJobsFormRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobsFormLocaleUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertJobsFormRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertJobsFormRelationInput"]: {
	update: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateCopyrightLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertCopyrightLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertCopyrightLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateRecommendationFormEntityRelationInput"]: {
	connect?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RecommendationFormLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateRecommendationFormRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RecommendationFormLocaleUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertRecommendationFormRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	yourEmailLabel?: string | undefined | null | Variable<any, string>,
	theirEmailLabel?: string | undefined | null | Variable<any, string>,
	yourName?: string | undefined | null | Variable<any, string>,
	sendBtnLabel?: string | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successSubtitle?: string | undefined | null | Variable<any, string>,
	successButtonClose?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["RecommendationFormLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["RecommendationFormLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutRecommendationFormsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutRecommendationFormsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RecommendationFormLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutRecommendationFormsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutRecommendationFormsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutRecommendationFormsCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpsertRecommendationFormRelationInput"]: {
	update: ValueTypes["RecommendationFormLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RecommendationFormLocaleCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertBannerSecondLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertBannerSecondLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["FooterLocaleUpdateInstagramLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateInstagramLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertInstagramLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertInstagramLinkRelationInput"]: {
	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkCreateInput"] | Variable<any, string>
};
	["LocaleUpsertFootersRelationInput"]: {
	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["FooterLocaleWithoutLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | Variable<any, string>
};
	["GeneralLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutGeneralUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutGeneralCreateInput"] | Variable<any, string>
};
	["GeneralUpsertLocalesRelationInput"]: {
	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GeneralLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GeneralLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GenericPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageEdge"]: AliasType<{
	node?:ValueTypes["GenericPage"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["GenericPageCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GenericPageConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["GenericPageUpdateInput"]: {
	locales?: Array<ValueTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["GenericPageUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GenericPageUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GenericPageUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["GenericPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["GenericPageUpdateLocalesRelationInput"]: {
	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["GenericPageLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["GenericPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageUpsertLocalesRelationInput"]: {
	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["GenericPageLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GenericPageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: boolean | `@${string}`
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: boolean | `@${string}`
}>;
	["ContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentEdge"]: AliasType<{
	node?:ValueTypes["Content"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentBlockCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	references?: Array<ValueTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentWithoutBlocksCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentWithoutBlocksCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockConnectOrCreateContentRelationInput"]: {
	connect: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentWithoutBlocksCreateInput"] | Variable<any, string>
};
	["ContentBlockUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	references?: Array<ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentWithoutBlocksCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentWithoutBlocksUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentBlockUpsertContentRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockUpsertContentRelationInput"]: {
	update: ValueTypes["ContentWithoutBlocksUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentWithoutBlocksCreateInput"] | Variable<any, string>
};
	["ContentReferenceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	primaryText?: string | undefined | null | Variable<any, string>,
	block?: ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkables?: Array<ValueTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	secondaryText?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	textList?: ValueTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["ContentReferenceCreateCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	bonusBanner?: ValueTypes["ContentReferenceCreateBonusBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	sideBySide?: ValueTypes["ContentReferenceCreateSideBySideEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	showBoolean?: boolean | undefined | null | Variable<any, string>,
	isRed?: boolean | undefined | null | Variable<any, string>,
	video?: ValueTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined | null | Variable<any, string>
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentBlockCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceConnectOrCreateBlockRelationInput"]: {
	connect: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | Variable<any, string>
};
	["ContentReferenceUpdateInput"]: {
	type?: ValueTypes["ContentReferenceType"] | undefined | null | Variable<any, string>,
	primaryText?: string | undefined | null | Variable<any, string>,
	block?: ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	linkables?: Array<ValueTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	secondaryText?: string | undefined | null | Variable<any, string>,
	link?: ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	textList?: ValueTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined | null | Variable<any, string>,
	carousel?: ValueTypes["ContentReferenceUpdateCarouselEntityRelationInput"] | undefined | null | Variable<any, string>,
	bonusBanner?: ValueTypes["ContentReferenceUpdateBonusBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	sideBySide?: ValueTypes["ContentReferenceUpdateSideBySideEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	showBoolean?: boolean | undefined | null | Variable<any, string>,
	isRed?: boolean | undefined | null | Variable<any, string>,
	video?: ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ContentReferenceUpsertBlockRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	json?: string | undefined | null | Variable<any, string>,
	content?: ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update: ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | Variable<any, string>
};
	["RedirectConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RedirectEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectEdge"]: AliasType<{
	node?:ValueTypes["Redirect"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["RedirectCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	target?: ValueTypes["RedirectCreateTargetEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RedirectCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutRedirectCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RedirectConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>
};
	["LinkableWithoutRedirectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RedirectConnectOrCreateLinkRelationInput"]: {
	connect: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutRedirectCreateInput"] | Variable<any, string>
};
	["RedirectUpdateInput"]: {
	link?: ValueTypes["RedirectUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	target?: ValueTypes["RedirectUpdateTargetEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RedirectUpdateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LinkableWithoutRedirectCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RedirectConnectOrCreateLinkRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LinkableWithoutRedirectUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RedirectUpsertLinkRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LinkableWithoutRedirectUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	genericPage?: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	businessPage?: ValueTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobPage?: ValueTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePage?: ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null | Variable<any, string>,
	homePageLokal?: ValueTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RedirectUpsertLinkRelationInput"]: {
	update: ValueTypes["LinkableWithoutRedirectUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LinkableWithoutRedirectCreateInput"] | Variable<any, string>
};
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: boolean | `@${string}`
}>;
	["FooterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FooterEdge"]: AliasType<{
	node?:ValueTypes["Footer"],
		__typename?: boolean | `@${string}`
}>;
	["FooterCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["FooterCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FooterLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FooterLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	address?: string | undefined | null | Variable<any, string>,
	ico?: string | undefined | null | Variable<any, string>,
	dic?: string | undefined | null | Variable<any, string>,
	copyright?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	noteSecond?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linksFirstColumn?: Array<ValueTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	linksSecondColumn?: Array<ValueTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	termsAndConditions?: ValueTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined | null | Variable<any, string>,
	form?: string | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerSubtitle?: string | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerLink?: ValueTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	copyrightLink?: ValueTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondBtn?: string | undefined | null | Variable<any, string>,
	recommendationForm?: ValueTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondLink?: ValueTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	instagramLink?: ValueTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutFootersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutFootersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutFootersCreateInput"] | Variable<any, string>
};
	["FooterConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FooterLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["FooterUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["FooterUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["FooterLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FooterUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["FooterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["FooterUpdateLocalesRelationInput"]: {
	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["FooterLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["FooterLocaleWithoutRootUpdateInput"]: {
	email?: string | undefined | null | Variable<any, string>,
	address?: string | undefined | null | Variable<any, string>,
	ico?: string | undefined | null | Variable<any, string>,
	dic?: string | undefined | null | Variable<any, string>,
	copyright?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	noteSecond?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linksFirstColumn?: Array<ValueTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	linksSecondColumn?: Array<ValueTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	termsAndConditions?: ValueTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined | null | Variable<any, string>,
	form?: string | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerSubtitle?: string | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerLink?: ValueTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	copyrightLink?: ValueTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondBtn?: string | undefined | null | Variable<any, string>,
	recommendationForm?: ValueTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondLink?: ValueTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	instagramLink?: ValueTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutFootersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutFootersUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["FooterLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutFootersUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutFootersUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutFootersCreateInput"] | Variable<any, string>
};
	["FooterUpsertLocalesRelationInput"]: {
	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["FooterLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FooterLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["FooterLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	address?: string | undefined | null | Variable<any, string>,
	ico?: string | undefined | null | Variable<any, string>,
	dic?: string | undefined | null | Variable<any, string>,
	copyright?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	noteSecond?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linksFirstColumn?: Array<ValueTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	linksSecondColumn?: Array<ValueTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	termsAndConditions?: ValueTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined | null | Variable<any, string>,
	form?: string | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerSubtitle?: string | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerLink?: ValueTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	copyrightLink?: ValueTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondBtn?: string | undefined | null | Variable<any, string>,
	recommendationForm?: ValueTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondLink?: ValueTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	instagramLink?: ValueTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FooterLocaleUpdateInput"]: {
	email?: string | undefined | null | Variable<any, string>,
	address?: string | undefined | null | Variable<any, string>,
	ico?: string | undefined | null | Variable<any, string>,
	dic?: string | undefined | null | Variable<any, string>,
	copyright?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	noteSecond?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	linksFirstColumn?: Array<ValueTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	linksSecondColumn?: Array<ValueTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined | null | Variable<any, string>,
	termsAndConditions?: ValueTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined | null | Variable<any, string>,
	form?: string | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerSubtitle?: string | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerLink?: ValueTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	copyrightLink?: ValueTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondBtn?: string | undefined | null | Variable<any, string>,
	recommendationForm?: ValueTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerSecondLink?: ValueTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	instagramLink?: ValueTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GenericPageLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderEdge"]: AliasType<{
	node?:ValueTypes["Header"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["HeaderCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HeaderCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	logoMenu?: ValueTypes["HeaderCreateLogoMenuEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HeaderLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeaderLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	menuLabel?: string | undefined | null | Variable<any, string>,
	menuTitle?: string | undefined | null | Variable<any, string>,
	menuText?: string | undefined | null | Variable<any, string>,
	business?: Array<ValueTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined | null | Variable<any, string>,
	lokalEnterprise?: Array<ValueTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessSectionTitle?: string | undefined | null | Variable<any, string>,
	lokalSectionTitle?: string | undefined | null | Variable<any, string>,
	businessLink?: ValueTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	lokalLink?: ValueTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutHeadersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutHeadersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutHeadersCreateInput"] | Variable<any, string>
};
	["HeaderConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HeaderLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["HeaderUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["HeaderUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HeaderUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	logoMenu?: ValueTypes["HeaderUpdateLogoMenuEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["HeaderLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HeaderUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["HeaderLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HeaderUpdateLocalesRelationInput"]: {
	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["HeaderLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	menuLabel?: string | undefined | null | Variable<any, string>,
	menuTitle?: string | undefined | null | Variable<any, string>,
	menuText?: string | undefined | null | Variable<any, string>,
	business?: Array<ValueTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined | null | Variable<any, string>,
	lokalEnterprise?: Array<ValueTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessSectionTitle?: string | undefined | null | Variable<any, string>,
	lokalSectionTitle?: string | undefined | null | Variable<any, string>,
	businessLink?: ValueTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	lokalLink?: ValueTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutHeadersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutHeadersUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HeaderLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutHeadersUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutHeadersUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutHeadersCreateInput"] | Variable<any, string>
};
	["HeaderUpsertLocalesRelationInput"]: {
	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["HeaderLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HeaderLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["HeaderLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	menuLabel?: string | undefined | null | Variable<any, string>,
	menuTitle?: string | undefined | null | Variable<any, string>,
	menuText?: string | undefined | null | Variable<any, string>,
	business?: Array<ValueTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined | null | Variable<any, string>,
	lokalEnterprise?: Array<ValueTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessSectionTitle?: string | undefined | null | Variable<any, string>,
	lokalSectionTitle?: string | undefined | null | Variable<any, string>,
	businessLink?: ValueTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	lokalLink?: ValueTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HeaderLocaleUpdateInput"]: {
	root?: ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	menuLabel?: string | undefined | null | Variable<any, string>,
	menuTitle?: string | undefined | null | Variable<any, string>,
	menuText?: string | undefined | null | Variable<any, string>,
	business?: Array<ValueTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined | null | Variable<any, string>,
	lokalEnterprise?: Array<ValueTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessSectionTitle?: string | undefined | null | Variable<any, string>,
	lokalSectionTitle?: string | undefined | null | Variable<any, string>,
	businessLink?: ValueTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	lokalLink?: ValueTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleEdge"]: AliasType<{
	node?:ValueTypes["Locale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["LocaleUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoDefaultEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultEdge"]: AliasType<{
	node?:ValueTypes["SeoDefault"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["SeoDefaultCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SeoDefaultLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoDefaultConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutSeoDefaultsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutSeoDefaultsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutSeoDefaultsCreateInput"] | Variable<any, string>
};
	["SeoDefaultConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SeoDefaultLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["SeoDefaultUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["SeoDefaultUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["SeoDefaultLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SeoDefaultUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SeoDefaultUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["SeoDefaultUpdateLocalesRelationInput"]: {
	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["SeoDefaultLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["SeoDefaultLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutSeoDefaultsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutSeoDefaultsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SeoDefaultLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutSeoDefaultsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutSeoDefaultsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutSeoDefaultsCreateInput"] | Variable<any, string>
};
	["SeoDefaultUpsertLocalesRelationInput"]: {
	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["SeoDefaultLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SeoDefaultLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["SeoDefaultLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["SeoDefaultLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SeoDefaultLocaleUpdateInput"]: {
	root?: ValueTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageEdge"]: AliasType<{
	node?:ValueTypes["BusinessPage"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	infoBox?: ValueTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BusinessPageLocaleUpdateInput"]: {
	root?: ValueTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	image?: ValueTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	infoBox?: ValueTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["IconConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IconEdge"],
		__typename?: boolean | `@${string}`
}>;
	["IconEdge"]: AliasType<{
	node?:ValueTypes["Icon"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["JobPageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["JobPageCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	contractType?: ValueTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobCity?: ValueTypes["JobPageCreateJobCityEntityRelationInput"] | undefined | null | Variable<any, string>,
	isActive?: boolean | undefined | null | Variable<any, string>,
	jobPosition?: ValueTypes["JobPageCreateJobPositionEntityRelationInput"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	business?: ValueTypes["JobPageCreateBusinessEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	siteType?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	isHiddenFromListing?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageUpdateInput"]: {
	locales?: Array<ValueTypes["JobPageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["JobPageUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	contractType?: ValueTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobCity?: ValueTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined | null | Variable<any, string>,
	isActive?: boolean | undefined | null | Variable<any, string>,
	jobPosition?: ValueTypes["JobPageUpdateJobPositionEntityRelationInput"] | undefined | null | Variable<any, string>,
	publishedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	business?: ValueTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined | null | Variable<any, string>,
	headerColor?: string | undefined | null | Variable<any, string>,
	siteType?: ValueTypes["SiteType"] | undefined | null | Variable<any, string>,
	isHiddenFromListing?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	recruitisJobId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPageLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	keyInfo?: ValueTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	mobileImage?: ValueTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	recruitisJobId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	keyInfo?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["KeyInfoItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["KeyInfoItemCreateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["KeyInfoListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["KeyInfoListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["KeyInfoItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["KeyInfoListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["KeyInfoListWithoutItemsCreateInput"] | Variable<any, string>
};
	["KeyInfoItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	keyInfo?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["KeyInfoItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	icon?: ValueTypes["KeyInfoItemUpdateIconEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["KeyInfoListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["KeyInfoListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["KeyInfoItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["KeyInfoListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["KeyInfoItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["KeyInfoItemUpsertListRelationInput"]: {
	update: ValueTypes["KeyInfoListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["KeyInfoListWithoutItemsCreateInput"] | Variable<any, string>
};
	["KeyInfoListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["KeyInfoListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListEdge"]: AliasType<{
	node?:ValueTypes["KeyInfoList"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContractTypeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeEdge"]: AliasType<{
	node?:ValueTypes["ContractType"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ContractTypeLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ContractTypeLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ContractTypeLocaleUpdateInput"]: {
	type?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["ContractTypeLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["ContractTypeLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobCityEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityEdge"]: AliasType<{
	node?:ValueTypes["JobCity"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobCityLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobCityLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobCityLocaleUpdateInput"]: {
	root?: ValueTypes["JobCityLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobCityLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobPositionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionEdge"]: AliasType<{
	node?:ValueTypes["JobPosition"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["JobPositionCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobs?: Array<ValueTypes["JobPositionCreateJobsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionUpdateInput"]: {
	locales?: Array<ValueTypes["JobPositionUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobs?: Array<ValueTypes["JobPositionUpdateJobsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPositionLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobPositionLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobPositionLocaleUpdateInput"]: {
	type?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobPositionLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobPositionLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GalleryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryEdge"]: AliasType<{
	node?:ValueTypes["Gallery"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageEdge"]: AliasType<{
	node?:ValueTypes["HomePage"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["HomePageCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["HomePageCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HomePageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HomePageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["HomePageUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["HomePageUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["HomePageUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["HomePageLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HomePageUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["HomePageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HomePageUpdateLocalesRelationInput"]: {
	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["HomePageLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["HomePageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageUpsertLocalesRelationInput"]: {
	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["HomePageLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HomePageLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["HomePageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumEdge"]: AliasType<{
	node?:ValueTypes["Medium"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["MediumItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumItemCreateMediumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["MediumListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["MediumListWithoutItemsCreateInput"] | Variable<any, string>
};
	["MediumItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["MediumItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	medium?: ValueTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["MediumListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["MediumListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["MediumItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["MediumListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["MediumItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["MediumListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["MediumItemUpsertListRelationInput"]: {
	update: ValueTypes["MediumListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["MediumListWithoutItemsCreateInput"] | Variable<any, string>
};
	["MediumListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListEdge"]: AliasType<{
	node?:ValueTypes["MediumList"],
		__typename?: boolean | `@${string}`
}>;
	["VideoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VideoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VideoEdge"]: AliasType<{
	node?:ValueTypes["Video"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["TextItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TextItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["TextListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TextListWithoutItemsCreateInput"] | Variable<any, string>
};
	["TextItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["TextItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TextListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TextItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TextListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TextItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["TextListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TextItemUpsertListRelationInput"]: {
	update: ValueTypes["TextListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TextListWithoutItemsCreateInput"] | Variable<any, string>
};
	["TextListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TextListEdge"]: AliasType<{
	node?:ValueTypes["TextList"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CarouselEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselEdge"]: AliasType<{
	node?:ValueTypes["Carousel"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["CarouselItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["CarouselItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	linkUrl?: ValueTypes["CarouselItemCreateLinkUrlEntityRelationInput"] | undefined | null | Variable<any, string>,
	normalAspectRatio?: boolean | undefined | null | Variable<any, string>,
	isImage?: boolean | undefined | null | Variable<any, string>,
	video?: ValueTypes["CarouselItemCreateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CarouselItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["CarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CarouselWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CarouselItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["CarouselWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	background?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	squareImages?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CarouselItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["CarouselWithoutItemsCreateInput"] | Variable<any, string>
};
	["CarouselItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["CarouselItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["CarouselItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	linkUrl?: ValueTypes["CarouselItemUpdateLinkUrlEntityRelationInput"] | undefined | null | Variable<any, string>,
	normalAspectRatio?: boolean | undefined | null | Variable<any, string>,
	isImage?: boolean | undefined | null | Variable<any, string>,
	video?: ValueTypes["CarouselItemUpdateVideoEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CarouselItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["CarouselUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["CarouselWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["CarouselItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["CarouselWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["CarouselItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["CarouselWithoutItemsUpdateInput"]: {
	background?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	squareImages?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CarouselItemUpsertListRelationInput"]: {
	update: ValueTypes["CarouselWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["CarouselWithoutItemsCreateInput"] | Variable<any, string>
};
	["ThemeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ThemeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeEdge"]: AliasType<{
	node?:ValueTypes["Theme"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BonusBannerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerEdge"]: AliasType<{
	node?:ValueTypes["BonusBanner"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["BonusBannerCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BonusBannerLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["BonusBannerConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	tiles?: Array<ValueTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	logo?: ValueTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerName?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BonusBannerLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["BonusBannerUpdateInput"]: {
	locales?: Array<ValueTypes["BonusBannerUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["BonusBannerLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["BonusBannerUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["BonusBannerUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["BonusBannerUpdateLocalesRelationInput"]: {
	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["BonusBannerLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["BonusBannerLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	tiles?: Array<ValueTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	logo?: ValueTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerName?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerUpsertLocalesRelationInput"]: {
	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["BonusBannerLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BonusBannerLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["TileCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	bonusBanner?: ValueTypes["TileCreateBonusBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["TileCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	lightBoxTitle?: string | undefined | null | Variable<any, string>,
	lightBoxText?: string | undefined | null | Variable<any, string>,
	ligthBoxMedia?: ValueTypes["TileCreateLigthBoxMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	lightBoxSectionTitle?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	lightBoxLinkLabel?: string | undefined | null | Variable<any, string>,
	lightBoxForm?: ValueTypes["TileCreateLightBoxFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileCreateBonusBannerEntityRelationInput"]: {
	connect?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BonusBannerLocaleWithoutTilesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileConnectOrCreateBonusBannerRelationInput"] | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleWithoutTilesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerName?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileConnectOrCreateBonusBannerRelationInput"]: {
	connect: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["BonusBannerLocaleWithoutTilesCreateInput"] | Variable<any, string>
};
	["TileUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	bonusBanner?: ValueTypes["TileUpdateBonusBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["TileUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	lightBoxTitle?: string | undefined | null | Variable<any, string>,
	lightBoxText?: string | undefined | null | Variable<any, string>,
	ligthBoxMedia?: ValueTypes["TileUpdateLigthBoxMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	lightBoxSectionTitle?: string | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	lightBoxLinkLabel?: string | undefined | null | Variable<any, string>,
	lightBoxForm?: ValueTypes["TileUpdateLightBoxFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileUpdateBonusBannerEntityRelationInput"]: {
	connect?: ValueTypes["BonusBannerLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["BonusBannerLocaleWithoutTilesCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TileConnectOrCreateBonusBannerRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["BonusBannerLocaleWithoutTilesUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TileUpsertBonusBannerRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["BonusBannerLocaleWithoutTilesUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerName?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TileUpsertBonusBannerRelationInput"]: {
	update: ValueTypes["BonusBannerLocaleWithoutTilesUpdateInput"] | Variable<any, string>,
	create: ValueTypes["BonusBannerLocaleWithoutTilesCreateInput"] | Variable<any, string>
};
	["SideBySideConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SideBySideEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideEdge"]: AliasType<{
	node?:ValueTypes["SideBySide"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["SideBySideItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["SideBySideItemCreateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	formButtonLabel?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["SideBySideItemType"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["SideBySideItemCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["SideBySideItemCreateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	textNew?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["SideBySideUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SideBySideWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SideBySideItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["SideBySideWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	background?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	alignment?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	mediumSize?: ValueTypes["MediumSize"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["SideBySideWithoutItemsCreateInput"] | Variable<any, string>
};
	["SideBySideItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["SideBySideItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	media?: ValueTypes["SideBySideItemUpdateMediaEntityRelationInput"] | undefined | null | Variable<any, string>,
	formButtonLabel?: string | undefined | null | Variable<any, string>,
	type?: ValueTypes["SideBySideItemType"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["SideBySideItemUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	jobsForm?: ValueTypes["SideBySideItemUpdateJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	textNew?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["SideBySideUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["SideBySideWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["SideBySideItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["SideBySideWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["SideBySideItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideWithoutItemsUpdateInput"]: {
	background?: ValueTypes["Background"] | undefined | null | Variable<any, string>,
	alignment?: ValueTypes["ContentAlignment"] | undefined | null | Variable<any, string>,
	mediumSize?: ValueTypes["MediumSize"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SideBySideItemUpsertListRelationInput"]: {
	update: ValueTypes["SideBySideWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["SideBySideWithoutItemsCreateInput"] | Variable<any, string>
};
	["HomePageLokalConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageLokalEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalEdge"]: AliasType<{
	node?:ValueTypes["HomePageLokal"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["HomePageLokalCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["HomePageLokalCreateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["HomePageLokalLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["HomePageLokalConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["HomePageLokalLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["HomePageLokalUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["HomePageLokalUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	theme?: ValueTypes["HomePageLokalUpdateThemeEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["HomePageLokalLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["HomePageLokalUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["HomePageLokalUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["HomePageLokalUpdateLocalesRelationInput"]: {
	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["HomePageLokalLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalUpsertLocalesRelationInput"]: {
	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["HomePageLokalLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["HomePageLokalLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["HomePageLokalLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["HomePageLokalLocaleUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	logo?: ValueTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	button?: ValueTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined | null | Variable<any, string>,
	content?: ValueTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	link?: ValueTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined | null | Variable<any, string>,
	siteSwitcher?: ValueTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null | Variable<any, string>,
	gallery?: ValueTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined | null | Variable<any, string>,
	stickyBar?: ValueTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined | null | Variable<any, string>,
	text?: string | undefined | null | Variable<any, string>,
	ilustration?: ValueTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["SiteSwitcherConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SiteSwitcherEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherEdge"]: AliasType<{
	node?:ValueTypes["SiteSwitcher"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["GalleryItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["GalleryItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GalleryItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GalleryItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["GalleryWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GalleryItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["GalleryWithoutItemsCreateInput"] | Variable<any, string>
};
	["GalleryItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["GalleryItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["GalleryItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GalleryItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["GalleryWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["GalleryItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["GalleryWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["GalleryItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["GalleryWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GalleryItemUpsertListRelationInput"]: {
	update: ValueTypes["GalleryWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["GalleryWithoutItemsCreateInput"] | Variable<any, string>
};
	["JobsFormConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobsFormEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormEdge"]: AliasType<{
	node?:ValueTypes["JobsForm"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["JobsFormCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fileIlustration?: ValueTypes["JobsFormCreateFileIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFormLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFormConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobsFormLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	jobText?: string | undefined | null | Variable<any, string>,
	genericText?: string | undefined | null | Variable<any, string>,
	nameLabel?: string | undefined | null | Variable<any, string>,
	emailLabel?: string | undefined | null | Variable<any, string>,
	telefonLabel?: string | undefined | null | Variable<any, string>,
	fileTitleLabel?: string | undefined | null | Variable<any, string>,
	fileFormatLabel?: string | undefined | null | Variable<any, string>,
	formTextLabel?: string | undefined | null | Variable<any, string>,
	submitLabel?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobsFormLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageTextList?: ValueTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimalize?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successText?: string | undefined | null | Variable<any, string>,
	successBtnLabel?: string | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	successOtherJobsTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsCategoryTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsButtonTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionYesButton?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionNoButton?: string | undefined | null | Variable<any, string>,
	fileRemoveBtnLabel?: string | undefined | null | Variable<any, string>,
	gdprLabel?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobsFormUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["JobsFormUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	fileIlustration?: ValueTypes["JobsFormUpdateFileIlustrationEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["JobsFormLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobsFormUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFormUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobsFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobsFormUpdateLocalesRelationInput"]: {
	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobsFormLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["JobsFormLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	jobText?: string | undefined | null | Variable<any, string>,
	genericText?: string | undefined | null | Variable<any, string>,
	nameLabel?: string | undefined | null | Variable<any, string>,
	emailLabel?: string | undefined | null | Variable<any, string>,
	telefonLabel?: string | undefined | null | Variable<any, string>,
	fileTitleLabel?: string | undefined | null | Variable<any, string>,
	fileFormatLabel?: string | undefined | null | Variable<any, string>,
	formTextLabel?: string | undefined | null | Variable<any, string>,
	submitLabel?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobsFormLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	imageTextList?: ValueTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined | null | Variable<any, string>,
	minimalize?: string | undefined | null | Variable<any, string>,
	logo?: ValueTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successText?: string | undefined | null | Variable<any, string>,
	successBtnLabel?: string | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	successOtherJobsTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsCategoryTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsButtonTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionTitle?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionYesButton?: string | undefined | null | Variable<any, string>,
	successOtherJobsSelectionNoButton?: string | undefined | null | Variable<any, string>,
	fileRemoveBtnLabel?: string | undefined | null | Variable<any, string>,
	gdprLabel?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFormUpsertLocalesRelationInput"]: {
	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobsFormLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFormLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["ImageTextItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageTextItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageTextItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["ImageTextListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageTextListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageTextItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageTextListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageTextListWithoutItemsCreateInput"] | Variable<any, string>
};
	["ImageTextItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageTextItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageTextItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["ImageTextListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageTextListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageTextItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageTextListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageTextItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageTextItemUpsertListRelationInput"]: {
	update: ValueTypes["ImageTextListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageTextListWithoutItemsCreateInput"] | Variable<any, string>
};
	["ImageTextListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageTextListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListEdge"]: AliasType<{
	node?:ValueTypes["ImageTextList"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobsFilterEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterEdge"]: AliasType<{
	node?:ValueTypes["JobsFilter"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["JobsFilterCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["JobsFilterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobsFilterLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	jobPositionLabel?: string | undefined | null | Variable<any, string>,
	jobContractLabel?: string | undefined | null | Variable<any, string>,
	jobCityLabel?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobsFilterLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerFormLabel?: string | undefined | null | Variable<any, string>,
	bannerJobsForm?: ValueTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitle?: string | undefined | null | Variable<any, string>,
	noJobBtnLabel?: string | undefined | null | Variable<any, string>,
	noJobImage?: ValueTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitleForSpecificBusiness?: string | undefined | null | Variable<any, string>,
	deactivatedJob?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutJobsFiltersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutJobsFiltersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutJobsFiltersCreateInput"] | Variable<any, string>
};
	["JobsFilterConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobsFilterLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobsFilterUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["JobsFilterUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["JobsFilterLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobsFilterUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFilterUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["JobsFilterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["JobsFilterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["JobsFilterLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["JobsFilterUpdateLocalesRelationInput"]: {
	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["JobsFilterLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["JobsFilterLocaleWithoutRootUpdateInput"]: {
	jobPositionLabel?: string | undefined | null | Variable<any, string>,
	jobContractLabel?: string | undefined | null | Variable<any, string>,
	jobCityLabel?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobsFilterLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerFormLabel?: string | undefined | null | Variable<any, string>,
	bannerJobsForm?: ValueTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitle?: string | undefined | null | Variable<any, string>,
	noJobBtnLabel?: string | undefined | null | Variable<any, string>,
	noJobImage?: ValueTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitleForSpecificBusiness?: string | undefined | null | Variable<any, string>,
	deactivatedJob?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutJobsFiltersCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobsFilterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutJobsFiltersUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobsFilterLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutJobsFiltersUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	translations?: Array<ValueTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutJobsFiltersUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutJobsFiltersCreateInput"] | Variable<any, string>
};
	["JobsFilterUpsertLocalesRelationInput"]: {
	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["JobsFilterLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobsFilterLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["JobsFilterLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	jobPositionLabel?: string | undefined | null | Variable<any, string>,
	jobContractLabel?: string | undefined | null | Variable<any, string>,
	jobCityLabel?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFilterLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobsFilterLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerFormLabel?: string | undefined | null | Variable<any, string>,
	bannerJobsForm?: ValueTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitle?: string | undefined | null | Variable<any, string>,
	noJobBtnLabel?: string | undefined | null | Variable<any, string>,
	noJobImage?: ValueTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitleForSpecificBusiness?: string | undefined | null | Variable<any, string>,
	deactivatedJob?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobsFilterLocaleUpdateInput"]: {
	jobPositionLabel?: string | undefined | null | Variable<any, string>,
	jobContractLabel?: string | undefined | null | Variable<any, string>,
	jobCityLabel?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["JobsFilterLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["JobsFilterLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerTitle?: string | undefined | null | Variable<any, string>,
	bannerFormLabel?: string | undefined | null | Variable<any, string>,
	bannerJobsForm?: ValueTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined | null | Variable<any, string>,
	bannerImage?: ValueTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitle?: string | undefined | null | Variable<any, string>,
	noJobBtnLabel?: string | undefined | null | Variable<any, string>,
	noJobImage?: ValueTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	noJobTitleForSpecificBusiness?: string | undefined | null | Variable<any, string>,
	deactivatedJob?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["File"]: AliasType<{
	_meta?:ValueTypes["FileMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FileMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FileUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["FileWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["FileWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["FileWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>
};
	["FileOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	url?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	size?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["FileConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FileEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FileEdge"]: AliasType<{
	node?:ValueTypes["File"],
		__typename?: boolean | `@${string}`
}>;
	["FileCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	url?: string | undefined | null | Variable<any, string>,
	size?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["FileUpdateInput"]: {
	url?: string | undefined | null | Variable<any, string>,
	size?: number | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobFormSubscription"]: AliasType<{
	_meta?:ValueTypes["JobFormSubscriptionMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
file?: [{	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>},ValueTypes["File"]],
job?: [{	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
status?: [{	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionStatus"]],
	isSyncedToTabidoo?:boolean | `@${string}`,
	tabidooId?:boolean | `@${string}`,
	isGdprSyncedToTabidoo?:boolean | `@${string}`,
	recruitisAnswerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	message?:ValueTypes["FieldMeta"],
	file?:ValueTypes["FieldMeta"],
	job?:ValueTypes["FieldMeta"],
	status?:ValueTypes["FieldMeta"],
	isSyncedToTabidoo?:ValueTypes["FieldMeta"],
	tabidooId?:ValueTypes["FieldMeta"],
	isGdprSyncedToTabidoo?:ValueTypes["FieldMeta"],
	recruitisAnswerId?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatus"]: AliasType<{
	_meta?:ValueTypes["JobFormSubscriptionStatusMeta"],
	id?:boolean | `@${string}`,
	statusTitle?:boolean | `@${string}`,
	statusColor?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	statusTitle?:ValueTypes["FieldMeta"],
	statusColor?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	statusTitle?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	statusColor?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	file?: ValueTypes["FileUniqueWhere"] | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	phone?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	message?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	file?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>,
	job?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	tabidooId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	isGdprSyncedToTabidoo?: ValueTypes["BooleanCondition"] | undefined | null | Variable<any, string>,
	recruitisAnswerId?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["JobFormSubscriptionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["JobFormSubscriptionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	name?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	phone?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	email?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	message?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	file?: ValueTypes["FileOrderBy"] | undefined | null | Variable<any, string>,
	job?: ValueTypes["JobPageLocaleOrderBy"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["JobFormSubscriptionStatusOrderBy"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	tabidooId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	isGdprSyncedToTabidoo?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	recruitisAnswerId?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionStatusOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	statusTitle?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	statusColor?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobFormSubscriptionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionEdge"]: AliasType<{
	node?:ValueTypes["JobFormSubscription"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	phone?: string | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	message?: string | undefined | null | Variable<any, string>,
	file?: ValueTypes["JobFormSubscriptionCreateFileEntityRelationInput"] | undefined | null | Variable<any, string>,
	job?: ValueTypes["JobFormSubscriptionCreateJobEntityRelationInput"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["JobFormSubscriptionCreateStatusEntityRelationInput"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	isGdprSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	recruitisAnswerId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionCreateFileEntityRelationInput"]: {
	connect?: ValueTypes["FileUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FileCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobFormSubscriptionConnectOrCreateFileRelationInput"] | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionConnectOrCreateFileRelationInput"]: {
	connect: ValueTypes["FileUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["FileCreateInput"] | Variable<any, string>
};
	["JobFormSubscriptionCreateJobEntityRelationInput"]: {
	connect?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPageLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobFormSubscriptionConnectOrCreateJobRelationInput"] | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionConnectOrCreateJobRelationInput"]: {
	connect: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobPageLocaleCreateInput"] | Variable<any, string>
};
	["JobFormSubscriptionCreateStatusEntityRelationInput"]: {
	connect?: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobFormSubscriptionStatusCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobFormSubscriptionConnectOrCreateStatusRelationInput"] | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionStatusUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionStatusCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	statusTitle?: string | undefined | null | Variable<any, string>,
	statusColor?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionConnectOrCreateStatusRelationInput"]: {
	connect: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["JobFormSubscriptionStatusCreateInput"] | Variable<any, string>
};
	["JobFormSubscriptionUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	phone?: string | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	message?: string | undefined | null | Variable<any, string>,
	file?: ValueTypes["JobFormSubscriptionUpdateFileEntityRelationInput"] | undefined | null | Variable<any, string>,
	job?: ValueTypes["JobFormSubscriptionUpdateJobEntityRelationInput"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["JobFormSubscriptionUpdateStatusEntityRelationInput"] | undefined | null | Variable<any, string>,
	isSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	tabidooId?: string | undefined | null | Variable<any, string>,
	isGdprSyncedToTabidoo?: boolean | undefined | null | Variable<any, string>,
	recruitisAnswerId?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionUpdateFileEntityRelationInput"]: {
	connect?: ValueTypes["FileUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["FileCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobFormSubscriptionConnectOrCreateFileRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["FileUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobFormSubscriptionUpsertFileRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionUpsertFileRelationInput"]: {
	update: ValueTypes["FileUpdateInput"] | Variable<any, string>,
	create: ValueTypes["FileCreateInput"] | Variable<any, string>
};
	["JobFormSubscriptionUpdateJobEntityRelationInput"]: {
	connect?: ValueTypes["JobPageLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobPageLocaleCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobFormSubscriptionConnectOrCreateJobRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobPageLocaleUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobFormSubscriptionUpsertJobRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionUpsertJobRelationInput"]: {
	update: ValueTypes["JobPageLocaleUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobPageLocaleCreateInput"] | Variable<any, string>
};
	["JobFormSubscriptionUpdateStatusEntityRelationInput"]: {
	connect?: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["JobFormSubscriptionStatusCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["JobFormSubscriptionConnectOrCreateStatusRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["JobFormSubscriptionStatusUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["JobFormSubscriptionUpsertStatusRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionStatusUpdateInput"]: {
	statusTitle?: string | undefined | null | Variable<any, string>,
	statusColor?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["JobFormSubscriptionUpsertStatusRelationInput"]: {
	update: ValueTypes["JobFormSubscriptionStatusUpdateInput"] | Variable<any, string>,
	create: ValueTypes["JobFormSubscriptionStatusCreateInput"] | Variable<any, string>
};
	["ImageList"]: AliasType<{
	_meta?:ValueTypes["ImageListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageListItem"]],
itemsByImage?: [{	by: ValueTypes["ImageListItemsByImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageListItem"]],
paginateItems?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItem"]: AliasType<{
	_meta?:ValueTypes["ImageListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageList"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ImageListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ImageListWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>
};
	["ImageListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["IntCondition"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["ImageListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["ImageListItemWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>
};
	["ImageListItemOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	order?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageListOrderBy"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageOrderBy"] | undefined | null | Variable<any, string>
};
	["ImageListOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["ImageListItemsByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ImageListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemEdge"]: AliasType<{
	node?:ValueTypes["ImageListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ImageListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>
};
	["ImageListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListEdge"]: AliasType<{
	node?:ValueTypes["ImageList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	items?: Array<ValueTypes["ImageListCreateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageListConnectOrCreateItemsRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ImageListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageListItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageListItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageListItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageListItemConnectOrCreateImageRelationInput"]: {
	connect: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ImageListConnectOrCreateItemsRelationInput"]: {
	connect: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageListItemWithoutListCreateInput"] | Variable<any, string>
};
	["ImageListUpdateInput"]: {
	items?: Array<ValueTypes["ImageListUpdateItemsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ImageListItemWithoutListCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageListUpdateItemsRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageListUpsertItemsRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["ImageListUpdateItemsRelationInput"]: {
	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["ImageListItemWithoutListUpdateInput"] | Variable<any, string>
};
	["ImageListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageListItemUpdateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageListItemConnectOrCreateImageRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageListItemUpsertImageRelationInput"] | undefined | null | Variable<any, string>,
	disconnect?: boolean | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageListItemUpsertImageRelationInput"]: {
	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageCreateInput"] | Variable<any, string>
};
	["ImageListUpsertItemsRelationInput"]: {
	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["ImageListItemWithoutListUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageListItemWithoutListCreateInput"] | Variable<any, string>
};
	["ImageListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageListItemCreateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageListItemCreateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["ImageListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>
};
	["ImageListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageListItemConnectOrCreateListRelationInput"]: {
	connect: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["ImageListWithoutItemsCreateInput"] | Variable<any, string>
};
	["ImageListItemUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	list?: ValueTypes["ImageListItemUpdateListEntityRelationInput"] | undefined | null | Variable<any, string>,
	image?: ValueTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageListItemUpdateListEntityRelationInput"]: {
	connect?: ValueTypes["ImageListUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["ImageListWithoutItemsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["ImageListItemConnectOrCreateListRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["ImageListWithoutItemsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["ImageListItemUpsertListRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["ImageListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["ImageListItemUpsertListRelationInput"]: {
	update: ValueTypes["ImageListWithoutItemsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["ImageListWithoutItemsCreateInput"] | Variable<any, string>
};
	["JobFormSubscriptionStatusConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["JobFormSubscriptionStatusEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusEdge"]: AliasType<{
	node?:ValueTypes["JobFormSubscriptionStatus"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	root?: ValueTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	cornerBanner?: ValueTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["GeneralLocaleUpdateInput"]: {
	root?: ValueTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	seo?: ValueTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null | Variable<any, string>,
	cornerBanner?: ValueTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["StickyBarConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StickyBarEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarEdge"]: AliasType<{
	node?:ValueTypes["StickyBar"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RecommendationFormEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormEdge"]: AliasType<{
	node?:ValueTypes["RecommendationForm"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["RecommendationFormCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["RecommendationFormCreateSuccessImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["RecommendationFormLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["RecommendationFormConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RecommendationFormLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	yourEmailLabel?: string | undefined | null | Variable<any, string>,
	theirEmailLabel?: string | undefined | null | Variable<any, string>,
	yourName?: string | undefined | null | Variable<any, string>,
	sendBtnLabel?: string | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successSubtitle?: string | undefined | null | Variable<any, string>,
	successButtonClose?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["RecommendationFormLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["RecommendationFormLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["RecommendationFormUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["RecommendationFormUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	successImage?: ValueTypes["RecommendationFormUpdateSuccessImageEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["RecommendationFormLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["RecommendationFormUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["RecommendationFormUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["RecommendationFormUpdateLocalesRelationInput"]: {
	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["RecommendationFormLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["RecommendationFormLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	subtitle?: string | undefined | null | Variable<any, string>,
	yourEmailLabel?: string | undefined | null | Variable<any, string>,
	theirEmailLabel?: string | undefined | null | Variable<any, string>,
	yourName?: string | undefined | null | Variable<any, string>,
	sendBtnLabel?: string | undefined | null | Variable<any, string>,
	successTitle?: string | undefined | null | Variable<any, string>,
	successSubtitle?: string | undefined | null | Variable<any, string>,
	successButtonClose?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["RecommendationFormLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormUpsertLocalesRelationInput"]: {
	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["RecommendationFormLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["RecommendationFormLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["RecommendationFormSubscription"]: AliasType<{
	_meta?:ValueTypes["RecommendationFormSubscriptionMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	yourEmail?:boolean | `@${string}`,
	theirEmail?:boolean | `@${string}`,
	yourName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	yourEmail?:ValueTypes["FieldMeta"],
	theirEmail?:ValueTypes["FieldMeta"],
	yourName?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>
};
	["RecommendationFormSubscriptionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null | Variable<any, string>,
	yourEmail?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	theirEmail?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	yourName?: ValueTypes["StringCondition"] | undefined | null | Variable<any, string>,
	and?: Array<ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	or?: Array<ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null> | undefined | null | Variable<any, string>,
	not?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>
};
	["RecommendationFormSubscriptionOrderBy"]: {
	_random?: boolean | undefined | null | Variable<any, string>,
	_randomSeeded?: number | undefined | null | Variable<any, string>,
	id?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	yourEmail?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	theirEmail?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>,
	yourName?: ValueTypes["OrderDirection"] | undefined | null | Variable<any, string>
};
	["RecommendationFormSubscriptionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RecommendationFormSubscriptionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionEdge"]: AliasType<{
	node?:ValueTypes["RecommendationFormSubscription"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	yourEmail?: string | undefined | null | Variable<any, string>,
	theirEmail?: string | undefined | null | Variable<any, string>,
	yourName?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["RecommendationFormSubscriptionUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	yourEmail?: string | undefined | null | Variable<any, string>,
	theirEmail?: string | undefined | null | Variable<any, string>,
	yourName?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InfoBoxEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxEdge"]: AliasType<{
	node?:ValueTypes["InfoBox"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	address?: string | undefined | null | Variable<any, string>,
	web?: string | undefined | null | Variable<any, string>,
	instagram?: string | undefined | null | Variable<any, string>,
	facebook?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoBoxLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["InfoBoxLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	openingHours?: ValueTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined | null | Variable<any, string>,
	addressLink?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["InfoBoxLocaleUpdateInput"]: {
	address?: string | undefined | null | Variable<any, string>,
	web?: string | undefined | null | Variable<any, string>,
	instagram?: string | undefined | null | Variable<any, string>,
	facebook?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["InfoBoxLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["InfoBoxLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	openingHours?: ValueTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined | null | Variable<any, string>,
	addressLink?: string | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationEdge"]: AliasType<{
	node?:ValueTypes["Translation"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	order?: number | undefined | null | Variable<any, string>,
	key?: string | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["TranslationCreateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isTextarea?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["TranslationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["TranslationLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationConnectOrCreateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	value?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["TranslationLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutTranslationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>
};
	["LocaleWithoutTranslationsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutTranslationsCreateInput"] | Variable<any, string>
};
	["TranslationConnectOrCreateLocalesRelationInput"]: {
	connect: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,
	create: ValueTypes["TranslationLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["TranslationUpdateInput"]: {
	order?: number | undefined | null | Variable<any, string>,
	key?: string | undefined | null | Variable<any, string>,
	locales?: Array<ValueTypes["TranslationUpdateLocalesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	isTextarea?: boolean | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["TranslationLocaleWithoutRootCreateInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["TranslationUpdateLocalesRelationInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationUpsertLocalesRelationInput"] | undefined | null | Variable<any, string>,
	connect?: ValueTypes["TranslationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	disconnect?: ValueTypes["TranslationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	delete?: ValueTypes["TranslationLocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	alias?: string | undefined | null | Variable<any, string>
};
	["TranslationUpdateLocalesRelationInput"]: {
	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,
	data: ValueTypes["TranslationLocaleWithoutRootUpdateInput"] | Variable<any, string>
};
	["TranslationLocaleWithoutRootUpdateInput"]: {
	value?: string | undefined | null | Variable<any, string>,
	locale?: ValueTypes["TranslationLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null | Variable<any, string>,
	create?: ValueTypes["LocaleWithoutTranslationsCreateInput"] | undefined | null | Variable<any, string>,
	connectOrCreate?: ValueTypes["TranslationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null | Variable<any, string>,
	update?: ValueTypes["LocaleWithoutTranslationsUpdateInput"] | undefined | null | Variable<any, string>,
	upsert?: ValueTypes["TranslationLocaleUpsertLocaleRelationInput"] | undefined | null | Variable<any, string>,
	delete?: boolean | undefined | null | Variable<any, string>
};
	["LocaleWithoutTranslationsUpdateInput"]: {
	code?: string | undefined | null | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	footers?: Array<ValueTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	genericPages?: Array<ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	headers?: Array<ValueTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	seoDefaults?: Array<ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	businessPages?: Array<ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPages?: Array<ValueTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	contractTypes?: Array<ValueTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobCities?: Array<ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobPositions?: Array<ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePages?: Array<ValueTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	bonusBanners?: Array<ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	homePageLokals?: Array<ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsForms?: Array<ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	jobsFilters?: Array<ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null | Variable<any, string>,
	general?: Array<ValueTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null | Variable<any, string>,
	recommendationForms?: Array<ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null | Variable<any, string>,
	infoBoxes?: Array<ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationLocaleUpsertLocaleRelationInput"]: {
	update: ValueTypes["LocaleWithoutTranslationsUpdateInput"] | Variable<any, string>,
	create: ValueTypes["LocaleWithoutTranslationsCreateInput"] | Variable<any, string>
};
	["TranslationUpsertLocalesRelationInput"]: {
	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,
	update: ValueTypes["TranslationLocaleWithoutRootUpdateInput"] | Variable<any, string>,
	create: ValueTypes["TranslationLocaleWithoutRootCreateInput"] | Variable<any, string>
};
	["TranslationLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null | Variable<any, string>,
	value?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["TranslationLocaleCreateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["TranslationLocaleCreateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["TranslationLocaleUpdateInput"]: {
	value?: string | undefined | null | Variable<any, string>,
	root?: ValueTypes["TranslationLocaleUpdateRootEntityRelationInput"] | undefined | null | Variable<any, string>,
	locale?: ValueTypes["TranslationLocaleUpdateLocaleEntityRelationInput"] | undefined | null | Variable<any, string>,
	_dummy_field_?: boolean | undefined | null | Variable<any, string>
};
	["CornerBannerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CornerBannerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerEdge"]: AliasType<{
	node?:ValueTypes["CornerBanner"],
		__typename?: boolean | `@${string}`
}>;
	["QueryTransaction"]: AliasType<{
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:boolean | `@${string}`,
getGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>},ValueTypes["General"]],
listGeneral?: [{	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["General"]],
paginateGeneral?: [{	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralConnection"]],
validateCreateGeneral?: [{	data: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GeneralUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["Image"]],
listImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Image"]],
paginateImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
listGenericPage?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPage"]],
paginateGenericPage?: [{	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
listLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkableUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
listSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Seo"]],
paginateSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SeoUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["Content"]],
listContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Content"]],
paginateContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContentReferenceLinkableItem?: [{	by: ValueTypes["ContentReferenceLinkableItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
listContentReferenceLinkableItem?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItem"]],
paginateContentReferenceLinkableItem?: [{	filter?: ValueTypes["ContentReferenceLinkableItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceLinkableItemConnection"]],
getRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>},ValueTypes["Redirect"]],
listRedirect?: [{	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RedirectOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RedirectOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data: ValueTypes["RedirectCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RedirectUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["Link"]],
listLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Link"]],
paginateLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LinkUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>},ValueTypes["Footer"]],
listFooter?: [{	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Footer"]],
paginateFooter?: [{	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FooterUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFooterLink?: [{	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLink"]],
listFooterLink?: [{	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLinkOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLink"]],
paginateFooterLink?: [{	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLinkOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLinkConnection"]],
validateCreateFooterLink?: [{	data: ValueTypes["FooterLinkCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFooterLink?: [{	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FooterLinkUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
listFooterLocale?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FooterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
listGenericPageLocale?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocale"]],
paginateGenericPageLocale?: [{	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GenericPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleConnection"]],
validateCreateGenericPageLocale?: [{	data: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>},ValueTypes["Header"]],
listHeader?: [{	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Header"]],
paginateHeader?: [{	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeaderUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HeaderLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
listLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Locale"]],
paginateLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["LocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSeoDefault?: [{	by: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefault"]],
listSeoDefault?: [{	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefault"]],
paginateSeoDefault?: [{	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultConnection"]],
validateCreateSeoDefault?: [{	data: ValueTypes["SeoDefaultCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSeoDefault?: [{	by: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SeoDefaultUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSeoDefaultLocale?: [{	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocale"]],
listSeoDefaultLocale?: [{	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocale"]],
paginateSeoDefaultLocale?: [{	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SeoDefaultLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocaleConnection"]],
validateCreateSeoDefaultLocale?: [{	data: ValueTypes["SeoDefaultLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSeoDefaultLocale?: [{	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SeoDefaultLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getBusiness?: [{	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>},ValueTypes["Business"]],
listBusiness?: [{	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Business"]],
paginateBusiness?: [{	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessConnection"]],
validateCreateBusiness?: [{	data: ValueTypes["BusinessCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateBusiness?: [{	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,	data: ValueTypes["BusinessUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getBusinessPage?: [{	by: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPage"]],
listBusinessPage?: [{	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPage"]],
paginateBusinessPage?: [{	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPageConnection"]],
validateCreateBusinessPage?: [{	data: ValueTypes["BusinessPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateBusinessPage?: [{	by: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["BusinessPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getBusinessPageLocale?: [{	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
listBusinessPageLocale?: [{	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocale"]],
paginateBusinessPageLocale?: [{	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BusinessPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocaleConnection"]],
validateCreateBusinessPageLocale?: [{	data: ValueTypes["BusinessPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateBusinessPageLocale?: [{	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["BusinessPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getIcon?: [{	by: ValueTypes["IconUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>},ValueTypes["Icon"]],
listIcon?: [{	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["IconOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Icon"]],
paginateIcon?: [{	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["IconOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["IconConnection"]],
validateCreateIcon?: [{	data: ValueTypes["IconCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateIcon?: [{	by: ValueTypes["IconUniqueWhere"] | Variable<any, string>,	data: ValueTypes["IconUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobPage?: [{	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPage"]],
listJobPage?: [{	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPage"]],
paginateJobPage?: [{	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageConnection"]],
validateCreateJobPage?: [{	data: ValueTypes["JobPageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobPage?: [{	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobPageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobPageLocale?: [{	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
listJobPageLocale?: [{	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageLocale"]],
paginateJobPageLocale?: [{	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPageLocaleConnection"]],
validateCreateJobPageLocale?: [{	data: ValueTypes["JobPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobPageLocale?: [{	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getKeyInfoItem?: [{	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["KeyInfoItem"]],
listKeyInfoItem?: [{	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["KeyInfoItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["KeyInfoItem"]],
paginateKeyInfoItem?: [{	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["KeyInfoItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["KeyInfoItemConnection"]],
validateCreateKeyInfoItem?: [{	data: ValueTypes["KeyInfoItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateKeyInfoItem?: [{	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["KeyInfoItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getKeyInfoList?: [{	by: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>},ValueTypes["KeyInfoList"]],
listKeyInfoList?: [{	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["KeyInfoListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["KeyInfoList"]],
paginateKeyInfoList?: [{	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["KeyInfoListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["KeyInfoListConnection"]],
validateCreateKeyInfoList?: [{	data: ValueTypes["KeyInfoListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateKeyInfoList?: [{	by: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["KeyInfoListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContractType?: [{	by: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractType"]],
listContractType?: [{	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContractType"]],
paginateContractType?: [{	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContractTypeConnection"]],
validateCreateContractType?: [{	data: ValueTypes["ContractTypeCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContractType?: [{	by: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContractTypeUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getContractTypeLocale?: [{	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocale"]],
listContractTypeLocale?: [{	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocale"]],
paginateContractTypeLocale?: [{	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ContractTypeLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocaleConnection"]],
validateCreateContractTypeLocale?: [{	data: ValueTypes["ContractTypeLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateContractTypeLocale?: [{	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ContractTypeLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobCity?: [{	by: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCity"]],
listJobCity?: [{	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobCity"]],
paginateJobCity?: [{	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobCityConnection"]],
validateCreateJobCity?: [{	data: ValueTypes["JobCityCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobCity?: [{	by: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobCityUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobCityLocale?: [{	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCityLocale"]],
listJobCityLocale?: [{	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobCityLocale"]],
paginateJobCityLocale?: [{	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobCityLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobCityLocaleConnection"]],
validateCreateJobCityLocale?: [{	data: ValueTypes["JobCityLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobCityLocale?: [{	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobCityLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobPosition?: [{	by: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPosition"]],
listJobPosition?: [{	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPosition"]],
paginateJobPosition?: [{	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPositionConnection"]],
validateCreateJobPosition?: [{	data: ValueTypes["JobPositionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobPosition?: [{	by: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobPositionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobPositionLocale?: [{	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocale"]],
listJobPositionLocale?: [{	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocale"]],
paginateJobPositionLocale?: [{	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobPositionLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocaleConnection"]],
validateCreateJobPositionLocale?: [{	data: ValueTypes["JobPositionLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobPositionLocale?: [{	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobPositionLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGallery?: [{	by: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>},ValueTypes["Gallery"]],
listGallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GalleryOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GalleryOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data: ValueTypes["GalleryCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GalleryUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePage"]],
listHomePage?: [{	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data: ValueTypes["HomePageCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HomePageUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHomePageLocale?: [{	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
listHomePageLocale?: [{	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLocale"]],
paginateHomePageLocale?: [{	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLocaleConnection"]],
validateCreateHomePageLocale?: [{	data: ValueTypes["HomePageLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHomePageLocale?: [{	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HomePageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>},ValueTypes["Medium"]],
listMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Medium"]],
paginateMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumItem"]],
listMediumItem?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItem"]],
paginateMediumItem?: [{	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumItemConnection"]],
validateCreateMediumItem?: [{	data: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
listMediumList?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["MediumList"]],
paginateMediumList?: [{	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["MediumListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["MediumListConnection"]],
validateCreateMediumList?: [{	data: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["MediumListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["Video"]],
listVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Video"]],
paginateVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	data: ValueTypes["VideoUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextItem"]],
listTextItem?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TextItem"]],
paginateTextItem?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TextItemConnection"]],
validateCreateTextItem?: [{	data: ValueTypes["TextItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TextItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTextList?: [{	by: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextList"]],
listTextList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TextList"]],
paginateTextList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TextListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TextListConnection"]],
validateCreateTextList?: [{	data: ValueTypes["TextListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTextList?: [{	by: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TextListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCarousel?: [{	by: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["Carousel"]],
listCarousel?: [{	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CarouselOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Carousel"]],
paginateCarousel?: [{	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CarouselOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CarouselConnection"]],
validateCreateCarousel?: [{	data: ValueTypes["CarouselCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCarousel?: [{	by: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CarouselUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCarouselItem?: [{	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CarouselItem"]],
listCarouselItem?: [{	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CarouselItem"]],
paginateCarouselItem?: [{	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CarouselItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CarouselItemConnection"]],
validateCreateCarouselItem?: [{	data: ValueTypes["CarouselItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCarouselItem?: [{	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTheme?: [{	by: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>},ValueTypes["Theme"]],
listTheme?: [{	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ThemeOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Theme"]],
paginateTheme?: [{	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ThemeOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ThemeConnection"]],
validateCreateTheme?: [{	data: ValueTypes["ThemeCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTheme?: [{	by: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ThemeUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getBonusBanner?: [{	by: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBanner"]],
listBonusBanner?: [{	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBanner"]],
paginateBonusBanner?: [{	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBannerConnection"]],
validateCreateBonusBanner?: [{	data: ValueTypes["BonusBannerCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateBonusBanner?: [{	by: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,	data: ValueTypes["BonusBannerUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getBonusBannerLocale?: [{	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
listBonusBannerLocale?: [{	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocale"]],
paginateBonusBannerLocale?: [{	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["BonusBannerLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocaleConnection"]],
validateCreateBonusBannerLocale?: [{	data: ValueTypes["BonusBannerLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateBonusBannerLocale?: [{	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["BonusBannerLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTile?: [{	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>},ValueTypes["Tile"]],
listTile?: [{	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Tile"]],
paginateTile?: [{	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TileOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TileConnection"]],
validateCreateTile?: [{	data: ValueTypes["TileCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTile?: [{	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TileUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSideBySide?: [{	by: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySide"]],
listSideBySide?: [{	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SideBySideOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SideBySide"]],
paginateSideBySide?: [{	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SideBySideOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SideBySideConnection"]],
validateCreateSideBySide?: [{	data: ValueTypes["SideBySideCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSideBySide?: [{	by: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SideBySideUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSideBySideItem?: [{	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySideItem"]],
listSideBySideItem?: [{	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SideBySideItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SideBySideItem"]],
paginateSideBySideItem?: [{	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SideBySideItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SideBySideItemConnection"]],
validateCreateSideBySideItem?: [{	data: ValueTypes["SideBySideItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSideBySideItem?: [{	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SideBySideItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHomePageLokal?: [{	by: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokal"]],
listHomePageLokal?: [{	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokal"]],
paginateHomePageLokal?: [{	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalConnection"]],
validateCreateHomePageLokal?: [{	data: ValueTypes["HomePageLokalCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHomePageLokal?: [{	by: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HomePageLokalUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getHomePageLokalLocale?: [{	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
listHomePageLokalLocale?: [{	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocale"]],
paginateHomePageLokalLocale?: [{	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["HomePageLokalLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocaleConnection"]],
validateCreateHomePageLokalLocale?: [{	data: ValueTypes["HomePageLokalLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateHomePageLokalLocale?: [{	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["HomePageLokalLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getSiteSwitcher?: [{	by: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>},ValueTypes["SiteSwitcher"]],
listSiteSwitcher?: [{	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SiteSwitcherOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["SiteSwitcher"]],
paginateSiteSwitcher?: [{	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["SiteSwitcherOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["SiteSwitcherConnection"]],
validateCreateSiteSwitcher?: [{	data: ValueTypes["SiteSwitcherCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateSiteSwitcher?: [{	by: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,	data: ValueTypes["SiteSwitcherUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data: ValueTypes["GalleryItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GalleryItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobsForm?: [{	by: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsForm"]],
listJobsForm?: [{	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsForm"]],
paginateJobsForm?: [{	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFormConnection"]],
validateCreateJobsForm?: [{	data: ValueTypes["JobsFormCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobsForm?: [{	by: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobsFormUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobsFormLocale?: [{	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
listJobsFormLocale?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocale"]],
paginateJobsFormLocale?: [{	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocaleConnection"]],
validateCreateJobsFormLocale?: [{	data: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobsFormLocale?: [{	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageTextItem?: [{	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextItem"]],
listImageTextItem?: [{	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageTextItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageTextItem"]],
paginateImageTextItem?: [{	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageTextItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageTextItemConnection"]],
validateCreateImageTextItem?: [{	data: ValueTypes["ImageTextItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageTextItem?: [{	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageTextItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageTextList?: [{	by: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextList"]],
listImageTextList?: [{	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageTextListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageTextList"]],
paginateImageTextList?: [{	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageTextListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageTextListConnection"]],
validateCreateImageTextList?: [{	data: ValueTypes["ImageTextListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageTextList?: [{	by: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageTextListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobsFilter?: [{	by: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilter"]],
listJobsFilter?: [{	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilter"]],
paginateJobsFilter?: [{	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilterConnection"]],
validateCreateJobsFilter?: [{	data: ValueTypes["JobsFilterCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobsFilter?: [{	by: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobsFilterUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobsFilterLocale?: [{	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
listJobsFilterLocale?: [{	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocale"]],
paginateJobsFilterLocale?: [{	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobsFilterLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocaleConnection"]],
validateCreateJobsFilterLocale?: [{	data: ValueTypes["JobsFilterLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobsFilterLocale?: [{	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobsFilterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getFile?: [{	by: ValueTypes["FileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>},ValueTypes["File"]],
listFile?: [{	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FileOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["File"]],
paginateFile?: [{	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["FileOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["FileConnection"]],
validateCreateFile?: [{	data: ValueTypes["FileCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateFile?: [{	by: ValueTypes["FileUniqueWhere"] | Variable<any, string>,	data: ValueTypes["FileUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobFormSubscription?: [{	by: ValueTypes["JobFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscription"]],
listJobFormSubscription?: [{	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobFormSubscriptionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscription"]],
paginateJobFormSubscription?: [{	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobFormSubscriptionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionConnection"]],
validateCreateJobFormSubscription?: [{	data: ValueTypes["JobFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobFormSubscription?: [{	by: ValueTypes["JobFormSubscriptionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobFormSubscriptionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageList?: [{	by: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageList"]],
listImageList?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageListOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageList"]],
paginateImageList?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageListOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageListConnection"]],
validateCreateImageList?: [{	data: ValueTypes["ImageListCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageListUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageListItem"]],
listImageListItem?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["ImageListItem"]],
paginateImageListItem?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["ImageListItemConnection"]],
validateCreateImageListItem?: [{	data: ValueTypes["ImageListItemCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,	data: ValueTypes["ImageListItemUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getJobFormSubscriptionStatus?: [{	by: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionStatus"]],
listJobFormSubscriptionStatus?: [{	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobFormSubscriptionStatusOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionStatus"]],
paginateJobFormSubscriptionStatus?: [{	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["JobFormSubscriptionStatusOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionStatusConnection"]],
validateCreateJobFormSubscriptionStatus?: [{	data: ValueTypes["JobFormSubscriptionStatusCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateJobFormSubscriptionStatus?: [{	by: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,	data: ValueTypes["JobFormSubscriptionStatusUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
listGeneralLocale?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocale"]],
paginateGeneralLocale?: [{	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["GeneralLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleConnection"]],
validateCreateGeneralLocale?: [{	data: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getStickyBar?: [{	by: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>},ValueTypes["StickyBar"]],
listStickyBar?: [{	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StickyBarOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["StickyBar"]],
paginateStickyBar?: [{	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["StickyBarOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["StickyBarConnection"]],
validateCreateStickyBar?: [{	data: ValueTypes["StickyBarCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateStickyBar?: [{	by: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,	data: ValueTypes["StickyBarUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRecommendationForm?: [{	by: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationForm"]],
listRecommendationForm?: [{	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationForm"]],
paginateRecommendationForm?: [{	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormConnection"]],
validateCreateRecommendationForm?: [{	data: ValueTypes["RecommendationFormCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRecommendationForm?: [{	by: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RecommendationFormUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRecommendationFormLocale?: [{	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocale"]],
listRecommendationFormLocale?: [{	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocale"]],
paginateRecommendationFormLocale?: [{	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocaleConnection"]],
validateCreateRecommendationFormLocale?: [{	data: ValueTypes["RecommendationFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRecommendationFormLocale?: [{	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RecommendationFormLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getRecommendationFormSubscription?: [{	by: ValueTypes["RecommendationFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormSubscription"]],
listRecommendationFormSubscription?: [{	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormSubscriptionOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormSubscription"]],
paginateRecommendationFormSubscription?: [{	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["RecommendationFormSubscriptionOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormSubscriptionConnection"]],
validateCreateRecommendationFormSubscription?: [{	data: ValueTypes["RecommendationFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateRecommendationFormSubscription?: [{	by: ValueTypes["RecommendationFormSubscriptionUniqueWhere"] | Variable<any, string>,	data: ValueTypes["RecommendationFormSubscriptionUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getInfoBox?: [{	by: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBox"]],
listInfoBox?: [{	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBox"]],
paginateInfoBox?: [{	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBoxConnection"]],
validateCreateInfoBox?: [{	data: ValueTypes["InfoBoxCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateInfoBox?: [{	by: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,	data: ValueTypes["InfoBoxUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getInfoBoxLocale?: [{	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocale"]],
listInfoBoxLocale?: [{	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocale"]],
paginateInfoBoxLocale?: [{	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["InfoBoxLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocaleConnection"]],
validateCreateInfoBoxLocale?: [{	data: ValueTypes["InfoBoxLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateInfoBoxLocale?: [{	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["InfoBoxLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslation?: [{	by: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>},ValueTypes["Translation"]],
listTranslation?: [{	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["Translation"]],
paginateTranslation?: [{	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationConnection"]],
validateCreateTranslation?: [{	data: ValueTypes["TranslationCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslation?: [{	by: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getTranslationLocale?: [{	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationLocale"]],
listTranslationLocale?: [{	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationLocale"]],
paginateTranslationLocale?: [{	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["TranslationLocaleOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["TranslationLocaleConnection"]],
validateCreateTranslationLocale?: [{	data: ValueTypes["TranslationLocaleCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateTranslationLocale?: [{	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,	data: ValueTypes["TranslationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
getCornerBanner?: [{	by: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["CornerBanner"]],
listCornerBanner?: [{	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CornerBannerOrderBy"]> | undefined | null | Variable<any, string>,	offset?: number | undefined | null | Variable<any, string>,	limit?: number | undefined | null | Variable<any, string>},ValueTypes["CornerBanner"]],
paginateCornerBanner?: [{	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>,	orderBy?: Array<ValueTypes["CornerBannerOrderBy"]> | undefined | null | Variable<any, string>,	skip?: number | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>},ValueTypes["CornerBannerConnection"]],
validateCreateCornerBanner?: [{	data: ValueTypes["CornerBannerCreateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
validateUpdateCornerBanner?: [{	by: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,	data: ValueTypes["CornerBannerUpdateInput"] | Variable<any, string>},ValueTypes["_ValidationResult"]],
		__typename?: boolean | `@${string}`
}>;
	["Info"]: AliasType<{
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mutation"]: AliasType<{
generateUploadUrl?: [{	input?: ValueTypes["S3GenerateSignedUploadInput"] | undefined | null | Variable<any, string>},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey: string | Variable<any, string>,	expiration?: number | undefined | null | Variable<any, string>},ValueTypes["S3SignedRead"]],
createGeneral?: [{	data: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["GeneralCreateResult"]],
deleteGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralDeleteResult"]],
updateGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GeneralUpdateInput"] | Variable<any, string>},ValueTypes["GeneralUpdateResult"]],
upsertGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GeneralUpdateInput"] | Variable<any, string>,	create: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["GeneralUpsertResult"]],
createImage?: [{	data: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageUpdateInput"] | Variable<any, string>},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["ImageUpsertResult"]],
createGenericPage?: [{	data: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["GenericPageUpsertResult"]],
createLinkable?: [{	data: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkableUpdateInput"] | Variable<any, string>},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkableUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["LinkableUpsertResult"]],
createSeo?: [{	data: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SeoUpdateInput"] | Variable<any, string>},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,	create: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["SeoUpsertResult"]],
createContent?: [{	data: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentUpdateInput"] | Variable<any, string>},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["ContentReferenceUpsertResult"]],
createRedirect?: [{	data: ValueTypes["RedirectCreateInput"] | Variable<any, string>},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RedirectUpdateInput"] | Variable<any, string>},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RedirectUpdateInput"] | Variable<any, string>,	create: ValueTypes["RedirectCreateInput"] | Variable<any, string>},ValueTypes["RedirectUpsertResult"]],
createLink?: [{	data: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkUpdateInput"] | Variable<any, string>},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["LinkUpsertResult"]],
createFooter?: [{	data: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FooterUpdateInput"] | Variable<any, string>},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FooterUpdateInput"] | Variable<any, string>,	create: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["FooterUpsertResult"]],
createFooterLink?: [{	data: ValueTypes["FooterLinkCreateInput"] | Variable<any, string>},ValueTypes["FooterLinkCreateResult"]],
deleteFooterLink?: [{	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLinkDeleteResult"]],
updateFooterLink?: [{	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FooterLinkUpdateInput"] | Variable<any, string>},ValueTypes["FooterLinkUpdateResult"]],
upsertFooterLink?: [{	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FooterLinkUpdateInput"] | Variable<any, string>,	create: ValueTypes["FooterLinkCreateInput"] | Variable<any, string>},ValueTypes["FooterLinkUpsertResult"]],
createFooterLocale?: [{	data: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["FooterLocaleUpsertResult"]],
createGenericPageLocale?: [{	data: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleCreateResult"]],
deleteGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleDeleteResult"]],
updateGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleUpdateResult"]],
upsertGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleUpsertResult"]],
createHeader?: [{	data: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeaderUpdateInput"] | Variable<any, string>},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeaderUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["HeaderUpsertResult"]],
createHeaderLocale?: [{	data: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleUpsertResult"]],
createLocale?: [{	data: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LocaleUpdateInput"] | Variable<any, string>},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["LocaleUpsertResult"]],
createSeoDefault?: [{	data: ValueTypes["SeoDefaultCreateInput"] | Variable<any, string>},ValueTypes["SeoDefaultCreateResult"]],
deleteSeoDefault?: [{	by: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultDeleteResult"]],
updateSeoDefault?: [{	by: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SeoDefaultUpdateInput"] | Variable<any, string>},ValueTypes["SeoDefaultUpdateResult"]],
upsertSeoDefault?: [{	by: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SeoDefaultUpdateInput"] | Variable<any, string>,	create: ValueTypes["SeoDefaultCreateInput"] | Variable<any, string>},ValueTypes["SeoDefaultUpsertResult"]],
createSeoDefaultLocale?: [{	data: ValueTypes["SeoDefaultLocaleCreateInput"] | Variable<any, string>},ValueTypes["SeoDefaultLocaleCreateResult"]],
deleteSeoDefaultLocale?: [{	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocaleDeleteResult"]],
updateSeoDefaultLocale?: [{	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SeoDefaultLocaleUpdateInput"] | Variable<any, string>},ValueTypes["SeoDefaultLocaleUpdateResult"]],
upsertSeoDefaultLocale?: [{	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SeoDefaultLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["SeoDefaultLocaleCreateInput"] | Variable<any, string>},ValueTypes["SeoDefaultLocaleUpsertResult"]],
createBusiness?: [{	data: ValueTypes["BusinessCreateInput"] | Variable<any, string>},ValueTypes["BusinessCreateResult"]],
deleteBusiness?: [{	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessDeleteResult"]],
updateBusiness?: [{	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["BusinessUpdateInput"] | Variable<any, string>},ValueTypes["BusinessUpdateResult"]],
upsertBusiness?: [{	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["BusinessUpdateInput"] | Variable<any, string>,	create: ValueTypes["BusinessCreateInput"] | Variable<any, string>},ValueTypes["BusinessUpsertResult"]],
createBusinessPage?: [{	data: ValueTypes["BusinessPageCreateInput"] | Variable<any, string>},ValueTypes["BusinessPageCreateResult"]],
deleteBusinessPage?: [{	by: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageDeleteResult"]],
updateBusinessPage?: [{	by: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["BusinessPageUpdateInput"] | Variable<any, string>},ValueTypes["BusinessPageUpdateResult"]],
upsertBusinessPage?: [{	by: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["BusinessPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["BusinessPageCreateInput"] | Variable<any, string>},ValueTypes["BusinessPageUpsertResult"]],
createBusinessPageLocale?: [{	data: ValueTypes["BusinessPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["BusinessPageLocaleCreateResult"]],
deleteBusinessPageLocale?: [{	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocaleDeleteResult"]],
updateBusinessPageLocale?: [{	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["BusinessPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["BusinessPageLocaleUpdateResult"]],
upsertBusinessPageLocale?: [{	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["BusinessPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["BusinessPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["BusinessPageLocaleUpsertResult"]],
createIcon?: [{	data: ValueTypes["IconCreateInput"] | Variable<any, string>},ValueTypes["IconCreateResult"]],
deleteIcon?: [{	by: ValueTypes["IconUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>},ValueTypes["IconDeleteResult"]],
updateIcon?: [{	by: ValueTypes["IconUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["IconUpdateInput"] | Variable<any, string>},ValueTypes["IconUpdateResult"]],
upsertIcon?: [{	by: ValueTypes["IconUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["IconUpdateInput"] | Variable<any, string>,	create: ValueTypes["IconCreateInput"] | Variable<any, string>},ValueTypes["IconUpsertResult"]],
createJobPage?: [{	data: ValueTypes["JobPageCreateInput"] | Variable<any, string>},ValueTypes["JobPageCreateResult"]],
deleteJobPage?: [{	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageDeleteResult"]],
updateJobPage?: [{	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobPageUpdateInput"] | Variable<any, string>},ValueTypes["JobPageUpdateResult"]],
upsertJobPage?: [{	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobPageCreateInput"] | Variable<any, string>},ValueTypes["JobPageUpsertResult"]],
createJobPageLocale?: [{	data: ValueTypes["JobPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobPageLocaleCreateResult"]],
deleteJobPageLocale?: [{	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocaleDeleteResult"]],
updateJobPageLocale?: [{	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["JobPageLocaleUpdateResult"]],
upsertJobPageLocale?: [{	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobPageLocaleUpsertResult"]],
createKeyInfoItem?: [{	data: ValueTypes["KeyInfoItemCreateInput"] | Variable<any, string>},ValueTypes["KeyInfoItemCreateResult"]],
deleteKeyInfoItem?: [{	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["KeyInfoItemDeleteResult"]],
updateKeyInfoItem?: [{	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["KeyInfoItemUpdateInput"] | Variable<any, string>},ValueTypes["KeyInfoItemUpdateResult"]],
upsertKeyInfoItem?: [{	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["KeyInfoItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["KeyInfoItemCreateInput"] | Variable<any, string>},ValueTypes["KeyInfoItemUpsertResult"]],
createKeyInfoList?: [{	data: ValueTypes["KeyInfoListCreateInput"] | Variable<any, string>},ValueTypes["KeyInfoListCreateResult"]],
deleteKeyInfoList?: [{	by: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>},ValueTypes["KeyInfoListDeleteResult"]],
updateKeyInfoList?: [{	by: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["KeyInfoListUpdateInput"] | Variable<any, string>},ValueTypes["KeyInfoListUpdateResult"]],
upsertKeyInfoList?: [{	by: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["KeyInfoListUpdateInput"] | Variable<any, string>,	create: ValueTypes["KeyInfoListCreateInput"] | Variable<any, string>},ValueTypes["KeyInfoListUpsertResult"]],
createContractType?: [{	data: ValueTypes["ContractTypeCreateInput"] | Variable<any, string>},ValueTypes["ContractTypeCreateResult"]],
deleteContractType?: [{	by: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractTypeDeleteResult"]],
updateContractType?: [{	by: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContractTypeUpdateInput"] | Variable<any, string>},ValueTypes["ContractTypeUpdateResult"]],
upsertContractType?: [{	by: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContractTypeUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContractTypeCreateInput"] | Variable<any, string>},ValueTypes["ContractTypeUpsertResult"]],
createContractTypeLocale?: [{	data: ValueTypes["ContractTypeLocaleCreateInput"] | Variable<any, string>},ValueTypes["ContractTypeLocaleCreateResult"]],
deleteContractTypeLocale?: [{	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocaleDeleteResult"]],
updateContractTypeLocale?: [{	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContractTypeLocaleUpdateInput"] | Variable<any, string>},ValueTypes["ContractTypeLocaleUpdateResult"]],
upsertContractTypeLocale?: [{	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContractTypeLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContractTypeLocaleCreateInput"] | Variable<any, string>},ValueTypes["ContractTypeLocaleUpsertResult"]],
createJobCity?: [{	data: ValueTypes["JobCityCreateInput"] | Variable<any, string>},ValueTypes["JobCityCreateResult"]],
deleteJobCity?: [{	by: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCityDeleteResult"]],
updateJobCity?: [{	by: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobCityUpdateInput"] | Variable<any, string>},ValueTypes["JobCityUpdateResult"]],
upsertJobCity?: [{	by: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobCityUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobCityCreateInput"] | Variable<any, string>},ValueTypes["JobCityUpsertResult"]],
createJobCityLocale?: [{	data: ValueTypes["JobCityLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobCityLocaleCreateResult"]],
deleteJobCityLocale?: [{	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCityLocaleDeleteResult"]],
updateJobCityLocale?: [{	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobCityLocaleUpdateInput"] | Variable<any, string>},ValueTypes["JobCityLocaleUpdateResult"]],
upsertJobCityLocale?: [{	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobCityLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobCityLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobCityLocaleUpsertResult"]],
createJobPosition?: [{	data: ValueTypes["JobPositionCreateInput"] | Variable<any, string>},ValueTypes["JobPositionCreateResult"]],
deleteJobPosition?: [{	by: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPositionDeleteResult"]],
updateJobPosition?: [{	by: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobPositionUpdateInput"] | Variable<any, string>},ValueTypes["JobPositionUpdateResult"]],
upsertJobPosition?: [{	by: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobPositionUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobPositionCreateInput"] | Variable<any, string>},ValueTypes["JobPositionUpsertResult"]],
createJobPositionLocale?: [{	data: ValueTypes["JobPositionLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobPositionLocaleCreateResult"]],
deleteJobPositionLocale?: [{	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocaleDeleteResult"]],
updateJobPositionLocale?: [{	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobPositionLocaleUpdateInput"] | Variable<any, string>},ValueTypes["JobPositionLocaleUpdateResult"]],
upsertJobPositionLocale?: [{	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobPositionLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobPositionLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobPositionLocaleUpsertResult"]],
createGallery?: [{	data: ValueTypes["GalleryCreateInput"] | Variable<any, string>},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GalleryUpdateInput"] | Variable<any, string>},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GalleryUpdateInput"] | Variable<any, string>,	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>},ValueTypes["GalleryUpsertResult"]],
createHomePage?: [{	data: ValueTypes["HomePageCreateInput"] | Variable<any, string>},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HomePageUpdateInput"] | Variable<any, string>},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HomePageUpdateInput"] | Variable<any, string>,	create: ValueTypes["HomePageCreateInput"] | Variable<any, string>},ValueTypes["HomePageUpsertResult"]],
createHomePageLocale?: [{	data: ValueTypes["HomePageLocaleCreateInput"] | Variable<any, string>},ValueTypes["HomePageLocaleCreateResult"]],
deleteHomePageLocale?: [{	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocaleDeleteResult"]],
updateHomePageLocale?: [{	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HomePageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["HomePageLocaleUpdateResult"]],
upsertHomePageLocale?: [{	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HomePageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["HomePageLocaleCreateInput"] | Variable<any, string>},ValueTypes["HomePageLocaleUpsertResult"]],
createMedium?: [{	data: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumUpdateInput"] | Variable<any, string>},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["MediumUpsertResult"]],
createMediumItem?: [{	data: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["MediumItemCreateResult"]],
deleteMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumItemDeleteResult"]],
updateMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>},ValueTypes["MediumItemUpdateResult"]],
upsertMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["MediumItemUpsertResult"]],
createMediumList?: [{	data: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["MediumListCreateResult"]],
deleteMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumListDeleteResult"]],
updateMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumListUpdateInput"] | Variable<any, string>},ValueTypes["MediumListUpdateResult"]],
upsertMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumListUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["MediumListUpsertResult"]],
createVideo?: [{	data: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["VideoUpdateInput"] | Variable<any, string>},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["VideoUpdateInput"] | Variable<any, string>,	create: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["VideoUpsertResult"]],
createTextItem?: [{	data: ValueTypes["TextItemCreateInput"] | Variable<any, string>},ValueTypes["TextItemCreateResult"]],
deleteTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextItemDeleteResult"]],
updateTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TextItemUpdateInput"] | Variable<any, string>},ValueTypes["TextItemUpdateResult"]],
upsertTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TextItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["TextItemCreateInput"] | Variable<any, string>},ValueTypes["TextItemUpsertResult"]],
createTextList?: [{	data: ValueTypes["TextListCreateInput"] | Variable<any, string>},ValueTypes["TextListCreateResult"]],
deleteTextList?: [{	by: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextListDeleteResult"]],
updateTextList?: [{	by: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TextListUpdateInput"] | Variable<any, string>},ValueTypes["TextListUpdateResult"]],
upsertTextList?: [{	by: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TextListUpdateInput"] | Variable<any, string>,	create: ValueTypes["TextListCreateInput"] | Variable<any, string>},ValueTypes["TextListUpsertResult"]],
createCarousel?: [{	data: ValueTypes["CarouselCreateInput"] | Variable<any, string>},ValueTypes["CarouselCreateResult"]],
deleteCarousel?: [{	by: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["CarouselDeleteResult"]],
updateCarousel?: [{	by: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CarouselUpdateInput"] | Variable<any, string>},ValueTypes["CarouselUpdateResult"]],
upsertCarousel?: [{	by: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CarouselUpdateInput"] | Variable<any, string>,	create: ValueTypes["CarouselCreateInput"] | Variable<any, string>},ValueTypes["CarouselUpsertResult"]],
createCarouselItem?: [{	data: ValueTypes["CarouselItemCreateInput"] | Variable<any, string>},ValueTypes["CarouselItemCreateResult"]],
deleteCarouselItem?: [{	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CarouselItemDeleteResult"]],
updateCarouselItem?: [{	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["CarouselItemUpdateResult"]],
upsertCarouselItem?: [{	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CarouselItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["CarouselItemCreateInput"] | Variable<any, string>},ValueTypes["CarouselItemUpsertResult"]],
createTheme?: [{	data: ValueTypes["ThemeCreateInput"] | Variable<any, string>},ValueTypes["ThemeCreateResult"]],
deleteTheme?: [{	by: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>},ValueTypes["ThemeDeleteResult"]],
updateTheme?: [{	by: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ThemeUpdateInput"] | Variable<any, string>},ValueTypes["ThemeUpdateResult"]],
upsertTheme?: [{	by: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ThemeUpdateInput"] | Variable<any, string>,	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>},ValueTypes["ThemeUpsertResult"]],
createBonusBanner?: [{	data: ValueTypes["BonusBannerCreateInput"] | Variable<any, string>},ValueTypes["BonusBannerCreateResult"]],
deleteBonusBanner?: [{	by: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerDeleteResult"]],
updateBonusBanner?: [{	by: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["BonusBannerUpdateInput"] | Variable<any, string>},ValueTypes["BonusBannerUpdateResult"]],
upsertBonusBanner?: [{	by: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["BonusBannerUpdateInput"] | Variable<any, string>,	create: ValueTypes["BonusBannerCreateInput"] | Variable<any, string>},ValueTypes["BonusBannerUpsertResult"]],
createBonusBannerLocale?: [{	data: ValueTypes["BonusBannerLocaleCreateInput"] | Variable<any, string>},ValueTypes["BonusBannerLocaleCreateResult"]],
deleteBonusBannerLocale?: [{	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocaleDeleteResult"]],
updateBonusBannerLocale?: [{	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["BonusBannerLocaleUpdateInput"] | Variable<any, string>},ValueTypes["BonusBannerLocaleUpdateResult"]],
upsertBonusBannerLocale?: [{	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["BonusBannerLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["BonusBannerLocaleCreateInput"] | Variable<any, string>},ValueTypes["BonusBannerLocaleUpsertResult"]],
createTile?: [{	data: ValueTypes["TileCreateInput"] | Variable<any, string>},ValueTypes["TileCreateResult"]],
deleteTile?: [{	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileDeleteResult"]],
updateTile?: [{	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TileUpdateInput"] | Variable<any, string>},ValueTypes["TileUpdateResult"]],
upsertTile?: [{	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TileUpdateInput"] | Variable<any, string>,	create: ValueTypes["TileCreateInput"] | Variable<any, string>},ValueTypes["TileUpsertResult"]],
createSideBySide?: [{	data: ValueTypes["SideBySideCreateInput"] | Variable<any, string>},ValueTypes["SideBySideCreateResult"]],
deleteSideBySide?: [{	by: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySideDeleteResult"]],
updateSideBySide?: [{	by: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SideBySideUpdateInput"] | Variable<any, string>},ValueTypes["SideBySideUpdateResult"]],
upsertSideBySide?: [{	by: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SideBySideUpdateInput"] | Variable<any, string>,	create: ValueTypes["SideBySideCreateInput"] | Variable<any, string>},ValueTypes["SideBySideUpsertResult"]],
createSideBySideItem?: [{	data: ValueTypes["SideBySideItemCreateInput"] | Variable<any, string>},ValueTypes["SideBySideItemCreateResult"]],
deleteSideBySideItem?: [{	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySideItemDeleteResult"]],
updateSideBySideItem?: [{	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SideBySideItemUpdateInput"] | Variable<any, string>},ValueTypes["SideBySideItemUpdateResult"]],
upsertSideBySideItem?: [{	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SideBySideItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["SideBySideItemCreateInput"] | Variable<any, string>},ValueTypes["SideBySideItemUpsertResult"]],
createHomePageLokal?: [{	data: ValueTypes["HomePageLokalCreateInput"] | Variable<any, string>},ValueTypes["HomePageLokalCreateResult"]],
deleteHomePageLokal?: [{	by: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalDeleteResult"]],
updateHomePageLokal?: [{	by: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HomePageLokalUpdateInput"] | Variable<any, string>},ValueTypes["HomePageLokalUpdateResult"]],
upsertHomePageLokal?: [{	by: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HomePageLokalUpdateInput"] | Variable<any, string>,	create: ValueTypes["HomePageLokalCreateInput"] | Variable<any, string>},ValueTypes["HomePageLokalUpsertResult"]],
createHomePageLokalLocale?: [{	data: ValueTypes["HomePageLokalLocaleCreateInput"] | Variable<any, string>},ValueTypes["HomePageLokalLocaleCreateResult"]],
deleteHomePageLokalLocale?: [{	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocaleDeleteResult"]],
updateHomePageLokalLocale?: [{	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HomePageLokalLocaleUpdateInput"] | Variable<any, string>},ValueTypes["HomePageLokalLocaleUpdateResult"]],
upsertHomePageLokalLocale?: [{	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HomePageLokalLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["HomePageLokalLocaleCreateInput"] | Variable<any, string>},ValueTypes["HomePageLokalLocaleUpsertResult"]],
createSiteSwitcher?: [{	data: ValueTypes["SiteSwitcherCreateInput"] | Variable<any, string>},ValueTypes["SiteSwitcherCreateResult"]],
deleteSiteSwitcher?: [{	by: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>},ValueTypes["SiteSwitcherDeleteResult"]],
updateSiteSwitcher?: [{	by: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SiteSwitcherUpdateInput"] | Variable<any, string>},ValueTypes["SiteSwitcherUpdateResult"]],
upsertSiteSwitcher?: [{	by: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SiteSwitcherUpdateInput"] | Variable<any, string>,	create: ValueTypes["SiteSwitcherCreateInput"] | Variable<any, string>},ValueTypes["SiteSwitcherUpsertResult"]],
createGalleryItem?: [{	data: ValueTypes["GalleryItemCreateInput"] | Variable<any, string>},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GalleryItemUpdateInput"] | Variable<any, string>},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GalleryItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["GalleryItemCreateInput"] | Variable<any, string>},ValueTypes["GalleryItemUpsertResult"]],
createJobsForm?: [{	data: ValueTypes["JobsFormCreateInput"] | Variable<any, string>},ValueTypes["JobsFormCreateResult"]],
deleteJobsForm?: [{	by: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormDeleteResult"]],
updateJobsForm?: [{	by: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobsFormUpdateInput"] | Variable<any, string>},ValueTypes["JobsFormUpdateResult"]],
upsertJobsForm?: [{	by: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobsFormUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobsFormCreateInput"] | Variable<any, string>},ValueTypes["JobsFormUpsertResult"]],
createJobsFormLocale?: [{	data: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobsFormLocaleCreateResult"]],
deleteJobsFormLocale?: [{	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocaleDeleteResult"]],
updateJobsFormLocale?: [{	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>},ValueTypes["JobsFormLocaleUpdateResult"]],
upsertJobsFormLocale?: [{	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobsFormLocaleUpsertResult"]],
createImageTextItem?: [{	data: ValueTypes["ImageTextItemCreateInput"] | Variable<any, string>},ValueTypes["ImageTextItemCreateResult"]],
deleteImageTextItem?: [{	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextItemDeleteResult"]],
updateImageTextItem?: [{	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageTextItemUpdateInput"] | Variable<any, string>},ValueTypes["ImageTextItemUpdateResult"]],
upsertImageTextItem?: [{	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageTextItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageTextItemCreateInput"] | Variable<any, string>},ValueTypes["ImageTextItemUpsertResult"]],
createImageTextList?: [{	data: ValueTypes["ImageTextListCreateInput"] | Variable<any, string>},ValueTypes["ImageTextListCreateResult"]],
deleteImageTextList?: [{	by: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextListDeleteResult"]],
updateImageTextList?: [{	by: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageTextListUpdateInput"] | Variable<any, string>},ValueTypes["ImageTextListUpdateResult"]],
upsertImageTextList?: [{	by: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageTextListUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageTextListCreateInput"] | Variable<any, string>},ValueTypes["ImageTextListUpsertResult"]],
createJobsFilter?: [{	data: ValueTypes["JobsFilterCreateInput"] | Variable<any, string>},ValueTypes["JobsFilterCreateResult"]],
deleteJobsFilter?: [{	by: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterDeleteResult"]],
updateJobsFilter?: [{	by: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobsFilterUpdateInput"] | Variable<any, string>},ValueTypes["JobsFilterUpdateResult"]],
upsertJobsFilter?: [{	by: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobsFilterUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobsFilterCreateInput"] | Variable<any, string>},ValueTypes["JobsFilterUpsertResult"]],
createJobsFilterLocale?: [{	data: ValueTypes["JobsFilterLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobsFilterLocaleCreateResult"]],
deleteJobsFilterLocale?: [{	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocaleDeleteResult"]],
updateJobsFilterLocale?: [{	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobsFilterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["JobsFilterLocaleUpdateResult"]],
upsertJobsFilterLocale?: [{	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobsFilterLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobsFilterLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobsFilterLocaleUpsertResult"]],
createFile?: [{	data: ValueTypes["FileCreateInput"] | Variable<any, string>},ValueTypes["FileCreateResult"]],
deleteFile?: [{	by: ValueTypes["FileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>},ValueTypes["FileDeleteResult"]],
updateFile?: [{	by: ValueTypes["FileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FileUpdateInput"] | Variable<any, string>},ValueTypes["FileUpdateResult"]],
upsertFile?: [{	by: ValueTypes["FileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FileUpdateInput"] | Variable<any, string>,	create: ValueTypes["FileCreateInput"] | Variable<any, string>},ValueTypes["FileUpsertResult"]],
createJobFormSubscription?: [{	data: ValueTypes["JobFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionCreateResult"]],
deleteJobFormSubscription?: [{	by: ValueTypes["JobFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionDeleteResult"]],
updateJobFormSubscription?: [{	by: ValueTypes["JobFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobFormSubscriptionUpdateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionUpdateResult"]],
upsertJobFormSubscription?: [{	by: ValueTypes["JobFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobFormSubscriptionUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionUpsertResult"]],
createImageList?: [{	data: ValueTypes["ImageListCreateInput"] | Variable<any, string>},ValueTypes["ImageListCreateResult"]],
deleteImageList?: [{	by: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageListDeleteResult"]],
updateImageList?: [{	by: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageListUpdateInput"] | Variable<any, string>},ValueTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageListUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageListCreateInput"] | Variable<any, string>},ValueTypes["ImageListUpsertResult"]],
createImageListItem?: [{	data: ValueTypes["ImageListItemCreateInput"] | Variable<any, string>},ValueTypes["ImageListItemCreateResult"]],
deleteImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageListItemDeleteResult"]],
updateImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageListItemUpdateInput"] | Variable<any, string>},ValueTypes["ImageListItemUpdateResult"]],
upsertImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageListItemCreateInput"] | Variable<any, string>},ValueTypes["ImageListItemUpsertResult"]],
createJobFormSubscriptionStatus?: [{	data: ValueTypes["JobFormSubscriptionStatusCreateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionStatusCreateResult"]],
deleteJobFormSubscriptionStatus?: [{	by: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionStatusDeleteResult"]],
updateJobFormSubscriptionStatus?: [{	by: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobFormSubscriptionStatusUpdateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionStatusUpdateResult"]],
upsertJobFormSubscriptionStatus?: [{	by: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobFormSubscriptionStatusUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobFormSubscriptionStatusCreateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionStatusUpsertResult"]],
createGeneralLocale?: [{	data: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleCreateResult"]],
deleteGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleDeleteResult"]],
updateGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleUpdateResult"]],
upsertGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleUpsertResult"]],
createStickyBar?: [{	data: ValueTypes["StickyBarCreateInput"] | Variable<any, string>},ValueTypes["StickyBarCreateResult"]],
deleteStickyBar?: [{	by: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>},ValueTypes["StickyBarDeleteResult"]],
updateStickyBar?: [{	by: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StickyBarUpdateInput"] | Variable<any, string>},ValueTypes["StickyBarUpdateResult"]],
upsertStickyBar?: [{	by: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StickyBarUpdateInput"] | Variable<any, string>,	create: ValueTypes["StickyBarCreateInput"] | Variable<any, string>},ValueTypes["StickyBarUpsertResult"]],
createRecommendationForm?: [{	data: ValueTypes["RecommendationFormCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormCreateResult"]],
deleteRecommendationForm?: [{	by: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormDeleteResult"]],
updateRecommendationForm?: [{	by: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RecommendationFormUpdateInput"] | Variable<any, string>},ValueTypes["RecommendationFormUpdateResult"]],
upsertRecommendationForm?: [{	by: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RecommendationFormUpdateInput"] | Variable<any, string>,	create: ValueTypes["RecommendationFormCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormUpsertResult"]],
createRecommendationFormLocale?: [{	data: ValueTypes["RecommendationFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormLocaleCreateResult"]],
deleteRecommendationFormLocale?: [{	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocaleDeleteResult"]],
updateRecommendationFormLocale?: [{	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RecommendationFormLocaleUpdateInput"] | Variable<any, string>},ValueTypes["RecommendationFormLocaleUpdateResult"]],
upsertRecommendationFormLocale?: [{	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RecommendationFormLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["RecommendationFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormLocaleUpsertResult"]],
createRecommendationFormSubscription?: [{	data: ValueTypes["RecommendationFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormSubscriptionCreateResult"]],
deleteRecommendationFormSubscription?: [{	by: ValueTypes["RecommendationFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormSubscriptionDeleteResult"]],
updateRecommendationFormSubscription?: [{	by: ValueTypes["RecommendationFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RecommendationFormSubscriptionUpdateInput"] | Variable<any, string>},ValueTypes["RecommendationFormSubscriptionUpdateResult"]],
upsertRecommendationFormSubscription?: [{	by: ValueTypes["RecommendationFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RecommendationFormSubscriptionUpdateInput"] | Variable<any, string>,	create: ValueTypes["RecommendationFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormSubscriptionUpsertResult"]],
createInfoBox?: [{	data: ValueTypes["InfoBoxCreateInput"] | Variable<any, string>},ValueTypes["InfoBoxCreateResult"]],
deleteInfoBox?: [{	by: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBoxDeleteResult"]],
updateInfoBox?: [{	by: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["InfoBoxUpdateInput"] | Variable<any, string>},ValueTypes["InfoBoxUpdateResult"]],
upsertInfoBox?: [{	by: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["InfoBoxUpdateInput"] | Variable<any, string>,	create: ValueTypes["InfoBoxCreateInput"] | Variable<any, string>},ValueTypes["InfoBoxUpsertResult"]],
createInfoBoxLocale?: [{	data: ValueTypes["InfoBoxLocaleCreateInput"] | Variable<any, string>},ValueTypes["InfoBoxLocaleCreateResult"]],
deleteInfoBoxLocale?: [{	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocaleDeleteResult"]],
updateInfoBoxLocale?: [{	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["InfoBoxLocaleUpdateInput"] | Variable<any, string>},ValueTypes["InfoBoxLocaleUpdateResult"]],
upsertInfoBoxLocale?: [{	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["InfoBoxLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["InfoBoxLocaleCreateInput"] | Variable<any, string>},ValueTypes["InfoBoxLocaleUpsertResult"]],
createTranslation?: [{	data: ValueTypes["TranslationCreateInput"] | Variable<any, string>},ValueTypes["TranslationCreateResult"]],
deleteTranslation?: [{	by: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationDeleteResult"]],
updateTranslation?: [{	by: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationUpdateInput"] | Variable<any, string>},ValueTypes["TranslationUpdateResult"]],
upsertTranslation?: [{	by: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationCreateInput"] | Variable<any, string>},ValueTypes["TranslationUpsertResult"]],
createTranslationLocale?: [{	data: ValueTypes["TranslationLocaleCreateInput"] | Variable<any, string>},ValueTypes["TranslationLocaleCreateResult"]],
deleteTranslationLocale?: [{	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationLocaleDeleteResult"]],
updateTranslationLocale?: [{	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["TranslationLocaleUpdateResult"]],
upsertTranslationLocale?: [{	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationLocaleCreateInput"] | Variable<any, string>},ValueTypes["TranslationLocaleUpsertResult"]],
createCornerBanner?: [{	data: ValueTypes["CornerBannerCreateInput"] | Variable<any, string>},ValueTypes["CornerBannerCreateResult"]],
deleteCornerBanner?: [{	by: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["CornerBannerDeleteResult"]],
updateCornerBanner?: [{	by: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CornerBannerUpdateInput"] | Variable<any, string>},ValueTypes["CornerBannerUpdateResult"]],
upsertCornerBanner?: [{	by: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CornerBannerUpdateInput"] | Variable<any, string>,	create: ValueTypes["CornerBannerCreateInput"] | Variable<any, string>},ValueTypes["CornerBannerUpsertResult"]],
transaction?: [{	options?: ValueTypes["MutationTransactionOptions"] | undefined | null | Variable<any, string>},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
		__typename?: boolean | `@${string}`
}>;
	["S3SignedUpload"]: AliasType<{
	url?:boolean | `@${string}`,
	headers?:ValueTypes["S3Header"],
	method?:boolean | `@${string}`,
	objectKey?:boolean | `@${string}`,
	bucket?:boolean | `@${string}`,
	publicUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3Header"]: AliasType<{
	key?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3GenerateSignedUploadInput"]: {
	contentType?: string | undefined | null | Variable<any, string>,
	/** If not provided, extension is detected from a content-type. */
	extension?: string | undefined | null | Variable<any, string>,
	/** Signed URL expiration. */
	expiration?: number | undefined | null | Variable<any, string>,
	/** Uploaded file size. Required when you enable ACL size limits. */
	size?: number | undefined | null | Variable<any, string>,
	/** Can be used as a "directory". */
	prefix?: string | undefined | null | Variable<any, string>,
	/** Suffix after generated id and before the extension. */
	suffix?: string | undefined | null | Variable<any, string>,
	/** This only affects Content-disposition header. Does not affect actual object key. */
	fileName?: string | undefined | null | Variable<any, string>,
	contentDisposition?: ValueTypes["S33ContentDisposition"] | undefined | null | Variable<any, string>,
	/** If not supported by S3 provider, an error is thrown. */
	acl?: ValueTypes["S3Acl"] | undefined | null | Variable<any, string>
};
	["S33ContentDisposition"]:S33ContentDisposition;
	["S3Acl"]:S3Acl;
	["S3SignedRead"]: AliasType<{
	url?:boolean | `@${string}`,
	headers?:ValueTypes["S3Header"],
	method?:boolean | `@${string}`,
	objectKey?:boolean | `@${string}`,
	bucket?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GeneralCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["General"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MutationResult"]:AliasType<{
		ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"];
		['...on GeneralCreateResult']?: Omit<ValueTypes["GeneralCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralDeleteResult']?: Omit<ValueTypes["GeneralDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralUpdateResult']?: Omit<ValueTypes["GeneralUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralUpsertResult']?: Omit<ValueTypes["GeneralUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageCreateResult']?: Omit<ValueTypes["GenericPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageDeleteResult']?: Omit<ValueTypes["GenericPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageUpdateResult']?: Omit<ValueTypes["GenericPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageUpsertResult']?: Omit<ValueTypes["GenericPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentCreateResult']?: Omit<ValueTypes["ContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ValueTypes["ContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ValueTypes["ContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ValueTypes["ContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ValueTypes["ContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ValueTypes["ContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ValueTypes["ContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ValueTypes["ContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectCreateResult']?: Omit<ValueTypes["RedirectCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectDeleteResult']?: Omit<ValueTypes["RedirectDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpdateResult']?: Omit<ValueTypes["RedirectUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpsertResult']?: Omit<ValueTypes["RedirectUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ValueTypes["FooterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ValueTypes["FooterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ValueTypes["FooterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ValueTypes["FooterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkCreateResult']?: Omit<ValueTypes["FooterLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkDeleteResult']?: Omit<ValueTypes["FooterLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkUpdateResult']?: Omit<ValueTypes["FooterLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkUpsertResult']?: Omit<ValueTypes["FooterLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleCreateResult']?: Omit<ValueTypes["FooterLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleDeleteResult']?: Omit<ValueTypes["FooterLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleUpdateResult']?: Omit<ValueTypes["FooterLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleUpsertResult']?: Omit<ValueTypes["FooterLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageLocaleCreateResult']?: Omit<ValueTypes["GenericPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageLocaleDeleteResult']?: Omit<ValueTypes["GenericPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageLocaleUpdateResult']?: Omit<ValueTypes["GenericPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageLocaleUpsertResult']?: Omit<ValueTypes["GenericPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderCreateResult']?: Omit<ValueTypes["HeaderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderDeleteResult']?: Omit<ValueTypes["HeaderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpdateResult']?: Omit<ValueTypes["HeaderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpsertResult']?: Omit<ValueTypes["HeaderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleCreateResult']?: Omit<ValueTypes["HeaderLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleDeleteResult']?: Omit<ValueTypes["HeaderLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleUpdateResult']?: Omit<ValueTypes["HeaderLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleUpsertResult']?: Omit<ValueTypes["HeaderLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleCreateResult']?: Omit<ValueTypes["LocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleDeleteResult']?: Omit<ValueTypes["LocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpdateResult']?: Omit<ValueTypes["LocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpsertResult']?: Omit<ValueTypes["LocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultCreateResult']?: Omit<ValueTypes["SeoDefaultCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultDeleteResult']?: Omit<ValueTypes["SeoDefaultDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultUpdateResult']?: Omit<ValueTypes["SeoDefaultUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultUpsertResult']?: Omit<ValueTypes["SeoDefaultUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultLocaleCreateResult']?: Omit<ValueTypes["SeoDefaultLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultLocaleDeleteResult']?: Omit<ValueTypes["SeoDefaultLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultLocaleUpdateResult']?: Omit<ValueTypes["SeoDefaultLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultLocaleUpsertResult']?: Omit<ValueTypes["SeoDefaultLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCreateResult']?: Omit<ValueTypes["BusinessCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessDeleteResult']?: Omit<ValueTypes["BusinessDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessUpdateResult']?: Omit<ValueTypes["BusinessUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessUpsertResult']?: Omit<ValueTypes["BusinessUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessPageCreateResult']?: Omit<ValueTypes["BusinessPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessPageDeleteResult']?: Omit<ValueTypes["BusinessPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessPageUpdateResult']?: Omit<ValueTypes["BusinessPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessPageUpsertResult']?: Omit<ValueTypes["BusinessPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessPageLocaleCreateResult']?: Omit<ValueTypes["BusinessPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessPageLocaleDeleteResult']?: Omit<ValueTypes["BusinessPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessPageLocaleUpdateResult']?: Omit<ValueTypes["BusinessPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessPageLocaleUpsertResult']?: Omit<ValueTypes["BusinessPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IconCreateResult']?: Omit<ValueTypes["IconCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IconDeleteResult']?: Omit<ValueTypes["IconDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IconUpdateResult']?: Omit<ValueTypes["IconUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IconUpsertResult']?: Omit<ValueTypes["IconUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPageCreateResult']?: Omit<ValueTypes["JobPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPageDeleteResult']?: Omit<ValueTypes["JobPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPageUpdateResult']?: Omit<ValueTypes["JobPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPageUpsertResult']?: Omit<ValueTypes["JobPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPageLocaleCreateResult']?: Omit<ValueTypes["JobPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPageLocaleDeleteResult']?: Omit<ValueTypes["JobPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPageLocaleUpdateResult']?: Omit<ValueTypes["JobPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPageLocaleUpsertResult']?: Omit<ValueTypes["JobPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on KeyInfoItemCreateResult']?: Omit<ValueTypes["KeyInfoItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on KeyInfoItemDeleteResult']?: Omit<ValueTypes["KeyInfoItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on KeyInfoItemUpdateResult']?: Omit<ValueTypes["KeyInfoItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on KeyInfoItemUpsertResult']?: Omit<ValueTypes["KeyInfoItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on KeyInfoListCreateResult']?: Omit<ValueTypes["KeyInfoListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on KeyInfoListDeleteResult']?: Omit<ValueTypes["KeyInfoListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on KeyInfoListUpdateResult']?: Omit<ValueTypes["KeyInfoListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on KeyInfoListUpsertResult']?: Omit<ValueTypes["KeyInfoListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContractTypeCreateResult']?: Omit<ValueTypes["ContractTypeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContractTypeDeleteResult']?: Omit<ValueTypes["ContractTypeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContractTypeUpdateResult']?: Omit<ValueTypes["ContractTypeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContractTypeUpsertResult']?: Omit<ValueTypes["ContractTypeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContractTypeLocaleCreateResult']?: Omit<ValueTypes["ContractTypeLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContractTypeLocaleDeleteResult']?: Omit<ValueTypes["ContractTypeLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContractTypeLocaleUpdateResult']?: Omit<ValueTypes["ContractTypeLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContractTypeLocaleUpsertResult']?: Omit<ValueTypes["ContractTypeLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobCityCreateResult']?: Omit<ValueTypes["JobCityCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobCityDeleteResult']?: Omit<ValueTypes["JobCityDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobCityUpdateResult']?: Omit<ValueTypes["JobCityUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobCityUpsertResult']?: Omit<ValueTypes["JobCityUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobCityLocaleCreateResult']?: Omit<ValueTypes["JobCityLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobCityLocaleDeleteResult']?: Omit<ValueTypes["JobCityLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobCityLocaleUpdateResult']?: Omit<ValueTypes["JobCityLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobCityLocaleUpsertResult']?: Omit<ValueTypes["JobCityLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPositionCreateResult']?: Omit<ValueTypes["JobPositionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPositionDeleteResult']?: Omit<ValueTypes["JobPositionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPositionUpdateResult']?: Omit<ValueTypes["JobPositionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPositionUpsertResult']?: Omit<ValueTypes["JobPositionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPositionLocaleCreateResult']?: Omit<ValueTypes["JobPositionLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPositionLocaleDeleteResult']?: Omit<ValueTypes["JobPositionLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPositionLocaleUpdateResult']?: Omit<ValueTypes["JobPositionLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobPositionLocaleUpsertResult']?: Omit<ValueTypes["JobPositionLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryCreateResult']?: Omit<ValueTypes["GalleryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryDeleteResult']?: Omit<ValueTypes["GalleryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpdateResult']?: Omit<ValueTypes["GalleryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpsertResult']?: Omit<ValueTypes["GalleryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageCreateResult']?: Omit<ValueTypes["HomePageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageDeleteResult']?: Omit<ValueTypes["HomePageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpdateResult']?: Omit<ValueTypes["HomePageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpsertResult']?: Omit<ValueTypes["HomePageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLocaleCreateResult']?: Omit<ValueTypes["HomePageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLocaleDeleteResult']?: Omit<ValueTypes["HomePageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLocaleUpdateResult']?: Omit<ValueTypes["HomePageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLocaleUpsertResult']?: Omit<ValueTypes["HomePageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumCreateResult']?: Omit<ValueTypes["MediumCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumDeleteResult']?: Omit<ValueTypes["MediumDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpdateResult']?: Omit<ValueTypes["MediumUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpsertResult']?: Omit<ValueTypes["MediumUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemCreateResult']?: Omit<ValueTypes["MediumItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemDeleteResult']?: Omit<ValueTypes["MediumItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemUpdateResult']?: Omit<ValueTypes["MediumItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemUpsertResult']?: Omit<ValueTypes["MediumItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListCreateResult']?: Omit<ValueTypes["MediumListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListDeleteResult']?: Omit<ValueTypes["MediumListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListUpdateResult']?: Omit<ValueTypes["MediumListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListUpsertResult']?: Omit<ValueTypes["MediumListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoCreateResult']?: Omit<ValueTypes["VideoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoDeleteResult']?: Omit<ValueTypes["VideoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpdateResult']?: Omit<ValueTypes["VideoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpsertResult']?: Omit<ValueTypes["VideoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemCreateResult']?: Omit<ValueTypes["TextItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemDeleteResult']?: Omit<ValueTypes["TextItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemUpdateResult']?: Omit<ValueTypes["TextItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemUpsertResult']?: Omit<ValueTypes["TextItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListCreateResult']?: Omit<ValueTypes["TextListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListDeleteResult']?: Omit<ValueTypes["TextListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListUpdateResult']?: Omit<ValueTypes["TextListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListUpsertResult']?: Omit<ValueTypes["TextListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CarouselCreateResult']?: Omit<ValueTypes["CarouselCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CarouselDeleteResult']?: Omit<ValueTypes["CarouselDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CarouselUpdateResult']?: Omit<ValueTypes["CarouselUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CarouselUpsertResult']?: Omit<ValueTypes["CarouselUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CarouselItemCreateResult']?: Omit<ValueTypes["CarouselItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CarouselItemDeleteResult']?: Omit<ValueTypes["CarouselItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CarouselItemUpdateResult']?: Omit<ValueTypes["CarouselItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CarouselItemUpsertResult']?: Omit<ValueTypes["CarouselItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ThemeCreateResult']?: Omit<ValueTypes["ThemeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ThemeDeleteResult']?: Omit<ValueTypes["ThemeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ThemeUpdateResult']?: Omit<ValueTypes["ThemeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ThemeUpsertResult']?: Omit<ValueTypes["ThemeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BonusBannerCreateResult']?: Omit<ValueTypes["BonusBannerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BonusBannerDeleteResult']?: Omit<ValueTypes["BonusBannerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BonusBannerUpdateResult']?: Omit<ValueTypes["BonusBannerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BonusBannerUpsertResult']?: Omit<ValueTypes["BonusBannerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BonusBannerLocaleCreateResult']?: Omit<ValueTypes["BonusBannerLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BonusBannerLocaleDeleteResult']?: Omit<ValueTypes["BonusBannerLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BonusBannerLocaleUpdateResult']?: Omit<ValueTypes["BonusBannerLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BonusBannerLocaleUpsertResult']?: Omit<ValueTypes["BonusBannerLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileCreateResult']?: Omit<ValueTypes["TileCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileDeleteResult']?: Omit<ValueTypes["TileDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileUpdateResult']?: Omit<ValueTypes["TileUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TileUpsertResult']?: Omit<ValueTypes["TileUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SideBySideCreateResult']?: Omit<ValueTypes["SideBySideCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SideBySideDeleteResult']?: Omit<ValueTypes["SideBySideDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SideBySideUpdateResult']?: Omit<ValueTypes["SideBySideUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SideBySideUpsertResult']?: Omit<ValueTypes["SideBySideUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SideBySideItemCreateResult']?: Omit<ValueTypes["SideBySideItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SideBySideItemDeleteResult']?: Omit<ValueTypes["SideBySideItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SideBySideItemUpdateResult']?: Omit<ValueTypes["SideBySideItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SideBySideItemUpsertResult']?: Omit<ValueTypes["SideBySideItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLokalCreateResult']?: Omit<ValueTypes["HomePageLokalCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLokalDeleteResult']?: Omit<ValueTypes["HomePageLokalDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLokalUpdateResult']?: Omit<ValueTypes["HomePageLokalUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLokalUpsertResult']?: Omit<ValueTypes["HomePageLokalUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLokalLocaleCreateResult']?: Omit<ValueTypes["HomePageLokalLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLokalLocaleDeleteResult']?: Omit<ValueTypes["HomePageLokalLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLokalLocaleUpdateResult']?: Omit<ValueTypes["HomePageLokalLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLokalLocaleUpsertResult']?: Omit<ValueTypes["HomePageLokalLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteSwitcherCreateResult']?: Omit<ValueTypes["SiteSwitcherCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteSwitcherDeleteResult']?: Omit<ValueTypes["SiteSwitcherDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteSwitcherUpdateResult']?: Omit<ValueTypes["SiteSwitcherUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteSwitcherUpsertResult']?: Omit<ValueTypes["SiteSwitcherUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemCreateResult']?: Omit<ValueTypes["GalleryItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemDeleteResult']?: Omit<ValueTypes["GalleryItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpdateResult']?: Omit<ValueTypes["GalleryItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpsertResult']?: Omit<ValueTypes["GalleryItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFormCreateResult']?: Omit<ValueTypes["JobsFormCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFormDeleteResult']?: Omit<ValueTypes["JobsFormDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFormUpdateResult']?: Omit<ValueTypes["JobsFormUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFormUpsertResult']?: Omit<ValueTypes["JobsFormUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFormLocaleCreateResult']?: Omit<ValueTypes["JobsFormLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFormLocaleDeleteResult']?: Omit<ValueTypes["JobsFormLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFormLocaleUpdateResult']?: Omit<ValueTypes["JobsFormLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFormLocaleUpsertResult']?: Omit<ValueTypes["JobsFormLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTextItemCreateResult']?: Omit<ValueTypes["ImageTextItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTextItemDeleteResult']?: Omit<ValueTypes["ImageTextItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTextItemUpdateResult']?: Omit<ValueTypes["ImageTextItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTextItemUpsertResult']?: Omit<ValueTypes["ImageTextItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTextListCreateResult']?: Omit<ValueTypes["ImageTextListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTextListDeleteResult']?: Omit<ValueTypes["ImageTextListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTextListUpdateResult']?: Omit<ValueTypes["ImageTextListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTextListUpsertResult']?: Omit<ValueTypes["ImageTextListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFilterCreateResult']?: Omit<ValueTypes["JobsFilterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFilterDeleteResult']?: Omit<ValueTypes["JobsFilterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFilterUpdateResult']?: Omit<ValueTypes["JobsFilterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFilterUpsertResult']?: Omit<ValueTypes["JobsFilterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFilterLocaleCreateResult']?: Omit<ValueTypes["JobsFilterLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFilterLocaleDeleteResult']?: Omit<ValueTypes["JobsFilterLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFilterLocaleUpdateResult']?: Omit<ValueTypes["JobsFilterLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobsFilterLocaleUpsertResult']?: Omit<ValueTypes["JobsFilterLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileCreateResult']?: Omit<ValueTypes["FileCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileDeleteResult']?: Omit<ValueTypes["FileDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUpdateResult']?: Omit<ValueTypes["FileUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUpsertResult']?: Omit<ValueTypes["FileUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobFormSubscriptionCreateResult']?: Omit<ValueTypes["JobFormSubscriptionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobFormSubscriptionDeleteResult']?: Omit<ValueTypes["JobFormSubscriptionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobFormSubscriptionUpdateResult']?: Omit<ValueTypes["JobFormSubscriptionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobFormSubscriptionUpsertResult']?: Omit<ValueTypes["JobFormSubscriptionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListCreateResult']?: Omit<ValueTypes["ImageListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListDeleteResult']?: Omit<ValueTypes["ImageListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListUpdateResult']?: Omit<ValueTypes["ImageListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListUpsertResult']?: Omit<ValueTypes["ImageListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemCreateResult']?: Omit<ValueTypes["ImageListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemDeleteResult']?: Omit<ValueTypes["ImageListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemUpdateResult']?: Omit<ValueTypes["ImageListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemUpsertResult']?: Omit<ValueTypes["ImageListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobFormSubscriptionStatusCreateResult']?: Omit<ValueTypes["JobFormSubscriptionStatusCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobFormSubscriptionStatusDeleteResult']?: Omit<ValueTypes["JobFormSubscriptionStatusDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobFormSubscriptionStatusUpdateResult']?: Omit<ValueTypes["JobFormSubscriptionStatusUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on JobFormSubscriptionStatusUpsertResult']?: Omit<ValueTypes["JobFormSubscriptionStatusUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralLocaleCreateResult']?: Omit<ValueTypes["GeneralLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralLocaleDeleteResult']?: Omit<ValueTypes["GeneralLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralLocaleUpdateResult']?: Omit<ValueTypes["GeneralLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GeneralLocaleUpsertResult']?: Omit<ValueTypes["GeneralLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StickyBarCreateResult']?: Omit<ValueTypes["StickyBarCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StickyBarDeleteResult']?: Omit<ValueTypes["StickyBarDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StickyBarUpdateResult']?: Omit<ValueTypes["StickyBarUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StickyBarUpsertResult']?: Omit<ValueTypes["StickyBarUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormCreateResult']?: Omit<ValueTypes["RecommendationFormCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormDeleteResult']?: Omit<ValueTypes["RecommendationFormDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormUpdateResult']?: Omit<ValueTypes["RecommendationFormUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormUpsertResult']?: Omit<ValueTypes["RecommendationFormUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormLocaleCreateResult']?: Omit<ValueTypes["RecommendationFormLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormLocaleDeleteResult']?: Omit<ValueTypes["RecommendationFormLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormLocaleUpdateResult']?: Omit<ValueTypes["RecommendationFormLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormLocaleUpsertResult']?: Omit<ValueTypes["RecommendationFormLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormSubscriptionCreateResult']?: Omit<ValueTypes["RecommendationFormSubscriptionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormSubscriptionDeleteResult']?: Omit<ValueTypes["RecommendationFormSubscriptionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormSubscriptionUpdateResult']?: Omit<ValueTypes["RecommendationFormSubscriptionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RecommendationFormSubscriptionUpsertResult']?: Omit<ValueTypes["RecommendationFormSubscriptionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoBoxCreateResult']?: Omit<ValueTypes["InfoBoxCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoBoxDeleteResult']?: Omit<ValueTypes["InfoBoxDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoBoxUpdateResult']?: Omit<ValueTypes["InfoBoxUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoBoxUpsertResult']?: Omit<ValueTypes["InfoBoxUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoBoxLocaleCreateResult']?: Omit<ValueTypes["InfoBoxLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoBoxLocaleDeleteResult']?: Omit<ValueTypes["InfoBoxLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoBoxLocaleUpdateResult']?: Omit<ValueTypes["InfoBoxLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoBoxLocaleUpsertResult']?: Omit<ValueTypes["InfoBoxLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCreateResult']?: Omit<ValueTypes["TranslationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDeleteResult']?: Omit<ValueTypes["TranslationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationUpdateResult']?: Omit<ValueTypes["TranslationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationUpsertResult']?: Omit<ValueTypes["TranslationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationLocaleCreateResult']?: Omit<ValueTypes["TranslationLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationLocaleDeleteResult']?: Omit<ValueTypes["TranslationLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationLocaleUpdateResult']?: Omit<ValueTypes["TranslationLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationLocaleUpsertResult']?: Omit<ValueTypes["TranslationLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CornerBannerCreateResult']?: Omit<ValueTypes["CornerBannerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CornerBannerDeleteResult']?: Omit<ValueTypes["CornerBannerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CornerBannerUpdateResult']?: Omit<ValueTypes["CornerBannerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CornerBannerUpsertResult']?: Omit<ValueTypes["CornerBannerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: boolean | `@${string}`
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["GeneralDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["General"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["General"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["General"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: boolean | `@${string}`
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: boolean | `@${string}`
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
		__typename?: boolean | `@${string}`
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: boolean | `@${string}`
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
		__typename?: boolean | `@${string}`
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefault"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefault"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefault"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefault"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefaultLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefaultLocale"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefaultLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefaultLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Business"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Business"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Business"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Business"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessPage"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IconCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Icon"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IconDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Icon"],
		__typename?: boolean | `@${string}`
}>;
	["IconUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Icon"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IconUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Icon"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPage"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["KeyInfoItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["KeyInfoItem"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["KeyInfoItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["KeyInfoItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["KeyInfoList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["KeyInfoList"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["KeyInfoList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["KeyInfoList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContractType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContractType"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContractType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContractType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContractTypeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContractTypeLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContractTypeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContractTypeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobCity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobCity"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobCity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobCity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobCityLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobCityLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobCityLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobCityLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPosition"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPosition"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPosition"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPosition"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPositionLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPositionLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPositionLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobPositionLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
		__typename?: boolean | `@${string}`
}>;
	["MediumUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
		__typename?: boolean | `@${string}`
}>;
	["VideoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
		__typename?: boolean | `@${string}`
}>;
	["TextListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Carousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Carousel"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Carousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Carousel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CarouselItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CarouselItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CarouselItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Theme"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Theme"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Theme"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Theme"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BonusBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BonusBanner"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BonusBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BonusBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BonusBannerLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BonusBannerLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BonusBannerLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BonusBannerLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tile"],
		__typename?: boolean | `@${string}`
}>;
	["TileUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SideBySide"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SideBySide"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SideBySide"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SideBySide"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SideBySideItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SideBySideItem"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SideBySideItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SideBySideItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLokal"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLokal"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLokal"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLokal"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLokalLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLokalLocale"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLokalLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLokalLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteSwitcher"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteSwitcher"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteSwitcher"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteSwitcher"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsForm"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFormLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTextItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTextList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFilter"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFilter"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFilter"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFilter"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFilterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFilterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFilterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobsFilterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FileCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FileDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
		__typename?: boolean | `@${string}`
}>;
	["FileUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FileUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobFormSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobFormSubscription"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobFormSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobFormSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobFormSubscriptionStatus"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobFormSubscriptionStatus"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobFormSubscriptionStatus"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["JobFormSubscriptionStatus"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GeneralLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GeneralLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GeneralLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GeneralLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StickyBar"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StickyBar"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StickyBar"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StickyBar"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationForm"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationFormLocale"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationFormSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationFormSubscription"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationFormSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RecommendationFormSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoBox"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoBox"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoBox"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoBox"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoBoxLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoBoxLocale"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoBoxLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoBoxLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Translation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Translation"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Translation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Translation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CornerBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CornerBanner"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CornerBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CornerBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTransaction"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
generateUploadUrl?: [{	input?: ValueTypes["S3GenerateSignedUploadInput"] | undefined | null | Variable<any, string>},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey: string | Variable<any, string>,	expiration?: number | undefined | null | Variable<any, string>},ValueTypes["S3SignedRead"]],
createGeneral?: [{	data: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["GeneralCreateResult"]],
deleteGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralDeleteResult"]],
updateGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GeneralUpdateInput"] | Variable<any, string>},ValueTypes["GeneralUpdateResult"]],
upsertGeneral?: [{	by: ValueTypes["GeneralUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GeneralUpdateInput"] | Variable<any, string>,	create: ValueTypes["GeneralCreateInput"] | Variable<any, string>},ValueTypes["GeneralUpsertResult"]],
createImage?: [{	data: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageUpdateInput"] | Variable<any, string>},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by: ValueTypes["ImageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageCreateInput"] | Variable<any, string>},ValueTypes["ImageUpsertResult"]],
createGenericPage?: [{	data: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by: ValueTypes["GenericPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageCreateInput"] | Variable<any, string>},ValueTypes["GenericPageUpsertResult"]],
createLinkable?: [{	data: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkableUpdateInput"] | Variable<any, string>},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkableWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkableUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkableCreateInput"] | Variable<any, string>},ValueTypes["LinkableUpsertResult"]],
createSeo?: [{	data: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SeoUpdateInput"] | Variable<any, string>},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by: ValueTypes["SeoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SeoUpdateInput"] | Variable<any, string>,	create: ValueTypes["SeoCreateInput"] | Variable<any, string>},ValueTypes["SeoUpsertResult"]],
createContent?: [{	data: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentUpdateInput"] | Variable<any, string>},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by: ValueTypes["ContentUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentCreateInput"] | Variable<any, string>},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentBlockWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentBlockUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentBlockCreateInput"] | Variable<any, string>},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContentReferenceUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContentReferenceCreateInput"] | Variable<any, string>},ValueTypes["ContentReferenceUpsertResult"]],
createRedirect?: [{	data: ValueTypes["RedirectCreateInput"] | Variable<any, string>},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RedirectUpdateInput"] | Variable<any, string>},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RedirectWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RedirectUpdateInput"] | Variable<any, string>,	create: ValueTypes["RedirectCreateInput"] | Variable<any, string>},ValueTypes["RedirectUpsertResult"]],
createLink?: [{	data: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LinkUpdateInput"] | Variable<any, string>},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by: ValueTypes["LinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LinkWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LinkUpdateInput"] | Variable<any, string>,	create: ValueTypes["LinkCreateInput"] | Variable<any, string>},ValueTypes["LinkUpsertResult"]],
createFooter?: [{	data: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FooterUpdateInput"] | Variable<any, string>},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by: ValueTypes["FooterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FooterUpdateInput"] | Variable<any, string>,	create: ValueTypes["FooterCreateInput"] | Variable<any, string>},ValueTypes["FooterUpsertResult"]],
createFooterLink?: [{	data: ValueTypes["FooterLinkCreateInput"] | Variable<any, string>},ValueTypes["FooterLinkCreateResult"]],
deleteFooterLink?: [{	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLinkDeleteResult"]],
updateFooterLink?: [{	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FooterLinkUpdateInput"] | Variable<any, string>},ValueTypes["FooterLinkUpdateResult"]],
upsertFooterLink?: [{	by: ValueTypes["FooterLinkUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLinkWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FooterLinkUpdateInput"] | Variable<any, string>,	create: ValueTypes["FooterLinkCreateInput"] | Variable<any, string>},ValueTypes["FooterLinkUpsertResult"]],
createFooterLocale?: [{	data: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by: ValueTypes["FooterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FooterLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FooterLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["FooterLocaleCreateInput"] | Variable<any, string>},ValueTypes["FooterLocaleUpsertResult"]],
createGenericPageLocale?: [{	data: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleCreateResult"]],
deleteGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GenericPageLocaleDeleteResult"]],
updateGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleUpdateResult"]],
upsertGenericPageLocale?: [{	by: ValueTypes["GenericPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GenericPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GenericPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GenericPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["GenericPageLocaleUpsertResult"]],
createHeader?: [{	data: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeaderUpdateInput"] | Variable<any, string>},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by: ValueTypes["HeaderUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeaderUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeaderCreateInput"] | Variable<any, string>},ValueTypes["HeaderUpsertResult"]],
createHeaderLocale?: [{	data: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by: ValueTypes["HeaderLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HeaderLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HeaderLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["HeaderLocaleCreateInput"] | Variable<any, string>},ValueTypes["HeaderLocaleUpsertResult"]],
createLocale?: [{	data: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["LocaleUpdateInput"] | Variable<any, string>},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by: ValueTypes["LocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["LocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["LocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["LocaleCreateInput"] | Variable<any, string>},ValueTypes["LocaleUpsertResult"]],
createSeoDefault?: [{	data: ValueTypes["SeoDefaultCreateInput"] | Variable<any, string>},ValueTypes["SeoDefaultCreateResult"]],
deleteSeoDefault?: [{	by: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultDeleteResult"]],
updateSeoDefault?: [{	by: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SeoDefaultUpdateInput"] | Variable<any, string>},ValueTypes["SeoDefaultUpdateResult"]],
upsertSeoDefault?: [{	by: ValueTypes["SeoDefaultUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SeoDefaultUpdateInput"] | Variable<any, string>,	create: ValueTypes["SeoDefaultCreateInput"] | Variable<any, string>},ValueTypes["SeoDefaultUpsertResult"]],
createSeoDefaultLocale?: [{	data: ValueTypes["SeoDefaultLocaleCreateInput"] | Variable<any, string>},ValueTypes["SeoDefaultLocaleCreateResult"]],
deleteSeoDefaultLocale?: [{	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["SeoDefaultLocaleDeleteResult"]],
updateSeoDefaultLocale?: [{	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SeoDefaultLocaleUpdateInput"] | Variable<any, string>},ValueTypes["SeoDefaultLocaleUpdateResult"]],
upsertSeoDefaultLocale?: [{	by: ValueTypes["SeoDefaultLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SeoDefaultLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SeoDefaultLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["SeoDefaultLocaleCreateInput"] | Variable<any, string>},ValueTypes["SeoDefaultLocaleUpsertResult"]],
createBusiness?: [{	data: ValueTypes["BusinessCreateInput"] | Variable<any, string>},ValueTypes["BusinessCreateResult"]],
deleteBusiness?: [{	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessDeleteResult"]],
updateBusiness?: [{	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["BusinessUpdateInput"] | Variable<any, string>},ValueTypes["BusinessUpdateResult"]],
upsertBusiness?: [{	by: ValueTypes["BusinessUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["BusinessUpdateInput"] | Variable<any, string>,	create: ValueTypes["BusinessCreateInput"] | Variable<any, string>},ValueTypes["BusinessUpsertResult"]],
createBusinessPage?: [{	data: ValueTypes["BusinessPageCreateInput"] | Variable<any, string>},ValueTypes["BusinessPageCreateResult"]],
deleteBusinessPage?: [{	by: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageDeleteResult"]],
updateBusinessPage?: [{	by: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["BusinessPageUpdateInput"] | Variable<any, string>},ValueTypes["BusinessPageUpdateResult"]],
upsertBusinessPage?: [{	by: ValueTypes["BusinessPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["BusinessPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["BusinessPageCreateInput"] | Variable<any, string>},ValueTypes["BusinessPageUpsertResult"]],
createBusinessPageLocale?: [{	data: ValueTypes["BusinessPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["BusinessPageLocaleCreateResult"]],
deleteBusinessPageLocale?: [{	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BusinessPageLocaleDeleteResult"]],
updateBusinessPageLocale?: [{	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["BusinessPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["BusinessPageLocaleUpdateResult"]],
upsertBusinessPageLocale?: [{	by: ValueTypes["BusinessPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BusinessPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["BusinessPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["BusinessPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["BusinessPageLocaleUpsertResult"]],
createIcon?: [{	data: ValueTypes["IconCreateInput"] | Variable<any, string>},ValueTypes["IconCreateResult"]],
deleteIcon?: [{	by: ValueTypes["IconUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>},ValueTypes["IconDeleteResult"]],
updateIcon?: [{	by: ValueTypes["IconUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["IconUpdateInput"] | Variable<any, string>},ValueTypes["IconUpdateResult"]],
upsertIcon?: [{	by: ValueTypes["IconUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["IconWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["IconUpdateInput"] | Variable<any, string>,	create: ValueTypes["IconCreateInput"] | Variable<any, string>},ValueTypes["IconUpsertResult"]],
createJobPage?: [{	data: ValueTypes["JobPageCreateInput"] | Variable<any, string>},ValueTypes["JobPageCreateResult"]],
deleteJobPage?: [{	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageDeleteResult"]],
updateJobPage?: [{	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobPageUpdateInput"] | Variable<any, string>},ValueTypes["JobPageUpdateResult"]],
upsertJobPage?: [{	by: ValueTypes["JobPageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobPageUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobPageCreateInput"] | Variable<any, string>},ValueTypes["JobPageUpsertResult"]],
createJobPageLocale?: [{	data: ValueTypes["JobPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobPageLocaleCreateResult"]],
deleteJobPageLocale?: [{	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPageLocaleDeleteResult"]],
updateJobPageLocale?: [{	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobPageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["JobPageLocaleUpdateResult"]],
upsertJobPageLocale?: [{	by: ValueTypes["JobPageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobPageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobPageLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobPageLocaleUpsertResult"]],
createKeyInfoItem?: [{	data: ValueTypes["KeyInfoItemCreateInput"] | Variable<any, string>},ValueTypes["KeyInfoItemCreateResult"]],
deleteKeyInfoItem?: [{	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["KeyInfoItemDeleteResult"]],
updateKeyInfoItem?: [{	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["KeyInfoItemUpdateInput"] | Variable<any, string>},ValueTypes["KeyInfoItemUpdateResult"]],
upsertKeyInfoItem?: [{	by: ValueTypes["KeyInfoItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["KeyInfoItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["KeyInfoItemCreateInput"] | Variable<any, string>},ValueTypes["KeyInfoItemUpsertResult"]],
createKeyInfoList?: [{	data: ValueTypes["KeyInfoListCreateInput"] | Variable<any, string>},ValueTypes["KeyInfoListCreateResult"]],
deleteKeyInfoList?: [{	by: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>},ValueTypes["KeyInfoListDeleteResult"]],
updateKeyInfoList?: [{	by: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["KeyInfoListUpdateInput"] | Variable<any, string>},ValueTypes["KeyInfoListUpdateResult"]],
upsertKeyInfoList?: [{	by: ValueTypes["KeyInfoListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["KeyInfoListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["KeyInfoListUpdateInput"] | Variable<any, string>,	create: ValueTypes["KeyInfoListCreateInput"] | Variable<any, string>},ValueTypes["KeyInfoListUpsertResult"]],
createContractType?: [{	data: ValueTypes["ContractTypeCreateInput"] | Variable<any, string>},ValueTypes["ContractTypeCreateResult"]],
deleteContractType?: [{	by: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractTypeDeleteResult"]],
updateContractType?: [{	by: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContractTypeUpdateInput"] | Variable<any, string>},ValueTypes["ContractTypeUpdateResult"]],
upsertContractType?: [{	by: ValueTypes["ContractTypeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContractTypeUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContractTypeCreateInput"] | Variable<any, string>},ValueTypes["ContractTypeUpsertResult"]],
createContractTypeLocale?: [{	data: ValueTypes["ContractTypeLocaleCreateInput"] | Variable<any, string>},ValueTypes["ContractTypeLocaleCreateResult"]],
deleteContractTypeLocale?: [{	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["ContractTypeLocaleDeleteResult"]],
updateContractTypeLocale?: [{	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ContractTypeLocaleUpdateInput"] | Variable<any, string>},ValueTypes["ContractTypeLocaleUpdateResult"]],
upsertContractTypeLocale?: [{	by: ValueTypes["ContractTypeLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ContractTypeLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ContractTypeLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["ContractTypeLocaleCreateInput"] | Variable<any, string>},ValueTypes["ContractTypeLocaleUpsertResult"]],
createJobCity?: [{	data: ValueTypes["JobCityCreateInput"] | Variable<any, string>},ValueTypes["JobCityCreateResult"]],
deleteJobCity?: [{	by: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCityDeleteResult"]],
updateJobCity?: [{	by: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobCityUpdateInput"] | Variable<any, string>},ValueTypes["JobCityUpdateResult"]],
upsertJobCity?: [{	by: ValueTypes["JobCityUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobCityUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobCityCreateInput"] | Variable<any, string>},ValueTypes["JobCityUpsertResult"]],
createJobCityLocale?: [{	data: ValueTypes["JobCityLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobCityLocaleCreateResult"]],
deleteJobCityLocale?: [{	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobCityLocaleDeleteResult"]],
updateJobCityLocale?: [{	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobCityLocaleUpdateInput"] | Variable<any, string>},ValueTypes["JobCityLocaleUpdateResult"]],
upsertJobCityLocale?: [{	by: ValueTypes["JobCityLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobCityLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobCityLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobCityLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobCityLocaleUpsertResult"]],
createJobPosition?: [{	data: ValueTypes["JobPositionCreateInput"] | Variable<any, string>},ValueTypes["JobPositionCreateResult"]],
deleteJobPosition?: [{	by: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPositionDeleteResult"]],
updateJobPosition?: [{	by: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobPositionUpdateInput"] | Variable<any, string>},ValueTypes["JobPositionUpdateResult"]],
upsertJobPosition?: [{	by: ValueTypes["JobPositionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobPositionUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobPositionCreateInput"] | Variable<any, string>},ValueTypes["JobPositionUpsertResult"]],
createJobPositionLocale?: [{	data: ValueTypes["JobPositionLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobPositionLocaleCreateResult"]],
deleteJobPositionLocale?: [{	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobPositionLocaleDeleteResult"]],
updateJobPositionLocale?: [{	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobPositionLocaleUpdateInput"] | Variable<any, string>},ValueTypes["JobPositionLocaleUpdateResult"]],
upsertJobPositionLocale?: [{	by: ValueTypes["JobPositionLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobPositionLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobPositionLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobPositionLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobPositionLocaleUpsertResult"]],
createGallery?: [{	data: ValueTypes["GalleryCreateInput"] | Variable<any, string>},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GalleryUpdateInput"] | Variable<any, string>},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by: ValueTypes["GalleryUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GalleryUpdateInput"] | Variable<any, string>,	create: ValueTypes["GalleryCreateInput"] | Variable<any, string>},ValueTypes["GalleryUpsertResult"]],
createHomePage?: [{	data: ValueTypes["HomePageCreateInput"] | Variable<any, string>},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HomePageUpdateInput"] | Variable<any, string>},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by: ValueTypes["HomePageUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HomePageUpdateInput"] | Variable<any, string>,	create: ValueTypes["HomePageCreateInput"] | Variable<any, string>},ValueTypes["HomePageUpsertResult"]],
createHomePageLocale?: [{	data: ValueTypes["HomePageLocaleCreateInput"] | Variable<any, string>},ValueTypes["HomePageLocaleCreateResult"]],
deleteHomePageLocale?: [{	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLocaleDeleteResult"]],
updateHomePageLocale?: [{	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HomePageLocaleUpdateInput"] | Variable<any, string>},ValueTypes["HomePageLocaleUpdateResult"]],
upsertHomePageLocale?: [{	by: ValueTypes["HomePageLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HomePageLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["HomePageLocaleCreateInput"] | Variable<any, string>},ValueTypes["HomePageLocaleUpsertResult"]],
createMedium?: [{	data: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumUpdateInput"] | Variable<any, string>},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by: ValueTypes["MediumUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumCreateInput"] | Variable<any, string>},ValueTypes["MediumUpsertResult"]],
createMediumItem?: [{	data: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["MediumItemCreateResult"]],
deleteMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumItemDeleteResult"]],
updateMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>},ValueTypes["MediumItemUpdateResult"]],
upsertMediumItem?: [{	by: ValueTypes["MediumItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumItemCreateInput"] | Variable<any, string>},ValueTypes["MediumItemUpsertResult"]],
createMediumList?: [{	data: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["MediumListCreateResult"]],
deleteMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>},ValueTypes["MediumListDeleteResult"]],
updateMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["MediumListUpdateInput"] | Variable<any, string>},ValueTypes["MediumListUpdateResult"]],
upsertMediumList?: [{	by: ValueTypes["MediumListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["MediumListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["MediumListUpdateInput"] | Variable<any, string>,	create: ValueTypes["MediumListCreateInput"] | Variable<any, string>},ValueTypes["MediumListUpsertResult"]],
createVideo?: [{	data: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["VideoUpdateInput"] | Variable<any, string>},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by: ValueTypes["VideoUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["VideoWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["VideoUpdateInput"] | Variable<any, string>,	create: ValueTypes["VideoCreateInput"] | Variable<any, string>},ValueTypes["VideoUpsertResult"]],
createTextItem?: [{	data: ValueTypes["TextItemCreateInput"] | Variable<any, string>},ValueTypes["TextItemCreateResult"]],
deleteTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextItemDeleteResult"]],
updateTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TextItemUpdateInput"] | Variable<any, string>},ValueTypes["TextItemUpdateResult"]],
upsertTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TextItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["TextItemCreateInput"] | Variable<any, string>},ValueTypes["TextItemUpsertResult"]],
createTextList?: [{	data: ValueTypes["TextListCreateInput"] | Variable<any, string>},ValueTypes["TextListCreateResult"]],
deleteTextList?: [{	by: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["TextListDeleteResult"]],
updateTextList?: [{	by: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TextListUpdateInput"] | Variable<any, string>},ValueTypes["TextListUpdateResult"]],
upsertTextList?: [{	by: ValueTypes["TextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TextListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TextListUpdateInput"] | Variable<any, string>,	create: ValueTypes["TextListCreateInput"] | Variable<any, string>},ValueTypes["TextListUpsertResult"]],
createCarousel?: [{	data: ValueTypes["CarouselCreateInput"] | Variable<any, string>},ValueTypes["CarouselCreateResult"]],
deleteCarousel?: [{	by: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>},ValueTypes["CarouselDeleteResult"]],
updateCarousel?: [{	by: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CarouselUpdateInput"] | Variable<any, string>},ValueTypes["CarouselUpdateResult"]],
upsertCarousel?: [{	by: ValueTypes["CarouselUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CarouselUpdateInput"] | Variable<any, string>,	create: ValueTypes["CarouselCreateInput"] | Variable<any, string>},ValueTypes["CarouselUpsertResult"]],
createCarouselItem?: [{	data: ValueTypes["CarouselItemCreateInput"] | Variable<any, string>},ValueTypes["CarouselItemCreateResult"]],
deleteCarouselItem?: [{	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["CarouselItemDeleteResult"]],
updateCarouselItem?: [{	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CarouselItemUpdateInput"] | Variable<any, string>},ValueTypes["CarouselItemUpdateResult"]],
upsertCarouselItem?: [{	by: ValueTypes["CarouselItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CarouselItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CarouselItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["CarouselItemCreateInput"] | Variable<any, string>},ValueTypes["CarouselItemUpsertResult"]],
createTheme?: [{	data: ValueTypes["ThemeCreateInput"] | Variable<any, string>},ValueTypes["ThemeCreateResult"]],
deleteTheme?: [{	by: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>},ValueTypes["ThemeDeleteResult"]],
updateTheme?: [{	by: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ThemeUpdateInput"] | Variable<any, string>},ValueTypes["ThemeUpdateResult"]],
upsertTheme?: [{	by: ValueTypes["ThemeUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ThemeWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ThemeUpdateInput"] | Variable<any, string>,	create: ValueTypes["ThemeCreateInput"] | Variable<any, string>},ValueTypes["ThemeUpsertResult"]],
createBonusBanner?: [{	data: ValueTypes["BonusBannerCreateInput"] | Variable<any, string>},ValueTypes["BonusBannerCreateResult"]],
deleteBonusBanner?: [{	by: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerDeleteResult"]],
updateBonusBanner?: [{	by: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["BonusBannerUpdateInput"] | Variable<any, string>},ValueTypes["BonusBannerUpdateResult"]],
upsertBonusBanner?: [{	by: ValueTypes["BonusBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["BonusBannerUpdateInput"] | Variable<any, string>,	create: ValueTypes["BonusBannerCreateInput"] | Variable<any, string>},ValueTypes["BonusBannerUpsertResult"]],
createBonusBannerLocale?: [{	data: ValueTypes["BonusBannerLocaleCreateInput"] | Variable<any, string>},ValueTypes["BonusBannerLocaleCreateResult"]],
deleteBonusBannerLocale?: [{	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["BonusBannerLocaleDeleteResult"]],
updateBonusBannerLocale?: [{	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["BonusBannerLocaleUpdateInput"] | Variable<any, string>},ValueTypes["BonusBannerLocaleUpdateResult"]],
upsertBonusBannerLocale?: [{	by: ValueTypes["BonusBannerLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["BonusBannerLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["BonusBannerLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["BonusBannerLocaleCreateInput"] | Variable<any, string>},ValueTypes["BonusBannerLocaleUpsertResult"]],
createTile?: [{	data: ValueTypes["TileCreateInput"] | Variable<any, string>},ValueTypes["TileCreateResult"]],
deleteTile?: [{	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>},ValueTypes["TileDeleteResult"]],
updateTile?: [{	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TileUpdateInput"] | Variable<any, string>},ValueTypes["TileUpdateResult"]],
upsertTile?: [{	by: ValueTypes["TileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TileWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TileUpdateInput"] | Variable<any, string>,	create: ValueTypes["TileCreateInput"] | Variable<any, string>},ValueTypes["TileUpsertResult"]],
createSideBySide?: [{	data: ValueTypes["SideBySideCreateInput"] | Variable<any, string>},ValueTypes["SideBySideCreateResult"]],
deleteSideBySide?: [{	by: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySideDeleteResult"]],
updateSideBySide?: [{	by: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SideBySideUpdateInput"] | Variable<any, string>},ValueTypes["SideBySideUpdateResult"]],
upsertSideBySide?: [{	by: ValueTypes["SideBySideUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SideBySideUpdateInput"] | Variable<any, string>,	create: ValueTypes["SideBySideCreateInput"] | Variable<any, string>},ValueTypes["SideBySideUpsertResult"]],
createSideBySideItem?: [{	data: ValueTypes["SideBySideItemCreateInput"] | Variable<any, string>},ValueTypes["SideBySideItemCreateResult"]],
deleteSideBySideItem?: [{	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["SideBySideItemDeleteResult"]],
updateSideBySideItem?: [{	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SideBySideItemUpdateInput"] | Variable<any, string>},ValueTypes["SideBySideItemUpdateResult"]],
upsertSideBySideItem?: [{	by: ValueTypes["SideBySideItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SideBySideItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SideBySideItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["SideBySideItemCreateInput"] | Variable<any, string>},ValueTypes["SideBySideItemUpsertResult"]],
createHomePageLokal?: [{	data: ValueTypes["HomePageLokalCreateInput"] | Variable<any, string>},ValueTypes["HomePageLokalCreateResult"]],
deleteHomePageLokal?: [{	by: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalDeleteResult"]],
updateHomePageLokal?: [{	by: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HomePageLokalUpdateInput"] | Variable<any, string>},ValueTypes["HomePageLokalUpdateResult"]],
upsertHomePageLokal?: [{	by: ValueTypes["HomePageLokalUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HomePageLokalUpdateInput"] | Variable<any, string>,	create: ValueTypes["HomePageLokalCreateInput"] | Variable<any, string>},ValueTypes["HomePageLokalUpsertResult"]],
createHomePageLokalLocale?: [{	data: ValueTypes["HomePageLokalLocaleCreateInput"] | Variable<any, string>},ValueTypes["HomePageLokalLocaleCreateResult"]],
deleteHomePageLokalLocale?: [{	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["HomePageLokalLocaleDeleteResult"]],
updateHomePageLokalLocale?: [{	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["HomePageLokalLocaleUpdateInput"] | Variable<any, string>},ValueTypes["HomePageLokalLocaleUpdateResult"]],
upsertHomePageLokalLocale?: [{	by: ValueTypes["HomePageLokalLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["HomePageLokalLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["HomePageLokalLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["HomePageLokalLocaleCreateInput"] | Variable<any, string>},ValueTypes["HomePageLokalLocaleUpsertResult"]],
createSiteSwitcher?: [{	data: ValueTypes["SiteSwitcherCreateInput"] | Variable<any, string>},ValueTypes["SiteSwitcherCreateResult"]],
deleteSiteSwitcher?: [{	by: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>},ValueTypes["SiteSwitcherDeleteResult"]],
updateSiteSwitcher?: [{	by: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["SiteSwitcherUpdateInput"] | Variable<any, string>},ValueTypes["SiteSwitcherUpdateResult"]],
upsertSiteSwitcher?: [{	by: ValueTypes["SiteSwitcherUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["SiteSwitcherWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["SiteSwitcherUpdateInput"] | Variable<any, string>,	create: ValueTypes["SiteSwitcherCreateInput"] | Variable<any, string>},ValueTypes["SiteSwitcherUpsertResult"]],
createGalleryItem?: [{	data: ValueTypes["GalleryItemCreateInput"] | Variable<any, string>},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GalleryItemUpdateInput"] | Variable<any, string>},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GalleryItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GalleryItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["GalleryItemCreateInput"] | Variable<any, string>},ValueTypes["GalleryItemUpsertResult"]],
createJobsForm?: [{	data: ValueTypes["JobsFormCreateInput"] | Variable<any, string>},ValueTypes["JobsFormCreateResult"]],
deleteJobsForm?: [{	by: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormDeleteResult"]],
updateJobsForm?: [{	by: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobsFormUpdateInput"] | Variable<any, string>},ValueTypes["JobsFormUpdateResult"]],
upsertJobsForm?: [{	by: ValueTypes["JobsFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobsFormUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobsFormCreateInput"] | Variable<any, string>},ValueTypes["JobsFormUpsertResult"]],
createJobsFormLocale?: [{	data: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobsFormLocaleCreateResult"]],
deleteJobsFormLocale?: [{	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFormLocaleDeleteResult"]],
updateJobsFormLocale?: [{	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>},ValueTypes["JobsFormLocaleUpdateResult"]],
upsertJobsFormLocale?: [{	by: ValueTypes["JobsFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFormLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobsFormLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobsFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobsFormLocaleUpsertResult"]],
createImageTextItem?: [{	data: ValueTypes["ImageTextItemCreateInput"] | Variable<any, string>},ValueTypes["ImageTextItemCreateResult"]],
deleteImageTextItem?: [{	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextItemDeleteResult"]],
updateImageTextItem?: [{	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageTextItemUpdateInput"] | Variable<any, string>},ValueTypes["ImageTextItemUpdateResult"]],
upsertImageTextItem?: [{	by: ValueTypes["ImageTextItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageTextItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageTextItemCreateInput"] | Variable<any, string>},ValueTypes["ImageTextItemUpsertResult"]],
createImageTextList?: [{	data: ValueTypes["ImageTextListCreateInput"] | Variable<any, string>},ValueTypes["ImageTextListCreateResult"]],
deleteImageTextList?: [{	by: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageTextListDeleteResult"]],
updateImageTextList?: [{	by: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageTextListUpdateInput"] | Variable<any, string>},ValueTypes["ImageTextListUpdateResult"]],
upsertImageTextList?: [{	by: ValueTypes["ImageTextListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageTextListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageTextListUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageTextListCreateInput"] | Variable<any, string>},ValueTypes["ImageTextListUpsertResult"]],
createJobsFilter?: [{	data: ValueTypes["JobsFilterCreateInput"] | Variable<any, string>},ValueTypes["JobsFilterCreateResult"]],
deleteJobsFilter?: [{	by: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterDeleteResult"]],
updateJobsFilter?: [{	by: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobsFilterUpdateInput"] | Variable<any, string>},ValueTypes["JobsFilterUpdateResult"]],
upsertJobsFilter?: [{	by: ValueTypes["JobsFilterUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobsFilterUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobsFilterCreateInput"] | Variable<any, string>},ValueTypes["JobsFilterUpsertResult"]],
createJobsFilterLocale?: [{	data: ValueTypes["JobsFilterLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobsFilterLocaleCreateResult"]],
deleteJobsFilterLocale?: [{	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobsFilterLocaleDeleteResult"]],
updateJobsFilterLocale?: [{	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobsFilterLocaleUpdateInput"] | Variable<any, string>},ValueTypes["JobsFilterLocaleUpdateResult"]],
upsertJobsFilterLocale?: [{	by: ValueTypes["JobsFilterLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobsFilterLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobsFilterLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobsFilterLocaleCreateInput"] | Variable<any, string>},ValueTypes["JobsFilterLocaleUpsertResult"]],
createFile?: [{	data: ValueTypes["FileCreateInput"] | Variable<any, string>},ValueTypes["FileCreateResult"]],
deleteFile?: [{	by: ValueTypes["FileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>},ValueTypes["FileDeleteResult"]],
updateFile?: [{	by: ValueTypes["FileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["FileUpdateInput"] | Variable<any, string>},ValueTypes["FileUpdateResult"]],
upsertFile?: [{	by: ValueTypes["FileUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["FileWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["FileUpdateInput"] | Variable<any, string>,	create: ValueTypes["FileCreateInput"] | Variable<any, string>},ValueTypes["FileUpsertResult"]],
createJobFormSubscription?: [{	data: ValueTypes["JobFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionCreateResult"]],
deleteJobFormSubscription?: [{	by: ValueTypes["JobFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionDeleteResult"]],
updateJobFormSubscription?: [{	by: ValueTypes["JobFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobFormSubscriptionUpdateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionUpdateResult"]],
upsertJobFormSubscription?: [{	by: ValueTypes["JobFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobFormSubscriptionUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionUpsertResult"]],
createImageList?: [{	data: ValueTypes["ImageListCreateInput"] | Variable<any, string>},ValueTypes["ImageListCreateResult"]],
deleteImageList?: [{	by: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageListDeleteResult"]],
updateImageList?: [{	by: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageListUpdateInput"] | Variable<any, string>},ValueTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by: ValueTypes["ImageListUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageListUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageListCreateInput"] | Variable<any, string>},ValueTypes["ImageListUpsertResult"]],
createImageListItem?: [{	data: ValueTypes["ImageListItemCreateInput"] | Variable<any, string>},ValueTypes["ImageListItemCreateResult"]],
deleteImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>},ValueTypes["ImageListItemDeleteResult"]],
updateImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["ImageListItemUpdateInput"] | Variable<any, string>},ValueTypes["ImageListItemUpdateResult"]],
upsertImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["ImageListItemWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["ImageListItemUpdateInput"] | Variable<any, string>,	create: ValueTypes["ImageListItemCreateInput"] | Variable<any, string>},ValueTypes["ImageListItemUpsertResult"]],
createJobFormSubscriptionStatus?: [{	data: ValueTypes["JobFormSubscriptionStatusCreateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionStatusCreateResult"]],
deleteJobFormSubscriptionStatus?: [{	by: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>},ValueTypes["JobFormSubscriptionStatusDeleteResult"]],
updateJobFormSubscriptionStatus?: [{	by: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["JobFormSubscriptionStatusUpdateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionStatusUpdateResult"]],
upsertJobFormSubscriptionStatus?: [{	by: ValueTypes["JobFormSubscriptionStatusUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["JobFormSubscriptionStatusWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["JobFormSubscriptionStatusUpdateInput"] | Variable<any, string>,	create: ValueTypes["JobFormSubscriptionStatusCreateInput"] | Variable<any, string>},ValueTypes["JobFormSubscriptionStatusUpsertResult"]],
createGeneralLocale?: [{	data: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleCreateResult"]],
deleteGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["GeneralLocaleDeleteResult"]],
updateGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleUpdateResult"]],
upsertGeneralLocale?: [{	by: ValueTypes["GeneralLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["GeneralLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["GeneralLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["GeneralLocaleCreateInput"] | Variable<any, string>},ValueTypes["GeneralLocaleUpsertResult"]],
createStickyBar?: [{	data: ValueTypes["StickyBarCreateInput"] | Variable<any, string>},ValueTypes["StickyBarCreateResult"]],
deleteStickyBar?: [{	by: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>},ValueTypes["StickyBarDeleteResult"]],
updateStickyBar?: [{	by: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["StickyBarUpdateInput"] | Variable<any, string>},ValueTypes["StickyBarUpdateResult"]],
upsertStickyBar?: [{	by: ValueTypes["StickyBarUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["StickyBarWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["StickyBarUpdateInput"] | Variable<any, string>,	create: ValueTypes["StickyBarCreateInput"] | Variable<any, string>},ValueTypes["StickyBarUpsertResult"]],
createRecommendationForm?: [{	data: ValueTypes["RecommendationFormCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormCreateResult"]],
deleteRecommendationForm?: [{	by: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormDeleteResult"]],
updateRecommendationForm?: [{	by: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RecommendationFormUpdateInput"] | Variable<any, string>},ValueTypes["RecommendationFormUpdateResult"]],
upsertRecommendationForm?: [{	by: ValueTypes["RecommendationFormUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RecommendationFormUpdateInput"] | Variable<any, string>,	create: ValueTypes["RecommendationFormCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormUpsertResult"]],
createRecommendationFormLocale?: [{	data: ValueTypes["RecommendationFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormLocaleCreateResult"]],
deleteRecommendationFormLocale?: [{	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormLocaleDeleteResult"]],
updateRecommendationFormLocale?: [{	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RecommendationFormLocaleUpdateInput"] | Variable<any, string>},ValueTypes["RecommendationFormLocaleUpdateResult"]],
upsertRecommendationFormLocale?: [{	by: ValueTypes["RecommendationFormLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RecommendationFormLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["RecommendationFormLocaleCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormLocaleUpsertResult"]],
createRecommendationFormSubscription?: [{	data: ValueTypes["RecommendationFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormSubscriptionCreateResult"]],
deleteRecommendationFormSubscription?: [{	by: ValueTypes["RecommendationFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>},ValueTypes["RecommendationFormSubscriptionDeleteResult"]],
updateRecommendationFormSubscription?: [{	by: ValueTypes["RecommendationFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["RecommendationFormSubscriptionUpdateInput"] | Variable<any, string>},ValueTypes["RecommendationFormSubscriptionUpdateResult"]],
upsertRecommendationFormSubscription?: [{	by: ValueTypes["RecommendationFormSubscriptionUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["RecommendationFormSubscriptionWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["RecommendationFormSubscriptionUpdateInput"] | Variable<any, string>,	create: ValueTypes["RecommendationFormSubscriptionCreateInput"] | Variable<any, string>},ValueTypes["RecommendationFormSubscriptionUpsertResult"]],
createInfoBox?: [{	data: ValueTypes["InfoBoxCreateInput"] | Variable<any, string>},ValueTypes["InfoBoxCreateResult"]],
deleteInfoBox?: [{	by: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBoxDeleteResult"]],
updateInfoBox?: [{	by: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["InfoBoxUpdateInput"] | Variable<any, string>},ValueTypes["InfoBoxUpdateResult"]],
upsertInfoBox?: [{	by: ValueTypes["InfoBoxUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["InfoBoxUpdateInput"] | Variable<any, string>,	create: ValueTypes["InfoBoxCreateInput"] | Variable<any, string>},ValueTypes["InfoBoxUpsertResult"]],
createInfoBoxLocale?: [{	data: ValueTypes["InfoBoxLocaleCreateInput"] | Variable<any, string>},ValueTypes["InfoBoxLocaleCreateResult"]],
deleteInfoBoxLocale?: [{	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["InfoBoxLocaleDeleteResult"]],
updateInfoBoxLocale?: [{	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["InfoBoxLocaleUpdateInput"] | Variable<any, string>},ValueTypes["InfoBoxLocaleUpdateResult"]],
upsertInfoBoxLocale?: [{	by: ValueTypes["InfoBoxLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["InfoBoxLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["InfoBoxLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["InfoBoxLocaleCreateInput"] | Variable<any, string>},ValueTypes["InfoBoxLocaleUpsertResult"]],
createTranslation?: [{	data: ValueTypes["TranslationCreateInput"] | Variable<any, string>},ValueTypes["TranslationCreateResult"]],
deleteTranslation?: [{	by: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationDeleteResult"]],
updateTranslation?: [{	by: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationUpdateInput"] | Variable<any, string>},ValueTypes["TranslationUpdateResult"]],
upsertTranslation?: [{	by: ValueTypes["TranslationUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationCreateInput"] | Variable<any, string>},ValueTypes["TranslationUpsertResult"]],
createTranslationLocale?: [{	data: ValueTypes["TranslationLocaleCreateInput"] | Variable<any, string>},ValueTypes["TranslationLocaleCreateResult"]],
deleteTranslationLocale?: [{	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>},ValueTypes["TranslationLocaleDeleteResult"]],
updateTranslationLocale?: [{	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["TranslationLocaleUpdateInput"] | Variable<any, string>},ValueTypes["TranslationLocaleUpdateResult"]],
upsertTranslationLocale?: [{	by: ValueTypes["TranslationLocaleUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["TranslationLocaleWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["TranslationLocaleUpdateInput"] | Variable<any, string>,	create: ValueTypes["TranslationLocaleCreateInput"] | Variable<any, string>},ValueTypes["TranslationLocaleUpsertResult"]],
createCornerBanner?: [{	data: ValueTypes["CornerBannerCreateInput"] | Variable<any, string>},ValueTypes["CornerBannerCreateResult"]],
deleteCornerBanner?: [{	by: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>},ValueTypes["CornerBannerDeleteResult"]],
updateCornerBanner?: [{	by: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>,	data: ValueTypes["CornerBannerUpdateInput"] | Variable<any, string>},ValueTypes["CornerBannerUpdateResult"]],
upsertCornerBanner?: [{	by: ValueTypes["CornerBannerUniqueWhere"] | Variable<any, string>,	filter?: ValueTypes["CornerBannerWhere"] | undefined | null | Variable<any, string>,	update: ValueTypes["CornerBannerUpdateInput"] | Variable<any, string>,	create: ValueTypes["CornerBannerCreateInput"] | Variable<any, string>},ValueTypes["CornerBannerUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?: boolean | undefined | null | Variable<any, string>
}
  }

export type ResolverInputTypes = {
    ["_Column"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	enumName?:boolean | `@${string}`,
	defaultValue?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	rules?:ResolverInputTypes["_Rule"],
	validators?:ResolverInputTypes["_Validator"],
		__typename?: boolean | `@${string}`
}>;
	["_Field"]:AliasType<{
		name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	rules?:ResolverInputTypes["_Rule"],
	validators?:ResolverInputTypes["_Validator"];
		['...on _Column']?: Omit<ResolverInputTypes["_Column"],keyof ResolverInputTypes["_Field"]>;
		['...on _Relation']?: Omit<ResolverInputTypes["_Relation"],keyof ResolverInputTypes["_Field"]>;
		__typename?: boolean | `@${string}`
}>;
	["_Rule"]: AliasType<{
	message?:ResolverInputTypes["_RuleMessage"],
	validator?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_RuleMessage"]: AliasType<{
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Validator"]: AliasType<{
	operation?:boolean | `@${string}`,
	arguments?:ResolverInputTypes["_Argument"],
		__typename?: boolean | `@${string}`
}>;
	["_Argument"]: AliasType<{
	_ValidatorArgument?:ResolverInputTypes["_ValidatorArgument"],
	_PathArgument?:ResolverInputTypes["_PathArgument"],
	_LiteralArgument?:ResolverInputTypes["_LiteralArgument"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_PathArgument"]: AliasType<{
	path?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_LiteralArgument"]: AliasType<{
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Json custom scalar type */
["Json"]:unknown;
	["_Relation"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	side?:boolean | `@${string}`,
	targetEntity?:boolean | `@${string}`,
	ownedBy?:boolean | `@${string}`,
	inversedBy?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	onDelete?:boolean | `@${string}`,
	orphanRemoval?:boolean | `@${string}`,
	orderBy?:ResolverInputTypes["_OrderBy"],
	rules?:ResolverInputTypes["_Rule"],
	validators?:ResolverInputTypes["_Validator"],
		__typename?: boolean | `@${string}`
}>;
	["_RelationSide"]:_RelationSide;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_OrderBy"]: AliasType<{
	path?:boolean | `@${string}`,
	direction?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_OrderByDirection"]:_OrderByDirection;
	["Query"]: AliasType<{
	schema?:ResolverInputTypes["_Schema"],
	s3DummyQuery?:boolean | `@${string}`,
getGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null},ResolverInputTypes["General"]],
listGeneral?: [{	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["General"]],
paginateGeneral?: [{	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralConnection"]],
validateCreateGeneral?: [{	data: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	data: ResolverInputTypes["GeneralUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
listImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Image"]],
paginateImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageConnection"]],
validateCreateImage?: [{	data: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	data: ResolverInputTypes["ImageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null},ResolverInputTypes["GenericPage"]],
listGenericPage?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPage"]],
paginateGenericPage?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	data: ResolverInputTypes["GenericPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
listLinkable?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkableOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Linkable"]],
paginateLinkable?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkableOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	data: ResolverInputTypes["LinkableUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
listSeo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Seo"]],
paginateSeo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SeoConnection"]],
validateCreateSeo?: [{	data: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	data: ResolverInputTypes["SeoUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
listContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Content"]],
paginateContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentConnection"]],
validateCreateContent?: [{	data: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	data: ResolverInputTypes["ContentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlock"]],
listContentBlock?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	data: ResolverInputTypes["ContentBlockUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
listContentReference?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReference"]],
paginateContentReference?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	data: ResolverInputTypes["ContentReferenceUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentReferenceLinkableItem?: [{	by: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
listContentReferenceLinkableItem?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
paginateContentReferenceLinkableItem?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItemConnection"]],
getRedirect?: [{	by: ResolverInputTypes["RedirectUniqueWhere"],	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null},ResolverInputTypes["Redirect"]],
listRedirect?: [{	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RedirectOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Redirect"]],
paginateRedirect?: [{	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RedirectOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data: ResolverInputTypes["RedirectCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by: ResolverInputTypes["RedirectUniqueWhere"],	data: ResolverInputTypes["RedirectUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
listLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Link"]],
paginateLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkConnection"]],
validateCreateLink?: [{	data: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	data: ResolverInputTypes["LinkUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null},ResolverInputTypes["Footer"]],
listFooter?: [{	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Footer"]],
paginateFooter?: [{	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterConnection"]],
validateCreateFooter?: [{	data: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	data: ResolverInputTypes["FooterUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFooterLink?: [{	by: ResolverInputTypes["FooterLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null},ResolverInputTypes["FooterLink"]],
listFooterLink?: [{	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLink"]],
paginateFooterLink?: [{	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLinkConnection"]],
validateCreateFooterLink?: [{	data: ResolverInputTypes["FooterLinkCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFooterLink?: [{	by: ResolverInputTypes["FooterLinkUniqueWhere"],	data: ResolverInputTypes["FooterLinkUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
listFooterLocale?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	data: ResolverInputTypes["FooterLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
listGenericPageLocale?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageLocale"]],
paginateGenericPageLocale?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageLocaleConnection"]],
validateCreateGenericPageLocale?: [{	data: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	data: ResolverInputTypes["GenericPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null},ResolverInputTypes["Header"]],
listHeader?: [{	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Header"]],
paginateHeader?: [{	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderConnection"]],
validateCreateHeader?: [{	data: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	data: ResolverInputTypes["HeaderUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	data: ResolverInputTypes["HeaderLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
listLocale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Locale"]],
paginateLocale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LocaleConnection"]],
validateCreateLocale?: [{	data: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	data: ResolverInputTypes["LocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSeoDefault?: [{	by: ResolverInputTypes["SeoDefaultUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null},ResolverInputTypes["SeoDefault"]],
listSeoDefault?: [{	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SeoDefault"]],
paginateSeoDefault?: [{	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SeoDefaultConnection"]],
validateCreateSeoDefault?: [{	data: ResolverInputTypes["SeoDefaultCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSeoDefault?: [{	by: ResolverInputTypes["SeoDefaultUniqueWhere"],	data: ResolverInputTypes["SeoDefaultUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSeoDefaultLocale?: [{	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null},ResolverInputTypes["SeoDefaultLocale"]],
listSeoDefaultLocale?: [{	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SeoDefaultLocale"]],
paginateSeoDefaultLocale?: [{	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SeoDefaultLocaleConnection"]],
validateCreateSeoDefaultLocale?: [{	data: ResolverInputTypes["SeoDefaultLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSeoDefaultLocale?: [{	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],	data: ResolverInputTypes["SeoDefaultLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getBusiness?: [{	by: ResolverInputTypes["BusinessUniqueWhere"],	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null},ResolverInputTypes["Business"]],
listBusiness?: [{	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Business"]],
paginateBusiness?: [{	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BusinessConnection"]],
validateCreateBusiness?: [{	data: ResolverInputTypes["BusinessCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateBusiness?: [{	by: ResolverInputTypes["BusinessUniqueWhere"],	data: ResolverInputTypes["BusinessUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getBusinessPage?: [{	by: ResolverInputTypes["BusinessPageUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null},ResolverInputTypes["BusinessPage"]],
listBusinessPage?: [{	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BusinessPage"]],
paginateBusinessPage?: [{	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BusinessPageConnection"]],
validateCreateBusinessPage?: [{	data: ResolverInputTypes["BusinessPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateBusinessPage?: [{	by: ResolverInputTypes["BusinessPageUniqueWhere"],	data: ResolverInputTypes["BusinessPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getBusinessPageLocale?: [{	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
listBusinessPageLocale?: [{	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
paginateBusinessPageLocale?: [{	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BusinessPageLocaleConnection"]],
validateCreateBusinessPageLocale?: [{	data: ResolverInputTypes["BusinessPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateBusinessPageLocale?: [{	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],	data: ResolverInputTypes["BusinessPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getIcon?: [{	by: ResolverInputTypes["IconUniqueWhere"],	filter?: ResolverInputTypes["IconWhere"] | undefined | null},ResolverInputTypes["Icon"]],
listIcon?: [{	filter?: ResolverInputTypes["IconWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["IconOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Icon"]],
paginateIcon?: [{	filter?: ResolverInputTypes["IconWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["IconOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["IconConnection"]],
validateCreateIcon?: [{	data: ResolverInputTypes["IconCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateIcon?: [{	by: ResolverInputTypes["IconUniqueWhere"],	data: ResolverInputTypes["IconUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobPage?: [{	by: ResolverInputTypes["JobPageUniqueWhere"],	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null},ResolverInputTypes["JobPage"]],
listJobPage?: [{	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPage"]],
paginateJobPage?: [{	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPageConnection"]],
validateCreateJobPage?: [{	data: ResolverInputTypes["JobPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobPage?: [{	by: ResolverInputTypes["JobPageUniqueWhere"],	data: ResolverInputTypes["JobPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobPageLocale?: [{	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
listJobPageLocale?: [{	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPageLocale"]],
paginateJobPageLocale?: [{	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPageLocaleConnection"]],
validateCreateJobPageLocale?: [{	data: ResolverInputTypes["JobPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobPageLocale?: [{	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],	data: ResolverInputTypes["JobPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getKeyInfoItem?: [{	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null},ResolverInputTypes["KeyInfoItem"]],
listKeyInfoItem?: [{	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["KeyInfoItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["KeyInfoItem"]],
paginateKeyInfoItem?: [{	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["KeyInfoItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["KeyInfoItemConnection"]],
validateCreateKeyInfoItem?: [{	data: ResolverInputTypes["KeyInfoItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateKeyInfoItem?: [{	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],	data: ResolverInputTypes["KeyInfoItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getKeyInfoList?: [{	by: ResolverInputTypes["KeyInfoListUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null},ResolverInputTypes["KeyInfoList"]],
listKeyInfoList?: [{	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["KeyInfoListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["KeyInfoList"]],
paginateKeyInfoList?: [{	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["KeyInfoListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["KeyInfoListConnection"]],
validateCreateKeyInfoList?: [{	data: ResolverInputTypes["KeyInfoListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateKeyInfoList?: [{	by: ResolverInputTypes["KeyInfoListUniqueWhere"],	data: ResolverInputTypes["KeyInfoListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContractType?: [{	by: ResolverInputTypes["ContractTypeUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null},ResolverInputTypes["ContractType"]],
listContractType?: [{	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContractType"]],
paginateContractType?: [{	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContractTypeConnection"]],
validateCreateContractType?: [{	data: ResolverInputTypes["ContractTypeCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContractType?: [{	by: ResolverInputTypes["ContractTypeUniqueWhere"],	data: ResolverInputTypes["ContractTypeUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContractTypeLocale?: [{	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null},ResolverInputTypes["ContractTypeLocale"]],
listContractTypeLocale?: [{	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContractTypeLocale"]],
paginateContractTypeLocale?: [{	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContractTypeLocaleConnection"]],
validateCreateContractTypeLocale?: [{	data: ResolverInputTypes["ContractTypeLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContractTypeLocale?: [{	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],	data: ResolverInputTypes["ContractTypeLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobCity?: [{	by: ResolverInputTypes["JobCityUniqueWhere"],	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null},ResolverInputTypes["JobCity"]],
listJobCity?: [{	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobCity"]],
paginateJobCity?: [{	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobCityConnection"]],
validateCreateJobCity?: [{	data: ResolverInputTypes["JobCityCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobCity?: [{	by: ResolverInputTypes["JobCityUniqueWhere"],	data: ResolverInputTypes["JobCityUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobCityLocale?: [{	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null},ResolverInputTypes["JobCityLocale"]],
listJobCityLocale?: [{	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobCityLocale"]],
paginateJobCityLocale?: [{	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobCityLocaleConnection"]],
validateCreateJobCityLocale?: [{	data: ResolverInputTypes["JobCityLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobCityLocale?: [{	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],	data: ResolverInputTypes["JobCityLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobPosition?: [{	by: ResolverInputTypes["JobPositionUniqueWhere"],	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null},ResolverInputTypes["JobPosition"]],
listJobPosition?: [{	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPosition"]],
paginateJobPosition?: [{	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPositionConnection"]],
validateCreateJobPosition?: [{	data: ResolverInputTypes["JobPositionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobPosition?: [{	by: ResolverInputTypes["JobPositionUniqueWhere"],	data: ResolverInputTypes["JobPositionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobPositionLocale?: [{	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null},ResolverInputTypes["JobPositionLocale"]],
listJobPositionLocale?: [{	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPositionLocale"]],
paginateJobPositionLocale?: [{	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPositionLocaleConnection"]],
validateCreateJobPositionLocale?: [{	data: ResolverInputTypes["JobPositionLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobPositionLocale?: [{	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],	data: ResolverInputTypes["JobPositionLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGallery?: [{	by: ResolverInputTypes["GalleryUniqueWhere"],	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null},ResolverInputTypes["Gallery"]],
listGallery?: [{	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GalleryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Gallery"]],
paginateGallery?: [{	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GalleryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GalleryConnection"]],
validateCreateGallery?: [{	data: ResolverInputTypes["GalleryCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by: ResolverInputTypes["GalleryUniqueWhere"],	data: ResolverInputTypes["GalleryUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHomePage?: [{	by: ResolverInputTypes["HomePageUniqueWhere"],	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null},ResolverInputTypes["HomePage"]],
listHomePage?: [{	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePage"]],
paginateHomePage?: [{	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data: ResolverInputTypes["HomePageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by: ResolverInputTypes["HomePageUniqueWhere"],	data: ResolverInputTypes["HomePageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHomePageLocale?: [{	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
listHomePageLocale?: [{	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePageLocale"]],
paginateHomePageLocale?: [{	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageLocaleConnection"]],
validateCreateHomePageLocale?: [{	data: ResolverInputTypes["HomePageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHomePageLocale?: [{	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],	data: ResolverInputTypes["HomePageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null},ResolverInputTypes["Medium"]],
listMedium?: [{	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Medium"]],
paginateMedium?: [{	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumConnection"]],
validateCreateMedium?: [{	data: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	data: ResolverInputTypes["MediumUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null},ResolverInputTypes["MediumItem"]],
listMediumItem?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MediumItem"]],
paginateMediumItem?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumItemConnection"]],
validateCreateMediumItem?: [{	data: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	data: ResolverInputTypes["MediumItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumList"]],
listMediumList?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MediumList"]],
paginateMediumList?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumListConnection"]],
validateCreateMediumList?: [{	data: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	data: ResolverInputTypes["MediumListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["Video"]],
listVideo?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["VideoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Video"]],
paginateVideo?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["VideoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["VideoConnection"]],
validateCreateVideo?: [{	data: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	data: ResolverInputTypes["VideoUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTextItem?: [{	by: ResolverInputTypes["TextItemUniqueWhere"],	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null},ResolverInputTypes["TextItem"]],
listTextItem?: [{	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TextItem"]],
paginateTextItem?: [{	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TextItemConnection"]],
validateCreateTextItem?: [{	data: ResolverInputTypes["TextItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTextItem?: [{	by: ResolverInputTypes["TextItemUniqueWhere"],	data: ResolverInputTypes["TextItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTextList?: [{	by: ResolverInputTypes["TextListUniqueWhere"],	filter?: ResolverInputTypes["TextListWhere"] | undefined | null},ResolverInputTypes["TextList"]],
listTextList?: [{	filter?: ResolverInputTypes["TextListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TextList"]],
paginateTextList?: [{	filter?: ResolverInputTypes["TextListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TextListConnection"]],
validateCreateTextList?: [{	data: ResolverInputTypes["TextListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTextList?: [{	by: ResolverInputTypes["TextListUniqueWhere"],	data: ResolverInputTypes["TextListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCarousel?: [{	by: ResolverInputTypes["CarouselUniqueWhere"],	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null},ResolverInputTypes["Carousel"]],
listCarousel?: [{	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CarouselOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Carousel"]],
paginateCarousel?: [{	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CarouselOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CarouselConnection"]],
validateCreateCarousel?: [{	data: ResolverInputTypes["CarouselCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCarousel?: [{	by: ResolverInputTypes["CarouselUniqueWhere"],	data: ResolverInputTypes["CarouselUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCarouselItem?: [{	by: ResolverInputTypes["CarouselItemUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null},ResolverInputTypes["CarouselItem"]],
listCarouselItem?: [{	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CarouselItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CarouselItem"]],
paginateCarouselItem?: [{	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CarouselItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CarouselItemConnection"]],
validateCreateCarouselItem?: [{	data: ResolverInputTypes["CarouselItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCarouselItem?: [{	by: ResolverInputTypes["CarouselItemUniqueWhere"],	data: ResolverInputTypes["CarouselItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTheme?: [{	by: ResolverInputTypes["ThemeUniqueWhere"],	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null},ResolverInputTypes["Theme"]],
listTheme?: [{	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ThemeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Theme"]],
paginateTheme?: [{	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ThemeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ThemeConnection"]],
validateCreateTheme?: [{	data: ResolverInputTypes["ThemeCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTheme?: [{	by: ResolverInputTypes["ThemeUniqueWhere"],	data: ResolverInputTypes["ThemeUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getBonusBanner?: [{	by: ResolverInputTypes["BonusBannerUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null},ResolverInputTypes["BonusBanner"]],
listBonusBanner?: [{	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BonusBanner"]],
paginateBonusBanner?: [{	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BonusBannerConnection"]],
validateCreateBonusBanner?: [{	data: ResolverInputTypes["BonusBannerCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateBonusBanner?: [{	by: ResolverInputTypes["BonusBannerUniqueWhere"],	data: ResolverInputTypes["BonusBannerUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getBonusBannerLocale?: [{	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
listBonusBannerLocale?: [{	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
paginateBonusBannerLocale?: [{	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BonusBannerLocaleConnection"]],
validateCreateBonusBannerLocale?: [{	data: ResolverInputTypes["BonusBannerLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateBonusBannerLocale?: [{	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],	data: ResolverInputTypes["BonusBannerLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTile?: [{	by: ResolverInputTypes["TileUniqueWhere"],	filter?: ResolverInputTypes["TileWhere"] | undefined | null},ResolverInputTypes["Tile"]],
listTile?: [{	filter?: ResolverInputTypes["TileWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Tile"]],
paginateTile?: [{	filter?: ResolverInputTypes["TileWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TileConnection"]],
validateCreateTile?: [{	data: ResolverInputTypes["TileCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTile?: [{	by: ResolverInputTypes["TileUniqueWhere"],	data: ResolverInputTypes["TileUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSideBySide?: [{	by: ResolverInputTypes["SideBySideUniqueWhere"],	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null},ResolverInputTypes["SideBySide"]],
listSideBySide?: [{	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SideBySideOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SideBySide"]],
paginateSideBySide?: [{	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SideBySideOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SideBySideConnection"]],
validateCreateSideBySide?: [{	data: ResolverInputTypes["SideBySideCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSideBySide?: [{	by: ResolverInputTypes["SideBySideUniqueWhere"],	data: ResolverInputTypes["SideBySideUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSideBySideItem?: [{	by: ResolverInputTypes["SideBySideItemUniqueWhere"],	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null},ResolverInputTypes["SideBySideItem"]],
listSideBySideItem?: [{	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SideBySideItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SideBySideItem"]],
paginateSideBySideItem?: [{	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SideBySideItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SideBySideItemConnection"]],
validateCreateSideBySideItem?: [{	data: ResolverInputTypes["SideBySideItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSideBySideItem?: [{	by: ResolverInputTypes["SideBySideItemUniqueWhere"],	data: ResolverInputTypes["SideBySideItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHomePageLokal?: [{	by: ResolverInputTypes["HomePageLokalUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null},ResolverInputTypes["HomePageLokal"]],
listHomePageLokal?: [{	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePageLokal"]],
paginateHomePageLokal?: [{	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageLokalConnection"]],
validateCreateHomePageLokal?: [{	data: ResolverInputTypes["HomePageLokalCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHomePageLokal?: [{	by: ResolverInputTypes["HomePageLokalUniqueWhere"],	data: ResolverInputTypes["HomePageLokalUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHomePageLokalLocale?: [{	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
listHomePageLokalLocale?: [{	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
paginateHomePageLokalLocale?: [{	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageLokalLocaleConnection"]],
validateCreateHomePageLokalLocale?: [{	data: ResolverInputTypes["HomePageLokalLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHomePageLokalLocale?: [{	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],	data: ResolverInputTypes["HomePageLokalLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSiteSwitcher?: [{	by: ResolverInputTypes["SiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null},ResolverInputTypes["SiteSwitcher"]],
listSiteSwitcher?: [{	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SiteSwitcherOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SiteSwitcher"]],
paginateSiteSwitcher?: [{	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SiteSwitcherOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SiteSwitcherConnection"]],
validateCreateSiteSwitcher?: [{	data: ResolverInputTypes["SiteSwitcherCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSiteSwitcher?: [{	by: ResolverInputTypes["SiteSwitcherUniqueWhere"],	data: ResolverInputTypes["SiteSwitcherUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGalleryItem?: [{	by: ResolverInputTypes["GalleryItemUniqueWhere"],	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null},ResolverInputTypes["GalleryItem"]],
listGalleryItem?: [{	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GalleryItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GalleryItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data: ResolverInputTypes["GalleryItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by: ResolverInputTypes["GalleryItemUniqueWhere"],	data: ResolverInputTypes["GalleryItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobsForm?: [{	by: ResolverInputTypes["JobsFormUniqueWhere"],	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null},ResolverInputTypes["JobsForm"]],
listJobsForm?: [{	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsForm"]],
paginateJobsForm?: [{	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFormConnection"]],
validateCreateJobsForm?: [{	data: ResolverInputTypes["JobsFormCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobsForm?: [{	by: ResolverInputTypes["JobsFormUniqueWhere"],	data: ResolverInputTypes["JobsFormUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobsFormLocale?: [{	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
listJobsFormLocale?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsFormLocale"]],
paginateJobsFormLocale?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFormLocaleConnection"]],
validateCreateJobsFormLocale?: [{	data: ResolverInputTypes["JobsFormLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobsFormLocale?: [{	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],	data: ResolverInputTypes["JobsFormLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageTextItem?: [{	by: ResolverInputTypes["ImageTextItemUniqueWhere"],	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null},ResolverInputTypes["ImageTextItem"]],
listImageTextItem?: [{	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageTextItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageTextItem"]],
paginateImageTextItem?: [{	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageTextItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageTextItemConnection"]],
validateCreateImageTextItem?: [{	data: ResolverInputTypes["ImageTextItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageTextItem?: [{	by: ResolverInputTypes["ImageTextItemUniqueWhere"],	data: ResolverInputTypes["ImageTextItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageTextList?: [{	by: ResolverInputTypes["ImageTextListUniqueWhere"],	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null},ResolverInputTypes["ImageTextList"]],
listImageTextList?: [{	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageTextListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageTextList"]],
paginateImageTextList?: [{	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageTextListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageTextListConnection"]],
validateCreateImageTextList?: [{	data: ResolverInputTypes["ImageTextListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageTextList?: [{	by: ResolverInputTypes["ImageTextListUniqueWhere"],	data: ResolverInputTypes["ImageTextListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobsFilter?: [{	by: ResolverInputTypes["JobsFilterUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null},ResolverInputTypes["JobsFilter"]],
listJobsFilter?: [{	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsFilter"]],
paginateJobsFilter?: [{	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFilterConnection"]],
validateCreateJobsFilter?: [{	data: ResolverInputTypes["JobsFilterCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobsFilter?: [{	by: ResolverInputTypes["JobsFilterUniqueWhere"],	data: ResolverInputTypes["JobsFilterUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobsFilterLocale?: [{	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
listJobsFilterLocale?: [{	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
paginateJobsFilterLocale?: [{	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFilterLocaleConnection"]],
validateCreateJobsFilterLocale?: [{	data: ResolverInputTypes["JobsFilterLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobsFilterLocale?: [{	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],	data: ResolverInputTypes["JobsFilterLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFile?: [{	by: ResolverInputTypes["FileUniqueWhere"],	filter?: ResolverInputTypes["FileWhere"] | undefined | null},ResolverInputTypes["File"]],
listFile?: [{	filter?: ResolverInputTypes["FileWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["File"]],
paginateFile?: [{	filter?: ResolverInputTypes["FileWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FileConnection"]],
validateCreateFile?: [{	data: ResolverInputTypes["FileCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFile?: [{	by: ResolverInputTypes["FileUniqueWhere"],	data: ResolverInputTypes["FileUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobFormSubscription?: [{	by: ResolverInputTypes["JobFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null},ResolverInputTypes["JobFormSubscription"]],
listJobFormSubscription?: [{	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobFormSubscriptionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobFormSubscription"]],
paginateJobFormSubscription?: [{	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobFormSubscriptionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobFormSubscriptionConnection"]],
validateCreateJobFormSubscription?: [{	data: ResolverInputTypes["JobFormSubscriptionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobFormSubscription?: [{	by: ResolverInputTypes["JobFormSubscriptionUniqueWhere"],	data: ResolverInputTypes["JobFormSubscriptionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageList?: [{	by: ResolverInputTypes["ImageListUniqueWhere"],	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null},ResolverInputTypes["ImageList"]],
listImageList?: [{	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageList"]],
paginateImageList?: [{	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageListConnection"]],
validateCreateImageList?: [{	data: ResolverInputTypes["ImageListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by: ResolverInputTypes["ImageListUniqueWhere"],	data: ResolverInputTypes["ImageListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageListItem?: [{	by: ResolverInputTypes["ImageListItemUniqueWhere"],	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null},ResolverInputTypes["ImageListItem"]],
listImageListItem?: [{	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageListItem"]],
paginateImageListItem?: [{	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageListItemConnection"]],
validateCreateImageListItem?: [{	data: ResolverInputTypes["ImageListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageListItem?: [{	by: ResolverInputTypes["ImageListItemUniqueWhere"],	data: ResolverInputTypes["ImageListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobFormSubscriptionStatus?: [{	by: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null},ResolverInputTypes["JobFormSubscriptionStatus"]],
listJobFormSubscriptionStatus?: [{	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobFormSubscriptionStatusOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobFormSubscriptionStatus"]],
paginateJobFormSubscriptionStatus?: [{	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobFormSubscriptionStatusOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobFormSubscriptionStatusConnection"]],
validateCreateJobFormSubscriptionStatus?: [{	data: ResolverInputTypes["JobFormSubscriptionStatusCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobFormSubscriptionStatus?: [{	by: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],	data: ResolverInputTypes["JobFormSubscriptionStatusUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
listGeneralLocale?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GeneralLocale"]],
paginateGeneralLocale?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralLocaleConnection"]],
validateCreateGeneralLocale?: [{	data: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	data: ResolverInputTypes["GeneralLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStickyBar?: [{	by: ResolverInputTypes["StickyBarUniqueWhere"],	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null},ResolverInputTypes["StickyBar"]],
listStickyBar?: [{	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StickyBarOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StickyBar"]],
paginateStickyBar?: [{	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StickyBarOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StickyBarConnection"]],
validateCreateStickyBar?: [{	data: ResolverInputTypes["StickyBarCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStickyBar?: [{	by: ResolverInputTypes["StickyBarUniqueWhere"],	data: ResolverInputTypes["StickyBarUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRecommendationForm?: [{	by: ResolverInputTypes["RecommendationFormUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null},ResolverInputTypes["RecommendationForm"]],
listRecommendationForm?: [{	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecommendationForm"]],
paginateRecommendationForm?: [{	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecommendationFormConnection"]],
validateCreateRecommendationForm?: [{	data: ResolverInputTypes["RecommendationFormCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRecommendationForm?: [{	by: ResolverInputTypes["RecommendationFormUniqueWhere"],	data: ResolverInputTypes["RecommendationFormUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRecommendationFormLocale?: [{	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null},ResolverInputTypes["RecommendationFormLocale"]],
listRecommendationFormLocale?: [{	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecommendationFormLocale"]],
paginateRecommendationFormLocale?: [{	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecommendationFormLocaleConnection"]],
validateCreateRecommendationFormLocale?: [{	data: ResolverInputTypes["RecommendationFormLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRecommendationFormLocale?: [{	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],	data: ResolverInputTypes["RecommendationFormLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRecommendationFormSubscription?: [{	by: ResolverInputTypes["RecommendationFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null},ResolverInputTypes["RecommendationFormSubscription"]],
listRecommendationFormSubscription?: [{	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormSubscriptionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecommendationFormSubscription"]],
paginateRecommendationFormSubscription?: [{	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormSubscriptionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecommendationFormSubscriptionConnection"]],
validateCreateRecommendationFormSubscription?: [{	data: ResolverInputTypes["RecommendationFormSubscriptionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRecommendationFormSubscription?: [{	by: ResolverInputTypes["RecommendationFormSubscriptionUniqueWhere"],	data: ResolverInputTypes["RecommendationFormSubscriptionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getInfoBox?: [{	by: ResolverInputTypes["InfoBoxUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null},ResolverInputTypes["InfoBox"]],
listInfoBox?: [{	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoBox"]],
paginateInfoBox?: [{	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoBoxConnection"]],
validateCreateInfoBox?: [{	data: ResolverInputTypes["InfoBoxCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateInfoBox?: [{	by: ResolverInputTypes["InfoBoxUniqueWhere"],	data: ResolverInputTypes["InfoBoxUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getInfoBoxLocale?: [{	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null},ResolverInputTypes["InfoBoxLocale"]],
listInfoBoxLocale?: [{	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoBoxLocale"]],
paginateInfoBoxLocale?: [{	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoBoxLocaleConnection"]],
validateCreateInfoBoxLocale?: [{	data: ResolverInputTypes["InfoBoxLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateInfoBoxLocale?: [{	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],	data: ResolverInputTypes["InfoBoxLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslation?: [{	by: ResolverInputTypes["TranslationUniqueWhere"],	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null},ResolverInputTypes["Translation"]],
listTranslation?: [{	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Translation"]],
paginateTranslation?: [{	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationConnection"]],
validateCreateTranslation?: [{	data: ResolverInputTypes["TranslationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslation?: [{	by: ResolverInputTypes["TranslationUniqueWhere"],	data: ResolverInputTypes["TranslationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationLocale?: [{	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null},ResolverInputTypes["TranslationLocale"]],
listTranslationLocale?: [{	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationLocale"]],
paginateTranslationLocale?: [{	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationLocaleConnection"]],
validateCreateTranslationLocale?: [{	data: ResolverInputTypes["TranslationLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationLocale?: [{	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],	data: ResolverInputTypes["TranslationLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCornerBanner?: [{	by: ResolverInputTypes["CornerBannerUniqueWhere"],	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null},ResolverInputTypes["CornerBanner"]],
listCornerBanner?: [{	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CornerBannerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CornerBanner"]],
paginateCornerBanner?: [{	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CornerBannerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CornerBannerConnection"]],
validateCreateCornerBanner?: [{	data: ResolverInputTypes["CornerBannerCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCornerBanner?: [{	by: ResolverInputTypes["CornerBannerUniqueWhere"],	data: ResolverInputTypes["CornerBannerUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
	transaction?:ResolverInputTypes["QueryTransaction"],
	_info?:ResolverInputTypes["Info"],
		__typename?: boolean | `@${string}`
}>;
	["_Schema"]: AliasType<{
	enums?:ResolverInputTypes["_Enum"],
	entities?:ResolverInputTypes["_Entity"],
		__typename?: boolean | `@${string}`
}>;
	["_Enum"]: AliasType<{
	name?:boolean | `@${string}`,
	values?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Entity"]: AliasType<{
	name?:boolean | `@${string}`,
	customPrimaryAllowed?:boolean | `@${string}`,
	fields?:ResolverInputTypes["_Field"],
	unique?:ResolverInputTypes["_UniqueConstraint"],
		__typename?: boolean | `@${string}`
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["General"]: AliasType<{
	_meta?:ResolverInputTypes["GeneralMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GeneralLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["GeneralLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["GeneralLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
localesByCornerBanner?: [{	by: ResolverInputTypes["GeneralLocalesByCornerBannerUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GeneralMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FieldMeta"]: AliasType<{
	readable?:boolean | `@${string}`,
	updatable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UUID"]:unknown;
	["One"]:One;
	["GeneralLocale"]: AliasType<{
	_meta?:ResolverInputTypes["GeneralLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null},ResolverInputTypes["General"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
cornerBanner?: [{	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null},ResolverInputTypes["CornerBanner"]],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	cornerBanner?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GeneralWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GeneralWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GeneralWhere"] | undefined | null
};
	["UUIDCondition"]: {
	and?: Array<ResolverInputTypes["UUIDCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["UUIDCondition"]> | undefined | null,
	not?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["UUID"] | undefined | null,
	notEq?: ResolverInputTypes["UUID"] | undefined | null,
	in?: Array<ResolverInputTypes["UUID"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["UUID"]> | undefined | null,
	lt?: ResolverInputTypes["UUID"] | undefined | null,
	lte?: ResolverInputTypes["UUID"] | undefined | null,
	gt?: ResolverInputTypes["UUID"] | undefined | null,
	gte?: ResolverInputTypes["UUID"] | undefined | null
};
	["OneCondition"]: {
	and?: Array<ResolverInputTypes["OneCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["OneCondition"]> | undefined | null,
	not?: ResolverInputTypes["OneCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["One"] | undefined | null,
	notEq?: ResolverInputTypes["One"] | undefined | null,
	in?: Array<ResolverInputTypes["One"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["One"]> | undefined | null,
	lt?: ResolverInputTypes["One"] | undefined | null,
	lte?: ResolverInputTypes["One"] | undefined | null,
	gt?: ResolverInputTypes["One"] | undefined | null,
	gte?: ResolverInputTypes["One"] | undefined | null
};
	["GeneralLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["GeneralWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	cornerBanner?: ResolverInputTypes["CornerBannerWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GeneralLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GeneralLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null
};
	["LocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	code?: ResolverInputTypes["StringCondition"] | undefined | null,
	label?: ResolverInputTypes["StringCondition"] | undefined | null,
	footers?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,
	genericPages?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,
	headers?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,
	seoDefaults?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,
	businessPages?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,
	jobPages?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,
	contractTypes?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,
	jobCities?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,
	jobPositions?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,
	homePages?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,
	bonusBanners?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,
	homePageLokals?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,
	jobsForms?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,
	jobsFilters?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,
	general?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,
	recommendationForms?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,
	infoBoxes?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,
	translations?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["LocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["LocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["LocaleWhere"] | undefined | null
};
	["StringCondition"]: {
	and?: Array<ResolverInputTypes["StringCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["StringCondition"]> | undefined | null,
	not?: ResolverInputTypes["StringCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: string | undefined | null,
	notEq?: string | undefined | null,
	in?: Array<string> | undefined | null,
	notIn?: Array<string> | undefined | null,
	lt?: string | undefined | null,
	lte?: string | undefined | null,
	gt?: string | undefined | null,
	gte?: string | undefined | null,
	contains?: string | undefined | null,
	startsWith?: string | undefined | null,
	endsWith?: string | undefined | null,
	containsCI?: string | undefined | null,
	startsWithCI?: string | undefined | null,
	endsWithCI?: string | undefined | null
};
	["FooterLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	email?: ResolverInputTypes["StringCondition"] | undefined | null,
	address?: ResolverInputTypes["StringCondition"] | undefined | null,
	ico?: ResolverInputTypes["StringCondition"] | undefined | null,
	dic?: ResolverInputTypes["StringCondition"] | undefined | null,
	copyright?: ResolverInputTypes["StringCondition"] | undefined | null,
	note?: ResolverInputTypes["StringCondition"] | undefined | null,
	noteSecond?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["FooterWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	linksFirstColumn?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,
	linksSecondColumn?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,
	termsAndConditions?: ResolverInputTypes["LinkWhere"] | undefined | null,
	form?: ResolverInputTypes["StringCondition"] | undefined | null,
	bannerTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	bannerSubtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	bannerImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	bannerLink?: ResolverInputTypes["LinkWhere"] | undefined | null,
	jobsForm?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,
	copyrightLink?: ResolverInputTypes["LinkWhere"] | undefined | null,
	bannerSecondBtn?: ResolverInputTypes["StringCondition"] | undefined | null,
	recommendationForm?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,
	bannerSecondLink?: ResolverInputTypes["LinkWhere"] | undefined | null,
	instagramLink?: ResolverInputTypes["LinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["FooterLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FooterLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null
};
	["FooterWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["FooterWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FooterWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FooterWhere"] | undefined | null
};
	["FooterLinkWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["FooterLinkWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FooterLinkWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FooterLinkWhere"] | undefined | null
};
	["IntCondition"]: {
	and?: Array<ResolverInputTypes["IntCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["IntCondition"]> | undefined | null,
	not?: ResolverInputTypes["IntCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: number | undefined | null,
	notEq?: number | undefined | null,
	in?: Array<number> | undefined | null,
	notIn?: Array<number> | undefined | null,
	lt?: number | undefined | null,
	lte?: number | undefined | null,
	gt?: number | undefined | null,
	gte?: number | undefined | null
};
	["LinkWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["LinkTypeCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	externalLink?: ResolverInputTypes["StringCondition"] | undefined | null,
	internalLink?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	anchorLink?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["LinkWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["LinkWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["LinkWhere"] | undefined | null
};
	["LinkTypeCondition"]: {
	and?: Array<ResolverInputTypes["LinkTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["LinkTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["LinkTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["LinkType"] | undefined | null,
	notEq?: ResolverInputTypes["LinkType"] | undefined | null,
	in?: Array<ResolverInputTypes["LinkType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["LinkType"]> | undefined | null,
	lt?: ResolverInputTypes["LinkType"] | undefined | null,
	lte?: ResolverInputTypes["LinkType"] | undefined | null,
	gt?: ResolverInputTypes["LinkType"] | undefined | null,
	gte?: ResolverInputTypes["LinkType"] | undefined | null
};
	["LinkType"]:LinkType;
	["LinkableWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	url?: ResolverInputTypes["StringCondition"] | undefined | null,
	redirect?: ResolverInputTypes["RedirectWhere"] | undefined | null,
	genericPage?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,
	businessPage?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,
	jobPage?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,
	homePage?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,
	homePageLokal?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["LinkableWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["LinkableWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["LinkableWhere"] | undefined | null
};
	["RedirectWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	target?: ResolverInputTypes["LinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["RedirectWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["RedirectWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["RedirectWhere"] | undefined | null
};
	["GenericPageLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["GenericPageWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null
};
	["GenericPageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	locales?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,
	theme?: ResolverInputTypes["ThemeWhere"] | undefined | null,
	headerColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["GenericPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GenericPageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GenericPageWhere"] | undefined | null
};
	["ThemeWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	backgroundColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	textColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	buttonBackgroundColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	buttonTextColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	buttonBackgroundHoverColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	buttonTextHoverColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	buttonBorderColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	buttonBorderHoverColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	headerMenuColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["ThemeWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ThemeWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ThemeWhere"] | undefined | null
};
	["ContentWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	blocks?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ContentWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ContentWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ContentWhere"] | undefined | null
};
	["ContentBlockWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	json?: ResolverInputTypes["StringCondition"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	references?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ContentBlockWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ContentBlockWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ContentBlockWhere"] | undefined | null
};
	["ContentReferenceWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["ContentReferenceTypeCondition"] | undefined | null,
	primaryText?: ResolverInputTypes["StringCondition"] | undefined | null,
	block?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	linkables?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,
	secondaryText?: ResolverInputTypes["StringCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	media?: ResolverInputTypes["MediumListWhere"] | undefined | null,
	textList?: ResolverInputTypes["TextListWhere"] | undefined | null,
	carousel?: ResolverInputTypes["CarouselWhere"] | undefined | null,
	bonusBanner?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,
	sideBySide?: ResolverInputTypes["SideBySideWhere"] | undefined | null,
	gallery?: ResolverInputTypes["GalleryWhere"] | undefined | null,
	showBoolean?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	isRed?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	video?: ResolverInputTypes["VideoWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ContentReferenceWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ContentReferenceWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null
};
	["ContentReferenceTypeCondition"]: {
	and?: Array<ResolverInputTypes["ContentReferenceTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["ContentReferenceTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["ContentReferenceTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	notEq?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	in?: Array<ResolverInputTypes["ContentReferenceType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["ContentReferenceType"]> | undefined | null,
	lt?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	lte?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	gt?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	gte?: ResolverInputTypes["ContentReferenceType"] | undefined | null
};
	["ContentReferenceType"]:ContentReferenceType;
	["ImageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	url?: ResolverInputTypes["StringCondition"] | undefined | null,
	width?: ResolverInputTypes["IntCondition"] | undefined | null,
	height?: ResolverInputTypes["IntCondition"] | undefined | null,
	size?: ResolverInputTypes["IntCondition"] | undefined | null,
	type?: ResolverInputTypes["StringCondition"] | undefined | null,
	alt?: ResolverInputTypes["StringCondition"] | undefined | null,
	fileName?: ResolverInputTypes["StringCondition"] | undefined | null,
	focalPointX?: ResolverInputTypes["FloatCondition"] | undefined | null,
	focalPointY?: ResolverInputTypes["FloatCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["ImageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ImageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ImageWhere"] | undefined | null
};
	["FloatCondition"]: {
	and?: Array<ResolverInputTypes["FloatCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["FloatCondition"]> | undefined | null,
	not?: ResolverInputTypes["FloatCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: number | undefined | null,
	notEq?: number | undefined | null,
	in?: Array<number> | undefined | null,
	notIn?: Array<number> | undefined | null,
	lt?: number | undefined | null,
	lte?: number | undefined | null,
	gt?: number | undefined | null,
	gte?: number | undefined | null
};
	["ContentReferenceLinkableItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	item?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	reference?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null
};
	["MediumListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["MediumItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["MediumListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["MediumListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["MediumListWhere"] | undefined | null
};
	["MediumItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["MediumListWhere"] | undefined | null,
	medium?: ResolverInputTypes["MediumWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["MediumItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["MediumItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["MediumItemWhere"] | undefined | null
};
	["MediumWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["MediumTypeCondition"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	video?: ResolverInputTypes["VideoWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["MediumWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["MediumWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["MediumWhere"] | undefined | null
};
	["MediumTypeCondition"]: {
	and?: Array<ResolverInputTypes["MediumTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["MediumTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["MediumTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["MediumType"] | undefined | null,
	notEq?: ResolverInputTypes["MediumType"] | undefined | null,
	in?: Array<ResolverInputTypes["MediumType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["MediumType"]> | undefined | null,
	lt?: ResolverInputTypes["MediumType"] | undefined | null,
	lte?: ResolverInputTypes["MediumType"] | undefined | null,
	gt?: ResolverInputTypes["MediumType"] | undefined | null,
	gte?: ResolverInputTypes["MediumType"] | undefined | null
};
	["MediumType"]:MediumType;
	["VideoWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	src?: ResolverInputTypes["StringCondition"] | undefined | null,
	width?: ResolverInputTypes["IntCondition"] | undefined | null,
	height?: ResolverInputTypes["IntCondition"] | undefined | null,
	size?: ResolverInputTypes["IntCondition"] | undefined | null,
	type?: ResolverInputTypes["StringCondition"] | undefined | null,
	videoInfo?: ResolverInputTypes["StringCondition"] | undefined | null,
	duration?: ResolverInputTypes["FloatCondition"] | undefined | null,
	poster?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["VideoWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["VideoWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["VideoWhere"] | undefined | null
};
	["TextListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["TextItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TextListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TextListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TextListWhere"] | undefined | null
};
	["TextItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	list?: ResolverInputTypes["TextListWhere"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["TextItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TextItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TextItemWhere"] | undefined | null
};
	["CarouselWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,
	background?: ResolverInputTypes["BackgroundCondition"] | undefined | null,
	squareImages?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["CarouselWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["CarouselWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["CarouselWhere"] | undefined | null
};
	["CarouselItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	list?: ResolverInputTypes["CarouselWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	linkUrl?: ResolverInputTypes["LinkWhere"] | undefined | null,
	normalAspectRatio?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	isImage?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	video?: ResolverInputTypes["VideoWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["CarouselItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["CarouselItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["CarouselItemWhere"] | undefined | null
};
	["BooleanCondition"]: {
	and?: Array<ResolverInputTypes["BooleanCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["BooleanCondition"]> | undefined | null,
	not?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: boolean | undefined | null,
	notEq?: boolean | undefined | null,
	in?: Array<boolean> | undefined | null,
	notIn?: Array<boolean> | undefined | null,
	lt?: boolean | undefined | null,
	lte?: boolean | undefined | null,
	gt?: boolean | undefined | null,
	gte?: boolean | undefined | null
};
	["BackgroundCondition"]: {
	and?: Array<ResolverInputTypes["BackgroundCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["BackgroundCondition"]> | undefined | null,
	not?: ResolverInputTypes["BackgroundCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["Background"] | undefined | null,
	notEq?: ResolverInputTypes["Background"] | undefined | null,
	in?: Array<ResolverInputTypes["Background"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["Background"]> | undefined | null,
	lt?: ResolverInputTypes["Background"] | undefined | null,
	lte?: ResolverInputTypes["Background"] | undefined | null,
	gt?: ResolverInputTypes["Background"] | undefined | null,
	gte?: ResolverInputTypes["Background"] | undefined | null
};
	["Background"]:Background;
	["BonusBannerLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["BonusBannerWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	tiles?: ResolverInputTypes["TileWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	bannerName?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null
};
	["BonusBannerWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	locales?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["BonusBannerWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["BonusBannerWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["BonusBannerWhere"] | undefined | null
};
	["TileWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	bonusBanner?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	lightBoxTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	lightBoxText?: ResolverInputTypes["StringCondition"] | undefined | null,
	ligthBoxMedia?: ResolverInputTypes["MediumListWhere"] | undefined | null,
	lightBoxSectionTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	lightBoxLinkLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	lightBoxForm?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TileWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TileWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TileWhere"] | undefined | null
};
	["JobsFormLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	jobText?: ResolverInputTypes["StringCondition"] | undefined | null,
	genericText?: ResolverInputTypes["StringCondition"] | undefined | null,
	nameLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	emailLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	telefonLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	fileTitleLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	fileFormatLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	formTextLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	submitLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["JobsFormWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	imageTextList?: ResolverInputTypes["ImageTextListWhere"] | undefined | null,
	minimalize?: ResolverInputTypes["StringCondition"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	successTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	successText?: ResolverInputTypes["StringCondition"] | undefined | null,
	successBtnLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	successImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	successOtherJobsTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	successOtherJobsCategoryTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	successOtherJobsButtonTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	successOtherJobsSelectionTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	successOtherJobsSelectionYesButton?: ResolverInputTypes["StringCondition"] | undefined | null,
	successOtherJobsSelectionNoButton?: ResolverInputTypes["StringCondition"] | undefined | null,
	fileRemoveBtnLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	gdprLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null
};
	["JobsFormWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,
	fileIlustration?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["JobsFormWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobsFormWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobsFormWhere"] | undefined | null
};
	["ImageTextListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ImageTextListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ImageTextListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ImageTextListWhere"] | undefined | null
};
	["ImageTextItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	list?: ResolverInputTypes["ImageTextListWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ImageTextItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ImageTextItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null
};
	["SideBySideWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,
	background?: ResolverInputTypes["BackgroundCondition"] | undefined | null,
	alignment?: ResolverInputTypes["ContentAlignmentCondition"] | undefined | null,
	mediumSize?: ResolverInputTypes["MediumSizeCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["SideBySideWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["SideBySideWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["SideBySideWhere"] | undefined | null
};
	["SideBySideItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	list?: ResolverInputTypes["SideBySideWhere"] | undefined | null,
	media?: ResolverInputTypes["MediumListWhere"] | undefined | null,
	formButtonLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	type?: ResolverInputTypes["SideBySideItemTypeCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	jobsForm?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,
	textNew?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["SideBySideItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["SideBySideItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null
};
	["SideBySideItemTypeCondition"]: {
	and?: Array<ResolverInputTypes["SideBySideItemTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["SideBySideItemTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["SideBySideItemTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["SideBySideItemType"] | undefined | null,
	notEq?: ResolverInputTypes["SideBySideItemType"] | undefined | null,
	in?: Array<ResolverInputTypes["SideBySideItemType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["SideBySideItemType"]> | undefined | null,
	lt?: ResolverInputTypes["SideBySideItemType"] | undefined | null,
	lte?: ResolverInputTypes["SideBySideItemType"] | undefined | null,
	gt?: ResolverInputTypes["SideBySideItemType"] | undefined | null,
	gte?: ResolverInputTypes["SideBySideItemType"] | undefined | null
};
	["SideBySideItemType"]:SideBySideItemType;
	["ContentAlignmentCondition"]: {
	and?: Array<ResolverInputTypes["ContentAlignmentCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["ContentAlignmentCondition"]> | undefined | null,
	not?: ResolverInputTypes["ContentAlignmentCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	notEq?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	in?: Array<ResolverInputTypes["ContentAlignment"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["ContentAlignment"]> | undefined | null,
	lt?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	lte?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	gt?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	gte?: ResolverInputTypes["ContentAlignment"] | undefined | null
};
	["ContentAlignment"]:ContentAlignment;
	["MediumSizeCondition"]: {
	and?: Array<ResolverInputTypes["MediumSizeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["MediumSizeCondition"]> | undefined | null,
	not?: ResolverInputTypes["MediumSizeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["MediumSize"] | undefined | null,
	notEq?: ResolverInputTypes["MediumSize"] | undefined | null,
	in?: Array<ResolverInputTypes["MediumSize"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["MediumSize"]> | undefined | null,
	lt?: ResolverInputTypes["MediumSize"] | undefined | null,
	lte?: ResolverInputTypes["MediumSize"] | undefined | null,
	gt?: ResolverInputTypes["MediumSize"] | undefined | null,
	gte?: ResolverInputTypes["MediumSize"] | undefined | null
};
	["MediumSize"]:MediumSize;
	["GalleryWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GalleryWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GalleryWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GalleryWhere"] | undefined | null
};
	["GalleryItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["GalleryWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["GalleryItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["GalleryItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["GalleryItemWhere"] | undefined | null
};
	["SeoWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	description?: ResolverInputTypes["StringCondition"] | undefined | null,
	ogTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	ogDescription?: ResolverInputTypes["StringCondition"] | undefined | null,
	noIndex?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	noFollow?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	ogImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["SeoWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["SeoWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["SeoWhere"] | undefined | null
};
	["BusinessPageLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["BusinessPageWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	subtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	stickyBar?: ResolverInputTypes["StickyBarWhere"] | undefined | null,
	infoBox?: ResolverInputTypes["InfoBoxWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null
};
	["BusinessPageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	locales?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,
	theme?: ResolverInputTypes["ThemeWhere"] | undefined | null,
	isLokal?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	tabidooId?: ResolverInputTypes["StringCondition"] | undefined | null,
	headerColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	recruitisOfficeId?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["BusinessPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["BusinessPageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["BusinessPageWhere"] | undefined | null
};
	["StickyBarWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	formButtonLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	jobsForm?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["StickyBarWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["StickyBarWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["StickyBarWhere"] | undefined | null
};
	["InfoBoxWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	logoSize?: ResolverInputTypes["LogoSizeCondition"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	locales?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["InfoBoxWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["InfoBoxWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["InfoBoxWhere"] | undefined | null
};
	["LogoSizeCondition"]: {
	and?: Array<ResolverInputTypes["LogoSizeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["LogoSizeCondition"]> | undefined | null,
	not?: ResolverInputTypes["LogoSizeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["LogoSize"] | undefined | null,
	notEq?: ResolverInputTypes["LogoSize"] | undefined | null,
	in?: Array<ResolverInputTypes["LogoSize"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["LogoSize"]> | undefined | null,
	lt?: ResolverInputTypes["LogoSize"] | undefined | null,
	lte?: ResolverInputTypes["LogoSize"] | undefined | null,
	gt?: ResolverInputTypes["LogoSize"] | undefined | null,
	gte?: ResolverInputTypes["LogoSize"] | undefined | null
};
	["LogoSize"]:LogoSize;
	["InfoBoxLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	address?: ResolverInputTypes["StringCondition"] | undefined | null,
	web?: ResolverInputTypes["StringCondition"] | undefined | null,
	instagram?: ResolverInputTypes["StringCondition"] | undefined | null,
	facebook?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["InfoBoxWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	openingHours?: ResolverInputTypes["TextListWhere"] | undefined | null,
	addressLink?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null
};
	["JobPageLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["JobPageWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	keyInfo?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	email?: ResolverInputTypes["StringCondition"] | undefined | null,
	stickyBar?: ResolverInputTypes["StickyBarWhere"] | undefined | null,
	mobileImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	isSyncedToTabidoo?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	tabidooId?: ResolverInputTypes["StringCondition"] | undefined | null,
	recruitisJobId?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["JobPageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobPageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null
};
	["JobPageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	locales?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,
	theme?: ResolverInputTypes["ThemeWhere"] | undefined | null,
	contractType?: ResolverInputTypes["ContractTypeWhere"] | undefined | null,
	jobCity?: ResolverInputTypes["JobCityWhere"] | undefined | null,
	isActive?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	jobPosition?: ResolverInputTypes["JobPositionWhere"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	isSyncedToTabidoo?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	business?: ResolverInputTypes["BusinessPageWhere"] | undefined | null,
	headerColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	siteType?: ResolverInputTypes["SiteTypeCondition"] | undefined | null,
	isHiddenFromListing?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["JobPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobPageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobPageWhere"] | undefined | null
};
	["ContractTypeWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	locales?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ContractTypeWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ContractTypeWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ContractTypeWhere"] | undefined | null
};
	["ContractTypeLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["ContractTypeWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	slug?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null
};
	["JobCityWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	locales?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["JobCityWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobCityWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobCityWhere"] | undefined | null
};
	["JobCityLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["JobCityWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	slug?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["JobCityLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobCityLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null
};
	["JobPositionWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	locales?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,
	jobs?: ResolverInputTypes["JobPageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["JobPositionWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobPositionWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobPositionWhere"] | undefined | null
};
	["JobPositionLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	type?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["JobPositionWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	slug?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null
};
	["DateTimeCondition"]: {
	and?: Array<ResolverInputTypes["DateTimeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["DateTimeCondition"]> | undefined | null,
	not?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["DateTime"] | undefined | null,
	notEq?: ResolverInputTypes["DateTime"] | undefined | null,
	in?: Array<ResolverInputTypes["DateTime"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["DateTime"]> | undefined | null,
	lt?: ResolverInputTypes["DateTime"] | undefined | null,
	lte?: ResolverInputTypes["DateTime"] | undefined | null,
	gt?: ResolverInputTypes["DateTime"] | undefined | null,
	gte?: ResolverInputTypes["DateTime"] | undefined | null
};
	["DateTime"]:unknown;
	["SiteTypeCondition"]: {
	and?: Array<ResolverInputTypes["SiteTypeCondition"]> | undefined | null,
	or?: Array<ResolverInputTypes["SiteTypeCondition"]> | undefined | null,
	not?: ResolverInputTypes["SiteTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ResolverInputTypes["SiteType"] | undefined | null,
	notEq?: ResolverInputTypes["SiteType"] | undefined | null,
	in?: Array<ResolverInputTypes["SiteType"]> | undefined | null,
	notIn?: Array<ResolverInputTypes["SiteType"]> | undefined | null,
	lt?: ResolverInputTypes["SiteType"] | undefined | null,
	lte?: ResolverInputTypes["SiteType"] | undefined | null,
	gt?: ResolverInputTypes["SiteType"] | undefined | null,
	gte?: ResolverInputTypes["SiteType"] | undefined | null
};
	["SiteType"]:SiteType;
	["KeyInfoListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["KeyInfoListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["KeyInfoListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null
};
	["KeyInfoItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	keyInfo?: ResolverInputTypes["StringCondition"] | undefined | null,
	list?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null,
	icon?: ResolverInputTypes["IconWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["KeyInfoItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["KeyInfoItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null
};
	["IconWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	icon?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["IconWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["IconWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["IconWhere"] | undefined | null
};
	["HomePageLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["HomePageWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	button?: ResolverInputTypes["LinkWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null,
	gallery?: ResolverInputTypes["GalleryWhere"] | undefined | null,
	stickyBar?: ResolverInputTypes["StickyBarWhere"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	ilustration?: ResolverInputTypes["GalleryWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["HomePageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["HomePageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null
};
	["HomePageWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,
	theme?: ResolverInputTypes["ThemeWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["HomePageWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["HomePageWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["HomePageWhere"] | undefined | null
};
	["SiteSwitcherWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	theme?: ResolverInputTypes["ThemeWhere"] | undefined | null,
	headerColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["SiteSwitcherWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["SiteSwitcherWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null
};
	["HomePageLokalLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	button?: ResolverInputTypes["LinkWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableWhere"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null,
	gallery?: ResolverInputTypes["GalleryWhere"] | undefined | null,
	stickyBar?: ResolverInputTypes["StickyBarWhere"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	ilustration?: ResolverInputTypes["GalleryWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null
};
	["HomePageLokalWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,
	theme?: ResolverInputTypes["ThemeWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["HomePageLokalWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["HomePageLokalWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null
};
	["RecommendationFormLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	subtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	yourEmailLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	theirEmailLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	yourName?: ResolverInputTypes["StringCondition"] | undefined | null,
	sendBtnLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	successTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	successSubtitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	successButtonClose?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null
};
	["RecommendationFormWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,
	successImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["RecommendationFormWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["RecommendationFormWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null
};
	["HeaderLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["HeaderWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	menuLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	menuTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	menuText?: ResolverInputTypes["StringCondition"] | undefined | null,
	business?: ResolverInputTypes["BusinessWhere"] | undefined | null,
	lokalEnterprise?: ResolverInputTypes["BusinessWhere"] | undefined | null,
	businessSectionTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	lokalSectionTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	businessLink?: ResolverInputTypes["LinkWhere"] | undefined | null,
	lokalLink?: ResolverInputTypes["LinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["HeaderLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["HeaderLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null
};
	["HeaderWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	logoMenu?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["HeaderWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["HeaderWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["HeaderWhere"] | undefined | null
};
	["BusinessWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["BusinessWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["BusinessWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["BusinessWhere"] | undefined | null
};
	["SeoDefaultLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	root?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null
};
	["SeoDefaultWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["SeoDefaultWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["SeoDefaultWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null
};
	["JobsFilterLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	jobPositionLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	jobContractLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	jobCityLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["JobsFilterWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	bannerTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	bannerFormLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	bannerJobsForm?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,
	bannerImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	noJobTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	noJobBtnLabel?: ResolverInputTypes["StringCondition"] | undefined | null,
	noJobImage?: ResolverInputTypes["ImageWhere"] | undefined | null,
	noJobTitleForSpecificBusiness?: ResolverInputTypes["StringCondition"] | undefined | null,
	deactivatedJob?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null
};
	["JobsFilterWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	unique?: ResolverInputTypes["OneCondition"] | undefined | null,
	locales?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["JobsFilterWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobsFilterWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobsFilterWhere"] | undefined | null
};
	["TranslationLocaleWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	value?: ResolverInputTypes["StringCondition"] | undefined | null,
	root?: ResolverInputTypes["TranslationWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["TranslationLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TranslationLocaleWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null
};
	["TranslationWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	key?: ResolverInputTypes["StringCondition"] | undefined | null,
	locales?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,
	isTextarea?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["TranslationWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["TranslationWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["TranslationWhere"] | undefined | null
};
	["CornerBannerWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	isActive?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	title?: ResolverInputTypes["StringCondition"] | undefined | null,
	text?: ResolverInputTypes["StringCondition"] | undefined | null,
	logo?: ResolverInputTypes["ImageWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["CornerBannerWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["CornerBannerWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["CornerBannerWhere"] | undefined | null
};
	["Locale"]: AliasType<{
	_meta?:ResolverInputTypes["LocaleMeta"],
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
footers?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLocale"]],
genericPages?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageLocale"]],
headers?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeaderLocale"]],
seoDefaults?: [{	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SeoDefaultLocale"]],
businessPages?: [{	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
jobPages?: [{	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPageLocale"]],
contractTypes?: [{	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContractTypeLocale"]],
jobCities?: [{	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobCityLocale"]],
jobPositions?: [{	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPositionLocale"]],
homePages?: [{	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePageLocale"]],
bonusBanners?: [{	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
homePageLokals?: [{	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
jobsForms?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsFormLocale"]],
jobsFilters?: [{	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
general?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GeneralLocale"]],
recommendationForms?: [{	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecommendationFormLocale"]],
infoBoxes?: [{	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoBoxLocale"]],
translations?: [{	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationLocale"]],
footersByRoot?: [{	by: ResolverInputTypes["LocaleFootersByRootUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByTermsAndConditions?: [{	by: ResolverInputTypes["LocaleFootersByTermsAndConditionsUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByBannerImage?: [{	by: ResolverInputTypes["LocaleFootersByBannerImageUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByBannerLink?: [{	by: ResolverInputTypes["LocaleFootersByBannerLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByJobsForm?: [{	by: ResolverInputTypes["LocaleFootersByJobsFormUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByCopyrightLink?: [{	by: ResolverInputTypes["LocaleFootersByCopyrightLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByRecommendationForm?: [{	by: ResolverInputTypes["LocaleFootersByRecommendationFormUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByBannerSecondLink?: [{	by: ResolverInputTypes["LocaleFootersByBannerSecondLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
footersByInstagramLink?: [{	by: ResolverInputTypes["LocaleFootersByInstagramLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
genericPagesByRoot?: [{	by: ResolverInputTypes["LocaleGenericPagesByRootUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
genericPagesByContent?: [{	by: ResolverInputTypes["LocaleGenericPagesByContentUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
genericPagesBySeo?: [{	by: ResolverInputTypes["LocaleGenericPagesBySeoUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
genericPagesByLink?: [{	by: ResolverInputTypes["LocaleGenericPagesByLinkUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
genericPagesByLogo?: [{	by: ResolverInputTypes["LocaleGenericPagesByLogoUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
genericPagesByImage?: [{	by: ResolverInputTypes["LocaleGenericPagesByImageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
headersByRoot?: [{	by: ResolverInputTypes["LocaleHeadersByRootUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
headersByBusinessLink?: [{	by: ResolverInputTypes["LocaleHeadersByBusinessLinkUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
headersByLokalLink?: [{	by: ResolverInputTypes["LocaleHeadersByLokalLinkUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
seoDefaultsByRoot?: [{	by: ResolverInputTypes["LocaleSeoDefaultsByRootUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null},ResolverInputTypes["SeoDefaultLocale"]],
seoDefaultsBySeo?: [{	by: ResolverInputTypes["LocaleSeoDefaultsBySeoUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null},ResolverInputTypes["SeoDefaultLocale"]],
businessPagesByRoot?: [{	by: ResolverInputTypes["LocaleBusinessPagesByRootUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
businessPagesByContent?: [{	by: ResolverInputTypes["LocaleBusinessPagesByContentUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
businessPagesBySeo?: [{	by: ResolverInputTypes["LocaleBusinessPagesBySeoUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
businessPagesByLink?: [{	by: ResolverInputTypes["LocaleBusinessPagesByLinkUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
businessPagesByImage?: [{	by: ResolverInputTypes["LocaleBusinessPagesByImageUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
jobPagesByRoot?: [{	by: ResolverInputTypes["LocaleJobPagesByRootUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
jobPagesByImage?: [{	by: ResolverInputTypes["LocaleJobPagesByImageUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
jobPagesByKeyInfo?: [{	by: ResolverInputTypes["LocaleJobPagesByKeyInfoUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
jobPagesByContent?: [{	by: ResolverInputTypes["LocaleJobPagesByContentUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
jobPagesBySeo?: [{	by: ResolverInputTypes["LocaleJobPagesBySeoUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
jobPagesByLink?: [{	by: ResolverInputTypes["LocaleJobPagesByLinkUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
jobPagesByMobileImage?: [{	by: ResolverInputTypes["LocaleJobPagesByMobileImageUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
contractTypesByRoot?: [{	by: ResolverInputTypes["LocaleContractTypesByRootUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null},ResolverInputTypes["ContractTypeLocale"]],
contractTypesBySlug?: [{	by: ResolverInputTypes["LocaleContractTypesBySlugUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null},ResolverInputTypes["ContractTypeLocale"]],
jobCitiesByRoot?: [{	by: ResolverInputTypes["LocaleJobCitiesByRootUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null},ResolverInputTypes["JobCityLocale"]],
jobCitiesBySlug?: [{	by: ResolverInputTypes["LocaleJobCitiesBySlugUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null},ResolverInputTypes["JobCityLocale"]],
jobPositionsByRoot?: [{	by: ResolverInputTypes["LocaleJobPositionsByRootUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null},ResolverInputTypes["JobPositionLocale"]],
jobPositionsBySlug?: [{	by: ResolverInputTypes["LocaleJobPositionsBySlugUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null},ResolverInputTypes["JobPositionLocale"]],
homePagesByRoot?: [{	by: ResolverInputTypes["LocaleHomePagesByRootUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
homePagesByButton?: [{	by: ResolverInputTypes["LocaleHomePagesByButtonUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
homePagesByContent?: [{	by: ResolverInputTypes["LocaleHomePagesByContentUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
homePagesBySeo?: [{	by: ResolverInputTypes["LocaleHomePagesBySeoUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
homePagesByLink?: [{	by: ResolverInputTypes["LocaleHomePagesByLinkUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
homePagesByLogo?: [{	by: ResolverInputTypes["LocaleHomePagesByLogoUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
homePagesBySiteSwitcher?: [{	by: ResolverInputTypes["LocaleHomePagesBySiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
homePagesByIlustration?: [{	by: ResolverInputTypes["LocaleHomePagesByIlustrationUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
bonusBannersByRoot?: [{	by: ResolverInputTypes["LocaleBonusBannersByRootUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
bonusBannersByTiles?: [{	by: ResolverInputTypes["LocaleBonusBannersByTilesUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
bonusBannersByLogo?: [{	by: ResolverInputTypes["LocaleBonusBannersByLogoUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
homePageLokalsByRoot?: [{	by: ResolverInputTypes["LocaleHomePageLokalsByRootUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
homePageLokalsByLogo?: [{	by: ResolverInputTypes["LocaleHomePageLokalsByLogoUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
homePageLokalsByButton?: [{	by: ResolverInputTypes["LocaleHomePageLokalsByButtonUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
homePageLokalsByContent?: [{	by: ResolverInputTypes["LocaleHomePageLokalsByContentUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
homePageLokalsBySeo?: [{	by: ResolverInputTypes["LocaleHomePageLokalsBySeoUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
homePageLokalsByLink?: [{	by: ResolverInputTypes["LocaleHomePageLokalsByLinkUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
homePageLokalsBySiteSwitcher?: [{	by: ResolverInputTypes["LocaleHomePageLokalsBySiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
homePageLokalsByIlustration?: [{	by: ResolverInputTypes["LocaleHomePageLokalsByIlustrationUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
jobsFormsByRoot?: [{	by: ResolverInputTypes["LocaleJobsFormsByRootUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
jobsFormsByImageTextList?: [{	by: ResolverInputTypes["LocaleJobsFormsByImageTextListUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
jobsFormsByLogo?: [{	by: ResolverInputTypes["LocaleJobsFormsByLogoUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
jobsFormsBySuccessImage?: [{	by: ResolverInputTypes["LocaleJobsFormsBySuccessImageUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
jobsFiltersByRoot?: [{	by: ResolverInputTypes["LocaleJobsFiltersByRootUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
jobsFiltersByBannerJobsForm?: [{	by: ResolverInputTypes["LocaleJobsFiltersByBannerJobsFormUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
jobsFiltersByBannerImage?: [{	by: ResolverInputTypes["LocaleJobsFiltersByBannerImageUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
jobsFiltersByNoJobImage?: [{	by: ResolverInputTypes["LocaleJobsFiltersByNoJobImageUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
generalByRoot?: [{	by: ResolverInputTypes["LocaleGeneralByRootUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
generalBySeo?: [{	by: ResolverInputTypes["LocaleGeneralBySeoUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
generalByCornerBanner?: [{	by: ResolverInputTypes["LocaleGeneralByCornerBannerUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
recommendationFormsByRoot?: [{	by: ResolverInputTypes["LocaleRecommendationFormsByRootUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null},ResolverInputTypes["RecommendationFormLocale"]],
infoBoxesByRoot?: [{	by: ResolverInputTypes["LocaleInfoBoxesByRootUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null},ResolverInputTypes["InfoBoxLocale"]],
translationsByRoot?: [{	by: ResolverInputTypes["LocaleTranslationsByRootUniqueWhere"],	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null},ResolverInputTypes["TranslationLocale"]],
paginateFooters?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLocaleConnection"]],
paginateGenericPages?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageLocaleConnection"]],
paginateHeaders?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderLocaleConnection"]],
paginateSeoDefaults?: [{	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SeoDefaultLocaleConnection"]],
paginateBusinessPages?: [{	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BusinessPageLocaleConnection"]],
paginateJobPages?: [{	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPageLocaleConnection"]],
paginateContractTypes?: [{	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContractTypeLocaleConnection"]],
paginateJobCities?: [{	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobCityLocaleConnection"]],
paginateJobPositions?: [{	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPositionLocaleConnection"]],
paginateHomePages?: [{	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageLocaleConnection"]],
paginateBonusBanners?: [{	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BonusBannerLocaleConnection"]],
paginateHomePageLokals?: [{	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageLokalLocaleConnection"]],
paginateJobsForms?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFormLocaleConnection"]],
paginateJobsFilters?: [{	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFilterLocaleConnection"]],
paginateGeneral?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralLocaleConnection"]],
paginateRecommendationForms?: [{	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecommendationFormLocaleConnection"]],
paginateInfoBoxes?: [{	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoBoxLocaleConnection"]],
paginateTranslations?: [{	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["LocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	code?:ResolverInputTypes["FieldMeta"],
	label?:ResolverInputTypes["FieldMeta"],
	footers?:ResolverInputTypes["FieldMeta"],
	genericPages?:ResolverInputTypes["FieldMeta"],
	headers?:ResolverInputTypes["FieldMeta"],
	seoDefaults?:ResolverInputTypes["FieldMeta"],
	businessPages?:ResolverInputTypes["FieldMeta"],
	jobPages?:ResolverInputTypes["FieldMeta"],
	contractTypes?:ResolverInputTypes["FieldMeta"],
	jobCities?:ResolverInputTypes["FieldMeta"],
	jobPositions?:ResolverInputTypes["FieldMeta"],
	homePages?:ResolverInputTypes["FieldMeta"],
	bonusBanners?:ResolverInputTypes["FieldMeta"],
	homePageLokals?:ResolverInputTypes["FieldMeta"],
	jobsForms?:ResolverInputTypes["FieldMeta"],
	jobsFilters?:ResolverInputTypes["FieldMeta"],
	general?:ResolverInputTypes["FieldMeta"],
	recommendationForms?:ResolverInputTypes["FieldMeta"],
	infoBoxes?:ResolverInputTypes["FieldMeta"],
	translations?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocale"]: AliasType<{
	_meta?:ResolverInputTypes["FooterLocaleMeta"],
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	address?:boolean | `@${string}`,
	ico?:boolean | `@${string}`,
	dic?:boolean | `@${string}`,
	copyright?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	noteSecond?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["FooterWhere"] | undefined | null},ResolverInputTypes["Footer"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
linksFirstColumn?: [{	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLink"]],
linksSecondColumn?: [{	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLink"]],
termsAndConditions?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
	form?:boolean | `@${string}`,
	bannerTitle?:boolean | `@${string}`,
	bannerSubtitle?:boolean | `@${string}`,
bannerImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
bannerLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
jobsForm?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
copyrightLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
	bannerSecondBtn?:boolean | `@${string}`,
recommendationForm?: [{	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null},ResolverInputTypes["RecommendationFormLocale"]],
bannerSecondLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
instagramLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
paginateLinksFirstColumn?: [{	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLinkConnection"]],
paginateLinksSecondColumn?: [{	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLinkConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	email?:ResolverInputTypes["FieldMeta"],
	address?:ResolverInputTypes["FieldMeta"],
	ico?:ResolverInputTypes["FieldMeta"],
	dic?:ResolverInputTypes["FieldMeta"],
	copyright?:ResolverInputTypes["FieldMeta"],
	note?:ResolverInputTypes["FieldMeta"],
	noteSecond?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	linksFirstColumn?:ResolverInputTypes["FieldMeta"],
	linksSecondColumn?:ResolverInputTypes["FieldMeta"],
	termsAndConditions?:ResolverInputTypes["FieldMeta"],
	form?:ResolverInputTypes["FieldMeta"],
	bannerTitle?:ResolverInputTypes["FieldMeta"],
	bannerSubtitle?:ResolverInputTypes["FieldMeta"],
	bannerImage?:ResolverInputTypes["FieldMeta"],
	bannerLink?:ResolverInputTypes["FieldMeta"],
	jobsForm?:ResolverInputTypes["FieldMeta"],
	copyrightLink?:ResolverInputTypes["FieldMeta"],
	bannerSecondBtn?:ResolverInputTypes["FieldMeta"],
	recommendationForm?:ResolverInputTypes["FieldMeta"],
	bannerSecondLink?:ResolverInputTypes["FieldMeta"],
	instagramLink?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Footer"]: AliasType<{
	_meta?:ResolverInputTypes["FooterMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["FooterLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByTermsAndConditions?: [{	by: ResolverInputTypes["FooterLocalesByTermsAndConditionsUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByBannerImage?: [{	by: ResolverInputTypes["FooterLocalesByBannerImageUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByBannerLink?: [{	by: ResolverInputTypes["FooterLocalesByBannerLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByJobsForm?: [{	by: ResolverInputTypes["FooterLocalesByJobsFormUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByCopyrightLink?: [{	by: ResolverInputTypes["FooterLocalesByCopyrightLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByRecommendationForm?: [{	by: ResolverInputTypes["FooterLocalesByRecommendationFormUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByBannerSecondLink?: [{	by: ResolverInputTypes["FooterLocalesByBannerSecondLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
localesByInstagramLink?: [{	by: ResolverInputTypes["FooterLocalesByInstagramLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FooterMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	email?: ResolverInputTypes["OrderDirection"] | undefined | null,
	address?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ico?: ResolverInputTypes["OrderDirection"] | undefined | null,
	dic?: ResolverInputTypes["OrderDirection"] | undefined | null,
	copyright?: ResolverInputTypes["OrderDirection"] | undefined | null,
	note?: ResolverInputTypes["OrderDirection"] | undefined | null,
	noteSecond?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["FooterOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	termsAndConditions?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	form?: ResolverInputTypes["OrderDirection"] | undefined | null,
	bannerTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	bannerSubtitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	bannerImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	bannerLink?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	jobsForm?: ResolverInputTypes["JobsFormLocaleOrderBy"] | undefined | null,
	copyrightLink?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	bannerSecondBtn?: ResolverInputTypes["OrderDirection"] | undefined | null,
	recommendationForm?: ResolverInputTypes["RecommendationFormLocaleOrderBy"] | undefined | null,
	bannerSecondLink?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	instagramLink?: ResolverInputTypes["LinkOrderBy"] | undefined | null
};
	["OrderDirection"]:OrderDirection;
	["FooterOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["LocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	code?: ResolverInputTypes["OrderDirection"] | undefined | null,
	label?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["LinkOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	externalLink?: ResolverInputTypes["OrderDirection"] | undefined | null,
	internalLink?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	anchorLink?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["LinkableOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	url?: ResolverInputTypes["OrderDirection"] | undefined | null,
	redirect?: ResolverInputTypes["RedirectOrderBy"] | undefined | null,
	genericPage?: ResolverInputTypes["GenericPageLocaleOrderBy"] | undefined | null,
	businessPage?: ResolverInputTypes["BusinessPageLocaleOrderBy"] | undefined | null,
	jobPage?: ResolverInputTypes["JobPageLocaleOrderBy"] | undefined | null,
	homePage?: ResolverInputTypes["HomePageLocaleOrderBy"] | undefined | null,
	homePageLokal?: ResolverInputTypes["HomePageLokalLocaleOrderBy"] | undefined | null
};
	["RedirectOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	target?: ResolverInputTypes["LinkOrderBy"] | undefined | null
};
	["GenericPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["GenericPageOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["GenericPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	theme?: ResolverInputTypes["ThemeOrderBy"] | undefined | null,
	headerColor?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ThemeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	backgroundColor?: ResolverInputTypes["OrderDirection"] | undefined | null,
	textColor?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	buttonBackgroundColor?: ResolverInputTypes["OrderDirection"] | undefined | null,
	buttonTextColor?: ResolverInputTypes["OrderDirection"] | undefined | null,
	buttonBackgroundHoverColor?: ResolverInputTypes["OrderDirection"] | undefined | null,
	buttonTextHoverColor?: ResolverInputTypes["OrderDirection"] | undefined | null,
	buttonBorderColor?: ResolverInputTypes["OrderDirection"] | undefined | null,
	buttonBorderHoverColor?: ResolverInputTypes["OrderDirection"] | undefined | null,
	headerMenuColor?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ContentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["SeoOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	description?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ogTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ogDescription?: ResolverInputTypes["OrderDirection"] | undefined | null,
	noIndex?: ResolverInputTypes["OrderDirection"] | undefined | null,
	noFollow?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ogImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["ImageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	url?: ResolverInputTypes["OrderDirection"] | undefined | null,
	width?: ResolverInputTypes["OrderDirection"] | undefined | null,
	height?: ResolverInputTypes["OrderDirection"] | undefined | null,
	size?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	alt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fileName?: ResolverInputTypes["OrderDirection"] | undefined | null,
	focalPointX?: ResolverInputTypes["OrderDirection"] | undefined | null,
	focalPointY?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["BusinessPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["BusinessPageOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	subtitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	stickyBar?: ResolverInputTypes["StickyBarOrderBy"] | undefined | null,
	infoBox?: ResolverInputTypes["InfoBoxOrderBy"] | undefined | null
};
	["BusinessPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	theme?: ResolverInputTypes["ThemeOrderBy"] | undefined | null,
	isLokal?: ResolverInputTypes["OrderDirection"] | undefined | null,
	tabidooId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	headerColor?: ResolverInputTypes["OrderDirection"] | undefined | null,
	recruitisOfficeId?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["StickyBarOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	formButtonLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	jobsForm?: ResolverInputTypes["JobsFormLocaleOrderBy"] | undefined | null
};
	["JobsFormLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	jobText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	genericText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	nameLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	emailLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	telefonLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fileTitleLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fileFormatLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	formTextLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	submitLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["JobsFormOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	imageTextList?: ResolverInputTypes["ImageTextListOrderBy"] | undefined | null,
	minimalize?: ResolverInputTypes["OrderDirection"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	successTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successBtnLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	successOtherJobsTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successOtherJobsCategoryTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successOtherJobsButtonTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successOtherJobsSelectionTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successOtherJobsSelectionYesButton?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successOtherJobsSelectionNoButton?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fileRemoveBtnLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	gdprLabel?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["JobsFormOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null,
	fileIlustration?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["ImageTextListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["InfoBoxOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	logoSize?: ResolverInputTypes["OrderDirection"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["JobPageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["JobPageOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	keyInfo?: ResolverInputTypes["KeyInfoListOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	email?: ResolverInputTypes["OrderDirection"] | undefined | null,
	stickyBar?: ResolverInputTypes["StickyBarOrderBy"] | undefined | null,
	mobileImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	isSyncedToTabidoo?: ResolverInputTypes["OrderDirection"] | undefined | null,
	tabidooId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	recruitisJobId?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["JobPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	theme?: ResolverInputTypes["ThemeOrderBy"] | undefined | null,
	contractType?: ResolverInputTypes["ContractTypeOrderBy"] | undefined | null,
	jobCity?: ResolverInputTypes["JobCityOrderBy"] | undefined | null,
	isActive?: ResolverInputTypes["OrderDirection"] | undefined | null,
	jobPosition?: ResolverInputTypes["JobPositionOrderBy"] | undefined | null,
	publishedAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isSyncedToTabidoo?: ResolverInputTypes["OrderDirection"] | undefined | null,
	business?: ResolverInputTypes["BusinessPageOrderBy"] | undefined | null,
	headerColor?: ResolverInputTypes["OrderDirection"] | undefined | null,
	siteType?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isHiddenFromListing?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ContractTypeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["JobCityOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["JobPositionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["KeyInfoListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["HomePageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["HomePageOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	button?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["SiteSwitcherOrderBy"] | undefined | null,
	gallery?: ResolverInputTypes["GalleryOrderBy"] | undefined | null,
	stickyBar?: ResolverInputTypes["StickyBarOrderBy"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ilustration?: ResolverInputTypes["GalleryOrderBy"] | undefined | null
};
	["HomePageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null,
	theme?: ResolverInputTypes["ThemeOrderBy"] | undefined | null
};
	["SiteSwitcherOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	theme?: ResolverInputTypes["ThemeOrderBy"] | undefined | null,
	headerColor?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["GalleryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["HomePageLokalLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["HomePageLokalOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	button?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["SiteSwitcherOrderBy"] | undefined | null,
	gallery?: ResolverInputTypes["GalleryOrderBy"] | undefined | null,
	stickyBar?: ResolverInputTypes["StickyBarOrderBy"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ilustration?: ResolverInputTypes["GalleryOrderBy"] | undefined | null
};
	["HomePageLokalOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null,
	theme?: ResolverInputTypes["ThemeOrderBy"] | undefined | null
};
	["RecommendationFormLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	subtitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	yourEmailLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	theirEmailLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	yourName?: ResolverInputTypes["OrderDirection"] | undefined | null,
	sendBtnLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successSubtitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successButtonClose?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["RecommendationFormOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null
};
	["RecommendationFormOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null,
	successImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["FooterLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["LocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	footers?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	genericPages?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	headers?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	seoDefaults?: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null,
	businessPages?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	jobPages?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	contractTypes?: ResolverInputTypes["ContractTypeLocaleUniqueWhere"] | undefined | null,
	jobCities?: ResolverInputTypes["JobCityLocaleUniqueWhere"] | undefined | null,
	jobPositions?: ResolverInputTypes["JobPositionLocaleUniqueWhere"] | undefined | null,
	homePages?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	bonusBanners?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	homePageLokals?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	jobsForms?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	jobsFilters?: ResolverInputTypes["JobsFilterLocaleUniqueWhere"] | undefined | null,
	general?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	recommendationForms?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	infoBoxes?: ResolverInputTypes["InfoBoxLocaleUniqueWhere"] | undefined | null,
	translations?: ResolverInputTypes["TranslationLocaleUniqueWhere"] | undefined | null
};
	["FooterLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["FooterUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	termsAndConditions?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	bannerImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	bannerLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	jobsForm?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	copyrightLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	recommendationForm?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	bannerSecondLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	instagramLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["FooterUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null
};
	["LinkUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["ImageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["JobsFormLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["JobsFormUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	imageTextList?: ResolverInputTypes["ImageTextListUniqueWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	successImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["JobsFormUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	fileIlustration?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["ImageTextListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["ImageTextItemUniqueWhere"] | undefined | null
};
	["ImageTextItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["RecommendationFormLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["RecommendationFormUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["RecommendationFormUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	successImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["GenericPageLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["GenericPageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null
};
	["ContentUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	blocks?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null
};
	["ContentBlockUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	references?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null
};
	["ContentReferenceUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	linkables?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	media?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null
};
	["ContentReferenceLinkableItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	item?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LinkableUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["RedirectUniqueWhere"] | undefined | null,
	genericPage?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	businessPage?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	jobPage?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	homePage?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	homePageLokal?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null
};
	["RedirectUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	target?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["BusinessPageLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["BusinessPageUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["BusinessPageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null
};
	["SeoUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	ogImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["JobPageLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["JobPageUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	keyInfo?: ResolverInputTypes["KeyInfoListUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	mobileImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["JobPageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null
};
	["KeyInfoListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["KeyInfoItemUniqueWhere"] | undefined | null
};
	["KeyInfoItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["HomePageLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["HomePageUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	button?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["SiteSwitcherUniqueWhere"] | undefined | null,
	ilustration?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null
};
	["HomePageUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	theme?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null
};
	["ThemeUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["SiteSwitcherUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	theme?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null
};
	["GalleryUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["GalleryItemUniqueWhere"] | undefined | null
};
	["GalleryItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["HomePageLokalLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["HomePageLokalUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	button?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["SiteSwitcherUniqueWhere"] | undefined | null,
	ilustration?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null
};
	["HomePageLokalUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	theme?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null
};
	["MediumListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["MediumItemUniqueWhere"] | undefined | null
};
	["MediumItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["HeaderLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["HeaderUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	businessLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	lokalLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["HeaderUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	logoMenu?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["SeoDefaultLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["SeoDefaultUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["SeoDefaultUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null
};
	["ContractTypeLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["ContractTypeUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	slug?: string | undefined | null
};
	["ContractTypeUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["ContractTypeLocaleUniqueWhere"] | undefined | null
};
	["JobCityLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["JobCityUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	slug?: string | undefined | null
};
	["JobCityUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["JobCityLocaleUniqueWhere"] | undefined | null
};
	["JobPositionLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["JobPositionUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	slug?: string | undefined | null
};
	["JobPositionUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["JobPositionLocaleUniqueWhere"] | undefined | null,
	jobs?: ResolverInputTypes["JobPageUniqueWhere"] | undefined | null
};
	["BonusBannerLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["BonusBannerUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	tiles?: ResolverInputTypes["TileUniqueWhere"] | undefined | null,
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["BonusBannerUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null
};
	["TileUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	ligthBoxMedia?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null
};
	["JobsFilterLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["JobsFilterUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	bannerJobsForm?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	bannerImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	noJobImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["JobsFilterUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["JobsFilterLocaleUniqueWhere"] | undefined | null
};
	["GeneralLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GeneralUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	cornerBanner?: ResolverInputTypes["CornerBannerUniqueWhere"] | undefined | null
};
	["GeneralUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null
};
	["CornerBannerUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["InfoBoxLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["InfoBoxUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["InfoBoxUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	locales?: ResolverInputTypes["InfoBoxLocaleUniqueWhere"] | undefined | null
};
	["TranslationLocaleUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["TranslationUniqueWhere"] | undefined | null,
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["TranslationUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: ResolverInputTypes["TranslationLocaleUniqueWhere"] | undefined | null
};
	["FooterLocalesByTermsAndConditionsUniqueWhere"]: {
	termsAndConditions?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["FooterLocalesByBannerImageUniqueWhere"]: {
	bannerImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["FooterLocalesByBannerLinkUniqueWhere"]: {
	bannerLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["FooterLocalesByJobsFormUniqueWhere"]: {
	jobsForm?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null
};
	["FooterLocalesByCopyrightLinkUniqueWhere"]: {
	copyrightLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["FooterLocalesByRecommendationFormUniqueWhere"]: {
	recommendationForm?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null
};
	["FooterLocalesByBannerSecondLinkUniqueWhere"]: {
	bannerSecondLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["FooterLocalesByInstagramLinkUniqueWhere"]: {
	instagramLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["FooterLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FooterLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PageInfo"]: AliasType<{
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["FooterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLink"]: AliasType<{
	_meta?:ResolverInputTypes["FooterLinkMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Link"]: AliasType<{
	_meta?:ResolverInputTypes["LinkMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	externalLink?:boolean | `@${string}`,
internalLink?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
	anchorLink?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LinkMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	externalLink?:ResolverInputTypes["FieldMeta"],
	internalLink?:ResolverInputTypes["FieldMeta"],
	anchorLink?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Linkable"]: AliasType<{
	_meta?:ResolverInputTypes["LinkableMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
redirect?: [{	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null},ResolverInputTypes["Redirect"]],
genericPage?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
businessPage?: [{	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
jobPage?: [{	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
homePage?: [{	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
homePageLokal?: [{	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkableMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	url?:ResolverInputTypes["FieldMeta"],
	redirect?:ResolverInputTypes["FieldMeta"],
	genericPage?:ResolverInputTypes["FieldMeta"],
	businessPage?:ResolverInputTypes["FieldMeta"],
	jobPage?:ResolverInputTypes["FieldMeta"],
	homePage?:ResolverInputTypes["FieldMeta"],
	homePageLokal?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Redirect"]: AliasType<{
	_meta?:ResolverInputTypes["RedirectMeta"],
	id?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
target?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["RedirectMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	target?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocale"]: AliasType<{
	_meta?:ResolverInputTypes["GenericPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null},ResolverInputTypes["GenericPage"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
	text?:boolean | `@${string}`,
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPage"]: AliasType<{
	_meta?:ResolverInputTypes["GenericPageMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageLocale"]],
theme?: [{	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null},ResolverInputTypes["Theme"]],
	headerColor?:boolean | `@${string}`,
localesByLocale?: [{	by: ResolverInputTypes["GenericPageLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
localesByContent?: [{	by: ResolverInputTypes["GenericPageLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["GenericPageLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
localesByLink?: [{	by: ResolverInputTypes["GenericPageLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
localesByLogo?: [{	by: ResolverInputTypes["GenericPageLocalesByLogoUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
localesByImage?: [{	by: ResolverInputTypes["GenericPageLocalesByImageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	theme?:ResolverInputTypes["FieldMeta"],
	headerColor?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Theme"]: AliasType<{
	_meta?:ResolverInputTypes["ThemeMeta"],
	id?:boolean | `@${string}`,
	backgroundColor?:boolean | `@${string}`,
	textColor?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	buttonBackgroundColor?:boolean | `@${string}`,
	buttonTextColor?:boolean | `@${string}`,
	buttonBackgroundHoverColor?:boolean | `@${string}`,
	buttonTextHoverColor?:boolean | `@${string}`,
	buttonBorderColor?:boolean | `@${string}`,
	buttonBorderHoverColor?:boolean | `@${string}`,
	headerMenuColor?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ThemeMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	backgroundColor?:ResolverInputTypes["FieldMeta"],
	textColor?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	buttonBackgroundColor?:ResolverInputTypes["FieldMeta"],
	buttonTextColor?:ResolverInputTypes["FieldMeta"],
	buttonBackgroundHoverColor?:ResolverInputTypes["FieldMeta"],
	buttonTextHoverColor?:ResolverInputTypes["FieldMeta"],
	buttonBorderColor?:ResolverInputTypes["FieldMeta"],
	buttonBorderHoverColor?:ResolverInputTypes["FieldMeta"],
	headerMenuColor?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["GenericPageLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["GenericPageLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["GenericPageLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["GenericPageLocalesByLogoUniqueWhere"]: {
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["GenericPageLocalesByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["GenericPageLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GenericPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["GenericPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Content"]: AliasType<{
	_meta?:ResolverInputTypes["ContentMeta"],
	id?:boolean | `@${string}`,
blocks?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentBlock"]],
blocksByReferences?: [{	by: ResolverInputTypes["ContentBlocksByReferencesUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlock"]],
paginateBlocks?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentBlockConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	blocks?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ResolverInputTypes["ContentBlockMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	json?:boolean | `@${string}`,
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
references?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByLinkables?: [{	by: ResolverInputTypes["ContentBlockReferencesByLinkablesUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByLink?: [{	by: ResolverInputTypes["ContentBlockReferencesByLinkUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
referencesByMedia?: [{	by: ResolverInputTypes["ContentBlockReferencesByMediaUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
paginateReferences?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	json?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	references?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReference"]: AliasType<{
	_meta?:ResolverInputTypes["ContentReferenceMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	primaryText?:boolean | `@${string}`,
block?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlock"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
linkables?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
	secondaryText?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
media?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumList"]],
textList?: [{	filter?: ResolverInputTypes["TextListWhere"] | undefined | null},ResolverInputTypes["TextList"]],
carousel?: [{	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null},ResolverInputTypes["Carousel"]],
bonusBanner?: [{	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
sideBySide?: [{	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null},ResolverInputTypes["SideBySide"]],
gallery?: [{	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null},ResolverInputTypes["Gallery"]],
	showBoolean?:boolean | `@${string}`,
	isRed?:boolean | `@${string}`,
video?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["Video"]],
linkablesByItem?: [{	by: ResolverInputTypes["ContentReferenceLinkablesByItemUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
paginateLinkables?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	primaryText?:ResolverInputTypes["FieldMeta"],
	block?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	linkables?:ResolverInputTypes["FieldMeta"],
	secondaryText?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	media?:ResolverInputTypes["FieldMeta"],
	textList?:ResolverInputTypes["FieldMeta"],
	carousel?:ResolverInputTypes["FieldMeta"],
	bonusBanner?:ResolverInputTypes["FieldMeta"],
	sideBySide?:ResolverInputTypes["FieldMeta"],
	gallery?:ResolverInputTypes["FieldMeta"],
	showBoolean?:ResolverInputTypes["FieldMeta"],
	isRed?:ResolverInputTypes["FieldMeta"],
	video?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Image"]: AliasType<{
	_meta?:ResolverInputTypes["ImageMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	alt?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	focalPointX?:boolean | `@${string}`,
	focalPointY?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ImageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	url?:ResolverInputTypes["FieldMeta"],
	width?:ResolverInputTypes["FieldMeta"],
	height?:ResolverInputTypes["FieldMeta"],
	size?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	alt?:ResolverInputTypes["FieldMeta"],
	fileName?:ResolverInputTypes["FieldMeta"],
	focalPointX?:ResolverInputTypes["FieldMeta"],
	focalPointY?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItem"]: AliasType<{
	_meta?:ResolverInputTypes["ContentReferenceLinkableItemMeta"],
	id?:boolean | `@${string}`,
item?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
reference?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	item?:ResolverInputTypes["FieldMeta"],
	reference?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	item?: ResolverInputTypes["LinkableOrderBy"] | undefined | null,
	reference?: ResolverInputTypes["ContentReferenceOrderBy"] | undefined | null
};
	["ContentReferenceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	primaryText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	block?: ResolverInputTypes["ContentBlockOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	secondaryText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	media?: ResolverInputTypes["MediumListOrderBy"] | undefined | null,
	textList?: ResolverInputTypes["TextListOrderBy"] | undefined | null,
	carousel?: ResolverInputTypes["CarouselOrderBy"] | undefined | null,
	bonusBanner?: ResolverInputTypes["BonusBannerLocaleOrderBy"] | undefined | null,
	sideBySide?: ResolverInputTypes["SideBySideOrderBy"] | undefined | null,
	gallery?: ResolverInputTypes["GalleryOrderBy"] | undefined | null,
	showBoolean?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isRed?: ResolverInputTypes["OrderDirection"] | undefined | null,
	video?: ResolverInputTypes["VideoOrderBy"] | undefined | null
};
	["ContentBlockOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	json?: ResolverInputTypes["OrderDirection"] | undefined | null,
	content?: ResolverInputTypes["ContentOrderBy"] | undefined | null
};
	["MediumListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["TextListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["CarouselOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	background?: ResolverInputTypes["OrderDirection"] | undefined | null,
	squareImages?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["BonusBannerLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["BonusBannerOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	bannerName?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["BonusBannerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["SideBySideOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	background?: ResolverInputTypes["OrderDirection"] | undefined | null,
	alignment?: ResolverInputTypes["OrderDirection"] | undefined | null,
	mediumSize?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["VideoOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	src?: ResolverInputTypes["OrderDirection"] | undefined | null,
	width?: ResolverInputTypes["OrderDirection"] | undefined | null,
	height?: ResolverInputTypes["OrderDirection"] | undefined | null,
	size?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	videoInfo?: ResolverInputTypes["OrderDirection"] | undefined | null,
	duration?: ResolverInputTypes["OrderDirection"] | undefined | null,
	poster?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["MediumList"]: AliasType<{
	_meta?:ResolverInputTypes["MediumListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MediumItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItem"]: AliasType<{
	_meta?:ResolverInputTypes["MediumItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumList"]],
medium?: [{	filter?: ResolverInputTypes["MediumWhere"] | undefined | null},ResolverInputTypes["Medium"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	medium?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Medium"]: AliasType<{
	_meta?:ResolverInputTypes["MediumMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
video?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["Video"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	video?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Video"]: AliasType<{
	_meta?:ResolverInputTypes["VideoMeta"],
	id?:boolean | `@${string}`,
	src?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	videoInfo?:boolean | `@${string}`,
	duration?:boolean | `@${string}`,
poster?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["VideoMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	src?:ResolverInputTypes["FieldMeta"],
	width?:ResolverInputTypes["FieldMeta"],
	height?:ResolverInputTypes["FieldMeta"],
	size?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	videoInfo?:ResolverInputTypes["FieldMeta"],
	duration?:ResolverInputTypes["FieldMeta"],
	poster?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["MediumListOrderBy"] | undefined | null,
	medium?: ResolverInputTypes["MediumOrderBy"] | undefined | null
};
	["MediumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	video?: ResolverInputTypes["VideoOrderBy"] | undefined | null
};
	["MediumItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["MediumItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemEdge"]: AliasType<{
	node?:ResolverInputTypes["MediumItem"],
		__typename?: boolean | `@${string}`
}>;
	["TextList"]: AliasType<{
	_meta?:ResolverInputTypes["TextListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TextItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TextItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TextListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextItem"]: AliasType<{
	_meta?:ResolverInputTypes["TextItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["TextListWhere"] | undefined | null},ResolverInputTypes["TextList"]],
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TextItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["TextListOrderBy"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["TextItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TextItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemEdge"]: AliasType<{
	node?:ResolverInputTypes["TextItem"],
		__typename?: boolean | `@${string}`
}>;
	["Carousel"]: AliasType<{
	_meta?:ResolverInputTypes["CarouselMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CarouselItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CarouselItem"]],
	background?:boolean | `@${string}`,
	squareImages?:boolean | `@${string}`,
itemsByImage?: [{	by: ResolverInputTypes["CarouselItemsByImageUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null},ResolverInputTypes["CarouselItem"]],
itemsByLinkUrl?: [{	by: ResolverInputTypes["CarouselItemsByLinkUrlUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null},ResolverInputTypes["CarouselItem"]],
itemsByVideo?: [{	by: ResolverInputTypes["CarouselItemsByVideoUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null},ResolverInputTypes["CarouselItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CarouselItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CarouselItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CarouselMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
	background?:ResolverInputTypes["FieldMeta"],
	squareImages?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItem"]: AliasType<{
	_meta?:ResolverInputTypes["CarouselItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null},ResolverInputTypes["Carousel"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	name?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
linkUrl?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
	normalAspectRatio?:boolean | `@${string}`,
	isImage?:boolean | `@${string}`,
video?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["Video"]],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	linkUrl?:ResolverInputTypes["FieldMeta"],
	normalAspectRatio?:ResolverInputTypes["FieldMeta"],
	isImage?:ResolverInputTypes["FieldMeta"],
	video?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["CarouselOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	linkUrl?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	normalAspectRatio?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isImage?: ResolverInputTypes["OrderDirection"] | undefined | null,
	video?: ResolverInputTypes["VideoOrderBy"] | undefined | null
};
	["CarouselItemsByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["CarouselItemsByLinkUrlUniqueWhere"]: {
	linkUrl?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["CarouselItemsByVideoUniqueWhere"]: {
	video?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null
};
	["VideoUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["CarouselItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["CarouselItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemEdge"]: AliasType<{
	node?:ResolverInputTypes["CarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocale"]: AliasType<{
	_meta?:ResolverInputTypes["BonusBannerLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null},ResolverInputTypes["BonusBanner"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
tiles?: [{	filter?: ResolverInputTypes["TileWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Tile"]],
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	bannerName?:boolean | `@${string}`,
tilesByImage?: [{	by: ResolverInputTypes["BonusBannerLocaleTilesByImageUniqueWhere"],	filter?: ResolverInputTypes["TileWhere"] | undefined | null},ResolverInputTypes["Tile"]],
tilesByLigthBoxMedia?: [{	by: ResolverInputTypes["BonusBannerLocaleTilesByLigthBoxMediaUniqueWhere"],	filter?: ResolverInputTypes["TileWhere"] | undefined | null},ResolverInputTypes["Tile"]],
paginateTiles?: [{	filter?: ResolverInputTypes["TileWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TileConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	tiles?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
	bannerName?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBanner"]: AliasType<{
	_meta?:ResolverInputTypes["BonusBannerMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["BonusBannerLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
localesByTiles?: [{	by: ResolverInputTypes["BonusBannerLocalesByTilesUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
localesByLogo?: [{	by: ResolverInputTypes["BonusBannerLocalesByLogoUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BonusBannerLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["BonusBannerLocalesByTilesUniqueWhere"]: {
	tiles?: ResolverInputTypes["TileUniqueWhere"] | undefined | null
};
	["BonusBannerLocalesByLogoUniqueWhere"]: {
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["BonusBannerLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["BonusBannerLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["BonusBannerLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Tile"]: AliasType<{
	_meta?:ResolverInputTypes["TileMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
bonusBanner?: [{	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	lightBoxTitle?:boolean | `@${string}`,
	lightBoxText?:boolean | `@${string}`,
ligthBoxMedia?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumList"]],
	lightBoxSectionTitle?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	lightBoxLinkLabel?:boolean | `@${string}`,
lightBoxForm?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
		__typename?: boolean | `@${string}`
}>;
	["TileMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	bonusBanner?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	lightBoxTitle?:ResolverInputTypes["FieldMeta"],
	lightBoxText?:ResolverInputTypes["FieldMeta"],
	ligthBoxMedia?:ResolverInputTypes["FieldMeta"],
	lightBoxSectionTitle?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	lightBoxLinkLabel?:ResolverInputTypes["FieldMeta"],
	lightBoxForm?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocale"]: AliasType<{
	_meta?:ResolverInputTypes["JobsFormLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	jobText?:boolean | `@${string}`,
	genericText?:boolean | `@${string}`,
	nameLabel?:boolean | `@${string}`,
	emailLabel?:boolean | `@${string}`,
	telefonLabel?:boolean | `@${string}`,
	fileTitleLabel?:boolean | `@${string}`,
	fileFormatLabel?:boolean | `@${string}`,
	formTextLabel?:boolean | `@${string}`,
	submitLabel?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null},ResolverInputTypes["JobsForm"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
imageTextList?: [{	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null},ResolverInputTypes["ImageTextList"]],
	minimalize?:boolean | `@${string}`,
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	successTitle?:boolean | `@${string}`,
	successText?:boolean | `@${string}`,
	successBtnLabel?:boolean | `@${string}`,
successImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	successOtherJobsTitle?:boolean | `@${string}`,
	successOtherJobsCategoryTitle?:boolean | `@${string}`,
	successOtherJobsButtonTitle?:boolean | `@${string}`,
	successOtherJobsSelectionTitle?:boolean | `@${string}`,
	successOtherJobsSelectionYesButton?:boolean | `@${string}`,
	successOtherJobsSelectionNoButton?:boolean | `@${string}`,
	fileRemoveBtnLabel?:boolean | `@${string}`,
	gdprLabel?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	jobText?:ResolverInputTypes["FieldMeta"],
	genericText?:ResolverInputTypes["FieldMeta"],
	nameLabel?:ResolverInputTypes["FieldMeta"],
	emailLabel?:ResolverInputTypes["FieldMeta"],
	telefonLabel?:ResolverInputTypes["FieldMeta"],
	fileTitleLabel?:ResolverInputTypes["FieldMeta"],
	fileFormatLabel?:ResolverInputTypes["FieldMeta"],
	formTextLabel?:ResolverInputTypes["FieldMeta"],
	submitLabel?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	imageTextList?:ResolverInputTypes["FieldMeta"],
	minimalize?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
	successTitle?:ResolverInputTypes["FieldMeta"],
	successText?:ResolverInputTypes["FieldMeta"],
	successBtnLabel?:ResolverInputTypes["FieldMeta"],
	successImage?:ResolverInputTypes["FieldMeta"],
	successOtherJobsTitle?:ResolverInputTypes["FieldMeta"],
	successOtherJobsCategoryTitle?:ResolverInputTypes["FieldMeta"],
	successOtherJobsButtonTitle?:ResolverInputTypes["FieldMeta"],
	successOtherJobsSelectionTitle?:ResolverInputTypes["FieldMeta"],
	successOtherJobsSelectionYesButton?:ResolverInputTypes["FieldMeta"],
	successOtherJobsSelectionNoButton?:ResolverInputTypes["FieldMeta"],
	fileRemoveBtnLabel?:ResolverInputTypes["FieldMeta"],
	gdprLabel?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobsForm"]: AliasType<{
	_meta?:ResolverInputTypes["JobsFormMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsFormLocale"]],
fileIlustration?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
localesByLocale?: [{	by: ResolverInputTypes["JobsFormLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
localesByImageTextList?: [{	by: ResolverInputTypes["JobsFormLocalesByImageTextListUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
localesByLogo?: [{	by: ResolverInputTypes["JobsFormLocalesByLogoUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
localesBySuccessImage?: [{	by: ResolverInputTypes["JobsFormLocalesBySuccessImageUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFormLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	fileIlustration?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["JobsFormLocalesByImageTextListUniqueWhere"]: {
	imageTextList?: ResolverInputTypes["ImageTextListUniqueWhere"] | undefined | null
};
	["JobsFormLocalesByLogoUniqueWhere"]: {
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["JobsFormLocalesBySuccessImageUniqueWhere"]: {
	successImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["JobsFormLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobsFormLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["JobsFormLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextList"]: AliasType<{
	_meta?:ResolverInputTypes["ImageTextListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageTextItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageTextItem"]],
itemsByImage?: [{	by: ResolverInputTypes["ImageTextListItemsByImageUniqueWhere"],	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null},ResolverInputTypes["ImageTextItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageTextItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageTextItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItem"]: AliasType<{
	_meta?:ResolverInputTypes["ImageTextItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null},ResolverInputTypes["ImageTextList"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["ImageTextListOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["ImageTextListItemsByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["ImageTextItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ImageTextItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemEdge"]: AliasType<{
	node?:ResolverInputTypes["ImageTextItem"],
		__typename?: boolean | `@${string}`
}>;
	["TileOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	bonusBanner?: ResolverInputTypes["BonusBannerLocaleOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	lightBoxTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	lightBoxText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	ligthBoxMedia?: ResolverInputTypes["MediumListOrderBy"] | undefined | null,
	lightBoxSectionTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	lightBoxLinkLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	lightBoxForm?: ResolverInputTypes["JobsFormLocaleOrderBy"] | undefined | null
};
	["BonusBannerLocaleTilesByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["BonusBannerLocaleTilesByLigthBoxMediaUniqueWhere"]: {
	ligthBoxMedia?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null
};
	["TileConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TileEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TileEdge"]: AliasType<{
	node?:ResolverInputTypes["Tile"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySide"]: AliasType<{
	_meta?:ResolverInputTypes["SideBySideMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SideBySideItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SideBySideItem"]],
	background?:boolean | `@${string}`,
	alignment?:boolean | `@${string}`,
	mediumSize?:boolean | `@${string}`,
itemsByMedia?: [{	by: ResolverInputTypes["SideBySideItemsByMediaUniqueWhere"],	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null},ResolverInputTypes["SideBySideItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SideBySideItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SideBySideItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
	background?:ResolverInputTypes["FieldMeta"],
	alignment?:ResolverInputTypes["FieldMeta"],
	mediumSize?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItem"]: AliasType<{
	_meta?:ResolverInputTypes["SideBySideItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null},ResolverInputTypes["SideBySide"]],
media?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumList"]],
	formButtonLabel?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
jobsForm?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
	textNew?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	media?:ResolverInputTypes["FieldMeta"],
	formButtonLabel?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	jobsForm?:ResolverInputTypes["FieldMeta"],
	textNew?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["SideBySideOrderBy"] | undefined | null,
	media?: ResolverInputTypes["MediumListOrderBy"] | undefined | null,
	formButtonLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	jobsForm?: ResolverInputTypes["JobsFormLocaleOrderBy"] | undefined | null,
	textNew?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["SideBySideItemsByMediaUniqueWhere"]: {
	media?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null
};
	["SideBySideItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["SideBySideItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemEdge"]: AliasType<{
	node?:ResolverInputTypes["SideBySideItem"],
		__typename?: boolean | `@${string}`
}>;
	["Gallery"]: AliasType<{
	_meta?:ResolverInputTypes["GalleryMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GalleryItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GalleryItem"]],
itemsByImage?: [{	by: ResolverInputTypes["GalleryItemsByImageUniqueWhere"],	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null},ResolverInputTypes["GalleryItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GalleryItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GalleryItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GalleryMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItem"]: AliasType<{
	_meta?:ResolverInputTypes["GalleryItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null},ResolverInputTypes["Gallery"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["GalleryOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["GalleryItemsByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["GalleryItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GalleryItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemEdge"]: AliasType<{
	node?:ResolverInputTypes["GalleryItem"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkablesByItemUniqueWhere"]: {
	item?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["ContentReferenceLinkableItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ContentReferenceLinkableItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceLinkableItemEdge"]: AliasType<{
	node?:ResolverInputTypes["ContentReferenceLinkableItem"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockReferencesByLinkablesUniqueWhere"]: {
	linkables?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByMediaUniqueWhere"]: {
	media?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null
};
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ContentReferenceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ResolverInputTypes["ContentReference"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ContentBlockEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ResolverInputTypes["ContentBlock"],
		__typename?: boolean | `@${string}`
}>;
	["Seo"]: AliasType<{
	_meta?:ResolverInputTypes["SeoMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	ogTitle?:boolean | `@${string}`,
	ogDescription?:boolean | `@${string}`,
	noIndex?:boolean | `@${string}`,
	noFollow?:boolean | `@${string}`,
ogImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["SeoMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	description?:ResolverInputTypes["FieldMeta"],
	ogTitle?:ResolverInputTypes["FieldMeta"],
	ogDescription?:ResolverInputTypes["FieldMeta"],
	noIndex?:ResolverInputTypes["FieldMeta"],
	noFollow?:ResolverInputTypes["FieldMeta"],
	ogImage?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocale"]: AliasType<{
	_meta?:ResolverInputTypes["BusinessPageLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null},ResolverInputTypes["BusinessPage"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
	subtitle?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
stickyBar?: [{	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null},ResolverInputTypes["StickyBar"]],
infoBox?: [{	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null},ResolverInputTypes["InfoBox"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	subtitle?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	stickyBar?:ResolverInputTypes["FieldMeta"],
	infoBox?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPage"]: AliasType<{
	_meta?:ResolverInputTypes["BusinessPageMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
theme?: [{	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null},ResolverInputTypes["Theme"]],
	isLokal?:boolean | `@${string}`,
	tabidooId?:boolean | `@${string}`,
	headerColor?:boolean | `@${string}`,
	recruitisOfficeId?:boolean | `@${string}`,
localesByLocale?: [{	by: ResolverInputTypes["BusinessPageLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
localesByContent?: [{	by: ResolverInputTypes["BusinessPageLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["BusinessPageLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
localesByLink?: [{	by: ResolverInputTypes["BusinessPageLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
localesByImage?: [{	by: ResolverInputTypes["BusinessPageLocalesByImageUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BusinessPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	theme?:ResolverInputTypes["FieldMeta"],
	isLokal?:ResolverInputTypes["FieldMeta"],
	tabidooId?:ResolverInputTypes["FieldMeta"],
	headerColor?:ResolverInputTypes["FieldMeta"],
	recruitisOfficeId?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["BusinessPageLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["BusinessPageLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["BusinessPageLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["BusinessPageLocalesByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["BusinessPageLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["BusinessPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["BusinessPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBar"]: AliasType<{
	_meta?:ResolverInputTypes["StickyBarMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
	formButtonLabel?:boolean | `@${string}`,
jobsForm?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	formButtonLabel?:ResolverInputTypes["FieldMeta"],
	jobsForm?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBox"]: AliasType<{
	_meta?:ResolverInputTypes["InfoBoxMeta"],
	id?:boolean | `@${string}`,
	logoSize?:boolean | `@${string}`,
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
locales?: [{	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoBoxLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["InfoBoxLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null},ResolverInputTypes["InfoBoxLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoBoxLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	logoSize?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocale"]: AliasType<{
	_meta?:ResolverInputTypes["InfoBoxLocaleMeta"],
	id?:boolean | `@${string}`,
	address?:boolean | `@${string}`,
	web?:boolean | `@${string}`,
	instagram?:boolean | `@${string}`,
	facebook?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null},ResolverInputTypes["InfoBox"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
openingHours?: [{	filter?: ResolverInputTypes["TextListWhere"] | undefined | null},ResolverInputTypes["TextList"]],
	addressLink?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	address?:ResolverInputTypes["FieldMeta"],
	web?:ResolverInputTypes["FieldMeta"],
	instagram?:ResolverInputTypes["FieldMeta"],
	facebook?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	openingHours?:ResolverInputTypes["FieldMeta"],
	addressLink?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	address?: ResolverInputTypes["OrderDirection"] | undefined | null,
	web?: ResolverInputTypes["OrderDirection"] | undefined | null,
	instagram?: ResolverInputTypes["OrderDirection"] | undefined | null,
	facebook?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["InfoBoxOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	openingHours?: ResolverInputTypes["TextListOrderBy"] | undefined | null,
	addressLink?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["InfoBoxLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["InfoBoxLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["InfoBoxLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["InfoBoxLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocale"]: AliasType<{
	_meta?:ResolverInputTypes["JobPageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null},ResolverInputTypes["JobPage"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
keyInfo?: [{	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null},ResolverInputTypes["KeyInfoList"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
	email?:boolean | `@${string}`,
stickyBar?: [{	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null},ResolverInputTypes["StickyBar"]],
mobileImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	isSyncedToTabidoo?:boolean | `@${string}`,
	tabidooId?:boolean | `@${string}`,
	recruitisJobId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
	keyInfo?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	email?:ResolverInputTypes["FieldMeta"],
	stickyBar?:ResolverInputTypes["FieldMeta"],
	mobileImage?:ResolverInputTypes["FieldMeta"],
	isSyncedToTabidoo?:ResolverInputTypes["FieldMeta"],
	tabidooId?:ResolverInputTypes["FieldMeta"],
	recruitisJobId?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobPage"]: AliasType<{
	_meta?:ResolverInputTypes["JobPageMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPageLocale"]],
theme?: [{	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null},ResolverInputTypes["Theme"]],
contractType?: [{	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null},ResolverInputTypes["ContractType"]],
jobCity?: [{	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null},ResolverInputTypes["JobCity"]],
	isActive?:boolean | `@${string}`,
jobPosition?: [{	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null},ResolverInputTypes["JobPosition"]],
	publishedAt?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	isSyncedToTabidoo?:boolean | `@${string}`,
business?: [{	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null},ResolverInputTypes["BusinessPage"]],
	headerColor?:boolean | `@${string}`,
	siteType?:boolean | `@${string}`,
	isHiddenFromListing?:boolean | `@${string}`,
localesByLocale?: [{	by: ResolverInputTypes["JobPageLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
localesByImage?: [{	by: ResolverInputTypes["JobPageLocalesByImageUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
localesByKeyInfo?: [{	by: ResolverInputTypes["JobPageLocalesByKeyInfoUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
localesByContent?: [{	by: ResolverInputTypes["JobPageLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["JobPageLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
localesByLink?: [{	by: ResolverInputTypes["JobPageLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
localesByMobileImage?: [{	by: ResolverInputTypes["JobPageLocalesByMobileImageUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["JobPageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	theme?:ResolverInputTypes["FieldMeta"],
	contractType?:ResolverInputTypes["FieldMeta"],
	jobCity?:ResolverInputTypes["FieldMeta"],
	isActive?:ResolverInputTypes["FieldMeta"],
	jobPosition?:ResolverInputTypes["FieldMeta"],
	publishedAt?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	isSyncedToTabidoo?:ResolverInputTypes["FieldMeta"],
	business?:ResolverInputTypes["FieldMeta"],
	headerColor?:ResolverInputTypes["FieldMeta"],
	siteType?:ResolverInputTypes["FieldMeta"],
	isHiddenFromListing?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContractType"]: AliasType<{
	_meta?:ResolverInputTypes["ContractTypeMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContractTypeLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["ContractTypeLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null},ResolverInputTypes["ContractTypeLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContractTypeLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocale"]: AliasType<{
	_meta?:ResolverInputTypes["ContractTypeLocaleMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null},ResolverInputTypes["ContractType"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	slug?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["ContractTypeOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	slug?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ContractTypeLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["ContractTypeLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ContractTypeLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["ContractTypeLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobCity"]: AliasType<{
	_meta?:ResolverInputTypes["JobCityMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobCityLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["JobCityLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null},ResolverInputTypes["JobCityLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobCityLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["JobCityMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocale"]: AliasType<{
	_meta?:ResolverInputTypes["JobCityLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null},ResolverInputTypes["JobCity"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
	name?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	slug?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["JobCityOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	slug?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["JobCityLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["JobCityLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobCityLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["JobCityLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobPosition"]: AliasType<{
	_meta?:ResolverInputTypes["JobPositionMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPositionLocale"]],
jobs?: [{	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPage"]],
localesByLocale?: [{	by: ResolverInputTypes["JobPositionLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null},ResolverInputTypes["JobPositionLocale"]],
jobsByLocales?: [{	by: ResolverInputTypes["JobPositionJobsByLocalesUniqueWhere"],	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null},ResolverInputTypes["JobPage"]],
paginateLocales?: [{	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPositionLocaleConnection"]],
paginateJobs?: [{	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPageConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	jobs?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocale"]: AliasType<{
	_meta?:ResolverInputTypes["JobPositionLocaleMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null},ResolverInputTypes["JobPosition"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	slug?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["JobPositionOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	slug?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["JobPositionLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["JobPositionJobsByLocalesUniqueWhere"]: {
	locales?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null
};
	["JobPositionLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobPositionLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["JobPositionLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageEdge"]: AliasType<{
	node?:ResolverInputTypes["JobPage"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["JobPageLocalesByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["JobPageLocalesByKeyInfoUniqueWhere"]: {
	keyInfo?: ResolverInputTypes["KeyInfoListUniqueWhere"] | undefined | null
};
	["JobPageLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["JobPageLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["JobPageLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["JobPageLocalesByMobileImageUniqueWhere"]: {
	mobileImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["JobPageLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobPageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["JobPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoList"]: AliasType<{
	_meta?:ResolverInputTypes["KeyInfoListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["KeyInfoItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["KeyInfoItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["KeyInfoItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["KeyInfoItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItem"]: AliasType<{
	_meta?:ResolverInputTypes["KeyInfoItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	keyInfo?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null},ResolverInputTypes["KeyInfoList"]],
icon?: [{	filter?: ResolverInputTypes["IconWhere"] | undefined | null},ResolverInputTypes["Icon"]],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	keyInfo?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	icon?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Icon"]: AliasType<{
	_meta?:ResolverInputTypes["IconMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
icon?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["IconMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	icon?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	keyInfo?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["KeyInfoListOrderBy"] | undefined | null,
	icon?: ResolverInputTypes["IconOrderBy"] | undefined | null
};
	["IconOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	icon?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["KeyInfoItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["KeyInfoItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemEdge"]: AliasType<{
	node?:ResolverInputTypes["KeyInfoItem"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocale"]: AliasType<{
	_meta?:ResolverInputTypes["HomePageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null},ResolverInputTypes["HomePage"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
button?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
siteSwitcher?: [{	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null},ResolverInputTypes["SiteSwitcher"]],
gallery?: [{	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null},ResolverInputTypes["Gallery"]],
stickyBar?: [{	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null},ResolverInputTypes["StickyBar"]],
	text?:boolean | `@${string}`,
ilustration?: [{	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null},ResolverInputTypes["Gallery"]],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	button?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
	siteSwitcher?:ResolverInputTypes["FieldMeta"],
	gallery?:ResolverInputTypes["FieldMeta"],
	stickyBar?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	ilustration?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HomePage"]: AliasType<{
	_meta?:ResolverInputTypes["HomePageMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePageLocale"]],
theme?: [{	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null},ResolverInputTypes["Theme"]],
localesByLocale?: [{	by: ResolverInputTypes["HomePageLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
localesByButton?: [{	by: ResolverInputTypes["HomePageLocalesByButtonUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
localesByContent?: [{	by: ResolverInputTypes["HomePageLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["HomePageLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
localesByLink?: [{	by: ResolverInputTypes["HomePageLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
localesByLogo?: [{	by: ResolverInputTypes["HomePageLocalesByLogoUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
localesBySiteSwitcher?: [{	by: ResolverInputTypes["HomePageLocalesBySiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
localesByIlustration?: [{	by: ResolverInputTypes["HomePageLocalesByIlustrationUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HomePageMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	theme?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["HomePageLocalesByButtonUniqueWhere"]: {
	button?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["HomePageLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["HomePageLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["HomePageLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["HomePageLocalesByLogoUniqueWhere"]: {
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["HomePageLocalesBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ResolverInputTypes["SiteSwitcherUniqueWhere"] | undefined | null
};
	["HomePageLocalesByIlustrationUniqueWhere"]: {
	ilustration?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null
};
	["HomePageLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["HomePageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["HomePageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcher"]: AliasType<{
	_meta?:ResolverInputTypes["SiteSwitcherMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
theme?: [{	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null},ResolverInputTypes["Theme"]],
	headerColor?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	theme?:ResolverInputTypes["FieldMeta"],
	headerColor?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocale"]: AliasType<{
	_meta?:ResolverInputTypes["HomePageLokalLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null},ResolverInputTypes["HomePageLokal"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
button?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
content?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
link?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
siteSwitcher?: [{	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null},ResolverInputTypes["SiteSwitcher"]],
gallery?: [{	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null},ResolverInputTypes["Gallery"]],
stickyBar?: [{	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null},ResolverInputTypes["StickyBar"]],
	text?:boolean | `@${string}`,
ilustration?: [{	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null},ResolverInputTypes["Gallery"]],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
	button?:ResolverInputTypes["FieldMeta"],
	content?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
	siteSwitcher?:ResolverInputTypes["FieldMeta"],
	gallery?:ResolverInputTypes["FieldMeta"],
	stickyBar?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	ilustration?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokal"]: AliasType<{
	_meta?:ResolverInputTypes["HomePageLokalMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
theme?: [{	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null},ResolverInputTypes["Theme"]],
localesByLocale?: [{	by: ResolverInputTypes["HomePageLokalLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
localesByLogo?: [{	by: ResolverInputTypes["HomePageLokalLocalesByLogoUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
localesByButton?: [{	by: ResolverInputTypes["HomePageLokalLocalesByButtonUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
localesByContent?: [{	by: ResolverInputTypes["HomePageLokalLocalesByContentUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["HomePageLokalLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
localesByLink?: [{	by: ResolverInputTypes["HomePageLokalLocalesByLinkUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
localesBySiteSwitcher?: [{	by: ResolverInputTypes["HomePageLokalLocalesBySiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
localesByIlustration?: [{	by: ResolverInputTypes["HomePageLokalLocalesByIlustrationUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageLokalLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	theme?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["HomePageLokalLocalesByLogoUniqueWhere"]: {
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["HomePageLokalLocalesByButtonUniqueWhere"]: {
	button?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["HomePageLokalLocalesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["HomePageLokalLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["HomePageLokalLocalesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["HomePageLokalLocalesBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ResolverInputTypes["SiteSwitcherUniqueWhere"] | undefined | null
};
	["HomePageLokalLocalesByIlustrationUniqueWhere"]: {
	ilustration?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null
};
	["HomePageLokalLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["HomePageLokalLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["HomePageLokalLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null
};
	["RecommendationFormLocale"]: AliasType<{
	_meta?:ResolverInputTypes["RecommendationFormLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	subtitle?:boolean | `@${string}`,
	yourEmailLabel?:boolean | `@${string}`,
	theirEmailLabel?:boolean | `@${string}`,
	yourName?:boolean | `@${string}`,
	sendBtnLabel?:boolean | `@${string}`,
	successTitle?:boolean | `@${string}`,
	successSubtitle?:boolean | `@${string}`,
	successButtonClose?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null},ResolverInputTypes["RecommendationForm"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	subtitle?:ResolverInputTypes["FieldMeta"],
	yourEmailLabel?:ResolverInputTypes["FieldMeta"],
	theirEmailLabel?:ResolverInputTypes["FieldMeta"],
	yourName?:ResolverInputTypes["FieldMeta"],
	sendBtnLabel?:ResolverInputTypes["FieldMeta"],
	successTitle?:ResolverInputTypes["FieldMeta"],
	successSubtitle?:ResolverInputTypes["FieldMeta"],
	successButtonClose?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationForm"]: AliasType<{
	_meta?:ResolverInputTypes["RecommendationFormMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecommendationFormLocale"]],
successImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
localesByLocale?: [{	by: ResolverInputTypes["RecommendationFormLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null},ResolverInputTypes["RecommendationFormLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecommendationFormLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	successImage?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["RecommendationFormLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["RecommendationFormLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["RecommendationFormLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FooterLinkEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkEdge"]: AliasType<{
	node?:ResolverInputTypes["FooterLink"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocale"]: AliasType<{
	_meta?:ResolverInputTypes["HeaderLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null},ResolverInputTypes["Header"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
	menuLabel?:boolean | `@${string}`,
	menuTitle?:boolean | `@${string}`,
	menuText?:boolean | `@${string}`,
business?: [{	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Business"]],
lokalEnterprise?: [{	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Business"]],
	businessSectionTitle?:boolean | `@${string}`,
	lokalSectionTitle?:boolean | `@${string}`,
businessLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
lokalLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
paginateBusiness?: [{	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BusinessConnection"]],
paginateLokalEnterprise?: [{	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BusinessConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	menuLabel?:ResolverInputTypes["FieldMeta"],
	menuTitle?:ResolverInputTypes["FieldMeta"],
	menuText?:ResolverInputTypes["FieldMeta"],
	business?:ResolverInputTypes["FieldMeta"],
	lokalEnterprise?:ResolverInputTypes["FieldMeta"],
	businessSectionTitle?:ResolverInputTypes["FieldMeta"],
	lokalSectionTitle?:ResolverInputTypes["FieldMeta"],
	businessLink?:ResolverInputTypes["FieldMeta"],
	lokalLink?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Header"]: AliasType<{
	_meta?:ResolverInputTypes["HeaderMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeaderLocale"]],
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
logoMenu?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
localesByLocale?: [{	by: ResolverInputTypes["HeaderLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
localesByBusinessLink?: [{	by: ResolverInputTypes["HeaderLocalesByBusinessLinkUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
localesByLokalLink?: [{	by: ResolverInputTypes["HeaderLocalesByLokalLinkUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["HeaderMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
	logoMenu?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["HeaderOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	menuLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	menuTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	menuText?: ResolverInputTypes["OrderDirection"] | undefined | null,
	businessSectionTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	lokalSectionTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	businessLink?: ResolverInputTypes["LinkOrderBy"] | undefined | null,
	lokalLink?: ResolverInputTypes["LinkOrderBy"] | undefined | null
};
	["HeaderOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	logoMenu?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["HeaderLocalesByBusinessLinkUniqueWhere"]: {
	businessLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["HeaderLocalesByLokalLinkUniqueWhere"]: {
	lokalLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["HeaderLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["HeaderLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["HeaderLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Business"]: AliasType<{
	_meta?:ResolverInputTypes["BusinessMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null
};
	["BusinessConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["BusinessEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessEdge"]: AliasType<{
	node?:ResolverInputTypes["Business"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocale"]: AliasType<{
	_meta?:ResolverInputTypes["SeoDefaultLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null},ResolverInputTypes["SeoDefault"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
seo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	seo?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefault"]: AliasType<{
	_meta?:ResolverInputTypes["SeoDefaultMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SeoDefaultLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["SeoDefaultLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null},ResolverInputTypes["SeoDefaultLocale"]],
localesBySeo?: [{	by: ResolverInputTypes["SeoDefaultLocalesBySeoUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null},ResolverInputTypes["SeoDefaultLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SeoDefaultLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["SeoDefaultOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null
};
	["SeoDefaultOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["SeoDefaultLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["SeoDefaultLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["SeoDefaultLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["SeoDefaultLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["SeoDefaultLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocale"]: AliasType<{
	_meta?:ResolverInputTypes["JobsFilterLocaleMeta"],
	id?:boolean | `@${string}`,
	jobPositionLabel?:boolean | `@${string}`,
	jobContractLabel?:boolean | `@${string}`,
	jobCityLabel?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null},ResolverInputTypes["JobsFilter"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
	bannerTitle?:boolean | `@${string}`,
	bannerFormLabel?:boolean | `@${string}`,
bannerJobsForm?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
bannerImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	noJobTitle?:boolean | `@${string}`,
	noJobBtnLabel?:boolean | `@${string}`,
noJobImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
	noJobTitleForSpecificBusiness?:boolean | `@${string}`,
	deactivatedJob?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	jobPositionLabel?:ResolverInputTypes["FieldMeta"],
	jobContractLabel?:ResolverInputTypes["FieldMeta"],
	jobCityLabel?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
	bannerTitle?:ResolverInputTypes["FieldMeta"],
	bannerFormLabel?:ResolverInputTypes["FieldMeta"],
	bannerJobsForm?:ResolverInputTypes["FieldMeta"],
	bannerImage?:ResolverInputTypes["FieldMeta"],
	noJobTitle?:ResolverInputTypes["FieldMeta"],
	noJobBtnLabel?:ResolverInputTypes["FieldMeta"],
	noJobImage?:ResolverInputTypes["FieldMeta"],
	noJobTitleForSpecificBusiness?:ResolverInputTypes["FieldMeta"],
	deactivatedJob?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilter"]: AliasType<{
	_meta?:ResolverInputTypes["JobsFilterMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
localesByLocale?: [{	by: ResolverInputTypes["JobsFilterLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
localesByBannerJobsForm?: [{	by: ResolverInputTypes["JobsFilterLocalesByBannerJobsFormUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
localesByBannerImage?: [{	by: ResolverInputTypes["JobsFilterLocalesByBannerImageUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
localesByNoJobImage?: [{	by: ResolverInputTypes["JobsFilterLocalesByNoJobImageUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFilterLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	unique?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	jobPositionLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	jobContractLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	jobCityLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["JobsFilterOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	bannerTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	bannerFormLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	bannerJobsForm?: ResolverInputTypes["JobsFormLocaleOrderBy"] | undefined | null,
	bannerImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	noJobTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	noJobBtnLabel?: ResolverInputTypes["OrderDirection"] | undefined | null,
	noJobImage?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	noJobTitleForSpecificBusiness?: ResolverInputTypes["OrderDirection"] | undefined | null,
	deactivatedJob?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["JobsFilterOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["JobsFilterLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["JobsFilterLocalesByBannerJobsFormUniqueWhere"]: {
	bannerJobsForm?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null
};
	["JobsFilterLocalesByBannerImageUniqueWhere"]: {
	bannerImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["JobsFilterLocalesByNoJobImageUniqueWhere"]: {
	noJobImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["JobsFilterLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobsFilterLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["JobsFilterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["GeneralOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null,
	seo?: ResolverInputTypes["SeoOrderBy"] | undefined | null,
	cornerBanner?: ResolverInputTypes["CornerBannerOrderBy"] | undefined | null
};
	["GeneralOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	unique?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["CornerBannerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isActive?: ResolverInputTypes["OrderDirection"] | undefined | null,
	title?: ResolverInputTypes["OrderDirection"] | undefined | null,
	text?: ResolverInputTypes["OrderDirection"] | undefined | null,
	logo?: ResolverInputTypes["ImageOrderBy"] | undefined | null,
	link?: ResolverInputTypes["LinkOrderBy"] | undefined | null
};
	["TranslationLocale"]: AliasType<{
	_meta?:ResolverInputTypes["TranslationLocaleMeta"],
	id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
root?: [{	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null},ResolverInputTypes["Translation"]],
locale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	value?:ResolverInputTypes["FieldMeta"],
	root?:ResolverInputTypes["FieldMeta"],
	locale?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Translation"]: AliasType<{
	_meta?:ResolverInputTypes["TranslationMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
locales?: [{	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationLocale"]],
	isTextarea?:boolean | `@${string}`,
localesByLocale?: [{	by: ResolverInputTypes["TranslationLocalesByLocaleUniqueWhere"],	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null},ResolverInputTypes["TranslationLocale"]],
paginateLocales?: [{	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	key?:ResolverInputTypes["FieldMeta"],
	locales?:ResolverInputTypes["FieldMeta"],
	isTextarea?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	value?: ResolverInputTypes["OrderDirection"] | undefined | null,
	root?: ResolverInputTypes["TranslationOrderBy"] | undefined | null,
	locale?: ResolverInputTypes["LocaleOrderBy"] | undefined | null
};
	["TranslationOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	key?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isTextarea?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["TranslationLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["TranslationLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TranslationLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["TranslationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleFootersByRootUniqueWhere"]: {
	root?: ResolverInputTypes["FooterUniqueWhere"] | undefined | null
};
	["LocaleFootersByTermsAndConditionsUniqueWhere"]: {
	termsAndConditions?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleFootersByBannerImageUniqueWhere"]: {
	bannerImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleFootersByBannerLinkUniqueWhere"]: {
	bannerLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleFootersByJobsFormUniqueWhere"]: {
	jobsForm?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null
};
	["LocaleFootersByCopyrightLinkUniqueWhere"]: {
	copyrightLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleFootersByRecommendationFormUniqueWhere"]: {
	recommendationForm?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null
};
	["LocaleFootersByBannerSecondLinkUniqueWhere"]: {
	bannerSecondLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleFootersByInstagramLinkUniqueWhere"]: {
	instagramLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleGenericPagesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null
};
	["LocaleGenericPagesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleGenericPagesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleGenericPagesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocaleGenericPagesByLogoUniqueWhere"]: {
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleGenericPagesByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleHeadersByRootUniqueWhere"]: {
	root?: ResolverInputTypes["HeaderUniqueWhere"] | undefined | null
};
	["LocaleHeadersByBusinessLinkUniqueWhere"]: {
	businessLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleHeadersByLokalLinkUniqueWhere"]: {
	lokalLink?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleSeoDefaultsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["SeoDefaultUniqueWhere"] | undefined | null
};
	["LocaleSeoDefaultsBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleBusinessPagesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["BusinessPageUniqueWhere"] | undefined | null
};
	["LocaleBusinessPagesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleBusinessPagesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleBusinessPagesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocaleBusinessPagesByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleJobPagesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["JobPageUniqueWhere"] | undefined | null
};
	["LocaleJobPagesByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleJobPagesByKeyInfoUniqueWhere"]: {
	keyInfo?: ResolverInputTypes["KeyInfoListUniqueWhere"] | undefined | null
};
	["LocaleJobPagesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleJobPagesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleJobPagesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocaleJobPagesByMobileImageUniqueWhere"]: {
	mobileImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleContractTypesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["ContractTypeUniqueWhere"] | undefined | null
};
	["LocaleContractTypesBySlugUniqueWhere"]: {
	slug?: string | undefined | null
};
	["LocaleJobCitiesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["JobCityUniqueWhere"] | undefined | null
};
	["LocaleJobCitiesBySlugUniqueWhere"]: {
	slug?: string | undefined | null
};
	["LocaleJobPositionsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["JobPositionUniqueWhere"] | undefined | null
};
	["LocaleJobPositionsBySlugUniqueWhere"]: {
	slug?: string | undefined | null
};
	["LocaleHomePagesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["HomePageUniqueWhere"] | undefined | null
};
	["LocaleHomePagesByButtonUniqueWhere"]: {
	button?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleHomePagesByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleHomePagesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleHomePagesByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocaleHomePagesByLogoUniqueWhere"]: {
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleHomePagesBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ResolverInputTypes["SiteSwitcherUniqueWhere"] | undefined | null
};
	["LocaleHomePagesByIlustrationUniqueWhere"]: {
	ilustration?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null
};
	["LocaleBonusBannersByRootUniqueWhere"]: {
	root?: ResolverInputTypes["BonusBannerUniqueWhere"] | undefined | null
};
	["LocaleBonusBannersByTilesUniqueWhere"]: {
	tiles?: ResolverInputTypes["TileUniqueWhere"] | undefined | null
};
	["LocaleBonusBannersByLogoUniqueWhere"]: {
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleHomePageLokalsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["HomePageLokalUniqueWhere"] | undefined | null
};
	["LocaleHomePageLokalsByLogoUniqueWhere"]: {
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleHomePageLokalsByButtonUniqueWhere"]: {
	button?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["LocaleHomePageLokalsByContentUniqueWhere"]: {
	content?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleHomePageLokalsBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleHomePageLokalsByLinkUniqueWhere"]: {
	link?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocaleHomePageLokalsBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ResolverInputTypes["SiteSwitcherUniqueWhere"] | undefined | null
};
	["LocaleHomePageLokalsByIlustrationUniqueWhere"]: {
	ilustration?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null
};
	["LocaleJobsFormsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["JobsFormUniqueWhere"] | undefined | null
};
	["LocaleJobsFormsByImageTextListUniqueWhere"]: {
	imageTextList?: ResolverInputTypes["ImageTextListUniqueWhere"] | undefined | null
};
	["LocaleJobsFormsByLogoUniqueWhere"]: {
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleJobsFormsBySuccessImageUniqueWhere"]: {
	successImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleJobsFiltersByRootUniqueWhere"]: {
	root?: ResolverInputTypes["JobsFilterUniqueWhere"] | undefined | null
};
	["LocaleJobsFiltersByBannerJobsFormUniqueWhere"]: {
	bannerJobsForm?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null
};
	["LocaleJobsFiltersByBannerImageUniqueWhere"]: {
	bannerImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleJobsFiltersByNoJobImageUniqueWhere"]: {
	noJobImage?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["LocaleGeneralByRootUniqueWhere"]: {
	root?: ResolverInputTypes["GeneralUniqueWhere"] | undefined | null
};
	["LocaleGeneralBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleGeneralByCornerBannerUniqueWhere"]: {
	cornerBanner?: ResolverInputTypes["CornerBannerUniqueWhere"] | undefined | null
};
	["LocaleRecommendationFormsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["RecommendationFormUniqueWhere"] | undefined | null
};
	["LocaleInfoBoxesByRootUniqueWhere"]: {
	root?: ResolverInputTypes["InfoBoxUniqueWhere"] | undefined | null
};
	["LocaleTranslationsByRootUniqueWhere"]: {
	root?: ResolverInputTypes["TranslationUniqueWhere"] | undefined | null
};
	["GeneralLocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GeneralLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["GeneralLocale"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBanner"]: AliasType<{
	_meta?:ResolverInputTypes["CornerBannerMeta"],
	id?:boolean | `@${string}`,
	isActive?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
logo?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
link?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	isActive?:ResolverInputTypes["FieldMeta"],
	title?:ResolverInputTypes["FieldMeta"],
	text?:ResolverInputTypes["FieldMeta"],
	logo?:ResolverInputTypes["FieldMeta"],
	link?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocalesByLocaleUniqueWhere"]: {
	locale?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null
};
	["GeneralLocalesBySeoUniqueWhere"]: {
	seo?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null
};
	["GeneralLocalesByCornerBannerUniqueWhere"]: {
	cornerBanner?: ResolverInputTypes["CornerBannerUniqueWhere"] | undefined | null
};
	["GeneralConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GeneralEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralEdge"]: AliasType<{
	node?:ResolverInputTypes["General"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidationResult"]: AliasType<{
	valid?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_ValidationError"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidationError"]: AliasType<{
	path?:ResolverInputTypes["_PathFragment"],
	message?:ResolverInputTypes["_ValidationMessage"],
		__typename?: boolean | `@${string}`
}>;
	["_PathFragment"]: AliasType<{
	_FieldPathFragment?:ResolverInputTypes["_FieldPathFragment"],
	_IndexPathFragment?:ResolverInputTypes["_IndexPathFragment"],
		__typename?: boolean | `@${string}`
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:boolean | `@${string}`,
	alias?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_ValidationMessage"]: AliasType<{
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GeneralCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["GeneralCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GeneralLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GeneralLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null,
	cornerBanner?: ResolverInputTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGeneralCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutGeneralCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateFootersEntityRelationInput"]: {
	connect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateFootersRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	email?: string | undefined | null,
	address?: string | undefined | null,
	ico?: string | undefined | null,
	dic?: string | undefined | null,
	copyright?: string | undefined | null,
	note?: string | undefined | null,
	noteSecond?: string | undefined | null,
	root?: ResolverInputTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined | null,
	linksFirstColumn?: Array<ResolverInputTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined | null,
	linksSecondColumn?: Array<ResolverInputTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined | null,
	termsAndConditions?: ResolverInputTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined | null,
	form?: string | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerSubtitle?: string | undefined | null,
	bannerImage?: ResolverInputTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined | null,
	bannerLink?: ResolverInputTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined | null,
	jobsForm?: ResolverInputTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined | null,
	copyrightLink?: ResolverInputTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined | null,
	bannerSecondBtn?: string | undefined | null,
	recommendationForm?: ResolverInputTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined | null,
	bannerSecondLink?: ResolverInputTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined | null,
	instagramLink?: ResolverInputTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["FooterUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FooterWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["FooterWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["FooterUniqueWhere"],
	create: ResolverInputTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]: {
	connect?: ResolverInputTypes["FooterLinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FooterLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FooterLinkUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["FooterLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	link?: ResolverInputTypes["FooterLinkCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLinkCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLinkConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["LinkType"] | undefined | null,
	title?: string | undefined | null,
	externalLink?: string | undefined | null,
	internalLink?: ResolverInputTypes["LinkCreateInternalLinkEntityRelationInput"] | undefined | null,
	anchorLink?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined | null
};
	["LinkableCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateRedirectEntityRelationInput"]: {
	connect?: ResolverInputTypes["RedirectUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RedirectWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateRedirectRelationInput"] | undefined | null
};
	["RedirectWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	target?: ResolverInputTypes["RedirectCreateTargetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectCreateTargetEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RedirectConnectOrCreateTargetRelationInput"] | undefined | null
};
	["RedirectConnectOrCreateTargetRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["LinkableConnectOrCreateRedirectRelationInput"]: {
	connect: ResolverInputTypes["RedirectUniqueWhere"],
	create: ResolverInputTypes["RedirectWithoutLinkCreateInput"]
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined | null
};
	["GenericPageLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	logo?: ResolverInputTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["GenericPageWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	theme?: ResolverInputTypes["GenericPageCreateThemeEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageCreateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageConnectOrCreateThemeRelationInput"] | undefined | null
};
	["ThemeCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	backgroundColor?: string | undefined | null,
	textColor?: string | undefined | null,
	name?: string | undefined | null,
	buttonBackgroundColor?: string | undefined | null,
	buttonTextColor?: string | undefined | null,
	buttonBackgroundHoverColor?: string | undefined | null,
	buttonTextHoverColor?: string | undefined | null,
	buttonBorderColor?: string | undefined | null,
	buttonBorderHoverColor?: string | undefined | null,
	headerMenuColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageConnectOrCreateThemeRelationInput"]: {
	connect: ResolverInputTypes["ThemeUniqueWhere"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["GenericPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["GenericPageUniqueWhere"],
	create: ResolverInputTypes["GenericPageWithoutLocalesCreateInput"]
};
	["GenericPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGenericPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutGenericPagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateHeadersEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateHeadersRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined | null,
	menuLabel?: string | undefined | null,
	menuTitle?: string | undefined | null,
	menuText?: string | undefined | null,
	business?: Array<ResolverInputTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined | null,
	lokalEnterprise?: Array<ResolverInputTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined | null,
	businessSectionTitle?: string | undefined | null,
	lokalSectionTitle?: string | undefined | null,
	businessLink?: ResolverInputTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined | null,
	lokalLink?: ResolverInputTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeaderUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeaderWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["HeaderWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	logo?: ResolverInputTypes["HeaderCreateLogoEntityRelationInput"] | undefined | null,
	logoMenu?: ResolverInputTypes["HeaderCreateLogoMenuEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined | null
};
	["ImageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	alt?: string | undefined | null,
	fileName?: string | undefined | null,
	focalPointX?: number | undefined | null,
	focalPointY?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["HeaderCreateLogoMenuEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderConnectOrCreateLogoMenuRelationInput"] | undefined | null
};
	["HeaderConnectOrCreateLogoMenuRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["HeaderLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["HeaderUniqueWhere"],
	create: ResolverInputTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleCreateBusinessEntityRelationInput"]: {
	connect?: ResolverInputTypes["BusinessUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BusinessCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateBusinessRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	logo?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["BusinessCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	logo?: ResolverInputTypes["BusinessCreateLogoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["BusinessCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessConnectOrCreateLogoRelationInput"] | undefined | null
};
	["BusinessConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["BusinessCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessConnectOrCreateLinkRelationInput"] | undefined | null
};
	["BusinessConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["HeaderLocaleConnectOrCreateBusinessRelationInput"]: {
	connect: ResolverInputTypes["BusinessUniqueWhere"],
	create: ResolverInputTypes["BusinessCreateInput"]
};
	["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]: {
	connect?: ResolverInputTypes["BusinessUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BusinessCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"]: {
	connect: ResolverInputTypes["BusinessUniqueWhere"],
	create: ResolverInputTypes["BusinessCreateInput"]
};
	["HeaderLocaleCreateBusinessLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"] | undefined | null
};
	["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["HeaderLocaleCreateLokalLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateLokalLinkRelationInput"] | undefined | null
};
	["HeaderLocaleConnectOrCreateLokalLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["LocaleConnectOrCreateHeadersRelationInput"]: {
	connect: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	create: ResolverInputTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateSeoDefaultsEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateSeoDefaultsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SeoDefaultLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["SeoDefaultLocaleCreateRootEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoDefaultUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoDefaultWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoDefaultLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["SeoDefaultWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["SeoDefaultUniqueWhere"],
	create: ResolverInputTypes["SeoDefaultWithoutLocalesCreateInput"]
};
	["SeoDefaultLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoDefaultLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["SeoCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	ogTitle?: string | undefined | null,
	ogDescription?: string | undefined | null,
	noIndex?: boolean | undefined | null,
	noFollow?: boolean | undefined | null,
	ogImage?: ResolverInputTypes["SeoCreateOgImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined | null
};
	["SeoConnectOrCreateOgImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["SeoDefaultLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["LocaleConnectOrCreateSeoDefaultsRelationInput"]: {
	connect: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],
	create: ResolverInputTypes["SeoDefaultLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateBusinessPagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BusinessPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateBusinessPagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessPageLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	text?: string | undefined | null,
	name?: string | undefined | null,
	image?: ResolverInputTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	infoBox?: ResolverInputTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["BusinessPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BusinessPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["BusinessPageWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	theme?: ResolverInputTypes["BusinessPageCreateThemeEntityRelationInput"] | undefined | null,
	isLokal?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	headerColor?: string | undefined | null,
	recruitisOfficeId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageCreateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageConnectOrCreateThemeRelationInput"] | undefined | null
};
	["BusinessPageConnectOrCreateThemeRelationInput"]: {
	connect: ResolverInputTypes["ThemeUniqueWhere"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["BusinessPageUniqueWhere"],
	create: ResolverInputTypes["BusinessPageWithoutLocalesCreateInput"]
};
	["BusinessPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["ContentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	blocks?: Array<ResolverInputTypes["ContentCreateBlocksEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentBlockWithoutContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentConnectOrCreateBlocksRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	json?: string | undefined | null,
	references?: Array<ResolverInputTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentBlockConnectOrCreateReferencesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	image?: ResolverInputTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined | null,
	linkables?: Array<ResolverInputTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined | null,
	secondaryText?: string | undefined | null,
	link?: ResolverInputTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined | null,
	textList?: ResolverInputTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined | null,
	carousel?: ResolverInputTypes["ContentReferenceCreateCarouselEntityRelationInput"] | undefined | null,
	bonusBanner?: ResolverInputTypes["ContentReferenceCreateBonusBannerEntityRelationInput"] | undefined | null,
	sideBySide?: ResolverInputTypes["ContentReferenceCreateSideBySideEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined | null,
	showBoolean?: boolean | undefined | null,
	isRed?: boolean | undefined | null,
	video?: ResolverInputTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined | null
};
	["ContentReferenceConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ContentReferenceCreateLinkablesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined | null
};
	["ContentReferenceConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["ContentReferenceCreateMediaEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined | null
};
	["MediumListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["MediumListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["MediumItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	medium?: ResolverInputTypes["MediumItemCreateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemCreateMediumEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined | null
};
	["MediumUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["MediumCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["MediumType"] | undefined | null,
	image?: ResolverInputTypes["MediumCreateImageEntityRelationInput"] | undefined | null,
	video?: ResolverInputTypes["MediumCreateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumConnectOrCreateImageRelationInput"] | undefined | null
};
	["MediumConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["MediumCreateVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumConnectOrCreateVideoRelationInput"] | undefined | null
};
	["VideoCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	src?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	videoInfo?: string | undefined | null,
	duration?: number | undefined | null,
	poster?: ResolverInputTypes["VideoCreatePosterEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["VideoConnectOrCreatePosterRelationInput"] | undefined | null
};
	["VideoConnectOrCreatePosterRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["MediumConnectOrCreateVideoRelationInput"]: {
	connect: ResolverInputTypes["VideoUniqueWhere"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["MediumItemConnectOrCreateMediumRelationInput"]: {
	connect: ResolverInputTypes["MediumUniqueWhere"],
	create: ResolverInputTypes["MediumCreateInput"]
};
	["MediumListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["MediumItemUniqueWhere"],
	create: ResolverInputTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateMediaRelationInput"]: {
	connect: ResolverInputTypes["MediumListUniqueWhere"],
	create: ResolverInputTypes["MediumListCreateInput"]
};
	["ContentReferenceCreateTextListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateTextListRelationInput"] | undefined | null
};
	["TextListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["TextItemUniqueWhere"] | undefined | null
};
	["TextItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["TextListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["TextListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TextListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TextItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	text?: string | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["TextItemUniqueWhere"],
	create: ResolverInputTypes["TextItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateTextListRelationInput"]: {
	connect: ResolverInputTypes["TextListUniqueWhere"],
	create: ResolverInputTypes["TextListCreateInput"]
};
	["ContentReferenceCreateCarouselEntityRelationInput"]: {
	connect?: ResolverInputTypes["CarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CarouselCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateCarouselRelationInput"] | undefined | null
};
	["CarouselUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["CarouselItemUniqueWhere"] | undefined | null
};
	["CarouselItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	linkUrl?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	video?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null
};
	["CarouselCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["CarouselCreateItemsEntityRelationInput"]> | undefined | null,
	background?: ResolverInputTypes["Background"] | undefined | null,
	squareImages?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CarouselCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["CarouselItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CarouselItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CarouselConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CarouselItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	text?: string | undefined | null,
	image?: ResolverInputTypes["CarouselItemCreateImageEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	title?: string | undefined | null,
	linkUrl?: ResolverInputTypes["CarouselItemCreateLinkUrlEntityRelationInput"] | undefined | null,
	normalAspectRatio?: boolean | undefined | null,
	isImage?: boolean | undefined | null,
	video?: ResolverInputTypes["CarouselItemCreateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CarouselItemCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CarouselItemConnectOrCreateImageRelationInput"] | undefined | null
};
	["CarouselItemConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["CarouselItemCreateLinkUrlEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CarouselItemConnectOrCreateLinkUrlRelationInput"] | undefined | null
};
	["CarouselItemConnectOrCreateLinkUrlRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["CarouselItemCreateVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CarouselItemConnectOrCreateVideoRelationInput"] | undefined | null
};
	["CarouselItemConnectOrCreateVideoRelationInput"]: {
	connect: ResolverInputTypes["VideoUniqueWhere"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["CarouselConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["CarouselItemUniqueWhere"],
	create: ResolverInputTypes["CarouselItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateCarouselRelationInput"]: {
	connect: ResolverInputTypes["CarouselUniqueWhere"],
	create: ResolverInputTypes["CarouselCreateInput"]
};
	["ContentReferenceCreateBonusBannerEntityRelationInput"]: {
	connect?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BonusBannerLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateBonusBannerRelationInput"] | undefined | null
};
	["BonusBannerLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	tiles?: Array<ResolverInputTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined | null,
	logo?: ResolverInputTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined | null,
	bannerName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BonusBannerLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["BonusBannerUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BonusBannerWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BonusBannerLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["BonusBannerWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BonusBannerLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["BonusBannerUniqueWhere"],
	create: ResolverInputTypes["BonusBannerWithoutLocalesCreateInput"]
};
	["BonusBannerLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutBonusBannersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BonusBannerLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutBonusBannersCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateGenericPagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateGenericPagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	logo?: ResolverInputTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["GenericPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["GenericPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["GenericPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["GenericPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutGenericPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutGenericPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateBusinessPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BusinessPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateBusinessPageRelationInput"] | undefined | null
};
	["BusinessPageLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	text?: string | undefined | null,
	name?: string | undefined | null,
	image?: ResolverInputTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	infoBox?: ResolverInputTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutBusinessPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutBusinessPagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateJobPagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateJobPagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobPageLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	keyInfo?: ResolverInputTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	stickyBar?: ResolverInputTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	mobileImage?: ResolverInputTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	recruitisJobId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["JobPageWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	theme?: ResolverInputTypes["JobPageCreateThemeEntityRelationInput"] | undefined | null,
	contractType?: ResolverInputTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined | null,
	jobCity?: ResolverInputTypes["JobPageCreateJobCityEntityRelationInput"] | undefined | null,
	isActive?: boolean | undefined | null,
	jobPosition?: ResolverInputTypes["JobPageCreateJobPositionEntityRelationInput"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	order?: number | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	business?: ResolverInputTypes["JobPageCreateBusinessEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	siteType?: ResolverInputTypes["SiteType"] | undefined | null,
	isHiddenFromListing?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageCreateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateThemeRelationInput"] | undefined | null
};
	["JobPageConnectOrCreateThemeRelationInput"]: {
	connect: ResolverInputTypes["ThemeUniqueWhere"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["JobPageCreateContractTypeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContractTypeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContractTypeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateContractTypeRelationInput"] | undefined | null
};
	["ContractTypeCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["ContractTypeCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContractTypeCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContractTypeLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContractTypeLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContractTypeConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ContractTypeLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: string | undefined | null,
	locale?: ResolverInputTypes["ContractTypeLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContractTypeLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutContractTypesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContractTypeLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutContractTypesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateJobCitiesEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobCityLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobCityLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateJobCitiesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobCityLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["JobCityLocaleCreateRootEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobCityUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobCityWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobCityLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["JobCityWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["JobCityUniqueWhere"],
	create: ResolverInputTypes["JobCityWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateJobCitiesRelationInput"]: {
	connect: ResolverInputTypes["JobCityLocaleUniqueWhere"],
	create: ResolverInputTypes["JobCityLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateJobPositionsEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPositionLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPositionLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateJobPositionsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobPositionLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: string | undefined | null,
	root?: ResolverInputTypes["JobPositionLocaleCreateRootEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPositionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPositionWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPositionLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["JobPositionWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	jobs?: Array<ResolverInputTypes["JobPositionCreateJobsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionCreateJobsEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPageWithoutJobPositionCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPositionConnectOrCreateJobsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobPageWithoutJobPositionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["JobPageCreateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["JobPageCreateThemeEntityRelationInput"] | undefined | null,
	contractType?: ResolverInputTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined | null,
	jobCity?: ResolverInputTypes["JobPageCreateJobCityEntityRelationInput"] | undefined | null,
	isActive?: boolean | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	order?: number | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	business?: ResolverInputTypes["JobPageCreateBusinessEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	siteType?: ResolverInputTypes["SiteType"] | undefined | null,
	isHiddenFromListing?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPageLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobPageLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	locale?: ResolverInputTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	keyInfo?: ResolverInputTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	stickyBar?: ResolverInputTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	mobileImage?: ResolverInputTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	recruitisJobId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutJobPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutJobPagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateContractTypesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContractTypeLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContractTypeLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateContractTypesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ContractTypeLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: string | undefined | null,
	root?: ResolverInputTypes["ContractTypeLocaleCreateRootEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContractTypeLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContractTypeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContractTypeWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContractTypeLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["ContractTypeWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContractTypeLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["ContractTypeUniqueWhere"],
	create: ResolverInputTypes["ContractTypeWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateContractTypesRelationInput"]: {
	connect: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],
	create: ResolverInputTypes["ContractTypeLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateHomePagesEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateHomePagesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HomePageLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["HomePageWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	theme?: ResolverInputTypes["HomePageCreateThemeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageCreateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageConnectOrCreateThemeRelationInput"] | undefined | null
};
	["HomePageConnectOrCreateThemeRelationInput"]: {
	connect: ResolverInputTypes["ThemeUniqueWhere"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["HomePageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["HomePageUniqueWhere"],
	create: ResolverInputTypes["HomePageWithoutLocalesCreateInput"]
};
	["HomePageLocaleCreateButtonEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateButtonRelationInput"] | undefined | null
};
	["HomePageLocaleConnectOrCreateButtonRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["HomePageLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["HomePageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["HomePageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["HomePageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["HomePageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutHomePageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutHomePageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateJobPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateJobPageRelationInput"] | undefined | null
};
	["JobPageLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	keyInfo?: ResolverInputTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	stickyBar?: ResolverInputTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	mobileImage?: ResolverInputTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	recruitisJobId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageLocaleCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateImageRelationInput"] | undefined | null
};
	["JobPageLocaleConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["JobPageLocaleCreateKeyInfoEntityRelationInput"]: {
	connect?: ResolverInputTypes["KeyInfoListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["KeyInfoListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateKeyInfoRelationInput"] | undefined | null
};
	["KeyInfoListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["KeyInfoListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["KeyInfoListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["KeyInfoItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["KeyInfoItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["KeyInfoListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["KeyInfoItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	keyInfo?: string | undefined | null,
	icon?: ResolverInputTypes["KeyInfoItemCreateIconEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["KeyInfoItemCreateIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["IconUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["IconCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["KeyInfoItemConnectOrCreateIconRelationInput"] | undefined | null
};
	["IconUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	icon?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["IconCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	icon?: ResolverInputTypes["IconCreateIconEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IconCreateIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["IconConnectOrCreateIconRelationInput"] | undefined | null
};
	["IconConnectOrCreateIconRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["KeyInfoItemConnectOrCreateIconRelationInput"]: {
	connect: ResolverInputTypes["IconUniqueWhere"],
	create: ResolverInputTypes["IconCreateInput"]
};
	["KeyInfoListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["KeyInfoItemUniqueWhere"],
	create: ResolverInputTypes["KeyInfoItemWithoutListCreateInput"]
};
	["JobPageLocaleConnectOrCreateKeyInfoRelationInput"]: {
	connect: ResolverInputTypes["KeyInfoListUniqueWhere"],
	create: ResolverInputTypes["KeyInfoListCreateInput"]
};
	["JobPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["JobPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["JobPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["JobPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["JobPageLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ResolverInputTypes["StickyBarUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StickyBarCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null
};
	["StickyBarUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	link?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null
};
	["StickyBarCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	link?: ResolverInputTypes["StickyBarCreateLinkEntityRelationInput"] | undefined | null,
	formButtonLabel?: string | undefined | null,
	jobsForm?: ResolverInputTypes["StickyBarCreateJobsFormEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StickyBarCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StickyBarConnectOrCreateLinkRelationInput"] | undefined | null
};
	["StickyBarConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["StickyBarCreateJobsFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StickyBarConnectOrCreateJobsFormRelationInput"] | undefined | null
};
	["JobsFormLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	jobText?: string | undefined | null,
	genericText?: string | undefined | null,
	nameLabel?: string | undefined | null,
	emailLabel?: string | undefined | null,
	telefonLabel?: string | undefined | null,
	fileTitleLabel?: string | undefined | null,
	fileFormatLabel?: string | undefined | null,
	formTextLabel?: string | undefined | null,
	submitLabel?: string | undefined | null,
	root?: ResolverInputTypes["JobsFormLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobsFormLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	imageTextList?: ResolverInputTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined | null,
	minimalize?: string | undefined | null,
	logo?: ResolverInputTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined | null,
	successTitle?: string | undefined | null,
	successText?: string | undefined | null,
	successBtnLabel?: string | undefined | null,
	successImage?: ResolverInputTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined | null,
	successOtherJobsTitle?: string | undefined | null,
	successOtherJobsCategoryTitle?: string | undefined | null,
	successOtherJobsButtonTitle?: string | undefined | null,
	successOtherJobsSelectionTitle?: string | undefined | null,
	successOtherJobsSelectionYesButton?: string | undefined | null,
	successOtherJobsSelectionNoButton?: string | undefined | null,
	fileRemoveBtnLabel?: string | undefined | null,
	gdprLabel?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFormLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["JobsFormWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	fileIlustration?: ResolverInputTypes["JobsFormCreateFileIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFormCreateFileIlustrationEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormConnectOrCreateFileIlustrationRelationInput"] | undefined | null
};
	["JobsFormConnectOrCreateFileIlustrationRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["JobsFormLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["JobsFormUniqueWhere"],
	create: ResolverInputTypes["JobsFormWithoutLocalesCreateInput"]
};
	["JobsFormLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutJobsFormsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutJobsFormsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateBonusBannersEntityRelationInput"]: {
	connect?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BonusBannerLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateBonusBannersRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BonusBannerLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined | null,
	tiles?: Array<ResolverInputTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined | null,
	logo?: ResolverInputTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined | null,
	bannerName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BonusBannerLocaleCreateTilesEntityRelationInput"]: {
	connect?: ResolverInputTypes["TileUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TileWithoutBonusBannerCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BonusBannerLocaleConnectOrCreateTilesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TileWithoutBonusBannerCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	text?: string | undefined | null,
	image?: ResolverInputTypes["TileCreateImageEntityRelationInput"] | undefined | null,
	lightBoxTitle?: string | undefined | null,
	lightBoxText?: string | undefined | null,
	ligthBoxMedia?: ResolverInputTypes["TileCreateLigthBoxMediaEntityRelationInput"] | undefined | null,
	lightBoxSectionTitle?: string | undefined | null,
	title?: string | undefined | null,
	lightBoxLinkLabel?: string | undefined | null,
	lightBoxForm?: ResolverInputTypes["TileCreateLightBoxFormEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileConnectOrCreateImageRelationInput"] | undefined | null
};
	["TileConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["TileCreateLigthBoxMediaEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileConnectOrCreateLigthBoxMediaRelationInput"] | undefined | null
};
	["TileConnectOrCreateLigthBoxMediaRelationInput"]: {
	connect: ResolverInputTypes["MediumListUniqueWhere"],
	create: ResolverInputTypes["MediumListCreateInput"]
};
	["TileCreateLightBoxFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileConnectOrCreateLightBoxFormRelationInput"] | undefined | null
};
	["TileConnectOrCreateLightBoxFormRelationInput"]: {
	connect: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	create: ResolverInputTypes["JobsFormLocaleCreateInput"]
};
	["BonusBannerLocaleConnectOrCreateTilesRelationInput"]: {
	connect: ResolverInputTypes["TileUniqueWhere"],
	create: ResolverInputTypes["TileWithoutBonusBannerCreateInput"]
};
	["BonusBannerLocaleCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BonusBannerLocaleConnectOrCreateLogoRelationInput"] | undefined | null
};
	["BonusBannerLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateBonusBannersRelationInput"]: {
	connect: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],
	create: ResolverInputTypes["BonusBannerLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateHomePageLokalsEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageLokalLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateHomePageLokalsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HomePageLokalLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageLokalUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageLokalWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["HomePageLokalWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	theme?: ResolverInputTypes["HomePageLokalCreateThemeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalCreateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalConnectOrCreateThemeRelationInput"] | undefined | null
};
	["HomePageLokalConnectOrCreateThemeRelationInput"]: {
	connect: ResolverInputTypes["ThemeUniqueWhere"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["HomePageLokalLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["HomePageLokalUniqueWhere"],
	create: ResolverInputTypes["HomePageLokalWithoutLocalesCreateInput"]
};
	["HomePageLokalLocaleCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateLogoRelationInput"] | undefined | null
};
	["HomePageLokalLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["HomePageLokalLocaleCreateButtonEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateButtonRelationInput"] | undefined | null
};
	["HomePageLokalLocaleConnectOrCreateButtonRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["HomePageLokalLocaleCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateContentRelationInput"] | undefined | null
};
	["HomePageLokalLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["HomePageLokalLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["HomePageLokalLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["HomePageLokalLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutHomePageLokalCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutHomePageLokalCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateHomePageEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateHomePageRelationInput"] | undefined | null
};
	["HomePageLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutHomePagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutHomePagesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateJobsFormsEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateJobsFormsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobsFormLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	jobText?: string | undefined | null,
	genericText?: string | undefined | null,
	nameLabel?: string | undefined | null,
	emailLabel?: string | undefined | null,
	telefonLabel?: string | undefined | null,
	fileTitleLabel?: string | undefined | null,
	fileFormatLabel?: string | undefined | null,
	formTextLabel?: string | undefined | null,
	submitLabel?: string | undefined | null,
	root?: ResolverInputTypes["JobsFormLocaleCreateRootEntityRelationInput"] | undefined | null,
	imageTextList?: ResolverInputTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined | null,
	minimalize?: string | undefined | null,
	logo?: ResolverInputTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined | null,
	successTitle?: string | undefined | null,
	successText?: string | undefined | null,
	successBtnLabel?: string | undefined | null,
	successImage?: ResolverInputTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined | null,
	successOtherJobsTitle?: string | undefined | null,
	successOtherJobsCategoryTitle?: string | undefined | null,
	successOtherJobsButtonTitle?: string | undefined | null,
	successOtherJobsSelectionTitle?: string | undefined | null,
	successOtherJobsSelectionYesButton?: string | undefined | null,
	successOtherJobsSelectionNoButton?: string | undefined | null,
	fileRemoveBtnLabel?: string | undefined | null,
	gdprLabel?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFormLocaleCreateImageTextListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageTextListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageTextListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormLocaleConnectOrCreateImageTextListRelationInput"] | undefined | null
};
	["ImageTextListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["ImageTextListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageTextListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageTextItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageTextItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageTextListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ImageTextItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	image?: ResolverInputTypes["ImageTextItemCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageTextItemCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageTextItemConnectOrCreateImageRelationInput"] | undefined | null
};
	["ImageTextItemConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ImageTextListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["ImageTextItemUniqueWhere"],
	create: ResolverInputTypes["ImageTextItemWithoutListCreateInput"]
};
	["JobsFormLocaleConnectOrCreateImageTextListRelationInput"]: {
	connect: ResolverInputTypes["ImageTextListUniqueWhere"],
	create: ResolverInputTypes["ImageTextListCreateInput"]
};
	["JobsFormLocaleCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormLocaleConnectOrCreateLogoRelationInput"] | undefined | null
};
	["JobsFormLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["JobsFormLocaleCreateSuccessImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"] | undefined | null
};
	["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateJobsFormsRelationInput"]: {
	connect: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	create: ResolverInputTypes["JobsFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateJobsFiltersEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFilterLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFilterLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateJobsFiltersRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobsFilterLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	jobPositionLabel?: string | undefined | null,
	jobContractLabel?: string | undefined | null,
	jobCityLabel?: string | undefined | null,
	root?: ResolverInputTypes["JobsFilterLocaleCreateRootEntityRelationInput"] | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerFormLabel?: string | undefined | null,
	bannerJobsForm?: ResolverInputTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined | null,
	bannerImage?: ResolverInputTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined | null,
	noJobTitle?: string | undefined | null,
	noJobBtnLabel?: string | undefined | null,
	noJobImage?: ResolverInputTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined | null,
	noJobTitleForSpecificBusiness?: string | undefined | null,
	deactivatedJob?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFilterUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFilterWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["JobsFilterWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["JobsFilterUniqueWhere"],
	create: ResolverInputTypes["JobsFilterWithoutLocalesCreateInput"]
};
	["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"] | undefined | null
};
	["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"]: {
	connect: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	create: ResolverInputTypes["JobsFormLocaleCreateInput"]
};
	["JobsFilterLocaleCreateBannerImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"] | undefined | null
};
	["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["JobsFilterLocaleCreateNoJobImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"] | undefined | null
};
	["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateJobsFiltersRelationInput"]: {
	connect: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],
	create: ResolverInputTypes["JobsFilterLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateGeneralEntityRelationInput"]: {
	connect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateGeneralRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GeneralLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null,
	cornerBanner?: ResolverInputTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GeneralUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GeneralWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["GeneralWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["GeneralUniqueWhere"],
	create: ResolverInputTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["GeneralLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["GeneralLocaleCreateCornerBannerEntityRelationInput"]: {
	connect?: ResolverInputTypes["CornerBannerUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CornerBannerCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateCornerBannerRelationInput"] | undefined | null
};
	["CornerBannerCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	isActive?: boolean | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	logo?: ResolverInputTypes["CornerBannerCreateLogoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["CornerBannerCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CornerBannerCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CornerBannerConnectOrCreateLogoRelationInput"] | undefined | null
};
	["CornerBannerConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["CornerBannerCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CornerBannerConnectOrCreateLinkRelationInput"] | undefined | null
};
	["CornerBannerConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["GeneralLocaleConnectOrCreateCornerBannerRelationInput"]: {
	connect: ResolverInputTypes["CornerBannerUniqueWhere"],
	create: ResolverInputTypes["CornerBannerCreateInput"]
};
	["LocaleConnectOrCreateGeneralRelationInput"]: {
	connect: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	create: ResolverInputTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateRecommendationFormsEntityRelationInput"]: {
	connect?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RecommendationFormLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateRecommendationFormsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["RecommendationFormLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	yourEmailLabel?: string | undefined | null,
	theirEmailLabel?: string | undefined | null,
	yourName?: string | undefined | null,
	sendBtnLabel?: string | undefined | null,
	successTitle?: string | undefined | null,
	successSubtitle?: string | undefined | null,
	successButtonClose?: string | undefined | null,
	root?: ResolverInputTypes["RecommendationFormLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["RecommendationFormUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RecommendationFormWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecommendationFormLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["RecommendationFormWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	successImage?: ResolverInputTypes["RecommendationFormCreateSuccessImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormCreateSuccessImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecommendationFormConnectOrCreateSuccessImageRelationInput"] | undefined | null
};
	["RecommendationFormConnectOrCreateSuccessImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["RecommendationFormLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["RecommendationFormUniqueWhere"],
	create: ResolverInputTypes["RecommendationFormWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateRecommendationFormsRelationInput"]: {
	connect: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],
	create: ResolverInputTypes["RecommendationFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateInfoBoxesEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoBoxLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoBoxLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateInfoBoxesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["InfoBoxLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	address?: string | undefined | null,
	web?: string | undefined | null,
	instagram?: string | undefined | null,
	facebook?: string | undefined | null,
	root?: ResolverInputTypes["InfoBoxLocaleCreateRootEntityRelationInput"] | undefined | null,
	openingHours?: ResolverInputTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined | null,
	addressLink?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoBoxUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoBoxWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoBoxLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["InfoBoxWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	logoSize?: ResolverInputTypes["LogoSize"] | undefined | null,
	logo?: ResolverInputTypes["InfoBoxCreateLogoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoBoxConnectOrCreateLogoRelationInput"] | undefined | null
};
	["InfoBoxConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["InfoBoxLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["InfoBoxUniqueWhere"],
	create: ResolverInputTypes["InfoBoxWithoutLocalesCreateInput"]
};
	["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"] | undefined | null
};
	["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"]: {
	connect: ResolverInputTypes["TextListUniqueWhere"],
	create: ResolverInputTypes["TextListCreateInput"]
};
	["LocaleConnectOrCreateInfoBoxesRelationInput"]: {
	connect: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],
	create: ResolverInputTypes["InfoBoxLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateTranslationsEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationLocaleWithoutLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LocaleConnectOrCreateTranslationsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationLocaleWithoutLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	value?: string | undefined | null,
	root?: ResolverInputTypes["TranslationLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationLocaleCreateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationLocaleConnectOrCreateRootRelationInput"] | undefined | null
};
	["TranslationWithoutLocalesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	key?: string | undefined | null,
	isTextarea?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["TranslationUniqueWhere"],
	create: ResolverInputTypes["TranslationWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateTranslationsRelationInput"]: {
	connect: ResolverInputTypes["TranslationLocaleUniqueWhere"],
	create: ResolverInputTypes["TranslationLocaleWithoutLocaleCreateInput"]
};
	["HomePageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutHomePagesCreateInput"]
};
	["HomePageLocaleCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateLogoRelationInput"] | undefined | null
};
	["HomePageLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["HomePageLocaleCreateSiteSwitcherEntityRelationInput"]: {
	connect?: ResolverInputTypes["SiteSwitcherUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SiteSwitcherCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined | null
};
	["SiteSwitcherCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	link?: ResolverInputTypes["SiteSwitcherCreateLinkEntityRelationInput"] | undefined | null,
	theme?: ResolverInputTypes["SiteSwitcherCreateThemeEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SiteSwitcherCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SiteSwitcherConnectOrCreateLinkRelationInput"] | undefined | null
};
	["SiteSwitcherConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["SiteSwitcherCreateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SiteSwitcherConnectOrCreateThemeRelationInput"] | undefined | null
};
	["SiteSwitcherConnectOrCreateThemeRelationInput"]: {
	connect: ResolverInputTypes["ThemeUniqueWhere"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"]: {
	connect: ResolverInputTypes["SiteSwitcherUniqueWhere"],
	create: ResolverInputTypes["SiteSwitcherCreateInput"]
};
	["HomePageLocaleCreateGalleryEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateGalleryRelationInput"] | undefined | null
};
	["GalleryCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["GalleryCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GalleryConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GalleryItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	image?: ResolverInputTypes["GalleryItemCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GalleryItemConnectOrCreateImageRelationInput"] | undefined | null
};
	["GalleryItemConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["GalleryConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["GalleryItemUniqueWhere"],
	create: ResolverInputTypes["GalleryItemWithoutListCreateInput"]
};
	["HomePageLocaleConnectOrCreateGalleryRelationInput"]: {
	connect: ResolverInputTypes["GalleryUniqueWhere"],
	create: ResolverInputTypes["GalleryCreateInput"]
};
	["HomePageLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ResolverInputTypes["StickyBarUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StickyBarCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null
};
	["HomePageLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ResolverInputTypes["StickyBarUniqueWhere"],
	create: ResolverInputTypes["StickyBarCreateInput"]
};
	["HomePageLocaleCreateIlustrationEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateIlustrationRelationInput"] | undefined | null
};
	["HomePageLocaleConnectOrCreateIlustrationRelationInput"]: {
	connect: ResolverInputTypes["GalleryUniqueWhere"],
	create: ResolverInputTypes["GalleryCreateInput"]
};
	["LinkableConnectOrCreateHomePageRelationInput"]: {
	connect: ResolverInputTypes["HomePageLocaleUniqueWhere"],
	create: ResolverInputTypes["HomePageLocaleWithoutLinkCreateInput"]
};
	["HomePageLokalLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutHomePageLokalCreateInput"]
};
	["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"]: {
	connect?: ResolverInputTypes["SiteSwitcherUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SiteSwitcherCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined | null
};
	["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"]: {
	connect: ResolverInputTypes["SiteSwitcherUniqueWhere"],
	create: ResolverInputTypes["SiteSwitcherCreateInput"]
};
	["HomePageLokalLocaleCreateGalleryEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"] | undefined | null
};
	["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"]: {
	connect: ResolverInputTypes["GalleryUniqueWhere"],
	create: ResolverInputTypes["GalleryCreateInput"]
};
	["HomePageLokalLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ResolverInputTypes["StickyBarUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StickyBarCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null
};
	["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ResolverInputTypes["StickyBarUniqueWhere"],
	create: ResolverInputTypes["StickyBarCreateInput"]
};
	["HomePageLokalLocaleCreateIlustrationEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"] | undefined | null
};
	["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"]: {
	connect: ResolverInputTypes["GalleryUniqueWhere"],
	create: ResolverInputTypes["GalleryCreateInput"]
};
	["LocaleConnectOrCreateHomePageLokalsRelationInput"]: {
	connect: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],
	create: ResolverInputTypes["HomePageLokalLocaleWithoutLocaleCreateInput"]
};
	["JobsFormLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutJobsFormsCreateInput"]
};
	["StickyBarConnectOrCreateJobsFormRelationInput"]: {
	connect: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	create: ResolverInputTypes["JobsFormLocaleCreateInput"]
};
	["JobPageLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ResolverInputTypes["StickyBarUniqueWhere"],
	create: ResolverInputTypes["StickyBarCreateInput"]
};
	["JobPageLocaleCreateMobileImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateMobileImageRelationInput"] | undefined | null
};
	["JobPageLocaleConnectOrCreateMobileImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LinkableConnectOrCreateJobPageRelationInput"]: {
	connect: ResolverInputTypes["JobPageLocaleUniqueWhere"],
	create: ResolverInputTypes["JobPageLocaleWithoutLinkCreateInput"]
};
	["LinkableCreateHomePageLokalEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageLokalLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateHomePageLokalRelationInput"] | undefined | null
};
	["HomePageLokalLocaleWithoutLinkCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutHomePageLokalsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutHomePageLokalsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutHomePageLokalsCreateInput"]
};
	["LinkableConnectOrCreateHomePageLokalRelationInput"]: {
	connect: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],
	create: ResolverInputTypes["HomePageLokalLocaleWithoutLinkCreateInput"]
};
	["HomePageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutHomePageCreateInput"]
};
	["LocaleConnectOrCreateHomePagesRelationInput"]: {
	connect: ResolverInputTypes["HomePageLocaleUniqueWhere"],
	create: ResolverInputTypes["HomePageLocaleWithoutLocaleCreateInput"]
};
	["JobPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutJobPagesCreateInput"]
};
	["JobPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutJobPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutJobPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutJobPageCreateInput"]
};
	["JobPageConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["JobPageLocaleUniqueWhere"],
	create: ResolverInputTypes["JobPageLocaleWithoutRootCreateInput"]
};
	["JobPageCreateJobCityEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobCityUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobCityCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateJobCityRelationInput"] | undefined | null
};
	["JobCityCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["JobCityCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobCityLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobCityLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobCityConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobCityLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["JobCityLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutJobCitiesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobCityLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutJobCitiesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutJobCitiesCreateInput"]
};
	["JobCityConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["JobCityLocaleUniqueWhere"],
	create: ResolverInputTypes["JobCityLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateJobCityRelationInput"]: {
	connect: ResolverInputTypes["JobCityUniqueWhere"],
	create: ResolverInputTypes["JobCityCreateInput"]
};
	["JobPageCreateBusinessEntityRelationInput"]: {
	connect?: ResolverInputTypes["BusinessPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BusinessPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateBusinessRelationInput"] | undefined | null
};
	["BusinessPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["BusinessPageCreateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["BusinessPageCreateThemeEntityRelationInput"] | undefined | null,
	isLokal?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	headerColor?: string | undefined | null,
	recruitisOfficeId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BusinessPageLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessPageLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	text?: string | undefined | null,
	name?: string | undefined | null,
	image?: ResolverInputTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	infoBox?: ResolverInputTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null
};
	["BusinessPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ResolverInputTypes["SeoUniqueWhere"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["BusinessPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutBusinessPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutBusinessPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutBusinessPageCreateInput"]
};
	["BusinessPageLocaleCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateImageRelationInput"] | undefined | null
};
	["BusinessPageLocaleConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["BusinessPageLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ResolverInputTypes["StickyBarUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StickyBarCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null
};
	["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ResolverInputTypes["StickyBarUniqueWhere"],
	create: ResolverInputTypes["StickyBarCreateInput"]
};
	["BusinessPageLocaleCreateInfoBoxEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoBoxUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoBoxCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"] | undefined | null
};
	["InfoBoxCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	logoSize?: ResolverInputTypes["LogoSize"] | undefined | null,
	logo?: ResolverInputTypes["InfoBoxCreateLogoEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["InfoBoxCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoBoxLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoBoxLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoBoxConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["InfoBoxLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	address?: string | undefined | null,
	web?: string | undefined | null,
	instagram?: string | undefined | null,
	facebook?: string | undefined | null,
	locale?: ResolverInputTypes["InfoBoxLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	openingHours?: ResolverInputTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined | null,
	addressLink?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutInfoBoxesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoBoxLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutInfoBoxesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutInfoBoxesCreateInput"]
};
	["InfoBoxConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],
	create: ResolverInputTypes["InfoBoxLocaleWithoutRootCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"]: {
	connect: ResolverInputTypes["InfoBoxUniqueWhere"],
	create: ResolverInputTypes["InfoBoxCreateInput"]
};
	["BusinessPageConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],
	create: ResolverInputTypes["BusinessPageLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateBusinessRelationInput"]: {
	connect: ResolverInputTypes["BusinessPageUniqueWhere"],
	create: ResolverInputTypes["BusinessPageCreateInput"]
};
	["JobPositionConnectOrCreateJobsRelationInput"]: {
	connect: ResolverInputTypes["JobPageUniqueWhere"],
	create: ResolverInputTypes["JobPageWithoutJobPositionCreateInput"]
};
	["JobPositionLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["JobPositionUniqueWhere"],
	create: ResolverInputTypes["JobPositionWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateJobPositionsRelationInput"]: {
	connect: ResolverInputTypes["JobPositionLocaleUniqueWhere"],
	create: ResolverInputTypes["JobPositionLocaleWithoutLocaleCreateInput"]
};
	["ContractTypeLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutContractTypesCreateInput"]
};
	["ContractTypeConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],
	create: ResolverInputTypes["ContractTypeLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateContractTypeRelationInput"]: {
	connect: ResolverInputTypes["ContractTypeUniqueWhere"],
	create: ResolverInputTypes["ContractTypeCreateInput"]
};
	["JobPageCreateJobPositionEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPositionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPositionWithoutJobsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateJobPositionRelationInput"] | undefined | null
};
	["JobPositionWithoutJobsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["JobPositionCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPositionLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPositionLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPositionConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobPositionLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: string | undefined | null,
	locale?: ResolverInputTypes["JobPositionLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutJobPositionsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPositionLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutJobPositionsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutJobPositionsCreateInput"]
};
	["JobPositionConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["JobPositionLocaleUniqueWhere"],
	create: ResolverInputTypes["JobPositionLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateJobPositionRelationInput"]: {
	connect: ResolverInputTypes["JobPositionUniqueWhere"],
	create: ResolverInputTypes["JobPositionWithoutJobsCreateInput"]
};
	["JobPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ResolverInputTypes["JobPageUniqueWhere"],
	create: ResolverInputTypes["JobPageWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateJobPagesRelationInput"]: {
	connect: ResolverInputTypes["JobPageLocaleUniqueWhere"],
	create: ResolverInputTypes["JobPageLocaleWithoutLocaleCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutBusinessPagesCreateInput"]
};
	["LinkableConnectOrCreateBusinessPageRelationInput"]: {
	connect: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],
	create: ResolverInputTypes["BusinessPageLocaleWithoutLinkCreateInput"]
};
	["GenericPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageLocaleCreateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateLogoRelationInput"] | undefined | null
};
	["GenericPageLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["GenericPageLocaleCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateImageRelationInput"] | undefined | null
};
	["GenericPageLocaleConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateGenericPagesRelationInput"]: {
	connect: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	create: ResolverInputTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["BonusBannerLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutBonusBannersCreateInput"]
};
	["ContentReferenceConnectOrCreateBonusBannerRelationInput"]: {
	connect: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],
	create: ResolverInputTypes["BonusBannerLocaleCreateInput"]
};
	["ContentReferenceCreateSideBySideEntityRelationInput"]: {
	connect?: ResolverInputTypes["SideBySideUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SideBySideCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateSideBySideRelationInput"] | undefined | null
};
	["SideBySideUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["SideBySideItemUniqueWhere"] | undefined | null
};
	["SideBySideItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	media?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null
};
	["SideBySideCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["SideBySideCreateItemsEntityRelationInput"]> | undefined | null,
	background?: ResolverInputTypes["Background"] | undefined | null,
	alignment?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	mediumSize?: ResolverInputTypes["MediumSize"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SideBySideCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["SideBySideItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SideBySideItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SideBySideConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SideBySideItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	media?: ResolverInputTypes["SideBySideItemCreateMediaEntityRelationInput"] | undefined | null,
	formButtonLabel?: string | undefined | null,
	type?: ResolverInputTypes["SideBySideItemType"] | undefined | null,
	link?: ResolverInputTypes["SideBySideItemCreateLinkEntityRelationInput"] | undefined | null,
	jobsForm?: ResolverInputTypes["SideBySideItemCreateJobsFormEntityRelationInput"] | undefined | null,
	textNew?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SideBySideItemCreateMediaEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SideBySideItemConnectOrCreateMediaRelationInput"] | undefined | null
};
	["SideBySideItemConnectOrCreateMediaRelationInput"]: {
	connect: ResolverInputTypes["MediumListUniqueWhere"],
	create: ResolverInputTypes["MediumListCreateInput"]
};
	["SideBySideItemCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SideBySideItemConnectOrCreateLinkRelationInput"] | undefined | null
};
	["SideBySideItemConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["SideBySideItemCreateJobsFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SideBySideItemConnectOrCreateJobsFormRelationInput"] | undefined | null
};
	["SideBySideItemConnectOrCreateJobsFormRelationInput"]: {
	connect: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	create: ResolverInputTypes["JobsFormLocaleCreateInput"]
};
	["SideBySideConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["SideBySideItemUniqueWhere"],
	create: ResolverInputTypes["SideBySideItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateSideBySideRelationInput"]: {
	connect: ResolverInputTypes["SideBySideUniqueWhere"],
	create: ResolverInputTypes["SideBySideCreateInput"]
};
	["ContentReferenceCreateGalleryEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateGalleryRelationInput"] | undefined | null
};
	["ContentReferenceConnectOrCreateGalleryRelationInput"]: {
	connect: ResolverInputTypes["GalleryUniqueWhere"],
	create: ResolverInputTypes["GalleryCreateInput"]
};
	["ContentReferenceCreateVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined | null
};
	["ContentReferenceConnectOrCreateVideoRelationInput"]: {
	connect: ResolverInputTypes["VideoUniqueWhere"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["ContentBlockConnectOrCreateReferencesRelationInput"]: {
	connect: ResolverInputTypes["ContentReferenceUniqueWhere"],
	create: ResolverInputTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentConnectOrCreateBlocksRelationInput"]: {
	connect: ResolverInputTypes["ContentBlockUniqueWhere"],
	create: ResolverInputTypes["ContentBlockWithoutContentCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["LocaleConnectOrCreateBusinessPagesRelationInput"]: {
	connect: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],
	create: ResolverInputTypes["BusinessPageLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableConnectOrCreateGenericPageRelationInput"]: {
	connect: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	create: ResolverInputTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["LinkConnectOrCreateInternalLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableCreateInput"]
};
	["FooterLinkConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"]: {
	connect: ResolverInputTypes["FooterLinkUniqueWhere"],
	create: ResolverInputTypes["FooterLinkCreateInput"]
};
	["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]: {
	connect?: ResolverInputTypes["FooterLinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FooterLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"]: {
	connect: ResolverInputTypes["FooterLinkUniqueWhere"],
	create: ResolverInputTypes["FooterLinkCreateInput"]
};
	["FooterLocaleCreateTermsAndConditionsEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"] | undefined | null
};
	["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["FooterLocaleCreateBannerImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateBannerImageRelationInput"] | undefined | null
};
	["FooterLocaleConnectOrCreateBannerImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["FooterLocaleCreateBannerLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateBannerLinkRelationInput"] | undefined | null
};
	["FooterLocaleConnectOrCreateBannerLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["FooterLocaleCreateJobsFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateJobsFormRelationInput"] | undefined | null
};
	["FooterLocaleConnectOrCreateJobsFormRelationInput"]: {
	connect: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	create: ResolverInputTypes["JobsFormLocaleCreateInput"]
};
	["FooterLocaleCreateCopyrightLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"] | undefined | null
};
	["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["FooterLocaleCreateRecommendationFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RecommendationFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateRecommendationFormRelationInput"] | undefined | null
};
	["RecommendationFormLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	yourEmailLabel?: string | undefined | null,
	theirEmailLabel?: string | undefined | null,
	yourName?: string | undefined | null,
	sendBtnLabel?: string | undefined | null,
	successTitle?: string | undefined | null,
	successSubtitle?: string | undefined | null,
	successButtonClose?: string | undefined | null,
	root?: ResolverInputTypes["RecommendationFormLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["RecommendationFormLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutRecommendationFormsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutRecommendationFormsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutRecommendationFormsCreateInput"]
};
	["FooterLocaleConnectOrCreateRecommendationFormRelationInput"]: {
	connect: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],
	create: ResolverInputTypes["RecommendationFormLocaleCreateInput"]
};
	["FooterLocaleCreateBannerSecondLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"] | undefined | null
};
	["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["FooterLocaleCreateInstagramLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateInstagramLinkRelationInput"] | undefined | null
};
	["FooterLocaleConnectOrCreateInstagramLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkUniqueWhere"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["LocaleConnectOrCreateFootersRelationInput"]: {
	connect: ResolverInputTypes["FooterLocaleUniqueWhere"],
	create: ResolverInputTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutGeneralCreateInput"]
};
	["GeneralConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	create: ResolverInputTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["GeneralUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["GeneralUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["GeneralLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["GeneralUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GeneralUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	data: ResolverInputTypes["GeneralLocaleWithoutRootUpdateInput"]
};
	["GeneralLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	cornerBanner?: ResolverInputTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGeneralCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutGeneralUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutGeneralUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateFootersEntityRelationInput"]: {
	create?: ResolverInputTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateFootersRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertFootersRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateFootersRelationInput"]: {
	by: ResolverInputTypes["FooterLocaleUniqueWhere"],
	data: ResolverInputTypes["FooterLocaleWithoutLocaleUpdateInput"]
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
	email?: string | undefined | null,
	address?: string | undefined | null,
	ico?: string | undefined | null,
	dic?: string | undefined | null,
	copyright?: string | undefined | null,
	note?: string | undefined | null,
	noteSecond?: string | undefined | null,
	root?: ResolverInputTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined | null,
	linksFirstColumn?: Array<ResolverInputTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined | null,
	linksSecondColumn?: Array<ResolverInputTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined | null,
	termsAndConditions?: ResolverInputTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined | null,
	form?: string | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerSubtitle?: string | undefined | null,
	bannerImage?: ResolverInputTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null,
	bannerLink?: ResolverInputTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined | null,
	jobsForm?: ResolverInputTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined | null,
	copyrightLink?: ResolverInputTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined | null,
	bannerSecondBtn?: string | undefined | null,
	recommendationForm?: ResolverInputTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined | null,
	bannerSecondLink?: ResolverInputTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined | null,
	instagramLink?: ResolverInputTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["FooterUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FooterWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["FooterWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["FooterWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]: {
	create?: ResolverInputTypes["FooterLinkCreateInput"] | undefined | null,
	update?: ResolverInputTypes["FooterLocaleUpdateLinksFirstColumnRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertLinksFirstColumnRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["FooterLinkUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["FooterLinkUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["FooterLinkUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FooterLocaleUpdateLinksFirstColumnRelationInput"]: {
	by: ResolverInputTypes["FooterLinkUniqueWhere"],
	data: ResolverInputTypes["FooterLinkUpdateInput"]
};
	["FooterLinkUpdateInput"]: {
	order?: number | undefined | null,
	link?: ResolverInputTypes["FooterLinkUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLinkUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLinkConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLinkUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkUpdateInput"]: {
	type?: ResolverInputTypes["LinkType"] | undefined | null,
	title?: string | undefined | null,
	externalLink?: string | undefined | null,
	internalLink?: ResolverInputTypes["LinkUpdateInternalLinkEntityRelationInput"] | undefined | null,
	anchorLink?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkUpsertInternalLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableUpdateInput"]: {
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
	connect?: ResolverInputTypes["RedirectUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RedirectWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateRedirectRelationInput"] | undefined | null,
	update?: ResolverInputTypes["RedirectWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertRedirectRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["RedirectWithoutLinkUpdateInput"]: {
	target?: ResolverInputTypes["RedirectUpdateTargetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectUpdateTargetEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RedirectConnectOrCreateTargetRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RedirectUpsertTargetRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["RedirectUpsertTargetRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["LinkableUpsertRedirectRelationInput"]: {
	update: ResolverInputTypes["RedirectWithoutLinkUpdateInput"],
	create: ResolverInputTypes["RedirectWithoutLinkCreateInput"]
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertGenericPageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	logo?: ResolverInputTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageWithoutLocalesUpdateInput"]: {
	theme?: ResolverInputTypes["GenericPageUpdateThemeEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageUpdateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageConnectOrCreateThemeRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ThemeUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageUpsertThemeRelationInput"] | undefined | null
};
	["ThemeUpdateInput"]: {
	backgroundColor?: string | undefined | null,
	textColor?: string | undefined | null,
	name?: string | undefined | null,
	buttonBackgroundColor?: string | undefined | null,
	buttonTextColor?: string | undefined | null,
	buttonBackgroundHoverColor?: string | undefined | null,
	buttonTextHoverColor?: string | undefined | null,
	buttonBorderColor?: string | undefined | null,
	buttonBorderHoverColor?: string | undefined | null,
	headerMenuColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageUpsertThemeRelationInput"]: {
	update: ResolverInputTypes["ThemeUpdateInput"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["GenericPageLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["GenericPageWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["GenericPageWithoutLocalesCreateInput"]
};
	["GenericPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutGenericPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutGenericPagesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutGenericPagesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
	create?: ResolverInputTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateHeadersRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertHeadersRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateHeadersRelationInput"]: {
	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	data: ResolverInputTypes["HeaderLocaleWithoutLocaleUpdateInput"]
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined | null,
	menuLabel?: string | undefined | null,
	menuTitle?: string | undefined | null,
	menuText?: string | undefined | null,
	business?: Array<ResolverInputTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined | null,
	lokalEnterprise?: Array<ResolverInputTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined | null,
	businessSectionTitle?: string | undefined | null,
	lokalSectionTitle?: string | undefined | null,
	businessLink?: ResolverInputTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined | null,
	lokalLink?: ResolverInputTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeaderUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeaderWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["HeaderWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["HeaderWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	logo?: ResolverInputTypes["HeaderUpdateLogoEntityRelationInput"] | undefined | null,
	logoMenu?: ResolverInputTypes["HeaderUpdateLogoMenuEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageUpdateInput"]: {
	url?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	alt?: string | undefined | null,
	fileName?: string | undefined | null,
	focalPointX?: number | undefined | null,
	focalPointY?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["HeaderUpdateLogoMenuEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderConnectOrCreateLogoMenuRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderUpsertLogoMenuRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HeaderUpsertLogoMenuRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["HeaderLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["HeaderWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleUpdateBusinessEntityRelationInput"]: {
	create?: ResolverInputTypes["BusinessCreateInput"] | undefined | null,
	update?: ResolverInputTypes["HeaderLocaleUpdateBusinessRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderLocaleUpsertBusinessRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["BusinessUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["BusinessUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["BusinessUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["HeaderLocaleUpdateBusinessRelationInput"]: {
	by: ResolverInputTypes["BusinessUniqueWhere"],
	data: ResolverInputTypes["BusinessUpdateInput"]
};
	["BusinessUpdateInput"]: {
	order?: number | undefined | null,
	logo?: ResolverInputTypes["BusinessUpdateLogoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["BusinessUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["BusinessUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["HeaderLocaleUpsertBusinessRelationInput"]: {
	by: ResolverInputTypes["BusinessUniqueWhere"],
	update: ResolverInputTypes["BusinessUpdateInput"],
	create: ResolverInputTypes["BusinessCreateInput"]
};
	["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]: {
	create?: ResolverInputTypes["BusinessCreateInput"] | undefined | null,
	update?: ResolverInputTypes["HeaderLocaleUpdateLokalEnterpriseRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderLocaleUpsertLokalEnterpriseRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["BusinessUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["BusinessUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["BusinessUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["HeaderLocaleUpdateLokalEnterpriseRelationInput"]: {
	by: ResolverInputTypes["BusinessUniqueWhere"],
	data: ResolverInputTypes["BusinessUpdateInput"]
};
	["HeaderLocaleUpsertLokalEnterpriseRelationInput"]: {
	by: ResolverInputTypes["BusinessUniqueWhere"],
	update: ResolverInputTypes["BusinessUpdateInput"],
	create: ResolverInputTypes["BusinessCreateInput"]
};
	["HeaderLocaleUpdateBusinessLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderLocaleUpsertBusinessLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HeaderLocaleUpsertBusinessLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["HeaderLocaleUpdateLokalLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateLokalLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderLocaleUpsertLokalLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HeaderLocaleUpsertLokalLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["LocaleUpsertHeadersRelationInput"]: {
	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	update: ResolverInputTypes["HeaderLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateSeoDefaultsEntityRelationInput"]: {
	create?: ResolverInputTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateSeoDefaultsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertSeoDefaultsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateSeoDefaultsRelationInput"]: {
	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],
	data: ResolverInputTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"]
};
	["SeoDefaultLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoDefaultUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoDefaultWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoDefaultLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoDefaultWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SeoDefaultLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["SeoDefaultWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["SeoDefaultWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["SeoDefaultWithoutLocalesCreateInput"]
};
	["SeoDefaultLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoDefaultLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SeoDefaultLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SeoUpdateInput"]: {
	title?: string | undefined | null,
	description?: string | undefined | null,
	ogTitle?: string | undefined | null,
	ogDescription?: string | undefined | null,
	noIndex?: boolean | undefined | null,
	noFollow?: boolean | undefined | null,
	ogImage?: ResolverInputTypes["SeoUpdateOgImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SeoUpsertOgImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["SeoDefaultLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["LocaleUpsertSeoDefaultsRelationInput"]: {
	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],
	update: ResolverInputTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["SeoDefaultLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateBusinessPagesEntityRelationInput"]: {
	create?: ResolverInputTypes["BusinessPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateBusinessPagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertBusinessPagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateBusinessPagesRelationInput"]: {
	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],
	data: ResolverInputTypes["BusinessPageLocaleWithoutLocaleUpdateInput"]
};
	["BusinessPageLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	text?: string | undefined | null,
	name?: string | undefined | null,
	image?: ResolverInputTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	infoBox?: ResolverInputTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["BusinessPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BusinessPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["BusinessPageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessPageLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessPageWithoutLocalesUpdateInput"]: {
	theme?: ResolverInputTypes["BusinessPageUpdateThemeEntityRelationInput"] | undefined | null,
	isLokal?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	headerColor?: string | undefined | null,
	recruitisOfficeId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageUpdateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageConnectOrCreateThemeRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ThemeUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessPageUpsertThemeRelationInput"] | undefined | null
};
	["BusinessPageUpsertThemeRelationInput"]: {
	update: ResolverInputTypes["ThemeUpdateInput"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["BusinessPageLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["BusinessPageWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["BusinessPageWithoutLocalesCreateInput"]
};
	["BusinessPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessPageLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentUpdateInput"]: {
	blocks?: Array<ResolverInputTypes["ContentUpdateBlocksEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?: ResolverInputTypes["ContentBlockWithoutContentCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateBlocksRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentUpsertBlocksRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentUpdateBlocksRelationInput"]: {
	by: ResolverInputTypes["ContentBlockUniqueWhere"],
	data: ResolverInputTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?: number | undefined | null,
	json?: string | undefined | null,
	references?: Array<ResolverInputTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?: ResolverInputTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ContentBlockUpdateReferencesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentBlockUpsertReferencesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ContentReferenceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by: ResolverInputTypes["ContentReferenceUniqueWhere"],
	data: ResolverInputTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	image?: ResolverInputTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined | null,
	linkables?: Array<ResolverInputTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined | null,
	secondaryText?: string | undefined | null,
	link?: ResolverInputTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined | null,
	textList?: ResolverInputTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined | null,
	carousel?: ResolverInputTypes["ContentReferenceUpdateCarouselEntityRelationInput"] | undefined | null,
	bonusBanner?: ResolverInputTypes["ContentReferenceUpdateBonusBannerEntityRelationInput"] | undefined | null,
	sideBySide?: ResolverInputTypes["ContentReferenceUpdateSideBySideEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined | null,
	showBoolean?: boolean | undefined | null,
	isRed?: boolean | undefined | null,
	video?: ResolverInputTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateLinkablesEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateMediaEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined | null,
	update?: ResolverInputTypes["MediumListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertMediaRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumListUpdateInput"]: {
	items?: Array<ResolverInputTypes["MediumListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["MediumItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["MediumListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["MediumListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["MediumItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["MediumItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["MediumItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["MediumListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["MediumItemUniqueWhere"],
	data: ResolverInputTypes["MediumItemWithoutListUpdateInput"]
};
	["MediumItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	medium?: ResolverInputTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemUpdateMediumEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined | null,
	update?: ResolverInputTypes["MediumUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MediumItemUpsertMediumRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumUpdateInput"]: {
	type?: ResolverInputTypes["MediumType"] | undefined | null,
	image?: ResolverInputTypes["MediumUpdateImageEntityRelationInput"] | undefined | null,
	video?: ResolverInputTypes["MediumUpdateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MediumUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["MediumUpdateVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumConnectOrCreateVideoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["VideoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MediumUpsertVideoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VideoUpdateInput"]: {
	src?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	videoInfo?: string | undefined | null,
	duration?: number | undefined | null,
	poster?: ResolverInputTypes["VideoUpdatePosterEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VideoUpdatePosterEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["VideoConnectOrCreatePosterRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["VideoUpsertPosterRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VideoUpsertPosterRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["MediumUpsertVideoRelationInput"]: {
	update: ResolverInputTypes["VideoUpdateInput"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["MediumItemUpsertMediumRelationInput"]: {
	update: ResolverInputTypes["MediumUpdateInput"],
	create: ResolverInputTypes["MediumCreateInput"]
};
	["MediumListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["MediumItemUniqueWhere"],
	update: ResolverInputTypes["MediumItemWithoutListUpdateInput"],
	create: ResolverInputTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertMediaRelationInput"]: {
	update: ResolverInputTypes["MediumListUpdateInput"],
	create: ResolverInputTypes["MediumListCreateInput"]
};
	["ContentReferenceUpdateTextListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateTextListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TextListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertTextListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TextListUpdateInput"]: {
	items?: Array<ResolverInputTypes["TextListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["TextItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["TextListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["TextListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TextItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TextItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TextItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TextListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["TextItemUniqueWhere"],
	data: ResolverInputTypes["TextItemWithoutListUpdateInput"]
};
	["TextItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	text?: string | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["TextItemUniqueWhere"],
	update: ResolverInputTypes["TextItemWithoutListUpdateInput"],
	create: ResolverInputTypes["TextItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertTextListRelationInput"]: {
	update: ResolverInputTypes["TextListUpdateInput"],
	create: ResolverInputTypes["TextListCreateInput"]
};
	["ContentReferenceUpdateCarouselEntityRelationInput"]: {
	connect?: ResolverInputTypes["CarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CarouselCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateCarouselRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CarouselUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertCarouselRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CarouselUpdateInput"]: {
	items?: Array<ResolverInputTypes["CarouselUpdateItemsEntityRelationInput"]> | undefined | null,
	background?: ResolverInputTypes["Background"] | undefined | null,
	squareImages?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CarouselUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["CarouselItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["CarouselUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["CarouselUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["CarouselItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["CarouselItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["CarouselItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CarouselUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["CarouselItemUniqueWhere"],
	data: ResolverInputTypes["CarouselItemWithoutListUpdateInput"]
};
	["CarouselItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	text?: string | undefined | null,
	image?: ResolverInputTypes["CarouselItemUpdateImageEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	title?: string | undefined | null,
	linkUrl?: ResolverInputTypes["CarouselItemUpdateLinkUrlEntityRelationInput"] | undefined | null,
	normalAspectRatio?: boolean | undefined | null,
	isImage?: boolean | undefined | null,
	video?: ResolverInputTypes["CarouselItemUpdateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CarouselItemUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CarouselItemConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["CarouselItemUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CarouselItemUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["CarouselItemUpdateLinkUrlEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CarouselItemConnectOrCreateLinkUrlRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["CarouselItemUpsertLinkUrlRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CarouselItemUpsertLinkUrlRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["CarouselItemUpdateVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CarouselItemConnectOrCreateVideoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["VideoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["CarouselItemUpsertVideoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CarouselItemUpsertVideoRelationInput"]: {
	update: ResolverInputTypes["VideoUpdateInput"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["CarouselUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["CarouselItemUniqueWhere"],
	update: ResolverInputTypes["CarouselItemWithoutListUpdateInput"],
	create: ResolverInputTypes["CarouselItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertCarouselRelationInput"]: {
	update: ResolverInputTypes["CarouselUpdateInput"],
	create: ResolverInputTypes["CarouselCreateInput"]
};
	["ContentReferenceUpdateBonusBannerEntityRelationInput"]: {
	connect?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BonusBannerLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateBonusBannerRelationInput"] | undefined | null,
	update?: ResolverInputTypes["BonusBannerLocaleUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertBonusBannerRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BonusBannerLocaleUpdateInput"]: {
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	tiles?: Array<ResolverInputTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined | null,
	logo?: ResolverInputTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	bannerName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BonusBannerLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["BonusBannerUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BonusBannerWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BonusBannerLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["BonusBannerWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BonusBannerLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["BonusBannerWithoutLocalesUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["BonusBannerLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["BonusBannerWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["BonusBannerWithoutLocalesCreateInput"]
};
	["BonusBannerLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutBonusBannersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BonusBannerLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutBonusBannersUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BonusBannerLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutBonusBannersUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateGenericPagesEntityRelationInput"]: {
	create?: ResolverInputTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateGenericPagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertGenericPagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateGenericPagesRelationInput"]: {
	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	data: ResolverInputTypes["GenericPageLocaleWithoutLocaleUpdateInput"]
};
	["GenericPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	logo?: ResolverInputTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["GenericPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["GenericPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutGenericPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutGenericPageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutGenericPageUpdateInput"]: {
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdateBusinessPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BusinessPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateBusinessPageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["BusinessPageLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertBusinessPageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessPageLocaleWithoutLinkUpdateInput"]: {
	root?: ResolverInputTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	text?: string | undefined | null,
	name?: string | undefined | null,
	image?: ResolverInputTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	infoBox?: ResolverInputTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutBusinessPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutBusinessPagesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessPageLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutBusinessPagesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateJobPagesEntityRelationInput"]: {
	create?: ResolverInputTypes["JobPageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateJobPagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertJobPagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateJobPagesRelationInput"]: {
	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],
	data: ResolverInputTypes["JobPageLocaleWithoutLocaleUpdateInput"]
};
	["JobPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	keyInfo?: ResolverInputTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	stickyBar?: ResolverInputTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	mobileImage?: ResolverInputTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	recruitisJobId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobPageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["JobPageWithoutLocalesUpdateInput"]: {
	theme?: ResolverInputTypes["JobPageUpdateThemeEntityRelationInput"] | undefined | null,
	contractType?: ResolverInputTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined | null,
	jobCity?: ResolverInputTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined | null,
	isActive?: boolean | undefined | null,
	jobPosition?: ResolverInputTypes["JobPageUpdateJobPositionEntityRelationInput"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	order?: number | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	business?: ResolverInputTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	siteType?: ResolverInputTypes["SiteType"] | undefined | null,
	isHiddenFromListing?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageUpdateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateThemeRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ThemeUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageUpsertThemeRelationInput"] | undefined | null
};
	["JobPageUpsertThemeRelationInput"]: {
	update: ResolverInputTypes["ThemeUpdateInput"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["JobPageUpdateContractTypeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContractTypeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContractTypeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateContractTypeRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContractTypeUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageUpsertContractTypeRelationInput"] | undefined | null
};
	["ContractTypeUpdateInput"]: {
	locales?: Array<ResolverInputTypes["ContractTypeUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContractTypeUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["ContractTypeLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ContractTypeUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContractTypeUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ContractTypeLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ContractTypeLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ContractTypeLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContractTypeUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],
	data: ResolverInputTypes["ContractTypeLocaleWithoutRootUpdateInput"]
};
	["ContractTypeLocaleWithoutRootUpdateInput"]: {
	type?: string | undefined | null,
	locale?: ResolverInputTypes["ContractTypeLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContractTypeLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutContractTypesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContractTypeLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutContractTypesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContractTypeLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutContractTypesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateJobCitiesEntityRelationInput"]: {
	create?: ResolverInputTypes["JobCityLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateJobCitiesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertJobCitiesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobCityLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobCityLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobCityLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateJobCitiesRelationInput"]: {
	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],
	data: ResolverInputTypes["JobCityLocaleWithoutLocaleUpdateInput"]
};
	["JobCityLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["JobCityLocaleUpdateRootEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobCityUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobCityWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobCityLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobCityWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobCityLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["JobCityWithoutLocalesUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["JobCityLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["JobCityWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["JobCityWithoutLocalesCreateInput"]
};
	["LocaleUpsertJobCitiesRelationInput"]: {
	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],
	update: ResolverInputTypes["JobCityLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["JobCityLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateJobPositionsEntityRelationInput"]: {
	create?: ResolverInputTypes["JobPositionLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateJobPositionsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertJobPositionsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobPositionLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobPositionLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobPositionLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateJobPositionsRelationInput"]: {
	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],
	data: ResolverInputTypes["JobPositionLocaleWithoutLocaleUpdateInput"]
};
	["JobPositionLocaleWithoutLocaleUpdateInput"]: {
	type?: string | undefined | null,
	root?: ResolverInputTypes["JobPositionLocaleUpdateRootEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPositionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPositionWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPositionLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobPositionWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPositionLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["JobPositionWithoutLocalesUpdateInput"]: {
	jobs?: Array<ResolverInputTypes["JobPositionUpdateJobsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionUpdateJobsEntityRelationInput"]: {
	create?: ResolverInputTypes["JobPageWithoutJobPositionCreateInput"] | undefined | null,
	update?: ResolverInputTypes["JobPositionUpdateJobsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPositionUpsertJobsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobPageUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobPageUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobPageUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["JobPositionUpdateJobsRelationInput"]: {
	by: ResolverInputTypes["JobPageUniqueWhere"],
	data: ResolverInputTypes["JobPageWithoutJobPositionUpdateInput"]
};
	["JobPageWithoutJobPositionUpdateInput"]: {
	locales?: Array<ResolverInputTypes["JobPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["JobPageUpdateThemeEntityRelationInput"] | undefined | null,
	contractType?: ResolverInputTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined | null,
	jobCity?: ResolverInputTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined | null,
	isActive?: boolean | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	order?: number | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	business?: ResolverInputTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	siteType?: ResolverInputTypes["SiteType"] | undefined | null,
	isHiddenFromListing?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["JobPageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["JobPageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["JobPageUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],
	data: ResolverInputTypes["JobPageLocaleWithoutRootUpdateInput"]
};
	["JobPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	text?: string | undefined | null,
	locale?: ResolverInputTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	keyInfo?: ResolverInputTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	stickyBar?: ResolverInputTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	mobileImage?: ResolverInputTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	recruitisJobId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutJobPagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutJobPagesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutJobPagesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateContractTypesEntityRelationInput"]: {
	create?: ResolverInputTypes["ContractTypeLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateContractTypesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertContractTypesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ContractTypeLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ContractTypeLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ContractTypeLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateContractTypesRelationInput"]: {
	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],
	data: ResolverInputTypes["ContractTypeLocaleWithoutLocaleUpdateInput"]
};
	["ContractTypeLocaleWithoutLocaleUpdateInput"]: {
	type?: string | undefined | null,
	root?: ResolverInputTypes["ContractTypeLocaleUpdateRootEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContractTypeLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContractTypeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContractTypeWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContractTypeLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContractTypeWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContractTypeLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ContractTypeWithoutLocalesUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["ContractTypeLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["ContractTypeWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["ContractTypeWithoutLocalesCreateInput"]
};
	["LocaleUpsertContractTypesRelationInput"]: {
	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],
	update: ResolverInputTypes["ContractTypeLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["ContractTypeLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateHomePagesEntityRelationInput"]: {
	create?: ResolverInputTypes["HomePageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateHomePagesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertHomePagesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateHomePagesRelationInput"]: {
	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],
	data: ResolverInputTypes["HomePageLocaleWithoutLocaleUpdateInput"]
};
	["HomePageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["HomePageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	theme?: ResolverInputTypes["HomePageUpdateThemeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageUpdateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageConnectOrCreateThemeRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ThemeUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageUpsertThemeRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageUpsertThemeRelationInput"]: {
	update: ResolverInputTypes["ThemeUpdateInput"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["HomePageLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["HomePageWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["HomePageWithoutLocalesCreateInput"]
};
	["HomePageLocaleUpdateButtonEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateButtonRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertButtonRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLocaleUpsertButtonRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["HomePageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["HomePageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["HomePageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutHomePageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutHomePageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutHomePageUpdateInput"]: {
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdateJobPageEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateJobPageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobPageLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertJobPageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	keyInfo?: ResolverInputTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	stickyBar?: ResolverInputTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	mobileImage?: ResolverInputTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	recruitisJobId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageLocaleUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageLocaleUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobPageLocaleUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["JobPageLocaleUpdateKeyInfoEntityRelationInput"]: {
	connect?: ResolverInputTypes["KeyInfoListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["KeyInfoListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateKeyInfoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["KeyInfoListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageLocaleUpsertKeyInfoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["KeyInfoListUpdateInput"]: {
	items?: Array<ResolverInputTypes["KeyInfoListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["KeyInfoListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["KeyInfoItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["KeyInfoListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["KeyInfoListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["KeyInfoItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["KeyInfoItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["KeyInfoItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["KeyInfoListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],
	data: ResolverInputTypes["KeyInfoItemWithoutListUpdateInput"]
};
	["KeyInfoItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	keyInfo?: string | undefined | null,
	icon?: ResolverInputTypes["KeyInfoItemUpdateIconEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["KeyInfoItemUpdateIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["IconUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["IconCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["KeyInfoItemConnectOrCreateIconRelationInput"] | undefined | null,
	update?: ResolverInputTypes["IconUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["KeyInfoItemUpsertIconRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["IconUpdateInput"]: {
	name?: string | undefined | null,
	icon?: ResolverInputTypes["IconUpdateIconEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IconUpdateIconEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["IconConnectOrCreateIconRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["IconUpsertIconRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["IconUpsertIconRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["KeyInfoItemUpsertIconRelationInput"]: {
	update: ResolverInputTypes["IconUpdateInput"],
	create: ResolverInputTypes["IconCreateInput"]
};
	["KeyInfoListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],
	update: ResolverInputTypes["KeyInfoItemWithoutListUpdateInput"],
	create: ResolverInputTypes["KeyInfoItemWithoutListCreateInput"]
};
	["JobPageLocaleUpsertKeyInfoRelationInput"]: {
	update: ResolverInputTypes["KeyInfoListUpdateInput"],
	create: ResolverInputTypes["KeyInfoListCreateInput"]
};
	["JobPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobPageLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["JobPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobPageLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["JobPageLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ResolverInputTypes["StickyBarUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StickyBarCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null,
	update?: ResolverInputTypes["StickyBarUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageLocaleUpsertStickyBarRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StickyBarUpdateInput"]: {
	title?: string | undefined | null,
	link?: ResolverInputTypes["StickyBarUpdateLinkEntityRelationInput"] | undefined | null,
	formButtonLabel?: string | undefined | null,
	jobsForm?: ResolverInputTypes["StickyBarUpdateJobsFormEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StickyBarUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StickyBarConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["StickyBarUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StickyBarUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["StickyBarUpdateJobsFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["StickyBarConnectOrCreateJobsFormRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobsFormLocaleUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["StickyBarUpsertJobsFormRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobsFormLocaleUpdateInput"]: {
	title?: string | undefined | null,
	jobText?: string | undefined | null,
	genericText?: string | undefined | null,
	nameLabel?: string | undefined | null,
	emailLabel?: string | undefined | null,
	telefonLabel?: string | undefined | null,
	fileTitleLabel?: string | undefined | null,
	fileFormatLabel?: string | undefined | null,
	formTextLabel?: string | undefined | null,
	submitLabel?: string | undefined | null,
	root?: ResolverInputTypes["JobsFormLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobsFormLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	imageTextList?: ResolverInputTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined | null,
	minimalize?: string | undefined | null,
	logo?: ResolverInputTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	successTitle?: string | undefined | null,
	successText?: string | undefined | null,
	successBtnLabel?: string | undefined | null,
	successImage?: ResolverInputTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined | null,
	successOtherJobsTitle?: string | undefined | null,
	successOtherJobsCategoryTitle?: string | undefined | null,
	successOtherJobsButtonTitle?: string | undefined | null,
	successOtherJobsSelectionTitle?: string | undefined | null,
	successOtherJobsSelectionYesButton?: string | undefined | null,
	successOtherJobsSelectionNoButton?: string | undefined | null,
	fileRemoveBtnLabel?: string | undefined | null,
	gdprLabel?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFormLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobsFormWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFormLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["JobsFormWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	fileIlustration?: ResolverInputTypes["JobsFormUpdateFileIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFormUpdateFileIlustrationEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormConnectOrCreateFileIlustrationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFormUpsertFileIlustrationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobsFormUpsertFileIlustrationRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["JobsFormLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["JobsFormWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["JobsFormWithoutLocalesCreateInput"]
};
	["JobsFormLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutJobsFormsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutJobsFormsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFormLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutJobsFormsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateBonusBannersEntityRelationInput"]: {
	create?: ResolverInputTypes["BonusBannerLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateBonusBannersRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertBonusBannersRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateBonusBannersRelationInput"]: {
	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],
	data: ResolverInputTypes["BonusBannerLocaleWithoutLocaleUpdateInput"]
};
	["BonusBannerLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined | null,
	tiles?: Array<ResolverInputTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined | null,
	logo?: ResolverInputTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	bannerName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BonusBannerLocaleUpdateTilesEntityRelationInput"]: {
	create?: ResolverInputTypes["TileWithoutBonusBannerCreateInput"] | undefined | null,
	update?: ResolverInputTypes["BonusBannerLocaleUpdateTilesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["BonusBannerLocaleUpsertTilesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TileUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TileUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TileUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BonusBannerLocaleUpdateTilesRelationInput"]: {
	by: ResolverInputTypes["TileUniqueWhere"],
	data: ResolverInputTypes["TileWithoutBonusBannerUpdateInput"]
};
	["TileWithoutBonusBannerUpdateInput"]: {
	order?: number | undefined | null,
	text?: string | undefined | null,
	image?: ResolverInputTypes["TileUpdateImageEntityRelationInput"] | undefined | null,
	lightBoxTitle?: string | undefined | null,
	lightBoxText?: string | undefined | null,
	ligthBoxMedia?: ResolverInputTypes["TileUpdateLigthBoxMediaEntityRelationInput"] | undefined | null,
	lightBoxSectionTitle?: string | undefined | null,
	title?: string | undefined | null,
	lightBoxLinkLabel?: string | undefined | null,
	lightBoxForm?: ResolverInputTypes["TileUpdateLightBoxFormEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TileUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["TileUpdateLigthBoxMediaEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileConnectOrCreateLigthBoxMediaRelationInput"] | undefined | null,
	update?: ResolverInputTypes["MediumListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileUpsertLigthBoxMediaRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TileUpsertLigthBoxMediaRelationInput"]: {
	update: ResolverInputTypes["MediumListUpdateInput"],
	create: ResolverInputTypes["MediumListCreateInput"]
};
	["TileUpdateLightBoxFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileConnectOrCreateLightBoxFormRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobsFormLocaleUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileUpsertLightBoxFormRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TileUpsertLightBoxFormRelationInput"]: {
	update: ResolverInputTypes["JobsFormLocaleUpdateInput"],
	create: ResolverInputTypes["JobsFormLocaleCreateInput"]
};
	["BonusBannerLocaleUpsertTilesRelationInput"]: {
	by: ResolverInputTypes["TileUniqueWhere"],
	update: ResolverInputTypes["TileWithoutBonusBannerUpdateInput"],
	create: ResolverInputTypes["TileWithoutBonusBannerCreateInput"]
};
	["BonusBannerLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BonusBannerLocaleConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BonusBannerLocaleUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BonusBannerLocaleUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LocaleUpsertBonusBannersRelationInput"]: {
	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],
	update: ResolverInputTypes["BonusBannerLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["BonusBannerLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateHomePageLokalsEntityRelationInput"]: {
	create?: ResolverInputTypes["HomePageLokalLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateHomePageLokalsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertHomePageLokalsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateHomePageLokalsRelationInput"]: {
	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],
	data: ResolverInputTypes["HomePageLokalLocaleWithoutLocaleUpdateInput"]
};
	["HomePageLokalLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageLokalUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageLokalWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["HomePageLokalWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	theme?: ResolverInputTypes["HomePageLokalUpdateThemeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalUpdateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalConnectOrCreateThemeRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ThemeUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalUpsertThemeRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalUpsertThemeRelationInput"]: {
	update: ResolverInputTypes["ThemeUpdateInput"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["HomePageLokalLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["HomePageLokalWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["HomePageLokalWithoutLocalesCreateInput"]
};
	["HomePageLokalLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalLocaleUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["HomePageLokalLocaleUpdateButtonEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateButtonRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertButtonRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalLocaleUpsertButtonRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["HomePageLokalLocaleUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertContentRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["HomePageLokalLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["HomePageLokalLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutHomePageLokalCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutHomePageLokalUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutHomePageLokalUpdateInput"]: {
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateHomePageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["HomePageLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertHomePageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutHomePagesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutHomePagesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutHomePagesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateJobsFormsEntityRelationInput"]: {
	create?: ResolverInputTypes["JobsFormLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateJobsFormsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertJobsFormsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateJobsFormsRelationInput"]: {
	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	data: ResolverInputTypes["JobsFormLocaleWithoutLocaleUpdateInput"]
};
	["JobsFormLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	jobText?: string | undefined | null,
	genericText?: string | undefined | null,
	nameLabel?: string | undefined | null,
	emailLabel?: string | undefined | null,
	telefonLabel?: string | undefined | null,
	fileTitleLabel?: string | undefined | null,
	fileFormatLabel?: string | undefined | null,
	formTextLabel?: string | undefined | null,
	submitLabel?: string | undefined | null,
	root?: ResolverInputTypes["JobsFormLocaleUpdateRootEntityRelationInput"] | undefined | null,
	imageTextList?: ResolverInputTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined | null,
	minimalize?: string | undefined | null,
	logo?: ResolverInputTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	successTitle?: string | undefined | null,
	successText?: string | undefined | null,
	successBtnLabel?: string | undefined | null,
	successImage?: ResolverInputTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined | null,
	successOtherJobsTitle?: string | undefined | null,
	successOtherJobsCategoryTitle?: string | undefined | null,
	successOtherJobsButtonTitle?: string | undefined | null,
	successOtherJobsSelectionTitle?: string | undefined | null,
	successOtherJobsSelectionYesButton?: string | undefined | null,
	successOtherJobsSelectionNoButton?: string | undefined | null,
	fileRemoveBtnLabel?: string | undefined | null,
	gdprLabel?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFormLocaleUpdateImageTextListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageTextListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageTextListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormLocaleConnectOrCreateImageTextListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageTextListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFormLocaleUpsertImageTextListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageTextListUpdateInput"]: {
	items?: Array<ResolverInputTypes["ImageTextListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageTextListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["ImageTextItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ImageTextListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageTextListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ImageTextItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ImageTextItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ImageTextItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ImageTextListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["ImageTextItemUniqueWhere"],
	data: ResolverInputTypes["ImageTextItemWithoutListUpdateInput"]
};
	["ImageTextItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	image?: ResolverInputTypes["ImageTextItemUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageTextItemUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageTextItemConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageTextItemUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageTextItemUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ImageTextListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["ImageTextItemUniqueWhere"],
	update: ResolverInputTypes["ImageTextItemWithoutListUpdateInput"],
	create: ResolverInputTypes["ImageTextItemWithoutListCreateInput"]
};
	["JobsFormLocaleUpsertImageTextListRelationInput"]: {
	update: ResolverInputTypes["ImageTextListUpdateInput"],
	create: ResolverInputTypes["ImageTextListCreateInput"]
};
	["JobsFormLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormLocaleConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFormLocaleUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobsFormLocaleUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["JobsFormLocaleUpdateSuccessImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFormLocaleUpsertSuccessImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobsFormLocaleUpsertSuccessImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LocaleUpsertJobsFormsRelationInput"]: {
	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	update: ResolverInputTypes["JobsFormLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["JobsFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateJobsFiltersEntityRelationInput"]: {
	create?: ResolverInputTypes["JobsFilterLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateJobsFiltersRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertJobsFiltersRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobsFilterLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobsFilterLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobsFilterLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateJobsFiltersRelationInput"]: {
	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],
	data: ResolverInputTypes["JobsFilterLocaleWithoutLocaleUpdateInput"]
};
	["JobsFilterLocaleWithoutLocaleUpdateInput"]: {
	jobPositionLabel?: string | undefined | null,
	jobContractLabel?: string | undefined | null,
	jobCityLabel?: string | undefined | null,
	root?: ResolverInputTypes["JobsFilterLocaleUpdateRootEntityRelationInput"] | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerFormLabel?: string | undefined | null,
	bannerJobsForm?: ResolverInputTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined | null,
	bannerImage?: ResolverInputTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null,
	noJobTitle?: string | undefined | null,
	noJobBtnLabel?: string | undefined | null,
	noJobImage?: ResolverInputTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined | null,
	noJobTitleForSpecificBusiness?: string | undefined | null,
	deactivatedJob?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFilterUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFilterWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobsFilterWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFilterLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["JobsFilterWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["JobsFilterWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["JobsFilterWithoutLocalesCreateInput"]
};
	["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobsFormLocaleUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFilterLocaleUpsertBannerJobsFormRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobsFilterLocaleUpsertBannerJobsFormRelationInput"]: {
	update: ResolverInputTypes["JobsFormLocaleUpdateInput"],
	create: ResolverInputTypes["JobsFormLocaleCreateInput"]
};
	["JobsFilterLocaleUpdateBannerImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFilterLocaleUpsertBannerImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobsFilterLocaleUpsertBannerImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFilterLocaleUpsertNoJobImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobsFilterLocaleUpsertNoJobImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LocaleUpsertJobsFiltersRelationInput"]: {
	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],
	update: ResolverInputTypes["JobsFilterLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["JobsFilterLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateGeneralEntityRelationInput"]: {
	create?: ResolverInputTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateGeneralRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertGeneralRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GeneralLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateGeneralRelationInput"]: {
	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	data: ResolverInputTypes["GeneralLocaleWithoutLocaleUpdateInput"]
};
	["GeneralLocaleWithoutLocaleUpdateInput"]: {
	root?: ResolverInputTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	cornerBanner?: ResolverInputTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["GeneralUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GeneralWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GeneralWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["GeneralWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["GeneralWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GeneralLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["GeneralLocaleUpdateCornerBannerEntityRelationInput"]: {
	connect?: ResolverInputTypes["CornerBannerUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CornerBannerCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GeneralLocaleConnectOrCreateCornerBannerRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CornerBannerUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GeneralLocaleUpsertCornerBannerRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CornerBannerUpdateInput"]: {
	isActive?: boolean | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	logo?: ResolverInputTypes["CornerBannerUpdateLogoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["CornerBannerUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CornerBannerUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CornerBannerConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["CornerBannerUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CornerBannerUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["CornerBannerUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CornerBannerConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["CornerBannerUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CornerBannerUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["GeneralLocaleUpsertCornerBannerRelationInput"]: {
	update: ResolverInputTypes["CornerBannerUpdateInput"],
	create: ResolverInputTypes["CornerBannerCreateInput"]
};
	["LocaleUpsertGeneralRelationInput"]: {
	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	update: ResolverInputTypes["GeneralLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateRecommendationFormsEntityRelationInput"]: {
	create?: ResolverInputTypes["RecommendationFormLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateRecommendationFormsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertRecommendationFormsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateRecommendationFormsRelationInput"]: {
	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],
	data: ResolverInputTypes["RecommendationFormLocaleWithoutLocaleUpdateInput"]
};
	["RecommendationFormLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	yourEmailLabel?: string | undefined | null,
	theirEmailLabel?: string | undefined | null,
	yourName?: string | undefined | null,
	sendBtnLabel?: string | undefined | null,
	successTitle?: string | undefined | null,
	successSubtitle?: string | undefined | null,
	successButtonClose?: string | undefined | null,
	root?: ResolverInputTypes["RecommendationFormLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["RecommendationFormUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RecommendationFormWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecommendationFormLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["RecommendationFormWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RecommendationFormLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["RecommendationFormWithoutLocalesUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	successImage?: ResolverInputTypes["RecommendationFormUpdateSuccessImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormUpdateSuccessImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecommendationFormConnectOrCreateSuccessImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RecommendationFormUpsertSuccessImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["RecommendationFormUpsertSuccessImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["RecommendationFormLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["RecommendationFormWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["RecommendationFormWithoutLocalesCreateInput"]
};
	["LocaleUpsertRecommendationFormsRelationInput"]: {
	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],
	update: ResolverInputTypes["RecommendationFormLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["RecommendationFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateInfoBoxesEntityRelationInput"]: {
	create?: ResolverInputTypes["InfoBoxLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateInfoBoxesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertInfoBoxesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["InfoBoxLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["InfoBoxLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["InfoBoxLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateInfoBoxesRelationInput"]: {
	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],
	data: ResolverInputTypes["InfoBoxLocaleWithoutLocaleUpdateInput"]
};
	["InfoBoxLocaleWithoutLocaleUpdateInput"]: {
	address?: string | undefined | null,
	web?: string | undefined | null,
	instagram?: string | undefined | null,
	facebook?: string | undefined | null,
	root?: ResolverInputTypes["InfoBoxLocaleUpdateRootEntityRelationInput"] | undefined | null,
	openingHours?: ResolverInputTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined | null,
	addressLink?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoBoxUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoBoxWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoBoxLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["InfoBoxWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoBoxLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["InfoBoxWithoutLocalesUpdateInput"]: {
	logoSize?: ResolverInputTypes["LogoSize"] | undefined | null,
	logo?: ResolverInputTypes["InfoBoxUpdateLogoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoBoxConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoBoxUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InfoBoxUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["InfoBoxLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["InfoBoxWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["InfoBoxWithoutLocalesCreateInput"]
};
	["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TextListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoBoxLocaleUpsertOpeningHoursRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InfoBoxLocaleUpsertOpeningHoursRelationInput"]: {
	update: ResolverInputTypes["TextListUpdateInput"],
	create: ResolverInputTypes["TextListCreateInput"]
};
	["LocaleUpsertInfoBoxesRelationInput"]: {
	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],
	update: ResolverInputTypes["InfoBoxLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["InfoBoxLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateTranslationsEntityRelationInput"]: {
	create?: ResolverInputTypes["TranslationLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleUpdateTranslationsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["LocaleUpsertTranslationsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TranslationLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TranslationLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TranslationLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateTranslationsRelationInput"]: {
	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],
	data: ResolverInputTypes["TranslationLocaleWithoutLocaleUpdateInput"]
};
	["TranslationLocaleWithoutLocaleUpdateInput"]: {
	value?: string | undefined | null,
	root?: ResolverInputTypes["TranslationLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationWithoutLocalesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationLocaleConnectOrCreateRootRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationLocaleUpsertRootRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null,
	key?: string | undefined | null,
	isTextarea?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["TranslationWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["TranslationWithoutLocalesCreateInput"]
};
	["LocaleUpsertTranslationsRelationInput"]: {
	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],
	update: ResolverInputTypes["TranslationLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["TranslationLocaleWithoutLocaleCreateInput"]
};
	["HomePageLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutHomePagesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutHomePagesCreateInput"]
};
	["HomePageLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLocaleUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"]: {
	connect?: ResolverInputTypes["SiteSwitcherUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SiteSwitcherCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SiteSwitcherUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertSiteSwitcherRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SiteSwitcherUpdateInput"]: {
	title?: string | undefined | null,
	link?: ResolverInputTypes["SiteSwitcherUpdateLinkEntityRelationInput"] | undefined | null,
	theme?: ResolverInputTypes["SiteSwitcherUpdateThemeEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SiteSwitcherUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SiteSwitcherConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SiteSwitcherUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SiteSwitcherUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["SiteSwitcherUpdateThemeEntityRelationInput"]: {
	connect?: ResolverInputTypes["ThemeUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ThemeCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SiteSwitcherConnectOrCreateThemeRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ThemeUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SiteSwitcherUpsertThemeRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SiteSwitcherUpsertThemeRelationInput"]: {
	update: ResolverInputTypes["ThemeUpdateInput"],
	create: ResolverInputTypes["ThemeCreateInput"]
};
	["HomePageLocaleUpsertSiteSwitcherRelationInput"]: {
	update: ResolverInputTypes["SiteSwitcherUpdateInput"],
	create: ResolverInputTypes["SiteSwitcherCreateInput"]
};
	["HomePageLocaleUpdateGalleryEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateGalleryRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GalleryUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertGalleryRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GalleryUpdateInput"]: {
	items?: Array<ResolverInputTypes["GalleryUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["GalleryItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["GalleryUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["GalleryUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GalleryItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GalleryItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GalleryItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GalleryUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["GalleryItemUniqueWhere"],
	data: ResolverInputTypes["GalleryItemWithoutListUpdateInput"]
};
	["GalleryItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	image?: ResolverInputTypes["GalleryItemUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GalleryItemConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GalleryItemUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GalleryItemUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["GalleryUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["GalleryItemUniqueWhere"],
	update: ResolverInputTypes["GalleryItemWithoutListUpdateInput"],
	create: ResolverInputTypes["GalleryItemWithoutListCreateInput"]
};
	["HomePageLocaleUpsertGalleryRelationInput"]: {
	update: ResolverInputTypes["GalleryUpdateInput"],
	create: ResolverInputTypes["GalleryCreateInput"]
};
	["HomePageLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ResolverInputTypes["StickyBarUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StickyBarCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null,
	update?: ResolverInputTypes["StickyBarUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertStickyBarRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLocaleUpsertStickyBarRelationInput"]: {
	update: ResolverInputTypes["StickyBarUpdateInput"],
	create: ResolverInputTypes["StickyBarCreateInput"]
};
	["HomePageLocaleUpdateIlustrationEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLocaleConnectOrCreateIlustrationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GalleryUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLocaleUpsertIlustrationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLocaleUpsertIlustrationRelationInput"]: {
	update: ResolverInputTypes["GalleryUpdateInput"],
	create: ResolverInputTypes["GalleryCreateInput"]
};
	["LinkableUpsertHomePageRelationInput"]: {
	update: ResolverInputTypes["HomePageLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["HomePageLocaleWithoutLinkCreateInput"]
};
	["HomePageLokalLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutHomePageLokalUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutHomePageLokalCreateInput"]
};
	["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"]: {
	connect?: ResolverInputTypes["SiteSwitcherUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SiteSwitcherCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SiteSwitcherUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertSiteSwitcherRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalLocaleUpsertSiteSwitcherRelationInput"]: {
	update: ResolverInputTypes["SiteSwitcherUpdateInput"],
	create: ResolverInputTypes["SiteSwitcherCreateInput"]
};
	["HomePageLokalLocaleUpdateGalleryEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GalleryUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertGalleryRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalLocaleUpsertGalleryRelationInput"]: {
	update: ResolverInputTypes["GalleryUpdateInput"],
	create: ResolverInputTypes["GalleryCreateInput"]
};
	["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ResolverInputTypes["StickyBarUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StickyBarCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null,
	update?: ResolverInputTypes["StickyBarUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertStickyBarRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalLocaleUpsertStickyBarRelationInput"]: {
	update: ResolverInputTypes["StickyBarUpdateInput"],
	create: ResolverInputTypes["StickyBarCreateInput"]
};
	["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GalleryUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertIlustrationRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalLocaleUpsertIlustrationRelationInput"]: {
	update: ResolverInputTypes["GalleryUpdateInput"],
	create: ResolverInputTypes["GalleryCreateInput"]
};
	["LocaleUpsertHomePageLokalsRelationInput"]: {
	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],
	update: ResolverInputTypes["HomePageLokalLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["HomePageLokalLocaleWithoutLocaleCreateInput"]
};
	["JobsFormLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutJobsFormsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutJobsFormsCreateInput"]
};
	["StickyBarUpsertJobsFormRelationInput"]: {
	update: ResolverInputTypes["JobsFormLocaleUpdateInput"],
	create: ResolverInputTypes["JobsFormLocaleCreateInput"]
};
	["JobPageLocaleUpsertStickyBarRelationInput"]: {
	update: ResolverInputTypes["StickyBarUpdateInput"],
	create: ResolverInputTypes["StickyBarCreateInput"]
};
	["JobPageLocaleUpdateMobileImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateMobileImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageLocaleUpsertMobileImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobPageLocaleUpsertMobileImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LinkableUpsertJobPageRelationInput"]: {
	update: ResolverInputTypes["JobPageLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["JobPageLocaleWithoutLinkCreateInput"]
};
	["LinkableUpdateHomePageLokalEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageLokalLocaleWithoutLinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["LinkableConnectOrCreateHomePageLokalRelationInput"] | undefined | null,
	update?: ResolverInputTypes["HomePageLokalLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["LinkableUpsertHomePageLokalRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HomePageLokalLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutHomePageLokalsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutHomePageLokalsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutHomePageLokalsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutHomePageLokalsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutHomePageLokalsCreateInput"]
};
	["LinkableUpsertHomePageLokalRelationInput"]: {
	update: ResolverInputTypes["HomePageLokalLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["HomePageLokalLocaleWithoutLinkCreateInput"]
};
	["HomePageLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutHomePageUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutHomePageCreateInput"]
};
	["LocaleUpsertHomePagesRelationInput"]: {
	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],
	update: ResolverInputTypes["HomePageLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["HomePageLocaleWithoutLocaleCreateInput"]
};
	["JobPageLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutJobPagesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutJobPagesCreateInput"]
};
	["JobPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutJobPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutJobPageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutJobPageUpdateInput"]: {
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutJobPageUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutJobPageCreateInput"]
};
	["JobPageUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],
	update: ResolverInputTypes["JobPageLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["JobPageLocaleWithoutRootCreateInput"]
};
	["JobPageUpdateJobCityEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobCityUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobCityCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateJobCityRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobCityUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageUpsertJobCityRelationInput"] | undefined | null
};
	["JobCityUpdateInput"]: {
	locales?: Array<ResolverInputTypes["JobCityUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["JobCityLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["JobCityUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobCityUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobCityLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobCityLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobCityLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["JobCityUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],
	data: ResolverInputTypes["JobCityLocaleWithoutRootUpdateInput"]
};
	["JobCityLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["JobCityLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutJobCitiesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobCityLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutJobCitiesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobCityLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutJobCitiesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutJobCitiesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutJobCitiesCreateInput"]
};
	["JobCityUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],
	update: ResolverInputTypes["JobCityLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["JobCityLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertJobCityRelationInput"]: {
	update: ResolverInputTypes["JobCityUpdateInput"],
	create: ResolverInputTypes["JobCityCreateInput"]
};
	["JobPageUpdateBusinessEntityRelationInput"]: {
	connect?: ResolverInputTypes["BusinessPageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BusinessPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateBusinessRelationInput"] | undefined | null,
	update?: ResolverInputTypes["BusinessPageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageUpsertBusinessRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessPageUpdateInput"]: {
	locales?: Array<ResolverInputTypes["BusinessPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["BusinessPageUpdateThemeEntityRelationInput"] | undefined | null,
	isLokal?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	headerColor?: string | undefined | null,
	recruitisOfficeId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["BusinessPageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["BusinessPageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessPageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["BusinessPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessPageUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],
	data: ResolverInputTypes["BusinessPageLocaleWithoutRootUpdateInput"]
};
	["BusinessPageLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	text?: string | undefined | null,
	name?: string | undefined | null,
	image?: ResolverInputTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	infoBox?: ResolverInputTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateSeoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessPageLocaleUpsertSeoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessPageLocaleUpsertSeoRelationInput"]: {
	update: ResolverInputTypes["SeoUpdateInput"],
	create: ResolverInputTypes["SeoCreateInput"]
};
	["BusinessPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutBusinessPageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutBusinessPageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessPageLocaleUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutBusinessPageUpdateInput"]: {
	url?: string | undefined | null,
	redirect?: ResolverInputTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutBusinessPageUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutBusinessPageCreateInput"]
};
	["BusinessPageLocaleUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessPageLocaleUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessPageLocaleUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["BusinessPageLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ResolverInputTypes["StickyBarUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["StickyBarCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined | null,
	update?: ResolverInputTypes["StickyBarUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessPageLocaleUpsertStickyBarRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessPageLocaleUpsertStickyBarRelationInput"]: {
	update: ResolverInputTypes["StickyBarUpdateInput"],
	create: ResolverInputTypes["StickyBarCreateInput"]
};
	["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"]: {
	connect?: ResolverInputTypes["InfoBoxUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["InfoBoxCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"] | undefined | null,
	update?: ResolverInputTypes["InfoBoxUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["BusinessPageLocaleUpsertInfoBoxRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InfoBoxUpdateInput"]: {
	logoSize?: ResolverInputTypes["LogoSize"] | undefined | null,
	logo?: ResolverInputTypes["InfoBoxUpdateLogoEntityRelationInput"] | undefined | null,
	locales?: Array<ResolverInputTypes["InfoBoxUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["InfoBoxLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["InfoBoxUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoBoxUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["InfoBoxLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["InfoBoxLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["InfoBoxLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["InfoBoxUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],
	data: ResolverInputTypes["InfoBoxLocaleWithoutRootUpdateInput"]
};
	["InfoBoxLocaleWithoutRootUpdateInput"]: {
	address?: string | undefined | null,
	web?: string | undefined | null,
	instagram?: string | undefined | null,
	facebook?: string | undefined | null,
	locale?: ResolverInputTypes["InfoBoxLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	openingHours?: ResolverInputTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined | null,
	addressLink?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutInfoBoxesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["InfoBoxLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutInfoBoxesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["InfoBoxLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutInfoBoxesUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutInfoBoxesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutInfoBoxesCreateInput"]
};
	["InfoBoxUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],
	update: ResolverInputTypes["InfoBoxLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["InfoBoxLocaleWithoutRootCreateInput"]
};
	["BusinessPageLocaleUpsertInfoBoxRelationInput"]: {
	update: ResolverInputTypes["InfoBoxUpdateInput"],
	create: ResolverInputTypes["InfoBoxCreateInput"]
};
	["BusinessPageUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],
	update: ResolverInputTypes["BusinessPageLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["BusinessPageLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertBusinessRelationInput"]: {
	update: ResolverInputTypes["BusinessPageUpdateInput"],
	create: ResolverInputTypes["BusinessPageCreateInput"]
};
	["JobPositionUpsertJobsRelationInput"]: {
	by: ResolverInputTypes["JobPageUniqueWhere"],
	update: ResolverInputTypes["JobPageWithoutJobPositionUpdateInput"],
	create: ResolverInputTypes["JobPageWithoutJobPositionCreateInput"]
};
	["JobPositionLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["JobPositionWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["JobPositionWithoutLocalesCreateInput"]
};
	["LocaleUpsertJobPositionsRelationInput"]: {
	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],
	update: ResolverInputTypes["JobPositionLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["JobPositionLocaleWithoutLocaleCreateInput"]
};
	["ContractTypeLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutContractTypesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutContractTypesCreateInput"]
};
	["ContractTypeUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],
	update: ResolverInputTypes["ContractTypeLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["ContractTypeLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertContractTypeRelationInput"]: {
	update: ResolverInputTypes["ContractTypeUpdateInput"],
	create: ResolverInputTypes["ContractTypeCreateInput"]
};
	["JobPageUpdateJobPositionEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPositionUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPositionWithoutJobsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPageConnectOrCreateJobPositionRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobPositionWithoutJobsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPageUpsertJobPositionRelationInput"] | undefined | null
};
	["JobPositionWithoutJobsUpdateInput"]: {
	locales?: Array<ResolverInputTypes["JobPositionUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["JobPositionLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["JobPositionUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPositionUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobPositionLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobPositionLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobPositionLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["JobPositionUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],
	data: ResolverInputTypes["JobPositionLocaleWithoutRootUpdateInput"]
};
	["JobPositionLocaleWithoutRootUpdateInput"]: {
	type?: string | undefined | null,
	locale?: ResolverInputTypes["JobPositionLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutJobPositionsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobPositionLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutJobPositionsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobPositionLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutJobPositionsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutJobPositionsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutJobPositionsCreateInput"]
};
	["JobPositionUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],
	update: ResolverInputTypes["JobPositionLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["JobPositionLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertJobPositionRelationInput"]: {
	update: ResolverInputTypes["JobPositionWithoutJobsUpdateInput"],
	create: ResolverInputTypes["JobPositionWithoutJobsCreateInput"]
};
	["JobPageLocaleUpsertRootRelationInput"]: {
	update: ResolverInputTypes["JobPageWithoutLocalesUpdateInput"],
	create: ResolverInputTypes["JobPageWithoutLocalesCreateInput"]
};
	["LocaleUpsertJobPagesRelationInput"]: {
	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],
	update: ResolverInputTypes["JobPageLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["JobPageLocaleWithoutLocaleCreateInput"]
};
	["BusinessPageLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutBusinessPagesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutBusinessPagesCreateInput"]
};
	["LinkableUpsertBusinessPageRelationInput"]: {
	update: ResolverInputTypes["BusinessPageLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["BusinessPageLocaleWithoutLinkCreateInput"]
};
	["GenericPageLocaleUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutGenericPageUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateLogoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertLogoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageLocaleUpsertLogoRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["GenericPageLocaleUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageLocaleConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageLocaleUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GenericPageLocaleUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["LocaleUpsertGenericPagesRelationInput"]: {
	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	update: ResolverInputTypes["GenericPageLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["BonusBannerLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutBonusBannersUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutBonusBannersCreateInput"]
};
	["ContentReferenceUpsertBonusBannerRelationInput"]: {
	update: ResolverInputTypes["BonusBannerLocaleUpdateInput"],
	create: ResolverInputTypes["BonusBannerLocaleCreateInput"]
};
	["ContentReferenceUpdateSideBySideEntityRelationInput"]: {
	connect?: ResolverInputTypes["SideBySideUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SideBySideCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateSideBySideRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SideBySideUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertSideBySideRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SideBySideUpdateInput"]: {
	items?: Array<ResolverInputTypes["SideBySideUpdateItemsEntityRelationInput"]> | undefined | null,
	background?: ResolverInputTypes["Background"] | undefined | null,
	alignment?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	mediumSize?: ResolverInputTypes["MediumSize"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SideBySideUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["SideBySideItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["SideBySideUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["SideBySideUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["SideBySideItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["SideBySideItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["SideBySideItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["SideBySideUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["SideBySideItemUniqueWhere"],
	data: ResolverInputTypes["SideBySideItemWithoutListUpdateInput"]
};
	["SideBySideItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	media?: ResolverInputTypes["SideBySideItemUpdateMediaEntityRelationInput"] | undefined | null,
	formButtonLabel?: string | undefined | null,
	type?: ResolverInputTypes["SideBySideItemType"] | undefined | null,
	link?: ResolverInputTypes["SideBySideItemUpdateLinkEntityRelationInput"] | undefined | null,
	jobsForm?: ResolverInputTypes["SideBySideItemUpdateJobsFormEntityRelationInput"] | undefined | null,
	textNew?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SideBySideItemUpdateMediaEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SideBySideItemConnectOrCreateMediaRelationInput"] | undefined | null,
	update?: ResolverInputTypes["MediumListUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SideBySideItemUpsertMediaRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SideBySideItemUpsertMediaRelationInput"]: {
	update: ResolverInputTypes["MediumListUpdateInput"],
	create: ResolverInputTypes["MediumListCreateInput"]
};
	["SideBySideItemUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SideBySideItemConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SideBySideItemUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SideBySideItemUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["SideBySideItemUpdateJobsFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SideBySideItemConnectOrCreateJobsFormRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobsFormLocaleUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SideBySideItemUpsertJobsFormRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SideBySideItemUpsertJobsFormRelationInput"]: {
	update: ResolverInputTypes["JobsFormLocaleUpdateInput"],
	create: ResolverInputTypes["JobsFormLocaleCreateInput"]
};
	["SideBySideUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["SideBySideItemUniqueWhere"],
	update: ResolverInputTypes["SideBySideItemWithoutListUpdateInput"],
	create: ResolverInputTypes["SideBySideItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertSideBySideRelationInput"]: {
	update: ResolverInputTypes["SideBySideUpdateInput"],
	create: ResolverInputTypes["SideBySideCreateInput"]
};
	["ContentReferenceUpdateGalleryEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateGalleryRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GalleryUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertGalleryRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertGalleryRelationInput"]: {
	update: ResolverInputTypes["GalleryUpdateInput"],
	create: ResolverInputTypes["GalleryCreateInput"]
};
	["ContentReferenceUpdateVideoEntityRelationInput"]: {
	connect?: ResolverInputTypes["VideoUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["VideoCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined | null,
	update?: ResolverInputTypes["VideoUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertVideoRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertVideoRelationInput"]: {
	update: ResolverInputTypes["VideoUpdateInput"],
	create: ResolverInputTypes["VideoCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by: ResolverInputTypes["ContentReferenceUniqueWhere"],
	update: ResolverInputTypes["ContentReferenceWithoutBlockUpdateInput"],
	create: ResolverInputTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
	by: ResolverInputTypes["ContentBlockUniqueWhere"],
	update: ResolverInputTypes["ContentBlockWithoutContentUpdateInput"],
	create: ResolverInputTypes["ContentBlockWithoutContentCreateInput"]
};
	["BusinessPageLocaleUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentUpdateInput"],
	create: ResolverInputTypes["ContentCreateInput"]
};
	["LocaleUpsertBusinessPagesRelationInput"]: {
	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],
	update: ResolverInputTypes["BusinessPageLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["BusinessPageLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutGenericPagesUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableUpsertGenericPageRelationInput"]: {
	update: ResolverInputTypes["GenericPageLocaleWithoutLinkUpdateInput"],
	create: ResolverInputTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableUpdateInput"],
	create: ResolverInputTypes["LinkableCreateInput"]
};
	["FooterLinkUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["FooterLocaleUpsertLinksFirstColumnRelationInput"]: {
	by: ResolverInputTypes["FooterLinkUniqueWhere"],
	update: ResolverInputTypes["FooterLinkUpdateInput"],
	create: ResolverInputTypes["FooterLinkCreateInput"]
};
	["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]: {
	create?: ResolverInputTypes["FooterLinkCreateInput"] | undefined | null,
	update?: ResolverInputTypes["FooterLocaleUpdateLinksSecondColumnRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertLinksSecondColumnRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["FooterLinkUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["FooterLinkUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["FooterLinkUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FooterLocaleUpdateLinksSecondColumnRelationInput"]: {
	by: ResolverInputTypes["FooterLinkUniqueWhere"],
	data: ResolverInputTypes["FooterLinkUpdateInput"]
};
	["FooterLocaleUpsertLinksSecondColumnRelationInput"]: {
	by: ResolverInputTypes["FooterLinkUniqueWhere"],
	update: ResolverInputTypes["FooterLinkUpdateInput"],
	create: ResolverInputTypes["FooterLinkCreateInput"]
};
	["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertTermsAndConditionsRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterLocaleUpsertTermsAndConditionsRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateBannerImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateBannerImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertBannerImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterLocaleUpsertBannerImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["FooterLocaleUpdateBannerLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateBannerLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertBannerLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterLocaleUpsertBannerLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateJobsFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateJobsFormRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobsFormLocaleUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertJobsFormRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterLocaleUpsertJobsFormRelationInput"]: {
	update: ResolverInputTypes["JobsFormLocaleUpdateInput"],
	create: ResolverInputTypes["JobsFormLocaleCreateInput"]
};
	["FooterLocaleUpdateCopyrightLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertCopyrightLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterLocaleUpsertCopyrightLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateRecommendationFormEntityRelationInput"]: {
	connect?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RecommendationFormLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateRecommendationFormRelationInput"] | undefined | null,
	update?: ResolverInputTypes["RecommendationFormLocaleUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertRecommendationFormRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["RecommendationFormLocaleUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	yourEmailLabel?: string | undefined | null,
	theirEmailLabel?: string | undefined | null,
	yourName?: string | undefined | null,
	sendBtnLabel?: string | undefined | null,
	successTitle?: string | undefined | null,
	successSubtitle?: string | undefined | null,
	successButtonClose?: string | undefined | null,
	root?: ResolverInputTypes["RecommendationFormLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["RecommendationFormLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutRecommendationFormsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutRecommendationFormsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RecommendationFormLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutRecommendationFormsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutRecommendationFormsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutRecommendationFormsCreateInput"]
};
	["FooterLocaleUpsertRecommendationFormRelationInput"]: {
	update: ResolverInputTypes["RecommendationFormLocaleUpdateInput"],
	create: ResolverInputTypes["RecommendationFormLocaleCreateInput"]
};
	["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertBannerSecondLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterLocaleUpsertBannerSecondLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateInstagramLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateInstagramLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertInstagramLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FooterLocaleUpsertInstagramLinkRelationInput"]: {
	update: ResolverInputTypes["LinkUpdateInput"],
	create: ResolverInputTypes["LinkCreateInput"]
};
	["LocaleUpsertFootersRelationInput"]: {
	by: ResolverInputTypes["FooterLocaleUniqueWhere"],
	update: ResolverInputTypes["FooterLocaleWithoutLocaleUpdateInput"],
	create: ResolverInputTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutGeneralUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutGeneralCreateInput"]
};
	["GeneralUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],
	update: ResolverInputTypes["GeneralLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["ImageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ImageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageEdge"]: AliasType<{
	node?:ResolverInputTypes["Image"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GenericPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageEdge"]: AliasType<{
	node?:ResolverInputTypes["GenericPage"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["GenericPageCreateThemeEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GenericPageConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	logo?: ResolverInputTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	create: ResolverInputTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["GenericPageUpdateInput"]: {
	locales?: Array<ResolverInputTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["GenericPageUpdateThemeEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["GenericPageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["GenericPageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["GenericPageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GenericPageUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	data: ResolverInputTypes["GenericPageLocaleWithoutRootUpdateInput"]
};
	["GenericPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	logo?: ResolverInputTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],
	update: ResolverInputTypes["GenericPageLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["LinkableConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["LinkableEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableEdge"]: AliasType<{
	node?:ResolverInputTypes["Linkable"],
		__typename?: boolean | `@${string}`
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["SeoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SeoEdge"]: AliasType<{
	node?:ResolverInputTypes["Seo"],
		__typename?: boolean | `@${string}`
}>;
	["ContentConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ContentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentEdge"]: AliasType<{
	node?:ResolverInputTypes["Content"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ResolverInputTypes["ContentBlockCreateContentEntityRelationInput"] | undefined | null,
	references?: Array<ResolverInputTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentWithoutBlocksCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined | null
};
	["ContentWithoutBlocksCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockConnectOrCreateContentRelationInput"]: {
	connect: ResolverInputTypes["ContentUniqueWhere"],
	create: ResolverInputTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentBlockUpdateInput"]: {
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ResolverInputTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined | null,
	references?: Array<ResolverInputTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentWithoutBlocksCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentWithoutBlocksUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentBlockUpsertContentRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpsertContentRelationInput"]: {
	update: ResolverInputTypes["ContentWithoutBlocksUpdateInput"],
	create: ResolverInputTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	block?: ResolverInputTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined | null,
	linkables?: Array<ResolverInputTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined | null,
	secondaryText?: string | undefined | null,
	link?: ResolverInputTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined | null,
	textList?: ResolverInputTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined | null,
	carousel?: ResolverInputTypes["ContentReferenceCreateCarouselEntityRelationInput"] | undefined | null,
	bonusBanner?: ResolverInputTypes["ContentReferenceCreateBonusBannerEntityRelationInput"] | undefined | null,
	sideBySide?: ResolverInputTypes["ContentReferenceCreateSideBySideEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined | null,
	showBoolean?: boolean | undefined | null,
	isRed?: boolean | undefined | null,
	video?: ResolverInputTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined | null
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ResolverInputTypes["ContentBlockCreateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceConnectOrCreateBlockRelationInput"]: {
	connect: ResolverInputTypes["ContentBlockUniqueWhere"],
	create: ResolverInputTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceUpdateInput"]: {
	type?: ResolverInputTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	block?: ResolverInputTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined | null,
	linkables?: Array<ResolverInputTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined | null,
	secondaryText?: string | undefined | null,
	link?: ResolverInputTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined | null,
	textList?: ResolverInputTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined | null,
	carousel?: ResolverInputTypes["ContentReferenceUpdateCarouselEntityRelationInput"] | undefined | null,
	bonusBanner?: ResolverInputTypes["ContentReferenceUpdateBonusBannerEntityRelationInput"] | undefined | null,
	sideBySide?: ResolverInputTypes["ContentReferenceUpdateSideBySideEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined | null,
	showBoolean?: boolean | undefined | null,
	isRed?: boolean | undefined | null,
	video?: ResolverInputTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	connect?: ResolverInputTypes["ContentBlockUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ContentReferenceUpsertBlockRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ResolverInputTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update: ResolverInputTypes["ContentBlockWithoutReferencesUpdateInput"],
	create: ResolverInputTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["RedirectConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["RedirectEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectEdge"]: AliasType<{
	node?:ResolverInputTypes["Redirect"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	link?: ResolverInputTypes["RedirectCreateLinkEntityRelationInput"] | undefined | null,
	target?: ResolverInputTypes["RedirectCreateTargetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectCreateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutRedirectCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RedirectConnectOrCreateLinkRelationInput"] | undefined | null
};
	["LinkableWithoutRedirectCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableCreateJobPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableCreateHomePageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectConnectOrCreateLinkRelationInput"]: {
	connect: ResolverInputTypes["LinkableUniqueWhere"],
	create: ResolverInputTypes["LinkableWithoutRedirectCreateInput"]
};
	["RedirectUpdateInput"]: {
	link?: ResolverInputTypes["RedirectUpdateLinkEntityRelationInput"] | undefined | null,
	target?: ResolverInputTypes["RedirectUpdateTargetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectUpdateLinkEntityRelationInput"]: {
	connect?: ResolverInputTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LinkableWithoutRedirectCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RedirectConnectOrCreateLinkRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LinkableWithoutRedirectUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["RedirectUpsertLinkRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutRedirectUpdateInput"]: {
	url?: string | undefined | null,
	genericPage?: ResolverInputTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined | null,
	businessPage?: ResolverInputTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined | null,
	jobPage?: ResolverInputTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined | null,
	homePage?: ResolverInputTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined | null,
	homePageLokal?: ResolverInputTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectUpsertLinkRelationInput"]: {
	update: ResolverInputTypes["LinkableWithoutRedirectUpdateInput"],
	create: ResolverInputTypes["LinkableWithoutRedirectCreateInput"]
};
	["LinkConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["LinkEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkEdge"]: AliasType<{
	node?:ResolverInputTypes["Link"],
		__typename?: boolean | `@${string}`
}>;
	["FooterConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FooterEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FooterEdge"]: AliasType<{
	node?:ResolverInputTypes["Footer"],
		__typename?: boolean | `@${string}`
}>;
	["FooterCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["FooterCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FooterLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FooterLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	email?: string | undefined | null,
	address?: string | undefined | null,
	ico?: string | undefined | null,
	dic?: string | undefined | null,
	copyright?: string | undefined | null,
	note?: string | undefined | null,
	noteSecond?: string | undefined | null,
	locale?: ResolverInputTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	linksFirstColumn?: Array<ResolverInputTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined | null,
	linksSecondColumn?: Array<ResolverInputTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined | null,
	termsAndConditions?: ResolverInputTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined | null,
	form?: string | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerSubtitle?: string | undefined | null,
	bannerImage?: ResolverInputTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined | null,
	bannerLink?: ResolverInputTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined | null,
	jobsForm?: ResolverInputTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined | null,
	copyrightLink?: ResolverInputTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined | null,
	bannerSecondBtn?: string | undefined | null,
	recommendationForm?: ResolverInputTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined | null,
	bannerSecondLink?: ResolverInputTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined | null,
	instagramLink?: ResolverInputTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutFootersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutFootersCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["FooterLocaleUniqueWhere"],
	create: ResolverInputTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["FooterUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["FooterLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["FooterUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["FooterLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FooterUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["FooterLocaleUniqueWhere"],
	data: ResolverInputTypes["FooterLocaleWithoutRootUpdateInput"]
};
	["FooterLocaleWithoutRootUpdateInput"]: {
	email?: string | undefined | null,
	address?: string | undefined | null,
	ico?: string | undefined | null,
	dic?: string | undefined | null,
	copyright?: string | undefined | null,
	note?: string | undefined | null,
	noteSecond?: string | undefined | null,
	locale?: ResolverInputTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	linksFirstColumn?: Array<ResolverInputTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined | null,
	linksSecondColumn?: Array<ResolverInputTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined | null,
	termsAndConditions?: ResolverInputTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined | null,
	form?: string | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerSubtitle?: string | undefined | null,
	bannerImage?: ResolverInputTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null,
	bannerLink?: ResolverInputTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined | null,
	jobsForm?: ResolverInputTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined | null,
	copyrightLink?: ResolverInputTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined | null,
	bannerSecondBtn?: string | undefined | null,
	recommendationForm?: ResolverInputTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined | null,
	bannerSecondLink?: ResolverInputTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined | null,
	instagramLink?: ResolverInputTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutFootersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutFootersUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["FooterLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutFootersUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutFootersUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["FooterLocaleUniqueWhere"],
	update: ResolverInputTypes["FooterLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	email?: string | undefined | null,
	address?: string | undefined | null,
	ico?: string | undefined | null,
	dic?: string | undefined | null,
	copyright?: string | undefined | null,
	note?: string | undefined | null,
	noteSecond?: string | undefined | null,
	root?: ResolverInputTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	linksFirstColumn?: Array<ResolverInputTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined | null,
	linksSecondColumn?: Array<ResolverInputTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined | null,
	termsAndConditions?: ResolverInputTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined | null,
	form?: string | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerSubtitle?: string | undefined | null,
	bannerImage?: ResolverInputTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined | null,
	bannerLink?: ResolverInputTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined | null,
	jobsForm?: ResolverInputTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined | null,
	copyrightLink?: ResolverInputTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined | null,
	bannerSecondBtn?: string | undefined | null,
	recommendationForm?: ResolverInputTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined | null,
	bannerSecondLink?: ResolverInputTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined | null,
	instagramLink?: ResolverInputTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FooterLocaleUpdateInput"]: {
	email?: string | undefined | null,
	address?: string | undefined | null,
	ico?: string | undefined | null,
	dic?: string | undefined | null,
	copyright?: string | undefined | null,
	note?: string | undefined | null,
	noteSecond?: string | undefined | null,
	root?: ResolverInputTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	linksFirstColumn?: Array<ResolverInputTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined | null,
	linksSecondColumn?: Array<ResolverInputTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined | null,
	termsAndConditions?: ResolverInputTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined | null,
	form?: string | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerSubtitle?: string | undefined | null,
	bannerImage?: ResolverInputTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null,
	bannerLink?: ResolverInputTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined | null,
	jobsForm?: ResolverInputTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined | null,
	copyrightLink?: ResolverInputTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined | null,
	bannerSecondBtn?: string | undefined | null,
	recommendationForm?: ResolverInputTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined | null,
	bannerSecondLink?: ResolverInputTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined | null,
	instagramLink?: ResolverInputTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	logo?: ResolverInputTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GenericPageLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	logo?: ResolverInputTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["HeaderEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderEdge"]: AliasType<{
	node?:ResolverInputTypes["Header"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["HeaderCreateLocalesEntityRelationInput"]> | undefined | null,
	logo?: ResolverInputTypes["HeaderCreateLogoEntityRelationInput"] | undefined | null,
	logoMenu?: ResolverInputTypes["HeaderCreateLogoMenuEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HeaderLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HeaderLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	menuLabel?: string | undefined | null,
	menuTitle?: string | undefined | null,
	menuText?: string | undefined | null,
	business?: Array<ResolverInputTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined | null,
	lokalEnterprise?: Array<ResolverInputTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined | null,
	businessSectionTitle?: string | undefined | null,
	lokalSectionTitle?: string | undefined | null,
	businessLink?: ResolverInputTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined | null,
	lokalLink?: ResolverInputTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutHeadersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutHeadersCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	create: ResolverInputTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["HeaderUpdateLocalesEntityRelationInput"]> | undefined | null,
	logo?: ResolverInputTypes["HeaderUpdateLogoEntityRelationInput"] | undefined | null,
	logoMenu?: ResolverInputTypes["HeaderUpdateLogoMenuEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["HeaderLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["HeaderUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["HeaderLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["HeaderUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	data: ResolverInputTypes["HeaderLocaleWithoutRootUpdateInput"]
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	menuLabel?: string | undefined | null,
	menuTitle?: string | undefined | null,
	menuText?: string | undefined | null,
	business?: Array<ResolverInputTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined | null,
	lokalEnterprise?: Array<ResolverInputTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined | null,
	businessSectionTitle?: string | undefined | null,
	lokalSectionTitle?: string | undefined | null,
	businessLink?: ResolverInputTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined | null,
	lokalLink?: ResolverInputTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutHeadersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutHeadersUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["HeaderLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutHeadersUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutHeadersUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],
	update: ResolverInputTypes["HeaderLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	menuLabel?: string | undefined | null,
	menuTitle?: string | undefined | null,
	menuText?: string | undefined | null,
	business?: Array<ResolverInputTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined | null,
	lokalEnterprise?: Array<ResolverInputTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined | null,
	businessSectionTitle?: string | undefined | null,
	lokalSectionTitle?: string | undefined | null,
	businessLink?: ResolverInputTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined | null,
	lokalLink?: ResolverInputTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeaderLocaleUpdateInput"]: {
	root?: ResolverInputTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	menuLabel?: string | undefined | null,
	menuTitle?: string | undefined | null,
	menuText?: string | undefined | null,
	business?: Array<ResolverInputTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined | null,
	lokalEnterprise?: Array<ResolverInputTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined | null,
	businessSectionTitle?: string | undefined | null,
	lokalSectionTitle?: string | undefined | null,
	businessLink?: ResolverInputTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined | null,
	lokalLink?: ResolverInputTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["LocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleEdge"]: AliasType<{
	node?:ResolverInputTypes["Locale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["SeoDefaultEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultEdge"]: AliasType<{
	node?:ResolverInputTypes["SeoDefault"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["SeoDefaultCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SeoDefaultLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoDefaultConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SeoDefaultLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locale?: ResolverInputTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutSeoDefaultsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutSeoDefaultsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutSeoDefaultsCreateInput"]
};
	["SeoDefaultConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],
	create: ResolverInputTypes["SeoDefaultLocaleWithoutRootCreateInput"]
};
	["SeoDefaultUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["SeoDefaultUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["SeoDefaultLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["SeoDefaultUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["SeoDefaultUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["SeoDefaultUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],
	data: ResolverInputTypes["SeoDefaultLocaleWithoutRootUpdateInput"]
};
	["SeoDefaultLocaleWithoutRootUpdateInput"]: {
	locale?: ResolverInputTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutSeoDefaultsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutSeoDefaultsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SeoDefaultLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutSeoDefaultsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutSeoDefaultsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutSeoDefaultsCreateInput"]
};
	["SeoDefaultUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],
	update: ResolverInputTypes["SeoDefaultLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["SeoDefaultLocaleWithoutRootCreateInput"]
};
	["SeoDefaultLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["SeoDefaultLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoDefaultLocaleUpdateInput"]: {
	root?: ResolverInputTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["BusinessPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageEdge"]: AliasType<{
	node?:ResolverInputTypes["BusinessPage"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	text?: string | undefined | null,
	name?: string | undefined | null,
	image?: ResolverInputTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	infoBox?: ResolverInputTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessPageLocaleUpdateInput"]: {
	root?: ResolverInputTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	subtitle?: string | undefined | null,
	text?: string | undefined | null,
	name?: string | undefined | null,
	image?: ResolverInputTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	infoBox?: ResolverInputTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IconConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["IconEdge"],
		__typename?: boolean | `@${string}`
}>;
	["IconEdge"]: AliasType<{
	node?:ResolverInputTypes["Icon"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["JobPageCreateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["JobPageCreateThemeEntityRelationInput"] | undefined | null,
	contractType?: ResolverInputTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined | null,
	jobCity?: ResolverInputTypes["JobPageCreateJobCityEntityRelationInput"] | undefined | null,
	isActive?: boolean | undefined | null,
	jobPosition?: ResolverInputTypes["JobPageCreateJobPositionEntityRelationInput"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	order?: number | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	business?: ResolverInputTypes["JobPageCreateBusinessEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	siteType?: ResolverInputTypes["SiteType"] | undefined | null,
	isHiddenFromListing?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageUpdateInput"]: {
	locales?: Array<ResolverInputTypes["JobPageUpdateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["JobPageUpdateThemeEntityRelationInput"] | undefined | null,
	contractType?: ResolverInputTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined | null,
	jobCity?: ResolverInputTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined | null,
	isActive?: boolean | undefined | null,
	jobPosition?: ResolverInputTypes["JobPageUpdateJobPositionEntityRelationInput"] | undefined | null,
	publishedAt?: ResolverInputTypes["DateTime"] | undefined | null,
	order?: number | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	business?: ResolverInputTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined | null,
	headerColor?: string | undefined | null,
	siteType?: ResolverInputTypes["SiteType"] | undefined | null,
	isHiddenFromListing?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined | null,
	keyInfo?: ResolverInputTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	stickyBar?: ResolverInputTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	mobileImage?: ResolverInputTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	recruitisJobId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPageLocaleUpdateInput"]: {
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined | null,
	keyInfo?: ResolverInputTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	stickyBar?: ResolverInputTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	mobileImage?: ResolverInputTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	recruitisJobId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["KeyInfoItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	keyInfo?: string | undefined | null,
	list?: ResolverInputTypes["KeyInfoItemCreateListEntityRelationInput"] | undefined | null,
	icon?: ResolverInputTypes["KeyInfoItemCreateIconEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["KeyInfoItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["KeyInfoListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["KeyInfoListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["KeyInfoItemConnectOrCreateListRelationInput"] | undefined | null
};
	["KeyInfoListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["KeyInfoItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["KeyInfoListUniqueWhere"],
	create: ResolverInputTypes["KeyInfoListWithoutItemsCreateInput"]
};
	["KeyInfoItemUpdateInput"]: {
	order?: number | undefined | null,
	keyInfo?: string | undefined | null,
	list?: ResolverInputTypes["KeyInfoItemUpdateListEntityRelationInput"] | undefined | null,
	icon?: ResolverInputTypes["KeyInfoItemUpdateIconEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["KeyInfoItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["KeyInfoListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["KeyInfoListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["KeyInfoItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["KeyInfoListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["KeyInfoItemUpsertListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["KeyInfoListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["KeyInfoItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["KeyInfoListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["KeyInfoListWithoutItemsCreateInput"]
};
	["KeyInfoListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["KeyInfoListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListEdge"]: AliasType<{
	node?:ResolverInputTypes["KeyInfoList"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ContractTypeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeEdge"]: AliasType<{
	node?:ResolverInputTypes["ContractType"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: string | undefined | null,
	root?: ResolverInputTypes["ContractTypeLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ContractTypeLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContractTypeLocaleUpdateInput"]: {
	type?: string | undefined | null,
	root?: ResolverInputTypes["ContractTypeLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["ContractTypeLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobCityEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityEdge"]: AliasType<{
	node?:ResolverInputTypes["JobCity"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["JobCityLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobCityLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobCityLocaleUpdateInput"]: {
	root?: ResolverInputTypes["JobCityLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobCityLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobPositionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionEdge"]: AliasType<{
	node?:ResolverInputTypes["JobPosition"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["JobPositionCreateLocalesEntityRelationInput"]> | undefined | null,
	jobs?: Array<ResolverInputTypes["JobPositionCreateJobsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionUpdateInput"]: {
	locales?: Array<ResolverInputTypes["JobPositionUpdateLocalesEntityRelationInput"]> | undefined | null,
	jobs?: Array<ResolverInputTypes["JobPositionUpdateJobsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	type?: string | undefined | null,
	root?: ResolverInputTypes["JobPositionLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobPositionLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobPositionLocaleUpdateInput"]: {
	type?: string | undefined | null,
	root?: ResolverInputTypes["JobPositionLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobPositionLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["GalleryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryEdge"]: AliasType<{
	node?:ResolverInputTypes["Gallery"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["HomePageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageEdge"]: AliasType<{
	node?:ResolverInputTypes["HomePage"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["HomePageCreateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["HomePageCreateThemeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HomePageLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	locale?: ResolverInputTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["HomePageLocaleUniqueWhere"],
	create: ResolverInputTypes["HomePageLocaleWithoutRootCreateInput"]
};
	["HomePageUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["HomePageUpdateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["HomePageUpdateThemeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["HomePageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["HomePageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["HomePageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["HomePageUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],
	data: ResolverInputTypes["HomePageLocaleWithoutRootUpdateInput"]
};
	["HomePageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	locale?: ResolverInputTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],
	update: ResolverInputTypes["HomePageLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["HomePageLocaleWithoutRootCreateInput"]
};
	["HomePageLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["MediumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumEdge"]: AliasType<{
	node?:ResolverInputTypes["Medium"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["MediumItemCreateListEntityRelationInput"] | undefined | null,
	medium?: ResolverInputTypes["MediumItemCreateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumItemConnectOrCreateListRelationInput"] | undefined | null
};
	["MediumListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["MediumListUniqueWhere"],
	create: ResolverInputTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["MediumItemUpdateListEntityRelationInput"] | undefined | null,
	medium?: ResolverInputTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["MediumListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["MediumListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["MediumItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["MediumListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["MediumItemUpsertListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["MediumItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["MediumListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["MediumListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListEdge"]: AliasType<{
	node?:ResolverInputTypes["MediumList"],
		__typename?: boolean | `@${string}`
}>;
	["VideoConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["VideoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VideoEdge"]: AliasType<{
	node?:ResolverInputTypes["Video"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	text?: string | undefined | null,
	list?: ResolverInputTypes["TextItemCreateListEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TextItemConnectOrCreateListRelationInput"] | undefined | null
};
	["TextListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["TextListUniqueWhere"],
	create: ResolverInputTypes["TextListWithoutItemsCreateInput"]
};
	["TextItemUpdateInput"]: {
	order?: number | undefined | null,
	text?: string | undefined | null,
	list?: ResolverInputTypes["TextItemUpdateListEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["TextListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TextListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TextItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["TextListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TextItemUpsertListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TextListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["TextItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["TextListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["TextListWithoutItemsCreateInput"]
};
	["TextListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TextListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TextListEdge"]: AliasType<{
	node?:ResolverInputTypes["TextList"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["CarouselEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselEdge"]: AliasType<{
	node?:ResolverInputTypes["Carousel"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	text?: string | undefined | null,
	list?: ResolverInputTypes["CarouselItemCreateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["CarouselItemCreateImageEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	title?: string | undefined | null,
	linkUrl?: ResolverInputTypes["CarouselItemCreateLinkUrlEntityRelationInput"] | undefined | null,
	normalAspectRatio?: boolean | undefined | null,
	isImage?: boolean | undefined | null,
	video?: ResolverInputTypes["CarouselItemCreateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CarouselItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["CarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CarouselWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CarouselItemConnectOrCreateListRelationInput"] | undefined | null
};
	["CarouselWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	background?: ResolverInputTypes["Background"] | undefined | null,
	squareImages?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CarouselItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["CarouselUniqueWhere"],
	create: ResolverInputTypes["CarouselWithoutItemsCreateInput"]
};
	["CarouselItemUpdateInput"]: {
	order?: number | undefined | null,
	text?: string | undefined | null,
	list?: ResolverInputTypes["CarouselItemUpdateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["CarouselItemUpdateImageEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	title?: string | undefined | null,
	linkUrl?: ResolverInputTypes["CarouselItemUpdateLinkUrlEntityRelationInput"] | undefined | null,
	normalAspectRatio?: boolean | undefined | null,
	isImage?: boolean | undefined | null,
	video?: ResolverInputTypes["CarouselItemUpdateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CarouselItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["CarouselUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["CarouselWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["CarouselItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["CarouselWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["CarouselItemUpsertListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CarouselWithoutItemsUpdateInput"]: {
	background?: ResolverInputTypes["Background"] | undefined | null,
	squareImages?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CarouselItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["CarouselWithoutItemsUpdateInput"],
	create: ResolverInputTypes["CarouselWithoutItemsCreateInput"]
};
	["ThemeConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ThemeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeEdge"]: AliasType<{
	node?:ResolverInputTypes["Theme"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["BonusBannerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerEdge"]: AliasType<{
	node?:ResolverInputTypes["BonusBanner"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	locales?: Array<ResolverInputTypes["BonusBannerCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BonusBannerCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BonusBannerLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["BonusBannerConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BonusBannerLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	locale?: ResolverInputTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	tiles?: Array<ResolverInputTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined | null,
	logo?: ResolverInputTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined | null,
	bannerName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BonusBannerConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],
	create: ResolverInputTypes["BonusBannerLocaleWithoutRootCreateInput"]
};
	["BonusBannerUpdateInput"]: {
	locales?: Array<ResolverInputTypes["BonusBannerUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BonusBannerUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["BonusBannerLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["BonusBannerUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["BonusBannerUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BonusBannerUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],
	data: ResolverInputTypes["BonusBannerLocaleWithoutRootUpdateInput"]
};
	["BonusBannerLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	text?: string | undefined | null,
	locale?: ResolverInputTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	tiles?: Array<ResolverInputTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined | null,
	logo?: ResolverInputTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	bannerName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BonusBannerUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],
	update: ResolverInputTypes["BonusBannerLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["BonusBannerLocaleWithoutRootCreateInput"]
};
	["TileCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	text?: string | undefined | null,
	bonusBanner?: ResolverInputTypes["TileCreateBonusBannerEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["TileCreateImageEntityRelationInput"] | undefined | null,
	lightBoxTitle?: string | undefined | null,
	lightBoxText?: string | undefined | null,
	ligthBoxMedia?: ResolverInputTypes["TileCreateLigthBoxMediaEntityRelationInput"] | undefined | null,
	lightBoxSectionTitle?: string | undefined | null,
	title?: string | undefined | null,
	lightBoxLinkLabel?: string | undefined | null,
	lightBoxForm?: ResolverInputTypes["TileCreateLightBoxFormEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileCreateBonusBannerEntityRelationInput"]: {
	connect?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BonusBannerLocaleWithoutTilesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileConnectOrCreateBonusBannerRelationInput"] | undefined | null
};
	["BonusBannerLocaleWithoutTilesCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined | null,
	bannerName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileConnectOrCreateBonusBannerRelationInput"]: {
	connect: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],
	create: ResolverInputTypes["BonusBannerLocaleWithoutTilesCreateInput"]
};
	["TileUpdateInput"]: {
	order?: number | undefined | null,
	text?: string | undefined | null,
	bonusBanner?: ResolverInputTypes["TileUpdateBonusBannerEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["TileUpdateImageEntityRelationInput"] | undefined | null,
	lightBoxTitle?: string | undefined | null,
	lightBoxText?: string | undefined | null,
	ligthBoxMedia?: ResolverInputTypes["TileUpdateLigthBoxMediaEntityRelationInput"] | undefined | null,
	lightBoxSectionTitle?: string | undefined | null,
	title?: string | undefined | null,
	lightBoxLinkLabel?: string | undefined | null,
	lightBoxForm?: ResolverInputTypes["TileUpdateLightBoxFormEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileUpdateBonusBannerEntityRelationInput"]: {
	connect?: ResolverInputTypes["BonusBannerLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["BonusBannerLocaleWithoutTilesCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TileConnectOrCreateBonusBannerRelationInput"] | undefined | null,
	update?: ResolverInputTypes["BonusBannerLocaleWithoutTilesUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TileUpsertBonusBannerRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BonusBannerLocaleWithoutTilesUpdateInput"]: {
	title?: string | undefined | null,
	text?: string | undefined | null,
	root?: ResolverInputTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	bannerName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TileUpsertBonusBannerRelationInput"]: {
	update: ResolverInputTypes["BonusBannerLocaleWithoutTilesUpdateInput"],
	create: ResolverInputTypes["BonusBannerLocaleWithoutTilesCreateInput"]
};
	["SideBySideConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["SideBySideEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideEdge"]: AliasType<{
	node?:ResolverInputTypes["SideBySide"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	list?: ResolverInputTypes["SideBySideItemCreateListEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["SideBySideItemCreateMediaEntityRelationInput"] | undefined | null,
	formButtonLabel?: string | undefined | null,
	type?: ResolverInputTypes["SideBySideItemType"] | undefined | null,
	link?: ResolverInputTypes["SideBySideItemCreateLinkEntityRelationInput"] | undefined | null,
	jobsForm?: ResolverInputTypes["SideBySideItemCreateJobsFormEntityRelationInput"] | undefined | null,
	textNew?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SideBySideItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["SideBySideUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SideBySideWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SideBySideItemConnectOrCreateListRelationInput"] | undefined | null
};
	["SideBySideWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	background?: ResolverInputTypes["Background"] | undefined | null,
	alignment?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	mediumSize?: ResolverInputTypes["MediumSize"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SideBySideItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["SideBySideUniqueWhere"],
	create: ResolverInputTypes["SideBySideWithoutItemsCreateInput"]
};
	["SideBySideItemUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	text?: string | undefined | null,
	list?: ResolverInputTypes["SideBySideItemUpdateListEntityRelationInput"] | undefined | null,
	media?: ResolverInputTypes["SideBySideItemUpdateMediaEntityRelationInput"] | undefined | null,
	formButtonLabel?: string | undefined | null,
	type?: ResolverInputTypes["SideBySideItemType"] | undefined | null,
	link?: ResolverInputTypes["SideBySideItemUpdateLinkEntityRelationInput"] | undefined | null,
	jobsForm?: ResolverInputTypes["SideBySideItemUpdateJobsFormEntityRelationInput"] | undefined | null,
	textNew?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SideBySideItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["SideBySideUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["SideBySideWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["SideBySideItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["SideBySideWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["SideBySideItemUpsertListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SideBySideWithoutItemsUpdateInput"]: {
	background?: ResolverInputTypes["Background"] | undefined | null,
	alignment?: ResolverInputTypes["ContentAlignment"] | undefined | null,
	mediumSize?: ResolverInputTypes["MediumSize"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SideBySideItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["SideBySideWithoutItemsUpdateInput"],
	create: ResolverInputTypes["SideBySideWithoutItemsCreateInput"]
};
	["HomePageLokalConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["HomePageLokalEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalEdge"]: AliasType<{
	node?:ResolverInputTypes["HomePageLokal"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["HomePageLokalCreateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["HomePageLokalCreateThemeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["HomePageLokalLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["HomePageLokalConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["HomePageLokalLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	locale?: ResolverInputTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],
	create: ResolverInputTypes["HomePageLokalLocaleWithoutRootCreateInput"]
};
	["HomePageLokalUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["HomePageLokalUpdateLocalesEntityRelationInput"]> | undefined | null,
	theme?: ResolverInputTypes["HomePageLokalUpdateThemeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["HomePageLokalLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["HomePageLokalUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["HomePageLokalUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["HomePageLokalUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],
	data: ResolverInputTypes["HomePageLokalLocaleWithoutRootUpdateInput"]
};
	["HomePageLokalLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	locale?: ResolverInputTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],
	update: ResolverInputTypes["HomePageLokalLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["HomePageLokalLocaleWithoutRootCreateInput"]
};
	["HomePageLokalLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HomePageLokalLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ResolverInputTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	logo?: ResolverInputTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	button?: ResolverInputTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined | null,
	content?: ResolverInputTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	link?: ResolverInputTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	siteSwitcher?: ResolverInputTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined | null,
	gallery?: ResolverInputTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined | null,
	stickyBar?: ResolverInputTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	ilustration?: ResolverInputTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SiteSwitcherConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["SiteSwitcherEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherEdge"]: AliasType<{
	node?:ResolverInputTypes["SiteSwitcher"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["GalleryItemCreateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["GalleryItemCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GalleryItemConnectOrCreateListRelationInput"] | undefined | null
};
	["GalleryWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["GalleryUniqueWhere"],
	create: ResolverInputTypes["GalleryWithoutItemsCreateInput"]
};
	["GalleryItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["GalleryItemUpdateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["GalleryItemUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["GalleryWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["GalleryItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["GalleryWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["GalleryItemUpsertListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GalleryWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["GalleryWithoutItemsUpdateInput"],
	create: ResolverInputTypes["GalleryWithoutItemsCreateInput"]
};
	["JobsFormConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobsFormEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormEdge"]: AliasType<{
	node?:ResolverInputTypes["JobsForm"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["JobsFormCreateLocalesEntityRelationInput"]> | undefined | null,
	fileIlustration?: ResolverInputTypes["JobsFormCreateFileIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFormCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFormLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFormConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobsFormLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	jobText?: string | undefined | null,
	genericText?: string | undefined | null,
	nameLabel?: string | undefined | null,
	emailLabel?: string | undefined | null,
	telefonLabel?: string | undefined | null,
	fileTitleLabel?: string | undefined | null,
	fileFormatLabel?: string | undefined | null,
	formTextLabel?: string | undefined | null,
	submitLabel?: string | undefined | null,
	locale?: ResolverInputTypes["JobsFormLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	imageTextList?: ResolverInputTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined | null,
	minimalize?: string | undefined | null,
	logo?: ResolverInputTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined | null,
	successTitle?: string | undefined | null,
	successText?: string | undefined | null,
	successBtnLabel?: string | undefined | null,
	successImage?: ResolverInputTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined | null,
	successOtherJobsTitle?: string | undefined | null,
	successOtherJobsCategoryTitle?: string | undefined | null,
	successOtherJobsButtonTitle?: string | undefined | null,
	successOtherJobsSelectionTitle?: string | undefined | null,
	successOtherJobsSelectionYesButton?: string | undefined | null,
	successOtherJobsSelectionNoButton?: string | undefined | null,
	fileRemoveBtnLabel?: string | undefined | null,
	gdprLabel?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFormConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	create: ResolverInputTypes["JobsFormLocaleWithoutRootCreateInput"]
};
	["JobsFormUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["JobsFormUpdateLocalesEntityRelationInput"]> | undefined | null,
	fileIlustration?: ResolverInputTypes["JobsFormUpdateFileIlustrationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFormUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["JobsFormLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["JobsFormUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFormUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobsFormLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["JobsFormUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	data: ResolverInputTypes["JobsFormLocaleWithoutRootUpdateInput"]
};
	["JobsFormLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	jobText?: string | undefined | null,
	genericText?: string | undefined | null,
	nameLabel?: string | undefined | null,
	emailLabel?: string | undefined | null,
	telefonLabel?: string | undefined | null,
	fileTitleLabel?: string | undefined | null,
	fileFormatLabel?: string | undefined | null,
	formTextLabel?: string | undefined | null,
	submitLabel?: string | undefined | null,
	locale?: ResolverInputTypes["JobsFormLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	imageTextList?: ResolverInputTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined | null,
	minimalize?: string | undefined | null,
	logo?: ResolverInputTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined | null,
	successTitle?: string | undefined | null,
	successText?: string | undefined | null,
	successBtnLabel?: string | undefined | null,
	successImage?: ResolverInputTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined | null,
	successOtherJobsTitle?: string | undefined | null,
	successOtherJobsCategoryTitle?: string | undefined | null,
	successOtherJobsButtonTitle?: string | undefined | null,
	successOtherJobsSelectionTitle?: string | undefined | null,
	successOtherJobsSelectionYesButton?: string | undefined | null,
	successOtherJobsSelectionNoButton?: string | undefined | null,
	fileRemoveBtnLabel?: string | undefined | null,
	gdprLabel?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFormUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],
	update: ResolverInputTypes["JobsFormLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["JobsFormLocaleWithoutRootCreateInput"]
};
	["ImageTextItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	list?: ResolverInputTypes["ImageTextItemCreateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ImageTextItemCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageTextItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageTextListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageTextListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageTextItemConnectOrCreateListRelationInput"] | undefined | null
};
	["ImageTextListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageTextItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["ImageTextListUniqueWhere"],
	create: ResolverInputTypes["ImageTextListWithoutItemsCreateInput"]
};
	["ImageTextItemUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	list?: ResolverInputTypes["ImageTextItemUpdateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ImageTextItemUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageTextItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageTextListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageTextListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageTextItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageTextListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageTextItemUpsertListRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageTextListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["ImageTextItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["ImageTextListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["ImageTextListWithoutItemsCreateInput"]
};
	["ImageTextListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ImageTextListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListEdge"]: AliasType<{
	node?:ResolverInputTypes["ImageTextList"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobsFilterEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterEdge"]: AliasType<{
	node?:ResolverInputTypes["JobsFilter"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["JobsFilterCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobsFilterLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobsFilterLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["JobsFilterLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	jobPositionLabel?: string | undefined | null,
	jobContractLabel?: string | undefined | null,
	jobCityLabel?: string | undefined | null,
	locale?: ResolverInputTypes["JobsFilterLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerFormLabel?: string | undefined | null,
	bannerJobsForm?: ResolverInputTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined | null,
	bannerImage?: ResolverInputTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined | null,
	noJobTitle?: string | undefined | null,
	noJobBtnLabel?: string | undefined | null,
	noJobImage?: ResolverInputTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined | null,
	noJobTitleForSpecificBusiness?: string | undefined | null,
	deactivatedJob?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutJobsFiltersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutJobsFiltersCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutJobsFiltersCreateInput"]
};
	["JobsFilterConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],
	create: ResolverInputTypes["JobsFilterLocaleWithoutRootCreateInput"]
};
	["JobsFilterUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["JobsFilterUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["JobsFilterLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["JobsFilterUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFilterUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["JobsFilterLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["JobsFilterLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["JobsFilterLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["JobsFilterUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],
	data: ResolverInputTypes["JobsFilterLocaleWithoutRootUpdateInput"]
};
	["JobsFilterLocaleWithoutRootUpdateInput"]: {
	jobPositionLabel?: string | undefined | null,
	jobContractLabel?: string | undefined | null,
	jobCityLabel?: string | undefined | null,
	locale?: ResolverInputTypes["JobsFilterLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerFormLabel?: string | undefined | null,
	bannerJobsForm?: ResolverInputTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined | null,
	bannerImage?: ResolverInputTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null,
	noJobTitle?: string | undefined | null,
	noJobBtnLabel?: string | undefined | null,
	noJobImage?: ResolverInputTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined | null,
	noJobTitleForSpecificBusiness?: string | undefined | null,
	deactivatedJob?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutJobsFiltersCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobsFilterLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutJobsFiltersUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobsFilterLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutJobsFiltersUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	translations?: Array<ResolverInputTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutJobsFiltersUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutJobsFiltersCreateInput"]
};
	["JobsFilterUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],
	update: ResolverInputTypes["JobsFilterLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["JobsFilterLocaleWithoutRootCreateInput"]
};
	["JobsFilterLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	jobPositionLabel?: string | undefined | null,
	jobContractLabel?: string | undefined | null,
	jobCityLabel?: string | undefined | null,
	root?: ResolverInputTypes["JobsFilterLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobsFilterLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerFormLabel?: string | undefined | null,
	bannerJobsForm?: ResolverInputTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined | null,
	bannerImage?: ResolverInputTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined | null,
	noJobTitle?: string | undefined | null,
	noJobBtnLabel?: string | undefined | null,
	noJobImage?: ResolverInputTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined | null,
	noJobTitleForSpecificBusiness?: string | undefined | null,
	deactivatedJob?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobsFilterLocaleUpdateInput"]: {
	jobPositionLabel?: string | undefined | null,
	jobContractLabel?: string | undefined | null,
	jobCityLabel?: string | undefined | null,
	root?: ResolverInputTypes["JobsFilterLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["JobsFilterLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	bannerTitle?: string | undefined | null,
	bannerFormLabel?: string | undefined | null,
	bannerJobsForm?: ResolverInputTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined | null,
	bannerImage?: ResolverInputTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined | null,
	noJobTitle?: string | undefined | null,
	noJobBtnLabel?: string | undefined | null,
	noJobImage?: ResolverInputTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined | null,
	noJobTitleForSpecificBusiness?: string | undefined | null,
	deactivatedJob?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["File"]: AliasType<{
	_meta?:ResolverInputTypes["FileMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FileMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	url?:ResolverInputTypes["FieldMeta"],
	size?:ResolverInputTypes["FieldMeta"],
	type?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FileUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["FileWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	url?: ResolverInputTypes["StringCondition"] | undefined | null,
	size?: ResolverInputTypes["IntCondition"] | undefined | null,
	type?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["FileWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["FileWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["FileWhere"] | undefined | null
};
	["FileOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	url?: ResolverInputTypes["OrderDirection"] | undefined | null,
	size?: ResolverInputTypes["OrderDirection"] | undefined | null,
	type?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["FileConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["FileEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FileEdge"]: AliasType<{
	node?:ResolverInputTypes["File"],
		__typename?: boolean | `@${string}`
}>;
	["FileCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FileUpdateInput"]: {
	url?: string | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobFormSubscription"]: AliasType<{
	_meta?:ResolverInputTypes["JobFormSubscriptionMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
file?: [{	filter?: ResolverInputTypes["FileWhere"] | undefined | null},ResolverInputTypes["File"]],
job?: [{	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
status?: [{	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null},ResolverInputTypes["JobFormSubscriptionStatus"]],
	isSyncedToTabidoo?:boolean | `@${string}`,
	tabidooId?:boolean | `@${string}`,
	isGdprSyncedToTabidoo?:boolean | `@${string}`,
	recruitisAnswerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	name?:ResolverInputTypes["FieldMeta"],
	phone?:ResolverInputTypes["FieldMeta"],
	email?:ResolverInputTypes["FieldMeta"],
	message?:ResolverInputTypes["FieldMeta"],
	file?:ResolverInputTypes["FieldMeta"],
	job?:ResolverInputTypes["FieldMeta"],
	status?:ResolverInputTypes["FieldMeta"],
	isSyncedToTabidoo?:ResolverInputTypes["FieldMeta"],
	tabidooId?:ResolverInputTypes["FieldMeta"],
	isGdprSyncedToTabidoo?:ResolverInputTypes["FieldMeta"],
	recruitisAnswerId?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatus"]: AliasType<{
	_meta?:ResolverInputTypes["JobFormSubscriptionStatusMeta"],
	id?:boolean | `@${string}`,
	statusTitle?:boolean | `@${string}`,
	statusColor?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	statusTitle?:ResolverInputTypes["FieldMeta"],
	statusColor?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	statusTitle?: ResolverInputTypes["StringCondition"] | undefined | null,
	statusColor?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null
};
	["JobFormSubscriptionUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	file?: ResolverInputTypes["FileUniqueWhere"] | undefined | null
};
	["JobFormSubscriptionWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	name?: ResolverInputTypes["StringCondition"] | undefined | null,
	phone?: ResolverInputTypes["StringCondition"] | undefined | null,
	email?: ResolverInputTypes["StringCondition"] | undefined | null,
	message?: ResolverInputTypes["StringCondition"] | undefined | null,
	file?: ResolverInputTypes["FileWhere"] | undefined | null,
	job?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,
	status?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null,
	isSyncedToTabidoo?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	tabidooId?: ResolverInputTypes["StringCondition"] | undefined | null,
	isGdprSyncedToTabidoo?: ResolverInputTypes["BooleanCondition"] | undefined | null,
	recruitisAnswerId?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null
};
	["JobFormSubscriptionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	name?: ResolverInputTypes["OrderDirection"] | undefined | null,
	phone?: ResolverInputTypes["OrderDirection"] | undefined | null,
	email?: ResolverInputTypes["OrderDirection"] | undefined | null,
	message?: ResolverInputTypes["OrderDirection"] | undefined | null,
	file?: ResolverInputTypes["FileOrderBy"] | undefined | null,
	job?: ResolverInputTypes["JobPageLocaleOrderBy"] | undefined | null,
	status?: ResolverInputTypes["JobFormSubscriptionStatusOrderBy"] | undefined | null,
	isSyncedToTabidoo?: ResolverInputTypes["OrderDirection"] | undefined | null,
	tabidooId?: ResolverInputTypes["OrderDirection"] | undefined | null,
	isGdprSyncedToTabidoo?: ResolverInputTypes["OrderDirection"] | undefined | null,
	recruitisAnswerId?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["JobFormSubscriptionStatusOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	statusTitle?: ResolverInputTypes["OrderDirection"] | undefined | null,
	statusColor?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["JobFormSubscriptionConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobFormSubscriptionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionEdge"]: AliasType<{
	node?:ResolverInputTypes["JobFormSubscription"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	name?: string | undefined | null,
	phone?: string | undefined | null,
	email?: string | undefined | null,
	message?: string | undefined | null,
	file?: ResolverInputTypes["JobFormSubscriptionCreateFileEntityRelationInput"] | undefined | null,
	job?: ResolverInputTypes["JobFormSubscriptionCreateJobEntityRelationInput"] | undefined | null,
	status?: ResolverInputTypes["JobFormSubscriptionCreateStatusEntityRelationInput"] | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	isGdprSyncedToTabidoo?: boolean | undefined | null,
	recruitisAnswerId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobFormSubscriptionCreateFileEntityRelationInput"]: {
	connect?: ResolverInputTypes["FileUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FileCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobFormSubscriptionConnectOrCreateFileRelationInput"] | undefined | null
};
	["JobFormSubscriptionConnectOrCreateFileRelationInput"]: {
	connect: ResolverInputTypes["FileUniqueWhere"],
	create: ResolverInputTypes["FileCreateInput"]
};
	["JobFormSubscriptionCreateJobEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPageLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobFormSubscriptionConnectOrCreateJobRelationInput"] | undefined | null
};
	["JobFormSubscriptionConnectOrCreateJobRelationInput"]: {
	connect: ResolverInputTypes["JobPageLocaleUniqueWhere"],
	create: ResolverInputTypes["JobPageLocaleCreateInput"]
};
	["JobFormSubscriptionCreateStatusEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobFormSubscriptionStatusCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobFormSubscriptionConnectOrCreateStatusRelationInput"] | undefined | null
};
	["JobFormSubscriptionStatusUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["JobFormSubscriptionStatusCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	statusTitle?: string | undefined | null,
	statusColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobFormSubscriptionConnectOrCreateStatusRelationInput"]: {
	connect: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],
	create: ResolverInputTypes["JobFormSubscriptionStatusCreateInput"]
};
	["JobFormSubscriptionUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	name?: string | undefined | null,
	phone?: string | undefined | null,
	email?: string | undefined | null,
	message?: string | undefined | null,
	file?: ResolverInputTypes["JobFormSubscriptionUpdateFileEntityRelationInput"] | undefined | null,
	job?: ResolverInputTypes["JobFormSubscriptionUpdateJobEntityRelationInput"] | undefined | null,
	status?: ResolverInputTypes["JobFormSubscriptionUpdateStatusEntityRelationInput"] | undefined | null,
	isSyncedToTabidoo?: boolean | undefined | null,
	tabidooId?: string | undefined | null,
	isGdprSyncedToTabidoo?: boolean | undefined | null,
	recruitisAnswerId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobFormSubscriptionUpdateFileEntityRelationInput"]: {
	connect?: ResolverInputTypes["FileUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["FileCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobFormSubscriptionConnectOrCreateFileRelationInput"] | undefined | null,
	update?: ResolverInputTypes["FileUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobFormSubscriptionUpsertFileRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobFormSubscriptionUpsertFileRelationInput"]: {
	update: ResolverInputTypes["FileUpdateInput"],
	create: ResolverInputTypes["FileCreateInput"]
};
	["JobFormSubscriptionUpdateJobEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobPageLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobPageLocaleCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobFormSubscriptionConnectOrCreateJobRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobPageLocaleUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobFormSubscriptionUpsertJobRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobFormSubscriptionUpsertJobRelationInput"]: {
	update: ResolverInputTypes["JobPageLocaleUpdateInput"],
	create: ResolverInputTypes["JobPageLocaleCreateInput"]
};
	["JobFormSubscriptionUpdateStatusEntityRelationInput"]: {
	connect?: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["JobFormSubscriptionStatusCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["JobFormSubscriptionConnectOrCreateStatusRelationInput"] | undefined | null,
	update?: ResolverInputTypes["JobFormSubscriptionStatusUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["JobFormSubscriptionUpsertStatusRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["JobFormSubscriptionStatusUpdateInput"]: {
	statusTitle?: string | undefined | null,
	statusColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["JobFormSubscriptionUpsertStatusRelationInput"]: {
	update: ResolverInputTypes["JobFormSubscriptionStatusUpdateInput"],
	create: ResolverInputTypes["JobFormSubscriptionStatusCreateInput"]
};
	["ImageList"]: AliasType<{
	_meta?:ResolverInputTypes["ImageListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageListItem"]],
itemsByImage?: [{	by: ResolverInputTypes["ImageListItemsByImageUniqueWhere"],	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null},ResolverInputTypes["ImageListItem"]],
paginateItems?: [{	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageListMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	items?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItem"]: AliasType<{
	_meta?:ResolverInputTypes["ImageListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null},ResolverInputTypes["ImageList"]],
image?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	order?:ResolverInputTypes["FieldMeta"],
	list?:ResolverInputTypes["FieldMeta"],
	image?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	items?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ImageListWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ImageListWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ImageListWhere"] | undefined | null
};
	["ImageListItemWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	order?: ResolverInputTypes["IntCondition"] | undefined | null,
	list?: ResolverInputTypes["ImageListWhere"] | undefined | null,
	image?: ResolverInputTypes["ImageWhere"] | undefined | null,
	and?: Array<ResolverInputTypes["ImageListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["ImageListItemWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["ImageListItemWhere"] | undefined | null
};
	["ImageListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	order?: ResolverInputTypes["OrderDirection"] | undefined | null,
	list?: ResolverInputTypes["ImageListOrderBy"] | undefined | null,
	image?: ResolverInputTypes["ImageOrderBy"] | undefined | null
};
	["ImageListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["ImageListItemsByImageUniqueWhere"]: {
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["ImageListItemConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ImageListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemEdge"]: AliasType<{
	node?:ResolverInputTypes["ImageListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: ResolverInputTypes["ImageListItemUniqueWhere"] | undefined | null
};
	["ImageListItemUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	image?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null
};
	["ImageListConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["ImageListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListEdge"]: AliasType<{
	node?:ResolverInputTypes["ImageList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	items?: Array<ResolverInputTypes["ImageListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListCreateItemsEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageListItemUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageListItemWithoutListCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageListConnectOrCreateItemsRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ImageListItemWithoutListCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	image?: ResolverInputTypes["ImageListItemCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemCreateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageListItemConnectOrCreateImageRelationInput"] | undefined | null
};
	["ImageListItemConnectOrCreateImageRelationInput"]: {
	connect: ResolverInputTypes["ImageUniqueWhere"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ImageListConnectOrCreateItemsRelationInput"]: {
	connect: ResolverInputTypes["ImageListItemUniqueWhere"],
	create: ResolverInputTypes["ImageListItemWithoutListCreateInput"]
};
	["ImageListUpdateInput"]: {
	items?: Array<ResolverInputTypes["ImageListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListUpdateItemsEntityRelationInput"]: {
	create?: ResolverInputTypes["ImageListItemWithoutListCreateInput"] | undefined | null,
	update?: ResolverInputTypes["ImageListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageListUpsertItemsRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["ImageListItemUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["ImageListItemUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["ImageListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ImageListUpdateItemsRelationInput"]: {
	by: ResolverInputTypes["ImageListItemUniqueWhere"],
	data: ResolverInputTypes["ImageListItemWithoutListUpdateInput"]
};
	["ImageListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	image?: ResolverInputTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemUpdateImageEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageListItemConnectOrCreateImageRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageListItemUpsertImageRelationInput"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageListItemUpsertImageRelationInput"]: {
	update: ResolverInputTypes["ImageUpdateInput"],
	create: ResolverInputTypes["ImageCreateInput"]
};
	["ImageListUpsertItemsRelationInput"]: {
	by: ResolverInputTypes["ImageListItemUniqueWhere"],
	update: ResolverInputTypes["ImageListItemWithoutListUpdateInput"],
	create: ResolverInputTypes["ImageListItemWithoutListCreateInput"]
};
	["ImageListItemCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ResolverInputTypes["ImageListItemCreateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ImageListItemCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemCreateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageListItemConnectOrCreateListRelationInput"] | undefined | null
};
	["ImageListWithoutItemsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemConnectOrCreateListRelationInput"]: {
	connect: ResolverInputTypes["ImageListUniqueWhere"],
	create: ResolverInputTypes["ImageListWithoutItemsCreateInput"]
};
	["ImageListItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ResolverInputTypes["ImageListItemUpdateListEntityRelationInput"] | undefined | null,
	image?: ResolverInputTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemUpdateListEntityRelationInput"]: {
	connect?: ResolverInputTypes["ImageListUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["ImageListWithoutItemsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["ImageListItemConnectOrCreateListRelationInput"] | undefined | null,
	update?: ResolverInputTypes["ImageListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["ImageListItemUpsertListRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemUpsertListRelationInput"]: {
	update: ResolverInputTypes["ImageListWithoutItemsUpdateInput"],
	create: ResolverInputTypes["ImageListWithoutItemsCreateInput"]
};
	["JobFormSubscriptionStatusConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["JobFormSubscriptionStatusEdge"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusEdge"]: AliasType<{
	node?:ResolverInputTypes["JobFormSubscriptionStatus"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	root?: ResolverInputTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined | null,
	cornerBanner?: ResolverInputTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GeneralLocaleUpdateInput"]: {
	root?: ResolverInputTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ResolverInputTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	cornerBanner?: ResolverInputTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StickyBarConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["StickyBarEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarEdge"]: AliasType<{
	node?:ResolverInputTypes["StickyBar"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["RecommendationFormEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormEdge"]: AliasType<{
	node?:ResolverInputTypes["RecommendationForm"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["RecommendationFormCreateLocalesEntityRelationInput"]> | undefined | null,
	successImage?: ResolverInputTypes["RecommendationFormCreateSuccessImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["RecommendationFormLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["RecommendationFormConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["RecommendationFormLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	yourEmailLabel?: string | undefined | null,
	theirEmailLabel?: string | undefined | null,
	yourName?: string | undefined | null,
	sendBtnLabel?: string | undefined | null,
	successTitle?: string | undefined | null,
	successSubtitle?: string | undefined | null,
	successButtonClose?: string | undefined | null,
	locale?: ResolverInputTypes["RecommendationFormLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],
	create: ResolverInputTypes["RecommendationFormLocaleWithoutRootCreateInput"]
};
	["RecommendationFormUpdateInput"]: {
	unique?: ResolverInputTypes["One"] | undefined | null,
	locales?: Array<ResolverInputTypes["RecommendationFormUpdateLocalesEntityRelationInput"]> | undefined | null,
	successImage?: ResolverInputTypes["RecommendationFormUpdateSuccessImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["RecommendationFormLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["RecommendationFormUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["RecommendationFormUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["RecommendationFormUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],
	data: ResolverInputTypes["RecommendationFormLocaleWithoutRootUpdateInput"]
};
	["RecommendationFormLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	subtitle?: string | undefined | null,
	yourEmailLabel?: string | undefined | null,
	theirEmailLabel?: string | undefined | null,
	yourName?: string | undefined | null,
	sendBtnLabel?: string | undefined | null,
	successTitle?: string | undefined | null,
	successSubtitle?: string | undefined | null,
	successButtonClose?: string | undefined | null,
	locale?: ResolverInputTypes["RecommendationFormLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],
	update: ResolverInputTypes["RecommendationFormLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["RecommendationFormLocaleWithoutRootCreateInput"]
};
	["RecommendationFormSubscription"]: AliasType<{
	_meta?:ResolverInputTypes["RecommendationFormSubscriptionMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	yourEmail?:boolean | `@${string}`,
	theirEmail?:boolean | `@${string}`,
	yourName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionMeta"]: AliasType<{
	id?:ResolverInputTypes["FieldMeta"],
	createdAt?:ResolverInputTypes["FieldMeta"],
	yourEmail?:ResolverInputTypes["FieldMeta"],
	theirEmail?:ResolverInputTypes["FieldMeta"],
	yourName?:ResolverInputTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionUniqueWhere"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null
};
	["RecommendationFormSubscriptionWhere"]: {
	id?: ResolverInputTypes["UUIDCondition"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeCondition"] | undefined | null,
	yourEmail?: ResolverInputTypes["StringCondition"] | undefined | null,
	theirEmail?: ResolverInputTypes["StringCondition"] | undefined | null,
	yourName?: ResolverInputTypes["StringCondition"] | undefined | null,
	and?: Array<ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null> | undefined | null,
	or?: Array<ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null> | undefined | null,
	not?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null
};
	["RecommendationFormSubscriptionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ResolverInputTypes["OrderDirection"] | undefined | null,
	createdAt?: ResolverInputTypes["OrderDirection"] | undefined | null,
	yourEmail?: ResolverInputTypes["OrderDirection"] | undefined | null,
	theirEmail?: ResolverInputTypes["OrderDirection"] | undefined | null,
	yourName?: ResolverInputTypes["OrderDirection"] | undefined | null
};
	["RecommendationFormSubscriptionConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["RecommendationFormSubscriptionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionEdge"]: AliasType<{
	node?:ResolverInputTypes["RecommendationFormSubscription"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	yourEmail?: string | undefined | null,
	theirEmail?: string | undefined | null,
	yourName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RecommendationFormSubscriptionUpdateInput"]: {
	createdAt?: ResolverInputTypes["DateTime"] | undefined | null,
	yourEmail?: string | undefined | null,
	theirEmail?: string | undefined | null,
	yourName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["InfoBoxEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxEdge"]: AliasType<{
	node?:ResolverInputTypes["InfoBox"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	address?: string | undefined | null,
	web?: string | undefined | null,
	instagram?: string | undefined | null,
	facebook?: string | undefined | null,
	root?: ResolverInputTypes["InfoBoxLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["InfoBoxLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	openingHours?: ResolverInputTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined | null,
	addressLink?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InfoBoxLocaleUpdateInput"]: {
	address?: string | undefined | null,
	web?: string | undefined | null,
	instagram?: string | undefined | null,
	facebook?: string | undefined | null,
	root?: ResolverInputTypes["InfoBoxLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["InfoBoxLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	openingHours?: ResolverInputTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined | null,
	addressLink?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["TranslationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationEdge"]: AliasType<{
	node?:ResolverInputTypes["Translation"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	key?: string | undefined | null,
	locales?: Array<ResolverInputTypes["TranslationCreateLocalesEntityRelationInput"]> | undefined | null,
	isTextarea?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCreateLocalesEntityRelationInput"]: {
	connect?: ResolverInputTypes["TranslationLocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["TranslationLocaleWithoutRootCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationConnectOrCreateLocalesRelationInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationLocaleWithoutRootCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	value?: string | undefined | null,
	locale?: ResolverInputTypes["TranslationLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutTranslationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null
};
	["LocaleWithoutTranslationsCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleCreateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ResolverInputTypes["LocaleUniqueWhere"],
	create: ResolverInputTypes["LocaleWithoutTranslationsCreateInput"]
};
	["TranslationConnectOrCreateLocalesRelationInput"]: {
	connect: ResolverInputTypes["TranslationLocaleUniqueWhere"],
	create: ResolverInputTypes["TranslationLocaleWithoutRootCreateInput"]
};
	["TranslationUpdateInput"]: {
	order?: number | undefined | null,
	key?: string | undefined | null,
	locales?: Array<ResolverInputTypes["TranslationUpdateLocalesEntityRelationInput"]> | undefined | null,
	isTextarea?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationUpdateLocalesEntityRelationInput"]: {
	create?: ResolverInputTypes["TranslationLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ResolverInputTypes["TranslationUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationUpsertLocalesRelationInput"] | undefined | null,
	connect?: ResolverInputTypes["TranslationLocaleUniqueWhere"] | undefined | null,
	disconnect?: ResolverInputTypes["TranslationLocaleUniqueWhere"] | undefined | null,
	delete?: ResolverInputTypes["TranslationLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationUpdateLocalesRelationInput"]: {
	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],
	data: ResolverInputTypes["TranslationLocaleWithoutRootUpdateInput"]
};
	["TranslationLocaleWithoutRootUpdateInput"]: {
	value?: string | undefined | null,
	locale?: ResolverInputTypes["TranslationLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ResolverInputTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ResolverInputTypes["LocaleWithoutTranslationsCreateInput"] | undefined | null,
	connectOrCreate?: ResolverInputTypes["TranslationLocaleConnectOrCreateLocaleRelationInput"] | undefined | null,
	update?: ResolverInputTypes["LocaleWithoutTranslationsUpdateInput"] | undefined | null,
	upsert?: ResolverInputTypes["TranslationLocaleUpsertLocaleRelationInput"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutTranslationsUpdateInput"]: {
	code?: string | undefined | null,
	label?: string | undefined | null,
	footers?: Array<ResolverInputTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined | null,
	genericPages?: Array<ResolverInputTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined | null,
	headers?: Array<ResolverInputTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined | null,
	seoDefaults?: Array<ResolverInputTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined | null,
	businessPages?: Array<ResolverInputTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined | null,
	jobPages?: Array<ResolverInputTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined | null,
	contractTypes?: Array<ResolverInputTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined | null,
	jobCities?: Array<ResolverInputTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined | null,
	jobPositions?: Array<ResolverInputTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined | null,
	homePages?: Array<ResolverInputTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined | null,
	bonusBanners?: Array<ResolverInputTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined | null,
	homePageLokals?: Array<ResolverInputTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined | null,
	jobsForms?: Array<ResolverInputTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined | null,
	jobsFilters?: Array<ResolverInputTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined | null,
	general?: Array<ResolverInputTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined | null,
	recommendationForms?: Array<ResolverInputTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined | null,
	infoBoxes?: Array<ResolverInputTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationLocaleUpsertLocaleRelationInput"]: {
	update: ResolverInputTypes["LocaleWithoutTranslationsUpdateInput"],
	create: ResolverInputTypes["LocaleWithoutTranslationsCreateInput"]
};
	["TranslationUpsertLocalesRelationInput"]: {
	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],
	update: ResolverInputTypes["TranslationLocaleWithoutRootUpdateInput"],
	create: ResolverInputTypes["TranslationLocaleWithoutRootCreateInput"]
};
	["TranslationLocaleCreateInput"]: {
	id?: ResolverInputTypes["UUID"] | undefined | null,
	value?: string | undefined | null,
	root?: ResolverInputTypes["TranslationLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["TranslationLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationLocaleUpdateInput"]: {
	value?: string | undefined | null,
	root?: ResolverInputTypes["TranslationLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ResolverInputTypes["TranslationLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CornerBannerConnection"]: AliasType<{
	pageInfo?:ResolverInputTypes["PageInfo"],
	edges?:ResolverInputTypes["CornerBannerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerEdge"]: AliasType<{
	node?:ResolverInputTypes["CornerBanner"],
		__typename?: boolean | `@${string}`
}>;
	["QueryTransaction"]: AliasType<{
	schema?:ResolverInputTypes["_Schema"],
	s3DummyQuery?:boolean | `@${string}`,
getGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null},ResolverInputTypes["General"]],
listGeneral?: [{	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["General"]],
paginateGeneral?: [{	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralConnection"]],
validateCreateGeneral?: [{	data: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	data: ResolverInputTypes["GeneralUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["Image"]],
listImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Image"]],
paginateImage?: [{	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageConnection"]],
validateCreateImage?: [{	data: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	data: ResolverInputTypes["ImageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null},ResolverInputTypes["GenericPage"]],
listGenericPage?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPage"]],
paginateGenericPage?: [{	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	data: ResolverInputTypes["GenericPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["Linkable"]],
listLinkable?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkableOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Linkable"]],
paginateLinkable?: [{	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkableOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	data: ResolverInputTypes["LinkableUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["Seo"]],
listSeo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Seo"]],
paginateSeo?: [{	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SeoConnection"]],
validateCreateSeo?: [{	data: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	data: ResolverInputTypes["SeoUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["Content"]],
listContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Content"]],
paginateContent?: [{	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentConnection"]],
validateCreateContent?: [{	data: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	data: ResolverInputTypes["ContentUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlock"]],
listContentBlock?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentBlockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	data: ResolverInputTypes["ContentBlockUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReference"]],
listContentReference?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReference"]],
paginateContentReference?: [{	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	data: ResolverInputTypes["ContentReferenceUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContentReferenceLinkableItem?: [{	by: ResolverInputTypes["ContentReferenceLinkableItemUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
listContentReferenceLinkableItem?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItem"]],
paginateContentReferenceLinkableItem?: [{	filter?: ResolverInputTypes["ContentReferenceLinkableItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContentReferenceLinkableItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContentReferenceLinkableItemConnection"]],
getRedirect?: [{	by: ResolverInputTypes["RedirectUniqueWhere"],	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null},ResolverInputTypes["Redirect"]],
listRedirect?: [{	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RedirectOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Redirect"]],
paginateRedirect?: [{	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RedirectOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data: ResolverInputTypes["RedirectCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by: ResolverInputTypes["RedirectUniqueWhere"],	data: ResolverInputTypes["RedirectUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["Link"]],
listLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Link"]],
paginateLink?: [{	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LinkConnection"]],
validateCreateLink?: [{	data: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	data: ResolverInputTypes["LinkUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null},ResolverInputTypes["Footer"]],
listFooter?: [{	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Footer"]],
paginateFooter?: [{	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterConnection"]],
validateCreateFooter?: [{	data: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	data: ResolverInputTypes["FooterUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFooterLink?: [{	by: ResolverInputTypes["FooterLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null},ResolverInputTypes["FooterLink"]],
listFooterLink?: [{	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLink"]],
paginateFooterLink?: [{	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLinkConnection"]],
validateCreateFooterLink?: [{	data: ResolverInputTypes["FooterLinkCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFooterLink?: [{	by: ResolverInputTypes["FooterLinkUniqueWhere"],	data: ResolverInputTypes["FooterLinkUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocale"]],
listFooterLocale?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FooterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	data: ResolverInputTypes["FooterLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocale"]],
listGenericPageLocale?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GenericPageLocale"]],
paginateGenericPageLocale?: [{	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GenericPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GenericPageLocaleConnection"]],
validateCreateGenericPageLocale?: [{	data: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	data: ResolverInputTypes["GenericPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null},ResolverInputTypes["Header"]],
listHeader?: [{	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Header"]],
paginateHeader?: [{	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderConnection"]],
validateCreateHeader?: [{	data: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	data: ResolverInputTypes["HeaderUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HeaderLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	data: ResolverInputTypes["HeaderLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["Locale"]],
listLocale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Locale"]],
paginateLocale?: [{	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["LocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["LocaleConnection"]],
validateCreateLocale?: [{	data: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	data: ResolverInputTypes["LocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSeoDefault?: [{	by: ResolverInputTypes["SeoDefaultUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null},ResolverInputTypes["SeoDefault"]],
listSeoDefault?: [{	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SeoDefault"]],
paginateSeoDefault?: [{	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SeoDefaultConnection"]],
validateCreateSeoDefault?: [{	data: ResolverInputTypes["SeoDefaultCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSeoDefault?: [{	by: ResolverInputTypes["SeoDefaultUniqueWhere"],	data: ResolverInputTypes["SeoDefaultUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSeoDefaultLocale?: [{	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null},ResolverInputTypes["SeoDefaultLocale"]],
listSeoDefaultLocale?: [{	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SeoDefaultLocale"]],
paginateSeoDefaultLocale?: [{	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SeoDefaultLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SeoDefaultLocaleConnection"]],
validateCreateSeoDefaultLocale?: [{	data: ResolverInputTypes["SeoDefaultLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSeoDefaultLocale?: [{	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],	data: ResolverInputTypes["SeoDefaultLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getBusiness?: [{	by: ResolverInputTypes["BusinessUniqueWhere"],	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null},ResolverInputTypes["Business"]],
listBusiness?: [{	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Business"]],
paginateBusiness?: [{	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BusinessConnection"]],
validateCreateBusiness?: [{	data: ResolverInputTypes["BusinessCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateBusiness?: [{	by: ResolverInputTypes["BusinessUniqueWhere"],	data: ResolverInputTypes["BusinessUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getBusinessPage?: [{	by: ResolverInputTypes["BusinessPageUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null},ResolverInputTypes["BusinessPage"]],
listBusinessPage?: [{	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BusinessPage"]],
paginateBusinessPage?: [{	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BusinessPageConnection"]],
validateCreateBusinessPage?: [{	data: ResolverInputTypes["BusinessPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateBusinessPage?: [{	by: ResolverInputTypes["BusinessPageUniqueWhere"],	data: ResolverInputTypes["BusinessPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getBusinessPageLocale?: [{	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
listBusinessPageLocale?: [{	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BusinessPageLocale"]],
paginateBusinessPageLocale?: [{	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BusinessPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BusinessPageLocaleConnection"]],
validateCreateBusinessPageLocale?: [{	data: ResolverInputTypes["BusinessPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateBusinessPageLocale?: [{	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],	data: ResolverInputTypes["BusinessPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getIcon?: [{	by: ResolverInputTypes["IconUniqueWhere"],	filter?: ResolverInputTypes["IconWhere"] | undefined | null},ResolverInputTypes["Icon"]],
listIcon?: [{	filter?: ResolverInputTypes["IconWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["IconOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Icon"]],
paginateIcon?: [{	filter?: ResolverInputTypes["IconWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["IconOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["IconConnection"]],
validateCreateIcon?: [{	data: ResolverInputTypes["IconCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateIcon?: [{	by: ResolverInputTypes["IconUniqueWhere"],	data: ResolverInputTypes["IconUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobPage?: [{	by: ResolverInputTypes["JobPageUniqueWhere"],	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null},ResolverInputTypes["JobPage"]],
listJobPage?: [{	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPage"]],
paginateJobPage?: [{	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPageConnection"]],
validateCreateJobPage?: [{	data: ResolverInputTypes["JobPageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobPage?: [{	by: ResolverInputTypes["JobPageUniqueWhere"],	data: ResolverInputTypes["JobPageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobPageLocale?: [{	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocale"]],
listJobPageLocale?: [{	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPageLocale"]],
paginateJobPageLocale?: [{	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPageLocaleConnection"]],
validateCreateJobPageLocale?: [{	data: ResolverInputTypes["JobPageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobPageLocale?: [{	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],	data: ResolverInputTypes["JobPageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getKeyInfoItem?: [{	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null},ResolverInputTypes["KeyInfoItem"]],
listKeyInfoItem?: [{	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["KeyInfoItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["KeyInfoItem"]],
paginateKeyInfoItem?: [{	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["KeyInfoItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["KeyInfoItemConnection"]],
validateCreateKeyInfoItem?: [{	data: ResolverInputTypes["KeyInfoItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateKeyInfoItem?: [{	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],	data: ResolverInputTypes["KeyInfoItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getKeyInfoList?: [{	by: ResolverInputTypes["KeyInfoListUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null},ResolverInputTypes["KeyInfoList"]],
listKeyInfoList?: [{	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["KeyInfoListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["KeyInfoList"]],
paginateKeyInfoList?: [{	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["KeyInfoListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["KeyInfoListConnection"]],
validateCreateKeyInfoList?: [{	data: ResolverInputTypes["KeyInfoListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateKeyInfoList?: [{	by: ResolverInputTypes["KeyInfoListUniqueWhere"],	data: ResolverInputTypes["KeyInfoListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContractType?: [{	by: ResolverInputTypes["ContractTypeUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null},ResolverInputTypes["ContractType"]],
listContractType?: [{	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContractType"]],
paginateContractType?: [{	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContractTypeConnection"]],
validateCreateContractType?: [{	data: ResolverInputTypes["ContractTypeCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContractType?: [{	by: ResolverInputTypes["ContractTypeUniqueWhere"],	data: ResolverInputTypes["ContractTypeUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getContractTypeLocale?: [{	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null},ResolverInputTypes["ContractTypeLocale"]],
listContractTypeLocale?: [{	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ContractTypeLocale"]],
paginateContractTypeLocale?: [{	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ContractTypeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ContractTypeLocaleConnection"]],
validateCreateContractTypeLocale?: [{	data: ResolverInputTypes["ContractTypeLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateContractTypeLocale?: [{	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],	data: ResolverInputTypes["ContractTypeLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobCity?: [{	by: ResolverInputTypes["JobCityUniqueWhere"],	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null},ResolverInputTypes["JobCity"]],
listJobCity?: [{	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobCity"]],
paginateJobCity?: [{	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobCityConnection"]],
validateCreateJobCity?: [{	data: ResolverInputTypes["JobCityCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobCity?: [{	by: ResolverInputTypes["JobCityUniqueWhere"],	data: ResolverInputTypes["JobCityUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobCityLocale?: [{	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null},ResolverInputTypes["JobCityLocale"]],
listJobCityLocale?: [{	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobCityLocale"]],
paginateJobCityLocale?: [{	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobCityLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobCityLocaleConnection"]],
validateCreateJobCityLocale?: [{	data: ResolverInputTypes["JobCityLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobCityLocale?: [{	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],	data: ResolverInputTypes["JobCityLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobPosition?: [{	by: ResolverInputTypes["JobPositionUniqueWhere"],	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null},ResolverInputTypes["JobPosition"]],
listJobPosition?: [{	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPosition"]],
paginateJobPosition?: [{	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPositionConnection"]],
validateCreateJobPosition?: [{	data: ResolverInputTypes["JobPositionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobPosition?: [{	by: ResolverInputTypes["JobPositionUniqueWhere"],	data: ResolverInputTypes["JobPositionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobPositionLocale?: [{	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null},ResolverInputTypes["JobPositionLocale"]],
listJobPositionLocale?: [{	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobPositionLocale"]],
paginateJobPositionLocale?: [{	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobPositionLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobPositionLocaleConnection"]],
validateCreateJobPositionLocale?: [{	data: ResolverInputTypes["JobPositionLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobPositionLocale?: [{	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],	data: ResolverInputTypes["JobPositionLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGallery?: [{	by: ResolverInputTypes["GalleryUniqueWhere"],	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null},ResolverInputTypes["Gallery"]],
listGallery?: [{	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GalleryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Gallery"]],
paginateGallery?: [{	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GalleryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GalleryConnection"]],
validateCreateGallery?: [{	data: ResolverInputTypes["GalleryCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by: ResolverInputTypes["GalleryUniqueWhere"],	data: ResolverInputTypes["GalleryUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHomePage?: [{	by: ResolverInputTypes["HomePageUniqueWhere"],	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null},ResolverInputTypes["HomePage"]],
listHomePage?: [{	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePage"]],
paginateHomePage?: [{	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data: ResolverInputTypes["HomePageCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by: ResolverInputTypes["HomePageUniqueWhere"],	data: ResolverInputTypes["HomePageUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHomePageLocale?: [{	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocale"]],
listHomePageLocale?: [{	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePageLocale"]],
paginateHomePageLocale?: [{	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageLocaleConnection"]],
validateCreateHomePageLocale?: [{	data: ResolverInputTypes["HomePageLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHomePageLocale?: [{	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],	data: ResolverInputTypes["HomePageLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null},ResolverInputTypes["Medium"]],
listMedium?: [{	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Medium"]],
paginateMedium?: [{	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumConnection"]],
validateCreateMedium?: [{	data: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	data: ResolverInputTypes["MediumUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null},ResolverInputTypes["MediumItem"]],
listMediumItem?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MediumItem"]],
paginateMediumItem?: [{	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumItemConnection"]],
validateCreateMediumItem?: [{	data: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	data: ResolverInputTypes["MediumItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumList"]],
listMediumList?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["MediumList"]],
paginateMediumList?: [{	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["MediumListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["MediumListConnection"]],
validateCreateMediumList?: [{	data: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	data: ResolverInputTypes["MediumListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["Video"]],
listVideo?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["VideoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Video"]],
paginateVideo?: [{	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["VideoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["VideoConnection"]],
validateCreateVideo?: [{	data: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	data: ResolverInputTypes["VideoUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTextItem?: [{	by: ResolverInputTypes["TextItemUniqueWhere"],	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null},ResolverInputTypes["TextItem"]],
listTextItem?: [{	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TextItem"]],
paginateTextItem?: [{	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TextItemConnection"]],
validateCreateTextItem?: [{	data: ResolverInputTypes["TextItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTextItem?: [{	by: ResolverInputTypes["TextItemUniqueWhere"],	data: ResolverInputTypes["TextItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTextList?: [{	by: ResolverInputTypes["TextListUniqueWhere"],	filter?: ResolverInputTypes["TextListWhere"] | undefined | null},ResolverInputTypes["TextList"]],
listTextList?: [{	filter?: ResolverInputTypes["TextListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TextList"]],
paginateTextList?: [{	filter?: ResolverInputTypes["TextListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TextListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TextListConnection"]],
validateCreateTextList?: [{	data: ResolverInputTypes["TextListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTextList?: [{	by: ResolverInputTypes["TextListUniqueWhere"],	data: ResolverInputTypes["TextListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCarousel?: [{	by: ResolverInputTypes["CarouselUniqueWhere"],	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null},ResolverInputTypes["Carousel"]],
listCarousel?: [{	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CarouselOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Carousel"]],
paginateCarousel?: [{	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CarouselOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CarouselConnection"]],
validateCreateCarousel?: [{	data: ResolverInputTypes["CarouselCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCarousel?: [{	by: ResolverInputTypes["CarouselUniqueWhere"],	data: ResolverInputTypes["CarouselUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCarouselItem?: [{	by: ResolverInputTypes["CarouselItemUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null},ResolverInputTypes["CarouselItem"]],
listCarouselItem?: [{	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CarouselItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CarouselItem"]],
paginateCarouselItem?: [{	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CarouselItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CarouselItemConnection"]],
validateCreateCarouselItem?: [{	data: ResolverInputTypes["CarouselItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCarouselItem?: [{	by: ResolverInputTypes["CarouselItemUniqueWhere"],	data: ResolverInputTypes["CarouselItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTheme?: [{	by: ResolverInputTypes["ThemeUniqueWhere"],	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null},ResolverInputTypes["Theme"]],
listTheme?: [{	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ThemeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Theme"]],
paginateTheme?: [{	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ThemeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ThemeConnection"]],
validateCreateTheme?: [{	data: ResolverInputTypes["ThemeCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTheme?: [{	by: ResolverInputTypes["ThemeUniqueWhere"],	data: ResolverInputTypes["ThemeUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getBonusBanner?: [{	by: ResolverInputTypes["BonusBannerUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null},ResolverInputTypes["BonusBanner"]],
listBonusBanner?: [{	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BonusBanner"]],
paginateBonusBanner?: [{	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BonusBannerConnection"]],
validateCreateBonusBanner?: [{	data: ResolverInputTypes["BonusBannerCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateBonusBanner?: [{	by: ResolverInputTypes["BonusBannerUniqueWhere"],	data: ResolverInputTypes["BonusBannerUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getBonusBannerLocale?: [{	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
listBonusBannerLocale?: [{	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["BonusBannerLocale"]],
paginateBonusBannerLocale?: [{	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["BonusBannerLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["BonusBannerLocaleConnection"]],
validateCreateBonusBannerLocale?: [{	data: ResolverInputTypes["BonusBannerLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateBonusBannerLocale?: [{	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],	data: ResolverInputTypes["BonusBannerLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTile?: [{	by: ResolverInputTypes["TileUniqueWhere"],	filter?: ResolverInputTypes["TileWhere"] | undefined | null},ResolverInputTypes["Tile"]],
listTile?: [{	filter?: ResolverInputTypes["TileWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Tile"]],
paginateTile?: [{	filter?: ResolverInputTypes["TileWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TileConnection"]],
validateCreateTile?: [{	data: ResolverInputTypes["TileCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTile?: [{	by: ResolverInputTypes["TileUniqueWhere"],	data: ResolverInputTypes["TileUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSideBySide?: [{	by: ResolverInputTypes["SideBySideUniqueWhere"],	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null},ResolverInputTypes["SideBySide"]],
listSideBySide?: [{	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SideBySideOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SideBySide"]],
paginateSideBySide?: [{	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SideBySideOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SideBySideConnection"]],
validateCreateSideBySide?: [{	data: ResolverInputTypes["SideBySideCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSideBySide?: [{	by: ResolverInputTypes["SideBySideUniqueWhere"],	data: ResolverInputTypes["SideBySideUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSideBySideItem?: [{	by: ResolverInputTypes["SideBySideItemUniqueWhere"],	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null},ResolverInputTypes["SideBySideItem"]],
listSideBySideItem?: [{	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SideBySideItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SideBySideItem"]],
paginateSideBySideItem?: [{	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SideBySideItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SideBySideItemConnection"]],
validateCreateSideBySideItem?: [{	data: ResolverInputTypes["SideBySideItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSideBySideItem?: [{	by: ResolverInputTypes["SideBySideItemUniqueWhere"],	data: ResolverInputTypes["SideBySideItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHomePageLokal?: [{	by: ResolverInputTypes["HomePageLokalUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null},ResolverInputTypes["HomePageLokal"]],
listHomePageLokal?: [{	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePageLokal"]],
paginateHomePageLokal?: [{	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageLokalConnection"]],
validateCreateHomePageLokal?: [{	data: ResolverInputTypes["HomePageLokalCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHomePageLokal?: [{	by: ResolverInputTypes["HomePageLokalUniqueWhere"],	data: ResolverInputTypes["HomePageLokalUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getHomePageLokalLocale?: [{	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
listHomePageLokalLocale?: [{	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["HomePageLokalLocale"]],
paginateHomePageLokalLocale?: [{	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["HomePageLokalLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["HomePageLokalLocaleConnection"]],
validateCreateHomePageLokalLocale?: [{	data: ResolverInputTypes["HomePageLokalLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateHomePageLokalLocale?: [{	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],	data: ResolverInputTypes["HomePageLokalLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getSiteSwitcher?: [{	by: ResolverInputTypes["SiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null},ResolverInputTypes["SiteSwitcher"]],
listSiteSwitcher?: [{	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SiteSwitcherOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["SiteSwitcher"]],
paginateSiteSwitcher?: [{	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["SiteSwitcherOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["SiteSwitcherConnection"]],
validateCreateSiteSwitcher?: [{	data: ResolverInputTypes["SiteSwitcherCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateSiteSwitcher?: [{	by: ResolverInputTypes["SiteSwitcherUniqueWhere"],	data: ResolverInputTypes["SiteSwitcherUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGalleryItem?: [{	by: ResolverInputTypes["GalleryItemUniqueWhere"],	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null},ResolverInputTypes["GalleryItem"]],
listGalleryItem?: [{	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GalleryItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GalleryItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data: ResolverInputTypes["GalleryItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by: ResolverInputTypes["GalleryItemUniqueWhere"],	data: ResolverInputTypes["GalleryItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobsForm?: [{	by: ResolverInputTypes["JobsFormUniqueWhere"],	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null},ResolverInputTypes["JobsForm"]],
listJobsForm?: [{	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsForm"]],
paginateJobsForm?: [{	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFormConnection"]],
validateCreateJobsForm?: [{	data: ResolverInputTypes["JobsFormCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobsForm?: [{	by: ResolverInputTypes["JobsFormUniqueWhere"],	data: ResolverInputTypes["JobsFormUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobsFormLocale?: [{	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocale"]],
listJobsFormLocale?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsFormLocale"]],
paginateJobsFormLocale?: [{	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFormLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFormLocaleConnection"]],
validateCreateJobsFormLocale?: [{	data: ResolverInputTypes["JobsFormLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobsFormLocale?: [{	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],	data: ResolverInputTypes["JobsFormLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageTextItem?: [{	by: ResolverInputTypes["ImageTextItemUniqueWhere"],	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null},ResolverInputTypes["ImageTextItem"]],
listImageTextItem?: [{	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageTextItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageTextItem"]],
paginateImageTextItem?: [{	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageTextItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageTextItemConnection"]],
validateCreateImageTextItem?: [{	data: ResolverInputTypes["ImageTextItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageTextItem?: [{	by: ResolverInputTypes["ImageTextItemUniqueWhere"],	data: ResolverInputTypes["ImageTextItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageTextList?: [{	by: ResolverInputTypes["ImageTextListUniqueWhere"],	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null},ResolverInputTypes["ImageTextList"]],
listImageTextList?: [{	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageTextListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageTextList"]],
paginateImageTextList?: [{	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageTextListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageTextListConnection"]],
validateCreateImageTextList?: [{	data: ResolverInputTypes["ImageTextListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageTextList?: [{	by: ResolverInputTypes["ImageTextListUniqueWhere"],	data: ResolverInputTypes["ImageTextListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobsFilter?: [{	by: ResolverInputTypes["JobsFilterUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null},ResolverInputTypes["JobsFilter"]],
listJobsFilter?: [{	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsFilter"]],
paginateJobsFilter?: [{	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFilterConnection"]],
validateCreateJobsFilter?: [{	data: ResolverInputTypes["JobsFilterCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobsFilter?: [{	by: ResolverInputTypes["JobsFilterUniqueWhere"],	data: ResolverInputTypes["JobsFilterUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobsFilterLocale?: [{	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
listJobsFilterLocale?: [{	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobsFilterLocale"]],
paginateJobsFilterLocale?: [{	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobsFilterLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobsFilterLocaleConnection"]],
validateCreateJobsFilterLocale?: [{	data: ResolverInputTypes["JobsFilterLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobsFilterLocale?: [{	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],	data: ResolverInputTypes["JobsFilterLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getFile?: [{	by: ResolverInputTypes["FileUniqueWhere"],	filter?: ResolverInputTypes["FileWhere"] | undefined | null},ResolverInputTypes["File"]],
listFile?: [{	filter?: ResolverInputTypes["FileWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["File"]],
paginateFile?: [{	filter?: ResolverInputTypes["FileWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["FileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["FileConnection"]],
validateCreateFile?: [{	data: ResolverInputTypes["FileCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateFile?: [{	by: ResolverInputTypes["FileUniqueWhere"],	data: ResolverInputTypes["FileUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobFormSubscription?: [{	by: ResolverInputTypes["JobFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null},ResolverInputTypes["JobFormSubscription"]],
listJobFormSubscription?: [{	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobFormSubscriptionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobFormSubscription"]],
paginateJobFormSubscription?: [{	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobFormSubscriptionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobFormSubscriptionConnection"]],
validateCreateJobFormSubscription?: [{	data: ResolverInputTypes["JobFormSubscriptionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobFormSubscription?: [{	by: ResolverInputTypes["JobFormSubscriptionUniqueWhere"],	data: ResolverInputTypes["JobFormSubscriptionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageList?: [{	by: ResolverInputTypes["ImageListUniqueWhere"],	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null},ResolverInputTypes["ImageList"]],
listImageList?: [{	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageList"]],
paginateImageList?: [{	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageListConnection"]],
validateCreateImageList?: [{	data: ResolverInputTypes["ImageListCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by: ResolverInputTypes["ImageListUniqueWhere"],	data: ResolverInputTypes["ImageListUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getImageListItem?: [{	by: ResolverInputTypes["ImageListItemUniqueWhere"],	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null},ResolverInputTypes["ImageListItem"]],
listImageListItem?: [{	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["ImageListItem"]],
paginateImageListItem?: [{	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["ImageListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["ImageListItemConnection"]],
validateCreateImageListItem?: [{	data: ResolverInputTypes["ImageListItemCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateImageListItem?: [{	by: ResolverInputTypes["ImageListItemUniqueWhere"],	data: ResolverInputTypes["ImageListItemUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getJobFormSubscriptionStatus?: [{	by: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null},ResolverInputTypes["JobFormSubscriptionStatus"]],
listJobFormSubscriptionStatus?: [{	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobFormSubscriptionStatusOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["JobFormSubscriptionStatus"]],
paginateJobFormSubscriptionStatus?: [{	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["JobFormSubscriptionStatusOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["JobFormSubscriptionStatusConnection"]],
validateCreateJobFormSubscriptionStatus?: [{	data: ResolverInputTypes["JobFormSubscriptionStatusCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateJobFormSubscriptionStatus?: [{	by: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],	data: ResolverInputTypes["JobFormSubscriptionStatusUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocale"]],
listGeneralLocale?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["GeneralLocale"]],
paginateGeneralLocale?: [{	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["GeneralLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["GeneralLocaleConnection"]],
validateCreateGeneralLocale?: [{	data: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	data: ResolverInputTypes["GeneralLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getStickyBar?: [{	by: ResolverInputTypes["StickyBarUniqueWhere"],	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null},ResolverInputTypes["StickyBar"]],
listStickyBar?: [{	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StickyBarOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["StickyBar"]],
paginateStickyBar?: [{	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["StickyBarOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["StickyBarConnection"]],
validateCreateStickyBar?: [{	data: ResolverInputTypes["StickyBarCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateStickyBar?: [{	by: ResolverInputTypes["StickyBarUniqueWhere"],	data: ResolverInputTypes["StickyBarUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRecommendationForm?: [{	by: ResolverInputTypes["RecommendationFormUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null},ResolverInputTypes["RecommendationForm"]],
listRecommendationForm?: [{	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecommendationForm"]],
paginateRecommendationForm?: [{	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecommendationFormConnection"]],
validateCreateRecommendationForm?: [{	data: ResolverInputTypes["RecommendationFormCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRecommendationForm?: [{	by: ResolverInputTypes["RecommendationFormUniqueWhere"],	data: ResolverInputTypes["RecommendationFormUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRecommendationFormLocale?: [{	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null},ResolverInputTypes["RecommendationFormLocale"]],
listRecommendationFormLocale?: [{	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecommendationFormLocale"]],
paginateRecommendationFormLocale?: [{	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecommendationFormLocaleConnection"]],
validateCreateRecommendationFormLocale?: [{	data: ResolverInputTypes["RecommendationFormLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRecommendationFormLocale?: [{	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],	data: ResolverInputTypes["RecommendationFormLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getRecommendationFormSubscription?: [{	by: ResolverInputTypes["RecommendationFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null},ResolverInputTypes["RecommendationFormSubscription"]],
listRecommendationFormSubscription?: [{	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormSubscriptionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["RecommendationFormSubscription"]],
paginateRecommendationFormSubscription?: [{	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["RecommendationFormSubscriptionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["RecommendationFormSubscriptionConnection"]],
validateCreateRecommendationFormSubscription?: [{	data: ResolverInputTypes["RecommendationFormSubscriptionCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateRecommendationFormSubscription?: [{	by: ResolverInputTypes["RecommendationFormSubscriptionUniqueWhere"],	data: ResolverInputTypes["RecommendationFormSubscriptionUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getInfoBox?: [{	by: ResolverInputTypes["InfoBoxUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null},ResolverInputTypes["InfoBox"]],
listInfoBox?: [{	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoBox"]],
paginateInfoBox?: [{	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoBoxConnection"]],
validateCreateInfoBox?: [{	data: ResolverInputTypes["InfoBoxCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateInfoBox?: [{	by: ResolverInputTypes["InfoBoxUniqueWhere"],	data: ResolverInputTypes["InfoBoxUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getInfoBoxLocale?: [{	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null},ResolverInputTypes["InfoBoxLocale"]],
listInfoBoxLocale?: [{	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["InfoBoxLocale"]],
paginateInfoBoxLocale?: [{	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["InfoBoxLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["InfoBoxLocaleConnection"]],
validateCreateInfoBoxLocale?: [{	data: ResolverInputTypes["InfoBoxLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateInfoBoxLocale?: [{	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],	data: ResolverInputTypes["InfoBoxLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslation?: [{	by: ResolverInputTypes["TranslationUniqueWhere"],	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null},ResolverInputTypes["Translation"]],
listTranslation?: [{	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["Translation"]],
paginateTranslation?: [{	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationConnection"]],
validateCreateTranslation?: [{	data: ResolverInputTypes["TranslationCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslation?: [{	by: ResolverInputTypes["TranslationUniqueWhere"],	data: ResolverInputTypes["TranslationUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getTranslationLocale?: [{	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null},ResolverInputTypes["TranslationLocale"]],
listTranslationLocale?: [{	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["TranslationLocale"]],
paginateTranslationLocale?: [{	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["TranslationLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["TranslationLocaleConnection"]],
validateCreateTranslationLocale?: [{	data: ResolverInputTypes["TranslationLocaleCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateTranslationLocale?: [{	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],	data: ResolverInputTypes["TranslationLocaleUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
getCornerBanner?: [{	by: ResolverInputTypes["CornerBannerUniqueWhere"],	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null},ResolverInputTypes["CornerBanner"]],
listCornerBanner?: [{	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CornerBannerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ResolverInputTypes["CornerBanner"]],
paginateCornerBanner?: [{	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null,	orderBy?: Array<ResolverInputTypes["CornerBannerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ResolverInputTypes["CornerBannerConnection"]],
validateCreateCornerBanner?: [{	data: ResolverInputTypes["CornerBannerCreateInput"]},ResolverInputTypes["_ValidationResult"]],
validateUpdateCornerBanner?: [{	by: ResolverInputTypes["CornerBannerUniqueWhere"],	data: ResolverInputTypes["CornerBannerUpdateInput"]},ResolverInputTypes["_ValidationResult"]],
		__typename?: boolean | `@${string}`
}>;
	["Info"]: AliasType<{
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mutation"]: AliasType<{
generateUploadUrl?: [{	input?: ResolverInputTypes["S3GenerateSignedUploadInput"] | undefined | null},ResolverInputTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey: string,	expiration?: number | undefined | null},ResolverInputTypes["S3SignedRead"]],
createGeneral?: [{	data: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["GeneralCreateResult"]],
deleteGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null},ResolverInputTypes["GeneralDeleteResult"]],
updateGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	data: ResolverInputTypes["GeneralUpdateInput"]},ResolverInputTypes["GeneralUpdateResult"]],
upsertGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	update: ResolverInputTypes["GeneralUpdateInput"],	create: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["GeneralUpsertResult"]],
createImage?: [{	data: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["ImageCreateResult"]],
deleteImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["ImageDeleteResult"]],
updateImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	data: ResolverInputTypes["ImageUpdateInput"]},ResolverInputTypes["ImageUpdateResult"]],
upsertImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	update: ResolverInputTypes["ImageUpdateInput"],	create: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["ImageUpsertResult"]],
createGenericPage?: [{	data: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null},ResolverInputTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageUpdateInput"]},ResolverInputTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageUpdateInput"],	create: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["GenericPageUpsertResult"]],
createLinkable?: [{	data: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	data: ResolverInputTypes["LinkableUpdateInput"]},ResolverInputTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	update: ResolverInputTypes["LinkableUpdateInput"],	create: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["LinkableUpsertResult"]],
createSeo?: [{	data: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["SeoCreateResult"]],
deleteSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["SeoDeleteResult"]],
updateSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	data: ResolverInputTypes["SeoUpdateInput"]},ResolverInputTypes["SeoUpdateResult"]],
upsertSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	update: ResolverInputTypes["SeoUpdateInput"],	create: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["SeoUpsertResult"]],
createContent?: [{	data: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["ContentCreateResult"]],
deleteContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["ContentDeleteResult"]],
updateContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	data: ResolverInputTypes["ContentUpdateInput"]},ResolverInputTypes["ContentUpdateResult"]],
upsertContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	update: ResolverInputTypes["ContentUpdateInput"],	create: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["ContentUpsertResult"]],
createContentBlock?: [{	data: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	data: ResolverInputTypes["ContentBlockUpdateInput"]},ResolverInputTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	update: ResolverInputTypes["ContentBlockUpdateInput"],	create: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	data: ResolverInputTypes["ContentReferenceUpdateInput"]},ResolverInputTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	update: ResolverInputTypes["ContentReferenceUpdateInput"],	create: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["ContentReferenceUpsertResult"]],
createRedirect?: [{	data: ResolverInputTypes["RedirectCreateInput"]},ResolverInputTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by: ResolverInputTypes["RedirectUniqueWhere"],	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null},ResolverInputTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by: ResolverInputTypes["RedirectUniqueWhere"],	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null,	data: ResolverInputTypes["RedirectUpdateInput"]},ResolverInputTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by: ResolverInputTypes["RedirectUniqueWhere"],	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null,	update: ResolverInputTypes["RedirectUpdateInput"],	create: ResolverInputTypes["RedirectCreateInput"]},ResolverInputTypes["RedirectUpsertResult"]],
createLink?: [{	data: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["LinkCreateResult"]],
deleteLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["LinkDeleteResult"]],
updateLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	data: ResolverInputTypes["LinkUpdateInput"]},ResolverInputTypes["LinkUpdateResult"]],
upsertLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	update: ResolverInputTypes["LinkUpdateInput"],	create: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["LinkUpsertResult"]],
createFooter?: [{	data: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["FooterCreateResult"]],
deleteFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null},ResolverInputTypes["FooterDeleteResult"]],
updateFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	data: ResolverInputTypes["FooterUpdateInput"]},ResolverInputTypes["FooterUpdateResult"]],
upsertFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	update: ResolverInputTypes["FooterUpdateInput"],	create: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["FooterUpsertResult"]],
createFooterLink?: [{	data: ResolverInputTypes["FooterLinkCreateInput"]},ResolverInputTypes["FooterLinkCreateResult"]],
deleteFooterLink?: [{	by: ResolverInputTypes["FooterLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null},ResolverInputTypes["FooterLinkDeleteResult"]],
updateFooterLink?: [{	by: ResolverInputTypes["FooterLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	data: ResolverInputTypes["FooterLinkUpdateInput"]},ResolverInputTypes["FooterLinkUpdateResult"]],
upsertFooterLink?: [{	by: ResolverInputTypes["FooterLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	update: ResolverInputTypes["FooterLinkUpdateInput"],	create: ResolverInputTypes["FooterLinkCreateInput"]},ResolverInputTypes["FooterLinkUpsertResult"]],
createFooterLocale?: [{	data: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	data: ResolverInputTypes["FooterLocaleUpdateInput"]},ResolverInputTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	update: ResolverInputTypes["FooterLocaleUpdateInput"],	create: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["FooterLocaleUpsertResult"]],
createGenericPageLocale?: [{	data: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["GenericPageLocaleCreateResult"]],
deleteGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocaleDeleteResult"]],
updateGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageLocaleUpdateInput"]},ResolverInputTypes["GenericPageLocaleUpdateResult"]],
upsertGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageLocaleUpdateInput"],	create: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["GenericPageLocaleUpsertResult"]],
createHeader?: [{	data: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["HeaderCreateResult"]],
deleteHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null},ResolverInputTypes["HeaderDeleteResult"]],
updateHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	data: ResolverInputTypes["HeaderUpdateInput"]},ResolverInputTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	update: ResolverInputTypes["HeaderUpdateInput"],	create: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["HeaderUpsertResult"]],
createHeaderLocale?: [{	data: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	data: ResolverInputTypes["HeaderLocaleUpdateInput"]},ResolverInputTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	update: ResolverInputTypes["HeaderLocaleUpdateInput"],	create: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["HeaderLocaleUpsertResult"]],
createLocale?: [{	data: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["LocaleCreateResult"]],
deleteLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["LocaleDeleteResult"]],
updateLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	data: ResolverInputTypes["LocaleUpdateInput"]},ResolverInputTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	update: ResolverInputTypes["LocaleUpdateInput"],	create: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["LocaleUpsertResult"]],
createSeoDefault?: [{	data: ResolverInputTypes["SeoDefaultCreateInput"]},ResolverInputTypes["SeoDefaultCreateResult"]],
deleteSeoDefault?: [{	by: ResolverInputTypes["SeoDefaultUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null},ResolverInputTypes["SeoDefaultDeleteResult"]],
updateSeoDefault?: [{	by: ResolverInputTypes["SeoDefaultUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null,	data: ResolverInputTypes["SeoDefaultUpdateInput"]},ResolverInputTypes["SeoDefaultUpdateResult"]],
upsertSeoDefault?: [{	by: ResolverInputTypes["SeoDefaultUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null,	update: ResolverInputTypes["SeoDefaultUpdateInput"],	create: ResolverInputTypes["SeoDefaultCreateInput"]},ResolverInputTypes["SeoDefaultUpsertResult"]],
createSeoDefaultLocale?: [{	data: ResolverInputTypes["SeoDefaultLocaleCreateInput"]},ResolverInputTypes["SeoDefaultLocaleCreateResult"]],
deleteSeoDefaultLocale?: [{	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null},ResolverInputTypes["SeoDefaultLocaleDeleteResult"]],
updateSeoDefaultLocale?: [{	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	data: ResolverInputTypes["SeoDefaultLocaleUpdateInput"]},ResolverInputTypes["SeoDefaultLocaleUpdateResult"]],
upsertSeoDefaultLocale?: [{	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	update: ResolverInputTypes["SeoDefaultLocaleUpdateInput"],	create: ResolverInputTypes["SeoDefaultLocaleCreateInput"]},ResolverInputTypes["SeoDefaultLocaleUpsertResult"]],
createBusiness?: [{	data: ResolverInputTypes["BusinessCreateInput"]},ResolverInputTypes["BusinessCreateResult"]],
deleteBusiness?: [{	by: ResolverInputTypes["BusinessUniqueWhere"],	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null},ResolverInputTypes["BusinessDeleteResult"]],
updateBusiness?: [{	by: ResolverInputTypes["BusinessUniqueWhere"],	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	data: ResolverInputTypes["BusinessUpdateInput"]},ResolverInputTypes["BusinessUpdateResult"]],
upsertBusiness?: [{	by: ResolverInputTypes["BusinessUniqueWhere"],	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	update: ResolverInputTypes["BusinessUpdateInput"],	create: ResolverInputTypes["BusinessCreateInput"]},ResolverInputTypes["BusinessUpsertResult"]],
createBusinessPage?: [{	data: ResolverInputTypes["BusinessPageCreateInput"]},ResolverInputTypes["BusinessPageCreateResult"]],
deleteBusinessPage?: [{	by: ResolverInputTypes["BusinessPageUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null},ResolverInputTypes["BusinessPageDeleteResult"]],
updateBusinessPage?: [{	by: ResolverInputTypes["BusinessPageUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null,	data: ResolverInputTypes["BusinessPageUpdateInput"]},ResolverInputTypes["BusinessPageUpdateResult"]],
upsertBusinessPage?: [{	by: ResolverInputTypes["BusinessPageUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null,	update: ResolverInputTypes["BusinessPageUpdateInput"],	create: ResolverInputTypes["BusinessPageCreateInput"]},ResolverInputTypes["BusinessPageUpsertResult"]],
createBusinessPageLocale?: [{	data: ResolverInputTypes["BusinessPageLocaleCreateInput"]},ResolverInputTypes["BusinessPageLocaleCreateResult"]],
deleteBusinessPageLocale?: [{	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocaleDeleteResult"]],
updateBusinessPageLocale?: [{	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["BusinessPageLocaleUpdateInput"]},ResolverInputTypes["BusinessPageLocaleUpdateResult"]],
upsertBusinessPageLocale?: [{	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["BusinessPageLocaleUpdateInput"],	create: ResolverInputTypes["BusinessPageLocaleCreateInput"]},ResolverInputTypes["BusinessPageLocaleUpsertResult"]],
createIcon?: [{	data: ResolverInputTypes["IconCreateInput"]},ResolverInputTypes["IconCreateResult"]],
deleteIcon?: [{	by: ResolverInputTypes["IconUniqueWhere"],	filter?: ResolverInputTypes["IconWhere"] | undefined | null},ResolverInputTypes["IconDeleteResult"]],
updateIcon?: [{	by: ResolverInputTypes["IconUniqueWhere"],	filter?: ResolverInputTypes["IconWhere"] | undefined | null,	data: ResolverInputTypes["IconUpdateInput"]},ResolverInputTypes["IconUpdateResult"]],
upsertIcon?: [{	by: ResolverInputTypes["IconUniqueWhere"],	filter?: ResolverInputTypes["IconWhere"] | undefined | null,	update: ResolverInputTypes["IconUpdateInput"],	create: ResolverInputTypes["IconCreateInput"]},ResolverInputTypes["IconUpsertResult"]],
createJobPage?: [{	data: ResolverInputTypes["JobPageCreateInput"]},ResolverInputTypes["JobPageCreateResult"]],
deleteJobPage?: [{	by: ResolverInputTypes["JobPageUniqueWhere"],	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null},ResolverInputTypes["JobPageDeleteResult"]],
updateJobPage?: [{	by: ResolverInputTypes["JobPageUniqueWhere"],	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null,	data: ResolverInputTypes["JobPageUpdateInput"]},ResolverInputTypes["JobPageUpdateResult"]],
upsertJobPage?: [{	by: ResolverInputTypes["JobPageUniqueWhere"],	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null,	update: ResolverInputTypes["JobPageUpdateInput"],	create: ResolverInputTypes["JobPageCreateInput"]},ResolverInputTypes["JobPageUpsertResult"]],
createJobPageLocale?: [{	data: ResolverInputTypes["JobPageLocaleCreateInput"]},ResolverInputTypes["JobPageLocaleCreateResult"]],
deleteJobPageLocale?: [{	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocaleDeleteResult"]],
updateJobPageLocale?: [{	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["JobPageLocaleUpdateInput"]},ResolverInputTypes["JobPageLocaleUpdateResult"]],
upsertJobPageLocale?: [{	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["JobPageLocaleUpdateInput"],	create: ResolverInputTypes["JobPageLocaleCreateInput"]},ResolverInputTypes["JobPageLocaleUpsertResult"]],
createKeyInfoItem?: [{	data: ResolverInputTypes["KeyInfoItemCreateInput"]},ResolverInputTypes["KeyInfoItemCreateResult"]],
deleteKeyInfoItem?: [{	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null},ResolverInputTypes["KeyInfoItemDeleteResult"]],
updateKeyInfoItem?: [{	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,	data: ResolverInputTypes["KeyInfoItemUpdateInput"]},ResolverInputTypes["KeyInfoItemUpdateResult"]],
upsertKeyInfoItem?: [{	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,	update: ResolverInputTypes["KeyInfoItemUpdateInput"],	create: ResolverInputTypes["KeyInfoItemCreateInput"]},ResolverInputTypes["KeyInfoItemUpsertResult"]],
createKeyInfoList?: [{	data: ResolverInputTypes["KeyInfoListCreateInput"]},ResolverInputTypes["KeyInfoListCreateResult"]],
deleteKeyInfoList?: [{	by: ResolverInputTypes["KeyInfoListUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null},ResolverInputTypes["KeyInfoListDeleteResult"]],
updateKeyInfoList?: [{	by: ResolverInputTypes["KeyInfoListUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null,	data: ResolverInputTypes["KeyInfoListUpdateInput"]},ResolverInputTypes["KeyInfoListUpdateResult"]],
upsertKeyInfoList?: [{	by: ResolverInputTypes["KeyInfoListUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null,	update: ResolverInputTypes["KeyInfoListUpdateInput"],	create: ResolverInputTypes["KeyInfoListCreateInput"]},ResolverInputTypes["KeyInfoListUpsertResult"]],
createContractType?: [{	data: ResolverInputTypes["ContractTypeCreateInput"]},ResolverInputTypes["ContractTypeCreateResult"]],
deleteContractType?: [{	by: ResolverInputTypes["ContractTypeUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null},ResolverInputTypes["ContractTypeDeleteResult"]],
updateContractType?: [{	by: ResolverInputTypes["ContractTypeUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null,	data: ResolverInputTypes["ContractTypeUpdateInput"]},ResolverInputTypes["ContractTypeUpdateResult"]],
upsertContractType?: [{	by: ResolverInputTypes["ContractTypeUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null,	update: ResolverInputTypes["ContractTypeUpdateInput"],	create: ResolverInputTypes["ContractTypeCreateInput"]},ResolverInputTypes["ContractTypeUpsertResult"]],
createContractTypeLocale?: [{	data: ResolverInputTypes["ContractTypeLocaleCreateInput"]},ResolverInputTypes["ContractTypeLocaleCreateResult"]],
deleteContractTypeLocale?: [{	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null},ResolverInputTypes["ContractTypeLocaleDeleteResult"]],
updateContractTypeLocale?: [{	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	data: ResolverInputTypes["ContractTypeLocaleUpdateInput"]},ResolverInputTypes["ContractTypeLocaleUpdateResult"]],
upsertContractTypeLocale?: [{	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	update: ResolverInputTypes["ContractTypeLocaleUpdateInput"],	create: ResolverInputTypes["ContractTypeLocaleCreateInput"]},ResolverInputTypes["ContractTypeLocaleUpsertResult"]],
createJobCity?: [{	data: ResolverInputTypes["JobCityCreateInput"]},ResolverInputTypes["JobCityCreateResult"]],
deleteJobCity?: [{	by: ResolverInputTypes["JobCityUniqueWhere"],	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null},ResolverInputTypes["JobCityDeleteResult"]],
updateJobCity?: [{	by: ResolverInputTypes["JobCityUniqueWhere"],	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null,	data: ResolverInputTypes["JobCityUpdateInput"]},ResolverInputTypes["JobCityUpdateResult"]],
upsertJobCity?: [{	by: ResolverInputTypes["JobCityUniqueWhere"],	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null,	update: ResolverInputTypes["JobCityUpdateInput"],	create: ResolverInputTypes["JobCityCreateInput"]},ResolverInputTypes["JobCityUpsertResult"]],
createJobCityLocale?: [{	data: ResolverInputTypes["JobCityLocaleCreateInput"]},ResolverInputTypes["JobCityLocaleCreateResult"]],
deleteJobCityLocale?: [{	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null},ResolverInputTypes["JobCityLocaleDeleteResult"]],
updateJobCityLocale?: [{	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	data: ResolverInputTypes["JobCityLocaleUpdateInput"]},ResolverInputTypes["JobCityLocaleUpdateResult"]],
upsertJobCityLocale?: [{	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	update: ResolverInputTypes["JobCityLocaleUpdateInput"],	create: ResolverInputTypes["JobCityLocaleCreateInput"]},ResolverInputTypes["JobCityLocaleUpsertResult"]],
createJobPosition?: [{	data: ResolverInputTypes["JobPositionCreateInput"]},ResolverInputTypes["JobPositionCreateResult"]],
deleteJobPosition?: [{	by: ResolverInputTypes["JobPositionUniqueWhere"],	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null},ResolverInputTypes["JobPositionDeleteResult"]],
updateJobPosition?: [{	by: ResolverInputTypes["JobPositionUniqueWhere"],	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null,	data: ResolverInputTypes["JobPositionUpdateInput"]},ResolverInputTypes["JobPositionUpdateResult"]],
upsertJobPosition?: [{	by: ResolverInputTypes["JobPositionUniqueWhere"],	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null,	update: ResolverInputTypes["JobPositionUpdateInput"],	create: ResolverInputTypes["JobPositionCreateInput"]},ResolverInputTypes["JobPositionUpsertResult"]],
createJobPositionLocale?: [{	data: ResolverInputTypes["JobPositionLocaleCreateInput"]},ResolverInputTypes["JobPositionLocaleCreateResult"]],
deleteJobPositionLocale?: [{	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null},ResolverInputTypes["JobPositionLocaleDeleteResult"]],
updateJobPositionLocale?: [{	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	data: ResolverInputTypes["JobPositionLocaleUpdateInput"]},ResolverInputTypes["JobPositionLocaleUpdateResult"]],
upsertJobPositionLocale?: [{	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	update: ResolverInputTypes["JobPositionLocaleUpdateInput"],	create: ResolverInputTypes["JobPositionLocaleCreateInput"]},ResolverInputTypes["JobPositionLocaleUpsertResult"]],
createGallery?: [{	data: ResolverInputTypes["GalleryCreateInput"]},ResolverInputTypes["GalleryCreateResult"]],
deleteGallery?: [{	by: ResolverInputTypes["GalleryUniqueWhere"],	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null},ResolverInputTypes["GalleryDeleteResult"]],
updateGallery?: [{	by: ResolverInputTypes["GalleryUniqueWhere"],	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null,	data: ResolverInputTypes["GalleryUpdateInput"]},ResolverInputTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by: ResolverInputTypes["GalleryUniqueWhere"],	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null,	update: ResolverInputTypes["GalleryUpdateInput"],	create: ResolverInputTypes["GalleryCreateInput"]},ResolverInputTypes["GalleryUpsertResult"]],
createHomePage?: [{	data: ResolverInputTypes["HomePageCreateInput"]},ResolverInputTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by: ResolverInputTypes["HomePageUniqueWhere"],	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null},ResolverInputTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by: ResolverInputTypes["HomePageUniqueWhere"],	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null,	data: ResolverInputTypes["HomePageUpdateInput"]},ResolverInputTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by: ResolverInputTypes["HomePageUniqueWhere"],	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null,	update: ResolverInputTypes["HomePageUpdateInput"],	create: ResolverInputTypes["HomePageCreateInput"]},ResolverInputTypes["HomePageUpsertResult"]],
createHomePageLocale?: [{	data: ResolverInputTypes["HomePageLocaleCreateInput"]},ResolverInputTypes["HomePageLocaleCreateResult"]],
deleteHomePageLocale?: [{	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocaleDeleteResult"]],
updateHomePageLocale?: [{	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["HomePageLocaleUpdateInput"]},ResolverInputTypes["HomePageLocaleUpdateResult"]],
upsertHomePageLocale?: [{	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["HomePageLocaleUpdateInput"],	create: ResolverInputTypes["HomePageLocaleCreateInput"]},ResolverInputTypes["HomePageLocaleUpsertResult"]],
createMedium?: [{	data: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["MediumCreateResult"]],
deleteMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null},ResolverInputTypes["MediumDeleteResult"]],
updateMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	data: ResolverInputTypes["MediumUpdateInput"]},ResolverInputTypes["MediumUpdateResult"]],
upsertMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	update: ResolverInputTypes["MediumUpdateInput"],	create: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["MediumUpsertResult"]],
createMediumItem?: [{	data: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["MediumItemCreateResult"]],
deleteMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null},ResolverInputTypes["MediumItemDeleteResult"]],
updateMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	data: ResolverInputTypes["MediumItemUpdateInput"]},ResolverInputTypes["MediumItemUpdateResult"]],
upsertMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	update: ResolverInputTypes["MediumItemUpdateInput"],	create: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["MediumItemUpsertResult"]],
createMediumList?: [{	data: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["MediumListCreateResult"]],
deleteMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumListDeleteResult"]],
updateMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	data: ResolverInputTypes["MediumListUpdateInput"]},ResolverInputTypes["MediumListUpdateResult"]],
upsertMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	update: ResolverInputTypes["MediumListUpdateInput"],	create: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["MediumListUpsertResult"]],
createVideo?: [{	data: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["VideoCreateResult"]],
deleteVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["VideoDeleteResult"]],
updateVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	data: ResolverInputTypes["VideoUpdateInput"]},ResolverInputTypes["VideoUpdateResult"]],
upsertVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	update: ResolverInputTypes["VideoUpdateInput"],	create: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["VideoUpsertResult"]],
createTextItem?: [{	data: ResolverInputTypes["TextItemCreateInput"]},ResolverInputTypes["TextItemCreateResult"]],
deleteTextItem?: [{	by: ResolverInputTypes["TextItemUniqueWhere"],	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null},ResolverInputTypes["TextItemDeleteResult"]],
updateTextItem?: [{	by: ResolverInputTypes["TextItemUniqueWhere"],	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null,	data: ResolverInputTypes["TextItemUpdateInput"]},ResolverInputTypes["TextItemUpdateResult"]],
upsertTextItem?: [{	by: ResolverInputTypes["TextItemUniqueWhere"],	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null,	update: ResolverInputTypes["TextItemUpdateInput"],	create: ResolverInputTypes["TextItemCreateInput"]},ResolverInputTypes["TextItemUpsertResult"]],
createTextList?: [{	data: ResolverInputTypes["TextListCreateInput"]},ResolverInputTypes["TextListCreateResult"]],
deleteTextList?: [{	by: ResolverInputTypes["TextListUniqueWhere"],	filter?: ResolverInputTypes["TextListWhere"] | undefined | null},ResolverInputTypes["TextListDeleteResult"]],
updateTextList?: [{	by: ResolverInputTypes["TextListUniqueWhere"],	filter?: ResolverInputTypes["TextListWhere"] | undefined | null,	data: ResolverInputTypes["TextListUpdateInput"]},ResolverInputTypes["TextListUpdateResult"]],
upsertTextList?: [{	by: ResolverInputTypes["TextListUniqueWhere"],	filter?: ResolverInputTypes["TextListWhere"] | undefined | null,	update: ResolverInputTypes["TextListUpdateInput"],	create: ResolverInputTypes["TextListCreateInput"]},ResolverInputTypes["TextListUpsertResult"]],
createCarousel?: [{	data: ResolverInputTypes["CarouselCreateInput"]},ResolverInputTypes["CarouselCreateResult"]],
deleteCarousel?: [{	by: ResolverInputTypes["CarouselUniqueWhere"],	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null},ResolverInputTypes["CarouselDeleteResult"]],
updateCarousel?: [{	by: ResolverInputTypes["CarouselUniqueWhere"],	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null,	data: ResolverInputTypes["CarouselUpdateInput"]},ResolverInputTypes["CarouselUpdateResult"]],
upsertCarousel?: [{	by: ResolverInputTypes["CarouselUniqueWhere"],	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null,	update: ResolverInputTypes["CarouselUpdateInput"],	create: ResolverInputTypes["CarouselCreateInput"]},ResolverInputTypes["CarouselUpsertResult"]],
createCarouselItem?: [{	data: ResolverInputTypes["CarouselItemCreateInput"]},ResolverInputTypes["CarouselItemCreateResult"]],
deleteCarouselItem?: [{	by: ResolverInputTypes["CarouselItemUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null},ResolverInputTypes["CarouselItemDeleteResult"]],
updateCarouselItem?: [{	by: ResolverInputTypes["CarouselItemUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,	data: ResolverInputTypes["CarouselItemUpdateInput"]},ResolverInputTypes["CarouselItemUpdateResult"]],
upsertCarouselItem?: [{	by: ResolverInputTypes["CarouselItemUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,	update: ResolverInputTypes["CarouselItemUpdateInput"],	create: ResolverInputTypes["CarouselItemCreateInput"]},ResolverInputTypes["CarouselItemUpsertResult"]],
createTheme?: [{	data: ResolverInputTypes["ThemeCreateInput"]},ResolverInputTypes["ThemeCreateResult"]],
deleteTheme?: [{	by: ResolverInputTypes["ThemeUniqueWhere"],	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null},ResolverInputTypes["ThemeDeleteResult"]],
updateTheme?: [{	by: ResolverInputTypes["ThemeUniqueWhere"],	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null,	data: ResolverInputTypes["ThemeUpdateInput"]},ResolverInputTypes["ThemeUpdateResult"]],
upsertTheme?: [{	by: ResolverInputTypes["ThemeUniqueWhere"],	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null,	update: ResolverInputTypes["ThemeUpdateInput"],	create: ResolverInputTypes["ThemeCreateInput"]},ResolverInputTypes["ThemeUpsertResult"]],
createBonusBanner?: [{	data: ResolverInputTypes["BonusBannerCreateInput"]},ResolverInputTypes["BonusBannerCreateResult"]],
deleteBonusBanner?: [{	by: ResolverInputTypes["BonusBannerUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null},ResolverInputTypes["BonusBannerDeleteResult"]],
updateBonusBanner?: [{	by: ResolverInputTypes["BonusBannerUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null,	data: ResolverInputTypes["BonusBannerUpdateInput"]},ResolverInputTypes["BonusBannerUpdateResult"]],
upsertBonusBanner?: [{	by: ResolverInputTypes["BonusBannerUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null,	update: ResolverInputTypes["BonusBannerUpdateInput"],	create: ResolverInputTypes["BonusBannerCreateInput"]},ResolverInputTypes["BonusBannerUpsertResult"]],
createBonusBannerLocale?: [{	data: ResolverInputTypes["BonusBannerLocaleCreateInput"]},ResolverInputTypes["BonusBannerLocaleCreateResult"]],
deleteBonusBannerLocale?: [{	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocaleDeleteResult"]],
updateBonusBannerLocale?: [{	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	data: ResolverInputTypes["BonusBannerLocaleUpdateInput"]},ResolverInputTypes["BonusBannerLocaleUpdateResult"]],
upsertBonusBannerLocale?: [{	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	update: ResolverInputTypes["BonusBannerLocaleUpdateInput"],	create: ResolverInputTypes["BonusBannerLocaleCreateInput"]},ResolverInputTypes["BonusBannerLocaleUpsertResult"]],
createTile?: [{	data: ResolverInputTypes["TileCreateInput"]},ResolverInputTypes["TileCreateResult"]],
deleteTile?: [{	by: ResolverInputTypes["TileUniqueWhere"],	filter?: ResolverInputTypes["TileWhere"] | undefined | null},ResolverInputTypes["TileDeleteResult"]],
updateTile?: [{	by: ResolverInputTypes["TileUniqueWhere"],	filter?: ResolverInputTypes["TileWhere"] | undefined | null,	data: ResolverInputTypes["TileUpdateInput"]},ResolverInputTypes["TileUpdateResult"]],
upsertTile?: [{	by: ResolverInputTypes["TileUniqueWhere"],	filter?: ResolverInputTypes["TileWhere"] | undefined | null,	update: ResolverInputTypes["TileUpdateInput"],	create: ResolverInputTypes["TileCreateInput"]},ResolverInputTypes["TileUpsertResult"]],
createSideBySide?: [{	data: ResolverInputTypes["SideBySideCreateInput"]},ResolverInputTypes["SideBySideCreateResult"]],
deleteSideBySide?: [{	by: ResolverInputTypes["SideBySideUniqueWhere"],	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null},ResolverInputTypes["SideBySideDeleteResult"]],
updateSideBySide?: [{	by: ResolverInputTypes["SideBySideUniqueWhere"],	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null,	data: ResolverInputTypes["SideBySideUpdateInput"]},ResolverInputTypes["SideBySideUpdateResult"]],
upsertSideBySide?: [{	by: ResolverInputTypes["SideBySideUniqueWhere"],	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null,	update: ResolverInputTypes["SideBySideUpdateInput"],	create: ResolverInputTypes["SideBySideCreateInput"]},ResolverInputTypes["SideBySideUpsertResult"]],
createSideBySideItem?: [{	data: ResolverInputTypes["SideBySideItemCreateInput"]},ResolverInputTypes["SideBySideItemCreateResult"]],
deleteSideBySideItem?: [{	by: ResolverInputTypes["SideBySideItemUniqueWhere"],	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null},ResolverInputTypes["SideBySideItemDeleteResult"]],
updateSideBySideItem?: [{	by: ResolverInputTypes["SideBySideItemUniqueWhere"],	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,	data: ResolverInputTypes["SideBySideItemUpdateInput"]},ResolverInputTypes["SideBySideItemUpdateResult"]],
upsertSideBySideItem?: [{	by: ResolverInputTypes["SideBySideItemUniqueWhere"],	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,	update: ResolverInputTypes["SideBySideItemUpdateInput"],	create: ResolverInputTypes["SideBySideItemCreateInput"]},ResolverInputTypes["SideBySideItemUpsertResult"]],
createHomePageLokal?: [{	data: ResolverInputTypes["HomePageLokalCreateInput"]},ResolverInputTypes["HomePageLokalCreateResult"]],
deleteHomePageLokal?: [{	by: ResolverInputTypes["HomePageLokalUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null},ResolverInputTypes["HomePageLokalDeleteResult"]],
updateHomePageLokal?: [{	by: ResolverInputTypes["HomePageLokalUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null,	data: ResolverInputTypes["HomePageLokalUpdateInput"]},ResolverInputTypes["HomePageLokalUpdateResult"]],
upsertHomePageLokal?: [{	by: ResolverInputTypes["HomePageLokalUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null,	update: ResolverInputTypes["HomePageLokalUpdateInput"],	create: ResolverInputTypes["HomePageLokalCreateInput"]},ResolverInputTypes["HomePageLokalUpsertResult"]],
createHomePageLokalLocale?: [{	data: ResolverInputTypes["HomePageLokalLocaleCreateInput"]},ResolverInputTypes["HomePageLokalLocaleCreateResult"]],
deleteHomePageLokalLocale?: [{	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocaleDeleteResult"]],
updateHomePageLokalLocale?: [{	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	data: ResolverInputTypes["HomePageLokalLocaleUpdateInput"]},ResolverInputTypes["HomePageLokalLocaleUpdateResult"]],
upsertHomePageLokalLocale?: [{	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	update: ResolverInputTypes["HomePageLokalLocaleUpdateInput"],	create: ResolverInputTypes["HomePageLokalLocaleCreateInput"]},ResolverInputTypes["HomePageLokalLocaleUpsertResult"]],
createSiteSwitcher?: [{	data: ResolverInputTypes["SiteSwitcherCreateInput"]},ResolverInputTypes["SiteSwitcherCreateResult"]],
deleteSiteSwitcher?: [{	by: ResolverInputTypes["SiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null},ResolverInputTypes["SiteSwitcherDeleteResult"]],
updateSiteSwitcher?: [{	by: ResolverInputTypes["SiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null,	data: ResolverInputTypes["SiteSwitcherUpdateInput"]},ResolverInputTypes["SiteSwitcherUpdateResult"]],
upsertSiteSwitcher?: [{	by: ResolverInputTypes["SiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null,	update: ResolverInputTypes["SiteSwitcherUpdateInput"],	create: ResolverInputTypes["SiteSwitcherCreateInput"]},ResolverInputTypes["SiteSwitcherUpsertResult"]],
createGalleryItem?: [{	data: ResolverInputTypes["GalleryItemCreateInput"]},ResolverInputTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by: ResolverInputTypes["GalleryItemUniqueWhere"],	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null},ResolverInputTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by: ResolverInputTypes["GalleryItemUniqueWhere"],	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,	data: ResolverInputTypes["GalleryItemUpdateInput"]},ResolverInputTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by: ResolverInputTypes["GalleryItemUniqueWhere"],	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,	update: ResolverInputTypes["GalleryItemUpdateInput"],	create: ResolverInputTypes["GalleryItemCreateInput"]},ResolverInputTypes["GalleryItemUpsertResult"]],
createJobsForm?: [{	data: ResolverInputTypes["JobsFormCreateInput"]},ResolverInputTypes["JobsFormCreateResult"]],
deleteJobsForm?: [{	by: ResolverInputTypes["JobsFormUniqueWhere"],	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null},ResolverInputTypes["JobsFormDeleteResult"]],
updateJobsForm?: [{	by: ResolverInputTypes["JobsFormUniqueWhere"],	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null,	data: ResolverInputTypes["JobsFormUpdateInput"]},ResolverInputTypes["JobsFormUpdateResult"]],
upsertJobsForm?: [{	by: ResolverInputTypes["JobsFormUniqueWhere"],	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null,	update: ResolverInputTypes["JobsFormUpdateInput"],	create: ResolverInputTypes["JobsFormCreateInput"]},ResolverInputTypes["JobsFormUpsertResult"]],
createJobsFormLocale?: [{	data: ResolverInputTypes["JobsFormLocaleCreateInput"]},ResolverInputTypes["JobsFormLocaleCreateResult"]],
deleteJobsFormLocale?: [{	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocaleDeleteResult"]],
updateJobsFormLocale?: [{	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	data: ResolverInputTypes["JobsFormLocaleUpdateInput"]},ResolverInputTypes["JobsFormLocaleUpdateResult"]],
upsertJobsFormLocale?: [{	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	update: ResolverInputTypes["JobsFormLocaleUpdateInput"],	create: ResolverInputTypes["JobsFormLocaleCreateInput"]},ResolverInputTypes["JobsFormLocaleUpsertResult"]],
createImageTextItem?: [{	data: ResolverInputTypes["ImageTextItemCreateInput"]},ResolverInputTypes["ImageTextItemCreateResult"]],
deleteImageTextItem?: [{	by: ResolverInputTypes["ImageTextItemUniqueWhere"],	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null},ResolverInputTypes["ImageTextItemDeleteResult"]],
updateImageTextItem?: [{	by: ResolverInputTypes["ImageTextItemUniqueWhere"],	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,	data: ResolverInputTypes["ImageTextItemUpdateInput"]},ResolverInputTypes["ImageTextItemUpdateResult"]],
upsertImageTextItem?: [{	by: ResolverInputTypes["ImageTextItemUniqueWhere"],	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,	update: ResolverInputTypes["ImageTextItemUpdateInput"],	create: ResolverInputTypes["ImageTextItemCreateInput"]},ResolverInputTypes["ImageTextItemUpsertResult"]],
createImageTextList?: [{	data: ResolverInputTypes["ImageTextListCreateInput"]},ResolverInputTypes["ImageTextListCreateResult"]],
deleteImageTextList?: [{	by: ResolverInputTypes["ImageTextListUniqueWhere"],	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null},ResolverInputTypes["ImageTextListDeleteResult"]],
updateImageTextList?: [{	by: ResolverInputTypes["ImageTextListUniqueWhere"],	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null,	data: ResolverInputTypes["ImageTextListUpdateInput"]},ResolverInputTypes["ImageTextListUpdateResult"]],
upsertImageTextList?: [{	by: ResolverInputTypes["ImageTextListUniqueWhere"],	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null,	update: ResolverInputTypes["ImageTextListUpdateInput"],	create: ResolverInputTypes["ImageTextListCreateInput"]},ResolverInputTypes["ImageTextListUpsertResult"]],
createJobsFilter?: [{	data: ResolverInputTypes["JobsFilterCreateInput"]},ResolverInputTypes["JobsFilterCreateResult"]],
deleteJobsFilter?: [{	by: ResolverInputTypes["JobsFilterUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null},ResolverInputTypes["JobsFilterDeleteResult"]],
updateJobsFilter?: [{	by: ResolverInputTypes["JobsFilterUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null,	data: ResolverInputTypes["JobsFilterUpdateInput"]},ResolverInputTypes["JobsFilterUpdateResult"]],
upsertJobsFilter?: [{	by: ResolverInputTypes["JobsFilterUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null,	update: ResolverInputTypes["JobsFilterUpdateInput"],	create: ResolverInputTypes["JobsFilterCreateInput"]},ResolverInputTypes["JobsFilterUpsertResult"]],
createJobsFilterLocale?: [{	data: ResolverInputTypes["JobsFilterLocaleCreateInput"]},ResolverInputTypes["JobsFilterLocaleCreateResult"]],
deleteJobsFilterLocale?: [{	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocaleDeleteResult"]],
updateJobsFilterLocale?: [{	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	data: ResolverInputTypes["JobsFilterLocaleUpdateInput"]},ResolverInputTypes["JobsFilterLocaleUpdateResult"]],
upsertJobsFilterLocale?: [{	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	update: ResolverInputTypes["JobsFilterLocaleUpdateInput"],	create: ResolverInputTypes["JobsFilterLocaleCreateInput"]},ResolverInputTypes["JobsFilterLocaleUpsertResult"]],
createFile?: [{	data: ResolverInputTypes["FileCreateInput"]},ResolverInputTypes["FileCreateResult"]],
deleteFile?: [{	by: ResolverInputTypes["FileUniqueWhere"],	filter?: ResolverInputTypes["FileWhere"] | undefined | null},ResolverInputTypes["FileDeleteResult"]],
updateFile?: [{	by: ResolverInputTypes["FileUniqueWhere"],	filter?: ResolverInputTypes["FileWhere"] | undefined | null,	data: ResolverInputTypes["FileUpdateInput"]},ResolverInputTypes["FileUpdateResult"]],
upsertFile?: [{	by: ResolverInputTypes["FileUniqueWhere"],	filter?: ResolverInputTypes["FileWhere"] | undefined | null,	update: ResolverInputTypes["FileUpdateInput"],	create: ResolverInputTypes["FileCreateInput"]},ResolverInputTypes["FileUpsertResult"]],
createJobFormSubscription?: [{	data: ResolverInputTypes["JobFormSubscriptionCreateInput"]},ResolverInputTypes["JobFormSubscriptionCreateResult"]],
deleteJobFormSubscription?: [{	by: ResolverInputTypes["JobFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null},ResolverInputTypes["JobFormSubscriptionDeleteResult"]],
updateJobFormSubscription?: [{	by: ResolverInputTypes["JobFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null,	data: ResolverInputTypes["JobFormSubscriptionUpdateInput"]},ResolverInputTypes["JobFormSubscriptionUpdateResult"]],
upsertJobFormSubscription?: [{	by: ResolverInputTypes["JobFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null,	update: ResolverInputTypes["JobFormSubscriptionUpdateInput"],	create: ResolverInputTypes["JobFormSubscriptionCreateInput"]},ResolverInputTypes["JobFormSubscriptionUpsertResult"]],
createImageList?: [{	data: ResolverInputTypes["ImageListCreateInput"]},ResolverInputTypes["ImageListCreateResult"]],
deleteImageList?: [{	by: ResolverInputTypes["ImageListUniqueWhere"],	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null},ResolverInputTypes["ImageListDeleteResult"]],
updateImageList?: [{	by: ResolverInputTypes["ImageListUniqueWhere"],	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null,	data: ResolverInputTypes["ImageListUpdateInput"]},ResolverInputTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by: ResolverInputTypes["ImageListUniqueWhere"],	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null,	update: ResolverInputTypes["ImageListUpdateInput"],	create: ResolverInputTypes["ImageListCreateInput"]},ResolverInputTypes["ImageListUpsertResult"]],
createImageListItem?: [{	data: ResolverInputTypes["ImageListItemCreateInput"]},ResolverInputTypes["ImageListItemCreateResult"]],
deleteImageListItem?: [{	by: ResolverInputTypes["ImageListItemUniqueWhere"],	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null},ResolverInputTypes["ImageListItemDeleteResult"]],
updateImageListItem?: [{	by: ResolverInputTypes["ImageListItemUniqueWhere"],	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,	data: ResolverInputTypes["ImageListItemUpdateInput"]},ResolverInputTypes["ImageListItemUpdateResult"]],
upsertImageListItem?: [{	by: ResolverInputTypes["ImageListItemUniqueWhere"],	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,	update: ResolverInputTypes["ImageListItemUpdateInput"],	create: ResolverInputTypes["ImageListItemCreateInput"]},ResolverInputTypes["ImageListItemUpsertResult"]],
createJobFormSubscriptionStatus?: [{	data: ResolverInputTypes["JobFormSubscriptionStatusCreateInput"]},ResolverInputTypes["JobFormSubscriptionStatusCreateResult"]],
deleteJobFormSubscriptionStatus?: [{	by: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null},ResolverInputTypes["JobFormSubscriptionStatusDeleteResult"]],
updateJobFormSubscriptionStatus?: [{	by: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null,	data: ResolverInputTypes["JobFormSubscriptionStatusUpdateInput"]},ResolverInputTypes["JobFormSubscriptionStatusUpdateResult"]],
upsertJobFormSubscriptionStatus?: [{	by: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null,	update: ResolverInputTypes["JobFormSubscriptionStatusUpdateInput"],	create: ResolverInputTypes["JobFormSubscriptionStatusCreateInput"]},ResolverInputTypes["JobFormSubscriptionStatusUpsertResult"]],
createGeneralLocale?: [{	data: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["GeneralLocaleCreateResult"]],
deleteGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocaleDeleteResult"]],
updateGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GeneralLocaleUpdateInput"]},ResolverInputTypes["GeneralLocaleUpdateResult"]],
upsertGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GeneralLocaleUpdateInput"],	create: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["GeneralLocaleUpsertResult"]],
createStickyBar?: [{	data: ResolverInputTypes["StickyBarCreateInput"]},ResolverInputTypes["StickyBarCreateResult"]],
deleteStickyBar?: [{	by: ResolverInputTypes["StickyBarUniqueWhere"],	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null},ResolverInputTypes["StickyBarDeleteResult"]],
updateStickyBar?: [{	by: ResolverInputTypes["StickyBarUniqueWhere"],	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null,	data: ResolverInputTypes["StickyBarUpdateInput"]},ResolverInputTypes["StickyBarUpdateResult"]],
upsertStickyBar?: [{	by: ResolverInputTypes["StickyBarUniqueWhere"],	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null,	update: ResolverInputTypes["StickyBarUpdateInput"],	create: ResolverInputTypes["StickyBarCreateInput"]},ResolverInputTypes["StickyBarUpsertResult"]],
createRecommendationForm?: [{	data: ResolverInputTypes["RecommendationFormCreateInput"]},ResolverInputTypes["RecommendationFormCreateResult"]],
deleteRecommendationForm?: [{	by: ResolverInputTypes["RecommendationFormUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null},ResolverInputTypes["RecommendationFormDeleteResult"]],
updateRecommendationForm?: [{	by: ResolverInputTypes["RecommendationFormUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null,	data: ResolverInputTypes["RecommendationFormUpdateInput"]},ResolverInputTypes["RecommendationFormUpdateResult"]],
upsertRecommendationForm?: [{	by: ResolverInputTypes["RecommendationFormUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null,	update: ResolverInputTypes["RecommendationFormUpdateInput"],	create: ResolverInputTypes["RecommendationFormCreateInput"]},ResolverInputTypes["RecommendationFormUpsertResult"]],
createRecommendationFormLocale?: [{	data: ResolverInputTypes["RecommendationFormLocaleCreateInput"]},ResolverInputTypes["RecommendationFormLocaleCreateResult"]],
deleteRecommendationFormLocale?: [{	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null},ResolverInputTypes["RecommendationFormLocaleDeleteResult"]],
updateRecommendationFormLocale?: [{	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	data: ResolverInputTypes["RecommendationFormLocaleUpdateInput"]},ResolverInputTypes["RecommendationFormLocaleUpdateResult"]],
upsertRecommendationFormLocale?: [{	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	update: ResolverInputTypes["RecommendationFormLocaleUpdateInput"],	create: ResolverInputTypes["RecommendationFormLocaleCreateInput"]},ResolverInputTypes["RecommendationFormLocaleUpsertResult"]],
createRecommendationFormSubscription?: [{	data: ResolverInputTypes["RecommendationFormSubscriptionCreateInput"]},ResolverInputTypes["RecommendationFormSubscriptionCreateResult"]],
deleteRecommendationFormSubscription?: [{	by: ResolverInputTypes["RecommendationFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null},ResolverInputTypes["RecommendationFormSubscriptionDeleteResult"]],
updateRecommendationFormSubscription?: [{	by: ResolverInputTypes["RecommendationFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null,	data: ResolverInputTypes["RecommendationFormSubscriptionUpdateInput"]},ResolverInputTypes["RecommendationFormSubscriptionUpdateResult"]],
upsertRecommendationFormSubscription?: [{	by: ResolverInputTypes["RecommendationFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null,	update: ResolverInputTypes["RecommendationFormSubscriptionUpdateInput"],	create: ResolverInputTypes["RecommendationFormSubscriptionCreateInput"]},ResolverInputTypes["RecommendationFormSubscriptionUpsertResult"]],
createInfoBox?: [{	data: ResolverInputTypes["InfoBoxCreateInput"]},ResolverInputTypes["InfoBoxCreateResult"]],
deleteInfoBox?: [{	by: ResolverInputTypes["InfoBoxUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null},ResolverInputTypes["InfoBoxDeleteResult"]],
updateInfoBox?: [{	by: ResolverInputTypes["InfoBoxUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null,	data: ResolverInputTypes["InfoBoxUpdateInput"]},ResolverInputTypes["InfoBoxUpdateResult"]],
upsertInfoBox?: [{	by: ResolverInputTypes["InfoBoxUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null,	update: ResolverInputTypes["InfoBoxUpdateInput"],	create: ResolverInputTypes["InfoBoxCreateInput"]},ResolverInputTypes["InfoBoxUpsertResult"]],
createInfoBoxLocale?: [{	data: ResolverInputTypes["InfoBoxLocaleCreateInput"]},ResolverInputTypes["InfoBoxLocaleCreateResult"]],
deleteInfoBoxLocale?: [{	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null},ResolverInputTypes["InfoBoxLocaleDeleteResult"]],
updateInfoBoxLocale?: [{	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	data: ResolverInputTypes["InfoBoxLocaleUpdateInput"]},ResolverInputTypes["InfoBoxLocaleUpdateResult"]],
upsertInfoBoxLocale?: [{	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	update: ResolverInputTypes["InfoBoxLocaleUpdateInput"],	create: ResolverInputTypes["InfoBoxLocaleCreateInput"]},ResolverInputTypes["InfoBoxLocaleUpsertResult"]],
createTranslation?: [{	data: ResolverInputTypes["TranslationCreateInput"]},ResolverInputTypes["TranslationCreateResult"]],
deleteTranslation?: [{	by: ResolverInputTypes["TranslationUniqueWhere"],	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null},ResolverInputTypes["TranslationDeleteResult"]],
updateTranslation?: [{	by: ResolverInputTypes["TranslationUniqueWhere"],	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null,	data: ResolverInputTypes["TranslationUpdateInput"]},ResolverInputTypes["TranslationUpdateResult"]],
upsertTranslation?: [{	by: ResolverInputTypes["TranslationUniqueWhere"],	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null,	update: ResolverInputTypes["TranslationUpdateInput"],	create: ResolverInputTypes["TranslationCreateInput"]},ResolverInputTypes["TranslationUpsertResult"]],
createTranslationLocale?: [{	data: ResolverInputTypes["TranslationLocaleCreateInput"]},ResolverInputTypes["TranslationLocaleCreateResult"]],
deleteTranslationLocale?: [{	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null},ResolverInputTypes["TranslationLocaleDeleteResult"]],
updateTranslationLocale?: [{	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	data: ResolverInputTypes["TranslationLocaleUpdateInput"]},ResolverInputTypes["TranslationLocaleUpdateResult"]],
upsertTranslationLocale?: [{	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	update: ResolverInputTypes["TranslationLocaleUpdateInput"],	create: ResolverInputTypes["TranslationLocaleCreateInput"]},ResolverInputTypes["TranslationLocaleUpsertResult"]],
createCornerBanner?: [{	data: ResolverInputTypes["CornerBannerCreateInput"]},ResolverInputTypes["CornerBannerCreateResult"]],
deleteCornerBanner?: [{	by: ResolverInputTypes["CornerBannerUniqueWhere"],	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null},ResolverInputTypes["CornerBannerDeleteResult"]],
updateCornerBanner?: [{	by: ResolverInputTypes["CornerBannerUniqueWhere"],	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null,	data: ResolverInputTypes["CornerBannerUpdateInput"]},ResolverInputTypes["CornerBannerUpdateResult"]],
upsertCornerBanner?: [{	by: ResolverInputTypes["CornerBannerUniqueWhere"],	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null,	update: ResolverInputTypes["CornerBannerUpdateInput"],	create: ResolverInputTypes["CornerBannerCreateInput"]},ResolverInputTypes["CornerBannerUpsertResult"]],
transaction?: [{	options?: ResolverInputTypes["MutationTransactionOptions"] | undefined | null},ResolverInputTypes["MutationTransaction"]],
	query?:ResolverInputTypes["Query"],
		__typename?: boolean | `@${string}`
}>;
	["S3SignedUpload"]: AliasType<{
	url?:boolean | `@${string}`,
	headers?:ResolverInputTypes["S3Header"],
	method?:boolean | `@${string}`,
	objectKey?:boolean | `@${string}`,
	bucket?:boolean | `@${string}`,
	publicUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3Header"]: AliasType<{
	key?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3GenerateSignedUploadInput"]: {
	contentType?: string | undefined | null,
	/** If not provided, extension is detected from a content-type. */
	extension?: string | undefined | null,
	/** Signed URL expiration. */
	expiration?: number | undefined | null,
	/** Uploaded file size. Required when you enable ACL size limits. */
	size?: number | undefined | null,
	/** Can be used as a "directory". */
	prefix?: string | undefined | null,
	/** Suffix after generated id and before the extension. */
	suffix?: string | undefined | null,
	/** This only affects Content-disposition header. Does not affect actual object key. */
	fileName?: string | undefined | null,
	contentDisposition?: ResolverInputTypes["S33ContentDisposition"] | undefined | null,
	/** If not supported by S3 provider, an error is thrown. */
	acl?: ResolverInputTypes["S3Acl"] | undefined | null
};
	["S33ContentDisposition"]:S33ContentDisposition;
	["S3Acl"]:S3Acl;
	["S3SignedRead"]: AliasType<{
	url?:boolean | `@${string}`,
	headers?:ResolverInputTypes["S3Header"],
	method?:boolean | `@${string}`,
	objectKey?:boolean | `@${string}`,
	bucket?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GeneralCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["General"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MutationResult"]:AliasType<{
		ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"];
		['...on GeneralCreateResult']?: Omit<ResolverInputTypes["GeneralCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralDeleteResult']?: Omit<ResolverInputTypes["GeneralDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralUpdateResult']?: Omit<ResolverInputTypes["GeneralUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralUpsertResult']?: Omit<ResolverInputTypes["GeneralUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ResolverInputTypes["ImageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ResolverInputTypes["ImageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ResolverInputTypes["ImageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ResolverInputTypes["ImageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageCreateResult']?: Omit<ResolverInputTypes["GenericPageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageDeleteResult']?: Omit<ResolverInputTypes["GenericPageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageUpdateResult']?: Omit<ResolverInputTypes["GenericPageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageUpsertResult']?: Omit<ResolverInputTypes["GenericPageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ResolverInputTypes["LinkableCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ResolverInputTypes["LinkableDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ResolverInputTypes["LinkableUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ResolverInputTypes["LinkableUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ResolverInputTypes["SeoCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ResolverInputTypes["SeoDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ResolverInputTypes["SeoUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ResolverInputTypes["SeoUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentCreateResult']?: Omit<ResolverInputTypes["ContentCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ResolverInputTypes["ContentDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ResolverInputTypes["ContentUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ResolverInputTypes["ContentUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ResolverInputTypes["ContentBlockCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ResolverInputTypes["ContentBlockDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ResolverInputTypes["ContentBlockUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ResolverInputTypes["ContentBlockUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ResolverInputTypes["ContentReferenceCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ResolverInputTypes["ContentReferenceDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ResolverInputTypes["ContentReferenceUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ResolverInputTypes["ContentReferenceUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RedirectCreateResult']?: Omit<ResolverInputTypes["RedirectCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RedirectDeleteResult']?: Omit<ResolverInputTypes["RedirectDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RedirectUpdateResult']?: Omit<ResolverInputTypes["RedirectUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RedirectUpsertResult']?: Omit<ResolverInputTypes["RedirectUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ResolverInputTypes["LinkCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ResolverInputTypes["LinkDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ResolverInputTypes["LinkUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ResolverInputTypes["LinkUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ResolverInputTypes["FooterCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ResolverInputTypes["FooterDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ResolverInputTypes["FooterUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ResolverInputTypes["FooterUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLinkCreateResult']?: Omit<ResolverInputTypes["FooterLinkCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLinkDeleteResult']?: Omit<ResolverInputTypes["FooterLinkDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLinkUpdateResult']?: Omit<ResolverInputTypes["FooterLinkUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLinkUpsertResult']?: Omit<ResolverInputTypes["FooterLinkUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLocaleCreateResult']?: Omit<ResolverInputTypes["FooterLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLocaleDeleteResult']?: Omit<ResolverInputTypes["FooterLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLocaleUpdateResult']?: Omit<ResolverInputTypes["FooterLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FooterLocaleUpsertResult']?: Omit<ResolverInputTypes["FooterLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageLocaleCreateResult']?: Omit<ResolverInputTypes["GenericPageLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageLocaleDeleteResult']?: Omit<ResolverInputTypes["GenericPageLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageLocaleUpdateResult']?: Omit<ResolverInputTypes["GenericPageLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GenericPageLocaleUpsertResult']?: Omit<ResolverInputTypes["GenericPageLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderCreateResult']?: Omit<ResolverInputTypes["HeaderCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderDeleteResult']?: Omit<ResolverInputTypes["HeaderDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderUpdateResult']?: Omit<ResolverInputTypes["HeaderUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderUpsertResult']?: Omit<ResolverInputTypes["HeaderUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderLocaleCreateResult']?: Omit<ResolverInputTypes["HeaderLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderLocaleDeleteResult']?: Omit<ResolverInputTypes["HeaderLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderLocaleUpdateResult']?: Omit<ResolverInputTypes["HeaderLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HeaderLocaleUpsertResult']?: Omit<ResolverInputTypes["HeaderLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LocaleCreateResult']?: Omit<ResolverInputTypes["LocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LocaleDeleteResult']?: Omit<ResolverInputTypes["LocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LocaleUpdateResult']?: Omit<ResolverInputTypes["LocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on LocaleUpsertResult']?: Omit<ResolverInputTypes["LocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoDefaultCreateResult']?: Omit<ResolverInputTypes["SeoDefaultCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoDefaultDeleteResult']?: Omit<ResolverInputTypes["SeoDefaultDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoDefaultUpdateResult']?: Omit<ResolverInputTypes["SeoDefaultUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoDefaultUpsertResult']?: Omit<ResolverInputTypes["SeoDefaultUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoDefaultLocaleCreateResult']?: Omit<ResolverInputTypes["SeoDefaultLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoDefaultLocaleDeleteResult']?: Omit<ResolverInputTypes["SeoDefaultLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoDefaultLocaleUpdateResult']?: Omit<ResolverInputTypes["SeoDefaultLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SeoDefaultLocaleUpsertResult']?: Omit<ResolverInputTypes["SeoDefaultLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessCreateResult']?: Omit<ResolverInputTypes["BusinessCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessDeleteResult']?: Omit<ResolverInputTypes["BusinessDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessUpdateResult']?: Omit<ResolverInputTypes["BusinessUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessUpsertResult']?: Omit<ResolverInputTypes["BusinessUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessPageCreateResult']?: Omit<ResolverInputTypes["BusinessPageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessPageDeleteResult']?: Omit<ResolverInputTypes["BusinessPageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessPageUpdateResult']?: Omit<ResolverInputTypes["BusinessPageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessPageUpsertResult']?: Omit<ResolverInputTypes["BusinessPageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessPageLocaleCreateResult']?: Omit<ResolverInputTypes["BusinessPageLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessPageLocaleDeleteResult']?: Omit<ResolverInputTypes["BusinessPageLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessPageLocaleUpdateResult']?: Omit<ResolverInputTypes["BusinessPageLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BusinessPageLocaleUpsertResult']?: Omit<ResolverInputTypes["BusinessPageLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on IconCreateResult']?: Omit<ResolverInputTypes["IconCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on IconDeleteResult']?: Omit<ResolverInputTypes["IconDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on IconUpdateResult']?: Omit<ResolverInputTypes["IconUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on IconUpsertResult']?: Omit<ResolverInputTypes["IconUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPageCreateResult']?: Omit<ResolverInputTypes["JobPageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPageDeleteResult']?: Omit<ResolverInputTypes["JobPageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPageUpdateResult']?: Omit<ResolverInputTypes["JobPageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPageUpsertResult']?: Omit<ResolverInputTypes["JobPageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPageLocaleCreateResult']?: Omit<ResolverInputTypes["JobPageLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPageLocaleDeleteResult']?: Omit<ResolverInputTypes["JobPageLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPageLocaleUpdateResult']?: Omit<ResolverInputTypes["JobPageLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPageLocaleUpsertResult']?: Omit<ResolverInputTypes["JobPageLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on KeyInfoItemCreateResult']?: Omit<ResolverInputTypes["KeyInfoItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on KeyInfoItemDeleteResult']?: Omit<ResolverInputTypes["KeyInfoItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on KeyInfoItemUpdateResult']?: Omit<ResolverInputTypes["KeyInfoItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on KeyInfoItemUpsertResult']?: Omit<ResolverInputTypes["KeyInfoItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on KeyInfoListCreateResult']?: Omit<ResolverInputTypes["KeyInfoListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on KeyInfoListDeleteResult']?: Omit<ResolverInputTypes["KeyInfoListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on KeyInfoListUpdateResult']?: Omit<ResolverInputTypes["KeyInfoListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on KeyInfoListUpsertResult']?: Omit<ResolverInputTypes["KeyInfoListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContractTypeCreateResult']?: Omit<ResolverInputTypes["ContractTypeCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContractTypeDeleteResult']?: Omit<ResolverInputTypes["ContractTypeDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContractTypeUpdateResult']?: Omit<ResolverInputTypes["ContractTypeUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContractTypeUpsertResult']?: Omit<ResolverInputTypes["ContractTypeUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContractTypeLocaleCreateResult']?: Omit<ResolverInputTypes["ContractTypeLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContractTypeLocaleDeleteResult']?: Omit<ResolverInputTypes["ContractTypeLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContractTypeLocaleUpdateResult']?: Omit<ResolverInputTypes["ContractTypeLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ContractTypeLocaleUpsertResult']?: Omit<ResolverInputTypes["ContractTypeLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobCityCreateResult']?: Omit<ResolverInputTypes["JobCityCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobCityDeleteResult']?: Omit<ResolverInputTypes["JobCityDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobCityUpdateResult']?: Omit<ResolverInputTypes["JobCityUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobCityUpsertResult']?: Omit<ResolverInputTypes["JobCityUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobCityLocaleCreateResult']?: Omit<ResolverInputTypes["JobCityLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobCityLocaleDeleteResult']?: Omit<ResolverInputTypes["JobCityLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobCityLocaleUpdateResult']?: Omit<ResolverInputTypes["JobCityLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobCityLocaleUpsertResult']?: Omit<ResolverInputTypes["JobCityLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPositionCreateResult']?: Omit<ResolverInputTypes["JobPositionCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPositionDeleteResult']?: Omit<ResolverInputTypes["JobPositionDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPositionUpdateResult']?: Omit<ResolverInputTypes["JobPositionUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPositionUpsertResult']?: Omit<ResolverInputTypes["JobPositionUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPositionLocaleCreateResult']?: Omit<ResolverInputTypes["JobPositionLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPositionLocaleDeleteResult']?: Omit<ResolverInputTypes["JobPositionLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPositionLocaleUpdateResult']?: Omit<ResolverInputTypes["JobPositionLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobPositionLocaleUpsertResult']?: Omit<ResolverInputTypes["JobPositionLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GalleryCreateResult']?: Omit<ResolverInputTypes["GalleryCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GalleryDeleteResult']?: Omit<ResolverInputTypes["GalleryDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GalleryUpdateResult']?: Omit<ResolverInputTypes["GalleryUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GalleryUpsertResult']?: Omit<ResolverInputTypes["GalleryUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageCreateResult']?: Omit<ResolverInputTypes["HomePageCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageDeleteResult']?: Omit<ResolverInputTypes["HomePageDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageUpdateResult']?: Omit<ResolverInputTypes["HomePageUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageUpsertResult']?: Omit<ResolverInputTypes["HomePageUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLocaleCreateResult']?: Omit<ResolverInputTypes["HomePageLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLocaleDeleteResult']?: Omit<ResolverInputTypes["HomePageLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLocaleUpdateResult']?: Omit<ResolverInputTypes["HomePageLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLocaleUpsertResult']?: Omit<ResolverInputTypes["HomePageLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumCreateResult']?: Omit<ResolverInputTypes["MediumCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumDeleteResult']?: Omit<ResolverInputTypes["MediumDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumUpdateResult']?: Omit<ResolverInputTypes["MediumUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumUpsertResult']?: Omit<ResolverInputTypes["MediumUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumItemCreateResult']?: Omit<ResolverInputTypes["MediumItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumItemDeleteResult']?: Omit<ResolverInputTypes["MediumItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumItemUpdateResult']?: Omit<ResolverInputTypes["MediumItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumItemUpsertResult']?: Omit<ResolverInputTypes["MediumItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumListCreateResult']?: Omit<ResolverInputTypes["MediumListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumListDeleteResult']?: Omit<ResolverInputTypes["MediumListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumListUpdateResult']?: Omit<ResolverInputTypes["MediumListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on MediumListUpsertResult']?: Omit<ResolverInputTypes["MediumListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on VideoCreateResult']?: Omit<ResolverInputTypes["VideoCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on VideoDeleteResult']?: Omit<ResolverInputTypes["VideoDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on VideoUpdateResult']?: Omit<ResolverInputTypes["VideoUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on VideoUpsertResult']?: Omit<ResolverInputTypes["VideoUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextItemCreateResult']?: Omit<ResolverInputTypes["TextItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextItemDeleteResult']?: Omit<ResolverInputTypes["TextItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextItemUpdateResult']?: Omit<ResolverInputTypes["TextItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextItemUpsertResult']?: Omit<ResolverInputTypes["TextItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextListCreateResult']?: Omit<ResolverInputTypes["TextListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextListDeleteResult']?: Omit<ResolverInputTypes["TextListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextListUpdateResult']?: Omit<ResolverInputTypes["TextListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TextListUpsertResult']?: Omit<ResolverInputTypes["TextListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CarouselCreateResult']?: Omit<ResolverInputTypes["CarouselCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CarouselDeleteResult']?: Omit<ResolverInputTypes["CarouselDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CarouselUpdateResult']?: Omit<ResolverInputTypes["CarouselUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CarouselUpsertResult']?: Omit<ResolverInputTypes["CarouselUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CarouselItemCreateResult']?: Omit<ResolverInputTypes["CarouselItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CarouselItemDeleteResult']?: Omit<ResolverInputTypes["CarouselItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CarouselItemUpdateResult']?: Omit<ResolverInputTypes["CarouselItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CarouselItemUpsertResult']?: Omit<ResolverInputTypes["CarouselItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ThemeCreateResult']?: Omit<ResolverInputTypes["ThemeCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ThemeDeleteResult']?: Omit<ResolverInputTypes["ThemeDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ThemeUpdateResult']?: Omit<ResolverInputTypes["ThemeUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ThemeUpsertResult']?: Omit<ResolverInputTypes["ThemeUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BonusBannerCreateResult']?: Omit<ResolverInputTypes["BonusBannerCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BonusBannerDeleteResult']?: Omit<ResolverInputTypes["BonusBannerDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BonusBannerUpdateResult']?: Omit<ResolverInputTypes["BonusBannerUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BonusBannerUpsertResult']?: Omit<ResolverInputTypes["BonusBannerUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BonusBannerLocaleCreateResult']?: Omit<ResolverInputTypes["BonusBannerLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BonusBannerLocaleDeleteResult']?: Omit<ResolverInputTypes["BonusBannerLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BonusBannerLocaleUpdateResult']?: Omit<ResolverInputTypes["BonusBannerLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on BonusBannerLocaleUpsertResult']?: Omit<ResolverInputTypes["BonusBannerLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileCreateResult']?: Omit<ResolverInputTypes["TileCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileDeleteResult']?: Omit<ResolverInputTypes["TileDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileUpdateResult']?: Omit<ResolverInputTypes["TileUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TileUpsertResult']?: Omit<ResolverInputTypes["TileUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SideBySideCreateResult']?: Omit<ResolverInputTypes["SideBySideCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SideBySideDeleteResult']?: Omit<ResolverInputTypes["SideBySideDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SideBySideUpdateResult']?: Omit<ResolverInputTypes["SideBySideUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SideBySideUpsertResult']?: Omit<ResolverInputTypes["SideBySideUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SideBySideItemCreateResult']?: Omit<ResolverInputTypes["SideBySideItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SideBySideItemDeleteResult']?: Omit<ResolverInputTypes["SideBySideItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SideBySideItemUpdateResult']?: Omit<ResolverInputTypes["SideBySideItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SideBySideItemUpsertResult']?: Omit<ResolverInputTypes["SideBySideItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLokalCreateResult']?: Omit<ResolverInputTypes["HomePageLokalCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLokalDeleteResult']?: Omit<ResolverInputTypes["HomePageLokalDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLokalUpdateResult']?: Omit<ResolverInputTypes["HomePageLokalUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLokalUpsertResult']?: Omit<ResolverInputTypes["HomePageLokalUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLokalLocaleCreateResult']?: Omit<ResolverInputTypes["HomePageLokalLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLokalLocaleDeleteResult']?: Omit<ResolverInputTypes["HomePageLokalLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLokalLocaleUpdateResult']?: Omit<ResolverInputTypes["HomePageLokalLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on HomePageLokalLocaleUpsertResult']?: Omit<ResolverInputTypes["HomePageLokalLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SiteSwitcherCreateResult']?: Omit<ResolverInputTypes["SiteSwitcherCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SiteSwitcherDeleteResult']?: Omit<ResolverInputTypes["SiteSwitcherDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SiteSwitcherUpdateResult']?: Omit<ResolverInputTypes["SiteSwitcherUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on SiteSwitcherUpsertResult']?: Omit<ResolverInputTypes["SiteSwitcherUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GalleryItemCreateResult']?: Omit<ResolverInputTypes["GalleryItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GalleryItemDeleteResult']?: Omit<ResolverInputTypes["GalleryItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GalleryItemUpdateResult']?: Omit<ResolverInputTypes["GalleryItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GalleryItemUpsertResult']?: Omit<ResolverInputTypes["GalleryItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFormCreateResult']?: Omit<ResolverInputTypes["JobsFormCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFormDeleteResult']?: Omit<ResolverInputTypes["JobsFormDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFormUpdateResult']?: Omit<ResolverInputTypes["JobsFormUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFormUpsertResult']?: Omit<ResolverInputTypes["JobsFormUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFormLocaleCreateResult']?: Omit<ResolverInputTypes["JobsFormLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFormLocaleDeleteResult']?: Omit<ResolverInputTypes["JobsFormLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFormLocaleUpdateResult']?: Omit<ResolverInputTypes["JobsFormLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFormLocaleUpsertResult']?: Omit<ResolverInputTypes["JobsFormLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageTextItemCreateResult']?: Omit<ResolverInputTypes["ImageTextItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageTextItemDeleteResult']?: Omit<ResolverInputTypes["ImageTextItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageTextItemUpdateResult']?: Omit<ResolverInputTypes["ImageTextItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageTextItemUpsertResult']?: Omit<ResolverInputTypes["ImageTextItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageTextListCreateResult']?: Omit<ResolverInputTypes["ImageTextListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageTextListDeleteResult']?: Omit<ResolverInputTypes["ImageTextListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageTextListUpdateResult']?: Omit<ResolverInputTypes["ImageTextListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageTextListUpsertResult']?: Omit<ResolverInputTypes["ImageTextListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFilterCreateResult']?: Omit<ResolverInputTypes["JobsFilterCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFilterDeleteResult']?: Omit<ResolverInputTypes["JobsFilterDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFilterUpdateResult']?: Omit<ResolverInputTypes["JobsFilterUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFilterUpsertResult']?: Omit<ResolverInputTypes["JobsFilterUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFilterLocaleCreateResult']?: Omit<ResolverInputTypes["JobsFilterLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFilterLocaleDeleteResult']?: Omit<ResolverInputTypes["JobsFilterLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFilterLocaleUpdateResult']?: Omit<ResolverInputTypes["JobsFilterLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobsFilterLocaleUpsertResult']?: Omit<ResolverInputTypes["JobsFilterLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FileCreateResult']?: Omit<ResolverInputTypes["FileCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FileDeleteResult']?: Omit<ResolverInputTypes["FileDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FileUpdateResult']?: Omit<ResolverInputTypes["FileUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on FileUpsertResult']?: Omit<ResolverInputTypes["FileUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobFormSubscriptionCreateResult']?: Omit<ResolverInputTypes["JobFormSubscriptionCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobFormSubscriptionDeleteResult']?: Omit<ResolverInputTypes["JobFormSubscriptionDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobFormSubscriptionUpdateResult']?: Omit<ResolverInputTypes["JobFormSubscriptionUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobFormSubscriptionUpsertResult']?: Omit<ResolverInputTypes["JobFormSubscriptionUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageListCreateResult']?: Omit<ResolverInputTypes["ImageListCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageListDeleteResult']?: Omit<ResolverInputTypes["ImageListDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageListUpdateResult']?: Omit<ResolverInputTypes["ImageListUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageListUpsertResult']?: Omit<ResolverInputTypes["ImageListUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageListItemCreateResult']?: Omit<ResolverInputTypes["ImageListItemCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageListItemDeleteResult']?: Omit<ResolverInputTypes["ImageListItemDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageListItemUpdateResult']?: Omit<ResolverInputTypes["ImageListItemUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on ImageListItemUpsertResult']?: Omit<ResolverInputTypes["ImageListItemUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobFormSubscriptionStatusCreateResult']?: Omit<ResolverInputTypes["JobFormSubscriptionStatusCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobFormSubscriptionStatusDeleteResult']?: Omit<ResolverInputTypes["JobFormSubscriptionStatusDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobFormSubscriptionStatusUpdateResult']?: Omit<ResolverInputTypes["JobFormSubscriptionStatusUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on JobFormSubscriptionStatusUpsertResult']?: Omit<ResolverInputTypes["JobFormSubscriptionStatusUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralLocaleCreateResult']?: Omit<ResolverInputTypes["GeneralLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralLocaleDeleteResult']?: Omit<ResolverInputTypes["GeneralLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralLocaleUpdateResult']?: Omit<ResolverInputTypes["GeneralLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on GeneralLocaleUpsertResult']?: Omit<ResolverInputTypes["GeneralLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StickyBarCreateResult']?: Omit<ResolverInputTypes["StickyBarCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StickyBarDeleteResult']?: Omit<ResolverInputTypes["StickyBarDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StickyBarUpdateResult']?: Omit<ResolverInputTypes["StickyBarUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on StickyBarUpsertResult']?: Omit<ResolverInputTypes["StickyBarUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormCreateResult']?: Omit<ResolverInputTypes["RecommendationFormCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormDeleteResult']?: Omit<ResolverInputTypes["RecommendationFormDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormUpdateResult']?: Omit<ResolverInputTypes["RecommendationFormUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormUpsertResult']?: Omit<ResolverInputTypes["RecommendationFormUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormLocaleCreateResult']?: Omit<ResolverInputTypes["RecommendationFormLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormLocaleDeleteResult']?: Omit<ResolverInputTypes["RecommendationFormLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormLocaleUpdateResult']?: Omit<ResolverInputTypes["RecommendationFormLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormLocaleUpsertResult']?: Omit<ResolverInputTypes["RecommendationFormLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormSubscriptionCreateResult']?: Omit<ResolverInputTypes["RecommendationFormSubscriptionCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormSubscriptionDeleteResult']?: Omit<ResolverInputTypes["RecommendationFormSubscriptionDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormSubscriptionUpdateResult']?: Omit<ResolverInputTypes["RecommendationFormSubscriptionUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on RecommendationFormSubscriptionUpsertResult']?: Omit<ResolverInputTypes["RecommendationFormSubscriptionUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoBoxCreateResult']?: Omit<ResolverInputTypes["InfoBoxCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoBoxDeleteResult']?: Omit<ResolverInputTypes["InfoBoxDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoBoxUpdateResult']?: Omit<ResolverInputTypes["InfoBoxUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoBoxUpsertResult']?: Omit<ResolverInputTypes["InfoBoxUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoBoxLocaleCreateResult']?: Omit<ResolverInputTypes["InfoBoxLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoBoxLocaleDeleteResult']?: Omit<ResolverInputTypes["InfoBoxLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoBoxLocaleUpdateResult']?: Omit<ResolverInputTypes["InfoBoxLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on InfoBoxLocaleUpsertResult']?: Omit<ResolverInputTypes["InfoBoxLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationCreateResult']?: Omit<ResolverInputTypes["TranslationCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationDeleteResult']?: Omit<ResolverInputTypes["TranslationDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationUpdateResult']?: Omit<ResolverInputTypes["TranslationUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationUpsertResult']?: Omit<ResolverInputTypes["TranslationUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationLocaleCreateResult']?: Omit<ResolverInputTypes["TranslationLocaleCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationLocaleDeleteResult']?: Omit<ResolverInputTypes["TranslationLocaleDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationLocaleUpdateResult']?: Omit<ResolverInputTypes["TranslationLocaleUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on TranslationLocaleUpsertResult']?: Omit<ResolverInputTypes["TranslationLocaleUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CornerBannerCreateResult']?: Omit<ResolverInputTypes["CornerBannerCreateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CornerBannerDeleteResult']?: Omit<ResolverInputTypes["CornerBannerDeleteResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CornerBannerUpdateResult']?: Omit<ResolverInputTypes["CornerBannerUpdateResult"],keyof ResolverInputTypes["MutationResult"]>;
		['...on CornerBannerUpsertResult']?: Omit<ResolverInputTypes["CornerBannerUpsertResult"],keyof ResolverInputTypes["MutationResult"]>;
		__typename?: boolean | `@${string}`
}>;
	["_MutationError"]: AliasType<{
	path?:ResolverInputTypes["_PathFragment"],
	paths?:ResolverInputTypes["_PathFragment"],
	type?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["GeneralDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["General"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["General"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["General"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Image"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Image"],
		__typename?: boolean | `@${string}`
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Image"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Image"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPage"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Linkable"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Linkable"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Linkable"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Linkable"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Seo"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Seo"],
		__typename?: boolean | `@${string}`
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Seo"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Seo"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Content"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Content"],
		__typename?: boolean | `@${string}`
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Content"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Content"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentBlock"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentBlock"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentBlock"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentBlock"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentReference"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentReference"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentReference"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContentReference"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Redirect"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Redirect"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Redirect"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Redirect"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Link"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Link"],
		__typename?: boolean | `@${string}`
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Link"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Link"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Footer"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Footer"],
		__typename?: boolean | `@${string}`
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Footer"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Footer"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLink"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLink"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLink"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLinkUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLink"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FooterLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["FooterLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GenericPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GenericPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Header"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Header"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Header"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Header"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeaderLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeaderLocale"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeaderLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeaderLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HeaderLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Locale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Locale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Locale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Locale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SeoDefault"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SeoDefault"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SeoDefault"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SeoDefault"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SeoDefaultLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SeoDefaultLocale"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SeoDefaultLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDefaultLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SeoDefaultLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Business"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Business"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Business"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Business"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BusinessPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BusinessPage"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BusinessPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BusinessPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BusinessPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BusinessPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BusinessPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BusinessPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IconCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Icon"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IconDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Icon"],
		__typename?: boolean | `@${string}`
}>;
	["IconUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Icon"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IconUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Icon"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPage"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["KeyInfoItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["KeyInfoItem"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["KeyInfoItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["KeyInfoItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["KeyInfoList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["KeyInfoList"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["KeyInfoList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["KeyInfoListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["KeyInfoList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContractType"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContractType"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContractType"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContractType"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContractTypeLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContractTypeLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContractTypeLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContractTypeLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ContractTypeLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobCity"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobCity"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobCity"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobCity"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobCityLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobCityLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobCityLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobCityLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobCityLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPosition"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPosition"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPosition"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPosition"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPositionLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPositionLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPositionLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobPositionLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobPositionLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Gallery"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Gallery"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Gallery"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Gallery"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePage"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePage"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Medium"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Medium"],
		__typename?: boolean | `@${string}`
}>;
	["MediumUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Medium"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Medium"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumItem"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumList"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["MediumList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Video"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Video"],
		__typename?: boolean | `@${string}`
}>;
	["VideoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Video"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Video"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextItem"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextList"],
		__typename?: boolean | `@${string}`
}>;
	["TextListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TextList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Carousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Carousel"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Carousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Carousel"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CarouselItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CarouselItem"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CarouselItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CarouselItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CarouselItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Theme"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Theme"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Theme"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Theme"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BonusBanner"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BonusBanner"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BonusBanner"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BonusBanner"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BonusBannerLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BonusBannerLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BonusBannerLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BonusBannerLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["BonusBannerLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Tile"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Tile"],
		__typename?: boolean | `@${string}`
}>;
	["TileUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Tile"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TileUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Tile"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SideBySide"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SideBySide"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SideBySide"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SideBySide"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SideBySideItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SideBySideItem"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SideBySideItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SideBySideItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SideBySideItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLokal"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLokal"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLokal"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLokal"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLokalLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLokalLocale"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLokalLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HomePageLokalLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["HomePageLokalLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SiteSwitcher"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SiteSwitcher"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SiteSwitcher"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SiteSwitcherUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["SiteSwitcher"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GalleryItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GalleryItem"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GalleryItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GalleryItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsForm"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsForm"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsForm"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsForm"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFormLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFormLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFormLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFormLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFormLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageTextItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageTextItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageTextItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageTextItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageTextList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageTextList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageTextList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageTextListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageTextList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFilter"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFilter"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFilter"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFilter"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFilterLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFilterLocale"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFilterLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobsFilterLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobsFilterLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FileCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["File"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FileDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["File"],
		__typename?: boolean | `@${string}`
}>;
	["FileUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["File"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FileUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["File"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobFormSubscription"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobFormSubscription"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobFormSubscription"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobFormSubscription"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageList"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["ImageListItem"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobFormSubscriptionStatus"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobFormSubscriptionStatus"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobFormSubscriptionStatus"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["JobFormSubscriptionStatusUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["JobFormSubscriptionStatus"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GeneralLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GeneralLocale"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GeneralLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GeneralLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["GeneralLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StickyBar"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StickyBar"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StickyBar"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StickyBarUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["StickyBar"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationForm"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationForm"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationForm"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationForm"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationFormLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationFormLocale"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationFormLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationFormLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationFormSubscription"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationFormSubscription"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationFormSubscription"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RecommendationFormSubscriptionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["RecommendationFormSubscription"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoBox"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoBox"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoBox"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoBox"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoBoxLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoBoxLocale"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoBoxLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InfoBoxLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["InfoBoxLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Translation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Translation"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Translation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["Translation"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationLocale"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["TranslationLocale"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CornerBanner"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CornerBanner"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CornerBanner"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CornerBannerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	node?:ResolverInputTypes["CornerBanner"],
	validation?:ResolverInputTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTransaction"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ResolverInputTypes["_MutationError"],
	validation?:ResolverInputTypes["_ValidationResult"],
generateUploadUrl?: [{	input?: ResolverInputTypes["S3GenerateSignedUploadInput"] | undefined | null},ResolverInputTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey: string,	expiration?: number | undefined | null},ResolverInputTypes["S3SignedRead"]],
createGeneral?: [{	data: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["GeneralCreateResult"]],
deleteGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null},ResolverInputTypes["GeneralDeleteResult"]],
updateGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	data: ResolverInputTypes["GeneralUpdateInput"]},ResolverInputTypes["GeneralUpdateResult"]],
upsertGeneral?: [{	by: ResolverInputTypes["GeneralUniqueWhere"],	filter?: ResolverInputTypes["GeneralWhere"] | undefined | null,	update: ResolverInputTypes["GeneralUpdateInput"],	create: ResolverInputTypes["GeneralCreateInput"]},ResolverInputTypes["GeneralUpsertResult"]],
createImage?: [{	data: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["ImageCreateResult"]],
deleteImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null},ResolverInputTypes["ImageDeleteResult"]],
updateImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	data: ResolverInputTypes["ImageUpdateInput"]},ResolverInputTypes["ImageUpdateResult"]],
upsertImage?: [{	by: ResolverInputTypes["ImageUniqueWhere"],	filter?: ResolverInputTypes["ImageWhere"] | undefined | null,	update: ResolverInputTypes["ImageUpdateInput"],	create: ResolverInputTypes["ImageCreateInput"]},ResolverInputTypes["ImageUpsertResult"]],
createGenericPage?: [{	data: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null},ResolverInputTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageUpdateInput"]},ResolverInputTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by: ResolverInputTypes["GenericPageUniqueWhere"],	filter?: ResolverInputTypes["GenericPageWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageUpdateInput"],	create: ResolverInputTypes["GenericPageCreateInput"]},ResolverInputTypes["GenericPageUpsertResult"]],
createLinkable?: [{	data: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null},ResolverInputTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	data: ResolverInputTypes["LinkableUpdateInput"]},ResolverInputTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by: ResolverInputTypes["LinkableUniqueWhere"],	filter?: ResolverInputTypes["LinkableWhere"] | undefined | null,	update: ResolverInputTypes["LinkableUpdateInput"],	create: ResolverInputTypes["LinkableCreateInput"]},ResolverInputTypes["LinkableUpsertResult"]],
createSeo?: [{	data: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["SeoCreateResult"]],
deleteSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null},ResolverInputTypes["SeoDeleteResult"]],
updateSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	data: ResolverInputTypes["SeoUpdateInput"]},ResolverInputTypes["SeoUpdateResult"]],
upsertSeo?: [{	by: ResolverInputTypes["SeoUniqueWhere"],	filter?: ResolverInputTypes["SeoWhere"] | undefined | null,	update: ResolverInputTypes["SeoUpdateInput"],	create: ResolverInputTypes["SeoCreateInput"]},ResolverInputTypes["SeoUpsertResult"]],
createContent?: [{	data: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["ContentCreateResult"]],
deleteContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null},ResolverInputTypes["ContentDeleteResult"]],
updateContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	data: ResolverInputTypes["ContentUpdateInput"]},ResolverInputTypes["ContentUpdateResult"]],
upsertContent?: [{	by: ResolverInputTypes["ContentUniqueWhere"],	filter?: ResolverInputTypes["ContentWhere"] | undefined | null,	update: ResolverInputTypes["ContentUpdateInput"],	create: ResolverInputTypes["ContentCreateInput"]},ResolverInputTypes["ContentUpsertResult"]],
createContentBlock?: [{	data: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null},ResolverInputTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	data: ResolverInputTypes["ContentBlockUpdateInput"]},ResolverInputTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by: ResolverInputTypes["ContentBlockUniqueWhere"],	filter?: ResolverInputTypes["ContentBlockWhere"] | undefined | null,	update: ResolverInputTypes["ContentBlockUpdateInput"],	create: ResolverInputTypes["ContentBlockCreateInput"]},ResolverInputTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null},ResolverInputTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	data: ResolverInputTypes["ContentReferenceUpdateInput"]},ResolverInputTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by: ResolverInputTypes["ContentReferenceUniqueWhere"],	filter?: ResolverInputTypes["ContentReferenceWhere"] | undefined | null,	update: ResolverInputTypes["ContentReferenceUpdateInput"],	create: ResolverInputTypes["ContentReferenceCreateInput"]},ResolverInputTypes["ContentReferenceUpsertResult"]],
createRedirect?: [{	data: ResolverInputTypes["RedirectCreateInput"]},ResolverInputTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by: ResolverInputTypes["RedirectUniqueWhere"],	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null},ResolverInputTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by: ResolverInputTypes["RedirectUniqueWhere"],	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null,	data: ResolverInputTypes["RedirectUpdateInput"]},ResolverInputTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by: ResolverInputTypes["RedirectUniqueWhere"],	filter?: ResolverInputTypes["RedirectWhere"] | undefined | null,	update: ResolverInputTypes["RedirectUpdateInput"],	create: ResolverInputTypes["RedirectCreateInput"]},ResolverInputTypes["RedirectUpsertResult"]],
createLink?: [{	data: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["LinkCreateResult"]],
deleteLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null},ResolverInputTypes["LinkDeleteResult"]],
updateLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	data: ResolverInputTypes["LinkUpdateInput"]},ResolverInputTypes["LinkUpdateResult"]],
upsertLink?: [{	by: ResolverInputTypes["LinkUniqueWhere"],	filter?: ResolverInputTypes["LinkWhere"] | undefined | null,	update: ResolverInputTypes["LinkUpdateInput"],	create: ResolverInputTypes["LinkCreateInput"]},ResolverInputTypes["LinkUpsertResult"]],
createFooter?: [{	data: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["FooterCreateResult"]],
deleteFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null},ResolverInputTypes["FooterDeleteResult"]],
updateFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	data: ResolverInputTypes["FooterUpdateInput"]},ResolverInputTypes["FooterUpdateResult"]],
upsertFooter?: [{	by: ResolverInputTypes["FooterUniqueWhere"],	filter?: ResolverInputTypes["FooterWhere"] | undefined | null,	update: ResolverInputTypes["FooterUpdateInput"],	create: ResolverInputTypes["FooterCreateInput"]},ResolverInputTypes["FooterUpsertResult"]],
createFooterLink?: [{	data: ResolverInputTypes["FooterLinkCreateInput"]},ResolverInputTypes["FooterLinkCreateResult"]],
deleteFooterLink?: [{	by: ResolverInputTypes["FooterLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null},ResolverInputTypes["FooterLinkDeleteResult"]],
updateFooterLink?: [{	by: ResolverInputTypes["FooterLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	data: ResolverInputTypes["FooterLinkUpdateInput"]},ResolverInputTypes["FooterLinkUpdateResult"]],
upsertFooterLink?: [{	by: ResolverInputTypes["FooterLinkUniqueWhere"],	filter?: ResolverInputTypes["FooterLinkWhere"] | undefined | null,	update: ResolverInputTypes["FooterLinkUpdateInput"],	create: ResolverInputTypes["FooterLinkCreateInput"]},ResolverInputTypes["FooterLinkUpsertResult"]],
createFooterLocale?: [{	data: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null},ResolverInputTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	data: ResolverInputTypes["FooterLocaleUpdateInput"]},ResolverInputTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by: ResolverInputTypes["FooterLocaleUniqueWhere"],	filter?: ResolverInputTypes["FooterLocaleWhere"] | undefined | null,	update: ResolverInputTypes["FooterLocaleUpdateInput"],	create: ResolverInputTypes["FooterLocaleCreateInput"]},ResolverInputTypes["FooterLocaleUpsertResult"]],
createGenericPageLocale?: [{	data: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["GenericPageLocaleCreateResult"]],
deleteGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null},ResolverInputTypes["GenericPageLocaleDeleteResult"]],
updateGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GenericPageLocaleUpdateInput"]},ResolverInputTypes["GenericPageLocaleUpdateResult"]],
upsertGenericPageLocale?: [{	by: ResolverInputTypes["GenericPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["GenericPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GenericPageLocaleUpdateInput"],	create: ResolverInputTypes["GenericPageLocaleCreateInput"]},ResolverInputTypes["GenericPageLocaleUpsertResult"]],
createHeader?: [{	data: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["HeaderCreateResult"]],
deleteHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null},ResolverInputTypes["HeaderDeleteResult"]],
updateHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	data: ResolverInputTypes["HeaderUpdateInput"]},ResolverInputTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by: ResolverInputTypes["HeaderUniqueWhere"],	filter?: ResolverInputTypes["HeaderWhere"] | undefined | null,	update: ResolverInputTypes["HeaderUpdateInput"],	create: ResolverInputTypes["HeaderCreateInput"]},ResolverInputTypes["HeaderUpsertResult"]],
createHeaderLocale?: [{	data: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null},ResolverInputTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	data: ResolverInputTypes["HeaderLocaleUpdateInput"]},ResolverInputTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by: ResolverInputTypes["HeaderLocaleUniqueWhere"],	filter?: ResolverInputTypes["HeaderLocaleWhere"] | undefined | null,	update: ResolverInputTypes["HeaderLocaleUpdateInput"],	create: ResolverInputTypes["HeaderLocaleCreateInput"]},ResolverInputTypes["HeaderLocaleUpsertResult"]],
createLocale?: [{	data: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["LocaleCreateResult"]],
deleteLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null},ResolverInputTypes["LocaleDeleteResult"]],
updateLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	data: ResolverInputTypes["LocaleUpdateInput"]},ResolverInputTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by: ResolverInputTypes["LocaleUniqueWhere"],	filter?: ResolverInputTypes["LocaleWhere"] | undefined | null,	update: ResolverInputTypes["LocaleUpdateInput"],	create: ResolverInputTypes["LocaleCreateInput"]},ResolverInputTypes["LocaleUpsertResult"]],
createSeoDefault?: [{	data: ResolverInputTypes["SeoDefaultCreateInput"]},ResolverInputTypes["SeoDefaultCreateResult"]],
deleteSeoDefault?: [{	by: ResolverInputTypes["SeoDefaultUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null},ResolverInputTypes["SeoDefaultDeleteResult"]],
updateSeoDefault?: [{	by: ResolverInputTypes["SeoDefaultUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null,	data: ResolverInputTypes["SeoDefaultUpdateInput"]},ResolverInputTypes["SeoDefaultUpdateResult"]],
upsertSeoDefault?: [{	by: ResolverInputTypes["SeoDefaultUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultWhere"] | undefined | null,	update: ResolverInputTypes["SeoDefaultUpdateInput"],	create: ResolverInputTypes["SeoDefaultCreateInput"]},ResolverInputTypes["SeoDefaultUpsertResult"]],
createSeoDefaultLocale?: [{	data: ResolverInputTypes["SeoDefaultLocaleCreateInput"]},ResolverInputTypes["SeoDefaultLocaleCreateResult"]],
deleteSeoDefaultLocale?: [{	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null},ResolverInputTypes["SeoDefaultLocaleDeleteResult"]],
updateSeoDefaultLocale?: [{	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	data: ResolverInputTypes["SeoDefaultLocaleUpdateInput"]},ResolverInputTypes["SeoDefaultLocaleUpdateResult"]],
upsertSeoDefaultLocale?: [{	by: ResolverInputTypes["SeoDefaultLocaleUniqueWhere"],	filter?: ResolverInputTypes["SeoDefaultLocaleWhere"] | undefined | null,	update: ResolverInputTypes["SeoDefaultLocaleUpdateInput"],	create: ResolverInputTypes["SeoDefaultLocaleCreateInput"]},ResolverInputTypes["SeoDefaultLocaleUpsertResult"]],
createBusiness?: [{	data: ResolverInputTypes["BusinessCreateInput"]},ResolverInputTypes["BusinessCreateResult"]],
deleteBusiness?: [{	by: ResolverInputTypes["BusinessUniqueWhere"],	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null},ResolverInputTypes["BusinessDeleteResult"]],
updateBusiness?: [{	by: ResolverInputTypes["BusinessUniqueWhere"],	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	data: ResolverInputTypes["BusinessUpdateInput"]},ResolverInputTypes["BusinessUpdateResult"]],
upsertBusiness?: [{	by: ResolverInputTypes["BusinessUniqueWhere"],	filter?: ResolverInputTypes["BusinessWhere"] | undefined | null,	update: ResolverInputTypes["BusinessUpdateInput"],	create: ResolverInputTypes["BusinessCreateInput"]},ResolverInputTypes["BusinessUpsertResult"]],
createBusinessPage?: [{	data: ResolverInputTypes["BusinessPageCreateInput"]},ResolverInputTypes["BusinessPageCreateResult"]],
deleteBusinessPage?: [{	by: ResolverInputTypes["BusinessPageUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null},ResolverInputTypes["BusinessPageDeleteResult"]],
updateBusinessPage?: [{	by: ResolverInputTypes["BusinessPageUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null,	data: ResolverInputTypes["BusinessPageUpdateInput"]},ResolverInputTypes["BusinessPageUpdateResult"]],
upsertBusinessPage?: [{	by: ResolverInputTypes["BusinessPageUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageWhere"] | undefined | null,	update: ResolverInputTypes["BusinessPageUpdateInput"],	create: ResolverInputTypes["BusinessPageCreateInput"]},ResolverInputTypes["BusinessPageUpsertResult"]],
createBusinessPageLocale?: [{	data: ResolverInputTypes["BusinessPageLocaleCreateInput"]},ResolverInputTypes["BusinessPageLocaleCreateResult"]],
deleteBusinessPageLocale?: [{	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null},ResolverInputTypes["BusinessPageLocaleDeleteResult"]],
updateBusinessPageLocale?: [{	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["BusinessPageLocaleUpdateInput"]},ResolverInputTypes["BusinessPageLocaleUpdateResult"]],
upsertBusinessPageLocale?: [{	by: ResolverInputTypes["BusinessPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["BusinessPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["BusinessPageLocaleUpdateInput"],	create: ResolverInputTypes["BusinessPageLocaleCreateInput"]},ResolverInputTypes["BusinessPageLocaleUpsertResult"]],
createIcon?: [{	data: ResolverInputTypes["IconCreateInput"]},ResolverInputTypes["IconCreateResult"]],
deleteIcon?: [{	by: ResolverInputTypes["IconUniqueWhere"],	filter?: ResolverInputTypes["IconWhere"] | undefined | null},ResolverInputTypes["IconDeleteResult"]],
updateIcon?: [{	by: ResolverInputTypes["IconUniqueWhere"],	filter?: ResolverInputTypes["IconWhere"] | undefined | null,	data: ResolverInputTypes["IconUpdateInput"]},ResolverInputTypes["IconUpdateResult"]],
upsertIcon?: [{	by: ResolverInputTypes["IconUniqueWhere"],	filter?: ResolverInputTypes["IconWhere"] | undefined | null,	update: ResolverInputTypes["IconUpdateInput"],	create: ResolverInputTypes["IconCreateInput"]},ResolverInputTypes["IconUpsertResult"]],
createJobPage?: [{	data: ResolverInputTypes["JobPageCreateInput"]},ResolverInputTypes["JobPageCreateResult"]],
deleteJobPage?: [{	by: ResolverInputTypes["JobPageUniqueWhere"],	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null},ResolverInputTypes["JobPageDeleteResult"]],
updateJobPage?: [{	by: ResolverInputTypes["JobPageUniqueWhere"],	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null,	data: ResolverInputTypes["JobPageUpdateInput"]},ResolverInputTypes["JobPageUpdateResult"]],
upsertJobPage?: [{	by: ResolverInputTypes["JobPageUniqueWhere"],	filter?: ResolverInputTypes["JobPageWhere"] | undefined | null,	update: ResolverInputTypes["JobPageUpdateInput"],	create: ResolverInputTypes["JobPageCreateInput"]},ResolverInputTypes["JobPageUpsertResult"]],
createJobPageLocale?: [{	data: ResolverInputTypes["JobPageLocaleCreateInput"]},ResolverInputTypes["JobPageLocaleCreateResult"]],
deleteJobPageLocale?: [{	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null},ResolverInputTypes["JobPageLocaleDeleteResult"]],
updateJobPageLocale?: [{	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["JobPageLocaleUpdateInput"]},ResolverInputTypes["JobPageLocaleUpdateResult"]],
upsertJobPageLocale?: [{	by: ResolverInputTypes["JobPageLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["JobPageLocaleUpdateInput"],	create: ResolverInputTypes["JobPageLocaleCreateInput"]},ResolverInputTypes["JobPageLocaleUpsertResult"]],
createKeyInfoItem?: [{	data: ResolverInputTypes["KeyInfoItemCreateInput"]},ResolverInputTypes["KeyInfoItemCreateResult"]],
deleteKeyInfoItem?: [{	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null},ResolverInputTypes["KeyInfoItemDeleteResult"]],
updateKeyInfoItem?: [{	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,	data: ResolverInputTypes["KeyInfoItemUpdateInput"]},ResolverInputTypes["KeyInfoItemUpdateResult"]],
upsertKeyInfoItem?: [{	by: ResolverInputTypes["KeyInfoItemUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoItemWhere"] | undefined | null,	update: ResolverInputTypes["KeyInfoItemUpdateInput"],	create: ResolverInputTypes["KeyInfoItemCreateInput"]},ResolverInputTypes["KeyInfoItemUpsertResult"]],
createKeyInfoList?: [{	data: ResolverInputTypes["KeyInfoListCreateInput"]},ResolverInputTypes["KeyInfoListCreateResult"]],
deleteKeyInfoList?: [{	by: ResolverInputTypes["KeyInfoListUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null},ResolverInputTypes["KeyInfoListDeleteResult"]],
updateKeyInfoList?: [{	by: ResolverInputTypes["KeyInfoListUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null,	data: ResolverInputTypes["KeyInfoListUpdateInput"]},ResolverInputTypes["KeyInfoListUpdateResult"]],
upsertKeyInfoList?: [{	by: ResolverInputTypes["KeyInfoListUniqueWhere"],	filter?: ResolverInputTypes["KeyInfoListWhere"] | undefined | null,	update: ResolverInputTypes["KeyInfoListUpdateInput"],	create: ResolverInputTypes["KeyInfoListCreateInput"]},ResolverInputTypes["KeyInfoListUpsertResult"]],
createContractType?: [{	data: ResolverInputTypes["ContractTypeCreateInput"]},ResolverInputTypes["ContractTypeCreateResult"]],
deleteContractType?: [{	by: ResolverInputTypes["ContractTypeUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null},ResolverInputTypes["ContractTypeDeleteResult"]],
updateContractType?: [{	by: ResolverInputTypes["ContractTypeUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null,	data: ResolverInputTypes["ContractTypeUpdateInput"]},ResolverInputTypes["ContractTypeUpdateResult"]],
upsertContractType?: [{	by: ResolverInputTypes["ContractTypeUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeWhere"] | undefined | null,	update: ResolverInputTypes["ContractTypeUpdateInput"],	create: ResolverInputTypes["ContractTypeCreateInput"]},ResolverInputTypes["ContractTypeUpsertResult"]],
createContractTypeLocale?: [{	data: ResolverInputTypes["ContractTypeLocaleCreateInput"]},ResolverInputTypes["ContractTypeLocaleCreateResult"]],
deleteContractTypeLocale?: [{	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null},ResolverInputTypes["ContractTypeLocaleDeleteResult"]],
updateContractTypeLocale?: [{	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	data: ResolverInputTypes["ContractTypeLocaleUpdateInput"]},ResolverInputTypes["ContractTypeLocaleUpdateResult"]],
upsertContractTypeLocale?: [{	by: ResolverInputTypes["ContractTypeLocaleUniqueWhere"],	filter?: ResolverInputTypes["ContractTypeLocaleWhere"] | undefined | null,	update: ResolverInputTypes["ContractTypeLocaleUpdateInput"],	create: ResolverInputTypes["ContractTypeLocaleCreateInput"]},ResolverInputTypes["ContractTypeLocaleUpsertResult"]],
createJobCity?: [{	data: ResolverInputTypes["JobCityCreateInput"]},ResolverInputTypes["JobCityCreateResult"]],
deleteJobCity?: [{	by: ResolverInputTypes["JobCityUniqueWhere"],	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null},ResolverInputTypes["JobCityDeleteResult"]],
updateJobCity?: [{	by: ResolverInputTypes["JobCityUniqueWhere"],	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null,	data: ResolverInputTypes["JobCityUpdateInput"]},ResolverInputTypes["JobCityUpdateResult"]],
upsertJobCity?: [{	by: ResolverInputTypes["JobCityUniqueWhere"],	filter?: ResolverInputTypes["JobCityWhere"] | undefined | null,	update: ResolverInputTypes["JobCityUpdateInput"],	create: ResolverInputTypes["JobCityCreateInput"]},ResolverInputTypes["JobCityUpsertResult"]],
createJobCityLocale?: [{	data: ResolverInputTypes["JobCityLocaleCreateInput"]},ResolverInputTypes["JobCityLocaleCreateResult"]],
deleteJobCityLocale?: [{	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null},ResolverInputTypes["JobCityLocaleDeleteResult"]],
updateJobCityLocale?: [{	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	data: ResolverInputTypes["JobCityLocaleUpdateInput"]},ResolverInputTypes["JobCityLocaleUpdateResult"]],
upsertJobCityLocale?: [{	by: ResolverInputTypes["JobCityLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobCityLocaleWhere"] | undefined | null,	update: ResolverInputTypes["JobCityLocaleUpdateInput"],	create: ResolverInputTypes["JobCityLocaleCreateInput"]},ResolverInputTypes["JobCityLocaleUpsertResult"]],
createJobPosition?: [{	data: ResolverInputTypes["JobPositionCreateInput"]},ResolverInputTypes["JobPositionCreateResult"]],
deleteJobPosition?: [{	by: ResolverInputTypes["JobPositionUniqueWhere"],	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null},ResolverInputTypes["JobPositionDeleteResult"]],
updateJobPosition?: [{	by: ResolverInputTypes["JobPositionUniqueWhere"],	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null,	data: ResolverInputTypes["JobPositionUpdateInput"]},ResolverInputTypes["JobPositionUpdateResult"]],
upsertJobPosition?: [{	by: ResolverInputTypes["JobPositionUniqueWhere"],	filter?: ResolverInputTypes["JobPositionWhere"] | undefined | null,	update: ResolverInputTypes["JobPositionUpdateInput"],	create: ResolverInputTypes["JobPositionCreateInput"]},ResolverInputTypes["JobPositionUpsertResult"]],
createJobPositionLocale?: [{	data: ResolverInputTypes["JobPositionLocaleCreateInput"]},ResolverInputTypes["JobPositionLocaleCreateResult"]],
deleteJobPositionLocale?: [{	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null},ResolverInputTypes["JobPositionLocaleDeleteResult"]],
updateJobPositionLocale?: [{	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	data: ResolverInputTypes["JobPositionLocaleUpdateInput"]},ResolverInputTypes["JobPositionLocaleUpdateResult"]],
upsertJobPositionLocale?: [{	by: ResolverInputTypes["JobPositionLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobPositionLocaleWhere"] | undefined | null,	update: ResolverInputTypes["JobPositionLocaleUpdateInput"],	create: ResolverInputTypes["JobPositionLocaleCreateInput"]},ResolverInputTypes["JobPositionLocaleUpsertResult"]],
createGallery?: [{	data: ResolverInputTypes["GalleryCreateInput"]},ResolverInputTypes["GalleryCreateResult"]],
deleteGallery?: [{	by: ResolverInputTypes["GalleryUniqueWhere"],	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null},ResolverInputTypes["GalleryDeleteResult"]],
updateGallery?: [{	by: ResolverInputTypes["GalleryUniqueWhere"],	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null,	data: ResolverInputTypes["GalleryUpdateInput"]},ResolverInputTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by: ResolverInputTypes["GalleryUniqueWhere"],	filter?: ResolverInputTypes["GalleryWhere"] | undefined | null,	update: ResolverInputTypes["GalleryUpdateInput"],	create: ResolverInputTypes["GalleryCreateInput"]},ResolverInputTypes["GalleryUpsertResult"]],
createHomePage?: [{	data: ResolverInputTypes["HomePageCreateInput"]},ResolverInputTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by: ResolverInputTypes["HomePageUniqueWhere"],	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null},ResolverInputTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by: ResolverInputTypes["HomePageUniqueWhere"],	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null,	data: ResolverInputTypes["HomePageUpdateInput"]},ResolverInputTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by: ResolverInputTypes["HomePageUniqueWhere"],	filter?: ResolverInputTypes["HomePageWhere"] | undefined | null,	update: ResolverInputTypes["HomePageUpdateInput"],	create: ResolverInputTypes["HomePageCreateInput"]},ResolverInputTypes["HomePageUpsertResult"]],
createHomePageLocale?: [{	data: ResolverInputTypes["HomePageLocaleCreateInput"]},ResolverInputTypes["HomePageLocaleCreateResult"]],
deleteHomePageLocale?: [{	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLocaleDeleteResult"]],
updateHomePageLocale?: [{	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	data: ResolverInputTypes["HomePageLocaleUpdateInput"]},ResolverInputTypes["HomePageLocaleUpdateResult"]],
upsertHomePageLocale?: [{	by: ResolverInputTypes["HomePageLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLocaleWhere"] | undefined | null,	update: ResolverInputTypes["HomePageLocaleUpdateInput"],	create: ResolverInputTypes["HomePageLocaleCreateInput"]},ResolverInputTypes["HomePageLocaleUpsertResult"]],
createMedium?: [{	data: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["MediumCreateResult"]],
deleteMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null},ResolverInputTypes["MediumDeleteResult"]],
updateMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	data: ResolverInputTypes["MediumUpdateInput"]},ResolverInputTypes["MediumUpdateResult"]],
upsertMedium?: [{	by: ResolverInputTypes["MediumUniqueWhere"],	filter?: ResolverInputTypes["MediumWhere"] | undefined | null,	update: ResolverInputTypes["MediumUpdateInput"],	create: ResolverInputTypes["MediumCreateInput"]},ResolverInputTypes["MediumUpsertResult"]],
createMediumItem?: [{	data: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["MediumItemCreateResult"]],
deleteMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null},ResolverInputTypes["MediumItemDeleteResult"]],
updateMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	data: ResolverInputTypes["MediumItemUpdateInput"]},ResolverInputTypes["MediumItemUpdateResult"]],
upsertMediumItem?: [{	by: ResolverInputTypes["MediumItemUniqueWhere"],	filter?: ResolverInputTypes["MediumItemWhere"] | undefined | null,	update: ResolverInputTypes["MediumItemUpdateInput"],	create: ResolverInputTypes["MediumItemCreateInput"]},ResolverInputTypes["MediumItemUpsertResult"]],
createMediumList?: [{	data: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["MediumListCreateResult"]],
deleteMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null},ResolverInputTypes["MediumListDeleteResult"]],
updateMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	data: ResolverInputTypes["MediumListUpdateInput"]},ResolverInputTypes["MediumListUpdateResult"]],
upsertMediumList?: [{	by: ResolverInputTypes["MediumListUniqueWhere"],	filter?: ResolverInputTypes["MediumListWhere"] | undefined | null,	update: ResolverInputTypes["MediumListUpdateInput"],	create: ResolverInputTypes["MediumListCreateInput"]},ResolverInputTypes["MediumListUpsertResult"]],
createVideo?: [{	data: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["VideoCreateResult"]],
deleteVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null},ResolverInputTypes["VideoDeleteResult"]],
updateVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	data: ResolverInputTypes["VideoUpdateInput"]},ResolverInputTypes["VideoUpdateResult"]],
upsertVideo?: [{	by: ResolverInputTypes["VideoUniqueWhere"],	filter?: ResolverInputTypes["VideoWhere"] | undefined | null,	update: ResolverInputTypes["VideoUpdateInput"],	create: ResolverInputTypes["VideoCreateInput"]},ResolverInputTypes["VideoUpsertResult"]],
createTextItem?: [{	data: ResolverInputTypes["TextItemCreateInput"]},ResolverInputTypes["TextItemCreateResult"]],
deleteTextItem?: [{	by: ResolverInputTypes["TextItemUniqueWhere"],	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null},ResolverInputTypes["TextItemDeleteResult"]],
updateTextItem?: [{	by: ResolverInputTypes["TextItemUniqueWhere"],	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null,	data: ResolverInputTypes["TextItemUpdateInput"]},ResolverInputTypes["TextItemUpdateResult"]],
upsertTextItem?: [{	by: ResolverInputTypes["TextItemUniqueWhere"],	filter?: ResolverInputTypes["TextItemWhere"] | undefined | null,	update: ResolverInputTypes["TextItemUpdateInput"],	create: ResolverInputTypes["TextItemCreateInput"]},ResolverInputTypes["TextItemUpsertResult"]],
createTextList?: [{	data: ResolverInputTypes["TextListCreateInput"]},ResolverInputTypes["TextListCreateResult"]],
deleteTextList?: [{	by: ResolverInputTypes["TextListUniqueWhere"],	filter?: ResolverInputTypes["TextListWhere"] | undefined | null},ResolverInputTypes["TextListDeleteResult"]],
updateTextList?: [{	by: ResolverInputTypes["TextListUniqueWhere"],	filter?: ResolverInputTypes["TextListWhere"] | undefined | null,	data: ResolverInputTypes["TextListUpdateInput"]},ResolverInputTypes["TextListUpdateResult"]],
upsertTextList?: [{	by: ResolverInputTypes["TextListUniqueWhere"],	filter?: ResolverInputTypes["TextListWhere"] | undefined | null,	update: ResolverInputTypes["TextListUpdateInput"],	create: ResolverInputTypes["TextListCreateInput"]},ResolverInputTypes["TextListUpsertResult"]],
createCarousel?: [{	data: ResolverInputTypes["CarouselCreateInput"]},ResolverInputTypes["CarouselCreateResult"]],
deleteCarousel?: [{	by: ResolverInputTypes["CarouselUniqueWhere"],	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null},ResolverInputTypes["CarouselDeleteResult"]],
updateCarousel?: [{	by: ResolverInputTypes["CarouselUniqueWhere"],	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null,	data: ResolverInputTypes["CarouselUpdateInput"]},ResolverInputTypes["CarouselUpdateResult"]],
upsertCarousel?: [{	by: ResolverInputTypes["CarouselUniqueWhere"],	filter?: ResolverInputTypes["CarouselWhere"] | undefined | null,	update: ResolverInputTypes["CarouselUpdateInput"],	create: ResolverInputTypes["CarouselCreateInput"]},ResolverInputTypes["CarouselUpsertResult"]],
createCarouselItem?: [{	data: ResolverInputTypes["CarouselItemCreateInput"]},ResolverInputTypes["CarouselItemCreateResult"]],
deleteCarouselItem?: [{	by: ResolverInputTypes["CarouselItemUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null},ResolverInputTypes["CarouselItemDeleteResult"]],
updateCarouselItem?: [{	by: ResolverInputTypes["CarouselItemUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,	data: ResolverInputTypes["CarouselItemUpdateInput"]},ResolverInputTypes["CarouselItemUpdateResult"]],
upsertCarouselItem?: [{	by: ResolverInputTypes["CarouselItemUniqueWhere"],	filter?: ResolverInputTypes["CarouselItemWhere"] | undefined | null,	update: ResolverInputTypes["CarouselItemUpdateInput"],	create: ResolverInputTypes["CarouselItemCreateInput"]},ResolverInputTypes["CarouselItemUpsertResult"]],
createTheme?: [{	data: ResolverInputTypes["ThemeCreateInput"]},ResolverInputTypes["ThemeCreateResult"]],
deleteTheme?: [{	by: ResolverInputTypes["ThemeUniqueWhere"],	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null},ResolverInputTypes["ThemeDeleteResult"]],
updateTheme?: [{	by: ResolverInputTypes["ThemeUniqueWhere"],	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null,	data: ResolverInputTypes["ThemeUpdateInput"]},ResolverInputTypes["ThemeUpdateResult"]],
upsertTheme?: [{	by: ResolverInputTypes["ThemeUniqueWhere"],	filter?: ResolverInputTypes["ThemeWhere"] | undefined | null,	update: ResolverInputTypes["ThemeUpdateInput"],	create: ResolverInputTypes["ThemeCreateInput"]},ResolverInputTypes["ThemeUpsertResult"]],
createBonusBanner?: [{	data: ResolverInputTypes["BonusBannerCreateInput"]},ResolverInputTypes["BonusBannerCreateResult"]],
deleteBonusBanner?: [{	by: ResolverInputTypes["BonusBannerUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null},ResolverInputTypes["BonusBannerDeleteResult"]],
updateBonusBanner?: [{	by: ResolverInputTypes["BonusBannerUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null,	data: ResolverInputTypes["BonusBannerUpdateInput"]},ResolverInputTypes["BonusBannerUpdateResult"]],
upsertBonusBanner?: [{	by: ResolverInputTypes["BonusBannerUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerWhere"] | undefined | null,	update: ResolverInputTypes["BonusBannerUpdateInput"],	create: ResolverInputTypes["BonusBannerCreateInput"]},ResolverInputTypes["BonusBannerUpsertResult"]],
createBonusBannerLocale?: [{	data: ResolverInputTypes["BonusBannerLocaleCreateInput"]},ResolverInputTypes["BonusBannerLocaleCreateResult"]],
deleteBonusBannerLocale?: [{	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null},ResolverInputTypes["BonusBannerLocaleDeleteResult"]],
updateBonusBannerLocale?: [{	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	data: ResolverInputTypes["BonusBannerLocaleUpdateInput"]},ResolverInputTypes["BonusBannerLocaleUpdateResult"]],
upsertBonusBannerLocale?: [{	by: ResolverInputTypes["BonusBannerLocaleUniqueWhere"],	filter?: ResolverInputTypes["BonusBannerLocaleWhere"] | undefined | null,	update: ResolverInputTypes["BonusBannerLocaleUpdateInput"],	create: ResolverInputTypes["BonusBannerLocaleCreateInput"]},ResolverInputTypes["BonusBannerLocaleUpsertResult"]],
createTile?: [{	data: ResolverInputTypes["TileCreateInput"]},ResolverInputTypes["TileCreateResult"]],
deleteTile?: [{	by: ResolverInputTypes["TileUniqueWhere"],	filter?: ResolverInputTypes["TileWhere"] | undefined | null},ResolverInputTypes["TileDeleteResult"]],
updateTile?: [{	by: ResolverInputTypes["TileUniqueWhere"],	filter?: ResolverInputTypes["TileWhere"] | undefined | null,	data: ResolverInputTypes["TileUpdateInput"]},ResolverInputTypes["TileUpdateResult"]],
upsertTile?: [{	by: ResolverInputTypes["TileUniqueWhere"],	filter?: ResolverInputTypes["TileWhere"] | undefined | null,	update: ResolverInputTypes["TileUpdateInput"],	create: ResolverInputTypes["TileCreateInput"]},ResolverInputTypes["TileUpsertResult"]],
createSideBySide?: [{	data: ResolverInputTypes["SideBySideCreateInput"]},ResolverInputTypes["SideBySideCreateResult"]],
deleteSideBySide?: [{	by: ResolverInputTypes["SideBySideUniqueWhere"],	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null},ResolverInputTypes["SideBySideDeleteResult"]],
updateSideBySide?: [{	by: ResolverInputTypes["SideBySideUniqueWhere"],	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null,	data: ResolverInputTypes["SideBySideUpdateInput"]},ResolverInputTypes["SideBySideUpdateResult"]],
upsertSideBySide?: [{	by: ResolverInputTypes["SideBySideUniqueWhere"],	filter?: ResolverInputTypes["SideBySideWhere"] | undefined | null,	update: ResolverInputTypes["SideBySideUpdateInput"],	create: ResolverInputTypes["SideBySideCreateInput"]},ResolverInputTypes["SideBySideUpsertResult"]],
createSideBySideItem?: [{	data: ResolverInputTypes["SideBySideItemCreateInput"]},ResolverInputTypes["SideBySideItemCreateResult"]],
deleteSideBySideItem?: [{	by: ResolverInputTypes["SideBySideItemUniqueWhere"],	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null},ResolverInputTypes["SideBySideItemDeleteResult"]],
updateSideBySideItem?: [{	by: ResolverInputTypes["SideBySideItemUniqueWhere"],	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,	data: ResolverInputTypes["SideBySideItemUpdateInput"]},ResolverInputTypes["SideBySideItemUpdateResult"]],
upsertSideBySideItem?: [{	by: ResolverInputTypes["SideBySideItemUniqueWhere"],	filter?: ResolverInputTypes["SideBySideItemWhere"] | undefined | null,	update: ResolverInputTypes["SideBySideItemUpdateInput"],	create: ResolverInputTypes["SideBySideItemCreateInput"]},ResolverInputTypes["SideBySideItemUpsertResult"]],
createHomePageLokal?: [{	data: ResolverInputTypes["HomePageLokalCreateInput"]},ResolverInputTypes["HomePageLokalCreateResult"]],
deleteHomePageLokal?: [{	by: ResolverInputTypes["HomePageLokalUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null},ResolverInputTypes["HomePageLokalDeleteResult"]],
updateHomePageLokal?: [{	by: ResolverInputTypes["HomePageLokalUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null,	data: ResolverInputTypes["HomePageLokalUpdateInput"]},ResolverInputTypes["HomePageLokalUpdateResult"]],
upsertHomePageLokal?: [{	by: ResolverInputTypes["HomePageLokalUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalWhere"] | undefined | null,	update: ResolverInputTypes["HomePageLokalUpdateInput"],	create: ResolverInputTypes["HomePageLokalCreateInput"]},ResolverInputTypes["HomePageLokalUpsertResult"]],
createHomePageLokalLocale?: [{	data: ResolverInputTypes["HomePageLokalLocaleCreateInput"]},ResolverInputTypes["HomePageLokalLocaleCreateResult"]],
deleteHomePageLokalLocale?: [{	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null},ResolverInputTypes["HomePageLokalLocaleDeleteResult"]],
updateHomePageLokalLocale?: [{	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	data: ResolverInputTypes["HomePageLokalLocaleUpdateInput"]},ResolverInputTypes["HomePageLokalLocaleUpdateResult"]],
upsertHomePageLokalLocale?: [{	by: ResolverInputTypes["HomePageLokalLocaleUniqueWhere"],	filter?: ResolverInputTypes["HomePageLokalLocaleWhere"] | undefined | null,	update: ResolverInputTypes["HomePageLokalLocaleUpdateInput"],	create: ResolverInputTypes["HomePageLokalLocaleCreateInput"]},ResolverInputTypes["HomePageLokalLocaleUpsertResult"]],
createSiteSwitcher?: [{	data: ResolverInputTypes["SiteSwitcherCreateInput"]},ResolverInputTypes["SiteSwitcherCreateResult"]],
deleteSiteSwitcher?: [{	by: ResolverInputTypes["SiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null},ResolverInputTypes["SiteSwitcherDeleteResult"]],
updateSiteSwitcher?: [{	by: ResolverInputTypes["SiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null,	data: ResolverInputTypes["SiteSwitcherUpdateInput"]},ResolverInputTypes["SiteSwitcherUpdateResult"]],
upsertSiteSwitcher?: [{	by: ResolverInputTypes["SiteSwitcherUniqueWhere"],	filter?: ResolverInputTypes["SiteSwitcherWhere"] | undefined | null,	update: ResolverInputTypes["SiteSwitcherUpdateInput"],	create: ResolverInputTypes["SiteSwitcherCreateInput"]},ResolverInputTypes["SiteSwitcherUpsertResult"]],
createGalleryItem?: [{	data: ResolverInputTypes["GalleryItemCreateInput"]},ResolverInputTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by: ResolverInputTypes["GalleryItemUniqueWhere"],	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null},ResolverInputTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by: ResolverInputTypes["GalleryItemUniqueWhere"],	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,	data: ResolverInputTypes["GalleryItemUpdateInput"]},ResolverInputTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by: ResolverInputTypes["GalleryItemUniqueWhere"],	filter?: ResolverInputTypes["GalleryItemWhere"] | undefined | null,	update: ResolverInputTypes["GalleryItemUpdateInput"],	create: ResolverInputTypes["GalleryItemCreateInput"]},ResolverInputTypes["GalleryItemUpsertResult"]],
createJobsForm?: [{	data: ResolverInputTypes["JobsFormCreateInput"]},ResolverInputTypes["JobsFormCreateResult"]],
deleteJobsForm?: [{	by: ResolverInputTypes["JobsFormUniqueWhere"],	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null},ResolverInputTypes["JobsFormDeleteResult"]],
updateJobsForm?: [{	by: ResolverInputTypes["JobsFormUniqueWhere"],	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null,	data: ResolverInputTypes["JobsFormUpdateInput"]},ResolverInputTypes["JobsFormUpdateResult"]],
upsertJobsForm?: [{	by: ResolverInputTypes["JobsFormUniqueWhere"],	filter?: ResolverInputTypes["JobsFormWhere"] | undefined | null,	update: ResolverInputTypes["JobsFormUpdateInput"],	create: ResolverInputTypes["JobsFormCreateInput"]},ResolverInputTypes["JobsFormUpsertResult"]],
createJobsFormLocale?: [{	data: ResolverInputTypes["JobsFormLocaleCreateInput"]},ResolverInputTypes["JobsFormLocaleCreateResult"]],
deleteJobsFormLocale?: [{	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFormLocaleDeleteResult"]],
updateJobsFormLocale?: [{	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	data: ResolverInputTypes["JobsFormLocaleUpdateInput"]},ResolverInputTypes["JobsFormLocaleUpdateResult"]],
upsertJobsFormLocale?: [{	by: ResolverInputTypes["JobsFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFormLocaleWhere"] | undefined | null,	update: ResolverInputTypes["JobsFormLocaleUpdateInput"],	create: ResolverInputTypes["JobsFormLocaleCreateInput"]},ResolverInputTypes["JobsFormLocaleUpsertResult"]],
createImageTextItem?: [{	data: ResolverInputTypes["ImageTextItemCreateInput"]},ResolverInputTypes["ImageTextItemCreateResult"]],
deleteImageTextItem?: [{	by: ResolverInputTypes["ImageTextItemUniqueWhere"],	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null},ResolverInputTypes["ImageTextItemDeleteResult"]],
updateImageTextItem?: [{	by: ResolverInputTypes["ImageTextItemUniqueWhere"],	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,	data: ResolverInputTypes["ImageTextItemUpdateInput"]},ResolverInputTypes["ImageTextItemUpdateResult"]],
upsertImageTextItem?: [{	by: ResolverInputTypes["ImageTextItemUniqueWhere"],	filter?: ResolverInputTypes["ImageTextItemWhere"] | undefined | null,	update: ResolverInputTypes["ImageTextItemUpdateInput"],	create: ResolverInputTypes["ImageTextItemCreateInput"]},ResolverInputTypes["ImageTextItemUpsertResult"]],
createImageTextList?: [{	data: ResolverInputTypes["ImageTextListCreateInput"]},ResolverInputTypes["ImageTextListCreateResult"]],
deleteImageTextList?: [{	by: ResolverInputTypes["ImageTextListUniqueWhere"],	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null},ResolverInputTypes["ImageTextListDeleteResult"]],
updateImageTextList?: [{	by: ResolverInputTypes["ImageTextListUniqueWhere"],	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null,	data: ResolverInputTypes["ImageTextListUpdateInput"]},ResolverInputTypes["ImageTextListUpdateResult"]],
upsertImageTextList?: [{	by: ResolverInputTypes["ImageTextListUniqueWhere"],	filter?: ResolverInputTypes["ImageTextListWhere"] | undefined | null,	update: ResolverInputTypes["ImageTextListUpdateInput"],	create: ResolverInputTypes["ImageTextListCreateInput"]},ResolverInputTypes["ImageTextListUpsertResult"]],
createJobsFilter?: [{	data: ResolverInputTypes["JobsFilterCreateInput"]},ResolverInputTypes["JobsFilterCreateResult"]],
deleteJobsFilter?: [{	by: ResolverInputTypes["JobsFilterUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null},ResolverInputTypes["JobsFilterDeleteResult"]],
updateJobsFilter?: [{	by: ResolverInputTypes["JobsFilterUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null,	data: ResolverInputTypes["JobsFilterUpdateInput"]},ResolverInputTypes["JobsFilterUpdateResult"]],
upsertJobsFilter?: [{	by: ResolverInputTypes["JobsFilterUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterWhere"] | undefined | null,	update: ResolverInputTypes["JobsFilterUpdateInput"],	create: ResolverInputTypes["JobsFilterCreateInput"]},ResolverInputTypes["JobsFilterUpsertResult"]],
createJobsFilterLocale?: [{	data: ResolverInputTypes["JobsFilterLocaleCreateInput"]},ResolverInputTypes["JobsFilterLocaleCreateResult"]],
deleteJobsFilterLocale?: [{	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null},ResolverInputTypes["JobsFilterLocaleDeleteResult"]],
updateJobsFilterLocale?: [{	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	data: ResolverInputTypes["JobsFilterLocaleUpdateInput"]},ResolverInputTypes["JobsFilterLocaleUpdateResult"]],
upsertJobsFilterLocale?: [{	by: ResolverInputTypes["JobsFilterLocaleUniqueWhere"],	filter?: ResolverInputTypes["JobsFilterLocaleWhere"] | undefined | null,	update: ResolverInputTypes["JobsFilterLocaleUpdateInput"],	create: ResolverInputTypes["JobsFilterLocaleCreateInput"]},ResolverInputTypes["JobsFilterLocaleUpsertResult"]],
createFile?: [{	data: ResolverInputTypes["FileCreateInput"]},ResolverInputTypes["FileCreateResult"]],
deleteFile?: [{	by: ResolverInputTypes["FileUniqueWhere"],	filter?: ResolverInputTypes["FileWhere"] | undefined | null},ResolverInputTypes["FileDeleteResult"]],
updateFile?: [{	by: ResolverInputTypes["FileUniqueWhere"],	filter?: ResolverInputTypes["FileWhere"] | undefined | null,	data: ResolverInputTypes["FileUpdateInput"]},ResolverInputTypes["FileUpdateResult"]],
upsertFile?: [{	by: ResolverInputTypes["FileUniqueWhere"],	filter?: ResolverInputTypes["FileWhere"] | undefined | null,	update: ResolverInputTypes["FileUpdateInput"],	create: ResolverInputTypes["FileCreateInput"]},ResolverInputTypes["FileUpsertResult"]],
createJobFormSubscription?: [{	data: ResolverInputTypes["JobFormSubscriptionCreateInput"]},ResolverInputTypes["JobFormSubscriptionCreateResult"]],
deleteJobFormSubscription?: [{	by: ResolverInputTypes["JobFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null},ResolverInputTypes["JobFormSubscriptionDeleteResult"]],
updateJobFormSubscription?: [{	by: ResolverInputTypes["JobFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null,	data: ResolverInputTypes["JobFormSubscriptionUpdateInput"]},ResolverInputTypes["JobFormSubscriptionUpdateResult"]],
upsertJobFormSubscription?: [{	by: ResolverInputTypes["JobFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionWhere"] | undefined | null,	update: ResolverInputTypes["JobFormSubscriptionUpdateInput"],	create: ResolverInputTypes["JobFormSubscriptionCreateInput"]},ResolverInputTypes["JobFormSubscriptionUpsertResult"]],
createImageList?: [{	data: ResolverInputTypes["ImageListCreateInput"]},ResolverInputTypes["ImageListCreateResult"]],
deleteImageList?: [{	by: ResolverInputTypes["ImageListUniqueWhere"],	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null},ResolverInputTypes["ImageListDeleteResult"]],
updateImageList?: [{	by: ResolverInputTypes["ImageListUniqueWhere"],	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null,	data: ResolverInputTypes["ImageListUpdateInput"]},ResolverInputTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by: ResolverInputTypes["ImageListUniqueWhere"],	filter?: ResolverInputTypes["ImageListWhere"] | undefined | null,	update: ResolverInputTypes["ImageListUpdateInput"],	create: ResolverInputTypes["ImageListCreateInput"]},ResolverInputTypes["ImageListUpsertResult"]],
createImageListItem?: [{	data: ResolverInputTypes["ImageListItemCreateInput"]},ResolverInputTypes["ImageListItemCreateResult"]],
deleteImageListItem?: [{	by: ResolverInputTypes["ImageListItemUniqueWhere"],	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null},ResolverInputTypes["ImageListItemDeleteResult"]],
updateImageListItem?: [{	by: ResolverInputTypes["ImageListItemUniqueWhere"],	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,	data: ResolverInputTypes["ImageListItemUpdateInput"]},ResolverInputTypes["ImageListItemUpdateResult"]],
upsertImageListItem?: [{	by: ResolverInputTypes["ImageListItemUniqueWhere"],	filter?: ResolverInputTypes["ImageListItemWhere"] | undefined | null,	update: ResolverInputTypes["ImageListItemUpdateInput"],	create: ResolverInputTypes["ImageListItemCreateInput"]},ResolverInputTypes["ImageListItemUpsertResult"]],
createJobFormSubscriptionStatus?: [{	data: ResolverInputTypes["JobFormSubscriptionStatusCreateInput"]},ResolverInputTypes["JobFormSubscriptionStatusCreateResult"]],
deleteJobFormSubscriptionStatus?: [{	by: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null},ResolverInputTypes["JobFormSubscriptionStatusDeleteResult"]],
updateJobFormSubscriptionStatus?: [{	by: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null,	data: ResolverInputTypes["JobFormSubscriptionStatusUpdateInput"]},ResolverInputTypes["JobFormSubscriptionStatusUpdateResult"]],
upsertJobFormSubscriptionStatus?: [{	by: ResolverInputTypes["JobFormSubscriptionStatusUniqueWhere"],	filter?: ResolverInputTypes["JobFormSubscriptionStatusWhere"] | undefined | null,	update: ResolverInputTypes["JobFormSubscriptionStatusUpdateInput"],	create: ResolverInputTypes["JobFormSubscriptionStatusCreateInput"]},ResolverInputTypes["JobFormSubscriptionStatusUpsertResult"]],
createGeneralLocale?: [{	data: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["GeneralLocaleCreateResult"]],
deleteGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null},ResolverInputTypes["GeneralLocaleDeleteResult"]],
updateGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	data: ResolverInputTypes["GeneralLocaleUpdateInput"]},ResolverInputTypes["GeneralLocaleUpdateResult"]],
upsertGeneralLocale?: [{	by: ResolverInputTypes["GeneralLocaleUniqueWhere"],	filter?: ResolverInputTypes["GeneralLocaleWhere"] | undefined | null,	update: ResolverInputTypes["GeneralLocaleUpdateInput"],	create: ResolverInputTypes["GeneralLocaleCreateInput"]},ResolverInputTypes["GeneralLocaleUpsertResult"]],
createStickyBar?: [{	data: ResolverInputTypes["StickyBarCreateInput"]},ResolverInputTypes["StickyBarCreateResult"]],
deleteStickyBar?: [{	by: ResolverInputTypes["StickyBarUniqueWhere"],	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null},ResolverInputTypes["StickyBarDeleteResult"]],
updateStickyBar?: [{	by: ResolverInputTypes["StickyBarUniqueWhere"],	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null,	data: ResolverInputTypes["StickyBarUpdateInput"]},ResolverInputTypes["StickyBarUpdateResult"]],
upsertStickyBar?: [{	by: ResolverInputTypes["StickyBarUniqueWhere"],	filter?: ResolverInputTypes["StickyBarWhere"] | undefined | null,	update: ResolverInputTypes["StickyBarUpdateInput"],	create: ResolverInputTypes["StickyBarCreateInput"]},ResolverInputTypes["StickyBarUpsertResult"]],
createRecommendationForm?: [{	data: ResolverInputTypes["RecommendationFormCreateInput"]},ResolverInputTypes["RecommendationFormCreateResult"]],
deleteRecommendationForm?: [{	by: ResolverInputTypes["RecommendationFormUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null},ResolverInputTypes["RecommendationFormDeleteResult"]],
updateRecommendationForm?: [{	by: ResolverInputTypes["RecommendationFormUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null,	data: ResolverInputTypes["RecommendationFormUpdateInput"]},ResolverInputTypes["RecommendationFormUpdateResult"]],
upsertRecommendationForm?: [{	by: ResolverInputTypes["RecommendationFormUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormWhere"] | undefined | null,	update: ResolverInputTypes["RecommendationFormUpdateInput"],	create: ResolverInputTypes["RecommendationFormCreateInput"]},ResolverInputTypes["RecommendationFormUpsertResult"]],
createRecommendationFormLocale?: [{	data: ResolverInputTypes["RecommendationFormLocaleCreateInput"]},ResolverInputTypes["RecommendationFormLocaleCreateResult"]],
deleteRecommendationFormLocale?: [{	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null},ResolverInputTypes["RecommendationFormLocaleDeleteResult"]],
updateRecommendationFormLocale?: [{	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	data: ResolverInputTypes["RecommendationFormLocaleUpdateInput"]},ResolverInputTypes["RecommendationFormLocaleUpdateResult"]],
upsertRecommendationFormLocale?: [{	by: ResolverInputTypes["RecommendationFormLocaleUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormLocaleWhere"] | undefined | null,	update: ResolverInputTypes["RecommendationFormLocaleUpdateInput"],	create: ResolverInputTypes["RecommendationFormLocaleCreateInput"]},ResolverInputTypes["RecommendationFormLocaleUpsertResult"]],
createRecommendationFormSubscription?: [{	data: ResolverInputTypes["RecommendationFormSubscriptionCreateInput"]},ResolverInputTypes["RecommendationFormSubscriptionCreateResult"]],
deleteRecommendationFormSubscription?: [{	by: ResolverInputTypes["RecommendationFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null},ResolverInputTypes["RecommendationFormSubscriptionDeleteResult"]],
updateRecommendationFormSubscription?: [{	by: ResolverInputTypes["RecommendationFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null,	data: ResolverInputTypes["RecommendationFormSubscriptionUpdateInput"]},ResolverInputTypes["RecommendationFormSubscriptionUpdateResult"]],
upsertRecommendationFormSubscription?: [{	by: ResolverInputTypes["RecommendationFormSubscriptionUniqueWhere"],	filter?: ResolverInputTypes["RecommendationFormSubscriptionWhere"] | undefined | null,	update: ResolverInputTypes["RecommendationFormSubscriptionUpdateInput"],	create: ResolverInputTypes["RecommendationFormSubscriptionCreateInput"]},ResolverInputTypes["RecommendationFormSubscriptionUpsertResult"]],
createInfoBox?: [{	data: ResolverInputTypes["InfoBoxCreateInput"]},ResolverInputTypes["InfoBoxCreateResult"]],
deleteInfoBox?: [{	by: ResolverInputTypes["InfoBoxUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null},ResolverInputTypes["InfoBoxDeleteResult"]],
updateInfoBox?: [{	by: ResolverInputTypes["InfoBoxUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null,	data: ResolverInputTypes["InfoBoxUpdateInput"]},ResolverInputTypes["InfoBoxUpdateResult"]],
upsertInfoBox?: [{	by: ResolverInputTypes["InfoBoxUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxWhere"] | undefined | null,	update: ResolverInputTypes["InfoBoxUpdateInput"],	create: ResolverInputTypes["InfoBoxCreateInput"]},ResolverInputTypes["InfoBoxUpsertResult"]],
createInfoBoxLocale?: [{	data: ResolverInputTypes["InfoBoxLocaleCreateInput"]},ResolverInputTypes["InfoBoxLocaleCreateResult"]],
deleteInfoBoxLocale?: [{	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null},ResolverInputTypes["InfoBoxLocaleDeleteResult"]],
updateInfoBoxLocale?: [{	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	data: ResolverInputTypes["InfoBoxLocaleUpdateInput"]},ResolverInputTypes["InfoBoxLocaleUpdateResult"]],
upsertInfoBoxLocale?: [{	by: ResolverInputTypes["InfoBoxLocaleUniqueWhere"],	filter?: ResolverInputTypes["InfoBoxLocaleWhere"] | undefined | null,	update: ResolverInputTypes["InfoBoxLocaleUpdateInput"],	create: ResolverInputTypes["InfoBoxLocaleCreateInput"]},ResolverInputTypes["InfoBoxLocaleUpsertResult"]],
createTranslation?: [{	data: ResolverInputTypes["TranslationCreateInput"]},ResolverInputTypes["TranslationCreateResult"]],
deleteTranslation?: [{	by: ResolverInputTypes["TranslationUniqueWhere"],	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null},ResolverInputTypes["TranslationDeleteResult"]],
updateTranslation?: [{	by: ResolverInputTypes["TranslationUniqueWhere"],	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null,	data: ResolverInputTypes["TranslationUpdateInput"]},ResolverInputTypes["TranslationUpdateResult"]],
upsertTranslation?: [{	by: ResolverInputTypes["TranslationUniqueWhere"],	filter?: ResolverInputTypes["TranslationWhere"] | undefined | null,	update: ResolverInputTypes["TranslationUpdateInput"],	create: ResolverInputTypes["TranslationCreateInput"]},ResolverInputTypes["TranslationUpsertResult"]],
createTranslationLocale?: [{	data: ResolverInputTypes["TranslationLocaleCreateInput"]},ResolverInputTypes["TranslationLocaleCreateResult"]],
deleteTranslationLocale?: [{	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null},ResolverInputTypes["TranslationLocaleDeleteResult"]],
updateTranslationLocale?: [{	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	data: ResolverInputTypes["TranslationLocaleUpdateInput"]},ResolverInputTypes["TranslationLocaleUpdateResult"]],
upsertTranslationLocale?: [{	by: ResolverInputTypes["TranslationLocaleUniqueWhere"],	filter?: ResolverInputTypes["TranslationLocaleWhere"] | undefined | null,	update: ResolverInputTypes["TranslationLocaleUpdateInput"],	create: ResolverInputTypes["TranslationLocaleCreateInput"]},ResolverInputTypes["TranslationLocaleUpsertResult"]],
createCornerBanner?: [{	data: ResolverInputTypes["CornerBannerCreateInput"]},ResolverInputTypes["CornerBannerCreateResult"]],
deleteCornerBanner?: [{	by: ResolverInputTypes["CornerBannerUniqueWhere"],	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null},ResolverInputTypes["CornerBannerDeleteResult"]],
updateCornerBanner?: [{	by: ResolverInputTypes["CornerBannerUniqueWhere"],	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null,	data: ResolverInputTypes["CornerBannerUpdateInput"]},ResolverInputTypes["CornerBannerUpdateResult"]],
upsertCornerBanner?: [{	by: ResolverInputTypes["CornerBannerUniqueWhere"],	filter?: ResolverInputTypes["CornerBannerWhere"] | undefined | null,	update: ResolverInputTypes["CornerBannerUpdateInput"],	create: ResolverInputTypes["CornerBannerCreateInput"]},ResolverInputTypes["CornerBannerUpsertResult"]],
	query?:ResolverInputTypes["Query"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?: boolean | undefined | null
}
  }

export type ModelTypes = {
    ["_Column"]: {
		name: string,
	type: string,
	enumName?: string | undefined,
	defaultValue?: ModelTypes["Json"] | undefined,
	nullable: boolean,
	rules: Array<ModelTypes["_Rule"]>,
	validators: Array<ModelTypes["_Validator"]>
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Rule"]: {
		message?: ModelTypes["_RuleMessage"] | undefined,
	validator: number
};
	["_RuleMessage"]: {
		text?: string | undefined
};
	["_Validator"]: {
		operation: string,
	arguments: Array<ModelTypes["_Argument"]>
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator: number
};
	["_PathArgument"]: {
		path: Array<string>
};
	["_LiteralArgument"]: {
		value?: ModelTypes["Json"] | undefined
};
	/** Json custom scalar type */
["Json"]:any;
	["_Relation"]: {
		name: string,
	type: string,
	side: ModelTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string | undefined,
	inversedBy?: string | undefined,
	nullable?: boolean | undefined,
	onDelete?: ModelTypes["_OnDeleteBehaviour"] | undefined,
	orphanRemoval?: boolean | undefined,
	orderBy?: Array<ModelTypes["_OrderBy"]> | undefined,
	rules: Array<ModelTypes["_Rule"]>,
	validators: Array<ModelTypes["_Validator"]>
};
	["_RelationSide"]:_RelationSide;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_OrderBy"]: {
		path: Array<string>,
	direction: ModelTypes["_OrderByDirection"]
};
	["_OrderByDirection"]:_OrderByDirection;
	["Query"]: {
		schema?: ModelTypes["_Schema"] | undefined,
	s3DummyQuery?: string | undefined,
	getGeneral?: ModelTypes["General"] | undefined,
	listGeneral: Array<ModelTypes["General"]>,
	paginateGeneral: ModelTypes["GeneralConnection"],
	validateCreateGeneral: ModelTypes["_ValidationResult"],
	validateUpdateGeneral: ModelTypes["_ValidationResult"],
	getImage?: ModelTypes["Image"] | undefined,
	listImage: Array<ModelTypes["Image"]>,
	paginateImage: ModelTypes["ImageConnection"],
	validateCreateImage: ModelTypes["_ValidationResult"],
	validateUpdateImage: ModelTypes["_ValidationResult"],
	getGenericPage?: ModelTypes["GenericPage"] | undefined,
	listGenericPage: Array<ModelTypes["GenericPage"]>,
	paginateGenericPage: ModelTypes["GenericPageConnection"],
	validateCreateGenericPage: ModelTypes["_ValidationResult"],
	validateUpdateGenericPage: ModelTypes["_ValidationResult"],
	getLinkable?: ModelTypes["Linkable"] | undefined,
	listLinkable: Array<ModelTypes["Linkable"]>,
	paginateLinkable: ModelTypes["LinkableConnection"],
	validateCreateLinkable: ModelTypes["_ValidationResult"],
	validateUpdateLinkable: ModelTypes["_ValidationResult"],
	getSeo?: ModelTypes["Seo"] | undefined,
	listSeo: Array<ModelTypes["Seo"]>,
	paginateSeo: ModelTypes["SeoConnection"],
	validateCreateSeo: ModelTypes["_ValidationResult"],
	validateUpdateSeo: ModelTypes["_ValidationResult"],
	getContent?: ModelTypes["Content"] | undefined,
	listContent: Array<ModelTypes["Content"]>,
	paginateContent: ModelTypes["ContentConnection"],
	validateCreateContent: ModelTypes["_ValidationResult"],
	validateUpdateContent: ModelTypes["_ValidationResult"],
	getContentBlock?: ModelTypes["ContentBlock"] | undefined,
	listContentBlock: Array<ModelTypes["ContentBlock"]>,
	paginateContentBlock: ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock: ModelTypes["_ValidationResult"],
	validateUpdateContentBlock: ModelTypes["_ValidationResult"],
	getContentReference?: ModelTypes["ContentReference"] | undefined,
	listContentReference: Array<ModelTypes["ContentReference"]>,
	paginateContentReference: ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference: ModelTypes["_ValidationResult"],
	validateUpdateContentReference: ModelTypes["_ValidationResult"],
	getContentReferenceLinkableItem?: ModelTypes["ContentReferenceLinkableItem"] | undefined,
	listContentReferenceLinkableItem: Array<ModelTypes["ContentReferenceLinkableItem"]>,
	paginateContentReferenceLinkableItem: ModelTypes["ContentReferenceLinkableItemConnection"],
	getRedirect?: ModelTypes["Redirect"] | undefined,
	listRedirect: Array<ModelTypes["Redirect"]>,
	paginateRedirect: ModelTypes["RedirectConnection"],
	validateCreateRedirect: ModelTypes["_ValidationResult"],
	validateUpdateRedirect: ModelTypes["_ValidationResult"],
	getLink?: ModelTypes["Link"] | undefined,
	listLink: Array<ModelTypes["Link"]>,
	paginateLink: ModelTypes["LinkConnection"],
	validateCreateLink: ModelTypes["_ValidationResult"],
	validateUpdateLink: ModelTypes["_ValidationResult"],
	getFooter?: ModelTypes["Footer"] | undefined,
	listFooter: Array<ModelTypes["Footer"]>,
	paginateFooter: ModelTypes["FooterConnection"],
	validateCreateFooter: ModelTypes["_ValidationResult"],
	validateUpdateFooter: ModelTypes["_ValidationResult"],
	getFooterLink?: ModelTypes["FooterLink"] | undefined,
	listFooterLink: Array<ModelTypes["FooterLink"]>,
	paginateFooterLink: ModelTypes["FooterLinkConnection"],
	validateCreateFooterLink: ModelTypes["_ValidationResult"],
	validateUpdateFooterLink: ModelTypes["_ValidationResult"],
	getFooterLocale?: ModelTypes["FooterLocale"] | undefined,
	listFooterLocale: Array<ModelTypes["FooterLocale"]>,
	paginateFooterLocale: ModelTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: ModelTypes["_ValidationResult"],
	validateUpdateFooterLocale: ModelTypes["_ValidationResult"],
	getGenericPageLocale?: ModelTypes["GenericPageLocale"] | undefined,
	listGenericPageLocale: Array<ModelTypes["GenericPageLocale"]>,
	paginateGenericPageLocale: ModelTypes["GenericPageLocaleConnection"],
	validateCreateGenericPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateGenericPageLocale: ModelTypes["_ValidationResult"],
	getHeader?: ModelTypes["Header"] | undefined,
	listHeader: Array<ModelTypes["Header"]>,
	paginateHeader: ModelTypes["HeaderConnection"],
	validateCreateHeader: ModelTypes["_ValidationResult"],
	validateUpdateHeader: ModelTypes["_ValidationResult"],
	getHeaderLocale?: ModelTypes["HeaderLocale"] | undefined,
	listHeaderLocale: Array<ModelTypes["HeaderLocale"]>,
	paginateHeaderLocale: ModelTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: ModelTypes["_ValidationResult"],
	validateUpdateHeaderLocale: ModelTypes["_ValidationResult"],
	getLocale?: ModelTypes["Locale"] | undefined,
	listLocale: Array<ModelTypes["Locale"]>,
	paginateLocale: ModelTypes["LocaleConnection"],
	validateCreateLocale: ModelTypes["_ValidationResult"],
	validateUpdateLocale: ModelTypes["_ValidationResult"],
	getSeoDefault?: ModelTypes["SeoDefault"] | undefined,
	listSeoDefault: Array<ModelTypes["SeoDefault"]>,
	paginateSeoDefault: ModelTypes["SeoDefaultConnection"],
	validateCreateSeoDefault: ModelTypes["_ValidationResult"],
	validateUpdateSeoDefault: ModelTypes["_ValidationResult"],
	getSeoDefaultLocale?: ModelTypes["SeoDefaultLocale"] | undefined,
	listSeoDefaultLocale: Array<ModelTypes["SeoDefaultLocale"]>,
	paginateSeoDefaultLocale: ModelTypes["SeoDefaultLocaleConnection"],
	validateCreateSeoDefaultLocale: ModelTypes["_ValidationResult"],
	validateUpdateSeoDefaultLocale: ModelTypes["_ValidationResult"],
	getBusiness?: ModelTypes["Business"] | undefined,
	listBusiness: Array<ModelTypes["Business"]>,
	paginateBusiness: ModelTypes["BusinessConnection"],
	validateCreateBusiness: ModelTypes["_ValidationResult"],
	validateUpdateBusiness: ModelTypes["_ValidationResult"],
	getBusinessPage?: ModelTypes["BusinessPage"] | undefined,
	listBusinessPage: Array<ModelTypes["BusinessPage"]>,
	paginateBusinessPage: ModelTypes["BusinessPageConnection"],
	validateCreateBusinessPage: ModelTypes["_ValidationResult"],
	validateUpdateBusinessPage: ModelTypes["_ValidationResult"],
	getBusinessPageLocale?: ModelTypes["BusinessPageLocale"] | undefined,
	listBusinessPageLocale: Array<ModelTypes["BusinessPageLocale"]>,
	paginateBusinessPageLocale: ModelTypes["BusinessPageLocaleConnection"],
	validateCreateBusinessPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateBusinessPageLocale: ModelTypes["_ValidationResult"],
	getIcon?: ModelTypes["Icon"] | undefined,
	listIcon: Array<ModelTypes["Icon"]>,
	paginateIcon: ModelTypes["IconConnection"],
	validateCreateIcon: ModelTypes["_ValidationResult"],
	validateUpdateIcon: ModelTypes["_ValidationResult"],
	getJobPage?: ModelTypes["JobPage"] | undefined,
	listJobPage: Array<ModelTypes["JobPage"]>,
	paginateJobPage: ModelTypes["JobPageConnection"],
	validateCreateJobPage: ModelTypes["_ValidationResult"],
	validateUpdateJobPage: ModelTypes["_ValidationResult"],
	getJobPageLocale?: ModelTypes["JobPageLocale"] | undefined,
	listJobPageLocale: Array<ModelTypes["JobPageLocale"]>,
	paginateJobPageLocale: ModelTypes["JobPageLocaleConnection"],
	validateCreateJobPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateJobPageLocale: ModelTypes["_ValidationResult"],
	getKeyInfoItem?: ModelTypes["KeyInfoItem"] | undefined,
	listKeyInfoItem: Array<ModelTypes["KeyInfoItem"]>,
	paginateKeyInfoItem: ModelTypes["KeyInfoItemConnection"],
	validateCreateKeyInfoItem: ModelTypes["_ValidationResult"],
	validateUpdateKeyInfoItem: ModelTypes["_ValidationResult"],
	getKeyInfoList?: ModelTypes["KeyInfoList"] | undefined,
	listKeyInfoList: Array<ModelTypes["KeyInfoList"]>,
	paginateKeyInfoList: ModelTypes["KeyInfoListConnection"],
	validateCreateKeyInfoList: ModelTypes["_ValidationResult"],
	validateUpdateKeyInfoList: ModelTypes["_ValidationResult"],
	getContractType?: ModelTypes["ContractType"] | undefined,
	listContractType: Array<ModelTypes["ContractType"]>,
	paginateContractType: ModelTypes["ContractTypeConnection"],
	validateCreateContractType: ModelTypes["_ValidationResult"],
	validateUpdateContractType: ModelTypes["_ValidationResult"],
	getContractTypeLocale?: ModelTypes["ContractTypeLocale"] | undefined,
	listContractTypeLocale: Array<ModelTypes["ContractTypeLocale"]>,
	paginateContractTypeLocale: ModelTypes["ContractTypeLocaleConnection"],
	validateCreateContractTypeLocale: ModelTypes["_ValidationResult"],
	validateUpdateContractTypeLocale: ModelTypes["_ValidationResult"],
	getJobCity?: ModelTypes["JobCity"] | undefined,
	listJobCity: Array<ModelTypes["JobCity"]>,
	paginateJobCity: ModelTypes["JobCityConnection"],
	validateCreateJobCity: ModelTypes["_ValidationResult"],
	validateUpdateJobCity: ModelTypes["_ValidationResult"],
	getJobCityLocale?: ModelTypes["JobCityLocale"] | undefined,
	listJobCityLocale: Array<ModelTypes["JobCityLocale"]>,
	paginateJobCityLocale: ModelTypes["JobCityLocaleConnection"],
	validateCreateJobCityLocale: ModelTypes["_ValidationResult"],
	validateUpdateJobCityLocale: ModelTypes["_ValidationResult"],
	getJobPosition?: ModelTypes["JobPosition"] | undefined,
	listJobPosition: Array<ModelTypes["JobPosition"]>,
	paginateJobPosition: ModelTypes["JobPositionConnection"],
	validateCreateJobPosition: ModelTypes["_ValidationResult"],
	validateUpdateJobPosition: ModelTypes["_ValidationResult"],
	getJobPositionLocale?: ModelTypes["JobPositionLocale"] | undefined,
	listJobPositionLocale: Array<ModelTypes["JobPositionLocale"]>,
	paginateJobPositionLocale: ModelTypes["JobPositionLocaleConnection"],
	validateCreateJobPositionLocale: ModelTypes["_ValidationResult"],
	validateUpdateJobPositionLocale: ModelTypes["_ValidationResult"],
	getGallery?: ModelTypes["Gallery"] | undefined,
	listGallery: Array<ModelTypes["Gallery"]>,
	paginateGallery: ModelTypes["GalleryConnection"],
	validateCreateGallery: ModelTypes["_ValidationResult"],
	validateUpdateGallery: ModelTypes["_ValidationResult"],
	getHomePage?: ModelTypes["HomePage"] | undefined,
	listHomePage: Array<ModelTypes["HomePage"]>,
	paginateHomePage: ModelTypes["HomePageConnection"],
	validateCreateHomePage: ModelTypes["_ValidationResult"],
	validateUpdateHomePage: ModelTypes["_ValidationResult"],
	getHomePageLocale?: ModelTypes["HomePageLocale"] | undefined,
	listHomePageLocale: Array<ModelTypes["HomePageLocale"]>,
	paginateHomePageLocale: ModelTypes["HomePageLocaleConnection"],
	validateCreateHomePageLocale: ModelTypes["_ValidationResult"],
	validateUpdateHomePageLocale: ModelTypes["_ValidationResult"],
	getMedium?: ModelTypes["Medium"] | undefined,
	listMedium: Array<ModelTypes["Medium"]>,
	paginateMedium: ModelTypes["MediumConnection"],
	validateCreateMedium: ModelTypes["_ValidationResult"],
	validateUpdateMedium: ModelTypes["_ValidationResult"],
	getMediumItem?: ModelTypes["MediumItem"] | undefined,
	listMediumItem: Array<ModelTypes["MediumItem"]>,
	paginateMediumItem: ModelTypes["MediumItemConnection"],
	validateCreateMediumItem: ModelTypes["_ValidationResult"],
	validateUpdateMediumItem: ModelTypes["_ValidationResult"],
	getMediumList?: ModelTypes["MediumList"] | undefined,
	listMediumList: Array<ModelTypes["MediumList"]>,
	paginateMediumList: ModelTypes["MediumListConnection"],
	validateCreateMediumList: ModelTypes["_ValidationResult"],
	validateUpdateMediumList: ModelTypes["_ValidationResult"],
	getVideo?: ModelTypes["Video"] | undefined,
	listVideo: Array<ModelTypes["Video"]>,
	paginateVideo: ModelTypes["VideoConnection"],
	validateCreateVideo: ModelTypes["_ValidationResult"],
	validateUpdateVideo: ModelTypes["_ValidationResult"],
	getTextItem?: ModelTypes["TextItem"] | undefined,
	listTextItem: Array<ModelTypes["TextItem"]>,
	paginateTextItem: ModelTypes["TextItemConnection"],
	validateCreateTextItem: ModelTypes["_ValidationResult"],
	validateUpdateTextItem: ModelTypes["_ValidationResult"],
	getTextList?: ModelTypes["TextList"] | undefined,
	listTextList: Array<ModelTypes["TextList"]>,
	paginateTextList: ModelTypes["TextListConnection"],
	validateCreateTextList: ModelTypes["_ValidationResult"],
	validateUpdateTextList: ModelTypes["_ValidationResult"],
	getCarousel?: ModelTypes["Carousel"] | undefined,
	listCarousel: Array<ModelTypes["Carousel"]>,
	paginateCarousel: ModelTypes["CarouselConnection"],
	validateCreateCarousel: ModelTypes["_ValidationResult"],
	validateUpdateCarousel: ModelTypes["_ValidationResult"],
	getCarouselItem?: ModelTypes["CarouselItem"] | undefined,
	listCarouselItem: Array<ModelTypes["CarouselItem"]>,
	paginateCarouselItem: ModelTypes["CarouselItemConnection"],
	validateCreateCarouselItem: ModelTypes["_ValidationResult"],
	validateUpdateCarouselItem: ModelTypes["_ValidationResult"],
	getTheme?: ModelTypes["Theme"] | undefined,
	listTheme: Array<ModelTypes["Theme"]>,
	paginateTheme: ModelTypes["ThemeConnection"],
	validateCreateTheme: ModelTypes["_ValidationResult"],
	validateUpdateTheme: ModelTypes["_ValidationResult"],
	getBonusBanner?: ModelTypes["BonusBanner"] | undefined,
	listBonusBanner: Array<ModelTypes["BonusBanner"]>,
	paginateBonusBanner: ModelTypes["BonusBannerConnection"],
	validateCreateBonusBanner: ModelTypes["_ValidationResult"],
	validateUpdateBonusBanner: ModelTypes["_ValidationResult"],
	getBonusBannerLocale?: ModelTypes["BonusBannerLocale"] | undefined,
	listBonusBannerLocale: Array<ModelTypes["BonusBannerLocale"]>,
	paginateBonusBannerLocale: ModelTypes["BonusBannerLocaleConnection"],
	validateCreateBonusBannerLocale: ModelTypes["_ValidationResult"],
	validateUpdateBonusBannerLocale: ModelTypes["_ValidationResult"],
	getTile?: ModelTypes["Tile"] | undefined,
	listTile: Array<ModelTypes["Tile"]>,
	paginateTile: ModelTypes["TileConnection"],
	validateCreateTile: ModelTypes["_ValidationResult"],
	validateUpdateTile: ModelTypes["_ValidationResult"],
	getSideBySide?: ModelTypes["SideBySide"] | undefined,
	listSideBySide: Array<ModelTypes["SideBySide"]>,
	paginateSideBySide: ModelTypes["SideBySideConnection"],
	validateCreateSideBySide: ModelTypes["_ValidationResult"],
	validateUpdateSideBySide: ModelTypes["_ValidationResult"],
	getSideBySideItem?: ModelTypes["SideBySideItem"] | undefined,
	listSideBySideItem: Array<ModelTypes["SideBySideItem"]>,
	paginateSideBySideItem: ModelTypes["SideBySideItemConnection"],
	validateCreateSideBySideItem: ModelTypes["_ValidationResult"],
	validateUpdateSideBySideItem: ModelTypes["_ValidationResult"],
	getHomePageLokal?: ModelTypes["HomePageLokal"] | undefined,
	listHomePageLokal: Array<ModelTypes["HomePageLokal"]>,
	paginateHomePageLokal: ModelTypes["HomePageLokalConnection"],
	validateCreateHomePageLokal: ModelTypes["_ValidationResult"],
	validateUpdateHomePageLokal: ModelTypes["_ValidationResult"],
	getHomePageLokalLocale?: ModelTypes["HomePageLokalLocale"] | undefined,
	listHomePageLokalLocale: Array<ModelTypes["HomePageLokalLocale"]>,
	paginateHomePageLokalLocale: ModelTypes["HomePageLokalLocaleConnection"],
	validateCreateHomePageLokalLocale: ModelTypes["_ValidationResult"],
	validateUpdateHomePageLokalLocale: ModelTypes["_ValidationResult"],
	getSiteSwitcher?: ModelTypes["SiteSwitcher"] | undefined,
	listSiteSwitcher: Array<ModelTypes["SiteSwitcher"]>,
	paginateSiteSwitcher: ModelTypes["SiteSwitcherConnection"],
	validateCreateSiteSwitcher: ModelTypes["_ValidationResult"],
	validateUpdateSiteSwitcher: ModelTypes["_ValidationResult"],
	getGalleryItem?: ModelTypes["GalleryItem"] | undefined,
	listGalleryItem: Array<ModelTypes["GalleryItem"]>,
	paginateGalleryItem: ModelTypes["GalleryItemConnection"],
	validateCreateGalleryItem: ModelTypes["_ValidationResult"],
	validateUpdateGalleryItem: ModelTypes["_ValidationResult"],
	getJobsForm?: ModelTypes["JobsForm"] | undefined,
	listJobsForm: Array<ModelTypes["JobsForm"]>,
	paginateJobsForm: ModelTypes["JobsFormConnection"],
	validateCreateJobsForm: ModelTypes["_ValidationResult"],
	validateUpdateJobsForm: ModelTypes["_ValidationResult"],
	getJobsFormLocale?: ModelTypes["JobsFormLocale"] | undefined,
	listJobsFormLocale: Array<ModelTypes["JobsFormLocale"]>,
	paginateJobsFormLocale: ModelTypes["JobsFormLocaleConnection"],
	validateCreateJobsFormLocale: ModelTypes["_ValidationResult"],
	validateUpdateJobsFormLocale: ModelTypes["_ValidationResult"],
	getImageTextItem?: ModelTypes["ImageTextItem"] | undefined,
	listImageTextItem: Array<ModelTypes["ImageTextItem"]>,
	paginateImageTextItem: ModelTypes["ImageTextItemConnection"],
	validateCreateImageTextItem: ModelTypes["_ValidationResult"],
	validateUpdateImageTextItem: ModelTypes["_ValidationResult"],
	getImageTextList?: ModelTypes["ImageTextList"] | undefined,
	listImageTextList: Array<ModelTypes["ImageTextList"]>,
	paginateImageTextList: ModelTypes["ImageTextListConnection"],
	validateCreateImageTextList: ModelTypes["_ValidationResult"],
	validateUpdateImageTextList: ModelTypes["_ValidationResult"],
	getJobsFilter?: ModelTypes["JobsFilter"] | undefined,
	listJobsFilter: Array<ModelTypes["JobsFilter"]>,
	paginateJobsFilter: ModelTypes["JobsFilterConnection"],
	validateCreateJobsFilter: ModelTypes["_ValidationResult"],
	validateUpdateJobsFilter: ModelTypes["_ValidationResult"],
	getJobsFilterLocale?: ModelTypes["JobsFilterLocale"] | undefined,
	listJobsFilterLocale: Array<ModelTypes["JobsFilterLocale"]>,
	paginateJobsFilterLocale: ModelTypes["JobsFilterLocaleConnection"],
	validateCreateJobsFilterLocale: ModelTypes["_ValidationResult"],
	validateUpdateJobsFilterLocale: ModelTypes["_ValidationResult"],
	getFile?: ModelTypes["File"] | undefined,
	listFile: Array<ModelTypes["File"]>,
	paginateFile: ModelTypes["FileConnection"],
	validateCreateFile: ModelTypes["_ValidationResult"],
	validateUpdateFile: ModelTypes["_ValidationResult"],
	getJobFormSubscription?: ModelTypes["JobFormSubscription"] | undefined,
	listJobFormSubscription: Array<ModelTypes["JobFormSubscription"]>,
	paginateJobFormSubscription: ModelTypes["JobFormSubscriptionConnection"],
	validateCreateJobFormSubscription: ModelTypes["_ValidationResult"],
	validateUpdateJobFormSubscription: ModelTypes["_ValidationResult"],
	getImageList?: ModelTypes["ImageList"] | undefined,
	listImageList: Array<ModelTypes["ImageList"]>,
	paginateImageList: ModelTypes["ImageListConnection"],
	validateCreateImageList: ModelTypes["_ValidationResult"],
	validateUpdateImageList: ModelTypes["_ValidationResult"],
	getImageListItem?: ModelTypes["ImageListItem"] | undefined,
	listImageListItem: Array<ModelTypes["ImageListItem"]>,
	paginateImageListItem: ModelTypes["ImageListItemConnection"],
	validateCreateImageListItem: ModelTypes["_ValidationResult"],
	validateUpdateImageListItem: ModelTypes["_ValidationResult"],
	getJobFormSubscriptionStatus?: ModelTypes["JobFormSubscriptionStatus"] | undefined,
	listJobFormSubscriptionStatus: Array<ModelTypes["JobFormSubscriptionStatus"]>,
	paginateJobFormSubscriptionStatus: ModelTypes["JobFormSubscriptionStatusConnection"],
	validateCreateJobFormSubscriptionStatus: ModelTypes["_ValidationResult"],
	validateUpdateJobFormSubscriptionStatus: ModelTypes["_ValidationResult"],
	getGeneralLocale?: ModelTypes["GeneralLocale"] | undefined,
	listGeneralLocale: Array<ModelTypes["GeneralLocale"]>,
	paginateGeneralLocale: ModelTypes["GeneralLocaleConnection"],
	validateCreateGeneralLocale: ModelTypes["_ValidationResult"],
	validateUpdateGeneralLocale: ModelTypes["_ValidationResult"],
	getStickyBar?: ModelTypes["StickyBar"] | undefined,
	listStickyBar: Array<ModelTypes["StickyBar"]>,
	paginateStickyBar: ModelTypes["StickyBarConnection"],
	validateCreateStickyBar: ModelTypes["_ValidationResult"],
	validateUpdateStickyBar: ModelTypes["_ValidationResult"],
	getRecommendationForm?: ModelTypes["RecommendationForm"] | undefined,
	listRecommendationForm: Array<ModelTypes["RecommendationForm"]>,
	paginateRecommendationForm: ModelTypes["RecommendationFormConnection"],
	validateCreateRecommendationForm: ModelTypes["_ValidationResult"],
	validateUpdateRecommendationForm: ModelTypes["_ValidationResult"],
	getRecommendationFormLocale?: ModelTypes["RecommendationFormLocale"] | undefined,
	listRecommendationFormLocale: Array<ModelTypes["RecommendationFormLocale"]>,
	paginateRecommendationFormLocale: ModelTypes["RecommendationFormLocaleConnection"],
	validateCreateRecommendationFormLocale: ModelTypes["_ValidationResult"],
	validateUpdateRecommendationFormLocale: ModelTypes["_ValidationResult"],
	getRecommendationFormSubscription?: ModelTypes["RecommendationFormSubscription"] | undefined,
	listRecommendationFormSubscription: Array<ModelTypes["RecommendationFormSubscription"]>,
	paginateRecommendationFormSubscription: ModelTypes["RecommendationFormSubscriptionConnection"],
	validateCreateRecommendationFormSubscription: ModelTypes["_ValidationResult"],
	validateUpdateRecommendationFormSubscription: ModelTypes["_ValidationResult"],
	getInfoBox?: ModelTypes["InfoBox"] | undefined,
	listInfoBox: Array<ModelTypes["InfoBox"]>,
	paginateInfoBox: ModelTypes["InfoBoxConnection"],
	validateCreateInfoBox: ModelTypes["_ValidationResult"],
	validateUpdateInfoBox: ModelTypes["_ValidationResult"],
	getInfoBoxLocale?: ModelTypes["InfoBoxLocale"] | undefined,
	listInfoBoxLocale: Array<ModelTypes["InfoBoxLocale"]>,
	paginateInfoBoxLocale: ModelTypes["InfoBoxLocaleConnection"],
	validateCreateInfoBoxLocale: ModelTypes["_ValidationResult"],
	validateUpdateInfoBoxLocale: ModelTypes["_ValidationResult"],
	getTranslation?: ModelTypes["Translation"] | undefined,
	listTranslation: Array<ModelTypes["Translation"]>,
	paginateTranslation: ModelTypes["TranslationConnection"],
	validateCreateTranslation: ModelTypes["_ValidationResult"],
	validateUpdateTranslation: ModelTypes["_ValidationResult"],
	getTranslationLocale?: ModelTypes["TranslationLocale"] | undefined,
	listTranslationLocale: Array<ModelTypes["TranslationLocale"]>,
	paginateTranslationLocale: ModelTypes["TranslationLocaleConnection"],
	validateCreateTranslationLocale: ModelTypes["_ValidationResult"],
	validateUpdateTranslationLocale: ModelTypes["_ValidationResult"],
	getCornerBanner?: ModelTypes["CornerBanner"] | undefined,
	listCornerBanner: Array<ModelTypes["CornerBanner"]>,
	paginateCornerBanner: ModelTypes["CornerBannerConnection"],
	validateCreateCornerBanner: ModelTypes["_ValidationResult"],
	validateUpdateCornerBanner: ModelTypes["_ValidationResult"],
	transaction?: ModelTypes["QueryTransaction"] | undefined,
	_info?: ModelTypes["Info"] | undefined
};
	["_Schema"]: {
		enums: Array<ModelTypes["_Enum"]>,
	entities: Array<ModelTypes["_Entity"]>
};
	["_Enum"]: {
		name: string,
	values: Array<string>
};
	["_Entity"]: {
		name: string,
	customPrimaryAllowed: boolean,
	fields: Array<ModelTypes["_Field"]>,
	unique: Array<ModelTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
		fields: Array<string>
};
	["General"]: {
		_meta?: ModelTypes["GeneralMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["GeneralLocale"]>,
	localesByLocale?: ModelTypes["GeneralLocale"] | undefined,
	localesBySeo?: ModelTypes["GeneralLocale"] | undefined,
	localesByCornerBanner?: ModelTypes["GeneralLocale"] | undefined,
	paginateLocales: ModelTypes["GeneralLocaleConnection"]
};
	["GeneralMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["FieldMeta"]: {
		readable?: boolean | undefined,
	updatable?: boolean | undefined
};
	["UUID"]:any;
	["One"]:One;
	["GeneralLocale"]: {
		_meta?: ModelTypes["GeneralLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["General"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	cornerBanner?: ModelTypes["CornerBanner"] | undefined
};
	["GeneralLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	cornerBanner?: ModelTypes["FieldMeta"] | undefined
};
	["GeneralWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["GeneralLocaleWhere"] | undefined,
	and?: Array<ModelTypes["GeneralWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GeneralWhere"] | undefined> | undefined,
	not?: ModelTypes["GeneralWhere"] | undefined
};
	["UUIDCondition"]: {
	and?: Array<ModelTypes["UUIDCondition"]> | undefined,
	or?: Array<ModelTypes["UUIDCondition"]> | undefined,
	not?: ModelTypes["UUIDCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["UUID"] | undefined,
	notEq?: ModelTypes["UUID"] | undefined,
	in?: Array<ModelTypes["UUID"]> | undefined,
	notIn?: Array<ModelTypes["UUID"]> | undefined,
	lt?: ModelTypes["UUID"] | undefined,
	lte?: ModelTypes["UUID"] | undefined,
	gt?: ModelTypes["UUID"] | undefined,
	gte?: ModelTypes["UUID"] | undefined
};
	["OneCondition"]: {
	and?: Array<ModelTypes["OneCondition"]> | undefined,
	or?: Array<ModelTypes["OneCondition"]> | undefined,
	not?: ModelTypes["OneCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["One"] | undefined,
	notEq?: ModelTypes["One"] | undefined,
	in?: Array<ModelTypes["One"]> | undefined,
	notIn?: Array<ModelTypes["One"]> | undefined,
	lt?: ModelTypes["One"] | undefined,
	lte?: ModelTypes["One"] | undefined,
	gt?: ModelTypes["One"] | undefined,
	gte?: ModelTypes["One"] | undefined
};
	["GeneralLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["GeneralWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	cornerBanner?: ModelTypes["CornerBannerWhere"] | undefined,
	and?: Array<ModelTypes["GeneralLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GeneralLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["GeneralLocaleWhere"] | undefined
};
	["LocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	code?: ModelTypes["StringCondition"] | undefined,
	label?: ModelTypes["StringCondition"] | undefined,
	footers?: ModelTypes["FooterLocaleWhere"] | undefined,
	genericPages?: ModelTypes["GenericPageLocaleWhere"] | undefined,
	headers?: ModelTypes["HeaderLocaleWhere"] | undefined,
	seoDefaults?: ModelTypes["SeoDefaultLocaleWhere"] | undefined,
	businessPages?: ModelTypes["BusinessPageLocaleWhere"] | undefined,
	jobPages?: ModelTypes["JobPageLocaleWhere"] | undefined,
	contractTypes?: ModelTypes["ContractTypeLocaleWhere"] | undefined,
	jobCities?: ModelTypes["JobCityLocaleWhere"] | undefined,
	jobPositions?: ModelTypes["JobPositionLocaleWhere"] | undefined,
	homePages?: ModelTypes["HomePageLocaleWhere"] | undefined,
	bonusBanners?: ModelTypes["BonusBannerLocaleWhere"] | undefined,
	homePageLokals?: ModelTypes["HomePageLokalLocaleWhere"] | undefined,
	jobsForms?: ModelTypes["JobsFormLocaleWhere"] | undefined,
	jobsFilters?: ModelTypes["JobsFilterLocaleWhere"] | undefined,
	general?: ModelTypes["GeneralLocaleWhere"] | undefined,
	recommendationForms?: ModelTypes["RecommendationFormLocaleWhere"] | undefined,
	infoBoxes?: ModelTypes["InfoBoxLocaleWhere"] | undefined,
	translations?: ModelTypes["TranslationLocaleWhere"] | undefined,
	and?: Array<ModelTypes["LocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["LocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["LocaleWhere"] | undefined
};
	["StringCondition"]: {
	and?: Array<ModelTypes["StringCondition"]> | undefined,
	or?: Array<ModelTypes["StringCondition"]> | undefined,
	not?: ModelTypes["StringCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: string | undefined,
	notEq?: string | undefined,
	in?: Array<string> | undefined,
	notIn?: Array<string> | undefined,
	lt?: string | undefined,
	lte?: string | undefined,
	gt?: string | undefined,
	gte?: string | undefined,
	contains?: string | undefined,
	startsWith?: string | undefined,
	endsWith?: string | undefined,
	containsCI?: string | undefined,
	startsWithCI?: string | undefined,
	endsWithCI?: string | undefined
};
	["FooterLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	email?: ModelTypes["StringCondition"] | undefined,
	address?: ModelTypes["StringCondition"] | undefined,
	ico?: ModelTypes["StringCondition"] | undefined,
	dic?: ModelTypes["StringCondition"] | undefined,
	copyright?: ModelTypes["StringCondition"] | undefined,
	note?: ModelTypes["StringCondition"] | undefined,
	noteSecond?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["FooterWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	linksFirstColumn?: ModelTypes["FooterLinkWhere"] | undefined,
	linksSecondColumn?: ModelTypes["FooterLinkWhere"] | undefined,
	termsAndConditions?: ModelTypes["LinkWhere"] | undefined,
	form?: ModelTypes["StringCondition"] | undefined,
	bannerTitle?: ModelTypes["StringCondition"] | undefined,
	bannerSubtitle?: ModelTypes["StringCondition"] | undefined,
	bannerImage?: ModelTypes["ImageWhere"] | undefined,
	bannerLink?: ModelTypes["LinkWhere"] | undefined,
	jobsForm?: ModelTypes["JobsFormLocaleWhere"] | undefined,
	copyrightLink?: ModelTypes["LinkWhere"] | undefined,
	bannerSecondBtn?: ModelTypes["StringCondition"] | undefined,
	recommendationForm?: ModelTypes["RecommendationFormLocaleWhere"] | undefined,
	bannerSecondLink?: ModelTypes["LinkWhere"] | undefined,
	instagramLink?: ModelTypes["LinkWhere"] | undefined,
	and?: Array<ModelTypes["FooterLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FooterLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["FooterLocaleWhere"] | undefined
};
	["FooterWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["FooterLocaleWhere"] | undefined,
	and?: Array<ModelTypes["FooterWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FooterWhere"] | undefined> | undefined,
	not?: ModelTypes["FooterWhere"] | undefined
};
	["FooterLinkWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	and?: Array<ModelTypes["FooterLinkWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FooterLinkWhere"] | undefined> | undefined,
	not?: ModelTypes["FooterLinkWhere"] | undefined
};
	["IntCondition"]: {
	and?: Array<ModelTypes["IntCondition"]> | undefined,
	or?: Array<ModelTypes["IntCondition"]> | undefined,
	not?: ModelTypes["IntCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: number | undefined,
	notEq?: number | undefined,
	in?: Array<number> | undefined,
	notIn?: Array<number> | undefined,
	lt?: number | undefined,
	lte?: number | undefined,
	gt?: number | undefined,
	gte?: number | undefined
};
	["LinkWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["LinkTypeCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	externalLink?: ModelTypes["StringCondition"] | undefined,
	internalLink?: ModelTypes["LinkableWhere"] | undefined,
	anchorLink?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["LinkWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["LinkWhere"] | undefined> | undefined,
	not?: ModelTypes["LinkWhere"] | undefined
};
	["LinkTypeCondition"]: {
	and?: Array<ModelTypes["LinkTypeCondition"]> | undefined,
	or?: Array<ModelTypes["LinkTypeCondition"]> | undefined,
	not?: ModelTypes["LinkTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["LinkType"] | undefined,
	notEq?: ModelTypes["LinkType"] | undefined,
	in?: Array<ModelTypes["LinkType"]> | undefined,
	notIn?: Array<ModelTypes["LinkType"]> | undefined,
	lt?: ModelTypes["LinkType"] | undefined,
	lte?: ModelTypes["LinkType"] | undefined,
	gt?: ModelTypes["LinkType"] | undefined,
	gte?: ModelTypes["LinkType"] | undefined
};
	["LinkType"]:LinkType;
	["LinkableWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	url?: ModelTypes["StringCondition"] | undefined,
	redirect?: ModelTypes["RedirectWhere"] | undefined,
	genericPage?: ModelTypes["GenericPageLocaleWhere"] | undefined,
	businessPage?: ModelTypes["BusinessPageLocaleWhere"] | undefined,
	jobPage?: ModelTypes["JobPageLocaleWhere"] | undefined,
	homePage?: ModelTypes["HomePageLocaleWhere"] | undefined,
	homePageLokal?: ModelTypes["HomePageLokalLocaleWhere"] | undefined,
	and?: Array<ModelTypes["LinkableWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["LinkableWhere"] | undefined> | undefined,
	not?: ModelTypes["LinkableWhere"] | undefined
};
	["RedirectWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	target?: ModelTypes["LinkWhere"] | undefined,
	and?: Array<ModelTypes["RedirectWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["RedirectWhere"] | undefined> | undefined,
	not?: ModelTypes["RedirectWhere"] | undefined
};
	["GenericPageLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["GenericPageWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["GenericPageLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GenericPageLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["GenericPageLocaleWhere"] | undefined
};
	["GenericPageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	locales?: ModelTypes["GenericPageLocaleWhere"] | undefined,
	theme?: ModelTypes["ThemeWhere"] | undefined,
	headerColor?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["GenericPageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GenericPageWhere"] | undefined> | undefined,
	not?: ModelTypes["GenericPageWhere"] | undefined
};
	["ThemeWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	backgroundColor?: ModelTypes["StringCondition"] | undefined,
	textColor?: ModelTypes["StringCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	buttonBackgroundColor?: ModelTypes["StringCondition"] | undefined,
	buttonTextColor?: ModelTypes["StringCondition"] | undefined,
	buttonBackgroundHoverColor?: ModelTypes["StringCondition"] | undefined,
	buttonTextHoverColor?: ModelTypes["StringCondition"] | undefined,
	buttonBorderColor?: ModelTypes["StringCondition"] | undefined,
	buttonBorderHoverColor?: ModelTypes["StringCondition"] | undefined,
	headerMenuColor?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["ThemeWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ThemeWhere"] | undefined> | undefined,
	not?: ModelTypes["ThemeWhere"] | undefined
};
	["ContentWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	blocks?: ModelTypes["ContentBlockWhere"] | undefined,
	and?: Array<ModelTypes["ContentWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ContentWhere"] | undefined> | undefined,
	not?: ModelTypes["ContentWhere"] | undefined
};
	["ContentBlockWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	json?: ModelTypes["StringCondition"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	references?: ModelTypes["ContentReferenceWhere"] | undefined,
	and?: Array<ModelTypes["ContentBlockWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ContentBlockWhere"] | undefined> | undefined,
	not?: ModelTypes["ContentBlockWhere"] | undefined
};
	["ContentReferenceWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["ContentReferenceTypeCondition"] | undefined,
	primaryText?: ModelTypes["StringCondition"] | undefined,
	block?: ModelTypes["ContentBlockWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	linkables?: ModelTypes["ContentReferenceLinkableItemWhere"] | undefined,
	secondaryText?: ModelTypes["StringCondition"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	media?: ModelTypes["MediumListWhere"] | undefined,
	textList?: ModelTypes["TextListWhere"] | undefined,
	carousel?: ModelTypes["CarouselWhere"] | undefined,
	bonusBanner?: ModelTypes["BonusBannerLocaleWhere"] | undefined,
	sideBySide?: ModelTypes["SideBySideWhere"] | undefined,
	gallery?: ModelTypes["GalleryWhere"] | undefined,
	showBoolean?: ModelTypes["BooleanCondition"] | undefined,
	isRed?: ModelTypes["BooleanCondition"] | undefined,
	video?: ModelTypes["VideoWhere"] | undefined,
	and?: Array<ModelTypes["ContentReferenceWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ContentReferenceWhere"] | undefined> | undefined,
	not?: ModelTypes["ContentReferenceWhere"] | undefined
};
	["ContentReferenceTypeCondition"]: {
	and?: Array<ModelTypes["ContentReferenceTypeCondition"]> | undefined,
	or?: Array<ModelTypes["ContentReferenceTypeCondition"]> | undefined,
	not?: ModelTypes["ContentReferenceTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["ContentReferenceType"] | undefined,
	notEq?: ModelTypes["ContentReferenceType"] | undefined,
	in?: Array<ModelTypes["ContentReferenceType"]> | undefined,
	notIn?: Array<ModelTypes["ContentReferenceType"]> | undefined,
	lt?: ModelTypes["ContentReferenceType"] | undefined,
	lte?: ModelTypes["ContentReferenceType"] | undefined,
	gt?: ModelTypes["ContentReferenceType"] | undefined,
	gte?: ModelTypes["ContentReferenceType"] | undefined
};
	["ContentReferenceType"]:ContentReferenceType;
	["ImageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	url?: ModelTypes["StringCondition"] | undefined,
	width?: ModelTypes["IntCondition"] | undefined,
	height?: ModelTypes["IntCondition"] | undefined,
	size?: ModelTypes["IntCondition"] | undefined,
	type?: ModelTypes["StringCondition"] | undefined,
	alt?: ModelTypes["StringCondition"] | undefined,
	fileName?: ModelTypes["StringCondition"] | undefined,
	focalPointX?: ModelTypes["FloatCondition"] | undefined,
	focalPointY?: ModelTypes["FloatCondition"] | undefined,
	and?: Array<ModelTypes["ImageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ImageWhere"] | undefined> | undefined,
	not?: ModelTypes["ImageWhere"] | undefined
};
	["FloatCondition"]: {
	and?: Array<ModelTypes["FloatCondition"]> | undefined,
	or?: Array<ModelTypes["FloatCondition"]> | undefined,
	not?: ModelTypes["FloatCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: number | undefined,
	notEq?: number | undefined,
	in?: Array<number> | undefined,
	notIn?: Array<number> | undefined,
	lt?: number | undefined,
	lte?: number | undefined,
	gt?: number | undefined,
	gte?: number | undefined
};
	["ContentReferenceLinkableItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	item?: ModelTypes["LinkableWhere"] | undefined,
	reference?: ModelTypes["ContentReferenceWhere"] | undefined,
	and?: Array<ModelTypes["ContentReferenceLinkableItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ContentReferenceLinkableItemWhere"] | undefined> | undefined,
	not?: ModelTypes["ContentReferenceLinkableItemWhere"] | undefined
};
	["MediumListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["MediumItemWhere"] | undefined,
	and?: Array<ModelTypes["MediumListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["MediumListWhere"] | undefined> | undefined,
	not?: ModelTypes["MediumListWhere"] | undefined
};
	["MediumItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["MediumListWhere"] | undefined,
	medium?: ModelTypes["MediumWhere"] | undefined,
	and?: Array<ModelTypes["MediumItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["MediumItemWhere"] | undefined> | undefined,
	not?: ModelTypes["MediumItemWhere"] | undefined
};
	["MediumWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["MediumTypeCondition"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	video?: ModelTypes["VideoWhere"] | undefined,
	and?: Array<ModelTypes["MediumWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["MediumWhere"] | undefined> | undefined,
	not?: ModelTypes["MediumWhere"] | undefined
};
	["MediumTypeCondition"]: {
	and?: Array<ModelTypes["MediumTypeCondition"]> | undefined,
	or?: Array<ModelTypes["MediumTypeCondition"]> | undefined,
	not?: ModelTypes["MediumTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["MediumType"] | undefined,
	notEq?: ModelTypes["MediumType"] | undefined,
	in?: Array<ModelTypes["MediumType"]> | undefined,
	notIn?: Array<ModelTypes["MediumType"]> | undefined,
	lt?: ModelTypes["MediumType"] | undefined,
	lte?: ModelTypes["MediumType"] | undefined,
	gt?: ModelTypes["MediumType"] | undefined,
	gte?: ModelTypes["MediumType"] | undefined
};
	["MediumType"]:MediumType;
	["VideoWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	src?: ModelTypes["StringCondition"] | undefined,
	width?: ModelTypes["IntCondition"] | undefined,
	height?: ModelTypes["IntCondition"] | undefined,
	size?: ModelTypes["IntCondition"] | undefined,
	type?: ModelTypes["StringCondition"] | undefined,
	videoInfo?: ModelTypes["StringCondition"] | undefined,
	duration?: ModelTypes["FloatCondition"] | undefined,
	poster?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["VideoWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["VideoWhere"] | undefined> | undefined,
	not?: ModelTypes["VideoWhere"] | undefined
};
	["TextListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["TextItemWhere"] | undefined,
	and?: Array<ModelTypes["TextListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TextListWhere"] | undefined> | undefined,
	not?: ModelTypes["TextListWhere"] | undefined
};
	["TextItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	list?: ModelTypes["TextListWhere"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["TextItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TextItemWhere"] | undefined> | undefined,
	not?: ModelTypes["TextItemWhere"] | undefined
};
	["CarouselWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["CarouselItemWhere"] | undefined,
	background?: ModelTypes["BackgroundCondition"] | undefined,
	squareImages?: ModelTypes["BooleanCondition"] | undefined,
	and?: Array<ModelTypes["CarouselWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["CarouselWhere"] | undefined> | undefined,
	not?: ModelTypes["CarouselWhere"] | undefined
};
	["CarouselItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	list?: ModelTypes["CarouselWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	linkUrl?: ModelTypes["LinkWhere"] | undefined,
	normalAspectRatio?: ModelTypes["BooleanCondition"] | undefined,
	isImage?: ModelTypes["BooleanCondition"] | undefined,
	video?: ModelTypes["VideoWhere"] | undefined,
	and?: Array<ModelTypes["CarouselItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["CarouselItemWhere"] | undefined> | undefined,
	not?: ModelTypes["CarouselItemWhere"] | undefined
};
	["BooleanCondition"]: {
	and?: Array<ModelTypes["BooleanCondition"]> | undefined,
	or?: Array<ModelTypes["BooleanCondition"]> | undefined,
	not?: ModelTypes["BooleanCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: boolean | undefined,
	notEq?: boolean | undefined,
	in?: Array<boolean> | undefined,
	notIn?: Array<boolean> | undefined,
	lt?: boolean | undefined,
	lte?: boolean | undefined,
	gt?: boolean | undefined,
	gte?: boolean | undefined
};
	["BackgroundCondition"]: {
	and?: Array<ModelTypes["BackgroundCondition"]> | undefined,
	or?: Array<ModelTypes["BackgroundCondition"]> | undefined,
	not?: ModelTypes["BackgroundCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["Background"] | undefined,
	notEq?: ModelTypes["Background"] | undefined,
	in?: Array<ModelTypes["Background"]> | undefined,
	notIn?: Array<ModelTypes["Background"]> | undefined,
	lt?: ModelTypes["Background"] | undefined,
	lte?: ModelTypes["Background"] | undefined,
	gt?: ModelTypes["Background"] | undefined,
	gte?: ModelTypes["Background"] | undefined
};
	["Background"]:Background;
	["BonusBannerLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["BonusBannerWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	tiles?: ModelTypes["TileWhere"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	bannerName?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["BonusBannerLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["BonusBannerLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["BonusBannerLocaleWhere"] | undefined
};
	["BonusBannerWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	locales?: ModelTypes["BonusBannerLocaleWhere"] | undefined,
	and?: Array<ModelTypes["BonusBannerWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["BonusBannerWhere"] | undefined> | undefined,
	not?: ModelTypes["BonusBannerWhere"] | undefined
};
	["TileWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	bonusBanner?: ModelTypes["BonusBannerLocaleWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	lightBoxTitle?: ModelTypes["StringCondition"] | undefined,
	lightBoxText?: ModelTypes["StringCondition"] | undefined,
	ligthBoxMedia?: ModelTypes["MediumListWhere"] | undefined,
	lightBoxSectionTitle?: ModelTypes["StringCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	lightBoxLinkLabel?: ModelTypes["StringCondition"] | undefined,
	lightBoxForm?: ModelTypes["JobsFormLocaleWhere"] | undefined,
	and?: Array<ModelTypes["TileWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TileWhere"] | undefined> | undefined,
	not?: ModelTypes["TileWhere"] | undefined
};
	["JobsFormLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	jobText?: ModelTypes["StringCondition"] | undefined,
	genericText?: ModelTypes["StringCondition"] | undefined,
	nameLabel?: ModelTypes["StringCondition"] | undefined,
	emailLabel?: ModelTypes["StringCondition"] | undefined,
	telefonLabel?: ModelTypes["StringCondition"] | undefined,
	fileTitleLabel?: ModelTypes["StringCondition"] | undefined,
	fileFormatLabel?: ModelTypes["StringCondition"] | undefined,
	formTextLabel?: ModelTypes["StringCondition"] | undefined,
	submitLabel?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["JobsFormWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	imageTextList?: ModelTypes["ImageTextListWhere"] | undefined,
	minimalize?: ModelTypes["StringCondition"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	successTitle?: ModelTypes["StringCondition"] | undefined,
	successText?: ModelTypes["StringCondition"] | undefined,
	successBtnLabel?: ModelTypes["StringCondition"] | undefined,
	successImage?: ModelTypes["ImageWhere"] | undefined,
	successOtherJobsTitle?: ModelTypes["StringCondition"] | undefined,
	successOtherJobsCategoryTitle?: ModelTypes["StringCondition"] | undefined,
	successOtherJobsButtonTitle?: ModelTypes["StringCondition"] | undefined,
	successOtherJobsSelectionTitle?: ModelTypes["StringCondition"] | undefined,
	successOtherJobsSelectionYesButton?: ModelTypes["StringCondition"] | undefined,
	successOtherJobsSelectionNoButton?: ModelTypes["StringCondition"] | undefined,
	fileRemoveBtnLabel?: ModelTypes["StringCondition"] | undefined,
	gdprLabel?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["JobsFormLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobsFormLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["JobsFormLocaleWhere"] | undefined
};
	["JobsFormWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["JobsFormLocaleWhere"] | undefined,
	fileIlustration?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["JobsFormWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobsFormWhere"] | undefined> | undefined,
	not?: ModelTypes["JobsFormWhere"] | undefined
};
	["ImageTextListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["ImageTextItemWhere"] | undefined,
	and?: Array<ModelTypes["ImageTextListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ImageTextListWhere"] | undefined> | undefined,
	not?: ModelTypes["ImageTextListWhere"] | undefined
};
	["ImageTextItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	list?: ModelTypes["ImageTextListWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["ImageTextItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ImageTextItemWhere"] | undefined> | undefined,
	not?: ModelTypes["ImageTextItemWhere"] | undefined
};
	["SideBySideWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["SideBySideItemWhere"] | undefined,
	background?: ModelTypes["BackgroundCondition"] | undefined,
	alignment?: ModelTypes["ContentAlignmentCondition"] | undefined,
	mediumSize?: ModelTypes["MediumSizeCondition"] | undefined,
	and?: Array<ModelTypes["SideBySideWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["SideBySideWhere"] | undefined> | undefined,
	not?: ModelTypes["SideBySideWhere"] | undefined
};
	["SideBySideItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	list?: ModelTypes["SideBySideWhere"] | undefined,
	media?: ModelTypes["MediumListWhere"] | undefined,
	formButtonLabel?: ModelTypes["StringCondition"] | undefined,
	type?: ModelTypes["SideBySideItemTypeCondition"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	jobsForm?: ModelTypes["JobsFormLocaleWhere"] | undefined,
	textNew?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["SideBySideItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["SideBySideItemWhere"] | undefined> | undefined,
	not?: ModelTypes["SideBySideItemWhere"] | undefined
};
	["SideBySideItemTypeCondition"]: {
	and?: Array<ModelTypes["SideBySideItemTypeCondition"]> | undefined,
	or?: Array<ModelTypes["SideBySideItemTypeCondition"]> | undefined,
	not?: ModelTypes["SideBySideItemTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["SideBySideItemType"] | undefined,
	notEq?: ModelTypes["SideBySideItemType"] | undefined,
	in?: Array<ModelTypes["SideBySideItemType"]> | undefined,
	notIn?: Array<ModelTypes["SideBySideItemType"]> | undefined,
	lt?: ModelTypes["SideBySideItemType"] | undefined,
	lte?: ModelTypes["SideBySideItemType"] | undefined,
	gt?: ModelTypes["SideBySideItemType"] | undefined,
	gte?: ModelTypes["SideBySideItemType"] | undefined
};
	["SideBySideItemType"]:SideBySideItemType;
	["ContentAlignmentCondition"]: {
	and?: Array<ModelTypes["ContentAlignmentCondition"]> | undefined,
	or?: Array<ModelTypes["ContentAlignmentCondition"]> | undefined,
	not?: ModelTypes["ContentAlignmentCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["ContentAlignment"] | undefined,
	notEq?: ModelTypes["ContentAlignment"] | undefined,
	in?: Array<ModelTypes["ContentAlignment"]> | undefined,
	notIn?: Array<ModelTypes["ContentAlignment"]> | undefined,
	lt?: ModelTypes["ContentAlignment"] | undefined,
	lte?: ModelTypes["ContentAlignment"] | undefined,
	gt?: ModelTypes["ContentAlignment"] | undefined,
	gte?: ModelTypes["ContentAlignment"] | undefined
};
	["ContentAlignment"]:ContentAlignment;
	["MediumSizeCondition"]: {
	and?: Array<ModelTypes["MediumSizeCondition"]> | undefined,
	or?: Array<ModelTypes["MediumSizeCondition"]> | undefined,
	not?: ModelTypes["MediumSizeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["MediumSize"] | undefined,
	notEq?: ModelTypes["MediumSize"] | undefined,
	in?: Array<ModelTypes["MediumSize"]> | undefined,
	notIn?: Array<ModelTypes["MediumSize"]> | undefined,
	lt?: ModelTypes["MediumSize"] | undefined,
	lte?: ModelTypes["MediumSize"] | undefined,
	gt?: ModelTypes["MediumSize"] | undefined,
	gte?: ModelTypes["MediumSize"] | undefined
};
	["MediumSize"]:MediumSize;
	["GalleryWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["GalleryItemWhere"] | undefined,
	and?: Array<ModelTypes["GalleryWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GalleryWhere"] | undefined> | undefined,
	not?: ModelTypes["GalleryWhere"] | undefined
};
	["GalleryItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["GalleryWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["GalleryItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["GalleryItemWhere"] | undefined> | undefined,
	not?: ModelTypes["GalleryItemWhere"] | undefined
};
	["SeoWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	description?: ModelTypes["StringCondition"] | undefined,
	ogTitle?: ModelTypes["StringCondition"] | undefined,
	ogDescription?: ModelTypes["StringCondition"] | undefined,
	noIndex?: ModelTypes["BooleanCondition"] | undefined,
	noFollow?: ModelTypes["BooleanCondition"] | undefined,
	ogImage?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["SeoWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["SeoWhere"] | undefined> | undefined,
	not?: ModelTypes["SeoWhere"] | undefined
};
	["BusinessPageLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["BusinessPageWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	subtitle?: ModelTypes["StringCondition"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	stickyBar?: ModelTypes["StickyBarWhere"] | undefined,
	infoBox?: ModelTypes["InfoBoxWhere"] | undefined,
	and?: Array<ModelTypes["BusinessPageLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["BusinessPageLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["BusinessPageLocaleWhere"] | undefined
};
	["BusinessPageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	locales?: ModelTypes["BusinessPageLocaleWhere"] | undefined,
	theme?: ModelTypes["ThemeWhere"] | undefined,
	isLokal?: ModelTypes["BooleanCondition"] | undefined,
	tabidooId?: ModelTypes["StringCondition"] | undefined,
	headerColor?: ModelTypes["StringCondition"] | undefined,
	recruitisOfficeId?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["BusinessPageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["BusinessPageWhere"] | undefined> | undefined,
	not?: ModelTypes["BusinessPageWhere"] | undefined
};
	["StickyBarWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	formButtonLabel?: ModelTypes["StringCondition"] | undefined,
	jobsForm?: ModelTypes["JobsFormLocaleWhere"] | undefined,
	and?: Array<ModelTypes["StickyBarWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["StickyBarWhere"] | undefined> | undefined,
	not?: ModelTypes["StickyBarWhere"] | undefined
};
	["InfoBoxWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	logoSize?: ModelTypes["LogoSizeCondition"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	locales?: ModelTypes["InfoBoxLocaleWhere"] | undefined,
	and?: Array<ModelTypes["InfoBoxWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["InfoBoxWhere"] | undefined> | undefined,
	not?: ModelTypes["InfoBoxWhere"] | undefined
};
	["LogoSizeCondition"]: {
	and?: Array<ModelTypes["LogoSizeCondition"]> | undefined,
	or?: Array<ModelTypes["LogoSizeCondition"]> | undefined,
	not?: ModelTypes["LogoSizeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["LogoSize"] | undefined,
	notEq?: ModelTypes["LogoSize"] | undefined,
	in?: Array<ModelTypes["LogoSize"]> | undefined,
	notIn?: Array<ModelTypes["LogoSize"]> | undefined,
	lt?: ModelTypes["LogoSize"] | undefined,
	lte?: ModelTypes["LogoSize"] | undefined,
	gt?: ModelTypes["LogoSize"] | undefined,
	gte?: ModelTypes["LogoSize"] | undefined
};
	["LogoSize"]:LogoSize;
	["InfoBoxLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	address?: ModelTypes["StringCondition"] | undefined,
	web?: ModelTypes["StringCondition"] | undefined,
	instagram?: ModelTypes["StringCondition"] | undefined,
	facebook?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["InfoBoxWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	openingHours?: ModelTypes["TextListWhere"] | undefined,
	addressLink?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["InfoBoxLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["InfoBoxLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["InfoBoxLocaleWhere"] | undefined
};
	["JobPageLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["JobPageWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	keyInfo?: ModelTypes["KeyInfoListWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	email?: ModelTypes["StringCondition"] | undefined,
	stickyBar?: ModelTypes["StickyBarWhere"] | undefined,
	mobileImage?: ModelTypes["ImageWhere"] | undefined,
	isSyncedToTabidoo?: ModelTypes["BooleanCondition"] | undefined,
	tabidooId?: ModelTypes["StringCondition"] | undefined,
	recruitisJobId?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["JobPageLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobPageLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["JobPageLocaleWhere"] | undefined
};
	["JobPageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	locales?: ModelTypes["JobPageLocaleWhere"] | undefined,
	theme?: ModelTypes["ThemeWhere"] | undefined,
	contractType?: ModelTypes["ContractTypeWhere"] | undefined,
	jobCity?: ModelTypes["JobCityWhere"] | undefined,
	isActive?: ModelTypes["BooleanCondition"] | undefined,
	jobPosition?: ModelTypes["JobPositionWhere"] | undefined,
	publishedAt?: ModelTypes["DateTimeCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	isSyncedToTabidoo?: ModelTypes["BooleanCondition"] | undefined,
	business?: ModelTypes["BusinessPageWhere"] | undefined,
	headerColor?: ModelTypes["StringCondition"] | undefined,
	siteType?: ModelTypes["SiteTypeCondition"] | undefined,
	isHiddenFromListing?: ModelTypes["BooleanCondition"] | undefined,
	and?: Array<ModelTypes["JobPageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobPageWhere"] | undefined> | undefined,
	not?: ModelTypes["JobPageWhere"] | undefined
};
	["ContractTypeWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	locales?: ModelTypes["ContractTypeLocaleWhere"] | undefined,
	and?: Array<ModelTypes["ContractTypeWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ContractTypeWhere"] | undefined> | undefined,
	not?: ModelTypes["ContractTypeWhere"] | undefined
};
	["ContractTypeLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["ContractTypeWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	slug?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["ContractTypeLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ContractTypeLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["ContractTypeLocaleWhere"] | undefined
};
	["JobCityWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	locales?: ModelTypes["JobCityLocaleWhere"] | undefined,
	and?: Array<ModelTypes["JobCityWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobCityWhere"] | undefined> | undefined,
	not?: ModelTypes["JobCityWhere"] | undefined
};
	["JobCityLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["JobCityWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	slug?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["JobCityLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobCityLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["JobCityLocaleWhere"] | undefined
};
	["JobPositionWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	locales?: ModelTypes["JobPositionLocaleWhere"] | undefined,
	jobs?: ModelTypes["JobPageWhere"] | undefined,
	and?: Array<ModelTypes["JobPositionWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobPositionWhere"] | undefined> | undefined,
	not?: ModelTypes["JobPositionWhere"] | undefined
};
	["JobPositionLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	type?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["JobPositionWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	slug?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["JobPositionLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobPositionLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["JobPositionLocaleWhere"] | undefined
};
	["DateTimeCondition"]: {
	and?: Array<ModelTypes["DateTimeCondition"]> | undefined,
	or?: Array<ModelTypes["DateTimeCondition"]> | undefined,
	not?: ModelTypes["DateTimeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["DateTime"] | undefined,
	notEq?: ModelTypes["DateTime"] | undefined,
	in?: Array<ModelTypes["DateTime"]> | undefined,
	notIn?: Array<ModelTypes["DateTime"]> | undefined,
	lt?: ModelTypes["DateTime"] | undefined,
	lte?: ModelTypes["DateTime"] | undefined,
	gt?: ModelTypes["DateTime"] | undefined,
	gte?: ModelTypes["DateTime"] | undefined
};
	["DateTime"]:any;
	["SiteTypeCondition"]: {
	and?: Array<ModelTypes["SiteTypeCondition"]> | undefined,
	or?: Array<ModelTypes["SiteTypeCondition"]> | undefined,
	not?: ModelTypes["SiteTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: ModelTypes["SiteType"] | undefined,
	notEq?: ModelTypes["SiteType"] | undefined,
	in?: Array<ModelTypes["SiteType"]> | undefined,
	notIn?: Array<ModelTypes["SiteType"]> | undefined,
	lt?: ModelTypes["SiteType"] | undefined,
	lte?: ModelTypes["SiteType"] | undefined,
	gt?: ModelTypes["SiteType"] | undefined,
	gte?: ModelTypes["SiteType"] | undefined
};
	["SiteType"]:SiteType;
	["KeyInfoListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["KeyInfoItemWhere"] | undefined,
	and?: Array<ModelTypes["KeyInfoListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["KeyInfoListWhere"] | undefined> | undefined,
	not?: ModelTypes["KeyInfoListWhere"] | undefined
};
	["KeyInfoItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	keyInfo?: ModelTypes["StringCondition"] | undefined,
	list?: ModelTypes["KeyInfoListWhere"] | undefined,
	icon?: ModelTypes["IconWhere"] | undefined,
	and?: Array<ModelTypes["KeyInfoItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["KeyInfoItemWhere"] | undefined> | undefined,
	not?: ModelTypes["KeyInfoItemWhere"] | undefined
};
	["IconWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	icon?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["IconWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["IconWhere"] | undefined> | undefined,
	not?: ModelTypes["IconWhere"] | undefined
};
	["HomePageLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["HomePageWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	button?: ModelTypes["LinkWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	siteSwitcher?: ModelTypes["SiteSwitcherWhere"] | undefined,
	gallery?: ModelTypes["GalleryWhere"] | undefined,
	stickyBar?: ModelTypes["StickyBarWhere"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	ilustration?: ModelTypes["GalleryWhere"] | undefined,
	and?: Array<ModelTypes["HomePageLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["HomePageLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["HomePageLocaleWhere"] | undefined
};
	["HomePageWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["HomePageLocaleWhere"] | undefined,
	theme?: ModelTypes["ThemeWhere"] | undefined,
	and?: Array<ModelTypes["HomePageWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["HomePageWhere"] | undefined> | undefined,
	not?: ModelTypes["HomePageWhere"] | undefined
};
	["SiteSwitcherWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	theme?: ModelTypes["ThemeWhere"] | undefined,
	headerColor?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["SiteSwitcherWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["SiteSwitcherWhere"] | undefined> | undefined,
	not?: ModelTypes["SiteSwitcherWhere"] | undefined
};
	["HomePageLokalLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["HomePageLokalWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	button?: ModelTypes["LinkWhere"] | undefined,
	content?: ModelTypes["ContentWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	link?: ModelTypes["LinkableWhere"] | undefined,
	siteSwitcher?: ModelTypes["SiteSwitcherWhere"] | undefined,
	gallery?: ModelTypes["GalleryWhere"] | undefined,
	stickyBar?: ModelTypes["StickyBarWhere"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	ilustration?: ModelTypes["GalleryWhere"] | undefined,
	and?: Array<ModelTypes["HomePageLokalLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["HomePageLokalLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["HomePageLokalLocaleWhere"] | undefined
};
	["HomePageLokalWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["HomePageLokalLocaleWhere"] | undefined,
	theme?: ModelTypes["ThemeWhere"] | undefined,
	and?: Array<ModelTypes["HomePageLokalWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["HomePageLokalWhere"] | undefined> | undefined,
	not?: ModelTypes["HomePageLokalWhere"] | undefined
};
	["RecommendationFormLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	subtitle?: ModelTypes["StringCondition"] | undefined,
	yourEmailLabel?: ModelTypes["StringCondition"] | undefined,
	theirEmailLabel?: ModelTypes["StringCondition"] | undefined,
	yourName?: ModelTypes["StringCondition"] | undefined,
	sendBtnLabel?: ModelTypes["StringCondition"] | undefined,
	successTitle?: ModelTypes["StringCondition"] | undefined,
	successSubtitle?: ModelTypes["StringCondition"] | undefined,
	successButtonClose?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["RecommendationFormWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	and?: Array<ModelTypes["RecommendationFormLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["RecommendationFormLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["RecommendationFormLocaleWhere"] | undefined
};
	["RecommendationFormWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["RecommendationFormLocaleWhere"] | undefined,
	successImage?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["RecommendationFormWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["RecommendationFormWhere"] | undefined> | undefined,
	not?: ModelTypes["RecommendationFormWhere"] | undefined
};
	["HeaderLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["HeaderWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	menuLabel?: ModelTypes["StringCondition"] | undefined,
	menuTitle?: ModelTypes["StringCondition"] | undefined,
	menuText?: ModelTypes["StringCondition"] | undefined,
	business?: ModelTypes["BusinessWhere"] | undefined,
	lokalEnterprise?: ModelTypes["BusinessWhere"] | undefined,
	businessSectionTitle?: ModelTypes["StringCondition"] | undefined,
	lokalSectionTitle?: ModelTypes["StringCondition"] | undefined,
	businessLink?: ModelTypes["LinkWhere"] | undefined,
	lokalLink?: ModelTypes["LinkWhere"] | undefined,
	and?: Array<ModelTypes["HeaderLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["HeaderLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["HeaderLocaleWhere"] | undefined
};
	["HeaderWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["HeaderLocaleWhere"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	logoMenu?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["HeaderWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["HeaderWhere"] | undefined> | undefined,
	not?: ModelTypes["HeaderWhere"] | undefined
};
	["BusinessWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	and?: Array<ModelTypes["BusinessWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["BusinessWhere"] | undefined> | undefined,
	not?: ModelTypes["BusinessWhere"] | undefined
};
	["SeoDefaultLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	root?: ModelTypes["SeoDefaultWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	seo?: ModelTypes["SeoWhere"] | undefined,
	and?: Array<ModelTypes["SeoDefaultLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["SeoDefaultLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["SeoDefaultLocaleWhere"] | undefined
};
	["SeoDefaultWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["SeoDefaultLocaleWhere"] | undefined,
	and?: Array<ModelTypes["SeoDefaultWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["SeoDefaultWhere"] | undefined> | undefined,
	not?: ModelTypes["SeoDefaultWhere"] | undefined
};
	["JobsFilterLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	jobPositionLabel?: ModelTypes["StringCondition"] | undefined,
	jobContractLabel?: ModelTypes["StringCondition"] | undefined,
	jobCityLabel?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["JobsFilterWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	bannerTitle?: ModelTypes["StringCondition"] | undefined,
	bannerFormLabel?: ModelTypes["StringCondition"] | undefined,
	bannerJobsForm?: ModelTypes["JobsFormLocaleWhere"] | undefined,
	bannerImage?: ModelTypes["ImageWhere"] | undefined,
	noJobTitle?: ModelTypes["StringCondition"] | undefined,
	noJobBtnLabel?: ModelTypes["StringCondition"] | undefined,
	noJobImage?: ModelTypes["ImageWhere"] | undefined,
	noJobTitleForSpecificBusiness?: ModelTypes["StringCondition"] | undefined,
	deactivatedJob?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["JobsFilterLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobsFilterLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["JobsFilterLocaleWhere"] | undefined
};
	["JobsFilterWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	unique?: ModelTypes["OneCondition"] | undefined,
	locales?: ModelTypes["JobsFilterLocaleWhere"] | undefined,
	and?: Array<ModelTypes["JobsFilterWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobsFilterWhere"] | undefined> | undefined,
	not?: ModelTypes["JobsFilterWhere"] | undefined
};
	["TranslationLocaleWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	value?: ModelTypes["StringCondition"] | undefined,
	root?: ModelTypes["TranslationWhere"] | undefined,
	locale?: ModelTypes["LocaleWhere"] | undefined,
	and?: Array<ModelTypes["TranslationLocaleWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TranslationLocaleWhere"] | undefined> | undefined,
	not?: ModelTypes["TranslationLocaleWhere"] | undefined
};
	["TranslationWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	key?: ModelTypes["StringCondition"] | undefined,
	locales?: ModelTypes["TranslationLocaleWhere"] | undefined,
	isTextarea?: ModelTypes["BooleanCondition"] | undefined,
	and?: Array<ModelTypes["TranslationWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["TranslationWhere"] | undefined> | undefined,
	not?: ModelTypes["TranslationWhere"] | undefined
};
	["CornerBannerWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	isActive?: ModelTypes["BooleanCondition"] | undefined,
	title?: ModelTypes["StringCondition"] | undefined,
	text?: ModelTypes["StringCondition"] | undefined,
	logo?: ModelTypes["ImageWhere"] | undefined,
	link?: ModelTypes["LinkWhere"] | undefined,
	and?: Array<ModelTypes["CornerBannerWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["CornerBannerWhere"] | undefined> | undefined,
	not?: ModelTypes["CornerBannerWhere"] | undefined
};
	["Locale"]: {
		_meta?: ModelTypes["LocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	code: string,
	label?: string | undefined,
	footers: Array<ModelTypes["FooterLocale"]>,
	genericPages: Array<ModelTypes["GenericPageLocale"]>,
	headers: Array<ModelTypes["HeaderLocale"]>,
	seoDefaults: Array<ModelTypes["SeoDefaultLocale"]>,
	businessPages: Array<ModelTypes["BusinessPageLocale"]>,
	jobPages: Array<ModelTypes["JobPageLocale"]>,
	contractTypes: Array<ModelTypes["ContractTypeLocale"]>,
	jobCities: Array<ModelTypes["JobCityLocale"]>,
	jobPositions: Array<ModelTypes["JobPositionLocale"]>,
	homePages: Array<ModelTypes["HomePageLocale"]>,
	bonusBanners: Array<ModelTypes["BonusBannerLocale"]>,
	homePageLokals: Array<ModelTypes["HomePageLokalLocale"]>,
	jobsForms: Array<ModelTypes["JobsFormLocale"]>,
	jobsFilters: Array<ModelTypes["JobsFilterLocale"]>,
	general: Array<ModelTypes["GeneralLocale"]>,
	recommendationForms: Array<ModelTypes["RecommendationFormLocale"]>,
	infoBoxes: Array<ModelTypes["InfoBoxLocale"]>,
	translations: Array<ModelTypes["TranslationLocale"]>,
	footersByRoot?: ModelTypes["FooterLocale"] | undefined,
	footersByTermsAndConditions?: ModelTypes["FooterLocale"] | undefined,
	footersByBannerImage?: ModelTypes["FooterLocale"] | undefined,
	footersByBannerLink?: ModelTypes["FooterLocale"] | undefined,
	footersByJobsForm?: ModelTypes["FooterLocale"] | undefined,
	footersByCopyrightLink?: ModelTypes["FooterLocale"] | undefined,
	footersByRecommendationForm?: ModelTypes["FooterLocale"] | undefined,
	footersByBannerSecondLink?: ModelTypes["FooterLocale"] | undefined,
	footersByInstagramLink?: ModelTypes["FooterLocale"] | undefined,
	genericPagesByRoot?: ModelTypes["GenericPageLocale"] | undefined,
	genericPagesByContent?: ModelTypes["GenericPageLocale"] | undefined,
	genericPagesBySeo?: ModelTypes["GenericPageLocale"] | undefined,
	genericPagesByLink?: ModelTypes["GenericPageLocale"] | undefined,
	genericPagesByLogo?: ModelTypes["GenericPageLocale"] | undefined,
	genericPagesByImage?: ModelTypes["GenericPageLocale"] | undefined,
	headersByRoot?: ModelTypes["HeaderLocale"] | undefined,
	headersByBusinessLink?: ModelTypes["HeaderLocale"] | undefined,
	headersByLokalLink?: ModelTypes["HeaderLocale"] | undefined,
	seoDefaultsByRoot?: ModelTypes["SeoDefaultLocale"] | undefined,
	seoDefaultsBySeo?: ModelTypes["SeoDefaultLocale"] | undefined,
	businessPagesByRoot?: ModelTypes["BusinessPageLocale"] | undefined,
	businessPagesByContent?: ModelTypes["BusinessPageLocale"] | undefined,
	businessPagesBySeo?: ModelTypes["BusinessPageLocale"] | undefined,
	businessPagesByLink?: ModelTypes["BusinessPageLocale"] | undefined,
	businessPagesByImage?: ModelTypes["BusinessPageLocale"] | undefined,
	jobPagesByRoot?: ModelTypes["JobPageLocale"] | undefined,
	jobPagesByImage?: ModelTypes["JobPageLocale"] | undefined,
	jobPagesByKeyInfo?: ModelTypes["JobPageLocale"] | undefined,
	jobPagesByContent?: ModelTypes["JobPageLocale"] | undefined,
	jobPagesBySeo?: ModelTypes["JobPageLocale"] | undefined,
	jobPagesByLink?: ModelTypes["JobPageLocale"] | undefined,
	jobPagesByMobileImage?: ModelTypes["JobPageLocale"] | undefined,
	contractTypesByRoot?: ModelTypes["ContractTypeLocale"] | undefined,
	contractTypesBySlug?: ModelTypes["ContractTypeLocale"] | undefined,
	jobCitiesByRoot?: ModelTypes["JobCityLocale"] | undefined,
	jobCitiesBySlug?: ModelTypes["JobCityLocale"] | undefined,
	jobPositionsByRoot?: ModelTypes["JobPositionLocale"] | undefined,
	jobPositionsBySlug?: ModelTypes["JobPositionLocale"] | undefined,
	homePagesByRoot?: ModelTypes["HomePageLocale"] | undefined,
	homePagesByButton?: ModelTypes["HomePageLocale"] | undefined,
	homePagesByContent?: ModelTypes["HomePageLocale"] | undefined,
	homePagesBySeo?: ModelTypes["HomePageLocale"] | undefined,
	homePagesByLink?: ModelTypes["HomePageLocale"] | undefined,
	homePagesByLogo?: ModelTypes["HomePageLocale"] | undefined,
	homePagesBySiteSwitcher?: ModelTypes["HomePageLocale"] | undefined,
	homePagesByIlustration?: ModelTypes["HomePageLocale"] | undefined,
	bonusBannersByRoot?: ModelTypes["BonusBannerLocale"] | undefined,
	bonusBannersByTiles?: ModelTypes["BonusBannerLocale"] | undefined,
	bonusBannersByLogo?: ModelTypes["BonusBannerLocale"] | undefined,
	homePageLokalsByRoot?: ModelTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsByLogo?: ModelTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsByButton?: ModelTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsByContent?: ModelTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsBySeo?: ModelTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsByLink?: ModelTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsBySiteSwitcher?: ModelTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsByIlustration?: ModelTypes["HomePageLokalLocale"] | undefined,
	jobsFormsByRoot?: ModelTypes["JobsFormLocale"] | undefined,
	jobsFormsByImageTextList?: ModelTypes["JobsFormLocale"] | undefined,
	jobsFormsByLogo?: ModelTypes["JobsFormLocale"] | undefined,
	jobsFormsBySuccessImage?: ModelTypes["JobsFormLocale"] | undefined,
	jobsFiltersByRoot?: ModelTypes["JobsFilterLocale"] | undefined,
	jobsFiltersByBannerJobsForm?: ModelTypes["JobsFilterLocale"] | undefined,
	jobsFiltersByBannerImage?: ModelTypes["JobsFilterLocale"] | undefined,
	jobsFiltersByNoJobImage?: ModelTypes["JobsFilterLocale"] | undefined,
	generalByRoot?: ModelTypes["GeneralLocale"] | undefined,
	generalBySeo?: ModelTypes["GeneralLocale"] | undefined,
	generalByCornerBanner?: ModelTypes["GeneralLocale"] | undefined,
	recommendationFormsByRoot?: ModelTypes["RecommendationFormLocale"] | undefined,
	infoBoxesByRoot?: ModelTypes["InfoBoxLocale"] | undefined,
	translationsByRoot?: ModelTypes["TranslationLocale"] | undefined,
	paginateFooters: ModelTypes["FooterLocaleConnection"],
	paginateGenericPages: ModelTypes["GenericPageLocaleConnection"],
	paginateHeaders: ModelTypes["HeaderLocaleConnection"],
	paginateSeoDefaults: ModelTypes["SeoDefaultLocaleConnection"],
	paginateBusinessPages: ModelTypes["BusinessPageLocaleConnection"],
	paginateJobPages: ModelTypes["JobPageLocaleConnection"],
	paginateContractTypes: ModelTypes["ContractTypeLocaleConnection"],
	paginateJobCities: ModelTypes["JobCityLocaleConnection"],
	paginateJobPositions: ModelTypes["JobPositionLocaleConnection"],
	paginateHomePages: ModelTypes["HomePageLocaleConnection"],
	paginateBonusBanners: ModelTypes["BonusBannerLocaleConnection"],
	paginateHomePageLokals: ModelTypes["HomePageLokalLocaleConnection"],
	paginateJobsForms: ModelTypes["JobsFormLocaleConnection"],
	paginateJobsFilters: ModelTypes["JobsFilterLocaleConnection"],
	paginateGeneral: ModelTypes["GeneralLocaleConnection"],
	paginateRecommendationForms: ModelTypes["RecommendationFormLocaleConnection"],
	paginateInfoBoxes: ModelTypes["InfoBoxLocaleConnection"],
	paginateTranslations: ModelTypes["TranslationLocaleConnection"]
};
	["LocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	code?: ModelTypes["FieldMeta"] | undefined,
	label?: ModelTypes["FieldMeta"] | undefined,
	footers?: ModelTypes["FieldMeta"] | undefined,
	genericPages?: ModelTypes["FieldMeta"] | undefined,
	headers?: ModelTypes["FieldMeta"] | undefined,
	seoDefaults?: ModelTypes["FieldMeta"] | undefined,
	businessPages?: ModelTypes["FieldMeta"] | undefined,
	jobPages?: ModelTypes["FieldMeta"] | undefined,
	contractTypes?: ModelTypes["FieldMeta"] | undefined,
	jobCities?: ModelTypes["FieldMeta"] | undefined,
	jobPositions?: ModelTypes["FieldMeta"] | undefined,
	homePages?: ModelTypes["FieldMeta"] | undefined,
	bonusBanners?: ModelTypes["FieldMeta"] | undefined,
	homePageLokals?: ModelTypes["FieldMeta"] | undefined,
	jobsForms?: ModelTypes["FieldMeta"] | undefined,
	jobsFilters?: ModelTypes["FieldMeta"] | undefined,
	general?: ModelTypes["FieldMeta"] | undefined,
	recommendationForms?: ModelTypes["FieldMeta"] | undefined,
	infoBoxes?: ModelTypes["FieldMeta"] | undefined,
	translations?: ModelTypes["FieldMeta"] | undefined
};
	["FooterLocale"]: {
		_meta?: ModelTypes["FooterLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	root?: ModelTypes["Footer"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	linksFirstColumn: Array<ModelTypes["FooterLink"]>,
	linksSecondColumn: Array<ModelTypes["FooterLink"]>,
	termsAndConditions?: ModelTypes["Link"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: ModelTypes["Image"] | undefined,
	bannerLink?: ModelTypes["Link"] | undefined,
	jobsForm?: ModelTypes["JobsFormLocale"] | undefined,
	copyrightLink?: ModelTypes["Link"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: ModelTypes["RecommendationFormLocale"] | undefined,
	bannerSecondLink?: ModelTypes["Link"] | undefined,
	instagramLink?: ModelTypes["Link"] | undefined,
	paginateLinksFirstColumn: ModelTypes["FooterLinkConnection"],
	paginateLinksSecondColumn: ModelTypes["FooterLinkConnection"]
};
	["FooterLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	email?: ModelTypes["FieldMeta"] | undefined,
	address?: ModelTypes["FieldMeta"] | undefined,
	ico?: ModelTypes["FieldMeta"] | undefined,
	dic?: ModelTypes["FieldMeta"] | undefined,
	copyright?: ModelTypes["FieldMeta"] | undefined,
	note?: ModelTypes["FieldMeta"] | undefined,
	noteSecond?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	linksFirstColumn?: ModelTypes["FieldMeta"] | undefined,
	linksSecondColumn?: ModelTypes["FieldMeta"] | undefined,
	termsAndConditions?: ModelTypes["FieldMeta"] | undefined,
	form?: ModelTypes["FieldMeta"] | undefined,
	bannerTitle?: ModelTypes["FieldMeta"] | undefined,
	bannerSubtitle?: ModelTypes["FieldMeta"] | undefined,
	bannerImage?: ModelTypes["FieldMeta"] | undefined,
	bannerLink?: ModelTypes["FieldMeta"] | undefined,
	jobsForm?: ModelTypes["FieldMeta"] | undefined,
	copyrightLink?: ModelTypes["FieldMeta"] | undefined,
	bannerSecondBtn?: ModelTypes["FieldMeta"] | undefined,
	recommendationForm?: ModelTypes["FieldMeta"] | undefined,
	bannerSecondLink?: ModelTypes["FieldMeta"] | undefined,
	instagramLink?: ModelTypes["FieldMeta"] | undefined
};
	["Footer"]: {
		_meta?: ModelTypes["FooterMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["FooterLocale"]>,
	localesByLocale?: ModelTypes["FooterLocale"] | undefined,
	localesByTermsAndConditions?: ModelTypes["FooterLocale"] | undefined,
	localesByBannerImage?: ModelTypes["FooterLocale"] | undefined,
	localesByBannerLink?: ModelTypes["FooterLocale"] | undefined,
	localesByJobsForm?: ModelTypes["FooterLocale"] | undefined,
	localesByCopyrightLink?: ModelTypes["FooterLocale"] | undefined,
	localesByRecommendationForm?: ModelTypes["FooterLocale"] | undefined,
	localesByBannerSecondLink?: ModelTypes["FooterLocale"] | undefined,
	localesByInstagramLink?: ModelTypes["FooterLocale"] | undefined,
	paginateLocales: ModelTypes["FooterLocaleConnection"]
};
	["FooterMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["FooterLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	email?: ModelTypes["OrderDirection"] | undefined,
	address?: ModelTypes["OrderDirection"] | undefined,
	ico?: ModelTypes["OrderDirection"] | undefined,
	dic?: ModelTypes["OrderDirection"] | undefined,
	copyright?: ModelTypes["OrderDirection"] | undefined,
	note?: ModelTypes["OrderDirection"] | undefined,
	noteSecond?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["FooterOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	termsAndConditions?: ModelTypes["LinkOrderBy"] | undefined,
	form?: ModelTypes["OrderDirection"] | undefined,
	bannerTitle?: ModelTypes["OrderDirection"] | undefined,
	bannerSubtitle?: ModelTypes["OrderDirection"] | undefined,
	bannerImage?: ModelTypes["ImageOrderBy"] | undefined,
	bannerLink?: ModelTypes["LinkOrderBy"] | undefined,
	jobsForm?: ModelTypes["JobsFormLocaleOrderBy"] | undefined,
	copyrightLink?: ModelTypes["LinkOrderBy"] | undefined,
	bannerSecondBtn?: ModelTypes["OrderDirection"] | undefined,
	recommendationForm?: ModelTypes["RecommendationFormLocaleOrderBy"] | undefined,
	bannerSecondLink?: ModelTypes["LinkOrderBy"] | undefined,
	instagramLink?: ModelTypes["LinkOrderBy"] | undefined
};
	["OrderDirection"]:OrderDirection;
	["FooterOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["LocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	code?: ModelTypes["OrderDirection"] | undefined,
	label?: ModelTypes["OrderDirection"] | undefined
};
	["LinkOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	externalLink?: ModelTypes["OrderDirection"] | undefined,
	internalLink?: ModelTypes["LinkableOrderBy"] | undefined,
	anchorLink?: ModelTypes["OrderDirection"] | undefined
};
	["LinkableOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	url?: ModelTypes["OrderDirection"] | undefined,
	redirect?: ModelTypes["RedirectOrderBy"] | undefined,
	genericPage?: ModelTypes["GenericPageLocaleOrderBy"] | undefined,
	businessPage?: ModelTypes["BusinessPageLocaleOrderBy"] | undefined,
	jobPage?: ModelTypes["JobPageLocaleOrderBy"] | undefined,
	homePage?: ModelTypes["HomePageLocaleOrderBy"] | undefined,
	homePageLokal?: ModelTypes["HomePageLokalLocaleOrderBy"] | undefined
};
	["RedirectOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	target?: ModelTypes["LinkOrderBy"] | undefined
};
	["GenericPageLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["GenericPageOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined
};
	["GenericPageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	theme?: ModelTypes["ThemeOrderBy"] | undefined,
	headerColor?: ModelTypes["OrderDirection"] | undefined
};
	["ThemeOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	backgroundColor?: ModelTypes["OrderDirection"] | undefined,
	textColor?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	buttonBackgroundColor?: ModelTypes["OrderDirection"] | undefined,
	buttonTextColor?: ModelTypes["OrderDirection"] | undefined,
	buttonBackgroundHoverColor?: ModelTypes["OrderDirection"] | undefined,
	buttonTextHoverColor?: ModelTypes["OrderDirection"] | undefined,
	buttonBorderColor?: ModelTypes["OrderDirection"] | undefined,
	buttonBorderHoverColor?: ModelTypes["OrderDirection"] | undefined,
	headerMenuColor?: ModelTypes["OrderDirection"] | undefined
};
	["ContentOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["SeoOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	description?: ModelTypes["OrderDirection"] | undefined,
	ogTitle?: ModelTypes["OrderDirection"] | undefined,
	ogDescription?: ModelTypes["OrderDirection"] | undefined,
	noIndex?: ModelTypes["OrderDirection"] | undefined,
	noFollow?: ModelTypes["OrderDirection"] | undefined,
	ogImage?: ModelTypes["ImageOrderBy"] | undefined
};
	["ImageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	url?: ModelTypes["OrderDirection"] | undefined,
	width?: ModelTypes["OrderDirection"] | undefined,
	height?: ModelTypes["OrderDirection"] | undefined,
	size?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	alt?: ModelTypes["OrderDirection"] | undefined,
	fileName?: ModelTypes["OrderDirection"] | undefined,
	focalPointX?: ModelTypes["OrderDirection"] | undefined,
	focalPointY?: ModelTypes["OrderDirection"] | undefined
};
	["BusinessPageLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["BusinessPageOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	subtitle?: ModelTypes["OrderDirection"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	stickyBar?: ModelTypes["StickyBarOrderBy"] | undefined,
	infoBox?: ModelTypes["InfoBoxOrderBy"] | undefined
};
	["BusinessPageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	theme?: ModelTypes["ThemeOrderBy"] | undefined,
	isLokal?: ModelTypes["OrderDirection"] | undefined,
	tabidooId?: ModelTypes["OrderDirection"] | undefined,
	headerColor?: ModelTypes["OrderDirection"] | undefined,
	recruitisOfficeId?: ModelTypes["OrderDirection"] | undefined
};
	["StickyBarOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined,
	formButtonLabel?: ModelTypes["OrderDirection"] | undefined,
	jobsForm?: ModelTypes["JobsFormLocaleOrderBy"] | undefined
};
	["JobsFormLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	jobText?: ModelTypes["OrderDirection"] | undefined,
	genericText?: ModelTypes["OrderDirection"] | undefined,
	nameLabel?: ModelTypes["OrderDirection"] | undefined,
	emailLabel?: ModelTypes["OrderDirection"] | undefined,
	telefonLabel?: ModelTypes["OrderDirection"] | undefined,
	fileTitleLabel?: ModelTypes["OrderDirection"] | undefined,
	fileFormatLabel?: ModelTypes["OrderDirection"] | undefined,
	formTextLabel?: ModelTypes["OrderDirection"] | undefined,
	submitLabel?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["JobsFormOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	imageTextList?: ModelTypes["ImageTextListOrderBy"] | undefined,
	minimalize?: ModelTypes["OrderDirection"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined,
	successTitle?: ModelTypes["OrderDirection"] | undefined,
	successText?: ModelTypes["OrderDirection"] | undefined,
	successBtnLabel?: ModelTypes["OrderDirection"] | undefined,
	successImage?: ModelTypes["ImageOrderBy"] | undefined,
	successOtherJobsTitle?: ModelTypes["OrderDirection"] | undefined,
	successOtherJobsCategoryTitle?: ModelTypes["OrderDirection"] | undefined,
	successOtherJobsButtonTitle?: ModelTypes["OrderDirection"] | undefined,
	successOtherJobsSelectionTitle?: ModelTypes["OrderDirection"] | undefined,
	successOtherJobsSelectionYesButton?: ModelTypes["OrderDirection"] | undefined,
	successOtherJobsSelectionNoButton?: ModelTypes["OrderDirection"] | undefined,
	fileRemoveBtnLabel?: ModelTypes["OrderDirection"] | undefined,
	gdprLabel?: ModelTypes["OrderDirection"] | undefined
};
	["JobsFormOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined,
	fileIlustration?: ModelTypes["ImageOrderBy"] | undefined
};
	["ImageTextListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["InfoBoxOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	logoSize?: ModelTypes["OrderDirection"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined
};
	["JobPageLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["JobPageOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	keyInfo?: ModelTypes["KeyInfoListOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	email?: ModelTypes["OrderDirection"] | undefined,
	stickyBar?: ModelTypes["StickyBarOrderBy"] | undefined,
	mobileImage?: ModelTypes["ImageOrderBy"] | undefined,
	isSyncedToTabidoo?: ModelTypes["OrderDirection"] | undefined,
	tabidooId?: ModelTypes["OrderDirection"] | undefined,
	recruitisJobId?: ModelTypes["OrderDirection"] | undefined
};
	["JobPageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	theme?: ModelTypes["ThemeOrderBy"] | undefined,
	contractType?: ModelTypes["ContractTypeOrderBy"] | undefined,
	jobCity?: ModelTypes["JobCityOrderBy"] | undefined,
	isActive?: ModelTypes["OrderDirection"] | undefined,
	jobPosition?: ModelTypes["JobPositionOrderBy"] | undefined,
	publishedAt?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	isSyncedToTabidoo?: ModelTypes["OrderDirection"] | undefined,
	business?: ModelTypes["BusinessPageOrderBy"] | undefined,
	headerColor?: ModelTypes["OrderDirection"] | undefined,
	siteType?: ModelTypes["OrderDirection"] | undefined,
	isHiddenFromListing?: ModelTypes["OrderDirection"] | undefined
};
	["ContractTypeOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["JobCityOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["JobPositionOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["KeyInfoListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["HomePageLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["HomePageOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	button?: ModelTypes["LinkOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined,
	siteSwitcher?: ModelTypes["SiteSwitcherOrderBy"] | undefined,
	gallery?: ModelTypes["GalleryOrderBy"] | undefined,
	stickyBar?: ModelTypes["StickyBarOrderBy"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	ilustration?: ModelTypes["GalleryOrderBy"] | undefined
};
	["HomePageOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined,
	theme?: ModelTypes["ThemeOrderBy"] | undefined
};
	["SiteSwitcherOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined,
	theme?: ModelTypes["ThemeOrderBy"] | undefined,
	headerColor?: ModelTypes["OrderDirection"] | undefined
};
	["GalleryOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["HomePageLokalLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["HomePageLokalOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined,
	button?: ModelTypes["LinkOrderBy"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	link?: ModelTypes["LinkableOrderBy"] | undefined,
	siteSwitcher?: ModelTypes["SiteSwitcherOrderBy"] | undefined,
	gallery?: ModelTypes["GalleryOrderBy"] | undefined,
	stickyBar?: ModelTypes["StickyBarOrderBy"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	ilustration?: ModelTypes["GalleryOrderBy"] | undefined
};
	["HomePageLokalOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined,
	theme?: ModelTypes["ThemeOrderBy"] | undefined
};
	["RecommendationFormLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	subtitle?: ModelTypes["OrderDirection"] | undefined,
	yourEmailLabel?: ModelTypes["OrderDirection"] | undefined,
	theirEmailLabel?: ModelTypes["OrderDirection"] | undefined,
	yourName?: ModelTypes["OrderDirection"] | undefined,
	sendBtnLabel?: ModelTypes["OrderDirection"] | undefined,
	successTitle?: ModelTypes["OrderDirection"] | undefined,
	successSubtitle?: ModelTypes["OrderDirection"] | undefined,
	successButtonClose?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["RecommendationFormOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined
};
	["RecommendationFormOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined,
	successImage?: ModelTypes["ImageOrderBy"] | undefined
};
	["FooterLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["LocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	footers?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	genericPages?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	headers?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	seoDefaults?: ModelTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	businessPages?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	jobPages?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	contractTypes?: ModelTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	jobCities?: ModelTypes["JobCityLocaleUniqueWhere"] | undefined,
	jobPositions?: ModelTypes["JobPositionLocaleUniqueWhere"] | undefined,
	homePages?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	bonusBanners?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	homePageLokals?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	jobsForms?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	jobsFilters?: ModelTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	general?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	recommendationForms?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	infoBoxes?: ModelTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	translations?: ModelTypes["TranslationLocaleUniqueWhere"] | undefined
};
	["FooterLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["FooterUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	termsAndConditions?: ModelTypes["LinkUniqueWhere"] | undefined,
	bannerImage?: ModelTypes["ImageUniqueWhere"] | undefined,
	bannerLink?: ModelTypes["LinkUniqueWhere"] | undefined,
	jobsForm?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	copyrightLink?: ModelTypes["LinkUniqueWhere"] | undefined,
	recommendationForm?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	bannerSecondLink?: ModelTypes["LinkUniqueWhere"] | undefined,
	instagramLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["FooterUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["FooterLocaleUniqueWhere"] | undefined
};
	["LinkUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["ImageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["JobsFormLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["JobsFormUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	imageTextList?: ModelTypes["ImageTextListUniqueWhere"] | undefined,
	logo?: ModelTypes["ImageUniqueWhere"] | undefined,
	successImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["JobsFormUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	fileIlustration?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["ImageTextListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["ImageTextItemUniqueWhere"] | undefined
};
	["ImageTextItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["RecommendationFormLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["RecommendationFormUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["RecommendationFormUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	successImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["GenericPageLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GenericPageUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined,
	logo?: ModelTypes["ImageUniqueWhere"] | undefined,
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["GenericPageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined
};
	["ContentUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	blocks?: ModelTypes["ContentBlockUniqueWhere"] | undefined
};
	["ContentBlockUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	references?: ModelTypes["ContentReferenceUniqueWhere"] | undefined
};
	["ContentReferenceUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	linkables?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined,
	media?: ModelTypes["MediumListUniqueWhere"] | undefined
};
	["ContentReferenceLinkableItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	item?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LinkableUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: ModelTypes["RedirectUniqueWhere"] | undefined,
	genericPage?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	businessPage?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	jobPage?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	homePage?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	homePageLokal?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined
};
	["RedirectUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined,
	target?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["BusinessPageLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["BusinessPageUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined,
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["BusinessPageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined
};
	["SeoUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	ogImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["JobPageLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["JobPageUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	image?: ModelTypes["ImageUniqueWhere"] | undefined,
	keyInfo?: ModelTypes["KeyInfoListUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined,
	mobileImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["JobPageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined
};
	["KeyInfoListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["KeyInfoItemUniqueWhere"] | undefined
};
	["KeyInfoItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["HomePageLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["HomePageUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	button?: ModelTypes["LinkUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined,
	logo?: ModelTypes["ImageUniqueWhere"] | undefined,
	siteSwitcher?: ModelTypes["SiteSwitcherUniqueWhere"] | undefined,
	ilustration?: ModelTypes["GalleryUniqueWhere"] | undefined
};
	["HomePageUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	theme?: ModelTypes["ThemeUniqueWhere"] | undefined
};
	["ThemeUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["SiteSwitcherUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined,
	theme?: ModelTypes["ThemeUniqueWhere"] | undefined
};
	["GalleryUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["GalleryItemUniqueWhere"] | undefined
};
	["GalleryItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["HomePageLokalLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["HomePageLokalUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	logo?: ModelTypes["ImageUniqueWhere"] | undefined,
	button?: ModelTypes["LinkUniqueWhere"] | undefined,
	content?: ModelTypes["ContentUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	link?: ModelTypes["LinkableUniqueWhere"] | undefined,
	siteSwitcher?: ModelTypes["SiteSwitcherUniqueWhere"] | undefined,
	ilustration?: ModelTypes["GalleryUniqueWhere"] | undefined
};
	["HomePageLokalUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	theme?: ModelTypes["ThemeUniqueWhere"] | undefined
};
	["MediumListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["MediumItemUniqueWhere"] | undefined
};
	["MediumItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["HeaderLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["HeaderUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	businessLink?: ModelTypes["LinkUniqueWhere"] | undefined,
	lokalLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["HeaderUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	logo?: ModelTypes["ImageUniqueWhere"] | undefined,
	logoMenu?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["SeoDefaultLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["SeoDefaultUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["SeoDefaultUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["SeoDefaultLocaleUniqueWhere"] | undefined
};
	["ContractTypeLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["ContractTypeUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	slug?: string | undefined
};
	["ContractTypeUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["ContractTypeLocaleUniqueWhere"] | undefined
};
	["JobCityLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["JobCityUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	slug?: string | undefined
};
	["JobCityUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["JobCityLocaleUniqueWhere"] | undefined
};
	["JobPositionLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["JobPositionUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	slug?: string | undefined
};
	["JobPositionUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["JobPositionLocaleUniqueWhere"] | undefined,
	jobs?: ModelTypes["JobPageUniqueWhere"] | undefined
};
	["BonusBannerLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["BonusBannerUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	tiles?: ModelTypes["TileUniqueWhere"] | undefined,
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["BonusBannerUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined
};
	["TileUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	image?: ModelTypes["ImageUniqueWhere"] | undefined,
	ligthBoxMedia?: ModelTypes["MediumListUniqueWhere"] | undefined
};
	["JobsFilterLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["JobsFilterUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	bannerJobsForm?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	bannerImage?: ModelTypes["ImageUniqueWhere"] | undefined,
	noJobImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["JobsFilterUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["JobsFilterLocaleUniqueWhere"] | undefined
};
	["GeneralLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GeneralUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined,
	seo?: ModelTypes["SeoUniqueWhere"] | undefined,
	cornerBanner?: ModelTypes["CornerBannerUniqueWhere"] | undefined
};
	["GeneralUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined
};
	["CornerBannerUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	logo?: ModelTypes["ImageUniqueWhere"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["InfoBoxLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["InfoBoxUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["InfoBoxUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	logo?: ModelTypes["ImageUniqueWhere"] | undefined,
	locales?: ModelTypes["InfoBoxLocaleUniqueWhere"] | undefined
};
	["TranslationLocaleUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["TranslationUniqueWhere"] | undefined,
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["TranslationUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: ModelTypes["TranslationLocaleUniqueWhere"] | undefined
};
	["FooterLocalesByTermsAndConditionsUniqueWhere"]: {
	termsAndConditions?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocalesByBannerImageUniqueWhere"]: {
	bannerImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["FooterLocalesByBannerLinkUniqueWhere"]: {
	bannerLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocalesByJobsFormUniqueWhere"]: {
	jobsForm?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined
};
	["FooterLocalesByCopyrightLinkUniqueWhere"]: {
	copyrightLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocalesByRecommendationFormUniqueWhere"]: {
	recommendationForm?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined
};
	["FooterLocalesByBannerSecondLinkUniqueWhere"]: {
	bannerSecondLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocalesByInstagramLinkUniqueWhere"]: {
	instagramLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FooterLocaleEdge"]>
};
	["PageInfo"]: {
		totalCount: number
};
	["FooterLocaleEdge"]: {
		node: ModelTypes["FooterLocale"]
};
	["FooterLink"]: {
		_meta?: ModelTypes["FooterLinkMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	link?: ModelTypes["Link"] | undefined
};
	["FooterLinkMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined
};
	["Link"]: {
		_meta?: ModelTypes["LinkMeta"] | undefined,
	id: ModelTypes["UUID"],
	type: ModelTypes["LinkType"],
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: ModelTypes["Linkable"] | undefined,
	anchorLink?: string | undefined
};
	["LinkMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	externalLink?: ModelTypes["FieldMeta"] | undefined,
	internalLink?: ModelTypes["FieldMeta"] | undefined,
	anchorLink?: ModelTypes["FieldMeta"] | undefined
};
	["Linkable"]: {
		_meta?: ModelTypes["LinkableMeta"] | undefined,
	id: ModelTypes["UUID"],
	url: string,
	redirect?: ModelTypes["Redirect"] | undefined,
	genericPage?: ModelTypes["GenericPageLocale"] | undefined,
	businessPage?: ModelTypes["BusinessPageLocale"] | undefined,
	jobPage?: ModelTypes["JobPageLocale"] | undefined,
	homePage?: ModelTypes["HomePageLocale"] | undefined,
	homePageLokal?: ModelTypes["HomePageLokalLocale"] | undefined
};
	["LinkableMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	url?: ModelTypes["FieldMeta"] | undefined,
	redirect?: ModelTypes["FieldMeta"] | undefined,
	genericPage?: ModelTypes["FieldMeta"] | undefined,
	businessPage?: ModelTypes["FieldMeta"] | undefined,
	jobPage?: ModelTypes["FieldMeta"] | undefined,
	homePage?: ModelTypes["FieldMeta"] | undefined,
	homePageLokal?: ModelTypes["FieldMeta"] | undefined
};
	["Redirect"]: {
		_meta?: ModelTypes["RedirectMeta"] | undefined,
	id: ModelTypes["UUID"],
	link?: ModelTypes["Linkable"] | undefined,
	target?: ModelTypes["Link"] | undefined
};
	["RedirectMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	target?: ModelTypes["FieldMeta"] | undefined
};
	["GenericPageLocale"]: {
		_meta?: ModelTypes["GenericPageLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	root?: ModelTypes["GenericPage"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	text?: string | undefined,
	logo?: ModelTypes["Image"] | undefined,
	image?: ModelTypes["Image"] | undefined
};
	["GenericPageLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined
};
	["GenericPage"]: {
		_meta?: ModelTypes["GenericPageMeta"] | undefined,
	id: ModelTypes["UUID"],
	locales: Array<ModelTypes["GenericPageLocale"]>,
	theme?: ModelTypes["Theme"] | undefined,
	headerColor?: string | undefined,
	localesByLocale?: ModelTypes["GenericPageLocale"] | undefined,
	localesByContent?: ModelTypes["GenericPageLocale"] | undefined,
	localesBySeo?: ModelTypes["GenericPageLocale"] | undefined,
	localesByLink?: ModelTypes["GenericPageLocale"] | undefined,
	localesByLogo?: ModelTypes["GenericPageLocale"] | undefined,
	localesByImage?: ModelTypes["GenericPageLocale"] | undefined,
	paginateLocales: ModelTypes["GenericPageLocaleConnection"]
};
	["GenericPageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	theme?: ModelTypes["FieldMeta"] | undefined,
	headerColor?: ModelTypes["FieldMeta"] | undefined
};
	["Theme"]: {
		_meta?: ModelTypes["ThemeMeta"] | undefined,
	id: ModelTypes["UUID"],
	backgroundColor?: string | undefined,
	textColor?: string | undefined,
	name?: string | undefined,
	buttonBackgroundColor?: string | undefined,
	buttonTextColor?: string | undefined,
	buttonBackgroundHoverColor?: string | undefined,
	buttonTextHoverColor?: string | undefined,
	buttonBorderColor?: string | undefined,
	buttonBorderHoverColor?: string | undefined,
	headerMenuColor?: string | undefined
};
	["ThemeMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	backgroundColor?: ModelTypes["FieldMeta"] | undefined,
	textColor?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	buttonBackgroundColor?: ModelTypes["FieldMeta"] | undefined,
	buttonTextColor?: ModelTypes["FieldMeta"] | undefined,
	buttonBackgroundHoverColor?: ModelTypes["FieldMeta"] | undefined,
	buttonTextHoverColor?: ModelTypes["FieldMeta"] | undefined,
	buttonBorderColor?: ModelTypes["FieldMeta"] | undefined,
	buttonBorderHoverColor?: ModelTypes["FieldMeta"] | undefined,
	headerMenuColor?: ModelTypes["FieldMeta"] | undefined
};
	["GenericPageLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["GenericPageLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["GenericPageLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["GenericPageLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["GenericPageLocalesByLogoUniqueWhere"]: {
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["GenericPageLocalesByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["GenericPageLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GenericPageLocaleEdge"]>
};
	["GenericPageLocaleEdge"]: {
		node: ModelTypes["GenericPageLocale"]
};
	["Content"]: {
		_meta?: ModelTypes["ContentMeta"] | undefined,
	id: ModelTypes["UUID"],
	blocks: Array<ModelTypes["ContentBlock"]>,
	blocksByReferences?: ModelTypes["ContentBlock"] | undefined,
	paginateBlocks: ModelTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	blocks?: ModelTypes["FieldMeta"] | undefined
};
	["ContentBlock"]: {
		_meta?: ModelTypes["ContentBlockMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	json: string,
	content?: ModelTypes["Content"] | undefined,
	references: Array<ModelTypes["ContentReference"]>,
	referencesByLinkables?: ModelTypes["ContentReference"] | undefined,
	referencesByLink?: ModelTypes["ContentReference"] | undefined,
	referencesByMedia?: ModelTypes["ContentReference"] | undefined,
	paginateReferences: ModelTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	json?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	references?: ModelTypes["FieldMeta"] | undefined
};
	["ContentReference"]: {
		_meta?: ModelTypes["ContentReferenceMeta"] | undefined,
	id: ModelTypes["UUID"],
	type: ModelTypes["ContentReferenceType"],
	primaryText?: string | undefined,
	block?: ModelTypes["ContentBlock"] | undefined,
	image?: ModelTypes["Image"] | undefined,
	linkables: Array<ModelTypes["ContentReferenceLinkableItem"]>,
	secondaryText?: string | undefined,
	link?: ModelTypes["Link"] | undefined,
	media?: ModelTypes["MediumList"] | undefined,
	textList?: ModelTypes["TextList"] | undefined,
	carousel?: ModelTypes["Carousel"] | undefined,
	bonusBanner?: ModelTypes["BonusBannerLocale"] | undefined,
	sideBySide?: ModelTypes["SideBySide"] | undefined,
	gallery?: ModelTypes["Gallery"] | undefined,
	showBoolean?: boolean | undefined,
	isRed?: boolean | undefined,
	video?: ModelTypes["Video"] | undefined,
	linkablesByItem?: ModelTypes["ContentReferenceLinkableItem"] | undefined,
	paginateLinkables: ModelTypes["ContentReferenceLinkableItemConnection"]
};
	["ContentReferenceMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	primaryText?: ModelTypes["FieldMeta"] | undefined,
	block?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	linkables?: ModelTypes["FieldMeta"] | undefined,
	secondaryText?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	media?: ModelTypes["FieldMeta"] | undefined,
	textList?: ModelTypes["FieldMeta"] | undefined,
	carousel?: ModelTypes["FieldMeta"] | undefined,
	bonusBanner?: ModelTypes["FieldMeta"] | undefined,
	sideBySide?: ModelTypes["FieldMeta"] | undefined,
	gallery?: ModelTypes["FieldMeta"] | undefined,
	showBoolean?: ModelTypes["FieldMeta"] | undefined,
	isRed?: ModelTypes["FieldMeta"] | undefined,
	video?: ModelTypes["FieldMeta"] | undefined
};
	["Image"]: {
		_meta?: ModelTypes["ImageMeta"] | undefined,
	id: ModelTypes["UUID"],
	url: string,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined
};
	["ImageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	url?: ModelTypes["FieldMeta"] | undefined,
	width?: ModelTypes["FieldMeta"] | undefined,
	height?: ModelTypes["FieldMeta"] | undefined,
	size?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	alt?: ModelTypes["FieldMeta"] | undefined,
	fileName?: ModelTypes["FieldMeta"] | undefined,
	focalPointX?: ModelTypes["FieldMeta"] | undefined,
	focalPointY?: ModelTypes["FieldMeta"] | undefined
};
	["ContentReferenceLinkableItem"]: {
		_meta?: ModelTypes["ContentReferenceLinkableItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	item?: ModelTypes["Linkable"] | undefined,
	reference?: ModelTypes["ContentReference"] | undefined
};
	["ContentReferenceLinkableItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	item?: ModelTypes["FieldMeta"] | undefined,
	reference?: ModelTypes["FieldMeta"] | undefined
};
	["ContentReferenceLinkableItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	item?: ModelTypes["LinkableOrderBy"] | undefined,
	reference?: ModelTypes["ContentReferenceOrderBy"] | undefined
};
	["ContentReferenceOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	primaryText?: ModelTypes["OrderDirection"] | undefined,
	block?: ModelTypes["ContentBlockOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	secondaryText?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined,
	media?: ModelTypes["MediumListOrderBy"] | undefined,
	textList?: ModelTypes["TextListOrderBy"] | undefined,
	carousel?: ModelTypes["CarouselOrderBy"] | undefined,
	bonusBanner?: ModelTypes["BonusBannerLocaleOrderBy"] | undefined,
	sideBySide?: ModelTypes["SideBySideOrderBy"] | undefined,
	gallery?: ModelTypes["GalleryOrderBy"] | undefined,
	showBoolean?: ModelTypes["OrderDirection"] | undefined,
	isRed?: ModelTypes["OrderDirection"] | undefined,
	video?: ModelTypes["VideoOrderBy"] | undefined
};
	["ContentBlockOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	json?: ModelTypes["OrderDirection"] | undefined,
	content?: ModelTypes["ContentOrderBy"] | undefined
};
	["MediumListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["TextListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["CarouselOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	background?: ModelTypes["OrderDirection"] | undefined,
	squareImages?: ModelTypes["OrderDirection"] | undefined
};
	["BonusBannerLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["BonusBannerOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined,
	bannerName?: ModelTypes["OrderDirection"] | undefined
};
	["BonusBannerOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["SideBySideOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	background?: ModelTypes["OrderDirection"] | undefined,
	alignment?: ModelTypes["OrderDirection"] | undefined,
	mediumSize?: ModelTypes["OrderDirection"] | undefined
};
	["VideoOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	src?: ModelTypes["OrderDirection"] | undefined,
	width?: ModelTypes["OrderDirection"] | undefined,
	height?: ModelTypes["OrderDirection"] | undefined,
	size?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	videoInfo?: ModelTypes["OrderDirection"] | undefined,
	duration?: ModelTypes["OrderDirection"] | undefined,
	poster?: ModelTypes["ImageOrderBy"] | undefined
};
	["MediumList"]: {
		_meta?: ModelTypes["MediumListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["MediumItem"]>,
	paginateItems: ModelTypes["MediumItemConnection"]
};
	["MediumListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["MediumItem"]: {
		_meta?: ModelTypes["MediumItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["MediumList"] | undefined,
	medium?: ModelTypes["Medium"] | undefined
};
	["MediumItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	medium?: ModelTypes["FieldMeta"] | undefined
};
	["Medium"]: {
		_meta?: ModelTypes["MediumMeta"] | undefined,
	id: ModelTypes["UUID"],
	type: ModelTypes["MediumType"],
	image?: ModelTypes["Image"] | undefined,
	video?: ModelTypes["Video"] | undefined
};
	["MediumMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	video?: ModelTypes["FieldMeta"] | undefined
};
	["Video"]: {
		_meta?: ModelTypes["VideoMeta"] | undefined,
	id: ModelTypes["UUID"],
	src?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	videoInfo?: string | undefined,
	duration?: number | undefined,
	poster?: ModelTypes["Image"] | undefined
};
	["VideoMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	src?: ModelTypes["FieldMeta"] | undefined,
	width?: ModelTypes["FieldMeta"] | undefined,
	height?: ModelTypes["FieldMeta"] | undefined,
	size?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	videoInfo?: ModelTypes["FieldMeta"] | undefined,
	duration?: ModelTypes["FieldMeta"] | undefined,
	poster?: ModelTypes["FieldMeta"] | undefined
};
	["MediumItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["MediumListOrderBy"] | undefined,
	medium?: ModelTypes["MediumOrderBy"] | undefined
};
	["MediumOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	video?: ModelTypes["VideoOrderBy"] | undefined
};
	["MediumItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["MediumItemEdge"]>
};
	["MediumItemEdge"]: {
		node: ModelTypes["MediumItem"]
};
	["TextList"]: {
		_meta?: ModelTypes["TextListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["TextItem"]>,
	paginateItems: ModelTypes["TextItemConnection"]
};
	["TextListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["TextItem"]: {
		_meta?: ModelTypes["TextItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order?: number | undefined,
	text?: string | undefined,
	list?: ModelTypes["TextList"] | undefined,
	title?: string | undefined
};
	["TextItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined
};
	["TextItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["TextListOrderBy"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined
};
	["TextItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TextItemEdge"]>
};
	["TextItemEdge"]: {
		node: ModelTypes["TextItem"]
};
	["Carousel"]: {
		_meta?: ModelTypes["CarouselMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["CarouselItem"]>,
	background?: ModelTypes["Background"] | undefined,
	squareImages?: boolean | undefined,
	itemsByImage?: ModelTypes["CarouselItem"] | undefined,
	itemsByLinkUrl?: ModelTypes["CarouselItem"] | undefined,
	itemsByVideo?: ModelTypes["CarouselItem"] | undefined,
	paginateItems: ModelTypes["CarouselItemConnection"]
};
	["CarouselMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined,
	background?: ModelTypes["FieldMeta"] | undefined,
	squareImages?: ModelTypes["FieldMeta"] | undefined
};
	["CarouselItem"]: {
		_meta?: ModelTypes["CarouselItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order?: number | undefined,
	text?: string | undefined,
	list?: ModelTypes["Carousel"] | undefined,
	image?: ModelTypes["Image"] | undefined,
	name?: string | undefined,
	title?: string | undefined,
	linkUrl?: ModelTypes["Link"] | undefined,
	normalAspectRatio?: boolean | undefined,
	isImage?: boolean | undefined,
	video?: ModelTypes["Video"] | undefined
};
	["CarouselItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	linkUrl?: ModelTypes["FieldMeta"] | undefined,
	normalAspectRatio?: ModelTypes["FieldMeta"] | undefined,
	isImage?: ModelTypes["FieldMeta"] | undefined,
	video?: ModelTypes["FieldMeta"] | undefined
};
	["CarouselItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["CarouselOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	linkUrl?: ModelTypes["LinkOrderBy"] | undefined,
	normalAspectRatio?: ModelTypes["OrderDirection"] | undefined,
	isImage?: ModelTypes["OrderDirection"] | undefined,
	video?: ModelTypes["VideoOrderBy"] | undefined
};
	["CarouselItemsByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["CarouselItemsByLinkUrlUniqueWhere"]: {
	linkUrl?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["CarouselItemsByVideoUniqueWhere"]: {
	video?: ModelTypes["VideoUniqueWhere"] | undefined
};
	["VideoUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["CarouselItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["CarouselItemEdge"]>
};
	["CarouselItemEdge"]: {
		node: ModelTypes["CarouselItem"]
};
	["BonusBannerLocale"]: {
		_meta?: ModelTypes["BonusBannerLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["BonusBanner"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	tiles: Array<ModelTypes["Tile"]>,
	logo?: ModelTypes["Image"] | undefined,
	bannerName?: string | undefined,
	tilesByImage?: ModelTypes["Tile"] | undefined,
	tilesByLigthBoxMedia?: ModelTypes["Tile"] | undefined,
	paginateTiles: ModelTypes["TileConnection"]
};
	["BonusBannerLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	tiles?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined,
	bannerName?: ModelTypes["FieldMeta"] | undefined
};
	["BonusBanner"]: {
		_meta?: ModelTypes["BonusBannerMeta"] | undefined,
	id: ModelTypes["UUID"],
	locales: Array<ModelTypes["BonusBannerLocale"]>,
	localesByLocale?: ModelTypes["BonusBannerLocale"] | undefined,
	localesByTiles?: ModelTypes["BonusBannerLocale"] | undefined,
	localesByLogo?: ModelTypes["BonusBannerLocale"] | undefined,
	paginateLocales: ModelTypes["BonusBannerLocaleConnection"]
};
	["BonusBannerMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["BonusBannerLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["BonusBannerLocalesByTilesUniqueWhere"]: {
	tiles?: ModelTypes["TileUniqueWhere"] | undefined
};
	["BonusBannerLocalesByLogoUniqueWhere"]: {
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["BonusBannerLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["BonusBannerLocaleEdge"]>
};
	["BonusBannerLocaleEdge"]: {
		node: ModelTypes["BonusBannerLocale"]
};
	["Tile"]: {
		_meta?: ModelTypes["TileMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	text?: string | undefined,
	bonusBanner?: ModelTypes["BonusBannerLocale"] | undefined,
	image?: ModelTypes["Image"] | undefined,
	lightBoxTitle?: string | undefined,
	lightBoxText?: string | undefined,
	ligthBoxMedia?: ModelTypes["MediumList"] | undefined,
	lightBoxSectionTitle?: string | undefined,
	title?: string | undefined,
	lightBoxLinkLabel?: string | undefined,
	lightBoxForm?: ModelTypes["JobsFormLocale"] | undefined
};
	["TileMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	bonusBanner?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	lightBoxTitle?: ModelTypes["FieldMeta"] | undefined,
	lightBoxText?: ModelTypes["FieldMeta"] | undefined,
	ligthBoxMedia?: ModelTypes["FieldMeta"] | undefined,
	lightBoxSectionTitle?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	lightBoxLinkLabel?: ModelTypes["FieldMeta"] | undefined,
	lightBoxForm?: ModelTypes["FieldMeta"] | undefined
};
	["JobsFormLocale"]: {
		_meta?: ModelTypes["JobsFormLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	root?: ModelTypes["JobsForm"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	imageTextList?: ModelTypes["ImageTextList"] | undefined,
	minimalize?: string | undefined,
	logo?: ModelTypes["Image"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: ModelTypes["Image"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined
};
	["JobsFormLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	jobText?: ModelTypes["FieldMeta"] | undefined,
	genericText?: ModelTypes["FieldMeta"] | undefined,
	nameLabel?: ModelTypes["FieldMeta"] | undefined,
	emailLabel?: ModelTypes["FieldMeta"] | undefined,
	telefonLabel?: ModelTypes["FieldMeta"] | undefined,
	fileTitleLabel?: ModelTypes["FieldMeta"] | undefined,
	fileFormatLabel?: ModelTypes["FieldMeta"] | undefined,
	formTextLabel?: ModelTypes["FieldMeta"] | undefined,
	submitLabel?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	imageTextList?: ModelTypes["FieldMeta"] | undefined,
	minimalize?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined,
	successTitle?: ModelTypes["FieldMeta"] | undefined,
	successText?: ModelTypes["FieldMeta"] | undefined,
	successBtnLabel?: ModelTypes["FieldMeta"] | undefined,
	successImage?: ModelTypes["FieldMeta"] | undefined,
	successOtherJobsTitle?: ModelTypes["FieldMeta"] | undefined,
	successOtherJobsCategoryTitle?: ModelTypes["FieldMeta"] | undefined,
	successOtherJobsButtonTitle?: ModelTypes["FieldMeta"] | undefined,
	successOtherJobsSelectionTitle?: ModelTypes["FieldMeta"] | undefined,
	successOtherJobsSelectionYesButton?: ModelTypes["FieldMeta"] | undefined,
	successOtherJobsSelectionNoButton?: ModelTypes["FieldMeta"] | undefined,
	fileRemoveBtnLabel?: ModelTypes["FieldMeta"] | undefined,
	gdprLabel?: ModelTypes["FieldMeta"] | undefined
};
	["JobsForm"]: {
		_meta?: ModelTypes["JobsFormMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["JobsFormLocale"]>,
	fileIlustration?: ModelTypes["Image"] | undefined,
	localesByLocale?: ModelTypes["JobsFormLocale"] | undefined,
	localesByImageTextList?: ModelTypes["JobsFormLocale"] | undefined,
	localesByLogo?: ModelTypes["JobsFormLocale"] | undefined,
	localesBySuccessImage?: ModelTypes["JobsFormLocale"] | undefined,
	paginateLocales: ModelTypes["JobsFormLocaleConnection"]
};
	["JobsFormMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	fileIlustration?: ModelTypes["FieldMeta"] | undefined
};
	["JobsFormLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["JobsFormLocalesByImageTextListUniqueWhere"]: {
	imageTextList?: ModelTypes["ImageTextListUniqueWhere"] | undefined
};
	["JobsFormLocalesByLogoUniqueWhere"]: {
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["JobsFormLocalesBySuccessImageUniqueWhere"]: {
	successImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["JobsFormLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobsFormLocaleEdge"]>
};
	["JobsFormLocaleEdge"]: {
		node: ModelTypes["JobsFormLocale"]
};
	["ImageTextList"]: {
		_meta?: ModelTypes["ImageTextListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["ImageTextItem"]>,
	itemsByImage?: ModelTypes["ImageTextItem"] | undefined,
	paginateItems: ModelTypes["ImageTextItemConnection"]
};
	["ImageTextListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["ImageTextItem"]: {
		_meta?: ModelTypes["ImageTextItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order?: number | undefined,
	title?: string | undefined,
	list?: ModelTypes["ImageTextList"] | undefined,
	image?: ModelTypes["Image"] | undefined
};
	["ImageTextItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined
};
	["ImageTextItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["ImageTextListOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined
};
	["ImageTextListItemsByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["ImageTextItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ImageTextItemEdge"]>
};
	["ImageTextItemEdge"]: {
		node: ModelTypes["ImageTextItem"]
};
	["TileOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	bonusBanner?: ModelTypes["BonusBannerLocaleOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined,
	lightBoxTitle?: ModelTypes["OrderDirection"] | undefined,
	lightBoxText?: ModelTypes["OrderDirection"] | undefined,
	ligthBoxMedia?: ModelTypes["MediumListOrderBy"] | undefined,
	lightBoxSectionTitle?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	lightBoxLinkLabel?: ModelTypes["OrderDirection"] | undefined,
	lightBoxForm?: ModelTypes["JobsFormLocaleOrderBy"] | undefined
};
	["BonusBannerLocaleTilesByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["BonusBannerLocaleTilesByLigthBoxMediaUniqueWhere"]: {
	ligthBoxMedia?: ModelTypes["MediumListUniqueWhere"] | undefined
};
	["TileConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TileEdge"]>
};
	["TileEdge"]: {
		node: ModelTypes["Tile"]
};
	["SideBySide"]: {
		_meta?: ModelTypes["SideBySideMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["SideBySideItem"]>,
	background: ModelTypes["Background"],
	alignment: ModelTypes["ContentAlignment"],
	mediumSize: ModelTypes["MediumSize"],
	itemsByMedia?: ModelTypes["SideBySideItem"] | undefined,
	paginateItems: ModelTypes["SideBySideItemConnection"]
};
	["SideBySideMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined,
	background?: ModelTypes["FieldMeta"] | undefined,
	alignment?: ModelTypes["FieldMeta"] | undefined,
	mediumSize?: ModelTypes["FieldMeta"] | undefined
};
	["SideBySideItem"]: {
		_meta?: ModelTypes["SideBySideItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order?: number | undefined,
	title?: string | undefined,
	text?: string | undefined,
	list?: ModelTypes["SideBySide"] | undefined,
	media?: ModelTypes["MediumList"] | undefined,
	formButtonLabel?: string | undefined,
	type: ModelTypes["SideBySideItemType"],
	link?: ModelTypes["Link"] | undefined,
	jobsForm?: ModelTypes["JobsFormLocale"] | undefined,
	textNew?: string | undefined
};
	["SideBySideItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	media?: ModelTypes["FieldMeta"] | undefined,
	formButtonLabel?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	jobsForm?: ModelTypes["FieldMeta"] | undefined,
	textNew?: ModelTypes["FieldMeta"] | undefined
};
	["SideBySideItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["SideBySideOrderBy"] | undefined,
	media?: ModelTypes["MediumListOrderBy"] | undefined,
	formButtonLabel?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined,
	jobsForm?: ModelTypes["JobsFormLocaleOrderBy"] | undefined,
	textNew?: ModelTypes["OrderDirection"] | undefined
};
	["SideBySideItemsByMediaUniqueWhere"]: {
	media?: ModelTypes["MediumListUniqueWhere"] | undefined
};
	["SideBySideItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["SideBySideItemEdge"]>
};
	["SideBySideItemEdge"]: {
		node: ModelTypes["SideBySideItem"]
};
	["Gallery"]: {
		_meta?: ModelTypes["GalleryMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["GalleryItem"]>,
	itemsByImage?: ModelTypes["GalleryItem"] | undefined,
	paginateItems: ModelTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["GalleryItem"]: {
		_meta?: ModelTypes["GalleryItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order?: number | undefined,
	list?: ModelTypes["Gallery"] | undefined,
	image?: ModelTypes["Image"] | undefined
};
	["GalleryItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined
};
	["GalleryItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["GalleryOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined
};
	["GalleryItemsByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["GalleryItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GalleryItemEdge"]>
};
	["GalleryItemEdge"]: {
		node: ModelTypes["GalleryItem"]
};
	["ContentReferenceLinkablesByItemUniqueWhere"]: {
	item?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["ContentReferenceLinkableItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ContentReferenceLinkableItemEdge"]>
};
	["ContentReferenceLinkableItemEdge"]: {
		node: ModelTypes["ContentReferenceLinkableItem"]
};
	["ContentBlockReferencesByLinkablesUniqueWhere"]: {
	linkables?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["ContentBlockReferencesByMediaUniqueWhere"]: {
	media?: ModelTypes["MediumListUniqueWhere"] | undefined
};
	["ContentReferenceConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
		node: ModelTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?: ModelTypes["ContentReferenceUniqueWhere"] | undefined
};
	["ContentBlockConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
		node: ModelTypes["ContentBlock"]
};
	["Seo"]: {
		_meta?: ModelTypes["SeoMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: ModelTypes["Image"] | undefined
};
	["SeoMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	description?: ModelTypes["FieldMeta"] | undefined,
	ogTitle?: ModelTypes["FieldMeta"] | undefined,
	ogDescription?: ModelTypes["FieldMeta"] | undefined,
	noIndex?: ModelTypes["FieldMeta"] | undefined,
	noFollow?: ModelTypes["FieldMeta"] | undefined,
	ogImage?: ModelTypes["FieldMeta"] | undefined
};
	["BusinessPageLocale"]: {
		_meta?: ModelTypes["BusinessPageLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["BusinessPage"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: ModelTypes["Image"] | undefined,
	stickyBar?: ModelTypes["StickyBar"] | undefined,
	infoBox?: ModelTypes["InfoBox"] | undefined
};
	["BusinessPageLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	subtitle?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	stickyBar?: ModelTypes["FieldMeta"] | undefined,
	infoBox?: ModelTypes["FieldMeta"] | undefined
};
	["BusinessPage"]: {
		_meta?: ModelTypes["BusinessPageMeta"] | undefined,
	id: ModelTypes["UUID"],
	locales: Array<ModelTypes["BusinessPageLocale"]>,
	theme?: ModelTypes["Theme"] | undefined,
	isLokal?: boolean | undefined,
	tabidooId?: string | undefined,
	headerColor?: string | undefined,
	recruitisOfficeId?: string | undefined,
	localesByLocale?: ModelTypes["BusinessPageLocale"] | undefined,
	localesByContent?: ModelTypes["BusinessPageLocale"] | undefined,
	localesBySeo?: ModelTypes["BusinessPageLocale"] | undefined,
	localesByLink?: ModelTypes["BusinessPageLocale"] | undefined,
	localesByImage?: ModelTypes["BusinessPageLocale"] | undefined,
	paginateLocales: ModelTypes["BusinessPageLocaleConnection"]
};
	["BusinessPageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	theme?: ModelTypes["FieldMeta"] | undefined,
	isLokal?: ModelTypes["FieldMeta"] | undefined,
	tabidooId?: ModelTypes["FieldMeta"] | undefined,
	headerColor?: ModelTypes["FieldMeta"] | undefined,
	recruitisOfficeId?: ModelTypes["FieldMeta"] | undefined
};
	["BusinessPageLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["BusinessPageLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["BusinessPageLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["BusinessPageLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["BusinessPageLocalesByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["BusinessPageLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["BusinessPageLocaleEdge"]>
};
	["BusinessPageLocaleEdge"]: {
		node: ModelTypes["BusinessPageLocale"]
};
	["StickyBar"]: {
		_meta?: ModelTypes["StickyBarMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	link?: ModelTypes["Link"] | undefined,
	formButtonLabel?: string | undefined,
	jobsForm?: ModelTypes["JobsFormLocale"] | undefined
};
	["StickyBarMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	formButtonLabel?: ModelTypes["FieldMeta"] | undefined,
	jobsForm?: ModelTypes["FieldMeta"] | undefined
};
	["InfoBox"]: {
		_meta?: ModelTypes["InfoBoxMeta"] | undefined,
	id: ModelTypes["UUID"],
	logoSize: ModelTypes["LogoSize"],
	logo?: ModelTypes["Image"] | undefined,
	locales: Array<ModelTypes["InfoBoxLocale"]>,
	localesByLocale?: ModelTypes["InfoBoxLocale"] | undefined,
	paginateLocales: ModelTypes["InfoBoxLocaleConnection"]
};
	["InfoBoxMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	logoSize?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["InfoBoxLocale"]: {
		_meta?: ModelTypes["InfoBoxLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	root?: ModelTypes["InfoBox"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	openingHours?: ModelTypes["TextList"] | undefined,
	addressLink?: string | undefined
};
	["InfoBoxLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	address?: ModelTypes["FieldMeta"] | undefined,
	web?: ModelTypes["FieldMeta"] | undefined,
	instagram?: ModelTypes["FieldMeta"] | undefined,
	facebook?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	openingHours?: ModelTypes["FieldMeta"] | undefined,
	addressLink?: ModelTypes["FieldMeta"] | undefined
};
	["InfoBoxLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	address?: ModelTypes["OrderDirection"] | undefined,
	web?: ModelTypes["OrderDirection"] | undefined,
	instagram?: ModelTypes["OrderDirection"] | undefined,
	facebook?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["InfoBoxOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	openingHours?: ModelTypes["TextListOrderBy"] | undefined,
	addressLink?: ModelTypes["OrderDirection"] | undefined
};
	["InfoBoxLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["InfoBoxLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["InfoBoxLocaleEdge"]>
};
	["InfoBoxLocaleEdge"]: {
		node: ModelTypes["InfoBoxLocale"]
};
	["JobPageLocale"]: {
		_meta?: ModelTypes["JobPageLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["JobPage"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	image?: ModelTypes["Image"] | undefined,
	keyInfo?: ModelTypes["KeyInfoList"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	email?: string | undefined,
	stickyBar?: ModelTypes["StickyBar"] | undefined,
	mobileImage?: ModelTypes["Image"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined
};
	["JobPageLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined,
	keyInfo?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	email?: ModelTypes["FieldMeta"] | undefined,
	stickyBar?: ModelTypes["FieldMeta"] | undefined,
	mobileImage?: ModelTypes["FieldMeta"] | undefined,
	isSyncedToTabidoo?: ModelTypes["FieldMeta"] | undefined,
	tabidooId?: ModelTypes["FieldMeta"] | undefined,
	recruitisJobId?: ModelTypes["FieldMeta"] | undefined
};
	["JobPage"]: {
		_meta?: ModelTypes["JobPageMeta"] | undefined,
	id: ModelTypes["UUID"],
	locales: Array<ModelTypes["JobPageLocale"]>,
	theme?: ModelTypes["Theme"] | undefined,
	contractType?: ModelTypes["ContractType"] | undefined,
	jobCity?: ModelTypes["JobCity"] | undefined,
	isActive?: boolean | undefined,
	jobPosition?: ModelTypes["JobPosition"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: ModelTypes["BusinessPage"] | undefined,
	headerColor?: string | undefined,
	siteType: ModelTypes["SiteType"],
	isHiddenFromListing?: boolean | undefined,
	localesByLocale?: ModelTypes["JobPageLocale"] | undefined,
	localesByImage?: ModelTypes["JobPageLocale"] | undefined,
	localesByKeyInfo?: ModelTypes["JobPageLocale"] | undefined,
	localesByContent?: ModelTypes["JobPageLocale"] | undefined,
	localesBySeo?: ModelTypes["JobPageLocale"] | undefined,
	localesByLink?: ModelTypes["JobPageLocale"] | undefined,
	localesByMobileImage?: ModelTypes["JobPageLocale"] | undefined,
	paginateLocales: ModelTypes["JobPageLocaleConnection"]
};
	["JobPageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	theme?: ModelTypes["FieldMeta"] | undefined,
	contractType?: ModelTypes["FieldMeta"] | undefined,
	jobCity?: ModelTypes["FieldMeta"] | undefined,
	isActive?: ModelTypes["FieldMeta"] | undefined,
	jobPosition?: ModelTypes["FieldMeta"] | undefined,
	publishedAt?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	isSyncedToTabidoo?: ModelTypes["FieldMeta"] | undefined,
	business?: ModelTypes["FieldMeta"] | undefined,
	headerColor?: ModelTypes["FieldMeta"] | undefined,
	siteType?: ModelTypes["FieldMeta"] | undefined,
	isHiddenFromListing?: ModelTypes["FieldMeta"] | undefined
};
	["ContractType"]: {
		_meta?: ModelTypes["ContractTypeMeta"] | undefined,
	id: ModelTypes["UUID"],
	locales: Array<ModelTypes["ContractTypeLocale"]>,
	localesByLocale?: ModelTypes["ContractTypeLocale"] | undefined,
	paginateLocales: ModelTypes["ContractTypeLocaleConnection"]
};
	["ContractTypeMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["ContractTypeLocale"]: {
		_meta?: ModelTypes["ContractTypeLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	type?: string | undefined,
	root?: ModelTypes["ContractType"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	slug: string
};
	["ContractTypeLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	slug?: ModelTypes["FieldMeta"] | undefined
};
	["ContractTypeLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["ContractTypeOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	slug?: ModelTypes["OrderDirection"] | undefined
};
	["ContractTypeLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["ContractTypeLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ContractTypeLocaleEdge"]>
};
	["ContractTypeLocaleEdge"]: {
		node: ModelTypes["ContractTypeLocale"]
};
	["JobCity"]: {
		_meta?: ModelTypes["JobCityMeta"] | undefined,
	id: ModelTypes["UUID"],
	locales: Array<ModelTypes["JobCityLocale"]>,
	localesByLocale?: ModelTypes["JobCityLocale"] | undefined,
	paginateLocales: ModelTypes["JobCityLocaleConnection"]
};
	["JobCityMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["JobCityLocale"]: {
		_meta?: ModelTypes["JobCityLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["JobCity"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	name?: string | undefined,
	slug: string
};
	["JobCityLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	slug?: ModelTypes["FieldMeta"] | undefined
};
	["JobCityLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["JobCityOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	slug?: ModelTypes["OrderDirection"] | undefined
};
	["JobCityLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["JobCityLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobCityLocaleEdge"]>
};
	["JobCityLocaleEdge"]: {
		node: ModelTypes["JobCityLocale"]
};
	["JobPosition"]: {
		_meta?: ModelTypes["JobPositionMeta"] | undefined,
	id: ModelTypes["UUID"],
	locales: Array<ModelTypes["JobPositionLocale"]>,
	jobs: Array<ModelTypes["JobPage"]>,
	localesByLocale?: ModelTypes["JobPositionLocale"] | undefined,
	jobsByLocales?: ModelTypes["JobPage"] | undefined,
	paginateLocales: ModelTypes["JobPositionLocaleConnection"],
	paginateJobs: ModelTypes["JobPageConnection"]
};
	["JobPositionMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	jobs?: ModelTypes["FieldMeta"] | undefined
};
	["JobPositionLocale"]: {
		_meta?: ModelTypes["JobPositionLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	type?: string | undefined,
	root?: ModelTypes["JobPosition"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	slug: string
};
	["JobPositionLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	slug?: ModelTypes["FieldMeta"] | undefined
};
	["JobPositionLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["JobPositionOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	slug?: ModelTypes["OrderDirection"] | undefined
};
	["JobPositionLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["JobPositionJobsByLocalesUniqueWhere"]: {
	locales?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined
};
	["JobPositionLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobPositionLocaleEdge"]>
};
	["JobPositionLocaleEdge"]: {
		node: ModelTypes["JobPositionLocale"]
};
	["JobPageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobPageEdge"]>
};
	["JobPageEdge"]: {
		node: ModelTypes["JobPage"]
};
	["JobPageLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["JobPageLocalesByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["JobPageLocalesByKeyInfoUniqueWhere"]: {
	keyInfo?: ModelTypes["KeyInfoListUniqueWhere"] | undefined
};
	["JobPageLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["JobPageLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["JobPageLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["JobPageLocalesByMobileImageUniqueWhere"]: {
	mobileImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["JobPageLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobPageLocaleEdge"]>
};
	["JobPageLocaleEdge"]: {
		node: ModelTypes["JobPageLocale"]
};
	["KeyInfoList"]: {
		_meta?: ModelTypes["KeyInfoListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["KeyInfoItem"]>,
	paginateItems: ModelTypes["KeyInfoItemConnection"]
};
	["KeyInfoListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["KeyInfoItem"]: {
		_meta?: ModelTypes["KeyInfoItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order?: number | undefined,
	keyInfo?: string | undefined,
	list?: ModelTypes["KeyInfoList"] | undefined,
	icon?: ModelTypes["Icon"] | undefined
};
	["KeyInfoItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	keyInfo?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	icon?: ModelTypes["FieldMeta"] | undefined
};
	["Icon"]: {
		_meta?: ModelTypes["IconMeta"] | undefined,
	id: ModelTypes["UUID"],
	name?: string | undefined,
	icon?: ModelTypes["Image"] | undefined
};
	["IconMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	icon?: ModelTypes["FieldMeta"] | undefined
};
	["KeyInfoItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	keyInfo?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["KeyInfoListOrderBy"] | undefined,
	icon?: ModelTypes["IconOrderBy"] | undefined
};
	["IconOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	icon?: ModelTypes["ImageOrderBy"] | undefined
};
	["KeyInfoItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["KeyInfoItemEdge"]>
};
	["KeyInfoItemEdge"]: {
		node: ModelTypes["KeyInfoItem"]
};
	["HomePageLocale"]: {
		_meta?: ModelTypes["HomePageLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	root?: ModelTypes["HomePage"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	button?: ModelTypes["Link"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	logo?: ModelTypes["Image"] | undefined,
	siteSwitcher?: ModelTypes["SiteSwitcher"] | undefined,
	gallery?: ModelTypes["Gallery"] | undefined,
	stickyBar?: ModelTypes["StickyBar"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["Gallery"] | undefined
};
	["HomePageLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	button?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined,
	siteSwitcher?: ModelTypes["FieldMeta"] | undefined,
	gallery?: ModelTypes["FieldMeta"] | undefined,
	stickyBar?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	ilustration?: ModelTypes["FieldMeta"] | undefined
};
	["HomePage"]: {
		_meta?: ModelTypes["HomePageMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["HomePageLocale"]>,
	theme?: ModelTypes["Theme"] | undefined,
	localesByLocale?: ModelTypes["HomePageLocale"] | undefined,
	localesByButton?: ModelTypes["HomePageLocale"] | undefined,
	localesByContent?: ModelTypes["HomePageLocale"] | undefined,
	localesBySeo?: ModelTypes["HomePageLocale"] | undefined,
	localesByLink?: ModelTypes["HomePageLocale"] | undefined,
	localesByLogo?: ModelTypes["HomePageLocale"] | undefined,
	localesBySiteSwitcher?: ModelTypes["HomePageLocale"] | undefined,
	localesByIlustration?: ModelTypes["HomePageLocale"] | undefined,
	paginateLocales: ModelTypes["HomePageLocaleConnection"]
};
	["HomePageMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	theme?: ModelTypes["FieldMeta"] | undefined
};
	["HomePageLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["HomePageLocalesByButtonUniqueWhere"]: {
	button?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["HomePageLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["HomePageLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["HomePageLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["HomePageLocalesByLogoUniqueWhere"]: {
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["HomePageLocalesBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ModelTypes["SiteSwitcherUniqueWhere"] | undefined
};
	["HomePageLocalesByIlustrationUniqueWhere"]: {
	ilustration?: ModelTypes["GalleryUniqueWhere"] | undefined
};
	["HomePageLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["HomePageLocaleEdge"]>
};
	["HomePageLocaleEdge"]: {
		node: ModelTypes["HomePageLocale"]
};
	["SiteSwitcher"]: {
		_meta?: ModelTypes["SiteSwitcherMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	link?: ModelTypes["Link"] | undefined,
	theme?: ModelTypes["Theme"] | undefined,
	headerColor?: string | undefined
};
	["SiteSwitcherMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	theme?: ModelTypes["FieldMeta"] | undefined,
	headerColor?: ModelTypes["FieldMeta"] | undefined
};
	["HomePageLokalLocale"]: {
		_meta?: ModelTypes["HomePageLokalLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	root?: ModelTypes["HomePageLokal"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	logo?: ModelTypes["Image"] | undefined,
	button?: ModelTypes["Link"] | undefined,
	content?: ModelTypes["Content"] | undefined,
	seo?: ModelTypes["Seo"] | undefined,
	link?: ModelTypes["Linkable"] | undefined,
	siteSwitcher?: ModelTypes["SiteSwitcher"] | undefined,
	gallery?: ModelTypes["Gallery"] | undefined,
	stickyBar?: ModelTypes["StickyBar"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["Gallery"] | undefined
};
	["HomePageLokalLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined,
	button?: ModelTypes["FieldMeta"] | undefined,
	content?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined,
	siteSwitcher?: ModelTypes["FieldMeta"] | undefined,
	gallery?: ModelTypes["FieldMeta"] | undefined,
	stickyBar?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	ilustration?: ModelTypes["FieldMeta"] | undefined
};
	["HomePageLokal"]: {
		_meta?: ModelTypes["HomePageLokalMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["HomePageLokalLocale"]>,
	theme?: ModelTypes["Theme"] | undefined,
	localesByLocale?: ModelTypes["HomePageLokalLocale"] | undefined,
	localesByLogo?: ModelTypes["HomePageLokalLocale"] | undefined,
	localesByButton?: ModelTypes["HomePageLokalLocale"] | undefined,
	localesByContent?: ModelTypes["HomePageLokalLocale"] | undefined,
	localesBySeo?: ModelTypes["HomePageLokalLocale"] | undefined,
	localesByLink?: ModelTypes["HomePageLokalLocale"] | undefined,
	localesBySiteSwitcher?: ModelTypes["HomePageLokalLocale"] | undefined,
	localesByIlustration?: ModelTypes["HomePageLokalLocale"] | undefined,
	paginateLocales: ModelTypes["HomePageLokalLocaleConnection"]
};
	["HomePageLokalMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	theme?: ModelTypes["FieldMeta"] | undefined
};
	["HomePageLokalLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["HomePageLokalLocalesByLogoUniqueWhere"]: {
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["HomePageLokalLocalesByButtonUniqueWhere"]: {
	button?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["HomePageLokalLocalesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["HomePageLokalLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["HomePageLokalLocalesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["HomePageLokalLocalesBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ModelTypes["SiteSwitcherUniqueWhere"] | undefined
};
	["HomePageLokalLocalesByIlustrationUniqueWhere"]: {
	ilustration?: ModelTypes["GalleryUniqueWhere"] | undefined
};
	["HomePageLokalLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["HomePageLokalLocaleEdge"]>
};
	["HomePageLokalLocaleEdge"]: {
		node: ModelTypes["HomePageLokalLocale"]
};
	["FooterLinkOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined
};
	["RecommendationFormLocale"]: {
		_meta?: ModelTypes["RecommendationFormLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	root?: ModelTypes["RecommendationForm"] | undefined,
	locale?: ModelTypes["Locale"] | undefined
};
	["RecommendationFormLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	subtitle?: ModelTypes["FieldMeta"] | undefined,
	yourEmailLabel?: ModelTypes["FieldMeta"] | undefined,
	theirEmailLabel?: ModelTypes["FieldMeta"] | undefined,
	yourName?: ModelTypes["FieldMeta"] | undefined,
	sendBtnLabel?: ModelTypes["FieldMeta"] | undefined,
	successTitle?: ModelTypes["FieldMeta"] | undefined,
	successSubtitle?: ModelTypes["FieldMeta"] | undefined,
	successButtonClose?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined
};
	["RecommendationForm"]: {
		_meta?: ModelTypes["RecommendationFormMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["RecommendationFormLocale"]>,
	successImage?: ModelTypes["Image"] | undefined,
	localesByLocale?: ModelTypes["RecommendationFormLocale"] | undefined,
	paginateLocales: ModelTypes["RecommendationFormLocaleConnection"]
};
	["RecommendationFormMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	successImage?: ModelTypes["FieldMeta"] | undefined
};
	["RecommendationFormLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["RecommendationFormLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["RecommendationFormLocaleEdge"]>
};
	["RecommendationFormLocaleEdge"]: {
		node: ModelTypes["RecommendationFormLocale"]
};
	["FooterLinkConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FooterLinkEdge"]>
};
	["FooterLinkEdge"]: {
		node: ModelTypes["FooterLink"]
};
	["HeaderLocale"]: {
		_meta?: ModelTypes["HeaderLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["Header"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business: Array<ModelTypes["Business"]>,
	lokalEnterprise: Array<ModelTypes["Business"]>,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: ModelTypes["Link"] | undefined,
	lokalLink?: ModelTypes["Link"] | undefined,
	paginateBusiness: ModelTypes["BusinessConnection"],
	paginateLokalEnterprise: ModelTypes["BusinessConnection"]
};
	["HeaderLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	menuLabel?: ModelTypes["FieldMeta"] | undefined,
	menuTitle?: ModelTypes["FieldMeta"] | undefined,
	menuText?: ModelTypes["FieldMeta"] | undefined,
	business?: ModelTypes["FieldMeta"] | undefined,
	lokalEnterprise?: ModelTypes["FieldMeta"] | undefined,
	businessSectionTitle?: ModelTypes["FieldMeta"] | undefined,
	lokalSectionTitle?: ModelTypes["FieldMeta"] | undefined,
	businessLink?: ModelTypes["FieldMeta"] | undefined,
	lokalLink?: ModelTypes["FieldMeta"] | undefined
};
	["Header"]: {
		_meta?: ModelTypes["HeaderMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["HeaderLocale"]>,
	logo?: ModelTypes["Image"] | undefined,
	logoMenu?: ModelTypes["Image"] | undefined,
	localesByLocale?: ModelTypes["HeaderLocale"] | undefined,
	localesByBusinessLink?: ModelTypes["HeaderLocale"] | undefined,
	localesByLokalLink?: ModelTypes["HeaderLocale"] | undefined,
	paginateLocales: ModelTypes["HeaderLocaleConnection"]
};
	["HeaderMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined,
	logoMenu?: ModelTypes["FieldMeta"] | undefined
};
	["HeaderLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["HeaderOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	menuLabel?: ModelTypes["OrderDirection"] | undefined,
	menuTitle?: ModelTypes["OrderDirection"] | undefined,
	menuText?: ModelTypes["OrderDirection"] | undefined,
	businessSectionTitle?: ModelTypes["OrderDirection"] | undefined,
	lokalSectionTitle?: ModelTypes["OrderDirection"] | undefined,
	businessLink?: ModelTypes["LinkOrderBy"] | undefined,
	lokalLink?: ModelTypes["LinkOrderBy"] | undefined
};
	["HeaderOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined,
	logoMenu?: ModelTypes["ImageOrderBy"] | undefined
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["HeaderLocalesByBusinessLinkUniqueWhere"]: {
	businessLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["HeaderLocalesByLokalLinkUniqueWhere"]: {
	lokalLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["HeaderLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["HeaderLocaleEdge"]>
};
	["HeaderLocaleEdge"]: {
		node: ModelTypes["HeaderLocale"]
};
	["Business"]: {
		_meta?: ModelTypes["BusinessMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	logo?: ModelTypes["Image"] | undefined,
	link?: ModelTypes["Link"] | undefined
};
	["BusinessMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined
};
	["BusinessOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined
};
	["BusinessConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["BusinessEdge"]>
};
	["BusinessEdge"]: {
		node: ModelTypes["Business"]
};
	["SeoDefaultLocale"]: {
		_meta?: ModelTypes["SeoDefaultLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	root?: ModelTypes["SeoDefault"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	seo?: ModelTypes["Seo"] | undefined
};
	["SeoDefaultLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	seo?: ModelTypes["FieldMeta"] | undefined
};
	["SeoDefault"]: {
		_meta?: ModelTypes["SeoDefaultMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["SeoDefaultLocale"]>,
	localesByLocale?: ModelTypes["SeoDefaultLocale"] | undefined,
	localesBySeo?: ModelTypes["SeoDefaultLocale"] | undefined,
	paginateLocales: ModelTypes["SeoDefaultLocaleConnection"]
};
	["SeoDefaultMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["SeoDefaultLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["SeoDefaultOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined
};
	["SeoDefaultOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["SeoDefaultLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["SeoDefaultLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["SeoDefaultLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["SeoDefaultLocaleEdge"]>
};
	["SeoDefaultLocaleEdge"]: {
		node: ModelTypes["SeoDefaultLocale"]
};
	["JobsFilterLocale"]: {
		_meta?: ModelTypes["JobsFilterLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	root?: ModelTypes["JobsFilter"] | undefined,
	locale?: ModelTypes["Locale"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: ModelTypes["JobsFormLocale"] | undefined,
	bannerImage?: ModelTypes["Image"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: ModelTypes["Image"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined
};
	["JobsFilterLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	jobPositionLabel?: ModelTypes["FieldMeta"] | undefined,
	jobContractLabel?: ModelTypes["FieldMeta"] | undefined,
	jobCityLabel?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined,
	bannerTitle?: ModelTypes["FieldMeta"] | undefined,
	bannerFormLabel?: ModelTypes["FieldMeta"] | undefined,
	bannerJobsForm?: ModelTypes["FieldMeta"] | undefined,
	bannerImage?: ModelTypes["FieldMeta"] | undefined,
	noJobTitle?: ModelTypes["FieldMeta"] | undefined,
	noJobBtnLabel?: ModelTypes["FieldMeta"] | undefined,
	noJobImage?: ModelTypes["FieldMeta"] | undefined,
	noJobTitleForSpecificBusiness?: ModelTypes["FieldMeta"] | undefined,
	deactivatedJob?: ModelTypes["FieldMeta"] | undefined
};
	["JobsFilter"]: {
		_meta?: ModelTypes["JobsFilterMeta"] | undefined,
	id: ModelTypes["UUID"],
	unique: ModelTypes["One"],
	locales: Array<ModelTypes["JobsFilterLocale"]>,
	localesByLocale?: ModelTypes["JobsFilterLocale"] | undefined,
	localesByBannerJobsForm?: ModelTypes["JobsFilterLocale"] | undefined,
	localesByBannerImage?: ModelTypes["JobsFilterLocale"] | undefined,
	localesByNoJobImage?: ModelTypes["JobsFilterLocale"] | undefined,
	paginateLocales: ModelTypes["JobsFilterLocaleConnection"]
};
	["JobsFilterMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	unique?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined
};
	["JobsFilterLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	jobPositionLabel?: ModelTypes["OrderDirection"] | undefined,
	jobContractLabel?: ModelTypes["OrderDirection"] | undefined,
	jobCityLabel?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["JobsFilterOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	bannerTitle?: ModelTypes["OrderDirection"] | undefined,
	bannerFormLabel?: ModelTypes["OrderDirection"] | undefined,
	bannerJobsForm?: ModelTypes["JobsFormLocaleOrderBy"] | undefined,
	bannerImage?: ModelTypes["ImageOrderBy"] | undefined,
	noJobTitle?: ModelTypes["OrderDirection"] | undefined,
	noJobBtnLabel?: ModelTypes["OrderDirection"] | undefined,
	noJobImage?: ModelTypes["ImageOrderBy"] | undefined,
	noJobTitleForSpecificBusiness?: ModelTypes["OrderDirection"] | undefined,
	deactivatedJob?: ModelTypes["OrderDirection"] | undefined
};
	["JobsFilterOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["JobsFilterLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["JobsFilterLocalesByBannerJobsFormUniqueWhere"]: {
	bannerJobsForm?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined
};
	["JobsFilterLocalesByBannerImageUniqueWhere"]: {
	bannerImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["JobsFilterLocalesByNoJobImageUniqueWhere"]: {
	noJobImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["JobsFilterLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobsFilterLocaleEdge"]>
};
	["JobsFilterLocaleEdge"]: {
		node: ModelTypes["JobsFilterLocale"]
};
	["GeneralLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["GeneralOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined,
	seo?: ModelTypes["SeoOrderBy"] | undefined,
	cornerBanner?: ModelTypes["CornerBannerOrderBy"] | undefined
};
	["GeneralOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	unique?: ModelTypes["OrderDirection"] | undefined
};
	["CornerBannerOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	isActive?: ModelTypes["OrderDirection"] | undefined,
	title?: ModelTypes["OrderDirection"] | undefined,
	text?: ModelTypes["OrderDirection"] | undefined,
	logo?: ModelTypes["ImageOrderBy"] | undefined,
	link?: ModelTypes["LinkOrderBy"] | undefined
};
	["TranslationLocale"]: {
		_meta?: ModelTypes["TranslationLocaleMeta"] | undefined,
	id: ModelTypes["UUID"],
	value: string,
	root?: ModelTypes["Translation"] | undefined,
	locale?: ModelTypes["Locale"] | undefined
};
	["TranslationLocaleMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	value?: ModelTypes["FieldMeta"] | undefined,
	root?: ModelTypes["FieldMeta"] | undefined,
	locale?: ModelTypes["FieldMeta"] | undefined
};
	["Translation"]: {
		_meta?: ModelTypes["TranslationMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	key: string,
	locales: Array<ModelTypes["TranslationLocale"]>,
	isTextarea: boolean,
	localesByLocale?: ModelTypes["TranslationLocale"] | undefined,
	paginateLocales: ModelTypes["TranslationLocaleConnection"]
};
	["TranslationMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	key?: ModelTypes["FieldMeta"] | undefined,
	locales?: ModelTypes["FieldMeta"] | undefined,
	isTextarea?: ModelTypes["FieldMeta"] | undefined
};
	["TranslationLocaleOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	value?: ModelTypes["OrderDirection"] | undefined,
	root?: ModelTypes["TranslationOrderBy"] | undefined,
	locale?: ModelTypes["LocaleOrderBy"] | undefined
};
	["TranslationOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	key?: ModelTypes["OrderDirection"] | undefined,
	isTextarea?: ModelTypes["OrderDirection"] | undefined
};
	["TranslationLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["TranslationLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TranslationLocaleEdge"]>
};
	["TranslationLocaleEdge"]: {
		node: ModelTypes["TranslationLocale"]
};
	["LocaleFootersByRootUniqueWhere"]: {
	root?: ModelTypes["FooterUniqueWhere"] | undefined
};
	["LocaleFootersByTermsAndConditionsUniqueWhere"]: {
	termsAndConditions?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleFootersByBannerImageUniqueWhere"]: {
	bannerImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleFootersByBannerLinkUniqueWhere"]: {
	bannerLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleFootersByJobsFormUniqueWhere"]: {
	jobsForm?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined
};
	["LocaleFootersByCopyrightLinkUniqueWhere"]: {
	copyrightLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleFootersByRecommendationFormUniqueWhere"]: {
	recommendationForm?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined
};
	["LocaleFootersByBannerSecondLinkUniqueWhere"]: {
	bannerSecondLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleFootersByInstagramLinkUniqueWhere"]: {
	instagramLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleGenericPagesByRootUniqueWhere"]: {
	root?: ModelTypes["GenericPageUniqueWhere"] | undefined
};
	["LocaleGenericPagesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleGenericPagesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleGenericPagesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleGenericPagesByLogoUniqueWhere"]: {
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleGenericPagesByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleHeadersByRootUniqueWhere"]: {
	root?: ModelTypes["HeaderUniqueWhere"] | undefined
};
	["LocaleHeadersByBusinessLinkUniqueWhere"]: {
	businessLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleHeadersByLokalLinkUniqueWhere"]: {
	lokalLink?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleSeoDefaultsByRootUniqueWhere"]: {
	root?: ModelTypes["SeoDefaultUniqueWhere"] | undefined
};
	["LocaleSeoDefaultsBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleBusinessPagesByRootUniqueWhere"]: {
	root?: ModelTypes["BusinessPageUniqueWhere"] | undefined
};
	["LocaleBusinessPagesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleBusinessPagesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleBusinessPagesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleBusinessPagesByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleJobPagesByRootUniqueWhere"]: {
	root?: ModelTypes["JobPageUniqueWhere"] | undefined
};
	["LocaleJobPagesByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleJobPagesByKeyInfoUniqueWhere"]: {
	keyInfo?: ModelTypes["KeyInfoListUniqueWhere"] | undefined
};
	["LocaleJobPagesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleJobPagesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleJobPagesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleJobPagesByMobileImageUniqueWhere"]: {
	mobileImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleContractTypesByRootUniqueWhere"]: {
	root?: ModelTypes["ContractTypeUniqueWhere"] | undefined
};
	["LocaleContractTypesBySlugUniqueWhere"]: {
	slug?: string | undefined
};
	["LocaleJobCitiesByRootUniqueWhere"]: {
	root?: ModelTypes["JobCityUniqueWhere"] | undefined
};
	["LocaleJobCitiesBySlugUniqueWhere"]: {
	slug?: string | undefined
};
	["LocaleJobPositionsByRootUniqueWhere"]: {
	root?: ModelTypes["JobPositionUniqueWhere"] | undefined
};
	["LocaleJobPositionsBySlugUniqueWhere"]: {
	slug?: string | undefined
};
	["LocaleHomePagesByRootUniqueWhere"]: {
	root?: ModelTypes["HomePageUniqueWhere"] | undefined
};
	["LocaleHomePagesByButtonUniqueWhere"]: {
	button?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleHomePagesByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleHomePagesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleHomePagesByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleHomePagesByLogoUniqueWhere"]: {
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleHomePagesBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ModelTypes["SiteSwitcherUniqueWhere"] | undefined
};
	["LocaleHomePagesByIlustrationUniqueWhere"]: {
	ilustration?: ModelTypes["GalleryUniqueWhere"] | undefined
};
	["LocaleBonusBannersByRootUniqueWhere"]: {
	root?: ModelTypes["BonusBannerUniqueWhere"] | undefined
};
	["LocaleBonusBannersByTilesUniqueWhere"]: {
	tiles?: ModelTypes["TileUniqueWhere"] | undefined
};
	["LocaleBonusBannersByLogoUniqueWhere"]: {
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByRootUniqueWhere"]: {
	root?: ModelTypes["HomePageLokalUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByLogoUniqueWhere"]: {
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByButtonUniqueWhere"]: {
	button?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByContentUniqueWhere"]: {
	content?: ModelTypes["ContentUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByLinkUniqueWhere"]: {
	link?: ModelTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsBySiteSwitcherUniqueWhere"]: {
	siteSwitcher?: ModelTypes["SiteSwitcherUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByIlustrationUniqueWhere"]: {
	ilustration?: ModelTypes["GalleryUniqueWhere"] | undefined
};
	["LocaleJobsFormsByRootUniqueWhere"]: {
	root?: ModelTypes["JobsFormUniqueWhere"] | undefined
};
	["LocaleJobsFormsByImageTextListUniqueWhere"]: {
	imageTextList?: ModelTypes["ImageTextListUniqueWhere"] | undefined
};
	["LocaleJobsFormsByLogoUniqueWhere"]: {
	logo?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleJobsFormsBySuccessImageUniqueWhere"]: {
	successImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleJobsFiltersByRootUniqueWhere"]: {
	root?: ModelTypes["JobsFilterUniqueWhere"] | undefined
};
	["LocaleJobsFiltersByBannerJobsFormUniqueWhere"]: {
	bannerJobsForm?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined
};
	["LocaleJobsFiltersByBannerImageUniqueWhere"]: {
	bannerImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleJobsFiltersByNoJobImageUniqueWhere"]: {
	noJobImage?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["LocaleGeneralByRootUniqueWhere"]: {
	root?: ModelTypes["GeneralUniqueWhere"] | undefined
};
	["LocaleGeneralBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["LocaleGeneralByCornerBannerUniqueWhere"]: {
	cornerBanner?: ModelTypes["CornerBannerUniqueWhere"] | undefined
};
	["LocaleRecommendationFormsByRootUniqueWhere"]: {
	root?: ModelTypes["RecommendationFormUniqueWhere"] | undefined
};
	["LocaleInfoBoxesByRootUniqueWhere"]: {
	root?: ModelTypes["InfoBoxUniqueWhere"] | undefined
};
	["LocaleTranslationsByRootUniqueWhere"]: {
	root?: ModelTypes["TranslationUniqueWhere"] | undefined
};
	["GeneralLocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GeneralLocaleEdge"]>
};
	["GeneralLocaleEdge"]: {
		node: ModelTypes["GeneralLocale"]
};
	["CornerBanner"]: {
		_meta?: ModelTypes["CornerBannerMeta"] | undefined,
	id: ModelTypes["UUID"],
	isActive: boolean,
	title?: string | undefined,
	text?: string | undefined,
	logo?: ModelTypes["Image"] | undefined,
	link?: ModelTypes["Link"] | undefined
};
	["CornerBannerMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	isActive?: ModelTypes["FieldMeta"] | undefined,
	title?: ModelTypes["FieldMeta"] | undefined,
	text?: ModelTypes["FieldMeta"] | undefined,
	logo?: ModelTypes["FieldMeta"] | undefined,
	link?: ModelTypes["FieldMeta"] | undefined
};
	["GeneralLocalesByLocaleUniqueWhere"]: {
	locale?: ModelTypes["LocaleUniqueWhere"] | undefined
};
	["GeneralLocalesBySeoUniqueWhere"]: {
	seo?: ModelTypes["SeoUniqueWhere"] | undefined
};
	["GeneralLocalesByCornerBannerUniqueWhere"]: {
	cornerBanner?: ModelTypes["CornerBannerUniqueWhere"] | undefined
};
	["GeneralConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GeneralEdge"]>
};
	["GeneralEdge"]: {
		node: ModelTypes["General"]
};
	["_ValidationResult"]: {
		valid: boolean,
	errors: Array<ModelTypes["_ValidationError"]>
};
	["_ValidationError"]: {
		path: Array<ModelTypes["_PathFragment"]>,
	message: ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field: string
};
	["_IndexPathFragment"]: {
		index: number,
	alias?: string | undefined
};
	["_ValidationMessage"]: {
		text: string
};
	["GeneralCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["GeneralCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GeneralLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GeneralLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	cornerBanner?: ModelTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGeneralCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGeneralCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateFootersEntityRelationInput"]: {
	connect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateFootersRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	root?: ModelTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<ModelTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<ModelTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: ModelTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: ModelTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: ModelTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: ModelTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: ModelTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: ModelTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: ModelTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: ModelTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["FooterUniqueWhere"] | undefined,
	create?: ModelTypes["FooterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["FooterWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["FooterUniqueWhere"],
	create: ModelTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]: {
	connect?: ModelTypes["FooterLinkUniqueWhere"] | undefined,
	create?: ModelTypes["FooterLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLinkUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["FooterLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	link?: ModelTypes["FooterLinkCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLinkCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLinkConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["LinkType"] | undefined,
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: ModelTypes["LinkCreateInternalLinkEntityRelationInput"] | undefined,
	anchorLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined
};
	["LinkableCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: ModelTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateRedirectEntityRelationInput"]: {
	connect?: ModelTypes["RedirectUniqueWhere"] | undefined,
	create?: ModelTypes["RedirectWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateRedirectRelationInput"] | undefined
};
	["RedirectWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	target?: ModelTypes["RedirectCreateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectCreateTargetEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RedirectConnectOrCreateTargetRelationInput"] | undefined
};
	["RedirectConnectOrCreateTargetRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["LinkableConnectOrCreateRedirectRelationInput"]: {
	connect: ModelTypes["RedirectUniqueWhere"],
	create: ModelTypes["RedirectWithoutLinkCreateInput"]
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined
};
	["GenericPageLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: ModelTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined,
	image?: ModelTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GenericPageWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	theme?: ModelTypes["GenericPageCreateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageCreateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageConnectOrCreateThemeRelationInput"] | undefined
};
	["ThemeCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	backgroundColor?: string | undefined,
	textColor?: string | undefined,
	name?: string | undefined,
	buttonBackgroundColor?: string | undefined,
	buttonTextColor?: string | undefined,
	buttonBackgroundHoverColor?: string | undefined,
	buttonTextHoverColor?: string | undefined,
	buttonBorderColor?: string | undefined,
	buttonBorderHoverColor?: string | undefined,
	headerMenuColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageConnectOrCreateThemeRelationInput"]: {
	connect: ModelTypes["ThemeUniqueWhere"],
	create: ModelTypes["ThemeCreateInput"]
};
	["GenericPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["GenericPageUniqueWhere"],
	create: ModelTypes["GenericPageWithoutLocalesCreateInput"]
};
	["GenericPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGenericPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGenericPagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateHeadersEntityRelationInput"]: {
	connect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateHeadersRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<ModelTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<ModelTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: ModelTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: ModelTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["HeaderUniqueWhere"] | undefined,
	create?: ModelTypes["HeaderWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["HeaderWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	logo?: ModelTypes["HeaderCreateLogoEntityRelationInput"] | undefined,
	logoMenu?: ModelTypes["HeaderCreateLogoMenuEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined
};
	["ImageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["HeaderCreateLogoMenuEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderConnectOrCreateLogoMenuRelationInput"] | undefined
};
	["HeaderConnectOrCreateLogoMenuRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["HeaderLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["HeaderUniqueWhere"],
	create: ModelTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleCreateBusinessEntityRelationInput"]: {
	connect?: ModelTypes["BusinessUniqueWhere"] | undefined,
	create?: ModelTypes["BusinessCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateBusinessRelationInput"] | undefined,
	alias?: string | undefined
};
	["BusinessUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	logo?: ModelTypes["ImageUniqueWhere"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["BusinessCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	logo?: ModelTypes["BusinessCreateLogoEntityRelationInput"] | undefined,
	link?: ModelTypes["BusinessCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessConnectOrCreateLogoRelationInput"] | undefined
};
	["BusinessConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["BusinessCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessConnectOrCreateLinkRelationInput"] | undefined
};
	["BusinessConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["HeaderLocaleConnectOrCreateBusinessRelationInput"]: {
	connect: ModelTypes["BusinessUniqueWhere"],
	create: ModelTypes["BusinessCreateInput"]
};
	["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]: {
	connect?: ModelTypes["BusinessUniqueWhere"] | undefined,
	create?: ModelTypes["BusinessCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"]: {
	connect: ModelTypes["BusinessUniqueWhere"],
	create: ModelTypes["BusinessCreateInput"]
};
	["HeaderLocaleCreateBusinessLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"] | undefined
};
	["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["HeaderLocaleCreateLokalLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateLokalLinkRelationInput"] | undefined
};
	["HeaderLocaleConnectOrCreateLokalLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["LocaleConnectOrCreateHeadersRelationInput"]: {
	connect: ModelTypes["HeaderLocaleUniqueWhere"],
	create: ModelTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateSeoDefaultsEntityRelationInput"]: {
	connect?: ModelTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateSeoDefaultsRelationInput"] | undefined,
	alias?: string | undefined
};
	["SeoDefaultLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["SeoDefaultLocaleCreateRootEntityRelationInput"] | undefined,
	seo?: ModelTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["SeoDefaultUniqueWhere"] | undefined,
	create?: ModelTypes["SeoDefaultWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoDefaultLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["SeoDefaultWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["SeoDefaultUniqueWhere"],
	create: ModelTypes["SeoDefaultWithoutLocalesCreateInput"]
};
	["SeoDefaultLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoDefaultLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["SeoCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: ModelTypes["SeoCreateOgImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined
};
	["SeoConnectOrCreateOgImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["SeoDefaultLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["LocaleConnectOrCreateSeoDefaultsRelationInput"]: {
	connect: ModelTypes["SeoDefaultLocaleUniqueWhere"],
	create: ModelTypes["SeoDefaultLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateBusinessPagesEntityRelationInput"]: {
	connect?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["BusinessPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateBusinessPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["BusinessPageLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: ModelTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	infoBox?: ModelTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["BusinessPageUniqueWhere"] | undefined,
	create?: ModelTypes["BusinessPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["BusinessPageWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	theme?: ModelTypes["BusinessPageCreateThemeEntityRelationInput"] | undefined,
	isLokal?: boolean | undefined,
	tabidooId?: string | undefined,
	headerColor?: string | undefined,
	recruitisOfficeId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageCreateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageConnectOrCreateThemeRelationInput"] | undefined
};
	["BusinessPageConnectOrCreateThemeRelationInput"]: {
	connect: ModelTypes["ThemeUniqueWhere"],
	create: ModelTypes["ThemeCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["BusinessPageUniqueWhere"],
	create: ModelTypes["BusinessPageWithoutLocalesCreateInput"]
};
	["BusinessPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["ContentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	blocks?: Array<ModelTypes["ContentCreateBlocksEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	create?: ModelTypes["ContentBlockWithoutContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentConnectOrCreateBlocksRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	references?: Array<ModelTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	create?: ModelTypes["ContentReferenceWithoutBlockCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentBlockConnectOrCreateReferencesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	image?: ModelTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined,
	linkables?: Array<ModelTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	media?: ModelTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined,
	textList?: ModelTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined,
	carousel?: ModelTypes["ContentReferenceCreateCarouselEntityRelationInput"] | undefined,
	bonusBanner?: ModelTypes["ContentReferenceCreateBonusBannerEntityRelationInput"] | undefined,
	sideBySide?: ModelTypes["ContentReferenceCreateSideBySideEntityRelationInput"] | undefined,
	gallery?: ModelTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined,
	showBoolean?: boolean | undefined,
	isRed?: boolean | undefined,
	video?: ModelTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["ContentReferenceCreateLinkablesEntityRelationInput"]: {
	connect?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["ContentReferenceCreateMediaEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined
};
	["MediumListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["MediumListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["MediumItemUniqueWhere"] | undefined,
	create?: ModelTypes["MediumItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["MediumItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	medium?: ModelTypes["MediumItemCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemCreateMediumEntityRelationInput"]: {
	connect?: ModelTypes["MediumUniqueWhere"] | undefined,
	create?: ModelTypes["MediumCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined
};
	["MediumUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["MediumCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["MediumType"] | undefined,
	image?: ModelTypes["MediumCreateImageEntityRelationInput"] | undefined,
	video?: ModelTypes["MediumCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumConnectOrCreateImageRelationInput"] | undefined
};
	["MediumConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["MediumCreateVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumConnectOrCreateVideoRelationInput"] | undefined
};
	["VideoCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	src?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	videoInfo?: string | undefined,
	duration?: number | undefined,
	poster?: ModelTypes["VideoCreatePosterEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["VideoConnectOrCreatePosterRelationInput"] | undefined
};
	["VideoConnectOrCreatePosterRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["MediumConnectOrCreateVideoRelationInput"]: {
	connect: ModelTypes["VideoUniqueWhere"],
	create: ModelTypes["VideoCreateInput"]
};
	["MediumItemConnectOrCreateMediumRelationInput"]: {
	connect: ModelTypes["MediumUniqueWhere"],
	create: ModelTypes["MediumCreateInput"]
};
	["MediumListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["MediumItemUniqueWhere"],
	create: ModelTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateMediaRelationInput"]: {
	connect: ModelTypes["MediumListUniqueWhere"],
	create: ModelTypes["MediumListCreateInput"]
};
	["ContentReferenceCreateTextListEntityRelationInput"]: {
	connect?: ModelTypes["TextListUniqueWhere"] | undefined,
	create?: ModelTypes["TextListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateTextListRelationInput"] | undefined
};
	["TextListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["TextItemUniqueWhere"] | undefined
};
	["TextItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["TextListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["TextListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["TextItemUniqueWhere"] | undefined,
	create?: ModelTypes["TextItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TextListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["TextItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["TextItemUniqueWhere"],
	create: ModelTypes["TextItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateTextListRelationInput"]: {
	connect: ModelTypes["TextListUniqueWhere"],
	create: ModelTypes["TextListCreateInput"]
};
	["ContentReferenceCreateCarouselEntityRelationInput"]: {
	connect?: ModelTypes["CarouselUniqueWhere"] | undefined,
	create?: ModelTypes["CarouselCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateCarouselRelationInput"] | undefined
};
	["CarouselUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["CarouselItemUniqueWhere"] | undefined
};
	["CarouselItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	image?: ModelTypes["ImageUniqueWhere"] | undefined,
	linkUrl?: ModelTypes["LinkUniqueWhere"] | undefined,
	video?: ModelTypes["VideoUniqueWhere"] | undefined
};
	["CarouselCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["CarouselCreateItemsEntityRelationInput"]> | undefined,
	background?: ModelTypes["Background"] | undefined,
	squareImages?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["CarouselItemUniqueWhere"] | undefined,
	create?: ModelTypes["CarouselItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CarouselConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["CarouselItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	image?: ModelTypes["CarouselItemCreateImageEntityRelationInput"] | undefined,
	name?: string | undefined,
	title?: string | undefined,
	linkUrl?: ModelTypes["CarouselItemCreateLinkUrlEntityRelationInput"] | undefined,
	normalAspectRatio?: boolean | undefined,
	isImage?: boolean | undefined,
	video?: ModelTypes["CarouselItemCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CarouselItemConnectOrCreateImageRelationInput"] | undefined
};
	["CarouselItemConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["CarouselItemCreateLinkUrlEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CarouselItemConnectOrCreateLinkUrlRelationInput"] | undefined
};
	["CarouselItemConnectOrCreateLinkUrlRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["CarouselItemCreateVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CarouselItemConnectOrCreateVideoRelationInput"] | undefined
};
	["CarouselItemConnectOrCreateVideoRelationInput"]: {
	connect: ModelTypes["VideoUniqueWhere"],
	create: ModelTypes["VideoCreateInput"]
};
	["CarouselConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["CarouselItemUniqueWhere"],
	create: ModelTypes["CarouselItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateCarouselRelationInput"]: {
	connect: ModelTypes["CarouselUniqueWhere"],
	create: ModelTypes["CarouselCreateInput"]
};
	["ContentReferenceCreateBonusBannerEntityRelationInput"]: {
	connect?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["BonusBannerLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateBonusBannerRelationInput"] | undefined
};
	["BonusBannerLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined,
	tiles?: Array<ModelTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined,
	logo?: ModelTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["BonusBannerUniqueWhere"] | undefined,
	create?: ModelTypes["BonusBannerWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BonusBannerLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["BonusBannerWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["BonusBannerUniqueWhere"],
	create: ModelTypes["BonusBannerWithoutLocalesCreateInput"]
};
	["BonusBannerLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutBonusBannersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BonusBannerLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutBonusBannersCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateGenericPagesEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateGenericPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: ModelTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined,
	image?: ModelTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["GenericPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["GenericPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutGenericPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutGenericPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: ModelTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateBusinessPageEntityRelationInput"]: {
	connect?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["BusinessPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateBusinessPageRelationInput"] | undefined
};
	["BusinessPageLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: ModelTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	infoBox?: ModelTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutBusinessPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutBusinessPagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateJobPagesEntityRelationInput"]: {
	connect?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateJobPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobPageLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined,
	image?: ModelTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined,
	keyInfo?: ModelTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined,
	content?: ModelTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: ModelTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: ModelTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["JobPageUniqueWhere"] | undefined,
	create?: ModelTypes["JobPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["JobPageWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	theme?: ModelTypes["JobPageCreateThemeEntityRelationInput"] | undefined,
	contractType?: ModelTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined,
	jobCity?: ModelTypes["JobPageCreateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	jobPosition?: ModelTypes["JobPageCreateJobPositionEntityRelationInput"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: ModelTypes["JobPageCreateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: ModelTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageCreateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateThemeRelationInput"] | undefined
};
	["JobPageConnectOrCreateThemeRelationInput"]: {
	connect: ModelTypes["ThemeUniqueWhere"],
	create: ModelTypes["ThemeCreateInput"]
};
	["JobPageCreateContractTypeEntityRelationInput"]: {
	connect?: ModelTypes["ContractTypeUniqueWhere"] | undefined,
	create?: ModelTypes["ContractTypeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateContractTypeRelationInput"] | undefined
};
	["ContractTypeCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["ContractTypeCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ContractTypeLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContractTypeConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContractTypeLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: string | undefined,
	locale?: ModelTypes["ContractTypeLocaleCreateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutContractTypesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContractTypeLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutContractTypesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateJobCitiesEntityRelationInput"]: {
	connect?: ModelTypes["JobCityLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobCityLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateJobCitiesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobCityLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["JobCityLocaleCreateRootEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["JobCityUniqueWhere"] | undefined,
	create?: ModelTypes["JobCityWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobCityLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["JobCityWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["JobCityUniqueWhere"],
	create: ModelTypes["JobCityWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateJobCitiesRelationInput"]: {
	connect: ModelTypes["JobCityLocaleUniqueWhere"],
	create: ModelTypes["JobCityLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateJobPositionsEntityRelationInput"]: {
	connect?: ModelTypes["JobPositionLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobPositionLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateJobPositionsRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobPositionLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: string | undefined,
	root?: ModelTypes["JobPositionLocaleCreateRootEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["JobPositionUniqueWhere"] | undefined,
	create?: ModelTypes["JobPositionWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPositionLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["JobPositionWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	jobs?: Array<ModelTypes["JobPositionCreateJobsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionCreateJobsEntityRelationInput"]: {
	connect?: ModelTypes["JobPageUniqueWhere"] | undefined,
	create?: ModelTypes["JobPageWithoutJobPositionCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPositionConnectOrCreateJobsRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobPageWithoutJobPositionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["JobPageCreateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["JobPageCreateThemeEntityRelationInput"] | undefined,
	contractType?: ModelTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined,
	jobCity?: ModelTypes["JobPageCreateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: ModelTypes["JobPageCreateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: ModelTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobPageLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	locale?: ModelTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	image?: ModelTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined,
	keyInfo?: ModelTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined,
	content?: ModelTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: ModelTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: ModelTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutJobPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutJobPagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateContractTypesEntityRelationInput"]: {
	connect?: ModelTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["ContractTypeLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateContractTypesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContractTypeLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: string | undefined,
	root?: ModelTypes["ContractTypeLocaleCreateRootEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["ContractTypeUniqueWhere"] | undefined,
	create?: ModelTypes["ContractTypeWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContractTypeLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["ContractTypeWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["ContractTypeUniqueWhere"],
	create: ModelTypes["ContractTypeWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateContractTypesRelationInput"]: {
	connect: ModelTypes["ContractTypeLocaleUniqueWhere"],
	create: ModelTypes["ContractTypeLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateHomePagesEntityRelationInput"]: {
	connect?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateHomePagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["HomePageLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["HomePageUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["HomePageWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	theme?: ModelTypes["HomePageCreateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageCreateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageConnectOrCreateThemeRelationInput"] | undefined
};
	["HomePageConnectOrCreateThemeRelationInput"]: {
	connect: ModelTypes["ThemeUniqueWhere"],
	create: ModelTypes["ThemeCreateInput"]
};
	["HomePageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["HomePageUniqueWhere"],
	create: ModelTypes["HomePageWithoutLocalesCreateInput"]
};
	["HomePageLocaleCreateButtonEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateButtonRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateButtonRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["HomePageLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["HomePageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["HomePageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutHomePageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutHomePageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: ModelTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateJobPageEntityRelationInput"]: {
	connect?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateJobPageRelationInput"] | undefined
};
	["JobPageLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	image?: ModelTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined,
	keyInfo?: ModelTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined,
	content?: ModelTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: ModelTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: ModelTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateImageRelationInput"] | undefined
};
	["JobPageLocaleConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["JobPageLocaleCreateKeyInfoEntityRelationInput"]: {
	connect?: ModelTypes["KeyInfoListUniqueWhere"] | undefined,
	create?: ModelTypes["KeyInfoListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateKeyInfoRelationInput"] | undefined
};
	["KeyInfoListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["KeyInfoListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["KeyInfoItemUniqueWhere"] | undefined,
	create?: ModelTypes["KeyInfoItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["KeyInfoListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["KeyInfoItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	keyInfo?: string | undefined,
	icon?: ModelTypes["KeyInfoItemCreateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemCreateIconEntityRelationInput"]: {
	connect?: ModelTypes["IconUniqueWhere"] | undefined,
	create?: ModelTypes["IconCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["KeyInfoItemConnectOrCreateIconRelationInput"] | undefined
};
	["IconUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	icon?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["IconCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	name?: string | undefined,
	icon?: ModelTypes["IconCreateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IconCreateIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["IconConnectOrCreateIconRelationInput"] | undefined
};
	["IconConnectOrCreateIconRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["KeyInfoItemConnectOrCreateIconRelationInput"]: {
	connect: ModelTypes["IconUniqueWhere"],
	create: ModelTypes["IconCreateInput"]
};
	["KeyInfoListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["KeyInfoItemUniqueWhere"],
	create: ModelTypes["KeyInfoItemWithoutListCreateInput"]
};
	["JobPageLocaleConnectOrCreateKeyInfoRelationInput"]: {
	connect: ModelTypes["KeyInfoListUniqueWhere"],
	create: ModelTypes["KeyInfoListCreateInput"]
};
	["JobPageLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["JobPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["JobPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["JobPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["JobPageLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ModelTypes["StickyBarUniqueWhere"] | undefined,
	create?: ModelTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined
};
	["StickyBarUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	link?: ModelTypes["LinkUniqueWhere"] | undefined
};
	["StickyBarCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	link?: ModelTypes["StickyBarCreateLinkEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	jobsForm?: ModelTypes["StickyBarCreateJobsFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StickyBarCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StickyBarConnectOrCreateLinkRelationInput"] | undefined
};
	["StickyBarConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["StickyBarCreateJobsFormEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StickyBarConnectOrCreateJobsFormRelationInput"] | undefined
};
	["JobsFormLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	root?: ModelTypes["JobsFormLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobsFormLocaleCreateLocaleEntityRelationInput"] | undefined,
	imageTextList?: ModelTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: ModelTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: ModelTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["JobsFormWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	fileIlustration?: ModelTypes["JobsFormCreateFileIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormCreateFileIlustrationEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormConnectOrCreateFileIlustrationRelationInput"] | undefined
};
	["JobsFormConnectOrCreateFileIlustrationRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["JobsFormLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["JobsFormUniqueWhere"],
	create: ModelTypes["JobsFormWithoutLocalesCreateInput"]
};
	["JobsFormLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutJobsFormsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutJobsFormsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateBonusBannersEntityRelationInput"]: {
	connect?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["BonusBannerLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateBonusBannersRelationInput"] | undefined,
	alias?: string | undefined
};
	["BonusBannerLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined,
	tiles?: Array<ModelTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined,
	logo?: ModelTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleCreateTilesEntityRelationInput"]: {
	connect?: ModelTypes["TileUniqueWhere"] | undefined,
	create?: ModelTypes["TileWithoutBonusBannerCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BonusBannerLocaleConnectOrCreateTilesRelationInput"] | undefined,
	alias?: string | undefined
};
	["TileWithoutBonusBannerCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	image?: ModelTypes["TileCreateImageEntityRelationInput"] | undefined,
	lightBoxTitle?: string | undefined,
	lightBoxText?: string | undefined,
	ligthBoxMedia?: ModelTypes["TileCreateLigthBoxMediaEntityRelationInput"] | undefined,
	lightBoxSectionTitle?: string | undefined,
	title?: string | undefined,
	lightBoxLinkLabel?: string | undefined,
	lightBoxForm?: ModelTypes["TileCreateLightBoxFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileConnectOrCreateImageRelationInput"] | undefined
};
	["TileConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["TileCreateLigthBoxMediaEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileConnectOrCreateLigthBoxMediaRelationInput"] | undefined
};
	["TileConnectOrCreateLigthBoxMediaRelationInput"]: {
	connect: ModelTypes["MediumListUniqueWhere"],
	create: ModelTypes["MediumListCreateInput"]
};
	["TileCreateLightBoxFormEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileConnectOrCreateLightBoxFormRelationInput"] | undefined
};
	["TileConnectOrCreateLightBoxFormRelationInput"]: {
	connect: ModelTypes["JobsFormLocaleUniqueWhere"],
	create: ModelTypes["JobsFormLocaleCreateInput"]
};
	["BonusBannerLocaleConnectOrCreateTilesRelationInput"]: {
	connect: ModelTypes["TileUniqueWhere"],
	create: ModelTypes["TileWithoutBonusBannerCreateInput"]
};
	["BonusBannerLocaleCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BonusBannerLocaleConnectOrCreateLogoRelationInput"] | undefined
};
	["BonusBannerLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateBonusBannersRelationInput"]: {
	connect: ModelTypes["BonusBannerLocaleUniqueWhere"],
	create: ModelTypes["BonusBannerLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateHomePageLokalsEntityRelationInput"]: {
	connect?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageLokalLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateHomePageLokalsRelationInput"] | undefined,
	alias?: string | undefined
};
	["HomePageLokalLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["HomePageLokalUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageLokalWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["HomePageLokalWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	theme?: ModelTypes["HomePageLokalCreateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalCreateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalConnectOrCreateThemeRelationInput"] | undefined
};
	["HomePageLokalConnectOrCreateThemeRelationInput"]: {
	connect: ModelTypes["ThemeUniqueWhere"],
	create: ModelTypes["ThemeCreateInput"]
};
	["HomePageLokalLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["HomePageLokalUniqueWhere"],
	create: ModelTypes["HomePageLokalWithoutLocalesCreateInput"]
};
	["HomePageLokalLocaleCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateLogoRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["HomePageLokalLocaleCreateButtonEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateButtonRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateButtonRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["HomePageLokalLocaleCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["HomePageLokalLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["HomePageLokalLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutHomePageLokalCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutHomePageLokalCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: ModelTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateHomePageEntityRelationInput"]: {
	connect?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateHomePageRelationInput"] | undefined
};
	["HomePageLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutHomePagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutHomePagesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateJobsFormsEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateJobsFormsRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobsFormLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	root?: ModelTypes["JobsFormLocaleCreateRootEntityRelationInput"] | undefined,
	imageTextList?: ModelTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: ModelTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: ModelTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormLocaleCreateImageTextListEntityRelationInput"]: {
	connect?: ModelTypes["ImageTextListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageTextListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormLocaleConnectOrCreateImageTextListRelationInput"] | undefined
};
	["ImageTextListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["ImageTextListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["ImageTextItemUniqueWhere"] | undefined,
	create?: ModelTypes["ImageTextItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageTextListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ImageTextItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	image?: ModelTypes["ImageTextItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageTextItemConnectOrCreateImageRelationInput"] | undefined
};
	["ImageTextItemConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["ImageTextListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["ImageTextItemUniqueWhere"],
	create: ModelTypes["ImageTextItemWithoutListCreateInput"]
};
	["JobsFormLocaleConnectOrCreateImageTextListRelationInput"]: {
	connect: ModelTypes["ImageTextListUniqueWhere"],
	create: ModelTypes["ImageTextListCreateInput"]
};
	["JobsFormLocaleCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormLocaleConnectOrCreateLogoRelationInput"] | undefined
};
	["JobsFormLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["JobsFormLocaleCreateSuccessImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"] | undefined
};
	["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateJobsFormsRelationInput"]: {
	connect: ModelTypes["JobsFormLocaleUniqueWhere"],
	create: ModelTypes["JobsFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateJobsFiltersEntityRelationInput"]: {
	connect?: ModelTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFilterLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateJobsFiltersRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobsFilterLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	root?: ModelTypes["JobsFilterLocaleCreateRootEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: ModelTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: ModelTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: ModelTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["JobsFilterUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFilterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["JobsFilterWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["JobsFilterUniqueWhere"],
	create: ModelTypes["JobsFilterWithoutLocalesCreateInput"]
};
	["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"] | undefined
};
	["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"]: {
	connect: ModelTypes["JobsFormLocaleUniqueWhere"],
	create: ModelTypes["JobsFormLocaleCreateInput"]
};
	["JobsFilterLocaleCreateBannerImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"] | undefined
};
	["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["JobsFilterLocaleCreateNoJobImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"] | undefined
};
	["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateJobsFiltersRelationInput"]: {
	connect: ModelTypes["JobsFilterLocaleUniqueWhere"],
	create: ModelTypes["JobsFilterLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateGeneralEntityRelationInput"]: {
	connect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateGeneralRelationInput"] | undefined,
	alias?: string | undefined
};
	["GeneralLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	cornerBanner?: ModelTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["GeneralUniqueWhere"] | undefined,
	create?: ModelTypes["GeneralWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GeneralWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["GeneralUniqueWhere"],
	create: ModelTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["GeneralLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["GeneralLocaleCreateCornerBannerEntityRelationInput"]: {
	connect?: ModelTypes["CornerBannerUniqueWhere"] | undefined,
	create?: ModelTypes["CornerBannerCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateCornerBannerRelationInput"] | undefined
};
	["CornerBannerCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	isActive?: boolean | undefined,
	title?: string | undefined,
	text?: string | undefined,
	logo?: ModelTypes["CornerBannerCreateLogoEntityRelationInput"] | undefined,
	link?: ModelTypes["CornerBannerCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CornerBannerCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CornerBannerConnectOrCreateLogoRelationInput"] | undefined
};
	["CornerBannerConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["CornerBannerCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CornerBannerConnectOrCreateLinkRelationInput"] | undefined
};
	["CornerBannerConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["GeneralLocaleConnectOrCreateCornerBannerRelationInput"]: {
	connect: ModelTypes["CornerBannerUniqueWhere"],
	create: ModelTypes["CornerBannerCreateInput"]
};
	["LocaleConnectOrCreateGeneralRelationInput"]: {
	connect: ModelTypes["GeneralLocaleUniqueWhere"],
	create: ModelTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateRecommendationFormsEntityRelationInput"]: {
	connect?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["RecommendationFormLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateRecommendationFormsRelationInput"] | undefined,
	alias?: string | undefined
};
	["RecommendationFormLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	root?: ModelTypes["RecommendationFormLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["RecommendationFormUniqueWhere"] | undefined,
	create?: ModelTypes["RecommendationFormWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecommendationFormLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["RecommendationFormWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	successImage?: ModelTypes["RecommendationFormCreateSuccessImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormCreateSuccessImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecommendationFormConnectOrCreateSuccessImageRelationInput"] | undefined
};
	["RecommendationFormConnectOrCreateSuccessImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["RecommendationFormLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["RecommendationFormUniqueWhere"],
	create: ModelTypes["RecommendationFormWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateRecommendationFormsRelationInput"]: {
	connect: ModelTypes["RecommendationFormLocaleUniqueWhere"],
	create: ModelTypes["RecommendationFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateInfoBoxesEntityRelationInput"]: {
	connect?: ModelTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["InfoBoxLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateInfoBoxesRelationInput"] | undefined,
	alias?: string | undefined
};
	["InfoBoxLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	root?: ModelTypes["InfoBoxLocaleCreateRootEntityRelationInput"] | undefined,
	openingHours?: ModelTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["InfoBoxUniqueWhere"] | undefined,
	create?: ModelTypes["InfoBoxWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoBoxLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["InfoBoxWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	logoSize?: ModelTypes["LogoSize"] | undefined,
	logo?: ModelTypes["InfoBoxCreateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoBoxConnectOrCreateLogoRelationInput"] | undefined
};
	["InfoBoxConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["InfoBoxLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["InfoBoxUniqueWhere"],
	create: ModelTypes["InfoBoxWithoutLocalesCreateInput"]
};
	["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"]: {
	connect?: ModelTypes["TextListUniqueWhere"] | undefined,
	create?: ModelTypes["TextListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"] | undefined
};
	["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"]: {
	connect: ModelTypes["TextListUniqueWhere"],
	create: ModelTypes["TextListCreateInput"]
};
	["LocaleConnectOrCreateInfoBoxesRelationInput"]: {
	connect: ModelTypes["InfoBoxLocaleUniqueWhere"],
	create: ModelTypes["InfoBoxLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateTranslationsEntityRelationInput"]: {
	connect?: ModelTypes["TranslationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LocaleConnectOrCreateTranslationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationLocaleWithoutLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	value?: string | undefined,
	root?: ModelTypes["TranslationLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleCreateRootEntityRelationInput"]: {
	connect?: ModelTypes["TranslationUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["TranslationWithoutLocalesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	key?: string | undefined,
	isTextarea?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["TranslationUniqueWhere"],
	create: ModelTypes["TranslationWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateTranslationsRelationInput"]: {
	connect: ModelTypes["TranslationLocaleUniqueWhere"],
	create: ModelTypes["TranslationLocaleWithoutLocaleCreateInput"]
};
	["HomePageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutHomePagesCreateInput"]
};
	["HomePageLocaleCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateLogoRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["HomePageLocaleCreateSiteSwitcherEntityRelationInput"]: {
	connect?: ModelTypes["SiteSwitcherUniqueWhere"] | undefined,
	create?: ModelTypes["SiteSwitcherCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined
};
	["SiteSwitcherCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	link?: ModelTypes["SiteSwitcherCreateLinkEntityRelationInput"] | undefined,
	theme?: ModelTypes["SiteSwitcherCreateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SiteSwitcherCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SiteSwitcherConnectOrCreateLinkRelationInput"] | undefined
};
	["SiteSwitcherConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["SiteSwitcherCreateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SiteSwitcherConnectOrCreateThemeRelationInput"] | undefined
};
	["SiteSwitcherConnectOrCreateThemeRelationInput"]: {
	connect: ModelTypes["ThemeUniqueWhere"],
	create: ModelTypes["ThemeCreateInput"]
};
	["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"]: {
	connect: ModelTypes["SiteSwitcherUniqueWhere"],
	create: ModelTypes["SiteSwitcherCreateInput"]
};
	["HomePageLocaleCreateGalleryEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateGalleryRelationInput"] | undefined
};
	["GalleryCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["GalleryCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["GalleryItemUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GalleryConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["GalleryItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	image?: ModelTypes["GalleryItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GalleryItemConnectOrCreateImageRelationInput"] | undefined
};
	["GalleryItemConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["GalleryConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["GalleryItemUniqueWhere"],
	create: ModelTypes["GalleryItemWithoutListCreateInput"]
};
	["HomePageLocaleConnectOrCreateGalleryRelationInput"]: {
	connect: ModelTypes["GalleryUniqueWhere"],
	create: ModelTypes["GalleryCreateInput"]
};
	["HomePageLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ModelTypes["StickyBarUniqueWhere"] | undefined,
	create?: ModelTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateStickyBarRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ModelTypes["StickyBarUniqueWhere"],
	create: ModelTypes["StickyBarCreateInput"]
};
	["HomePageLocaleCreateIlustrationEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateIlustrationRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateIlustrationRelationInput"]: {
	connect: ModelTypes["GalleryUniqueWhere"],
	create: ModelTypes["GalleryCreateInput"]
};
	["LinkableConnectOrCreateHomePageRelationInput"]: {
	connect: ModelTypes["HomePageLocaleUniqueWhere"],
	create: ModelTypes["HomePageLocaleWithoutLinkCreateInput"]
};
	["HomePageLokalLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutHomePageLokalCreateInput"]
};
	["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"]: {
	connect?: ModelTypes["SiteSwitcherUniqueWhere"] | undefined,
	create?: ModelTypes["SiteSwitcherCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"]: {
	connect: ModelTypes["SiteSwitcherUniqueWhere"],
	create: ModelTypes["SiteSwitcherCreateInput"]
};
	["HomePageLokalLocaleCreateGalleryEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"]: {
	connect: ModelTypes["GalleryUniqueWhere"],
	create: ModelTypes["GalleryCreateInput"]
};
	["HomePageLokalLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ModelTypes["StickyBarUniqueWhere"] | undefined,
	create?: ModelTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ModelTypes["StickyBarUniqueWhere"],
	create: ModelTypes["StickyBarCreateInput"]
};
	["HomePageLokalLocaleCreateIlustrationEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"]: {
	connect: ModelTypes["GalleryUniqueWhere"],
	create: ModelTypes["GalleryCreateInput"]
};
	["LocaleConnectOrCreateHomePageLokalsRelationInput"]: {
	connect: ModelTypes["HomePageLokalLocaleUniqueWhere"],
	create: ModelTypes["HomePageLokalLocaleWithoutLocaleCreateInput"]
};
	["JobsFormLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutJobsFormsCreateInput"]
};
	["StickyBarConnectOrCreateJobsFormRelationInput"]: {
	connect: ModelTypes["JobsFormLocaleUniqueWhere"],
	create: ModelTypes["JobsFormLocaleCreateInput"]
};
	["JobPageLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ModelTypes["StickyBarUniqueWhere"],
	create: ModelTypes["StickyBarCreateInput"]
};
	["JobPageLocaleCreateMobileImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateMobileImageRelationInput"] | undefined
};
	["JobPageLocaleConnectOrCreateMobileImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["LinkableConnectOrCreateJobPageRelationInput"]: {
	connect: ModelTypes["JobPageLocaleUniqueWhere"],
	create: ModelTypes["JobPageLocaleWithoutLinkCreateInput"]
};
	["LinkableCreateHomePageLokalEntityRelationInput"]: {
	connect?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageLokalLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateHomePageLokalRelationInput"] | undefined
};
	["HomePageLokalLocaleWithoutLinkCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutHomePageLokalsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutHomePageLokalsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutHomePageLokalsCreateInput"]
};
	["LinkableConnectOrCreateHomePageLokalRelationInput"]: {
	connect: ModelTypes["HomePageLokalLocaleUniqueWhere"],
	create: ModelTypes["HomePageLokalLocaleWithoutLinkCreateInput"]
};
	["HomePageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutHomePageCreateInput"]
};
	["LocaleConnectOrCreateHomePagesRelationInput"]: {
	connect: ModelTypes["HomePageLocaleUniqueWhere"],
	create: ModelTypes["HomePageLocaleWithoutLocaleCreateInput"]
};
	["JobPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutJobPagesCreateInput"]
};
	["JobPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutJobPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutJobPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: ModelTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutJobPageCreateInput"]
};
	["JobPageConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["JobPageLocaleUniqueWhere"],
	create: ModelTypes["JobPageLocaleWithoutRootCreateInput"]
};
	["JobPageCreateJobCityEntityRelationInput"]: {
	connect?: ModelTypes["JobCityUniqueWhere"] | undefined,
	create?: ModelTypes["JobCityCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateJobCityRelationInput"] | undefined
};
	["JobCityCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["JobCityCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["JobCityLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobCityLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobCityConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobCityLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["JobCityLocaleCreateLocaleEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutJobCitiesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobCityLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutJobCitiesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutJobCitiesCreateInput"]
};
	["JobCityConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["JobCityLocaleUniqueWhere"],
	create: ModelTypes["JobCityLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateJobCityRelationInput"]: {
	connect: ModelTypes["JobCityUniqueWhere"],
	create: ModelTypes["JobCityCreateInput"]
};
	["JobPageCreateBusinessEntityRelationInput"]: {
	connect?: ModelTypes["BusinessPageUniqueWhere"] | undefined,
	create?: ModelTypes["BusinessPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateBusinessRelationInput"] | undefined
};
	["BusinessPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["BusinessPageCreateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["BusinessPageCreateThemeEntityRelationInput"] | undefined,
	isLokal?: boolean | undefined,
	tabidooId?: string | undefined,
	headerColor?: string | undefined,
	recruitisOfficeId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["BusinessPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["BusinessPageLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: ModelTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	infoBox?: ModelTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["BusinessPageLocaleConnectOrCreateSeoRelationInput"]: {
	connect: ModelTypes["SeoUniqueWhere"],
	create: ModelTypes["SeoCreateInput"]
};
	["BusinessPageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutBusinessPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutBusinessPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: ModelTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutBusinessPageCreateInput"]
};
	["BusinessPageLocaleCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateImageRelationInput"] | undefined
};
	["BusinessPageLocaleConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["BusinessPageLocaleCreateStickyBarEntityRelationInput"]: {
	connect?: ModelTypes["StickyBarUniqueWhere"] | undefined,
	create?: ModelTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined
};
	["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"]: {
	connect: ModelTypes["StickyBarUniqueWhere"],
	create: ModelTypes["StickyBarCreateInput"]
};
	["BusinessPageLocaleCreateInfoBoxEntityRelationInput"]: {
	connect?: ModelTypes["InfoBoxUniqueWhere"] | undefined,
	create?: ModelTypes["InfoBoxCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"] | undefined
};
	["InfoBoxCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	logoSize?: ModelTypes["LogoSize"] | undefined,
	logo?: ModelTypes["InfoBoxCreateLogoEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["InfoBoxCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["InfoBoxLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoBoxConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["InfoBoxLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	locale?: ModelTypes["InfoBoxLocaleCreateLocaleEntityRelationInput"] | undefined,
	openingHours?: ModelTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutInfoBoxesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoBoxLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutInfoBoxesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutInfoBoxesCreateInput"]
};
	["InfoBoxConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["InfoBoxLocaleUniqueWhere"],
	create: ModelTypes["InfoBoxLocaleWithoutRootCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"]: {
	connect: ModelTypes["InfoBoxUniqueWhere"],
	create: ModelTypes["InfoBoxCreateInput"]
};
	["BusinessPageConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["BusinessPageLocaleUniqueWhere"],
	create: ModelTypes["BusinessPageLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateBusinessRelationInput"]: {
	connect: ModelTypes["BusinessPageUniqueWhere"],
	create: ModelTypes["BusinessPageCreateInput"]
};
	["JobPositionConnectOrCreateJobsRelationInput"]: {
	connect: ModelTypes["JobPageUniqueWhere"],
	create: ModelTypes["JobPageWithoutJobPositionCreateInput"]
};
	["JobPositionLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["JobPositionUniqueWhere"],
	create: ModelTypes["JobPositionWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateJobPositionsRelationInput"]: {
	connect: ModelTypes["JobPositionLocaleUniqueWhere"],
	create: ModelTypes["JobPositionLocaleWithoutLocaleCreateInput"]
};
	["ContractTypeLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutContractTypesCreateInput"]
};
	["ContractTypeConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["ContractTypeLocaleUniqueWhere"],
	create: ModelTypes["ContractTypeLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateContractTypeRelationInput"]: {
	connect: ModelTypes["ContractTypeUniqueWhere"],
	create: ModelTypes["ContractTypeCreateInput"]
};
	["JobPageCreateJobPositionEntityRelationInput"]: {
	connect?: ModelTypes["JobPositionUniqueWhere"] | undefined,
	create?: ModelTypes["JobPositionWithoutJobsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateJobPositionRelationInput"] | undefined
};
	["JobPositionWithoutJobsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["JobPositionCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["JobPositionLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobPositionLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPositionConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobPositionLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: string | undefined,
	locale?: ModelTypes["JobPositionLocaleCreateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutJobPositionsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPositionLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutJobPositionsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutJobPositionsCreateInput"]
};
	["JobPositionConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["JobPositionLocaleUniqueWhere"],
	create: ModelTypes["JobPositionLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateJobPositionRelationInput"]: {
	connect: ModelTypes["JobPositionUniqueWhere"],
	create: ModelTypes["JobPositionWithoutJobsCreateInput"]
};
	["JobPageLocaleConnectOrCreateRootRelationInput"]: {
	connect: ModelTypes["JobPageUniqueWhere"],
	create: ModelTypes["JobPageWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateJobPagesRelationInput"]: {
	connect: ModelTypes["JobPageLocaleUniqueWhere"],
	create: ModelTypes["JobPageLocaleWithoutLocaleCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutBusinessPagesCreateInput"]
};
	["LinkableConnectOrCreateBusinessPageRelationInput"]: {
	connect: ModelTypes["BusinessPageLocaleUniqueWhere"],
	create: ModelTypes["BusinessPageLocaleWithoutLinkCreateInput"]
};
	["GenericPageLocaleConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageLocaleCreateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateLogoRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateLogoRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["GenericPageLocaleCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateImageRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateGenericPagesRelationInput"]: {
	connect: ModelTypes["GenericPageLocaleUniqueWhere"],
	create: ModelTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["BonusBannerLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutBonusBannersCreateInput"]
};
	["ContentReferenceConnectOrCreateBonusBannerRelationInput"]: {
	connect: ModelTypes["BonusBannerLocaleUniqueWhere"],
	create: ModelTypes["BonusBannerLocaleCreateInput"]
};
	["ContentReferenceCreateSideBySideEntityRelationInput"]: {
	connect?: ModelTypes["SideBySideUniqueWhere"] | undefined,
	create?: ModelTypes["SideBySideCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateSideBySideRelationInput"] | undefined
};
	["SideBySideUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["SideBySideItemUniqueWhere"] | undefined
};
	["SideBySideItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	media?: ModelTypes["MediumListUniqueWhere"] | undefined
};
	["SideBySideCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["SideBySideCreateItemsEntityRelationInput"]> | undefined,
	background?: ModelTypes["Background"] | undefined,
	alignment?: ModelTypes["ContentAlignment"] | undefined,
	mediumSize?: ModelTypes["MediumSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["SideBySideItemUniqueWhere"] | undefined,
	create?: ModelTypes["SideBySideItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SideBySideConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["SideBySideItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	text?: string | undefined,
	media?: ModelTypes["SideBySideItemCreateMediaEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	type?: ModelTypes["SideBySideItemType"] | undefined,
	link?: ModelTypes["SideBySideItemCreateLinkEntityRelationInput"] | undefined,
	jobsForm?: ModelTypes["SideBySideItemCreateJobsFormEntityRelationInput"] | undefined,
	textNew?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemCreateMediaEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SideBySideItemConnectOrCreateMediaRelationInput"] | undefined
};
	["SideBySideItemConnectOrCreateMediaRelationInput"]: {
	connect: ModelTypes["MediumListUniqueWhere"],
	create: ModelTypes["MediumListCreateInput"]
};
	["SideBySideItemCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SideBySideItemConnectOrCreateLinkRelationInput"] | undefined
};
	["SideBySideItemConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["SideBySideItemCreateJobsFormEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SideBySideItemConnectOrCreateJobsFormRelationInput"] | undefined
};
	["SideBySideItemConnectOrCreateJobsFormRelationInput"]: {
	connect: ModelTypes["JobsFormLocaleUniqueWhere"],
	create: ModelTypes["JobsFormLocaleCreateInput"]
};
	["SideBySideConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["SideBySideItemUniqueWhere"],
	create: ModelTypes["SideBySideItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateSideBySideRelationInput"]: {
	connect: ModelTypes["SideBySideUniqueWhere"],
	create: ModelTypes["SideBySideCreateInput"]
};
	["ContentReferenceCreateGalleryEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateGalleryRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateGalleryRelationInput"]: {
	connect: ModelTypes["GalleryUniqueWhere"],
	create: ModelTypes["GalleryCreateInput"]
};
	["ContentReferenceCreateVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateVideoRelationInput"]: {
	connect: ModelTypes["VideoUniqueWhere"],
	create: ModelTypes["VideoCreateInput"]
};
	["ContentBlockConnectOrCreateReferencesRelationInput"]: {
	connect: ModelTypes["ContentReferenceUniqueWhere"],
	create: ModelTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentConnectOrCreateBlocksRelationInput"]: {
	connect: ModelTypes["ContentBlockUniqueWhere"],
	create: ModelTypes["ContentBlockWithoutContentCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentCreateInput"]
};
	["LocaleConnectOrCreateBusinessPagesRelationInput"]: {
	connect: ModelTypes["BusinessPageLocaleUniqueWhere"],
	create: ModelTypes["BusinessPageLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableConnectOrCreateGenericPageRelationInput"]: {
	connect: ModelTypes["GenericPageLocaleUniqueWhere"],
	create: ModelTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["LinkConnectOrCreateInternalLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableCreateInput"]
};
	["FooterLinkConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"]: {
	connect: ModelTypes["FooterLinkUniqueWhere"],
	create: ModelTypes["FooterLinkCreateInput"]
};
	["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]: {
	connect?: ModelTypes["FooterLinkUniqueWhere"] | undefined,
	create?: ModelTypes["FooterLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"]: {
	connect: ModelTypes["FooterLinkUniqueWhere"],
	create: ModelTypes["FooterLinkCreateInput"]
};
	["FooterLocaleCreateTermsAndConditionsEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["FooterLocaleCreateBannerImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateBannerImageRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateBannerImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["FooterLocaleCreateBannerLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateBannerLinkRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateBannerLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["FooterLocaleCreateJobsFormEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateJobsFormRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateJobsFormRelationInput"]: {
	connect: ModelTypes["JobsFormLocaleUniqueWhere"],
	create: ModelTypes["JobsFormLocaleCreateInput"]
};
	["FooterLocaleCreateCopyrightLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["FooterLocaleCreateRecommendationFormEntityRelationInput"]: {
	connect?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["RecommendationFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateRecommendationFormRelationInput"] | undefined
};
	["RecommendationFormLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	root?: ModelTypes["RecommendationFormLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["RecommendationFormLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutRecommendationFormsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutRecommendationFormsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutRecommendationFormsCreateInput"]
};
	["FooterLocaleConnectOrCreateRecommendationFormRelationInput"]: {
	connect: ModelTypes["RecommendationFormLocaleUniqueWhere"],
	create: ModelTypes["RecommendationFormLocaleCreateInput"]
};
	["FooterLocaleCreateBannerSecondLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["FooterLocaleCreateInstagramLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateInstagramLinkRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateInstagramLinkRelationInput"]: {
	connect: ModelTypes["LinkUniqueWhere"],
	create: ModelTypes["LinkCreateInput"]
};
	["LocaleConnectOrCreateFootersRelationInput"]: {
	connect: ModelTypes["FooterLocaleUniqueWhere"],
	create: ModelTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutGeneralCreateInput"]
};
	["GeneralConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["GeneralLocaleUniqueWhere"],
	create: ModelTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["GeneralUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["GeneralUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["GeneralLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["GeneralUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["GeneralUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GeneralUpdateLocalesRelationInput"]: {
	by: ModelTypes["GeneralLocaleUniqueWhere"],
	data: ModelTypes["GeneralLocaleWithoutRootUpdateInput"]
};
	["GeneralLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	cornerBanner?: ModelTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGeneralCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutGeneralUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGeneralUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateFootersEntityRelationInput"]: {
	create?: ModelTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateFootersRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertFootersRelationInput"] | undefined,
	connect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateFootersRelationInput"]: {
	by: ModelTypes["FooterLocaleUniqueWhere"],
	data: ModelTypes["FooterLocaleWithoutLocaleUpdateInput"]
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	root?: ModelTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<ModelTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<ModelTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: ModelTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: ModelTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: ModelTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: ModelTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: ModelTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: ModelTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: ModelTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: ModelTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["FooterUniqueWhere"] | undefined,
	create?: ModelTypes["FooterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["FooterWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["FooterWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["FooterWithoutLocalesUpdateInput"],
	create: ModelTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]: {
	create?: ModelTypes["FooterLinkCreateInput"] | undefined,
	update?: ModelTypes["FooterLocaleUpdateLinksFirstColumnRelationInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertLinksFirstColumnRelationInput"] | undefined,
	connect?: ModelTypes["FooterLinkUniqueWhere"] | undefined,
	disconnect?: ModelTypes["FooterLinkUniqueWhere"] | undefined,
	delete?: ModelTypes["FooterLinkUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleUpdateLinksFirstColumnRelationInput"]: {
	by: ModelTypes["FooterLinkUniqueWhere"],
	data: ModelTypes["FooterLinkUpdateInput"]
};
	["FooterLinkUpdateInput"]: {
	order?: number | undefined,
	link?: ModelTypes["FooterLinkUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLinkUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLinkConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLinkUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkUpdateInput"]: {
	type?: ModelTypes["LinkType"] | undefined,
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: ModelTypes["LinkUpdateInternalLinkEntityRelationInput"] | undefined,
	anchorLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkUpsertInternalLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableUpdateInput"]: {
	url?: string | undefined,
	redirect?: ModelTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
	connect?: ModelTypes["RedirectUniqueWhere"] | undefined,
	create?: ModelTypes["RedirectWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateRedirectRelationInput"] | undefined,
	update?: ModelTypes["RedirectWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertRedirectRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RedirectWithoutLinkUpdateInput"]: {
	target?: ModelTypes["RedirectUpdateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectUpdateTargetEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RedirectConnectOrCreateTargetRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["RedirectUpsertTargetRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RedirectUpsertTargetRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["LinkableUpsertRedirectRelationInput"]: {
	update: ModelTypes["RedirectWithoutLinkUpdateInput"],
	create: ModelTypes["RedirectWithoutLinkCreateInput"]
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined,
	update?: ModelTypes["GenericPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertGenericPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: ModelTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined,
	image?: ModelTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["GenericPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GenericPageWithoutLocalesUpdateInput"]: {
	theme?: ModelTypes["GenericPageUpdateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpdateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageConnectOrCreateThemeRelationInput"] | undefined,
	update?: ModelTypes["ThemeUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageUpsertThemeRelationInput"] | undefined
};
	["ThemeUpdateInput"]: {
	backgroundColor?: string | undefined,
	textColor?: string | undefined,
	name?: string | undefined,
	buttonBackgroundColor?: string | undefined,
	buttonTextColor?: string | undefined,
	buttonBackgroundHoverColor?: string | undefined,
	buttonTextHoverColor?: string | undefined,
	buttonBorderColor?: string | undefined,
	buttonBorderHoverColor?: string | undefined,
	headerMenuColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpsertThemeRelationInput"]: {
	update: ModelTypes["ThemeUpdateInput"],
	create: ModelTypes["ThemeCreateInput"]
};
	["GenericPageLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["GenericPageWithoutLocalesUpdateInput"],
	create: ModelTypes["GenericPageWithoutLocalesCreateInput"]
};
	["GenericPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutGenericPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutGenericPagesUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGenericPagesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
	create?: ModelTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateHeadersRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertHeadersRelationInput"] | undefined,
	connect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateHeadersRelationInput"]: {
	by: ModelTypes["HeaderLocaleUniqueWhere"],
	data: ModelTypes["HeaderLocaleWithoutLocaleUpdateInput"]
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<ModelTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<ModelTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: ModelTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: ModelTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["HeaderUniqueWhere"] | undefined,
	create?: ModelTypes["HeaderWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["HeaderWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["HeaderWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	logo?: ModelTypes["HeaderUpdateLogoEntityRelationInput"] | undefined,
	logoMenu?: ModelTypes["HeaderUpdateLogoMenuEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageUpdateInput"]: {
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["HeaderUpdateLogoMenuEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderConnectOrCreateLogoMenuRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderUpsertLogoMenuRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeaderUpsertLogoMenuRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["HeaderLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["HeaderWithoutLocalesUpdateInput"],
	create: ModelTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleUpdateBusinessEntityRelationInput"]: {
	create?: ModelTypes["BusinessCreateInput"] | undefined,
	update?: ModelTypes["HeaderLocaleUpdateBusinessRelationInput"] | undefined,
	upsert?: ModelTypes["HeaderLocaleUpsertBusinessRelationInput"] | undefined,
	connect?: ModelTypes["BusinessUniqueWhere"] | undefined,
	disconnect?: ModelTypes["BusinessUniqueWhere"] | undefined,
	delete?: ModelTypes["BusinessUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleUpdateBusinessRelationInput"]: {
	by: ModelTypes["BusinessUniqueWhere"],
	data: ModelTypes["BusinessUpdateInput"]
};
	["BusinessUpdateInput"]: {
	order?: number | undefined,
	logo?: ModelTypes["BusinessUpdateLogoEntityRelationInput"] | undefined,
	link?: ModelTypes["BusinessUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["BusinessUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["HeaderLocaleUpsertBusinessRelationInput"]: {
	by: ModelTypes["BusinessUniqueWhere"],
	update: ModelTypes["BusinessUpdateInput"],
	create: ModelTypes["BusinessCreateInput"]
};
	["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]: {
	create?: ModelTypes["BusinessCreateInput"] | undefined,
	update?: ModelTypes["HeaderLocaleUpdateLokalEnterpriseRelationInput"] | undefined,
	upsert?: ModelTypes["HeaderLocaleUpsertLokalEnterpriseRelationInput"] | undefined,
	connect?: ModelTypes["BusinessUniqueWhere"] | undefined,
	disconnect?: ModelTypes["BusinessUniqueWhere"] | undefined,
	delete?: ModelTypes["BusinessUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleUpdateLokalEnterpriseRelationInput"]: {
	by: ModelTypes["BusinessUniqueWhere"],
	data: ModelTypes["BusinessUpdateInput"]
};
	["HeaderLocaleUpsertLokalEnterpriseRelationInput"]: {
	by: ModelTypes["BusinessUniqueWhere"],
	update: ModelTypes["BusinessUpdateInput"],
	create: ModelTypes["BusinessCreateInput"]
};
	["HeaderLocaleUpdateBusinessLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderLocaleUpsertBusinessLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeaderLocaleUpsertBusinessLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["HeaderLocaleUpdateLokalLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateLokalLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderLocaleUpsertLokalLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeaderLocaleUpsertLokalLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["LocaleUpsertHeadersRelationInput"]: {
	by: ModelTypes["HeaderLocaleUniqueWhere"],
	update: ModelTypes["HeaderLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateSeoDefaultsEntityRelationInput"]: {
	create?: ModelTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateSeoDefaultsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertSeoDefaultsRelationInput"] | undefined,
	connect?: ModelTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateSeoDefaultsRelationInput"]: {
	by: ModelTypes["SeoDefaultLocaleUniqueWhere"],
	data: ModelTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"]
};
	["SeoDefaultLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"] | undefined,
	seo?: ModelTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["SeoDefaultUniqueWhere"] | undefined,
	create?: ModelTypes["SeoDefaultWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoDefaultLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["SeoDefaultWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["SeoDefaultLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["SeoDefaultWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["SeoDefaultWithoutLocalesUpdateInput"],
	create: ModelTypes["SeoDefaultWithoutLocalesCreateInput"]
};
	["SeoDefaultLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoDefaultLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["SeoDefaultLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeoUpdateInput"]: {
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: ModelTypes["SeoUpdateOgImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["SeoUpsertOgImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeoUpsertOgImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["SeoDefaultLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["LocaleUpsertSeoDefaultsRelationInput"]: {
	by: ModelTypes["SeoDefaultLocaleUniqueWhere"],
	update: ModelTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["SeoDefaultLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateBusinessPagesEntityRelationInput"]: {
	create?: ModelTypes["BusinessPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateBusinessPagesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertBusinessPagesRelationInput"] | undefined,
	connect?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateBusinessPagesRelationInput"]: {
	by: ModelTypes["BusinessPageLocaleUniqueWhere"],
	data: ModelTypes["BusinessPageLocaleWithoutLocaleUpdateInput"]
};
	["BusinessPageLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: ModelTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	infoBox?: ModelTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["BusinessPageUniqueWhere"] | undefined,
	create?: ModelTypes["BusinessPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["BusinessPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["BusinessPageWithoutLocalesUpdateInput"]: {
	theme?: ModelTypes["BusinessPageUpdateThemeEntityRelationInput"] | undefined,
	isLokal?: boolean | undefined,
	tabidooId?: string | undefined,
	headerColor?: string | undefined,
	recruitisOfficeId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageUpdateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageConnectOrCreateThemeRelationInput"] | undefined,
	update?: ModelTypes["ThemeUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessPageUpsertThemeRelationInput"] | undefined
};
	["BusinessPageUpsertThemeRelationInput"]: {
	update: ModelTypes["ThemeUpdateInput"],
	create: ModelTypes["ThemeCreateInput"]
};
	["BusinessPageLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["BusinessPageWithoutLocalesUpdateInput"],
	create: ModelTypes["BusinessPageWithoutLocalesCreateInput"]
};
	["BusinessPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentUpdateInput"]: {
	blocks?: Array<ModelTypes["ContentUpdateBlocksEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?: ModelTypes["ContentBlockWithoutContentCreateInput"] | undefined,
	update?: ModelTypes["ContentUpdateBlocksRelationInput"] | undefined,
	upsert?: ModelTypes["ContentUpsertBlocksRelationInput"] | undefined,
	connect?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	delete?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentUpdateBlocksRelationInput"]: {
	by: ModelTypes["ContentBlockUniqueWhere"],
	data: ModelTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?: number | undefined,
	json?: string | undefined,
	references?: Array<ModelTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?: ModelTypes["ContentReferenceWithoutBlockCreateInput"] | undefined,
	update?: ModelTypes["ContentBlockUpdateReferencesRelationInput"] | undefined,
	upsert?: ModelTypes["ContentBlockUpsertReferencesRelationInput"] | undefined,
	connect?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	delete?: ModelTypes["ContentReferenceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by: ModelTypes["ContentReferenceUniqueWhere"],
	data: ModelTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?: ModelTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	image?: ModelTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined,
	linkables?: Array<ModelTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	media?: ModelTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined,
	textList?: ModelTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined,
	carousel?: ModelTypes["ContentReferenceUpdateCarouselEntityRelationInput"] | undefined,
	bonusBanner?: ModelTypes["ContentReferenceUpdateBonusBannerEntityRelationInput"] | undefined,
	sideBySide?: ModelTypes["ContentReferenceUpdateSideBySideEntityRelationInput"] | undefined,
	gallery?: ModelTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined,
	showBoolean?: boolean | undefined,
	isRed?: boolean | undefined,
	video?: ModelTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateLinkablesEntityRelationInput"]: {
	connect?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	delete?: ModelTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateMediaEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined,
	update?: ModelTypes["MediumListUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertMediaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumListUpdateInput"]: {
	items?: Array<ModelTypes["MediumListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["MediumItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["MediumListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["MediumListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["MediumItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["MediumItemUniqueWhere"] | undefined,
	delete?: ModelTypes["MediumItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["MediumListUpdateItemsRelationInput"]: {
	by: ModelTypes["MediumItemUniqueWhere"],
	data: ModelTypes["MediumItemWithoutListUpdateInput"]
};
	["MediumItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	medium?: ModelTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemUpdateMediumEntityRelationInput"]: {
	connect?: ModelTypes["MediumUniqueWhere"] | undefined,
	create?: ModelTypes["MediumCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined,
	update?: ModelTypes["MediumUpdateInput"] | undefined,
	upsert?: ModelTypes["MediumItemUpsertMediumRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpdateInput"]: {
	type?: ModelTypes["MediumType"] | undefined,
	image?: ModelTypes["MediumUpdateImageEntityRelationInput"] | undefined,
	video?: ModelTypes["MediumUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["MediumUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["MediumUpdateVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumConnectOrCreateVideoRelationInput"] | undefined,
	update?: ModelTypes["VideoUpdateInput"] | undefined,
	upsert?: ModelTypes["MediumUpsertVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VideoUpdateInput"]: {
	src?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	videoInfo?: string | undefined,
	duration?: number | undefined,
	poster?: ModelTypes["VideoUpdatePosterEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VideoUpdatePosterEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["VideoConnectOrCreatePosterRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["VideoUpsertPosterRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VideoUpsertPosterRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["MediumUpsertVideoRelationInput"]: {
	update: ModelTypes["VideoUpdateInput"],
	create: ModelTypes["VideoCreateInput"]
};
	["MediumItemUpsertMediumRelationInput"]: {
	update: ModelTypes["MediumUpdateInput"],
	create: ModelTypes["MediumCreateInput"]
};
	["MediumListUpsertItemsRelationInput"]: {
	by: ModelTypes["MediumItemUniqueWhere"],
	update: ModelTypes["MediumItemWithoutListUpdateInput"],
	create: ModelTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertMediaRelationInput"]: {
	update: ModelTypes["MediumListUpdateInput"],
	create: ModelTypes["MediumListCreateInput"]
};
	["ContentReferenceUpdateTextListEntityRelationInput"]: {
	connect?: ModelTypes["TextListUniqueWhere"] | undefined,
	create?: ModelTypes["TextListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateTextListRelationInput"] | undefined,
	update?: ModelTypes["TextListUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertTextListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextListUpdateInput"]: {
	items?: Array<ModelTypes["TextListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["TextItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["TextListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["TextListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["TextItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TextItemUniqueWhere"] | undefined,
	delete?: ModelTypes["TextItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TextListUpdateItemsRelationInput"]: {
	by: ModelTypes["TextItemUniqueWhere"],
	data: ModelTypes["TextItemWithoutListUpdateInput"]
};
	["TextItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	text?: string | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListUpsertItemsRelationInput"]: {
	by: ModelTypes["TextItemUniqueWhere"],
	update: ModelTypes["TextItemWithoutListUpdateInput"],
	create: ModelTypes["TextItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertTextListRelationInput"]: {
	update: ModelTypes["TextListUpdateInput"],
	create: ModelTypes["TextListCreateInput"]
};
	["ContentReferenceUpdateCarouselEntityRelationInput"]: {
	connect?: ModelTypes["CarouselUniqueWhere"] | undefined,
	create?: ModelTypes["CarouselCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateCarouselRelationInput"] | undefined,
	update?: ModelTypes["CarouselUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertCarouselRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CarouselUpdateInput"]: {
	items?: Array<ModelTypes["CarouselUpdateItemsEntityRelationInput"]> | undefined,
	background?: ModelTypes["Background"] | undefined,
	squareImages?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["CarouselItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["CarouselUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["CarouselUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["CarouselItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["CarouselItemUniqueWhere"] | undefined,
	delete?: ModelTypes["CarouselItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CarouselUpdateItemsRelationInput"]: {
	by: ModelTypes["CarouselItemUniqueWhere"],
	data: ModelTypes["CarouselItemWithoutListUpdateInput"]
};
	["CarouselItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	text?: string | undefined,
	image?: ModelTypes["CarouselItemUpdateImageEntityRelationInput"] | undefined,
	name?: string | undefined,
	title?: string | undefined,
	linkUrl?: ModelTypes["CarouselItemUpdateLinkUrlEntityRelationInput"] | undefined,
	normalAspectRatio?: boolean | undefined,
	isImage?: boolean | undefined,
	video?: ModelTypes["CarouselItemUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CarouselItemConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["CarouselItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CarouselItemUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["CarouselItemUpdateLinkUrlEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CarouselItemConnectOrCreateLinkUrlRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["CarouselItemUpsertLinkUrlRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CarouselItemUpsertLinkUrlRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["CarouselItemUpdateVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CarouselItemConnectOrCreateVideoRelationInput"] | undefined,
	update?: ModelTypes["VideoUpdateInput"] | undefined,
	upsert?: ModelTypes["CarouselItemUpsertVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CarouselItemUpsertVideoRelationInput"]: {
	update: ModelTypes["VideoUpdateInput"],
	create: ModelTypes["VideoCreateInput"]
};
	["CarouselUpsertItemsRelationInput"]: {
	by: ModelTypes["CarouselItemUniqueWhere"],
	update: ModelTypes["CarouselItemWithoutListUpdateInput"],
	create: ModelTypes["CarouselItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertCarouselRelationInput"]: {
	update: ModelTypes["CarouselUpdateInput"],
	create: ModelTypes["CarouselCreateInput"]
};
	["ContentReferenceUpdateBonusBannerEntityRelationInput"]: {
	connect?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["BonusBannerLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateBonusBannerRelationInput"] | undefined,
	update?: ModelTypes["BonusBannerLocaleUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertBonusBannerRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BonusBannerLocaleUpdateInput"]: {
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined,
	tiles?: Array<ModelTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined,
	logo?: ModelTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["BonusBannerUniqueWhere"] | undefined,
	create?: ModelTypes["BonusBannerWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BonusBannerLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["BonusBannerWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["BonusBannerLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["BonusBannerWithoutLocalesUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["BonusBannerWithoutLocalesUpdateInput"],
	create: ModelTypes["BonusBannerWithoutLocalesCreateInput"]
};
	["BonusBannerLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutBonusBannersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BonusBannerLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutBonusBannersUpdateInput"] | undefined,
	upsert?: ModelTypes["BonusBannerLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutBonusBannersUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateGenericPagesEntityRelationInput"]: {
	create?: ModelTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateGenericPagesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertGenericPagesRelationInput"] | undefined,
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGenericPagesRelationInput"]: {
	by: ModelTypes["GenericPageLocaleUniqueWhere"],
	data: ModelTypes["GenericPageLocaleWithoutLocaleUpdateInput"]
};
	["GenericPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: ModelTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined,
	image?: ModelTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["GenericPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["GenericPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutGenericPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutGenericPageUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutGenericPageUpdateInput"]: {
	url?: string | undefined,
	redirect?: ModelTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateBusinessPageEntityRelationInput"]: {
	connect?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["BusinessPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateBusinessPageRelationInput"] | undefined,
	update?: ModelTypes["BusinessPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertBusinessPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessPageLocaleWithoutLinkUpdateInput"]: {
	root?: ModelTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: ModelTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	infoBox?: ModelTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutBusinessPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutBusinessPagesUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutBusinessPagesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateJobPagesEntityRelationInput"]: {
	create?: ModelTypes["JobPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateJobPagesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertJobPagesRelationInput"] | undefined,
	connect?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateJobPagesRelationInput"]: {
	by: ModelTypes["JobPageLocaleUniqueWhere"],
	data: ModelTypes["JobPageLocaleWithoutLocaleUpdateInput"]
};
	["JobPageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined,
	image?: ModelTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined,
	keyInfo?: ModelTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined,
	content?: ModelTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: ModelTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: ModelTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["JobPageUniqueWhere"] | undefined,
	create?: ModelTypes["JobPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["JobPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["JobPageWithoutLocalesUpdateInput"]: {
	theme?: ModelTypes["JobPageUpdateThemeEntityRelationInput"] | undefined,
	contractType?: ModelTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined,
	jobCity?: ModelTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	jobPosition?: ModelTypes["JobPageUpdateJobPositionEntityRelationInput"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: ModelTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: ModelTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageUpdateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateThemeRelationInput"] | undefined,
	update?: ModelTypes["ThemeUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageUpsertThemeRelationInput"] | undefined
};
	["JobPageUpsertThemeRelationInput"]: {
	update: ModelTypes["ThemeUpdateInput"],
	create: ModelTypes["ThemeCreateInput"]
};
	["JobPageUpdateContractTypeEntityRelationInput"]: {
	connect?: ModelTypes["ContractTypeUniqueWhere"] | undefined,
	create?: ModelTypes["ContractTypeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateContractTypeRelationInput"] | undefined,
	update?: ModelTypes["ContractTypeUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageUpsertContractTypeRelationInput"] | undefined
};
	["ContractTypeUpdateInput"]: {
	locales?: Array<ModelTypes["ContractTypeUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["ContractTypeLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["ContractTypeUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["ContractTypeUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContractTypeUpdateLocalesRelationInput"]: {
	by: ModelTypes["ContractTypeLocaleUniqueWhere"],
	data: ModelTypes["ContractTypeLocaleWithoutRootUpdateInput"]
};
	["ContractTypeLocaleWithoutRootUpdateInput"]: {
	type?: string | undefined,
	locale?: ModelTypes["ContractTypeLocaleUpdateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutContractTypesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContractTypeLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutContractTypesUpdateInput"] | undefined,
	upsert?: ModelTypes["ContractTypeLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutContractTypesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateJobCitiesEntityRelationInput"]: {
	create?: ModelTypes["JobCityLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateJobCitiesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertJobCitiesRelationInput"] | undefined,
	connect?: ModelTypes["JobCityLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobCityLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["JobCityLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateJobCitiesRelationInput"]: {
	by: ModelTypes["JobCityLocaleUniqueWhere"],
	data: ModelTypes["JobCityLocaleWithoutLocaleUpdateInput"]
};
	["JobCityLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["JobCityLocaleUpdateRootEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["JobCityUniqueWhere"] | undefined,
	create?: ModelTypes["JobCityWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobCityLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["JobCityWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["JobCityLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["JobCityWithoutLocalesUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["JobCityWithoutLocalesUpdateInput"],
	create: ModelTypes["JobCityWithoutLocalesCreateInput"]
};
	["LocaleUpsertJobCitiesRelationInput"]: {
	by: ModelTypes["JobCityLocaleUniqueWhere"],
	update: ModelTypes["JobCityLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["JobCityLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateJobPositionsEntityRelationInput"]: {
	create?: ModelTypes["JobPositionLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateJobPositionsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertJobPositionsRelationInput"] | undefined,
	connect?: ModelTypes["JobPositionLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobPositionLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["JobPositionLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateJobPositionsRelationInput"]: {
	by: ModelTypes["JobPositionLocaleUniqueWhere"],
	data: ModelTypes["JobPositionLocaleWithoutLocaleUpdateInput"]
};
	["JobPositionLocaleWithoutLocaleUpdateInput"]: {
	type?: string | undefined,
	root?: ModelTypes["JobPositionLocaleUpdateRootEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["JobPositionUniqueWhere"] | undefined,
	create?: ModelTypes["JobPositionWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPositionLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["JobPositionWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPositionLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["JobPositionWithoutLocalesUpdateInput"]: {
	jobs?: Array<ModelTypes["JobPositionUpdateJobsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionUpdateJobsEntityRelationInput"]: {
	create?: ModelTypes["JobPageWithoutJobPositionCreateInput"] | undefined,
	update?: ModelTypes["JobPositionUpdateJobsRelationInput"] | undefined,
	upsert?: ModelTypes["JobPositionUpsertJobsRelationInput"] | undefined,
	connect?: ModelTypes["JobPageUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobPageUniqueWhere"] | undefined,
	delete?: ModelTypes["JobPageUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobPositionUpdateJobsRelationInput"]: {
	by: ModelTypes["JobPageUniqueWhere"],
	data: ModelTypes["JobPageWithoutJobPositionUpdateInput"]
};
	["JobPageWithoutJobPositionUpdateInput"]: {
	locales?: Array<ModelTypes["JobPageUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["JobPageUpdateThemeEntityRelationInput"] | undefined,
	contractType?: ModelTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined,
	jobCity?: ModelTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: ModelTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: ModelTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["JobPageLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["JobPageUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["JobPageUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobPageUpdateLocalesRelationInput"]: {
	by: ModelTypes["JobPageLocaleUniqueWhere"],
	data: ModelTypes["JobPageLocaleWithoutRootUpdateInput"]
};
	["JobPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	text?: string | undefined,
	locale?: ModelTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	image?: ModelTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined,
	keyInfo?: ModelTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined,
	content?: ModelTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: ModelTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: ModelTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutJobPagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutJobPagesUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutJobPagesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateContractTypesEntityRelationInput"]: {
	create?: ModelTypes["ContractTypeLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateContractTypesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertContractTypesRelationInput"] | undefined,
	connect?: ModelTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateContractTypesRelationInput"]: {
	by: ModelTypes["ContractTypeLocaleUniqueWhere"],
	data: ModelTypes["ContractTypeLocaleWithoutLocaleUpdateInput"]
};
	["ContractTypeLocaleWithoutLocaleUpdateInput"]: {
	type?: string | undefined,
	root?: ModelTypes["ContractTypeLocaleUpdateRootEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["ContractTypeUniqueWhere"] | undefined,
	create?: ModelTypes["ContractTypeWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContractTypeLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["ContractTypeWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["ContractTypeLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ContractTypeWithoutLocalesUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["ContractTypeWithoutLocalesUpdateInput"],
	create: ModelTypes["ContractTypeWithoutLocalesCreateInput"]
};
	["LocaleUpsertContractTypesRelationInput"]: {
	by: ModelTypes["ContractTypeLocaleUniqueWhere"],
	update: ModelTypes["ContractTypeLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["ContractTypeLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateHomePagesEntityRelationInput"]: {
	create?: ModelTypes["HomePageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateHomePagesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertHomePagesRelationInput"] | undefined,
	connect?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateHomePagesRelationInput"]: {
	by: ModelTypes["HomePageLocaleUniqueWhere"],
	data: ModelTypes["HomePageLocaleWithoutLocaleUpdateInput"]
};
	["HomePageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["HomePageUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["HomePageWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["HomePageWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	theme?: ModelTypes["HomePageUpdateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageUpdateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageConnectOrCreateThemeRelationInput"] | undefined,
	update?: ModelTypes["ThemeUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageUpsertThemeRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageUpsertThemeRelationInput"]: {
	update: ModelTypes["ThemeUpdateInput"],
	create: ModelTypes["ThemeCreateInput"]
};
	["HomePageLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["HomePageWithoutLocalesUpdateInput"],
	create: ModelTypes["HomePageWithoutLocalesCreateInput"]
};
	["HomePageLocaleUpdateButtonEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateButtonRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertButtonRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertButtonRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["HomePageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["HomePageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["HomePageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutHomePageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutHomePageUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutHomePageUpdateInput"]: {
	url?: string | undefined,
	redirect?: ModelTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateJobPageEntityRelationInput"]: {
	connect?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateJobPageRelationInput"] | undefined,
	update?: ModelTypes["JobPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertJobPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobPageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	image?: ModelTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined,
	keyInfo?: ModelTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined,
	content?: ModelTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: ModelTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: ModelTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageLocaleUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobPageLocaleUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["JobPageLocaleUpdateKeyInfoEntityRelationInput"]: {
	connect?: ModelTypes["KeyInfoListUniqueWhere"] | undefined,
	create?: ModelTypes["KeyInfoListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateKeyInfoRelationInput"] | undefined,
	update?: ModelTypes["KeyInfoListUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageLocaleUpsertKeyInfoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["KeyInfoListUpdateInput"]: {
	items?: Array<ModelTypes["KeyInfoListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["KeyInfoItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["KeyInfoListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["KeyInfoListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["KeyInfoItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["KeyInfoItemUniqueWhere"] | undefined,
	delete?: ModelTypes["KeyInfoItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["KeyInfoListUpdateItemsRelationInput"]: {
	by: ModelTypes["KeyInfoItemUniqueWhere"],
	data: ModelTypes["KeyInfoItemWithoutListUpdateInput"]
};
	["KeyInfoItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	keyInfo?: string | undefined,
	icon?: ModelTypes["KeyInfoItemUpdateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemUpdateIconEntityRelationInput"]: {
	connect?: ModelTypes["IconUniqueWhere"] | undefined,
	create?: ModelTypes["IconCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["KeyInfoItemConnectOrCreateIconRelationInput"] | undefined,
	update?: ModelTypes["IconUpdateInput"] | undefined,
	upsert?: ModelTypes["KeyInfoItemUpsertIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["IconUpdateInput"]: {
	name?: string | undefined,
	icon?: ModelTypes["IconUpdateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IconUpdateIconEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["IconConnectOrCreateIconRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["IconUpsertIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["IconUpsertIconRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["KeyInfoItemUpsertIconRelationInput"]: {
	update: ModelTypes["IconUpdateInput"],
	create: ModelTypes["IconCreateInput"]
};
	["KeyInfoListUpsertItemsRelationInput"]: {
	by: ModelTypes["KeyInfoItemUniqueWhere"],
	update: ModelTypes["KeyInfoItemWithoutListUpdateInput"],
	create: ModelTypes["KeyInfoItemWithoutListCreateInput"]
};
	["JobPageLocaleUpsertKeyInfoRelationInput"]: {
	update: ModelTypes["KeyInfoListUpdateInput"],
	create: ModelTypes["KeyInfoListCreateInput"]
};
	["JobPageLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobPageLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["JobPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobPageLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["JobPageLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ModelTypes["StickyBarUniqueWhere"] | undefined,
	create?: ModelTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined,
	update?: ModelTypes["StickyBarUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageLocaleUpsertStickyBarRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StickyBarUpdateInput"]: {
	title?: string | undefined,
	link?: ModelTypes["StickyBarUpdateLinkEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	jobsForm?: ModelTypes["StickyBarUpdateJobsFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StickyBarUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StickyBarConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["StickyBarUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StickyBarUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["StickyBarUpdateJobsFormEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["StickyBarConnectOrCreateJobsFormRelationInput"] | undefined,
	update?: ModelTypes["JobsFormLocaleUpdateInput"] | undefined,
	upsert?: ModelTypes["StickyBarUpsertJobsFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFormLocaleUpdateInput"]: {
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	root?: ModelTypes["JobsFormLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobsFormLocaleUpdateLocaleEntityRelationInput"] | undefined,
	imageTextList?: ModelTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: ModelTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: ModelTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["JobsFormWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFormLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["JobsFormWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	fileIlustration?: ModelTypes["JobsFormUpdateFileIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormUpdateFileIlustrationEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormConnectOrCreateFileIlustrationRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFormUpsertFileIlustrationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFormUpsertFileIlustrationRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["JobsFormLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["JobsFormWithoutLocalesUpdateInput"],
	create: ModelTypes["JobsFormWithoutLocalesCreateInput"]
};
	["JobsFormLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutJobsFormsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutJobsFormsUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFormLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutJobsFormsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateBonusBannersEntityRelationInput"]: {
	create?: ModelTypes["BonusBannerLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateBonusBannersRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertBonusBannersRelationInput"] | undefined,
	connect?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateBonusBannersRelationInput"]: {
	by: ModelTypes["BonusBannerLocaleUniqueWhere"],
	data: ModelTypes["BonusBannerLocaleWithoutLocaleUpdateInput"]
};
	["BonusBannerLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined,
	tiles?: Array<ModelTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined,
	logo?: ModelTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleUpdateTilesEntityRelationInput"]: {
	create?: ModelTypes["TileWithoutBonusBannerCreateInput"] | undefined,
	update?: ModelTypes["BonusBannerLocaleUpdateTilesRelationInput"] | undefined,
	upsert?: ModelTypes["BonusBannerLocaleUpsertTilesRelationInput"] | undefined,
	connect?: ModelTypes["TileUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TileUniqueWhere"] | undefined,
	delete?: ModelTypes["TileUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BonusBannerLocaleUpdateTilesRelationInput"]: {
	by: ModelTypes["TileUniqueWhere"],
	data: ModelTypes["TileWithoutBonusBannerUpdateInput"]
};
	["TileWithoutBonusBannerUpdateInput"]: {
	order?: number | undefined,
	text?: string | undefined,
	image?: ModelTypes["TileUpdateImageEntityRelationInput"] | undefined,
	lightBoxTitle?: string | undefined,
	lightBoxText?: string | undefined,
	ligthBoxMedia?: ModelTypes["TileUpdateLigthBoxMediaEntityRelationInput"] | undefined,
	lightBoxSectionTitle?: string | undefined,
	title?: string | undefined,
	lightBoxLinkLabel?: string | undefined,
	lightBoxForm?: ModelTypes["TileUpdateLightBoxFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["TileUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["TileUpdateLigthBoxMediaEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileConnectOrCreateLigthBoxMediaRelationInput"] | undefined,
	update?: ModelTypes["MediumListUpdateInput"] | undefined,
	upsert?: ModelTypes["TileUpsertLigthBoxMediaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileUpsertLigthBoxMediaRelationInput"]: {
	update: ModelTypes["MediumListUpdateInput"],
	create: ModelTypes["MediumListCreateInput"]
};
	["TileUpdateLightBoxFormEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileConnectOrCreateLightBoxFormRelationInput"] | undefined,
	update?: ModelTypes["JobsFormLocaleUpdateInput"] | undefined,
	upsert?: ModelTypes["TileUpsertLightBoxFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileUpsertLightBoxFormRelationInput"]: {
	update: ModelTypes["JobsFormLocaleUpdateInput"],
	create: ModelTypes["JobsFormLocaleCreateInput"]
};
	["BonusBannerLocaleUpsertTilesRelationInput"]: {
	by: ModelTypes["TileUniqueWhere"],
	update: ModelTypes["TileWithoutBonusBannerUpdateInput"],
	create: ModelTypes["TileWithoutBonusBannerCreateInput"]
};
	["BonusBannerLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BonusBannerLocaleConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["BonusBannerLocaleUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BonusBannerLocaleUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["LocaleUpsertBonusBannersRelationInput"]: {
	by: ModelTypes["BonusBannerLocaleUniqueWhere"],
	update: ModelTypes["BonusBannerLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["BonusBannerLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateHomePageLokalsEntityRelationInput"]: {
	create?: ModelTypes["HomePageLokalLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateHomePageLokalsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertHomePageLokalsRelationInput"] | undefined,
	connect?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateHomePageLokalsRelationInput"]: {
	by: ModelTypes["HomePageLokalLocaleUniqueWhere"],
	data: ModelTypes["HomePageLokalLocaleWithoutLocaleUpdateInput"]
};
	["HomePageLokalLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["HomePageLokalUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageLokalWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["HomePageLokalWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	theme?: ModelTypes["HomePageLokalUpdateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalUpdateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalConnectOrCreateThemeRelationInput"] | undefined,
	update?: ModelTypes["ThemeUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalUpsertThemeRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalUpsertThemeRelationInput"]: {
	update: ModelTypes["ThemeUpdateInput"],
	create: ModelTypes["ThemeCreateInput"]
};
	["HomePageLokalLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["HomePageLokalWithoutLocalesUpdateInput"],
	create: ModelTypes["HomePageLokalWithoutLocalesCreateInput"]
};
	["HomePageLokalLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["HomePageLokalLocaleUpdateButtonEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateButtonRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertButtonRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertButtonRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["HomePageLokalLocaleUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["HomePageLokalLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["HomePageLokalLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutHomePageLokalCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutHomePageLokalUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutHomePageLokalUpdateInput"]: {
	url?: string | undefined,
	redirect?: ModelTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
	connect?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateHomePageRelationInput"] | undefined,
	update?: ModelTypes["HomePageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertHomePageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutHomePagesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutHomePagesUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutHomePagesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateJobsFormsEntityRelationInput"]: {
	create?: ModelTypes["JobsFormLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateJobsFormsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertJobsFormsRelationInput"] | undefined,
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateJobsFormsRelationInput"]: {
	by: ModelTypes["JobsFormLocaleUniqueWhere"],
	data: ModelTypes["JobsFormLocaleWithoutLocaleUpdateInput"]
};
	["JobsFormLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	root?: ModelTypes["JobsFormLocaleUpdateRootEntityRelationInput"] | undefined,
	imageTextList?: ModelTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: ModelTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: ModelTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormLocaleUpdateImageTextListEntityRelationInput"]: {
	connect?: ModelTypes["ImageTextListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageTextListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormLocaleConnectOrCreateImageTextListRelationInput"] | undefined,
	update?: ModelTypes["ImageTextListUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFormLocaleUpsertImageTextListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageTextListUpdateInput"]: {
	items?: Array<ModelTypes["ImageTextListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["ImageTextItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["ImageTextListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["ImageTextListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["ImageTextItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ImageTextItemUniqueWhere"] | undefined,
	delete?: ModelTypes["ImageTextItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ImageTextListUpdateItemsRelationInput"]: {
	by: ModelTypes["ImageTextItemUniqueWhere"],
	data: ModelTypes["ImageTextItemWithoutListUpdateInput"]
};
	["ImageTextItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	image?: ModelTypes["ImageTextItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageTextItemConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["ImageTextItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageTextItemUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["ImageTextListUpsertItemsRelationInput"]: {
	by: ModelTypes["ImageTextItemUniqueWhere"],
	update: ModelTypes["ImageTextItemWithoutListUpdateInput"],
	create: ModelTypes["ImageTextItemWithoutListCreateInput"]
};
	["JobsFormLocaleUpsertImageTextListRelationInput"]: {
	update: ModelTypes["ImageTextListUpdateInput"],
	create: ModelTypes["ImageTextListCreateInput"]
};
	["JobsFormLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormLocaleConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFormLocaleUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFormLocaleUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["JobsFormLocaleUpdateSuccessImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFormLocaleUpsertSuccessImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFormLocaleUpsertSuccessImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["LocaleUpsertJobsFormsRelationInput"]: {
	by: ModelTypes["JobsFormLocaleUniqueWhere"],
	update: ModelTypes["JobsFormLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["JobsFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateJobsFiltersEntityRelationInput"]: {
	create?: ModelTypes["JobsFilterLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateJobsFiltersRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertJobsFiltersRelationInput"] | undefined,
	connect?: ModelTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateJobsFiltersRelationInput"]: {
	by: ModelTypes["JobsFilterLocaleUniqueWhere"],
	data: ModelTypes["JobsFilterLocaleWithoutLocaleUpdateInput"]
};
	["JobsFilterLocaleWithoutLocaleUpdateInput"]: {
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	root?: ModelTypes["JobsFilterLocaleUpdateRootEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: ModelTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: ModelTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: ModelTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["JobsFilterUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFilterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["JobsFilterWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFilterLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["JobsFilterWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["JobsFilterWithoutLocalesUpdateInput"],
	create: ModelTypes["JobsFilterWithoutLocalesCreateInput"]
};
	["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"] | undefined,
	update?: ModelTypes["JobsFormLocaleUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFilterLocaleUpsertBannerJobsFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFilterLocaleUpsertBannerJobsFormRelationInput"]: {
	update: ModelTypes["JobsFormLocaleUpdateInput"],
	create: ModelTypes["JobsFormLocaleCreateInput"]
};
	["JobsFilterLocaleUpdateBannerImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFilterLocaleUpsertBannerImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFilterLocaleUpsertBannerImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFilterLocaleUpsertNoJobImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFilterLocaleUpsertNoJobImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["LocaleUpsertJobsFiltersRelationInput"]: {
	by: ModelTypes["JobsFilterLocaleUniqueWhere"],
	update: ModelTypes["JobsFilterLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["JobsFilterLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateGeneralEntityRelationInput"]: {
	create?: ModelTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateGeneralRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertGeneralRelationInput"] | undefined,
	connect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GeneralLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGeneralRelationInput"]: {
	by: ModelTypes["GeneralLocaleUniqueWhere"],
	data: ModelTypes["GeneralLocaleWithoutLocaleUpdateInput"]
};
	["GeneralLocaleWithoutLocaleUpdateInput"]: {
	root?: ModelTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	cornerBanner?: ModelTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["GeneralUniqueWhere"] | undefined,
	create?: ModelTypes["GeneralWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["GeneralWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GeneralWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["GeneralWithoutLocalesUpdateInput"],
	create: ModelTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GeneralLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["GeneralLocaleUpdateCornerBannerEntityRelationInput"]: {
	connect?: ModelTypes["CornerBannerUniqueWhere"] | undefined,
	create?: ModelTypes["CornerBannerCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GeneralLocaleConnectOrCreateCornerBannerRelationInput"] | undefined,
	update?: ModelTypes["CornerBannerUpdateInput"] | undefined,
	upsert?: ModelTypes["GeneralLocaleUpsertCornerBannerRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CornerBannerUpdateInput"]: {
	isActive?: boolean | undefined,
	title?: string | undefined,
	text?: string | undefined,
	logo?: ModelTypes["CornerBannerUpdateLogoEntityRelationInput"] | undefined,
	link?: ModelTypes["CornerBannerUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CornerBannerUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CornerBannerConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["CornerBannerUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CornerBannerUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["CornerBannerUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CornerBannerConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["CornerBannerUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CornerBannerUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["GeneralLocaleUpsertCornerBannerRelationInput"]: {
	update: ModelTypes["CornerBannerUpdateInput"],
	create: ModelTypes["CornerBannerCreateInput"]
};
	["LocaleUpsertGeneralRelationInput"]: {
	by: ModelTypes["GeneralLocaleUniqueWhere"],
	update: ModelTypes["GeneralLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateRecommendationFormsEntityRelationInput"]: {
	create?: ModelTypes["RecommendationFormLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateRecommendationFormsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertRecommendationFormsRelationInput"] | undefined,
	connect?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateRecommendationFormsRelationInput"]: {
	by: ModelTypes["RecommendationFormLocaleUniqueWhere"],
	data: ModelTypes["RecommendationFormLocaleWithoutLocaleUpdateInput"]
};
	["RecommendationFormLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	root?: ModelTypes["RecommendationFormLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["RecommendationFormUniqueWhere"] | undefined,
	create?: ModelTypes["RecommendationFormWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecommendationFormLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["RecommendationFormWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["RecommendationFormLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["RecommendationFormWithoutLocalesUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	successImage?: ModelTypes["RecommendationFormUpdateSuccessImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormUpdateSuccessImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecommendationFormConnectOrCreateSuccessImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["RecommendationFormUpsertSuccessImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RecommendationFormUpsertSuccessImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["RecommendationFormLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["RecommendationFormWithoutLocalesUpdateInput"],
	create: ModelTypes["RecommendationFormWithoutLocalesCreateInput"]
};
	["LocaleUpsertRecommendationFormsRelationInput"]: {
	by: ModelTypes["RecommendationFormLocaleUniqueWhere"],
	update: ModelTypes["RecommendationFormLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["RecommendationFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateInfoBoxesEntityRelationInput"]: {
	create?: ModelTypes["InfoBoxLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateInfoBoxesRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertInfoBoxesRelationInput"] | undefined,
	connect?: ModelTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateInfoBoxesRelationInput"]: {
	by: ModelTypes["InfoBoxLocaleUniqueWhere"],
	data: ModelTypes["InfoBoxLocaleWithoutLocaleUpdateInput"]
};
	["InfoBoxLocaleWithoutLocaleUpdateInput"]: {
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	root?: ModelTypes["InfoBoxLocaleUpdateRootEntityRelationInput"] | undefined,
	openingHours?: ModelTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["InfoBoxUniqueWhere"] | undefined,
	create?: ModelTypes["InfoBoxWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoBoxLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["InfoBoxWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["InfoBoxLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["InfoBoxWithoutLocalesUpdateInput"]: {
	logoSize?: ModelTypes["LogoSize"] | undefined,
	logo?: ModelTypes["InfoBoxUpdateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoBoxConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["InfoBoxUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InfoBoxUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["InfoBoxLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["InfoBoxWithoutLocalesUpdateInput"],
	create: ModelTypes["InfoBoxWithoutLocalesCreateInput"]
};
	["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"]: {
	connect?: ModelTypes["TextListUniqueWhere"] | undefined,
	create?: ModelTypes["TextListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"] | undefined,
	update?: ModelTypes["TextListUpdateInput"] | undefined,
	upsert?: ModelTypes["InfoBoxLocaleUpsertOpeningHoursRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InfoBoxLocaleUpsertOpeningHoursRelationInput"]: {
	update: ModelTypes["TextListUpdateInput"],
	create: ModelTypes["TextListCreateInput"]
};
	["LocaleUpsertInfoBoxesRelationInput"]: {
	by: ModelTypes["InfoBoxLocaleUniqueWhere"],
	update: ModelTypes["InfoBoxLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["InfoBoxLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateTranslationsEntityRelationInput"]: {
	create?: ModelTypes["TranslationLocaleWithoutLocaleCreateInput"] | undefined,
	update?: ModelTypes["LocaleUpdateTranslationsRelationInput"] | undefined,
	upsert?: ModelTypes["LocaleUpsertTranslationsRelationInput"] | undefined,
	connect?: ModelTypes["TranslationLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TranslationLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["TranslationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateTranslationsRelationInput"]: {
	by: ModelTypes["TranslationLocaleUniqueWhere"],
	data: ModelTypes["TranslationLocaleWithoutLocaleUpdateInput"]
};
	["TranslationLocaleWithoutLocaleUpdateInput"]: {
	value?: string | undefined,
	root?: ModelTypes["TranslationLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleUpdateRootEntityRelationInput"]: {
	connect?: ModelTypes["TranslationUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: ModelTypes["TranslationWithoutLocalesUpdateInput"] | undefined,
	upsert?: ModelTypes["TranslationLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationWithoutLocalesUpdateInput"]: {
	order?: number | undefined,
	key?: string | undefined,
	isTextarea?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["TranslationWithoutLocalesUpdateInput"],
	create: ModelTypes["TranslationWithoutLocalesCreateInput"]
};
	["LocaleUpsertTranslationsRelationInput"]: {
	by: ModelTypes["TranslationLocaleUniqueWhere"],
	update: ModelTypes["TranslationLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["TranslationLocaleWithoutLocaleCreateInput"]
};
	["HomePageLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutHomePagesUpdateInput"],
	create: ModelTypes["LocaleWithoutHomePagesCreateInput"]
};
	["HomePageLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"]: {
	connect?: ModelTypes["SiteSwitcherUniqueWhere"] | undefined,
	create?: ModelTypes["SiteSwitcherCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined,
	update?: ModelTypes["SiteSwitcherUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertSiteSwitcherRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SiteSwitcherUpdateInput"]: {
	title?: string | undefined,
	link?: ModelTypes["SiteSwitcherUpdateLinkEntityRelationInput"] | undefined,
	theme?: ModelTypes["SiteSwitcherUpdateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SiteSwitcherUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SiteSwitcherConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["SiteSwitcherUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SiteSwitcherUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["SiteSwitcherUpdateThemeEntityRelationInput"]: {
	connect?: ModelTypes["ThemeUniqueWhere"] | undefined,
	create?: ModelTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SiteSwitcherConnectOrCreateThemeRelationInput"] | undefined,
	update?: ModelTypes["ThemeUpdateInput"] | undefined,
	upsert?: ModelTypes["SiteSwitcherUpsertThemeRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SiteSwitcherUpsertThemeRelationInput"]: {
	update: ModelTypes["ThemeUpdateInput"],
	create: ModelTypes["ThemeCreateInput"]
};
	["HomePageLocaleUpsertSiteSwitcherRelationInput"]: {
	update: ModelTypes["SiteSwitcherUpdateInput"],
	create: ModelTypes["SiteSwitcherCreateInput"]
};
	["HomePageLocaleUpdateGalleryEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateGalleryRelationInput"] | undefined,
	update?: ModelTypes["GalleryUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertGalleryRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GalleryUpdateInput"]: {
	items?: Array<ModelTypes["GalleryUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["GalleryItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["GalleryUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["GalleryUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["GalleryItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GalleryItemUniqueWhere"] | undefined,
	delete?: ModelTypes["GalleryItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GalleryUpdateItemsRelationInput"]: {
	by: ModelTypes["GalleryItemUniqueWhere"],
	data: ModelTypes["GalleryItemWithoutListUpdateInput"]
};
	["GalleryItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	image?: ModelTypes["GalleryItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GalleryItemConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["GalleryItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GalleryItemUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["GalleryUpsertItemsRelationInput"]: {
	by: ModelTypes["GalleryItemUniqueWhere"],
	update: ModelTypes["GalleryItemWithoutListUpdateInput"],
	create: ModelTypes["GalleryItemWithoutListCreateInput"]
};
	["HomePageLocaleUpsertGalleryRelationInput"]: {
	update: ModelTypes["GalleryUpdateInput"],
	create: ModelTypes["GalleryCreateInput"]
};
	["HomePageLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ModelTypes["StickyBarUniqueWhere"] | undefined,
	create?: ModelTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateStickyBarRelationInput"] | undefined,
	update?: ModelTypes["StickyBarUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertStickyBarRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertStickyBarRelationInput"]: {
	update: ModelTypes["StickyBarUpdateInput"],
	create: ModelTypes["StickyBarCreateInput"]
};
	["HomePageLocaleUpdateIlustrationEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLocaleConnectOrCreateIlustrationRelationInput"] | undefined,
	update?: ModelTypes["GalleryUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLocaleUpsertIlustrationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertIlustrationRelationInput"]: {
	update: ModelTypes["GalleryUpdateInput"],
	create: ModelTypes["GalleryCreateInput"]
};
	["LinkableUpsertHomePageRelationInput"]: {
	update: ModelTypes["HomePageLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["HomePageLocaleWithoutLinkCreateInput"]
};
	["HomePageLokalLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutHomePageLokalUpdateInput"],
	create: ModelTypes["LinkableWithoutHomePageLokalCreateInput"]
};
	["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"]: {
	connect?: ModelTypes["SiteSwitcherUniqueWhere"] | undefined,
	create?: ModelTypes["SiteSwitcherCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined,
	update?: ModelTypes["SiteSwitcherUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertSiteSwitcherRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertSiteSwitcherRelationInput"]: {
	update: ModelTypes["SiteSwitcherUpdateInput"],
	create: ModelTypes["SiteSwitcherCreateInput"]
};
	["HomePageLokalLocaleUpdateGalleryEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"] | undefined,
	update?: ModelTypes["GalleryUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertGalleryRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertGalleryRelationInput"]: {
	update: ModelTypes["GalleryUpdateInput"],
	create: ModelTypes["GalleryCreateInput"]
};
	["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ModelTypes["StickyBarUniqueWhere"] | undefined,
	create?: ModelTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"] | undefined,
	update?: ModelTypes["StickyBarUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertStickyBarRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertStickyBarRelationInput"]: {
	update: ModelTypes["StickyBarUpdateInput"],
	create: ModelTypes["StickyBarCreateInput"]
};
	["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"] | undefined,
	update?: ModelTypes["GalleryUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertIlustrationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertIlustrationRelationInput"]: {
	update: ModelTypes["GalleryUpdateInput"],
	create: ModelTypes["GalleryCreateInput"]
};
	["LocaleUpsertHomePageLokalsRelationInput"]: {
	by: ModelTypes["HomePageLokalLocaleUniqueWhere"],
	update: ModelTypes["HomePageLokalLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["HomePageLokalLocaleWithoutLocaleCreateInput"]
};
	["JobsFormLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutJobsFormsUpdateInput"],
	create: ModelTypes["LocaleWithoutJobsFormsCreateInput"]
};
	["StickyBarUpsertJobsFormRelationInput"]: {
	update: ModelTypes["JobsFormLocaleUpdateInput"],
	create: ModelTypes["JobsFormLocaleCreateInput"]
};
	["JobPageLocaleUpsertStickyBarRelationInput"]: {
	update: ModelTypes["StickyBarUpdateInput"],
	create: ModelTypes["StickyBarCreateInput"]
};
	["JobPageLocaleUpdateMobileImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateMobileImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageLocaleUpsertMobileImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobPageLocaleUpsertMobileImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["LinkableUpsertJobPageRelationInput"]: {
	update: ModelTypes["JobPageLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["JobPageLocaleWithoutLinkCreateInput"]
};
	["LinkableUpdateHomePageLokalEntityRelationInput"]: {
	connect?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageLokalLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["LinkableConnectOrCreateHomePageLokalRelationInput"] | undefined,
	update?: ModelTypes["HomePageLokalLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: ModelTypes["LinkableUpsertHomePageLokalRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutHomePageLokalsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutHomePageLokalsUpdateInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutHomePageLokalsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutHomePageLokalsUpdateInput"],
	create: ModelTypes["LocaleWithoutHomePageLokalsCreateInput"]
};
	["LinkableUpsertHomePageLokalRelationInput"]: {
	update: ModelTypes["HomePageLokalLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["HomePageLokalLocaleWithoutLinkCreateInput"]
};
	["HomePageLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutHomePageUpdateInput"],
	create: ModelTypes["LinkableWithoutHomePageCreateInput"]
};
	["LocaleUpsertHomePagesRelationInput"]: {
	by: ModelTypes["HomePageLocaleUniqueWhere"],
	update: ModelTypes["HomePageLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["HomePageLocaleWithoutLocaleCreateInput"]
};
	["JobPageLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutJobPagesUpdateInput"],
	create: ModelTypes["LocaleWithoutJobPagesCreateInput"]
};
	["JobPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutJobPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutJobPageUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutJobPageUpdateInput"]: {
	url?: string | undefined,
	redirect?: ModelTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutJobPageUpdateInput"],
	create: ModelTypes["LinkableWithoutJobPageCreateInput"]
};
	["JobPageUpsertLocalesRelationInput"]: {
	by: ModelTypes["JobPageLocaleUniqueWhere"],
	update: ModelTypes["JobPageLocaleWithoutRootUpdateInput"],
	create: ModelTypes["JobPageLocaleWithoutRootCreateInput"]
};
	["JobPageUpdateJobCityEntityRelationInput"]: {
	connect?: ModelTypes["JobCityUniqueWhere"] | undefined,
	create?: ModelTypes["JobCityCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateJobCityRelationInput"] | undefined,
	update?: ModelTypes["JobCityUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageUpsertJobCityRelationInput"] | undefined
};
	["JobCityUpdateInput"]: {
	locales?: Array<ModelTypes["JobCityUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["JobCityLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["JobCityUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["JobCityUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["JobCityLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobCityLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["JobCityLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobCityUpdateLocalesRelationInput"]: {
	by: ModelTypes["JobCityLocaleUniqueWhere"],
	data: ModelTypes["JobCityLocaleWithoutRootUpdateInput"]
};
	["JobCityLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["JobCityLocaleUpdateLocaleEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutJobCitiesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobCityLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutJobCitiesUpdateInput"] | undefined,
	upsert?: ModelTypes["JobCityLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutJobCitiesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutJobCitiesUpdateInput"],
	create: ModelTypes["LocaleWithoutJobCitiesCreateInput"]
};
	["JobCityUpsertLocalesRelationInput"]: {
	by: ModelTypes["JobCityLocaleUniqueWhere"],
	update: ModelTypes["JobCityLocaleWithoutRootUpdateInput"],
	create: ModelTypes["JobCityLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertJobCityRelationInput"]: {
	update: ModelTypes["JobCityUpdateInput"],
	create: ModelTypes["JobCityCreateInput"]
};
	["JobPageUpdateBusinessEntityRelationInput"]: {
	connect?: ModelTypes["BusinessPageUniqueWhere"] | undefined,
	create?: ModelTypes["BusinessPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateBusinessRelationInput"] | undefined,
	update?: ModelTypes["BusinessPageUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageUpsertBusinessRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessPageUpdateInput"]: {
	locales?: Array<ModelTypes["BusinessPageUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["BusinessPageUpdateThemeEntityRelationInput"] | undefined,
	isLokal?: boolean | undefined,
	tabidooId?: string | undefined,
	headerColor?: string | undefined,
	recruitisOfficeId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["BusinessPageLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["BusinessPageUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["BusinessPageUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BusinessPageUpdateLocalesRelationInput"]: {
	by: ModelTypes["BusinessPageLocaleUniqueWhere"],
	data: ModelTypes["BusinessPageLocaleWithoutRootUpdateInput"]
};
	["BusinessPageLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: ModelTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	infoBox?: ModelTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleUpdateSeoEntityRelationInput"]: {
	connect?: ModelTypes["SeoUniqueWhere"] | undefined,
	create?: ModelTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: ModelTypes["SeoUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessPageLocaleUpsertSeoRelationInput"]: {
	update: ModelTypes["SeoUpdateInput"],
	create: ModelTypes["SeoCreateInput"]
};
	["BusinessPageLocaleUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutBusinessPageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutBusinessPageUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutBusinessPageUpdateInput"]: {
	url?: string | undefined,
	redirect?: ModelTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutBusinessPageUpdateInput"],
	create: ModelTypes["LinkableWithoutBusinessPageCreateInput"]
};
	["BusinessPageLocaleUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessPageLocaleUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessPageLocaleUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["BusinessPageLocaleUpdateStickyBarEntityRelationInput"]: {
	connect?: ModelTypes["StickyBarUniqueWhere"] | undefined,
	create?: ModelTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined,
	update?: ModelTypes["StickyBarUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessPageLocaleUpsertStickyBarRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessPageLocaleUpsertStickyBarRelationInput"]: {
	update: ModelTypes["StickyBarUpdateInput"],
	create: ModelTypes["StickyBarCreateInput"]
};
	["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"]: {
	connect?: ModelTypes["InfoBoxUniqueWhere"] | undefined,
	create?: ModelTypes["InfoBoxCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"] | undefined,
	update?: ModelTypes["InfoBoxUpdateInput"] | undefined,
	upsert?: ModelTypes["BusinessPageLocaleUpsertInfoBoxRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InfoBoxUpdateInput"]: {
	logoSize?: ModelTypes["LogoSize"] | undefined,
	logo?: ModelTypes["InfoBoxUpdateLogoEntityRelationInput"] | undefined,
	locales?: Array<ModelTypes["InfoBoxUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["InfoBoxLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["InfoBoxUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["InfoBoxUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["InfoBoxUpdateLocalesRelationInput"]: {
	by: ModelTypes["InfoBoxLocaleUniqueWhere"],
	data: ModelTypes["InfoBoxLocaleWithoutRootUpdateInput"]
};
	["InfoBoxLocaleWithoutRootUpdateInput"]: {
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	locale?: ModelTypes["InfoBoxLocaleUpdateLocaleEntityRelationInput"] | undefined,
	openingHours?: ModelTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutInfoBoxesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["InfoBoxLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutInfoBoxesUpdateInput"] | undefined,
	upsert?: ModelTypes["InfoBoxLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutInfoBoxesUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutInfoBoxesUpdateInput"],
	create: ModelTypes["LocaleWithoutInfoBoxesCreateInput"]
};
	["InfoBoxUpsertLocalesRelationInput"]: {
	by: ModelTypes["InfoBoxLocaleUniqueWhere"],
	update: ModelTypes["InfoBoxLocaleWithoutRootUpdateInput"],
	create: ModelTypes["InfoBoxLocaleWithoutRootCreateInput"]
};
	["BusinessPageLocaleUpsertInfoBoxRelationInput"]: {
	update: ModelTypes["InfoBoxUpdateInput"],
	create: ModelTypes["InfoBoxCreateInput"]
};
	["BusinessPageUpsertLocalesRelationInput"]: {
	by: ModelTypes["BusinessPageLocaleUniqueWhere"],
	update: ModelTypes["BusinessPageLocaleWithoutRootUpdateInput"],
	create: ModelTypes["BusinessPageLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertBusinessRelationInput"]: {
	update: ModelTypes["BusinessPageUpdateInput"],
	create: ModelTypes["BusinessPageCreateInput"]
};
	["JobPositionUpsertJobsRelationInput"]: {
	by: ModelTypes["JobPageUniqueWhere"],
	update: ModelTypes["JobPageWithoutJobPositionUpdateInput"],
	create: ModelTypes["JobPageWithoutJobPositionCreateInput"]
};
	["JobPositionLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["JobPositionWithoutLocalesUpdateInput"],
	create: ModelTypes["JobPositionWithoutLocalesCreateInput"]
};
	["LocaleUpsertJobPositionsRelationInput"]: {
	by: ModelTypes["JobPositionLocaleUniqueWhere"],
	update: ModelTypes["JobPositionLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["JobPositionLocaleWithoutLocaleCreateInput"]
};
	["ContractTypeLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutContractTypesUpdateInput"],
	create: ModelTypes["LocaleWithoutContractTypesCreateInput"]
};
	["ContractTypeUpsertLocalesRelationInput"]: {
	by: ModelTypes["ContractTypeLocaleUniqueWhere"],
	update: ModelTypes["ContractTypeLocaleWithoutRootUpdateInput"],
	create: ModelTypes["ContractTypeLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertContractTypeRelationInput"]: {
	update: ModelTypes["ContractTypeUpdateInput"],
	create: ModelTypes["ContractTypeCreateInput"]
};
	["JobPageUpdateJobPositionEntityRelationInput"]: {
	connect?: ModelTypes["JobPositionUniqueWhere"] | undefined,
	create?: ModelTypes["JobPositionWithoutJobsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPageConnectOrCreateJobPositionRelationInput"] | undefined,
	update?: ModelTypes["JobPositionWithoutJobsUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPageUpsertJobPositionRelationInput"] | undefined
};
	["JobPositionWithoutJobsUpdateInput"]: {
	locales?: Array<ModelTypes["JobPositionUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["JobPositionLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["JobPositionUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["JobPositionUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["JobPositionLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobPositionLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["JobPositionLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobPositionUpdateLocalesRelationInput"]: {
	by: ModelTypes["JobPositionLocaleUniqueWhere"],
	data: ModelTypes["JobPositionLocaleWithoutRootUpdateInput"]
};
	["JobPositionLocaleWithoutRootUpdateInput"]: {
	type?: string | undefined,
	locale?: ModelTypes["JobPositionLocaleUpdateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutJobPositionsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobPositionLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutJobPositionsUpdateInput"] | undefined,
	upsert?: ModelTypes["JobPositionLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutJobPositionsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutJobPositionsUpdateInput"],
	create: ModelTypes["LocaleWithoutJobPositionsCreateInput"]
};
	["JobPositionUpsertLocalesRelationInput"]: {
	by: ModelTypes["JobPositionLocaleUniqueWhere"],
	update: ModelTypes["JobPositionLocaleWithoutRootUpdateInput"],
	create: ModelTypes["JobPositionLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertJobPositionRelationInput"]: {
	update: ModelTypes["JobPositionWithoutJobsUpdateInput"],
	create: ModelTypes["JobPositionWithoutJobsCreateInput"]
};
	["JobPageLocaleUpsertRootRelationInput"]: {
	update: ModelTypes["JobPageWithoutLocalesUpdateInput"],
	create: ModelTypes["JobPageWithoutLocalesCreateInput"]
};
	["LocaleUpsertJobPagesRelationInput"]: {
	by: ModelTypes["JobPageLocaleUniqueWhere"],
	update: ModelTypes["JobPageLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["JobPageLocaleWithoutLocaleCreateInput"]
};
	["BusinessPageLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutBusinessPagesUpdateInput"],
	create: ModelTypes["LocaleWithoutBusinessPagesCreateInput"]
};
	["LinkableUpsertBusinessPageRelationInput"]: {
	update: ModelTypes["BusinessPageLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["BusinessPageLocaleWithoutLinkCreateInput"]
};
	["GenericPageLocaleUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutGenericPageUpdateInput"],
	create: ModelTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageLocaleUpdateLogoEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateLogoRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertLogoRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["GenericPageLocaleUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageLocaleConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["GenericPageLocaleUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["LocaleUpsertGenericPagesRelationInput"]: {
	by: ModelTypes["GenericPageLocaleUniqueWhere"],
	update: ModelTypes["GenericPageLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["BonusBannerLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutBonusBannersUpdateInput"],
	create: ModelTypes["LocaleWithoutBonusBannersCreateInput"]
};
	["ContentReferenceUpsertBonusBannerRelationInput"]: {
	update: ModelTypes["BonusBannerLocaleUpdateInput"],
	create: ModelTypes["BonusBannerLocaleCreateInput"]
};
	["ContentReferenceUpdateSideBySideEntityRelationInput"]: {
	connect?: ModelTypes["SideBySideUniqueWhere"] | undefined,
	create?: ModelTypes["SideBySideCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateSideBySideRelationInput"] | undefined,
	update?: ModelTypes["SideBySideUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertSideBySideRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SideBySideUpdateInput"]: {
	items?: Array<ModelTypes["SideBySideUpdateItemsEntityRelationInput"]> | undefined,
	background?: ModelTypes["Background"] | undefined,
	alignment?: ModelTypes["ContentAlignment"] | undefined,
	mediumSize?: ModelTypes["MediumSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["SideBySideItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["SideBySideUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["SideBySideUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["SideBySideItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["SideBySideItemUniqueWhere"] | undefined,
	delete?: ModelTypes["SideBySideItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SideBySideUpdateItemsRelationInput"]: {
	by: ModelTypes["SideBySideItemUniqueWhere"],
	data: ModelTypes["SideBySideItemWithoutListUpdateInput"]
};
	["SideBySideItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	text?: string | undefined,
	media?: ModelTypes["SideBySideItemUpdateMediaEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	type?: ModelTypes["SideBySideItemType"] | undefined,
	link?: ModelTypes["SideBySideItemUpdateLinkEntityRelationInput"] | undefined,
	jobsForm?: ModelTypes["SideBySideItemUpdateJobsFormEntityRelationInput"] | undefined,
	textNew?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemUpdateMediaEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SideBySideItemConnectOrCreateMediaRelationInput"] | undefined,
	update?: ModelTypes["MediumListUpdateInput"] | undefined,
	upsert?: ModelTypes["SideBySideItemUpsertMediaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SideBySideItemUpsertMediaRelationInput"]: {
	update: ModelTypes["MediumListUpdateInput"],
	create: ModelTypes["MediumListCreateInput"]
};
	["SideBySideItemUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SideBySideItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["SideBySideItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SideBySideItemUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["SideBySideItemUpdateJobsFormEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SideBySideItemConnectOrCreateJobsFormRelationInput"] | undefined,
	update?: ModelTypes["JobsFormLocaleUpdateInput"] | undefined,
	upsert?: ModelTypes["SideBySideItemUpsertJobsFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SideBySideItemUpsertJobsFormRelationInput"]: {
	update: ModelTypes["JobsFormLocaleUpdateInput"],
	create: ModelTypes["JobsFormLocaleCreateInput"]
};
	["SideBySideUpsertItemsRelationInput"]: {
	by: ModelTypes["SideBySideItemUniqueWhere"],
	update: ModelTypes["SideBySideItemWithoutListUpdateInput"],
	create: ModelTypes["SideBySideItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertSideBySideRelationInput"]: {
	update: ModelTypes["SideBySideUpdateInput"],
	create: ModelTypes["SideBySideCreateInput"]
};
	["ContentReferenceUpdateGalleryEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateGalleryRelationInput"] | undefined,
	update?: ModelTypes["GalleryUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertGalleryRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertGalleryRelationInput"]: {
	update: ModelTypes["GalleryUpdateInput"],
	create: ModelTypes["GalleryCreateInput"]
};
	["ContentReferenceUpdateVideoEntityRelationInput"]: {
	connect?: ModelTypes["VideoUniqueWhere"] | undefined,
	create?: ModelTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined,
	update?: ModelTypes["VideoUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertVideoRelationInput"]: {
	update: ModelTypes["VideoUpdateInput"],
	create: ModelTypes["VideoCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by: ModelTypes["ContentReferenceUniqueWhere"],
	update: ModelTypes["ContentReferenceWithoutBlockUpdateInput"],
	create: ModelTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
	by: ModelTypes["ContentBlockUniqueWhere"],
	update: ModelTypes["ContentBlockWithoutContentUpdateInput"],
	create: ModelTypes["ContentBlockWithoutContentCreateInput"]
};
	["BusinessPageLocaleUpsertContentRelationInput"]: {
	update: ModelTypes["ContentUpdateInput"],
	create: ModelTypes["ContentCreateInput"]
};
	["LocaleUpsertBusinessPagesRelationInput"]: {
	by: ModelTypes["BusinessPageLocaleUniqueWhere"],
	update: ModelTypes["BusinessPageLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["BusinessPageLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutGenericPagesUpdateInput"],
	create: ModelTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableUpsertGenericPageRelationInput"]: {
	update: ModelTypes["GenericPageLocaleWithoutLinkUpdateInput"],
	create: ModelTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update: ModelTypes["LinkableUpdateInput"],
	create: ModelTypes["LinkableCreateInput"]
};
	["FooterLinkUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["FooterLocaleUpsertLinksFirstColumnRelationInput"]: {
	by: ModelTypes["FooterLinkUniqueWhere"],
	update: ModelTypes["FooterLinkUpdateInput"],
	create: ModelTypes["FooterLinkCreateInput"]
};
	["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]: {
	create?: ModelTypes["FooterLinkCreateInput"] | undefined,
	update?: ModelTypes["FooterLocaleUpdateLinksSecondColumnRelationInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertLinksSecondColumnRelationInput"] | undefined,
	connect?: ModelTypes["FooterLinkUniqueWhere"] | undefined,
	disconnect?: ModelTypes["FooterLinkUniqueWhere"] | undefined,
	delete?: ModelTypes["FooterLinkUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleUpdateLinksSecondColumnRelationInput"]: {
	by: ModelTypes["FooterLinkUniqueWhere"],
	data: ModelTypes["FooterLinkUpdateInput"]
};
	["FooterLocaleUpsertLinksSecondColumnRelationInput"]: {
	by: ModelTypes["FooterLinkUniqueWhere"],
	update: ModelTypes["FooterLinkUpdateInput"],
	create: ModelTypes["FooterLinkCreateInput"]
};
	["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertTermsAndConditionsRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertTermsAndConditionsRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateBannerImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateBannerImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertBannerImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertBannerImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["FooterLocaleUpdateBannerLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateBannerLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertBannerLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertBannerLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateJobsFormEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateJobsFormRelationInput"] | undefined,
	update?: ModelTypes["JobsFormLocaleUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertJobsFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertJobsFormRelationInput"]: {
	update: ModelTypes["JobsFormLocaleUpdateInput"],
	create: ModelTypes["JobsFormLocaleCreateInput"]
};
	["FooterLocaleUpdateCopyrightLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertCopyrightLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertCopyrightLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateRecommendationFormEntityRelationInput"]: {
	connect?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["RecommendationFormLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateRecommendationFormRelationInput"] | undefined,
	update?: ModelTypes["RecommendationFormLocaleUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertRecommendationFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RecommendationFormLocaleUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	root?: ModelTypes["RecommendationFormLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["RecommendationFormLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutRecommendationFormsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutRecommendationFormsUpdateInput"] | undefined,
	upsert?: ModelTypes["RecommendationFormLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutRecommendationFormsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutRecommendationFormsUpdateInput"],
	create: ModelTypes["LocaleWithoutRecommendationFormsCreateInput"]
};
	["FooterLocaleUpsertRecommendationFormRelationInput"]: {
	update: ModelTypes["RecommendationFormLocaleUpdateInput"],
	create: ModelTypes["RecommendationFormLocaleCreateInput"]
};
	["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertBannerSecondLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertBannerSecondLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateInstagramLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkUniqueWhere"] | undefined,
	create?: ModelTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateInstagramLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertInstagramLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertInstagramLinkRelationInput"]: {
	update: ModelTypes["LinkUpdateInput"],
	create: ModelTypes["LinkCreateInput"]
};
	["LocaleUpsertFootersRelationInput"]: {
	by: ModelTypes["FooterLocaleUniqueWhere"],
	update: ModelTypes["FooterLocaleWithoutLocaleUpdateInput"],
	create: ModelTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutGeneralUpdateInput"],
	create: ModelTypes["LocaleWithoutGeneralCreateInput"]
};
	["GeneralUpsertLocalesRelationInput"]: {
	by: ModelTypes["GeneralLocaleUniqueWhere"],
	update: ModelTypes["GeneralLocaleWithoutRootUpdateInput"],
	create: ModelTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["ImageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ImageEdge"]>
};
	["ImageEdge"]: {
		node: ModelTypes["Image"]
};
	["GenericPageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GenericPageEdge"]>
};
	["GenericPageEdge"]: {
		node: ModelTypes["GenericPage"]
};
	["GenericPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["GenericPageCreateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GenericPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: ModelTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: ModelTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined,
	image?: ModelTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["GenericPageLocaleUniqueWhere"],
	create: ModelTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["GenericPageUpdateInput"]: {
	locales?: Array<ModelTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["GenericPageUpdateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["GenericPageUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["GenericPageUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["GenericPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GenericPageUpdateLocalesRelationInput"]: {
	by: ModelTypes["GenericPageLocaleUniqueWhere"],
	data: ModelTypes["GenericPageLocaleWithoutRootUpdateInput"]
};
	["GenericPageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	locale?: ModelTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: ModelTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined,
	image?: ModelTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpsertLocalesRelationInput"]: {
	by: ModelTypes["GenericPageLocaleUniqueWhere"],
	update: ModelTypes["GenericPageLocaleWithoutRootUpdateInput"],
	create: ModelTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["LinkableConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
		node: ModelTypes["Linkable"]
};
	["SeoConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["SeoEdge"]>
};
	["SeoEdge"]: {
		node: ModelTypes["Seo"]
};
	["ContentConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ContentEdge"]>
};
	["ContentEdge"]: {
		node: ModelTypes["Content"]
};
	["ContentBlockCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	content?: ModelTypes["ContentBlockCreateContentEntityRelationInput"] | undefined,
	references?: Array<ModelTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentWithoutBlocksCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined
};
	["ContentWithoutBlocksCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockConnectOrCreateContentRelationInput"]: {
	connect: ModelTypes["ContentUniqueWhere"],
	create: ModelTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentBlockUpdateInput"]: {
	order?: number | undefined,
	json?: string | undefined,
	content?: ModelTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined,
	references?: Array<ModelTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	connect?: ModelTypes["ContentUniqueWhere"] | undefined,
	create?: ModelTypes["ContentWithoutBlocksCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined,
	update?: ModelTypes["ContentWithoutBlocksUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentBlockUpsertContentRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpsertContentRelationInput"]: {
	update: ModelTypes["ContentWithoutBlocksUpdateInput"],
	create: ModelTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: ModelTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: ModelTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined,
	image?: ModelTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined,
	linkables?: Array<ModelTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	media?: ModelTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined,
	textList?: ModelTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined,
	carousel?: ModelTypes["ContentReferenceCreateCarouselEntityRelationInput"] | undefined,
	bonusBanner?: ModelTypes["ContentReferenceCreateBonusBannerEntityRelationInput"] | undefined,
	sideBySide?: ModelTypes["ContentReferenceCreateSideBySideEntityRelationInput"] | undefined,
	gallery?: ModelTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined,
	showBoolean?: boolean | undefined,
	isRed?: boolean | undefined,
	video?: ModelTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	create?: ModelTypes["ContentBlockWithoutReferencesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	content?: ModelTypes["ContentBlockCreateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceConnectOrCreateBlockRelationInput"]: {
	connect: ModelTypes["ContentBlockUniqueWhere"],
	create: ModelTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceUpdateInput"]: {
	type?: ModelTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: ModelTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined,
	image?: ModelTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined,
	linkables?: Array<ModelTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined,
	secondaryText?: string | undefined,
	link?: ModelTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	media?: ModelTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined,
	textList?: ModelTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined,
	carousel?: ModelTypes["ContentReferenceUpdateCarouselEntityRelationInput"] | undefined,
	bonusBanner?: ModelTypes["ContentReferenceUpdateBonusBannerEntityRelationInput"] | undefined,
	sideBySide?: ModelTypes["ContentReferenceUpdateSideBySideEntityRelationInput"] | undefined,
	gallery?: ModelTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined,
	showBoolean?: boolean | undefined,
	isRed?: boolean | undefined,
	video?: ModelTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	connect?: ModelTypes["ContentBlockUniqueWhere"] | undefined,
	create?: ModelTypes["ContentBlockWithoutReferencesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined,
	update?: ModelTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined,
	upsert?: ModelTypes["ContentReferenceUpsertBlockRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?: number | undefined,
	json?: string | undefined,
	content?: ModelTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update: ModelTypes["ContentBlockWithoutReferencesUpdateInput"],
	create: ModelTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["RedirectConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["RedirectEdge"]>
};
	["RedirectEdge"]: {
		node: ModelTypes["Redirect"]
};
	["RedirectCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	link?: ModelTypes["RedirectCreateLinkEntityRelationInput"] | undefined,
	target?: ModelTypes["RedirectCreateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectCreateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutRedirectCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RedirectConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutRedirectCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectConnectOrCreateLinkRelationInput"]: {
	connect: ModelTypes["LinkableUniqueWhere"],
	create: ModelTypes["LinkableWithoutRedirectCreateInput"]
};
	["RedirectUpdateInput"]: {
	link?: ModelTypes["RedirectUpdateLinkEntityRelationInput"] | undefined,
	target?: ModelTypes["RedirectUpdateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectUpdateLinkEntityRelationInput"]: {
	connect?: ModelTypes["LinkableUniqueWhere"] | undefined,
	create?: ModelTypes["LinkableWithoutRedirectCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RedirectConnectOrCreateLinkRelationInput"] | undefined,
	update?: ModelTypes["LinkableWithoutRedirectUpdateInput"] | undefined,
	upsert?: ModelTypes["RedirectUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutRedirectUpdateInput"]: {
	url?: string | undefined,
	genericPage?: ModelTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	businessPage?: ModelTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: ModelTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePage?: ModelTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: ModelTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectUpsertLinkRelationInput"]: {
	update: ModelTypes["LinkableWithoutRedirectUpdateInput"],
	create: ModelTypes["LinkableWithoutRedirectCreateInput"]
};
	["LinkConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["LinkEdge"]>
};
	["LinkEdge"]: {
		node: ModelTypes["Link"]
};
	["FooterConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FooterEdge"]>
};
	["FooterEdge"]: {
		node: ModelTypes["Footer"]
};
	["FooterCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["FooterCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["FooterLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	locale?: ModelTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<ModelTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<ModelTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: ModelTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: ModelTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: ModelTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: ModelTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: ModelTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: ModelTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: ModelTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: ModelTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutFootersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutFootersCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["FooterLocaleUniqueWhere"],
	create: ModelTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["FooterUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["FooterLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["FooterUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["FooterUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["FooterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FooterUpdateLocalesRelationInput"]: {
	by: ModelTypes["FooterLocaleUniqueWhere"],
	data: ModelTypes["FooterLocaleWithoutRootUpdateInput"]
};
	["FooterLocaleWithoutRootUpdateInput"]: {
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	locale?: ModelTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<ModelTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<ModelTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: ModelTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: ModelTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: ModelTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: ModelTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: ModelTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: ModelTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: ModelTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: ModelTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutFootersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutFootersUpdateInput"] | undefined,
	upsert?: ModelTypes["FooterLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutFootersUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutFootersUpdateInput"],
	create: ModelTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterUpsertLocalesRelationInput"]: {
	by: ModelTypes["FooterLocaleUniqueWhere"],
	update: ModelTypes["FooterLocaleWithoutRootUpdateInput"],
	create: ModelTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	root?: ModelTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<ModelTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<ModelTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: ModelTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: ModelTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: ModelTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: ModelTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: ModelTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: ModelTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: ModelTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: ModelTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateInput"]: {
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	root?: ModelTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<ModelTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<ModelTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: ModelTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: ModelTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: ModelTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: ModelTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: ModelTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: ModelTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: ModelTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: ModelTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: ModelTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined,
	image?: ModelTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: ModelTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined,
	image?: ModelTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["HeaderEdge"]>
};
	["HeaderEdge"]: {
		node: ModelTypes["Header"]
};
	["HeaderCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["HeaderCreateLocalesEntityRelationInput"]> | undefined,
	logo?: ModelTypes["HeaderCreateLogoEntityRelationInput"] | undefined,
	logoMenu?: ModelTypes["HeaderCreateLogoMenuEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HeaderLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<ModelTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<ModelTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: ModelTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: ModelTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutHeadersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutHeadersCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["HeaderLocaleUniqueWhere"],
	create: ModelTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["HeaderUpdateLocalesEntityRelationInput"]> | undefined,
	logo?: ModelTypes["HeaderUpdateLogoEntityRelationInput"] | undefined,
	logoMenu?: ModelTypes["HeaderUpdateLogoMenuEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["HeaderLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["HeaderUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["HeaderUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["HeaderLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeaderUpdateLocalesRelationInput"]: {
	by: ModelTypes["HeaderLocaleUniqueWhere"],
	data: ModelTypes["HeaderLocaleWithoutRootUpdateInput"]
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<ModelTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<ModelTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: ModelTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: ModelTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutHeadersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutHeadersUpdateInput"] | undefined,
	upsert?: ModelTypes["HeaderLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutHeadersUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutHeadersUpdateInput"],
	create: ModelTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderUpsertLocalesRelationInput"]: {
	by: ModelTypes["HeaderLocaleUniqueWhere"],
	update: ModelTypes["HeaderLocaleWithoutRootUpdateInput"],
	create: ModelTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<ModelTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<ModelTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: ModelTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: ModelTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateInput"]: {
	root?: ModelTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<ModelTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<ModelTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: ModelTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: ModelTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["LocaleEdge"]>
};
	["LocaleEdge"]: {
		node: ModelTypes["Locale"]
};
	["LocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["SeoDefaultEdge"]>
};
	["SeoDefaultEdge"]: {
		node: ModelTypes["SeoDefault"]
};
	["SeoDefaultCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["SeoDefaultCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["SeoDefaultLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoDefaultConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["SeoDefaultLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locale?: ModelTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutSeoDefaultsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutSeoDefaultsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutSeoDefaultsCreateInput"]
};
	["SeoDefaultConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["SeoDefaultLocaleUniqueWhere"],
	create: ModelTypes["SeoDefaultLocaleWithoutRootCreateInput"]
};
	["SeoDefaultUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["SeoDefaultUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["SeoDefaultLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["SeoDefaultUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["SeoDefaultUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SeoDefaultUpdateLocalesRelationInput"]: {
	by: ModelTypes["SeoDefaultLocaleUniqueWhere"],
	data: ModelTypes["SeoDefaultLocaleWithoutRootUpdateInput"]
};
	["SeoDefaultLocaleWithoutRootUpdateInput"]: {
	locale?: ModelTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutSeoDefaultsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutSeoDefaultsUpdateInput"] | undefined,
	upsert?: ModelTypes["SeoDefaultLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutSeoDefaultsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutSeoDefaultsUpdateInput"],
	create: ModelTypes["LocaleWithoutSeoDefaultsCreateInput"]
};
	["SeoDefaultUpsertLocalesRelationInput"]: {
	by: ModelTypes["SeoDefaultLocaleUniqueWhere"],
	update: ModelTypes["SeoDefaultLocaleWithoutRootUpdateInput"],
	create: ModelTypes["SeoDefaultLocaleWithoutRootCreateInput"]
};
	["SeoDefaultLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["SeoDefaultLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleUpdateInput"]: {
	root?: ModelTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["BusinessPageEdge"]>
};
	["BusinessPageEdge"]: {
		node: ModelTypes["BusinessPage"]
};
	["BusinessPageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: ModelTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	infoBox?: ModelTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleUpdateInput"]: {
	root?: ModelTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: ModelTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: ModelTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	infoBox?: ModelTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IconConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["IconEdge"]>
};
	["IconEdge"]: {
		node: ModelTypes["Icon"]
};
	["JobPageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["JobPageCreateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["JobPageCreateThemeEntityRelationInput"] | undefined,
	contractType?: ModelTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined,
	jobCity?: ModelTypes["JobPageCreateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	jobPosition?: ModelTypes["JobPageCreateJobPositionEntityRelationInput"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: ModelTypes["JobPageCreateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: ModelTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageUpdateInput"]: {
	locales?: Array<ModelTypes["JobPageUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["JobPageUpdateThemeEntityRelationInput"] | undefined,
	contractType?: ModelTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined,
	jobCity?: ModelTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	jobPosition?: ModelTypes["JobPageUpdateJobPositionEntityRelationInput"] | undefined,
	publishedAt?: ModelTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: ModelTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: ModelTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	image?: ModelTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined,
	keyInfo?: ModelTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined,
	content?: ModelTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: ModelTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: ModelTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleUpdateInput"]: {
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	image?: ModelTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined,
	keyInfo?: ModelTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined,
	content?: ModelTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: ModelTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: ModelTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	keyInfo?: string | undefined,
	list?: ModelTypes["KeyInfoItemCreateListEntityRelationInput"] | undefined,
	icon?: ModelTypes["KeyInfoItemCreateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["KeyInfoListUniqueWhere"] | undefined,
	create?: ModelTypes["KeyInfoListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["KeyInfoItemConnectOrCreateListRelationInput"] | undefined
};
	["KeyInfoListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["KeyInfoListUniqueWhere"],
	create: ModelTypes["KeyInfoListWithoutItemsCreateInput"]
};
	["KeyInfoItemUpdateInput"]: {
	order?: number | undefined,
	keyInfo?: string | undefined,
	list?: ModelTypes["KeyInfoItemUpdateListEntityRelationInput"] | undefined,
	icon?: ModelTypes["KeyInfoItemUpdateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["KeyInfoListUniqueWhere"] | undefined,
	create?: ModelTypes["KeyInfoListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["KeyInfoItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["KeyInfoListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["KeyInfoItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["KeyInfoListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemUpsertListRelationInput"]: {
	update: ModelTypes["KeyInfoListWithoutItemsUpdateInput"],
	create: ModelTypes["KeyInfoListWithoutItemsCreateInput"]
};
	["KeyInfoListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["KeyInfoListEdge"]>
};
	["KeyInfoListEdge"]: {
		node: ModelTypes["KeyInfoList"]
};
	["ContractTypeConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ContractTypeEdge"]>
};
	["ContractTypeEdge"]: {
		node: ModelTypes["ContractType"]
};
	["ContractTypeLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: string | undefined,
	root?: ModelTypes["ContractTypeLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ContractTypeLocaleCreateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleUpdateInput"]: {
	type?: string | undefined,
	root?: ModelTypes["ContractTypeLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["ContractTypeLocaleUpdateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobCityEdge"]>
};
	["JobCityEdge"]: {
		node: ModelTypes["JobCity"]
};
	["JobCityLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["JobCityLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobCityLocaleCreateLocaleEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleUpdateInput"]: {
	root?: ModelTypes["JobCityLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobCityLocaleUpdateLocaleEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobPositionEdge"]>
};
	["JobPositionEdge"]: {
		node: ModelTypes["JobPosition"]
};
	["JobPositionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["JobPositionCreateLocalesEntityRelationInput"]> | undefined,
	jobs?: Array<ModelTypes["JobPositionCreateJobsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionUpdateInput"]: {
	locales?: Array<ModelTypes["JobPositionUpdateLocalesEntityRelationInput"]> | undefined,
	jobs?: Array<ModelTypes["JobPositionUpdateJobsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	type?: string | undefined,
	root?: ModelTypes["JobPositionLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobPositionLocaleCreateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleUpdateInput"]: {
	type?: string | undefined,
	root?: ModelTypes["JobPositionLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobPositionLocaleUpdateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["GalleryEdge"]>
};
	["GalleryEdge"]: {
		node: ModelTypes["Gallery"]
};
	["HomePageConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["HomePageEdge"]>
};
	["HomePageEdge"]: {
		node: ModelTypes["HomePage"]
};
	["HomePageCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["HomePageCreateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["HomePageCreateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["HomePageLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: ModelTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["HomePageLocaleUniqueWhere"],
	create: ModelTypes["HomePageLocaleWithoutRootCreateInput"]
};
	["HomePageUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["HomePageUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["HomePageUpdateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["HomePageLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["HomePageUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["HomePageUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["HomePageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HomePageUpdateLocalesRelationInput"]: {
	by: ModelTypes["HomePageLocaleUniqueWhere"],
	data: ModelTypes["HomePageLocaleWithoutRootUpdateInput"]
};
	["HomePageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	locale?: ModelTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageUpsertLocalesRelationInput"]: {
	by: ModelTypes["HomePageLocaleUniqueWhere"],
	update: ModelTypes["HomePageLocaleWithoutRootUpdateInput"],
	create: ModelTypes["HomePageLocaleWithoutRootCreateInput"]
};
	["HomePageLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLocaleUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["MediumEdge"]>
};
	["MediumEdge"]: {
		node: ModelTypes["Medium"]
};
	["MediumItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["MediumItemCreateListEntityRelationInput"] | undefined,
	medium?: ModelTypes["MediumItemCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumItemConnectOrCreateListRelationInput"] | undefined
};
	["MediumListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["MediumListUniqueWhere"],
	create: ModelTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["MediumItemUpdateListEntityRelationInput"] | undefined,
	medium?: ModelTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["MediumListUniqueWhere"] | undefined,
	create?: ModelTypes["MediumListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["MediumItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["MediumListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["MediumItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["MediumItemUpsertListRelationInput"]: {
	update: ModelTypes["MediumListWithoutItemsUpdateInput"],
	create: ModelTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["MediumListEdge"]>
};
	["MediumListEdge"]: {
		node: ModelTypes["MediumList"]
};
	["VideoConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["VideoEdge"]>
};
	["VideoEdge"]: {
		node: ModelTypes["Video"]
};
	["TextItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	list?: ModelTypes["TextItemCreateListEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["TextListUniqueWhere"] | undefined,
	create?: ModelTypes["TextListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TextItemConnectOrCreateListRelationInput"] | undefined
};
	["TextListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["TextListUniqueWhere"],
	create: ModelTypes["TextListWithoutItemsCreateInput"]
};
	["TextItemUpdateInput"]: {
	order?: number | undefined,
	text?: string | undefined,
	list?: ModelTypes["TextItemUpdateListEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["TextListUniqueWhere"] | undefined,
	create?: ModelTypes["TextListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TextItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["TextListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["TextItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["TextItemUpsertListRelationInput"]: {
	update: ModelTypes["TextListWithoutItemsUpdateInput"],
	create: ModelTypes["TextListWithoutItemsCreateInput"]
};
	["TextListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TextListEdge"]>
};
	["TextListEdge"]: {
		node: ModelTypes["TextList"]
};
	["CarouselConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["CarouselEdge"]>
};
	["CarouselEdge"]: {
		node: ModelTypes["Carousel"]
};
	["CarouselItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	list?: ModelTypes["CarouselItemCreateListEntityRelationInput"] | undefined,
	image?: ModelTypes["CarouselItemCreateImageEntityRelationInput"] | undefined,
	name?: string | undefined,
	title?: string | undefined,
	linkUrl?: ModelTypes["CarouselItemCreateLinkUrlEntityRelationInput"] | undefined,
	normalAspectRatio?: boolean | undefined,
	isImage?: boolean | undefined,
	video?: ModelTypes["CarouselItemCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["CarouselUniqueWhere"] | undefined,
	create?: ModelTypes["CarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CarouselItemConnectOrCreateListRelationInput"] | undefined
};
	["CarouselWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	background?: ModelTypes["Background"] | undefined,
	squareImages?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["CarouselUniqueWhere"],
	create: ModelTypes["CarouselWithoutItemsCreateInput"]
};
	["CarouselItemUpdateInput"]: {
	order?: number | undefined,
	text?: string | undefined,
	list?: ModelTypes["CarouselItemUpdateListEntityRelationInput"] | undefined,
	image?: ModelTypes["CarouselItemUpdateImageEntityRelationInput"] | undefined,
	name?: string | undefined,
	title?: string | undefined,
	linkUrl?: ModelTypes["CarouselItemUpdateLinkUrlEntityRelationInput"] | undefined,
	normalAspectRatio?: boolean | undefined,
	isImage?: boolean | undefined,
	video?: ModelTypes["CarouselItemUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["CarouselUniqueWhere"] | undefined,
	create?: ModelTypes["CarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["CarouselItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["CarouselWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["CarouselItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CarouselWithoutItemsUpdateInput"]: {
	background?: ModelTypes["Background"] | undefined,
	squareImages?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemUpsertListRelationInput"]: {
	update: ModelTypes["CarouselWithoutItemsUpdateInput"],
	create: ModelTypes["CarouselWithoutItemsCreateInput"]
};
	["ThemeConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ThemeEdge"]>
};
	["ThemeEdge"]: {
		node: ModelTypes["Theme"]
};
	["BonusBannerConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["BonusBannerEdge"]>
};
	["BonusBannerEdge"]: {
		node: ModelTypes["BonusBanner"]
};
	["BonusBannerCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	locales?: Array<ModelTypes["BonusBannerCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["BonusBannerLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["BonusBannerConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["BonusBannerLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	locale?: ModelTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined,
	tiles?: Array<ModelTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined,
	logo?: ModelTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["BonusBannerLocaleUniqueWhere"],
	create: ModelTypes["BonusBannerLocaleWithoutRootCreateInput"]
};
	["BonusBannerUpdateInput"]: {
	locales?: Array<ModelTypes["BonusBannerUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["BonusBannerLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["BonusBannerUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["BonusBannerUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BonusBannerUpdateLocalesRelationInput"]: {
	by: ModelTypes["BonusBannerLocaleUniqueWhere"],
	data: ModelTypes["BonusBannerLocaleWithoutRootUpdateInput"]
};
	["BonusBannerLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	text?: string | undefined,
	locale?: ModelTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined,
	tiles?: Array<ModelTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined,
	logo?: ModelTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerUpsertLocalesRelationInput"]: {
	by: ModelTypes["BonusBannerLocaleUniqueWhere"],
	update: ModelTypes["BonusBannerLocaleWithoutRootUpdateInput"],
	create: ModelTypes["BonusBannerLocaleWithoutRootCreateInput"]
};
	["TileCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	bonusBanner?: ModelTypes["TileCreateBonusBannerEntityRelationInput"] | undefined,
	image?: ModelTypes["TileCreateImageEntityRelationInput"] | undefined,
	lightBoxTitle?: string | undefined,
	lightBoxText?: string | undefined,
	ligthBoxMedia?: ModelTypes["TileCreateLigthBoxMediaEntityRelationInput"] | undefined,
	lightBoxSectionTitle?: string | undefined,
	title?: string | undefined,
	lightBoxLinkLabel?: string | undefined,
	lightBoxForm?: ModelTypes["TileCreateLightBoxFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileCreateBonusBannerEntityRelationInput"]: {
	connect?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["BonusBannerLocaleWithoutTilesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileConnectOrCreateBonusBannerRelationInput"] | undefined
};
	["BonusBannerLocaleWithoutTilesCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined,
	logo?: ModelTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileConnectOrCreateBonusBannerRelationInput"]: {
	connect: ModelTypes["BonusBannerLocaleUniqueWhere"],
	create: ModelTypes["BonusBannerLocaleWithoutTilesCreateInput"]
};
	["TileUpdateInput"]: {
	order?: number | undefined,
	text?: string | undefined,
	bonusBanner?: ModelTypes["TileUpdateBonusBannerEntityRelationInput"] | undefined,
	image?: ModelTypes["TileUpdateImageEntityRelationInput"] | undefined,
	lightBoxTitle?: string | undefined,
	lightBoxText?: string | undefined,
	ligthBoxMedia?: ModelTypes["TileUpdateLigthBoxMediaEntityRelationInput"] | undefined,
	lightBoxSectionTitle?: string | undefined,
	title?: string | undefined,
	lightBoxLinkLabel?: string | undefined,
	lightBoxForm?: ModelTypes["TileUpdateLightBoxFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileUpdateBonusBannerEntityRelationInput"]: {
	connect?: ModelTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["BonusBannerLocaleWithoutTilesCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TileConnectOrCreateBonusBannerRelationInput"] | undefined,
	update?: ModelTypes["BonusBannerLocaleWithoutTilesUpdateInput"] | undefined,
	upsert?: ModelTypes["TileUpsertBonusBannerRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BonusBannerLocaleWithoutTilesUpdateInput"]: {
	title?: string | undefined,
	text?: string | undefined,
	root?: ModelTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined,
	logo?: ModelTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileUpsertBonusBannerRelationInput"]: {
	update: ModelTypes["BonusBannerLocaleWithoutTilesUpdateInput"],
	create: ModelTypes["BonusBannerLocaleWithoutTilesCreateInput"]
};
	["SideBySideConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["SideBySideEdge"]>
};
	["SideBySideEdge"]: {
		node: ModelTypes["SideBySide"]
};
	["SideBySideItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	text?: string | undefined,
	list?: ModelTypes["SideBySideItemCreateListEntityRelationInput"] | undefined,
	media?: ModelTypes["SideBySideItemCreateMediaEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	type?: ModelTypes["SideBySideItemType"] | undefined,
	link?: ModelTypes["SideBySideItemCreateLinkEntityRelationInput"] | undefined,
	jobsForm?: ModelTypes["SideBySideItemCreateJobsFormEntityRelationInput"] | undefined,
	textNew?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["SideBySideUniqueWhere"] | undefined,
	create?: ModelTypes["SideBySideWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SideBySideItemConnectOrCreateListRelationInput"] | undefined
};
	["SideBySideWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	background?: ModelTypes["Background"] | undefined,
	alignment?: ModelTypes["ContentAlignment"] | undefined,
	mediumSize?: ModelTypes["MediumSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["SideBySideUniqueWhere"],
	create: ModelTypes["SideBySideWithoutItemsCreateInput"]
};
	["SideBySideItemUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	text?: string | undefined,
	list?: ModelTypes["SideBySideItemUpdateListEntityRelationInput"] | undefined,
	media?: ModelTypes["SideBySideItemUpdateMediaEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	type?: ModelTypes["SideBySideItemType"] | undefined,
	link?: ModelTypes["SideBySideItemUpdateLinkEntityRelationInput"] | undefined,
	jobsForm?: ModelTypes["SideBySideItemUpdateJobsFormEntityRelationInput"] | undefined,
	textNew?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["SideBySideUniqueWhere"] | undefined,
	create?: ModelTypes["SideBySideWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["SideBySideItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["SideBySideWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["SideBySideItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SideBySideWithoutItemsUpdateInput"]: {
	background?: ModelTypes["Background"] | undefined,
	alignment?: ModelTypes["ContentAlignment"] | undefined,
	mediumSize?: ModelTypes["MediumSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemUpsertListRelationInput"]: {
	update: ModelTypes["SideBySideWithoutItemsUpdateInput"],
	create: ModelTypes["SideBySideWithoutItemsCreateInput"]
};
	["HomePageLokalConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["HomePageLokalEdge"]>
};
	["HomePageLokalEdge"]: {
		node: ModelTypes["HomePageLokal"]
};
	["HomePageLokalCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["HomePageLokalCreateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["HomePageLokalCreateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["HomePageLokalLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["HomePageLokalConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["HomePageLokalLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: ModelTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["HomePageLokalLocaleUniqueWhere"],
	create: ModelTypes["HomePageLokalLocaleWithoutRootCreateInput"]
};
	["HomePageLokalUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["HomePageLokalUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: ModelTypes["HomePageLokalUpdateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["HomePageLokalLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["HomePageLokalUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["HomePageLokalUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HomePageLokalUpdateLocalesRelationInput"]: {
	by: ModelTypes["HomePageLokalLocaleUniqueWhere"],
	data: ModelTypes["HomePageLokalLocaleWithoutRootUpdateInput"]
};
	["HomePageLokalLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	locale?: ModelTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalUpsertLocalesRelationInput"]: {
	by: ModelTypes["HomePageLokalLocaleUniqueWhere"],
	update: ModelTypes["HomePageLokalLocaleWithoutRootUpdateInput"],
	create: ModelTypes["HomePageLokalLocaleWithoutRootCreateInput"]
};
	["HomePageLokalLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: ModelTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleUpdateInput"]: {
	title?: string | undefined,
	root?: ModelTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined,
	logo?: ModelTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined,
	button?: ModelTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: ModelTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: ModelTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: ModelTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: ModelTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: ModelTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: ModelTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: ModelTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SiteSwitcherConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["SiteSwitcherEdge"]>
};
	["SiteSwitcherEdge"]: {
		node: ModelTypes["SiteSwitcher"]
};
	["GalleryItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["GalleryItemCreateListEntityRelationInput"] | undefined,
	image?: ModelTypes["GalleryItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GalleryItemConnectOrCreateListRelationInput"] | undefined
};
	["GalleryWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["GalleryUniqueWhere"],
	create: ModelTypes["GalleryWithoutItemsCreateInput"]
};
	["GalleryItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["GalleryItemUpdateListEntityRelationInput"] | undefined,
	image?: ModelTypes["GalleryItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["GalleryUniqueWhere"] | undefined,
	create?: ModelTypes["GalleryWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["GalleryItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["GalleryWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["GalleryItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GalleryWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["GalleryItemUpsertListRelationInput"]: {
	update: ModelTypes["GalleryWithoutItemsUpdateInput"],
	create: ModelTypes["GalleryWithoutItemsCreateInput"]
};
	["JobsFormConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobsFormEdge"]>
};
	["JobsFormEdge"]: {
		node: ModelTypes["JobsForm"]
};
	["JobsFormCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["JobsFormCreateLocalesEntityRelationInput"]> | undefined,
	fileIlustration?: ModelTypes["JobsFormCreateFileIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFormLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFormConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobsFormLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	locale?: ModelTypes["JobsFormLocaleCreateLocaleEntityRelationInput"] | undefined,
	imageTextList?: ModelTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: ModelTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: ModelTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["JobsFormLocaleUniqueWhere"],
	create: ModelTypes["JobsFormLocaleWithoutRootCreateInput"]
};
	["JobsFormUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["JobsFormUpdateLocalesEntityRelationInput"]> | undefined,
	fileIlustration?: ModelTypes["JobsFormUpdateFileIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["JobsFormLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["JobsFormUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["JobsFormUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["JobsFormLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobsFormUpdateLocalesRelationInput"]: {
	by: ModelTypes["JobsFormLocaleUniqueWhere"],
	data: ModelTypes["JobsFormLocaleWithoutRootUpdateInput"]
};
	["JobsFormLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	locale?: ModelTypes["JobsFormLocaleUpdateLocaleEntityRelationInput"] | undefined,
	imageTextList?: ModelTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: ModelTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: ModelTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormUpsertLocalesRelationInput"]: {
	by: ModelTypes["JobsFormLocaleUniqueWhere"],
	update: ModelTypes["JobsFormLocaleWithoutRootUpdateInput"],
	create: ModelTypes["JobsFormLocaleWithoutRootCreateInput"]
};
	["ImageTextItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	list?: ModelTypes["ImageTextItemCreateListEntityRelationInput"] | undefined,
	image?: ModelTypes["ImageTextItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["ImageTextListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageTextListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageTextItemConnectOrCreateListRelationInput"] | undefined
};
	["ImageTextListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["ImageTextListUniqueWhere"],
	create: ModelTypes["ImageTextListWithoutItemsCreateInput"]
};
	["ImageTextItemUpdateInput"]: {
	order?: number | undefined,
	title?: string | undefined,
	list?: ModelTypes["ImageTextItemUpdateListEntityRelationInput"] | undefined,
	image?: ModelTypes["ImageTextItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["ImageTextListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageTextListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageTextItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["ImageTextListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["ImageTextItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageTextListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemUpsertListRelationInput"]: {
	update: ModelTypes["ImageTextListWithoutItemsUpdateInput"],
	create: ModelTypes["ImageTextListWithoutItemsCreateInput"]
};
	["ImageTextListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ImageTextListEdge"]>
};
	["ImageTextListEdge"]: {
		node: ModelTypes["ImageTextList"]
};
	["JobsFilterConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobsFilterEdge"]>
};
	["JobsFilterEdge"]: {
		node: ModelTypes["JobsFilter"]
};
	["JobsFilterCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["JobsFilterCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobsFilterLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobsFilterLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	locale?: ModelTypes["JobsFilterLocaleCreateLocaleEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: ModelTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: ModelTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: ModelTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutJobsFiltersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutJobsFiltersCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutJobsFiltersCreateInput"]
};
	["JobsFilterConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["JobsFilterLocaleUniqueWhere"],
	create: ModelTypes["JobsFilterLocaleWithoutRootCreateInput"]
};
	["JobsFilterUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["JobsFilterUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["JobsFilterLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["JobsFilterUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["JobsFilterUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobsFilterUpdateLocalesRelationInput"]: {
	by: ModelTypes["JobsFilterLocaleUniqueWhere"],
	data: ModelTypes["JobsFilterLocaleWithoutRootUpdateInput"]
};
	["JobsFilterLocaleWithoutRootUpdateInput"]: {
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	locale?: ModelTypes["JobsFilterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: ModelTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: ModelTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: ModelTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutJobsFiltersCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobsFilterLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutJobsFiltersUpdateInput"] | undefined,
	upsert?: ModelTypes["JobsFilterLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutJobsFiltersUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<ModelTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutJobsFiltersUpdateInput"],
	create: ModelTypes["LocaleWithoutJobsFiltersCreateInput"]
};
	["JobsFilterUpsertLocalesRelationInput"]: {
	by: ModelTypes["JobsFilterLocaleUniqueWhere"],
	update: ModelTypes["JobsFilterLocaleWithoutRootUpdateInput"],
	create: ModelTypes["JobsFilterLocaleWithoutRootCreateInput"]
};
	["JobsFilterLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	root?: ModelTypes["JobsFilterLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobsFilterLocaleCreateLocaleEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: ModelTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: ModelTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: ModelTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleUpdateInput"]: {
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	root?: ModelTypes["JobsFilterLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["JobsFilterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: ModelTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: ModelTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: ModelTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["File"]: {
		_meta?: ModelTypes["FileMeta"] | undefined,
	id: ModelTypes["UUID"],
	url: string,
	size?: number | undefined,
	type?: string | undefined
};
	["FileMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	url?: ModelTypes["FieldMeta"] | undefined,
	size?: ModelTypes["FieldMeta"] | undefined,
	type?: ModelTypes["FieldMeta"] | undefined
};
	["FileUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["FileWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	url?: ModelTypes["StringCondition"] | undefined,
	size?: ModelTypes["IntCondition"] | undefined,
	type?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["FileWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["FileWhere"] | undefined> | undefined,
	not?: ModelTypes["FileWhere"] | undefined
};
	["FileOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	url?: ModelTypes["OrderDirection"] | undefined,
	size?: ModelTypes["OrderDirection"] | undefined,
	type?: ModelTypes["OrderDirection"] | undefined
};
	["FileConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["FileEdge"]>
};
	["FileEdge"]: {
		node: ModelTypes["File"]
};
	["FileCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	url?: string | undefined,
	size?: number | undefined,
	type?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FileUpdateInput"]: {
	url?: string | undefined,
	size?: number | undefined,
	type?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobFormSubscription"]: {
		_meta?: ModelTypes["JobFormSubscriptionMeta"] | undefined,
	id: ModelTypes["UUID"],
	createdAt: ModelTypes["DateTime"],
	name?: string | undefined,
	phone?: string | undefined,
	email?: string | undefined,
	message?: string | undefined,
	file?: ModelTypes["File"] | undefined,
	job?: ModelTypes["JobPageLocale"] | undefined,
	status?: ModelTypes["JobFormSubscriptionStatus"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	isGdprSyncedToTabidoo?: boolean | undefined,
	recruitisAnswerId?: string | undefined
};
	["JobFormSubscriptionMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	name?: ModelTypes["FieldMeta"] | undefined,
	phone?: ModelTypes["FieldMeta"] | undefined,
	email?: ModelTypes["FieldMeta"] | undefined,
	message?: ModelTypes["FieldMeta"] | undefined,
	file?: ModelTypes["FieldMeta"] | undefined,
	job?: ModelTypes["FieldMeta"] | undefined,
	status?: ModelTypes["FieldMeta"] | undefined,
	isSyncedToTabidoo?: ModelTypes["FieldMeta"] | undefined,
	tabidooId?: ModelTypes["FieldMeta"] | undefined,
	isGdprSyncedToTabidoo?: ModelTypes["FieldMeta"] | undefined,
	recruitisAnswerId?: ModelTypes["FieldMeta"] | undefined
};
	["JobFormSubscriptionStatus"]: {
		_meta?: ModelTypes["JobFormSubscriptionStatusMeta"] | undefined,
	id: ModelTypes["UUID"],
	statusTitle?: string | undefined,
	statusColor?: string | undefined
};
	["JobFormSubscriptionStatusMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	statusTitle?: ModelTypes["FieldMeta"] | undefined,
	statusColor?: ModelTypes["FieldMeta"] | undefined
};
	["JobFormSubscriptionStatusWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	statusTitle?: ModelTypes["StringCondition"] | undefined,
	statusColor?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["JobFormSubscriptionStatusWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobFormSubscriptionStatusWhere"] | undefined> | undefined,
	not?: ModelTypes["JobFormSubscriptionStatusWhere"] | undefined
};
	["JobFormSubscriptionUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	file?: ModelTypes["FileUniqueWhere"] | undefined
};
	["JobFormSubscriptionWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	name?: ModelTypes["StringCondition"] | undefined,
	phone?: ModelTypes["StringCondition"] | undefined,
	email?: ModelTypes["StringCondition"] | undefined,
	message?: ModelTypes["StringCondition"] | undefined,
	file?: ModelTypes["FileWhere"] | undefined,
	job?: ModelTypes["JobPageLocaleWhere"] | undefined,
	status?: ModelTypes["JobFormSubscriptionStatusWhere"] | undefined,
	isSyncedToTabidoo?: ModelTypes["BooleanCondition"] | undefined,
	tabidooId?: ModelTypes["StringCondition"] | undefined,
	isGdprSyncedToTabidoo?: ModelTypes["BooleanCondition"] | undefined,
	recruitisAnswerId?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["JobFormSubscriptionWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["JobFormSubscriptionWhere"] | undefined> | undefined,
	not?: ModelTypes["JobFormSubscriptionWhere"] | undefined
};
	["JobFormSubscriptionOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	name?: ModelTypes["OrderDirection"] | undefined,
	phone?: ModelTypes["OrderDirection"] | undefined,
	email?: ModelTypes["OrderDirection"] | undefined,
	message?: ModelTypes["OrderDirection"] | undefined,
	file?: ModelTypes["FileOrderBy"] | undefined,
	job?: ModelTypes["JobPageLocaleOrderBy"] | undefined,
	status?: ModelTypes["JobFormSubscriptionStatusOrderBy"] | undefined,
	isSyncedToTabidoo?: ModelTypes["OrderDirection"] | undefined,
	tabidooId?: ModelTypes["OrderDirection"] | undefined,
	isGdprSyncedToTabidoo?: ModelTypes["OrderDirection"] | undefined,
	recruitisAnswerId?: ModelTypes["OrderDirection"] | undefined
};
	["JobFormSubscriptionStatusOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	statusTitle?: ModelTypes["OrderDirection"] | undefined,
	statusColor?: ModelTypes["OrderDirection"] | undefined
};
	["JobFormSubscriptionConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobFormSubscriptionEdge"]>
};
	["JobFormSubscriptionEdge"]: {
		node: ModelTypes["JobFormSubscription"]
};
	["JobFormSubscriptionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	name?: string | undefined,
	phone?: string | undefined,
	email?: string | undefined,
	message?: string | undefined,
	file?: ModelTypes["JobFormSubscriptionCreateFileEntityRelationInput"] | undefined,
	job?: ModelTypes["JobFormSubscriptionCreateJobEntityRelationInput"] | undefined,
	status?: ModelTypes["JobFormSubscriptionCreateStatusEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	isGdprSyncedToTabidoo?: boolean | undefined,
	recruitisAnswerId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobFormSubscriptionCreateFileEntityRelationInput"]: {
	connect?: ModelTypes["FileUniqueWhere"] | undefined,
	create?: ModelTypes["FileCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobFormSubscriptionConnectOrCreateFileRelationInput"] | undefined
};
	["JobFormSubscriptionConnectOrCreateFileRelationInput"]: {
	connect: ModelTypes["FileUniqueWhere"],
	create: ModelTypes["FileCreateInput"]
};
	["JobFormSubscriptionCreateJobEntityRelationInput"]: {
	connect?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobPageLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobFormSubscriptionConnectOrCreateJobRelationInput"] | undefined
};
	["JobFormSubscriptionConnectOrCreateJobRelationInput"]: {
	connect: ModelTypes["JobPageLocaleUniqueWhere"],
	create: ModelTypes["JobPageLocaleCreateInput"]
};
	["JobFormSubscriptionCreateStatusEntityRelationInput"]: {
	connect?: ModelTypes["JobFormSubscriptionStatusUniqueWhere"] | undefined,
	create?: ModelTypes["JobFormSubscriptionStatusCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobFormSubscriptionConnectOrCreateStatusRelationInput"] | undefined
};
	["JobFormSubscriptionStatusUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["JobFormSubscriptionStatusCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	statusTitle?: string | undefined,
	statusColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobFormSubscriptionConnectOrCreateStatusRelationInput"]: {
	connect: ModelTypes["JobFormSubscriptionStatusUniqueWhere"],
	create: ModelTypes["JobFormSubscriptionStatusCreateInput"]
};
	["JobFormSubscriptionUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	name?: string | undefined,
	phone?: string | undefined,
	email?: string | undefined,
	message?: string | undefined,
	file?: ModelTypes["JobFormSubscriptionUpdateFileEntityRelationInput"] | undefined,
	job?: ModelTypes["JobFormSubscriptionUpdateJobEntityRelationInput"] | undefined,
	status?: ModelTypes["JobFormSubscriptionUpdateStatusEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	isGdprSyncedToTabidoo?: boolean | undefined,
	recruitisAnswerId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobFormSubscriptionUpdateFileEntityRelationInput"]: {
	connect?: ModelTypes["FileUniqueWhere"] | undefined,
	create?: ModelTypes["FileCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobFormSubscriptionConnectOrCreateFileRelationInput"] | undefined,
	update?: ModelTypes["FileUpdateInput"] | undefined,
	upsert?: ModelTypes["JobFormSubscriptionUpsertFileRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobFormSubscriptionUpsertFileRelationInput"]: {
	update: ModelTypes["FileUpdateInput"],
	create: ModelTypes["FileCreateInput"]
};
	["JobFormSubscriptionUpdateJobEntityRelationInput"]: {
	connect?: ModelTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["JobPageLocaleCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobFormSubscriptionConnectOrCreateJobRelationInput"] | undefined,
	update?: ModelTypes["JobPageLocaleUpdateInput"] | undefined,
	upsert?: ModelTypes["JobFormSubscriptionUpsertJobRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobFormSubscriptionUpsertJobRelationInput"]: {
	update: ModelTypes["JobPageLocaleUpdateInput"],
	create: ModelTypes["JobPageLocaleCreateInput"]
};
	["JobFormSubscriptionUpdateStatusEntityRelationInput"]: {
	connect?: ModelTypes["JobFormSubscriptionStatusUniqueWhere"] | undefined,
	create?: ModelTypes["JobFormSubscriptionStatusCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["JobFormSubscriptionConnectOrCreateStatusRelationInput"] | undefined,
	update?: ModelTypes["JobFormSubscriptionStatusUpdateInput"] | undefined,
	upsert?: ModelTypes["JobFormSubscriptionUpsertStatusRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobFormSubscriptionStatusUpdateInput"]: {
	statusTitle?: string | undefined,
	statusColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobFormSubscriptionUpsertStatusRelationInput"]: {
	update: ModelTypes["JobFormSubscriptionStatusUpdateInput"],
	create: ModelTypes["JobFormSubscriptionStatusCreateInput"]
};
	["ImageList"]: {
		_meta?: ModelTypes["ImageListMeta"] | undefined,
	id: ModelTypes["UUID"],
	items: Array<ModelTypes["ImageListItem"]>,
	itemsByImage?: ModelTypes["ImageListItem"] | undefined,
	paginateItems: ModelTypes["ImageListItemConnection"]
};
	["ImageListMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	items?: ModelTypes["FieldMeta"] | undefined
};
	["ImageListItem"]: {
		_meta?: ModelTypes["ImageListItemMeta"] | undefined,
	id: ModelTypes["UUID"],
	order: number,
	list?: ModelTypes["ImageList"] | undefined,
	image?: ModelTypes["Image"] | undefined
};
	["ImageListItemMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	order?: ModelTypes["FieldMeta"] | undefined,
	list?: ModelTypes["FieldMeta"] | undefined,
	image?: ModelTypes["FieldMeta"] | undefined
};
	["ImageListWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	items?: ModelTypes["ImageListItemWhere"] | undefined,
	and?: Array<ModelTypes["ImageListWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ImageListWhere"] | undefined> | undefined,
	not?: ModelTypes["ImageListWhere"] | undefined
};
	["ImageListItemWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	order?: ModelTypes["IntCondition"] | undefined,
	list?: ModelTypes["ImageListWhere"] | undefined,
	image?: ModelTypes["ImageWhere"] | undefined,
	and?: Array<ModelTypes["ImageListItemWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["ImageListItemWhere"] | undefined> | undefined,
	not?: ModelTypes["ImageListItemWhere"] | undefined
};
	["ImageListItemOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	order?: ModelTypes["OrderDirection"] | undefined,
	list?: ModelTypes["ImageListOrderBy"] | undefined,
	image?: ModelTypes["ImageOrderBy"] | undefined
};
	["ImageListOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined
};
	["ImageListItemsByImageUniqueWhere"]: {
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["ImageListItemConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ImageListItemEdge"]>
};
	["ImageListItemEdge"]: {
		node: ModelTypes["ImageListItem"]
};
	["ImageListUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: ModelTypes["ImageListItemUniqueWhere"] | undefined
};
	["ImageListItemUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined,
	image?: ModelTypes["ImageUniqueWhere"] | undefined
};
	["ImageListConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["ImageListEdge"]>
};
	["ImageListEdge"]: {
		node: ModelTypes["ImageList"]
};
	["ImageListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	items?: Array<ModelTypes["ImageListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListCreateItemsEntityRelationInput"]: {
	connect?: ModelTypes["ImageListItemUniqueWhere"] | undefined,
	create?: ModelTypes["ImageListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ImageListItemWithoutListCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	image?: ModelTypes["ImageListItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemCreateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageListItemConnectOrCreateImageRelationInput"] | undefined
};
	["ImageListItemConnectOrCreateImageRelationInput"]: {
	connect: ModelTypes["ImageUniqueWhere"],
	create: ModelTypes["ImageCreateInput"]
};
	["ImageListConnectOrCreateItemsRelationInput"]: {
	connect: ModelTypes["ImageListItemUniqueWhere"],
	create: ModelTypes["ImageListItemWithoutListCreateInput"]
};
	["ImageListUpdateInput"]: {
	items?: Array<ModelTypes["ImageListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListUpdateItemsEntityRelationInput"]: {
	create?: ModelTypes["ImageListItemWithoutListCreateInput"] | undefined,
	update?: ModelTypes["ImageListUpdateItemsRelationInput"] | undefined,
	upsert?: ModelTypes["ImageListUpsertItemsRelationInput"] | undefined,
	connect?: ModelTypes["ImageListItemUniqueWhere"] | undefined,
	disconnect?: ModelTypes["ImageListItemUniqueWhere"] | undefined,
	delete?: ModelTypes["ImageListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ImageListUpdateItemsRelationInput"]: {
	by: ModelTypes["ImageListItemUniqueWhere"],
	data: ModelTypes["ImageListItemWithoutListUpdateInput"]
};
	["ImageListItemWithoutListUpdateInput"]: {
	order?: number | undefined,
	image?: ModelTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemUpdateImageEntityRelationInput"]: {
	connect?: ModelTypes["ImageUniqueWhere"] | undefined,
	create?: ModelTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageListItemConnectOrCreateImageRelationInput"] | undefined,
	update?: ModelTypes["ImageUpdateInput"] | undefined,
	upsert?: ModelTypes["ImageListItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageListItemUpsertImageRelationInput"]: {
	update: ModelTypes["ImageUpdateInput"],
	create: ModelTypes["ImageCreateInput"]
};
	["ImageListUpsertItemsRelationInput"]: {
	by: ModelTypes["ImageListItemUniqueWhere"],
	update: ModelTypes["ImageListItemWithoutListUpdateInput"],
	create: ModelTypes["ImageListItemWithoutListCreateInput"]
};
	["ImageListItemCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: ModelTypes["ImageListItemCreateListEntityRelationInput"] | undefined,
	image?: ModelTypes["ImageListItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemCreateListEntityRelationInput"]: {
	connect?: ModelTypes["ImageListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageListItemConnectOrCreateListRelationInput"] | undefined
};
	["ImageListWithoutItemsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemConnectOrCreateListRelationInput"]: {
	connect: ModelTypes["ImageListUniqueWhere"],
	create: ModelTypes["ImageListWithoutItemsCreateInput"]
};
	["ImageListItemUpdateInput"]: {
	order?: number | undefined,
	list?: ModelTypes["ImageListItemUpdateListEntityRelationInput"] | undefined,
	image?: ModelTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemUpdateListEntityRelationInput"]: {
	connect?: ModelTypes["ImageListUniqueWhere"] | undefined,
	create?: ModelTypes["ImageListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["ImageListItemConnectOrCreateListRelationInput"] | undefined,
	update?: ModelTypes["ImageListWithoutItemsUpdateInput"] | undefined,
	upsert?: ModelTypes["ImageListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ImageListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined
};
	["ImageListItemUpsertListRelationInput"]: {
	update: ModelTypes["ImageListWithoutItemsUpdateInput"],
	create: ModelTypes["ImageListWithoutItemsCreateInput"]
};
	["JobFormSubscriptionStatusConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["JobFormSubscriptionStatusEdge"]>
};
	["JobFormSubscriptionStatusEdge"]: {
		node: ModelTypes["JobFormSubscriptionStatus"]
};
	["GeneralLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	root?: ModelTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	cornerBanner?: ModelTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateInput"]: {
	root?: ModelTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: ModelTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	cornerBanner?: ModelTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StickyBarConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["StickyBarEdge"]>
};
	["StickyBarEdge"]: {
		node: ModelTypes["StickyBar"]
};
	["RecommendationFormConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["RecommendationFormEdge"]>
};
	["RecommendationFormEdge"]: {
		node: ModelTypes["RecommendationForm"]
};
	["RecommendationFormCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["RecommendationFormCreateLocalesEntityRelationInput"]> | undefined,
	successImage?: ModelTypes["RecommendationFormCreateSuccessImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["RecommendationFormLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["RecommendationFormConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["RecommendationFormLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	locale?: ModelTypes["RecommendationFormLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["RecommendationFormLocaleUniqueWhere"],
	create: ModelTypes["RecommendationFormLocaleWithoutRootCreateInput"]
};
	["RecommendationFormUpdateInput"]: {
	unique?: ModelTypes["One"] | undefined,
	locales?: Array<ModelTypes["RecommendationFormUpdateLocalesEntityRelationInput"]> | undefined,
	successImage?: ModelTypes["RecommendationFormUpdateSuccessImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["RecommendationFormLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["RecommendationFormUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["RecommendationFormUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RecommendationFormUpdateLocalesRelationInput"]: {
	by: ModelTypes["RecommendationFormLocaleUniqueWhere"],
	data: ModelTypes["RecommendationFormLocaleWithoutRootUpdateInput"]
};
	["RecommendationFormLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	locale?: ModelTypes["RecommendationFormLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormUpsertLocalesRelationInput"]: {
	by: ModelTypes["RecommendationFormLocaleUniqueWhere"],
	update: ModelTypes["RecommendationFormLocaleWithoutRootUpdateInput"],
	create: ModelTypes["RecommendationFormLocaleWithoutRootCreateInput"]
};
	["RecommendationFormSubscription"]: {
		_meta?: ModelTypes["RecommendationFormSubscriptionMeta"] | undefined,
	id: ModelTypes["UUID"],
	createdAt: ModelTypes["DateTime"],
	yourEmail?: string | undefined,
	theirEmail?: string | undefined,
	yourName?: string | undefined
};
	["RecommendationFormSubscriptionMeta"]: {
		id?: ModelTypes["FieldMeta"] | undefined,
	createdAt?: ModelTypes["FieldMeta"] | undefined,
	yourEmail?: ModelTypes["FieldMeta"] | undefined,
	theirEmail?: ModelTypes["FieldMeta"] | undefined,
	yourName?: ModelTypes["FieldMeta"] | undefined
};
	["RecommendationFormSubscriptionUniqueWhere"]: {
	id?: ModelTypes["UUID"] | undefined
};
	["RecommendationFormSubscriptionWhere"]: {
	id?: ModelTypes["UUIDCondition"] | undefined,
	createdAt?: ModelTypes["DateTimeCondition"] | undefined,
	yourEmail?: ModelTypes["StringCondition"] | undefined,
	theirEmail?: ModelTypes["StringCondition"] | undefined,
	yourName?: ModelTypes["StringCondition"] | undefined,
	and?: Array<ModelTypes["RecommendationFormSubscriptionWhere"] | undefined> | undefined,
	or?: Array<ModelTypes["RecommendationFormSubscriptionWhere"] | undefined> | undefined,
	not?: ModelTypes["RecommendationFormSubscriptionWhere"] | undefined
};
	["RecommendationFormSubscriptionOrderBy"]: {
	_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: ModelTypes["OrderDirection"] | undefined,
	createdAt?: ModelTypes["OrderDirection"] | undefined,
	yourEmail?: ModelTypes["OrderDirection"] | undefined,
	theirEmail?: ModelTypes["OrderDirection"] | undefined,
	yourName?: ModelTypes["OrderDirection"] | undefined
};
	["RecommendationFormSubscriptionConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["RecommendationFormSubscriptionEdge"]>
};
	["RecommendationFormSubscriptionEdge"]: {
		node: ModelTypes["RecommendationFormSubscription"]
};
	["RecommendationFormSubscriptionCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	createdAt?: ModelTypes["DateTime"] | undefined,
	yourEmail?: string | undefined,
	theirEmail?: string | undefined,
	yourName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormSubscriptionUpdateInput"]: {
	createdAt?: ModelTypes["DateTime"] | undefined,
	yourEmail?: string | undefined,
	theirEmail?: string | undefined,
	yourName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["InfoBoxEdge"]>
};
	["InfoBoxEdge"]: {
		node: ModelTypes["InfoBox"]
};
	["InfoBoxLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	root?: ModelTypes["InfoBoxLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["InfoBoxLocaleCreateLocaleEntityRelationInput"] | undefined,
	openingHours?: ModelTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleUpdateInput"]: {
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	root?: ModelTypes["InfoBoxLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["InfoBoxLocaleUpdateLocaleEntityRelationInput"] | undefined,
	openingHours?: ModelTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["TranslationEdge"]>
};
	["TranslationEdge"]: {
		node: ModelTypes["Translation"]
};
	["TranslationCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	order?: number | undefined,
	key?: string | undefined,
	locales?: Array<ModelTypes["TranslationCreateLocalesEntityRelationInput"]> | undefined,
	isTextarea?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCreateLocalesEntityRelationInput"]: {
	connect?: ModelTypes["TranslationLocaleUniqueWhere"] | undefined,
	create?: ModelTypes["TranslationLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationLocaleWithoutRootCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	value?: string | undefined,
	locale?: ModelTypes["TranslationLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutTranslationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutTranslationsCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleConnectOrCreateLocaleRelationInput"]: {
	connect: ModelTypes["LocaleUniqueWhere"],
	create: ModelTypes["LocaleWithoutTranslationsCreateInput"]
};
	["TranslationConnectOrCreateLocalesRelationInput"]: {
	connect: ModelTypes["TranslationLocaleUniqueWhere"],
	create: ModelTypes["TranslationLocaleWithoutRootCreateInput"]
};
	["TranslationUpdateInput"]: {
	order?: number | undefined,
	key?: string | undefined,
	locales?: Array<ModelTypes["TranslationUpdateLocalesEntityRelationInput"]> | undefined,
	isTextarea?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationUpdateLocalesEntityRelationInput"]: {
	create?: ModelTypes["TranslationLocaleWithoutRootCreateInput"] | undefined,
	update?: ModelTypes["TranslationUpdateLocalesRelationInput"] | undefined,
	upsert?: ModelTypes["TranslationUpsertLocalesRelationInput"] | undefined,
	connect?: ModelTypes["TranslationLocaleUniqueWhere"] | undefined,
	disconnect?: ModelTypes["TranslationLocaleUniqueWhere"] | undefined,
	delete?: ModelTypes["TranslationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationUpdateLocalesRelationInput"]: {
	by: ModelTypes["TranslationLocaleUniqueWhere"],
	data: ModelTypes["TranslationLocaleWithoutRootUpdateInput"]
};
	["TranslationLocaleWithoutRootUpdateInput"]: {
	value?: string | undefined,
	locale?: ModelTypes["TranslationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleUpdateLocaleEntityRelationInput"]: {
	connect?: ModelTypes["LocaleUniqueWhere"] | undefined,
	create?: ModelTypes["LocaleWithoutTranslationsCreateInput"] | undefined,
	connectOrCreate?: ModelTypes["TranslationLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: ModelTypes["LocaleWithoutTranslationsUpdateInput"] | undefined,
	upsert?: ModelTypes["TranslationLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutTranslationsUpdateInput"]: {
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<ModelTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<ModelTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<ModelTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<ModelTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<ModelTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<ModelTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<ModelTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<ModelTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<ModelTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<ModelTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<ModelTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<ModelTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<ModelTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<ModelTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<ModelTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<ModelTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<ModelTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleUpsertLocaleRelationInput"]: {
	update: ModelTypes["LocaleWithoutTranslationsUpdateInput"],
	create: ModelTypes["LocaleWithoutTranslationsCreateInput"]
};
	["TranslationUpsertLocalesRelationInput"]: {
	by: ModelTypes["TranslationLocaleUniqueWhere"],
	update: ModelTypes["TranslationLocaleWithoutRootUpdateInput"],
	create: ModelTypes["TranslationLocaleWithoutRootCreateInput"]
};
	["TranslationLocaleCreateInput"]: {
	id?: ModelTypes["UUID"] | undefined,
	value?: string | undefined,
	root?: ModelTypes["TranslationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["TranslationLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleUpdateInput"]: {
	value?: string | undefined,
	root?: ModelTypes["TranslationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: ModelTypes["TranslationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CornerBannerConnection"]: {
		pageInfo: ModelTypes["PageInfo"],
	edges: Array<ModelTypes["CornerBannerEdge"]>
};
	["CornerBannerEdge"]: {
		node: ModelTypes["CornerBanner"]
};
	["QueryTransaction"]: {
		schema?: ModelTypes["_Schema"] | undefined,
	s3DummyQuery?: string | undefined,
	getGeneral?: ModelTypes["General"] | undefined,
	listGeneral: Array<ModelTypes["General"]>,
	paginateGeneral: ModelTypes["GeneralConnection"],
	validateCreateGeneral: ModelTypes["_ValidationResult"],
	validateUpdateGeneral: ModelTypes["_ValidationResult"],
	getImage?: ModelTypes["Image"] | undefined,
	listImage: Array<ModelTypes["Image"]>,
	paginateImage: ModelTypes["ImageConnection"],
	validateCreateImage: ModelTypes["_ValidationResult"],
	validateUpdateImage: ModelTypes["_ValidationResult"],
	getGenericPage?: ModelTypes["GenericPage"] | undefined,
	listGenericPage: Array<ModelTypes["GenericPage"]>,
	paginateGenericPage: ModelTypes["GenericPageConnection"],
	validateCreateGenericPage: ModelTypes["_ValidationResult"],
	validateUpdateGenericPage: ModelTypes["_ValidationResult"],
	getLinkable?: ModelTypes["Linkable"] | undefined,
	listLinkable: Array<ModelTypes["Linkable"]>,
	paginateLinkable: ModelTypes["LinkableConnection"],
	validateCreateLinkable: ModelTypes["_ValidationResult"],
	validateUpdateLinkable: ModelTypes["_ValidationResult"],
	getSeo?: ModelTypes["Seo"] | undefined,
	listSeo: Array<ModelTypes["Seo"]>,
	paginateSeo: ModelTypes["SeoConnection"],
	validateCreateSeo: ModelTypes["_ValidationResult"],
	validateUpdateSeo: ModelTypes["_ValidationResult"],
	getContent?: ModelTypes["Content"] | undefined,
	listContent: Array<ModelTypes["Content"]>,
	paginateContent: ModelTypes["ContentConnection"],
	validateCreateContent: ModelTypes["_ValidationResult"],
	validateUpdateContent: ModelTypes["_ValidationResult"],
	getContentBlock?: ModelTypes["ContentBlock"] | undefined,
	listContentBlock: Array<ModelTypes["ContentBlock"]>,
	paginateContentBlock: ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock: ModelTypes["_ValidationResult"],
	validateUpdateContentBlock: ModelTypes["_ValidationResult"],
	getContentReference?: ModelTypes["ContentReference"] | undefined,
	listContentReference: Array<ModelTypes["ContentReference"]>,
	paginateContentReference: ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference: ModelTypes["_ValidationResult"],
	validateUpdateContentReference: ModelTypes["_ValidationResult"],
	getContentReferenceLinkableItem?: ModelTypes["ContentReferenceLinkableItem"] | undefined,
	listContentReferenceLinkableItem: Array<ModelTypes["ContentReferenceLinkableItem"]>,
	paginateContentReferenceLinkableItem: ModelTypes["ContentReferenceLinkableItemConnection"],
	getRedirect?: ModelTypes["Redirect"] | undefined,
	listRedirect: Array<ModelTypes["Redirect"]>,
	paginateRedirect: ModelTypes["RedirectConnection"],
	validateCreateRedirect: ModelTypes["_ValidationResult"],
	validateUpdateRedirect: ModelTypes["_ValidationResult"],
	getLink?: ModelTypes["Link"] | undefined,
	listLink: Array<ModelTypes["Link"]>,
	paginateLink: ModelTypes["LinkConnection"],
	validateCreateLink: ModelTypes["_ValidationResult"],
	validateUpdateLink: ModelTypes["_ValidationResult"],
	getFooter?: ModelTypes["Footer"] | undefined,
	listFooter: Array<ModelTypes["Footer"]>,
	paginateFooter: ModelTypes["FooterConnection"],
	validateCreateFooter: ModelTypes["_ValidationResult"],
	validateUpdateFooter: ModelTypes["_ValidationResult"],
	getFooterLink?: ModelTypes["FooterLink"] | undefined,
	listFooterLink: Array<ModelTypes["FooterLink"]>,
	paginateFooterLink: ModelTypes["FooterLinkConnection"],
	validateCreateFooterLink: ModelTypes["_ValidationResult"],
	validateUpdateFooterLink: ModelTypes["_ValidationResult"],
	getFooterLocale?: ModelTypes["FooterLocale"] | undefined,
	listFooterLocale: Array<ModelTypes["FooterLocale"]>,
	paginateFooterLocale: ModelTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: ModelTypes["_ValidationResult"],
	validateUpdateFooterLocale: ModelTypes["_ValidationResult"],
	getGenericPageLocale?: ModelTypes["GenericPageLocale"] | undefined,
	listGenericPageLocale: Array<ModelTypes["GenericPageLocale"]>,
	paginateGenericPageLocale: ModelTypes["GenericPageLocaleConnection"],
	validateCreateGenericPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateGenericPageLocale: ModelTypes["_ValidationResult"],
	getHeader?: ModelTypes["Header"] | undefined,
	listHeader: Array<ModelTypes["Header"]>,
	paginateHeader: ModelTypes["HeaderConnection"],
	validateCreateHeader: ModelTypes["_ValidationResult"],
	validateUpdateHeader: ModelTypes["_ValidationResult"],
	getHeaderLocale?: ModelTypes["HeaderLocale"] | undefined,
	listHeaderLocale: Array<ModelTypes["HeaderLocale"]>,
	paginateHeaderLocale: ModelTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: ModelTypes["_ValidationResult"],
	validateUpdateHeaderLocale: ModelTypes["_ValidationResult"],
	getLocale?: ModelTypes["Locale"] | undefined,
	listLocale: Array<ModelTypes["Locale"]>,
	paginateLocale: ModelTypes["LocaleConnection"],
	validateCreateLocale: ModelTypes["_ValidationResult"],
	validateUpdateLocale: ModelTypes["_ValidationResult"],
	getSeoDefault?: ModelTypes["SeoDefault"] | undefined,
	listSeoDefault: Array<ModelTypes["SeoDefault"]>,
	paginateSeoDefault: ModelTypes["SeoDefaultConnection"],
	validateCreateSeoDefault: ModelTypes["_ValidationResult"],
	validateUpdateSeoDefault: ModelTypes["_ValidationResult"],
	getSeoDefaultLocale?: ModelTypes["SeoDefaultLocale"] | undefined,
	listSeoDefaultLocale: Array<ModelTypes["SeoDefaultLocale"]>,
	paginateSeoDefaultLocale: ModelTypes["SeoDefaultLocaleConnection"],
	validateCreateSeoDefaultLocale: ModelTypes["_ValidationResult"],
	validateUpdateSeoDefaultLocale: ModelTypes["_ValidationResult"],
	getBusiness?: ModelTypes["Business"] | undefined,
	listBusiness: Array<ModelTypes["Business"]>,
	paginateBusiness: ModelTypes["BusinessConnection"],
	validateCreateBusiness: ModelTypes["_ValidationResult"],
	validateUpdateBusiness: ModelTypes["_ValidationResult"],
	getBusinessPage?: ModelTypes["BusinessPage"] | undefined,
	listBusinessPage: Array<ModelTypes["BusinessPage"]>,
	paginateBusinessPage: ModelTypes["BusinessPageConnection"],
	validateCreateBusinessPage: ModelTypes["_ValidationResult"],
	validateUpdateBusinessPage: ModelTypes["_ValidationResult"],
	getBusinessPageLocale?: ModelTypes["BusinessPageLocale"] | undefined,
	listBusinessPageLocale: Array<ModelTypes["BusinessPageLocale"]>,
	paginateBusinessPageLocale: ModelTypes["BusinessPageLocaleConnection"],
	validateCreateBusinessPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateBusinessPageLocale: ModelTypes["_ValidationResult"],
	getIcon?: ModelTypes["Icon"] | undefined,
	listIcon: Array<ModelTypes["Icon"]>,
	paginateIcon: ModelTypes["IconConnection"],
	validateCreateIcon: ModelTypes["_ValidationResult"],
	validateUpdateIcon: ModelTypes["_ValidationResult"],
	getJobPage?: ModelTypes["JobPage"] | undefined,
	listJobPage: Array<ModelTypes["JobPage"]>,
	paginateJobPage: ModelTypes["JobPageConnection"],
	validateCreateJobPage: ModelTypes["_ValidationResult"],
	validateUpdateJobPage: ModelTypes["_ValidationResult"],
	getJobPageLocale?: ModelTypes["JobPageLocale"] | undefined,
	listJobPageLocale: Array<ModelTypes["JobPageLocale"]>,
	paginateJobPageLocale: ModelTypes["JobPageLocaleConnection"],
	validateCreateJobPageLocale: ModelTypes["_ValidationResult"],
	validateUpdateJobPageLocale: ModelTypes["_ValidationResult"],
	getKeyInfoItem?: ModelTypes["KeyInfoItem"] | undefined,
	listKeyInfoItem: Array<ModelTypes["KeyInfoItem"]>,
	paginateKeyInfoItem: ModelTypes["KeyInfoItemConnection"],
	validateCreateKeyInfoItem: ModelTypes["_ValidationResult"],
	validateUpdateKeyInfoItem: ModelTypes["_ValidationResult"],
	getKeyInfoList?: ModelTypes["KeyInfoList"] | undefined,
	listKeyInfoList: Array<ModelTypes["KeyInfoList"]>,
	paginateKeyInfoList: ModelTypes["KeyInfoListConnection"],
	validateCreateKeyInfoList: ModelTypes["_ValidationResult"],
	validateUpdateKeyInfoList: ModelTypes["_ValidationResult"],
	getContractType?: ModelTypes["ContractType"] | undefined,
	listContractType: Array<ModelTypes["ContractType"]>,
	paginateContractType: ModelTypes["ContractTypeConnection"],
	validateCreateContractType: ModelTypes["_ValidationResult"],
	validateUpdateContractType: ModelTypes["_ValidationResult"],
	getContractTypeLocale?: ModelTypes["ContractTypeLocale"] | undefined,
	listContractTypeLocale: Array<ModelTypes["ContractTypeLocale"]>,
	paginateContractTypeLocale: ModelTypes["ContractTypeLocaleConnection"],
	validateCreateContractTypeLocale: ModelTypes["_ValidationResult"],
	validateUpdateContractTypeLocale: ModelTypes["_ValidationResult"],
	getJobCity?: ModelTypes["JobCity"] | undefined,
	listJobCity: Array<ModelTypes["JobCity"]>,
	paginateJobCity: ModelTypes["JobCityConnection"],
	validateCreateJobCity: ModelTypes["_ValidationResult"],
	validateUpdateJobCity: ModelTypes["_ValidationResult"],
	getJobCityLocale?: ModelTypes["JobCityLocale"] | undefined,
	listJobCityLocale: Array<ModelTypes["JobCityLocale"]>,
	paginateJobCityLocale: ModelTypes["JobCityLocaleConnection"],
	validateCreateJobCityLocale: ModelTypes["_ValidationResult"],
	validateUpdateJobCityLocale: ModelTypes["_ValidationResult"],
	getJobPosition?: ModelTypes["JobPosition"] | undefined,
	listJobPosition: Array<ModelTypes["JobPosition"]>,
	paginateJobPosition: ModelTypes["JobPositionConnection"],
	validateCreateJobPosition: ModelTypes["_ValidationResult"],
	validateUpdateJobPosition: ModelTypes["_ValidationResult"],
	getJobPositionLocale?: ModelTypes["JobPositionLocale"] | undefined,
	listJobPositionLocale: Array<ModelTypes["JobPositionLocale"]>,
	paginateJobPositionLocale: ModelTypes["JobPositionLocaleConnection"],
	validateCreateJobPositionLocale: ModelTypes["_ValidationResult"],
	validateUpdateJobPositionLocale: ModelTypes["_ValidationResult"],
	getGallery?: ModelTypes["Gallery"] | undefined,
	listGallery: Array<ModelTypes["Gallery"]>,
	paginateGallery: ModelTypes["GalleryConnection"],
	validateCreateGallery: ModelTypes["_ValidationResult"],
	validateUpdateGallery: ModelTypes["_ValidationResult"],
	getHomePage?: ModelTypes["HomePage"] | undefined,
	listHomePage: Array<ModelTypes["HomePage"]>,
	paginateHomePage: ModelTypes["HomePageConnection"],
	validateCreateHomePage: ModelTypes["_ValidationResult"],
	validateUpdateHomePage: ModelTypes["_ValidationResult"],
	getHomePageLocale?: ModelTypes["HomePageLocale"] | undefined,
	listHomePageLocale: Array<ModelTypes["HomePageLocale"]>,
	paginateHomePageLocale: ModelTypes["HomePageLocaleConnection"],
	validateCreateHomePageLocale: ModelTypes["_ValidationResult"],
	validateUpdateHomePageLocale: ModelTypes["_ValidationResult"],
	getMedium?: ModelTypes["Medium"] | undefined,
	listMedium: Array<ModelTypes["Medium"]>,
	paginateMedium: ModelTypes["MediumConnection"],
	validateCreateMedium: ModelTypes["_ValidationResult"],
	validateUpdateMedium: ModelTypes["_ValidationResult"],
	getMediumItem?: ModelTypes["MediumItem"] | undefined,
	listMediumItem: Array<ModelTypes["MediumItem"]>,
	paginateMediumItem: ModelTypes["MediumItemConnection"],
	validateCreateMediumItem: ModelTypes["_ValidationResult"],
	validateUpdateMediumItem: ModelTypes["_ValidationResult"],
	getMediumList?: ModelTypes["MediumList"] | undefined,
	listMediumList: Array<ModelTypes["MediumList"]>,
	paginateMediumList: ModelTypes["MediumListConnection"],
	validateCreateMediumList: ModelTypes["_ValidationResult"],
	validateUpdateMediumList: ModelTypes["_ValidationResult"],
	getVideo?: ModelTypes["Video"] | undefined,
	listVideo: Array<ModelTypes["Video"]>,
	paginateVideo: ModelTypes["VideoConnection"],
	validateCreateVideo: ModelTypes["_ValidationResult"],
	validateUpdateVideo: ModelTypes["_ValidationResult"],
	getTextItem?: ModelTypes["TextItem"] | undefined,
	listTextItem: Array<ModelTypes["TextItem"]>,
	paginateTextItem: ModelTypes["TextItemConnection"],
	validateCreateTextItem: ModelTypes["_ValidationResult"],
	validateUpdateTextItem: ModelTypes["_ValidationResult"],
	getTextList?: ModelTypes["TextList"] | undefined,
	listTextList: Array<ModelTypes["TextList"]>,
	paginateTextList: ModelTypes["TextListConnection"],
	validateCreateTextList: ModelTypes["_ValidationResult"],
	validateUpdateTextList: ModelTypes["_ValidationResult"],
	getCarousel?: ModelTypes["Carousel"] | undefined,
	listCarousel: Array<ModelTypes["Carousel"]>,
	paginateCarousel: ModelTypes["CarouselConnection"],
	validateCreateCarousel: ModelTypes["_ValidationResult"],
	validateUpdateCarousel: ModelTypes["_ValidationResult"],
	getCarouselItem?: ModelTypes["CarouselItem"] | undefined,
	listCarouselItem: Array<ModelTypes["CarouselItem"]>,
	paginateCarouselItem: ModelTypes["CarouselItemConnection"],
	validateCreateCarouselItem: ModelTypes["_ValidationResult"],
	validateUpdateCarouselItem: ModelTypes["_ValidationResult"],
	getTheme?: ModelTypes["Theme"] | undefined,
	listTheme: Array<ModelTypes["Theme"]>,
	paginateTheme: ModelTypes["ThemeConnection"],
	validateCreateTheme: ModelTypes["_ValidationResult"],
	validateUpdateTheme: ModelTypes["_ValidationResult"],
	getBonusBanner?: ModelTypes["BonusBanner"] | undefined,
	listBonusBanner: Array<ModelTypes["BonusBanner"]>,
	paginateBonusBanner: ModelTypes["BonusBannerConnection"],
	validateCreateBonusBanner: ModelTypes["_ValidationResult"],
	validateUpdateBonusBanner: ModelTypes["_ValidationResult"],
	getBonusBannerLocale?: ModelTypes["BonusBannerLocale"] | undefined,
	listBonusBannerLocale: Array<ModelTypes["BonusBannerLocale"]>,
	paginateBonusBannerLocale: ModelTypes["BonusBannerLocaleConnection"],
	validateCreateBonusBannerLocale: ModelTypes["_ValidationResult"],
	validateUpdateBonusBannerLocale: ModelTypes["_ValidationResult"],
	getTile?: ModelTypes["Tile"] | undefined,
	listTile: Array<ModelTypes["Tile"]>,
	paginateTile: ModelTypes["TileConnection"],
	validateCreateTile: ModelTypes["_ValidationResult"],
	validateUpdateTile: ModelTypes["_ValidationResult"],
	getSideBySide?: ModelTypes["SideBySide"] | undefined,
	listSideBySide: Array<ModelTypes["SideBySide"]>,
	paginateSideBySide: ModelTypes["SideBySideConnection"],
	validateCreateSideBySide: ModelTypes["_ValidationResult"],
	validateUpdateSideBySide: ModelTypes["_ValidationResult"],
	getSideBySideItem?: ModelTypes["SideBySideItem"] | undefined,
	listSideBySideItem: Array<ModelTypes["SideBySideItem"]>,
	paginateSideBySideItem: ModelTypes["SideBySideItemConnection"],
	validateCreateSideBySideItem: ModelTypes["_ValidationResult"],
	validateUpdateSideBySideItem: ModelTypes["_ValidationResult"],
	getHomePageLokal?: ModelTypes["HomePageLokal"] | undefined,
	listHomePageLokal: Array<ModelTypes["HomePageLokal"]>,
	paginateHomePageLokal: ModelTypes["HomePageLokalConnection"],
	validateCreateHomePageLokal: ModelTypes["_ValidationResult"],
	validateUpdateHomePageLokal: ModelTypes["_ValidationResult"],
	getHomePageLokalLocale?: ModelTypes["HomePageLokalLocale"] | undefined,
	listHomePageLokalLocale: Array<ModelTypes["HomePageLokalLocale"]>,
	paginateHomePageLokalLocale: ModelTypes["HomePageLokalLocaleConnection"],
	validateCreateHomePageLokalLocale: ModelTypes["_ValidationResult"],
	validateUpdateHomePageLokalLocale: ModelTypes["_ValidationResult"],
	getSiteSwitcher?: ModelTypes["SiteSwitcher"] | undefined,
	listSiteSwitcher: Array<ModelTypes["SiteSwitcher"]>,
	paginateSiteSwitcher: ModelTypes["SiteSwitcherConnection"],
	validateCreateSiteSwitcher: ModelTypes["_ValidationResult"],
	validateUpdateSiteSwitcher: ModelTypes["_ValidationResult"],
	getGalleryItem?: ModelTypes["GalleryItem"] | undefined,
	listGalleryItem: Array<ModelTypes["GalleryItem"]>,
	paginateGalleryItem: ModelTypes["GalleryItemConnection"],
	validateCreateGalleryItem: ModelTypes["_ValidationResult"],
	validateUpdateGalleryItem: ModelTypes["_ValidationResult"],
	getJobsForm?: ModelTypes["JobsForm"] | undefined,
	listJobsForm: Array<ModelTypes["JobsForm"]>,
	paginateJobsForm: ModelTypes["JobsFormConnection"],
	validateCreateJobsForm: ModelTypes["_ValidationResult"],
	validateUpdateJobsForm: ModelTypes["_ValidationResult"],
	getJobsFormLocale?: ModelTypes["JobsFormLocale"] | undefined,
	listJobsFormLocale: Array<ModelTypes["JobsFormLocale"]>,
	paginateJobsFormLocale: ModelTypes["JobsFormLocaleConnection"],
	validateCreateJobsFormLocale: ModelTypes["_ValidationResult"],
	validateUpdateJobsFormLocale: ModelTypes["_ValidationResult"],
	getImageTextItem?: ModelTypes["ImageTextItem"] | undefined,
	listImageTextItem: Array<ModelTypes["ImageTextItem"]>,
	paginateImageTextItem: ModelTypes["ImageTextItemConnection"],
	validateCreateImageTextItem: ModelTypes["_ValidationResult"],
	validateUpdateImageTextItem: ModelTypes["_ValidationResult"],
	getImageTextList?: ModelTypes["ImageTextList"] | undefined,
	listImageTextList: Array<ModelTypes["ImageTextList"]>,
	paginateImageTextList: ModelTypes["ImageTextListConnection"],
	validateCreateImageTextList: ModelTypes["_ValidationResult"],
	validateUpdateImageTextList: ModelTypes["_ValidationResult"],
	getJobsFilter?: ModelTypes["JobsFilter"] | undefined,
	listJobsFilter: Array<ModelTypes["JobsFilter"]>,
	paginateJobsFilter: ModelTypes["JobsFilterConnection"],
	validateCreateJobsFilter: ModelTypes["_ValidationResult"],
	validateUpdateJobsFilter: ModelTypes["_ValidationResult"],
	getJobsFilterLocale?: ModelTypes["JobsFilterLocale"] | undefined,
	listJobsFilterLocale: Array<ModelTypes["JobsFilterLocale"]>,
	paginateJobsFilterLocale: ModelTypes["JobsFilterLocaleConnection"],
	validateCreateJobsFilterLocale: ModelTypes["_ValidationResult"],
	validateUpdateJobsFilterLocale: ModelTypes["_ValidationResult"],
	getFile?: ModelTypes["File"] | undefined,
	listFile: Array<ModelTypes["File"]>,
	paginateFile: ModelTypes["FileConnection"],
	validateCreateFile: ModelTypes["_ValidationResult"],
	validateUpdateFile: ModelTypes["_ValidationResult"],
	getJobFormSubscription?: ModelTypes["JobFormSubscription"] | undefined,
	listJobFormSubscription: Array<ModelTypes["JobFormSubscription"]>,
	paginateJobFormSubscription: ModelTypes["JobFormSubscriptionConnection"],
	validateCreateJobFormSubscription: ModelTypes["_ValidationResult"],
	validateUpdateJobFormSubscription: ModelTypes["_ValidationResult"],
	getImageList?: ModelTypes["ImageList"] | undefined,
	listImageList: Array<ModelTypes["ImageList"]>,
	paginateImageList: ModelTypes["ImageListConnection"],
	validateCreateImageList: ModelTypes["_ValidationResult"],
	validateUpdateImageList: ModelTypes["_ValidationResult"],
	getImageListItem?: ModelTypes["ImageListItem"] | undefined,
	listImageListItem: Array<ModelTypes["ImageListItem"]>,
	paginateImageListItem: ModelTypes["ImageListItemConnection"],
	validateCreateImageListItem: ModelTypes["_ValidationResult"],
	validateUpdateImageListItem: ModelTypes["_ValidationResult"],
	getJobFormSubscriptionStatus?: ModelTypes["JobFormSubscriptionStatus"] | undefined,
	listJobFormSubscriptionStatus: Array<ModelTypes["JobFormSubscriptionStatus"]>,
	paginateJobFormSubscriptionStatus: ModelTypes["JobFormSubscriptionStatusConnection"],
	validateCreateJobFormSubscriptionStatus: ModelTypes["_ValidationResult"],
	validateUpdateJobFormSubscriptionStatus: ModelTypes["_ValidationResult"],
	getGeneralLocale?: ModelTypes["GeneralLocale"] | undefined,
	listGeneralLocale: Array<ModelTypes["GeneralLocale"]>,
	paginateGeneralLocale: ModelTypes["GeneralLocaleConnection"],
	validateCreateGeneralLocale: ModelTypes["_ValidationResult"],
	validateUpdateGeneralLocale: ModelTypes["_ValidationResult"],
	getStickyBar?: ModelTypes["StickyBar"] | undefined,
	listStickyBar: Array<ModelTypes["StickyBar"]>,
	paginateStickyBar: ModelTypes["StickyBarConnection"],
	validateCreateStickyBar: ModelTypes["_ValidationResult"],
	validateUpdateStickyBar: ModelTypes["_ValidationResult"],
	getRecommendationForm?: ModelTypes["RecommendationForm"] | undefined,
	listRecommendationForm: Array<ModelTypes["RecommendationForm"]>,
	paginateRecommendationForm: ModelTypes["RecommendationFormConnection"],
	validateCreateRecommendationForm: ModelTypes["_ValidationResult"],
	validateUpdateRecommendationForm: ModelTypes["_ValidationResult"],
	getRecommendationFormLocale?: ModelTypes["RecommendationFormLocale"] | undefined,
	listRecommendationFormLocale: Array<ModelTypes["RecommendationFormLocale"]>,
	paginateRecommendationFormLocale: ModelTypes["RecommendationFormLocaleConnection"],
	validateCreateRecommendationFormLocale: ModelTypes["_ValidationResult"],
	validateUpdateRecommendationFormLocale: ModelTypes["_ValidationResult"],
	getRecommendationFormSubscription?: ModelTypes["RecommendationFormSubscription"] | undefined,
	listRecommendationFormSubscription: Array<ModelTypes["RecommendationFormSubscription"]>,
	paginateRecommendationFormSubscription: ModelTypes["RecommendationFormSubscriptionConnection"],
	validateCreateRecommendationFormSubscription: ModelTypes["_ValidationResult"],
	validateUpdateRecommendationFormSubscription: ModelTypes["_ValidationResult"],
	getInfoBox?: ModelTypes["InfoBox"] | undefined,
	listInfoBox: Array<ModelTypes["InfoBox"]>,
	paginateInfoBox: ModelTypes["InfoBoxConnection"],
	validateCreateInfoBox: ModelTypes["_ValidationResult"],
	validateUpdateInfoBox: ModelTypes["_ValidationResult"],
	getInfoBoxLocale?: ModelTypes["InfoBoxLocale"] | undefined,
	listInfoBoxLocale: Array<ModelTypes["InfoBoxLocale"]>,
	paginateInfoBoxLocale: ModelTypes["InfoBoxLocaleConnection"],
	validateCreateInfoBoxLocale: ModelTypes["_ValidationResult"],
	validateUpdateInfoBoxLocale: ModelTypes["_ValidationResult"],
	getTranslation?: ModelTypes["Translation"] | undefined,
	listTranslation: Array<ModelTypes["Translation"]>,
	paginateTranslation: ModelTypes["TranslationConnection"],
	validateCreateTranslation: ModelTypes["_ValidationResult"],
	validateUpdateTranslation: ModelTypes["_ValidationResult"],
	getTranslationLocale?: ModelTypes["TranslationLocale"] | undefined,
	listTranslationLocale: Array<ModelTypes["TranslationLocale"]>,
	paginateTranslationLocale: ModelTypes["TranslationLocaleConnection"],
	validateCreateTranslationLocale: ModelTypes["_ValidationResult"],
	validateUpdateTranslationLocale: ModelTypes["_ValidationResult"],
	getCornerBanner?: ModelTypes["CornerBanner"] | undefined,
	listCornerBanner: Array<ModelTypes["CornerBanner"]>,
	paginateCornerBanner: ModelTypes["CornerBannerConnection"],
	validateCreateCornerBanner: ModelTypes["_ValidationResult"],
	validateUpdateCornerBanner: ModelTypes["_ValidationResult"]
};
	["Info"]: {
		description?: string | undefined
};
	["Mutation"]: {
		generateUploadUrl: ModelTypes["S3SignedUpload"],
	generateReadUrl: ModelTypes["S3SignedRead"],
	createGeneral: ModelTypes["GeneralCreateResult"],
	deleteGeneral: ModelTypes["GeneralDeleteResult"],
	updateGeneral: ModelTypes["GeneralUpdateResult"],
	upsertGeneral: ModelTypes["GeneralUpsertResult"],
	createImage: ModelTypes["ImageCreateResult"],
	deleteImage: ModelTypes["ImageDeleteResult"],
	updateImage: ModelTypes["ImageUpdateResult"],
	upsertImage: ModelTypes["ImageUpsertResult"],
	createGenericPage: ModelTypes["GenericPageCreateResult"],
	deleteGenericPage: ModelTypes["GenericPageDeleteResult"],
	updateGenericPage: ModelTypes["GenericPageUpdateResult"],
	upsertGenericPage: ModelTypes["GenericPageUpsertResult"],
	createLinkable: ModelTypes["LinkableCreateResult"],
	deleteLinkable: ModelTypes["LinkableDeleteResult"],
	updateLinkable: ModelTypes["LinkableUpdateResult"],
	upsertLinkable: ModelTypes["LinkableUpsertResult"],
	createSeo: ModelTypes["SeoCreateResult"],
	deleteSeo: ModelTypes["SeoDeleteResult"],
	updateSeo: ModelTypes["SeoUpdateResult"],
	upsertSeo: ModelTypes["SeoUpsertResult"],
	createContent: ModelTypes["ContentCreateResult"],
	deleteContent: ModelTypes["ContentDeleteResult"],
	updateContent: ModelTypes["ContentUpdateResult"],
	upsertContent: ModelTypes["ContentUpsertResult"],
	createContentBlock: ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock: ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock: ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock: ModelTypes["ContentBlockUpsertResult"],
	createContentReference: ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference: ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference: ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference: ModelTypes["ContentReferenceUpsertResult"],
	createRedirect: ModelTypes["RedirectCreateResult"],
	deleteRedirect: ModelTypes["RedirectDeleteResult"],
	updateRedirect: ModelTypes["RedirectUpdateResult"],
	upsertRedirect: ModelTypes["RedirectUpsertResult"],
	createLink: ModelTypes["LinkCreateResult"],
	deleteLink: ModelTypes["LinkDeleteResult"],
	updateLink: ModelTypes["LinkUpdateResult"],
	upsertLink: ModelTypes["LinkUpsertResult"],
	createFooter: ModelTypes["FooterCreateResult"],
	deleteFooter: ModelTypes["FooterDeleteResult"],
	updateFooter: ModelTypes["FooterUpdateResult"],
	upsertFooter: ModelTypes["FooterUpsertResult"],
	createFooterLink: ModelTypes["FooterLinkCreateResult"],
	deleteFooterLink: ModelTypes["FooterLinkDeleteResult"],
	updateFooterLink: ModelTypes["FooterLinkUpdateResult"],
	upsertFooterLink: ModelTypes["FooterLinkUpsertResult"],
	createFooterLocale: ModelTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: ModelTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: ModelTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: ModelTypes["FooterLocaleUpsertResult"],
	createGenericPageLocale: ModelTypes["GenericPageLocaleCreateResult"],
	deleteGenericPageLocale: ModelTypes["GenericPageLocaleDeleteResult"],
	updateGenericPageLocale: ModelTypes["GenericPageLocaleUpdateResult"],
	upsertGenericPageLocale: ModelTypes["GenericPageLocaleUpsertResult"],
	createHeader: ModelTypes["HeaderCreateResult"],
	deleteHeader: ModelTypes["HeaderDeleteResult"],
	updateHeader: ModelTypes["HeaderUpdateResult"],
	upsertHeader: ModelTypes["HeaderUpsertResult"],
	createHeaderLocale: ModelTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: ModelTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: ModelTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: ModelTypes["HeaderLocaleUpsertResult"],
	createLocale: ModelTypes["LocaleCreateResult"],
	deleteLocale: ModelTypes["LocaleDeleteResult"],
	updateLocale: ModelTypes["LocaleUpdateResult"],
	upsertLocale: ModelTypes["LocaleUpsertResult"],
	createSeoDefault: ModelTypes["SeoDefaultCreateResult"],
	deleteSeoDefault: ModelTypes["SeoDefaultDeleteResult"],
	updateSeoDefault: ModelTypes["SeoDefaultUpdateResult"],
	upsertSeoDefault: ModelTypes["SeoDefaultUpsertResult"],
	createSeoDefaultLocale: ModelTypes["SeoDefaultLocaleCreateResult"],
	deleteSeoDefaultLocale: ModelTypes["SeoDefaultLocaleDeleteResult"],
	updateSeoDefaultLocale: ModelTypes["SeoDefaultLocaleUpdateResult"],
	upsertSeoDefaultLocale: ModelTypes["SeoDefaultLocaleUpsertResult"],
	createBusiness: ModelTypes["BusinessCreateResult"],
	deleteBusiness: ModelTypes["BusinessDeleteResult"],
	updateBusiness: ModelTypes["BusinessUpdateResult"],
	upsertBusiness: ModelTypes["BusinessUpsertResult"],
	createBusinessPage: ModelTypes["BusinessPageCreateResult"],
	deleteBusinessPage: ModelTypes["BusinessPageDeleteResult"],
	updateBusinessPage: ModelTypes["BusinessPageUpdateResult"],
	upsertBusinessPage: ModelTypes["BusinessPageUpsertResult"],
	createBusinessPageLocale: ModelTypes["BusinessPageLocaleCreateResult"],
	deleteBusinessPageLocale: ModelTypes["BusinessPageLocaleDeleteResult"],
	updateBusinessPageLocale: ModelTypes["BusinessPageLocaleUpdateResult"],
	upsertBusinessPageLocale: ModelTypes["BusinessPageLocaleUpsertResult"],
	createIcon: ModelTypes["IconCreateResult"],
	deleteIcon: ModelTypes["IconDeleteResult"],
	updateIcon: ModelTypes["IconUpdateResult"],
	upsertIcon: ModelTypes["IconUpsertResult"],
	createJobPage: ModelTypes["JobPageCreateResult"],
	deleteJobPage: ModelTypes["JobPageDeleteResult"],
	updateJobPage: ModelTypes["JobPageUpdateResult"],
	upsertJobPage: ModelTypes["JobPageUpsertResult"],
	createJobPageLocale: ModelTypes["JobPageLocaleCreateResult"],
	deleteJobPageLocale: ModelTypes["JobPageLocaleDeleteResult"],
	updateJobPageLocale: ModelTypes["JobPageLocaleUpdateResult"],
	upsertJobPageLocale: ModelTypes["JobPageLocaleUpsertResult"],
	createKeyInfoItem: ModelTypes["KeyInfoItemCreateResult"],
	deleteKeyInfoItem: ModelTypes["KeyInfoItemDeleteResult"],
	updateKeyInfoItem: ModelTypes["KeyInfoItemUpdateResult"],
	upsertKeyInfoItem: ModelTypes["KeyInfoItemUpsertResult"],
	createKeyInfoList: ModelTypes["KeyInfoListCreateResult"],
	deleteKeyInfoList: ModelTypes["KeyInfoListDeleteResult"],
	updateKeyInfoList: ModelTypes["KeyInfoListUpdateResult"],
	upsertKeyInfoList: ModelTypes["KeyInfoListUpsertResult"],
	createContractType: ModelTypes["ContractTypeCreateResult"],
	deleteContractType: ModelTypes["ContractTypeDeleteResult"],
	updateContractType: ModelTypes["ContractTypeUpdateResult"],
	upsertContractType: ModelTypes["ContractTypeUpsertResult"],
	createContractTypeLocale: ModelTypes["ContractTypeLocaleCreateResult"],
	deleteContractTypeLocale: ModelTypes["ContractTypeLocaleDeleteResult"],
	updateContractTypeLocale: ModelTypes["ContractTypeLocaleUpdateResult"],
	upsertContractTypeLocale: ModelTypes["ContractTypeLocaleUpsertResult"],
	createJobCity: ModelTypes["JobCityCreateResult"],
	deleteJobCity: ModelTypes["JobCityDeleteResult"],
	updateJobCity: ModelTypes["JobCityUpdateResult"],
	upsertJobCity: ModelTypes["JobCityUpsertResult"],
	createJobCityLocale: ModelTypes["JobCityLocaleCreateResult"],
	deleteJobCityLocale: ModelTypes["JobCityLocaleDeleteResult"],
	updateJobCityLocale: ModelTypes["JobCityLocaleUpdateResult"],
	upsertJobCityLocale: ModelTypes["JobCityLocaleUpsertResult"],
	createJobPosition: ModelTypes["JobPositionCreateResult"],
	deleteJobPosition: ModelTypes["JobPositionDeleteResult"],
	updateJobPosition: ModelTypes["JobPositionUpdateResult"],
	upsertJobPosition: ModelTypes["JobPositionUpsertResult"],
	createJobPositionLocale: ModelTypes["JobPositionLocaleCreateResult"],
	deleteJobPositionLocale: ModelTypes["JobPositionLocaleDeleteResult"],
	updateJobPositionLocale: ModelTypes["JobPositionLocaleUpdateResult"],
	upsertJobPositionLocale: ModelTypes["JobPositionLocaleUpsertResult"],
	createGallery: ModelTypes["GalleryCreateResult"],
	deleteGallery: ModelTypes["GalleryDeleteResult"],
	updateGallery: ModelTypes["GalleryUpdateResult"],
	upsertGallery: ModelTypes["GalleryUpsertResult"],
	createHomePage: ModelTypes["HomePageCreateResult"],
	deleteHomePage: ModelTypes["HomePageDeleteResult"],
	updateHomePage: ModelTypes["HomePageUpdateResult"],
	upsertHomePage: ModelTypes["HomePageUpsertResult"],
	createHomePageLocale: ModelTypes["HomePageLocaleCreateResult"],
	deleteHomePageLocale: ModelTypes["HomePageLocaleDeleteResult"],
	updateHomePageLocale: ModelTypes["HomePageLocaleUpdateResult"],
	upsertHomePageLocale: ModelTypes["HomePageLocaleUpsertResult"],
	createMedium: ModelTypes["MediumCreateResult"],
	deleteMedium: ModelTypes["MediumDeleteResult"],
	updateMedium: ModelTypes["MediumUpdateResult"],
	upsertMedium: ModelTypes["MediumUpsertResult"],
	createMediumItem: ModelTypes["MediumItemCreateResult"],
	deleteMediumItem: ModelTypes["MediumItemDeleteResult"],
	updateMediumItem: ModelTypes["MediumItemUpdateResult"],
	upsertMediumItem: ModelTypes["MediumItemUpsertResult"],
	createMediumList: ModelTypes["MediumListCreateResult"],
	deleteMediumList: ModelTypes["MediumListDeleteResult"],
	updateMediumList: ModelTypes["MediumListUpdateResult"],
	upsertMediumList: ModelTypes["MediumListUpsertResult"],
	createVideo: ModelTypes["VideoCreateResult"],
	deleteVideo: ModelTypes["VideoDeleteResult"],
	updateVideo: ModelTypes["VideoUpdateResult"],
	upsertVideo: ModelTypes["VideoUpsertResult"],
	createTextItem: ModelTypes["TextItemCreateResult"],
	deleteTextItem: ModelTypes["TextItemDeleteResult"],
	updateTextItem: ModelTypes["TextItemUpdateResult"],
	upsertTextItem: ModelTypes["TextItemUpsertResult"],
	createTextList: ModelTypes["TextListCreateResult"],
	deleteTextList: ModelTypes["TextListDeleteResult"],
	updateTextList: ModelTypes["TextListUpdateResult"],
	upsertTextList: ModelTypes["TextListUpsertResult"],
	createCarousel: ModelTypes["CarouselCreateResult"],
	deleteCarousel: ModelTypes["CarouselDeleteResult"],
	updateCarousel: ModelTypes["CarouselUpdateResult"],
	upsertCarousel: ModelTypes["CarouselUpsertResult"],
	createCarouselItem: ModelTypes["CarouselItemCreateResult"],
	deleteCarouselItem: ModelTypes["CarouselItemDeleteResult"],
	updateCarouselItem: ModelTypes["CarouselItemUpdateResult"],
	upsertCarouselItem: ModelTypes["CarouselItemUpsertResult"],
	createTheme: ModelTypes["ThemeCreateResult"],
	deleteTheme: ModelTypes["ThemeDeleteResult"],
	updateTheme: ModelTypes["ThemeUpdateResult"],
	upsertTheme: ModelTypes["ThemeUpsertResult"],
	createBonusBanner: ModelTypes["BonusBannerCreateResult"],
	deleteBonusBanner: ModelTypes["BonusBannerDeleteResult"],
	updateBonusBanner: ModelTypes["BonusBannerUpdateResult"],
	upsertBonusBanner: ModelTypes["BonusBannerUpsertResult"],
	createBonusBannerLocale: ModelTypes["BonusBannerLocaleCreateResult"],
	deleteBonusBannerLocale: ModelTypes["BonusBannerLocaleDeleteResult"],
	updateBonusBannerLocale: ModelTypes["BonusBannerLocaleUpdateResult"],
	upsertBonusBannerLocale: ModelTypes["BonusBannerLocaleUpsertResult"],
	createTile: ModelTypes["TileCreateResult"],
	deleteTile: ModelTypes["TileDeleteResult"],
	updateTile: ModelTypes["TileUpdateResult"],
	upsertTile: ModelTypes["TileUpsertResult"],
	createSideBySide: ModelTypes["SideBySideCreateResult"],
	deleteSideBySide: ModelTypes["SideBySideDeleteResult"],
	updateSideBySide: ModelTypes["SideBySideUpdateResult"],
	upsertSideBySide: ModelTypes["SideBySideUpsertResult"],
	createSideBySideItem: ModelTypes["SideBySideItemCreateResult"],
	deleteSideBySideItem: ModelTypes["SideBySideItemDeleteResult"],
	updateSideBySideItem: ModelTypes["SideBySideItemUpdateResult"],
	upsertSideBySideItem: ModelTypes["SideBySideItemUpsertResult"],
	createHomePageLokal: ModelTypes["HomePageLokalCreateResult"],
	deleteHomePageLokal: ModelTypes["HomePageLokalDeleteResult"],
	updateHomePageLokal: ModelTypes["HomePageLokalUpdateResult"],
	upsertHomePageLokal: ModelTypes["HomePageLokalUpsertResult"],
	createHomePageLokalLocale: ModelTypes["HomePageLokalLocaleCreateResult"],
	deleteHomePageLokalLocale: ModelTypes["HomePageLokalLocaleDeleteResult"],
	updateHomePageLokalLocale: ModelTypes["HomePageLokalLocaleUpdateResult"],
	upsertHomePageLokalLocale: ModelTypes["HomePageLokalLocaleUpsertResult"],
	createSiteSwitcher: ModelTypes["SiteSwitcherCreateResult"],
	deleteSiteSwitcher: ModelTypes["SiteSwitcherDeleteResult"],
	updateSiteSwitcher: ModelTypes["SiteSwitcherUpdateResult"],
	upsertSiteSwitcher: ModelTypes["SiteSwitcherUpsertResult"],
	createGalleryItem: ModelTypes["GalleryItemCreateResult"],
	deleteGalleryItem: ModelTypes["GalleryItemDeleteResult"],
	updateGalleryItem: ModelTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: ModelTypes["GalleryItemUpsertResult"],
	createJobsForm: ModelTypes["JobsFormCreateResult"],
	deleteJobsForm: ModelTypes["JobsFormDeleteResult"],
	updateJobsForm: ModelTypes["JobsFormUpdateResult"],
	upsertJobsForm: ModelTypes["JobsFormUpsertResult"],
	createJobsFormLocale: ModelTypes["JobsFormLocaleCreateResult"],
	deleteJobsFormLocale: ModelTypes["JobsFormLocaleDeleteResult"],
	updateJobsFormLocale: ModelTypes["JobsFormLocaleUpdateResult"],
	upsertJobsFormLocale: ModelTypes["JobsFormLocaleUpsertResult"],
	createImageTextItem: ModelTypes["ImageTextItemCreateResult"],
	deleteImageTextItem: ModelTypes["ImageTextItemDeleteResult"],
	updateImageTextItem: ModelTypes["ImageTextItemUpdateResult"],
	upsertImageTextItem: ModelTypes["ImageTextItemUpsertResult"],
	createImageTextList: ModelTypes["ImageTextListCreateResult"],
	deleteImageTextList: ModelTypes["ImageTextListDeleteResult"],
	updateImageTextList: ModelTypes["ImageTextListUpdateResult"],
	upsertImageTextList: ModelTypes["ImageTextListUpsertResult"],
	createJobsFilter: ModelTypes["JobsFilterCreateResult"],
	deleteJobsFilter: ModelTypes["JobsFilterDeleteResult"],
	updateJobsFilter: ModelTypes["JobsFilterUpdateResult"],
	upsertJobsFilter: ModelTypes["JobsFilterUpsertResult"],
	createJobsFilterLocale: ModelTypes["JobsFilterLocaleCreateResult"],
	deleteJobsFilterLocale: ModelTypes["JobsFilterLocaleDeleteResult"],
	updateJobsFilterLocale: ModelTypes["JobsFilterLocaleUpdateResult"],
	upsertJobsFilterLocale: ModelTypes["JobsFilterLocaleUpsertResult"],
	createFile: ModelTypes["FileCreateResult"],
	deleteFile: ModelTypes["FileDeleteResult"],
	updateFile: ModelTypes["FileUpdateResult"],
	upsertFile: ModelTypes["FileUpsertResult"],
	createJobFormSubscription: ModelTypes["JobFormSubscriptionCreateResult"],
	deleteJobFormSubscription: ModelTypes["JobFormSubscriptionDeleteResult"],
	updateJobFormSubscription: ModelTypes["JobFormSubscriptionUpdateResult"],
	upsertJobFormSubscription: ModelTypes["JobFormSubscriptionUpsertResult"],
	createImageList: ModelTypes["ImageListCreateResult"],
	deleteImageList: ModelTypes["ImageListDeleteResult"],
	updateImageList: ModelTypes["ImageListUpdateResult"],
	upsertImageList: ModelTypes["ImageListUpsertResult"],
	createImageListItem: ModelTypes["ImageListItemCreateResult"],
	deleteImageListItem: ModelTypes["ImageListItemDeleteResult"],
	updateImageListItem: ModelTypes["ImageListItemUpdateResult"],
	upsertImageListItem: ModelTypes["ImageListItemUpsertResult"],
	createJobFormSubscriptionStatus: ModelTypes["JobFormSubscriptionStatusCreateResult"],
	deleteJobFormSubscriptionStatus: ModelTypes["JobFormSubscriptionStatusDeleteResult"],
	updateJobFormSubscriptionStatus: ModelTypes["JobFormSubscriptionStatusUpdateResult"],
	upsertJobFormSubscriptionStatus: ModelTypes["JobFormSubscriptionStatusUpsertResult"],
	createGeneralLocale: ModelTypes["GeneralLocaleCreateResult"],
	deleteGeneralLocale: ModelTypes["GeneralLocaleDeleteResult"],
	updateGeneralLocale: ModelTypes["GeneralLocaleUpdateResult"],
	upsertGeneralLocale: ModelTypes["GeneralLocaleUpsertResult"],
	createStickyBar: ModelTypes["StickyBarCreateResult"],
	deleteStickyBar: ModelTypes["StickyBarDeleteResult"],
	updateStickyBar: ModelTypes["StickyBarUpdateResult"],
	upsertStickyBar: ModelTypes["StickyBarUpsertResult"],
	createRecommendationForm: ModelTypes["RecommendationFormCreateResult"],
	deleteRecommendationForm: ModelTypes["RecommendationFormDeleteResult"],
	updateRecommendationForm: ModelTypes["RecommendationFormUpdateResult"],
	upsertRecommendationForm: ModelTypes["RecommendationFormUpsertResult"],
	createRecommendationFormLocale: ModelTypes["RecommendationFormLocaleCreateResult"],
	deleteRecommendationFormLocale: ModelTypes["RecommendationFormLocaleDeleteResult"],
	updateRecommendationFormLocale: ModelTypes["RecommendationFormLocaleUpdateResult"],
	upsertRecommendationFormLocale: ModelTypes["RecommendationFormLocaleUpsertResult"],
	createRecommendationFormSubscription: ModelTypes["RecommendationFormSubscriptionCreateResult"],
	deleteRecommendationFormSubscription: ModelTypes["RecommendationFormSubscriptionDeleteResult"],
	updateRecommendationFormSubscription: ModelTypes["RecommendationFormSubscriptionUpdateResult"],
	upsertRecommendationFormSubscription: ModelTypes["RecommendationFormSubscriptionUpsertResult"],
	createInfoBox: ModelTypes["InfoBoxCreateResult"],
	deleteInfoBox: ModelTypes["InfoBoxDeleteResult"],
	updateInfoBox: ModelTypes["InfoBoxUpdateResult"],
	upsertInfoBox: ModelTypes["InfoBoxUpsertResult"],
	createInfoBoxLocale: ModelTypes["InfoBoxLocaleCreateResult"],
	deleteInfoBoxLocale: ModelTypes["InfoBoxLocaleDeleteResult"],
	updateInfoBoxLocale: ModelTypes["InfoBoxLocaleUpdateResult"],
	upsertInfoBoxLocale: ModelTypes["InfoBoxLocaleUpsertResult"],
	createTranslation: ModelTypes["TranslationCreateResult"],
	deleteTranslation: ModelTypes["TranslationDeleteResult"],
	updateTranslation: ModelTypes["TranslationUpdateResult"],
	upsertTranslation: ModelTypes["TranslationUpsertResult"],
	createTranslationLocale: ModelTypes["TranslationLocaleCreateResult"],
	deleteTranslationLocale: ModelTypes["TranslationLocaleDeleteResult"],
	updateTranslationLocale: ModelTypes["TranslationLocaleUpdateResult"],
	upsertTranslationLocale: ModelTypes["TranslationLocaleUpsertResult"],
	createCornerBanner: ModelTypes["CornerBannerCreateResult"],
	deleteCornerBanner: ModelTypes["CornerBannerDeleteResult"],
	updateCornerBanner: ModelTypes["CornerBannerUpdateResult"],
	upsertCornerBanner: ModelTypes["CornerBannerUpsertResult"],
	transaction: ModelTypes["MutationTransaction"],
	query: ModelTypes["Query"]
};
	["S3SignedUpload"]: {
		url: string,
	headers: Array<ModelTypes["S3Header"]>,
	method: string,
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
		key: string,
	value: string
};
	["S3GenerateSignedUploadInput"]: {
	contentType?: string | undefined,
	/** If not provided, extension is detected from a content-type. */
	extension?: string | undefined,
	/** Signed URL expiration. */
	expiration?: number | undefined,
	/** Uploaded file size. Required when you enable ACL size limits. */
	size?: number | undefined,
	/** Can be used as a "directory". */
	prefix?: string | undefined,
	/** Suffix after generated id and before the extension. */
	suffix?: string | undefined,
	/** This only affects Content-disposition header. Does not affect actual object key. */
	fileName?: string | undefined,
	contentDisposition?: ModelTypes["S33ContentDisposition"] | undefined,
	/** If not supported by S3 provider, an error is thrown. */
	acl?: ModelTypes["S3Acl"] | undefined
};
	["S33ContentDisposition"]:S33ContentDisposition;
	["S3Acl"]:S3Acl;
	["S3SignedRead"]: {
		url: string,
	headers: Array<ModelTypes["S3Header"]>,
	method: string,
	objectKey: string,
	bucket: string
};
	["GeneralCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["General"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["GeneralCreateResult"] | ModelTypes["GeneralDeleteResult"] | ModelTypes["GeneralUpdateResult"] | ModelTypes["GeneralUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["GenericPageCreateResult"] | ModelTypes["GenericPageDeleteResult"] | ModelTypes["GenericPageUpdateResult"] | ModelTypes["GenericPageUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["ContentCreateResult"] | ModelTypes["ContentDeleteResult"] | ModelTypes["ContentUpdateResult"] | ModelTypes["ContentUpsertResult"] | ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ContentReferenceCreateResult"] | ModelTypes["ContentReferenceDeleteResult"] | ModelTypes["ContentReferenceUpdateResult"] | ModelTypes["ContentReferenceUpsertResult"] | ModelTypes["RedirectCreateResult"] | ModelTypes["RedirectDeleteResult"] | ModelTypes["RedirectUpdateResult"] | ModelTypes["RedirectUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["FooterCreateResult"] | ModelTypes["FooterDeleteResult"] | ModelTypes["FooterUpdateResult"] | ModelTypes["FooterUpsertResult"] | ModelTypes["FooterLinkCreateResult"] | ModelTypes["FooterLinkDeleteResult"] | ModelTypes["FooterLinkUpdateResult"] | ModelTypes["FooterLinkUpsertResult"] | ModelTypes["FooterLocaleCreateResult"] | ModelTypes["FooterLocaleDeleteResult"] | ModelTypes["FooterLocaleUpdateResult"] | ModelTypes["FooterLocaleUpsertResult"] | ModelTypes["GenericPageLocaleCreateResult"] | ModelTypes["GenericPageLocaleDeleteResult"] | ModelTypes["GenericPageLocaleUpdateResult"] | ModelTypes["GenericPageLocaleUpsertResult"] | ModelTypes["HeaderCreateResult"] | ModelTypes["HeaderDeleteResult"] | ModelTypes["HeaderUpdateResult"] | ModelTypes["HeaderUpsertResult"] | ModelTypes["HeaderLocaleCreateResult"] | ModelTypes["HeaderLocaleDeleteResult"] | ModelTypes["HeaderLocaleUpdateResult"] | ModelTypes["HeaderLocaleUpsertResult"] | ModelTypes["LocaleCreateResult"] | ModelTypes["LocaleDeleteResult"] | ModelTypes["LocaleUpdateResult"] | ModelTypes["LocaleUpsertResult"] | ModelTypes["SeoDefaultCreateResult"] | ModelTypes["SeoDefaultDeleteResult"] | ModelTypes["SeoDefaultUpdateResult"] | ModelTypes["SeoDefaultUpsertResult"] | ModelTypes["SeoDefaultLocaleCreateResult"] | ModelTypes["SeoDefaultLocaleDeleteResult"] | ModelTypes["SeoDefaultLocaleUpdateResult"] | ModelTypes["SeoDefaultLocaleUpsertResult"] | ModelTypes["BusinessCreateResult"] | ModelTypes["BusinessDeleteResult"] | ModelTypes["BusinessUpdateResult"] | ModelTypes["BusinessUpsertResult"] | ModelTypes["BusinessPageCreateResult"] | ModelTypes["BusinessPageDeleteResult"] | ModelTypes["BusinessPageUpdateResult"] | ModelTypes["BusinessPageUpsertResult"] | ModelTypes["BusinessPageLocaleCreateResult"] | ModelTypes["BusinessPageLocaleDeleteResult"] | ModelTypes["BusinessPageLocaleUpdateResult"] | ModelTypes["BusinessPageLocaleUpsertResult"] | ModelTypes["IconCreateResult"] | ModelTypes["IconDeleteResult"] | ModelTypes["IconUpdateResult"] | ModelTypes["IconUpsertResult"] | ModelTypes["JobPageCreateResult"] | ModelTypes["JobPageDeleteResult"] | ModelTypes["JobPageUpdateResult"] | ModelTypes["JobPageUpsertResult"] | ModelTypes["JobPageLocaleCreateResult"] | ModelTypes["JobPageLocaleDeleteResult"] | ModelTypes["JobPageLocaleUpdateResult"] | ModelTypes["JobPageLocaleUpsertResult"] | ModelTypes["KeyInfoItemCreateResult"] | ModelTypes["KeyInfoItemDeleteResult"] | ModelTypes["KeyInfoItemUpdateResult"] | ModelTypes["KeyInfoItemUpsertResult"] | ModelTypes["KeyInfoListCreateResult"] | ModelTypes["KeyInfoListDeleteResult"] | ModelTypes["KeyInfoListUpdateResult"] | ModelTypes["KeyInfoListUpsertResult"] | ModelTypes["ContractTypeCreateResult"] | ModelTypes["ContractTypeDeleteResult"] | ModelTypes["ContractTypeUpdateResult"] | ModelTypes["ContractTypeUpsertResult"] | ModelTypes["ContractTypeLocaleCreateResult"] | ModelTypes["ContractTypeLocaleDeleteResult"] | ModelTypes["ContractTypeLocaleUpdateResult"] | ModelTypes["ContractTypeLocaleUpsertResult"] | ModelTypes["JobCityCreateResult"] | ModelTypes["JobCityDeleteResult"] | ModelTypes["JobCityUpdateResult"] | ModelTypes["JobCityUpsertResult"] | ModelTypes["JobCityLocaleCreateResult"] | ModelTypes["JobCityLocaleDeleteResult"] | ModelTypes["JobCityLocaleUpdateResult"] | ModelTypes["JobCityLocaleUpsertResult"] | ModelTypes["JobPositionCreateResult"] | ModelTypes["JobPositionDeleteResult"] | ModelTypes["JobPositionUpdateResult"] | ModelTypes["JobPositionUpsertResult"] | ModelTypes["JobPositionLocaleCreateResult"] | ModelTypes["JobPositionLocaleDeleteResult"] | ModelTypes["JobPositionLocaleUpdateResult"] | ModelTypes["JobPositionLocaleUpsertResult"] | ModelTypes["GalleryCreateResult"] | ModelTypes["GalleryDeleteResult"] | ModelTypes["GalleryUpdateResult"] | ModelTypes["GalleryUpsertResult"] | ModelTypes["HomePageCreateResult"] | ModelTypes["HomePageDeleteResult"] | ModelTypes["HomePageUpdateResult"] | ModelTypes["HomePageUpsertResult"] | ModelTypes["HomePageLocaleCreateResult"] | ModelTypes["HomePageLocaleDeleteResult"] | ModelTypes["HomePageLocaleUpdateResult"] | ModelTypes["HomePageLocaleUpsertResult"] | ModelTypes["MediumCreateResult"] | ModelTypes["MediumDeleteResult"] | ModelTypes["MediumUpdateResult"] | ModelTypes["MediumUpsertResult"] | ModelTypes["MediumItemCreateResult"] | ModelTypes["MediumItemDeleteResult"] | ModelTypes["MediumItemUpdateResult"] | ModelTypes["MediumItemUpsertResult"] | ModelTypes["MediumListCreateResult"] | ModelTypes["MediumListDeleteResult"] | ModelTypes["MediumListUpdateResult"] | ModelTypes["MediumListUpsertResult"] | ModelTypes["VideoCreateResult"] | ModelTypes["VideoDeleteResult"] | ModelTypes["VideoUpdateResult"] | ModelTypes["VideoUpsertResult"] | ModelTypes["TextItemCreateResult"] | ModelTypes["TextItemDeleteResult"] | ModelTypes["TextItemUpdateResult"] | ModelTypes["TextItemUpsertResult"] | ModelTypes["TextListCreateResult"] | ModelTypes["TextListDeleteResult"] | ModelTypes["TextListUpdateResult"] | ModelTypes["TextListUpsertResult"] | ModelTypes["CarouselCreateResult"] | ModelTypes["CarouselDeleteResult"] | ModelTypes["CarouselUpdateResult"] | ModelTypes["CarouselUpsertResult"] | ModelTypes["CarouselItemCreateResult"] | ModelTypes["CarouselItemDeleteResult"] | ModelTypes["CarouselItemUpdateResult"] | ModelTypes["CarouselItemUpsertResult"] | ModelTypes["ThemeCreateResult"] | ModelTypes["ThemeDeleteResult"] | ModelTypes["ThemeUpdateResult"] | ModelTypes["ThemeUpsertResult"] | ModelTypes["BonusBannerCreateResult"] | ModelTypes["BonusBannerDeleteResult"] | ModelTypes["BonusBannerUpdateResult"] | ModelTypes["BonusBannerUpsertResult"] | ModelTypes["BonusBannerLocaleCreateResult"] | ModelTypes["BonusBannerLocaleDeleteResult"] | ModelTypes["BonusBannerLocaleUpdateResult"] | ModelTypes["BonusBannerLocaleUpsertResult"] | ModelTypes["TileCreateResult"] | ModelTypes["TileDeleteResult"] | ModelTypes["TileUpdateResult"] | ModelTypes["TileUpsertResult"] | ModelTypes["SideBySideCreateResult"] | ModelTypes["SideBySideDeleteResult"] | ModelTypes["SideBySideUpdateResult"] | ModelTypes["SideBySideUpsertResult"] | ModelTypes["SideBySideItemCreateResult"] | ModelTypes["SideBySideItemDeleteResult"] | ModelTypes["SideBySideItemUpdateResult"] | ModelTypes["SideBySideItemUpsertResult"] | ModelTypes["HomePageLokalCreateResult"] | ModelTypes["HomePageLokalDeleteResult"] | ModelTypes["HomePageLokalUpdateResult"] | ModelTypes["HomePageLokalUpsertResult"] | ModelTypes["HomePageLokalLocaleCreateResult"] | ModelTypes["HomePageLokalLocaleDeleteResult"] | ModelTypes["HomePageLokalLocaleUpdateResult"] | ModelTypes["HomePageLokalLocaleUpsertResult"] | ModelTypes["SiteSwitcherCreateResult"] | ModelTypes["SiteSwitcherDeleteResult"] | ModelTypes["SiteSwitcherUpdateResult"] | ModelTypes["SiteSwitcherUpsertResult"] | ModelTypes["GalleryItemCreateResult"] | ModelTypes["GalleryItemDeleteResult"] | ModelTypes["GalleryItemUpdateResult"] | ModelTypes["GalleryItemUpsertResult"] | ModelTypes["JobsFormCreateResult"] | ModelTypes["JobsFormDeleteResult"] | ModelTypes["JobsFormUpdateResult"] | ModelTypes["JobsFormUpsertResult"] | ModelTypes["JobsFormLocaleCreateResult"] | ModelTypes["JobsFormLocaleDeleteResult"] | ModelTypes["JobsFormLocaleUpdateResult"] | ModelTypes["JobsFormLocaleUpsertResult"] | ModelTypes["ImageTextItemCreateResult"] | ModelTypes["ImageTextItemDeleteResult"] | ModelTypes["ImageTextItemUpdateResult"] | ModelTypes["ImageTextItemUpsertResult"] | ModelTypes["ImageTextListCreateResult"] | ModelTypes["ImageTextListDeleteResult"] | ModelTypes["ImageTextListUpdateResult"] | ModelTypes["ImageTextListUpsertResult"] | ModelTypes["JobsFilterCreateResult"] | ModelTypes["JobsFilterDeleteResult"] | ModelTypes["JobsFilterUpdateResult"] | ModelTypes["JobsFilterUpsertResult"] | ModelTypes["JobsFilterLocaleCreateResult"] | ModelTypes["JobsFilterLocaleDeleteResult"] | ModelTypes["JobsFilterLocaleUpdateResult"] | ModelTypes["JobsFilterLocaleUpsertResult"] | ModelTypes["FileCreateResult"] | ModelTypes["FileDeleteResult"] | ModelTypes["FileUpdateResult"] | ModelTypes["FileUpsertResult"] | ModelTypes["JobFormSubscriptionCreateResult"] | ModelTypes["JobFormSubscriptionDeleteResult"] | ModelTypes["JobFormSubscriptionUpdateResult"] | ModelTypes["JobFormSubscriptionUpsertResult"] | ModelTypes["ImageListCreateResult"] | ModelTypes["ImageListDeleteResult"] | ModelTypes["ImageListUpdateResult"] | ModelTypes["ImageListUpsertResult"] | ModelTypes["ImageListItemCreateResult"] | ModelTypes["ImageListItemDeleteResult"] | ModelTypes["ImageListItemUpdateResult"] | ModelTypes["ImageListItemUpsertResult"] | ModelTypes["JobFormSubscriptionStatusCreateResult"] | ModelTypes["JobFormSubscriptionStatusDeleteResult"] | ModelTypes["JobFormSubscriptionStatusUpdateResult"] | ModelTypes["JobFormSubscriptionStatusUpsertResult"] | ModelTypes["GeneralLocaleCreateResult"] | ModelTypes["GeneralLocaleDeleteResult"] | ModelTypes["GeneralLocaleUpdateResult"] | ModelTypes["GeneralLocaleUpsertResult"] | ModelTypes["StickyBarCreateResult"] | ModelTypes["StickyBarDeleteResult"] | ModelTypes["StickyBarUpdateResult"] | ModelTypes["StickyBarUpsertResult"] | ModelTypes["RecommendationFormCreateResult"] | ModelTypes["RecommendationFormDeleteResult"] | ModelTypes["RecommendationFormUpdateResult"] | ModelTypes["RecommendationFormUpsertResult"] | ModelTypes["RecommendationFormLocaleCreateResult"] | ModelTypes["RecommendationFormLocaleDeleteResult"] | ModelTypes["RecommendationFormLocaleUpdateResult"] | ModelTypes["RecommendationFormLocaleUpsertResult"] | ModelTypes["RecommendationFormSubscriptionCreateResult"] | ModelTypes["RecommendationFormSubscriptionDeleteResult"] | ModelTypes["RecommendationFormSubscriptionUpdateResult"] | ModelTypes["RecommendationFormSubscriptionUpsertResult"] | ModelTypes["InfoBoxCreateResult"] | ModelTypes["InfoBoxDeleteResult"] | ModelTypes["InfoBoxUpdateResult"] | ModelTypes["InfoBoxUpsertResult"] | ModelTypes["InfoBoxLocaleCreateResult"] | ModelTypes["InfoBoxLocaleDeleteResult"] | ModelTypes["InfoBoxLocaleUpdateResult"] | ModelTypes["InfoBoxLocaleUpsertResult"] | ModelTypes["TranslationCreateResult"] | ModelTypes["TranslationDeleteResult"] | ModelTypes["TranslationUpdateResult"] | ModelTypes["TranslationUpsertResult"] | ModelTypes["TranslationLocaleCreateResult"] | ModelTypes["TranslationLocaleDeleteResult"] | ModelTypes["TranslationLocaleUpdateResult"] | ModelTypes["TranslationLocaleUpsertResult"] | ModelTypes["CornerBannerCreateResult"] | ModelTypes["CornerBannerDeleteResult"] | ModelTypes["CornerBannerUpdateResult"] | ModelTypes["CornerBannerUpsertResult"];
	["_MutationError"]: {
		path: Array<ModelTypes["_PathFragment"]>,
	paths: Array<Array<ModelTypes["_PathFragment"]>>,
	type: ModelTypes["_MutationErrorType"],
	message?: string | undefined
};
	["_MutationErrorType"]:_MutationErrorType;
	["GeneralDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["General"] | undefined
};
	["GeneralUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["General"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GeneralUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["General"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Image"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Image"] | undefined
};
	["ImageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Image"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Image"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPage"] | undefined
};
	["GenericPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Linkable"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Linkable"] | undefined
};
	["LinkableUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Linkable"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Linkable"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Seo"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Seo"] | undefined
};
	["SeoUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Seo"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Seo"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Content"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Content"] | undefined
};
	["ContentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Content"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Content"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentBlock"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentBlock"] | undefined
};
	["ContentBlockUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentBlock"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentBlock"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentReference"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentReference"] | undefined
};
	["ContentReferenceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentReference"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContentReference"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Redirect"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Redirect"] | undefined
};
	["RedirectUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Redirect"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Redirect"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Link"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Link"] | undefined
};
	["LinkUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Link"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Link"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Footer"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Footer"] | undefined
};
	["FooterUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Footer"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Footer"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterLinkCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLink"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterLinkDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLink"] | undefined
};
	["FooterLinkUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLink"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterLinkUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLink"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLocale"] | undefined
};
	["FooterLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FooterLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["FooterLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageLocale"] | undefined
};
	["GenericPageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GenericPageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GenericPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Header"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Header"] | undefined
};
	["HeaderUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Header"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Header"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeaderLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeaderLocale"] | undefined
};
	["HeaderLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeaderLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HeaderLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HeaderLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Locale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Locale"] | undefined
};
	["LocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Locale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Locale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoDefaultCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SeoDefault"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoDefaultDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SeoDefault"] | undefined
};
	["SeoDefaultUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SeoDefault"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoDefaultUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SeoDefault"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoDefaultLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SeoDefaultLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoDefaultLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SeoDefaultLocale"] | undefined
};
	["SeoDefaultLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SeoDefaultLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SeoDefaultLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SeoDefaultLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BusinessCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Business"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BusinessDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Business"] | undefined
};
	["BusinessUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Business"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BusinessUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Business"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BusinessPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BusinessPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BusinessPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BusinessPage"] | undefined
};
	["BusinessPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BusinessPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BusinessPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BusinessPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BusinessPageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BusinessPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BusinessPageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BusinessPageLocale"] | undefined
};
	["BusinessPageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BusinessPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BusinessPageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BusinessPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["IconCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Icon"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["IconDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Icon"] | undefined
};
	["IconUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Icon"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["IconUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Icon"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPage"] | undefined
};
	["JobPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPageLocale"] | undefined
};
	["JobPageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["KeyInfoItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["KeyInfoItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["KeyInfoItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["KeyInfoItem"] | undefined
};
	["KeyInfoItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["KeyInfoItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["KeyInfoItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["KeyInfoItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["KeyInfoListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["KeyInfoList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["KeyInfoListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["KeyInfoList"] | undefined
};
	["KeyInfoListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["KeyInfoList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["KeyInfoListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["KeyInfoList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContractTypeCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContractType"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContractTypeDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContractType"] | undefined
};
	["ContractTypeUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContractType"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContractTypeUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContractType"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContractTypeLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContractTypeLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContractTypeLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContractTypeLocale"] | undefined
};
	["ContractTypeLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContractTypeLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ContractTypeLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ContractTypeLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobCityCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobCity"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobCityDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobCity"] | undefined
};
	["JobCityUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobCity"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobCityUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobCity"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobCityLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobCityLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobCityLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobCityLocale"] | undefined
};
	["JobCityLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobCityLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobCityLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobCityLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPositionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPosition"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPositionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPosition"] | undefined
};
	["JobPositionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPosition"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPositionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPosition"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPositionLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPositionLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPositionLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPositionLocale"] | undefined
};
	["JobPositionLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPositionLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobPositionLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobPositionLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Gallery"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Gallery"] | undefined
};
	["GalleryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Gallery"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Gallery"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePage"] | undefined
};
	["HomePageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePage"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLocale"] | undefined
};
	["HomePageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Medium"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Medium"] | undefined
};
	["MediumUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Medium"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Medium"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumItem"] | undefined
};
	["MediumItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumList"] | undefined
};
	["MediumListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MediumListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["MediumList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Video"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Video"] | undefined
};
	["VideoUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Video"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Video"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextItem"] | undefined
};
	["TextItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextList"] | undefined
};
	["TextListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TextListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TextList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CarouselCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Carousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CarouselDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Carousel"] | undefined
};
	["CarouselUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Carousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CarouselUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Carousel"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CarouselItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CarouselItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CarouselItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CarouselItem"] | undefined
};
	["CarouselItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CarouselItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CarouselItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CarouselItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ThemeCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Theme"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ThemeDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Theme"] | undefined
};
	["ThemeUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Theme"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ThemeUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Theme"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BonusBannerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BonusBanner"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BonusBannerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BonusBanner"] | undefined
};
	["BonusBannerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BonusBanner"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BonusBannerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BonusBanner"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BonusBannerLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BonusBannerLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BonusBannerLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BonusBannerLocale"] | undefined
};
	["BonusBannerLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BonusBannerLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["BonusBannerLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["BonusBannerLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TileCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Tile"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TileDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Tile"] | undefined
};
	["TileUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Tile"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TileUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Tile"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SideBySideCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SideBySide"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SideBySideDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SideBySide"] | undefined
};
	["SideBySideUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SideBySide"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SideBySideUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SideBySide"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SideBySideItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SideBySideItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SideBySideItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SideBySideItem"] | undefined
};
	["SideBySideItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SideBySideItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SideBySideItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SideBySideItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageLokalCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLokal"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageLokalDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLokal"] | undefined
};
	["HomePageLokalUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLokal"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageLokalUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLokal"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageLokalLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLokalLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageLokalLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLokalLocale"] | undefined
};
	["HomePageLokalLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLokalLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["HomePageLokalLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["HomePageLokalLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SiteSwitcherCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SiteSwitcher"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SiteSwitcherDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SiteSwitcher"] | undefined
};
	["SiteSwitcherUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SiteSwitcher"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["SiteSwitcherUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["SiteSwitcher"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GalleryItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GalleryItem"] | undefined
};
	["GalleryItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GalleryItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GalleryItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFormCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsForm"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFormDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsForm"] | undefined
};
	["JobsFormUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsForm"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFormUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsForm"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFormLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFormLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFormLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFormLocale"] | undefined
};
	["JobsFormLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFormLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFormLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFormLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageTextItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageTextItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageTextItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageTextItem"] | undefined
};
	["ImageTextItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageTextItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageTextItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageTextItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageTextListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageTextList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageTextListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageTextList"] | undefined
};
	["ImageTextListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageTextList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageTextListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageTextList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFilterCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFilter"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFilterDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFilter"] | undefined
};
	["JobsFilterUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFilter"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFilterUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFilter"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFilterLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFilterLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFilterLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFilterLocale"] | undefined
};
	["JobsFilterLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFilterLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobsFilterLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobsFilterLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FileCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["File"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FileDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["File"] | undefined
};
	["FileUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["File"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["FileUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["File"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobFormSubscriptionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobFormSubscription"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobFormSubscriptionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobFormSubscription"] | undefined
};
	["JobFormSubscriptionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobFormSubscription"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobFormSubscriptionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobFormSubscription"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageList"] | undefined
};
	["ImageListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageList"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageListItem"] | undefined
};
	["ImageListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["ImageListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["ImageListItem"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobFormSubscriptionStatusCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobFormSubscriptionStatus"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobFormSubscriptionStatusDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobFormSubscriptionStatus"] | undefined
};
	["JobFormSubscriptionStatusUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobFormSubscriptionStatus"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["JobFormSubscriptionStatusUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["JobFormSubscriptionStatus"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GeneralLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GeneralLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GeneralLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GeneralLocale"] | undefined
};
	["GeneralLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GeneralLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["GeneralLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["GeneralLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StickyBarCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StickyBar"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StickyBarDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StickyBar"] | undefined
};
	["StickyBarUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StickyBar"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["StickyBarUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["StickyBar"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecommendationFormCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationForm"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecommendationFormDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationForm"] | undefined
};
	["RecommendationFormUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationForm"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecommendationFormUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationForm"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecommendationFormLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationFormLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecommendationFormLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationFormLocale"] | undefined
};
	["RecommendationFormLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationFormLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecommendationFormLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationFormLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecommendationFormSubscriptionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationFormSubscription"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecommendationFormSubscriptionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationFormSubscription"] | undefined
};
	["RecommendationFormSubscriptionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationFormSubscription"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["RecommendationFormSubscriptionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["RecommendationFormSubscription"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoBoxCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoBox"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoBoxDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoBox"] | undefined
};
	["InfoBoxUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoBox"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoBoxUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoBox"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoBoxLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoBoxLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoBoxLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoBoxLocale"] | undefined
};
	["InfoBoxLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoBoxLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["InfoBoxLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["InfoBoxLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Translation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Translation"] | undefined
};
	["TranslationUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Translation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["Translation"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationLocale"] | undefined
};
	["TranslationLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["TranslationLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["TranslationLocale"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CornerBannerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CornerBanner"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CornerBannerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CornerBanner"] | undefined
};
	["CornerBannerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CornerBanner"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["CornerBannerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	node?: ModelTypes["CornerBanner"] | undefined,
	validation: ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<ModelTypes["_MutationError"]>,
	validation: ModelTypes["_ValidationResult"],
	generateUploadUrl: ModelTypes["S3SignedUpload"],
	generateReadUrl: ModelTypes["S3SignedRead"],
	createGeneral: ModelTypes["GeneralCreateResult"],
	deleteGeneral: ModelTypes["GeneralDeleteResult"],
	updateGeneral: ModelTypes["GeneralUpdateResult"],
	upsertGeneral: ModelTypes["GeneralUpsertResult"],
	createImage: ModelTypes["ImageCreateResult"],
	deleteImage: ModelTypes["ImageDeleteResult"],
	updateImage: ModelTypes["ImageUpdateResult"],
	upsertImage: ModelTypes["ImageUpsertResult"],
	createGenericPage: ModelTypes["GenericPageCreateResult"],
	deleteGenericPage: ModelTypes["GenericPageDeleteResult"],
	updateGenericPage: ModelTypes["GenericPageUpdateResult"],
	upsertGenericPage: ModelTypes["GenericPageUpsertResult"],
	createLinkable: ModelTypes["LinkableCreateResult"],
	deleteLinkable: ModelTypes["LinkableDeleteResult"],
	updateLinkable: ModelTypes["LinkableUpdateResult"],
	upsertLinkable: ModelTypes["LinkableUpsertResult"],
	createSeo: ModelTypes["SeoCreateResult"],
	deleteSeo: ModelTypes["SeoDeleteResult"],
	updateSeo: ModelTypes["SeoUpdateResult"],
	upsertSeo: ModelTypes["SeoUpsertResult"],
	createContent: ModelTypes["ContentCreateResult"],
	deleteContent: ModelTypes["ContentDeleteResult"],
	updateContent: ModelTypes["ContentUpdateResult"],
	upsertContent: ModelTypes["ContentUpsertResult"],
	createContentBlock: ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock: ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock: ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock: ModelTypes["ContentBlockUpsertResult"],
	createContentReference: ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference: ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference: ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference: ModelTypes["ContentReferenceUpsertResult"],
	createRedirect: ModelTypes["RedirectCreateResult"],
	deleteRedirect: ModelTypes["RedirectDeleteResult"],
	updateRedirect: ModelTypes["RedirectUpdateResult"],
	upsertRedirect: ModelTypes["RedirectUpsertResult"],
	createLink: ModelTypes["LinkCreateResult"],
	deleteLink: ModelTypes["LinkDeleteResult"],
	updateLink: ModelTypes["LinkUpdateResult"],
	upsertLink: ModelTypes["LinkUpsertResult"],
	createFooter: ModelTypes["FooterCreateResult"],
	deleteFooter: ModelTypes["FooterDeleteResult"],
	updateFooter: ModelTypes["FooterUpdateResult"],
	upsertFooter: ModelTypes["FooterUpsertResult"],
	createFooterLink: ModelTypes["FooterLinkCreateResult"],
	deleteFooterLink: ModelTypes["FooterLinkDeleteResult"],
	updateFooterLink: ModelTypes["FooterLinkUpdateResult"],
	upsertFooterLink: ModelTypes["FooterLinkUpsertResult"],
	createFooterLocale: ModelTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: ModelTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: ModelTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: ModelTypes["FooterLocaleUpsertResult"],
	createGenericPageLocale: ModelTypes["GenericPageLocaleCreateResult"],
	deleteGenericPageLocale: ModelTypes["GenericPageLocaleDeleteResult"],
	updateGenericPageLocale: ModelTypes["GenericPageLocaleUpdateResult"],
	upsertGenericPageLocale: ModelTypes["GenericPageLocaleUpsertResult"],
	createHeader: ModelTypes["HeaderCreateResult"],
	deleteHeader: ModelTypes["HeaderDeleteResult"],
	updateHeader: ModelTypes["HeaderUpdateResult"],
	upsertHeader: ModelTypes["HeaderUpsertResult"],
	createHeaderLocale: ModelTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: ModelTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: ModelTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: ModelTypes["HeaderLocaleUpsertResult"],
	createLocale: ModelTypes["LocaleCreateResult"],
	deleteLocale: ModelTypes["LocaleDeleteResult"],
	updateLocale: ModelTypes["LocaleUpdateResult"],
	upsertLocale: ModelTypes["LocaleUpsertResult"],
	createSeoDefault: ModelTypes["SeoDefaultCreateResult"],
	deleteSeoDefault: ModelTypes["SeoDefaultDeleteResult"],
	updateSeoDefault: ModelTypes["SeoDefaultUpdateResult"],
	upsertSeoDefault: ModelTypes["SeoDefaultUpsertResult"],
	createSeoDefaultLocale: ModelTypes["SeoDefaultLocaleCreateResult"],
	deleteSeoDefaultLocale: ModelTypes["SeoDefaultLocaleDeleteResult"],
	updateSeoDefaultLocale: ModelTypes["SeoDefaultLocaleUpdateResult"],
	upsertSeoDefaultLocale: ModelTypes["SeoDefaultLocaleUpsertResult"],
	createBusiness: ModelTypes["BusinessCreateResult"],
	deleteBusiness: ModelTypes["BusinessDeleteResult"],
	updateBusiness: ModelTypes["BusinessUpdateResult"],
	upsertBusiness: ModelTypes["BusinessUpsertResult"],
	createBusinessPage: ModelTypes["BusinessPageCreateResult"],
	deleteBusinessPage: ModelTypes["BusinessPageDeleteResult"],
	updateBusinessPage: ModelTypes["BusinessPageUpdateResult"],
	upsertBusinessPage: ModelTypes["BusinessPageUpsertResult"],
	createBusinessPageLocale: ModelTypes["BusinessPageLocaleCreateResult"],
	deleteBusinessPageLocale: ModelTypes["BusinessPageLocaleDeleteResult"],
	updateBusinessPageLocale: ModelTypes["BusinessPageLocaleUpdateResult"],
	upsertBusinessPageLocale: ModelTypes["BusinessPageLocaleUpsertResult"],
	createIcon: ModelTypes["IconCreateResult"],
	deleteIcon: ModelTypes["IconDeleteResult"],
	updateIcon: ModelTypes["IconUpdateResult"],
	upsertIcon: ModelTypes["IconUpsertResult"],
	createJobPage: ModelTypes["JobPageCreateResult"],
	deleteJobPage: ModelTypes["JobPageDeleteResult"],
	updateJobPage: ModelTypes["JobPageUpdateResult"],
	upsertJobPage: ModelTypes["JobPageUpsertResult"],
	createJobPageLocale: ModelTypes["JobPageLocaleCreateResult"],
	deleteJobPageLocale: ModelTypes["JobPageLocaleDeleteResult"],
	updateJobPageLocale: ModelTypes["JobPageLocaleUpdateResult"],
	upsertJobPageLocale: ModelTypes["JobPageLocaleUpsertResult"],
	createKeyInfoItem: ModelTypes["KeyInfoItemCreateResult"],
	deleteKeyInfoItem: ModelTypes["KeyInfoItemDeleteResult"],
	updateKeyInfoItem: ModelTypes["KeyInfoItemUpdateResult"],
	upsertKeyInfoItem: ModelTypes["KeyInfoItemUpsertResult"],
	createKeyInfoList: ModelTypes["KeyInfoListCreateResult"],
	deleteKeyInfoList: ModelTypes["KeyInfoListDeleteResult"],
	updateKeyInfoList: ModelTypes["KeyInfoListUpdateResult"],
	upsertKeyInfoList: ModelTypes["KeyInfoListUpsertResult"],
	createContractType: ModelTypes["ContractTypeCreateResult"],
	deleteContractType: ModelTypes["ContractTypeDeleteResult"],
	updateContractType: ModelTypes["ContractTypeUpdateResult"],
	upsertContractType: ModelTypes["ContractTypeUpsertResult"],
	createContractTypeLocale: ModelTypes["ContractTypeLocaleCreateResult"],
	deleteContractTypeLocale: ModelTypes["ContractTypeLocaleDeleteResult"],
	updateContractTypeLocale: ModelTypes["ContractTypeLocaleUpdateResult"],
	upsertContractTypeLocale: ModelTypes["ContractTypeLocaleUpsertResult"],
	createJobCity: ModelTypes["JobCityCreateResult"],
	deleteJobCity: ModelTypes["JobCityDeleteResult"],
	updateJobCity: ModelTypes["JobCityUpdateResult"],
	upsertJobCity: ModelTypes["JobCityUpsertResult"],
	createJobCityLocale: ModelTypes["JobCityLocaleCreateResult"],
	deleteJobCityLocale: ModelTypes["JobCityLocaleDeleteResult"],
	updateJobCityLocale: ModelTypes["JobCityLocaleUpdateResult"],
	upsertJobCityLocale: ModelTypes["JobCityLocaleUpsertResult"],
	createJobPosition: ModelTypes["JobPositionCreateResult"],
	deleteJobPosition: ModelTypes["JobPositionDeleteResult"],
	updateJobPosition: ModelTypes["JobPositionUpdateResult"],
	upsertJobPosition: ModelTypes["JobPositionUpsertResult"],
	createJobPositionLocale: ModelTypes["JobPositionLocaleCreateResult"],
	deleteJobPositionLocale: ModelTypes["JobPositionLocaleDeleteResult"],
	updateJobPositionLocale: ModelTypes["JobPositionLocaleUpdateResult"],
	upsertJobPositionLocale: ModelTypes["JobPositionLocaleUpsertResult"],
	createGallery: ModelTypes["GalleryCreateResult"],
	deleteGallery: ModelTypes["GalleryDeleteResult"],
	updateGallery: ModelTypes["GalleryUpdateResult"],
	upsertGallery: ModelTypes["GalleryUpsertResult"],
	createHomePage: ModelTypes["HomePageCreateResult"],
	deleteHomePage: ModelTypes["HomePageDeleteResult"],
	updateHomePage: ModelTypes["HomePageUpdateResult"],
	upsertHomePage: ModelTypes["HomePageUpsertResult"],
	createHomePageLocale: ModelTypes["HomePageLocaleCreateResult"],
	deleteHomePageLocale: ModelTypes["HomePageLocaleDeleteResult"],
	updateHomePageLocale: ModelTypes["HomePageLocaleUpdateResult"],
	upsertHomePageLocale: ModelTypes["HomePageLocaleUpsertResult"],
	createMedium: ModelTypes["MediumCreateResult"],
	deleteMedium: ModelTypes["MediumDeleteResult"],
	updateMedium: ModelTypes["MediumUpdateResult"],
	upsertMedium: ModelTypes["MediumUpsertResult"],
	createMediumItem: ModelTypes["MediumItemCreateResult"],
	deleteMediumItem: ModelTypes["MediumItemDeleteResult"],
	updateMediumItem: ModelTypes["MediumItemUpdateResult"],
	upsertMediumItem: ModelTypes["MediumItemUpsertResult"],
	createMediumList: ModelTypes["MediumListCreateResult"],
	deleteMediumList: ModelTypes["MediumListDeleteResult"],
	updateMediumList: ModelTypes["MediumListUpdateResult"],
	upsertMediumList: ModelTypes["MediumListUpsertResult"],
	createVideo: ModelTypes["VideoCreateResult"],
	deleteVideo: ModelTypes["VideoDeleteResult"],
	updateVideo: ModelTypes["VideoUpdateResult"],
	upsertVideo: ModelTypes["VideoUpsertResult"],
	createTextItem: ModelTypes["TextItemCreateResult"],
	deleteTextItem: ModelTypes["TextItemDeleteResult"],
	updateTextItem: ModelTypes["TextItemUpdateResult"],
	upsertTextItem: ModelTypes["TextItemUpsertResult"],
	createTextList: ModelTypes["TextListCreateResult"],
	deleteTextList: ModelTypes["TextListDeleteResult"],
	updateTextList: ModelTypes["TextListUpdateResult"],
	upsertTextList: ModelTypes["TextListUpsertResult"],
	createCarousel: ModelTypes["CarouselCreateResult"],
	deleteCarousel: ModelTypes["CarouselDeleteResult"],
	updateCarousel: ModelTypes["CarouselUpdateResult"],
	upsertCarousel: ModelTypes["CarouselUpsertResult"],
	createCarouselItem: ModelTypes["CarouselItemCreateResult"],
	deleteCarouselItem: ModelTypes["CarouselItemDeleteResult"],
	updateCarouselItem: ModelTypes["CarouselItemUpdateResult"],
	upsertCarouselItem: ModelTypes["CarouselItemUpsertResult"],
	createTheme: ModelTypes["ThemeCreateResult"],
	deleteTheme: ModelTypes["ThemeDeleteResult"],
	updateTheme: ModelTypes["ThemeUpdateResult"],
	upsertTheme: ModelTypes["ThemeUpsertResult"],
	createBonusBanner: ModelTypes["BonusBannerCreateResult"],
	deleteBonusBanner: ModelTypes["BonusBannerDeleteResult"],
	updateBonusBanner: ModelTypes["BonusBannerUpdateResult"],
	upsertBonusBanner: ModelTypes["BonusBannerUpsertResult"],
	createBonusBannerLocale: ModelTypes["BonusBannerLocaleCreateResult"],
	deleteBonusBannerLocale: ModelTypes["BonusBannerLocaleDeleteResult"],
	updateBonusBannerLocale: ModelTypes["BonusBannerLocaleUpdateResult"],
	upsertBonusBannerLocale: ModelTypes["BonusBannerLocaleUpsertResult"],
	createTile: ModelTypes["TileCreateResult"],
	deleteTile: ModelTypes["TileDeleteResult"],
	updateTile: ModelTypes["TileUpdateResult"],
	upsertTile: ModelTypes["TileUpsertResult"],
	createSideBySide: ModelTypes["SideBySideCreateResult"],
	deleteSideBySide: ModelTypes["SideBySideDeleteResult"],
	updateSideBySide: ModelTypes["SideBySideUpdateResult"],
	upsertSideBySide: ModelTypes["SideBySideUpsertResult"],
	createSideBySideItem: ModelTypes["SideBySideItemCreateResult"],
	deleteSideBySideItem: ModelTypes["SideBySideItemDeleteResult"],
	updateSideBySideItem: ModelTypes["SideBySideItemUpdateResult"],
	upsertSideBySideItem: ModelTypes["SideBySideItemUpsertResult"],
	createHomePageLokal: ModelTypes["HomePageLokalCreateResult"],
	deleteHomePageLokal: ModelTypes["HomePageLokalDeleteResult"],
	updateHomePageLokal: ModelTypes["HomePageLokalUpdateResult"],
	upsertHomePageLokal: ModelTypes["HomePageLokalUpsertResult"],
	createHomePageLokalLocale: ModelTypes["HomePageLokalLocaleCreateResult"],
	deleteHomePageLokalLocale: ModelTypes["HomePageLokalLocaleDeleteResult"],
	updateHomePageLokalLocale: ModelTypes["HomePageLokalLocaleUpdateResult"],
	upsertHomePageLokalLocale: ModelTypes["HomePageLokalLocaleUpsertResult"],
	createSiteSwitcher: ModelTypes["SiteSwitcherCreateResult"],
	deleteSiteSwitcher: ModelTypes["SiteSwitcherDeleteResult"],
	updateSiteSwitcher: ModelTypes["SiteSwitcherUpdateResult"],
	upsertSiteSwitcher: ModelTypes["SiteSwitcherUpsertResult"],
	createGalleryItem: ModelTypes["GalleryItemCreateResult"],
	deleteGalleryItem: ModelTypes["GalleryItemDeleteResult"],
	updateGalleryItem: ModelTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: ModelTypes["GalleryItemUpsertResult"],
	createJobsForm: ModelTypes["JobsFormCreateResult"],
	deleteJobsForm: ModelTypes["JobsFormDeleteResult"],
	updateJobsForm: ModelTypes["JobsFormUpdateResult"],
	upsertJobsForm: ModelTypes["JobsFormUpsertResult"],
	createJobsFormLocale: ModelTypes["JobsFormLocaleCreateResult"],
	deleteJobsFormLocale: ModelTypes["JobsFormLocaleDeleteResult"],
	updateJobsFormLocale: ModelTypes["JobsFormLocaleUpdateResult"],
	upsertJobsFormLocale: ModelTypes["JobsFormLocaleUpsertResult"],
	createImageTextItem: ModelTypes["ImageTextItemCreateResult"],
	deleteImageTextItem: ModelTypes["ImageTextItemDeleteResult"],
	updateImageTextItem: ModelTypes["ImageTextItemUpdateResult"],
	upsertImageTextItem: ModelTypes["ImageTextItemUpsertResult"],
	createImageTextList: ModelTypes["ImageTextListCreateResult"],
	deleteImageTextList: ModelTypes["ImageTextListDeleteResult"],
	updateImageTextList: ModelTypes["ImageTextListUpdateResult"],
	upsertImageTextList: ModelTypes["ImageTextListUpsertResult"],
	createJobsFilter: ModelTypes["JobsFilterCreateResult"],
	deleteJobsFilter: ModelTypes["JobsFilterDeleteResult"],
	updateJobsFilter: ModelTypes["JobsFilterUpdateResult"],
	upsertJobsFilter: ModelTypes["JobsFilterUpsertResult"],
	createJobsFilterLocale: ModelTypes["JobsFilterLocaleCreateResult"],
	deleteJobsFilterLocale: ModelTypes["JobsFilterLocaleDeleteResult"],
	updateJobsFilterLocale: ModelTypes["JobsFilterLocaleUpdateResult"],
	upsertJobsFilterLocale: ModelTypes["JobsFilterLocaleUpsertResult"],
	createFile: ModelTypes["FileCreateResult"],
	deleteFile: ModelTypes["FileDeleteResult"],
	updateFile: ModelTypes["FileUpdateResult"],
	upsertFile: ModelTypes["FileUpsertResult"],
	createJobFormSubscription: ModelTypes["JobFormSubscriptionCreateResult"],
	deleteJobFormSubscription: ModelTypes["JobFormSubscriptionDeleteResult"],
	updateJobFormSubscription: ModelTypes["JobFormSubscriptionUpdateResult"],
	upsertJobFormSubscription: ModelTypes["JobFormSubscriptionUpsertResult"],
	createImageList: ModelTypes["ImageListCreateResult"],
	deleteImageList: ModelTypes["ImageListDeleteResult"],
	updateImageList: ModelTypes["ImageListUpdateResult"],
	upsertImageList: ModelTypes["ImageListUpsertResult"],
	createImageListItem: ModelTypes["ImageListItemCreateResult"],
	deleteImageListItem: ModelTypes["ImageListItemDeleteResult"],
	updateImageListItem: ModelTypes["ImageListItemUpdateResult"],
	upsertImageListItem: ModelTypes["ImageListItemUpsertResult"],
	createJobFormSubscriptionStatus: ModelTypes["JobFormSubscriptionStatusCreateResult"],
	deleteJobFormSubscriptionStatus: ModelTypes["JobFormSubscriptionStatusDeleteResult"],
	updateJobFormSubscriptionStatus: ModelTypes["JobFormSubscriptionStatusUpdateResult"],
	upsertJobFormSubscriptionStatus: ModelTypes["JobFormSubscriptionStatusUpsertResult"],
	createGeneralLocale: ModelTypes["GeneralLocaleCreateResult"],
	deleteGeneralLocale: ModelTypes["GeneralLocaleDeleteResult"],
	updateGeneralLocale: ModelTypes["GeneralLocaleUpdateResult"],
	upsertGeneralLocale: ModelTypes["GeneralLocaleUpsertResult"],
	createStickyBar: ModelTypes["StickyBarCreateResult"],
	deleteStickyBar: ModelTypes["StickyBarDeleteResult"],
	updateStickyBar: ModelTypes["StickyBarUpdateResult"],
	upsertStickyBar: ModelTypes["StickyBarUpsertResult"],
	createRecommendationForm: ModelTypes["RecommendationFormCreateResult"],
	deleteRecommendationForm: ModelTypes["RecommendationFormDeleteResult"],
	updateRecommendationForm: ModelTypes["RecommendationFormUpdateResult"],
	upsertRecommendationForm: ModelTypes["RecommendationFormUpsertResult"],
	createRecommendationFormLocale: ModelTypes["RecommendationFormLocaleCreateResult"],
	deleteRecommendationFormLocale: ModelTypes["RecommendationFormLocaleDeleteResult"],
	updateRecommendationFormLocale: ModelTypes["RecommendationFormLocaleUpdateResult"],
	upsertRecommendationFormLocale: ModelTypes["RecommendationFormLocaleUpsertResult"],
	createRecommendationFormSubscription: ModelTypes["RecommendationFormSubscriptionCreateResult"],
	deleteRecommendationFormSubscription: ModelTypes["RecommendationFormSubscriptionDeleteResult"],
	updateRecommendationFormSubscription: ModelTypes["RecommendationFormSubscriptionUpdateResult"],
	upsertRecommendationFormSubscription: ModelTypes["RecommendationFormSubscriptionUpsertResult"],
	createInfoBox: ModelTypes["InfoBoxCreateResult"],
	deleteInfoBox: ModelTypes["InfoBoxDeleteResult"],
	updateInfoBox: ModelTypes["InfoBoxUpdateResult"],
	upsertInfoBox: ModelTypes["InfoBoxUpsertResult"],
	createInfoBoxLocale: ModelTypes["InfoBoxLocaleCreateResult"],
	deleteInfoBoxLocale: ModelTypes["InfoBoxLocaleDeleteResult"],
	updateInfoBoxLocale: ModelTypes["InfoBoxLocaleUpdateResult"],
	upsertInfoBoxLocale: ModelTypes["InfoBoxLocaleUpsertResult"],
	createTranslation: ModelTypes["TranslationCreateResult"],
	deleteTranslation: ModelTypes["TranslationDeleteResult"],
	updateTranslation: ModelTypes["TranslationUpdateResult"],
	upsertTranslation: ModelTypes["TranslationUpsertResult"],
	createTranslationLocale: ModelTypes["TranslationLocaleCreateResult"],
	deleteTranslationLocale: ModelTypes["TranslationLocaleDeleteResult"],
	updateTranslationLocale: ModelTypes["TranslationLocaleUpdateResult"],
	upsertTranslationLocale: ModelTypes["TranslationLocaleUpsertResult"],
	createCornerBanner: ModelTypes["CornerBannerCreateResult"],
	deleteCornerBanner: ModelTypes["CornerBannerDeleteResult"],
	updateCornerBanner: ModelTypes["CornerBannerUpdateResult"],
	upsertCornerBanner: ModelTypes["CornerBannerUpsertResult"],
	query?: ModelTypes["Query"] | undefined
};
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?: boolean | undefined
}
    }

export type GraphQLTypes = {
    ["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string | undefined,
	defaultValue?: GraphQLTypes["Json"] | undefined,
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean | undefined,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"] | undefined,
	validator: number
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string | undefined
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
        	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
        	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"] | undefined
};
	/** Json custom scalar type */
["Json"]: "scalar" & { name: "Json" };
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string | undefined,
	inversedBy?: string | undefined,
	nullable?: boolean | undefined,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"] | undefined,
	orphanRemoval?: boolean | undefined,
	orderBy?: Array<GraphQLTypes["_OrderBy"]> | undefined,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_RelationSide"]: _RelationSide;
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_OrderByDirection"]: _OrderByDirection;
	["Query"]: {
	__typename: "Query",
	schema?: GraphQLTypes["_Schema"] | undefined,
	s3DummyQuery?: string | undefined,
	getGeneral?: GraphQLTypes["General"] | undefined,
	listGeneral: Array<GraphQLTypes["General"]>,
	paginateGeneral: GraphQLTypes["GeneralConnection"],
	validateCreateGeneral: GraphQLTypes["_ValidationResult"],
	validateUpdateGeneral: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"] | undefined,
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getGenericPage?: GraphQLTypes["GenericPage"] | undefined,
	listGenericPage: Array<GraphQLTypes["GenericPage"]>,
	paginateGenericPage: GraphQLTypes["GenericPageConnection"],
	validateCreateGenericPage: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPage: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"] | undefined,
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"] | undefined,
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"] | undefined,
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"] | undefined,
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"] | undefined,
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getContentReferenceLinkableItem?: GraphQLTypes["ContentReferenceLinkableItem"] | undefined,
	listContentReferenceLinkableItem: Array<GraphQLTypes["ContentReferenceLinkableItem"]>,
	paginateContentReferenceLinkableItem: GraphQLTypes["ContentReferenceLinkableItemConnection"],
	getRedirect?: GraphQLTypes["Redirect"] | undefined,
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"] | undefined,
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"] | undefined,
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterLink?: GraphQLTypes["FooterLink"] | undefined,
	listFooterLink: Array<GraphQLTypes["FooterLink"]>,
	paginateFooterLink: GraphQLTypes["FooterLinkConnection"],
	validateCreateFooterLink: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLink: GraphQLTypes["_ValidationResult"],
	getFooterLocale?: GraphQLTypes["FooterLocale"] | undefined,
	listFooterLocale: Array<GraphQLTypes["FooterLocale"]>,
	paginateFooterLocale: GraphQLTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLocale: GraphQLTypes["_ValidationResult"],
	getGenericPageLocale?: GraphQLTypes["GenericPageLocale"] | undefined,
	listGenericPageLocale: Array<GraphQLTypes["GenericPageLocale"]>,
	paginateGenericPageLocale: GraphQLTypes["GenericPageLocaleConnection"],
	validateCreateGenericPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPageLocale: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"] | undefined,
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHeaderLocale?: GraphQLTypes["HeaderLocale"] | undefined,
	listHeaderLocale: Array<GraphQLTypes["HeaderLocale"]>,
	paginateHeaderLocale: GraphQLTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLocale: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"] | undefined,
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getSeoDefault?: GraphQLTypes["SeoDefault"] | undefined,
	listSeoDefault: Array<GraphQLTypes["SeoDefault"]>,
	paginateSeoDefault: GraphQLTypes["SeoDefaultConnection"],
	validateCreateSeoDefault: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoDefault: GraphQLTypes["_ValidationResult"],
	getSeoDefaultLocale?: GraphQLTypes["SeoDefaultLocale"] | undefined,
	listSeoDefaultLocale: Array<GraphQLTypes["SeoDefaultLocale"]>,
	paginateSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleConnection"],
	validateCreateSeoDefaultLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoDefaultLocale: GraphQLTypes["_ValidationResult"],
	getBusiness?: GraphQLTypes["Business"] | undefined,
	listBusiness: Array<GraphQLTypes["Business"]>,
	paginateBusiness: GraphQLTypes["BusinessConnection"],
	validateCreateBusiness: GraphQLTypes["_ValidationResult"],
	validateUpdateBusiness: GraphQLTypes["_ValidationResult"],
	getBusinessPage?: GraphQLTypes["BusinessPage"] | undefined,
	listBusinessPage: Array<GraphQLTypes["BusinessPage"]>,
	paginateBusinessPage: GraphQLTypes["BusinessPageConnection"],
	validateCreateBusinessPage: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessPage: GraphQLTypes["_ValidationResult"],
	getBusinessPageLocale?: GraphQLTypes["BusinessPageLocale"] | undefined,
	listBusinessPageLocale: Array<GraphQLTypes["BusinessPageLocale"]>,
	paginateBusinessPageLocale: GraphQLTypes["BusinessPageLocaleConnection"],
	validateCreateBusinessPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessPageLocale: GraphQLTypes["_ValidationResult"],
	getIcon?: GraphQLTypes["Icon"] | undefined,
	listIcon: Array<GraphQLTypes["Icon"]>,
	paginateIcon: GraphQLTypes["IconConnection"],
	validateCreateIcon: GraphQLTypes["_ValidationResult"],
	validateUpdateIcon: GraphQLTypes["_ValidationResult"],
	getJobPage?: GraphQLTypes["JobPage"] | undefined,
	listJobPage: Array<GraphQLTypes["JobPage"]>,
	paginateJobPage: GraphQLTypes["JobPageConnection"],
	validateCreateJobPage: GraphQLTypes["_ValidationResult"],
	validateUpdateJobPage: GraphQLTypes["_ValidationResult"],
	getJobPageLocale?: GraphQLTypes["JobPageLocale"] | undefined,
	listJobPageLocale: Array<GraphQLTypes["JobPageLocale"]>,
	paginateJobPageLocale: GraphQLTypes["JobPageLocaleConnection"],
	validateCreateJobPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateJobPageLocale: GraphQLTypes["_ValidationResult"],
	getKeyInfoItem?: GraphQLTypes["KeyInfoItem"] | undefined,
	listKeyInfoItem: Array<GraphQLTypes["KeyInfoItem"]>,
	paginateKeyInfoItem: GraphQLTypes["KeyInfoItemConnection"],
	validateCreateKeyInfoItem: GraphQLTypes["_ValidationResult"],
	validateUpdateKeyInfoItem: GraphQLTypes["_ValidationResult"],
	getKeyInfoList?: GraphQLTypes["KeyInfoList"] | undefined,
	listKeyInfoList: Array<GraphQLTypes["KeyInfoList"]>,
	paginateKeyInfoList: GraphQLTypes["KeyInfoListConnection"],
	validateCreateKeyInfoList: GraphQLTypes["_ValidationResult"],
	validateUpdateKeyInfoList: GraphQLTypes["_ValidationResult"],
	getContractType?: GraphQLTypes["ContractType"] | undefined,
	listContractType: Array<GraphQLTypes["ContractType"]>,
	paginateContractType: GraphQLTypes["ContractTypeConnection"],
	validateCreateContractType: GraphQLTypes["_ValidationResult"],
	validateUpdateContractType: GraphQLTypes["_ValidationResult"],
	getContractTypeLocale?: GraphQLTypes["ContractTypeLocale"] | undefined,
	listContractTypeLocale: Array<GraphQLTypes["ContractTypeLocale"]>,
	paginateContractTypeLocale: GraphQLTypes["ContractTypeLocaleConnection"],
	validateCreateContractTypeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateContractTypeLocale: GraphQLTypes["_ValidationResult"],
	getJobCity?: GraphQLTypes["JobCity"] | undefined,
	listJobCity: Array<GraphQLTypes["JobCity"]>,
	paginateJobCity: GraphQLTypes["JobCityConnection"],
	validateCreateJobCity: GraphQLTypes["_ValidationResult"],
	validateUpdateJobCity: GraphQLTypes["_ValidationResult"],
	getJobCityLocale?: GraphQLTypes["JobCityLocale"] | undefined,
	listJobCityLocale: Array<GraphQLTypes["JobCityLocale"]>,
	paginateJobCityLocale: GraphQLTypes["JobCityLocaleConnection"],
	validateCreateJobCityLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateJobCityLocale: GraphQLTypes["_ValidationResult"],
	getJobPosition?: GraphQLTypes["JobPosition"] | undefined,
	listJobPosition: Array<GraphQLTypes["JobPosition"]>,
	paginateJobPosition: GraphQLTypes["JobPositionConnection"],
	validateCreateJobPosition: GraphQLTypes["_ValidationResult"],
	validateUpdateJobPosition: GraphQLTypes["_ValidationResult"],
	getJobPositionLocale?: GraphQLTypes["JobPositionLocale"] | undefined,
	listJobPositionLocale: Array<GraphQLTypes["JobPositionLocale"]>,
	paginateJobPositionLocale: GraphQLTypes["JobPositionLocaleConnection"],
	validateCreateJobPositionLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateJobPositionLocale: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"] | undefined,
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"] | undefined,
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getHomePageLocale?: GraphQLTypes["HomePageLocale"] | undefined,
	listHomePageLocale: Array<GraphQLTypes["HomePageLocale"]>,
	paginateHomePageLocale: GraphQLTypes["HomePageLocaleConnection"],
	validateCreateHomePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePageLocale: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"] | undefined,
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getMediumItem?: GraphQLTypes["MediumItem"] | undefined,
	listMediumItem: Array<GraphQLTypes["MediumItem"]>,
	paginateMediumItem: GraphQLTypes["MediumItemConnection"],
	validateCreateMediumItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumItem: GraphQLTypes["_ValidationResult"],
	getMediumList?: GraphQLTypes["MediumList"] | undefined,
	listMediumList: Array<GraphQLTypes["MediumList"]>,
	paginateMediumList: GraphQLTypes["MediumListConnection"],
	validateCreateMediumList: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumList: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"] | undefined,
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getTextItem?: GraphQLTypes["TextItem"] | undefined,
	listTextItem: Array<GraphQLTypes["TextItem"]>,
	paginateTextItem: GraphQLTypes["TextItemConnection"],
	validateCreateTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTextItem: GraphQLTypes["_ValidationResult"],
	getTextList?: GraphQLTypes["TextList"] | undefined,
	listTextList: Array<GraphQLTypes["TextList"]>,
	paginateTextList: GraphQLTypes["TextListConnection"],
	validateCreateTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateTextList: GraphQLTypes["_ValidationResult"],
	getCarousel?: GraphQLTypes["Carousel"] | undefined,
	listCarousel: Array<GraphQLTypes["Carousel"]>,
	paginateCarousel: GraphQLTypes["CarouselConnection"],
	validateCreateCarousel: GraphQLTypes["_ValidationResult"],
	validateUpdateCarousel: GraphQLTypes["_ValidationResult"],
	getCarouselItem?: GraphQLTypes["CarouselItem"] | undefined,
	listCarouselItem: Array<GraphQLTypes["CarouselItem"]>,
	paginateCarouselItem: GraphQLTypes["CarouselItemConnection"],
	validateCreateCarouselItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCarouselItem: GraphQLTypes["_ValidationResult"],
	getTheme?: GraphQLTypes["Theme"] | undefined,
	listTheme: Array<GraphQLTypes["Theme"]>,
	paginateTheme: GraphQLTypes["ThemeConnection"],
	validateCreateTheme: GraphQLTypes["_ValidationResult"],
	validateUpdateTheme: GraphQLTypes["_ValidationResult"],
	getBonusBanner?: GraphQLTypes["BonusBanner"] | undefined,
	listBonusBanner: Array<GraphQLTypes["BonusBanner"]>,
	paginateBonusBanner: GraphQLTypes["BonusBannerConnection"],
	validateCreateBonusBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateBonusBanner: GraphQLTypes["_ValidationResult"],
	getBonusBannerLocale?: GraphQLTypes["BonusBannerLocale"] | undefined,
	listBonusBannerLocale: Array<GraphQLTypes["BonusBannerLocale"]>,
	paginateBonusBannerLocale: GraphQLTypes["BonusBannerLocaleConnection"],
	validateCreateBonusBannerLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBonusBannerLocale: GraphQLTypes["_ValidationResult"],
	getTile?: GraphQLTypes["Tile"] | undefined,
	listTile: Array<GraphQLTypes["Tile"]>,
	paginateTile: GraphQLTypes["TileConnection"],
	validateCreateTile: GraphQLTypes["_ValidationResult"],
	validateUpdateTile: GraphQLTypes["_ValidationResult"],
	getSideBySide?: GraphQLTypes["SideBySide"] | undefined,
	listSideBySide: Array<GraphQLTypes["SideBySide"]>,
	paginateSideBySide: GraphQLTypes["SideBySideConnection"],
	validateCreateSideBySide: GraphQLTypes["_ValidationResult"],
	validateUpdateSideBySide: GraphQLTypes["_ValidationResult"],
	getSideBySideItem?: GraphQLTypes["SideBySideItem"] | undefined,
	listSideBySideItem: Array<GraphQLTypes["SideBySideItem"]>,
	paginateSideBySideItem: GraphQLTypes["SideBySideItemConnection"],
	validateCreateSideBySideItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSideBySideItem: GraphQLTypes["_ValidationResult"],
	getHomePageLokal?: GraphQLTypes["HomePageLokal"] | undefined,
	listHomePageLokal: Array<GraphQLTypes["HomePageLokal"]>,
	paginateHomePageLokal: GraphQLTypes["HomePageLokalConnection"],
	validateCreateHomePageLokal: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePageLokal: GraphQLTypes["_ValidationResult"],
	getHomePageLokalLocale?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	listHomePageLokalLocale: Array<GraphQLTypes["HomePageLokalLocale"]>,
	paginateHomePageLokalLocale: GraphQLTypes["HomePageLokalLocaleConnection"],
	validateCreateHomePageLokalLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePageLokalLocale: GraphQLTypes["_ValidationResult"],
	getSiteSwitcher?: GraphQLTypes["SiteSwitcher"] | undefined,
	listSiteSwitcher: Array<GraphQLTypes["SiteSwitcher"]>,
	paginateSiteSwitcher: GraphQLTypes["SiteSwitcherConnection"],
	validateCreateSiteSwitcher: GraphQLTypes["_ValidationResult"],
	validateUpdateSiteSwitcher: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"] | undefined,
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getJobsForm?: GraphQLTypes["JobsForm"] | undefined,
	listJobsForm: Array<GraphQLTypes["JobsForm"]>,
	paginateJobsForm: GraphQLTypes["JobsFormConnection"],
	validateCreateJobsForm: GraphQLTypes["_ValidationResult"],
	validateUpdateJobsForm: GraphQLTypes["_ValidationResult"],
	getJobsFormLocale?: GraphQLTypes["JobsFormLocale"] | undefined,
	listJobsFormLocale: Array<GraphQLTypes["JobsFormLocale"]>,
	paginateJobsFormLocale: GraphQLTypes["JobsFormLocaleConnection"],
	validateCreateJobsFormLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateJobsFormLocale: GraphQLTypes["_ValidationResult"],
	getImageTextItem?: GraphQLTypes["ImageTextItem"] | undefined,
	listImageTextItem: Array<GraphQLTypes["ImageTextItem"]>,
	paginateImageTextItem: GraphQLTypes["ImageTextItemConnection"],
	validateCreateImageTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageTextItem: GraphQLTypes["_ValidationResult"],
	getImageTextList?: GraphQLTypes["ImageTextList"] | undefined,
	listImageTextList: Array<GraphQLTypes["ImageTextList"]>,
	paginateImageTextList: GraphQLTypes["ImageTextListConnection"],
	validateCreateImageTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageTextList: GraphQLTypes["_ValidationResult"],
	getJobsFilter?: GraphQLTypes["JobsFilter"] | undefined,
	listJobsFilter: Array<GraphQLTypes["JobsFilter"]>,
	paginateJobsFilter: GraphQLTypes["JobsFilterConnection"],
	validateCreateJobsFilter: GraphQLTypes["_ValidationResult"],
	validateUpdateJobsFilter: GraphQLTypes["_ValidationResult"],
	getJobsFilterLocale?: GraphQLTypes["JobsFilterLocale"] | undefined,
	listJobsFilterLocale: Array<GraphQLTypes["JobsFilterLocale"]>,
	paginateJobsFilterLocale: GraphQLTypes["JobsFilterLocaleConnection"],
	validateCreateJobsFilterLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateJobsFilterLocale: GraphQLTypes["_ValidationResult"],
	getFile?: GraphQLTypes["File"] | undefined,
	listFile: Array<GraphQLTypes["File"]>,
	paginateFile: GraphQLTypes["FileConnection"],
	validateCreateFile: GraphQLTypes["_ValidationResult"],
	validateUpdateFile: GraphQLTypes["_ValidationResult"],
	getJobFormSubscription?: GraphQLTypes["JobFormSubscription"] | undefined,
	listJobFormSubscription: Array<GraphQLTypes["JobFormSubscription"]>,
	paginateJobFormSubscription: GraphQLTypes["JobFormSubscriptionConnection"],
	validateCreateJobFormSubscription: GraphQLTypes["_ValidationResult"],
	validateUpdateJobFormSubscription: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"] | undefined,
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageListItem?: GraphQLTypes["ImageListItem"] | undefined,
	listImageListItem: Array<GraphQLTypes["ImageListItem"]>,
	paginateImageListItem: GraphQLTypes["ImageListItemConnection"],
	validateCreateImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageListItem: GraphQLTypes["_ValidationResult"],
	getJobFormSubscriptionStatus?: GraphQLTypes["JobFormSubscriptionStatus"] | undefined,
	listJobFormSubscriptionStatus: Array<GraphQLTypes["JobFormSubscriptionStatus"]>,
	paginateJobFormSubscriptionStatus: GraphQLTypes["JobFormSubscriptionStatusConnection"],
	validateCreateJobFormSubscriptionStatus: GraphQLTypes["_ValidationResult"],
	validateUpdateJobFormSubscriptionStatus: GraphQLTypes["_ValidationResult"],
	getGeneralLocale?: GraphQLTypes["GeneralLocale"] | undefined,
	listGeneralLocale: Array<GraphQLTypes["GeneralLocale"]>,
	paginateGeneralLocale: GraphQLTypes["GeneralLocaleConnection"],
	validateCreateGeneralLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGeneralLocale: GraphQLTypes["_ValidationResult"],
	getStickyBar?: GraphQLTypes["StickyBar"] | undefined,
	listStickyBar: Array<GraphQLTypes["StickyBar"]>,
	paginateStickyBar: GraphQLTypes["StickyBarConnection"],
	validateCreateStickyBar: GraphQLTypes["_ValidationResult"],
	validateUpdateStickyBar: GraphQLTypes["_ValidationResult"],
	getRecommendationForm?: GraphQLTypes["RecommendationForm"] | undefined,
	listRecommendationForm: Array<GraphQLTypes["RecommendationForm"]>,
	paginateRecommendationForm: GraphQLTypes["RecommendationFormConnection"],
	validateCreateRecommendationForm: GraphQLTypes["_ValidationResult"],
	validateUpdateRecommendationForm: GraphQLTypes["_ValidationResult"],
	getRecommendationFormLocale?: GraphQLTypes["RecommendationFormLocale"] | undefined,
	listRecommendationFormLocale: Array<GraphQLTypes["RecommendationFormLocale"]>,
	paginateRecommendationFormLocale: GraphQLTypes["RecommendationFormLocaleConnection"],
	validateCreateRecommendationFormLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateRecommendationFormLocale: GraphQLTypes["_ValidationResult"],
	getRecommendationFormSubscription?: GraphQLTypes["RecommendationFormSubscription"] | undefined,
	listRecommendationFormSubscription: Array<GraphQLTypes["RecommendationFormSubscription"]>,
	paginateRecommendationFormSubscription: GraphQLTypes["RecommendationFormSubscriptionConnection"],
	validateCreateRecommendationFormSubscription: GraphQLTypes["_ValidationResult"],
	validateUpdateRecommendationFormSubscription: GraphQLTypes["_ValidationResult"],
	getInfoBox?: GraphQLTypes["InfoBox"] | undefined,
	listInfoBox: Array<GraphQLTypes["InfoBox"]>,
	paginateInfoBox: GraphQLTypes["InfoBoxConnection"],
	validateCreateInfoBox: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoBox: GraphQLTypes["_ValidationResult"],
	getInfoBoxLocale?: GraphQLTypes["InfoBoxLocale"] | undefined,
	listInfoBoxLocale: Array<GraphQLTypes["InfoBoxLocale"]>,
	paginateInfoBoxLocale: GraphQLTypes["InfoBoxLocaleConnection"],
	validateCreateInfoBoxLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoBoxLocale: GraphQLTypes["_ValidationResult"],
	getTranslation?: GraphQLTypes["Translation"] | undefined,
	listTranslation: Array<GraphQLTypes["Translation"]>,
	paginateTranslation: GraphQLTypes["TranslationConnection"],
	validateCreateTranslation: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslation: GraphQLTypes["_ValidationResult"],
	getTranslationLocale?: GraphQLTypes["TranslationLocale"] | undefined,
	listTranslationLocale: Array<GraphQLTypes["TranslationLocale"]>,
	paginateTranslationLocale: GraphQLTypes["TranslationLocaleConnection"],
	validateCreateTranslationLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationLocale: GraphQLTypes["_ValidationResult"],
	getCornerBanner?: GraphQLTypes["CornerBanner"] | undefined,
	listCornerBanner: Array<GraphQLTypes["CornerBanner"]>,
	paginateCornerBanner: GraphQLTypes["CornerBannerConnection"],
	validateCreateCornerBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateCornerBanner: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"] | undefined,
	_info?: GraphQLTypes["Info"] | undefined
};
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["General"]: {
	__typename: "General",
	_meta?: GraphQLTypes["GeneralMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["GeneralLocale"]>,
	localesByLocale?: GraphQLTypes["GeneralLocale"] | undefined,
	localesBySeo?: GraphQLTypes["GeneralLocale"] | undefined,
	localesByCornerBanner?: GraphQLTypes["GeneralLocale"] | undefined,
	paginateLocales: GraphQLTypes["GeneralLocaleConnection"]
};
	["GeneralMeta"]: {
	__typename: "GeneralMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean | undefined,
	updatable?: boolean | undefined
};
	["UUID"]: "scalar" & { name: "UUID" };
	["One"]: One;
	["GeneralLocale"]: {
	__typename: "GeneralLocale",
	_meta?: GraphQLTypes["GeneralLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["General"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	cornerBanner?: GraphQLTypes["CornerBanner"] | undefined
};
	["GeneralLocaleMeta"]: {
	__typename: "GeneralLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	cornerBanner?: GraphQLTypes["FieldMeta"] | undefined
};
	["GeneralWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["GeneralLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["GeneralWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GeneralWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GeneralWhere"] | undefined
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]> | undefined,
	or?: Array<GraphQLTypes["UUIDCondition"]> | undefined,
	not?: GraphQLTypes["UUIDCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["UUID"] | undefined,
	notEq?: GraphQLTypes["UUID"] | undefined,
	in?: Array<GraphQLTypes["UUID"]> | undefined,
	notIn?: Array<GraphQLTypes["UUID"]> | undefined,
	lt?: GraphQLTypes["UUID"] | undefined,
	lte?: GraphQLTypes["UUID"] | undefined,
	gt?: GraphQLTypes["UUID"] | undefined,
	gte?: GraphQLTypes["UUID"] | undefined
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]> | undefined,
	or?: Array<GraphQLTypes["OneCondition"]> | undefined,
	not?: GraphQLTypes["OneCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["One"] | undefined,
	notEq?: GraphQLTypes["One"] | undefined,
	in?: Array<GraphQLTypes["One"]> | undefined,
	notIn?: Array<GraphQLTypes["One"]> | undefined,
	lt?: GraphQLTypes["One"] | undefined,
	lte?: GraphQLTypes["One"] | undefined,
	gt?: GraphQLTypes["One"] | undefined,
	gte?: GraphQLTypes["One"] | undefined
};
	["GeneralLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["GeneralWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	cornerBanner?: GraphQLTypes["CornerBannerWhere"] | undefined,
	and?: Array<GraphQLTypes["GeneralLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GeneralLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GeneralLocaleWhere"] | undefined
};
	["LocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	label?: GraphQLTypes["StringCondition"] | undefined,
	footers?: GraphQLTypes["FooterLocaleWhere"] | undefined,
	genericPages?: GraphQLTypes["GenericPageLocaleWhere"] | undefined,
	headers?: GraphQLTypes["HeaderLocaleWhere"] | undefined,
	seoDefaults?: GraphQLTypes["SeoDefaultLocaleWhere"] | undefined,
	businessPages?: GraphQLTypes["BusinessPageLocaleWhere"] | undefined,
	jobPages?: GraphQLTypes["JobPageLocaleWhere"] | undefined,
	contractTypes?: GraphQLTypes["ContractTypeLocaleWhere"] | undefined,
	jobCities?: GraphQLTypes["JobCityLocaleWhere"] | undefined,
	jobPositions?: GraphQLTypes["JobPositionLocaleWhere"] | undefined,
	homePages?: GraphQLTypes["HomePageLocaleWhere"] | undefined,
	bonusBanners?: GraphQLTypes["BonusBannerLocaleWhere"] | undefined,
	homePageLokals?: GraphQLTypes["HomePageLokalLocaleWhere"] | undefined,
	jobsForms?: GraphQLTypes["JobsFormLocaleWhere"] | undefined,
	jobsFilters?: GraphQLTypes["JobsFilterLocaleWhere"] | undefined,
	general?: GraphQLTypes["GeneralLocaleWhere"] | undefined,
	recommendationForms?: GraphQLTypes["RecommendationFormLocaleWhere"] | undefined,
	infoBoxes?: GraphQLTypes["InfoBoxLocaleWhere"] | undefined,
	translations?: GraphQLTypes["TranslationLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["LocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LocaleWhere"] | undefined
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]> | undefined,
	or?: Array<GraphQLTypes["StringCondition"]> | undefined,
	not?: GraphQLTypes["StringCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: string | undefined,
	notEq?: string | undefined,
	in?: Array<string> | undefined,
	notIn?: Array<string> | undefined,
	lt?: string | undefined,
	lte?: string | undefined,
	gt?: string | undefined,
	gte?: string | undefined,
	contains?: string | undefined,
	startsWith?: string | undefined,
	endsWith?: string | undefined,
	containsCI?: string | undefined,
	startsWithCI?: string | undefined,
	endsWithCI?: string | undefined
};
	["FooterLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	address?: GraphQLTypes["StringCondition"] | undefined,
	ico?: GraphQLTypes["StringCondition"] | undefined,
	dic?: GraphQLTypes["StringCondition"] | undefined,
	copyright?: GraphQLTypes["StringCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	noteSecond?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["FooterWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	linksFirstColumn?: GraphQLTypes["FooterLinkWhere"] | undefined,
	linksSecondColumn?: GraphQLTypes["FooterLinkWhere"] | undefined,
	termsAndConditions?: GraphQLTypes["LinkWhere"] | undefined,
	form?: GraphQLTypes["StringCondition"] | undefined,
	bannerTitle?: GraphQLTypes["StringCondition"] | undefined,
	bannerSubtitle?: GraphQLTypes["StringCondition"] | undefined,
	bannerImage?: GraphQLTypes["ImageWhere"] | undefined,
	bannerLink?: GraphQLTypes["LinkWhere"] | undefined,
	jobsForm?: GraphQLTypes["JobsFormLocaleWhere"] | undefined,
	copyrightLink?: GraphQLTypes["LinkWhere"] | undefined,
	bannerSecondBtn?: GraphQLTypes["StringCondition"] | undefined,
	recommendationForm?: GraphQLTypes["RecommendationFormLocaleWhere"] | undefined,
	bannerSecondLink?: GraphQLTypes["LinkWhere"] | undefined,
	instagramLink?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["FooterLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FooterLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FooterLocaleWhere"] | undefined
};
	["FooterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["FooterLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["FooterWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FooterWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FooterWhere"] | undefined
};
	["FooterLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["FooterLinkWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FooterLinkWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FooterLinkWhere"] | undefined
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]> | undefined,
	or?: Array<GraphQLTypes["IntCondition"]> | undefined,
	not?: GraphQLTypes["IntCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: number | undefined,
	notEq?: number | undefined,
	in?: Array<number> | undefined,
	notIn?: Array<number> | undefined,
	lt?: number | undefined,
	lte?: number | undefined,
	gt?: number | undefined,
	gte?: number | undefined
};
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["LinkTypeCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	externalLink?: GraphQLTypes["StringCondition"] | undefined,
	internalLink?: GraphQLTypes["LinkableWhere"] | undefined,
	anchorLink?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["LinkWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LinkWhere"] | undefined
};
	["LinkTypeCondition"]: {
		and?: Array<GraphQLTypes["LinkTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["LinkTypeCondition"]> | undefined,
	not?: GraphQLTypes["LinkTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["LinkType"] | undefined,
	notEq?: GraphQLTypes["LinkType"] | undefined,
	in?: Array<GraphQLTypes["LinkType"]> | undefined,
	notIn?: Array<GraphQLTypes["LinkType"]> | undefined,
	lt?: GraphQLTypes["LinkType"] | undefined,
	lte?: GraphQLTypes["LinkType"] | undefined,
	gt?: GraphQLTypes["LinkType"] | undefined,
	gte?: GraphQLTypes["LinkType"] | undefined
};
	["LinkType"]: LinkType;
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	redirect?: GraphQLTypes["RedirectWhere"] | undefined,
	genericPage?: GraphQLTypes["GenericPageLocaleWhere"] | undefined,
	businessPage?: GraphQLTypes["BusinessPageLocaleWhere"] | undefined,
	jobPage?: GraphQLTypes["JobPageLocaleWhere"] | undefined,
	homePage?: GraphQLTypes["HomePageLocaleWhere"] | undefined,
	homePageLokal?: GraphQLTypes["HomePageLokalLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LinkableWhere"] | undefined
};
	["RedirectWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	target?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["RedirectWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RedirectWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RedirectWhere"] | undefined
};
	["GenericPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["GenericPageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["GenericPageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GenericPageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GenericPageLocaleWhere"] | undefined
};
	["GenericPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locales?: GraphQLTypes["GenericPageLocaleWhere"] | undefined,
	theme?: GraphQLTypes["ThemeWhere"] | undefined,
	headerColor?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["GenericPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GenericPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GenericPageWhere"] | undefined
};
	["ThemeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	backgroundColor?: GraphQLTypes["StringCondition"] | undefined,
	textColor?: GraphQLTypes["StringCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	buttonBackgroundColor?: GraphQLTypes["StringCondition"] | undefined,
	buttonTextColor?: GraphQLTypes["StringCondition"] | undefined,
	buttonBackgroundHoverColor?: GraphQLTypes["StringCondition"] | undefined,
	buttonTextHoverColor?: GraphQLTypes["StringCondition"] | undefined,
	buttonBorderColor?: GraphQLTypes["StringCondition"] | undefined,
	buttonBorderHoverColor?: GraphQLTypes["StringCondition"] | undefined,
	headerMenuColor?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ThemeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ThemeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ThemeWhere"] | undefined
};
	["ContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	blocks?: GraphQLTypes["ContentBlockWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentWhere"] | undefined
};
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	json?: GraphQLTypes["StringCondition"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	references?: GraphQLTypes["ContentReferenceWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentBlockWhere"] | undefined
};
	["ContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["ContentReferenceTypeCondition"] | undefined,
	primaryText?: GraphQLTypes["StringCondition"] | undefined,
	block?: GraphQLTypes["ContentBlockWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	linkables?: GraphQLTypes["ContentReferenceLinkableItemWhere"] | undefined,
	secondaryText?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	media?: GraphQLTypes["MediumListWhere"] | undefined,
	textList?: GraphQLTypes["TextListWhere"] | undefined,
	carousel?: GraphQLTypes["CarouselWhere"] | undefined,
	bonusBanner?: GraphQLTypes["BonusBannerLocaleWhere"] | undefined,
	sideBySide?: GraphQLTypes["SideBySideWhere"] | undefined,
	gallery?: GraphQLTypes["GalleryWhere"] | undefined,
	showBoolean?: GraphQLTypes["BooleanCondition"] | undefined,
	isRed?: GraphQLTypes["BooleanCondition"] | undefined,
	video?: GraphQLTypes["VideoWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentReferenceWhere"] | undefined
};
	["ContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ContentReferenceTypeCondition"]> | undefined,
	not?: GraphQLTypes["ContentReferenceTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ContentReferenceType"] | undefined,
	notEq?: GraphQLTypes["ContentReferenceType"] | undefined,
	in?: Array<GraphQLTypes["ContentReferenceType"]> | undefined,
	notIn?: Array<GraphQLTypes["ContentReferenceType"]> | undefined,
	lt?: GraphQLTypes["ContentReferenceType"] | undefined,
	lte?: GraphQLTypes["ContentReferenceType"] | undefined,
	gt?: GraphQLTypes["ContentReferenceType"] | undefined,
	gte?: GraphQLTypes["ContentReferenceType"] | undefined
};
	["ContentReferenceType"]: ContentReferenceType;
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	width?: GraphQLTypes["IntCondition"] | undefined,
	height?: GraphQLTypes["IntCondition"] | undefined,
	size?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	alt?: GraphQLTypes["StringCondition"] | undefined,
	fileName?: GraphQLTypes["StringCondition"] | undefined,
	focalPointX?: GraphQLTypes["FloatCondition"] | undefined,
	focalPointY?: GraphQLTypes["FloatCondition"] | undefined,
	and?: Array<GraphQLTypes["ImageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageWhere"] | undefined
};
	["FloatCondition"]: {
		and?: Array<GraphQLTypes["FloatCondition"]> | undefined,
	or?: Array<GraphQLTypes["FloatCondition"]> | undefined,
	not?: GraphQLTypes["FloatCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: number | undefined,
	notEq?: number | undefined,
	in?: Array<number> | undefined,
	notIn?: Array<number> | undefined,
	lt?: number | undefined,
	lte?: number | undefined,
	gt?: number | undefined,
	gte?: number | undefined
};
	["ContentReferenceLinkableItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	item?: GraphQLTypes["LinkableWhere"] | undefined,
	reference?: GraphQLTypes["ContentReferenceWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentReferenceLinkableItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentReferenceLinkableItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentReferenceLinkableItemWhere"] | undefined
};
	["MediumListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["MediumItemWhere"] | undefined,
	and?: Array<GraphQLTypes["MediumListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MediumListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MediumListWhere"] | undefined
};
	["MediumItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["MediumListWhere"] | undefined,
	medium?: GraphQLTypes["MediumWhere"] | undefined,
	and?: Array<GraphQLTypes["MediumItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MediumItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MediumItemWhere"] | undefined
};
	["MediumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["MediumTypeCondition"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	video?: GraphQLTypes["VideoWhere"] | undefined,
	and?: Array<GraphQLTypes["MediumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MediumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MediumWhere"] | undefined
};
	["MediumTypeCondition"]: {
		and?: Array<GraphQLTypes["MediumTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["MediumTypeCondition"]> | undefined,
	not?: GraphQLTypes["MediumTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["MediumType"] | undefined,
	notEq?: GraphQLTypes["MediumType"] | undefined,
	in?: Array<GraphQLTypes["MediumType"]> | undefined,
	notIn?: Array<GraphQLTypes["MediumType"]> | undefined,
	lt?: GraphQLTypes["MediumType"] | undefined,
	lte?: GraphQLTypes["MediumType"] | undefined,
	gt?: GraphQLTypes["MediumType"] | undefined,
	gte?: GraphQLTypes["MediumType"] | undefined
};
	["MediumType"]: MediumType;
	["VideoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	src?: GraphQLTypes["StringCondition"] | undefined,
	width?: GraphQLTypes["IntCondition"] | undefined,
	height?: GraphQLTypes["IntCondition"] | undefined,
	size?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	videoInfo?: GraphQLTypes["StringCondition"] | undefined,
	duration?: GraphQLTypes["FloatCondition"] | undefined,
	poster?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["VideoWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["VideoWhere"] | undefined> | undefined,
	not?: GraphQLTypes["VideoWhere"] | undefined
};
	["TextListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["TextItemWhere"] | undefined,
	and?: Array<GraphQLTypes["TextListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TextListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TextListWhere"] | undefined
};
	["TextItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["TextListWhere"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["TextItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TextItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TextItemWhere"] | undefined
};
	["CarouselWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["CarouselItemWhere"] | undefined,
	background?: GraphQLTypes["BackgroundCondition"] | undefined,
	squareImages?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["CarouselWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CarouselWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CarouselWhere"] | undefined
};
	["CarouselItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["CarouselWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	linkUrl?: GraphQLTypes["LinkWhere"] | undefined,
	normalAspectRatio?: GraphQLTypes["BooleanCondition"] | undefined,
	isImage?: GraphQLTypes["BooleanCondition"] | undefined,
	video?: GraphQLTypes["VideoWhere"] | undefined,
	and?: Array<GraphQLTypes["CarouselItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CarouselItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CarouselItemWhere"] | undefined
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]> | undefined,
	or?: Array<GraphQLTypes["BooleanCondition"]> | undefined,
	not?: GraphQLTypes["BooleanCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: boolean | undefined,
	notEq?: boolean | undefined,
	in?: Array<boolean> | undefined,
	notIn?: Array<boolean> | undefined,
	lt?: boolean | undefined,
	lte?: boolean | undefined,
	gt?: boolean | undefined,
	gte?: boolean | undefined
};
	["BackgroundCondition"]: {
		and?: Array<GraphQLTypes["BackgroundCondition"]> | undefined,
	or?: Array<GraphQLTypes["BackgroundCondition"]> | undefined,
	not?: GraphQLTypes["BackgroundCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["Background"] | undefined,
	notEq?: GraphQLTypes["Background"] | undefined,
	in?: Array<GraphQLTypes["Background"]> | undefined,
	notIn?: Array<GraphQLTypes["Background"]> | undefined,
	lt?: GraphQLTypes["Background"] | undefined,
	lte?: GraphQLTypes["Background"] | undefined,
	gt?: GraphQLTypes["Background"] | undefined,
	gte?: GraphQLTypes["Background"] | undefined
};
	["Background"]: Background;
	["BonusBannerLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["BonusBannerWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	tiles?: GraphQLTypes["TileWhere"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	bannerName?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["BonusBannerLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BonusBannerLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BonusBannerLocaleWhere"] | undefined
};
	["BonusBannerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locales?: GraphQLTypes["BonusBannerLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["BonusBannerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BonusBannerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BonusBannerWhere"] | undefined
};
	["TileWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	bonusBanner?: GraphQLTypes["BonusBannerLocaleWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	lightBoxTitle?: GraphQLTypes["StringCondition"] | undefined,
	lightBoxText?: GraphQLTypes["StringCondition"] | undefined,
	ligthBoxMedia?: GraphQLTypes["MediumListWhere"] | undefined,
	lightBoxSectionTitle?: GraphQLTypes["StringCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	lightBoxLinkLabel?: GraphQLTypes["StringCondition"] | undefined,
	lightBoxForm?: GraphQLTypes["JobsFormLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["TileWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TileWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TileWhere"] | undefined
};
	["JobsFormLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	jobText?: GraphQLTypes["StringCondition"] | undefined,
	genericText?: GraphQLTypes["StringCondition"] | undefined,
	nameLabel?: GraphQLTypes["StringCondition"] | undefined,
	emailLabel?: GraphQLTypes["StringCondition"] | undefined,
	telefonLabel?: GraphQLTypes["StringCondition"] | undefined,
	fileTitleLabel?: GraphQLTypes["StringCondition"] | undefined,
	fileFormatLabel?: GraphQLTypes["StringCondition"] | undefined,
	formTextLabel?: GraphQLTypes["StringCondition"] | undefined,
	submitLabel?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["JobsFormWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	imageTextList?: GraphQLTypes["ImageTextListWhere"] | undefined,
	minimalize?: GraphQLTypes["StringCondition"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	successTitle?: GraphQLTypes["StringCondition"] | undefined,
	successText?: GraphQLTypes["StringCondition"] | undefined,
	successBtnLabel?: GraphQLTypes["StringCondition"] | undefined,
	successImage?: GraphQLTypes["ImageWhere"] | undefined,
	successOtherJobsTitle?: GraphQLTypes["StringCondition"] | undefined,
	successOtherJobsCategoryTitle?: GraphQLTypes["StringCondition"] | undefined,
	successOtherJobsButtonTitle?: GraphQLTypes["StringCondition"] | undefined,
	successOtherJobsSelectionTitle?: GraphQLTypes["StringCondition"] | undefined,
	successOtherJobsSelectionYesButton?: GraphQLTypes["StringCondition"] | undefined,
	successOtherJobsSelectionNoButton?: GraphQLTypes["StringCondition"] | undefined,
	fileRemoveBtnLabel?: GraphQLTypes["StringCondition"] | undefined,
	gdprLabel?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["JobsFormLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobsFormLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobsFormLocaleWhere"] | undefined
};
	["JobsFormWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["JobsFormLocaleWhere"] | undefined,
	fileIlustration?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["JobsFormWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobsFormWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobsFormWhere"] | undefined
};
	["ImageTextListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["ImageTextItemWhere"] | undefined,
	and?: Array<GraphQLTypes["ImageTextListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageTextListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageTextListWhere"] | undefined
};
	["ImageTextItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["ImageTextListWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["ImageTextItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageTextItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageTextItemWhere"] | undefined
};
	["SideBySideWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["SideBySideItemWhere"] | undefined,
	background?: GraphQLTypes["BackgroundCondition"] | undefined,
	alignment?: GraphQLTypes["ContentAlignmentCondition"] | undefined,
	mediumSize?: GraphQLTypes["MediumSizeCondition"] | undefined,
	and?: Array<GraphQLTypes["SideBySideWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SideBySideWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SideBySideWhere"] | undefined
};
	["SideBySideItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["SideBySideWhere"] | undefined,
	media?: GraphQLTypes["MediumListWhere"] | undefined,
	formButtonLabel?: GraphQLTypes["StringCondition"] | undefined,
	type?: GraphQLTypes["SideBySideItemTypeCondition"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	jobsForm?: GraphQLTypes["JobsFormLocaleWhere"] | undefined,
	textNew?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["SideBySideItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SideBySideItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SideBySideItemWhere"] | undefined
};
	["SideBySideItemTypeCondition"]: {
		and?: Array<GraphQLTypes["SideBySideItemTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["SideBySideItemTypeCondition"]> | undefined,
	not?: GraphQLTypes["SideBySideItemTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["SideBySideItemType"] | undefined,
	notEq?: GraphQLTypes["SideBySideItemType"] | undefined,
	in?: Array<GraphQLTypes["SideBySideItemType"]> | undefined,
	notIn?: Array<GraphQLTypes["SideBySideItemType"]> | undefined,
	lt?: GraphQLTypes["SideBySideItemType"] | undefined,
	lte?: GraphQLTypes["SideBySideItemType"] | undefined,
	gt?: GraphQLTypes["SideBySideItemType"] | undefined,
	gte?: GraphQLTypes["SideBySideItemType"] | undefined
};
	["SideBySideItemType"]: SideBySideItemType;
	["ContentAlignmentCondition"]: {
		and?: Array<GraphQLTypes["ContentAlignmentCondition"]> | undefined,
	or?: Array<GraphQLTypes["ContentAlignmentCondition"]> | undefined,
	not?: GraphQLTypes["ContentAlignmentCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ContentAlignment"] | undefined,
	notEq?: GraphQLTypes["ContentAlignment"] | undefined,
	in?: Array<GraphQLTypes["ContentAlignment"]> | undefined,
	notIn?: Array<GraphQLTypes["ContentAlignment"]> | undefined,
	lt?: GraphQLTypes["ContentAlignment"] | undefined,
	lte?: GraphQLTypes["ContentAlignment"] | undefined,
	gt?: GraphQLTypes["ContentAlignment"] | undefined,
	gte?: GraphQLTypes["ContentAlignment"] | undefined
};
	["ContentAlignment"]: ContentAlignment;
	["MediumSizeCondition"]: {
		and?: Array<GraphQLTypes["MediumSizeCondition"]> | undefined,
	or?: Array<GraphQLTypes["MediumSizeCondition"]> | undefined,
	not?: GraphQLTypes["MediumSizeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["MediumSize"] | undefined,
	notEq?: GraphQLTypes["MediumSize"] | undefined,
	in?: Array<GraphQLTypes["MediumSize"]> | undefined,
	notIn?: Array<GraphQLTypes["MediumSize"]> | undefined,
	lt?: GraphQLTypes["MediumSize"] | undefined,
	lte?: GraphQLTypes["MediumSize"] | undefined,
	gt?: GraphQLTypes["MediumSize"] | undefined,
	gte?: GraphQLTypes["MediumSize"] | undefined
};
	["MediumSize"]: MediumSize;
	["GalleryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["GalleryItemWhere"] | undefined,
	and?: Array<GraphQLTypes["GalleryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GalleryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GalleryWhere"] | undefined
};
	["GalleryItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["GalleryWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["GalleryItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GalleryItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GalleryItemWhere"] | undefined
};
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	ogTitle?: GraphQLTypes["StringCondition"] | undefined,
	ogDescription?: GraphQLTypes["StringCondition"] | undefined,
	noIndex?: GraphQLTypes["BooleanCondition"] | undefined,
	noFollow?: GraphQLTypes["BooleanCondition"] | undefined,
	ogImage?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["SeoWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SeoWhere"] | undefined
};
	["BusinessPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["BusinessPageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	subtitle?: GraphQLTypes["StringCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	stickyBar?: GraphQLTypes["StickyBarWhere"] | undefined,
	infoBox?: GraphQLTypes["InfoBoxWhere"] | undefined,
	and?: Array<GraphQLTypes["BusinessPageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BusinessPageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BusinessPageLocaleWhere"] | undefined
};
	["BusinessPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locales?: GraphQLTypes["BusinessPageLocaleWhere"] | undefined,
	theme?: GraphQLTypes["ThemeWhere"] | undefined,
	isLokal?: GraphQLTypes["BooleanCondition"] | undefined,
	tabidooId?: GraphQLTypes["StringCondition"] | undefined,
	headerColor?: GraphQLTypes["StringCondition"] | undefined,
	recruitisOfficeId?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["BusinessPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BusinessPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BusinessPageWhere"] | undefined
};
	["StickyBarWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	formButtonLabel?: GraphQLTypes["StringCondition"] | undefined,
	jobsForm?: GraphQLTypes["JobsFormLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["StickyBarWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StickyBarWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StickyBarWhere"] | undefined
};
	["InfoBoxWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	logoSize?: GraphQLTypes["LogoSizeCondition"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	locales?: GraphQLTypes["InfoBoxLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["InfoBoxWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InfoBoxWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InfoBoxWhere"] | undefined
};
	["LogoSizeCondition"]: {
		and?: Array<GraphQLTypes["LogoSizeCondition"]> | undefined,
	or?: Array<GraphQLTypes["LogoSizeCondition"]> | undefined,
	not?: GraphQLTypes["LogoSizeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["LogoSize"] | undefined,
	notEq?: GraphQLTypes["LogoSize"] | undefined,
	in?: Array<GraphQLTypes["LogoSize"]> | undefined,
	notIn?: Array<GraphQLTypes["LogoSize"]> | undefined,
	lt?: GraphQLTypes["LogoSize"] | undefined,
	lte?: GraphQLTypes["LogoSize"] | undefined,
	gt?: GraphQLTypes["LogoSize"] | undefined,
	gte?: GraphQLTypes["LogoSize"] | undefined
};
	["LogoSize"]: LogoSize;
	["InfoBoxLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	address?: GraphQLTypes["StringCondition"] | undefined,
	web?: GraphQLTypes["StringCondition"] | undefined,
	instagram?: GraphQLTypes["StringCondition"] | undefined,
	facebook?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["InfoBoxWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	openingHours?: GraphQLTypes["TextListWhere"] | undefined,
	addressLink?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["InfoBoxLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InfoBoxLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InfoBoxLocaleWhere"] | undefined
};
	["JobPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["JobPageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	keyInfo?: GraphQLTypes["KeyInfoListWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	stickyBar?: GraphQLTypes["StickyBarWhere"] | undefined,
	mobileImage?: GraphQLTypes["ImageWhere"] | undefined,
	isSyncedToTabidoo?: GraphQLTypes["BooleanCondition"] | undefined,
	tabidooId?: GraphQLTypes["StringCondition"] | undefined,
	recruitisJobId?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["JobPageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobPageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobPageLocaleWhere"] | undefined
};
	["JobPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locales?: GraphQLTypes["JobPageLocaleWhere"] | undefined,
	theme?: GraphQLTypes["ThemeWhere"] | undefined,
	contractType?: GraphQLTypes["ContractTypeWhere"] | undefined,
	jobCity?: GraphQLTypes["JobCityWhere"] | undefined,
	isActive?: GraphQLTypes["BooleanCondition"] | undefined,
	jobPosition?: GraphQLTypes["JobPositionWhere"] | undefined,
	publishedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	isSyncedToTabidoo?: GraphQLTypes["BooleanCondition"] | undefined,
	business?: GraphQLTypes["BusinessPageWhere"] | undefined,
	headerColor?: GraphQLTypes["StringCondition"] | undefined,
	siteType?: GraphQLTypes["SiteTypeCondition"] | undefined,
	isHiddenFromListing?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["JobPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobPageWhere"] | undefined
};
	["ContractTypeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locales?: GraphQLTypes["ContractTypeLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["ContractTypeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContractTypeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContractTypeWhere"] | undefined
};
	["ContractTypeLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["ContractTypeWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	slug?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ContractTypeLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContractTypeLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContractTypeLocaleWhere"] | undefined
};
	["JobCityWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locales?: GraphQLTypes["JobCityLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["JobCityWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobCityWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobCityWhere"] | undefined
};
	["JobCityLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["JobCityWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	slug?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["JobCityLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobCityLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobCityLocaleWhere"] | undefined
};
	["JobPositionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locales?: GraphQLTypes["JobPositionLocaleWhere"] | undefined,
	jobs?: GraphQLTypes["JobPageWhere"] | undefined,
	and?: Array<GraphQLTypes["JobPositionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobPositionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobPositionWhere"] | undefined
};
	["JobPositionLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["JobPositionWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	slug?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["JobPositionLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobPositionLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobPositionLocaleWhere"] | undefined
};
	["DateTimeCondition"]: {
		and?: Array<GraphQLTypes["DateTimeCondition"]> | undefined,
	or?: Array<GraphQLTypes["DateTimeCondition"]> | undefined,
	not?: GraphQLTypes["DateTimeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["DateTime"] | undefined,
	notEq?: GraphQLTypes["DateTime"] | undefined,
	in?: Array<GraphQLTypes["DateTime"]> | undefined,
	notIn?: Array<GraphQLTypes["DateTime"]> | undefined,
	lt?: GraphQLTypes["DateTime"] | undefined,
	lte?: GraphQLTypes["DateTime"] | undefined,
	gt?: GraphQLTypes["DateTime"] | undefined,
	gte?: GraphQLTypes["DateTime"] | undefined
};
	["DateTime"]: "scalar" & { name: "DateTime" };
	["SiteTypeCondition"]: {
		and?: Array<GraphQLTypes["SiteTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["SiteTypeCondition"]> | undefined,
	not?: GraphQLTypes["SiteTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["SiteType"] | undefined,
	notEq?: GraphQLTypes["SiteType"] | undefined,
	in?: Array<GraphQLTypes["SiteType"]> | undefined,
	notIn?: Array<GraphQLTypes["SiteType"]> | undefined,
	lt?: GraphQLTypes["SiteType"] | undefined,
	lte?: GraphQLTypes["SiteType"] | undefined,
	gt?: GraphQLTypes["SiteType"] | undefined,
	gte?: GraphQLTypes["SiteType"] | undefined
};
	["SiteType"]: SiteType;
	["KeyInfoListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["KeyInfoItemWhere"] | undefined,
	and?: Array<GraphQLTypes["KeyInfoListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["KeyInfoListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["KeyInfoListWhere"] | undefined
};
	["KeyInfoItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	keyInfo?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["KeyInfoListWhere"] | undefined,
	icon?: GraphQLTypes["IconWhere"] | undefined,
	and?: Array<GraphQLTypes["KeyInfoItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["KeyInfoItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["KeyInfoItemWhere"] | undefined
};
	["IconWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	icon?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["IconWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["IconWhere"] | undefined> | undefined,
	not?: GraphQLTypes["IconWhere"] | undefined
};
	["HomePageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["HomePageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	button?: GraphQLTypes["LinkWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	siteSwitcher?: GraphQLTypes["SiteSwitcherWhere"] | undefined,
	gallery?: GraphQLTypes["GalleryWhere"] | undefined,
	stickyBar?: GraphQLTypes["StickyBarWhere"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	ilustration?: GraphQLTypes["GalleryWhere"] | undefined,
	and?: Array<GraphQLTypes["HomePageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HomePageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HomePageLocaleWhere"] | undefined
};
	["HomePageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["HomePageLocaleWhere"] | undefined,
	theme?: GraphQLTypes["ThemeWhere"] | undefined,
	and?: Array<GraphQLTypes["HomePageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HomePageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HomePageWhere"] | undefined
};
	["SiteSwitcherWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	theme?: GraphQLTypes["ThemeWhere"] | undefined,
	headerColor?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["SiteSwitcherWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SiteSwitcherWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SiteSwitcherWhere"] | undefined
};
	["HomePageLokalLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["HomePageLokalWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	button?: GraphQLTypes["LinkWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	siteSwitcher?: GraphQLTypes["SiteSwitcherWhere"] | undefined,
	gallery?: GraphQLTypes["GalleryWhere"] | undefined,
	stickyBar?: GraphQLTypes["StickyBarWhere"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	ilustration?: GraphQLTypes["GalleryWhere"] | undefined,
	and?: Array<GraphQLTypes["HomePageLokalLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HomePageLokalLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HomePageLokalLocaleWhere"] | undefined
};
	["HomePageLokalWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["HomePageLokalLocaleWhere"] | undefined,
	theme?: GraphQLTypes["ThemeWhere"] | undefined,
	and?: Array<GraphQLTypes["HomePageLokalWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HomePageLokalWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HomePageLokalWhere"] | undefined
};
	["RecommendationFormLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	subtitle?: GraphQLTypes["StringCondition"] | undefined,
	yourEmailLabel?: GraphQLTypes["StringCondition"] | undefined,
	theirEmailLabel?: GraphQLTypes["StringCondition"] | undefined,
	yourName?: GraphQLTypes["StringCondition"] | undefined,
	sendBtnLabel?: GraphQLTypes["StringCondition"] | undefined,
	successTitle?: GraphQLTypes["StringCondition"] | undefined,
	successSubtitle?: GraphQLTypes["StringCondition"] | undefined,
	successButtonClose?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["RecommendationFormWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["RecommendationFormLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RecommendationFormLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RecommendationFormLocaleWhere"] | undefined
};
	["RecommendationFormWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["RecommendationFormLocaleWhere"] | undefined,
	successImage?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["RecommendationFormWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RecommendationFormWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RecommendationFormWhere"] | undefined
};
	["HeaderLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["HeaderWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	menuLabel?: GraphQLTypes["StringCondition"] | undefined,
	menuTitle?: GraphQLTypes["StringCondition"] | undefined,
	menuText?: GraphQLTypes["StringCondition"] | undefined,
	business?: GraphQLTypes["BusinessWhere"] | undefined,
	lokalEnterprise?: GraphQLTypes["BusinessWhere"] | undefined,
	businessSectionTitle?: GraphQLTypes["StringCondition"] | undefined,
	lokalSectionTitle?: GraphQLTypes["StringCondition"] | undefined,
	businessLink?: GraphQLTypes["LinkWhere"] | undefined,
	lokalLink?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["HeaderLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HeaderLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HeaderLocaleWhere"] | undefined
};
	["HeaderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["HeaderLocaleWhere"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	logoMenu?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["HeaderWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HeaderWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HeaderWhere"] | undefined
};
	["BusinessWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["BusinessWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BusinessWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BusinessWhere"] | undefined
};
	["SeoDefaultLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["SeoDefaultWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	and?: Array<GraphQLTypes["SeoDefaultLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SeoDefaultLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SeoDefaultLocaleWhere"] | undefined
};
	["SeoDefaultWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["SeoDefaultLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["SeoDefaultWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SeoDefaultWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SeoDefaultWhere"] | undefined
};
	["JobsFilterLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	jobPositionLabel?: GraphQLTypes["StringCondition"] | undefined,
	jobContractLabel?: GraphQLTypes["StringCondition"] | undefined,
	jobCityLabel?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["JobsFilterWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	bannerTitle?: GraphQLTypes["StringCondition"] | undefined,
	bannerFormLabel?: GraphQLTypes["StringCondition"] | undefined,
	bannerJobsForm?: GraphQLTypes["JobsFormLocaleWhere"] | undefined,
	bannerImage?: GraphQLTypes["ImageWhere"] | undefined,
	noJobTitle?: GraphQLTypes["StringCondition"] | undefined,
	noJobBtnLabel?: GraphQLTypes["StringCondition"] | undefined,
	noJobImage?: GraphQLTypes["ImageWhere"] | undefined,
	noJobTitleForSpecificBusiness?: GraphQLTypes["StringCondition"] | undefined,
	deactivatedJob?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["JobsFilterLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobsFilterLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobsFilterLocaleWhere"] | undefined
};
	["JobsFilterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["JobsFilterLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["JobsFilterWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobsFilterWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobsFilterWhere"] | undefined
};
	["TranslationLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	value?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["TranslationWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationLocaleWhere"] | undefined
};
	["TranslationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	key?: GraphQLTypes["StringCondition"] | undefined,
	locales?: GraphQLTypes["TranslationLocaleWhere"] | undefined,
	isTextarea?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["TranslationWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationWhere"] | undefined
};
	["CornerBannerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	isActive?: GraphQLTypes["BooleanCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["CornerBannerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CornerBannerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CornerBannerWhere"] | undefined
};
	["Locale"]: {
	__typename: "Locale",
	_meta?: GraphQLTypes["LocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	code: string,
	label?: string | undefined,
	footers: Array<GraphQLTypes["FooterLocale"]>,
	genericPages: Array<GraphQLTypes["GenericPageLocale"]>,
	headers: Array<GraphQLTypes["HeaderLocale"]>,
	seoDefaults: Array<GraphQLTypes["SeoDefaultLocale"]>,
	businessPages: Array<GraphQLTypes["BusinessPageLocale"]>,
	jobPages: Array<GraphQLTypes["JobPageLocale"]>,
	contractTypes: Array<GraphQLTypes["ContractTypeLocale"]>,
	jobCities: Array<GraphQLTypes["JobCityLocale"]>,
	jobPositions: Array<GraphQLTypes["JobPositionLocale"]>,
	homePages: Array<GraphQLTypes["HomePageLocale"]>,
	bonusBanners: Array<GraphQLTypes["BonusBannerLocale"]>,
	homePageLokals: Array<GraphQLTypes["HomePageLokalLocale"]>,
	jobsForms: Array<GraphQLTypes["JobsFormLocale"]>,
	jobsFilters: Array<GraphQLTypes["JobsFilterLocale"]>,
	general: Array<GraphQLTypes["GeneralLocale"]>,
	recommendationForms: Array<GraphQLTypes["RecommendationFormLocale"]>,
	infoBoxes: Array<GraphQLTypes["InfoBoxLocale"]>,
	translations: Array<GraphQLTypes["TranslationLocale"]>,
	footersByRoot?: GraphQLTypes["FooterLocale"] | undefined,
	footersByTermsAndConditions?: GraphQLTypes["FooterLocale"] | undefined,
	footersByBannerImage?: GraphQLTypes["FooterLocale"] | undefined,
	footersByBannerLink?: GraphQLTypes["FooterLocale"] | undefined,
	footersByJobsForm?: GraphQLTypes["FooterLocale"] | undefined,
	footersByCopyrightLink?: GraphQLTypes["FooterLocale"] | undefined,
	footersByRecommendationForm?: GraphQLTypes["FooterLocale"] | undefined,
	footersByBannerSecondLink?: GraphQLTypes["FooterLocale"] | undefined,
	footersByInstagramLink?: GraphQLTypes["FooterLocale"] | undefined,
	genericPagesByRoot?: GraphQLTypes["GenericPageLocale"] | undefined,
	genericPagesByContent?: GraphQLTypes["GenericPageLocale"] | undefined,
	genericPagesBySeo?: GraphQLTypes["GenericPageLocale"] | undefined,
	genericPagesByLink?: GraphQLTypes["GenericPageLocale"] | undefined,
	genericPagesByLogo?: GraphQLTypes["GenericPageLocale"] | undefined,
	genericPagesByImage?: GraphQLTypes["GenericPageLocale"] | undefined,
	headersByRoot?: GraphQLTypes["HeaderLocale"] | undefined,
	headersByBusinessLink?: GraphQLTypes["HeaderLocale"] | undefined,
	headersByLokalLink?: GraphQLTypes["HeaderLocale"] | undefined,
	seoDefaultsByRoot?: GraphQLTypes["SeoDefaultLocale"] | undefined,
	seoDefaultsBySeo?: GraphQLTypes["SeoDefaultLocale"] | undefined,
	businessPagesByRoot?: GraphQLTypes["BusinessPageLocale"] | undefined,
	businessPagesByContent?: GraphQLTypes["BusinessPageLocale"] | undefined,
	businessPagesBySeo?: GraphQLTypes["BusinessPageLocale"] | undefined,
	businessPagesByLink?: GraphQLTypes["BusinessPageLocale"] | undefined,
	businessPagesByImage?: GraphQLTypes["BusinessPageLocale"] | undefined,
	jobPagesByRoot?: GraphQLTypes["JobPageLocale"] | undefined,
	jobPagesByImage?: GraphQLTypes["JobPageLocale"] | undefined,
	jobPagesByKeyInfo?: GraphQLTypes["JobPageLocale"] | undefined,
	jobPagesByContent?: GraphQLTypes["JobPageLocale"] | undefined,
	jobPagesBySeo?: GraphQLTypes["JobPageLocale"] | undefined,
	jobPagesByLink?: GraphQLTypes["JobPageLocale"] | undefined,
	jobPagesByMobileImage?: GraphQLTypes["JobPageLocale"] | undefined,
	contractTypesByRoot?: GraphQLTypes["ContractTypeLocale"] | undefined,
	contractTypesBySlug?: GraphQLTypes["ContractTypeLocale"] | undefined,
	jobCitiesByRoot?: GraphQLTypes["JobCityLocale"] | undefined,
	jobCitiesBySlug?: GraphQLTypes["JobCityLocale"] | undefined,
	jobPositionsByRoot?: GraphQLTypes["JobPositionLocale"] | undefined,
	jobPositionsBySlug?: GraphQLTypes["JobPositionLocale"] | undefined,
	homePagesByRoot?: GraphQLTypes["HomePageLocale"] | undefined,
	homePagesByButton?: GraphQLTypes["HomePageLocale"] | undefined,
	homePagesByContent?: GraphQLTypes["HomePageLocale"] | undefined,
	homePagesBySeo?: GraphQLTypes["HomePageLocale"] | undefined,
	homePagesByLink?: GraphQLTypes["HomePageLocale"] | undefined,
	homePagesByLogo?: GraphQLTypes["HomePageLocale"] | undefined,
	homePagesBySiteSwitcher?: GraphQLTypes["HomePageLocale"] | undefined,
	homePagesByIlustration?: GraphQLTypes["HomePageLocale"] | undefined,
	bonusBannersByRoot?: GraphQLTypes["BonusBannerLocale"] | undefined,
	bonusBannersByTiles?: GraphQLTypes["BonusBannerLocale"] | undefined,
	bonusBannersByLogo?: GraphQLTypes["BonusBannerLocale"] | undefined,
	homePageLokalsByRoot?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsByLogo?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsByButton?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsByContent?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsBySeo?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsByLink?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsBySiteSwitcher?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	homePageLokalsByIlustration?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	jobsFormsByRoot?: GraphQLTypes["JobsFormLocale"] | undefined,
	jobsFormsByImageTextList?: GraphQLTypes["JobsFormLocale"] | undefined,
	jobsFormsByLogo?: GraphQLTypes["JobsFormLocale"] | undefined,
	jobsFormsBySuccessImage?: GraphQLTypes["JobsFormLocale"] | undefined,
	jobsFiltersByRoot?: GraphQLTypes["JobsFilterLocale"] | undefined,
	jobsFiltersByBannerJobsForm?: GraphQLTypes["JobsFilterLocale"] | undefined,
	jobsFiltersByBannerImage?: GraphQLTypes["JobsFilterLocale"] | undefined,
	jobsFiltersByNoJobImage?: GraphQLTypes["JobsFilterLocale"] | undefined,
	generalByRoot?: GraphQLTypes["GeneralLocale"] | undefined,
	generalBySeo?: GraphQLTypes["GeneralLocale"] | undefined,
	generalByCornerBanner?: GraphQLTypes["GeneralLocale"] | undefined,
	recommendationFormsByRoot?: GraphQLTypes["RecommendationFormLocale"] | undefined,
	infoBoxesByRoot?: GraphQLTypes["InfoBoxLocale"] | undefined,
	translationsByRoot?: GraphQLTypes["TranslationLocale"] | undefined,
	paginateFooters: GraphQLTypes["FooterLocaleConnection"],
	paginateGenericPages: GraphQLTypes["GenericPageLocaleConnection"],
	paginateHeaders: GraphQLTypes["HeaderLocaleConnection"],
	paginateSeoDefaults: GraphQLTypes["SeoDefaultLocaleConnection"],
	paginateBusinessPages: GraphQLTypes["BusinessPageLocaleConnection"],
	paginateJobPages: GraphQLTypes["JobPageLocaleConnection"],
	paginateContractTypes: GraphQLTypes["ContractTypeLocaleConnection"],
	paginateJobCities: GraphQLTypes["JobCityLocaleConnection"],
	paginateJobPositions: GraphQLTypes["JobPositionLocaleConnection"],
	paginateHomePages: GraphQLTypes["HomePageLocaleConnection"],
	paginateBonusBanners: GraphQLTypes["BonusBannerLocaleConnection"],
	paginateHomePageLokals: GraphQLTypes["HomePageLokalLocaleConnection"],
	paginateJobsForms: GraphQLTypes["JobsFormLocaleConnection"],
	paginateJobsFilters: GraphQLTypes["JobsFilterLocaleConnection"],
	paginateGeneral: GraphQLTypes["GeneralLocaleConnection"],
	paginateRecommendationForms: GraphQLTypes["RecommendationFormLocaleConnection"],
	paginateInfoBoxes: GraphQLTypes["InfoBoxLocaleConnection"],
	paginateTranslations: GraphQLTypes["TranslationLocaleConnection"]
};
	["LocaleMeta"]: {
	__typename: "LocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	label?: GraphQLTypes["FieldMeta"] | undefined,
	footers?: GraphQLTypes["FieldMeta"] | undefined,
	genericPages?: GraphQLTypes["FieldMeta"] | undefined,
	headers?: GraphQLTypes["FieldMeta"] | undefined,
	seoDefaults?: GraphQLTypes["FieldMeta"] | undefined,
	businessPages?: GraphQLTypes["FieldMeta"] | undefined,
	jobPages?: GraphQLTypes["FieldMeta"] | undefined,
	contractTypes?: GraphQLTypes["FieldMeta"] | undefined,
	jobCities?: GraphQLTypes["FieldMeta"] | undefined,
	jobPositions?: GraphQLTypes["FieldMeta"] | undefined,
	homePages?: GraphQLTypes["FieldMeta"] | undefined,
	bonusBanners?: GraphQLTypes["FieldMeta"] | undefined,
	homePageLokals?: GraphQLTypes["FieldMeta"] | undefined,
	jobsForms?: GraphQLTypes["FieldMeta"] | undefined,
	jobsFilters?: GraphQLTypes["FieldMeta"] | undefined,
	general?: GraphQLTypes["FieldMeta"] | undefined,
	recommendationForms?: GraphQLTypes["FieldMeta"] | undefined,
	infoBoxes?: GraphQLTypes["FieldMeta"] | undefined,
	translations?: GraphQLTypes["FieldMeta"] | undefined
};
	["FooterLocale"]: {
	__typename: "FooterLocale",
	_meta?: GraphQLTypes["FooterLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	root?: GraphQLTypes["Footer"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	linksFirstColumn: Array<GraphQLTypes["FooterLink"]>,
	linksSecondColumn: Array<GraphQLTypes["FooterLink"]>,
	termsAndConditions?: GraphQLTypes["Link"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: GraphQLTypes["Image"] | undefined,
	bannerLink?: GraphQLTypes["Link"] | undefined,
	jobsForm?: GraphQLTypes["JobsFormLocale"] | undefined,
	copyrightLink?: GraphQLTypes["Link"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: GraphQLTypes["RecommendationFormLocale"] | undefined,
	bannerSecondLink?: GraphQLTypes["Link"] | undefined,
	instagramLink?: GraphQLTypes["Link"] | undefined,
	paginateLinksFirstColumn: GraphQLTypes["FooterLinkConnection"],
	paginateLinksSecondColumn: GraphQLTypes["FooterLinkConnection"]
};
	["FooterLocaleMeta"]: {
	__typename: "FooterLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined,
	ico?: GraphQLTypes["FieldMeta"] | undefined,
	dic?: GraphQLTypes["FieldMeta"] | undefined,
	copyright?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	noteSecond?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	linksFirstColumn?: GraphQLTypes["FieldMeta"] | undefined,
	linksSecondColumn?: GraphQLTypes["FieldMeta"] | undefined,
	termsAndConditions?: GraphQLTypes["FieldMeta"] | undefined,
	form?: GraphQLTypes["FieldMeta"] | undefined,
	bannerTitle?: GraphQLTypes["FieldMeta"] | undefined,
	bannerSubtitle?: GraphQLTypes["FieldMeta"] | undefined,
	bannerImage?: GraphQLTypes["FieldMeta"] | undefined,
	bannerLink?: GraphQLTypes["FieldMeta"] | undefined,
	jobsForm?: GraphQLTypes["FieldMeta"] | undefined,
	copyrightLink?: GraphQLTypes["FieldMeta"] | undefined,
	bannerSecondBtn?: GraphQLTypes["FieldMeta"] | undefined,
	recommendationForm?: GraphQLTypes["FieldMeta"] | undefined,
	bannerSecondLink?: GraphQLTypes["FieldMeta"] | undefined,
	instagramLink?: GraphQLTypes["FieldMeta"] | undefined
};
	["Footer"]: {
	__typename: "Footer",
	_meta?: GraphQLTypes["FooterMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["FooterLocale"]>,
	localesByLocale?: GraphQLTypes["FooterLocale"] | undefined,
	localesByTermsAndConditions?: GraphQLTypes["FooterLocale"] | undefined,
	localesByBannerImage?: GraphQLTypes["FooterLocale"] | undefined,
	localesByBannerLink?: GraphQLTypes["FooterLocale"] | undefined,
	localesByJobsForm?: GraphQLTypes["FooterLocale"] | undefined,
	localesByCopyrightLink?: GraphQLTypes["FooterLocale"] | undefined,
	localesByRecommendationForm?: GraphQLTypes["FooterLocale"] | undefined,
	localesByBannerSecondLink?: GraphQLTypes["FooterLocale"] | undefined,
	localesByInstagramLink?: GraphQLTypes["FooterLocale"] | undefined,
	paginateLocales: GraphQLTypes["FooterLocaleConnection"]
};
	["FooterMeta"]: {
	__typename: "FooterMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["FooterLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	address?: GraphQLTypes["OrderDirection"] | undefined,
	ico?: GraphQLTypes["OrderDirection"] | undefined,
	dic?: GraphQLTypes["OrderDirection"] | undefined,
	copyright?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	noteSecond?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["FooterOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	termsAndConditions?: GraphQLTypes["LinkOrderBy"] | undefined,
	form?: GraphQLTypes["OrderDirection"] | undefined,
	bannerTitle?: GraphQLTypes["OrderDirection"] | undefined,
	bannerSubtitle?: GraphQLTypes["OrderDirection"] | undefined,
	bannerImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	bannerLink?: GraphQLTypes["LinkOrderBy"] | undefined,
	jobsForm?: GraphQLTypes["JobsFormLocaleOrderBy"] | undefined,
	copyrightLink?: GraphQLTypes["LinkOrderBy"] | undefined,
	bannerSecondBtn?: GraphQLTypes["OrderDirection"] | undefined,
	recommendationForm?: GraphQLTypes["RecommendationFormLocaleOrderBy"] | undefined,
	bannerSecondLink?: GraphQLTypes["LinkOrderBy"] | undefined,
	instagramLink?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["OrderDirection"]: OrderDirection;
	["FooterOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["LocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	label?: GraphQLTypes["OrderDirection"] | undefined
};
	["LinkOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	externalLink?: GraphQLTypes["OrderDirection"] | undefined,
	internalLink?: GraphQLTypes["LinkableOrderBy"] | undefined,
	anchorLink?: GraphQLTypes["OrderDirection"] | undefined
};
	["LinkableOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	redirect?: GraphQLTypes["RedirectOrderBy"] | undefined,
	genericPage?: GraphQLTypes["GenericPageLocaleOrderBy"] | undefined,
	businessPage?: GraphQLTypes["BusinessPageLocaleOrderBy"] | undefined,
	jobPage?: GraphQLTypes["JobPageLocaleOrderBy"] | undefined,
	homePage?: GraphQLTypes["HomePageLocaleOrderBy"] | undefined,
	homePageLokal?: GraphQLTypes["HomePageLokalLocaleOrderBy"] | undefined
};
	["RedirectOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	target?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["GenericPageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["GenericPageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["GenericPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	theme?: GraphQLTypes["ThemeOrderBy"] | undefined,
	headerColor?: GraphQLTypes["OrderDirection"] | undefined
};
	["ThemeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	backgroundColor?: GraphQLTypes["OrderDirection"] | undefined,
	textColor?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	buttonBackgroundColor?: GraphQLTypes["OrderDirection"] | undefined,
	buttonTextColor?: GraphQLTypes["OrderDirection"] | undefined,
	buttonBackgroundHoverColor?: GraphQLTypes["OrderDirection"] | undefined,
	buttonTextHoverColor?: GraphQLTypes["OrderDirection"] | undefined,
	buttonBorderColor?: GraphQLTypes["OrderDirection"] | undefined,
	buttonBorderHoverColor?: GraphQLTypes["OrderDirection"] | undefined,
	headerMenuColor?: GraphQLTypes["OrderDirection"] | undefined
};
	["ContentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["SeoOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	ogTitle?: GraphQLTypes["OrderDirection"] | undefined,
	ogDescription?: GraphQLTypes["OrderDirection"] | undefined,
	noIndex?: GraphQLTypes["OrderDirection"] | undefined,
	noFollow?: GraphQLTypes["OrderDirection"] | undefined,
	ogImage?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["ImageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	width?: GraphQLTypes["OrderDirection"] | undefined,
	height?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	alt?: GraphQLTypes["OrderDirection"] | undefined,
	fileName?: GraphQLTypes["OrderDirection"] | undefined,
	focalPointX?: GraphQLTypes["OrderDirection"] | undefined,
	focalPointY?: GraphQLTypes["OrderDirection"] | undefined
};
	["BusinessPageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["BusinessPageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	subtitle?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	stickyBar?: GraphQLTypes["StickyBarOrderBy"] | undefined,
	infoBox?: GraphQLTypes["InfoBoxOrderBy"] | undefined
};
	["BusinessPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	theme?: GraphQLTypes["ThemeOrderBy"] | undefined,
	isLokal?: GraphQLTypes["OrderDirection"] | undefined,
	tabidooId?: GraphQLTypes["OrderDirection"] | undefined,
	headerColor?: GraphQLTypes["OrderDirection"] | undefined,
	recruitisOfficeId?: GraphQLTypes["OrderDirection"] | undefined
};
	["StickyBarOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined,
	formButtonLabel?: GraphQLTypes["OrderDirection"] | undefined,
	jobsForm?: GraphQLTypes["JobsFormLocaleOrderBy"] | undefined
};
	["JobsFormLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	jobText?: GraphQLTypes["OrderDirection"] | undefined,
	genericText?: GraphQLTypes["OrderDirection"] | undefined,
	nameLabel?: GraphQLTypes["OrderDirection"] | undefined,
	emailLabel?: GraphQLTypes["OrderDirection"] | undefined,
	telefonLabel?: GraphQLTypes["OrderDirection"] | undefined,
	fileTitleLabel?: GraphQLTypes["OrderDirection"] | undefined,
	fileFormatLabel?: GraphQLTypes["OrderDirection"] | undefined,
	formTextLabel?: GraphQLTypes["OrderDirection"] | undefined,
	submitLabel?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["JobsFormOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	imageTextList?: GraphQLTypes["ImageTextListOrderBy"] | undefined,
	minimalize?: GraphQLTypes["OrderDirection"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined,
	successTitle?: GraphQLTypes["OrderDirection"] | undefined,
	successText?: GraphQLTypes["OrderDirection"] | undefined,
	successBtnLabel?: GraphQLTypes["OrderDirection"] | undefined,
	successImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	successOtherJobsTitle?: GraphQLTypes["OrderDirection"] | undefined,
	successOtherJobsCategoryTitle?: GraphQLTypes["OrderDirection"] | undefined,
	successOtherJobsButtonTitle?: GraphQLTypes["OrderDirection"] | undefined,
	successOtherJobsSelectionTitle?: GraphQLTypes["OrderDirection"] | undefined,
	successOtherJobsSelectionYesButton?: GraphQLTypes["OrderDirection"] | undefined,
	successOtherJobsSelectionNoButton?: GraphQLTypes["OrderDirection"] | undefined,
	fileRemoveBtnLabel?: GraphQLTypes["OrderDirection"] | undefined,
	gdprLabel?: GraphQLTypes["OrderDirection"] | undefined
};
	["JobsFormOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	fileIlustration?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["ImageTextListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["InfoBoxOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	logoSize?: GraphQLTypes["OrderDirection"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["JobPageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["JobPageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	keyInfo?: GraphQLTypes["KeyInfoListOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	stickyBar?: GraphQLTypes["StickyBarOrderBy"] | undefined,
	mobileImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	isSyncedToTabidoo?: GraphQLTypes["OrderDirection"] | undefined,
	tabidooId?: GraphQLTypes["OrderDirection"] | undefined,
	recruitisJobId?: GraphQLTypes["OrderDirection"] | undefined
};
	["JobPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	theme?: GraphQLTypes["ThemeOrderBy"] | undefined,
	contractType?: GraphQLTypes["ContractTypeOrderBy"] | undefined,
	jobCity?: GraphQLTypes["JobCityOrderBy"] | undefined,
	isActive?: GraphQLTypes["OrderDirection"] | undefined,
	jobPosition?: GraphQLTypes["JobPositionOrderBy"] | undefined,
	publishedAt?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	isSyncedToTabidoo?: GraphQLTypes["OrderDirection"] | undefined,
	business?: GraphQLTypes["BusinessPageOrderBy"] | undefined,
	headerColor?: GraphQLTypes["OrderDirection"] | undefined,
	siteType?: GraphQLTypes["OrderDirection"] | undefined,
	isHiddenFromListing?: GraphQLTypes["OrderDirection"] | undefined
};
	["ContractTypeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["JobCityOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["JobPositionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["KeyInfoListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["HomePageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["HomePageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	button?: GraphQLTypes["LinkOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined,
	siteSwitcher?: GraphQLTypes["SiteSwitcherOrderBy"] | undefined,
	gallery?: GraphQLTypes["GalleryOrderBy"] | undefined,
	stickyBar?: GraphQLTypes["StickyBarOrderBy"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	ilustration?: GraphQLTypes["GalleryOrderBy"] | undefined
};
	["HomePageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	theme?: GraphQLTypes["ThemeOrderBy"] | undefined
};
	["SiteSwitcherOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined,
	theme?: GraphQLTypes["ThemeOrderBy"] | undefined,
	headerColor?: GraphQLTypes["OrderDirection"] | undefined
};
	["GalleryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["HomePageLokalLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["HomePageLokalOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined,
	button?: GraphQLTypes["LinkOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	siteSwitcher?: GraphQLTypes["SiteSwitcherOrderBy"] | undefined,
	gallery?: GraphQLTypes["GalleryOrderBy"] | undefined,
	stickyBar?: GraphQLTypes["StickyBarOrderBy"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	ilustration?: GraphQLTypes["GalleryOrderBy"] | undefined
};
	["HomePageLokalOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	theme?: GraphQLTypes["ThemeOrderBy"] | undefined
};
	["RecommendationFormLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	subtitle?: GraphQLTypes["OrderDirection"] | undefined,
	yourEmailLabel?: GraphQLTypes["OrderDirection"] | undefined,
	theirEmailLabel?: GraphQLTypes["OrderDirection"] | undefined,
	yourName?: GraphQLTypes["OrderDirection"] | undefined,
	sendBtnLabel?: GraphQLTypes["OrderDirection"] | undefined,
	successTitle?: GraphQLTypes["OrderDirection"] | undefined,
	successSubtitle?: GraphQLTypes["OrderDirection"] | undefined,
	successButtonClose?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["RecommendationFormOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["RecommendationFormOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	successImage?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["FooterLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["LocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	footers?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	genericPages?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	headers?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	seoDefaults?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	businessPages?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	jobPages?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	contractTypes?: GraphQLTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	jobCities?: GraphQLTypes["JobCityLocaleUniqueWhere"] | undefined,
	jobPositions?: GraphQLTypes["JobPositionLocaleUniqueWhere"] | undefined,
	homePages?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	bonusBanners?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	homePageLokals?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	jobsForms?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	jobsFilters?: GraphQLTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	general?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	recommendationForms?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	infoBoxes?: GraphQLTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	translations?: GraphQLTypes["TranslationLocaleUniqueWhere"] | undefined
};
	["FooterLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["FooterUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	termsAndConditions?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	bannerImage?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	bannerLink?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	jobsForm?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	copyrightLink?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	recommendationForm?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	bannerSecondLink?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	instagramLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["FooterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["JobsFormLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["JobsFormUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	imageTextList?: GraphQLTypes["ImageTextListUniqueWhere"] | undefined,
	logo?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	successImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["JobsFormUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	fileIlustration?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["ImageTextListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ImageTextItemUniqueWhere"] | undefined
};
	["ImageTextItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["RecommendationFormLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["RecommendationFormUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["RecommendationFormUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	successImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["GenericPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GenericPageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	logo?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["GenericPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined
};
	["ContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	references?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined
};
	["ContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	linkables?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	media?: GraphQLTypes["MediumListUniqueWhere"] | undefined
};
	["ContentReferenceLinkableItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	item?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: GraphQLTypes["RedirectUniqueWhere"] | undefined,
	genericPage?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	businessPage?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	jobPage?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	homePage?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	homePageLokal?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined
};
	["RedirectUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	target?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["BusinessPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["BusinessPageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["BusinessPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	ogImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["JobPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["JobPageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	keyInfo?: GraphQLTypes["KeyInfoListUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	mobileImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["JobPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined
};
	["KeyInfoListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["KeyInfoItemUniqueWhere"] | undefined
};
	["KeyInfoItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["HomePageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["HomePageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	button?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	logo?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	siteSwitcher?: GraphQLTypes["SiteSwitcherUniqueWhere"] | undefined,
	ilustration?: GraphQLTypes["GalleryUniqueWhere"] | undefined
};
	["HomePageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	theme?: GraphQLTypes["ThemeUniqueWhere"] | undefined
};
	["ThemeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["SiteSwitcherUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	theme?: GraphQLTypes["ThemeUniqueWhere"] | undefined
};
	["GalleryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined
};
	["GalleryItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["HomePageLokalLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["HomePageLokalUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	logo?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	button?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	siteSwitcher?: GraphQLTypes["SiteSwitcherUniqueWhere"] | undefined,
	ilustration?: GraphQLTypes["GalleryUniqueWhere"] | undefined
};
	["HomePageLokalUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	theme?: GraphQLTypes["ThemeUniqueWhere"] | undefined
};
	["MediumListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["MediumItemUniqueWhere"] | undefined
};
	["MediumItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["HeaderLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["HeaderUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	businessLink?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	lokalLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["HeaderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	logo?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	logoMenu?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["SeoDefaultLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["SeoDefaultUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["SeoDefaultUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"] | undefined
};
	["ContractTypeLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ContractTypeUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	slug?: string | undefined
};
	["ContractTypeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["ContractTypeLocaleUniqueWhere"] | undefined
};
	["JobCityLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["JobCityUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	slug?: string | undefined
};
	["JobCityUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["JobCityLocaleUniqueWhere"] | undefined
};
	["JobPositionLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["JobPositionUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	slug?: string | undefined
};
	["JobPositionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["JobPositionLocaleUniqueWhere"] | undefined,
	jobs?: GraphQLTypes["JobPageUniqueWhere"] | undefined
};
	["BonusBannerLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["BonusBannerUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	tiles?: GraphQLTypes["TileUniqueWhere"] | undefined,
	logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["BonusBannerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined
};
	["TileUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	ligthBoxMedia?: GraphQLTypes["MediumListUniqueWhere"] | undefined
};
	["JobsFilterLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["JobsFilterUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	bannerJobsForm?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	bannerImage?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	noJobImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["JobsFilterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["JobsFilterLocaleUniqueWhere"] | undefined
};
	["GeneralLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GeneralUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	cornerBanner?: GraphQLTypes["CornerBannerUniqueWhere"] | undefined
};
	["GeneralUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined
};
	["CornerBannerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	logo?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["InfoBoxLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["InfoBoxUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["InfoBoxUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	logo?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	locales?: GraphQLTypes["InfoBoxLocaleUniqueWhere"] | undefined
};
	["TranslationLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["TranslationUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["TranslationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["TranslationLocaleUniqueWhere"] | undefined
};
	["FooterLocalesByTermsAndConditionsUniqueWhere"]: {
		termsAndConditions?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocalesByBannerImageUniqueWhere"]: {
		bannerImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["FooterLocalesByBannerLinkUniqueWhere"]: {
		bannerLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocalesByJobsFormUniqueWhere"]: {
		jobsForm?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined
};
	["FooterLocalesByCopyrightLinkUniqueWhere"]: {
		copyrightLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocalesByRecommendationFormUniqueWhere"]: {
		recommendationForm?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined
};
	["FooterLocalesByBannerSecondLinkUniqueWhere"]: {
		bannerSecondLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocalesByInstagramLinkUniqueWhere"]: {
		instagramLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["FooterLocaleConnection"]: {
	__typename: "FooterLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterLocaleEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["FooterLocaleEdge"]: {
	__typename: "FooterLocaleEdge",
	node: GraphQLTypes["FooterLocale"]
};
	["FooterLink"]: {
	__typename: "FooterLink",
	_meta?: GraphQLTypes["FooterLinkMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	link?: GraphQLTypes["Link"] | undefined
};
	["FooterLinkMeta"]: {
	__typename: "FooterLinkMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: GraphQLTypes["Linkable"] | undefined,
	anchorLink?: string | undefined
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	externalLink?: GraphQLTypes["FieldMeta"] | undefined,
	internalLink?: GraphQLTypes["FieldMeta"] | undefined,
	anchorLink?: GraphQLTypes["FieldMeta"] | undefined
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	redirect?: GraphQLTypes["Redirect"] | undefined,
	genericPage?: GraphQLTypes["GenericPageLocale"] | undefined,
	businessPage?: GraphQLTypes["BusinessPageLocale"] | undefined,
	jobPage?: GraphQLTypes["JobPageLocale"] | undefined,
	homePage?: GraphQLTypes["HomePageLocale"] | undefined,
	homePageLokal?: GraphQLTypes["HomePageLokalLocale"] | undefined
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	redirect?: GraphQLTypes["FieldMeta"] | undefined,
	genericPage?: GraphQLTypes["FieldMeta"] | undefined,
	businessPage?: GraphQLTypes["FieldMeta"] | undefined,
	jobPage?: GraphQLTypes["FieldMeta"] | undefined,
	homePage?: GraphQLTypes["FieldMeta"] | undefined,
	homePageLokal?: GraphQLTypes["FieldMeta"] | undefined
};
	["Redirect"]: {
	__typename: "Redirect",
	_meta?: GraphQLTypes["RedirectMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	link?: GraphQLTypes["Linkable"] | undefined,
	target?: GraphQLTypes["Link"] | undefined
};
	["RedirectMeta"]: {
	__typename: "RedirectMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	target?: GraphQLTypes["FieldMeta"] | undefined
};
	["GenericPageLocale"]: {
	__typename: "GenericPageLocale",
	_meta?: GraphQLTypes["GenericPageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	root?: GraphQLTypes["GenericPage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["Image"] | undefined,
	image?: GraphQLTypes["Image"] | undefined
};
	["GenericPageLocaleMeta"]: {
	__typename: "GenericPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined
};
	["GenericPage"]: {
	__typename: "GenericPage",
	_meta?: GraphQLTypes["GenericPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["GenericPageLocale"]>,
	theme?: GraphQLTypes["Theme"] | undefined,
	headerColor?: string | undefined,
	localesByLocale?: GraphQLTypes["GenericPageLocale"] | undefined,
	localesByContent?: GraphQLTypes["GenericPageLocale"] | undefined,
	localesBySeo?: GraphQLTypes["GenericPageLocale"] | undefined,
	localesByLink?: GraphQLTypes["GenericPageLocale"] | undefined,
	localesByLogo?: GraphQLTypes["GenericPageLocale"] | undefined,
	localesByImage?: GraphQLTypes["GenericPageLocale"] | undefined,
	paginateLocales: GraphQLTypes["GenericPageLocaleConnection"]
};
	["GenericPageMeta"]: {
	__typename: "GenericPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	theme?: GraphQLTypes["FieldMeta"] | undefined,
	headerColor?: GraphQLTypes["FieldMeta"] | undefined
};
	["Theme"]: {
	__typename: "Theme",
	_meta?: GraphQLTypes["ThemeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	backgroundColor?: string | undefined,
	textColor?: string | undefined,
	name?: string | undefined,
	buttonBackgroundColor?: string | undefined,
	buttonTextColor?: string | undefined,
	buttonBackgroundHoverColor?: string | undefined,
	buttonTextHoverColor?: string | undefined,
	buttonBorderColor?: string | undefined,
	buttonBorderHoverColor?: string | undefined,
	headerMenuColor?: string | undefined
};
	["ThemeMeta"]: {
	__typename: "ThemeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	backgroundColor?: GraphQLTypes["FieldMeta"] | undefined,
	textColor?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	buttonBackgroundColor?: GraphQLTypes["FieldMeta"] | undefined,
	buttonTextColor?: GraphQLTypes["FieldMeta"] | undefined,
	buttonBackgroundHoverColor?: GraphQLTypes["FieldMeta"] | undefined,
	buttonTextHoverColor?: GraphQLTypes["FieldMeta"] | undefined,
	buttonBorderColor?: GraphQLTypes["FieldMeta"] | undefined,
	buttonBorderHoverColor?: GraphQLTypes["FieldMeta"] | undefined,
	headerMenuColor?: GraphQLTypes["FieldMeta"] | undefined
};
	["GenericPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["GenericPageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["GenericPageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["GenericPageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["GenericPageLocalesByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["GenericPageLocalesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["GenericPageLocaleConnection"]: {
	__typename: "GenericPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GenericPageLocaleEdge"]>
};
	["GenericPageLocaleEdge"]: {
	__typename: "GenericPageLocaleEdge",
	node: GraphQLTypes["GenericPageLocale"]
};
	["Content"]: {
	__typename: "Content",
	_meta?: GraphQLTypes["ContentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByReferences?: GraphQLTypes["ContentBlock"] | undefined,
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
	__typename: "ContentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	blocks?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"] | undefined,
	references: Array<GraphQLTypes["ContentReference"]>,
	referencesByLinkables?: GraphQLTypes["ContentReference"] | undefined,
	referencesByLink?: GraphQLTypes["ContentReference"] | undefined,
	referencesByMedia?: GraphQLTypes["ContentReference"] | undefined,
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	json?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	references?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentReference"]: {
	__typename: "ContentReference",
	_meta?: GraphQLTypes["ContentReferenceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	primaryText?: string | undefined,
	block?: GraphQLTypes["ContentBlock"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	linkables: Array<GraphQLTypes["ContentReferenceLinkableItem"]>,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	media?: GraphQLTypes["MediumList"] | undefined,
	textList?: GraphQLTypes["TextList"] | undefined,
	carousel?: GraphQLTypes["Carousel"] | undefined,
	bonusBanner?: GraphQLTypes["BonusBannerLocale"] | undefined,
	sideBySide?: GraphQLTypes["SideBySide"] | undefined,
	gallery?: GraphQLTypes["Gallery"] | undefined,
	showBoolean?: boolean | undefined,
	isRed?: boolean | undefined,
	video?: GraphQLTypes["Video"] | undefined,
	linkablesByItem?: GraphQLTypes["ContentReferenceLinkableItem"] | undefined,
	paginateLinkables: GraphQLTypes["ContentReferenceLinkableItemConnection"]
};
	["ContentReferenceMeta"]: {
	__typename: "ContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	primaryText?: GraphQLTypes["FieldMeta"] | undefined,
	block?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	linkables?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryText?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	media?: GraphQLTypes["FieldMeta"] | undefined,
	textList?: GraphQLTypes["FieldMeta"] | undefined,
	carousel?: GraphQLTypes["FieldMeta"] | undefined,
	bonusBanner?: GraphQLTypes["FieldMeta"] | undefined,
	sideBySide?: GraphQLTypes["FieldMeta"] | undefined,
	gallery?: GraphQLTypes["FieldMeta"] | undefined,
	showBoolean?: GraphQLTypes["FieldMeta"] | undefined,
	isRed?: GraphQLTypes["FieldMeta"] | undefined,
	video?: GraphQLTypes["FieldMeta"] | undefined
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	alt?: GraphQLTypes["FieldMeta"] | undefined,
	fileName?: GraphQLTypes["FieldMeta"] | undefined,
	focalPointX?: GraphQLTypes["FieldMeta"] | undefined,
	focalPointY?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentReferenceLinkableItem"]: {
	__typename: "ContentReferenceLinkableItem",
	_meta?: GraphQLTypes["ContentReferenceLinkableItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	item?: GraphQLTypes["Linkable"] | undefined,
	reference?: GraphQLTypes["ContentReference"] | undefined
};
	["ContentReferenceLinkableItemMeta"]: {
	__typename: "ContentReferenceLinkableItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined,
	reference?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentReferenceLinkableItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	item?: GraphQLTypes["LinkableOrderBy"] | undefined,
	reference?: GraphQLTypes["ContentReferenceOrderBy"] | undefined
};
	["ContentReferenceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	primaryText?: GraphQLTypes["OrderDirection"] | undefined,
	block?: GraphQLTypes["ContentBlockOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	secondaryText?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined,
	media?: GraphQLTypes["MediumListOrderBy"] | undefined,
	textList?: GraphQLTypes["TextListOrderBy"] | undefined,
	carousel?: GraphQLTypes["CarouselOrderBy"] | undefined,
	bonusBanner?: GraphQLTypes["BonusBannerLocaleOrderBy"] | undefined,
	sideBySide?: GraphQLTypes["SideBySideOrderBy"] | undefined,
	gallery?: GraphQLTypes["GalleryOrderBy"] | undefined,
	showBoolean?: GraphQLTypes["OrderDirection"] | undefined,
	isRed?: GraphQLTypes["OrderDirection"] | undefined,
	video?: GraphQLTypes["VideoOrderBy"] | undefined
};
	["ContentBlockOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	json?: GraphQLTypes["OrderDirection"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined
};
	["MediumListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["TextListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["CarouselOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	background?: GraphQLTypes["OrderDirection"] | undefined,
	squareImages?: GraphQLTypes["OrderDirection"] | undefined
};
	["BonusBannerLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["BonusBannerOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined,
	bannerName?: GraphQLTypes["OrderDirection"] | undefined
};
	["BonusBannerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["SideBySideOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	background?: GraphQLTypes["OrderDirection"] | undefined,
	alignment?: GraphQLTypes["OrderDirection"] | undefined,
	mediumSize?: GraphQLTypes["OrderDirection"] | undefined
};
	["VideoOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	src?: GraphQLTypes["OrderDirection"] | undefined,
	width?: GraphQLTypes["OrderDirection"] | undefined,
	height?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	videoInfo?: GraphQLTypes["OrderDirection"] | undefined,
	duration?: GraphQLTypes["OrderDirection"] | undefined,
	poster?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["MediumList"]: {
	__typename: "MediumList",
	_meta?: GraphQLTypes["MediumListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["MediumItem"]>,
	paginateItems: GraphQLTypes["MediumItemConnection"]
};
	["MediumListMeta"]: {
	__typename: "MediumListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["MediumItem"]: {
	__typename: "MediumItem",
	_meta?: GraphQLTypes["MediumItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["MediumList"] | undefined,
	medium?: GraphQLTypes["Medium"] | undefined
};
	["MediumItemMeta"]: {
	__typename: "MediumItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined
};
	["Medium"]: {
	__typename: "Medium",
	_meta?: GraphQLTypes["MediumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["MediumType"],
	image?: GraphQLTypes["Image"] | undefined,
	video?: GraphQLTypes["Video"] | undefined
};
	["MediumMeta"]: {
	__typename: "MediumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	video?: GraphQLTypes["FieldMeta"] | undefined
};
	["Video"]: {
	__typename: "Video",
	_meta?: GraphQLTypes["VideoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	src?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	videoInfo?: string | undefined,
	duration?: number | undefined,
	poster?: GraphQLTypes["Image"] | undefined
};
	["VideoMeta"]: {
	__typename: "VideoMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	src?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	videoInfo?: GraphQLTypes["FieldMeta"] | undefined,
	duration?: GraphQLTypes["FieldMeta"] | undefined,
	poster?: GraphQLTypes["FieldMeta"] | undefined
};
	["MediumItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["MediumListOrderBy"] | undefined,
	medium?: GraphQLTypes["MediumOrderBy"] | undefined
};
	["MediumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	video?: GraphQLTypes["VideoOrderBy"] | undefined
};
	["MediumItemConnection"]: {
	__typename: "MediumItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumItemEdge"]>
};
	["MediumItemEdge"]: {
	__typename: "MediumItemEdge",
	node: GraphQLTypes["MediumItem"]
};
	["TextList"]: {
	__typename: "TextList",
	_meta?: GraphQLTypes["TextListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["TextItem"]>,
	paginateItems: GraphQLTypes["TextItemConnection"]
};
	["TextListMeta"]: {
	__typename: "TextListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["TextItem"]: {
	__typename: "TextItem",
	_meta?: GraphQLTypes["TextItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order?: number | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["TextList"] | undefined,
	title?: string | undefined
};
	["TextItemMeta"]: {
	__typename: "TextItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined
};
	["TextItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["TextListOrderBy"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined
};
	["TextItemConnection"]: {
	__typename: "TextItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextItemEdge"]>
};
	["TextItemEdge"]: {
	__typename: "TextItemEdge",
	node: GraphQLTypes["TextItem"]
};
	["Carousel"]: {
	__typename: "Carousel",
	_meta?: GraphQLTypes["CarouselMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["CarouselItem"]>,
	background?: GraphQLTypes["Background"] | undefined,
	squareImages?: boolean | undefined,
	itemsByImage?: GraphQLTypes["CarouselItem"] | undefined,
	itemsByLinkUrl?: GraphQLTypes["CarouselItem"] | undefined,
	itemsByVideo?: GraphQLTypes["CarouselItem"] | undefined,
	paginateItems: GraphQLTypes["CarouselItemConnection"]
};
	["CarouselMeta"]: {
	__typename: "CarouselMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	background?: GraphQLTypes["FieldMeta"] | undefined,
	squareImages?: GraphQLTypes["FieldMeta"] | undefined
};
	["CarouselItem"]: {
	__typename: "CarouselItem",
	_meta?: GraphQLTypes["CarouselItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order?: number | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["Carousel"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	name?: string | undefined,
	title?: string | undefined,
	linkUrl?: GraphQLTypes["Link"] | undefined,
	normalAspectRatio?: boolean | undefined,
	isImage?: boolean | undefined,
	video?: GraphQLTypes["Video"] | undefined
};
	["CarouselItemMeta"]: {
	__typename: "CarouselItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	linkUrl?: GraphQLTypes["FieldMeta"] | undefined,
	normalAspectRatio?: GraphQLTypes["FieldMeta"] | undefined,
	isImage?: GraphQLTypes["FieldMeta"] | undefined,
	video?: GraphQLTypes["FieldMeta"] | undefined
};
	["CarouselItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["CarouselOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	linkUrl?: GraphQLTypes["LinkOrderBy"] | undefined,
	normalAspectRatio?: GraphQLTypes["OrderDirection"] | undefined,
	isImage?: GraphQLTypes["OrderDirection"] | undefined,
	video?: GraphQLTypes["VideoOrderBy"] | undefined
};
	["CarouselItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["CarouselItemsByLinkUrlUniqueWhere"]: {
		linkUrl?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["CarouselItemsByVideoUniqueWhere"]: {
		video?: GraphQLTypes["VideoUniqueWhere"] | undefined
};
	["VideoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["CarouselItemConnection"]: {
	__typename: "CarouselItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CarouselItemEdge"]>
};
	["CarouselItemEdge"]: {
	__typename: "CarouselItemEdge",
	node: GraphQLTypes["CarouselItem"]
};
	["BonusBannerLocale"]: {
	__typename: "BonusBannerLocale",
	_meta?: GraphQLTypes["BonusBannerLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["BonusBanner"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	tiles: Array<GraphQLTypes["Tile"]>,
	logo?: GraphQLTypes["Image"] | undefined,
	bannerName?: string | undefined,
	tilesByImage?: GraphQLTypes["Tile"] | undefined,
	tilesByLigthBoxMedia?: GraphQLTypes["Tile"] | undefined,
	paginateTiles: GraphQLTypes["TileConnection"]
};
	["BonusBannerLocaleMeta"]: {
	__typename: "BonusBannerLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	tiles?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	bannerName?: GraphQLTypes["FieldMeta"] | undefined
};
	["BonusBanner"]: {
	__typename: "BonusBanner",
	_meta?: GraphQLTypes["BonusBannerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["BonusBannerLocale"]>,
	localesByLocale?: GraphQLTypes["BonusBannerLocale"] | undefined,
	localesByTiles?: GraphQLTypes["BonusBannerLocale"] | undefined,
	localesByLogo?: GraphQLTypes["BonusBannerLocale"] | undefined,
	paginateLocales: GraphQLTypes["BonusBannerLocaleConnection"]
};
	["BonusBannerMeta"]: {
	__typename: "BonusBannerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["BonusBannerLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["BonusBannerLocalesByTilesUniqueWhere"]: {
		tiles?: GraphQLTypes["TileUniqueWhere"] | undefined
};
	["BonusBannerLocalesByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["BonusBannerLocaleConnection"]: {
	__typename: "BonusBannerLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BonusBannerLocaleEdge"]>
};
	["BonusBannerLocaleEdge"]: {
	__typename: "BonusBannerLocaleEdge",
	node: GraphQLTypes["BonusBannerLocale"]
};
	["Tile"]: {
	__typename: "Tile",
	_meta?: GraphQLTypes["TileMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	text?: string | undefined,
	bonusBanner?: GraphQLTypes["BonusBannerLocale"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	lightBoxTitle?: string | undefined,
	lightBoxText?: string | undefined,
	ligthBoxMedia?: GraphQLTypes["MediumList"] | undefined,
	lightBoxSectionTitle?: string | undefined,
	title?: string | undefined,
	lightBoxLinkLabel?: string | undefined,
	lightBoxForm?: GraphQLTypes["JobsFormLocale"] | undefined
};
	["TileMeta"]: {
	__typename: "TileMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	bonusBanner?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	lightBoxTitle?: GraphQLTypes["FieldMeta"] | undefined,
	lightBoxText?: GraphQLTypes["FieldMeta"] | undefined,
	ligthBoxMedia?: GraphQLTypes["FieldMeta"] | undefined,
	lightBoxSectionTitle?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	lightBoxLinkLabel?: GraphQLTypes["FieldMeta"] | undefined,
	lightBoxForm?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobsFormLocale"]: {
	__typename: "JobsFormLocale",
	_meta?: GraphQLTypes["JobsFormLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	root?: GraphQLTypes["JobsForm"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	imageTextList?: GraphQLTypes["ImageTextList"] | undefined,
	minimalize?: string | undefined,
	logo?: GraphQLTypes["Image"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: GraphQLTypes["Image"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined
};
	["JobsFormLocaleMeta"]: {
	__typename: "JobsFormLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	jobText?: GraphQLTypes["FieldMeta"] | undefined,
	genericText?: GraphQLTypes["FieldMeta"] | undefined,
	nameLabel?: GraphQLTypes["FieldMeta"] | undefined,
	emailLabel?: GraphQLTypes["FieldMeta"] | undefined,
	telefonLabel?: GraphQLTypes["FieldMeta"] | undefined,
	fileTitleLabel?: GraphQLTypes["FieldMeta"] | undefined,
	fileFormatLabel?: GraphQLTypes["FieldMeta"] | undefined,
	formTextLabel?: GraphQLTypes["FieldMeta"] | undefined,
	submitLabel?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	imageTextList?: GraphQLTypes["FieldMeta"] | undefined,
	minimalize?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	successTitle?: GraphQLTypes["FieldMeta"] | undefined,
	successText?: GraphQLTypes["FieldMeta"] | undefined,
	successBtnLabel?: GraphQLTypes["FieldMeta"] | undefined,
	successImage?: GraphQLTypes["FieldMeta"] | undefined,
	successOtherJobsTitle?: GraphQLTypes["FieldMeta"] | undefined,
	successOtherJobsCategoryTitle?: GraphQLTypes["FieldMeta"] | undefined,
	successOtherJobsButtonTitle?: GraphQLTypes["FieldMeta"] | undefined,
	successOtherJobsSelectionTitle?: GraphQLTypes["FieldMeta"] | undefined,
	successOtherJobsSelectionYesButton?: GraphQLTypes["FieldMeta"] | undefined,
	successOtherJobsSelectionNoButton?: GraphQLTypes["FieldMeta"] | undefined,
	fileRemoveBtnLabel?: GraphQLTypes["FieldMeta"] | undefined,
	gdprLabel?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobsForm"]: {
	__typename: "JobsForm",
	_meta?: GraphQLTypes["JobsFormMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["JobsFormLocale"]>,
	fileIlustration?: GraphQLTypes["Image"] | undefined,
	localesByLocale?: GraphQLTypes["JobsFormLocale"] | undefined,
	localesByImageTextList?: GraphQLTypes["JobsFormLocale"] | undefined,
	localesByLogo?: GraphQLTypes["JobsFormLocale"] | undefined,
	localesBySuccessImage?: GraphQLTypes["JobsFormLocale"] | undefined,
	paginateLocales: GraphQLTypes["JobsFormLocaleConnection"]
};
	["JobsFormMeta"]: {
	__typename: "JobsFormMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	fileIlustration?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobsFormLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["JobsFormLocalesByImageTextListUniqueWhere"]: {
		imageTextList?: GraphQLTypes["ImageTextListUniqueWhere"] | undefined
};
	["JobsFormLocalesByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["JobsFormLocalesBySuccessImageUniqueWhere"]: {
		successImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["JobsFormLocaleConnection"]: {
	__typename: "JobsFormLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobsFormLocaleEdge"]>
};
	["JobsFormLocaleEdge"]: {
	__typename: "JobsFormLocaleEdge",
	node: GraphQLTypes["JobsFormLocale"]
};
	["ImageTextList"]: {
	__typename: "ImageTextList",
	_meta?: GraphQLTypes["ImageTextListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ImageTextItem"]>,
	itemsByImage?: GraphQLTypes["ImageTextItem"] | undefined,
	paginateItems: GraphQLTypes["ImageTextItemConnection"]
};
	["ImageTextListMeta"]: {
	__typename: "ImageTextListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageTextItem"]: {
	__typename: "ImageTextItem",
	_meta?: GraphQLTypes["ImageTextItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order?: number | undefined,
	title?: string | undefined,
	list?: GraphQLTypes["ImageTextList"] | undefined,
	image?: GraphQLTypes["Image"] | undefined
};
	["ImageTextItemMeta"]: {
	__typename: "ImageTextItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageTextItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["ImageTextListOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["ImageTextListItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["ImageTextItemConnection"]: {
	__typename: "ImageTextItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageTextItemEdge"]>
};
	["ImageTextItemEdge"]: {
	__typename: "ImageTextItemEdge",
	node: GraphQLTypes["ImageTextItem"]
};
	["TileOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	bonusBanner?: GraphQLTypes["BonusBannerLocaleOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	lightBoxTitle?: GraphQLTypes["OrderDirection"] | undefined,
	lightBoxText?: GraphQLTypes["OrderDirection"] | undefined,
	ligthBoxMedia?: GraphQLTypes["MediumListOrderBy"] | undefined,
	lightBoxSectionTitle?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	lightBoxLinkLabel?: GraphQLTypes["OrderDirection"] | undefined,
	lightBoxForm?: GraphQLTypes["JobsFormLocaleOrderBy"] | undefined
};
	["BonusBannerLocaleTilesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["BonusBannerLocaleTilesByLigthBoxMediaUniqueWhere"]: {
		ligthBoxMedia?: GraphQLTypes["MediumListUniqueWhere"] | undefined
};
	["TileConnection"]: {
	__typename: "TileConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TileEdge"]>
};
	["TileEdge"]: {
	__typename: "TileEdge",
	node: GraphQLTypes["Tile"]
};
	["SideBySide"]: {
	__typename: "SideBySide",
	_meta?: GraphQLTypes["SideBySideMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["SideBySideItem"]>,
	background: GraphQLTypes["Background"],
	alignment: GraphQLTypes["ContentAlignment"],
	mediumSize: GraphQLTypes["MediumSize"],
	itemsByMedia?: GraphQLTypes["SideBySideItem"] | undefined,
	paginateItems: GraphQLTypes["SideBySideItemConnection"]
};
	["SideBySideMeta"]: {
	__typename: "SideBySideMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	background?: GraphQLTypes["FieldMeta"] | undefined,
	alignment?: GraphQLTypes["FieldMeta"] | undefined,
	mediumSize?: GraphQLTypes["FieldMeta"] | undefined
};
	["SideBySideItem"]: {
	__typename: "SideBySideItem",
	_meta?: GraphQLTypes["SideBySideItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order?: number | undefined,
	title?: string | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["SideBySide"] | undefined,
	media?: GraphQLTypes["MediumList"] | undefined,
	formButtonLabel?: string | undefined,
	type: GraphQLTypes["SideBySideItemType"],
	link?: GraphQLTypes["Link"] | undefined,
	jobsForm?: GraphQLTypes["JobsFormLocale"] | undefined,
	textNew?: string | undefined
};
	["SideBySideItemMeta"]: {
	__typename: "SideBySideItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	media?: GraphQLTypes["FieldMeta"] | undefined,
	formButtonLabel?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	jobsForm?: GraphQLTypes["FieldMeta"] | undefined,
	textNew?: GraphQLTypes["FieldMeta"] | undefined
};
	["SideBySideItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["SideBySideOrderBy"] | undefined,
	media?: GraphQLTypes["MediumListOrderBy"] | undefined,
	formButtonLabel?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined,
	jobsForm?: GraphQLTypes["JobsFormLocaleOrderBy"] | undefined,
	textNew?: GraphQLTypes["OrderDirection"] | undefined
};
	["SideBySideItemsByMediaUniqueWhere"]: {
		media?: GraphQLTypes["MediumListUniqueWhere"] | undefined
};
	["SideBySideItemConnection"]: {
	__typename: "SideBySideItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SideBySideItemEdge"]>
};
	["SideBySideItemEdge"]: {
	__typename: "SideBySideItemEdge",
	node: GraphQLTypes["SideBySideItem"]
};
	["Gallery"]: {
	__typename: "Gallery",
	_meta?: GraphQLTypes["GalleryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["GalleryItem"]>,
	itemsByImage?: GraphQLTypes["GalleryItem"] | undefined,
	paginateItems: GraphQLTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
	__typename: "GalleryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["GalleryItem"]: {
	__typename: "GalleryItem",
	_meta?: GraphQLTypes["GalleryItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order?: number | undefined,
	list?: GraphQLTypes["Gallery"] | undefined,
	image?: GraphQLTypes["Image"] | undefined
};
	["GalleryItemMeta"]: {
	__typename: "GalleryItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined
};
	["GalleryItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["GalleryOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["GalleryItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["GalleryItemConnection"]: {
	__typename: "GalleryItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryItemEdge"]>
};
	["GalleryItemEdge"]: {
	__typename: "GalleryItemEdge",
	node: GraphQLTypes["GalleryItem"]
};
	["ContentReferenceLinkablesByItemUniqueWhere"]: {
		item?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["ContentReferenceLinkableItemConnection"]: {
	__typename: "ContentReferenceLinkableItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceLinkableItemEdge"]>
};
	["ContentReferenceLinkableItemEdge"]: {
	__typename: "ContentReferenceLinkableItemEdge",
	node: GraphQLTypes["ContentReferenceLinkableItem"]
};
	["ContentBlockReferencesByLinkablesUniqueWhere"]: {
		linkables?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["ContentBlockReferencesByMediaUniqueWhere"]: {
		media?: GraphQLTypes["MediumListUniqueWhere"] | undefined
};
	["ContentReferenceConnection"]: {
	__typename: "ContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
	__typename: "ContentReferenceEdge",
	node: GraphQLTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: GraphQLTypes["Image"] | undefined
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	ogTitle?: GraphQLTypes["FieldMeta"] | undefined,
	ogDescription?: GraphQLTypes["FieldMeta"] | undefined,
	noIndex?: GraphQLTypes["FieldMeta"] | undefined,
	noFollow?: GraphQLTypes["FieldMeta"] | undefined,
	ogImage?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessPageLocale"]: {
	__typename: "BusinessPageLocale",
	_meta?: GraphQLTypes["BusinessPageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["BusinessPage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	stickyBar?: GraphQLTypes["StickyBar"] | undefined,
	infoBox?: GraphQLTypes["InfoBox"] | undefined
};
	["BusinessPageLocaleMeta"]: {
	__typename: "BusinessPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	subtitle?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	stickyBar?: GraphQLTypes["FieldMeta"] | undefined,
	infoBox?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessPage"]: {
	__typename: "BusinessPage",
	_meta?: GraphQLTypes["BusinessPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["BusinessPageLocale"]>,
	theme?: GraphQLTypes["Theme"] | undefined,
	isLokal?: boolean | undefined,
	tabidooId?: string | undefined,
	headerColor?: string | undefined,
	recruitisOfficeId?: string | undefined,
	localesByLocale?: GraphQLTypes["BusinessPageLocale"] | undefined,
	localesByContent?: GraphQLTypes["BusinessPageLocale"] | undefined,
	localesBySeo?: GraphQLTypes["BusinessPageLocale"] | undefined,
	localesByLink?: GraphQLTypes["BusinessPageLocale"] | undefined,
	localesByImage?: GraphQLTypes["BusinessPageLocale"] | undefined,
	paginateLocales: GraphQLTypes["BusinessPageLocaleConnection"]
};
	["BusinessPageMeta"]: {
	__typename: "BusinessPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	theme?: GraphQLTypes["FieldMeta"] | undefined,
	isLokal?: GraphQLTypes["FieldMeta"] | undefined,
	tabidooId?: GraphQLTypes["FieldMeta"] | undefined,
	headerColor?: GraphQLTypes["FieldMeta"] | undefined,
	recruitisOfficeId?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["BusinessPageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["BusinessPageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["BusinessPageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["BusinessPageLocalesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["BusinessPageLocaleConnection"]: {
	__typename: "BusinessPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessPageLocaleEdge"]>
};
	["BusinessPageLocaleEdge"]: {
	__typename: "BusinessPageLocaleEdge",
	node: GraphQLTypes["BusinessPageLocale"]
};
	["StickyBar"]: {
	__typename: "StickyBar",
	_meta?: GraphQLTypes["StickyBarMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	formButtonLabel?: string | undefined,
	jobsForm?: GraphQLTypes["JobsFormLocale"] | undefined
};
	["StickyBarMeta"]: {
	__typename: "StickyBarMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	formButtonLabel?: GraphQLTypes["FieldMeta"] | undefined,
	jobsForm?: GraphQLTypes["FieldMeta"] | undefined
};
	["InfoBox"]: {
	__typename: "InfoBox",
	_meta?: GraphQLTypes["InfoBoxMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	logoSize: GraphQLTypes["LogoSize"],
	logo?: GraphQLTypes["Image"] | undefined,
	locales: Array<GraphQLTypes["InfoBoxLocale"]>,
	localesByLocale?: GraphQLTypes["InfoBoxLocale"] | undefined,
	paginateLocales: GraphQLTypes["InfoBoxLocaleConnection"]
};
	["InfoBoxMeta"]: {
	__typename: "InfoBoxMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	logoSize?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["InfoBoxLocale"]: {
	__typename: "InfoBoxLocale",
	_meta?: GraphQLTypes["InfoBoxLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	root?: GraphQLTypes["InfoBox"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	openingHours?: GraphQLTypes["TextList"] | undefined,
	addressLink?: string | undefined
};
	["InfoBoxLocaleMeta"]: {
	__typename: "InfoBoxLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined,
	web?: GraphQLTypes["FieldMeta"] | undefined,
	instagram?: GraphQLTypes["FieldMeta"] | undefined,
	facebook?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	openingHours?: GraphQLTypes["FieldMeta"] | undefined,
	addressLink?: GraphQLTypes["FieldMeta"] | undefined
};
	["InfoBoxLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	address?: GraphQLTypes["OrderDirection"] | undefined,
	web?: GraphQLTypes["OrderDirection"] | undefined,
	instagram?: GraphQLTypes["OrderDirection"] | undefined,
	facebook?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["InfoBoxOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	openingHours?: GraphQLTypes["TextListOrderBy"] | undefined,
	addressLink?: GraphQLTypes["OrderDirection"] | undefined
};
	["InfoBoxLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["InfoBoxLocaleConnection"]: {
	__typename: "InfoBoxLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InfoBoxLocaleEdge"]>
};
	["InfoBoxLocaleEdge"]: {
	__typename: "InfoBoxLocaleEdge",
	node: GraphQLTypes["InfoBoxLocale"]
};
	["JobPageLocale"]: {
	__typename: "JobPageLocale",
	_meta?: GraphQLTypes["JobPageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["JobPage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	keyInfo?: GraphQLTypes["KeyInfoList"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	email?: string | undefined,
	stickyBar?: GraphQLTypes["StickyBar"] | undefined,
	mobileImage?: GraphQLTypes["Image"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined
};
	["JobPageLocaleMeta"]: {
	__typename: "JobPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	keyInfo?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	stickyBar?: GraphQLTypes["FieldMeta"] | undefined,
	mobileImage?: GraphQLTypes["FieldMeta"] | undefined,
	isSyncedToTabidoo?: GraphQLTypes["FieldMeta"] | undefined,
	tabidooId?: GraphQLTypes["FieldMeta"] | undefined,
	recruitisJobId?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobPage"]: {
	__typename: "JobPage",
	_meta?: GraphQLTypes["JobPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["JobPageLocale"]>,
	theme?: GraphQLTypes["Theme"] | undefined,
	contractType?: GraphQLTypes["ContractType"] | undefined,
	jobCity?: GraphQLTypes["JobCity"] | undefined,
	isActive?: boolean | undefined,
	jobPosition?: GraphQLTypes["JobPosition"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: GraphQLTypes["BusinessPage"] | undefined,
	headerColor?: string | undefined,
	siteType: GraphQLTypes["SiteType"],
	isHiddenFromListing?: boolean | undefined,
	localesByLocale?: GraphQLTypes["JobPageLocale"] | undefined,
	localesByImage?: GraphQLTypes["JobPageLocale"] | undefined,
	localesByKeyInfo?: GraphQLTypes["JobPageLocale"] | undefined,
	localesByContent?: GraphQLTypes["JobPageLocale"] | undefined,
	localesBySeo?: GraphQLTypes["JobPageLocale"] | undefined,
	localesByLink?: GraphQLTypes["JobPageLocale"] | undefined,
	localesByMobileImage?: GraphQLTypes["JobPageLocale"] | undefined,
	paginateLocales: GraphQLTypes["JobPageLocaleConnection"]
};
	["JobPageMeta"]: {
	__typename: "JobPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	theme?: GraphQLTypes["FieldMeta"] | undefined,
	contractType?: GraphQLTypes["FieldMeta"] | undefined,
	jobCity?: GraphQLTypes["FieldMeta"] | undefined,
	isActive?: GraphQLTypes["FieldMeta"] | undefined,
	jobPosition?: GraphQLTypes["FieldMeta"] | undefined,
	publishedAt?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	isSyncedToTabidoo?: GraphQLTypes["FieldMeta"] | undefined,
	business?: GraphQLTypes["FieldMeta"] | undefined,
	headerColor?: GraphQLTypes["FieldMeta"] | undefined,
	siteType?: GraphQLTypes["FieldMeta"] | undefined,
	isHiddenFromListing?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContractType"]: {
	__typename: "ContractType",
	_meta?: GraphQLTypes["ContractTypeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["ContractTypeLocale"]>,
	localesByLocale?: GraphQLTypes["ContractTypeLocale"] | undefined,
	paginateLocales: GraphQLTypes["ContractTypeLocaleConnection"]
};
	["ContractTypeMeta"]: {
	__typename: "ContractTypeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContractTypeLocale"]: {
	__typename: "ContractTypeLocale",
	_meta?: GraphQLTypes["ContractTypeLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type?: string | undefined,
	root?: GraphQLTypes["ContractType"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	slug: string
};
	["ContractTypeLocaleMeta"]: {
	__typename: "ContractTypeLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	slug?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContractTypeLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["ContractTypeOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	slug?: GraphQLTypes["OrderDirection"] | undefined
};
	["ContractTypeLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ContractTypeLocaleConnection"]: {
	__typename: "ContractTypeLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContractTypeLocaleEdge"]>
};
	["ContractTypeLocaleEdge"]: {
	__typename: "ContractTypeLocaleEdge",
	node: GraphQLTypes["ContractTypeLocale"]
};
	["JobCity"]: {
	__typename: "JobCity",
	_meta?: GraphQLTypes["JobCityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["JobCityLocale"]>,
	localesByLocale?: GraphQLTypes["JobCityLocale"] | undefined,
	paginateLocales: GraphQLTypes["JobCityLocaleConnection"]
};
	["JobCityMeta"]: {
	__typename: "JobCityMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobCityLocale"]: {
	__typename: "JobCityLocale",
	_meta?: GraphQLTypes["JobCityLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["JobCity"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	name?: string | undefined,
	slug: string
};
	["JobCityLocaleMeta"]: {
	__typename: "JobCityLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	slug?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobCityLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["JobCityOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	slug?: GraphQLTypes["OrderDirection"] | undefined
};
	["JobCityLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["JobCityLocaleConnection"]: {
	__typename: "JobCityLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobCityLocaleEdge"]>
};
	["JobCityLocaleEdge"]: {
	__typename: "JobCityLocaleEdge",
	node: GraphQLTypes["JobCityLocale"]
};
	["JobPosition"]: {
	__typename: "JobPosition",
	_meta?: GraphQLTypes["JobPositionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["JobPositionLocale"]>,
	jobs: Array<GraphQLTypes["JobPage"]>,
	localesByLocale?: GraphQLTypes["JobPositionLocale"] | undefined,
	jobsByLocales?: GraphQLTypes["JobPage"] | undefined,
	paginateLocales: GraphQLTypes["JobPositionLocaleConnection"],
	paginateJobs: GraphQLTypes["JobPageConnection"]
};
	["JobPositionMeta"]: {
	__typename: "JobPositionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	jobs?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobPositionLocale"]: {
	__typename: "JobPositionLocale",
	_meta?: GraphQLTypes["JobPositionLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type?: string | undefined,
	root?: GraphQLTypes["JobPosition"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	slug: string
};
	["JobPositionLocaleMeta"]: {
	__typename: "JobPositionLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	slug?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobPositionLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["JobPositionOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	slug?: GraphQLTypes["OrderDirection"] | undefined
};
	["JobPositionLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["JobPositionJobsByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined
};
	["JobPositionLocaleConnection"]: {
	__typename: "JobPositionLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobPositionLocaleEdge"]>
};
	["JobPositionLocaleEdge"]: {
	__typename: "JobPositionLocaleEdge",
	node: GraphQLTypes["JobPositionLocale"]
};
	["JobPageConnection"]: {
	__typename: "JobPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobPageEdge"]>
};
	["JobPageEdge"]: {
	__typename: "JobPageEdge",
	node: GraphQLTypes["JobPage"]
};
	["JobPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["JobPageLocalesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["JobPageLocalesByKeyInfoUniqueWhere"]: {
		keyInfo?: GraphQLTypes["KeyInfoListUniqueWhere"] | undefined
};
	["JobPageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["JobPageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["JobPageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["JobPageLocalesByMobileImageUniqueWhere"]: {
		mobileImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["JobPageLocaleConnection"]: {
	__typename: "JobPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobPageLocaleEdge"]>
};
	["JobPageLocaleEdge"]: {
	__typename: "JobPageLocaleEdge",
	node: GraphQLTypes["JobPageLocale"]
};
	["KeyInfoList"]: {
	__typename: "KeyInfoList",
	_meta?: GraphQLTypes["KeyInfoListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["KeyInfoItem"]>,
	paginateItems: GraphQLTypes["KeyInfoItemConnection"]
};
	["KeyInfoListMeta"]: {
	__typename: "KeyInfoListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["KeyInfoItem"]: {
	__typename: "KeyInfoItem",
	_meta?: GraphQLTypes["KeyInfoItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order?: number | undefined,
	keyInfo?: string | undefined,
	list?: GraphQLTypes["KeyInfoList"] | undefined,
	icon?: GraphQLTypes["Icon"] | undefined
};
	["KeyInfoItemMeta"]: {
	__typename: "KeyInfoItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	keyInfo?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined
};
	["Icon"]: {
	__typename: "Icon",
	_meta?: GraphQLTypes["IconMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	icon?: GraphQLTypes["Image"] | undefined
};
	["IconMeta"]: {
	__typename: "IconMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined
};
	["KeyInfoItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	keyInfo?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["KeyInfoListOrderBy"] | undefined,
	icon?: GraphQLTypes["IconOrderBy"] | undefined
};
	["IconOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	icon?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["KeyInfoItemConnection"]: {
	__typename: "KeyInfoItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["KeyInfoItemEdge"]>
};
	["KeyInfoItemEdge"]: {
	__typename: "KeyInfoItemEdge",
	node: GraphQLTypes["KeyInfoItem"]
};
	["HomePageLocale"]: {
	__typename: "HomePageLocale",
	_meta?: GraphQLTypes["HomePageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	root?: GraphQLTypes["HomePage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	button?: GraphQLTypes["Link"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	logo?: GraphQLTypes["Image"] | undefined,
	siteSwitcher?: GraphQLTypes["SiteSwitcher"] | undefined,
	gallery?: GraphQLTypes["Gallery"] | undefined,
	stickyBar?: GraphQLTypes["StickyBar"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["Gallery"] | undefined
};
	["HomePageLocaleMeta"]: {
	__typename: "HomePageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	button?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	siteSwitcher?: GraphQLTypes["FieldMeta"] | undefined,
	gallery?: GraphQLTypes["FieldMeta"] | undefined,
	stickyBar?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	ilustration?: GraphQLTypes["FieldMeta"] | undefined
};
	["HomePage"]: {
	__typename: "HomePage",
	_meta?: GraphQLTypes["HomePageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["HomePageLocale"]>,
	theme?: GraphQLTypes["Theme"] | undefined,
	localesByLocale?: GraphQLTypes["HomePageLocale"] | undefined,
	localesByButton?: GraphQLTypes["HomePageLocale"] | undefined,
	localesByContent?: GraphQLTypes["HomePageLocale"] | undefined,
	localesBySeo?: GraphQLTypes["HomePageLocale"] | undefined,
	localesByLink?: GraphQLTypes["HomePageLocale"] | undefined,
	localesByLogo?: GraphQLTypes["HomePageLocale"] | undefined,
	localesBySiteSwitcher?: GraphQLTypes["HomePageLocale"] | undefined,
	localesByIlustration?: GraphQLTypes["HomePageLocale"] | undefined,
	paginateLocales: GraphQLTypes["HomePageLocaleConnection"]
};
	["HomePageMeta"]: {
	__typename: "HomePageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	theme?: GraphQLTypes["FieldMeta"] | undefined
};
	["HomePageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["HomePageLocalesByButtonUniqueWhere"]: {
		button?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["HomePageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["HomePageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["HomePageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["HomePageLocalesByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["HomePageLocalesBySiteSwitcherUniqueWhere"]: {
		siteSwitcher?: GraphQLTypes["SiteSwitcherUniqueWhere"] | undefined
};
	["HomePageLocalesByIlustrationUniqueWhere"]: {
		ilustration?: GraphQLTypes["GalleryUniqueWhere"] | undefined
};
	["HomePageLocaleConnection"]: {
	__typename: "HomePageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageLocaleEdge"]>
};
	["HomePageLocaleEdge"]: {
	__typename: "HomePageLocaleEdge",
	node: GraphQLTypes["HomePageLocale"]
};
	["SiteSwitcher"]: {
	__typename: "SiteSwitcher",
	_meta?: GraphQLTypes["SiteSwitcherMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	theme?: GraphQLTypes["Theme"] | undefined,
	headerColor?: string | undefined
};
	["SiteSwitcherMeta"]: {
	__typename: "SiteSwitcherMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	theme?: GraphQLTypes["FieldMeta"] | undefined,
	headerColor?: GraphQLTypes["FieldMeta"] | undefined
};
	["HomePageLokalLocale"]: {
	__typename: "HomePageLokalLocale",
	_meta?: GraphQLTypes["HomePageLokalLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	root?: GraphQLTypes["HomePageLokal"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	logo?: GraphQLTypes["Image"] | undefined,
	button?: GraphQLTypes["Link"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	siteSwitcher?: GraphQLTypes["SiteSwitcher"] | undefined,
	gallery?: GraphQLTypes["Gallery"] | undefined,
	stickyBar?: GraphQLTypes["StickyBar"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["Gallery"] | undefined
};
	["HomePageLokalLocaleMeta"]: {
	__typename: "HomePageLokalLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	button?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	siteSwitcher?: GraphQLTypes["FieldMeta"] | undefined,
	gallery?: GraphQLTypes["FieldMeta"] | undefined,
	stickyBar?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	ilustration?: GraphQLTypes["FieldMeta"] | undefined
};
	["HomePageLokal"]: {
	__typename: "HomePageLokal",
	_meta?: GraphQLTypes["HomePageLokalMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["HomePageLokalLocale"]>,
	theme?: GraphQLTypes["Theme"] | undefined,
	localesByLocale?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	localesByLogo?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	localesByButton?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	localesByContent?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	localesBySeo?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	localesByLink?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	localesBySiteSwitcher?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	localesByIlustration?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	paginateLocales: GraphQLTypes["HomePageLokalLocaleConnection"]
};
	["HomePageLokalMeta"]: {
	__typename: "HomePageLokalMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	theme?: GraphQLTypes["FieldMeta"] | undefined
};
	["HomePageLokalLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["HomePageLokalLocalesByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["HomePageLokalLocalesByButtonUniqueWhere"]: {
		button?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["HomePageLokalLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["HomePageLokalLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["HomePageLokalLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["HomePageLokalLocalesBySiteSwitcherUniqueWhere"]: {
		siteSwitcher?: GraphQLTypes["SiteSwitcherUniqueWhere"] | undefined
};
	["HomePageLokalLocalesByIlustrationUniqueWhere"]: {
		ilustration?: GraphQLTypes["GalleryUniqueWhere"] | undefined
};
	["HomePageLokalLocaleConnection"]: {
	__typename: "HomePageLokalLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageLokalLocaleEdge"]>
};
	["HomePageLokalLocaleEdge"]: {
	__typename: "HomePageLokalLocaleEdge",
	node: GraphQLTypes["HomePageLokalLocale"]
};
	["FooterLinkOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["RecommendationFormLocale"]: {
	__typename: "RecommendationFormLocale",
	_meta?: GraphQLTypes["RecommendationFormLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	root?: GraphQLTypes["RecommendationForm"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["RecommendationFormLocaleMeta"]: {
	__typename: "RecommendationFormLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	subtitle?: GraphQLTypes["FieldMeta"] | undefined,
	yourEmailLabel?: GraphQLTypes["FieldMeta"] | undefined,
	theirEmailLabel?: GraphQLTypes["FieldMeta"] | undefined,
	yourName?: GraphQLTypes["FieldMeta"] | undefined,
	sendBtnLabel?: GraphQLTypes["FieldMeta"] | undefined,
	successTitle?: GraphQLTypes["FieldMeta"] | undefined,
	successSubtitle?: GraphQLTypes["FieldMeta"] | undefined,
	successButtonClose?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["RecommendationForm"]: {
	__typename: "RecommendationForm",
	_meta?: GraphQLTypes["RecommendationFormMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["RecommendationFormLocale"]>,
	successImage?: GraphQLTypes["Image"] | undefined,
	localesByLocale?: GraphQLTypes["RecommendationFormLocale"] | undefined,
	paginateLocales: GraphQLTypes["RecommendationFormLocaleConnection"]
};
	["RecommendationFormMeta"]: {
	__typename: "RecommendationFormMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	successImage?: GraphQLTypes["FieldMeta"] | undefined
};
	["RecommendationFormLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["RecommendationFormLocaleConnection"]: {
	__typename: "RecommendationFormLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RecommendationFormLocaleEdge"]>
};
	["RecommendationFormLocaleEdge"]: {
	__typename: "RecommendationFormLocaleEdge",
	node: GraphQLTypes["RecommendationFormLocale"]
};
	["FooterLinkConnection"]: {
	__typename: "FooterLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterLinkEdge"]>
};
	["FooterLinkEdge"]: {
	__typename: "FooterLinkEdge",
	node: GraphQLTypes["FooterLink"]
};
	["HeaderLocale"]: {
	__typename: "HeaderLocale",
	_meta?: GraphQLTypes["HeaderLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["Header"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business: Array<GraphQLTypes["Business"]>,
	lokalEnterprise: Array<GraphQLTypes["Business"]>,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: GraphQLTypes["Link"] | undefined,
	lokalLink?: GraphQLTypes["Link"] | undefined,
	paginateBusiness: GraphQLTypes["BusinessConnection"],
	paginateLokalEnterprise: GraphQLTypes["BusinessConnection"]
};
	["HeaderLocaleMeta"]: {
	__typename: "HeaderLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	menuLabel?: GraphQLTypes["FieldMeta"] | undefined,
	menuTitle?: GraphQLTypes["FieldMeta"] | undefined,
	menuText?: GraphQLTypes["FieldMeta"] | undefined,
	business?: GraphQLTypes["FieldMeta"] | undefined,
	lokalEnterprise?: GraphQLTypes["FieldMeta"] | undefined,
	businessSectionTitle?: GraphQLTypes["FieldMeta"] | undefined,
	lokalSectionTitle?: GraphQLTypes["FieldMeta"] | undefined,
	businessLink?: GraphQLTypes["FieldMeta"] | undefined,
	lokalLink?: GraphQLTypes["FieldMeta"] | undefined
};
	["Header"]: {
	__typename: "Header",
	_meta?: GraphQLTypes["HeaderMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["HeaderLocale"]>,
	logo?: GraphQLTypes["Image"] | undefined,
	logoMenu?: GraphQLTypes["Image"] | undefined,
	localesByLocale?: GraphQLTypes["HeaderLocale"] | undefined,
	localesByBusinessLink?: GraphQLTypes["HeaderLocale"] | undefined,
	localesByLokalLink?: GraphQLTypes["HeaderLocale"] | undefined,
	paginateLocales: GraphQLTypes["HeaderLocaleConnection"]
};
	["HeaderMeta"]: {
	__typename: "HeaderMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	logoMenu?: GraphQLTypes["FieldMeta"] | undefined
};
	["HeaderLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["HeaderOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	menuLabel?: GraphQLTypes["OrderDirection"] | undefined,
	menuTitle?: GraphQLTypes["OrderDirection"] | undefined,
	menuText?: GraphQLTypes["OrderDirection"] | undefined,
	businessSectionTitle?: GraphQLTypes["OrderDirection"] | undefined,
	lokalSectionTitle?: GraphQLTypes["OrderDirection"] | undefined,
	businessLink?: GraphQLTypes["LinkOrderBy"] | undefined,
	lokalLink?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["HeaderOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined,
	logoMenu?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["HeaderLocalesByBusinessLinkUniqueWhere"]: {
		businessLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["HeaderLocalesByLokalLinkUniqueWhere"]: {
		lokalLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["HeaderLocaleConnection"]: {
	__typename: "HeaderLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderLocaleEdge"]>
};
	["HeaderLocaleEdge"]: {
	__typename: "HeaderLocaleEdge",
	node: GraphQLTypes["HeaderLocale"]
};
	["Business"]: {
	__typename: "Business",
	_meta?: GraphQLTypes["BusinessMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	logo?: GraphQLTypes["Image"] | undefined,
	link?: GraphQLTypes["Link"] | undefined
};
	["BusinessMeta"]: {
	__typename: "BusinessMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["BusinessConnection"]: {
	__typename: "BusinessConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessEdge"]>
};
	["BusinessEdge"]: {
	__typename: "BusinessEdge",
	node: GraphQLTypes["Business"]
};
	["SeoDefaultLocale"]: {
	__typename: "SeoDefaultLocale",
	_meta?: GraphQLTypes["SeoDefaultLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SeoDefault"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined
};
	["SeoDefaultLocaleMeta"]: {
	__typename: "SeoDefaultLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined
};
	["SeoDefault"]: {
	__typename: "SeoDefault",
	_meta?: GraphQLTypes["SeoDefaultMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["SeoDefaultLocale"]>,
	localesByLocale?: GraphQLTypes["SeoDefaultLocale"] | undefined,
	localesBySeo?: GraphQLTypes["SeoDefaultLocale"] | undefined,
	paginateLocales: GraphQLTypes["SeoDefaultLocaleConnection"]
};
	["SeoDefaultMeta"]: {
	__typename: "SeoDefaultMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["SeoDefaultLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["SeoDefaultOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined
};
	["SeoDefaultOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["SeoDefaultLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["SeoDefaultLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["SeoDefaultLocaleConnection"]: {
	__typename: "SeoDefaultLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoDefaultLocaleEdge"]>
};
	["SeoDefaultLocaleEdge"]: {
	__typename: "SeoDefaultLocaleEdge",
	node: GraphQLTypes["SeoDefaultLocale"]
};
	["JobsFilterLocale"]: {
	__typename: "JobsFilterLocale",
	_meta?: GraphQLTypes["JobsFilterLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	root?: GraphQLTypes["JobsFilter"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: GraphQLTypes["JobsFormLocale"] | undefined,
	bannerImage?: GraphQLTypes["Image"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: GraphQLTypes["Image"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined
};
	["JobsFilterLocaleMeta"]: {
	__typename: "JobsFilterLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	jobPositionLabel?: GraphQLTypes["FieldMeta"] | undefined,
	jobContractLabel?: GraphQLTypes["FieldMeta"] | undefined,
	jobCityLabel?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	bannerTitle?: GraphQLTypes["FieldMeta"] | undefined,
	bannerFormLabel?: GraphQLTypes["FieldMeta"] | undefined,
	bannerJobsForm?: GraphQLTypes["FieldMeta"] | undefined,
	bannerImage?: GraphQLTypes["FieldMeta"] | undefined,
	noJobTitle?: GraphQLTypes["FieldMeta"] | undefined,
	noJobBtnLabel?: GraphQLTypes["FieldMeta"] | undefined,
	noJobImage?: GraphQLTypes["FieldMeta"] | undefined,
	noJobTitleForSpecificBusiness?: GraphQLTypes["FieldMeta"] | undefined,
	deactivatedJob?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobsFilter"]: {
	__typename: "JobsFilter",
	_meta?: GraphQLTypes["JobsFilterMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["JobsFilterLocale"]>,
	localesByLocale?: GraphQLTypes["JobsFilterLocale"] | undefined,
	localesByBannerJobsForm?: GraphQLTypes["JobsFilterLocale"] | undefined,
	localesByBannerImage?: GraphQLTypes["JobsFilterLocale"] | undefined,
	localesByNoJobImage?: GraphQLTypes["JobsFilterLocale"] | undefined,
	paginateLocales: GraphQLTypes["JobsFilterLocaleConnection"]
};
	["JobsFilterMeta"]: {
	__typename: "JobsFilterMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobsFilterLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	jobPositionLabel?: GraphQLTypes["OrderDirection"] | undefined,
	jobContractLabel?: GraphQLTypes["OrderDirection"] | undefined,
	jobCityLabel?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["JobsFilterOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	bannerTitle?: GraphQLTypes["OrderDirection"] | undefined,
	bannerFormLabel?: GraphQLTypes["OrderDirection"] | undefined,
	bannerJobsForm?: GraphQLTypes["JobsFormLocaleOrderBy"] | undefined,
	bannerImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	noJobTitle?: GraphQLTypes["OrderDirection"] | undefined,
	noJobBtnLabel?: GraphQLTypes["OrderDirection"] | undefined,
	noJobImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	noJobTitleForSpecificBusiness?: GraphQLTypes["OrderDirection"] | undefined,
	deactivatedJob?: GraphQLTypes["OrderDirection"] | undefined
};
	["JobsFilterOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["JobsFilterLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["JobsFilterLocalesByBannerJobsFormUniqueWhere"]: {
		bannerJobsForm?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined
};
	["JobsFilterLocalesByBannerImageUniqueWhere"]: {
		bannerImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["JobsFilterLocalesByNoJobImageUniqueWhere"]: {
		noJobImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["JobsFilterLocaleConnection"]: {
	__typename: "JobsFilterLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobsFilterLocaleEdge"]>
};
	["JobsFilterLocaleEdge"]: {
	__typename: "JobsFilterLocaleEdge",
	node: GraphQLTypes["JobsFilterLocale"]
};
	["GeneralLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["GeneralOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	cornerBanner?: GraphQLTypes["CornerBannerOrderBy"] | undefined
};
	["GeneralOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["CornerBannerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	isActive?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["TranslationLocale"]: {
	__typename: "TranslationLocale",
	_meta?: GraphQLTypes["TranslationLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	value: string,
	root?: GraphQLTypes["Translation"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["TranslationLocaleMeta"]: {
	__typename: "TranslationLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	value?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["Translation"]: {
	__typename: "Translation",
	_meta?: GraphQLTypes["TranslationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	key: string,
	locales: Array<GraphQLTypes["TranslationLocale"]>,
	isTextarea: boolean,
	localesByLocale?: GraphQLTypes["TranslationLocale"] | undefined,
	paginateLocales: GraphQLTypes["TranslationLocaleConnection"]
};
	["TranslationMeta"]: {
	__typename: "TranslationMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	key?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	isTextarea?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	value?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["TranslationOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["TranslationOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	key?: GraphQLTypes["OrderDirection"] | undefined,
	isTextarea?: GraphQLTypes["OrderDirection"] | undefined
};
	["TranslationLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["TranslationLocaleConnection"]: {
	__typename: "TranslationLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationLocaleEdge"]>
};
	["TranslationLocaleEdge"]: {
	__typename: "TranslationLocaleEdge",
	node: GraphQLTypes["TranslationLocale"]
};
	["LocaleFootersByRootUniqueWhere"]: {
		root?: GraphQLTypes["FooterUniqueWhere"] | undefined
};
	["LocaleFootersByTermsAndConditionsUniqueWhere"]: {
		termsAndConditions?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleFootersByBannerImageUniqueWhere"]: {
		bannerImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleFootersByBannerLinkUniqueWhere"]: {
		bannerLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleFootersByJobsFormUniqueWhere"]: {
		jobsForm?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined
};
	["LocaleFootersByCopyrightLinkUniqueWhere"]: {
		copyrightLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleFootersByRecommendationFormUniqueWhere"]: {
		recommendationForm?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined
};
	["LocaleFootersByBannerSecondLinkUniqueWhere"]: {
		bannerSecondLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleFootersByInstagramLinkUniqueWhere"]: {
		instagramLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleGenericPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["GenericPageUniqueWhere"] | undefined
};
	["LocaleGenericPagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleGenericPagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleGenericPagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleGenericPagesByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleGenericPagesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleHeadersByRootUniqueWhere"]: {
		root?: GraphQLTypes["HeaderUniqueWhere"] | undefined
};
	["LocaleHeadersByBusinessLinkUniqueWhere"]: {
		businessLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleHeadersByLokalLinkUniqueWhere"]: {
		lokalLink?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleSeoDefaultsByRootUniqueWhere"]: {
		root?: GraphQLTypes["SeoDefaultUniqueWhere"] | undefined
};
	["LocaleSeoDefaultsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleBusinessPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["BusinessPageUniqueWhere"] | undefined
};
	["LocaleBusinessPagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleBusinessPagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleBusinessPagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleBusinessPagesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleJobPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["JobPageUniqueWhere"] | undefined
};
	["LocaleJobPagesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleJobPagesByKeyInfoUniqueWhere"]: {
		keyInfo?: GraphQLTypes["KeyInfoListUniqueWhere"] | undefined
};
	["LocaleJobPagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleJobPagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleJobPagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleJobPagesByMobileImageUniqueWhere"]: {
		mobileImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleContractTypesByRootUniqueWhere"]: {
		root?: GraphQLTypes["ContractTypeUniqueWhere"] | undefined
};
	["LocaleContractTypesBySlugUniqueWhere"]: {
		slug?: string | undefined
};
	["LocaleJobCitiesByRootUniqueWhere"]: {
		root?: GraphQLTypes["JobCityUniqueWhere"] | undefined
};
	["LocaleJobCitiesBySlugUniqueWhere"]: {
		slug?: string | undefined
};
	["LocaleJobPositionsByRootUniqueWhere"]: {
		root?: GraphQLTypes["JobPositionUniqueWhere"] | undefined
};
	["LocaleJobPositionsBySlugUniqueWhere"]: {
		slug?: string | undefined
};
	["LocaleHomePagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["HomePageUniqueWhere"] | undefined
};
	["LocaleHomePagesByButtonUniqueWhere"]: {
		button?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleHomePagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleHomePagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleHomePagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleHomePagesByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleHomePagesBySiteSwitcherUniqueWhere"]: {
		siteSwitcher?: GraphQLTypes["SiteSwitcherUniqueWhere"] | undefined
};
	["LocaleHomePagesByIlustrationUniqueWhere"]: {
		ilustration?: GraphQLTypes["GalleryUniqueWhere"] | undefined
};
	["LocaleBonusBannersByRootUniqueWhere"]: {
		root?: GraphQLTypes["BonusBannerUniqueWhere"] | undefined
};
	["LocaleBonusBannersByTilesUniqueWhere"]: {
		tiles?: GraphQLTypes["TileUniqueWhere"] | undefined
};
	["LocaleBonusBannersByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByRootUniqueWhere"]: {
		root?: GraphQLTypes["HomePageLokalUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByButtonUniqueWhere"]: {
		button?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsBySiteSwitcherUniqueWhere"]: {
		siteSwitcher?: GraphQLTypes["SiteSwitcherUniqueWhere"] | undefined
};
	["LocaleHomePageLokalsByIlustrationUniqueWhere"]: {
		ilustration?: GraphQLTypes["GalleryUniqueWhere"] | undefined
};
	["LocaleJobsFormsByRootUniqueWhere"]: {
		root?: GraphQLTypes["JobsFormUniqueWhere"] | undefined
};
	["LocaleJobsFormsByImageTextListUniqueWhere"]: {
		imageTextList?: GraphQLTypes["ImageTextListUniqueWhere"] | undefined
};
	["LocaleJobsFormsByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleJobsFormsBySuccessImageUniqueWhere"]: {
		successImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleJobsFiltersByRootUniqueWhere"]: {
		root?: GraphQLTypes["JobsFilterUniqueWhere"] | undefined
};
	["LocaleJobsFiltersByBannerJobsFormUniqueWhere"]: {
		bannerJobsForm?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined
};
	["LocaleJobsFiltersByBannerImageUniqueWhere"]: {
		bannerImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleJobsFiltersByNoJobImageUniqueWhere"]: {
		noJobImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LocaleGeneralByRootUniqueWhere"]: {
		root?: GraphQLTypes["GeneralUniqueWhere"] | undefined
};
	["LocaleGeneralBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleGeneralByCornerBannerUniqueWhere"]: {
		cornerBanner?: GraphQLTypes["CornerBannerUniqueWhere"] | undefined
};
	["LocaleRecommendationFormsByRootUniqueWhere"]: {
		root?: GraphQLTypes["RecommendationFormUniqueWhere"] | undefined
};
	["LocaleInfoBoxesByRootUniqueWhere"]: {
		root?: GraphQLTypes["InfoBoxUniqueWhere"] | undefined
};
	["LocaleTranslationsByRootUniqueWhere"]: {
		root?: GraphQLTypes["TranslationUniqueWhere"] | undefined
};
	["GeneralLocaleConnection"]: {
	__typename: "GeneralLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GeneralLocaleEdge"]>
};
	["GeneralLocaleEdge"]: {
	__typename: "GeneralLocaleEdge",
	node: GraphQLTypes["GeneralLocale"]
};
	["CornerBanner"]: {
	__typename: "CornerBanner",
	_meta?: GraphQLTypes["CornerBannerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	isActive: boolean,
	title?: string | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["Image"] | undefined,
	link?: GraphQLTypes["Link"] | undefined
};
	["CornerBannerMeta"]: {
	__typename: "CornerBannerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	isActive?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["GeneralLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["GeneralLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["GeneralLocalesByCornerBannerUniqueWhere"]: {
		cornerBanner?: GraphQLTypes["CornerBannerUniqueWhere"] | undefined
};
	["GeneralConnection"]: {
	__typename: "GeneralConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GeneralEdge"]>
};
	["GeneralEdge"]: {
	__typename: "GeneralEdge",
	node: GraphQLTypes["General"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
        	__typename:"_FieldPathFragment" | "_IndexPathFragment"
        	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string | undefined
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["GeneralCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["GeneralCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GeneralLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GeneralLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	cornerBanner?: GraphQLTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGeneralCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGeneralCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateFootersEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateFootersRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	root?: GraphQLTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<GraphQLTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<GraphQLTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: GraphQLTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: GraphQLTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: GraphQLTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: GraphQLTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: GraphQLTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: GraphQLTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: GraphQLTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: GraphQLTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterUniqueWhere"] | undefined,
	create?: GraphQLTypes["FooterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["FooterWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["FooterUniqueWhere"],
	create: GraphQLTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["FooterLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["FooterLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	link?: GraphQLTypes["FooterLinkCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLinkCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLinkConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["LinkType"] | undefined,
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"] | undefined,
	anchorLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateRedirectEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"] | undefined,
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateRedirectRelationInput"] | undefined
};
	["RedirectWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateTargetRelationInput"] | undefined
};
	["RedirectConnectOrCreateTargetRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["LinkableConnectOrCreateRedirectRelationInput"]: {
		connect: GraphQLTypes["RedirectUniqueWhere"],
	create: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined
};
	["GenericPageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined,
	image?: GraphQLTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GenericPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	theme?: GraphQLTypes["GenericPageCreateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageCreateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateThemeRelationInput"] | undefined
};
	["ThemeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	backgroundColor?: string | undefined,
	textColor?: string | undefined,
	name?: string | undefined,
	buttonBackgroundColor?: string | undefined,
	buttonTextColor?: string | undefined,
	buttonBackgroundHoverColor?: string | undefined,
	buttonTextHoverColor?: string | undefined,
	buttonBorderColor?: string | undefined,
	buttonBorderHoverColor?: string | undefined,
	headerMenuColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageConnectOrCreateThemeRelationInput"]: {
		connect: GraphQLTypes["ThemeUniqueWhere"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["GenericPageLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["GenericPageUniqueWhere"],
	create: GraphQLTypes["GenericPageWithoutLocalesCreateInput"]
};
	["GenericPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGenericPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutGenericPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateHeadersEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateHeadersRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<GraphQLTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<GraphQLTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: GraphQLTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: GraphQLTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeaderWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["HeaderWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	logo?: GraphQLTypes["HeaderCreateLogoEntityRelationInput"] | undefined,
	logoMenu?: GraphQLTypes["HeaderCreateLogoMenuEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["HeaderCreateLogoMenuEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderConnectOrCreateLogoMenuRelationInput"] | undefined
};
	["HeaderConnectOrCreateLogoMenuRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["HeaderLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["HeaderUniqueWhere"],
	create: GraphQLTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleCreateBusinessEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateBusinessRelationInput"] | undefined,
	alias?: string | undefined
};
	["BusinessUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	logo?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["BusinessCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	logo?: GraphQLTypes["BusinessCreateLogoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BusinessCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessConnectOrCreateLogoRelationInput"] | undefined
};
	["BusinessConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BusinessCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessConnectOrCreateLinkRelationInput"] | undefined
};
	["BusinessConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["HeaderLocaleConnectOrCreateBusinessRelationInput"]: {
		connect: GraphQLTypes["BusinessUniqueWhere"],
	create: GraphQLTypes["BusinessCreateInput"]
};
	["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"]: {
		connect: GraphQLTypes["BusinessUniqueWhere"],
	create: GraphQLTypes["BusinessCreateInput"]
};
	["HeaderLocaleCreateBusinessLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"] | undefined
};
	["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["HeaderLocaleCreateLokalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateLokalLinkRelationInput"] | undefined
};
	["HeaderLocaleConnectOrCreateLokalLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["LocaleConnectOrCreateHeadersRelationInput"]: {
		connect: GraphQLTypes["HeaderLocaleUniqueWhere"],
	create: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateSeoDefaultsEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateSeoDefaultsRelationInput"] | undefined,
	alias?: string | undefined
};
	["SeoDefaultLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["SeoDefaultLocaleCreateRootEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoDefaultUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoDefaultWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoDefaultLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["SeoDefaultWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["SeoDefaultUniqueWhere"],
	create: GraphQLTypes["SeoDefaultWithoutLocalesCreateInput"]
};
	["SeoDefaultLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoDefaultLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined
};
	["SeoConnectOrCreateOgImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["SeoDefaultLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["LocaleConnectOrCreateSeoDefaultsRelationInput"]: {
		connect: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	create: GraphQLTypes["SeoDefaultLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateBusinessPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateBusinessPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["BusinessPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	infoBox?: GraphQLTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["BusinessPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	theme?: GraphQLTypes["BusinessPageCreateThemeEntityRelationInput"] | undefined,
	isLokal?: boolean | undefined,
	tabidooId?: string | undefined,
	headerColor?: string | undefined,
	recruitisOfficeId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageCreateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageConnectOrCreateThemeRelationInput"] | undefined
};
	["BusinessPageConnectOrCreateThemeRelationInput"]: {
		connect: GraphQLTypes["ThemeUniqueWhere"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["BusinessPageUniqueWhere"],
	create: GraphQLTypes["BusinessPageWithoutLocalesCreateInput"]
};
	["BusinessPageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["ContentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	blocks?: Array<GraphQLTypes["ContentCreateBlocksEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentConnectOrCreateBlocksRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContentBlockWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentBlockConnectOrCreateReferencesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceWithoutBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined,
	linkables?: Array<GraphQLTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	media?: GraphQLTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined,
	carousel?: GraphQLTypes["ContentReferenceCreateCarouselEntityRelationInput"] | undefined,
	bonusBanner?: GraphQLTypes["ContentReferenceCreateBonusBannerEntityRelationInput"] | undefined,
	sideBySide?: GraphQLTypes["ContentReferenceCreateSideBySideEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined,
	showBoolean?: boolean | undefined,
	isRed?: boolean | undefined,
	video?: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateLinkablesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceCreateMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined
};
	["MediumListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["MediumListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["MediumItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	medium?: GraphQLTypes["MediumItemCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined
};
	["MediumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["MediumCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["MediumType"] | undefined,
	image?: GraphQLTypes["MediumCreateImageEntityRelationInput"] | undefined,
	video?: GraphQLTypes["MediumCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateImageRelationInput"] | undefined
};
	["MediumConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MediumCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateVideoRelationInput"] | undefined
};
	["VideoCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	src?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	videoInfo?: string | undefined,
	duration?: number | undefined,
	poster?: GraphQLTypes["VideoCreatePosterEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VideoCreatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["VideoConnectOrCreatePosterRelationInput"] | undefined
};
	["VideoConnectOrCreatePosterRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MediumConnectOrCreateVideoRelationInput"]: {
		connect: GraphQLTypes["VideoUniqueWhere"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["MediumItemConnectOrCreateMediumRelationInput"]: {
		connect: GraphQLTypes["MediumUniqueWhere"],
	create: GraphQLTypes["MediumCreateInput"]
};
	["MediumListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["MediumItemUniqueWhere"],
	create: GraphQLTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateMediaRelationInput"]: {
		connect: GraphQLTypes["MediumListUniqueWhere"],
	create: GraphQLTypes["MediumListCreateInput"]
};
	["ContentReferenceCreateTextListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateTextListRelationInput"] | undefined
};
	["TextListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["TextItemUniqueWhere"] | undefined
};
	["TextItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["TextListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["TextListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["TextItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TextListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["TextItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["TextItemUniqueWhere"],
	create: GraphQLTypes["TextItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateTextListRelationInput"]: {
		connect: GraphQLTypes["TextListUniqueWhere"],
	create: GraphQLTypes["TextListCreateInput"]
};
	["ContentReferenceCreateCarouselEntityRelationInput"]: {
		connect?: GraphQLTypes["CarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["CarouselCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateCarouselRelationInput"] | undefined
};
	["CarouselUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["CarouselItemUniqueWhere"] | undefined
};
	["CarouselItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	linkUrl?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	video?: GraphQLTypes["VideoUniqueWhere"] | undefined
};
	["CarouselCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["CarouselCreateItemsEntityRelationInput"]> | undefined,
	background?: GraphQLTypes["Background"] | undefined,
	squareImages?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["CarouselItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["CarouselItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CarouselConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["CarouselItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	image?: GraphQLTypes["CarouselItemCreateImageEntityRelationInput"] | undefined,
	name?: string | undefined,
	title?: string | undefined,
	linkUrl?: GraphQLTypes["CarouselItemCreateLinkUrlEntityRelationInput"] | undefined,
	normalAspectRatio?: boolean | undefined,
	isImage?: boolean | undefined,
	video?: GraphQLTypes["CarouselItemCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CarouselItemConnectOrCreateImageRelationInput"] | undefined
};
	["CarouselItemConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["CarouselItemCreateLinkUrlEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CarouselItemConnectOrCreateLinkUrlRelationInput"] | undefined
};
	["CarouselItemConnectOrCreateLinkUrlRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["CarouselItemCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CarouselItemConnectOrCreateVideoRelationInput"] | undefined
};
	["CarouselItemConnectOrCreateVideoRelationInput"]: {
		connect: GraphQLTypes["VideoUniqueWhere"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["CarouselConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["CarouselItemUniqueWhere"],
	create: GraphQLTypes["CarouselItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateCarouselRelationInput"]: {
		connect: GraphQLTypes["CarouselUniqueWhere"],
	create: GraphQLTypes["CarouselCreateInput"]
};
	["ContentReferenceCreateBonusBannerEntityRelationInput"]: {
		connect?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BonusBannerLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateBonusBannerRelationInput"] | undefined
};
	["BonusBannerLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined,
	tiles?: Array<GraphQLTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined,
	logo?: GraphQLTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BonusBannerUniqueWhere"] | undefined,
	create?: GraphQLTypes["BonusBannerWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BonusBannerLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["BonusBannerWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["BonusBannerUniqueWhere"],
	create: GraphQLTypes["BonusBannerWithoutLocalesCreateInput"]
};
	["BonusBannerLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBonusBannersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BonusBannerLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutBonusBannersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateGenericPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateGenericPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined,
	image?: GraphQLTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["GenericPageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["GenericPageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutGenericPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutGenericPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateBusinessPageEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateBusinessPageRelationInput"] | undefined
};
	["BusinessPageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	infoBox?: GraphQLTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBusinessPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutBusinessPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateJobPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateJobPagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined,
	image?: GraphQLTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined,
	keyInfo?: GraphQLTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: GraphQLTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: GraphQLTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["JobPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	theme?: GraphQLTypes["JobPageCreateThemeEntityRelationInput"] | undefined,
	contractType?: GraphQLTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined,
	jobCity?: GraphQLTypes["JobPageCreateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	jobPosition?: GraphQLTypes["JobPageCreateJobPositionEntityRelationInput"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: GraphQLTypes["JobPageCreateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: GraphQLTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageCreateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateThemeRelationInput"] | undefined
};
	["JobPageConnectOrCreateThemeRelationInput"]: {
		connect: GraphQLTypes["ThemeUniqueWhere"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["JobPageCreateContractTypeEntityRelationInput"]: {
		connect?: GraphQLTypes["ContractTypeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContractTypeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateContractTypeRelationInput"] | undefined
};
	["ContractTypeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["ContractTypeCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContractTypeLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContractTypeConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContractTypeLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: string | undefined,
	locale?: GraphQLTypes["ContractTypeLocaleCreateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutContractTypesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContractTypeLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutContractTypesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateJobCitiesEntityRelationInput"]: {
		connect?: GraphQLTypes["JobCityLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobCityLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateJobCitiesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobCityLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["JobCityLocaleCreateRootEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["JobCityUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobCityWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobCityLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["JobCityWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["JobCityUniqueWhere"],
	create: GraphQLTypes["JobCityWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateJobCitiesRelationInput"]: {
		connect: GraphQLTypes["JobCityLocaleUniqueWhere"],
	create: GraphQLTypes["JobCityLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateJobPositionsEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPositionLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPositionLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateJobPositionsRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobPositionLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: string | undefined,
	root?: GraphQLTypes["JobPositionLocaleCreateRootEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPositionUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPositionWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPositionLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["JobPositionWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	jobs?: Array<GraphQLTypes["JobPositionCreateJobsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionCreateJobsEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPageWithoutJobPositionCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPositionConnectOrCreateJobsRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobPageWithoutJobPositionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["JobPageCreateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["JobPageCreateThemeEntityRelationInput"] | undefined,
	contractType?: GraphQLTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined,
	jobCity?: GraphQLTypes["JobPageCreateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: GraphQLTypes["JobPageCreateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: GraphQLTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	locale?: GraphQLTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	image?: GraphQLTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined,
	keyInfo?: GraphQLTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: GraphQLTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: GraphQLTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutJobPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutJobPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateContractTypesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContractTypeLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateContractTypesRelationInput"] | undefined,
	alias?: string | undefined
};
	["ContractTypeLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: string | undefined,
	root?: GraphQLTypes["ContractTypeLocaleCreateRootEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ContractTypeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContractTypeWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContractTypeLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["ContractTypeWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["ContractTypeUniqueWhere"],
	create: GraphQLTypes["ContractTypeWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateContractTypesRelationInput"]: {
		connect: GraphQLTypes["ContractTypeLocaleUniqueWhere"],
	create: GraphQLTypes["ContractTypeLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateHomePagesEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateHomePagesRelationInput"] | undefined,
	alias?: string | undefined
};
	["HomePageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["HomePageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	theme?: GraphQLTypes["HomePageCreateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageCreateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageConnectOrCreateThemeRelationInput"] | undefined
};
	["HomePageConnectOrCreateThemeRelationInput"]: {
		connect: GraphQLTypes["ThemeUniqueWhere"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["HomePageLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["HomePageUniqueWhere"],
	create: GraphQLTypes["HomePageWithoutLocalesCreateInput"]
};
	["HomePageLocaleCreateButtonEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateButtonRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateButtonRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["HomePageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["HomePageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["HomePageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutHomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateJobPageEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateJobPageRelationInput"] | undefined
};
	["JobPageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	image?: GraphQLTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined,
	keyInfo?: GraphQLTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: GraphQLTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: GraphQLTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateImageRelationInput"] | undefined
};
	["JobPageLocaleConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["JobPageLocaleCreateKeyInfoEntityRelationInput"]: {
		connect?: GraphQLTypes["KeyInfoListUniqueWhere"] | undefined,
	create?: GraphQLTypes["KeyInfoListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateKeyInfoRelationInput"] | undefined
};
	["KeyInfoListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["KeyInfoListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["KeyInfoItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["KeyInfoItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["KeyInfoListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["KeyInfoItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	keyInfo?: string | undefined,
	icon?: GraphQLTypes["KeyInfoItemCreateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["IconUniqueWhere"] | undefined,
	create?: GraphQLTypes["IconCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["KeyInfoItemConnectOrCreateIconRelationInput"] | undefined
};
	["IconUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	icon?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["IconCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	icon?: GraphQLTypes["IconCreateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IconCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["IconConnectOrCreateIconRelationInput"] | undefined
};
	["IconConnectOrCreateIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["KeyInfoItemConnectOrCreateIconRelationInput"]: {
		connect: GraphQLTypes["IconUniqueWhere"],
	create: GraphQLTypes["IconCreateInput"]
};
	["KeyInfoListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["KeyInfoItemUniqueWhere"],
	create: GraphQLTypes["KeyInfoItemWithoutListCreateInput"]
};
	["JobPageLocaleConnectOrCreateKeyInfoRelationInput"]: {
		connect: GraphQLTypes["KeyInfoListUniqueWhere"],
	create: GraphQLTypes["KeyInfoListCreateInput"]
};
	["JobPageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["JobPageLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["JobPageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["JobPageLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["JobPageLocaleCreateStickyBarEntityRelationInput"]: {
		connect?: GraphQLTypes["StickyBarUniqueWhere"] | undefined,
	create?: GraphQLTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined
};
	["StickyBarUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["StickyBarCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	link?: GraphQLTypes["StickyBarCreateLinkEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	jobsForm?: GraphQLTypes["StickyBarCreateJobsFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StickyBarCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StickyBarConnectOrCreateLinkRelationInput"] | undefined
};
	["StickyBarConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["StickyBarCreateJobsFormEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StickyBarConnectOrCreateJobsFormRelationInput"] | undefined
};
	["JobsFormLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	root?: GraphQLTypes["JobsFormLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobsFormLocaleCreateLocaleEntityRelationInput"] | undefined,
	imageTextList?: GraphQLTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: GraphQLTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: GraphQLTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["JobsFormWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	fileIlustration?: GraphQLTypes["JobsFormCreateFileIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormCreateFileIlustrationEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormConnectOrCreateFileIlustrationRelationInput"] | undefined
};
	["JobsFormConnectOrCreateFileIlustrationRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["JobsFormLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["JobsFormUniqueWhere"],
	create: GraphQLTypes["JobsFormWithoutLocalesCreateInput"]
};
	["JobsFormLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutJobsFormsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutJobsFormsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateBonusBannersEntityRelationInput"]: {
		connect?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BonusBannerLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateBonusBannersRelationInput"] | undefined,
	alias?: string | undefined
};
	["BonusBannerLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined,
	tiles?: Array<GraphQLTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined,
	logo?: GraphQLTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleCreateTilesEntityRelationInput"]: {
		connect?: GraphQLTypes["TileUniqueWhere"] | undefined,
	create?: GraphQLTypes["TileWithoutBonusBannerCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BonusBannerLocaleConnectOrCreateTilesRelationInput"] | undefined,
	alias?: string | undefined
};
	["TileWithoutBonusBannerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	image?: GraphQLTypes["TileCreateImageEntityRelationInput"] | undefined,
	lightBoxTitle?: string | undefined,
	lightBoxText?: string | undefined,
	ligthBoxMedia?: GraphQLTypes["TileCreateLigthBoxMediaEntityRelationInput"] | undefined,
	lightBoxSectionTitle?: string | undefined,
	title?: string | undefined,
	lightBoxLinkLabel?: string | undefined,
	lightBoxForm?: GraphQLTypes["TileCreateLightBoxFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileConnectOrCreateImageRelationInput"] | undefined
};
	["TileConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["TileCreateLigthBoxMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileConnectOrCreateLigthBoxMediaRelationInput"] | undefined
};
	["TileConnectOrCreateLigthBoxMediaRelationInput"]: {
		connect: GraphQLTypes["MediumListUniqueWhere"],
	create: GraphQLTypes["MediumListCreateInput"]
};
	["TileCreateLightBoxFormEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileConnectOrCreateLightBoxFormRelationInput"] | undefined
};
	["TileConnectOrCreateLightBoxFormRelationInput"]: {
		connect: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	create: GraphQLTypes["JobsFormLocaleCreateInput"]
};
	["BonusBannerLocaleConnectOrCreateTilesRelationInput"]: {
		connect: GraphQLTypes["TileUniqueWhere"],
	create: GraphQLTypes["TileWithoutBonusBannerCreateInput"]
};
	["BonusBannerLocaleCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BonusBannerLocaleConnectOrCreateLogoRelationInput"] | undefined
};
	["BonusBannerLocaleConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateBonusBannersRelationInput"]: {
		connect: GraphQLTypes["BonusBannerLocaleUniqueWhere"],
	create: GraphQLTypes["BonusBannerLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateHomePageLokalsEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageLokalLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateHomePageLokalsRelationInput"] | undefined,
	alias?: string | undefined
};
	["HomePageLokalLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLokalUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageLokalWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["HomePageLokalWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	theme?: GraphQLTypes["HomePageLokalCreateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalCreateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalConnectOrCreateThemeRelationInput"] | undefined
};
	["HomePageLokalConnectOrCreateThemeRelationInput"]: {
		connect: GraphQLTypes["ThemeUniqueWhere"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["HomePageLokalLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["HomePageLokalUniqueWhere"],
	create: GraphQLTypes["HomePageLokalWithoutLocalesCreateInput"]
};
	["HomePageLokalLocaleCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateLogoRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["HomePageLokalLocaleCreateButtonEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateButtonRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateButtonRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["HomePageLokalLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateContentRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["HomePageLokalLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["HomePageLokalLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutHomePageLokalCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutHomePageLokalCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateHomePageEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateHomePageRelationInput"] | undefined
};
	["HomePageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutHomePagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutHomePagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateJobsFormsEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateJobsFormsRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobsFormLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	root?: GraphQLTypes["JobsFormLocaleCreateRootEntityRelationInput"] | undefined,
	imageTextList?: GraphQLTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: GraphQLTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: GraphQLTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormLocaleCreateImageTextListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageTextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageTextListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormLocaleConnectOrCreateImageTextListRelationInput"] | undefined
};
	["ImageTextListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ImageTextListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageTextItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageTextItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageTextListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ImageTextItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	image?: GraphQLTypes["ImageTextItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageTextItemConnectOrCreateImageRelationInput"] | undefined
};
	["ImageTextItemConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ImageTextListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ImageTextItemUniqueWhere"],
	create: GraphQLTypes["ImageTextItemWithoutListCreateInput"]
};
	["JobsFormLocaleConnectOrCreateImageTextListRelationInput"]: {
		connect: GraphQLTypes["ImageTextListUniqueWhere"],
	create: GraphQLTypes["ImageTextListCreateInput"]
};
	["JobsFormLocaleCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormLocaleConnectOrCreateLogoRelationInput"] | undefined
};
	["JobsFormLocaleConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["JobsFormLocaleCreateSuccessImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"] | undefined
};
	["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateJobsFormsRelationInput"]: {
		connect: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	create: GraphQLTypes["JobsFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateJobsFiltersEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFilterLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateJobsFiltersRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobsFilterLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	root?: GraphQLTypes["JobsFilterLocaleCreateRootEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: GraphQLTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: GraphQLTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: GraphQLTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFilterUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFilterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["JobsFilterWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["JobsFilterUniqueWhere"],
	create: GraphQLTypes["JobsFilterWithoutLocalesCreateInput"]
};
	["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"] | undefined
};
	["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"]: {
		connect: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	create: GraphQLTypes["JobsFormLocaleCreateInput"]
};
	["JobsFilterLocaleCreateBannerImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"] | undefined
};
	["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["JobsFilterLocaleCreateNoJobImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"] | undefined
};
	["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateJobsFiltersRelationInput"]: {
		connect: GraphQLTypes["JobsFilterLocaleUniqueWhere"],
	create: GraphQLTypes["JobsFilterLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateGeneralEntityRelationInput"]: {
		connect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateGeneralRelationInput"] | undefined,
	alias?: string | undefined
};
	["GeneralLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	cornerBanner?: GraphQLTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GeneralUniqueWhere"] | undefined,
	create?: GraphQLTypes["GeneralWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["GeneralWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["GeneralUniqueWhere"],
	create: GraphQLTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["GeneralLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["GeneralLocaleCreateCornerBannerEntityRelationInput"]: {
		connect?: GraphQLTypes["CornerBannerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CornerBannerCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateCornerBannerRelationInput"] | undefined
};
	["CornerBannerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	isActive?: boolean | undefined,
	title?: string | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["CornerBannerCreateLogoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["CornerBannerCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CornerBannerCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CornerBannerConnectOrCreateLogoRelationInput"] | undefined
};
	["CornerBannerConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["CornerBannerCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CornerBannerConnectOrCreateLinkRelationInput"] | undefined
};
	["CornerBannerConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["GeneralLocaleConnectOrCreateCornerBannerRelationInput"]: {
		connect: GraphQLTypes["CornerBannerUniqueWhere"],
	create: GraphQLTypes["CornerBannerCreateInput"]
};
	["LocaleConnectOrCreateGeneralRelationInput"]: {
		connect: GraphQLTypes["GeneralLocaleUniqueWhere"],
	create: GraphQLTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateRecommendationFormsEntityRelationInput"]: {
		connect?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["RecommendationFormLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateRecommendationFormsRelationInput"] | undefined,
	alias?: string | undefined
};
	["RecommendationFormLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	root?: GraphQLTypes["RecommendationFormLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["RecommendationFormUniqueWhere"] | undefined,
	create?: GraphQLTypes["RecommendationFormWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecommendationFormLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["RecommendationFormWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	successImage?: GraphQLTypes["RecommendationFormCreateSuccessImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormCreateSuccessImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecommendationFormConnectOrCreateSuccessImageRelationInput"] | undefined
};
	["RecommendationFormConnectOrCreateSuccessImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["RecommendationFormLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["RecommendationFormUniqueWhere"],
	create: GraphQLTypes["RecommendationFormWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateRecommendationFormsRelationInput"]: {
		connect: GraphQLTypes["RecommendationFormLocaleUniqueWhere"],
	create: GraphQLTypes["RecommendationFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateInfoBoxesEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoBoxLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateInfoBoxesRelationInput"] | undefined,
	alias?: string | undefined
};
	["InfoBoxLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	root?: GraphQLTypes["InfoBoxLocaleCreateRootEntityRelationInput"] | undefined,
	openingHours?: GraphQLTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoBoxUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoBoxWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoBoxLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["InfoBoxWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	logoSize?: GraphQLTypes["LogoSize"] | undefined,
	logo?: GraphQLTypes["InfoBoxCreateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoBoxConnectOrCreateLogoRelationInput"] | undefined
};
	["InfoBoxConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["InfoBoxLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["InfoBoxUniqueWhere"],
	create: GraphQLTypes["InfoBoxWithoutLocalesCreateInput"]
};
	["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"] | undefined
};
	["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"]: {
		connect: GraphQLTypes["TextListUniqueWhere"],
	create: GraphQLTypes["TextListCreateInput"]
};
	["LocaleConnectOrCreateInfoBoxesRelationInput"]: {
		connect: GraphQLTypes["InfoBoxLocaleUniqueWhere"],
	create: GraphQLTypes["InfoBoxLocaleWithoutLocaleCreateInput"]
};
	["LocaleCreateTranslationsEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationLocaleWithoutLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LocaleConnectOrCreateTranslationsRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	value?: string | undefined,
	root?: GraphQLTypes["TranslationLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationLocaleConnectOrCreateRootRelationInput"] | undefined
};
	["TranslationWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	key?: string | undefined,
	isTextarea?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["TranslationUniqueWhere"],
	create: GraphQLTypes["TranslationWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateTranslationsRelationInput"]: {
		connect: GraphQLTypes["TranslationLocaleUniqueWhere"],
	create: GraphQLTypes["TranslationLocaleWithoutLocaleCreateInput"]
};
	["HomePageLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutHomePagesCreateInput"]
};
	["HomePageLocaleCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateLogoRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["HomePageLocaleCreateSiteSwitcherEntityRelationInput"]: {
		connect?: GraphQLTypes["SiteSwitcherUniqueWhere"] | undefined,
	create?: GraphQLTypes["SiteSwitcherCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined
};
	["SiteSwitcherCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	link?: GraphQLTypes["SiteSwitcherCreateLinkEntityRelationInput"] | undefined,
	theme?: GraphQLTypes["SiteSwitcherCreateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SiteSwitcherCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SiteSwitcherConnectOrCreateLinkRelationInput"] | undefined
};
	["SiteSwitcherConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["SiteSwitcherCreateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SiteSwitcherConnectOrCreateThemeRelationInput"] | undefined
};
	["SiteSwitcherConnectOrCreateThemeRelationInput"]: {
		connect: GraphQLTypes["ThemeUniqueWhere"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"]: {
		connect: GraphQLTypes["SiteSwitcherUniqueWhere"],
	create: GraphQLTypes["SiteSwitcherCreateInput"]
};
	["HomePageLocaleCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateGalleryRelationInput"] | undefined
};
	["GalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["GalleryCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GalleryConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["GalleryItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	image?: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GalleryItemConnectOrCreateImageRelationInput"] | undefined
};
	["GalleryItemConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["GalleryConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["GalleryItemUniqueWhere"],
	create: GraphQLTypes["GalleryItemWithoutListCreateInput"]
};
	["HomePageLocaleConnectOrCreateGalleryRelationInput"]: {
		connect: GraphQLTypes["GalleryUniqueWhere"],
	create: GraphQLTypes["GalleryCreateInput"]
};
	["HomePageLocaleCreateStickyBarEntityRelationInput"]: {
		connect?: GraphQLTypes["StickyBarUniqueWhere"] | undefined,
	create?: GraphQLTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateStickyBarRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateStickyBarRelationInput"]: {
		connect: GraphQLTypes["StickyBarUniqueWhere"],
	create: GraphQLTypes["StickyBarCreateInput"]
};
	["HomePageLocaleCreateIlustrationEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateIlustrationRelationInput"] | undefined
};
	["HomePageLocaleConnectOrCreateIlustrationRelationInput"]: {
		connect: GraphQLTypes["GalleryUniqueWhere"],
	create: GraphQLTypes["GalleryCreateInput"]
};
	["LinkableConnectOrCreateHomePageRelationInput"]: {
		connect: GraphQLTypes["HomePageLocaleUniqueWhere"],
	create: GraphQLTypes["HomePageLocaleWithoutLinkCreateInput"]
};
	["HomePageLokalLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutHomePageLokalCreateInput"]
};
	["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"]: {
		connect?: GraphQLTypes["SiteSwitcherUniqueWhere"] | undefined,
	create?: GraphQLTypes["SiteSwitcherCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"]: {
		connect: GraphQLTypes["SiteSwitcherUniqueWhere"],
	create: GraphQLTypes["SiteSwitcherCreateInput"]
};
	["HomePageLokalLocaleCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"]: {
		connect: GraphQLTypes["GalleryUniqueWhere"],
	create: GraphQLTypes["GalleryCreateInput"]
};
	["HomePageLokalLocaleCreateStickyBarEntityRelationInput"]: {
		connect?: GraphQLTypes["StickyBarUniqueWhere"] | undefined,
	create?: GraphQLTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"]: {
		connect: GraphQLTypes["StickyBarUniqueWhere"],
	create: GraphQLTypes["StickyBarCreateInput"]
};
	["HomePageLokalLocaleCreateIlustrationEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"] | undefined
};
	["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"]: {
		connect: GraphQLTypes["GalleryUniqueWhere"],
	create: GraphQLTypes["GalleryCreateInput"]
};
	["LocaleConnectOrCreateHomePageLokalsRelationInput"]: {
		connect: GraphQLTypes["HomePageLokalLocaleUniqueWhere"],
	create: GraphQLTypes["HomePageLokalLocaleWithoutLocaleCreateInput"]
};
	["JobsFormLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutJobsFormsCreateInput"]
};
	["StickyBarConnectOrCreateJobsFormRelationInput"]: {
		connect: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	create: GraphQLTypes["JobsFormLocaleCreateInput"]
};
	["JobPageLocaleConnectOrCreateStickyBarRelationInput"]: {
		connect: GraphQLTypes["StickyBarUniqueWhere"],
	create: GraphQLTypes["StickyBarCreateInput"]
};
	["JobPageLocaleCreateMobileImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateMobileImageRelationInput"] | undefined
};
	["JobPageLocaleConnectOrCreateMobileImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LinkableConnectOrCreateJobPageRelationInput"]: {
		connect: GraphQLTypes["JobPageLocaleUniqueWhere"],
	create: GraphQLTypes["JobPageLocaleWithoutLinkCreateInput"]
};
	["LinkableCreateHomePageLokalEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageLokalLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateHomePageLokalRelationInput"] | undefined
};
	["HomePageLokalLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutHomePageLokalsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutHomePageLokalsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutHomePageLokalsCreateInput"]
};
	["LinkableConnectOrCreateHomePageLokalRelationInput"]: {
		connect: GraphQLTypes["HomePageLokalLocaleUniqueWhere"],
	create: GraphQLTypes["HomePageLokalLocaleWithoutLinkCreateInput"]
};
	["HomePageLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutHomePageCreateInput"]
};
	["LocaleConnectOrCreateHomePagesRelationInput"]: {
		connect: GraphQLTypes["HomePageLocaleUniqueWhere"],
	create: GraphQLTypes["HomePageLocaleWithoutLocaleCreateInput"]
};
	["JobPageLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutJobPagesCreateInput"]
};
	["JobPageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutJobPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutJobPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutJobPageCreateInput"]
};
	["JobPageConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["JobPageLocaleUniqueWhere"],
	create: GraphQLTypes["JobPageLocaleWithoutRootCreateInput"]
};
	["JobPageCreateJobCityEntityRelationInput"]: {
		connect?: GraphQLTypes["JobCityUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobCityCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateJobCityRelationInput"] | undefined
};
	["JobCityCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["JobCityCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["JobCityLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobCityLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobCityConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobCityLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["JobCityLocaleCreateLocaleEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutJobCitiesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobCityLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutJobCitiesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutJobCitiesCreateInput"]
};
	["JobCityConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["JobCityLocaleUniqueWhere"],
	create: GraphQLTypes["JobCityLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateJobCityRelationInput"]: {
		connect: GraphQLTypes["JobCityUniqueWhere"],
	create: GraphQLTypes["JobCityCreateInput"]
};
	["JobPageCreateBusinessEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateBusinessRelationInput"] | undefined
};
	["BusinessPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["BusinessPageCreateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["BusinessPageCreateThemeEntityRelationInput"] | undefined,
	isLokal?: boolean | undefined,
	tabidooId?: string | undefined,
	headerColor?: string | undefined,
	recruitisOfficeId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["BusinessPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	infoBox?: GraphQLTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateSeoRelationInput"] | undefined
};
	["BusinessPageLocaleConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["BusinessPageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutBusinessPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutBusinessPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutBusinessPageCreateInput"]
};
	["BusinessPageLocaleCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateImageRelationInput"] | undefined
};
	["BusinessPageLocaleConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BusinessPageLocaleCreateStickyBarEntityRelationInput"]: {
		connect?: GraphQLTypes["StickyBarUniqueWhere"] | undefined,
	create?: GraphQLTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined
};
	["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"]: {
		connect: GraphQLTypes["StickyBarUniqueWhere"],
	create: GraphQLTypes["StickyBarCreateInput"]
};
	["BusinessPageLocaleCreateInfoBoxEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoBoxUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoBoxCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"] | undefined
};
	["InfoBoxCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	logoSize?: GraphQLTypes["LogoSize"] | undefined,
	logo?: GraphQLTypes["InfoBoxCreateLogoEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["InfoBoxCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoBoxLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoBoxConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["InfoBoxLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	locale?: GraphQLTypes["InfoBoxLocaleCreateLocaleEntityRelationInput"] | undefined,
	openingHours?: GraphQLTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutInfoBoxesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoBoxLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutInfoBoxesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutInfoBoxesCreateInput"]
};
	["InfoBoxConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["InfoBoxLocaleUniqueWhere"],
	create: GraphQLTypes["InfoBoxLocaleWithoutRootCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"]: {
		connect: GraphQLTypes["InfoBoxUniqueWhere"],
	create: GraphQLTypes["InfoBoxCreateInput"]
};
	["BusinessPageConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["BusinessPageLocaleUniqueWhere"],
	create: GraphQLTypes["BusinessPageLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateBusinessRelationInput"]: {
		connect: GraphQLTypes["BusinessPageUniqueWhere"],
	create: GraphQLTypes["BusinessPageCreateInput"]
};
	["JobPositionConnectOrCreateJobsRelationInput"]: {
		connect: GraphQLTypes["JobPageUniqueWhere"],
	create: GraphQLTypes["JobPageWithoutJobPositionCreateInput"]
};
	["JobPositionLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["JobPositionUniqueWhere"],
	create: GraphQLTypes["JobPositionWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateJobPositionsRelationInput"]: {
		connect: GraphQLTypes["JobPositionLocaleUniqueWhere"],
	create: GraphQLTypes["JobPositionLocaleWithoutLocaleCreateInput"]
};
	["ContractTypeLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutContractTypesCreateInput"]
};
	["ContractTypeConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["ContractTypeLocaleUniqueWhere"],
	create: GraphQLTypes["ContractTypeLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateContractTypeRelationInput"]: {
		connect: GraphQLTypes["ContractTypeUniqueWhere"],
	create: GraphQLTypes["ContractTypeCreateInput"]
};
	["JobPageCreateJobPositionEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPositionUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPositionWithoutJobsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateJobPositionRelationInput"] | undefined
};
	["JobPositionWithoutJobsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["JobPositionCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPositionLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPositionLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPositionConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobPositionLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: string | undefined,
	locale?: GraphQLTypes["JobPositionLocaleCreateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutJobPositionsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPositionLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutJobPositionsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutJobPositionsCreateInput"]
};
	["JobPositionConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["JobPositionLocaleUniqueWhere"],
	create: GraphQLTypes["JobPositionLocaleWithoutRootCreateInput"]
};
	["JobPageConnectOrCreateJobPositionRelationInput"]: {
		connect: GraphQLTypes["JobPositionUniqueWhere"],
	create: GraphQLTypes["JobPositionWithoutJobsCreateInput"]
};
	["JobPageLocaleConnectOrCreateRootRelationInput"]: {
		connect: GraphQLTypes["JobPageUniqueWhere"],
	create: GraphQLTypes["JobPageWithoutLocalesCreateInput"]
};
	["LocaleConnectOrCreateJobPagesRelationInput"]: {
		connect: GraphQLTypes["JobPageLocaleUniqueWhere"],
	create: GraphQLTypes["JobPageLocaleWithoutLocaleCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutBusinessPagesCreateInput"]
};
	["LinkableConnectOrCreateBusinessPageRelationInput"]: {
		connect: GraphQLTypes["BusinessPageLocaleUniqueWhere"],
	create: GraphQLTypes["BusinessPageLocaleWithoutLinkCreateInput"]
};
	["GenericPageLocaleConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageLocaleCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateLogoRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["GenericPageLocaleCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateImageRelationInput"] | undefined
};
	["GenericPageLocaleConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LocaleConnectOrCreateGenericPagesRelationInput"]: {
		connect: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	create: GraphQLTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["BonusBannerLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutBonusBannersCreateInput"]
};
	["ContentReferenceConnectOrCreateBonusBannerRelationInput"]: {
		connect: GraphQLTypes["BonusBannerLocaleUniqueWhere"],
	create: GraphQLTypes["BonusBannerLocaleCreateInput"]
};
	["ContentReferenceCreateSideBySideEntityRelationInput"]: {
		connect?: GraphQLTypes["SideBySideUniqueWhere"] | undefined,
	create?: GraphQLTypes["SideBySideCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateSideBySideRelationInput"] | undefined
};
	["SideBySideUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["SideBySideItemUniqueWhere"] | undefined
};
	["SideBySideItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	media?: GraphQLTypes["MediumListUniqueWhere"] | undefined
};
	["SideBySideCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["SideBySideCreateItemsEntityRelationInput"]> | undefined,
	background?: GraphQLTypes["Background"] | undefined,
	alignment?: GraphQLTypes["ContentAlignment"] | undefined,
	mediumSize?: GraphQLTypes["MediumSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["SideBySideItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["SideBySideItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SideBySideConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["SideBySideItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	text?: string | undefined,
	media?: GraphQLTypes["SideBySideItemCreateMediaEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	type?: GraphQLTypes["SideBySideItemType"] | undefined,
	link?: GraphQLTypes["SideBySideItemCreateLinkEntityRelationInput"] | undefined,
	jobsForm?: GraphQLTypes["SideBySideItemCreateJobsFormEntityRelationInput"] | undefined,
	textNew?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemCreateMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SideBySideItemConnectOrCreateMediaRelationInput"] | undefined
};
	["SideBySideItemConnectOrCreateMediaRelationInput"]: {
		connect: GraphQLTypes["MediumListUniqueWhere"],
	create: GraphQLTypes["MediumListCreateInput"]
};
	["SideBySideItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SideBySideItemConnectOrCreateLinkRelationInput"] | undefined
};
	["SideBySideItemConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["SideBySideItemCreateJobsFormEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SideBySideItemConnectOrCreateJobsFormRelationInput"] | undefined
};
	["SideBySideItemConnectOrCreateJobsFormRelationInput"]: {
		connect: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	create: GraphQLTypes["JobsFormLocaleCreateInput"]
};
	["SideBySideConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["SideBySideItemUniqueWhere"],
	create: GraphQLTypes["SideBySideItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateSideBySideRelationInput"]: {
		connect: GraphQLTypes["SideBySideUniqueWhere"],
	create: GraphQLTypes["SideBySideCreateInput"]
};
	["ContentReferenceCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateGalleryRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateGalleryRelationInput"]: {
		connect: GraphQLTypes["GalleryUniqueWhere"],
	create: GraphQLTypes["GalleryCreateInput"]
};
	["ContentReferenceCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined
};
	["ContentReferenceConnectOrCreateVideoRelationInput"]: {
		connect: GraphQLTypes["VideoUniqueWhere"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["ContentBlockConnectOrCreateReferencesRelationInput"]: {
		connect: GraphQLTypes["ContentReferenceUniqueWhere"],
	create: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentConnectOrCreateBlocksRelationInput"]: {
		connect: GraphQLTypes["ContentBlockUniqueWhere"],
	create: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["BusinessPageLocaleConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["LocaleConnectOrCreateBusinessPagesRelationInput"]: {
		connect: GraphQLTypes["BusinessPageLocaleUniqueWhere"],
	create: GraphQLTypes["BusinessPageLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableConnectOrCreateGenericPageRelationInput"]: {
		connect: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	create: GraphQLTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["LinkConnectOrCreateInternalLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableCreateInput"]
};
	["FooterLinkConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"]: {
		connect: GraphQLTypes["FooterLinkUniqueWhere"],
	create: GraphQLTypes["FooterLinkCreateInput"]
};
	["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["FooterLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"]: {
		connect: GraphQLTypes["FooterLinkUniqueWhere"],
	create: GraphQLTypes["FooterLinkCreateInput"]
};
	["FooterLocaleCreateTermsAndConditionsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleCreateBannerImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateBannerImageRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateBannerImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["FooterLocaleCreateBannerLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateBannerLinkRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateBannerLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleCreateJobsFormEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateJobsFormRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateJobsFormRelationInput"]: {
		connect: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	create: GraphQLTypes["JobsFormLocaleCreateInput"]
};
	["FooterLocaleCreateCopyrightLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleCreateRecommendationFormEntityRelationInput"]: {
		connect?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["RecommendationFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateRecommendationFormRelationInput"] | undefined
};
	["RecommendationFormLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	root?: GraphQLTypes["RecommendationFormLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["RecommendationFormLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutRecommendationFormsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutRecommendationFormsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutRecommendationFormsCreateInput"]
};
	["FooterLocaleConnectOrCreateRecommendationFormRelationInput"]: {
		connect: GraphQLTypes["RecommendationFormLocaleUniqueWhere"],
	create: GraphQLTypes["RecommendationFormLocaleCreateInput"]
};
	["FooterLocaleCreateBannerSecondLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleCreateInstagramLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateInstagramLinkRelationInput"] | undefined
};
	["FooterLocaleConnectOrCreateInstagramLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["LocaleConnectOrCreateFootersRelationInput"]: {
		connect: GraphQLTypes["FooterLocaleUniqueWhere"],
	create: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutGeneralCreateInput"]
};
	["GeneralConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["GeneralLocaleUniqueWhere"],
	create: GraphQLTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["GeneralUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["GeneralUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["GeneralLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["GeneralUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["GeneralUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GeneralUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["GeneralLocaleUniqueWhere"],
	data: GraphQLTypes["GeneralLocaleWithoutRootUpdateInput"]
};
	["GeneralLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	cornerBanner?: GraphQLTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGeneralCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutGeneralUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGeneralUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateFootersEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateFootersRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertFootersRelationInput"] | undefined,
	connect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateFootersRelationInput"]: {
		by: GraphQLTypes["FooterLocaleUniqueWhere"],
	data: GraphQLTypes["FooterLocaleWithoutLocaleUpdateInput"]
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
		email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	root?: GraphQLTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<GraphQLTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<GraphQLTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: GraphQLTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: GraphQLTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: GraphQLTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: GraphQLTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: GraphQLTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: GraphQLTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: GraphQLTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: GraphQLTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterUniqueWhere"] | undefined,
	create?: GraphQLTypes["FooterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["FooterWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["FooterWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["FooterWithoutLocalesUpdateInput"],
	create: GraphQLTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLinkCreateInput"] | undefined,
	update?: GraphQLTypes["FooterLocaleUpdateLinksFirstColumnRelationInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertLinksFirstColumnRelationInput"] | undefined,
	connect?: GraphQLTypes["FooterLinkUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FooterLinkUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FooterLinkUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleUpdateLinksFirstColumnRelationInput"]: {
		by: GraphQLTypes["FooterLinkUniqueWhere"],
	data: GraphQLTypes["FooterLinkUpdateInput"]
};
	["FooterLinkUpdateInput"]: {
		order?: number | undefined,
	link?: GraphQLTypes["FooterLinkUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLinkUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLinkConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLinkUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkType"] | undefined,
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"] | undefined,
	anchorLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkConnectOrCreateInternalLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkUpsertInternalLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableUpdateInput"]: {
		url?: string | undefined,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"] | undefined,
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateRedirectRelationInput"] | undefined,
	update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertRedirectRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RedirectWithoutLinkUpdateInput"]: {
		target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectUpdateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateTargetRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RedirectUpsertTargetRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RedirectUpsertTargetRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["LinkableUpsertRedirectRelationInput"]: {
		update: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	create: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateGenericPageRelationInput"] | undefined,
	update?: GraphQLTypes["GenericPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertGenericPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleWithoutLinkUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined,
	image?: GraphQLTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["GenericPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GenericPageWithoutLocalesUpdateInput"]: {
		theme?: GraphQLTypes["GenericPageUpdateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpdateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateThemeRelationInput"] | undefined,
	update?: GraphQLTypes["ThemeUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageUpsertThemeRelationInput"] | undefined
};
	["ThemeUpdateInput"]: {
		backgroundColor?: string | undefined,
	textColor?: string | undefined,
	name?: string | undefined,
	buttonBackgroundColor?: string | undefined,
	buttonTextColor?: string | undefined,
	buttonBackgroundHoverColor?: string | undefined,
	buttonTextHoverColor?: string | undefined,
	buttonBorderColor?: string | undefined,
	buttonBorderHoverColor?: string | undefined,
	headerMenuColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpsertThemeRelationInput"]: {
		update: GraphQLTypes["ThemeUpdateInput"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["GenericPageLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["GenericPageWithoutLocalesUpdateInput"],
	create: GraphQLTypes["GenericPageWithoutLocalesCreateInput"]
};
	["GenericPageLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutGenericPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutGenericPagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutGenericPagesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateHeadersRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertHeadersRelationInput"] | undefined,
	connect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateHeadersRelationInput"]: {
		by: GraphQLTypes["HeaderLocaleUniqueWhere"],
	data: GraphQLTypes["HeaderLocaleWithoutLocaleUpdateInput"]
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<GraphQLTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<GraphQLTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: GraphQLTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: GraphQLTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeaderWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["HeaderWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["HeaderWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	logo?: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"] | undefined,
	logoMenu?: GraphQLTypes["HeaderUpdateLogoMenuEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageUpdateInput"]: {
		url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	fileName?: string | undefined,
	focalPointX?: number | undefined,
	focalPointY?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["HeaderUpdateLogoMenuEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderConnectOrCreateLogoMenuRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderUpsertLogoMenuRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeaderUpsertLogoMenuRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["HeaderLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["HeaderWithoutLocalesUpdateInput"],
	create: GraphQLTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleUpdateBusinessEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCreateInput"] | undefined,
	update?: GraphQLTypes["HeaderLocaleUpdateBusinessRelationInput"] | undefined,
	upsert?: GraphQLTypes["HeaderLocaleUpsertBusinessRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleUpdateBusinessRelationInput"]: {
		by: GraphQLTypes["BusinessUniqueWhere"],
	data: GraphQLTypes["BusinessUpdateInput"]
};
	["BusinessUpdateInput"]: {
		order?: number | undefined,
	logo?: GraphQLTypes["BusinessUpdateLogoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BusinessUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BusinessUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["HeaderLocaleUpsertBusinessRelationInput"]: {
		by: GraphQLTypes["BusinessUniqueWhere"],
	update: GraphQLTypes["BusinessUpdateInput"],
	create: GraphQLTypes["BusinessCreateInput"]
};
	["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCreateInput"] | undefined,
	update?: GraphQLTypes["HeaderLocaleUpdateLokalEnterpriseRelationInput"] | undefined,
	upsert?: GraphQLTypes["HeaderLocaleUpsertLokalEnterpriseRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleUpdateLokalEnterpriseRelationInput"]: {
		by: GraphQLTypes["BusinessUniqueWhere"],
	data: GraphQLTypes["BusinessUpdateInput"]
};
	["HeaderLocaleUpsertLokalEnterpriseRelationInput"]: {
		by: GraphQLTypes["BusinessUniqueWhere"],
	update: GraphQLTypes["BusinessUpdateInput"],
	create: GraphQLTypes["BusinessCreateInput"]
};
	["HeaderLocaleUpdateBusinessLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderLocaleUpsertBusinessLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeaderLocaleUpsertBusinessLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["HeaderLocaleUpdateLokalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateLokalLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderLocaleUpsertLokalLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeaderLocaleUpsertLokalLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["LocaleUpsertHeadersRelationInput"]: {
		by: GraphQLTypes["HeaderLocaleUniqueWhere"],
	update: GraphQLTypes["HeaderLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateSeoDefaultsEntityRelationInput"]: {
		create?: GraphQLTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateSeoDefaultsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertSeoDefaultsRelationInput"] | undefined,
	connect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateSeoDefaultsRelationInput"]: {
		by: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	data: GraphQLTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"]
};
	["SeoDefaultLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoDefaultUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoDefaultWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoDefaultLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["SeoDefaultWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SeoDefaultLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["SeoDefaultWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["SeoDefaultWithoutLocalesUpdateInput"],
	create: GraphQLTypes["SeoDefaultWithoutLocalesCreateInput"]
};
	["SeoDefaultLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoDefaultLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SeoDefaultLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeoUpdateInput"]: {
		title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	noIndex?: boolean | undefined,
	noFollow?: boolean | undefined,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateOgImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeoUpsertOgImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["SeoDefaultLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["LocaleUpsertSeoDefaultsRelationInput"]: {
		by: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	update: GraphQLTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["SeoDefaultLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateBusinessPagesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateBusinessPagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertBusinessPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateBusinessPagesRelationInput"]: {
		by: GraphQLTypes["BusinessPageLocaleUniqueWhere"],
	data: GraphQLTypes["BusinessPageLocaleWithoutLocaleUpdateInput"]
};
	["BusinessPageLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	infoBox?: GraphQLTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["BusinessPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["BusinessPageWithoutLocalesUpdateInput"]: {
		theme?: GraphQLTypes["BusinessPageUpdateThemeEntityRelationInput"] | undefined,
	isLokal?: boolean | undefined,
	tabidooId?: string | undefined,
	headerColor?: string | undefined,
	recruitisOfficeId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageUpdateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageConnectOrCreateThemeRelationInput"] | undefined,
	update?: GraphQLTypes["ThemeUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessPageUpsertThemeRelationInput"] | undefined
};
	["BusinessPageUpsertThemeRelationInput"]: {
		update: GraphQLTypes["ThemeUpdateInput"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["BusinessPageLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["BusinessPageWithoutLocalesUpdateInput"],
	create: GraphQLTypes["BusinessPageWithoutLocalesCreateInput"]
};
	["BusinessPageLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentUpdateInput"]: {
		blocks?: Array<GraphQLTypes["ContentUpdateBlocksEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateBlocksRelationInput"] | undefined,
	upsert?: GraphQLTypes["ContentUpsertBlocksRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentUpdateBlocksRelationInput"]: {
		by: GraphQLTypes["ContentBlockUniqueWhere"],
	data: GraphQLTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
		order?: number | undefined,
	json?: string | undefined,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"] | undefined,
	update?: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentBlockUpdateReferencesRelationInput"]: {
		by: GraphQLTypes["ContentReferenceUniqueWhere"],
	data: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined,
	linkables?: Array<GraphQLTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	media?: GraphQLTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined,
	carousel?: GraphQLTypes["ContentReferenceUpdateCarouselEntityRelationInput"] | undefined,
	bonusBanner?: GraphQLTypes["ContentReferenceUpdateBonusBannerEntityRelationInput"] | undefined,
	sideBySide?: GraphQLTypes["ContentReferenceUpdateSideBySideEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined,
	showBoolean?: boolean | undefined,
	isRed?: boolean | undefined,
	video?: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateLinkablesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContentReferenceLinkableItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateMediaRelationInput"] | undefined,
	update?: GraphQLTypes["MediumListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertMediaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumListUpdateInput"]: {
		items?: Array<GraphQLTypes["MediumListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["MediumItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["MediumListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["MediumListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["MediumItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["MediumItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["MediumItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["MediumListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["MediumItemUniqueWhere"],
	data: GraphQLTypes["MediumItemWithoutListUpdateInput"]
};
	["MediumItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	medium?: GraphQLTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemUpdateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumItemConnectOrCreateMediumRelationInput"] | undefined,
	update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MediumItemUpsertMediumRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpdateInput"]: {
		type?: GraphQLTypes["MediumType"] | undefined,
	image?: GraphQLTypes["MediumUpdateImageEntityRelationInput"] | undefined,
	video?: GraphQLTypes["MediumUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MediumUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MediumUpdateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateVideoRelationInput"] | undefined,
	update?: GraphQLTypes["VideoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MediumUpsertVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VideoUpdateInput"]: {
		src?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	videoInfo?: string | undefined,
	duration?: number | undefined,
	poster?: GraphQLTypes["VideoUpdatePosterEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VideoUpdatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["VideoConnectOrCreatePosterRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VideoUpsertPosterRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VideoUpsertPosterRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MediumUpsertVideoRelationInput"]: {
		update: GraphQLTypes["VideoUpdateInput"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["MediumItemUpsertMediumRelationInput"]: {
		update: GraphQLTypes["MediumUpdateInput"],
	create: GraphQLTypes["MediumCreateInput"]
};
	["MediumListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["MediumItemUniqueWhere"],
	update: GraphQLTypes["MediumItemWithoutListUpdateInput"],
	create: GraphQLTypes["MediumItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertMediaRelationInput"]: {
		update: GraphQLTypes["MediumListUpdateInput"],
	create: GraphQLTypes["MediumListCreateInput"]
};
	["ContentReferenceUpdateTextListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateTextListRelationInput"] | undefined,
	update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertTextListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextListUpdateInput"]: {
		items?: Array<GraphQLTypes["TextListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["TextItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["TextListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TextListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["TextItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TextItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TextItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TextListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["TextItemUniqueWhere"],
	data: GraphQLTypes["TextItemWithoutListUpdateInput"]
};
	["TextItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	text?: string | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["TextItemUniqueWhere"],
	update: GraphQLTypes["TextItemWithoutListUpdateInput"],
	create: GraphQLTypes["TextItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertTextListRelationInput"]: {
		update: GraphQLTypes["TextListUpdateInput"],
	create: GraphQLTypes["TextListCreateInput"]
};
	["ContentReferenceUpdateCarouselEntityRelationInput"]: {
		connect?: GraphQLTypes["CarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["CarouselCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateCarouselRelationInput"] | undefined,
	update?: GraphQLTypes["CarouselUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertCarouselRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CarouselUpdateInput"]: {
		items?: Array<GraphQLTypes["CarouselUpdateItemsEntityRelationInput"]> | undefined,
	background?: GraphQLTypes["Background"] | undefined,
	squareImages?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["CarouselItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["CarouselUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CarouselUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["CarouselItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CarouselItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CarouselItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CarouselUpdateItemsRelationInput"]: {
		by: GraphQLTypes["CarouselItemUniqueWhere"],
	data: GraphQLTypes["CarouselItemWithoutListUpdateInput"]
};
	["CarouselItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	text?: string | undefined,
	image?: GraphQLTypes["CarouselItemUpdateImageEntityRelationInput"] | undefined,
	name?: string | undefined,
	title?: string | undefined,
	linkUrl?: GraphQLTypes["CarouselItemUpdateLinkUrlEntityRelationInput"] | undefined,
	normalAspectRatio?: boolean | undefined,
	isImage?: boolean | undefined,
	video?: GraphQLTypes["CarouselItemUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CarouselItemConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CarouselItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CarouselItemUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["CarouselItemUpdateLinkUrlEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CarouselItemConnectOrCreateLinkUrlRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CarouselItemUpsertLinkUrlRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CarouselItemUpsertLinkUrlRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["CarouselItemUpdateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CarouselItemConnectOrCreateVideoRelationInput"] | undefined,
	update?: GraphQLTypes["VideoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CarouselItemUpsertVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CarouselItemUpsertVideoRelationInput"]: {
		update: GraphQLTypes["VideoUpdateInput"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["CarouselUpsertItemsRelationInput"]: {
		by: GraphQLTypes["CarouselItemUniqueWhere"],
	update: GraphQLTypes["CarouselItemWithoutListUpdateInput"],
	create: GraphQLTypes["CarouselItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertCarouselRelationInput"]: {
		update: GraphQLTypes["CarouselUpdateInput"],
	create: GraphQLTypes["CarouselCreateInput"]
};
	["ContentReferenceUpdateBonusBannerEntityRelationInput"]: {
		connect?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BonusBannerLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateBonusBannerRelationInput"] | undefined,
	update?: GraphQLTypes["BonusBannerLocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertBonusBannerRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BonusBannerLocaleUpdateInput"]: {
		title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined,
	tiles?: Array<GraphQLTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined,
	logo?: GraphQLTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BonusBannerUniqueWhere"] | undefined,
	create?: GraphQLTypes["BonusBannerWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BonusBannerLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["BonusBannerWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BonusBannerLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["BonusBannerWithoutLocalesUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["BonusBannerWithoutLocalesUpdateInput"],
	create: GraphQLTypes["BonusBannerWithoutLocalesCreateInput"]
};
	["BonusBannerLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBonusBannersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BonusBannerLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutBonusBannersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BonusBannerLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutBonusBannersUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateGenericPagesEntityRelationInput"]: {
		create?: GraphQLTypes["GenericPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateGenericPagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertGenericPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGenericPagesRelationInput"]: {
		by: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	data: GraphQLTypes["GenericPageLocaleWithoutLocaleUpdateInput"]
};
	["GenericPageLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined,
	image?: GraphQLTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["GenericPageLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["GenericPageLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutGenericPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutGenericPageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutGenericPageUpdateInput"]: {
		url?: string | undefined,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateBusinessPageEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateBusinessPageRelationInput"] | undefined,
	update?: GraphQLTypes["BusinessPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertBusinessPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessPageLocaleWithoutLinkUpdateInput"]: {
		root?: GraphQLTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	infoBox?: GraphQLTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBusinessPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutBusinessPagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutBusinessPagesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateJobPagesEntityRelationInput"]: {
		create?: GraphQLTypes["JobPageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateJobPagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertJobPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateJobPagesRelationInput"]: {
		by: GraphQLTypes["JobPageLocaleUniqueWhere"],
	data: GraphQLTypes["JobPageLocaleWithoutLocaleUpdateInput"]
};
	["JobPageLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined,
	image?: GraphQLTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined,
	keyInfo?: GraphQLTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: GraphQLTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: GraphQLTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["JobPageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["JobPageWithoutLocalesUpdateInput"]: {
		theme?: GraphQLTypes["JobPageUpdateThemeEntityRelationInput"] | undefined,
	contractType?: GraphQLTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined,
	jobCity?: GraphQLTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	jobPosition?: GraphQLTypes["JobPageUpdateJobPositionEntityRelationInput"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: GraphQLTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: GraphQLTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageUpdateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateThemeRelationInput"] | undefined,
	update?: GraphQLTypes["ThemeUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageUpsertThemeRelationInput"] | undefined
};
	["JobPageUpsertThemeRelationInput"]: {
		update: GraphQLTypes["ThemeUpdateInput"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["JobPageUpdateContractTypeEntityRelationInput"]: {
		connect?: GraphQLTypes["ContractTypeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContractTypeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateContractTypeRelationInput"] | undefined,
	update?: GraphQLTypes["ContractTypeUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageUpsertContractTypeRelationInput"] | undefined
};
	["ContractTypeUpdateInput"]: {
		locales?: Array<GraphQLTypes["ContractTypeUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ContractTypeLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ContractTypeUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ContractTypeUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContractTypeUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["ContractTypeLocaleUniqueWhere"],
	data: GraphQLTypes["ContractTypeLocaleWithoutRootUpdateInput"]
};
	["ContractTypeLocaleWithoutRootUpdateInput"]: {
		type?: string | undefined,
	locale?: GraphQLTypes["ContractTypeLocaleUpdateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutContractTypesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContractTypeLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutContractTypesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContractTypeLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutContractTypesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateJobCitiesEntityRelationInput"]: {
		create?: GraphQLTypes["JobCityLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateJobCitiesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertJobCitiesRelationInput"] | undefined,
	connect?: GraphQLTypes["JobCityLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobCityLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobCityLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateJobCitiesRelationInput"]: {
		by: GraphQLTypes["JobCityLocaleUniqueWhere"],
	data: GraphQLTypes["JobCityLocaleWithoutLocaleUpdateInput"]
};
	["JobCityLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["JobCityLocaleUpdateRootEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["JobCityUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobCityWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobCityLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["JobCityWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobCityLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["JobCityWithoutLocalesUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["JobCityLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["JobCityWithoutLocalesUpdateInput"],
	create: GraphQLTypes["JobCityWithoutLocalesCreateInput"]
};
	["LocaleUpsertJobCitiesRelationInput"]: {
		by: GraphQLTypes["JobCityLocaleUniqueWhere"],
	update: GraphQLTypes["JobCityLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["JobCityLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateJobPositionsEntityRelationInput"]: {
		create?: GraphQLTypes["JobPositionLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateJobPositionsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertJobPositionsRelationInput"] | undefined,
	connect?: GraphQLTypes["JobPositionLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobPositionLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobPositionLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateJobPositionsRelationInput"]: {
		by: GraphQLTypes["JobPositionLocaleUniqueWhere"],
	data: GraphQLTypes["JobPositionLocaleWithoutLocaleUpdateInput"]
};
	["JobPositionLocaleWithoutLocaleUpdateInput"]: {
		type?: string | undefined,
	root?: GraphQLTypes["JobPositionLocaleUpdateRootEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPositionUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPositionWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPositionLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["JobPositionWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPositionLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["JobPositionWithoutLocalesUpdateInput"]: {
		jobs?: Array<GraphQLTypes["JobPositionUpdateJobsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionUpdateJobsEntityRelationInput"]: {
		create?: GraphQLTypes["JobPageWithoutJobPositionCreateInput"] | undefined,
	update?: GraphQLTypes["JobPositionUpdateJobsRelationInput"] | undefined,
	upsert?: GraphQLTypes["JobPositionUpsertJobsRelationInput"] | undefined,
	connect?: GraphQLTypes["JobPageUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobPageUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobPageUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobPositionUpdateJobsRelationInput"]: {
		by: GraphQLTypes["JobPageUniqueWhere"],
	data: GraphQLTypes["JobPageWithoutJobPositionUpdateInput"]
};
	["JobPageWithoutJobPositionUpdateInput"]: {
		locales?: Array<GraphQLTypes["JobPageUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["JobPageUpdateThemeEntityRelationInput"] | undefined,
	contractType?: GraphQLTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined,
	jobCity?: GraphQLTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: GraphQLTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: GraphQLTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["JobPageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["JobPageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["JobPageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobPageUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["JobPageLocaleUniqueWhere"],
	data: GraphQLTypes["JobPageLocaleWithoutRootUpdateInput"]
};
	["JobPageLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	text?: string | undefined,
	locale?: GraphQLTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	image?: GraphQLTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined,
	keyInfo?: GraphQLTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: GraphQLTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: GraphQLTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutJobPagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutJobPagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutJobPagesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateContractTypesEntityRelationInput"]: {
		create?: GraphQLTypes["ContractTypeLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateContractTypesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertContractTypesRelationInput"] | undefined,
	connect?: GraphQLTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContractTypeLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateContractTypesRelationInput"]: {
		by: GraphQLTypes["ContractTypeLocaleUniqueWhere"],
	data: GraphQLTypes["ContractTypeLocaleWithoutLocaleUpdateInput"]
};
	["ContractTypeLocaleWithoutLocaleUpdateInput"]: {
		type?: string | undefined,
	root?: GraphQLTypes["ContractTypeLocaleUpdateRootEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ContractTypeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContractTypeWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContractTypeLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["ContractTypeWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContractTypeLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ContractTypeWithoutLocalesUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["ContractTypeWithoutLocalesUpdateInput"],
	create: GraphQLTypes["ContractTypeWithoutLocalesCreateInput"]
};
	["LocaleUpsertContractTypesRelationInput"]: {
		by: GraphQLTypes["ContractTypeLocaleUniqueWhere"],
	update: GraphQLTypes["ContractTypeLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["ContractTypeLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateHomePagesEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateHomePagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertHomePagesRelationInput"] | undefined,
	connect?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateHomePagesRelationInput"]: {
		by: GraphQLTypes["HomePageLocaleUniqueWhere"],
	data: GraphQLTypes["HomePageLocaleWithoutLocaleUpdateInput"]
};
	["HomePageLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["HomePageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["HomePageWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	theme?: GraphQLTypes["HomePageUpdateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageUpdateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageConnectOrCreateThemeRelationInput"] | undefined,
	update?: GraphQLTypes["ThemeUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageUpsertThemeRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageUpsertThemeRelationInput"]: {
		update: GraphQLTypes["ThemeUpdateInput"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["HomePageLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["HomePageWithoutLocalesUpdateInput"],
	create: GraphQLTypes["HomePageWithoutLocalesCreateInput"]
};
	["HomePageLocaleUpdateButtonEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateButtonRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertButtonRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertButtonRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["HomePageLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["HomePageLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["HomePageLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutHomePageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutHomePageUpdateInput"]: {
		url?: string | undefined,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateJobPageEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateJobPageRelationInput"] | undefined,
	update?: GraphQLTypes["JobPageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertJobPageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobPageLocaleWithoutLinkUpdateInput"]: {
		title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	image?: GraphQLTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined,
	keyInfo?: GraphQLTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: GraphQLTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: GraphQLTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageLocaleUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobPageLocaleUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["JobPageLocaleUpdateKeyInfoEntityRelationInput"]: {
		connect?: GraphQLTypes["KeyInfoListUniqueWhere"] | undefined,
	create?: GraphQLTypes["KeyInfoListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateKeyInfoRelationInput"] | undefined,
	update?: GraphQLTypes["KeyInfoListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageLocaleUpsertKeyInfoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["KeyInfoListUpdateInput"]: {
		items?: Array<GraphQLTypes["KeyInfoListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["KeyInfoItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["KeyInfoListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["KeyInfoListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["KeyInfoItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["KeyInfoItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["KeyInfoItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["KeyInfoListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["KeyInfoItemUniqueWhere"],
	data: GraphQLTypes["KeyInfoItemWithoutListUpdateInput"]
};
	["KeyInfoItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	keyInfo?: string | undefined,
	icon?: GraphQLTypes["KeyInfoItemUpdateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemUpdateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["IconUniqueWhere"] | undefined,
	create?: GraphQLTypes["IconCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["KeyInfoItemConnectOrCreateIconRelationInput"] | undefined,
	update?: GraphQLTypes["IconUpdateInput"] | undefined,
	upsert?: GraphQLTypes["KeyInfoItemUpsertIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["IconUpdateInput"]: {
		name?: string | undefined,
	icon?: GraphQLTypes["IconUpdateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IconUpdateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["IconConnectOrCreateIconRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["IconUpsertIconRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["IconUpsertIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["KeyInfoItemUpsertIconRelationInput"]: {
		update: GraphQLTypes["IconUpdateInput"],
	create: GraphQLTypes["IconCreateInput"]
};
	["KeyInfoListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["KeyInfoItemUniqueWhere"],
	update: GraphQLTypes["KeyInfoItemWithoutListUpdateInput"],
	create: GraphQLTypes["KeyInfoItemWithoutListCreateInput"]
};
	["JobPageLocaleUpsertKeyInfoRelationInput"]: {
		update: GraphQLTypes["KeyInfoListUpdateInput"],
	create: GraphQLTypes["KeyInfoListCreateInput"]
};
	["JobPageLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobPageLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["JobPageLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobPageLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["JobPageLocaleUpdateStickyBarEntityRelationInput"]: {
		connect?: GraphQLTypes["StickyBarUniqueWhere"] | undefined,
	create?: GraphQLTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined,
	update?: GraphQLTypes["StickyBarUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageLocaleUpsertStickyBarRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StickyBarUpdateInput"]: {
		title?: string | undefined,
	link?: GraphQLTypes["StickyBarUpdateLinkEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	jobsForm?: GraphQLTypes["StickyBarUpdateJobsFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StickyBarUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StickyBarConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StickyBarUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StickyBarUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["StickyBarUpdateJobsFormEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["StickyBarConnectOrCreateJobsFormRelationInput"] | undefined,
	update?: GraphQLTypes["JobsFormLocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StickyBarUpsertJobsFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFormLocaleUpdateInput"]: {
		title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	root?: GraphQLTypes["JobsFormLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobsFormLocaleUpdateLocaleEntityRelationInput"] | undefined,
	imageTextList?: GraphQLTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: GraphQLTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: GraphQLTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["JobsFormWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFormLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["JobsFormWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	fileIlustration?: GraphQLTypes["JobsFormUpdateFileIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormUpdateFileIlustrationEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormConnectOrCreateFileIlustrationRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFormUpsertFileIlustrationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFormUpsertFileIlustrationRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["JobsFormLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["JobsFormWithoutLocalesUpdateInput"],
	create: GraphQLTypes["JobsFormWithoutLocalesCreateInput"]
};
	["JobsFormLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutJobsFormsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutJobsFormsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFormLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutJobsFormsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateBonusBannersEntityRelationInput"]: {
		create?: GraphQLTypes["BonusBannerLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateBonusBannersRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertBonusBannersRelationInput"] | undefined,
	connect?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateBonusBannersRelationInput"]: {
		by: GraphQLTypes["BonusBannerLocaleUniqueWhere"],
	data: GraphQLTypes["BonusBannerLocaleWithoutLocaleUpdateInput"]
};
	["BonusBannerLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined,
	tiles?: Array<GraphQLTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined,
	logo?: GraphQLTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerLocaleUpdateTilesEntityRelationInput"]: {
		create?: GraphQLTypes["TileWithoutBonusBannerCreateInput"] | undefined,
	update?: GraphQLTypes["BonusBannerLocaleUpdateTilesRelationInput"] | undefined,
	upsert?: GraphQLTypes["BonusBannerLocaleUpsertTilesRelationInput"] | undefined,
	connect?: GraphQLTypes["TileUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TileUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TileUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BonusBannerLocaleUpdateTilesRelationInput"]: {
		by: GraphQLTypes["TileUniqueWhere"],
	data: GraphQLTypes["TileWithoutBonusBannerUpdateInput"]
};
	["TileWithoutBonusBannerUpdateInput"]: {
		order?: number | undefined,
	text?: string | undefined,
	image?: GraphQLTypes["TileUpdateImageEntityRelationInput"] | undefined,
	lightBoxTitle?: string | undefined,
	lightBoxText?: string | undefined,
	ligthBoxMedia?: GraphQLTypes["TileUpdateLigthBoxMediaEntityRelationInput"] | undefined,
	lightBoxSectionTitle?: string | undefined,
	title?: string | undefined,
	lightBoxLinkLabel?: string | undefined,
	lightBoxForm?: GraphQLTypes["TileUpdateLightBoxFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["TileUpdateLigthBoxMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileConnectOrCreateLigthBoxMediaRelationInput"] | undefined,
	update?: GraphQLTypes["MediumListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileUpsertLigthBoxMediaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileUpsertLigthBoxMediaRelationInput"]: {
		update: GraphQLTypes["MediumListUpdateInput"],
	create: GraphQLTypes["MediumListCreateInput"]
};
	["TileUpdateLightBoxFormEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileConnectOrCreateLightBoxFormRelationInput"] | undefined,
	update?: GraphQLTypes["JobsFormLocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileUpsertLightBoxFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TileUpsertLightBoxFormRelationInput"]: {
		update: GraphQLTypes["JobsFormLocaleUpdateInput"],
	create: GraphQLTypes["JobsFormLocaleCreateInput"]
};
	["BonusBannerLocaleUpsertTilesRelationInput"]: {
		by: GraphQLTypes["TileUniqueWhere"],
	update: GraphQLTypes["TileWithoutBonusBannerUpdateInput"],
	create: GraphQLTypes["TileWithoutBonusBannerCreateInput"]
};
	["BonusBannerLocaleUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BonusBannerLocaleConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BonusBannerLocaleUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BonusBannerLocaleUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LocaleUpsertBonusBannersRelationInput"]: {
		by: GraphQLTypes["BonusBannerLocaleUniqueWhere"],
	update: GraphQLTypes["BonusBannerLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["BonusBannerLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateHomePageLokalsEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageLokalLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateHomePageLokalsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertHomePageLokalsRelationInput"] | undefined,
	connect?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateHomePageLokalsRelationInput"]: {
		by: GraphQLTypes["HomePageLokalLocaleUniqueWhere"],
	data: GraphQLTypes["HomePageLokalLocaleWithoutLocaleUpdateInput"]
};
	["HomePageLokalLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLokalUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageLokalWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["HomePageLokalWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	theme?: GraphQLTypes["HomePageLokalUpdateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalUpdateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalConnectOrCreateThemeRelationInput"] | undefined,
	update?: GraphQLTypes["ThemeUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalUpsertThemeRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalUpsertThemeRelationInput"]: {
		update: GraphQLTypes["ThemeUpdateInput"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["HomePageLokalLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["HomePageLokalWithoutLocalesUpdateInput"],
	create: GraphQLTypes["HomePageLokalWithoutLocalesCreateInput"]
};
	["HomePageLokalLocaleUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["HomePageLokalLocaleUpdateButtonEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateButtonRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertButtonRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertButtonRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["HomePageLokalLocaleUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertContentRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["HomePageLokalLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["HomePageLokalLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutHomePageLokalCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutHomePageLokalUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutHomePageLokalUpdateInput"]: {
		url?: string | undefined,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateHomePageRelationInput"] | undefined,
	update?: GraphQLTypes["HomePageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertHomePageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleWithoutLinkUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutHomePagesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutHomePagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutHomePagesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateJobsFormsEntityRelationInput"]: {
		create?: GraphQLTypes["JobsFormLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateJobsFormsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertJobsFormsRelationInput"] | undefined,
	connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateJobsFormsRelationInput"]: {
		by: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	data: GraphQLTypes["JobsFormLocaleWithoutLocaleUpdateInput"]
};
	["JobsFormLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	root?: GraphQLTypes["JobsFormLocaleUpdateRootEntityRelationInput"] | undefined,
	imageTextList?: GraphQLTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: GraphQLTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: GraphQLTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormLocaleUpdateImageTextListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageTextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageTextListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormLocaleConnectOrCreateImageTextListRelationInput"] | undefined,
	update?: GraphQLTypes["ImageTextListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFormLocaleUpsertImageTextListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageTextListUpdateInput"]: {
		items?: Array<GraphQLTypes["ImageTextListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ImageTextItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["ImageTextListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ImageTextListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageTextItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ImageTextItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ImageTextItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ImageTextListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ImageTextItemUniqueWhere"],
	data: GraphQLTypes["ImageTextItemWithoutListUpdateInput"]
};
	["ImageTextItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	image?: GraphQLTypes["ImageTextItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageTextItemConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ImageTextItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageTextItemUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ImageTextListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ImageTextItemUniqueWhere"],
	update: GraphQLTypes["ImageTextItemWithoutListUpdateInput"],
	create: GraphQLTypes["ImageTextItemWithoutListCreateInput"]
};
	["JobsFormLocaleUpsertImageTextListRelationInput"]: {
		update: GraphQLTypes["ImageTextListUpdateInput"],
	create: GraphQLTypes["ImageTextListCreateInput"]
};
	["JobsFormLocaleUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormLocaleConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFormLocaleUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFormLocaleUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["JobsFormLocaleUpdateSuccessImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFormLocaleUpsertSuccessImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFormLocaleUpsertSuccessImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LocaleUpsertJobsFormsRelationInput"]: {
		by: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	update: GraphQLTypes["JobsFormLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["JobsFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateJobsFiltersEntityRelationInput"]: {
		create?: GraphQLTypes["JobsFilterLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateJobsFiltersRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertJobsFiltersRelationInput"] | undefined,
	connect?: GraphQLTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateJobsFiltersRelationInput"]: {
		by: GraphQLTypes["JobsFilterLocaleUniqueWhere"],
	data: GraphQLTypes["JobsFilterLocaleWithoutLocaleUpdateInput"]
};
	["JobsFilterLocaleWithoutLocaleUpdateInput"]: {
		jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	root?: GraphQLTypes["JobsFilterLocaleUpdateRootEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: GraphQLTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: GraphQLTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: GraphQLTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFilterUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFilterWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["JobsFilterWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFilterLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["JobsFilterWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["JobsFilterWithoutLocalesUpdateInput"],
	create: GraphQLTypes["JobsFilterWithoutLocalesCreateInput"]
};
	["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"] | undefined,
	update?: GraphQLTypes["JobsFormLocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFilterLocaleUpsertBannerJobsFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFilterLocaleUpsertBannerJobsFormRelationInput"]: {
		update: GraphQLTypes["JobsFormLocaleUpdateInput"],
	create: GraphQLTypes["JobsFormLocaleCreateInput"]
};
	["JobsFilterLocaleUpdateBannerImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFilterLocaleUpsertBannerImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFilterLocaleUpsertBannerImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFilterLocaleUpsertNoJobImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobsFilterLocaleUpsertNoJobImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LocaleUpsertJobsFiltersRelationInput"]: {
		by: GraphQLTypes["JobsFilterLocaleUniqueWhere"],
	update: GraphQLTypes["JobsFilterLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["JobsFilterLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateGeneralEntityRelationInput"]: {
		create?: GraphQLTypes["GeneralLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateGeneralRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertGeneralRelationInput"] | undefined,
	connect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GeneralLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateGeneralRelationInput"]: {
		by: GraphQLTypes["GeneralLocaleUniqueWhere"],
	data: GraphQLTypes["GeneralLocaleWithoutLocaleUpdateInput"]
};
	["GeneralLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	cornerBanner?: GraphQLTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["GeneralUniqueWhere"] | undefined,
	create?: GraphQLTypes["GeneralWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["GeneralWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["GeneralWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["GeneralWithoutLocalesUpdateInput"],
	create: GraphQLTypes["GeneralWithoutLocalesCreateInput"]
};
	["GeneralLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GeneralLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["GeneralLocaleUpdateCornerBannerEntityRelationInput"]: {
		connect?: GraphQLTypes["CornerBannerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CornerBannerCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GeneralLocaleConnectOrCreateCornerBannerRelationInput"] | undefined,
	update?: GraphQLTypes["CornerBannerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GeneralLocaleUpsertCornerBannerRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CornerBannerUpdateInput"]: {
		isActive?: boolean | undefined,
	title?: string | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["CornerBannerUpdateLogoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["CornerBannerUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CornerBannerUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CornerBannerConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CornerBannerUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CornerBannerUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["CornerBannerUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CornerBannerConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CornerBannerUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CornerBannerUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["GeneralLocaleUpsertCornerBannerRelationInput"]: {
		update: GraphQLTypes["CornerBannerUpdateInput"],
	create: GraphQLTypes["CornerBannerCreateInput"]
};
	["LocaleUpsertGeneralRelationInput"]: {
		by: GraphQLTypes["GeneralLocaleUniqueWhere"],
	update: GraphQLTypes["GeneralLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["GeneralLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateRecommendationFormsEntityRelationInput"]: {
		create?: GraphQLTypes["RecommendationFormLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateRecommendationFormsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertRecommendationFormsRelationInput"] | undefined,
	connect?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateRecommendationFormsRelationInput"]: {
		by: GraphQLTypes["RecommendationFormLocaleUniqueWhere"],
	data: GraphQLTypes["RecommendationFormLocaleWithoutLocaleUpdateInput"]
};
	["RecommendationFormLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	root?: GraphQLTypes["RecommendationFormLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["RecommendationFormUniqueWhere"] | undefined,
	create?: GraphQLTypes["RecommendationFormWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecommendationFormLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["RecommendationFormWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RecommendationFormLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["RecommendationFormWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	successImage?: GraphQLTypes["RecommendationFormUpdateSuccessImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormUpdateSuccessImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecommendationFormConnectOrCreateSuccessImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RecommendationFormUpsertSuccessImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RecommendationFormUpsertSuccessImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["RecommendationFormLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["RecommendationFormWithoutLocalesUpdateInput"],
	create: GraphQLTypes["RecommendationFormWithoutLocalesCreateInput"]
};
	["LocaleUpsertRecommendationFormsRelationInput"]: {
		by: GraphQLTypes["RecommendationFormLocaleUniqueWhere"],
	update: GraphQLTypes["RecommendationFormLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["RecommendationFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateInfoBoxesEntityRelationInput"]: {
		create?: GraphQLTypes["InfoBoxLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateInfoBoxesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertInfoBoxesRelationInput"] | undefined,
	connect?: GraphQLTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateInfoBoxesRelationInput"]: {
		by: GraphQLTypes["InfoBoxLocaleUniqueWhere"],
	data: GraphQLTypes["InfoBoxLocaleWithoutLocaleUpdateInput"]
};
	["InfoBoxLocaleWithoutLocaleUpdateInput"]: {
		address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	root?: GraphQLTypes["InfoBoxLocaleUpdateRootEntityRelationInput"] | undefined,
	openingHours?: GraphQLTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoBoxUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoBoxWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoBoxLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["InfoBoxWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InfoBoxLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["InfoBoxWithoutLocalesUpdateInput"]: {
		logoSize?: GraphQLTypes["LogoSize"] | undefined,
	logo?: GraphQLTypes["InfoBoxUpdateLogoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoBoxConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InfoBoxUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InfoBoxUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["InfoBoxLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["InfoBoxWithoutLocalesUpdateInput"],
	create: GraphQLTypes["InfoBoxWithoutLocalesCreateInput"]
};
	["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"] | undefined,
	update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InfoBoxLocaleUpsertOpeningHoursRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InfoBoxLocaleUpsertOpeningHoursRelationInput"]: {
		update: GraphQLTypes["TextListUpdateInput"],
	create: GraphQLTypes["TextListCreateInput"]
};
	["LocaleUpsertInfoBoxesRelationInput"]: {
		by: GraphQLTypes["InfoBoxLocaleUniqueWhere"],
	update: GraphQLTypes["InfoBoxLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["InfoBoxLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateTranslationsEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateTranslationsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertTranslationsRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateTranslationsRelationInput"]: {
		by: GraphQLTypes["TranslationLocaleUniqueWhere"],
	data: GraphQLTypes["TranslationLocaleWithoutLocaleUpdateInput"]
};
	["TranslationLocaleWithoutLocaleUpdateInput"]: {
		value?: string | undefined,
	root?: GraphQLTypes["TranslationLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleUpdateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationWithoutLocalesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationLocaleConnectOrCreateRootRelationInput"] | undefined,
	update?: GraphQLTypes["TranslationWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationLocaleUpsertRootRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["TranslationWithoutLocalesUpdateInput"]: {
		order?: number | undefined,
	key?: string | undefined,
	isTextarea?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["TranslationWithoutLocalesUpdateInput"],
	create: GraphQLTypes["TranslationWithoutLocalesCreateInput"]
};
	["LocaleUpsertTranslationsRelationInput"]: {
		by: GraphQLTypes["TranslationLocaleUniqueWhere"],
	update: GraphQLTypes["TranslationLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["TranslationLocaleWithoutLocaleCreateInput"]
};
	["HomePageLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutHomePagesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutHomePagesCreateInput"]
};
	["HomePageLocaleUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"]: {
		connect?: GraphQLTypes["SiteSwitcherUniqueWhere"] | undefined,
	create?: GraphQLTypes["SiteSwitcherCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined,
	update?: GraphQLTypes["SiteSwitcherUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertSiteSwitcherRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SiteSwitcherUpdateInput"]: {
		title?: string | undefined,
	link?: GraphQLTypes["SiteSwitcherUpdateLinkEntityRelationInput"] | undefined,
	theme?: GraphQLTypes["SiteSwitcherUpdateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SiteSwitcherUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SiteSwitcherConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SiteSwitcherUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SiteSwitcherUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["SiteSwitcherUpdateThemeEntityRelationInput"]: {
		connect?: GraphQLTypes["ThemeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ThemeCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SiteSwitcherConnectOrCreateThemeRelationInput"] | undefined,
	update?: GraphQLTypes["ThemeUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SiteSwitcherUpsertThemeRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SiteSwitcherUpsertThemeRelationInput"]: {
		update: GraphQLTypes["ThemeUpdateInput"],
	create: GraphQLTypes["ThemeCreateInput"]
};
	["HomePageLocaleUpsertSiteSwitcherRelationInput"]: {
		update: GraphQLTypes["SiteSwitcherUpdateInput"],
	create: GraphQLTypes["SiteSwitcherCreateInput"]
};
	["HomePageLocaleUpdateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateGalleryRelationInput"] | undefined,
	update?: GraphQLTypes["GalleryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertGalleryRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GalleryUpdateInput"]: {
		items?: Array<GraphQLTypes["GalleryUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["GalleryUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["GalleryUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GalleryUpdateItemsRelationInput"]: {
		by: GraphQLTypes["GalleryItemUniqueWhere"],
	data: GraphQLTypes["GalleryItemWithoutListUpdateInput"]
};
	["GalleryItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	image?: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GalleryItemConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GalleryItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GalleryItemUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["GalleryUpsertItemsRelationInput"]: {
		by: GraphQLTypes["GalleryItemUniqueWhere"],
	update: GraphQLTypes["GalleryItemWithoutListUpdateInput"],
	create: GraphQLTypes["GalleryItemWithoutListCreateInput"]
};
	["HomePageLocaleUpsertGalleryRelationInput"]: {
		update: GraphQLTypes["GalleryUpdateInput"],
	create: GraphQLTypes["GalleryCreateInput"]
};
	["HomePageLocaleUpdateStickyBarEntityRelationInput"]: {
		connect?: GraphQLTypes["StickyBarUniqueWhere"] | undefined,
	create?: GraphQLTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateStickyBarRelationInput"] | undefined,
	update?: GraphQLTypes["StickyBarUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertStickyBarRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertStickyBarRelationInput"]: {
		update: GraphQLTypes["StickyBarUpdateInput"],
	create: GraphQLTypes["StickyBarCreateInput"]
};
	["HomePageLocaleUpdateIlustrationEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLocaleConnectOrCreateIlustrationRelationInput"] | undefined,
	update?: GraphQLTypes["GalleryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLocaleUpsertIlustrationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLocaleUpsertIlustrationRelationInput"]: {
		update: GraphQLTypes["GalleryUpdateInput"],
	create: GraphQLTypes["GalleryCreateInput"]
};
	["LinkableUpsertHomePageRelationInput"]: {
		update: GraphQLTypes["HomePageLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["HomePageLocaleWithoutLinkCreateInput"]
};
	["HomePageLokalLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutHomePageLokalUpdateInput"],
	create: GraphQLTypes["LinkableWithoutHomePageLokalCreateInput"]
};
	["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"]: {
		connect?: GraphQLTypes["SiteSwitcherUniqueWhere"] | undefined,
	create?: GraphQLTypes["SiteSwitcherCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"] | undefined,
	update?: GraphQLTypes["SiteSwitcherUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertSiteSwitcherRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertSiteSwitcherRelationInput"]: {
		update: GraphQLTypes["SiteSwitcherUpdateInput"],
	create: GraphQLTypes["SiteSwitcherCreateInput"]
};
	["HomePageLokalLocaleUpdateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"] | undefined,
	update?: GraphQLTypes["GalleryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertGalleryRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertGalleryRelationInput"]: {
		update: GraphQLTypes["GalleryUpdateInput"],
	create: GraphQLTypes["GalleryCreateInput"]
};
	["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"]: {
		connect?: GraphQLTypes["StickyBarUniqueWhere"] | undefined,
	create?: GraphQLTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"] | undefined,
	update?: GraphQLTypes["StickyBarUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertStickyBarRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertStickyBarRelationInput"]: {
		update: GraphQLTypes["StickyBarUpdateInput"],
	create: GraphQLTypes["StickyBarCreateInput"]
};
	["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"] | undefined,
	update?: GraphQLTypes["GalleryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertIlustrationRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleUpsertIlustrationRelationInput"]: {
		update: GraphQLTypes["GalleryUpdateInput"],
	create: GraphQLTypes["GalleryCreateInput"]
};
	["LocaleUpsertHomePageLokalsRelationInput"]: {
		by: GraphQLTypes["HomePageLokalLocaleUniqueWhere"],
	update: GraphQLTypes["HomePageLokalLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["HomePageLokalLocaleWithoutLocaleCreateInput"]
};
	["JobsFormLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutJobsFormsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutJobsFormsCreateInput"]
};
	["StickyBarUpsertJobsFormRelationInput"]: {
		update: GraphQLTypes["JobsFormLocaleUpdateInput"],
	create: GraphQLTypes["JobsFormLocaleCreateInput"]
};
	["JobPageLocaleUpsertStickyBarRelationInput"]: {
		update: GraphQLTypes["StickyBarUpdateInput"],
	create: GraphQLTypes["StickyBarCreateInput"]
};
	["JobPageLocaleUpdateMobileImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateMobileImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageLocaleUpsertMobileImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobPageLocaleUpsertMobileImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LinkableUpsertJobPageRelationInput"]: {
		update: GraphQLTypes["JobPageLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["JobPageLocaleWithoutLinkCreateInput"]
};
	["LinkableUpdateHomePageLokalEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageLokalLocaleWithoutLinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateHomePageLokalRelationInput"] | undefined,
	update?: GraphQLTypes["HomePageLokalLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertHomePageLokalRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HomePageLokalLocaleWithoutLinkUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutHomePageLokalsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutHomePageLokalsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutHomePageLokalsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutHomePageLokalsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutHomePageLokalsCreateInput"]
};
	["LinkableUpsertHomePageLokalRelationInput"]: {
		update: GraphQLTypes["HomePageLokalLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["HomePageLokalLocaleWithoutLinkCreateInput"]
};
	["HomePageLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutHomePageUpdateInput"],
	create: GraphQLTypes["LinkableWithoutHomePageCreateInput"]
};
	["LocaleUpsertHomePagesRelationInput"]: {
		by: GraphQLTypes["HomePageLocaleUniqueWhere"],
	update: GraphQLTypes["HomePageLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["HomePageLocaleWithoutLocaleCreateInput"]
};
	["JobPageLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutJobPagesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutJobPagesCreateInput"]
};
	["JobPageLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutJobPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutJobPageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutJobPageUpdateInput"]: {
		url?: string | undefined,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutJobPageUpdateInput"],
	create: GraphQLTypes["LinkableWithoutJobPageCreateInput"]
};
	["JobPageUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["JobPageLocaleUniqueWhere"],
	update: GraphQLTypes["JobPageLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["JobPageLocaleWithoutRootCreateInput"]
};
	["JobPageUpdateJobCityEntityRelationInput"]: {
		connect?: GraphQLTypes["JobCityUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobCityCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateJobCityRelationInput"] | undefined,
	update?: GraphQLTypes["JobCityUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageUpsertJobCityRelationInput"] | undefined
};
	["JobCityUpdateInput"]: {
		locales?: Array<GraphQLTypes["JobCityUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["JobCityLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["JobCityUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["JobCityUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["JobCityLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobCityLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobCityLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobCityUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["JobCityLocaleUniqueWhere"],
	data: GraphQLTypes["JobCityLocaleWithoutRootUpdateInput"]
};
	["JobCityLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["JobCityLocaleUpdateLocaleEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutJobCitiesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobCityLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutJobCitiesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobCityLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutJobCitiesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutJobCitiesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutJobCitiesCreateInput"]
};
	["JobCityUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["JobCityLocaleUniqueWhere"],
	update: GraphQLTypes["JobCityLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["JobCityLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertJobCityRelationInput"]: {
		update: GraphQLTypes["JobCityUpdateInput"],
	create: GraphQLTypes["JobCityCreateInput"]
};
	["JobPageUpdateBusinessEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateBusinessRelationInput"] | undefined,
	update?: GraphQLTypes["BusinessPageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageUpsertBusinessRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessPageUpdateInput"]: {
		locales?: Array<GraphQLTypes["BusinessPageUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["BusinessPageUpdateThemeEntityRelationInput"] | undefined,
	isLokal?: boolean | undefined,
	tabidooId?: string | undefined,
	headerColor?: string | undefined,
	recruitisOfficeId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessPageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessPageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["BusinessPageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BusinessPageUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["BusinessPageLocaleUniqueWhere"],
	data: GraphQLTypes["BusinessPageLocaleWithoutRootUpdateInput"]
};
	["BusinessPageLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	infoBox?: GraphQLTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateSeoRelationInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessPageLocaleUpsertSeoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessPageLocaleUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["BusinessPageLocaleUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutBusinessPageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutBusinessPageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessPageLocaleUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutBusinessPageUpdateInput"]: {
		url?: string | undefined,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutBusinessPageUpdateInput"],
	create: GraphQLTypes["LinkableWithoutBusinessPageCreateInput"]
};
	["BusinessPageLocaleUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessPageLocaleUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessPageLocaleUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BusinessPageLocaleUpdateStickyBarEntityRelationInput"]: {
		connect?: GraphQLTypes["StickyBarUniqueWhere"] | undefined,
	create?: GraphQLTypes["StickyBarCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"] | undefined,
	update?: GraphQLTypes["StickyBarUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessPageLocaleUpsertStickyBarRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessPageLocaleUpsertStickyBarRelationInput"]: {
		update: GraphQLTypes["StickyBarUpdateInput"],
	create: GraphQLTypes["StickyBarCreateInput"]
};
	["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"]: {
		connect?: GraphQLTypes["InfoBoxUniqueWhere"] | undefined,
	create?: GraphQLTypes["InfoBoxCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"] | undefined,
	update?: GraphQLTypes["InfoBoxUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessPageLocaleUpsertInfoBoxRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InfoBoxUpdateInput"]: {
		logoSize?: GraphQLTypes["LogoSize"] | undefined,
	logo?: GraphQLTypes["InfoBoxUpdateLogoEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["InfoBoxUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["InfoBoxLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["InfoBoxUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["InfoBoxUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["InfoBoxLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["InfoBoxUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["InfoBoxLocaleUniqueWhere"],
	data: GraphQLTypes["InfoBoxLocaleWithoutRootUpdateInput"]
};
	["InfoBoxLocaleWithoutRootUpdateInput"]: {
		address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	locale?: GraphQLTypes["InfoBoxLocaleUpdateLocaleEntityRelationInput"] | undefined,
	openingHours?: GraphQLTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutInfoBoxesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["InfoBoxLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutInfoBoxesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InfoBoxLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutInfoBoxesUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutInfoBoxesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutInfoBoxesCreateInput"]
};
	["InfoBoxUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["InfoBoxLocaleUniqueWhere"],
	update: GraphQLTypes["InfoBoxLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["InfoBoxLocaleWithoutRootCreateInput"]
};
	["BusinessPageLocaleUpsertInfoBoxRelationInput"]: {
		update: GraphQLTypes["InfoBoxUpdateInput"],
	create: GraphQLTypes["InfoBoxCreateInput"]
};
	["BusinessPageUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["BusinessPageLocaleUniqueWhere"],
	update: GraphQLTypes["BusinessPageLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["BusinessPageLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertBusinessRelationInput"]: {
		update: GraphQLTypes["BusinessPageUpdateInput"],
	create: GraphQLTypes["BusinessPageCreateInput"]
};
	["JobPositionUpsertJobsRelationInput"]: {
		by: GraphQLTypes["JobPageUniqueWhere"],
	update: GraphQLTypes["JobPageWithoutJobPositionUpdateInput"],
	create: GraphQLTypes["JobPageWithoutJobPositionCreateInput"]
};
	["JobPositionLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["JobPositionWithoutLocalesUpdateInput"],
	create: GraphQLTypes["JobPositionWithoutLocalesCreateInput"]
};
	["LocaleUpsertJobPositionsRelationInput"]: {
		by: GraphQLTypes["JobPositionLocaleUniqueWhere"],
	update: GraphQLTypes["JobPositionLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["JobPositionLocaleWithoutLocaleCreateInput"]
};
	["ContractTypeLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutContractTypesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutContractTypesCreateInput"]
};
	["ContractTypeUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["ContractTypeLocaleUniqueWhere"],
	update: GraphQLTypes["ContractTypeLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["ContractTypeLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertContractTypeRelationInput"]: {
		update: GraphQLTypes["ContractTypeUpdateInput"],
	create: GraphQLTypes["ContractTypeCreateInput"]
};
	["JobPageUpdateJobPositionEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPositionUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPositionWithoutJobsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPageConnectOrCreateJobPositionRelationInput"] | undefined,
	update?: GraphQLTypes["JobPositionWithoutJobsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPageUpsertJobPositionRelationInput"] | undefined
};
	["JobPositionWithoutJobsUpdateInput"]: {
		locales?: Array<GraphQLTypes["JobPositionUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["JobPositionLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["JobPositionUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["JobPositionUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["JobPositionLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobPositionLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobPositionLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobPositionUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["JobPositionLocaleUniqueWhere"],
	data: GraphQLTypes["JobPositionLocaleWithoutRootUpdateInput"]
};
	["JobPositionLocaleWithoutRootUpdateInput"]: {
		type?: string | undefined,
	locale?: GraphQLTypes["JobPositionLocaleUpdateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutJobPositionsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobPositionLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutJobPositionsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobPositionLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutJobPositionsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutJobPositionsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutJobPositionsCreateInput"]
};
	["JobPositionUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["JobPositionLocaleUniqueWhere"],
	update: GraphQLTypes["JobPositionLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["JobPositionLocaleWithoutRootCreateInput"]
};
	["JobPageUpsertJobPositionRelationInput"]: {
		update: GraphQLTypes["JobPositionWithoutJobsUpdateInput"],
	create: GraphQLTypes["JobPositionWithoutJobsCreateInput"]
};
	["JobPageLocaleUpsertRootRelationInput"]: {
		update: GraphQLTypes["JobPageWithoutLocalesUpdateInput"],
	create: GraphQLTypes["JobPageWithoutLocalesCreateInput"]
};
	["LocaleUpsertJobPagesRelationInput"]: {
		by: GraphQLTypes["JobPageLocaleUniqueWhere"],
	update: GraphQLTypes["JobPageLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["JobPageLocaleWithoutLocaleCreateInput"]
};
	["BusinessPageLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutBusinessPagesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutBusinessPagesCreateInput"]
};
	["LinkableUpsertBusinessPageRelationInput"]: {
		update: GraphQLTypes["BusinessPageLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["BusinessPageLocaleWithoutLinkCreateInput"]
};
	["GenericPageLocaleUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutGenericPageUpdateInput"],
	create: GraphQLTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageLocaleUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateLogoRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertLogoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["GenericPageLocaleUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageLocaleConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageLocaleUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GenericPageLocaleUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["LocaleUpsertGenericPagesRelationInput"]: {
		by: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	update: GraphQLTypes["GenericPageLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["GenericPageLocaleWithoutLocaleCreateInput"]
};
	["BonusBannerLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutBonusBannersUpdateInput"],
	create: GraphQLTypes["LocaleWithoutBonusBannersCreateInput"]
};
	["ContentReferenceUpsertBonusBannerRelationInput"]: {
		update: GraphQLTypes["BonusBannerLocaleUpdateInput"],
	create: GraphQLTypes["BonusBannerLocaleCreateInput"]
};
	["ContentReferenceUpdateSideBySideEntityRelationInput"]: {
		connect?: GraphQLTypes["SideBySideUniqueWhere"] | undefined,
	create?: GraphQLTypes["SideBySideCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateSideBySideRelationInput"] | undefined,
	update?: GraphQLTypes["SideBySideUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertSideBySideRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SideBySideUpdateInput"]: {
		items?: Array<GraphQLTypes["SideBySideUpdateItemsEntityRelationInput"]> | undefined,
	background?: GraphQLTypes["Background"] | undefined,
	alignment?: GraphQLTypes["ContentAlignment"] | undefined,
	mediumSize?: GraphQLTypes["MediumSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["SideBySideItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["SideBySideUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["SideBySideUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["SideBySideItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SideBySideItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SideBySideItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SideBySideUpdateItemsRelationInput"]: {
		by: GraphQLTypes["SideBySideItemUniqueWhere"],
	data: GraphQLTypes["SideBySideItemWithoutListUpdateInput"]
};
	["SideBySideItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	text?: string | undefined,
	media?: GraphQLTypes["SideBySideItemUpdateMediaEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	type?: GraphQLTypes["SideBySideItemType"] | undefined,
	link?: GraphQLTypes["SideBySideItemUpdateLinkEntityRelationInput"] | undefined,
	jobsForm?: GraphQLTypes["SideBySideItemUpdateJobsFormEntityRelationInput"] | undefined,
	textNew?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemUpdateMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SideBySideItemConnectOrCreateMediaRelationInput"] | undefined,
	update?: GraphQLTypes["MediumListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SideBySideItemUpsertMediaRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SideBySideItemUpsertMediaRelationInput"]: {
		update: GraphQLTypes["MediumListUpdateInput"],
	create: GraphQLTypes["MediumListCreateInput"]
};
	["SideBySideItemUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SideBySideItemConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SideBySideItemUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SideBySideItemUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["SideBySideItemUpdateJobsFormEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SideBySideItemConnectOrCreateJobsFormRelationInput"] | undefined,
	update?: GraphQLTypes["JobsFormLocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SideBySideItemUpsertJobsFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SideBySideItemUpsertJobsFormRelationInput"]: {
		update: GraphQLTypes["JobsFormLocaleUpdateInput"],
	create: GraphQLTypes["JobsFormLocaleCreateInput"]
};
	["SideBySideUpsertItemsRelationInput"]: {
		by: GraphQLTypes["SideBySideItemUniqueWhere"],
	update: GraphQLTypes["SideBySideItemWithoutListUpdateInput"],
	create: GraphQLTypes["SideBySideItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertSideBySideRelationInput"]: {
		update: GraphQLTypes["SideBySideUpdateInput"],
	create: GraphQLTypes["SideBySideCreateInput"]
};
	["ContentReferenceUpdateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateGalleryRelationInput"] | undefined,
	update?: GraphQLTypes["GalleryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertGalleryRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertGalleryRelationInput"]: {
		update: GraphQLTypes["GalleryUpdateInput"],
	create: GraphQLTypes["GalleryCreateInput"]
};
	["ContentReferenceUpdateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | undefined,
	update?: GraphQLTypes["VideoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertVideoRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertVideoRelationInput"]: {
		update: GraphQLTypes["VideoUpdateInput"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
		by: GraphQLTypes["ContentReferenceUniqueWhere"],
	update: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"],
	create: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
		by: GraphQLTypes["ContentBlockUniqueWhere"],
	update: GraphQLTypes["ContentBlockWithoutContentUpdateInput"],
	create: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["BusinessPageLocaleUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["LocaleUpsertBusinessPagesRelationInput"]: {
		by: GraphQLTypes["BusinessPageLocaleUniqueWhere"],
	update: GraphQLTypes["BusinessPageLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["BusinessPageLocaleWithoutLocaleCreateInput"]
};
	["GenericPageLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutGenericPagesUpdateInput"],
	create: GraphQLTypes["LocaleWithoutGenericPagesCreateInput"]
};
	["LinkableUpsertGenericPageRelationInput"]: {
		update: GraphQLTypes["GenericPageLocaleWithoutLinkUpdateInput"],
	create: GraphQLTypes["GenericPageLocaleWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
		update: GraphQLTypes["LinkableUpdateInput"],
	create: GraphQLTypes["LinkableCreateInput"]
};
	["FooterLinkUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleUpsertLinksFirstColumnRelationInput"]: {
		by: GraphQLTypes["FooterLinkUniqueWhere"],
	update: GraphQLTypes["FooterLinkUpdateInput"],
	create: GraphQLTypes["FooterLinkCreateInput"]
};
	["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLinkCreateInput"] | undefined,
	update?: GraphQLTypes["FooterLocaleUpdateLinksSecondColumnRelationInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertLinksSecondColumnRelationInput"] | undefined,
	connect?: GraphQLTypes["FooterLinkUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FooterLinkUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FooterLinkUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleUpdateLinksSecondColumnRelationInput"]: {
		by: GraphQLTypes["FooterLinkUniqueWhere"],
	data: GraphQLTypes["FooterLinkUpdateInput"]
};
	["FooterLocaleUpsertLinksSecondColumnRelationInput"]: {
		by: GraphQLTypes["FooterLinkUniqueWhere"],
	update: GraphQLTypes["FooterLinkUpdateInput"],
	create: GraphQLTypes["FooterLinkCreateInput"]
};
	["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertTermsAndConditionsRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertTermsAndConditionsRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateBannerImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateBannerImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertBannerImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertBannerImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["FooterLocaleUpdateBannerLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateBannerLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertBannerLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertBannerLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateJobsFormEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateJobsFormRelationInput"] | undefined,
	update?: GraphQLTypes["JobsFormLocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertJobsFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertJobsFormRelationInput"]: {
		update: GraphQLTypes["JobsFormLocaleUpdateInput"],
	create: GraphQLTypes["JobsFormLocaleCreateInput"]
};
	["FooterLocaleUpdateCopyrightLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertCopyrightLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertCopyrightLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateRecommendationFormEntityRelationInput"]: {
		connect?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["RecommendationFormLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateRecommendationFormRelationInput"] | undefined,
	update?: GraphQLTypes["RecommendationFormLocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertRecommendationFormRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RecommendationFormLocaleUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	root?: GraphQLTypes["RecommendationFormLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["RecommendationFormLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutRecommendationFormsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutRecommendationFormsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RecommendationFormLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutRecommendationFormsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutRecommendationFormsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutRecommendationFormsCreateInput"]
};
	["FooterLocaleUpsertRecommendationFormRelationInput"]: {
		update: GraphQLTypes["RecommendationFormLocaleUpdateInput"],
	create: GraphQLTypes["RecommendationFormLocaleCreateInput"]
};
	["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertBannerSecondLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertBannerSecondLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleUpdateInstagramLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateInstagramLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertInstagramLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FooterLocaleUpsertInstagramLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["LocaleUpsertFootersRelationInput"]: {
		by: GraphQLTypes["FooterLocaleUniqueWhere"],
	update: GraphQLTypes["FooterLocaleWithoutLocaleUpdateInput"],
	create: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["GeneralLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutGeneralUpdateInput"],
	create: GraphQLTypes["LocaleWithoutGeneralCreateInput"]
};
	["GeneralUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["GeneralLocaleUniqueWhere"],
	update: GraphQLTypes["GeneralLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["GeneralLocaleWithoutRootCreateInput"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["GenericPageConnection"]: {
	__typename: "GenericPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GenericPageEdge"]>
};
	["GenericPageEdge"]: {
	__typename: "GenericPageEdge",
	node: GraphQLTypes["GenericPage"]
};
	["GenericPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["GenericPageCreateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["GenericPageCreateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["GenericPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: GraphQLTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined,
	image?: GraphQLTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	create: GraphQLTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["GenericPageUpdateInput"]: {
		locales?: Array<GraphQLTypes["GenericPageUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["GenericPageUpdateThemeEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["GenericPageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["GenericPageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["GenericPageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GenericPageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GenericPageUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	data: GraphQLTypes["GenericPageLocaleWithoutRootUpdateInput"]
};
	["GenericPageLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	locale?: GraphQLTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined,
	image?: GraphQLTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["GenericPageLocaleUniqueWhere"],
	update: GraphQLTypes["GenericPageLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["GenericPageLocaleWithoutRootCreateInput"]
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["ContentConnection"]: {
	__typename: "ContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
	__typename: "ContentEdge",
	node: GraphQLTypes["Content"]
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"] | undefined,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined
};
	["ContentWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentBlockUpdateInput"]: {
		order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentBlockConnectOrCreateContentRelationInput"] | undefined,
	update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentBlockUpsertContentRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ContentWithoutBlocksUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["ContentBlockUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	create: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"] | undefined,
	linkables?: Array<GraphQLTypes["ContentReferenceCreateLinkablesEntityRelationInput"]> | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	media?: GraphQLTypes["ContentReferenceCreateMediaEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined,
	carousel?: GraphQLTypes["ContentReferenceCreateCarouselEntityRelationInput"] | undefined,
	bonusBanner?: GraphQLTypes["ContentReferenceCreateBonusBannerEntityRelationInput"] | undefined,
	sideBySide?: GraphQLTypes["ContentReferenceCreateSideBySideEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined,
	showBoolean?: boolean | undefined,
	isRed?: boolean | undefined,
	video?: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined
};
	["ContentBlockWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceConnectOrCreateBlockRelationInput"]: {
		connect: GraphQLTypes["ContentBlockUniqueWhere"],
	create: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"] | undefined,
	linkables?: Array<GraphQLTypes["ContentReferenceUpdateLinkablesEntityRelationInput"]> | undefined,
	secondaryText?: string | undefined,
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	media?: GraphQLTypes["ContentReferenceUpdateMediaEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined,
	carousel?: GraphQLTypes["ContentReferenceUpdateCarouselEntityRelationInput"] | undefined,
	bonusBanner?: GraphQLTypes["ContentReferenceUpdateBonusBannerEntityRelationInput"] | undefined,
	sideBySide?: GraphQLTypes["ContentReferenceUpdateSideBySideEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined,
	showBoolean?: boolean | undefined,
	isRed?: boolean | undefined,
	video?: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | undefined,
	update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
		order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpsertBlockRelationInput"]: {
		update: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	create: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["RedirectConnection"]: {
	__typename: "RedirectConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RedirectEdge"]>
};
	["RedirectEdge"]: {
	__typename: "RedirectEdge",
	node: GraphQLTypes["Redirect"]
};
	["RedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["RedirectCreateLinkEntityRelationInput"] | undefined,
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateLinkRelationInput"] | undefined
};
	["LinkableWithoutRedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableCreateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableCreateJobPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableCreateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["RedirectUpdateInput"]: {
		link?: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"] | undefined,
	target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateLinkRelationInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RedirectUpsertLinkRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutRedirectUpdateInput"]: {
		url?: string | undefined,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"] | undefined,
	businessPage?: GraphQLTypes["LinkableUpdateBusinessPageEntityRelationInput"] | undefined,
	jobPage?: GraphQLTypes["LinkableUpdateJobPageEntityRelationInput"] | undefined,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"] | undefined,
	homePageLokal?: GraphQLTypes["LinkableUpdateHomePageLokalEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	create: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["FooterConnection"]: {
	__typename: "FooterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterEdge"]>
};
	["FooterEdge"]: {
	__typename: "FooterEdge",
	node: GraphQLTypes["Footer"]
};
	["FooterCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["FooterCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["FooterLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["FooterLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	locale?: GraphQLTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<GraphQLTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<GraphQLTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: GraphQLTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: GraphQLTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: GraphQLTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: GraphQLTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: GraphQLTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: GraphQLTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: GraphQLTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: GraphQLTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutFootersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutFootersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["FooterLocaleUniqueWhere"],
	create: GraphQLTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["FooterUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["FooterUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["FooterUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FooterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FooterUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["FooterLocaleUniqueWhere"],
	data: GraphQLTypes["FooterLocaleWithoutRootUpdateInput"]
};
	["FooterLocaleWithoutRootUpdateInput"]: {
		email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	locale?: GraphQLTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<GraphQLTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<GraphQLTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: GraphQLTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: GraphQLTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: GraphQLTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: GraphQLTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: GraphQLTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: GraphQLTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: GraphQLTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: GraphQLTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutFootersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["FooterLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutFootersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FooterLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutFootersUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutFootersUpdateInput"],
	create: GraphQLTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["FooterLocaleUniqueWhere"],
	update: GraphQLTypes["FooterLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	root?: GraphQLTypes["FooterLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["FooterLocaleCreateLocaleEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<GraphQLTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<GraphQLTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: GraphQLTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: GraphQLTypes["FooterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: GraphQLTypes["FooterLocaleCreateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: GraphQLTypes["FooterLocaleCreateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: GraphQLTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: GraphQLTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: GraphQLTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: GraphQLTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FooterLocaleUpdateInput"]: {
		email?: string | undefined,
	address?: string | undefined,
	ico?: string | undefined,
	dic?: string | undefined,
	copyright?: string | undefined,
	note?: string | undefined,
	noteSecond?: string | undefined,
	root?: GraphQLTypes["FooterLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	linksFirstColumn?: Array<GraphQLTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]> | undefined,
	linksSecondColumn?: Array<GraphQLTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]> | undefined,
	termsAndConditions?: GraphQLTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"] | undefined,
	form?: string | undefined,
	bannerTitle?: string | undefined,
	bannerSubtitle?: string | undefined,
	bannerImage?: GraphQLTypes["FooterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	bannerLink?: GraphQLTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"] | undefined,
	jobsForm?: GraphQLTypes["FooterLocaleUpdateJobsFormEntityRelationInput"] | undefined,
	copyrightLink?: GraphQLTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"] | undefined,
	bannerSecondBtn?: string | undefined,
	recommendationForm?: GraphQLTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"] | undefined,
	bannerSecondLink?: GraphQLTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"] | undefined,
	instagramLink?: GraphQLTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleCreateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["GenericPageLocaleCreateLogoEntityRelationInput"] | undefined,
	image?: GraphQLTypes["GenericPageLocaleCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GenericPageLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["GenericPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["GenericPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GenericPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GenericPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	text?: string | undefined,
	logo?: GraphQLTypes["GenericPageLocaleUpdateLogoEntityRelationInput"] | undefined,
	image?: GraphQLTypes["GenericPageLocaleUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderConnection"]: {
	__typename: "HeaderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderEdge"]>
};
	["HeaderEdge"]: {
	__typename: "HeaderEdge",
	node: GraphQLTypes["Header"]
};
	["HeaderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["HeaderCreateLocalesEntityRelationInput"]> | undefined,
	logo?: GraphQLTypes["HeaderCreateLogoEntityRelationInput"] | undefined,
	logoMenu?: GraphQLTypes["HeaderCreateLogoMenuEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["HeaderLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<GraphQLTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<GraphQLTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: GraphQLTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: GraphQLTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutHeadersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutHeadersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["HeaderLocaleUniqueWhere"],
	create: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["HeaderUpdateLocalesEntityRelationInput"]> | undefined,
	logo?: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"] | undefined,
	logoMenu?: GraphQLTypes["HeaderUpdateLogoMenuEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["HeaderUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["HeaderUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["HeaderLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HeaderUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["HeaderLocaleUniqueWhere"],
	data: GraphQLTypes["HeaderLocaleWithoutRootUpdateInput"]
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<GraphQLTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<GraphQLTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: GraphQLTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: GraphQLTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutHeadersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutHeadersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeaderLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutHeadersUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutHeadersUpdateInput"],
	create: GraphQLTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["HeaderLocaleUniqueWhere"],
	update: GraphQLTypes["HeaderLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<GraphQLTypes["HeaderLocaleCreateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<GraphQLTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: GraphQLTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: GraphQLTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeaderLocaleUpdateInput"]: {
		root?: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | undefined,
	menuLabel?: string | undefined,
	menuTitle?: string | undefined,
	menuText?: string | undefined,
	business?: Array<GraphQLTypes["HeaderLocaleUpdateBusinessEntityRelationInput"]> | undefined,
	lokalEnterprise?: Array<GraphQLTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]> | undefined,
	businessSectionTitle?: string | undefined,
	lokalSectionTitle?: string | undefined,
	businessLink?: GraphQLTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"] | undefined,
	lokalLink?: GraphQLTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleConnection"]: {
	__typename: "LocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LocaleEdge"]>
};
	["LocaleEdge"]: {
	__typename: "LocaleEdge",
	node: GraphQLTypes["Locale"]
};
	["LocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultConnection"]: {
	__typename: "SeoDefaultConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoDefaultEdge"]>
};
	["SeoDefaultEdge"]: {
	__typename: "SeoDefaultEdge",
	node: GraphQLTypes["SeoDefault"]
};
	["SeoDefaultCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["SeoDefaultCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoDefaultLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoDefaultConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["SeoDefaultLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutSeoDefaultsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutSeoDefaultsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutSeoDefaultsCreateInput"]
};
	["SeoDefaultConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	create: GraphQLTypes["SeoDefaultLocaleWithoutRootCreateInput"]
};
	["SeoDefaultUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["SeoDefaultUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["SeoDefaultLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["SeoDefaultUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["SeoDefaultUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SeoDefaultUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	data: GraphQLTypes["SeoDefaultLocaleWithoutRootUpdateInput"]
};
	["SeoDefaultLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutSeoDefaultsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutSeoDefaultsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SeoDefaultLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutSeoDefaultsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutSeoDefaultsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutSeoDefaultsCreateInput"]
};
	["SeoDefaultUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	update: GraphQLTypes["SeoDefaultLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["SeoDefaultLocaleWithoutRootCreateInput"]
};
	["SeoDefaultLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["SeoDefaultLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoDefaultLocaleUpdateInput"]: {
		root?: GraphQLTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageConnection"]: {
	__typename: "BusinessPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessPageEdge"]>
};
	["BusinessPageEdge"]: {
	__typename: "BusinessPageEdge",
	node: GraphQLTypes["BusinessPage"]
};
	["BusinessPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["BusinessPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BusinessPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BusinessPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BusinessPageLocaleCreateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["BusinessPageLocaleCreateImageEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	infoBox?: GraphQLTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessPageLocaleUpdateInput"]: {
		root?: GraphQLTypes["BusinessPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BusinessPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	subtitle?: string | undefined,
	text?: string | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["BusinessPageLocaleUpdateImageEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	infoBox?: GraphQLTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IconConnection"]: {
	__typename: "IconConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IconEdge"]>
};
	["IconEdge"]: {
	__typename: "IconEdge",
	node: GraphQLTypes["Icon"]
};
	["JobPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["JobPageCreateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["JobPageCreateThemeEntityRelationInput"] | undefined,
	contractType?: GraphQLTypes["JobPageCreateContractTypeEntityRelationInput"] | undefined,
	jobCity?: GraphQLTypes["JobPageCreateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	jobPosition?: GraphQLTypes["JobPageCreateJobPositionEntityRelationInput"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: GraphQLTypes["JobPageCreateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: GraphQLTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageUpdateInput"]: {
		locales?: Array<GraphQLTypes["JobPageUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["JobPageUpdateThemeEntityRelationInput"] | undefined,
	contractType?: GraphQLTypes["JobPageUpdateContractTypeEntityRelationInput"] | undefined,
	jobCity?: GraphQLTypes["JobPageUpdateJobCityEntityRelationInput"] | undefined,
	isActive?: boolean | undefined,
	jobPosition?: GraphQLTypes["JobPageUpdateJobPositionEntityRelationInput"] | undefined,
	publishedAt?: GraphQLTypes["DateTime"] | undefined,
	order?: number | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	business?: GraphQLTypes["JobPageUpdateBusinessEntityRelationInput"] | undefined,
	headerColor?: string | undefined,
	siteType?: GraphQLTypes["SiteType"] | undefined,
	isHiddenFromListing?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["JobPageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobPageLocaleCreateLocaleEntityRelationInput"] | undefined,
	image?: GraphQLTypes["JobPageLocaleCreateImageEntityRelationInput"] | undefined,
	keyInfo?: GraphQLTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["JobPageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["JobPageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["JobPageLocaleCreateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: GraphQLTypes["JobPageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: GraphQLTypes["JobPageLocaleCreateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPageLocaleUpdateInput"]: {
		title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["JobPageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobPageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	image?: GraphQLTypes["JobPageLocaleUpdateImageEntityRelationInput"] | undefined,
	keyInfo?: GraphQLTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["JobPageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["JobPageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["JobPageLocaleUpdateLinkEntityRelationInput"] | undefined,
	email?: string | undefined,
	stickyBar?: GraphQLTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	mobileImage?: GraphQLTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	recruitisJobId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	keyInfo?: string | undefined,
	list?: GraphQLTypes["KeyInfoItemCreateListEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["KeyInfoItemCreateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["KeyInfoListUniqueWhere"] | undefined,
	create?: GraphQLTypes["KeyInfoListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["KeyInfoItemConnectOrCreateListRelationInput"] | undefined
};
	["KeyInfoListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["KeyInfoListUniqueWhere"],
	create: GraphQLTypes["KeyInfoListWithoutItemsCreateInput"]
};
	["KeyInfoItemUpdateInput"]: {
		order?: number | undefined,
	keyInfo?: string | undefined,
	list?: GraphQLTypes["KeyInfoItemUpdateListEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["KeyInfoItemUpdateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["KeyInfoItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["KeyInfoListUniqueWhere"] | undefined,
	create?: GraphQLTypes["KeyInfoListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["KeyInfoItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["KeyInfoListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["KeyInfoItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["KeyInfoListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["KeyInfoItemUpsertListRelationInput"]: {
		update: GraphQLTypes["KeyInfoListWithoutItemsUpdateInput"],
	create: GraphQLTypes["KeyInfoListWithoutItemsCreateInput"]
};
	["KeyInfoListConnection"]: {
	__typename: "KeyInfoListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["KeyInfoListEdge"]>
};
	["KeyInfoListEdge"]: {
	__typename: "KeyInfoListEdge",
	node: GraphQLTypes["KeyInfoList"]
};
	["ContractTypeConnection"]: {
	__typename: "ContractTypeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContractTypeEdge"]>
};
	["ContractTypeEdge"]: {
	__typename: "ContractTypeEdge",
	node: GraphQLTypes["ContractType"]
};
	["ContractTypeLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: string | undefined,
	root?: GraphQLTypes["ContractTypeLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ContractTypeLocaleCreateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContractTypeLocaleUpdateInput"]: {
		type?: string | undefined,
	root?: GraphQLTypes["ContractTypeLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ContractTypeLocaleUpdateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityConnection"]: {
	__typename: "JobCityConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobCityEdge"]>
};
	["JobCityEdge"]: {
	__typename: "JobCityEdge",
	node: GraphQLTypes["JobCity"]
};
	["JobCityLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["JobCityLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobCityLocaleCreateLocaleEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobCityLocaleUpdateInput"]: {
		root?: GraphQLTypes["JobCityLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobCityLocaleUpdateLocaleEntityRelationInput"] | undefined,
	name?: string | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionConnection"]: {
	__typename: "JobPositionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobPositionEdge"]>
};
	["JobPositionEdge"]: {
	__typename: "JobPositionEdge",
	node: GraphQLTypes["JobPosition"]
};
	["JobPositionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["JobPositionCreateLocalesEntityRelationInput"]> | undefined,
	jobs?: Array<GraphQLTypes["JobPositionCreateJobsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionUpdateInput"]: {
		locales?: Array<GraphQLTypes["JobPositionUpdateLocalesEntityRelationInput"]> | undefined,
	jobs?: Array<GraphQLTypes["JobPositionUpdateJobsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: string | undefined,
	root?: GraphQLTypes["JobPositionLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobPositionLocaleCreateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobPositionLocaleUpdateInput"]: {
		type?: string | undefined,
	root?: GraphQLTypes["JobPositionLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobPositionLocaleUpdateLocaleEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryConnection"]: {
	__typename: "GalleryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryEdge"]>
};
	["GalleryEdge"]: {
	__typename: "GalleryEdge",
	node: GraphQLTypes["Gallery"]
};
	["HomePageConnection"]: {
	__typename: "HomePageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageEdge"]>
};
	["HomePageEdge"]: {
	__typename: "HomePageEdge",
	node: GraphQLTypes["HomePage"]
};
	["HomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["HomePageCreateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["HomePageCreateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["HomePageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: GraphQLTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["HomePageLocaleUniqueWhere"],
	create: GraphQLTypes["HomePageLocaleWithoutRootCreateInput"]
};
	["HomePageUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["HomePageUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["HomePageUpdateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["HomePageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["HomePageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["HomePageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HomePageUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["HomePageLocaleUniqueWhere"],
	data: GraphQLTypes["HomePageLocaleWithoutRootUpdateInput"]
};
	["HomePageLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	locale?: GraphQLTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["HomePageLocaleUniqueWhere"],
	update: GraphQLTypes["HomePageLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["HomePageLocaleWithoutRootCreateInput"]
};
	["HomePageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["HomePageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLocaleCreateLinkEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLocaleCreateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["HomePageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLocaleUpdateLogoEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumConnection"]: {
	__typename: "MediumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumEdge"]>
};
	["MediumEdge"]: {
	__typename: "MediumEdge",
	node: GraphQLTypes["Medium"]
};
	["MediumItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["MediumItemCreateListEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["MediumItemCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumItemConnectOrCreateListRelationInput"] | undefined
};
	["MediumListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["MediumListUniqueWhere"],
	create: GraphQLTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["MediumItemUpdateListEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["MediumItemUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["MediumItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["MediumListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MediumItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["MediumItemUpsertListRelationInput"]: {
		update: GraphQLTypes["MediumListWithoutItemsUpdateInput"],
	create: GraphQLTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumListConnection"]: {
	__typename: "MediumListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumListEdge"]>
};
	["MediumListEdge"]: {
	__typename: "MediumListEdge",
	node: GraphQLTypes["MediumList"]
};
	["VideoConnection"]: {
	__typename: "VideoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VideoEdge"]>
};
	["VideoEdge"]: {
	__typename: "VideoEdge",
	node: GraphQLTypes["Video"]
};
	["TextItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["TextItemCreateListEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TextItemConnectOrCreateListRelationInput"] | undefined
};
	["TextListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["TextListUniqueWhere"],
	create: GraphQLTypes["TextListWithoutItemsCreateInput"]
};
	["TextItemUpdateInput"]: {
		order?: number | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["TextItemUpdateListEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TextItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["TextListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TextItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["TextItemUpsertListRelationInput"]: {
		update: GraphQLTypes["TextListWithoutItemsUpdateInput"],
	create: GraphQLTypes["TextListWithoutItemsCreateInput"]
};
	["TextListConnection"]: {
	__typename: "TextListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextListEdge"]>
};
	["TextListEdge"]: {
	__typename: "TextListEdge",
	node: GraphQLTypes["TextList"]
};
	["CarouselConnection"]: {
	__typename: "CarouselConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CarouselEdge"]>
};
	["CarouselEdge"]: {
	__typename: "CarouselEdge",
	node: GraphQLTypes["Carousel"]
};
	["CarouselItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["CarouselItemCreateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["CarouselItemCreateImageEntityRelationInput"] | undefined,
	name?: string | undefined,
	title?: string | undefined,
	linkUrl?: GraphQLTypes["CarouselItemCreateLinkUrlEntityRelationInput"] | undefined,
	normalAspectRatio?: boolean | undefined,
	isImage?: boolean | undefined,
	video?: GraphQLTypes["CarouselItemCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["CarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["CarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CarouselItemConnectOrCreateListRelationInput"] | undefined
};
	["CarouselWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	background?: GraphQLTypes["Background"] | undefined,
	squareImages?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["CarouselUniqueWhere"],
	create: GraphQLTypes["CarouselWithoutItemsCreateInput"]
};
	["CarouselItemUpdateInput"]: {
		order?: number | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["CarouselItemUpdateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["CarouselItemUpdateImageEntityRelationInput"] | undefined,
	name?: string | undefined,
	title?: string | undefined,
	linkUrl?: GraphQLTypes["CarouselItemUpdateLinkUrlEntityRelationInput"] | undefined,
	normalAspectRatio?: boolean | undefined,
	isImage?: boolean | undefined,
	video?: GraphQLTypes["CarouselItemUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["CarouselUniqueWhere"] | undefined,
	create?: GraphQLTypes["CarouselWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["CarouselItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["CarouselWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CarouselItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CarouselWithoutItemsUpdateInput"]: {
		background?: GraphQLTypes["Background"] | undefined,
	squareImages?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CarouselItemUpsertListRelationInput"]: {
		update: GraphQLTypes["CarouselWithoutItemsUpdateInput"],
	create: GraphQLTypes["CarouselWithoutItemsCreateInput"]
};
	["ThemeConnection"]: {
	__typename: "ThemeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ThemeEdge"]>
};
	["ThemeEdge"]: {
	__typename: "ThemeEdge",
	node: GraphQLTypes["Theme"]
};
	["BonusBannerConnection"]: {
	__typename: "BonusBannerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BonusBannerEdge"]>
};
	["BonusBannerEdge"]: {
	__typename: "BonusBannerEdge",
	node: GraphQLTypes["BonusBanner"]
};
	["BonusBannerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["BonusBannerCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BonusBannerLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["BonusBannerConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["BonusBannerLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	locale?: GraphQLTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined,
	tiles?: Array<GraphQLTypes["BonusBannerLocaleCreateTilesEntityRelationInput"]> | undefined,
	logo?: GraphQLTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["BonusBannerLocaleUniqueWhere"],
	create: GraphQLTypes["BonusBannerLocaleWithoutRootCreateInput"]
};
	["BonusBannerUpdateInput"]: {
		locales?: Array<GraphQLTypes["BonusBannerUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["BonusBannerLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["BonusBannerUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["BonusBannerUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BonusBannerUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["BonusBannerLocaleUniqueWhere"],
	data: GraphQLTypes["BonusBannerLocaleWithoutRootUpdateInput"]
};
	["BonusBannerLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	text?: string | undefined,
	locale?: GraphQLTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined,
	tiles?: Array<GraphQLTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"]> | undefined,
	logo?: GraphQLTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BonusBannerUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["BonusBannerLocaleUniqueWhere"],
	update: GraphQLTypes["BonusBannerLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["BonusBannerLocaleWithoutRootCreateInput"]
};
	["TileCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	bonusBanner?: GraphQLTypes["TileCreateBonusBannerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["TileCreateImageEntityRelationInput"] | undefined,
	lightBoxTitle?: string | undefined,
	lightBoxText?: string | undefined,
	ligthBoxMedia?: GraphQLTypes["TileCreateLigthBoxMediaEntityRelationInput"] | undefined,
	lightBoxSectionTitle?: string | undefined,
	title?: string | undefined,
	lightBoxLinkLabel?: string | undefined,
	lightBoxForm?: GraphQLTypes["TileCreateLightBoxFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileCreateBonusBannerEntityRelationInput"]: {
		connect?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BonusBannerLocaleWithoutTilesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileConnectOrCreateBonusBannerRelationInput"] | undefined
};
	["BonusBannerLocaleWithoutTilesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["BonusBannerLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BonusBannerLocaleCreateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileConnectOrCreateBonusBannerRelationInput"]: {
		connect: GraphQLTypes["BonusBannerLocaleUniqueWhere"],
	create: GraphQLTypes["BonusBannerLocaleWithoutTilesCreateInput"]
};
	["TileUpdateInput"]: {
		order?: number | undefined,
	text?: string | undefined,
	bonusBanner?: GraphQLTypes["TileUpdateBonusBannerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["TileUpdateImageEntityRelationInput"] | undefined,
	lightBoxTitle?: string | undefined,
	lightBoxText?: string | undefined,
	ligthBoxMedia?: GraphQLTypes["TileUpdateLigthBoxMediaEntityRelationInput"] | undefined,
	lightBoxSectionTitle?: string | undefined,
	title?: string | undefined,
	lightBoxLinkLabel?: string | undefined,
	lightBoxForm?: GraphQLTypes["TileUpdateLightBoxFormEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileUpdateBonusBannerEntityRelationInput"]: {
		connect?: GraphQLTypes["BonusBannerLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BonusBannerLocaleWithoutTilesCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TileConnectOrCreateBonusBannerRelationInput"] | undefined,
	update?: GraphQLTypes["BonusBannerLocaleWithoutTilesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TileUpsertBonusBannerRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BonusBannerLocaleWithoutTilesUpdateInput"]: {
		title?: string | undefined,
	text?: string | undefined,
	root?: GraphQLTypes["BonusBannerLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"] | undefined,
	bannerName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TileUpsertBonusBannerRelationInput"]: {
		update: GraphQLTypes["BonusBannerLocaleWithoutTilesUpdateInput"],
	create: GraphQLTypes["BonusBannerLocaleWithoutTilesCreateInput"]
};
	["SideBySideConnection"]: {
	__typename: "SideBySideConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SideBySideEdge"]>
};
	["SideBySideEdge"]: {
	__typename: "SideBySideEdge",
	node: GraphQLTypes["SideBySide"]
};
	["SideBySideItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["SideBySideItemCreateListEntityRelationInput"] | undefined,
	media?: GraphQLTypes["SideBySideItemCreateMediaEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	type?: GraphQLTypes["SideBySideItemType"] | undefined,
	link?: GraphQLTypes["SideBySideItemCreateLinkEntityRelationInput"] | undefined,
	jobsForm?: GraphQLTypes["SideBySideItemCreateJobsFormEntityRelationInput"] | undefined,
	textNew?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["SideBySideUniqueWhere"] | undefined,
	create?: GraphQLTypes["SideBySideWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SideBySideItemConnectOrCreateListRelationInput"] | undefined
};
	["SideBySideWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	background?: GraphQLTypes["Background"] | undefined,
	alignment?: GraphQLTypes["ContentAlignment"] | undefined,
	mediumSize?: GraphQLTypes["MediumSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["SideBySideUniqueWhere"],
	create: GraphQLTypes["SideBySideWithoutItemsCreateInput"]
};
	["SideBySideItemUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["SideBySideItemUpdateListEntityRelationInput"] | undefined,
	media?: GraphQLTypes["SideBySideItemUpdateMediaEntityRelationInput"] | undefined,
	formButtonLabel?: string | undefined,
	type?: GraphQLTypes["SideBySideItemType"] | undefined,
	link?: GraphQLTypes["SideBySideItemUpdateLinkEntityRelationInput"] | undefined,
	jobsForm?: GraphQLTypes["SideBySideItemUpdateJobsFormEntityRelationInput"] | undefined,
	textNew?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["SideBySideUniqueWhere"] | undefined,
	create?: GraphQLTypes["SideBySideWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["SideBySideItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["SideBySideWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SideBySideItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SideBySideWithoutItemsUpdateInput"]: {
		background?: GraphQLTypes["Background"] | undefined,
	alignment?: GraphQLTypes["ContentAlignment"] | undefined,
	mediumSize?: GraphQLTypes["MediumSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SideBySideItemUpsertListRelationInput"]: {
		update: GraphQLTypes["SideBySideWithoutItemsUpdateInput"],
	create: GraphQLTypes["SideBySideWithoutItemsCreateInput"]
};
	["HomePageLokalConnection"]: {
	__typename: "HomePageLokalConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageLokalEdge"]>
};
	["HomePageLokalEdge"]: {
	__typename: "HomePageLokalEdge",
	node: GraphQLTypes["HomePageLokal"]
};
	["HomePageLokalCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["HomePageLokalCreateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["HomePageLokalCreateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["HomePageLokalLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["HomePageLokalConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["HomePageLokalLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: GraphQLTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["HomePageLokalLocaleUniqueWhere"],
	create: GraphQLTypes["HomePageLokalLocaleWithoutRootCreateInput"]
};
	["HomePageLokalUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["HomePageLokalUpdateLocalesEntityRelationInput"]> | undefined,
	theme?: GraphQLTypes["HomePageLokalUpdateThemeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageLokalLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["HomePageLokalUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["HomePageLokalUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["HomePageLokalLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["HomePageLokalUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["HomePageLokalLocaleUniqueWhere"],
	data: GraphQLTypes["HomePageLokalLocaleWithoutRootUpdateInput"]
};
	["HomePageLokalLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	locale?: GraphQLTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["HomePageLokalLocaleUniqueWhere"],
	update: GraphQLTypes["HomePageLokalLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["HomePageLokalLocaleWithoutRootCreateInput"]
};
	["HomePageLokalLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["HomePageLokalLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLokalLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HomePageLokalLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"] | undefined,
	button?: GraphQLTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"] | undefined,
	content?: GraphQLTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"] | undefined,
	link?: GraphQLTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"] | undefined,
	siteSwitcher?: GraphQLTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"] | undefined,
	stickyBar?: GraphQLTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"] | undefined,
	text?: string | undefined,
	ilustration?: GraphQLTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SiteSwitcherConnection"]: {
	__typename: "SiteSwitcherConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SiteSwitcherEdge"]>
};
	["SiteSwitcherEdge"]: {
	__typename: "SiteSwitcherEdge",
	node: GraphQLTypes["SiteSwitcher"]
};
	["GalleryItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["GalleryItemCreateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GalleryItemConnectOrCreateListRelationInput"] | undefined
};
	["GalleryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["GalleryUniqueWhere"],
	create: GraphQLTypes["GalleryWithoutItemsCreateInput"]
};
	["GalleryItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["GalleryItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GalleryItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GalleryWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["GalleryItemUpsertListRelationInput"]: {
		update: GraphQLTypes["GalleryWithoutItemsUpdateInput"],
	create: GraphQLTypes["GalleryWithoutItemsCreateInput"]
};
	["JobsFormConnection"]: {
	__typename: "JobsFormConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobsFormEdge"]>
};
	["JobsFormEdge"]: {
	__typename: "JobsFormEdge",
	node: GraphQLTypes["JobsForm"]
};
	["JobsFormCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["JobsFormCreateLocalesEntityRelationInput"]> | undefined,
	fileIlustration?: GraphQLTypes["JobsFormCreateFileIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFormLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFormConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobsFormLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	locale?: GraphQLTypes["JobsFormLocaleCreateLocaleEntityRelationInput"] | undefined,
	imageTextList?: GraphQLTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: GraphQLTypes["JobsFormLocaleCreateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: GraphQLTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	create: GraphQLTypes["JobsFormLocaleWithoutRootCreateInput"]
};
	["JobsFormUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["JobsFormUpdateLocalesEntityRelationInput"]> | undefined,
	fileIlustration?: GraphQLTypes["JobsFormUpdateFileIlustrationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["JobsFormLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["JobsFormUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["JobsFormUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobsFormLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobsFormUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	data: GraphQLTypes["JobsFormLocaleWithoutRootUpdateInput"]
};
	["JobsFormLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	jobText?: string | undefined,
	genericText?: string | undefined,
	nameLabel?: string | undefined,
	emailLabel?: string | undefined,
	telefonLabel?: string | undefined,
	fileTitleLabel?: string | undefined,
	fileFormatLabel?: string | undefined,
	formTextLabel?: string | undefined,
	submitLabel?: string | undefined,
	locale?: GraphQLTypes["JobsFormLocaleUpdateLocaleEntityRelationInput"] | undefined,
	imageTextList?: GraphQLTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"] | undefined,
	minimalize?: string | undefined,
	logo?: GraphQLTypes["JobsFormLocaleUpdateLogoEntityRelationInput"] | undefined,
	successTitle?: string | undefined,
	successText?: string | undefined,
	successBtnLabel?: string | undefined,
	successImage?: GraphQLTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"] | undefined,
	successOtherJobsTitle?: string | undefined,
	successOtherJobsCategoryTitle?: string | undefined,
	successOtherJobsButtonTitle?: string | undefined,
	successOtherJobsSelectionTitle?: string | undefined,
	successOtherJobsSelectionYesButton?: string | undefined,
	successOtherJobsSelectionNoButton?: string | undefined,
	fileRemoveBtnLabel?: string | undefined,
	gdprLabel?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFormUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["JobsFormLocaleUniqueWhere"],
	update: GraphQLTypes["JobsFormLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["JobsFormLocaleWithoutRootCreateInput"]
};
	["ImageTextItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	list?: GraphQLTypes["ImageTextItemCreateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ImageTextItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageTextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageTextListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageTextItemConnectOrCreateListRelationInput"] | undefined
};
	["ImageTextListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["ImageTextListUniqueWhere"],
	create: GraphQLTypes["ImageTextListWithoutItemsCreateInput"]
};
	["ImageTextItemUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	list?: GraphQLTypes["ImageTextItemUpdateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ImageTextItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageTextItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageTextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageTextListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageTextItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["ImageTextListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ImageTextItemUpsertListRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageTextListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["ImageTextItemUpsertListRelationInput"]: {
		update: GraphQLTypes["ImageTextListWithoutItemsUpdateInput"],
	create: GraphQLTypes["ImageTextListWithoutItemsCreateInput"]
};
	["ImageTextListConnection"]: {
	__typename: "ImageTextListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageTextListEdge"]>
};
	["ImageTextListEdge"]: {
	__typename: "ImageTextListEdge",
	node: GraphQLTypes["ImageTextList"]
};
	["JobsFilterConnection"]: {
	__typename: "JobsFilterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobsFilterEdge"]>
};
	["JobsFilterEdge"]: {
	__typename: "JobsFilterEdge",
	node: GraphQLTypes["JobsFilter"]
};
	["JobsFilterCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["JobsFilterCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobsFilterLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["JobsFilterLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	locale?: GraphQLTypes["JobsFilterLocaleCreateLocaleEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: GraphQLTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: GraphQLTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: GraphQLTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutJobsFiltersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutJobsFiltersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleCreateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutJobsFiltersCreateInput"]
};
	["JobsFilterConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["JobsFilterLocaleUniqueWhere"],
	create: GraphQLTypes["JobsFilterLocaleWithoutRootCreateInput"]
};
	["JobsFilterUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["JobsFilterUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["JobsFilterLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["JobsFilterUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["JobsFilterUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["JobsFilterLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["JobsFilterUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["JobsFilterLocaleUniqueWhere"],
	data: GraphQLTypes["JobsFilterLocaleWithoutRootUpdateInput"]
};
	["JobsFilterLocaleWithoutRootUpdateInput"]: {
		jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	locale?: GraphQLTypes["JobsFilterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: GraphQLTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: GraphQLTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: GraphQLTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutJobsFiltersCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobsFilterLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutJobsFiltersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobsFilterLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutJobsFiltersUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	translations?: Array<GraphQLTypes["LocaleUpdateTranslationsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutJobsFiltersUpdateInput"],
	create: GraphQLTypes["LocaleWithoutJobsFiltersCreateInput"]
};
	["JobsFilterUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["JobsFilterLocaleUniqueWhere"],
	update: GraphQLTypes["JobsFilterLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["JobsFilterLocaleWithoutRootCreateInput"]
};
	["JobsFilterLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	root?: GraphQLTypes["JobsFilterLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobsFilterLocaleCreateLocaleEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: GraphQLTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: GraphQLTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: GraphQLTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobsFilterLocaleUpdateInput"]: {
		jobPositionLabel?: string | undefined,
	jobContractLabel?: string | undefined,
	jobCityLabel?: string | undefined,
	root?: GraphQLTypes["JobsFilterLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["JobsFilterLocaleUpdateLocaleEntityRelationInput"] | undefined,
	bannerTitle?: string | undefined,
	bannerFormLabel?: string | undefined,
	bannerJobsForm?: GraphQLTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"] | undefined,
	bannerImage?: GraphQLTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"] | undefined,
	noJobTitle?: string | undefined,
	noJobBtnLabel?: string | undefined,
	noJobImage?: GraphQLTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"] | undefined,
	noJobTitleForSpecificBusiness?: string | undefined,
	deactivatedJob?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["File"]: {
	__typename: "File",
	_meta?: GraphQLTypes["FileMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	size?: number | undefined,
	type?: string | undefined
};
	["FileMeta"]: {
	__typename: "FileMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined
};
	["FileUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["FileWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	size?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["FileWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FileWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FileWhere"] | undefined
};
	["FileOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined
};
	["FileConnection"]: {
	__typename: "FileConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FileEdge"]>
};
	["FileEdge"]: {
	__typename: "FileEdge",
	node: GraphQLTypes["File"]
};
	["FileCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	size?: number | undefined,
	type?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FileUpdateInput"]: {
		url?: string | undefined,
	size?: number | undefined,
	type?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobFormSubscription"]: {
	__typename: "JobFormSubscription",
	_meta?: GraphQLTypes["JobFormSubscriptionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	name?: string | undefined,
	phone?: string | undefined,
	email?: string | undefined,
	message?: string | undefined,
	file?: GraphQLTypes["File"] | undefined,
	job?: GraphQLTypes["JobPageLocale"] | undefined,
	status?: GraphQLTypes["JobFormSubscriptionStatus"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	isGdprSyncedToTabidoo?: boolean | undefined,
	recruitisAnswerId?: string | undefined
};
	["JobFormSubscriptionMeta"]: {
	__typename: "JobFormSubscriptionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	phone?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	message?: GraphQLTypes["FieldMeta"] | undefined,
	file?: GraphQLTypes["FieldMeta"] | undefined,
	job?: GraphQLTypes["FieldMeta"] | undefined,
	status?: GraphQLTypes["FieldMeta"] | undefined,
	isSyncedToTabidoo?: GraphQLTypes["FieldMeta"] | undefined,
	tabidooId?: GraphQLTypes["FieldMeta"] | undefined,
	isGdprSyncedToTabidoo?: GraphQLTypes["FieldMeta"] | undefined,
	recruitisAnswerId?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobFormSubscriptionStatus"]: {
	__typename: "JobFormSubscriptionStatus",
	_meta?: GraphQLTypes["JobFormSubscriptionStatusMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	statusTitle?: string | undefined,
	statusColor?: string | undefined
};
	["JobFormSubscriptionStatusMeta"]: {
	__typename: "JobFormSubscriptionStatusMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	statusTitle?: GraphQLTypes["FieldMeta"] | undefined,
	statusColor?: GraphQLTypes["FieldMeta"] | undefined
};
	["JobFormSubscriptionStatusWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	statusTitle?: GraphQLTypes["StringCondition"] | undefined,
	statusColor?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["JobFormSubscriptionStatusWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobFormSubscriptionStatusWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobFormSubscriptionStatusWhere"] | undefined
};
	["JobFormSubscriptionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	file?: GraphQLTypes["FileUniqueWhere"] | undefined
};
	["JobFormSubscriptionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	phone?: GraphQLTypes["StringCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	message?: GraphQLTypes["StringCondition"] | undefined,
	file?: GraphQLTypes["FileWhere"] | undefined,
	job?: GraphQLTypes["JobPageLocaleWhere"] | undefined,
	status?: GraphQLTypes["JobFormSubscriptionStatusWhere"] | undefined,
	isSyncedToTabidoo?: GraphQLTypes["BooleanCondition"] | undefined,
	tabidooId?: GraphQLTypes["StringCondition"] | undefined,
	isGdprSyncedToTabidoo?: GraphQLTypes["BooleanCondition"] | undefined,
	recruitisAnswerId?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["JobFormSubscriptionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["JobFormSubscriptionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["JobFormSubscriptionWhere"] | undefined
};
	["JobFormSubscriptionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	phone?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	message?: GraphQLTypes["OrderDirection"] | undefined,
	file?: GraphQLTypes["FileOrderBy"] | undefined,
	job?: GraphQLTypes["JobPageLocaleOrderBy"] | undefined,
	status?: GraphQLTypes["JobFormSubscriptionStatusOrderBy"] | undefined,
	isSyncedToTabidoo?: GraphQLTypes["OrderDirection"] | undefined,
	tabidooId?: GraphQLTypes["OrderDirection"] | undefined,
	isGdprSyncedToTabidoo?: GraphQLTypes["OrderDirection"] | undefined,
	recruitisAnswerId?: GraphQLTypes["OrderDirection"] | undefined
};
	["JobFormSubscriptionStatusOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	statusTitle?: GraphQLTypes["OrderDirection"] | undefined,
	statusColor?: GraphQLTypes["OrderDirection"] | undefined
};
	["JobFormSubscriptionConnection"]: {
	__typename: "JobFormSubscriptionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobFormSubscriptionEdge"]>
};
	["JobFormSubscriptionEdge"]: {
	__typename: "JobFormSubscriptionEdge",
	node: GraphQLTypes["JobFormSubscription"]
};
	["JobFormSubscriptionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	name?: string | undefined,
	phone?: string | undefined,
	email?: string | undefined,
	message?: string | undefined,
	file?: GraphQLTypes["JobFormSubscriptionCreateFileEntityRelationInput"] | undefined,
	job?: GraphQLTypes["JobFormSubscriptionCreateJobEntityRelationInput"] | undefined,
	status?: GraphQLTypes["JobFormSubscriptionCreateStatusEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	isGdprSyncedToTabidoo?: boolean | undefined,
	recruitisAnswerId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobFormSubscriptionCreateFileEntityRelationInput"]: {
		connect?: GraphQLTypes["FileUniqueWhere"] | undefined,
	create?: GraphQLTypes["FileCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobFormSubscriptionConnectOrCreateFileRelationInput"] | undefined
};
	["JobFormSubscriptionConnectOrCreateFileRelationInput"]: {
		connect: GraphQLTypes["FileUniqueWhere"],
	create: GraphQLTypes["FileCreateInput"]
};
	["JobFormSubscriptionCreateJobEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPageLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobFormSubscriptionConnectOrCreateJobRelationInput"] | undefined
};
	["JobFormSubscriptionConnectOrCreateJobRelationInput"]: {
		connect: GraphQLTypes["JobPageLocaleUniqueWhere"],
	create: GraphQLTypes["JobPageLocaleCreateInput"]
};
	["JobFormSubscriptionCreateStatusEntityRelationInput"]: {
		connect?: GraphQLTypes["JobFormSubscriptionStatusUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobFormSubscriptionStatusCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobFormSubscriptionConnectOrCreateStatusRelationInput"] | undefined
};
	["JobFormSubscriptionStatusUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["JobFormSubscriptionStatusCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	statusTitle?: string | undefined,
	statusColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobFormSubscriptionConnectOrCreateStatusRelationInput"]: {
		connect: GraphQLTypes["JobFormSubscriptionStatusUniqueWhere"],
	create: GraphQLTypes["JobFormSubscriptionStatusCreateInput"]
};
	["JobFormSubscriptionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	name?: string | undefined,
	phone?: string | undefined,
	email?: string | undefined,
	message?: string | undefined,
	file?: GraphQLTypes["JobFormSubscriptionUpdateFileEntityRelationInput"] | undefined,
	job?: GraphQLTypes["JobFormSubscriptionUpdateJobEntityRelationInput"] | undefined,
	status?: GraphQLTypes["JobFormSubscriptionUpdateStatusEntityRelationInput"] | undefined,
	isSyncedToTabidoo?: boolean | undefined,
	tabidooId?: string | undefined,
	isGdprSyncedToTabidoo?: boolean | undefined,
	recruitisAnswerId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobFormSubscriptionUpdateFileEntityRelationInput"]: {
		connect?: GraphQLTypes["FileUniqueWhere"] | undefined,
	create?: GraphQLTypes["FileCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobFormSubscriptionConnectOrCreateFileRelationInput"] | undefined,
	update?: GraphQLTypes["FileUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobFormSubscriptionUpsertFileRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobFormSubscriptionUpsertFileRelationInput"]: {
		update: GraphQLTypes["FileUpdateInput"],
	create: GraphQLTypes["FileCreateInput"]
};
	["JobFormSubscriptionUpdateJobEntityRelationInput"]: {
		connect?: GraphQLTypes["JobPageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobPageLocaleCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobFormSubscriptionConnectOrCreateJobRelationInput"] | undefined,
	update?: GraphQLTypes["JobPageLocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobFormSubscriptionUpsertJobRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobFormSubscriptionUpsertJobRelationInput"]: {
		update: GraphQLTypes["JobPageLocaleUpdateInput"],
	create: GraphQLTypes["JobPageLocaleCreateInput"]
};
	["JobFormSubscriptionUpdateStatusEntityRelationInput"]: {
		connect?: GraphQLTypes["JobFormSubscriptionStatusUniqueWhere"] | undefined,
	create?: GraphQLTypes["JobFormSubscriptionStatusCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["JobFormSubscriptionConnectOrCreateStatusRelationInput"] | undefined,
	update?: GraphQLTypes["JobFormSubscriptionStatusUpdateInput"] | undefined,
	upsert?: GraphQLTypes["JobFormSubscriptionUpsertStatusRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["JobFormSubscriptionStatusUpdateInput"]: {
		statusTitle?: string | undefined,
	statusColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["JobFormSubscriptionUpsertStatusRelationInput"]: {
		update: GraphQLTypes["JobFormSubscriptionStatusUpdateInput"],
	create: GraphQLTypes["JobFormSubscriptionStatusCreateInput"]
};
	["ImageList"]: {
	__typename: "ImageList",
	_meta?: GraphQLTypes["ImageListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ImageListItem"]>,
	itemsByImage?: GraphQLTypes["ImageListItem"] | undefined,
	paginateItems: GraphQLTypes["ImageListItemConnection"]
};
	["ImageListMeta"]: {
	__typename: "ImageListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageListItem"]: {
	__typename: "ImageListItem",
	_meta?: GraphQLTypes["ImageListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ImageList"] | undefined,
	image?: GraphQLTypes["Image"] | undefined
};
	["ImageListItemMeta"]: {
	__typename: "ImageListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["ImageListItemWhere"] | undefined,
	and?: Array<GraphQLTypes["ImageListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageListWhere"] | undefined
};
	["ImageListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["ImageListWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["ImageListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageListItemWhere"] | undefined
};
	["ImageListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["ImageListOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["ImageListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["ImageListItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["ImageListItemConnection"]: {
	__typename: "ImageListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListItemEdge"]>
};
	["ImageListItemEdge"]: {
	__typename: "ImageListItemEdge",
	node: GraphQLTypes["ImageListItem"]
};
	["ImageListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined
};
	["ImageListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["ImageListConnection"]: {
	__typename: "ImageListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListEdge"]>
};
	["ImageListEdge"]: {
	__typename: "ImageListEdge",
	node: GraphQLTypes["ImageList"]
};
	["ImageListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ImageListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageListItemWithoutListCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageListConnectOrCreateItemsRelationInput"] | undefined,
	alias?: string | undefined
};
	["ImageListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	image?: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageListItemConnectOrCreateImageRelationInput"] | undefined
};
	["ImageListItemConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ImageListConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ImageListItemUniqueWhere"],
	create: GraphQLTypes["ImageListItemWithoutListCreateInput"]
};
	["ImageListUpdateInput"]: {
		items?: Array<GraphQLTypes["ImageListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ImageListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["ImageListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ImageListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ImageListUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ImageListItemUniqueWhere"],
	data: GraphQLTypes["ImageListItemWithoutListUpdateInput"]
};
	["ImageListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	image?: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageListItemConnectOrCreateImageRelationInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ImageListItemUpsertImageRelationInput"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageListItemUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ImageListUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ImageListItemUniqueWhere"],
	update: GraphQLTypes["ImageListItemWithoutListUpdateInput"],
	create: GraphQLTypes["ImageListItemWithoutListCreateInput"]
};
	["ImageListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["ImageListItemCreateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageListItemConnectOrCreateListRelationInput"] | undefined
};
	["ImageListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["ImageListUniqueWhere"],
	create: GraphQLTypes["ImageListWithoutItemsCreateInput"]
};
	["ImageListItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["ImageListItemUpdateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageListWithoutItemsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["ImageListItemConnectOrCreateListRelationInput"] | undefined,
	update?: GraphQLTypes["ImageListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ImageListItemUpsertListRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["ImageListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["ImageListItemUpsertListRelationInput"]: {
		update: GraphQLTypes["ImageListWithoutItemsUpdateInput"],
	create: GraphQLTypes["ImageListWithoutItemsCreateInput"]
};
	["JobFormSubscriptionStatusConnection"]: {
	__typename: "JobFormSubscriptionStatusConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["JobFormSubscriptionStatusEdge"]>
};
	["JobFormSubscriptionStatusEdge"]: {
	__typename: "JobFormSubscriptionStatusEdge",
	node: GraphQLTypes["JobFormSubscriptionStatus"]
};
	["GeneralLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["GeneralLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GeneralLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleCreateSeoEntityRelationInput"] | undefined,
	cornerBanner?: GraphQLTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GeneralLocaleUpdateInput"]: {
		root?: GraphQLTypes["GeneralLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["GeneralLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["GeneralLocaleUpdateSeoEntityRelationInput"] | undefined,
	cornerBanner?: GraphQLTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StickyBarConnection"]: {
	__typename: "StickyBarConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StickyBarEdge"]>
};
	["StickyBarEdge"]: {
	__typename: "StickyBarEdge",
	node: GraphQLTypes["StickyBar"]
};
	["RecommendationFormConnection"]: {
	__typename: "RecommendationFormConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RecommendationFormEdge"]>
};
	["RecommendationFormEdge"]: {
	__typename: "RecommendationFormEdge",
	node: GraphQLTypes["RecommendationForm"]
};
	["RecommendationFormCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["RecommendationFormCreateLocalesEntityRelationInput"]> | undefined,
	successImage?: GraphQLTypes["RecommendationFormCreateSuccessImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["RecommendationFormLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["RecommendationFormConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["RecommendationFormLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	locale?: GraphQLTypes["RecommendationFormLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["RecommendationFormLocaleUniqueWhere"],
	create: GraphQLTypes["RecommendationFormLocaleWithoutRootCreateInput"]
};
	["RecommendationFormUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["RecommendationFormUpdateLocalesEntityRelationInput"]> | undefined,
	successImage?: GraphQLTypes["RecommendationFormUpdateSuccessImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["RecommendationFormLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["RecommendationFormUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["RecommendationFormUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["RecommendationFormLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RecommendationFormUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["RecommendationFormLocaleUniqueWhere"],
	data: GraphQLTypes["RecommendationFormLocaleWithoutRootUpdateInput"]
};
	["RecommendationFormLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	subtitle?: string | undefined,
	yourEmailLabel?: string | undefined,
	theirEmailLabel?: string | undefined,
	yourName?: string | undefined,
	sendBtnLabel?: string | undefined,
	successTitle?: string | undefined,
	successSubtitle?: string | undefined,
	successButtonClose?: string | undefined,
	locale?: GraphQLTypes["RecommendationFormLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["RecommendationFormLocaleUniqueWhere"],
	update: GraphQLTypes["RecommendationFormLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["RecommendationFormLocaleWithoutRootCreateInput"]
};
	["RecommendationFormSubscription"]: {
	__typename: "RecommendationFormSubscription",
	_meta?: GraphQLTypes["RecommendationFormSubscriptionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	yourEmail?: string | undefined,
	theirEmail?: string | undefined,
	yourName?: string | undefined
};
	["RecommendationFormSubscriptionMeta"]: {
	__typename: "RecommendationFormSubscriptionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	yourEmail?: GraphQLTypes["FieldMeta"] | undefined,
	theirEmail?: GraphQLTypes["FieldMeta"] | undefined,
	yourName?: GraphQLTypes["FieldMeta"] | undefined
};
	["RecommendationFormSubscriptionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["RecommendationFormSubscriptionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	yourEmail?: GraphQLTypes["StringCondition"] | undefined,
	theirEmail?: GraphQLTypes["StringCondition"] | undefined,
	yourName?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["RecommendationFormSubscriptionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RecommendationFormSubscriptionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RecommendationFormSubscriptionWhere"] | undefined
};
	["RecommendationFormSubscriptionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	yourEmail?: GraphQLTypes["OrderDirection"] | undefined,
	theirEmail?: GraphQLTypes["OrderDirection"] | undefined,
	yourName?: GraphQLTypes["OrderDirection"] | undefined
};
	["RecommendationFormSubscriptionConnection"]: {
	__typename: "RecommendationFormSubscriptionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RecommendationFormSubscriptionEdge"]>
};
	["RecommendationFormSubscriptionEdge"]: {
	__typename: "RecommendationFormSubscriptionEdge",
	node: GraphQLTypes["RecommendationFormSubscription"]
};
	["RecommendationFormSubscriptionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	yourEmail?: string | undefined,
	theirEmail?: string | undefined,
	yourName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RecommendationFormSubscriptionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	yourEmail?: string | undefined,
	theirEmail?: string | undefined,
	yourName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxConnection"]: {
	__typename: "InfoBoxConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InfoBoxEdge"]>
};
	["InfoBoxEdge"]: {
	__typename: "InfoBoxEdge",
	node: GraphQLTypes["InfoBox"]
};
	["InfoBoxLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	root?: GraphQLTypes["InfoBoxLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["InfoBoxLocaleCreateLocaleEntityRelationInput"] | undefined,
	openingHours?: GraphQLTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InfoBoxLocaleUpdateInput"]: {
		address?: string | undefined,
	web?: string | undefined,
	instagram?: string | undefined,
	facebook?: string | undefined,
	root?: GraphQLTypes["InfoBoxLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["InfoBoxLocaleUpdateLocaleEntityRelationInput"] | undefined,
	openingHours?: GraphQLTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"] | undefined,
	addressLink?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationConnection"]: {
	__typename: "TranslationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationEdge"]>
};
	["TranslationEdge"]: {
	__typename: "TranslationEdge",
	node: GraphQLTypes["Translation"]
};
	["TranslationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	key?: string | undefined,
	locales?: Array<GraphQLTypes["TranslationCreateLocalesEntityRelationInput"]> | undefined,
	isTextarea?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationLocaleWithoutRootCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationConnectOrCreateLocalesRelationInput"] | undefined,
	alias?: string | undefined
};
	["TranslationLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	value?: string | undefined,
	locale?: GraphQLTypes["TranslationLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutTranslationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationLocaleConnectOrCreateLocaleRelationInput"] | undefined
};
	["LocaleWithoutTranslationsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleCreateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleCreateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleCreateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleCreateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleCreateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleCreateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleCreateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleCreateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleCreateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleCreateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleCreateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleCreateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleCreateInfoBoxesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleConnectOrCreateLocaleRelationInput"]: {
		connect: GraphQLTypes["LocaleUniqueWhere"],
	create: GraphQLTypes["LocaleWithoutTranslationsCreateInput"]
};
	["TranslationConnectOrCreateLocalesRelationInput"]: {
		connect: GraphQLTypes["TranslationLocaleUniqueWhere"],
	create: GraphQLTypes["TranslationLocaleWithoutRootCreateInput"]
};
	["TranslationUpdateInput"]: {
		order?: number | undefined,
	key?: string | undefined,
	locales?: Array<GraphQLTypes["TranslationUpdateLocalesEntityRelationInput"]> | undefined,
	isTextarea?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationUpdateLocalesRelationInput"]: {
		by: GraphQLTypes["TranslationLocaleUniqueWhere"],
	data: GraphQLTypes["TranslationLocaleWithoutRootUpdateInput"]
};
	["TranslationLocaleWithoutRootUpdateInput"]: {
		value?: string | undefined,
	locale?: GraphQLTypes["TranslationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleUpdateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutTranslationsCreateInput"] | undefined,
	connectOrCreate?: GraphQLTypes["TranslationLocaleConnectOrCreateLocaleRelationInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutTranslationsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationLocaleUpsertLocaleRelationInput"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutTranslationsUpdateInput"]: {
		code?: string | undefined,
	label?: string | undefined,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]> | undefined,
	genericPages?: Array<GraphQLTypes["LocaleUpdateGenericPagesEntityRelationInput"]> | undefined,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]> | undefined,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]> | undefined,
	businessPages?: Array<GraphQLTypes["LocaleUpdateBusinessPagesEntityRelationInput"]> | undefined,
	jobPages?: Array<GraphQLTypes["LocaleUpdateJobPagesEntityRelationInput"]> | undefined,
	contractTypes?: Array<GraphQLTypes["LocaleUpdateContractTypesEntityRelationInput"]> | undefined,
	jobCities?: Array<GraphQLTypes["LocaleUpdateJobCitiesEntityRelationInput"]> | undefined,
	jobPositions?: Array<GraphQLTypes["LocaleUpdateJobPositionsEntityRelationInput"]> | undefined,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]> | undefined,
	bonusBanners?: Array<GraphQLTypes["LocaleUpdateBonusBannersEntityRelationInput"]> | undefined,
	homePageLokals?: Array<GraphQLTypes["LocaleUpdateHomePageLokalsEntityRelationInput"]> | undefined,
	jobsForms?: Array<GraphQLTypes["LocaleUpdateJobsFormsEntityRelationInput"]> | undefined,
	jobsFilters?: Array<GraphQLTypes["LocaleUpdateJobsFiltersEntityRelationInput"]> | undefined,
	general?: Array<GraphQLTypes["LocaleUpdateGeneralEntityRelationInput"]> | undefined,
	recommendationForms?: Array<GraphQLTypes["LocaleUpdateRecommendationFormsEntityRelationInput"]> | undefined,
	infoBoxes?: Array<GraphQLTypes["LocaleUpdateInfoBoxesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleUpsertLocaleRelationInput"]: {
		update: GraphQLTypes["LocaleWithoutTranslationsUpdateInput"],
	create: GraphQLTypes["LocaleWithoutTranslationsCreateInput"]
};
	["TranslationUpsertLocalesRelationInput"]: {
		by: GraphQLTypes["TranslationLocaleUniqueWhere"],
	update: GraphQLTypes["TranslationLocaleWithoutRootUpdateInput"],
	create: GraphQLTypes["TranslationLocaleWithoutRootCreateInput"]
};
	["TranslationLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	value?: string | undefined,
	root?: GraphQLTypes["TranslationLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["TranslationLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationLocaleUpdateInput"]: {
		value?: string | undefined,
	root?: GraphQLTypes["TranslationLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["TranslationLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CornerBannerConnection"]: {
	__typename: "CornerBannerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CornerBannerEdge"]>
};
	["CornerBannerEdge"]: {
	__typename: "CornerBannerEdge",
	node: GraphQLTypes["CornerBanner"]
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	schema?: GraphQLTypes["_Schema"] | undefined,
	s3DummyQuery?: string | undefined,
	getGeneral?: GraphQLTypes["General"] | undefined,
	listGeneral: Array<GraphQLTypes["General"]>,
	paginateGeneral: GraphQLTypes["GeneralConnection"],
	validateCreateGeneral: GraphQLTypes["_ValidationResult"],
	validateUpdateGeneral: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"] | undefined,
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getGenericPage?: GraphQLTypes["GenericPage"] | undefined,
	listGenericPage: Array<GraphQLTypes["GenericPage"]>,
	paginateGenericPage: GraphQLTypes["GenericPageConnection"],
	validateCreateGenericPage: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPage: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"] | undefined,
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"] | undefined,
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"] | undefined,
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"] | undefined,
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"] | undefined,
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getContentReferenceLinkableItem?: GraphQLTypes["ContentReferenceLinkableItem"] | undefined,
	listContentReferenceLinkableItem: Array<GraphQLTypes["ContentReferenceLinkableItem"]>,
	paginateContentReferenceLinkableItem: GraphQLTypes["ContentReferenceLinkableItemConnection"],
	getRedirect?: GraphQLTypes["Redirect"] | undefined,
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"] | undefined,
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"] | undefined,
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterLink?: GraphQLTypes["FooterLink"] | undefined,
	listFooterLink: Array<GraphQLTypes["FooterLink"]>,
	paginateFooterLink: GraphQLTypes["FooterLinkConnection"],
	validateCreateFooterLink: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLink: GraphQLTypes["_ValidationResult"],
	getFooterLocale?: GraphQLTypes["FooterLocale"] | undefined,
	listFooterLocale: Array<GraphQLTypes["FooterLocale"]>,
	paginateFooterLocale: GraphQLTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLocale: GraphQLTypes["_ValidationResult"],
	getGenericPageLocale?: GraphQLTypes["GenericPageLocale"] | undefined,
	listGenericPageLocale: Array<GraphQLTypes["GenericPageLocale"]>,
	paginateGenericPageLocale: GraphQLTypes["GenericPageLocaleConnection"],
	validateCreateGenericPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPageLocale: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"] | undefined,
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHeaderLocale?: GraphQLTypes["HeaderLocale"] | undefined,
	listHeaderLocale: Array<GraphQLTypes["HeaderLocale"]>,
	paginateHeaderLocale: GraphQLTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLocale: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"] | undefined,
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getSeoDefault?: GraphQLTypes["SeoDefault"] | undefined,
	listSeoDefault: Array<GraphQLTypes["SeoDefault"]>,
	paginateSeoDefault: GraphQLTypes["SeoDefaultConnection"],
	validateCreateSeoDefault: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoDefault: GraphQLTypes["_ValidationResult"],
	getSeoDefaultLocale?: GraphQLTypes["SeoDefaultLocale"] | undefined,
	listSeoDefaultLocale: Array<GraphQLTypes["SeoDefaultLocale"]>,
	paginateSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleConnection"],
	validateCreateSeoDefaultLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoDefaultLocale: GraphQLTypes["_ValidationResult"],
	getBusiness?: GraphQLTypes["Business"] | undefined,
	listBusiness: Array<GraphQLTypes["Business"]>,
	paginateBusiness: GraphQLTypes["BusinessConnection"],
	validateCreateBusiness: GraphQLTypes["_ValidationResult"],
	validateUpdateBusiness: GraphQLTypes["_ValidationResult"],
	getBusinessPage?: GraphQLTypes["BusinessPage"] | undefined,
	listBusinessPage: Array<GraphQLTypes["BusinessPage"]>,
	paginateBusinessPage: GraphQLTypes["BusinessPageConnection"],
	validateCreateBusinessPage: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessPage: GraphQLTypes["_ValidationResult"],
	getBusinessPageLocale?: GraphQLTypes["BusinessPageLocale"] | undefined,
	listBusinessPageLocale: Array<GraphQLTypes["BusinessPageLocale"]>,
	paginateBusinessPageLocale: GraphQLTypes["BusinessPageLocaleConnection"],
	validateCreateBusinessPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessPageLocale: GraphQLTypes["_ValidationResult"],
	getIcon?: GraphQLTypes["Icon"] | undefined,
	listIcon: Array<GraphQLTypes["Icon"]>,
	paginateIcon: GraphQLTypes["IconConnection"],
	validateCreateIcon: GraphQLTypes["_ValidationResult"],
	validateUpdateIcon: GraphQLTypes["_ValidationResult"],
	getJobPage?: GraphQLTypes["JobPage"] | undefined,
	listJobPage: Array<GraphQLTypes["JobPage"]>,
	paginateJobPage: GraphQLTypes["JobPageConnection"],
	validateCreateJobPage: GraphQLTypes["_ValidationResult"],
	validateUpdateJobPage: GraphQLTypes["_ValidationResult"],
	getJobPageLocale?: GraphQLTypes["JobPageLocale"] | undefined,
	listJobPageLocale: Array<GraphQLTypes["JobPageLocale"]>,
	paginateJobPageLocale: GraphQLTypes["JobPageLocaleConnection"],
	validateCreateJobPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateJobPageLocale: GraphQLTypes["_ValidationResult"],
	getKeyInfoItem?: GraphQLTypes["KeyInfoItem"] | undefined,
	listKeyInfoItem: Array<GraphQLTypes["KeyInfoItem"]>,
	paginateKeyInfoItem: GraphQLTypes["KeyInfoItemConnection"],
	validateCreateKeyInfoItem: GraphQLTypes["_ValidationResult"],
	validateUpdateKeyInfoItem: GraphQLTypes["_ValidationResult"],
	getKeyInfoList?: GraphQLTypes["KeyInfoList"] | undefined,
	listKeyInfoList: Array<GraphQLTypes["KeyInfoList"]>,
	paginateKeyInfoList: GraphQLTypes["KeyInfoListConnection"],
	validateCreateKeyInfoList: GraphQLTypes["_ValidationResult"],
	validateUpdateKeyInfoList: GraphQLTypes["_ValidationResult"],
	getContractType?: GraphQLTypes["ContractType"] | undefined,
	listContractType: Array<GraphQLTypes["ContractType"]>,
	paginateContractType: GraphQLTypes["ContractTypeConnection"],
	validateCreateContractType: GraphQLTypes["_ValidationResult"],
	validateUpdateContractType: GraphQLTypes["_ValidationResult"],
	getContractTypeLocale?: GraphQLTypes["ContractTypeLocale"] | undefined,
	listContractTypeLocale: Array<GraphQLTypes["ContractTypeLocale"]>,
	paginateContractTypeLocale: GraphQLTypes["ContractTypeLocaleConnection"],
	validateCreateContractTypeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateContractTypeLocale: GraphQLTypes["_ValidationResult"],
	getJobCity?: GraphQLTypes["JobCity"] | undefined,
	listJobCity: Array<GraphQLTypes["JobCity"]>,
	paginateJobCity: GraphQLTypes["JobCityConnection"],
	validateCreateJobCity: GraphQLTypes["_ValidationResult"],
	validateUpdateJobCity: GraphQLTypes["_ValidationResult"],
	getJobCityLocale?: GraphQLTypes["JobCityLocale"] | undefined,
	listJobCityLocale: Array<GraphQLTypes["JobCityLocale"]>,
	paginateJobCityLocale: GraphQLTypes["JobCityLocaleConnection"],
	validateCreateJobCityLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateJobCityLocale: GraphQLTypes["_ValidationResult"],
	getJobPosition?: GraphQLTypes["JobPosition"] | undefined,
	listJobPosition: Array<GraphQLTypes["JobPosition"]>,
	paginateJobPosition: GraphQLTypes["JobPositionConnection"],
	validateCreateJobPosition: GraphQLTypes["_ValidationResult"],
	validateUpdateJobPosition: GraphQLTypes["_ValidationResult"],
	getJobPositionLocale?: GraphQLTypes["JobPositionLocale"] | undefined,
	listJobPositionLocale: Array<GraphQLTypes["JobPositionLocale"]>,
	paginateJobPositionLocale: GraphQLTypes["JobPositionLocaleConnection"],
	validateCreateJobPositionLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateJobPositionLocale: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"] | undefined,
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"] | undefined,
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getHomePageLocale?: GraphQLTypes["HomePageLocale"] | undefined,
	listHomePageLocale: Array<GraphQLTypes["HomePageLocale"]>,
	paginateHomePageLocale: GraphQLTypes["HomePageLocaleConnection"],
	validateCreateHomePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePageLocale: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"] | undefined,
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getMediumItem?: GraphQLTypes["MediumItem"] | undefined,
	listMediumItem: Array<GraphQLTypes["MediumItem"]>,
	paginateMediumItem: GraphQLTypes["MediumItemConnection"],
	validateCreateMediumItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumItem: GraphQLTypes["_ValidationResult"],
	getMediumList?: GraphQLTypes["MediumList"] | undefined,
	listMediumList: Array<GraphQLTypes["MediumList"]>,
	paginateMediumList: GraphQLTypes["MediumListConnection"],
	validateCreateMediumList: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumList: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"] | undefined,
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getTextItem?: GraphQLTypes["TextItem"] | undefined,
	listTextItem: Array<GraphQLTypes["TextItem"]>,
	paginateTextItem: GraphQLTypes["TextItemConnection"],
	validateCreateTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTextItem: GraphQLTypes["_ValidationResult"],
	getTextList?: GraphQLTypes["TextList"] | undefined,
	listTextList: Array<GraphQLTypes["TextList"]>,
	paginateTextList: GraphQLTypes["TextListConnection"],
	validateCreateTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateTextList: GraphQLTypes["_ValidationResult"],
	getCarousel?: GraphQLTypes["Carousel"] | undefined,
	listCarousel: Array<GraphQLTypes["Carousel"]>,
	paginateCarousel: GraphQLTypes["CarouselConnection"],
	validateCreateCarousel: GraphQLTypes["_ValidationResult"],
	validateUpdateCarousel: GraphQLTypes["_ValidationResult"],
	getCarouselItem?: GraphQLTypes["CarouselItem"] | undefined,
	listCarouselItem: Array<GraphQLTypes["CarouselItem"]>,
	paginateCarouselItem: GraphQLTypes["CarouselItemConnection"],
	validateCreateCarouselItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCarouselItem: GraphQLTypes["_ValidationResult"],
	getTheme?: GraphQLTypes["Theme"] | undefined,
	listTheme: Array<GraphQLTypes["Theme"]>,
	paginateTheme: GraphQLTypes["ThemeConnection"],
	validateCreateTheme: GraphQLTypes["_ValidationResult"],
	validateUpdateTheme: GraphQLTypes["_ValidationResult"],
	getBonusBanner?: GraphQLTypes["BonusBanner"] | undefined,
	listBonusBanner: Array<GraphQLTypes["BonusBanner"]>,
	paginateBonusBanner: GraphQLTypes["BonusBannerConnection"],
	validateCreateBonusBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateBonusBanner: GraphQLTypes["_ValidationResult"],
	getBonusBannerLocale?: GraphQLTypes["BonusBannerLocale"] | undefined,
	listBonusBannerLocale: Array<GraphQLTypes["BonusBannerLocale"]>,
	paginateBonusBannerLocale: GraphQLTypes["BonusBannerLocaleConnection"],
	validateCreateBonusBannerLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBonusBannerLocale: GraphQLTypes["_ValidationResult"],
	getTile?: GraphQLTypes["Tile"] | undefined,
	listTile: Array<GraphQLTypes["Tile"]>,
	paginateTile: GraphQLTypes["TileConnection"],
	validateCreateTile: GraphQLTypes["_ValidationResult"],
	validateUpdateTile: GraphQLTypes["_ValidationResult"],
	getSideBySide?: GraphQLTypes["SideBySide"] | undefined,
	listSideBySide: Array<GraphQLTypes["SideBySide"]>,
	paginateSideBySide: GraphQLTypes["SideBySideConnection"],
	validateCreateSideBySide: GraphQLTypes["_ValidationResult"],
	validateUpdateSideBySide: GraphQLTypes["_ValidationResult"],
	getSideBySideItem?: GraphQLTypes["SideBySideItem"] | undefined,
	listSideBySideItem: Array<GraphQLTypes["SideBySideItem"]>,
	paginateSideBySideItem: GraphQLTypes["SideBySideItemConnection"],
	validateCreateSideBySideItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSideBySideItem: GraphQLTypes["_ValidationResult"],
	getHomePageLokal?: GraphQLTypes["HomePageLokal"] | undefined,
	listHomePageLokal: Array<GraphQLTypes["HomePageLokal"]>,
	paginateHomePageLokal: GraphQLTypes["HomePageLokalConnection"],
	validateCreateHomePageLokal: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePageLokal: GraphQLTypes["_ValidationResult"],
	getHomePageLokalLocale?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	listHomePageLokalLocale: Array<GraphQLTypes["HomePageLokalLocale"]>,
	paginateHomePageLokalLocale: GraphQLTypes["HomePageLokalLocaleConnection"],
	validateCreateHomePageLokalLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePageLokalLocale: GraphQLTypes["_ValidationResult"],
	getSiteSwitcher?: GraphQLTypes["SiteSwitcher"] | undefined,
	listSiteSwitcher: Array<GraphQLTypes["SiteSwitcher"]>,
	paginateSiteSwitcher: GraphQLTypes["SiteSwitcherConnection"],
	validateCreateSiteSwitcher: GraphQLTypes["_ValidationResult"],
	validateUpdateSiteSwitcher: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"] | undefined,
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getJobsForm?: GraphQLTypes["JobsForm"] | undefined,
	listJobsForm: Array<GraphQLTypes["JobsForm"]>,
	paginateJobsForm: GraphQLTypes["JobsFormConnection"],
	validateCreateJobsForm: GraphQLTypes["_ValidationResult"],
	validateUpdateJobsForm: GraphQLTypes["_ValidationResult"],
	getJobsFormLocale?: GraphQLTypes["JobsFormLocale"] | undefined,
	listJobsFormLocale: Array<GraphQLTypes["JobsFormLocale"]>,
	paginateJobsFormLocale: GraphQLTypes["JobsFormLocaleConnection"],
	validateCreateJobsFormLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateJobsFormLocale: GraphQLTypes["_ValidationResult"],
	getImageTextItem?: GraphQLTypes["ImageTextItem"] | undefined,
	listImageTextItem: Array<GraphQLTypes["ImageTextItem"]>,
	paginateImageTextItem: GraphQLTypes["ImageTextItemConnection"],
	validateCreateImageTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageTextItem: GraphQLTypes["_ValidationResult"],
	getImageTextList?: GraphQLTypes["ImageTextList"] | undefined,
	listImageTextList: Array<GraphQLTypes["ImageTextList"]>,
	paginateImageTextList: GraphQLTypes["ImageTextListConnection"],
	validateCreateImageTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageTextList: GraphQLTypes["_ValidationResult"],
	getJobsFilter?: GraphQLTypes["JobsFilter"] | undefined,
	listJobsFilter: Array<GraphQLTypes["JobsFilter"]>,
	paginateJobsFilter: GraphQLTypes["JobsFilterConnection"],
	validateCreateJobsFilter: GraphQLTypes["_ValidationResult"],
	validateUpdateJobsFilter: GraphQLTypes["_ValidationResult"],
	getJobsFilterLocale?: GraphQLTypes["JobsFilterLocale"] | undefined,
	listJobsFilterLocale: Array<GraphQLTypes["JobsFilterLocale"]>,
	paginateJobsFilterLocale: GraphQLTypes["JobsFilterLocaleConnection"],
	validateCreateJobsFilterLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateJobsFilterLocale: GraphQLTypes["_ValidationResult"],
	getFile?: GraphQLTypes["File"] | undefined,
	listFile: Array<GraphQLTypes["File"]>,
	paginateFile: GraphQLTypes["FileConnection"],
	validateCreateFile: GraphQLTypes["_ValidationResult"],
	validateUpdateFile: GraphQLTypes["_ValidationResult"],
	getJobFormSubscription?: GraphQLTypes["JobFormSubscription"] | undefined,
	listJobFormSubscription: Array<GraphQLTypes["JobFormSubscription"]>,
	paginateJobFormSubscription: GraphQLTypes["JobFormSubscriptionConnection"],
	validateCreateJobFormSubscription: GraphQLTypes["_ValidationResult"],
	validateUpdateJobFormSubscription: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"] | undefined,
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageListItem?: GraphQLTypes["ImageListItem"] | undefined,
	listImageListItem: Array<GraphQLTypes["ImageListItem"]>,
	paginateImageListItem: GraphQLTypes["ImageListItemConnection"],
	validateCreateImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageListItem: GraphQLTypes["_ValidationResult"],
	getJobFormSubscriptionStatus?: GraphQLTypes["JobFormSubscriptionStatus"] | undefined,
	listJobFormSubscriptionStatus: Array<GraphQLTypes["JobFormSubscriptionStatus"]>,
	paginateJobFormSubscriptionStatus: GraphQLTypes["JobFormSubscriptionStatusConnection"],
	validateCreateJobFormSubscriptionStatus: GraphQLTypes["_ValidationResult"],
	validateUpdateJobFormSubscriptionStatus: GraphQLTypes["_ValidationResult"],
	getGeneralLocale?: GraphQLTypes["GeneralLocale"] | undefined,
	listGeneralLocale: Array<GraphQLTypes["GeneralLocale"]>,
	paginateGeneralLocale: GraphQLTypes["GeneralLocaleConnection"],
	validateCreateGeneralLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateGeneralLocale: GraphQLTypes["_ValidationResult"],
	getStickyBar?: GraphQLTypes["StickyBar"] | undefined,
	listStickyBar: Array<GraphQLTypes["StickyBar"]>,
	paginateStickyBar: GraphQLTypes["StickyBarConnection"],
	validateCreateStickyBar: GraphQLTypes["_ValidationResult"],
	validateUpdateStickyBar: GraphQLTypes["_ValidationResult"],
	getRecommendationForm?: GraphQLTypes["RecommendationForm"] | undefined,
	listRecommendationForm: Array<GraphQLTypes["RecommendationForm"]>,
	paginateRecommendationForm: GraphQLTypes["RecommendationFormConnection"],
	validateCreateRecommendationForm: GraphQLTypes["_ValidationResult"],
	validateUpdateRecommendationForm: GraphQLTypes["_ValidationResult"],
	getRecommendationFormLocale?: GraphQLTypes["RecommendationFormLocale"] | undefined,
	listRecommendationFormLocale: Array<GraphQLTypes["RecommendationFormLocale"]>,
	paginateRecommendationFormLocale: GraphQLTypes["RecommendationFormLocaleConnection"],
	validateCreateRecommendationFormLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateRecommendationFormLocale: GraphQLTypes["_ValidationResult"],
	getRecommendationFormSubscription?: GraphQLTypes["RecommendationFormSubscription"] | undefined,
	listRecommendationFormSubscription: Array<GraphQLTypes["RecommendationFormSubscription"]>,
	paginateRecommendationFormSubscription: GraphQLTypes["RecommendationFormSubscriptionConnection"],
	validateCreateRecommendationFormSubscription: GraphQLTypes["_ValidationResult"],
	validateUpdateRecommendationFormSubscription: GraphQLTypes["_ValidationResult"],
	getInfoBox?: GraphQLTypes["InfoBox"] | undefined,
	listInfoBox: Array<GraphQLTypes["InfoBox"]>,
	paginateInfoBox: GraphQLTypes["InfoBoxConnection"],
	validateCreateInfoBox: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoBox: GraphQLTypes["_ValidationResult"],
	getInfoBoxLocale?: GraphQLTypes["InfoBoxLocale"] | undefined,
	listInfoBoxLocale: Array<GraphQLTypes["InfoBoxLocale"]>,
	paginateInfoBoxLocale: GraphQLTypes["InfoBoxLocaleConnection"],
	validateCreateInfoBoxLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoBoxLocale: GraphQLTypes["_ValidationResult"],
	getTranslation?: GraphQLTypes["Translation"] | undefined,
	listTranslation: Array<GraphQLTypes["Translation"]>,
	paginateTranslation: GraphQLTypes["TranslationConnection"],
	validateCreateTranslation: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslation: GraphQLTypes["_ValidationResult"],
	getTranslationLocale?: GraphQLTypes["TranslationLocale"] | undefined,
	listTranslationLocale: Array<GraphQLTypes["TranslationLocale"]>,
	paginateTranslationLocale: GraphQLTypes["TranslationLocaleConnection"],
	validateCreateTranslationLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationLocale: GraphQLTypes["_ValidationResult"],
	getCornerBanner?: GraphQLTypes["CornerBanner"] | undefined,
	listCornerBanner: Array<GraphQLTypes["CornerBanner"]>,
	paginateCornerBanner: GraphQLTypes["CornerBannerConnection"],
	validateCreateCornerBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateCornerBanner: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string | undefined
};
	["Mutation"]: {
	__typename: "Mutation",
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"],
	createGeneral: GraphQLTypes["GeneralCreateResult"],
	deleteGeneral: GraphQLTypes["GeneralDeleteResult"],
	updateGeneral: GraphQLTypes["GeneralUpdateResult"],
	upsertGeneral: GraphQLTypes["GeneralUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createGenericPage: GraphQLTypes["GenericPageCreateResult"],
	deleteGenericPage: GraphQLTypes["GenericPageDeleteResult"],
	updateGenericPage: GraphQLTypes["GenericPageUpdateResult"],
	upsertGenericPage: GraphQLTypes["GenericPageUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterLink: GraphQLTypes["FooterLinkCreateResult"],
	deleteFooterLink: GraphQLTypes["FooterLinkDeleteResult"],
	updateFooterLink: GraphQLTypes["FooterLinkUpdateResult"],
	upsertFooterLink: GraphQLTypes["FooterLinkUpsertResult"],
	createFooterLocale: GraphQLTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: GraphQLTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: GraphQLTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: GraphQLTypes["FooterLocaleUpsertResult"],
	createGenericPageLocale: GraphQLTypes["GenericPageLocaleCreateResult"],
	deleteGenericPageLocale: GraphQLTypes["GenericPageLocaleDeleteResult"],
	updateGenericPageLocale: GraphQLTypes["GenericPageLocaleUpdateResult"],
	upsertGenericPageLocale: GraphQLTypes["GenericPageLocaleUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHeaderLocale: GraphQLTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: GraphQLTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: GraphQLTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: GraphQLTypes["HeaderLocaleUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createSeoDefault: GraphQLTypes["SeoDefaultCreateResult"],
	deleteSeoDefault: GraphQLTypes["SeoDefaultDeleteResult"],
	updateSeoDefault: GraphQLTypes["SeoDefaultUpdateResult"],
	upsertSeoDefault: GraphQLTypes["SeoDefaultUpsertResult"],
	createSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleCreateResult"],
	deleteSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleDeleteResult"],
	updateSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleUpdateResult"],
	upsertSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleUpsertResult"],
	createBusiness: GraphQLTypes["BusinessCreateResult"],
	deleteBusiness: GraphQLTypes["BusinessDeleteResult"],
	updateBusiness: GraphQLTypes["BusinessUpdateResult"],
	upsertBusiness: GraphQLTypes["BusinessUpsertResult"],
	createBusinessPage: GraphQLTypes["BusinessPageCreateResult"],
	deleteBusinessPage: GraphQLTypes["BusinessPageDeleteResult"],
	updateBusinessPage: GraphQLTypes["BusinessPageUpdateResult"],
	upsertBusinessPage: GraphQLTypes["BusinessPageUpsertResult"],
	createBusinessPageLocale: GraphQLTypes["BusinessPageLocaleCreateResult"],
	deleteBusinessPageLocale: GraphQLTypes["BusinessPageLocaleDeleteResult"],
	updateBusinessPageLocale: GraphQLTypes["BusinessPageLocaleUpdateResult"],
	upsertBusinessPageLocale: GraphQLTypes["BusinessPageLocaleUpsertResult"],
	createIcon: GraphQLTypes["IconCreateResult"],
	deleteIcon: GraphQLTypes["IconDeleteResult"],
	updateIcon: GraphQLTypes["IconUpdateResult"],
	upsertIcon: GraphQLTypes["IconUpsertResult"],
	createJobPage: GraphQLTypes["JobPageCreateResult"],
	deleteJobPage: GraphQLTypes["JobPageDeleteResult"],
	updateJobPage: GraphQLTypes["JobPageUpdateResult"],
	upsertJobPage: GraphQLTypes["JobPageUpsertResult"],
	createJobPageLocale: GraphQLTypes["JobPageLocaleCreateResult"],
	deleteJobPageLocale: GraphQLTypes["JobPageLocaleDeleteResult"],
	updateJobPageLocale: GraphQLTypes["JobPageLocaleUpdateResult"],
	upsertJobPageLocale: GraphQLTypes["JobPageLocaleUpsertResult"],
	createKeyInfoItem: GraphQLTypes["KeyInfoItemCreateResult"],
	deleteKeyInfoItem: GraphQLTypes["KeyInfoItemDeleteResult"],
	updateKeyInfoItem: GraphQLTypes["KeyInfoItemUpdateResult"],
	upsertKeyInfoItem: GraphQLTypes["KeyInfoItemUpsertResult"],
	createKeyInfoList: GraphQLTypes["KeyInfoListCreateResult"],
	deleteKeyInfoList: GraphQLTypes["KeyInfoListDeleteResult"],
	updateKeyInfoList: GraphQLTypes["KeyInfoListUpdateResult"],
	upsertKeyInfoList: GraphQLTypes["KeyInfoListUpsertResult"],
	createContractType: GraphQLTypes["ContractTypeCreateResult"],
	deleteContractType: GraphQLTypes["ContractTypeDeleteResult"],
	updateContractType: GraphQLTypes["ContractTypeUpdateResult"],
	upsertContractType: GraphQLTypes["ContractTypeUpsertResult"],
	createContractTypeLocale: GraphQLTypes["ContractTypeLocaleCreateResult"],
	deleteContractTypeLocale: GraphQLTypes["ContractTypeLocaleDeleteResult"],
	updateContractTypeLocale: GraphQLTypes["ContractTypeLocaleUpdateResult"],
	upsertContractTypeLocale: GraphQLTypes["ContractTypeLocaleUpsertResult"],
	createJobCity: GraphQLTypes["JobCityCreateResult"],
	deleteJobCity: GraphQLTypes["JobCityDeleteResult"],
	updateJobCity: GraphQLTypes["JobCityUpdateResult"],
	upsertJobCity: GraphQLTypes["JobCityUpsertResult"],
	createJobCityLocale: GraphQLTypes["JobCityLocaleCreateResult"],
	deleteJobCityLocale: GraphQLTypes["JobCityLocaleDeleteResult"],
	updateJobCityLocale: GraphQLTypes["JobCityLocaleUpdateResult"],
	upsertJobCityLocale: GraphQLTypes["JobCityLocaleUpsertResult"],
	createJobPosition: GraphQLTypes["JobPositionCreateResult"],
	deleteJobPosition: GraphQLTypes["JobPositionDeleteResult"],
	updateJobPosition: GraphQLTypes["JobPositionUpdateResult"],
	upsertJobPosition: GraphQLTypes["JobPositionUpsertResult"],
	createJobPositionLocale: GraphQLTypes["JobPositionLocaleCreateResult"],
	deleteJobPositionLocale: GraphQLTypes["JobPositionLocaleDeleteResult"],
	updateJobPositionLocale: GraphQLTypes["JobPositionLocaleUpdateResult"],
	upsertJobPositionLocale: GraphQLTypes["JobPositionLocaleUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createHomePageLocale: GraphQLTypes["HomePageLocaleCreateResult"],
	deleteHomePageLocale: GraphQLTypes["HomePageLocaleDeleteResult"],
	updateHomePageLocale: GraphQLTypes["HomePageLocaleUpdateResult"],
	upsertHomePageLocale: GraphQLTypes["HomePageLocaleUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createMediumItem: GraphQLTypes["MediumItemCreateResult"],
	deleteMediumItem: GraphQLTypes["MediumItemDeleteResult"],
	updateMediumItem: GraphQLTypes["MediumItemUpdateResult"],
	upsertMediumItem: GraphQLTypes["MediumItemUpsertResult"],
	createMediumList: GraphQLTypes["MediumListCreateResult"],
	deleteMediumList: GraphQLTypes["MediumListDeleteResult"],
	updateMediumList: GraphQLTypes["MediumListUpdateResult"],
	upsertMediumList: GraphQLTypes["MediumListUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createTextItem: GraphQLTypes["TextItemCreateResult"],
	deleteTextItem: GraphQLTypes["TextItemDeleteResult"],
	updateTextItem: GraphQLTypes["TextItemUpdateResult"],
	upsertTextItem: GraphQLTypes["TextItemUpsertResult"],
	createTextList: GraphQLTypes["TextListCreateResult"],
	deleteTextList: GraphQLTypes["TextListDeleteResult"],
	updateTextList: GraphQLTypes["TextListUpdateResult"],
	upsertTextList: GraphQLTypes["TextListUpsertResult"],
	createCarousel: GraphQLTypes["CarouselCreateResult"],
	deleteCarousel: GraphQLTypes["CarouselDeleteResult"],
	updateCarousel: GraphQLTypes["CarouselUpdateResult"],
	upsertCarousel: GraphQLTypes["CarouselUpsertResult"],
	createCarouselItem: GraphQLTypes["CarouselItemCreateResult"],
	deleteCarouselItem: GraphQLTypes["CarouselItemDeleteResult"],
	updateCarouselItem: GraphQLTypes["CarouselItemUpdateResult"],
	upsertCarouselItem: GraphQLTypes["CarouselItemUpsertResult"],
	createTheme: GraphQLTypes["ThemeCreateResult"],
	deleteTheme: GraphQLTypes["ThemeDeleteResult"],
	updateTheme: GraphQLTypes["ThemeUpdateResult"],
	upsertTheme: GraphQLTypes["ThemeUpsertResult"],
	createBonusBanner: GraphQLTypes["BonusBannerCreateResult"],
	deleteBonusBanner: GraphQLTypes["BonusBannerDeleteResult"],
	updateBonusBanner: GraphQLTypes["BonusBannerUpdateResult"],
	upsertBonusBanner: GraphQLTypes["BonusBannerUpsertResult"],
	createBonusBannerLocale: GraphQLTypes["BonusBannerLocaleCreateResult"],
	deleteBonusBannerLocale: GraphQLTypes["BonusBannerLocaleDeleteResult"],
	updateBonusBannerLocale: GraphQLTypes["BonusBannerLocaleUpdateResult"],
	upsertBonusBannerLocale: GraphQLTypes["BonusBannerLocaleUpsertResult"],
	createTile: GraphQLTypes["TileCreateResult"],
	deleteTile: GraphQLTypes["TileDeleteResult"],
	updateTile: GraphQLTypes["TileUpdateResult"],
	upsertTile: GraphQLTypes["TileUpsertResult"],
	createSideBySide: GraphQLTypes["SideBySideCreateResult"],
	deleteSideBySide: GraphQLTypes["SideBySideDeleteResult"],
	updateSideBySide: GraphQLTypes["SideBySideUpdateResult"],
	upsertSideBySide: GraphQLTypes["SideBySideUpsertResult"],
	createSideBySideItem: GraphQLTypes["SideBySideItemCreateResult"],
	deleteSideBySideItem: GraphQLTypes["SideBySideItemDeleteResult"],
	updateSideBySideItem: GraphQLTypes["SideBySideItemUpdateResult"],
	upsertSideBySideItem: GraphQLTypes["SideBySideItemUpsertResult"],
	createHomePageLokal: GraphQLTypes["HomePageLokalCreateResult"],
	deleteHomePageLokal: GraphQLTypes["HomePageLokalDeleteResult"],
	updateHomePageLokal: GraphQLTypes["HomePageLokalUpdateResult"],
	upsertHomePageLokal: GraphQLTypes["HomePageLokalUpsertResult"],
	createHomePageLokalLocale: GraphQLTypes["HomePageLokalLocaleCreateResult"],
	deleteHomePageLokalLocale: GraphQLTypes["HomePageLokalLocaleDeleteResult"],
	updateHomePageLokalLocale: GraphQLTypes["HomePageLokalLocaleUpdateResult"],
	upsertHomePageLokalLocale: GraphQLTypes["HomePageLokalLocaleUpsertResult"],
	createSiteSwitcher: GraphQLTypes["SiteSwitcherCreateResult"],
	deleteSiteSwitcher: GraphQLTypes["SiteSwitcherDeleteResult"],
	updateSiteSwitcher: GraphQLTypes["SiteSwitcherUpdateResult"],
	upsertSiteSwitcher: GraphQLTypes["SiteSwitcherUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createJobsForm: GraphQLTypes["JobsFormCreateResult"],
	deleteJobsForm: GraphQLTypes["JobsFormDeleteResult"],
	updateJobsForm: GraphQLTypes["JobsFormUpdateResult"],
	upsertJobsForm: GraphQLTypes["JobsFormUpsertResult"],
	createJobsFormLocale: GraphQLTypes["JobsFormLocaleCreateResult"],
	deleteJobsFormLocale: GraphQLTypes["JobsFormLocaleDeleteResult"],
	updateJobsFormLocale: GraphQLTypes["JobsFormLocaleUpdateResult"],
	upsertJobsFormLocale: GraphQLTypes["JobsFormLocaleUpsertResult"],
	createImageTextItem: GraphQLTypes["ImageTextItemCreateResult"],
	deleteImageTextItem: GraphQLTypes["ImageTextItemDeleteResult"],
	updateImageTextItem: GraphQLTypes["ImageTextItemUpdateResult"],
	upsertImageTextItem: GraphQLTypes["ImageTextItemUpsertResult"],
	createImageTextList: GraphQLTypes["ImageTextListCreateResult"],
	deleteImageTextList: GraphQLTypes["ImageTextListDeleteResult"],
	updateImageTextList: GraphQLTypes["ImageTextListUpdateResult"],
	upsertImageTextList: GraphQLTypes["ImageTextListUpsertResult"],
	createJobsFilter: GraphQLTypes["JobsFilterCreateResult"],
	deleteJobsFilter: GraphQLTypes["JobsFilterDeleteResult"],
	updateJobsFilter: GraphQLTypes["JobsFilterUpdateResult"],
	upsertJobsFilter: GraphQLTypes["JobsFilterUpsertResult"],
	createJobsFilterLocale: GraphQLTypes["JobsFilterLocaleCreateResult"],
	deleteJobsFilterLocale: GraphQLTypes["JobsFilterLocaleDeleteResult"],
	updateJobsFilterLocale: GraphQLTypes["JobsFilterLocaleUpdateResult"],
	upsertJobsFilterLocale: GraphQLTypes["JobsFilterLocaleUpsertResult"],
	createFile: GraphQLTypes["FileCreateResult"],
	deleteFile: GraphQLTypes["FileDeleteResult"],
	updateFile: GraphQLTypes["FileUpdateResult"],
	upsertFile: GraphQLTypes["FileUpsertResult"],
	createJobFormSubscription: GraphQLTypes["JobFormSubscriptionCreateResult"],
	deleteJobFormSubscription: GraphQLTypes["JobFormSubscriptionDeleteResult"],
	updateJobFormSubscription: GraphQLTypes["JobFormSubscriptionUpdateResult"],
	upsertJobFormSubscription: GraphQLTypes["JobFormSubscriptionUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageListItem: GraphQLTypes["ImageListItemCreateResult"],
	deleteImageListItem: GraphQLTypes["ImageListItemDeleteResult"],
	updateImageListItem: GraphQLTypes["ImageListItemUpdateResult"],
	upsertImageListItem: GraphQLTypes["ImageListItemUpsertResult"],
	createJobFormSubscriptionStatus: GraphQLTypes["JobFormSubscriptionStatusCreateResult"],
	deleteJobFormSubscriptionStatus: GraphQLTypes["JobFormSubscriptionStatusDeleteResult"],
	updateJobFormSubscriptionStatus: GraphQLTypes["JobFormSubscriptionStatusUpdateResult"],
	upsertJobFormSubscriptionStatus: GraphQLTypes["JobFormSubscriptionStatusUpsertResult"],
	createGeneralLocale: GraphQLTypes["GeneralLocaleCreateResult"],
	deleteGeneralLocale: GraphQLTypes["GeneralLocaleDeleteResult"],
	updateGeneralLocale: GraphQLTypes["GeneralLocaleUpdateResult"],
	upsertGeneralLocale: GraphQLTypes["GeneralLocaleUpsertResult"],
	createStickyBar: GraphQLTypes["StickyBarCreateResult"],
	deleteStickyBar: GraphQLTypes["StickyBarDeleteResult"],
	updateStickyBar: GraphQLTypes["StickyBarUpdateResult"],
	upsertStickyBar: GraphQLTypes["StickyBarUpsertResult"],
	createRecommendationForm: GraphQLTypes["RecommendationFormCreateResult"],
	deleteRecommendationForm: GraphQLTypes["RecommendationFormDeleteResult"],
	updateRecommendationForm: GraphQLTypes["RecommendationFormUpdateResult"],
	upsertRecommendationForm: GraphQLTypes["RecommendationFormUpsertResult"],
	createRecommendationFormLocale: GraphQLTypes["RecommendationFormLocaleCreateResult"],
	deleteRecommendationFormLocale: GraphQLTypes["RecommendationFormLocaleDeleteResult"],
	updateRecommendationFormLocale: GraphQLTypes["RecommendationFormLocaleUpdateResult"],
	upsertRecommendationFormLocale: GraphQLTypes["RecommendationFormLocaleUpsertResult"],
	createRecommendationFormSubscription: GraphQLTypes["RecommendationFormSubscriptionCreateResult"],
	deleteRecommendationFormSubscription: GraphQLTypes["RecommendationFormSubscriptionDeleteResult"],
	updateRecommendationFormSubscription: GraphQLTypes["RecommendationFormSubscriptionUpdateResult"],
	upsertRecommendationFormSubscription: GraphQLTypes["RecommendationFormSubscriptionUpsertResult"],
	createInfoBox: GraphQLTypes["InfoBoxCreateResult"],
	deleteInfoBox: GraphQLTypes["InfoBoxDeleteResult"],
	updateInfoBox: GraphQLTypes["InfoBoxUpdateResult"],
	upsertInfoBox: GraphQLTypes["InfoBoxUpsertResult"],
	createInfoBoxLocale: GraphQLTypes["InfoBoxLocaleCreateResult"],
	deleteInfoBoxLocale: GraphQLTypes["InfoBoxLocaleDeleteResult"],
	updateInfoBoxLocale: GraphQLTypes["InfoBoxLocaleUpdateResult"],
	upsertInfoBoxLocale: GraphQLTypes["InfoBoxLocaleUpsertResult"],
	createTranslation: GraphQLTypes["TranslationCreateResult"],
	deleteTranslation: GraphQLTypes["TranslationDeleteResult"],
	updateTranslation: GraphQLTypes["TranslationUpdateResult"],
	upsertTranslation: GraphQLTypes["TranslationUpsertResult"],
	createTranslationLocale: GraphQLTypes["TranslationLocaleCreateResult"],
	deleteTranslationLocale: GraphQLTypes["TranslationLocaleDeleteResult"],
	updateTranslationLocale: GraphQLTypes["TranslationLocaleUpdateResult"],
	upsertTranslationLocale: GraphQLTypes["TranslationLocaleUpsertResult"],
	createCornerBanner: GraphQLTypes["CornerBannerCreateResult"],
	deleteCornerBanner: GraphQLTypes["CornerBannerDeleteResult"],
	updateCornerBanner: GraphQLTypes["CornerBannerUpdateResult"],
	upsertCornerBanner: GraphQLTypes["CornerBannerUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"]
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3GenerateSignedUploadInput"]: {
		contentType?: string | undefined,
	/** If not provided, extension is detected from a content-type. */
	extension?: string | undefined,
	/** Signed URL expiration. */
	expiration?: number | undefined,
	/** Uploaded file size. Required when you enable ACL size limits. */
	size?: number | undefined,
	/** Can be used as a "directory". */
	prefix?: string | undefined,
	/** Suffix after generated id and before the extension. */
	suffix?: string | undefined,
	/** This only affects Content-disposition header. Does not affect actual object key. */
	fileName?: string | undefined,
	contentDisposition?: GraphQLTypes["S33ContentDisposition"] | undefined,
	/** If not supported by S3 provider, an error is thrown. */
	acl?: GraphQLTypes["S3Acl"] | undefined
};
	["S33ContentDisposition"]: S33ContentDisposition;
	["S3Acl"]: S3Acl;
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	objectKey: string,
	bucket: string
};
	["GeneralCreateResult"]: {
	__typename: "GeneralCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["General"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"GeneralCreateResult" | "GeneralDeleteResult" | "GeneralUpdateResult" | "GeneralUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "GenericPageCreateResult" | "GenericPageDeleteResult" | "GenericPageUpdateResult" | "GenericPageUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "ContentCreateResult" | "ContentDeleteResult" | "ContentUpdateResult" | "ContentUpsertResult" | "ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ContentReferenceCreateResult" | "ContentReferenceDeleteResult" | "ContentReferenceUpdateResult" | "ContentReferenceUpsertResult" | "RedirectCreateResult" | "RedirectDeleteResult" | "RedirectUpdateResult" | "RedirectUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "FooterCreateResult" | "FooterDeleteResult" | "FooterUpdateResult" | "FooterUpsertResult" | "FooterLinkCreateResult" | "FooterLinkDeleteResult" | "FooterLinkUpdateResult" | "FooterLinkUpsertResult" | "FooterLocaleCreateResult" | "FooterLocaleDeleteResult" | "FooterLocaleUpdateResult" | "FooterLocaleUpsertResult" | "GenericPageLocaleCreateResult" | "GenericPageLocaleDeleteResult" | "GenericPageLocaleUpdateResult" | "GenericPageLocaleUpsertResult" | "HeaderCreateResult" | "HeaderDeleteResult" | "HeaderUpdateResult" | "HeaderUpsertResult" | "HeaderLocaleCreateResult" | "HeaderLocaleDeleteResult" | "HeaderLocaleUpdateResult" | "HeaderLocaleUpsertResult" | "LocaleCreateResult" | "LocaleDeleteResult" | "LocaleUpdateResult" | "LocaleUpsertResult" | "SeoDefaultCreateResult" | "SeoDefaultDeleteResult" | "SeoDefaultUpdateResult" | "SeoDefaultUpsertResult" | "SeoDefaultLocaleCreateResult" | "SeoDefaultLocaleDeleteResult" | "SeoDefaultLocaleUpdateResult" | "SeoDefaultLocaleUpsertResult" | "BusinessCreateResult" | "BusinessDeleteResult" | "BusinessUpdateResult" | "BusinessUpsertResult" | "BusinessPageCreateResult" | "BusinessPageDeleteResult" | "BusinessPageUpdateResult" | "BusinessPageUpsertResult" | "BusinessPageLocaleCreateResult" | "BusinessPageLocaleDeleteResult" | "BusinessPageLocaleUpdateResult" | "BusinessPageLocaleUpsertResult" | "IconCreateResult" | "IconDeleteResult" | "IconUpdateResult" | "IconUpsertResult" | "JobPageCreateResult" | "JobPageDeleteResult" | "JobPageUpdateResult" | "JobPageUpsertResult" | "JobPageLocaleCreateResult" | "JobPageLocaleDeleteResult" | "JobPageLocaleUpdateResult" | "JobPageLocaleUpsertResult" | "KeyInfoItemCreateResult" | "KeyInfoItemDeleteResult" | "KeyInfoItemUpdateResult" | "KeyInfoItemUpsertResult" | "KeyInfoListCreateResult" | "KeyInfoListDeleteResult" | "KeyInfoListUpdateResult" | "KeyInfoListUpsertResult" | "ContractTypeCreateResult" | "ContractTypeDeleteResult" | "ContractTypeUpdateResult" | "ContractTypeUpsertResult" | "ContractTypeLocaleCreateResult" | "ContractTypeLocaleDeleteResult" | "ContractTypeLocaleUpdateResult" | "ContractTypeLocaleUpsertResult" | "JobCityCreateResult" | "JobCityDeleteResult" | "JobCityUpdateResult" | "JobCityUpsertResult" | "JobCityLocaleCreateResult" | "JobCityLocaleDeleteResult" | "JobCityLocaleUpdateResult" | "JobCityLocaleUpsertResult" | "JobPositionCreateResult" | "JobPositionDeleteResult" | "JobPositionUpdateResult" | "JobPositionUpsertResult" | "JobPositionLocaleCreateResult" | "JobPositionLocaleDeleteResult" | "JobPositionLocaleUpdateResult" | "JobPositionLocaleUpsertResult" | "GalleryCreateResult" | "GalleryDeleteResult" | "GalleryUpdateResult" | "GalleryUpsertResult" | "HomePageCreateResult" | "HomePageDeleteResult" | "HomePageUpdateResult" | "HomePageUpsertResult" | "HomePageLocaleCreateResult" | "HomePageLocaleDeleteResult" | "HomePageLocaleUpdateResult" | "HomePageLocaleUpsertResult" | "MediumCreateResult" | "MediumDeleteResult" | "MediumUpdateResult" | "MediumUpsertResult" | "MediumItemCreateResult" | "MediumItemDeleteResult" | "MediumItemUpdateResult" | "MediumItemUpsertResult" | "MediumListCreateResult" | "MediumListDeleteResult" | "MediumListUpdateResult" | "MediumListUpsertResult" | "VideoCreateResult" | "VideoDeleteResult" | "VideoUpdateResult" | "VideoUpsertResult" | "TextItemCreateResult" | "TextItemDeleteResult" | "TextItemUpdateResult" | "TextItemUpsertResult" | "TextListCreateResult" | "TextListDeleteResult" | "TextListUpdateResult" | "TextListUpsertResult" | "CarouselCreateResult" | "CarouselDeleteResult" | "CarouselUpdateResult" | "CarouselUpsertResult" | "CarouselItemCreateResult" | "CarouselItemDeleteResult" | "CarouselItemUpdateResult" | "CarouselItemUpsertResult" | "ThemeCreateResult" | "ThemeDeleteResult" | "ThemeUpdateResult" | "ThemeUpsertResult" | "BonusBannerCreateResult" | "BonusBannerDeleteResult" | "BonusBannerUpdateResult" | "BonusBannerUpsertResult" | "BonusBannerLocaleCreateResult" | "BonusBannerLocaleDeleteResult" | "BonusBannerLocaleUpdateResult" | "BonusBannerLocaleUpsertResult" | "TileCreateResult" | "TileDeleteResult" | "TileUpdateResult" | "TileUpsertResult" | "SideBySideCreateResult" | "SideBySideDeleteResult" | "SideBySideUpdateResult" | "SideBySideUpsertResult" | "SideBySideItemCreateResult" | "SideBySideItemDeleteResult" | "SideBySideItemUpdateResult" | "SideBySideItemUpsertResult" | "HomePageLokalCreateResult" | "HomePageLokalDeleteResult" | "HomePageLokalUpdateResult" | "HomePageLokalUpsertResult" | "HomePageLokalLocaleCreateResult" | "HomePageLokalLocaleDeleteResult" | "HomePageLokalLocaleUpdateResult" | "HomePageLokalLocaleUpsertResult" | "SiteSwitcherCreateResult" | "SiteSwitcherDeleteResult" | "SiteSwitcherUpdateResult" | "SiteSwitcherUpsertResult" | "GalleryItemCreateResult" | "GalleryItemDeleteResult" | "GalleryItemUpdateResult" | "GalleryItemUpsertResult" | "JobsFormCreateResult" | "JobsFormDeleteResult" | "JobsFormUpdateResult" | "JobsFormUpsertResult" | "JobsFormLocaleCreateResult" | "JobsFormLocaleDeleteResult" | "JobsFormLocaleUpdateResult" | "JobsFormLocaleUpsertResult" | "ImageTextItemCreateResult" | "ImageTextItemDeleteResult" | "ImageTextItemUpdateResult" | "ImageTextItemUpsertResult" | "ImageTextListCreateResult" | "ImageTextListDeleteResult" | "ImageTextListUpdateResult" | "ImageTextListUpsertResult" | "JobsFilterCreateResult" | "JobsFilterDeleteResult" | "JobsFilterUpdateResult" | "JobsFilterUpsertResult" | "JobsFilterLocaleCreateResult" | "JobsFilterLocaleDeleteResult" | "JobsFilterLocaleUpdateResult" | "JobsFilterLocaleUpsertResult" | "FileCreateResult" | "FileDeleteResult" | "FileUpdateResult" | "FileUpsertResult" | "JobFormSubscriptionCreateResult" | "JobFormSubscriptionDeleteResult" | "JobFormSubscriptionUpdateResult" | "JobFormSubscriptionUpsertResult" | "ImageListCreateResult" | "ImageListDeleteResult" | "ImageListUpdateResult" | "ImageListUpsertResult" | "ImageListItemCreateResult" | "ImageListItemDeleteResult" | "ImageListItemUpdateResult" | "ImageListItemUpsertResult" | "JobFormSubscriptionStatusCreateResult" | "JobFormSubscriptionStatusDeleteResult" | "JobFormSubscriptionStatusUpdateResult" | "JobFormSubscriptionStatusUpsertResult" | "GeneralLocaleCreateResult" | "GeneralLocaleDeleteResult" | "GeneralLocaleUpdateResult" | "GeneralLocaleUpsertResult" | "StickyBarCreateResult" | "StickyBarDeleteResult" | "StickyBarUpdateResult" | "StickyBarUpsertResult" | "RecommendationFormCreateResult" | "RecommendationFormDeleteResult" | "RecommendationFormUpdateResult" | "RecommendationFormUpsertResult" | "RecommendationFormLocaleCreateResult" | "RecommendationFormLocaleDeleteResult" | "RecommendationFormLocaleUpdateResult" | "RecommendationFormLocaleUpsertResult" | "RecommendationFormSubscriptionCreateResult" | "RecommendationFormSubscriptionDeleteResult" | "RecommendationFormSubscriptionUpdateResult" | "RecommendationFormSubscriptionUpsertResult" | "InfoBoxCreateResult" | "InfoBoxDeleteResult" | "InfoBoxUpdateResult" | "InfoBoxUpsertResult" | "InfoBoxLocaleCreateResult" | "InfoBoxLocaleDeleteResult" | "InfoBoxLocaleUpdateResult" | "InfoBoxLocaleUpsertResult" | "TranslationCreateResult" | "TranslationDeleteResult" | "TranslationUpdateResult" | "TranslationUpsertResult" | "TranslationLocaleCreateResult" | "TranslationLocaleDeleteResult" | "TranslationLocaleUpdateResult" | "TranslationLocaleUpsertResult" | "CornerBannerCreateResult" | "CornerBannerDeleteResult" | "CornerBannerUpdateResult" | "CornerBannerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on GeneralCreateResult']: '__union' & GraphQLTypes["GeneralCreateResult"];
	['...on GeneralDeleteResult']: '__union' & GraphQLTypes["GeneralDeleteResult"];
	['...on GeneralUpdateResult']: '__union' & GraphQLTypes["GeneralUpdateResult"];
	['...on GeneralUpsertResult']: '__union' & GraphQLTypes["GeneralUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on GenericPageCreateResult']: '__union' & GraphQLTypes["GenericPageCreateResult"];
	['...on GenericPageDeleteResult']: '__union' & GraphQLTypes["GenericPageDeleteResult"];
	['...on GenericPageUpdateResult']: '__union' & GraphQLTypes["GenericPageUpdateResult"];
	['...on GenericPageUpsertResult']: '__union' & GraphQLTypes["GenericPageUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on ContentCreateResult']: '__union' & GraphQLTypes["ContentCreateResult"];
	['...on ContentDeleteResult']: '__union' & GraphQLTypes["ContentDeleteResult"];
	['...on ContentUpdateResult']: '__union' & GraphQLTypes["ContentUpdateResult"];
	['...on ContentUpsertResult']: '__union' & GraphQLTypes["ContentUpsertResult"];
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ContentReferenceCreateResult']: '__union' & GraphQLTypes["ContentReferenceCreateResult"];
	['...on ContentReferenceDeleteResult']: '__union' & GraphQLTypes["ContentReferenceDeleteResult"];
	['...on ContentReferenceUpdateResult']: '__union' & GraphQLTypes["ContentReferenceUpdateResult"];
	['...on ContentReferenceUpsertResult']: '__union' & GraphQLTypes["ContentReferenceUpsertResult"];
	['...on RedirectCreateResult']: '__union' & GraphQLTypes["RedirectCreateResult"];
	['...on RedirectDeleteResult']: '__union' & GraphQLTypes["RedirectDeleteResult"];
	['...on RedirectUpdateResult']: '__union' & GraphQLTypes["RedirectUpdateResult"];
	['...on RedirectUpsertResult']: '__union' & GraphQLTypes["RedirectUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on FooterCreateResult']: '__union' & GraphQLTypes["FooterCreateResult"];
	['...on FooterDeleteResult']: '__union' & GraphQLTypes["FooterDeleteResult"];
	['...on FooterUpdateResult']: '__union' & GraphQLTypes["FooterUpdateResult"];
	['...on FooterUpsertResult']: '__union' & GraphQLTypes["FooterUpsertResult"];
	['...on FooterLinkCreateResult']: '__union' & GraphQLTypes["FooterLinkCreateResult"];
	['...on FooterLinkDeleteResult']: '__union' & GraphQLTypes["FooterLinkDeleteResult"];
	['...on FooterLinkUpdateResult']: '__union' & GraphQLTypes["FooterLinkUpdateResult"];
	['...on FooterLinkUpsertResult']: '__union' & GraphQLTypes["FooterLinkUpsertResult"];
	['...on FooterLocaleCreateResult']: '__union' & GraphQLTypes["FooterLocaleCreateResult"];
	['...on FooterLocaleDeleteResult']: '__union' & GraphQLTypes["FooterLocaleDeleteResult"];
	['...on FooterLocaleUpdateResult']: '__union' & GraphQLTypes["FooterLocaleUpdateResult"];
	['...on FooterLocaleUpsertResult']: '__union' & GraphQLTypes["FooterLocaleUpsertResult"];
	['...on GenericPageLocaleCreateResult']: '__union' & GraphQLTypes["GenericPageLocaleCreateResult"];
	['...on GenericPageLocaleDeleteResult']: '__union' & GraphQLTypes["GenericPageLocaleDeleteResult"];
	['...on GenericPageLocaleUpdateResult']: '__union' & GraphQLTypes["GenericPageLocaleUpdateResult"];
	['...on GenericPageLocaleUpsertResult']: '__union' & GraphQLTypes["GenericPageLocaleUpsertResult"];
	['...on HeaderCreateResult']: '__union' & GraphQLTypes["HeaderCreateResult"];
	['...on HeaderDeleteResult']: '__union' & GraphQLTypes["HeaderDeleteResult"];
	['...on HeaderUpdateResult']: '__union' & GraphQLTypes["HeaderUpdateResult"];
	['...on HeaderUpsertResult']: '__union' & GraphQLTypes["HeaderUpsertResult"];
	['...on HeaderLocaleCreateResult']: '__union' & GraphQLTypes["HeaderLocaleCreateResult"];
	['...on HeaderLocaleDeleteResult']: '__union' & GraphQLTypes["HeaderLocaleDeleteResult"];
	['...on HeaderLocaleUpdateResult']: '__union' & GraphQLTypes["HeaderLocaleUpdateResult"];
	['...on HeaderLocaleUpsertResult']: '__union' & GraphQLTypes["HeaderLocaleUpsertResult"];
	['...on LocaleCreateResult']: '__union' & GraphQLTypes["LocaleCreateResult"];
	['...on LocaleDeleteResult']: '__union' & GraphQLTypes["LocaleDeleteResult"];
	['...on LocaleUpdateResult']: '__union' & GraphQLTypes["LocaleUpdateResult"];
	['...on LocaleUpsertResult']: '__union' & GraphQLTypes["LocaleUpsertResult"];
	['...on SeoDefaultCreateResult']: '__union' & GraphQLTypes["SeoDefaultCreateResult"];
	['...on SeoDefaultDeleteResult']: '__union' & GraphQLTypes["SeoDefaultDeleteResult"];
	['...on SeoDefaultUpdateResult']: '__union' & GraphQLTypes["SeoDefaultUpdateResult"];
	['...on SeoDefaultUpsertResult']: '__union' & GraphQLTypes["SeoDefaultUpsertResult"];
	['...on SeoDefaultLocaleCreateResult']: '__union' & GraphQLTypes["SeoDefaultLocaleCreateResult"];
	['...on SeoDefaultLocaleDeleteResult']: '__union' & GraphQLTypes["SeoDefaultLocaleDeleteResult"];
	['...on SeoDefaultLocaleUpdateResult']: '__union' & GraphQLTypes["SeoDefaultLocaleUpdateResult"];
	['...on SeoDefaultLocaleUpsertResult']: '__union' & GraphQLTypes["SeoDefaultLocaleUpsertResult"];
	['...on BusinessCreateResult']: '__union' & GraphQLTypes["BusinessCreateResult"];
	['...on BusinessDeleteResult']: '__union' & GraphQLTypes["BusinessDeleteResult"];
	['...on BusinessUpdateResult']: '__union' & GraphQLTypes["BusinessUpdateResult"];
	['...on BusinessUpsertResult']: '__union' & GraphQLTypes["BusinessUpsertResult"];
	['...on BusinessPageCreateResult']: '__union' & GraphQLTypes["BusinessPageCreateResult"];
	['...on BusinessPageDeleteResult']: '__union' & GraphQLTypes["BusinessPageDeleteResult"];
	['...on BusinessPageUpdateResult']: '__union' & GraphQLTypes["BusinessPageUpdateResult"];
	['...on BusinessPageUpsertResult']: '__union' & GraphQLTypes["BusinessPageUpsertResult"];
	['...on BusinessPageLocaleCreateResult']: '__union' & GraphQLTypes["BusinessPageLocaleCreateResult"];
	['...on BusinessPageLocaleDeleteResult']: '__union' & GraphQLTypes["BusinessPageLocaleDeleteResult"];
	['...on BusinessPageLocaleUpdateResult']: '__union' & GraphQLTypes["BusinessPageLocaleUpdateResult"];
	['...on BusinessPageLocaleUpsertResult']: '__union' & GraphQLTypes["BusinessPageLocaleUpsertResult"];
	['...on IconCreateResult']: '__union' & GraphQLTypes["IconCreateResult"];
	['...on IconDeleteResult']: '__union' & GraphQLTypes["IconDeleteResult"];
	['...on IconUpdateResult']: '__union' & GraphQLTypes["IconUpdateResult"];
	['...on IconUpsertResult']: '__union' & GraphQLTypes["IconUpsertResult"];
	['...on JobPageCreateResult']: '__union' & GraphQLTypes["JobPageCreateResult"];
	['...on JobPageDeleteResult']: '__union' & GraphQLTypes["JobPageDeleteResult"];
	['...on JobPageUpdateResult']: '__union' & GraphQLTypes["JobPageUpdateResult"];
	['...on JobPageUpsertResult']: '__union' & GraphQLTypes["JobPageUpsertResult"];
	['...on JobPageLocaleCreateResult']: '__union' & GraphQLTypes["JobPageLocaleCreateResult"];
	['...on JobPageLocaleDeleteResult']: '__union' & GraphQLTypes["JobPageLocaleDeleteResult"];
	['...on JobPageLocaleUpdateResult']: '__union' & GraphQLTypes["JobPageLocaleUpdateResult"];
	['...on JobPageLocaleUpsertResult']: '__union' & GraphQLTypes["JobPageLocaleUpsertResult"];
	['...on KeyInfoItemCreateResult']: '__union' & GraphQLTypes["KeyInfoItemCreateResult"];
	['...on KeyInfoItemDeleteResult']: '__union' & GraphQLTypes["KeyInfoItemDeleteResult"];
	['...on KeyInfoItemUpdateResult']: '__union' & GraphQLTypes["KeyInfoItemUpdateResult"];
	['...on KeyInfoItemUpsertResult']: '__union' & GraphQLTypes["KeyInfoItemUpsertResult"];
	['...on KeyInfoListCreateResult']: '__union' & GraphQLTypes["KeyInfoListCreateResult"];
	['...on KeyInfoListDeleteResult']: '__union' & GraphQLTypes["KeyInfoListDeleteResult"];
	['...on KeyInfoListUpdateResult']: '__union' & GraphQLTypes["KeyInfoListUpdateResult"];
	['...on KeyInfoListUpsertResult']: '__union' & GraphQLTypes["KeyInfoListUpsertResult"];
	['...on ContractTypeCreateResult']: '__union' & GraphQLTypes["ContractTypeCreateResult"];
	['...on ContractTypeDeleteResult']: '__union' & GraphQLTypes["ContractTypeDeleteResult"];
	['...on ContractTypeUpdateResult']: '__union' & GraphQLTypes["ContractTypeUpdateResult"];
	['...on ContractTypeUpsertResult']: '__union' & GraphQLTypes["ContractTypeUpsertResult"];
	['...on ContractTypeLocaleCreateResult']: '__union' & GraphQLTypes["ContractTypeLocaleCreateResult"];
	['...on ContractTypeLocaleDeleteResult']: '__union' & GraphQLTypes["ContractTypeLocaleDeleteResult"];
	['...on ContractTypeLocaleUpdateResult']: '__union' & GraphQLTypes["ContractTypeLocaleUpdateResult"];
	['...on ContractTypeLocaleUpsertResult']: '__union' & GraphQLTypes["ContractTypeLocaleUpsertResult"];
	['...on JobCityCreateResult']: '__union' & GraphQLTypes["JobCityCreateResult"];
	['...on JobCityDeleteResult']: '__union' & GraphQLTypes["JobCityDeleteResult"];
	['...on JobCityUpdateResult']: '__union' & GraphQLTypes["JobCityUpdateResult"];
	['...on JobCityUpsertResult']: '__union' & GraphQLTypes["JobCityUpsertResult"];
	['...on JobCityLocaleCreateResult']: '__union' & GraphQLTypes["JobCityLocaleCreateResult"];
	['...on JobCityLocaleDeleteResult']: '__union' & GraphQLTypes["JobCityLocaleDeleteResult"];
	['...on JobCityLocaleUpdateResult']: '__union' & GraphQLTypes["JobCityLocaleUpdateResult"];
	['...on JobCityLocaleUpsertResult']: '__union' & GraphQLTypes["JobCityLocaleUpsertResult"];
	['...on JobPositionCreateResult']: '__union' & GraphQLTypes["JobPositionCreateResult"];
	['...on JobPositionDeleteResult']: '__union' & GraphQLTypes["JobPositionDeleteResult"];
	['...on JobPositionUpdateResult']: '__union' & GraphQLTypes["JobPositionUpdateResult"];
	['...on JobPositionUpsertResult']: '__union' & GraphQLTypes["JobPositionUpsertResult"];
	['...on JobPositionLocaleCreateResult']: '__union' & GraphQLTypes["JobPositionLocaleCreateResult"];
	['...on JobPositionLocaleDeleteResult']: '__union' & GraphQLTypes["JobPositionLocaleDeleteResult"];
	['...on JobPositionLocaleUpdateResult']: '__union' & GraphQLTypes["JobPositionLocaleUpdateResult"];
	['...on JobPositionLocaleUpsertResult']: '__union' & GraphQLTypes["JobPositionLocaleUpsertResult"];
	['...on GalleryCreateResult']: '__union' & GraphQLTypes["GalleryCreateResult"];
	['...on GalleryDeleteResult']: '__union' & GraphQLTypes["GalleryDeleteResult"];
	['...on GalleryUpdateResult']: '__union' & GraphQLTypes["GalleryUpdateResult"];
	['...on GalleryUpsertResult']: '__union' & GraphQLTypes["GalleryUpsertResult"];
	['...on HomePageCreateResult']: '__union' & GraphQLTypes["HomePageCreateResult"];
	['...on HomePageDeleteResult']: '__union' & GraphQLTypes["HomePageDeleteResult"];
	['...on HomePageUpdateResult']: '__union' & GraphQLTypes["HomePageUpdateResult"];
	['...on HomePageUpsertResult']: '__union' & GraphQLTypes["HomePageUpsertResult"];
	['...on HomePageLocaleCreateResult']: '__union' & GraphQLTypes["HomePageLocaleCreateResult"];
	['...on HomePageLocaleDeleteResult']: '__union' & GraphQLTypes["HomePageLocaleDeleteResult"];
	['...on HomePageLocaleUpdateResult']: '__union' & GraphQLTypes["HomePageLocaleUpdateResult"];
	['...on HomePageLocaleUpsertResult']: '__union' & GraphQLTypes["HomePageLocaleUpsertResult"];
	['...on MediumCreateResult']: '__union' & GraphQLTypes["MediumCreateResult"];
	['...on MediumDeleteResult']: '__union' & GraphQLTypes["MediumDeleteResult"];
	['...on MediumUpdateResult']: '__union' & GraphQLTypes["MediumUpdateResult"];
	['...on MediumUpsertResult']: '__union' & GraphQLTypes["MediumUpsertResult"];
	['...on MediumItemCreateResult']: '__union' & GraphQLTypes["MediumItemCreateResult"];
	['...on MediumItemDeleteResult']: '__union' & GraphQLTypes["MediumItemDeleteResult"];
	['...on MediumItemUpdateResult']: '__union' & GraphQLTypes["MediumItemUpdateResult"];
	['...on MediumItemUpsertResult']: '__union' & GraphQLTypes["MediumItemUpsertResult"];
	['...on MediumListCreateResult']: '__union' & GraphQLTypes["MediumListCreateResult"];
	['...on MediumListDeleteResult']: '__union' & GraphQLTypes["MediumListDeleteResult"];
	['...on MediumListUpdateResult']: '__union' & GraphQLTypes["MediumListUpdateResult"];
	['...on MediumListUpsertResult']: '__union' & GraphQLTypes["MediumListUpsertResult"];
	['...on VideoCreateResult']: '__union' & GraphQLTypes["VideoCreateResult"];
	['...on VideoDeleteResult']: '__union' & GraphQLTypes["VideoDeleteResult"];
	['...on VideoUpdateResult']: '__union' & GraphQLTypes["VideoUpdateResult"];
	['...on VideoUpsertResult']: '__union' & GraphQLTypes["VideoUpsertResult"];
	['...on TextItemCreateResult']: '__union' & GraphQLTypes["TextItemCreateResult"];
	['...on TextItemDeleteResult']: '__union' & GraphQLTypes["TextItemDeleteResult"];
	['...on TextItemUpdateResult']: '__union' & GraphQLTypes["TextItemUpdateResult"];
	['...on TextItemUpsertResult']: '__union' & GraphQLTypes["TextItemUpsertResult"];
	['...on TextListCreateResult']: '__union' & GraphQLTypes["TextListCreateResult"];
	['...on TextListDeleteResult']: '__union' & GraphQLTypes["TextListDeleteResult"];
	['...on TextListUpdateResult']: '__union' & GraphQLTypes["TextListUpdateResult"];
	['...on TextListUpsertResult']: '__union' & GraphQLTypes["TextListUpsertResult"];
	['...on CarouselCreateResult']: '__union' & GraphQLTypes["CarouselCreateResult"];
	['...on CarouselDeleteResult']: '__union' & GraphQLTypes["CarouselDeleteResult"];
	['...on CarouselUpdateResult']: '__union' & GraphQLTypes["CarouselUpdateResult"];
	['...on CarouselUpsertResult']: '__union' & GraphQLTypes["CarouselUpsertResult"];
	['...on CarouselItemCreateResult']: '__union' & GraphQLTypes["CarouselItemCreateResult"];
	['...on CarouselItemDeleteResult']: '__union' & GraphQLTypes["CarouselItemDeleteResult"];
	['...on CarouselItemUpdateResult']: '__union' & GraphQLTypes["CarouselItemUpdateResult"];
	['...on CarouselItemUpsertResult']: '__union' & GraphQLTypes["CarouselItemUpsertResult"];
	['...on ThemeCreateResult']: '__union' & GraphQLTypes["ThemeCreateResult"];
	['...on ThemeDeleteResult']: '__union' & GraphQLTypes["ThemeDeleteResult"];
	['...on ThemeUpdateResult']: '__union' & GraphQLTypes["ThemeUpdateResult"];
	['...on ThemeUpsertResult']: '__union' & GraphQLTypes["ThemeUpsertResult"];
	['...on BonusBannerCreateResult']: '__union' & GraphQLTypes["BonusBannerCreateResult"];
	['...on BonusBannerDeleteResult']: '__union' & GraphQLTypes["BonusBannerDeleteResult"];
	['...on BonusBannerUpdateResult']: '__union' & GraphQLTypes["BonusBannerUpdateResult"];
	['...on BonusBannerUpsertResult']: '__union' & GraphQLTypes["BonusBannerUpsertResult"];
	['...on BonusBannerLocaleCreateResult']: '__union' & GraphQLTypes["BonusBannerLocaleCreateResult"];
	['...on BonusBannerLocaleDeleteResult']: '__union' & GraphQLTypes["BonusBannerLocaleDeleteResult"];
	['...on BonusBannerLocaleUpdateResult']: '__union' & GraphQLTypes["BonusBannerLocaleUpdateResult"];
	['...on BonusBannerLocaleUpsertResult']: '__union' & GraphQLTypes["BonusBannerLocaleUpsertResult"];
	['...on TileCreateResult']: '__union' & GraphQLTypes["TileCreateResult"];
	['...on TileDeleteResult']: '__union' & GraphQLTypes["TileDeleteResult"];
	['...on TileUpdateResult']: '__union' & GraphQLTypes["TileUpdateResult"];
	['...on TileUpsertResult']: '__union' & GraphQLTypes["TileUpsertResult"];
	['...on SideBySideCreateResult']: '__union' & GraphQLTypes["SideBySideCreateResult"];
	['...on SideBySideDeleteResult']: '__union' & GraphQLTypes["SideBySideDeleteResult"];
	['...on SideBySideUpdateResult']: '__union' & GraphQLTypes["SideBySideUpdateResult"];
	['...on SideBySideUpsertResult']: '__union' & GraphQLTypes["SideBySideUpsertResult"];
	['...on SideBySideItemCreateResult']: '__union' & GraphQLTypes["SideBySideItemCreateResult"];
	['...on SideBySideItemDeleteResult']: '__union' & GraphQLTypes["SideBySideItemDeleteResult"];
	['...on SideBySideItemUpdateResult']: '__union' & GraphQLTypes["SideBySideItemUpdateResult"];
	['...on SideBySideItemUpsertResult']: '__union' & GraphQLTypes["SideBySideItemUpsertResult"];
	['...on HomePageLokalCreateResult']: '__union' & GraphQLTypes["HomePageLokalCreateResult"];
	['...on HomePageLokalDeleteResult']: '__union' & GraphQLTypes["HomePageLokalDeleteResult"];
	['...on HomePageLokalUpdateResult']: '__union' & GraphQLTypes["HomePageLokalUpdateResult"];
	['...on HomePageLokalUpsertResult']: '__union' & GraphQLTypes["HomePageLokalUpsertResult"];
	['...on HomePageLokalLocaleCreateResult']: '__union' & GraphQLTypes["HomePageLokalLocaleCreateResult"];
	['...on HomePageLokalLocaleDeleteResult']: '__union' & GraphQLTypes["HomePageLokalLocaleDeleteResult"];
	['...on HomePageLokalLocaleUpdateResult']: '__union' & GraphQLTypes["HomePageLokalLocaleUpdateResult"];
	['...on HomePageLokalLocaleUpsertResult']: '__union' & GraphQLTypes["HomePageLokalLocaleUpsertResult"];
	['...on SiteSwitcherCreateResult']: '__union' & GraphQLTypes["SiteSwitcherCreateResult"];
	['...on SiteSwitcherDeleteResult']: '__union' & GraphQLTypes["SiteSwitcherDeleteResult"];
	['...on SiteSwitcherUpdateResult']: '__union' & GraphQLTypes["SiteSwitcherUpdateResult"];
	['...on SiteSwitcherUpsertResult']: '__union' & GraphQLTypes["SiteSwitcherUpsertResult"];
	['...on GalleryItemCreateResult']: '__union' & GraphQLTypes["GalleryItemCreateResult"];
	['...on GalleryItemDeleteResult']: '__union' & GraphQLTypes["GalleryItemDeleteResult"];
	['...on GalleryItemUpdateResult']: '__union' & GraphQLTypes["GalleryItemUpdateResult"];
	['...on GalleryItemUpsertResult']: '__union' & GraphQLTypes["GalleryItemUpsertResult"];
	['...on JobsFormCreateResult']: '__union' & GraphQLTypes["JobsFormCreateResult"];
	['...on JobsFormDeleteResult']: '__union' & GraphQLTypes["JobsFormDeleteResult"];
	['...on JobsFormUpdateResult']: '__union' & GraphQLTypes["JobsFormUpdateResult"];
	['...on JobsFormUpsertResult']: '__union' & GraphQLTypes["JobsFormUpsertResult"];
	['...on JobsFormLocaleCreateResult']: '__union' & GraphQLTypes["JobsFormLocaleCreateResult"];
	['...on JobsFormLocaleDeleteResult']: '__union' & GraphQLTypes["JobsFormLocaleDeleteResult"];
	['...on JobsFormLocaleUpdateResult']: '__union' & GraphQLTypes["JobsFormLocaleUpdateResult"];
	['...on JobsFormLocaleUpsertResult']: '__union' & GraphQLTypes["JobsFormLocaleUpsertResult"];
	['...on ImageTextItemCreateResult']: '__union' & GraphQLTypes["ImageTextItemCreateResult"];
	['...on ImageTextItemDeleteResult']: '__union' & GraphQLTypes["ImageTextItemDeleteResult"];
	['...on ImageTextItemUpdateResult']: '__union' & GraphQLTypes["ImageTextItemUpdateResult"];
	['...on ImageTextItemUpsertResult']: '__union' & GraphQLTypes["ImageTextItemUpsertResult"];
	['...on ImageTextListCreateResult']: '__union' & GraphQLTypes["ImageTextListCreateResult"];
	['...on ImageTextListDeleteResult']: '__union' & GraphQLTypes["ImageTextListDeleteResult"];
	['...on ImageTextListUpdateResult']: '__union' & GraphQLTypes["ImageTextListUpdateResult"];
	['...on ImageTextListUpsertResult']: '__union' & GraphQLTypes["ImageTextListUpsertResult"];
	['...on JobsFilterCreateResult']: '__union' & GraphQLTypes["JobsFilterCreateResult"];
	['...on JobsFilterDeleteResult']: '__union' & GraphQLTypes["JobsFilterDeleteResult"];
	['...on JobsFilterUpdateResult']: '__union' & GraphQLTypes["JobsFilterUpdateResult"];
	['...on JobsFilterUpsertResult']: '__union' & GraphQLTypes["JobsFilterUpsertResult"];
	['...on JobsFilterLocaleCreateResult']: '__union' & GraphQLTypes["JobsFilterLocaleCreateResult"];
	['...on JobsFilterLocaleDeleteResult']: '__union' & GraphQLTypes["JobsFilterLocaleDeleteResult"];
	['...on JobsFilterLocaleUpdateResult']: '__union' & GraphQLTypes["JobsFilterLocaleUpdateResult"];
	['...on JobsFilterLocaleUpsertResult']: '__union' & GraphQLTypes["JobsFilterLocaleUpsertResult"];
	['...on FileCreateResult']: '__union' & GraphQLTypes["FileCreateResult"];
	['...on FileDeleteResult']: '__union' & GraphQLTypes["FileDeleteResult"];
	['...on FileUpdateResult']: '__union' & GraphQLTypes["FileUpdateResult"];
	['...on FileUpsertResult']: '__union' & GraphQLTypes["FileUpsertResult"];
	['...on JobFormSubscriptionCreateResult']: '__union' & GraphQLTypes["JobFormSubscriptionCreateResult"];
	['...on JobFormSubscriptionDeleteResult']: '__union' & GraphQLTypes["JobFormSubscriptionDeleteResult"];
	['...on JobFormSubscriptionUpdateResult']: '__union' & GraphQLTypes["JobFormSubscriptionUpdateResult"];
	['...on JobFormSubscriptionUpsertResult']: '__union' & GraphQLTypes["JobFormSubscriptionUpsertResult"];
	['...on ImageListCreateResult']: '__union' & GraphQLTypes["ImageListCreateResult"];
	['...on ImageListDeleteResult']: '__union' & GraphQLTypes["ImageListDeleteResult"];
	['...on ImageListUpdateResult']: '__union' & GraphQLTypes["ImageListUpdateResult"];
	['...on ImageListUpsertResult']: '__union' & GraphQLTypes["ImageListUpsertResult"];
	['...on ImageListItemCreateResult']: '__union' & GraphQLTypes["ImageListItemCreateResult"];
	['...on ImageListItemDeleteResult']: '__union' & GraphQLTypes["ImageListItemDeleteResult"];
	['...on ImageListItemUpdateResult']: '__union' & GraphQLTypes["ImageListItemUpdateResult"];
	['...on ImageListItemUpsertResult']: '__union' & GraphQLTypes["ImageListItemUpsertResult"];
	['...on JobFormSubscriptionStatusCreateResult']: '__union' & GraphQLTypes["JobFormSubscriptionStatusCreateResult"];
	['...on JobFormSubscriptionStatusDeleteResult']: '__union' & GraphQLTypes["JobFormSubscriptionStatusDeleteResult"];
	['...on JobFormSubscriptionStatusUpdateResult']: '__union' & GraphQLTypes["JobFormSubscriptionStatusUpdateResult"];
	['...on JobFormSubscriptionStatusUpsertResult']: '__union' & GraphQLTypes["JobFormSubscriptionStatusUpsertResult"];
	['...on GeneralLocaleCreateResult']: '__union' & GraphQLTypes["GeneralLocaleCreateResult"];
	['...on GeneralLocaleDeleteResult']: '__union' & GraphQLTypes["GeneralLocaleDeleteResult"];
	['...on GeneralLocaleUpdateResult']: '__union' & GraphQLTypes["GeneralLocaleUpdateResult"];
	['...on GeneralLocaleUpsertResult']: '__union' & GraphQLTypes["GeneralLocaleUpsertResult"];
	['...on StickyBarCreateResult']: '__union' & GraphQLTypes["StickyBarCreateResult"];
	['...on StickyBarDeleteResult']: '__union' & GraphQLTypes["StickyBarDeleteResult"];
	['...on StickyBarUpdateResult']: '__union' & GraphQLTypes["StickyBarUpdateResult"];
	['...on StickyBarUpsertResult']: '__union' & GraphQLTypes["StickyBarUpsertResult"];
	['...on RecommendationFormCreateResult']: '__union' & GraphQLTypes["RecommendationFormCreateResult"];
	['...on RecommendationFormDeleteResult']: '__union' & GraphQLTypes["RecommendationFormDeleteResult"];
	['...on RecommendationFormUpdateResult']: '__union' & GraphQLTypes["RecommendationFormUpdateResult"];
	['...on RecommendationFormUpsertResult']: '__union' & GraphQLTypes["RecommendationFormUpsertResult"];
	['...on RecommendationFormLocaleCreateResult']: '__union' & GraphQLTypes["RecommendationFormLocaleCreateResult"];
	['...on RecommendationFormLocaleDeleteResult']: '__union' & GraphQLTypes["RecommendationFormLocaleDeleteResult"];
	['...on RecommendationFormLocaleUpdateResult']: '__union' & GraphQLTypes["RecommendationFormLocaleUpdateResult"];
	['...on RecommendationFormLocaleUpsertResult']: '__union' & GraphQLTypes["RecommendationFormLocaleUpsertResult"];
	['...on RecommendationFormSubscriptionCreateResult']: '__union' & GraphQLTypes["RecommendationFormSubscriptionCreateResult"];
	['...on RecommendationFormSubscriptionDeleteResult']: '__union' & GraphQLTypes["RecommendationFormSubscriptionDeleteResult"];
	['...on RecommendationFormSubscriptionUpdateResult']: '__union' & GraphQLTypes["RecommendationFormSubscriptionUpdateResult"];
	['...on RecommendationFormSubscriptionUpsertResult']: '__union' & GraphQLTypes["RecommendationFormSubscriptionUpsertResult"];
	['...on InfoBoxCreateResult']: '__union' & GraphQLTypes["InfoBoxCreateResult"];
	['...on InfoBoxDeleteResult']: '__union' & GraphQLTypes["InfoBoxDeleteResult"];
	['...on InfoBoxUpdateResult']: '__union' & GraphQLTypes["InfoBoxUpdateResult"];
	['...on InfoBoxUpsertResult']: '__union' & GraphQLTypes["InfoBoxUpsertResult"];
	['...on InfoBoxLocaleCreateResult']: '__union' & GraphQLTypes["InfoBoxLocaleCreateResult"];
	['...on InfoBoxLocaleDeleteResult']: '__union' & GraphQLTypes["InfoBoxLocaleDeleteResult"];
	['...on InfoBoxLocaleUpdateResult']: '__union' & GraphQLTypes["InfoBoxLocaleUpdateResult"];
	['...on InfoBoxLocaleUpsertResult']: '__union' & GraphQLTypes["InfoBoxLocaleUpsertResult"];
	['...on TranslationCreateResult']: '__union' & GraphQLTypes["TranslationCreateResult"];
	['...on TranslationDeleteResult']: '__union' & GraphQLTypes["TranslationDeleteResult"];
	['...on TranslationUpdateResult']: '__union' & GraphQLTypes["TranslationUpdateResult"];
	['...on TranslationUpsertResult']: '__union' & GraphQLTypes["TranslationUpsertResult"];
	['...on TranslationLocaleCreateResult']: '__union' & GraphQLTypes["TranslationLocaleCreateResult"];
	['...on TranslationLocaleDeleteResult']: '__union' & GraphQLTypes["TranslationLocaleDeleteResult"];
	['...on TranslationLocaleUpdateResult']: '__union' & GraphQLTypes["TranslationLocaleUpdateResult"];
	['...on TranslationLocaleUpsertResult']: '__union' & GraphQLTypes["TranslationLocaleUpsertResult"];
	['...on CornerBannerCreateResult']: '__union' & GraphQLTypes["CornerBannerCreateResult"];
	['...on CornerBannerDeleteResult']: '__union' & GraphQLTypes["CornerBannerDeleteResult"];
	['...on CornerBannerUpdateResult']: '__union' & GraphQLTypes["CornerBannerUpdateResult"];
	['...on CornerBannerUpsertResult']: '__union' & GraphQLTypes["CornerBannerUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<Array<GraphQLTypes["_PathFragment"]>>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string | undefined
};
	["_MutationErrorType"]: _MutationErrorType;
	["GeneralDeleteResult"]: {
	__typename: "GeneralDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["General"] | undefined
};
	["GeneralUpdateResult"]: {
	__typename: "GeneralUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["General"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GeneralUpsertResult"]: {
	__typename: "GeneralUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["General"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageCreateResult"]: {
	__typename: "GenericPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageDeleteResult"]: {
	__typename: "GenericPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"] | undefined
};
	["GenericPageUpdateResult"]: {
	__typename: "GenericPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageUpsertResult"]: {
	__typename: "GenericPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
	__typename: "ContentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
	__typename: "ContentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined
};
	["ContentUpdateResult"]: {
	__typename: "ContentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
	__typename: "ContentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
	__typename: "ContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
	__typename: "ContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined
};
	["ContentReferenceUpdateResult"]: {
	__typename: "ContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
	__typename: "ContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
	__typename: "RedirectCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
	__typename: "RedirectDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined
};
	["RedirectUpdateResult"]: {
	__typename: "RedirectUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
	__typename: "RedirectUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
	__typename: "FooterCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
	__typename: "FooterDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"] | undefined
};
	["FooterUpdateResult"]: {
	__typename: "FooterUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
	__typename: "FooterUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkCreateResult"]: {
	__typename: "FooterLinkCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkDeleteResult"]: {
	__typename: "FooterLinkDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"] | undefined
};
	["FooterLinkUpdateResult"]: {
	__typename: "FooterLinkUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkUpsertResult"]: {
	__typename: "FooterLinkUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleCreateResult"]: {
	__typename: "FooterLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleDeleteResult"]: {
	__typename: "FooterLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"] | undefined
};
	["FooterLocaleUpdateResult"]: {
	__typename: "FooterLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleUpsertResult"]: {
	__typename: "FooterLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageLocaleCreateResult"]: {
	__typename: "GenericPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageLocaleDeleteResult"]: {
	__typename: "GenericPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageLocale"] | undefined
};
	["GenericPageLocaleUpdateResult"]: {
	__typename: "GenericPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageLocaleUpsertResult"]: {
	__typename: "GenericPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
	__typename: "HeaderCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
	__typename: "HeaderDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"] | undefined
};
	["HeaderUpdateResult"]: {
	__typename: "HeaderUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
	__typename: "HeaderUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleCreateResult"]: {
	__typename: "HeaderLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleDeleteResult"]: {
	__typename: "HeaderLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"] | undefined
};
	["HeaderLocaleUpdateResult"]: {
	__typename: "HeaderLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleUpsertResult"]: {
	__typename: "HeaderLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
	__typename: "LocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
	__typename: "LocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined
};
	["LocaleUpdateResult"]: {
	__typename: "LocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
	__typename: "LocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultCreateResult"]: {
	__typename: "SeoDefaultCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefault"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultDeleteResult"]: {
	__typename: "SeoDefaultDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefault"] | undefined
};
	["SeoDefaultUpdateResult"]: {
	__typename: "SeoDefaultUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefault"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultUpsertResult"]: {
	__typename: "SeoDefaultUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefault"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultLocaleCreateResult"]: {
	__typename: "SeoDefaultLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefaultLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultLocaleDeleteResult"]: {
	__typename: "SeoDefaultLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefaultLocale"] | undefined
};
	["SeoDefaultLocaleUpdateResult"]: {
	__typename: "SeoDefaultLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefaultLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultLocaleUpsertResult"]: {
	__typename: "SeoDefaultLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefaultLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCreateResult"]: {
	__typename: "BusinessCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Business"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessDeleteResult"]: {
	__typename: "BusinessDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Business"] | undefined
};
	["BusinessUpdateResult"]: {
	__typename: "BusinessUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Business"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessUpsertResult"]: {
	__typename: "BusinessUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Business"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessPageCreateResult"]: {
	__typename: "BusinessPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessPageDeleteResult"]: {
	__typename: "BusinessPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessPage"] | undefined
};
	["BusinessPageUpdateResult"]: {
	__typename: "BusinessPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessPageUpsertResult"]: {
	__typename: "BusinessPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessPageLocaleCreateResult"]: {
	__typename: "BusinessPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessPageLocaleDeleteResult"]: {
	__typename: "BusinessPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessPageLocale"] | undefined
};
	["BusinessPageLocaleUpdateResult"]: {
	__typename: "BusinessPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessPageLocaleUpsertResult"]: {
	__typename: "BusinessPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IconCreateResult"]: {
	__typename: "IconCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Icon"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IconDeleteResult"]: {
	__typename: "IconDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Icon"] | undefined
};
	["IconUpdateResult"]: {
	__typename: "IconUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Icon"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IconUpsertResult"]: {
	__typename: "IconUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Icon"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPageCreateResult"]: {
	__typename: "JobPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPageDeleteResult"]: {
	__typename: "JobPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPage"] | undefined
};
	["JobPageUpdateResult"]: {
	__typename: "JobPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPageUpsertResult"]: {
	__typename: "JobPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPageLocaleCreateResult"]: {
	__typename: "JobPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPageLocaleDeleteResult"]: {
	__typename: "JobPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPageLocale"] | undefined
};
	["JobPageLocaleUpdateResult"]: {
	__typename: "JobPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPageLocaleUpsertResult"]: {
	__typename: "JobPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["KeyInfoItemCreateResult"]: {
	__typename: "KeyInfoItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["KeyInfoItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["KeyInfoItemDeleteResult"]: {
	__typename: "KeyInfoItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["KeyInfoItem"] | undefined
};
	["KeyInfoItemUpdateResult"]: {
	__typename: "KeyInfoItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["KeyInfoItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["KeyInfoItemUpsertResult"]: {
	__typename: "KeyInfoItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["KeyInfoItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["KeyInfoListCreateResult"]: {
	__typename: "KeyInfoListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["KeyInfoList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["KeyInfoListDeleteResult"]: {
	__typename: "KeyInfoListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["KeyInfoList"] | undefined
};
	["KeyInfoListUpdateResult"]: {
	__typename: "KeyInfoListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["KeyInfoList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["KeyInfoListUpsertResult"]: {
	__typename: "KeyInfoListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["KeyInfoList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContractTypeCreateResult"]: {
	__typename: "ContractTypeCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContractType"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContractTypeDeleteResult"]: {
	__typename: "ContractTypeDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContractType"] | undefined
};
	["ContractTypeUpdateResult"]: {
	__typename: "ContractTypeUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContractType"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContractTypeUpsertResult"]: {
	__typename: "ContractTypeUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContractType"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContractTypeLocaleCreateResult"]: {
	__typename: "ContractTypeLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContractTypeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContractTypeLocaleDeleteResult"]: {
	__typename: "ContractTypeLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContractTypeLocale"] | undefined
};
	["ContractTypeLocaleUpdateResult"]: {
	__typename: "ContractTypeLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContractTypeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContractTypeLocaleUpsertResult"]: {
	__typename: "ContractTypeLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContractTypeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobCityCreateResult"]: {
	__typename: "JobCityCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobCity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobCityDeleteResult"]: {
	__typename: "JobCityDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobCity"] | undefined
};
	["JobCityUpdateResult"]: {
	__typename: "JobCityUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobCity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobCityUpsertResult"]: {
	__typename: "JobCityUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobCity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobCityLocaleCreateResult"]: {
	__typename: "JobCityLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobCityLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobCityLocaleDeleteResult"]: {
	__typename: "JobCityLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobCityLocale"] | undefined
};
	["JobCityLocaleUpdateResult"]: {
	__typename: "JobCityLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobCityLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobCityLocaleUpsertResult"]: {
	__typename: "JobCityLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobCityLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPositionCreateResult"]: {
	__typename: "JobPositionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPosition"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPositionDeleteResult"]: {
	__typename: "JobPositionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPosition"] | undefined
};
	["JobPositionUpdateResult"]: {
	__typename: "JobPositionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPosition"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPositionUpsertResult"]: {
	__typename: "JobPositionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPosition"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPositionLocaleCreateResult"]: {
	__typename: "JobPositionLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPositionLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPositionLocaleDeleteResult"]: {
	__typename: "JobPositionLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPositionLocale"] | undefined
};
	["JobPositionLocaleUpdateResult"]: {
	__typename: "JobPositionLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPositionLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobPositionLocaleUpsertResult"]: {
	__typename: "JobPositionLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobPositionLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
	__typename: "GalleryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
	__typename: "GalleryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined
};
	["GalleryUpdateResult"]: {
	__typename: "GalleryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
	__typename: "GalleryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
	__typename: "HomePageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
	__typename: "HomePageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"] | undefined
};
	["HomePageUpdateResult"]: {
	__typename: "HomePageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
	__typename: "HomePageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLocaleCreateResult"]: {
	__typename: "HomePageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLocaleDeleteResult"]: {
	__typename: "HomePageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLocale"] | undefined
};
	["HomePageLocaleUpdateResult"]: {
	__typename: "HomePageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLocaleUpsertResult"]: {
	__typename: "HomePageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
	__typename: "MediumCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
	__typename: "MediumDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined
};
	["MediumUpdateResult"]: {
	__typename: "MediumUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
	__typename: "MediumUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumItemCreateResult"]: {
	__typename: "MediumItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumItemDeleteResult"]: {
	__typename: "MediumItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"] | undefined
};
	["MediumItemUpdateResult"]: {
	__typename: "MediumItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumItemUpsertResult"]: {
	__typename: "MediumItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumListCreateResult"]: {
	__typename: "MediumListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumListDeleteResult"]: {
	__typename: "MediumListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"] | undefined
};
	["MediumListUpdateResult"]: {
	__typename: "MediumListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumListUpsertResult"]: {
	__typename: "MediumListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
	__typename: "VideoCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
	__typename: "VideoDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined
};
	["VideoUpdateResult"]: {
	__typename: "VideoUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
	__typename: "VideoUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemCreateResult"]: {
	__typename: "TextItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemDeleteResult"]: {
	__typename: "TextItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined
};
	["TextItemUpdateResult"]: {
	__typename: "TextItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemUpsertResult"]: {
	__typename: "TextItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListCreateResult"]: {
	__typename: "TextListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListDeleteResult"]: {
	__typename: "TextListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined
};
	["TextListUpdateResult"]: {
	__typename: "TextListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListUpsertResult"]: {
	__typename: "TextListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CarouselCreateResult"]: {
	__typename: "CarouselCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Carousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CarouselDeleteResult"]: {
	__typename: "CarouselDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Carousel"] | undefined
};
	["CarouselUpdateResult"]: {
	__typename: "CarouselUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Carousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CarouselUpsertResult"]: {
	__typename: "CarouselUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Carousel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CarouselItemCreateResult"]: {
	__typename: "CarouselItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CarouselItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CarouselItemDeleteResult"]: {
	__typename: "CarouselItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CarouselItem"] | undefined
};
	["CarouselItemUpdateResult"]: {
	__typename: "CarouselItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CarouselItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CarouselItemUpsertResult"]: {
	__typename: "CarouselItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CarouselItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ThemeCreateResult"]: {
	__typename: "ThemeCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Theme"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ThemeDeleteResult"]: {
	__typename: "ThemeDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Theme"] | undefined
};
	["ThemeUpdateResult"]: {
	__typename: "ThemeUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Theme"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ThemeUpsertResult"]: {
	__typename: "ThemeUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Theme"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BonusBannerCreateResult"]: {
	__typename: "BonusBannerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BonusBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BonusBannerDeleteResult"]: {
	__typename: "BonusBannerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BonusBanner"] | undefined
};
	["BonusBannerUpdateResult"]: {
	__typename: "BonusBannerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BonusBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BonusBannerUpsertResult"]: {
	__typename: "BonusBannerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BonusBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BonusBannerLocaleCreateResult"]: {
	__typename: "BonusBannerLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BonusBannerLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BonusBannerLocaleDeleteResult"]: {
	__typename: "BonusBannerLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BonusBannerLocale"] | undefined
};
	["BonusBannerLocaleUpdateResult"]: {
	__typename: "BonusBannerLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BonusBannerLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BonusBannerLocaleUpsertResult"]: {
	__typename: "BonusBannerLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BonusBannerLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TileCreateResult"]: {
	__typename: "TileCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TileDeleteResult"]: {
	__typename: "TileDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tile"] | undefined
};
	["TileUpdateResult"]: {
	__typename: "TileUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TileUpsertResult"]: {
	__typename: "TileUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SideBySideCreateResult"]: {
	__typename: "SideBySideCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SideBySide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SideBySideDeleteResult"]: {
	__typename: "SideBySideDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SideBySide"] | undefined
};
	["SideBySideUpdateResult"]: {
	__typename: "SideBySideUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SideBySide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SideBySideUpsertResult"]: {
	__typename: "SideBySideUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SideBySide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SideBySideItemCreateResult"]: {
	__typename: "SideBySideItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SideBySideItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SideBySideItemDeleteResult"]: {
	__typename: "SideBySideItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SideBySideItem"] | undefined
};
	["SideBySideItemUpdateResult"]: {
	__typename: "SideBySideItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SideBySideItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SideBySideItemUpsertResult"]: {
	__typename: "SideBySideItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SideBySideItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLokalCreateResult"]: {
	__typename: "HomePageLokalCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLokal"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLokalDeleteResult"]: {
	__typename: "HomePageLokalDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLokal"] | undefined
};
	["HomePageLokalUpdateResult"]: {
	__typename: "HomePageLokalUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLokal"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLokalUpsertResult"]: {
	__typename: "HomePageLokalUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLokal"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLokalLocaleCreateResult"]: {
	__typename: "HomePageLokalLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLokalLocaleDeleteResult"]: {
	__typename: "HomePageLokalLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLokalLocale"] | undefined
};
	["HomePageLokalLocaleUpdateResult"]: {
	__typename: "HomePageLokalLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLokalLocaleUpsertResult"]: {
	__typename: "HomePageLokalLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLokalLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteSwitcherCreateResult"]: {
	__typename: "SiteSwitcherCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteSwitcher"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteSwitcherDeleteResult"]: {
	__typename: "SiteSwitcherDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteSwitcher"] | undefined
};
	["SiteSwitcherUpdateResult"]: {
	__typename: "SiteSwitcherUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteSwitcher"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteSwitcherUpsertResult"]: {
	__typename: "SiteSwitcherUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteSwitcher"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
	__typename: "GalleryItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
	__typename: "GalleryItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined
};
	["GalleryItemUpdateResult"]: {
	__typename: "GalleryItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
	__typename: "GalleryItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFormCreateResult"]: {
	__typename: "JobsFormCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFormDeleteResult"]: {
	__typename: "JobsFormDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsForm"] | undefined
};
	["JobsFormUpdateResult"]: {
	__typename: "JobsFormUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFormUpsertResult"]: {
	__typename: "JobsFormUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFormLocaleCreateResult"]: {
	__typename: "JobsFormLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFormLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFormLocaleDeleteResult"]: {
	__typename: "JobsFormLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFormLocale"] | undefined
};
	["JobsFormLocaleUpdateResult"]: {
	__typename: "JobsFormLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFormLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFormLocaleUpsertResult"]: {
	__typename: "JobsFormLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFormLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageTextItemCreateResult"]: {
	__typename: "ImageTextItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageTextItemDeleteResult"]: {
	__typename: "ImageTextItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTextItem"] | undefined
};
	["ImageTextItemUpdateResult"]: {
	__typename: "ImageTextItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageTextItemUpsertResult"]: {
	__typename: "ImageTextItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageTextListCreateResult"]: {
	__typename: "ImageTextListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageTextListDeleteResult"]: {
	__typename: "ImageTextListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTextList"] | undefined
};
	["ImageTextListUpdateResult"]: {
	__typename: "ImageTextListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageTextListUpsertResult"]: {
	__typename: "ImageTextListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFilterCreateResult"]: {
	__typename: "JobsFilterCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFilter"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFilterDeleteResult"]: {
	__typename: "JobsFilterDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFilter"] | undefined
};
	["JobsFilterUpdateResult"]: {
	__typename: "JobsFilterUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFilter"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFilterUpsertResult"]: {
	__typename: "JobsFilterUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFilter"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFilterLocaleCreateResult"]: {
	__typename: "JobsFilterLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFilterLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFilterLocaleDeleteResult"]: {
	__typename: "JobsFilterLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFilterLocale"] | undefined
};
	["JobsFilterLocaleUpdateResult"]: {
	__typename: "JobsFilterLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFilterLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobsFilterLocaleUpsertResult"]: {
	__typename: "JobsFilterLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobsFilterLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileCreateResult"]: {
	__typename: "FileCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileDeleteResult"]: {
	__typename: "FileDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined
};
	["FileUpdateResult"]: {
	__typename: "FileUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileUpsertResult"]: {
	__typename: "FileUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobFormSubscriptionCreateResult"]: {
	__typename: "JobFormSubscriptionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobFormSubscription"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobFormSubscriptionDeleteResult"]: {
	__typename: "JobFormSubscriptionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobFormSubscription"] | undefined
};
	["JobFormSubscriptionUpdateResult"]: {
	__typename: "JobFormSubscriptionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobFormSubscription"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobFormSubscriptionUpsertResult"]: {
	__typename: "JobFormSubscriptionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobFormSubscription"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListCreateResult"]: {
	__typename: "ImageListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListDeleteResult"]: {
	__typename: "ImageListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined
};
	["ImageListUpdateResult"]: {
	__typename: "ImageListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListUpsertResult"]: {
	__typename: "ImageListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemCreateResult"]: {
	__typename: "ImageListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemDeleteResult"]: {
	__typename: "ImageListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined
};
	["ImageListItemUpdateResult"]: {
	__typename: "ImageListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemUpsertResult"]: {
	__typename: "ImageListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobFormSubscriptionStatusCreateResult"]: {
	__typename: "JobFormSubscriptionStatusCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobFormSubscriptionStatus"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobFormSubscriptionStatusDeleteResult"]: {
	__typename: "JobFormSubscriptionStatusDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobFormSubscriptionStatus"] | undefined
};
	["JobFormSubscriptionStatusUpdateResult"]: {
	__typename: "JobFormSubscriptionStatusUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobFormSubscriptionStatus"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["JobFormSubscriptionStatusUpsertResult"]: {
	__typename: "JobFormSubscriptionStatusUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["JobFormSubscriptionStatus"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GeneralLocaleCreateResult"]: {
	__typename: "GeneralLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GeneralLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GeneralLocaleDeleteResult"]: {
	__typename: "GeneralLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GeneralLocale"] | undefined
};
	["GeneralLocaleUpdateResult"]: {
	__typename: "GeneralLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GeneralLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GeneralLocaleUpsertResult"]: {
	__typename: "GeneralLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GeneralLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StickyBarCreateResult"]: {
	__typename: "StickyBarCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StickyBar"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StickyBarDeleteResult"]: {
	__typename: "StickyBarDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StickyBar"] | undefined
};
	["StickyBarUpdateResult"]: {
	__typename: "StickyBarUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StickyBar"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StickyBarUpsertResult"]: {
	__typename: "StickyBarUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StickyBar"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecommendationFormCreateResult"]: {
	__typename: "RecommendationFormCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecommendationFormDeleteResult"]: {
	__typename: "RecommendationFormDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationForm"] | undefined
};
	["RecommendationFormUpdateResult"]: {
	__typename: "RecommendationFormUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecommendationFormUpsertResult"]: {
	__typename: "RecommendationFormUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecommendationFormLocaleCreateResult"]: {
	__typename: "RecommendationFormLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationFormLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecommendationFormLocaleDeleteResult"]: {
	__typename: "RecommendationFormLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationFormLocale"] | undefined
};
	["RecommendationFormLocaleUpdateResult"]: {
	__typename: "RecommendationFormLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationFormLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecommendationFormLocaleUpsertResult"]: {
	__typename: "RecommendationFormLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationFormLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecommendationFormSubscriptionCreateResult"]: {
	__typename: "RecommendationFormSubscriptionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationFormSubscription"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecommendationFormSubscriptionDeleteResult"]: {
	__typename: "RecommendationFormSubscriptionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationFormSubscription"] | undefined
};
	["RecommendationFormSubscriptionUpdateResult"]: {
	__typename: "RecommendationFormSubscriptionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationFormSubscription"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RecommendationFormSubscriptionUpsertResult"]: {
	__typename: "RecommendationFormSubscriptionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RecommendationFormSubscription"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoBoxCreateResult"]: {
	__typename: "InfoBoxCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoBox"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoBoxDeleteResult"]: {
	__typename: "InfoBoxDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoBox"] | undefined
};
	["InfoBoxUpdateResult"]: {
	__typename: "InfoBoxUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoBox"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoBoxUpsertResult"]: {
	__typename: "InfoBoxUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoBox"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoBoxLocaleCreateResult"]: {
	__typename: "InfoBoxLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoBoxLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoBoxLocaleDeleteResult"]: {
	__typename: "InfoBoxLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoBoxLocale"] | undefined
};
	["InfoBoxLocaleUpdateResult"]: {
	__typename: "InfoBoxLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoBoxLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoBoxLocaleUpsertResult"]: {
	__typename: "InfoBoxLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoBoxLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCreateResult"]: {
	__typename: "TranslationCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Translation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDeleteResult"]: {
	__typename: "TranslationDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Translation"] | undefined
};
	["TranslationUpdateResult"]: {
	__typename: "TranslationUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Translation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationUpsertResult"]: {
	__typename: "TranslationUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Translation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationLocaleCreateResult"]: {
	__typename: "TranslationLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationLocaleDeleteResult"]: {
	__typename: "TranslationLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationLocale"] | undefined
};
	["TranslationLocaleUpdateResult"]: {
	__typename: "TranslationLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationLocaleUpsertResult"]: {
	__typename: "TranslationLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CornerBannerCreateResult"]: {
	__typename: "CornerBannerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CornerBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CornerBannerDeleteResult"]: {
	__typename: "CornerBannerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CornerBanner"] | undefined
};
	["CornerBannerUpdateResult"]: {
	__typename: "CornerBannerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CornerBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CornerBannerUpsertResult"]: {
	__typename: "CornerBannerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CornerBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"],
	createGeneral: GraphQLTypes["GeneralCreateResult"],
	deleteGeneral: GraphQLTypes["GeneralDeleteResult"],
	updateGeneral: GraphQLTypes["GeneralUpdateResult"],
	upsertGeneral: GraphQLTypes["GeneralUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createGenericPage: GraphQLTypes["GenericPageCreateResult"],
	deleteGenericPage: GraphQLTypes["GenericPageDeleteResult"],
	updateGenericPage: GraphQLTypes["GenericPageUpdateResult"],
	upsertGenericPage: GraphQLTypes["GenericPageUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterLink: GraphQLTypes["FooterLinkCreateResult"],
	deleteFooterLink: GraphQLTypes["FooterLinkDeleteResult"],
	updateFooterLink: GraphQLTypes["FooterLinkUpdateResult"],
	upsertFooterLink: GraphQLTypes["FooterLinkUpsertResult"],
	createFooterLocale: GraphQLTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: GraphQLTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: GraphQLTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: GraphQLTypes["FooterLocaleUpsertResult"],
	createGenericPageLocale: GraphQLTypes["GenericPageLocaleCreateResult"],
	deleteGenericPageLocale: GraphQLTypes["GenericPageLocaleDeleteResult"],
	updateGenericPageLocale: GraphQLTypes["GenericPageLocaleUpdateResult"],
	upsertGenericPageLocale: GraphQLTypes["GenericPageLocaleUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHeaderLocale: GraphQLTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: GraphQLTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: GraphQLTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: GraphQLTypes["HeaderLocaleUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createSeoDefault: GraphQLTypes["SeoDefaultCreateResult"],
	deleteSeoDefault: GraphQLTypes["SeoDefaultDeleteResult"],
	updateSeoDefault: GraphQLTypes["SeoDefaultUpdateResult"],
	upsertSeoDefault: GraphQLTypes["SeoDefaultUpsertResult"],
	createSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleCreateResult"],
	deleteSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleDeleteResult"],
	updateSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleUpdateResult"],
	upsertSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleUpsertResult"],
	createBusiness: GraphQLTypes["BusinessCreateResult"],
	deleteBusiness: GraphQLTypes["BusinessDeleteResult"],
	updateBusiness: GraphQLTypes["BusinessUpdateResult"],
	upsertBusiness: GraphQLTypes["BusinessUpsertResult"],
	createBusinessPage: GraphQLTypes["BusinessPageCreateResult"],
	deleteBusinessPage: GraphQLTypes["BusinessPageDeleteResult"],
	updateBusinessPage: GraphQLTypes["BusinessPageUpdateResult"],
	upsertBusinessPage: GraphQLTypes["BusinessPageUpsertResult"],
	createBusinessPageLocale: GraphQLTypes["BusinessPageLocaleCreateResult"],
	deleteBusinessPageLocale: GraphQLTypes["BusinessPageLocaleDeleteResult"],
	updateBusinessPageLocale: GraphQLTypes["BusinessPageLocaleUpdateResult"],
	upsertBusinessPageLocale: GraphQLTypes["BusinessPageLocaleUpsertResult"],
	createIcon: GraphQLTypes["IconCreateResult"],
	deleteIcon: GraphQLTypes["IconDeleteResult"],
	updateIcon: GraphQLTypes["IconUpdateResult"],
	upsertIcon: GraphQLTypes["IconUpsertResult"],
	createJobPage: GraphQLTypes["JobPageCreateResult"],
	deleteJobPage: GraphQLTypes["JobPageDeleteResult"],
	updateJobPage: GraphQLTypes["JobPageUpdateResult"],
	upsertJobPage: GraphQLTypes["JobPageUpsertResult"],
	createJobPageLocale: GraphQLTypes["JobPageLocaleCreateResult"],
	deleteJobPageLocale: GraphQLTypes["JobPageLocaleDeleteResult"],
	updateJobPageLocale: GraphQLTypes["JobPageLocaleUpdateResult"],
	upsertJobPageLocale: GraphQLTypes["JobPageLocaleUpsertResult"],
	createKeyInfoItem: GraphQLTypes["KeyInfoItemCreateResult"],
	deleteKeyInfoItem: GraphQLTypes["KeyInfoItemDeleteResult"],
	updateKeyInfoItem: GraphQLTypes["KeyInfoItemUpdateResult"],
	upsertKeyInfoItem: GraphQLTypes["KeyInfoItemUpsertResult"],
	createKeyInfoList: GraphQLTypes["KeyInfoListCreateResult"],
	deleteKeyInfoList: GraphQLTypes["KeyInfoListDeleteResult"],
	updateKeyInfoList: GraphQLTypes["KeyInfoListUpdateResult"],
	upsertKeyInfoList: GraphQLTypes["KeyInfoListUpsertResult"],
	createContractType: GraphQLTypes["ContractTypeCreateResult"],
	deleteContractType: GraphQLTypes["ContractTypeDeleteResult"],
	updateContractType: GraphQLTypes["ContractTypeUpdateResult"],
	upsertContractType: GraphQLTypes["ContractTypeUpsertResult"],
	createContractTypeLocale: GraphQLTypes["ContractTypeLocaleCreateResult"],
	deleteContractTypeLocale: GraphQLTypes["ContractTypeLocaleDeleteResult"],
	updateContractTypeLocale: GraphQLTypes["ContractTypeLocaleUpdateResult"],
	upsertContractTypeLocale: GraphQLTypes["ContractTypeLocaleUpsertResult"],
	createJobCity: GraphQLTypes["JobCityCreateResult"],
	deleteJobCity: GraphQLTypes["JobCityDeleteResult"],
	updateJobCity: GraphQLTypes["JobCityUpdateResult"],
	upsertJobCity: GraphQLTypes["JobCityUpsertResult"],
	createJobCityLocale: GraphQLTypes["JobCityLocaleCreateResult"],
	deleteJobCityLocale: GraphQLTypes["JobCityLocaleDeleteResult"],
	updateJobCityLocale: GraphQLTypes["JobCityLocaleUpdateResult"],
	upsertJobCityLocale: GraphQLTypes["JobCityLocaleUpsertResult"],
	createJobPosition: GraphQLTypes["JobPositionCreateResult"],
	deleteJobPosition: GraphQLTypes["JobPositionDeleteResult"],
	updateJobPosition: GraphQLTypes["JobPositionUpdateResult"],
	upsertJobPosition: GraphQLTypes["JobPositionUpsertResult"],
	createJobPositionLocale: GraphQLTypes["JobPositionLocaleCreateResult"],
	deleteJobPositionLocale: GraphQLTypes["JobPositionLocaleDeleteResult"],
	updateJobPositionLocale: GraphQLTypes["JobPositionLocaleUpdateResult"],
	upsertJobPositionLocale: GraphQLTypes["JobPositionLocaleUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createHomePageLocale: GraphQLTypes["HomePageLocaleCreateResult"],
	deleteHomePageLocale: GraphQLTypes["HomePageLocaleDeleteResult"],
	updateHomePageLocale: GraphQLTypes["HomePageLocaleUpdateResult"],
	upsertHomePageLocale: GraphQLTypes["HomePageLocaleUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createMediumItem: GraphQLTypes["MediumItemCreateResult"],
	deleteMediumItem: GraphQLTypes["MediumItemDeleteResult"],
	updateMediumItem: GraphQLTypes["MediumItemUpdateResult"],
	upsertMediumItem: GraphQLTypes["MediumItemUpsertResult"],
	createMediumList: GraphQLTypes["MediumListCreateResult"],
	deleteMediumList: GraphQLTypes["MediumListDeleteResult"],
	updateMediumList: GraphQLTypes["MediumListUpdateResult"],
	upsertMediumList: GraphQLTypes["MediumListUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createTextItem: GraphQLTypes["TextItemCreateResult"],
	deleteTextItem: GraphQLTypes["TextItemDeleteResult"],
	updateTextItem: GraphQLTypes["TextItemUpdateResult"],
	upsertTextItem: GraphQLTypes["TextItemUpsertResult"],
	createTextList: GraphQLTypes["TextListCreateResult"],
	deleteTextList: GraphQLTypes["TextListDeleteResult"],
	updateTextList: GraphQLTypes["TextListUpdateResult"],
	upsertTextList: GraphQLTypes["TextListUpsertResult"],
	createCarousel: GraphQLTypes["CarouselCreateResult"],
	deleteCarousel: GraphQLTypes["CarouselDeleteResult"],
	updateCarousel: GraphQLTypes["CarouselUpdateResult"],
	upsertCarousel: GraphQLTypes["CarouselUpsertResult"],
	createCarouselItem: GraphQLTypes["CarouselItemCreateResult"],
	deleteCarouselItem: GraphQLTypes["CarouselItemDeleteResult"],
	updateCarouselItem: GraphQLTypes["CarouselItemUpdateResult"],
	upsertCarouselItem: GraphQLTypes["CarouselItemUpsertResult"],
	createTheme: GraphQLTypes["ThemeCreateResult"],
	deleteTheme: GraphQLTypes["ThemeDeleteResult"],
	updateTheme: GraphQLTypes["ThemeUpdateResult"],
	upsertTheme: GraphQLTypes["ThemeUpsertResult"],
	createBonusBanner: GraphQLTypes["BonusBannerCreateResult"],
	deleteBonusBanner: GraphQLTypes["BonusBannerDeleteResult"],
	updateBonusBanner: GraphQLTypes["BonusBannerUpdateResult"],
	upsertBonusBanner: GraphQLTypes["BonusBannerUpsertResult"],
	createBonusBannerLocale: GraphQLTypes["BonusBannerLocaleCreateResult"],
	deleteBonusBannerLocale: GraphQLTypes["BonusBannerLocaleDeleteResult"],
	updateBonusBannerLocale: GraphQLTypes["BonusBannerLocaleUpdateResult"],
	upsertBonusBannerLocale: GraphQLTypes["BonusBannerLocaleUpsertResult"],
	createTile: GraphQLTypes["TileCreateResult"],
	deleteTile: GraphQLTypes["TileDeleteResult"],
	updateTile: GraphQLTypes["TileUpdateResult"],
	upsertTile: GraphQLTypes["TileUpsertResult"],
	createSideBySide: GraphQLTypes["SideBySideCreateResult"],
	deleteSideBySide: GraphQLTypes["SideBySideDeleteResult"],
	updateSideBySide: GraphQLTypes["SideBySideUpdateResult"],
	upsertSideBySide: GraphQLTypes["SideBySideUpsertResult"],
	createSideBySideItem: GraphQLTypes["SideBySideItemCreateResult"],
	deleteSideBySideItem: GraphQLTypes["SideBySideItemDeleteResult"],
	updateSideBySideItem: GraphQLTypes["SideBySideItemUpdateResult"],
	upsertSideBySideItem: GraphQLTypes["SideBySideItemUpsertResult"],
	createHomePageLokal: GraphQLTypes["HomePageLokalCreateResult"],
	deleteHomePageLokal: GraphQLTypes["HomePageLokalDeleteResult"],
	updateHomePageLokal: GraphQLTypes["HomePageLokalUpdateResult"],
	upsertHomePageLokal: GraphQLTypes["HomePageLokalUpsertResult"],
	createHomePageLokalLocale: GraphQLTypes["HomePageLokalLocaleCreateResult"],
	deleteHomePageLokalLocale: GraphQLTypes["HomePageLokalLocaleDeleteResult"],
	updateHomePageLokalLocale: GraphQLTypes["HomePageLokalLocaleUpdateResult"],
	upsertHomePageLokalLocale: GraphQLTypes["HomePageLokalLocaleUpsertResult"],
	createSiteSwitcher: GraphQLTypes["SiteSwitcherCreateResult"],
	deleteSiteSwitcher: GraphQLTypes["SiteSwitcherDeleteResult"],
	updateSiteSwitcher: GraphQLTypes["SiteSwitcherUpdateResult"],
	upsertSiteSwitcher: GraphQLTypes["SiteSwitcherUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createJobsForm: GraphQLTypes["JobsFormCreateResult"],
	deleteJobsForm: GraphQLTypes["JobsFormDeleteResult"],
	updateJobsForm: GraphQLTypes["JobsFormUpdateResult"],
	upsertJobsForm: GraphQLTypes["JobsFormUpsertResult"],
	createJobsFormLocale: GraphQLTypes["JobsFormLocaleCreateResult"],
	deleteJobsFormLocale: GraphQLTypes["JobsFormLocaleDeleteResult"],
	updateJobsFormLocale: GraphQLTypes["JobsFormLocaleUpdateResult"],
	upsertJobsFormLocale: GraphQLTypes["JobsFormLocaleUpsertResult"],
	createImageTextItem: GraphQLTypes["ImageTextItemCreateResult"],
	deleteImageTextItem: GraphQLTypes["ImageTextItemDeleteResult"],
	updateImageTextItem: GraphQLTypes["ImageTextItemUpdateResult"],
	upsertImageTextItem: GraphQLTypes["ImageTextItemUpsertResult"],
	createImageTextList: GraphQLTypes["ImageTextListCreateResult"],
	deleteImageTextList: GraphQLTypes["ImageTextListDeleteResult"],
	updateImageTextList: GraphQLTypes["ImageTextListUpdateResult"],
	upsertImageTextList: GraphQLTypes["ImageTextListUpsertResult"],
	createJobsFilter: GraphQLTypes["JobsFilterCreateResult"],
	deleteJobsFilter: GraphQLTypes["JobsFilterDeleteResult"],
	updateJobsFilter: GraphQLTypes["JobsFilterUpdateResult"],
	upsertJobsFilter: GraphQLTypes["JobsFilterUpsertResult"],
	createJobsFilterLocale: GraphQLTypes["JobsFilterLocaleCreateResult"],
	deleteJobsFilterLocale: GraphQLTypes["JobsFilterLocaleDeleteResult"],
	updateJobsFilterLocale: GraphQLTypes["JobsFilterLocaleUpdateResult"],
	upsertJobsFilterLocale: GraphQLTypes["JobsFilterLocaleUpsertResult"],
	createFile: GraphQLTypes["FileCreateResult"],
	deleteFile: GraphQLTypes["FileDeleteResult"],
	updateFile: GraphQLTypes["FileUpdateResult"],
	upsertFile: GraphQLTypes["FileUpsertResult"],
	createJobFormSubscription: GraphQLTypes["JobFormSubscriptionCreateResult"],
	deleteJobFormSubscription: GraphQLTypes["JobFormSubscriptionDeleteResult"],
	updateJobFormSubscription: GraphQLTypes["JobFormSubscriptionUpdateResult"],
	upsertJobFormSubscription: GraphQLTypes["JobFormSubscriptionUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageListItem: GraphQLTypes["ImageListItemCreateResult"],
	deleteImageListItem: GraphQLTypes["ImageListItemDeleteResult"],
	updateImageListItem: GraphQLTypes["ImageListItemUpdateResult"],
	upsertImageListItem: GraphQLTypes["ImageListItemUpsertResult"],
	createJobFormSubscriptionStatus: GraphQLTypes["JobFormSubscriptionStatusCreateResult"],
	deleteJobFormSubscriptionStatus: GraphQLTypes["JobFormSubscriptionStatusDeleteResult"],
	updateJobFormSubscriptionStatus: GraphQLTypes["JobFormSubscriptionStatusUpdateResult"],
	upsertJobFormSubscriptionStatus: GraphQLTypes["JobFormSubscriptionStatusUpsertResult"],
	createGeneralLocale: GraphQLTypes["GeneralLocaleCreateResult"],
	deleteGeneralLocale: GraphQLTypes["GeneralLocaleDeleteResult"],
	updateGeneralLocale: GraphQLTypes["GeneralLocaleUpdateResult"],
	upsertGeneralLocale: GraphQLTypes["GeneralLocaleUpsertResult"],
	createStickyBar: GraphQLTypes["StickyBarCreateResult"],
	deleteStickyBar: GraphQLTypes["StickyBarDeleteResult"],
	updateStickyBar: GraphQLTypes["StickyBarUpdateResult"],
	upsertStickyBar: GraphQLTypes["StickyBarUpsertResult"],
	createRecommendationForm: GraphQLTypes["RecommendationFormCreateResult"],
	deleteRecommendationForm: GraphQLTypes["RecommendationFormDeleteResult"],
	updateRecommendationForm: GraphQLTypes["RecommendationFormUpdateResult"],
	upsertRecommendationForm: GraphQLTypes["RecommendationFormUpsertResult"],
	createRecommendationFormLocale: GraphQLTypes["RecommendationFormLocaleCreateResult"],
	deleteRecommendationFormLocale: GraphQLTypes["RecommendationFormLocaleDeleteResult"],
	updateRecommendationFormLocale: GraphQLTypes["RecommendationFormLocaleUpdateResult"],
	upsertRecommendationFormLocale: GraphQLTypes["RecommendationFormLocaleUpsertResult"],
	createRecommendationFormSubscription: GraphQLTypes["RecommendationFormSubscriptionCreateResult"],
	deleteRecommendationFormSubscription: GraphQLTypes["RecommendationFormSubscriptionDeleteResult"],
	updateRecommendationFormSubscription: GraphQLTypes["RecommendationFormSubscriptionUpdateResult"],
	upsertRecommendationFormSubscription: GraphQLTypes["RecommendationFormSubscriptionUpsertResult"],
	createInfoBox: GraphQLTypes["InfoBoxCreateResult"],
	deleteInfoBox: GraphQLTypes["InfoBoxDeleteResult"],
	updateInfoBox: GraphQLTypes["InfoBoxUpdateResult"],
	upsertInfoBox: GraphQLTypes["InfoBoxUpsertResult"],
	createInfoBoxLocale: GraphQLTypes["InfoBoxLocaleCreateResult"],
	deleteInfoBoxLocale: GraphQLTypes["InfoBoxLocaleDeleteResult"],
	updateInfoBoxLocale: GraphQLTypes["InfoBoxLocaleUpdateResult"],
	upsertInfoBoxLocale: GraphQLTypes["InfoBoxLocaleUpsertResult"],
	createTranslation: GraphQLTypes["TranslationCreateResult"],
	deleteTranslation: GraphQLTypes["TranslationDeleteResult"],
	updateTranslation: GraphQLTypes["TranslationUpdateResult"],
	upsertTranslation: GraphQLTypes["TranslationUpsertResult"],
	createTranslationLocale: GraphQLTypes["TranslationLocaleCreateResult"],
	deleteTranslationLocale: GraphQLTypes["TranslationLocaleDeleteResult"],
	updateTranslationLocale: GraphQLTypes["TranslationLocaleUpdateResult"],
	upsertTranslationLocale: GraphQLTypes["TranslationLocaleUpsertResult"],
	createCornerBanner: GraphQLTypes["CornerBannerCreateResult"],
	deleteCornerBanner: GraphQLTypes["CornerBannerDeleteResult"],
	updateCornerBanner: GraphQLTypes["CornerBannerUpdateResult"],
	upsertCornerBanner: GraphQLTypes["CornerBannerUpsertResult"],
	query?: GraphQLTypes["Query"] | undefined
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean | undefined
}
    }
export const enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export const enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export const enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export const enum One {
	One = "One"
}
export const enum LinkType {
	internal = "internal",
	external = "external",
	anchor = "anchor"
}
export const enum ContentReferenceType {
	image = "image",
	video = "video",
	sideBySideContent = "sideBySideContent",
	linkables = "linkables",
	statistics = "statistics",
	collapsible = "collapsible",
	carousel = "carousel",
	bonusBanner = "bonusBanner",
	grid = "grid",
	gridGallery = "gridGallery",
	jobFilter = "jobFilter",
	anchor = "anchor",
	articlesCarousel = "articlesCarousel",
	button = "button",
	gallery = "gallery"
}
export const enum MediumType {
	image = "image",
	video = "video"
}
export const enum Background {
	red = "red",
	lightGrey = "lightGrey",
	inherit = "inherit",
	lokal = "lokal"
}
export const enum SideBySideItemType {
	default = "default",
	jobsForm = "jobsForm"
}
export const enum ContentAlignment {
	left = "left",
	center = "center",
	right = "right"
}
export const enum MediumSize {
	small = "small",
	medium = "medium",
	big = "big"
}
export const enum LogoSize {
	small = "small",
	medium = "medium",
	big = "big"
}
export const enum SiteType {
	Ambi = "Ambi",
	Lokal = "Lokal"
}
export const enum OrderDirection {
	asc = "asc",
	desc = "desc",
	ascNullsFirst = "ascNullsFirst",
	descNullsLast = "descNullsLast"
}
export const enum S33ContentDisposition {
	ATTACHMENT = "ATTACHMENT",
	INLINE = "INLINE"
}
export const enum S3Acl {
	PUBLIC_READ = "PUBLIC_READ",
	PRIVATE = "PRIVATE",
	NONE = "NONE"
}
export const enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}

type ZEUS_VARIABLES = {
	["Json"]: ValueTypes["Json"];
	["_RelationSide"]: ValueTypes["_RelationSide"];
	["_OnDeleteBehaviour"]: ValueTypes["_OnDeleteBehaviour"];
	["_OrderByDirection"]: ValueTypes["_OrderByDirection"];
	["UUID"]: ValueTypes["UUID"];
	["One"]: ValueTypes["One"];
	["GeneralWhere"]: ValueTypes["GeneralWhere"];
	["UUIDCondition"]: ValueTypes["UUIDCondition"];
	["OneCondition"]: ValueTypes["OneCondition"];
	["GeneralLocaleWhere"]: ValueTypes["GeneralLocaleWhere"];
	["LocaleWhere"]: ValueTypes["LocaleWhere"];
	["StringCondition"]: ValueTypes["StringCondition"];
	["FooterLocaleWhere"]: ValueTypes["FooterLocaleWhere"];
	["FooterWhere"]: ValueTypes["FooterWhere"];
	["FooterLinkWhere"]: ValueTypes["FooterLinkWhere"];
	["IntCondition"]: ValueTypes["IntCondition"];
	["LinkWhere"]: ValueTypes["LinkWhere"];
	["LinkTypeCondition"]: ValueTypes["LinkTypeCondition"];
	["LinkType"]: ValueTypes["LinkType"];
	["LinkableWhere"]: ValueTypes["LinkableWhere"];
	["RedirectWhere"]: ValueTypes["RedirectWhere"];
	["GenericPageLocaleWhere"]: ValueTypes["GenericPageLocaleWhere"];
	["GenericPageWhere"]: ValueTypes["GenericPageWhere"];
	["ThemeWhere"]: ValueTypes["ThemeWhere"];
	["ContentWhere"]: ValueTypes["ContentWhere"];
	["ContentBlockWhere"]: ValueTypes["ContentBlockWhere"];
	["ContentReferenceWhere"]: ValueTypes["ContentReferenceWhere"];
	["ContentReferenceTypeCondition"]: ValueTypes["ContentReferenceTypeCondition"];
	["ContentReferenceType"]: ValueTypes["ContentReferenceType"];
	["ImageWhere"]: ValueTypes["ImageWhere"];
	["FloatCondition"]: ValueTypes["FloatCondition"];
	["ContentReferenceLinkableItemWhere"]: ValueTypes["ContentReferenceLinkableItemWhere"];
	["MediumListWhere"]: ValueTypes["MediumListWhere"];
	["MediumItemWhere"]: ValueTypes["MediumItemWhere"];
	["MediumWhere"]: ValueTypes["MediumWhere"];
	["MediumTypeCondition"]: ValueTypes["MediumTypeCondition"];
	["MediumType"]: ValueTypes["MediumType"];
	["VideoWhere"]: ValueTypes["VideoWhere"];
	["TextListWhere"]: ValueTypes["TextListWhere"];
	["TextItemWhere"]: ValueTypes["TextItemWhere"];
	["CarouselWhere"]: ValueTypes["CarouselWhere"];
	["CarouselItemWhere"]: ValueTypes["CarouselItemWhere"];
	["BooleanCondition"]: ValueTypes["BooleanCondition"];
	["BackgroundCondition"]: ValueTypes["BackgroundCondition"];
	["Background"]: ValueTypes["Background"];
	["BonusBannerLocaleWhere"]: ValueTypes["BonusBannerLocaleWhere"];
	["BonusBannerWhere"]: ValueTypes["BonusBannerWhere"];
	["TileWhere"]: ValueTypes["TileWhere"];
	["JobsFormLocaleWhere"]: ValueTypes["JobsFormLocaleWhere"];
	["JobsFormWhere"]: ValueTypes["JobsFormWhere"];
	["ImageTextListWhere"]: ValueTypes["ImageTextListWhere"];
	["ImageTextItemWhere"]: ValueTypes["ImageTextItemWhere"];
	["SideBySideWhere"]: ValueTypes["SideBySideWhere"];
	["SideBySideItemWhere"]: ValueTypes["SideBySideItemWhere"];
	["SideBySideItemTypeCondition"]: ValueTypes["SideBySideItemTypeCondition"];
	["SideBySideItemType"]: ValueTypes["SideBySideItemType"];
	["ContentAlignmentCondition"]: ValueTypes["ContentAlignmentCondition"];
	["ContentAlignment"]: ValueTypes["ContentAlignment"];
	["MediumSizeCondition"]: ValueTypes["MediumSizeCondition"];
	["MediumSize"]: ValueTypes["MediumSize"];
	["GalleryWhere"]: ValueTypes["GalleryWhere"];
	["GalleryItemWhere"]: ValueTypes["GalleryItemWhere"];
	["SeoWhere"]: ValueTypes["SeoWhere"];
	["BusinessPageLocaleWhere"]: ValueTypes["BusinessPageLocaleWhere"];
	["BusinessPageWhere"]: ValueTypes["BusinessPageWhere"];
	["StickyBarWhere"]: ValueTypes["StickyBarWhere"];
	["InfoBoxWhere"]: ValueTypes["InfoBoxWhere"];
	["LogoSizeCondition"]: ValueTypes["LogoSizeCondition"];
	["LogoSize"]: ValueTypes["LogoSize"];
	["InfoBoxLocaleWhere"]: ValueTypes["InfoBoxLocaleWhere"];
	["JobPageLocaleWhere"]: ValueTypes["JobPageLocaleWhere"];
	["JobPageWhere"]: ValueTypes["JobPageWhere"];
	["ContractTypeWhere"]: ValueTypes["ContractTypeWhere"];
	["ContractTypeLocaleWhere"]: ValueTypes["ContractTypeLocaleWhere"];
	["JobCityWhere"]: ValueTypes["JobCityWhere"];
	["JobCityLocaleWhere"]: ValueTypes["JobCityLocaleWhere"];
	["JobPositionWhere"]: ValueTypes["JobPositionWhere"];
	["JobPositionLocaleWhere"]: ValueTypes["JobPositionLocaleWhere"];
	["DateTimeCondition"]: ValueTypes["DateTimeCondition"];
	["DateTime"]: ValueTypes["DateTime"];
	["SiteTypeCondition"]: ValueTypes["SiteTypeCondition"];
	["SiteType"]: ValueTypes["SiteType"];
	["KeyInfoListWhere"]: ValueTypes["KeyInfoListWhere"];
	["KeyInfoItemWhere"]: ValueTypes["KeyInfoItemWhere"];
	["IconWhere"]: ValueTypes["IconWhere"];
	["HomePageLocaleWhere"]: ValueTypes["HomePageLocaleWhere"];
	["HomePageWhere"]: ValueTypes["HomePageWhere"];
	["SiteSwitcherWhere"]: ValueTypes["SiteSwitcherWhere"];
	["HomePageLokalLocaleWhere"]: ValueTypes["HomePageLokalLocaleWhere"];
	["HomePageLokalWhere"]: ValueTypes["HomePageLokalWhere"];
	["RecommendationFormLocaleWhere"]: ValueTypes["RecommendationFormLocaleWhere"];
	["RecommendationFormWhere"]: ValueTypes["RecommendationFormWhere"];
	["HeaderLocaleWhere"]: ValueTypes["HeaderLocaleWhere"];
	["HeaderWhere"]: ValueTypes["HeaderWhere"];
	["BusinessWhere"]: ValueTypes["BusinessWhere"];
	["SeoDefaultLocaleWhere"]: ValueTypes["SeoDefaultLocaleWhere"];
	["SeoDefaultWhere"]: ValueTypes["SeoDefaultWhere"];
	["JobsFilterLocaleWhere"]: ValueTypes["JobsFilterLocaleWhere"];
	["JobsFilterWhere"]: ValueTypes["JobsFilterWhere"];
	["TranslationLocaleWhere"]: ValueTypes["TranslationLocaleWhere"];
	["TranslationWhere"]: ValueTypes["TranslationWhere"];
	["CornerBannerWhere"]: ValueTypes["CornerBannerWhere"];
	["FooterLocaleOrderBy"]: ValueTypes["FooterLocaleOrderBy"];
	["OrderDirection"]: ValueTypes["OrderDirection"];
	["FooterOrderBy"]: ValueTypes["FooterOrderBy"];
	["LocaleOrderBy"]: ValueTypes["LocaleOrderBy"];
	["LinkOrderBy"]: ValueTypes["LinkOrderBy"];
	["LinkableOrderBy"]: ValueTypes["LinkableOrderBy"];
	["RedirectOrderBy"]: ValueTypes["RedirectOrderBy"];
	["GenericPageLocaleOrderBy"]: ValueTypes["GenericPageLocaleOrderBy"];
	["GenericPageOrderBy"]: ValueTypes["GenericPageOrderBy"];
	["ThemeOrderBy"]: ValueTypes["ThemeOrderBy"];
	["ContentOrderBy"]: ValueTypes["ContentOrderBy"];
	["SeoOrderBy"]: ValueTypes["SeoOrderBy"];
	["ImageOrderBy"]: ValueTypes["ImageOrderBy"];
	["BusinessPageLocaleOrderBy"]: ValueTypes["BusinessPageLocaleOrderBy"];
	["BusinessPageOrderBy"]: ValueTypes["BusinessPageOrderBy"];
	["StickyBarOrderBy"]: ValueTypes["StickyBarOrderBy"];
	["JobsFormLocaleOrderBy"]: ValueTypes["JobsFormLocaleOrderBy"];
	["JobsFormOrderBy"]: ValueTypes["JobsFormOrderBy"];
	["ImageTextListOrderBy"]: ValueTypes["ImageTextListOrderBy"];
	["InfoBoxOrderBy"]: ValueTypes["InfoBoxOrderBy"];
	["JobPageLocaleOrderBy"]: ValueTypes["JobPageLocaleOrderBy"];
	["JobPageOrderBy"]: ValueTypes["JobPageOrderBy"];
	["ContractTypeOrderBy"]: ValueTypes["ContractTypeOrderBy"];
	["JobCityOrderBy"]: ValueTypes["JobCityOrderBy"];
	["JobPositionOrderBy"]: ValueTypes["JobPositionOrderBy"];
	["KeyInfoListOrderBy"]: ValueTypes["KeyInfoListOrderBy"];
	["HomePageLocaleOrderBy"]: ValueTypes["HomePageLocaleOrderBy"];
	["HomePageOrderBy"]: ValueTypes["HomePageOrderBy"];
	["SiteSwitcherOrderBy"]: ValueTypes["SiteSwitcherOrderBy"];
	["GalleryOrderBy"]: ValueTypes["GalleryOrderBy"];
	["HomePageLokalLocaleOrderBy"]: ValueTypes["HomePageLokalLocaleOrderBy"];
	["HomePageLokalOrderBy"]: ValueTypes["HomePageLokalOrderBy"];
	["RecommendationFormLocaleOrderBy"]: ValueTypes["RecommendationFormLocaleOrderBy"];
	["RecommendationFormOrderBy"]: ValueTypes["RecommendationFormOrderBy"];
	["FooterLocalesByLocaleUniqueWhere"]: ValueTypes["FooterLocalesByLocaleUniqueWhere"];
	["LocaleUniqueWhere"]: ValueTypes["LocaleUniqueWhere"];
	["FooterLocaleUniqueWhere"]: ValueTypes["FooterLocaleUniqueWhere"];
	["FooterUniqueWhere"]: ValueTypes["FooterUniqueWhere"];
	["LinkUniqueWhere"]: ValueTypes["LinkUniqueWhere"];
	["ImageUniqueWhere"]: ValueTypes["ImageUniqueWhere"];
	["JobsFormLocaleUniqueWhere"]: ValueTypes["JobsFormLocaleUniqueWhere"];
	["JobsFormUniqueWhere"]: ValueTypes["JobsFormUniqueWhere"];
	["ImageTextListUniqueWhere"]: ValueTypes["ImageTextListUniqueWhere"];
	["ImageTextItemUniqueWhere"]: ValueTypes["ImageTextItemUniqueWhere"];
	["RecommendationFormLocaleUniqueWhere"]: ValueTypes["RecommendationFormLocaleUniqueWhere"];
	["RecommendationFormUniqueWhere"]: ValueTypes["RecommendationFormUniqueWhere"];
	["GenericPageLocaleUniqueWhere"]: ValueTypes["GenericPageLocaleUniqueWhere"];
	["GenericPageUniqueWhere"]: ValueTypes["GenericPageUniqueWhere"];
	["ContentUniqueWhere"]: ValueTypes["ContentUniqueWhere"];
	["ContentBlockUniqueWhere"]: ValueTypes["ContentBlockUniqueWhere"];
	["ContentReferenceUniqueWhere"]: ValueTypes["ContentReferenceUniqueWhere"];
	["ContentReferenceLinkableItemUniqueWhere"]: ValueTypes["ContentReferenceLinkableItemUniqueWhere"];
	["LinkableUniqueWhere"]: ValueTypes["LinkableUniqueWhere"];
	["RedirectUniqueWhere"]: ValueTypes["RedirectUniqueWhere"];
	["BusinessPageLocaleUniqueWhere"]: ValueTypes["BusinessPageLocaleUniqueWhere"];
	["BusinessPageUniqueWhere"]: ValueTypes["BusinessPageUniqueWhere"];
	["SeoUniqueWhere"]: ValueTypes["SeoUniqueWhere"];
	["JobPageLocaleUniqueWhere"]: ValueTypes["JobPageLocaleUniqueWhere"];
	["JobPageUniqueWhere"]: ValueTypes["JobPageUniqueWhere"];
	["KeyInfoListUniqueWhere"]: ValueTypes["KeyInfoListUniqueWhere"];
	["KeyInfoItemUniqueWhere"]: ValueTypes["KeyInfoItemUniqueWhere"];
	["HomePageLocaleUniqueWhere"]: ValueTypes["HomePageLocaleUniqueWhere"];
	["HomePageUniqueWhere"]: ValueTypes["HomePageUniqueWhere"];
	["ThemeUniqueWhere"]: ValueTypes["ThemeUniqueWhere"];
	["SiteSwitcherUniqueWhere"]: ValueTypes["SiteSwitcherUniqueWhere"];
	["GalleryUniqueWhere"]: ValueTypes["GalleryUniqueWhere"];
	["GalleryItemUniqueWhere"]: ValueTypes["GalleryItemUniqueWhere"];
	["HomePageLokalLocaleUniqueWhere"]: ValueTypes["HomePageLokalLocaleUniqueWhere"];
	["HomePageLokalUniqueWhere"]: ValueTypes["HomePageLokalUniqueWhere"];
	["MediumListUniqueWhere"]: ValueTypes["MediumListUniqueWhere"];
	["MediumItemUniqueWhere"]: ValueTypes["MediumItemUniqueWhere"];
	["HeaderLocaleUniqueWhere"]: ValueTypes["HeaderLocaleUniqueWhere"];
	["HeaderUniqueWhere"]: ValueTypes["HeaderUniqueWhere"];
	["SeoDefaultLocaleUniqueWhere"]: ValueTypes["SeoDefaultLocaleUniqueWhere"];
	["SeoDefaultUniqueWhere"]: ValueTypes["SeoDefaultUniqueWhere"];
	["ContractTypeLocaleUniqueWhere"]: ValueTypes["ContractTypeLocaleUniqueWhere"];
	["ContractTypeUniqueWhere"]: ValueTypes["ContractTypeUniqueWhere"];
	["JobCityLocaleUniqueWhere"]: ValueTypes["JobCityLocaleUniqueWhere"];
	["JobCityUniqueWhere"]: ValueTypes["JobCityUniqueWhere"];
	["JobPositionLocaleUniqueWhere"]: ValueTypes["JobPositionLocaleUniqueWhere"];
	["JobPositionUniqueWhere"]: ValueTypes["JobPositionUniqueWhere"];
	["BonusBannerLocaleUniqueWhere"]: ValueTypes["BonusBannerLocaleUniqueWhere"];
	["BonusBannerUniqueWhere"]: ValueTypes["BonusBannerUniqueWhere"];
	["TileUniqueWhere"]: ValueTypes["TileUniqueWhere"];
	["JobsFilterLocaleUniqueWhere"]: ValueTypes["JobsFilterLocaleUniqueWhere"];
	["JobsFilterUniqueWhere"]: ValueTypes["JobsFilterUniqueWhere"];
	["GeneralLocaleUniqueWhere"]: ValueTypes["GeneralLocaleUniqueWhere"];
	["GeneralUniqueWhere"]: ValueTypes["GeneralUniqueWhere"];
	["CornerBannerUniqueWhere"]: ValueTypes["CornerBannerUniqueWhere"];
	["InfoBoxLocaleUniqueWhere"]: ValueTypes["InfoBoxLocaleUniqueWhere"];
	["InfoBoxUniqueWhere"]: ValueTypes["InfoBoxUniqueWhere"];
	["TranslationLocaleUniqueWhere"]: ValueTypes["TranslationLocaleUniqueWhere"];
	["TranslationUniqueWhere"]: ValueTypes["TranslationUniqueWhere"];
	["FooterLocalesByTermsAndConditionsUniqueWhere"]: ValueTypes["FooterLocalesByTermsAndConditionsUniqueWhere"];
	["FooterLocalesByBannerImageUniqueWhere"]: ValueTypes["FooterLocalesByBannerImageUniqueWhere"];
	["FooterLocalesByBannerLinkUniqueWhere"]: ValueTypes["FooterLocalesByBannerLinkUniqueWhere"];
	["FooterLocalesByJobsFormUniqueWhere"]: ValueTypes["FooterLocalesByJobsFormUniqueWhere"];
	["FooterLocalesByCopyrightLinkUniqueWhere"]: ValueTypes["FooterLocalesByCopyrightLinkUniqueWhere"];
	["FooterLocalesByRecommendationFormUniqueWhere"]: ValueTypes["FooterLocalesByRecommendationFormUniqueWhere"];
	["FooterLocalesByBannerSecondLinkUniqueWhere"]: ValueTypes["FooterLocalesByBannerSecondLinkUniqueWhere"];
	["FooterLocalesByInstagramLinkUniqueWhere"]: ValueTypes["FooterLocalesByInstagramLinkUniqueWhere"];
	["GenericPageLocalesByLocaleUniqueWhere"]: ValueTypes["GenericPageLocalesByLocaleUniqueWhere"];
	["GenericPageLocalesByContentUniqueWhere"]: ValueTypes["GenericPageLocalesByContentUniqueWhere"];
	["GenericPageLocalesBySeoUniqueWhere"]: ValueTypes["GenericPageLocalesBySeoUniqueWhere"];
	["GenericPageLocalesByLinkUniqueWhere"]: ValueTypes["GenericPageLocalesByLinkUniqueWhere"];
	["GenericPageLocalesByLogoUniqueWhere"]: ValueTypes["GenericPageLocalesByLogoUniqueWhere"];
	["GenericPageLocalesByImageUniqueWhere"]: ValueTypes["GenericPageLocalesByImageUniqueWhere"];
	["ContentReferenceLinkableItemOrderBy"]: ValueTypes["ContentReferenceLinkableItemOrderBy"];
	["ContentReferenceOrderBy"]: ValueTypes["ContentReferenceOrderBy"];
	["ContentBlockOrderBy"]: ValueTypes["ContentBlockOrderBy"];
	["MediumListOrderBy"]: ValueTypes["MediumListOrderBy"];
	["TextListOrderBy"]: ValueTypes["TextListOrderBy"];
	["CarouselOrderBy"]: ValueTypes["CarouselOrderBy"];
	["BonusBannerLocaleOrderBy"]: ValueTypes["BonusBannerLocaleOrderBy"];
	["BonusBannerOrderBy"]: ValueTypes["BonusBannerOrderBy"];
	["SideBySideOrderBy"]: ValueTypes["SideBySideOrderBy"];
	["VideoOrderBy"]: ValueTypes["VideoOrderBy"];
	["MediumItemOrderBy"]: ValueTypes["MediumItemOrderBy"];
	["MediumOrderBy"]: ValueTypes["MediumOrderBy"];
	["TextItemOrderBy"]: ValueTypes["TextItemOrderBy"];
	["CarouselItemOrderBy"]: ValueTypes["CarouselItemOrderBy"];
	["CarouselItemsByImageUniqueWhere"]: ValueTypes["CarouselItemsByImageUniqueWhere"];
	["CarouselItemsByLinkUrlUniqueWhere"]: ValueTypes["CarouselItemsByLinkUrlUniqueWhere"];
	["CarouselItemsByVideoUniqueWhere"]: ValueTypes["CarouselItemsByVideoUniqueWhere"];
	["VideoUniqueWhere"]: ValueTypes["VideoUniqueWhere"];
	["BonusBannerLocalesByLocaleUniqueWhere"]: ValueTypes["BonusBannerLocalesByLocaleUniqueWhere"];
	["BonusBannerLocalesByTilesUniqueWhere"]: ValueTypes["BonusBannerLocalesByTilesUniqueWhere"];
	["BonusBannerLocalesByLogoUniqueWhere"]: ValueTypes["BonusBannerLocalesByLogoUniqueWhere"];
	["JobsFormLocalesByLocaleUniqueWhere"]: ValueTypes["JobsFormLocalesByLocaleUniqueWhere"];
	["JobsFormLocalesByImageTextListUniqueWhere"]: ValueTypes["JobsFormLocalesByImageTextListUniqueWhere"];
	["JobsFormLocalesByLogoUniqueWhere"]: ValueTypes["JobsFormLocalesByLogoUniqueWhere"];
	["JobsFormLocalesBySuccessImageUniqueWhere"]: ValueTypes["JobsFormLocalesBySuccessImageUniqueWhere"];
	["ImageTextItemOrderBy"]: ValueTypes["ImageTextItemOrderBy"];
	["ImageTextListItemsByImageUniqueWhere"]: ValueTypes["ImageTextListItemsByImageUniqueWhere"];
	["TileOrderBy"]: ValueTypes["TileOrderBy"];
	["BonusBannerLocaleTilesByImageUniqueWhere"]: ValueTypes["BonusBannerLocaleTilesByImageUniqueWhere"];
	["BonusBannerLocaleTilesByLigthBoxMediaUniqueWhere"]: ValueTypes["BonusBannerLocaleTilesByLigthBoxMediaUniqueWhere"];
	["SideBySideItemOrderBy"]: ValueTypes["SideBySideItemOrderBy"];
	["SideBySideItemsByMediaUniqueWhere"]: ValueTypes["SideBySideItemsByMediaUniqueWhere"];
	["GalleryItemOrderBy"]: ValueTypes["GalleryItemOrderBy"];
	["GalleryItemsByImageUniqueWhere"]: ValueTypes["GalleryItemsByImageUniqueWhere"];
	["ContentReferenceLinkablesByItemUniqueWhere"]: ValueTypes["ContentReferenceLinkablesByItemUniqueWhere"];
	["ContentBlockReferencesByLinkablesUniqueWhere"]: ValueTypes["ContentBlockReferencesByLinkablesUniqueWhere"];
	["ContentBlockReferencesByLinkUniqueWhere"]: ValueTypes["ContentBlockReferencesByLinkUniqueWhere"];
	["ContentBlockReferencesByMediaUniqueWhere"]: ValueTypes["ContentBlockReferencesByMediaUniqueWhere"];
	["ContentBlocksByReferencesUniqueWhere"]: ValueTypes["ContentBlocksByReferencesUniqueWhere"];
	["BusinessPageLocalesByLocaleUniqueWhere"]: ValueTypes["BusinessPageLocalesByLocaleUniqueWhere"];
	["BusinessPageLocalesByContentUniqueWhere"]: ValueTypes["BusinessPageLocalesByContentUniqueWhere"];
	["BusinessPageLocalesBySeoUniqueWhere"]: ValueTypes["BusinessPageLocalesBySeoUniqueWhere"];
	["BusinessPageLocalesByLinkUniqueWhere"]: ValueTypes["BusinessPageLocalesByLinkUniqueWhere"];
	["BusinessPageLocalesByImageUniqueWhere"]: ValueTypes["BusinessPageLocalesByImageUniqueWhere"];
	["InfoBoxLocaleOrderBy"]: ValueTypes["InfoBoxLocaleOrderBy"];
	["InfoBoxLocalesByLocaleUniqueWhere"]: ValueTypes["InfoBoxLocalesByLocaleUniqueWhere"];
	["ContractTypeLocaleOrderBy"]: ValueTypes["ContractTypeLocaleOrderBy"];
	["ContractTypeLocalesByLocaleUniqueWhere"]: ValueTypes["ContractTypeLocalesByLocaleUniqueWhere"];
	["JobCityLocaleOrderBy"]: ValueTypes["JobCityLocaleOrderBy"];
	["JobCityLocalesByLocaleUniqueWhere"]: ValueTypes["JobCityLocalesByLocaleUniqueWhere"];
	["JobPositionLocaleOrderBy"]: ValueTypes["JobPositionLocaleOrderBy"];
	["JobPositionLocalesByLocaleUniqueWhere"]: ValueTypes["JobPositionLocalesByLocaleUniqueWhere"];
	["JobPositionJobsByLocalesUniqueWhere"]: ValueTypes["JobPositionJobsByLocalesUniqueWhere"];
	["JobPageLocalesByLocaleUniqueWhere"]: ValueTypes["JobPageLocalesByLocaleUniqueWhere"];
	["JobPageLocalesByImageUniqueWhere"]: ValueTypes["JobPageLocalesByImageUniqueWhere"];
	["JobPageLocalesByKeyInfoUniqueWhere"]: ValueTypes["JobPageLocalesByKeyInfoUniqueWhere"];
	["JobPageLocalesByContentUniqueWhere"]: ValueTypes["JobPageLocalesByContentUniqueWhere"];
	["JobPageLocalesBySeoUniqueWhere"]: ValueTypes["JobPageLocalesBySeoUniqueWhere"];
	["JobPageLocalesByLinkUniqueWhere"]: ValueTypes["JobPageLocalesByLinkUniqueWhere"];
	["JobPageLocalesByMobileImageUniqueWhere"]: ValueTypes["JobPageLocalesByMobileImageUniqueWhere"];
	["KeyInfoItemOrderBy"]: ValueTypes["KeyInfoItemOrderBy"];
	["IconOrderBy"]: ValueTypes["IconOrderBy"];
	["HomePageLocalesByLocaleUniqueWhere"]: ValueTypes["HomePageLocalesByLocaleUniqueWhere"];
	["HomePageLocalesByButtonUniqueWhere"]: ValueTypes["HomePageLocalesByButtonUniqueWhere"];
	["HomePageLocalesByContentUniqueWhere"]: ValueTypes["HomePageLocalesByContentUniqueWhere"];
	["HomePageLocalesBySeoUniqueWhere"]: ValueTypes["HomePageLocalesBySeoUniqueWhere"];
	["HomePageLocalesByLinkUniqueWhere"]: ValueTypes["HomePageLocalesByLinkUniqueWhere"];
	["HomePageLocalesByLogoUniqueWhere"]: ValueTypes["HomePageLocalesByLogoUniqueWhere"];
	["HomePageLocalesBySiteSwitcherUniqueWhere"]: ValueTypes["HomePageLocalesBySiteSwitcherUniqueWhere"];
	["HomePageLocalesByIlustrationUniqueWhere"]: ValueTypes["HomePageLocalesByIlustrationUniqueWhere"];
	["HomePageLokalLocalesByLocaleUniqueWhere"]: ValueTypes["HomePageLokalLocalesByLocaleUniqueWhere"];
	["HomePageLokalLocalesByLogoUniqueWhere"]: ValueTypes["HomePageLokalLocalesByLogoUniqueWhere"];
	["HomePageLokalLocalesByButtonUniqueWhere"]: ValueTypes["HomePageLokalLocalesByButtonUniqueWhere"];
	["HomePageLokalLocalesByContentUniqueWhere"]: ValueTypes["HomePageLokalLocalesByContentUniqueWhere"];
	["HomePageLokalLocalesBySeoUniqueWhere"]: ValueTypes["HomePageLokalLocalesBySeoUniqueWhere"];
	["HomePageLokalLocalesByLinkUniqueWhere"]: ValueTypes["HomePageLokalLocalesByLinkUniqueWhere"];
	["HomePageLokalLocalesBySiteSwitcherUniqueWhere"]: ValueTypes["HomePageLokalLocalesBySiteSwitcherUniqueWhere"];
	["HomePageLokalLocalesByIlustrationUniqueWhere"]: ValueTypes["HomePageLokalLocalesByIlustrationUniqueWhere"];
	["FooterLinkOrderBy"]: ValueTypes["FooterLinkOrderBy"];
	["RecommendationFormLocalesByLocaleUniqueWhere"]: ValueTypes["RecommendationFormLocalesByLocaleUniqueWhere"];
	["HeaderLocaleOrderBy"]: ValueTypes["HeaderLocaleOrderBy"];
	["HeaderOrderBy"]: ValueTypes["HeaderOrderBy"];
	["HeaderLocalesByLocaleUniqueWhere"]: ValueTypes["HeaderLocalesByLocaleUniqueWhere"];
	["HeaderLocalesByBusinessLinkUniqueWhere"]: ValueTypes["HeaderLocalesByBusinessLinkUniqueWhere"];
	["HeaderLocalesByLokalLinkUniqueWhere"]: ValueTypes["HeaderLocalesByLokalLinkUniqueWhere"];
	["BusinessOrderBy"]: ValueTypes["BusinessOrderBy"];
	["SeoDefaultLocaleOrderBy"]: ValueTypes["SeoDefaultLocaleOrderBy"];
	["SeoDefaultOrderBy"]: ValueTypes["SeoDefaultOrderBy"];
	["SeoDefaultLocalesByLocaleUniqueWhere"]: ValueTypes["SeoDefaultLocalesByLocaleUniqueWhere"];
	["SeoDefaultLocalesBySeoUniqueWhere"]: ValueTypes["SeoDefaultLocalesBySeoUniqueWhere"];
	["JobsFilterLocaleOrderBy"]: ValueTypes["JobsFilterLocaleOrderBy"];
	["JobsFilterOrderBy"]: ValueTypes["JobsFilterOrderBy"];
	["JobsFilterLocalesByLocaleUniqueWhere"]: ValueTypes["JobsFilterLocalesByLocaleUniqueWhere"];
	["JobsFilterLocalesByBannerJobsFormUniqueWhere"]: ValueTypes["JobsFilterLocalesByBannerJobsFormUniqueWhere"];
	["JobsFilterLocalesByBannerImageUniqueWhere"]: ValueTypes["JobsFilterLocalesByBannerImageUniqueWhere"];
	["JobsFilterLocalesByNoJobImageUniqueWhere"]: ValueTypes["JobsFilterLocalesByNoJobImageUniqueWhere"];
	["GeneralLocaleOrderBy"]: ValueTypes["GeneralLocaleOrderBy"];
	["GeneralOrderBy"]: ValueTypes["GeneralOrderBy"];
	["CornerBannerOrderBy"]: ValueTypes["CornerBannerOrderBy"];
	["TranslationLocaleOrderBy"]: ValueTypes["TranslationLocaleOrderBy"];
	["TranslationOrderBy"]: ValueTypes["TranslationOrderBy"];
	["TranslationLocalesByLocaleUniqueWhere"]: ValueTypes["TranslationLocalesByLocaleUniqueWhere"];
	["LocaleFootersByRootUniqueWhere"]: ValueTypes["LocaleFootersByRootUniqueWhere"];
	["LocaleFootersByTermsAndConditionsUniqueWhere"]: ValueTypes["LocaleFootersByTermsAndConditionsUniqueWhere"];
	["LocaleFootersByBannerImageUniqueWhere"]: ValueTypes["LocaleFootersByBannerImageUniqueWhere"];
	["LocaleFootersByBannerLinkUniqueWhere"]: ValueTypes["LocaleFootersByBannerLinkUniqueWhere"];
	["LocaleFootersByJobsFormUniqueWhere"]: ValueTypes["LocaleFootersByJobsFormUniqueWhere"];
	["LocaleFootersByCopyrightLinkUniqueWhere"]: ValueTypes["LocaleFootersByCopyrightLinkUniqueWhere"];
	["LocaleFootersByRecommendationFormUniqueWhere"]: ValueTypes["LocaleFootersByRecommendationFormUniqueWhere"];
	["LocaleFootersByBannerSecondLinkUniqueWhere"]: ValueTypes["LocaleFootersByBannerSecondLinkUniqueWhere"];
	["LocaleFootersByInstagramLinkUniqueWhere"]: ValueTypes["LocaleFootersByInstagramLinkUniqueWhere"];
	["LocaleGenericPagesByRootUniqueWhere"]: ValueTypes["LocaleGenericPagesByRootUniqueWhere"];
	["LocaleGenericPagesByContentUniqueWhere"]: ValueTypes["LocaleGenericPagesByContentUniqueWhere"];
	["LocaleGenericPagesBySeoUniqueWhere"]: ValueTypes["LocaleGenericPagesBySeoUniqueWhere"];
	["LocaleGenericPagesByLinkUniqueWhere"]: ValueTypes["LocaleGenericPagesByLinkUniqueWhere"];
	["LocaleGenericPagesByLogoUniqueWhere"]: ValueTypes["LocaleGenericPagesByLogoUniqueWhere"];
	["LocaleGenericPagesByImageUniqueWhere"]: ValueTypes["LocaleGenericPagesByImageUniqueWhere"];
	["LocaleHeadersByRootUniqueWhere"]: ValueTypes["LocaleHeadersByRootUniqueWhere"];
	["LocaleHeadersByBusinessLinkUniqueWhere"]: ValueTypes["LocaleHeadersByBusinessLinkUniqueWhere"];
	["LocaleHeadersByLokalLinkUniqueWhere"]: ValueTypes["LocaleHeadersByLokalLinkUniqueWhere"];
	["LocaleSeoDefaultsByRootUniqueWhere"]: ValueTypes["LocaleSeoDefaultsByRootUniqueWhere"];
	["LocaleSeoDefaultsBySeoUniqueWhere"]: ValueTypes["LocaleSeoDefaultsBySeoUniqueWhere"];
	["LocaleBusinessPagesByRootUniqueWhere"]: ValueTypes["LocaleBusinessPagesByRootUniqueWhere"];
	["LocaleBusinessPagesByContentUniqueWhere"]: ValueTypes["LocaleBusinessPagesByContentUniqueWhere"];
	["LocaleBusinessPagesBySeoUniqueWhere"]: ValueTypes["LocaleBusinessPagesBySeoUniqueWhere"];
	["LocaleBusinessPagesByLinkUniqueWhere"]: ValueTypes["LocaleBusinessPagesByLinkUniqueWhere"];
	["LocaleBusinessPagesByImageUniqueWhere"]: ValueTypes["LocaleBusinessPagesByImageUniqueWhere"];
	["LocaleJobPagesByRootUniqueWhere"]: ValueTypes["LocaleJobPagesByRootUniqueWhere"];
	["LocaleJobPagesByImageUniqueWhere"]: ValueTypes["LocaleJobPagesByImageUniqueWhere"];
	["LocaleJobPagesByKeyInfoUniqueWhere"]: ValueTypes["LocaleJobPagesByKeyInfoUniqueWhere"];
	["LocaleJobPagesByContentUniqueWhere"]: ValueTypes["LocaleJobPagesByContentUniqueWhere"];
	["LocaleJobPagesBySeoUniqueWhere"]: ValueTypes["LocaleJobPagesBySeoUniqueWhere"];
	["LocaleJobPagesByLinkUniqueWhere"]: ValueTypes["LocaleJobPagesByLinkUniqueWhere"];
	["LocaleJobPagesByMobileImageUniqueWhere"]: ValueTypes["LocaleJobPagesByMobileImageUniqueWhere"];
	["LocaleContractTypesByRootUniqueWhere"]: ValueTypes["LocaleContractTypesByRootUniqueWhere"];
	["LocaleContractTypesBySlugUniqueWhere"]: ValueTypes["LocaleContractTypesBySlugUniqueWhere"];
	["LocaleJobCitiesByRootUniqueWhere"]: ValueTypes["LocaleJobCitiesByRootUniqueWhere"];
	["LocaleJobCitiesBySlugUniqueWhere"]: ValueTypes["LocaleJobCitiesBySlugUniqueWhere"];
	["LocaleJobPositionsByRootUniqueWhere"]: ValueTypes["LocaleJobPositionsByRootUniqueWhere"];
	["LocaleJobPositionsBySlugUniqueWhere"]: ValueTypes["LocaleJobPositionsBySlugUniqueWhere"];
	["LocaleHomePagesByRootUniqueWhere"]: ValueTypes["LocaleHomePagesByRootUniqueWhere"];
	["LocaleHomePagesByButtonUniqueWhere"]: ValueTypes["LocaleHomePagesByButtonUniqueWhere"];
	["LocaleHomePagesByContentUniqueWhere"]: ValueTypes["LocaleHomePagesByContentUniqueWhere"];
	["LocaleHomePagesBySeoUniqueWhere"]: ValueTypes["LocaleHomePagesBySeoUniqueWhere"];
	["LocaleHomePagesByLinkUniqueWhere"]: ValueTypes["LocaleHomePagesByLinkUniqueWhere"];
	["LocaleHomePagesByLogoUniqueWhere"]: ValueTypes["LocaleHomePagesByLogoUniqueWhere"];
	["LocaleHomePagesBySiteSwitcherUniqueWhere"]: ValueTypes["LocaleHomePagesBySiteSwitcherUniqueWhere"];
	["LocaleHomePagesByIlustrationUniqueWhere"]: ValueTypes["LocaleHomePagesByIlustrationUniqueWhere"];
	["LocaleBonusBannersByRootUniqueWhere"]: ValueTypes["LocaleBonusBannersByRootUniqueWhere"];
	["LocaleBonusBannersByTilesUniqueWhere"]: ValueTypes["LocaleBonusBannersByTilesUniqueWhere"];
	["LocaleBonusBannersByLogoUniqueWhere"]: ValueTypes["LocaleBonusBannersByLogoUniqueWhere"];
	["LocaleHomePageLokalsByRootUniqueWhere"]: ValueTypes["LocaleHomePageLokalsByRootUniqueWhere"];
	["LocaleHomePageLokalsByLogoUniqueWhere"]: ValueTypes["LocaleHomePageLokalsByLogoUniqueWhere"];
	["LocaleHomePageLokalsByButtonUniqueWhere"]: ValueTypes["LocaleHomePageLokalsByButtonUniqueWhere"];
	["LocaleHomePageLokalsByContentUniqueWhere"]: ValueTypes["LocaleHomePageLokalsByContentUniqueWhere"];
	["LocaleHomePageLokalsBySeoUniqueWhere"]: ValueTypes["LocaleHomePageLokalsBySeoUniqueWhere"];
	["LocaleHomePageLokalsByLinkUniqueWhere"]: ValueTypes["LocaleHomePageLokalsByLinkUniqueWhere"];
	["LocaleHomePageLokalsBySiteSwitcherUniqueWhere"]: ValueTypes["LocaleHomePageLokalsBySiteSwitcherUniqueWhere"];
	["LocaleHomePageLokalsByIlustrationUniqueWhere"]: ValueTypes["LocaleHomePageLokalsByIlustrationUniqueWhere"];
	["LocaleJobsFormsByRootUniqueWhere"]: ValueTypes["LocaleJobsFormsByRootUniqueWhere"];
	["LocaleJobsFormsByImageTextListUniqueWhere"]: ValueTypes["LocaleJobsFormsByImageTextListUniqueWhere"];
	["LocaleJobsFormsByLogoUniqueWhere"]: ValueTypes["LocaleJobsFormsByLogoUniqueWhere"];
	["LocaleJobsFormsBySuccessImageUniqueWhere"]: ValueTypes["LocaleJobsFormsBySuccessImageUniqueWhere"];
	["LocaleJobsFiltersByRootUniqueWhere"]: ValueTypes["LocaleJobsFiltersByRootUniqueWhere"];
	["LocaleJobsFiltersByBannerJobsFormUniqueWhere"]: ValueTypes["LocaleJobsFiltersByBannerJobsFormUniqueWhere"];
	["LocaleJobsFiltersByBannerImageUniqueWhere"]: ValueTypes["LocaleJobsFiltersByBannerImageUniqueWhere"];
	["LocaleJobsFiltersByNoJobImageUniqueWhere"]: ValueTypes["LocaleJobsFiltersByNoJobImageUniqueWhere"];
	["LocaleGeneralByRootUniqueWhere"]: ValueTypes["LocaleGeneralByRootUniqueWhere"];
	["LocaleGeneralBySeoUniqueWhere"]: ValueTypes["LocaleGeneralBySeoUniqueWhere"];
	["LocaleGeneralByCornerBannerUniqueWhere"]: ValueTypes["LocaleGeneralByCornerBannerUniqueWhere"];
	["LocaleRecommendationFormsByRootUniqueWhere"]: ValueTypes["LocaleRecommendationFormsByRootUniqueWhere"];
	["LocaleInfoBoxesByRootUniqueWhere"]: ValueTypes["LocaleInfoBoxesByRootUniqueWhere"];
	["LocaleTranslationsByRootUniqueWhere"]: ValueTypes["LocaleTranslationsByRootUniqueWhere"];
	["GeneralLocalesByLocaleUniqueWhere"]: ValueTypes["GeneralLocalesByLocaleUniqueWhere"];
	["GeneralLocalesBySeoUniqueWhere"]: ValueTypes["GeneralLocalesBySeoUniqueWhere"];
	["GeneralLocalesByCornerBannerUniqueWhere"]: ValueTypes["GeneralLocalesByCornerBannerUniqueWhere"];
	["GeneralCreateInput"]: ValueTypes["GeneralCreateInput"];
	["GeneralCreateLocalesEntityRelationInput"]: ValueTypes["GeneralCreateLocalesEntityRelationInput"];
	["GeneralLocaleWithoutRootCreateInput"]: ValueTypes["GeneralLocaleWithoutRootCreateInput"];
	["GeneralLocaleCreateLocaleEntityRelationInput"]: ValueTypes["GeneralLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutGeneralCreateInput"]: ValueTypes["LocaleWithoutGeneralCreateInput"];
	["LocaleCreateFootersEntityRelationInput"]: ValueTypes["LocaleCreateFootersEntityRelationInput"];
	["FooterLocaleWithoutLocaleCreateInput"]: ValueTypes["FooterLocaleWithoutLocaleCreateInput"];
	["FooterLocaleCreateRootEntityRelationInput"]: ValueTypes["FooterLocaleCreateRootEntityRelationInput"];
	["FooterWithoutLocalesCreateInput"]: ValueTypes["FooterWithoutLocalesCreateInput"];
	["FooterLocaleConnectOrCreateRootRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateRootRelationInput"];
	["FooterLocaleCreateLinksFirstColumnEntityRelationInput"]: ValueTypes["FooterLocaleCreateLinksFirstColumnEntityRelationInput"];
	["FooterLinkUniqueWhere"]: ValueTypes["FooterLinkUniqueWhere"];
	["FooterLinkCreateInput"]: ValueTypes["FooterLinkCreateInput"];
	["FooterLinkCreateLinkEntityRelationInput"]: ValueTypes["FooterLinkCreateLinkEntityRelationInput"];
	["LinkCreateInput"]: ValueTypes["LinkCreateInput"];
	["LinkCreateInternalLinkEntityRelationInput"]: ValueTypes["LinkCreateInternalLinkEntityRelationInput"];
	["LinkableCreateInput"]: ValueTypes["LinkableCreateInput"];
	["LinkableCreateRedirectEntityRelationInput"]: ValueTypes["LinkableCreateRedirectEntityRelationInput"];
	["RedirectWithoutLinkCreateInput"]: ValueTypes["RedirectWithoutLinkCreateInput"];
	["RedirectCreateTargetEntityRelationInput"]: ValueTypes["RedirectCreateTargetEntityRelationInput"];
	["RedirectConnectOrCreateTargetRelationInput"]: ValueTypes["RedirectConnectOrCreateTargetRelationInput"];
	["LinkableConnectOrCreateRedirectRelationInput"]: ValueTypes["LinkableConnectOrCreateRedirectRelationInput"];
	["LinkableCreateGenericPageEntityRelationInput"]: ValueTypes["LinkableCreateGenericPageEntityRelationInput"];
	["GenericPageLocaleWithoutLinkCreateInput"]: ValueTypes["GenericPageLocaleWithoutLinkCreateInput"];
	["GenericPageLocaleCreateRootEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateRootEntityRelationInput"];
	["GenericPageWithoutLocalesCreateInput"]: ValueTypes["GenericPageWithoutLocalesCreateInput"];
	["GenericPageCreateThemeEntityRelationInput"]: ValueTypes["GenericPageCreateThemeEntityRelationInput"];
	["ThemeCreateInput"]: ValueTypes["ThemeCreateInput"];
	["GenericPageConnectOrCreateThemeRelationInput"]: ValueTypes["GenericPageConnectOrCreateThemeRelationInput"];
	["GenericPageLocaleConnectOrCreateRootRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateRootRelationInput"];
	["GenericPageLocaleCreateLocaleEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutGenericPagesCreateInput"]: ValueTypes["LocaleWithoutGenericPagesCreateInput"];
	["LocaleCreateHeadersEntityRelationInput"]: ValueTypes["LocaleCreateHeadersEntityRelationInput"];
	["HeaderLocaleWithoutLocaleCreateInput"]: ValueTypes["HeaderLocaleWithoutLocaleCreateInput"];
	["HeaderLocaleCreateRootEntityRelationInput"]: ValueTypes["HeaderLocaleCreateRootEntityRelationInput"];
	["HeaderWithoutLocalesCreateInput"]: ValueTypes["HeaderWithoutLocalesCreateInput"];
	["HeaderCreateLogoEntityRelationInput"]: ValueTypes["HeaderCreateLogoEntityRelationInput"];
	["ImageCreateInput"]: ValueTypes["ImageCreateInput"];
	["HeaderConnectOrCreateLogoRelationInput"]: ValueTypes["HeaderConnectOrCreateLogoRelationInput"];
	["HeaderCreateLogoMenuEntityRelationInput"]: ValueTypes["HeaderCreateLogoMenuEntityRelationInput"];
	["HeaderConnectOrCreateLogoMenuRelationInput"]: ValueTypes["HeaderConnectOrCreateLogoMenuRelationInput"];
	["HeaderLocaleConnectOrCreateRootRelationInput"]: ValueTypes["HeaderLocaleConnectOrCreateRootRelationInput"];
	["HeaderLocaleCreateBusinessEntityRelationInput"]: ValueTypes["HeaderLocaleCreateBusinessEntityRelationInput"];
	["BusinessUniqueWhere"]: ValueTypes["BusinessUniqueWhere"];
	["BusinessCreateInput"]: ValueTypes["BusinessCreateInput"];
	["BusinessCreateLogoEntityRelationInput"]: ValueTypes["BusinessCreateLogoEntityRelationInput"];
	["BusinessConnectOrCreateLogoRelationInput"]: ValueTypes["BusinessConnectOrCreateLogoRelationInput"];
	["BusinessCreateLinkEntityRelationInput"]: ValueTypes["BusinessCreateLinkEntityRelationInput"];
	["BusinessConnectOrCreateLinkRelationInput"]: ValueTypes["BusinessConnectOrCreateLinkRelationInput"];
	["HeaderLocaleConnectOrCreateBusinessRelationInput"]: ValueTypes["HeaderLocaleConnectOrCreateBusinessRelationInput"];
	["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"]: ValueTypes["HeaderLocaleCreateLokalEnterpriseEntityRelationInput"];
	["HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"]: ValueTypes["HeaderLocaleConnectOrCreateLokalEnterpriseRelationInput"];
	["HeaderLocaleCreateBusinessLinkEntityRelationInput"]: ValueTypes["HeaderLocaleCreateBusinessLinkEntityRelationInput"];
	["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"]: ValueTypes["HeaderLocaleConnectOrCreateBusinessLinkRelationInput"];
	["HeaderLocaleCreateLokalLinkEntityRelationInput"]: ValueTypes["HeaderLocaleCreateLokalLinkEntityRelationInput"];
	["HeaderLocaleConnectOrCreateLokalLinkRelationInput"]: ValueTypes["HeaderLocaleConnectOrCreateLokalLinkRelationInput"];
	["LocaleConnectOrCreateHeadersRelationInput"]: ValueTypes["LocaleConnectOrCreateHeadersRelationInput"];
	["LocaleCreateSeoDefaultsEntityRelationInput"]: ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"];
	["SeoDefaultLocaleWithoutLocaleCreateInput"]: ValueTypes["SeoDefaultLocaleWithoutLocaleCreateInput"];
	["SeoDefaultLocaleCreateRootEntityRelationInput"]: ValueTypes["SeoDefaultLocaleCreateRootEntityRelationInput"];
	["SeoDefaultWithoutLocalesCreateInput"]: ValueTypes["SeoDefaultWithoutLocalesCreateInput"];
	["SeoDefaultLocaleConnectOrCreateRootRelationInput"]: ValueTypes["SeoDefaultLocaleConnectOrCreateRootRelationInput"];
	["SeoDefaultLocaleCreateSeoEntityRelationInput"]: ValueTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: ValueTypes["SeoCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: ValueTypes["SeoCreateOgImageEntityRelationInput"];
	["SeoConnectOrCreateOgImageRelationInput"]: ValueTypes["SeoConnectOrCreateOgImageRelationInput"];
	["SeoDefaultLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["SeoDefaultLocaleConnectOrCreateSeoRelationInput"];
	["LocaleConnectOrCreateSeoDefaultsRelationInput"]: ValueTypes["LocaleConnectOrCreateSeoDefaultsRelationInput"];
	["LocaleCreateBusinessPagesEntityRelationInput"]: ValueTypes["LocaleCreateBusinessPagesEntityRelationInput"];
	["BusinessPageLocaleWithoutLocaleCreateInput"]: ValueTypes["BusinessPageLocaleWithoutLocaleCreateInput"];
	["BusinessPageLocaleCreateRootEntityRelationInput"]: ValueTypes["BusinessPageLocaleCreateRootEntityRelationInput"];
	["BusinessPageWithoutLocalesCreateInput"]: ValueTypes["BusinessPageWithoutLocalesCreateInput"];
	["BusinessPageCreateThemeEntityRelationInput"]: ValueTypes["BusinessPageCreateThemeEntityRelationInput"];
	["BusinessPageConnectOrCreateThemeRelationInput"]: ValueTypes["BusinessPageConnectOrCreateThemeRelationInput"];
	["BusinessPageLocaleConnectOrCreateRootRelationInput"]: ValueTypes["BusinessPageLocaleConnectOrCreateRootRelationInput"];
	["BusinessPageLocaleCreateContentEntityRelationInput"]: ValueTypes["BusinessPageLocaleCreateContentEntityRelationInput"];
	["ContentCreateInput"]: ValueTypes["ContentCreateInput"];
	["ContentCreateBlocksEntityRelationInput"]: ValueTypes["ContentCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutContentCreateInput"]: ValueTypes["ContentBlockWithoutContentCreateInput"];
	["ContentBlockCreateReferencesEntityRelationInput"]: ValueTypes["ContentBlockCreateReferencesEntityRelationInput"];
	["ContentReferenceWithoutBlockCreateInput"]: ValueTypes["ContentReferenceWithoutBlockCreateInput"];
	["ContentReferenceCreateImageEntityRelationInput"]: ValueTypes["ContentReferenceCreateImageEntityRelationInput"];
	["ContentReferenceConnectOrCreateImageRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateImageRelationInput"];
	["ContentReferenceCreateLinkablesEntityRelationInput"]: ValueTypes["ContentReferenceCreateLinkablesEntityRelationInput"];
	["ContentReferenceCreateLinkEntityRelationInput"]: ValueTypes["ContentReferenceCreateLinkEntityRelationInput"];
	["ContentReferenceConnectOrCreateLinkRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateLinkRelationInput"];
	["ContentReferenceCreateMediaEntityRelationInput"]: ValueTypes["ContentReferenceCreateMediaEntityRelationInput"];
	["MediumListCreateInput"]: ValueTypes["MediumListCreateInput"];
	["MediumListCreateItemsEntityRelationInput"]: ValueTypes["MediumListCreateItemsEntityRelationInput"];
	["MediumItemWithoutListCreateInput"]: ValueTypes["MediumItemWithoutListCreateInput"];
	["MediumItemCreateMediumEntityRelationInput"]: ValueTypes["MediumItemCreateMediumEntityRelationInput"];
	["MediumUniqueWhere"]: ValueTypes["MediumUniqueWhere"];
	["MediumCreateInput"]: ValueTypes["MediumCreateInput"];
	["MediumCreateImageEntityRelationInput"]: ValueTypes["MediumCreateImageEntityRelationInput"];
	["MediumConnectOrCreateImageRelationInput"]: ValueTypes["MediumConnectOrCreateImageRelationInput"];
	["MediumCreateVideoEntityRelationInput"]: ValueTypes["MediumCreateVideoEntityRelationInput"];
	["VideoCreateInput"]: ValueTypes["VideoCreateInput"];
	["VideoCreatePosterEntityRelationInput"]: ValueTypes["VideoCreatePosterEntityRelationInput"];
	["VideoConnectOrCreatePosterRelationInput"]: ValueTypes["VideoConnectOrCreatePosterRelationInput"];
	["MediumConnectOrCreateVideoRelationInput"]: ValueTypes["MediumConnectOrCreateVideoRelationInput"];
	["MediumItemConnectOrCreateMediumRelationInput"]: ValueTypes["MediumItemConnectOrCreateMediumRelationInput"];
	["MediumListConnectOrCreateItemsRelationInput"]: ValueTypes["MediumListConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateMediaRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateMediaRelationInput"];
	["ContentReferenceCreateTextListEntityRelationInput"]: ValueTypes["ContentReferenceCreateTextListEntityRelationInput"];
	["TextListUniqueWhere"]: ValueTypes["TextListUniqueWhere"];
	["TextItemUniqueWhere"]: ValueTypes["TextItemUniqueWhere"];
	["TextListCreateInput"]: ValueTypes["TextListCreateInput"];
	["TextListCreateItemsEntityRelationInput"]: ValueTypes["TextListCreateItemsEntityRelationInput"];
	["TextItemWithoutListCreateInput"]: ValueTypes["TextItemWithoutListCreateInput"];
	["TextListConnectOrCreateItemsRelationInput"]: ValueTypes["TextListConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateTextListRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateTextListRelationInput"];
	["ContentReferenceCreateCarouselEntityRelationInput"]: ValueTypes["ContentReferenceCreateCarouselEntityRelationInput"];
	["CarouselUniqueWhere"]: ValueTypes["CarouselUniqueWhere"];
	["CarouselItemUniqueWhere"]: ValueTypes["CarouselItemUniqueWhere"];
	["CarouselCreateInput"]: ValueTypes["CarouselCreateInput"];
	["CarouselCreateItemsEntityRelationInput"]: ValueTypes["CarouselCreateItemsEntityRelationInput"];
	["CarouselItemWithoutListCreateInput"]: ValueTypes["CarouselItemWithoutListCreateInput"];
	["CarouselItemCreateImageEntityRelationInput"]: ValueTypes["CarouselItemCreateImageEntityRelationInput"];
	["CarouselItemConnectOrCreateImageRelationInput"]: ValueTypes["CarouselItemConnectOrCreateImageRelationInput"];
	["CarouselItemCreateLinkUrlEntityRelationInput"]: ValueTypes["CarouselItemCreateLinkUrlEntityRelationInput"];
	["CarouselItemConnectOrCreateLinkUrlRelationInput"]: ValueTypes["CarouselItemConnectOrCreateLinkUrlRelationInput"];
	["CarouselItemCreateVideoEntityRelationInput"]: ValueTypes["CarouselItemCreateVideoEntityRelationInput"];
	["CarouselItemConnectOrCreateVideoRelationInput"]: ValueTypes["CarouselItemConnectOrCreateVideoRelationInput"];
	["CarouselConnectOrCreateItemsRelationInput"]: ValueTypes["CarouselConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateCarouselRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateCarouselRelationInput"];
	["ContentReferenceCreateBonusBannerEntityRelationInput"]: ValueTypes["ContentReferenceCreateBonusBannerEntityRelationInput"];
	["BonusBannerLocaleCreateInput"]: ValueTypes["BonusBannerLocaleCreateInput"];
	["BonusBannerLocaleCreateRootEntityRelationInput"]: ValueTypes["BonusBannerLocaleCreateRootEntityRelationInput"];
	["BonusBannerWithoutLocalesCreateInput"]: ValueTypes["BonusBannerWithoutLocalesCreateInput"];
	["BonusBannerLocaleConnectOrCreateRootRelationInput"]: ValueTypes["BonusBannerLocaleConnectOrCreateRootRelationInput"];
	["BonusBannerLocaleCreateLocaleEntityRelationInput"]: ValueTypes["BonusBannerLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutBonusBannersCreateInput"]: ValueTypes["LocaleWithoutBonusBannersCreateInput"];
	["LocaleCreateGenericPagesEntityRelationInput"]: ValueTypes["LocaleCreateGenericPagesEntityRelationInput"];
	["GenericPageLocaleWithoutLocaleCreateInput"]: ValueTypes["GenericPageLocaleWithoutLocaleCreateInput"];
	["GenericPageLocaleCreateContentEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateContentEntityRelationInput"];
	["GenericPageLocaleConnectOrCreateContentRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateContentRelationInput"];
	["GenericPageLocaleCreateSeoEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateSeoEntityRelationInput"];
	["GenericPageLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateSeoRelationInput"];
	["GenericPageLocaleCreateLinkEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutGenericPageCreateInput"]: ValueTypes["LinkableWithoutGenericPageCreateInput"];
	["LinkableCreateBusinessPageEntityRelationInput"]: ValueTypes["LinkableCreateBusinessPageEntityRelationInput"];
	["BusinessPageLocaleWithoutLinkCreateInput"]: ValueTypes["BusinessPageLocaleWithoutLinkCreateInput"];
	["BusinessPageLocaleCreateLocaleEntityRelationInput"]: ValueTypes["BusinessPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutBusinessPagesCreateInput"]: ValueTypes["LocaleWithoutBusinessPagesCreateInput"];
	["LocaleCreateJobPagesEntityRelationInput"]: ValueTypes["LocaleCreateJobPagesEntityRelationInput"];
	["JobPageLocaleWithoutLocaleCreateInput"]: ValueTypes["JobPageLocaleWithoutLocaleCreateInput"];
	["JobPageLocaleCreateRootEntityRelationInput"]: ValueTypes["JobPageLocaleCreateRootEntityRelationInput"];
	["JobPageWithoutLocalesCreateInput"]: ValueTypes["JobPageWithoutLocalesCreateInput"];
	["JobPageCreateThemeEntityRelationInput"]: ValueTypes["JobPageCreateThemeEntityRelationInput"];
	["JobPageConnectOrCreateThemeRelationInput"]: ValueTypes["JobPageConnectOrCreateThemeRelationInput"];
	["JobPageCreateContractTypeEntityRelationInput"]: ValueTypes["JobPageCreateContractTypeEntityRelationInput"];
	["ContractTypeCreateInput"]: ValueTypes["ContractTypeCreateInput"];
	["ContractTypeCreateLocalesEntityRelationInput"]: ValueTypes["ContractTypeCreateLocalesEntityRelationInput"];
	["ContractTypeLocaleWithoutRootCreateInput"]: ValueTypes["ContractTypeLocaleWithoutRootCreateInput"];
	["ContractTypeLocaleCreateLocaleEntityRelationInput"]: ValueTypes["ContractTypeLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutContractTypesCreateInput"]: ValueTypes["LocaleWithoutContractTypesCreateInput"];
	["LocaleCreateJobCitiesEntityRelationInput"]: ValueTypes["LocaleCreateJobCitiesEntityRelationInput"];
	["JobCityLocaleWithoutLocaleCreateInput"]: ValueTypes["JobCityLocaleWithoutLocaleCreateInput"];
	["JobCityLocaleCreateRootEntityRelationInput"]: ValueTypes["JobCityLocaleCreateRootEntityRelationInput"];
	["JobCityWithoutLocalesCreateInput"]: ValueTypes["JobCityWithoutLocalesCreateInput"];
	["JobCityLocaleConnectOrCreateRootRelationInput"]: ValueTypes["JobCityLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreateJobCitiesRelationInput"]: ValueTypes["LocaleConnectOrCreateJobCitiesRelationInput"];
	["LocaleCreateJobPositionsEntityRelationInput"]: ValueTypes["LocaleCreateJobPositionsEntityRelationInput"];
	["JobPositionLocaleWithoutLocaleCreateInput"]: ValueTypes["JobPositionLocaleWithoutLocaleCreateInput"];
	["JobPositionLocaleCreateRootEntityRelationInput"]: ValueTypes["JobPositionLocaleCreateRootEntityRelationInput"];
	["JobPositionWithoutLocalesCreateInput"]: ValueTypes["JobPositionWithoutLocalesCreateInput"];
	["JobPositionCreateJobsEntityRelationInput"]: ValueTypes["JobPositionCreateJobsEntityRelationInput"];
	["JobPageWithoutJobPositionCreateInput"]: ValueTypes["JobPageWithoutJobPositionCreateInput"];
	["JobPageCreateLocalesEntityRelationInput"]: ValueTypes["JobPageCreateLocalesEntityRelationInput"];
	["JobPageLocaleWithoutRootCreateInput"]: ValueTypes["JobPageLocaleWithoutRootCreateInput"];
	["JobPageLocaleCreateLocaleEntityRelationInput"]: ValueTypes["JobPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutJobPagesCreateInput"]: ValueTypes["LocaleWithoutJobPagesCreateInput"];
	["LocaleCreateContractTypesEntityRelationInput"]: ValueTypes["LocaleCreateContractTypesEntityRelationInput"];
	["ContractTypeLocaleWithoutLocaleCreateInput"]: ValueTypes["ContractTypeLocaleWithoutLocaleCreateInput"];
	["ContractTypeLocaleCreateRootEntityRelationInput"]: ValueTypes["ContractTypeLocaleCreateRootEntityRelationInput"];
	["ContractTypeWithoutLocalesCreateInput"]: ValueTypes["ContractTypeWithoutLocalesCreateInput"];
	["ContractTypeLocaleConnectOrCreateRootRelationInput"]: ValueTypes["ContractTypeLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreateContractTypesRelationInput"]: ValueTypes["LocaleConnectOrCreateContractTypesRelationInput"];
	["LocaleCreateHomePagesEntityRelationInput"]: ValueTypes["LocaleCreateHomePagesEntityRelationInput"];
	["HomePageLocaleWithoutLocaleCreateInput"]: ValueTypes["HomePageLocaleWithoutLocaleCreateInput"];
	["HomePageLocaleCreateRootEntityRelationInput"]: ValueTypes["HomePageLocaleCreateRootEntityRelationInput"];
	["HomePageWithoutLocalesCreateInput"]: ValueTypes["HomePageWithoutLocalesCreateInput"];
	["HomePageCreateThemeEntityRelationInput"]: ValueTypes["HomePageCreateThemeEntityRelationInput"];
	["HomePageConnectOrCreateThemeRelationInput"]: ValueTypes["HomePageConnectOrCreateThemeRelationInput"];
	["HomePageLocaleConnectOrCreateRootRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateRootRelationInput"];
	["HomePageLocaleCreateButtonEntityRelationInput"]: ValueTypes["HomePageLocaleCreateButtonEntityRelationInput"];
	["HomePageLocaleConnectOrCreateButtonRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateButtonRelationInput"];
	["HomePageLocaleCreateContentEntityRelationInput"]: ValueTypes["HomePageLocaleCreateContentEntityRelationInput"];
	["HomePageLocaleConnectOrCreateContentRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateContentRelationInput"];
	["HomePageLocaleCreateSeoEntityRelationInput"]: ValueTypes["HomePageLocaleCreateSeoEntityRelationInput"];
	["HomePageLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateSeoRelationInput"];
	["HomePageLocaleCreateLinkEntityRelationInput"]: ValueTypes["HomePageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutHomePageCreateInput"]: ValueTypes["LinkableWithoutHomePageCreateInput"];
	["LinkableCreateJobPageEntityRelationInput"]: ValueTypes["LinkableCreateJobPageEntityRelationInput"];
	["JobPageLocaleWithoutLinkCreateInput"]: ValueTypes["JobPageLocaleWithoutLinkCreateInput"];
	["JobPageLocaleCreateImageEntityRelationInput"]: ValueTypes["JobPageLocaleCreateImageEntityRelationInput"];
	["JobPageLocaleConnectOrCreateImageRelationInput"]: ValueTypes["JobPageLocaleConnectOrCreateImageRelationInput"];
	["JobPageLocaleCreateKeyInfoEntityRelationInput"]: ValueTypes["JobPageLocaleCreateKeyInfoEntityRelationInput"];
	["KeyInfoListCreateInput"]: ValueTypes["KeyInfoListCreateInput"];
	["KeyInfoListCreateItemsEntityRelationInput"]: ValueTypes["KeyInfoListCreateItemsEntityRelationInput"];
	["KeyInfoItemWithoutListCreateInput"]: ValueTypes["KeyInfoItemWithoutListCreateInput"];
	["KeyInfoItemCreateIconEntityRelationInput"]: ValueTypes["KeyInfoItemCreateIconEntityRelationInput"];
	["IconUniqueWhere"]: ValueTypes["IconUniqueWhere"];
	["IconCreateInput"]: ValueTypes["IconCreateInput"];
	["IconCreateIconEntityRelationInput"]: ValueTypes["IconCreateIconEntityRelationInput"];
	["IconConnectOrCreateIconRelationInput"]: ValueTypes["IconConnectOrCreateIconRelationInput"];
	["KeyInfoItemConnectOrCreateIconRelationInput"]: ValueTypes["KeyInfoItemConnectOrCreateIconRelationInput"];
	["KeyInfoListConnectOrCreateItemsRelationInput"]: ValueTypes["KeyInfoListConnectOrCreateItemsRelationInput"];
	["JobPageLocaleConnectOrCreateKeyInfoRelationInput"]: ValueTypes["JobPageLocaleConnectOrCreateKeyInfoRelationInput"];
	["JobPageLocaleCreateContentEntityRelationInput"]: ValueTypes["JobPageLocaleCreateContentEntityRelationInput"];
	["JobPageLocaleConnectOrCreateContentRelationInput"]: ValueTypes["JobPageLocaleConnectOrCreateContentRelationInput"];
	["JobPageLocaleCreateSeoEntityRelationInput"]: ValueTypes["JobPageLocaleCreateSeoEntityRelationInput"];
	["JobPageLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["JobPageLocaleConnectOrCreateSeoRelationInput"];
	["JobPageLocaleCreateStickyBarEntityRelationInput"]: ValueTypes["JobPageLocaleCreateStickyBarEntityRelationInput"];
	["StickyBarUniqueWhere"]: ValueTypes["StickyBarUniqueWhere"];
	["StickyBarCreateInput"]: ValueTypes["StickyBarCreateInput"];
	["StickyBarCreateLinkEntityRelationInput"]: ValueTypes["StickyBarCreateLinkEntityRelationInput"];
	["StickyBarConnectOrCreateLinkRelationInput"]: ValueTypes["StickyBarConnectOrCreateLinkRelationInput"];
	["StickyBarCreateJobsFormEntityRelationInput"]: ValueTypes["StickyBarCreateJobsFormEntityRelationInput"];
	["JobsFormLocaleCreateInput"]: ValueTypes["JobsFormLocaleCreateInput"];
	["JobsFormLocaleCreateRootEntityRelationInput"]: ValueTypes["JobsFormLocaleCreateRootEntityRelationInput"];
	["JobsFormWithoutLocalesCreateInput"]: ValueTypes["JobsFormWithoutLocalesCreateInput"];
	["JobsFormCreateFileIlustrationEntityRelationInput"]: ValueTypes["JobsFormCreateFileIlustrationEntityRelationInput"];
	["JobsFormConnectOrCreateFileIlustrationRelationInput"]: ValueTypes["JobsFormConnectOrCreateFileIlustrationRelationInput"];
	["JobsFormLocaleConnectOrCreateRootRelationInput"]: ValueTypes["JobsFormLocaleConnectOrCreateRootRelationInput"];
	["JobsFormLocaleCreateLocaleEntityRelationInput"]: ValueTypes["JobsFormLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutJobsFormsCreateInput"]: ValueTypes["LocaleWithoutJobsFormsCreateInput"];
	["LocaleCreateBonusBannersEntityRelationInput"]: ValueTypes["LocaleCreateBonusBannersEntityRelationInput"];
	["BonusBannerLocaleWithoutLocaleCreateInput"]: ValueTypes["BonusBannerLocaleWithoutLocaleCreateInput"];
	["BonusBannerLocaleCreateTilesEntityRelationInput"]: ValueTypes["BonusBannerLocaleCreateTilesEntityRelationInput"];
	["TileWithoutBonusBannerCreateInput"]: ValueTypes["TileWithoutBonusBannerCreateInput"];
	["TileCreateImageEntityRelationInput"]: ValueTypes["TileCreateImageEntityRelationInput"];
	["TileConnectOrCreateImageRelationInput"]: ValueTypes["TileConnectOrCreateImageRelationInput"];
	["TileCreateLigthBoxMediaEntityRelationInput"]: ValueTypes["TileCreateLigthBoxMediaEntityRelationInput"];
	["TileConnectOrCreateLigthBoxMediaRelationInput"]: ValueTypes["TileConnectOrCreateLigthBoxMediaRelationInput"];
	["TileCreateLightBoxFormEntityRelationInput"]: ValueTypes["TileCreateLightBoxFormEntityRelationInput"];
	["TileConnectOrCreateLightBoxFormRelationInput"]: ValueTypes["TileConnectOrCreateLightBoxFormRelationInput"];
	["BonusBannerLocaleConnectOrCreateTilesRelationInput"]: ValueTypes["BonusBannerLocaleConnectOrCreateTilesRelationInput"];
	["BonusBannerLocaleCreateLogoEntityRelationInput"]: ValueTypes["BonusBannerLocaleCreateLogoEntityRelationInput"];
	["BonusBannerLocaleConnectOrCreateLogoRelationInput"]: ValueTypes["BonusBannerLocaleConnectOrCreateLogoRelationInput"];
	["LocaleConnectOrCreateBonusBannersRelationInput"]: ValueTypes["LocaleConnectOrCreateBonusBannersRelationInput"];
	["LocaleCreateHomePageLokalsEntityRelationInput"]: ValueTypes["LocaleCreateHomePageLokalsEntityRelationInput"];
	["HomePageLokalLocaleWithoutLocaleCreateInput"]: ValueTypes["HomePageLokalLocaleWithoutLocaleCreateInput"];
	["HomePageLokalLocaleCreateRootEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateRootEntityRelationInput"];
	["HomePageLokalWithoutLocalesCreateInput"]: ValueTypes["HomePageLokalWithoutLocalesCreateInput"];
	["HomePageLokalCreateThemeEntityRelationInput"]: ValueTypes["HomePageLokalCreateThemeEntityRelationInput"];
	["HomePageLokalConnectOrCreateThemeRelationInput"]: ValueTypes["HomePageLokalConnectOrCreateThemeRelationInput"];
	["HomePageLokalLocaleConnectOrCreateRootRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateRootRelationInput"];
	["HomePageLokalLocaleCreateLogoEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateLogoEntityRelationInput"];
	["HomePageLokalLocaleConnectOrCreateLogoRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateLogoRelationInput"];
	["HomePageLokalLocaleCreateButtonEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateButtonEntityRelationInput"];
	["HomePageLokalLocaleConnectOrCreateButtonRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateButtonRelationInput"];
	["HomePageLokalLocaleCreateContentEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateContentEntityRelationInput"];
	["HomePageLokalLocaleConnectOrCreateContentRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateContentRelationInput"];
	["HomePageLokalLocaleCreateSeoEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateSeoEntityRelationInput"];
	["HomePageLokalLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateSeoRelationInput"];
	["HomePageLokalLocaleCreateLinkEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutHomePageLokalCreateInput"]: ValueTypes["LinkableWithoutHomePageLokalCreateInput"];
	["LinkableCreateHomePageEntityRelationInput"]: ValueTypes["LinkableCreateHomePageEntityRelationInput"];
	["HomePageLocaleWithoutLinkCreateInput"]: ValueTypes["HomePageLocaleWithoutLinkCreateInput"];
	["HomePageLocaleCreateLocaleEntityRelationInput"]: ValueTypes["HomePageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutHomePagesCreateInput"]: ValueTypes["LocaleWithoutHomePagesCreateInput"];
	["LocaleCreateJobsFormsEntityRelationInput"]: ValueTypes["LocaleCreateJobsFormsEntityRelationInput"];
	["JobsFormLocaleWithoutLocaleCreateInput"]: ValueTypes["JobsFormLocaleWithoutLocaleCreateInput"];
	["JobsFormLocaleCreateImageTextListEntityRelationInput"]: ValueTypes["JobsFormLocaleCreateImageTextListEntityRelationInput"];
	["ImageTextListCreateInput"]: ValueTypes["ImageTextListCreateInput"];
	["ImageTextListCreateItemsEntityRelationInput"]: ValueTypes["ImageTextListCreateItemsEntityRelationInput"];
	["ImageTextItemWithoutListCreateInput"]: ValueTypes["ImageTextItemWithoutListCreateInput"];
	["ImageTextItemCreateImageEntityRelationInput"]: ValueTypes["ImageTextItemCreateImageEntityRelationInput"];
	["ImageTextItemConnectOrCreateImageRelationInput"]: ValueTypes["ImageTextItemConnectOrCreateImageRelationInput"];
	["ImageTextListConnectOrCreateItemsRelationInput"]: ValueTypes["ImageTextListConnectOrCreateItemsRelationInput"];
	["JobsFormLocaleConnectOrCreateImageTextListRelationInput"]: ValueTypes["JobsFormLocaleConnectOrCreateImageTextListRelationInput"];
	["JobsFormLocaleCreateLogoEntityRelationInput"]: ValueTypes["JobsFormLocaleCreateLogoEntityRelationInput"];
	["JobsFormLocaleConnectOrCreateLogoRelationInput"]: ValueTypes["JobsFormLocaleConnectOrCreateLogoRelationInput"];
	["JobsFormLocaleCreateSuccessImageEntityRelationInput"]: ValueTypes["JobsFormLocaleCreateSuccessImageEntityRelationInput"];
	["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"]: ValueTypes["JobsFormLocaleConnectOrCreateSuccessImageRelationInput"];
	["LocaleConnectOrCreateJobsFormsRelationInput"]: ValueTypes["LocaleConnectOrCreateJobsFormsRelationInput"];
	["LocaleCreateJobsFiltersEntityRelationInput"]: ValueTypes["LocaleCreateJobsFiltersEntityRelationInput"];
	["JobsFilterLocaleWithoutLocaleCreateInput"]: ValueTypes["JobsFilterLocaleWithoutLocaleCreateInput"];
	["JobsFilterLocaleCreateRootEntityRelationInput"]: ValueTypes["JobsFilterLocaleCreateRootEntityRelationInput"];
	["JobsFilterWithoutLocalesCreateInput"]: ValueTypes["JobsFilterWithoutLocalesCreateInput"];
	["JobsFilterLocaleConnectOrCreateRootRelationInput"]: ValueTypes["JobsFilterLocaleConnectOrCreateRootRelationInput"];
	["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"]: ValueTypes["JobsFilterLocaleCreateBannerJobsFormEntityRelationInput"];
	["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"]: ValueTypes["JobsFilterLocaleConnectOrCreateBannerJobsFormRelationInput"];
	["JobsFilterLocaleCreateBannerImageEntityRelationInput"]: ValueTypes["JobsFilterLocaleCreateBannerImageEntityRelationInput"];
	["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"]: ValueTypes["JobsFilterLocaleConnectOrCreateBannerImageRelationInput"];
	["JobsFilterLocaleCreateNoJobImageEntityRelationInput"]: ValueTypes["JobsFilterLocaleCreateNoJobImageEntityRelationInput"];
	["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"]: ValueTypes["JobsFilterLocaleConnectOrCreateNoJobImageRelationInput"];
	["LocaleConnectOrCreateJobsFiltersRelationInput"]: ValueTypes["LocaleConnectOrCreateJobsFiltersRelationInput"];
	["LocaleCreateGeneralEntityRelationInput"]: ValueTypes["LocaleCreateGeneralEntityRelationInput"];
	["GeneralLocaleWithoutLocaleCreateInput"]: ValueTypes["GeneralLocaleWithoutLocaleCreateInput"];
	["GeneralLocaleCreateRootEntityRelationInput"]: ValueTypes["GeneralLocaleCreateRootEntityRelationInput"];
	["GeneralWithoutLocalesCreateInput"]: ValueTypes["GeneralWithoutLocalesCreateInput"];
	["GeneralLocaleConnectOrCreateRootRelationInput"]: ValueTypes["GeneralLocaleConnectOrCreateRootRelationInput"];
	["GeneralLocaleCreateSeoEntityRelationInput"]: ValueTypes["GeneralLocaleCreateSeoEntityRelationInput"];
	["GeneralLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["GeneralLocaleConnectOrCreateSeoRelationInput"];
	["GeneralLocaleCreateCornerBannerEntityRelationInput"]: ValueTypes["GeneralLocaleCreateCornerBannerEntityRelationInput"];
	["CornerBannerCreateInput"]: ValueTypes["CornerBannerCreateInput"];
	["CornerBannerCreateLogoEntityRelationInput"]: ValueTypes["CornerBannerCreateLogoEntityRelationInput"];
	["CornerBannerConnectOrCreateLogoRelationInput"]: ValueTypes["CornerBannerConnectOrCreateLogoRelationInput"];
	["CornerBannerCreateLinkEntityRelationInput"]: ValueTypes["CornerBannerCreateLinkEntityRelationInput"];
	["CornerBannerConnectOrCreateLinkRelationInput"]: ValueTypes["CornerBannerConnectOrCreateLinkRelationInput"];
	["GeneralLocaleConnectOrCreateCornerBannerRelationInput"]: ValueTypes["GeneralLocaleConnectOrCreateCornerBannerRelationInput"];
	["LocaleConnectOrCreateGeneralRelationInput"]: ValueTypes["LocaleConnectOrCreateGeneralRelationInput"];
	["LocaleCreateRecommendationFormsEntityRelationInput"]: ValueTypes["LocaleCreateRecommendationFormsEntityRelationInput"];
	["RecommendationFormLocaleWithoutLocaleCreateInput"]: ValueTypes["RecommendationFormLocaleWithoutLocaleCreateInput"];
	["RecommendationFormLocaleCreateRootEntityRelationInput"]: ValueTypes["RecommendationFormLocaleCreateRootEntityRelationInput"];
	["RecommendationFormWithoutLocalesCreateInput"]: ValueTypes["RecommendationFormWithoutLocalesCreateInput"];
	["RecommendationFormCreateSuccessImageEntityRelationInput"]: ValueTypes["RecommendationFormCreateSuccessImageEntityRelationInput"];
	["RecommendationFormConnectOrCreateSuccessImageRelationInput"]: ValueTypes["RecommendationFormConnectOrCreateSuccessImageRelationInput"];
	["RecommendationFormLocaleConnectOrCreateRootRelationInput"]: ValueTypes["RecommendationFormLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreateRecommendationFormsRelationInput"]: ValueTypes["LocaleConnectOrCreateRecommendationFormsRelationInput"];
	["LocaleCreateInfoBoxesEntityRelationInput"]: ValueTypes["LocaleCreateInfoBoxesEntityRelationInput"];
	["InfoBoxLocaleWithoutLocaleCreateInput"]: ValueTypes["InfoBoxLocaleWithoutLocaleCreateInput"];
	["InfoBoxLocaleCreateRootEntityRelationInput"]: ValueTypes["InfoBoxLocaleCreateRootEntityRelationInput"];
	["InfoBoxWithoutLocalesCreateInput"]: ValueTypes["InfoBoxWithoutLocalesCreateInput"];
	["InfoBoxCreateLogoEntityRelationInput"]: ValueTypes["InfoBoxCreateLogoEntityRelationInput"];
	["InfoBoxConnectOrCreateLogoRelationInput"]: ValueTypes["InfoBoxConnectOrCreateLogoRelationInput"];
	["InfoBoxLocaleConnectOrCreateRootRelationInput"]: ValueTypes["InfoBoxLocaleConnectOrCreateRootRelationInput"];
	["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"]: ValueTypes["InfoBoxLocaleCreateOpeningHoursEntityRelationInput"];
	["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"]: ValueTypes["InfoBoxLocaleConnectOrCreateOpeningHoursRelationInput"];
	["LocaleConnectOrCreateInfoBoxesRelationInput"]: ValueTypes["LocaleConnectOrCreateInfoBoxesRelationInput"];
	["LocaleCreateTranslationsEntityRelationInput"]: ValueTypes["LocaleCreateTranslationsEntityRelationInput"];
	["TranslationLocaleWithoutLocaleCreateInput"]: ValueTypes["TranslationLocaleWithoutLocaleCreateInput"];
	["TranslationLocaleCreateRootEntityRelationInput"]: ValueTypes["TranslationLocaleCreateRootEntityRelationInput"];
	["TranslationWithoutLocalesCreateInput"]: ValueTypes["TranslationWithoutLocalesCreateInput"];
	["TranslationLocaleConnectOrCreateRootRelationInput"]: ValueTypes["TranslationLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreateTranslationsRelationInput"]: ValueTypes["LocaleConnectOrCreateTranslationsRelationInput"];
	["HomePageLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateLocaleRelationInput"];
	["HomePageLocaleCreateLogoEntityRelationInput"]: ValueTypes["HomePageLocaleCreateLogoEntityRelationInput"];
	["HomePageLocaleConnectOrCreateLogoRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateLogoRelationInput"];
	["HomePageLocaleCreateSiteSwitcherEntityRelationInput"]: ValueTypes["HomePageLocaleCreateSiteSwitcherEntityRelationInput"];
	["SiteSwitcherCreateInput"]: ValueTypes["SiteSwitcherCreateInput"];
	["SiteSwitcherCreateLinkEntityRelationInput"]: ValueTypes["SiteSwitcherCreateLinkEntityRelationInput"];
	["SiteSwitcherConnectOrCreateLinkRelationInput"]: ValueTypes["SiteSwitcherConnectOrCreateLinkRelationInput"];
	["SiteSwitcherCreateThemeEntityRelationInput"]: ValueTypes["SiteSwitcherCreateThemeEntityRelationInput"];
	["SiteSwitcherConnectOrCreateThemeRelationInput"]: ValueTypes["SiteSwitcherConnectOrCreateThemeRelationInput"];
	["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateSiteSwitcherRelationInput"];
	["HomePageLocaleCreateGalleryEntityRelationInput"]: ValueTypes["HomePageLocaleCreateGalleryEntityRelationInput"];
	["GalleryCreateInput"]: ValueTypes["GalleryCreateInput"];
	["GalleryCreateItemsEntityRelationInput"]: ValueTypes["GalleryCreateItemsEntityRelationInput"];
	["GalleryItemWithoutListCreateInput"]: ValueTypes["GalleryItemWithoutListCreateInput"];
	["GalleryItemCreateImageEntityRelationInput"]: ValueTypes["GalleryItemCreateImageEntityRelationInput"];
	["GalleryItemConnectOrCreateImageRelationInput"]: ValueTypes["GalleryItemConnectOrCreateImageRelationInput"];
	["GalleryConnectOrCreateItemsRelationInput"]: ValueTypes["GalleryConnectOrCreateItemsRelationInput"];
	["HomePageLocaleConnectOrCreateGalleryRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateGalleryRelationInput"];
	["HomePageLocaleCreateStickyBarEntityRelationInput"]: ValueTypes["HomePageLocaleCreateStickyBarEntityRelationInput"];
	["HomePageLocaleConnectOrCreateStickyBarRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateStickyBarRelationInput"];
	["HomePageLocaleCreateIlustrationEntityRelationInput"]: ValueTypes["HomePageLocaleCreateIlustrationEntityRelationInput"];
	["HomePageLocaleConnectOrCreateIlustrationRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateIlustrationRelationInput"];
	["LinkableConnectOrCreateHomePageRelationInput"]: ValueTypes["LinkableConnectOrCreateHomePageRelationInput"];
	["HomePageLokalLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateLinkRelationInput"];
	["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateSiteSwitcherEntityRelationInput"];
	["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateSiteSwitcherRelationInput"];
	["HomePageLokalLocaleCreateGalleryEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateGalleryEntityRelationInput"];
	["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateGalleryRelationInput"];
	["HomePageLokalLocaleCreateStickyBarEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateStickyBarEntityRelationInput"];
	["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateStickyBarRelationInput"];
	["HomePageLokalLocaleCreateIlustrationEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateIlustrationEntityRelationInput"];
	["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateIlustrationRelationInput"];
	["LocaleConnectOrCreateHomePageLokalsRelationInput"]: ValueTypes["LocaleConnectOrCreateHomePageLokalsRelationInput"];
	["JobsFormLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["JobsFormLocaleConnectOrCreateLocaleRelationInput"];
	["StickyBarConnectOrCreateJobsFormRelationInput"]: ValueTypes["StickyBarConnectOrCreateJobsFormRelationInput"];
	["JobPageLocaleConnectOrCreateStickyBarRelationInput"]: ValueTypes["JobPageLocaleConnectOrCreateStickyBarRelationInput"];
	["JobPageLocaleCreateMobileImageEntityRelationInput"]: ValueTypes["JobPageLocaleCreateMobileImageEntityRelationInput"];
	["JobPageLocaleConnectOrCreateMobileImageRelationInput"]: ValueTypes["JobPageLocaleConnectOrCreateMobileImageRelationInput"];
	["LinkableConnectOrCreateJobPageRelationInput"]: ValueTypes["LinkableConnectOrCreateJobPageRelationInput"];
	["LinkableCreateHomePageLokalEntityRelationInput"]: ValueTypes["LinkableCreateHomePageLokalEntityRelationInput"];
	["HomePageLokalLocaleWithoutLinkCreateInput"]: ValueTypes["HomePageLokalLocaleWithoutLinkCreateInput"];
	["HomePageLokalLocaleCreateLocaleEntityRelationInput"]: ValueTypes["HomePageLokalLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutHomePageLokalsCreateInput"]: ValueTypes["LocaleWithoutHomePageLokalsCreateInput"];
	["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["HomePageLokalLocaleConnectOrCreateLocaleRelationInput"];
	["LinkableConnectOrCreateHomePageLokalRelationInput"]: ValueTypes["LinkableConnectOrCreateHomePageLokalRelationInput"];
	["HomePageLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["HomePageLocaleConnectOrCreateLinkRelationInput"];
	["LocaleConnectOrCreateHomePagesRelationInput"]: ValueTypes["LocaleConnectOrCreateHomePagesRelationInput"];
	["JobPageLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["JobPageLocaleConnectOrCreateLocaleRelationInput"];
	["JobPageLocaleCreateLinkEntityRelationInput"]: ValueTypes["JobPageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutJobPageCreateInput"]: ValueTypes["LinkableWithoutJobPageCreateInput"];
	["JobPageLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["JobPageLocaleConnectOrCreateLinkRelationInput"];
	["JobPageConnectOrCreateLocalesRelationInput"]: ValueTypes["JobPageConnectOrCreateLocalesRelationInput"];
	["JobPageCreateJobCityEntityRelationInput"]: ValueTypes["JobPageCreateJobCityEntityRelationInput"];
	["JobCityCreateInput"]: ValueTypes["JobCityCreateInput"];
	["JobCityCreateLocalesEntityRelationInput"]: ValueTypes["JobCityCreateLocalesEntityRelationInput"];
	["JobCityLocaleWithoutRootCreateInput"]: ValueTypes["JobCityLocaleWithoutRootCreateInput"];
	["JobCityLocaleCreateLocaleEntityRelationInput"]: ValueTypes["JobCityLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutJobCitiesCreateInput"]: ValueTypes["LocaleWithoutJobCitiesCreateInput"];
	["JobCityLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["JobCityLocaleConnectOrCreateLocaleRelationInput"];
	["JobCityConnectOrCreateLocalesRelationInput"]: ValueTypes["JobCityConnectOrCreateLocalesRelationInput"];
	["JobPageConnectOrCreateJobCityRelationInput"]: ValueTypes["JobPageConnectOrCreateJobCityRelationInput"];
	["JobPageCreateBusinessEntityRelationInput"]: ValueTypes["JobPageCreateBusinessEntityRelationInput"];
	["BusinessPageCreateInput"]: ValueTypes["BusinessPageCreateInput"];
	["BusinessPageCreateLocalesEntityRelationInput"]: ValueTypes["BusinessPageCreateLocalesEntityRelationInput"];
	["BusinessPageLocaleWithoutRootCreateInput"]: ValueTypes["BusinessPageLocaleWithoutRootCreateInput"];
	["BusinessPageLocaleCreateSeoEntityRelationInput"]: ValueTypes["BusinessPageLocaleCreateSeoEntityRelationInput"];
	["BusinessPageLocaleConnectOrCreateSeoRelationInput"]: ValueTypes["BusinessPageLocaleConnectOrCreateSeoRelationInput"];
	["BusinessPageLocaleCreateLinkEntityRelationInput"]: ValueTypes["BusinessPageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutBusinessPageCreateInput"]: ValueTypes["LinkableWithoutBusinessPageCreateInput"];
	["BusinessPageLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["BusinessPageLocaleConnectOrCreateLinkRelationInput"];
	["BusinessPageLocaleCreateImageEntityRelationInput"]: ValueTypes["BusinessPageLocaleCreateImageEntityRelationInput"];
	["BusinessPageLocaleConnectOrCreateImageRelationInput"]: ValueTypes["BusinessPageLocaleConnectOrCreateImageRelationInput"];
	["BusinessPageLocaleCreateStickyBarEntityRelationInput"]: ValueTypes["BusinessPageLocaleCreateStickyBarEntityRelationInput"];
	["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"]: ValueTypes["BusinessPageLocaleConnectOrCreateStickyBarRelationInput"];
	["BusinessPageLocaleCreateInfoBoxEntityRelationInput"]: ValueTypes["BusinessPageLocaleCreateInfoBoxEntityRelationInput"];
	["InfoBoxCreateInput"]: ValueTypes["InfoBoxCreateInput"];
	["InfoBoxCreateLocalesEntityRelationInput"]: ValueTypes["InfoBoxCreateLocalesEntityRelationInput"];
	["InfoBoxLocaleWithoutRootCreateInput"]: ValueTypes["InfoBoxLocaleWithoutRootCreateInput"];
	["InfoBoxLocaleCreateLocaleEntityRelationInput"]: ValueTypes["InfoBoxLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutInfoBoxesCreateInput"]: ValueTypes["LocaleWithoutInfoBoxesCreateInput"];
	["InfoBoxLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["InfoBoxLocaleConnectOrCreateLocaleRelationInput"];
	["InfoBoxConnectOrCreateLocalesRelationInput"]: ValueTypes["InfoBoxConnectOrCreateLocalesRelationInput"];
	["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"]: ValueTypes["BusinessPageLocaleConnectOrCreateInfoBoxRelationInput"];
	["BusinessPageConnectOrCreateLocalesRelationInput"]: ValueTypes["BusinessPageConnectOrCreateLocalesRelationInput"];
	["JobPageConnectOrCreateBusinessRelationInput"]: ValueTypes["JobPageConnectOrCreateBusinessRelationInput"];
	["JobPositionConnectOrCreateJobsRelationInput"]: ValueTypes["JobPositionConnectOrCreateJobsRelationInput"];
	["JobPositionLocaleConnectOrCreateRootRelationInput"]: ValueTypes["JobPositionLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreateJobPositionsRelationInput"]: ValueTypes["LocaleConnectOrCreateJobPositionsRelationInput"];
	["ContractTypeLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["ContractTypeLocaleConnectOrCreateLocaleRelationInput"];
	["ContractTypeConnectOrCreateLocalesRelationInput"]: ValueTypes["ContractTypeConnectOrCreateLocalesRelationInput"];
	["JobPageConnectOrCreateContractTypeRelationInput"]: ValueTypes["JobPageConnectOrCreateContractTypeRelationInput"];
	["JobPageCreateJobPositionEntityRelationInput"]: ValueTypes["JobPageCreateJobPositionEntityRelationInput"];
	["JobPositionWithoutJobsCreateInput"]: ValueTypes["JobPositionWithoutJobsCreateInput"];
	["JobPositionCreateLocalesEntityRelationInput"]: ValueTypes["JobPositionCreateLocalesEntityRelationInput"];
	["JobPositionLocaleWithoutRootCreateInput"]: ValueTypes["JobPositionLocaleWithoutRootCreateInput"];
	["JobPositionLocaleCreateLocaleEntityRelationInput"]: ValueTypes["JobPositionLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutJobPositionsCreateInput"]: ValueTypes["LocaleWithoutJobPositionsCreateInput"];
	["JobPositionLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["JobPositionLocaleConnectOrCreateLocaleRelationInput"];
	["JobPositionConnectOrCreateLocalesRelationInput"]: ValueTypes["JobPositionConnectOrCreateLocalesRelationInput"];
	["JobPageConnectOrCreateJobPositionRelationInput"]: ValueTypes["JobPageConnectOrCreateJobPositionRelationInput"];
	["JobPageLocaleConnectOrCreateRootRelationInput"]: ValueTypes["JobPageLocaleConnectOrCreateRootRelationInput"];
	["LocaleConnectOrCreateJobPagesRelationInput"]: ValueTypes["LocaleConnectOrCreateJobPagesRelationInput"];
	["BusinessPageLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["BusinessPageLocaleConnectOrCreateLocaleRelationInput"];
	["LinkableConnectOrCreateBusinessPageRelationInput"]: ValueTypes["LinkableConnectOrCreateBusinessPageRelationInput"];
	["GenericPageLocaleConnectOrCreateLinkRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateLinkRelationInput"];
	["GenericPageLocaleCreateLogoEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateLogoEntityRelationInput"];
	["GenericPageLocaleConnectOrCreateLogoRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateLogoRelationInput"];
	["GenericPageLocaleCreateImageEntityRelationInput"]: ValueTypes["GenericPageLocaleCreateImageEntityRelationInput"];
	["GenericPageLocaleConnectOrCreateImageRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateImageRelationInput"];
	["LocaleConnectOrCreateGenericPagesRelationInput"]: ValueTypes["LocaleConnectOrCreateGenericPagesRelationInput"];
	["BonusBannerLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["BonusBannerLocaleConnectOrCreateLocaleRelationInput"];
	["ContentReferenceConnectOrCreateBonusBannerRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateBonusBannerRelationInput"];
	["ContentReferenceCreateSideBySideEntityRelationInput"]: ValueTypes["ContentReferenceCreateSideBySideEntityRelationInput"];
	["SideBySideUniqueWhere"]: ValueTypes["SideBySideUniqueWhere"];
	["SideBySideItemUniqueWhere"]: ValueTypes["SideBySideItemUniqueWhere"];
	["SideBySideCreateInput"]: ValueTypes["SideBySideCreateInput"];
	["SideBySideCreateItemsEntityRelationInput"]: ValueTypes["SideBySideCreateItemsEntityRelationInput"];
	["SideBySideItemWithoutListCreateInput"]: ValueTypes["SideBySideItemWithoutListCreateInput"];
	["SideBySideItemCreateMediaEntityRelationInput"]: ValueTypes["SideBySideItemCreateMediaEntityRelationInput"];
	["SideBySideItemConnectOrCreateMediaRelationInput"]: ValueTypes["SideBySideItemConnectOrCreateMediaRelationInput"];
	["SideBySideItemCreateLinkEntityRelationInput"]: ValueTypes["SideBySideItemCreateLinkEntityRelationInput"];
	["SideBySideItemConnectOrCreateLinkRelationInput"]: ValueTypes["SideBySideItemConnectOrCreateLinkRelationInput"];
	["SideBySideItemCreateJobsFormEntityRelationInput"]: ValueTypes["SideBySideItemCreateJobsFormEntityRelationInput"];
	["SideBySideItemConnectOrCreateJobsFormRelationInput"]: ValueTypes["SideBySideItemConnectOrCreateJobsFormRelationInput"];
	["SideBySideConnectOrCreateItemsRelationInput"]: ValueTypes["SideBySideConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateSideBySideRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateSideBySideRelationInput"];
	["ContentReferenceCreateGalleryEntityRelationInput"]: ValueTypes["ContentReferenceCreateGalleryEntityRelationInput"];
	["ContentReferenceConnectOrCreateGalleryRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateGalleryRelationInput"];
	["ContentReferenceCreateVideoEntityRelationInput"]: ValueTypes["ContentReferenceCreateVideoEntityRelationInput"];
	["ContentReferenceConnectOrCreateVideoRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateVideoRelationInput"];
	["ContentBlockConnectOrCreateReferencesRelationInput"]: ValueTypes["ContentBlockConnectOrCreateReferencesRelationInput"];
	["ContentConnectOrCreateBlocksRelationInput"]: ValueTypes["ContentConnectOrCreateBlocksRelationInput"];
	["BusinessPageLocaleConnectOrCreateContentRelationInput"]: ValueTypes["BusinessPageLocaleConnectOrCreateContentRelationInput"];
	["LocaleConnectOrCreateBusinessPagesRelationInput"]: ValueTypes["LocaleConnectOrCreateBusinessPagesRelationInput"];
	["GenericPageLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["GenericPageLocaleConnectOrCreateLocaleRelationInput"];
	["LinkableConnectOrCreateGenericPageRelationInput"]: ValueTypes["LinkableConnectOrCreateGenericPageRelationInput"];
	["LinkConnectOrCreateInternalLinkRelationInput"]: ValueTypes["LinkConnectOrCreateInternalLinkRelationInput"];
	["FooterLinkConnectOrCreateLinkRelationInput"]: ValueTypes["FooterLinkConnectOrCreateLinkRelationInput"];
	["FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateLinksFirstColumnRelationInput"];
	["FooterLocaleCreateLinksSecondColumnEntityRelationInput"]: ValueTypes["FooterLocaleCreateLinksSecondColumnEntityRelationInput"];
	["FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateLinksSecondColumnRelationInput"];
	["FooterLocaleCreateTermsAndConditionsEntityRelationInput"]: ValueTypes["FooterLocaleCreateTermsAndConditionsEntityRelationInput"];
	["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateTermsAndConditionsRelationInput"];
	["FooterLocaleCreateBannerImageEntityRelationInput"]: ValueTypes["FooterLocaleCreateBannerImageEntityRelationInput"];
	["FooterLocaleConnectOrCreateBannerImageRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateBannerImageRelationInput"];
	["FooterLocaleCreateBannerLinkEntityRelationInput"]: ValueTypes["FooterLocaleCreateBannerLinkEntityRelationInput"];
	["FooterLocaleConnectOrCreateBannerLinkRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateBannerLinkRelationInput"];
	["FooterLocaleCreateJobsFormEntityRelationInput"]: ValueTypes["FooterLocaleCreateJobsFormEntityRelationInput"];
	["FooterLocaleConnectOrCreateJobsFormRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateJobsFormRelationInput"];
	["FooterLocaleCreateCopyrightLinkEntityRelationInput"]: ValueTypes["FooterLocaleCreateCopyrightLinkEntityRelationInput"];
	["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateCopyrightLinkRelationInput"];
	["FooterLocaleCreateRecommendationFormEntityRelationInput"]: ValueTypes["FooterLocaleCreateRecommendationFormEntityRelationInput"];
	["RecommendationFormLocaleCreateInput"]: ValueTypes["RecommendationFormLocaleCreateInput"];
	["RecommendationFormLocaleCreateLocaleEntityRelationInput"]: ValueTypes["RecommendationFormLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutRecommendationFormsCreateInput"]: ValueTypes["LocaleWithoutRecommendationFormsCreateInput"];
	["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["RecommendationFormLocaleConnectOrCreateLocaleRelationInput"];
	["FooterLocaleConnectOrCreateRecommendationFormRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateRecommendationFormRelationInput"];
	["FooterLocaleCreateBannerSecondLinkEntityRelationInput"]: ValueTypes["FooterLocaleCreateBannerSecondLinkEntityRelationInput"];
	["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateBannerSecondLinkRelationInput"];
	["FooterLocaleCreateInstagramLinkEntityRelationInput"]: ValueTypes["FooterLocaleCreateInstagramLinkEntityRelationInput"];
	["FooterLocaleConnectOrCreateInstagramLinkRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateInstagramLinkRelationInput"];
	["LocaleConnectOrCreateFootersRelationInput"]: ValueTypes["LocaleConnectOrCreateFootersRelationInput"];
	["GeneralLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["GeneralLocaleConnectOrCreateLocaleRelationInput"];
	["GeneralConnectOrCreateLocalesRelationInput"]: ValueTypes["GeneralConnectOrCreateLocalesRelationInput"];
	["GeneralUpdateInput"]: ValueTypes["GeneralUpdateInput"];
	["GeneralUpdateLocalesEntityRelationInput"]: ValueTypes["GeneralUpdateLocalesEntityRelationInput"];
	["GeneralUpdateLocalesRelationInput"]: ValueTypes["GeneralUpdateLocalesRelationInput"];
	["GeneralLocaleWithoutRootUpdateInput"]: ValueTypes["GeneralLocaleWithoutRootUpdateInput"];
	["GeneralLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["GeneralLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutGeneralUpdateInput"]: ValueTypes["LocaleWithoutGeneralUpdateInput"];
	["LocaleUpdateFootersEntityRelationInput"]: ValueTypes["LocaleUpdateFootersEntityRelationInput"];
	["LocaleUpdateFootersRelationInput"]: ValueTypes["LocaleUpdateFootersRelationInput"];
	["FooterLocaleWithoutLocaleUpdateInput"]: ValueTypes["FooterLocaleWithoutLocaleUpdateInput"];
	["FooterLocaleUpdateRootEntityRelationInput"]: ValueTypes["FooterLocaleUpdateRootEntityRelationInput"];
	["FooterWithoutLocalesUpdateInput"]: ValueTypes["FooterWithoutLocalesUpdateInput"];
	["FooterLocaleUpsertRootRelationInput"]: ValueTypes["FooterLocaleUpsertRootRelationInput"];
	["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"]: ValueTypes["FooterLocaleUpdateLinksFirstColumnEntityRelationInput"];
	["FooterLocaleUpdateLinksFirstColumnRelationInput"]: ValueTypes["FooterLocaleUpdateLinksFirstColumnRelationInput"];
	["FooterLinkUpdateInput"]: ValueTypes["FooterLinkUpdateInput"];
	["FooterLinkUpdateLinkEntityRelationInput"]: ValueTypes["FooterLinkUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: ValueTypes["LinkUpdateInput"];
	["LinkUpdateInternalLinkEntityRelationInput"]: ValueTypes["LinkUpdateInternalLinkEntityRelationInput"];
	["LinkableUpdateInput"]: ValueTypes["LinkableUpdateInput"];
	["LinkableUpdateRedirectEntityRelationInput"]: ValueTypes["LinkableUpdateRedirectEntityRelationInput"];
	["RedirectWithoutLinkUpdateInput"]: ValueTypes["RedirectWithoutLinkUpdateInput"];
	["RedirectUpdateTargetEntityRelationInput"]: ValueTypes["RedirectUpdateTargetEntityRelationInput"];
	["RedirectUpsertTargetRelationInput"]: ValueTypes["RedirectUpsertTargetRelationInput"];
	["LinkableUpsertRedirectRelationInput"]: ValueTypes["LinkableUpsertRedirectRelationInput"];
	["LinkableUpdateGenericPageEntityRelationInput"]: ValueTypes["LinkableUpdateGenericPageEntityRelationInput"];
	["GenericPageLocaleWithoutLinkUpdateInput"]: ValueTypes["GenericPageLocaleWithoutLinkUpdateInput"];
	["GenericPageLocaleUpdateRootEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateRootEntityRelationInput"];
	["GenericPageWithoutLocalesUpdateInput"]: ValueTypes["GenericPageWithoutLocalesUpdateInput"];
	["GenericPageUpdateThemeEntityRelationInput"]: ValueTypes["GenericPageUpdateThemeEntityRelationInput"];
	["ThemeUpdateInput"]: ValueTypes["ThemeUpdateInput"];
	["GenericPageUpsertThemeRelationInput"]: ValueTypes["GenericPageUpsertThemeRelationInput"];
	["GenericPageLocaleUpsertRootRelationInput"]: ValueTypes["GenericPageLocaleUpsertRootRelationInput"];
	["GenericPageLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutGenericPagesUpdateInput"]: ValueTypes["LocaleWithoutGenericPagesUpdateInput"];
	["LocaleUpdateHeadersEntityRelationInput"]: ValueTypes["LocaleUpdateHeadersEntityRelationInput"];
	["LocaleUpdateHeadersRelationInput"]: ValueTypes["LocaleUpdateHeadersRelationInput"];
	["HeaderLocaleWithoutLocaleUpdateInput"]: ValueTypes["HeaderLocaleWithoutLocaleUpdateInput"];
	["HeaderLocaleUpdateRootEntityRelationInput"]: ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"];
	["HeaderWithoutLocalesUpdateInput"]: ValueTypes["HeaderWithoutLocalesUpdateInput"];
	["HeaderUpdateLogoEntityRelationInput"]: ValueTypes["HeaderUpdateLogoEntityRelationInput"];
	["ImageUpdateInput"]: ValueTypes["ImageUpdateInput"];
	["HeaderUpsertLogoRelationInput"]: ValueTypes["HeaderUpsertLogoRelationInput"];
	["HeaderUpdateLogoMenuEntityRelationInput"]: ValueTypes["HeaderUpdateLogoMenuEntityRelationInput"];
	["HeaderUpsertLogoMenuRelationInput"]: ValueTypes["HeaderUpsertLogoMenuRelationInput"];
	["HeaderLocaleUpsertRootRelationInput"]: ValueTypes["HeaderLocaleUpsertRootRelationInput"];
	["HeaderLocaleUpdateBusinessEntityRelationInput"]: ValueTypes["HeaderLocaleUpdateBusinessEntityRelationInput"];
	["HeaderLocaleUpdateBusinessRelationInput"]: ValueTypes["HeaderLocaleUpdateBusinessRelationInput"];
	["BusinessUpdateInput"]: ValueTypes["BusinessUpdateInput"];
	["BusinessUpdateLogoEntityRelationInput"]: ValueTypes["BusinessUpdateLogoEntityRelationInput"];
	["BusinessUpsertLogoRelationInput"]: ValueTypes["BusinessUpsertLogoRelationInput"];
	["BusinessUpdateLinkEntityRelationInput"]: ValueTypes["BusinessUpdateLinkEntityRelationInput"];
	["BusinessUpsertLinkRelationInput"]: ValueTypes["BusinessUpsertLinkRelationInput"];
	["HeaderLocaleUpsertBusinessRelationInput"]: ValueTypes["HeaderLocaleUpsertBusinessRelationInput"];
	["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"]: ValueTypes["HeaderLocaleUpdateLokalEnterpriseEntityRelationInput"];
	["HeaderLocaleUpdateLokalEnterpriseRelationInput"]: ValueTypes["HeaderLocaleUpdateLokalEnterpriseRelationInput"];
	["HeaderLocaleUpsertLokalEnterpriseRelationInput"]: ValueTypes["HeaderLocaleUpsertLokalEnterpriseRelationInput"];
	["HeaderLocaleUpdateBusinessLinkEntityRelationInput"]: ValueTypes["HeaderLocaleUpdateBusinessLinkEntityRelationInput"];
	["HeaderLocaleUpsertBusinessLinkRelationInput"]: ValueTypes["HeaderLocaleUpsertBusinessLinkRelationInput"];
	["HeaderLocaleUpdateLokalLinkEntityRelationInput"]: ValueTypes["HeaderLocaleUpdateLokalLinkEntityRelationInput"];
	["HeaderLocaleUpsertLokalLinkRelationInput"]: ValueTypes["HeaderLocaleUpsertLokalLinkRelationInput"];
	["LocaleUpsertHeadersRelationInput"]: ValueTypes["LocaleUpsertHeadersRelationInput"];
	["LocaleUpdateSeoDefaultsEntityRelationInput"]: ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"];
	["LocaleUpdateSeoDefaultsRelationInput"]: ValueTypes["LocaleUpdateSeoDefaultsRelationInput"];
	["SeoDefaultLocaleWithoutLocaleUpdateInput"]: ValueTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"];
	["SeoDefaultLocaleUpdateRootEntityRelationInput"]: ValueTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"];
	["SeoDefaultWithoutLocalesUpdateInput"]: ValueTypes["SeoDefaultWithoutLocalesUpdateInput"];
	["SeoDefaultLocaleUpsertRootRelationInput"]: ValueTypes["SeoDefaultLocaleUpsertRootRelationInput"];
	["SeoDefaultLocaleUpdateSeoEntityRelationInput"]: ValueTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: ValueTypes["SeoUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: ValueTypes["SeoUpdateOgImageEntityRelationInput"];
	["SeoUpsertOgImageRelationInput"]: ValueTypes["SeoUpsertOgImageRelationInput"];
	["SeoDefaultLocaleUpsertSeoRelationInput"]: ValueTypes["SeoDefaultLocaleUpsertSeoRelationInput"];
	["LocaleUpsertSeoDefaultsRelationInput"]: ValueTypes["LocaleUpsertSeoDefaultsRelationInput"];
	["LocaleUpdateBusinessPagesEntityRelationInput"]: ValueTypes["LocaleUpdateBusinessPagesEntityRelationInput"];
	["LocaleUpdateBusinessPagesRelationInput"]: ValueTypes["LocaleUpdateBusinessPagesRelationInput"];
	["BusinessPageLocaleWithoutLocaleUpdateInput"]: ValueTypes["BusinessPageLocaleWithoutLocaleUpdateInput"];
	["BusinessPageLocaleUpdateRootEntityRelationInput"]: ValueTypes["BusinessPageLocaleUpdateRootEntityRelationInput"];
	["BusinessPageWithoutLocalesUpdateInput"]: ValueTypes["BusinessPageWithoutLocalesUpdateInput"];
	["BusinessPageUpdateThemeEntityRelationInput"]: ValueTypes["BusinessPageUpdateThemeEntityRelationInput"];
	["BusinessPageUpsertThemeRelationInput"]: ValueTypes["BusinessPageUpsertThemeRelationInput"];
	["BusinessPageLocaleUpsertRootRelationInput"]: ValueTypes["BusinessPageLocaleUpsertRootRelationInput"];
	["BusinessPageLocaleUpdateContentEntityRelationInput"]: ValueTypes["BusinessPageLocaleUpdateContentEntityRelationInput"];
	["ContentUpdateInput"]: ValueTypes["ContentUpdateInput"];
	["ContentUpdateBlocksEntityRelationInput"]: ValueTypes["ContentUpdateBlocksEntityRelationInput"];
	["ContentUpdateBlocksRelationInput"]: ValueTypes["ContentUpdateBlocksRelationInput"];
	["ContentBlockWithoutContentUpdateInput"]: ValueTypes["ContentBlockWithoutContentUpdateInput"];
	["ContentBlockUpdateReferencesEntityRelationInput"]: ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"];
	["ContentBlockUpdateReferencesRelationInput"]: ValueTypes["ContentBlockUpdateReferencesRelationInput"];
	["ContentReferenceWithoutBlockUpdateInput"]: ValueTypes["ContentReferenceWithoutBlockUpdateInput"];
	["ContentReferenceUpdateImageEntityRelationInput"]: ValueTypes["ContentReferenceUpdateImageEntityRelationInput"];
	["ContentReferenceUpsertImageRelationInput"]: ValueTypes["ContentReferenceUpsertImageRelationInput"];
	["ContentReferenceUpdateLinkablesEntityRelationInput"]: ValueTypes["ContentReferenceUpdateLinkablesEntityRelationInput"];
	["ContentReferenceUpdateLinkEntityRelationInput"]: ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"];
	["ContentReferenceUpsertLinkRelationInput"]: ValueTypes["ContentReferenceUpsertLinkRelationInput"];
	["ContentReferenceUpdateMediaEntityRelationInput"]: ValueTypes["ContentReferenceUpdateMediaEntityRelationInput"];
	["MediumListUpdateInput"]: ValueTypes["MediumListUpdateInput"];
	["MediumListUpdateItemsEntityRelationInput"]: ValueTypes["MediumListUpdateItemsEntityRelationInput"];
	["MediumListUpdateItemsRelationInput"]: ValueTypes["MediumListUpdateItemsRelationInput"];
	["MediumItemWithoutListUpdateInput"]: ValueTypes["MediumItemWithoutListUpdateInput"];
	["MediumItemUpdateMediumEntityRelationInput"]: ValueTypes["MediumItemUpdateMediumEntityRelationInput"];
	["MediumUpdateInput"]: ValueTypes["MediumUpdateInput"];
	["MediumUpdateImageEntityRelationInput"]: ValueTypes["MediumUpdateImageEntityRelationInput"];
	["MediumUpsertImageRelationInput"]: ValueTypes["MediumUpsertImageRelationInput"];
	["MediumUpdateVideoEntityRelationInput"]: ValueTypes["MediumUpdateVideoEntityRelationInput"];
	["VideoUpdateInput"]: ValueTypes["VideoUpdateInput"];
	["VideoUpdatePosterEntityRelationInput"]: ValueTypes["VideoUpdatePosterEntityRelationInput"];
	["VideoUpsertPosterRelationInput"]: ValueTypes["VideoUpsertPosterRelationInput"];
	["MediumUpsertVideoRelationInput"]: ValueTypes["MediumUpsertVideoRelationInput"];
	["MediumItemUpsertMediumRelationInput"]: ValueTypes["MediumItemUpsertMediumRelationInput"];
	["MediumListUpsertItemsRelationInput"]: ValueTypes["MediumListUpsertItemsRelationInput"];
	["ContentReferenceUpsertMediaRelationInput"]: ValueTypes["ContentReferenceUpsertMediaRelationInput"];
	["ContentReferenceUpdateTextListEntityRelationInput"]: ValueTypes["ContentReferenceUpdateTextListEntityRelationInput"];
	["TextListUpdateInput"]: ValueTypes["TextListUpdateInput"];
	["TextListUpdateItemsEntityRelationInput"]: ValueTypes["TextListUpdateItemsEntityRelationInput"];
	["TextListUpdateItemsRelationInput"]: ValueTypes["TextListUpdateItemsRelationInput"];
	["TextItemWithoutListUpdateInput"]: ValueTypes["TextItemWithoutListUpdateInput"];
	["TextListUpsertItemsRelationInput"]: ValueTypes["TextListUpsertItemsRelationInput"];
	["ContentReferenceUpsertTextListRelationInput"]: ValueTypes["ContentReferenceUpsertTextListRelationInput"];
	["ContentReferenceUpdateCarouselEntityRelationInput"]: ValueTypes["ContentReferenceUpdateCarouselEntityRelationInput"];
	["CarouselUpdateInput"]: ValueTypes["CarouselUpdateInput"];
	["CarouselUpdateItemsEntityRelationInput"]: ValueTypes["CarouselUpdateItemsEntityRelationInput"];
	["CarouselUpdateItemsRelationInput"]: ValueTypes["CarouselUpdateItemsRelationInput"];
	["CarouselItemWithoutListUpdateInput"]: ValueTypes["CarouselItemWithoutListUpdateInput"];
	["CarouselItemUpdateImageEntityRelationInput"]: ValueTypes["CarouselItemUpdateImageEntityRelationInput"];
	["CarouselItemUpsertImageRelationInput"]: ValueTypes["CarouselItemUpsertImageRelationInput"];
	["CarouselItemUpdateLinkUrlEntityRelationInput"]: ValueTypes["CarouselItemUpdateLinkUrlEntityRelationInput"];
	["CarouselItemUpsertLinkUrlRelationInput"]: ValueTypes["CarouselItemUpsertLinkUrlRelationInput"];
	["CarouselItemUpdateVideoEntityRelationInput"]: ValueTypes["CarouselItemUpdateVideoEntityRelationInput"];
	["CarouselItemUpsertVideoRelationInput"]: ValueTypes["CarouselItemUpsertVideoRelationInput"];
	["CarouselUpsertItemsRelationInput"]: ValueTypes["CarouselUpsertItemsRelationInput"];
	["ContentReferenceUpsertCarouselRelationInput"]: ValueTypes["ContentReferenceUpsertCarouselRelationInput"];
	["ContentReferenceUpdateBonusBannerEntityRelationInput"]: ValueTypes["ContentReferenceUpdateBonusBannerEntityRelationInput"];
	["BonusBannerLocaleUpdateInput"]: ValueTypes["BonusBannerLocaleUpdateInput"];
	["BonusBannerLocaleUpdateRootEntityRelationInput"]: ValueTypes["BonusBannerLocaleUpdateRootEntityRelationInput"];
	["BonusBannerWithoutLocalesUpdateInput"]: ValueTypes["BonusBannerWithoutLocalesUpdateInput"];
	["BonusBannerLocaleUpsertRootRelationInput"]: ValueTypes["BonusBannerLocaleUpsertRootRelationInput"];
	["BonusBannerLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["BonusBannerLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutBonusBannersUpdateInput"]: ValueTypes["LocaleWithoutBonusBannersUpdateInput"];
	["LocaleUpdateGenericPagesEntityRelationInput"]: ValueTypes["LocaleUpdateGenericPagesEntityRelationInput"];
	["LocaleUpdateGenericPagesRelationInput"]: ValueTypes["LocaleUpdateGenericPagesRelationInput"];
	["GenericPageLocaleWithoutLocaleUpdateInput"]: ValueTypes["GenericPageLocaleWithoutLocaleUpdateInput"];
	["GenericPageLocaleUpdateContentEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateContentEntityRelationInput"];
	["GenericPageLocaleUpsertContentRelationInput"]: ValueTypes["GenericPageLocaleUpsertContentRelationInput"];
	["GenericPageLocaleUpdateSeoEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateSeoEntityRelationInput"];
	["GenericPageLocaleUpsertSeoRelationInput"]: ValueTypes["GenericPageLocaleUpsertSeoRelationInput"];
	["GenericPageLocaleUpdateLinkEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutGenericPageUpdateInput"]: ValueTypes["LinkableWithoutGenericPageUpdateInput"];
	["LinkableUpdateBusinessPageEntityRelationInput"]: ValueTypes["LinkableUpdateBusinessPageEntityRelationInput"];
	["BusinessPageLocaleWithoutLinkUpdateInput"]: ValueTypes["BusinessPageLocaleWithoutLinkUpdateInput"];
	["BusinessPageLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["BusinessPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutBusinessPagesUpdateInput"]: ValueTypes["LocaleWithoutBusinessPagesUpdateInput"];
	["LocaleUpdateJobPagesEntityRelationInput"]: ValueTypes["LocaleUpdateJobPagesEntityRelationInput"];
	["LocaleUpdateJobPagesRelationInput"]: ValueTypes["LocaleUpdateJobPagesRelationInput"];
	["JobPageLocaleWithoutLocaleUpdateInput"]: ValueTypes["JobPageLocaleWithoutLocaleUpdateInput"];
	["JobPageLocaleUpdateRootEntityRelationInput"]: ValueTypes["JobPageLocaleUpdateRootEntityRelationInput"];
	["JobPageWithoutLocalesUpdateInput"]: ValueTypes["JobPageWithoutLocalesUpdateInput"];
	["JobPageUpdateThemeEntityRelationInput"]: ValueTypes["JobPageUpdateThemeEntityRelationInput"];
	["JobPageUpsertThemeRelationInput"]: ValueTypes["JobPageUpsertThemeRelationInput"];
	["JobPageUpdateContractTypeEntityRelationInput"]: ValueTypes["JobPageUpdateContractTypeEntityRelationInput"];
	["ContractTypeUpdateInput"]: ValueTypes["ContractTypeUpdateInput"];
	["ContractTypeUpdateLocalesEntityRelationInput"]: ValueTypes["ContractTypeUpdateLocalesEntityRelationInput"];
	["ContractTypeUpdateLocalesRelationInput"]: ValueTypes["ContractTypeUpdateLocalesRelationInput"];
	["ContractTypeLocaleWithoutRootUpdateInput"]: ValueTypes["ContractTypeLocaleWithoutRootUpdateInput"];
	["ContractTypeLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["ContractTypeLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutContractTypesUpdateInput"]: ValueTypes["LocaleWithoutContractTypesUpdateInput"];
	["LocaleUpdateJobCitiesEntityRelationInput"]: ValueTypes["LocaleUpdateJobCitiesEntityRelationInput"];
	["LocaleUpdateJobCitiesRelationInput"]: ValueTypes["LocaleUpdateJobCitiesRelationInput"];
	["JobCityLocaleWithoutLocaleUpdateInput"]: ValueTypes["JobCityLocaleWithoutLocaleUpdateInput"];
	["JobCityLocaleUpdateRootEntityRelationInput"]: ValueTypes["JobCityLocaleUpdateRootEntityRelationInput"];
	["JobCityWithoutLocalesUpdateInput"]: ValueTypes["JobCityWithoutLocalesUpdateInput"];
	["JobCityLocaleUpsertRootRelationInput"]: ValueTypes["JobCityLocaleUpsertRootRelationInput"];
	["LocaleUpsertJobCitiesRelationInput"]: ValueTypes["LocaleUpsertJobCitiesRelationInput"];
	["LocaleUpdateJobPositionsEntityRelationInput"]: ValueTypes["LocaleUpdateJobPositionsEntityRelationInput"];
	["LocaleUpdateJobPositionsRelationInput"]: ValueTypes["LocaleUpdateJobPositionsRelationInput"];
	["JobPositionLocaleWithoutLocaleUpdateInput"]: ValueTypes["JobPositionLocaleWithoutLocaleUpdateInput"];
	["JobPositionLocaleUpdateRootEntityRelationInput"]: ValueTypes["JobPositionLocaleUpdateRootEntityRelationInput"];
	["JobPositionWithoutLocalesUpdateInput"]: ValueTypes["JobPositionWithoutLocalesUpdateInput"];
	["JobPositionUpdateJobsEntityRelationInput"]: ValueTypes["JobPositionUpdateJobsEntityRelationInput"];
	["JobPositionUpdateJobsRelationInput"]: ValueTypes["JobPositionUpdateJobsRelationInput"];
	["JobPageWithoutJobPositionUpdateInput"]: ValueTypes["JobPageWithoutJobPositionUpdateInput"];
	["JobPageUpdateLocalesEntityRelationInput"]: ValueTypes["JobPageUpdateLocalesEntityRelationInput"];
	["JobPageUpdateLocalesRelationInput"]: ValueTypes["JobPageUpdateLocalesRelationInput"];
	["JobPageLocaleWithoutRootUpdateInput"]: ValueTypes["JobPageLocaleWithoutRootUpdateInput"];
	["JobPageLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["JobPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutJobPagesUpdateInput"]: ValueTypes["LocaleWithoutJobPagesUpdateInput"];
	["LocaleUpdateContractTypesEntityRelationInput"]: ValueTypes["LocaleUpdateContractTypesEntityRelationInput"];
	["LocaleUpdateContractTypesRelationInput"]: ValueTypes["LocaleUpdateContractTypesRelationInput"];
	["ContractTypeLocaleWithoutLocaleUpdateInput"]: ValueTypes["ContractTypeLocaleWithoutLocaleUpdateInput"];
	["ContractTypeLocaleUpdateRootEntityRelationInput"]: ValueTypes["ContractTypeLocaleUpdateRootEntityRelationInput"];
	["ContractTypeWithoutLocalesUpdateInput"]: ValueTypes["ContractTypeWithoutLocalesUpdateInput"];
	["ContractTypeLocaleUpsertRootRelationInput"]: ValueTypes["ContractTypeLocaleUpsertRootRelationInput"];
	["LocaleUpsertContractTypesRelationInput"]: ValueTypes["LocaleUpsertContractTypesRelationInput"];
	["LocaleUpdateHomePagesEntityRelationInput"]: ValueTypes["LocaleUpdateHomePagesEntityRelationInput"];
	["LocaleUpdateHomePagesRelationInput"]: ValueTypes["LocaleUpdateHomePagesRelationInput"];
	["HomePageLocaleWithoutLocaleUpdateInput"]: ValueTypes["HomePageLocaleWithoutLocaleUpdateInput"];
	["HomePageLocaleUpdateRootEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateRootEntityRelationInput"];
	["HomePageWithoutLocalesUpdateInput"]: ValueTypes["HomePageWithoutLocalesUpdateInput"];
	["HomePageUpdateThemeEntityRelationInput"]: ValueTypes["HomePageUpdateThemeEntityRelationInput"];
	["HomePageUpsertThemeRelationInput"]: ValueTypes["HomePageUpsertThemeRelationInput"];
	["HomePageLocaleUpsertRootRelationInput"]: ValueTypes["HomePageLocaleUpsertRootRelationInput"];
	["HomePageLocaleUpdateButtonEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateButtonEntityRelationInput"];
	["HomePageLocaleUpsertButtonRelationInput"]: ValueTypes["HomePageLocaleUpsertButtonRelationInput"];
	["HomePageLocaleUpdateContentEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateContentEntityRelationInput"];
	["HomePageLocaleUpsertContentRelationInput"]: ValueTypes["HomePageLocaleUpsertContentRelationInput"];
	["HomePageLocaleUpdateSeoEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateSeoEntityRelationInput"];
	["HomePageLocaleUpsertSeoRelationInput"]: ValueTypes["HomePageLocaleUpsertSeoRelationInput"];
	["HomePageLocaleUpdateLinkEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutHomePageUpdateInput"]: ValueTypes["LinkableWithoutHomePageUpdateInput"];
	["LinkableUpdateJobPageEntityRelationInput"]: ValueTypes["LinkableUpdateJobPageEntityRelationInput"];
	["JobPageLocaleWithoutLinkUpdateInput"]: ValueTypes["JobPageLocaleWithoutLinkUpdateInput"];
	["JobPageLocaleUpdateImageEntityRelationInput"]: ValueTypes["JobPageLocaleUpdateImageEntityRelationInput"];
	["JobPageLocaleUpsertImageRelationInput"]: ValueTypes["JobPageLocaleUpsertImageRelationInput"];
	["JobPageLocaleUpdateKeyInfoEntityRelationInput"]: ValueTypes["JobPageLocaleUpdateKeyInfoEntityRelationInput"];
	["KeyInfoListUpdateInput"]: ValueTypes["KeyInfoListUpdateInput"];
	["KeyInfoListUpdateItemsEntityRelationInput"]: ValueTypes["KeyInfoListUpdateItemsEntityRelationInput"];
	["KeyInfoListUpdateItemsRelationInput"]: ValueTypes["KeyInfoListUpdateItemsRelationInput"];
	["KeyInfoItemWithoutListUpdateInput"]: ValueTypes["KeyInfoItemWithoutListUpdateInput"];
	["KeyInfoItemUpdateIconEntityRelationInput"]: ValueTypes["KeyInfoItemUpdateIconEntityRelationInput"];
	["IconUpdateInput"]: ValueTypes["IconUpdateInput"];
	["IconUpdateIconEntityRelationInput"]: ValueTypes["IconUpdateIconEntityRelationInput"];
	["IconUpsertIconRelationInput"]: ValueTypes["IconUpsertIconRelationInput"];
	["KeyInfoItemUpsertIconRelationInput"]: ValueTypes["KeyInfoItemUpsertIconRelationInput"];
	["KeyInfoListUpsertItemsRelationInput"]: ValueTypes["KeyInfoListUpsertItemsRelationInput"];
	["JobPageLocaleUpsertKeyInfoRelationInput"]: ValueTypes["JobPageLocaleUpsertKeyInfoRelationInput"];
	["JobPageLocaleUpdateContentEntityRelationInput"]: ValueTypes["JobPageLocaleUpdateContentEntityRelationInput"];
	["JobPageLocaleUpsertContentRelationInput"]: ValueTypes["JobPageLocaleUpsertContentRelationInput"];
	["JobPageLocaleUpdateSeoEntityRelationInput"]: ValueTypes["JobPageLocaleUpdateSeoEntityRelationInput"];
	["JobPageLocaleUpsertSeoRelationInput"]: ValueTypes["JobPageLocaleUpsertSeoRelationInput"];
	["JobPageLocaleUpdateStickyBarEntityRelationInput"]: ValueTypes["JobPageLocaleUpdateStickyBarEntityRelationInput"];
	["StickyBarUpdateInput"]: ValueTypes["StickyBarUpdateInput"];
	["StickyBarUpdateLinkEntityRelationInput"]: ValueTypes["StickyBarUpdateLinkEntityRelationInput"];
	["StickyBarUpsertLinkRelationInput"]: ValueTypes["StickyBarUpsertLinkRelationInput"];
	["StickyBarUpdateJobsFormEntityRelationInput"]: ValueTypes["StickyBarUpdateJobsFormEntityRelationInput"];
	["JobsFormLocaleUpdateInput"]: ValueTypes["JobsFormLocaleUpdateInput"];
	["JobsFormLocaleUpdateRootEntityRelationInput"]: ValueTypes["JobsFormLocaleUpdateRootEntityRelationInput"];
	["JobsFormWithoutLocalesUpdateInput"]: ValueTypes["JobsFormWithoutLocalesUpdateInput"];
	["JobsFormUpdateFileIlustrationEntityRelationInput"]: ValueTypes["JobsFormUpdateFileIlustrationEntityRelationInput"];
	["JobsFormUpsertFileIlustrationRelationInput"]: ValueTypes["JobsFormUpsertFileIlustrationRelationInput"];
	["JobsFormLocaleUpsertRootRelationInput"]: ValueTypes["JobsFormLocaleUpsertRootRelationInput"];
	["JobsFormLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["JobsFormLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutJobsFormsUpdateInput"]: ValueTypes["LocaleWithoutJobsFormsUpdateInput"];
	["LocaleUpdateBonusBannersEntityRelationInput"]: ValueTypes["LocaleUpdateBonusBannersEntityRelationInput"];
	["LocaleUpdateBonusBannersRelationInput"]: ValueTypes["LocaleUpdateBonusBannersRelationInput"];
	["BonusBannerLocaleWithoutLocaleUpdateInput"]: ValueTypes["BonusBannerLocaleWithoutLocaleUpdateInput"];
	["BonusBannerLocaleUpdateTilesEntityRelationInput"]: ValueTypes["BonusBannerLocaleUpdateTilesEntityRelationInput"];
	["BonusBannerLocaleUpdateTilesRelationInput"]: ValueTypes["BonusBannerLocaleUpdateTilesRelationInput"];
	["TileWithoutBonusBannerUpdateInput"]: ValueTypes["TileWithoutBonusBannerUpdateInput"];
	["TileUpdateImageEntityRelationInput"]: ValueTypes["TileUpdateImageEntityRelationInput"];
	["TileUpsertImageRelationInput"]: ValueTypes["TileUpsertImageRelationInput"];
	["TileUpdateLigthBoxMediaEntityRelationInput"]: ValueTypes["TileUpdateLigthBoxMediaEntityRelationInput"];
	["TileUpsertLigthBoxMediaRelationInput"]: ValueTypes["TileUpsertLigthBoxMediaRelationInput"];
	["TileUpdateLightBoxFormEntityRelationInput"]: ValueTypes["TileUpdateLightBoxFormEntityRelationInput"];
	["TileUpsertLightBoxFormRelationInput"]: ValueTypes["TileUpsertLightBoxFormRelationInput"];
	["BonusBannerLocaleUpsertTilesRelationInput"]: ValueTypes["BonusBannerLocaleUpsertTilesRelationInput"];
	["BonusBannerLocaleUpdateLogoEntityRelationInput"]: ValueTypes["BonusBannerLocaleUpdateLogoEntityRelationInput"];
	["BonusBannerLocaleUpsertLogoRelationInput"]: ValueTypes["BonusBannerLocaleUpsertLogoRelationInput"];
	["LocaleUpsertBonusBannersRelationInput"]: ValueTypes["LocaleUpsertBonusBannersRelationInput"];
	["LocaleUpdateHomePageLokalsEntityRelationInput"]: ValueTypes["LocaleUpdateHomePageLokalsEntityRelationInput"];
	["LocaleUpdateHomePageLokalsRelationInput"]: ValueTypes["LocaleUpdateHomePageLokalsRelationInput"];
	["HomePageLokalLocaleWithoutLocaleUpdateInput"]: ValueTypes["HomePageLokalLocaleWithoutLocaleUpdateInput"];
	["HomePageLokalLocaleUpdateRootEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateRootEntityRelationInput"];
	["HomePageLokalWithoutLocalesUpdateInput"]: ValueTypes["HomePageLokalWithoutLocalesUpdateInput"];
	["HomePageLokalUpdateThemeEntityRelationInput"]: ValueTypes["HomePageLokalUpdateThemeEntityRelationInput"];
	["HomePageLokalUpsertThemeRelationInput"]: ValueTypes["HomePageLokalUpsertThemeRelationInput"];
	["HomePageLokalLocaleUpsertRootRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertRootRelationInput"];
	["HomePageLokalLocaleUpdateLogoEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateLogoEntityRelationInput"];
	["HomePageLokalLocaleUpsertLogoRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertLogoRelationInput"];
	["HomePageLokalLocaleUpdateButtonEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateButtonEntityRelationInput"];
	["HomePageLokalLocaleUpsertButtonRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertButtonRelationInput"];
	["HomePageLokalLocaleUpdateContentEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateContentEntityRelationInput"];
	["HomePageLokalLocaleUpsertContentRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertContentRelationInput"];
	["HomePageLokalLocaleUpdateSeoEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateSeoEntityRelationInput"];
	["HomePageLokalLocaleUpsertSeoRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertSeoRelationInput"];
	["HomePageLokalLocaleUpdateLinkEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutHomePageLokalUpdateInput"]: ValueTypes["LinkableWithoutHomePageLokalUpdateInput"];
	["LinkableUpdateHomePageEntityRelationInput"]: ValueTypes["LinkableUpdateHomePageEntityRelationInput"];
	["HomePageLocaleWithoutLinkUpdateInput"]: ValueTypes["HomePageLocaleWithoutLinkUpdateInput"];
	["HomePageLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutHomePagesUpdateInput"]: ValueTypes["LocaleWithoutHomePagesUpdateInput"];
	["LocaleUpdateJobsFormsEntityRelationInput"]: ValueTypes["LocaleUpdateJobsFormsEntityRelationInput"];
	["LocaleUpdateJobsFormsRelationInput"]: ValueTypes["LocaleUpdateJobsFormsRelationInput"];
	["JobsFormLocaleWithoutLocaleUpdateInput"]: ValueTypes["JobsFormLocaleWithoutLocaleUpdateInput"];
	["JobsFormLocaleUpdateImageTextListEntityRelationInput"]: ValueTypes["JobsFormLocaleUpdateImageTextListEntityRelationInput"];
	["ImageTextListUpdateInput"]: ValueTypes["ImageTextListUpdateInput"];
	["ImageTextListUpdateItemsEntityRelationInput"]: ValueTypes["ImageTextListUpdateItemsEntityRelationInput"];
	["ImageTextListUpdateItemsRelationInput"]: ValueTypes["ImageTextListUpdateItemsRelationInput"];
	["ImageTextItemWithoutListUpdateInput"]: ValueTypes["ImageTextItemWithoutListUpdateInput"];
	["ImageTextItemUpdateImageEntityRelationInput"]: ValueTypes["ImageTextItemUpdateImageEntityRelationInput"];
	["ImageTextItemUpsertImageRelationInput"]: ValueTypes["ImageTextItemUpsertImageRelationInput"];
	["ImageTextListUpsertItemsRelationInput"]: ValueTypes["ImageTextListUpsertItemsRelationInput"];
	["JobsFormLocaleUpsertImageTextListRelationInput"]: ValueTypes["JobsFormLocaleUpsertImageTextListRelationInput"];
	["JobsFormLocaleUpdateLogoEntityRelationInput"]: ValueTypes["JobsFormLocaleUpdateLogoEntityRelationInput"];
	["JobsFormLocaleUpsertLogoRelationInput"]: ValueTypes["JobsFormLocaleUpsertLogoRelationInput"];
	["JobsFormLocaleUpdateSuccessImageEntityRelationInput"]: ValueTypes["JobsFormLocaleUpdateSuccessImageEntityRelationInput"];
	["JobsFormLocaleUpsertSuccessImageRelationInput"]: ValueTypes["JobsFormLocaleUpsertSuccessImageRelationInput"];
	["LocaleUpsertJobsFormsRelationInput"]: ValueTypes["LocaleUpsertJobsFormsRelationInput"];
	["LocaleUpdateJobsFiltersEntityRelationInput"]: ValueTypes["LocaleUpdateJobsFiltersEntityRelationInput"];
	["LocaleUpdateJobsFiltersRelationInput"]: ValueTypes["LocaleUpdateJobsFiltersRelationInput"];
	["JobsFilterLocaleWithoutLocaleUpdateInput"]: ValueTypes["JobsFilterLocaleWithoutLocaleUpdateInput"];
	["JobsFilterLocaleUpdateRootEntityRelationInput"]: ValueTypes["JobsFilterLocaleUpdateRootEntityRelationInput"];
	["JobsFilterWithoutLocalesUpdateInput"]: ValueTypes["JobsFilterWithoutLocalesUpdateInput"];
	["JobsFilterLocaleUpsertRootRelationInput"]: ValueTypes["JobsFilterLocaleUpsertRootRelationInput"];
	["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"]: ValueTypes["JobsFilterLocaleUpdateBannerJobsFormEntityRelationInput"];
	["JobsFilterLocaleUpsertBannerJobsFormRelationInput"]: ValueTypes["JobsFilterLocaleUpsertBannerJobsFormRelationInput"];
	["JobsFilterLocaleUpdateBannerImageEntityRelationInput"]: ValueTypes["JobsFilterLocaleUpdateBannerImageEntityRelationInput"];
	["JobsFilterLocaleUpsertBannerImageRelationInput"]: ValueTypes["JobsFilterLocaleUpsertBannerImageRelationInput"];
	["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"]: ValueTypes["JobsFilterLocaleUpdateNoJobImageEntityRelationInput"];
	["JobsFilterLocaleUpsertNoJobImageRelationInput"]: ValueTypes["JobsFilterLocaleUpsertNoJobImageRelationInput"];
	["LocaleUpsertJobsFiltersRelationInput"]: ValueTypes["LocaleUpsertJobsFiltersRelationInput"];
	["LocaleUpdateGeneralEntityRelationInput"]: ValueTypes["LocaleUpdateGeneralEntityRelationInput"];
	["LocaleUpdateGeneralRelationInput"]: ValueTypes["LocaleUpdateGeneralRelationInput"];
	["GeneralLocaleWithoutLocaleUpdateInput"]: ValueTypes["GeneralLocaleWithoutLocaleUpdateInput"];
	["GeneralLocaleUpdateRootEntityRelationInput"]: ValueTypes["GeneralLocaleUpdateRootEntityRelationInput"];
	["GeneralWithoutLocalesUpdateInput"]: ValueTypes["GeneralWithoutLocalesUpdateInput"];
	["GeneralLocaleUpsertRootRelationInput"]: ValueTypes["GeneralLocaleUpsertRootRelationInput"];
	["GeneralLocaleUpdateSeoEntityRelationInput"]: ValueTypes["GeneralLocaleUpdateSeoEntityRelationInput"];
	["GeneralLocaleUpsertSeoRelationInput"]: ValueTypes["GeneralLocaleUpsertSeoRelationInput"];
	["GeneralLocaleUpdateCornerBannerEntityRelationInput"]: ValueTypes["GeneralLocaleUpdateCornerBannerEntityRelationInput"];
	["CornerBannerUpdateInput"]: ValueTypes["CornerBannerUpdateInput"];
	["CornerBannerUpdateLogoEntityRelationInput"]: ValueTypes["CornerBannerUpdateLogoEntityRelationInput"];
	["CornerBannerUpsertLogoRelationInput"]: ValueTypes["CornerBannerUpsertLogoRelationInput"];
	["CornerBannerUpdateLinkEntityRelationInput"]: ValueTypes["CornerBannerUpdateLinkEntityRelationInput"];
	["CornerBannerUpsertLinkRelationInput"]: ValueTypes["CornerBannerUpsertLinkRelationInput"];
	["GeneralLocaleUpsertCornerBannerRelationInput"]: ValueTypes["GeneralLocaleUpsertCornerBannerRelationInput"];
	["LocaleUpsertGeneralRelationInput"]: ValueTypes["LocaleUpsertGeneralRelationInput"];
	["LocaleUpdateRecommendationFormsEntityRelationInput"]: ValueTypes["LocaleUpdateRecommendationFormsEntityRelationInput"];
	["LocaleUpdateRecommendationFormsRelationInput"]: ValueTypes["LocaleUpdateRecommendationFormsRelationInput"];
	["RecommendationFormLocaleWithoutLocaleUpdateInput"]: ValueTypes["RecommendationFormLocaleWithoutLocaleUpdateInput"];
	["RecommendationFormLocaleUpdateRootEntityRelationInput"]: ValueTypes["RecommendationFormLocaleUpdateRootEntityRelationInput"];
	["RecommendationFormWithoutLocalesUpdateInput"]: ValueTypes["RecommendationFormWithoutLocalesUpdateInput"];
	["RecommendationFormUpdateSuccessImageEntityRelationInput"]: ValueTypes["RecommendationFormUpdateSuccessImageEntityRelationInput"];
	["RecommendationFormUpsertSuccessImageRelationInput"]: ValueTypes["RecommendationFormUpsertSuccessImageRelationInput"];
	["RecommendationFormLocaleUpsertRootRelationInput"]: ValueTypes["RecommendationFormLocaleUpsertRootRelationInput"];
	["LocaleUpsertRecommendationFormsRelationInput"]: ValueTypes["LocaleUpsertRecommendationFormsRelationInput"];
	["LocaleUpdateInfoBoxesEntityRelationInput"]: ValueTypes["LocaleUpdateInfoBoxesEntityRelationInput"];
	["LocaleUpdateInfoBoxesRelationInput"]: ValueTypes["LocaleUpdateInfoBoxesRelationInput"];
	["InfoBoxLocaleWithoutLocaleUpdateInput"]: ValueTypes["InfoBoxLocaleWithoutLocaleUpdateInput"];
	["InfoBoxLocaleUpdateRootEntityRelationInput"]: ValueTypes["InfoBoxLocaleUpdateRootEntityRelationInput"];
	["InfoBoxWithoutLocalesUpdateInput"]: ValueTypes["InfoBoxWithoutLocalesUpdateInput"];
	["InfoBoxUpdateLogoEntityRelationInput"]: ValueTypes["InfoBoxUpdateLogoEntityRelationInput"];
	["InfoBoxUpsertLogoRelationInput"]: ValueTypes["InfoBoxUpsertLogoRelationInput"];
	["InfoBoxLocaleUpsertRootRelationInput"]: ValueTypes["InfoBoxLocaleUpsertRootRelationInput"];
	["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"]: ValueTypes["InfoBoxLocaleUpdateOpeningHoursEntityRelationInput"];
	["InfoBoxLocaleUpsertOpeningHoursRelationInput"]: ValueTypes["InfoBoxLocaleUpsertOpeningHoursRelationInput"];
	["LocaleUpsertInfoBoxesRelationInput"]: ValueTypes["LocaleUpsertInfoBoxesRelationInput"];
	["LocaleUpdateTranslationsEntityRelationInput"]: ValueTypes["LocaleUpdateTranslationsEntityRelationInput"];
	["LocaleUpdateTranslationsRelationInput"]: ValueTypes["LocaleUpdateTranslationsRelationInput"];
	["TranslationLocaleWithoutLocaleUpdateInput"]: ValueTypes["TranslationLocaleWithoutLocaleUpdateInput"];
	["TranslationLocaleUpdateRootEntityRelationInput"]: ValueTypes["TranslationLocaleUpdateRootEntityRelationInput"];
	["TranslationWithoutLocalesUpdateInput"]: ValueTypes["TranslationWithoutLocalesUpdateInput"];
	["TranslationLocaleUpsertRootRelationInput"]: ValueTypes["TranslationLocaleUpsertRootRelationInput"];
	["LocaleUpsertTranslationsRelationInput"]: ValueTypes["LocaleUpsertTranslationsRelationInput"];
	["HomePageLocaleUpsertLocaleRelationInput"]: ValueTypes["HomePageLocaleUpsertLocaleRelationInput"];
	["HomePageLocaleUpdateLogoEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateLogoEntityRelationInput"];
	["HomePageLocaleUpsertLogoRelationInput"]: ValueTypes["HomePageLocaleUpsertLogoRelationInput"];
	["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateSiteSwitcherEntityRelationInput"];
	["SiteSwitcherUpdateInput"]: ValueTypes["SiteSwitcherUpdateInput"];
	["SiteSwitcherUpdateLinkEntityRelationInput"]: ValueTypes["SiteSwitcherUpdateLinkEntityRelationInput"];
	["SiteSwitcherUpsertLinkRelationInput"]: ValueTypes["SiteSwitcherUpsertLinkRelationInput"];
	["SiteSwitcherUpdateThemeEntityRelationInput"]: ValueTypes["SiteSwitcherUpdateThemeEntityRelationInput"];
	["SiteSwitcherUpsertThemeRelationInput"]: ValueTypes["SiteSwitcherUpsertThemeRelationInput"];
	["HomePageLocaleUpsertSiteSwitcherRelationInput"]: ValueTypes["HomePageLocaleUpsertSiteSwitcherRelationInput"];
	["HomePageLocaleUpdateGalleryEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateGalleryEntityRelationInput"];
	["GalleryUpdateInput"]: ValueTypes["GalleryUpdateInput"];
	["GalleryUpdateItemsEntityRelationInput"]: ValueTypes["GalleryUpdateItemsEntityRelationInput"];
	["GalleryUpdateItemsRelationInput"]: ValueTypes["GalleryUpdateItemsRelationInput"];
	["GalleryItemWithoutListUpdateInput"]: ValueTypes["GalleryItemWithoutListUpdateInput"];
	["GalleryItemUpdateImageEntityRelationInput"]: ValueTypes["GalleryItemUpdateImageEntityRelationInput"];
	["GalleryItemUpsertImageRelationInput"]: ValueTypes["GalleryItemUpsertImageRelationInput"];
	["GalleryUpsertItemsRelationInput"]: ValueTypes["GalleryUpsertItemsRelationInput"];
	["HomePageLocaleUpsertGalleryRelationInput"]: ValueTypes["HomePageLocaleUpsertGalleryRelationInput"];
	["HomePageLocaleUpdateStickyBarEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateStickyBarEntityRelationInput"];
	["HomePageLocaleUpsertStickyBarRelationInput"]: ValueTypes["HomePageLocaleUpsertStickyBarRelationInput"];
	["HomePageLocaleUpdateIlustrationEntityRelationInput"]: ValueTypes["HomePageLocaleUpdateIlustrationEntityRelationInput"];
	["HomePageLocaleUpsertIlustrationRelationInput"]: ValueTypes["HomePageLocaleUpsertIlustrationRelationInput"];
	["LinkableUpsertHomePageRelationInput"]: ValueTypes["LinkableUpsertHomePageRelationInput"];
	["HomePageLokalLocaleUpsertLinkRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertLinkRelationInput"];
	["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateSiteSwitcherEntityRelationInput"];
	["HomePageLokalLocaleUpsertSiteSwitcherRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertSiteSwitcherRelationInput"];
	["HomePageLokalLocaleUpdateGalleryEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateGalleryEntityRelationInput"];
	["HomePageLokalLocaleUpsertGalleryRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertGalleryRelationInput"];
	["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateStickyBarEntityRelationInput"];
	["HomePageLokalLocaleUpsertStickyBarRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertStickyBarRelationInput"];
	["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateIlustrationEntityRelationInput"];
	["HomePageLokalLocaleUpsertIlustrationRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertIlustrationRelationInput"];
	["LocaleUpsertHomePageLokalsRelationInput"]: ValueTypes["LocaleUpsertHomePageLokalsRelationInput"];
	["JobsFormLocaleUpsertLocaleRelationInput"]: ValueTypes["JobsFormLocaleUpsertLocaleRelationInput"];
	["StickyBarUpsertJobsFormRelationInput"]: ValueTypes["StickyBarUpsertJobsFormRelationInput"];
	["JobPageLocaleUpsertStickyBarRelationInput"]: ValueTypes["JobPageLocaleUpsertStickyBarRelationInput"];
	["JobPageLocaleUpdateMobileImageEntityRelationInput"]: ValueTypes["JobPageLocaleUpdateMobileImageEntityRelationInput"];
	["JobPageLocaleUpsertMobileImageRelationInput"]: ValueTypes["JobPageLocaleUpsertMobileImageRelationInput"];
	["LinkableUpsertJobPageRelationInput"]: ValueTypes["LinkableUpsertJobPageRelationInput"];
	["LinkableUpdateHomePageLokalEntityRelationInput"]: ValueTypes["LinkableUpdateHomePageLokalEntityRelationInput"];
	["HomePageLokalLocaleWithoutLinkUpdateInput"]: ValueTypes["HomePageLokalLocaleWithoutLinkUpdateInput"];
	["HomePageLokalLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["HomePageLokalLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutHomePageLokalsUpdateInput"]: ValueTypes["LocaleWithoutHomePageLokalsUpdateInput"];
	["HomePageLokalLocaleUpsertLocaleRelationInput"]: ValueTypes["HomePageLokalLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertHomePageLokalRelationInput"]: ValueTypes["LinkableUpsertHomePageLokalRelationInput"];
	["HomePageLocaleUpsertLinkRelationInput"]: ValueTypes["HomePageLocaleUpsertLinkRelationInput"];
	["LocaleUpsertHomePagesRelationInput"]: ValueTypes["LocaleUpsertHomePagesRelationInput"];
	["JobPageLocaleUpsertLocaleRelationInput"]: ValueTypes["JobPageLocaleUpsertLocaleRelationInput"];
	["JobPageLocaleUpdateLinkEntityRelationInput"]: ValueTypes["JobPageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutJobPageUpdateInput"]: ValueTypes["LinkableWithoutJobPageUpdateInput"];
	["JobPageLocaleUpsertLinkRelationInput"]: ValueTypes["JobPageLocaleUpsertLinkRelationInput"];
	["JobPageUpsertLocalesRelationInput"]: ValueTypes["JobPageUpsertLocalesRelationInput"];
	["JobPageUpdateJobCityEntityRelationInput"]: ValueTypes["JobPageUpdateJobCityEntityRelationInput"];
	["JobCityUpdateInput"]: ValueTypes["JobCityUpdateInput"];
	["JobCityUpdateLocalesEntityRelationInput"]: ValueTypes["JobCityUpdateLocalesEntityRelationInput"];
	["JobCityUpdateLocalesRelationInput"]: ValueTypes["JobCityUpdateLocalesRelationInput"];
	["JobCityLocaleWithoutRootUpdateInput"]: ValueTypes["JobCityLocaleWithoutRootUpdateInput"];
	["JobCityLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["JobCityLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutJobCitiesUpdateInput"]: ValueTypes["LocaleWithoutJobCitiesUpdateInput"];
	["JobCityLocaleUpsertLocaleRelationInput"]: ValueTypes["JobCityLocaleUpsertLocaleRelationInput"];
	["JobCityUpsertLocalesRelationInput"]: ValueTypes["JobCityUpsertLocalesRelationInput"];
	["JobPageUpsertJobCityRelationInput"]: ValueTypes["JobPageUpsertJobCityRelationInput"];
	["JobPageUpdateBusinessEntityRelationInput"]: ValueTypes["JobPageUpdateBusinessEntityRelationInput"];
	["BusinessPageUpdateInput"]: ValueTypes["BusinessPageUpdateInput"];
	["BusinessPageUpdateLocalesEntityRelationInput"]: ValueTypes["BusinessPageUpdateLocalesEntityRelationInput"];
	["BusinessPageUpdateLocalesRelationInput"]: ValueTypes["BusinessPageUpdateLocalesRelationInput"];
	["BusinessPageLocaleWithoutRootUpdateInput"]: ValueTypes["BusinessPageLocaleWithoutRootUpdateInput"];
	["BusinessPageLocaleUpdateSeoEntityRelationInput"]: ValueTypes["BusinessPageLocaleUpdateSeoEntityRelationInput"];
	["BusinessPageLocaleUpsertSeoRelationInput"]: ValueTypes["BusinessPageLocaleUpsertSeoRelationInput"];
	["BusinessPageLocaleUpdateLinkEntityRelationInput"]: ValueTypes["BusinessPageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutBusinessPageUpdateInput"]: ValueTypes["LinkableWithoutBusinessPageUpdateInput"];
	["BusinessPageLocaleUpsertLinkRelationInput"]: ValueTypes["BusinessPageLocaleUpsertLinkRelationInput"];
	["BusinessPageLocaleUpdateImageEntityRelationInput"]: ValueTypes["BusinessPageLocaleUpdateImageEntityRelationInput"];
	["BusinessPageLocaleUpsertImageRelationInput"]: ValueTypes["BusinessPageLocaleUpsertImageRelationInput"];
	["BusinessPageLocaleUpdateStickyBarEntityRelationInput"]: ValueTypes["BusinessPageLocaleUpdateStickyBarEntityRelationInput"];
	["BusinessPageLocaleUpsertStickyBarRelationInput"]: ValueTypes["BusinessPageLocaleUpsertStickyBarRelationInput"];
	["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"]: ValueTypes["BusinessPageLocaleUpdateInfoBoxEntityRelationInput"];
	["InfoBoxUpdateInput"]: ValueTypes["InfoBoxUpdateInput"];
	["InfoBoxUpdateLocalesEntityRelationInput"]: ValueTypes["InfoBoxUpdateLocalesEntityRelationInput"];
	["InfoBoxUpdateLocalesRelationInput"]: ValueTypes["InfoBoxUpdateLocalesRelationInput"];
	["InfoBoxLocaleWithoutRootUpdateInput"]: ValueTypes["InfoBoxLocaleWithoutRootUpdateInput"];
	["InfoBoxLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["InfoBoxLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutInfoBoxesUpdateInput"]: ValueTypes["LocaleWithoutInfoBoxesUpdateInput"];
	["InfoBoxLocaleUpsertLocaleRelationInput"]: ValueTypes["InfoBoxLocaleUpsertLocaleRelationInput"];
	["InfoBoxUpsertLocalesRelationInput"]: ValueTypes["InfoBoxUpsertLocalesRelationInput"];
	["BusinessPageLocaleUpsertInfoBoxRelationInput"]: ValueTypes["BusinessPageLocaleUpsertInfoBoxRelationInput"];
	["BusinessPageUpsertLocalesRelationInput"]: ValueTypes["BusinessPageUpsertLocalesRelationInput"];
	["JobPageUpsertBusinessRelationInput"]: ValueTypes["JobPageUpsertBusinessRelationInput"];
	["JobPositionUpsertJobsRelationInput"]: ValueTypes["JobPositionUpsertJobsRelationInput"];
	["JobPositionLocaleUpsertRootRelationInput"]: ValueTypes["JobPositionLocaleUpsertRootRelationInput"];
	["LocaleUpsertJobPositionsRelationInput"]: ValueTypes["LocaleUpsertJobPositionsRelationInput"];
	["ContractTypeLocaleUpsertLocaleRelationInput"]: ValueTypes["ContractTypeLocaleUpsertLocaleRelationInput"];
	["ContractTypeUpsertLocalesRelationInput"]: ValueTypes["ContractTypeUpsertLocalesRelationInput"];
	["JobPageUpsertContractTypeRelationInput"]: ValueTypes["JobPageUpsertContractTypeRelationInput"];
	["JobPageUpdateJobPositionEntityRelationInput"]: ValueTypes["JobPageUpdateJobPositionEntityRelationInput"];
	["JobPositionWithoutJobsUpdateInput"]: ValueTypes["JobPositionWithoutJobsUpdateInput"];
	["JobPositionUpdateLocalesEntityRelationInput"]: ValueTypes["JobPositionUpdateLocalesEntityRelationInput"];
	["JobPositionUpdateLocalesRelationInput"]: ValueTypes["JobPositionUpdateLocalesRelationInput"];
	["JobPositionLocaleWithoutRootUpdateInput"]: ValueTypes["JobPositionLocaleWithoutRootUpdateInput"];
	["JobPositionLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["JobPositionLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutJobPositionsUpdateInput"]: ValueTypes["LocaleWithoutJobPositionsUpdateInput"];
	["JobPositionLocaleUpsertLocaleRelationInput"]: ValueTypes["JobPositionLocaleUpsertLocaleRelationInput"];
	["JobPositionUpsertLocalesRelationInput"]: ValueTypes["JobPositionUpsertLocalesRelationInput"];
	["JobPageUpsertJobPositionRelationInput"]: ValueTypes["JobPageUpsertJobPositionRelationInput"];
	["JobPageLocaleUpsertRootRelationInput"]: ValueTypes["JobPageLocaleUpsertRootRelationInput"];
	["LocaleUpsertJobPagesRelationInput"]: ValueTypes["LocaleUpsertJobPagesRelationInput"];
	["BusinessPageLocaleUpsertLocaleRelationInput"]: ValueTypes["BusinessPageLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertBusinessPageRelationInput"]: ValueTypes["LinkableUpsertBusinessPageRelationInput"];
	["GenericPageLocaleUpsertLinkRelationInput"]: ValueTypes["GenericPageLocaleUpsertLinkRelationInput"];
	["GenericPageLocaleUpdateLogoEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateLogoEntityRelationInput"];
	["GenericPageLocaleUpsertLogoRelationInput"]: ValueTypes["GenericPageLocaleUpsertLogoRelationInput"];
	["GenericPageLocaleUpdateImageEntityRelationInput"]: ValueTypes["GenericPageLocaleUpdateImageEntityRelationInput"];
	["GenericPageLocaleUpsertImageRelationInput"]: ValueTypes["GenericPageLocaleUpsertImageRelationInput"];
	["LocaleUpsertGenericPagesRelationInput"]: ValueTypes["LocaleUpsertGenericPagesRelationInput"];
	["BonusBannerLocaleUpsertLocaleRelationInput"]: ValueTypes["BonusBannerLocaleUpsertLocaleRelationInput"];
	["ContentReferenceUpsertBonusBannerRelationInput"]: ValueTypes["ContentReferenceUpsertBonusBannerRelationInput"];
	["ContentReferenceUpdateSideBySideEntityRelationInput"]: ValueTypes["ContentReferenceUpdateSideBySideEntityRelationInput"];
	["SideBySideUpdateInput"]: ValueTypes["SideBySideUpdateInput"];
	["SideBySideUpdateItemsEntityRelationInput"]: ValueTypes["SideBySideUpdateItemsEntityRelationInput"];
	["SideBySideUpdateItemsRelationInput"]: ValueTypes["SideBySideUpdateItemsRelationInput"];
	["SideBySideItemWithoutListUpdateInput"]: ValueTypes["SideBySideItemWithoutListUpdateInput"];
	["SideBySideItemUpdateMediaEntityRelationInput"]: ValueTypes["SideBySideItemUpdateMediaEntityRelationInput"];
	["SideBySideItemUpsertMediaRelationInput"]: ValueTypes["SideBySideItemUpsertMediaRelationInput"];
	["SideBySideItemUpdateLinkEntityRelationInput"]: ValueTypes["SideBySideItemUpdateLinkEntityRelationInput"];
	["SideBySideItemUpsertLinkRelationInput"]: ValueTypes["SideBySideItemUpsertLinkRelationInput"];
	["SideBySideItemUpdateJobsFormEntityRelationInput"]: ValueTypes["SideBySideItemUpdateJobsFormEntityRelationInput"];
	["SideBySideItemUpsertJobsFormRelationInput"]: ValueTypes["SideBySideItemUpsertJobsFormRelationInput"];
	["SideBySideUpsertItemsRelationInput"]: ValueTypes["SideBySideUpsertItemsRelationInput"];
	["ContentReferenceUpsertSideBySideRelationInput"]: ValueTypes["ContentReferenceUpsertSideBySideRelationInput"];
	["ContentReferenceUpdateGalleryEntityRelationInput"]: ValueTypes["ContentReferenceUpdateGalleryEntityRelationInput"];
	["ContentReferenceUpsertGalleryRelationInput"]: ValueTypes["ContentReferenceUpsertGalleryRelationInput"];
	["ContentReferenceUpdateVideoEntityRelationInput"]: ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"];
	["ContentReferenceUpsertVideoRelationInput"]: ValueTypes["ContentReferenceUpsertVideoRelationInput"];
	["ContentBlockUpsertReferencesRelationInput"]: ValueTypes["ContentBlockUpsertReferencesRelationInput"];
	["ContentUpsertBlocksRelationInput"]: ValueTypes["ContentUpsertBlocksRelationInput"];
	["BusinessPageLocaleUpsertContentRelationInput"]: ValueTypes["BusinessPageLocaleUpsertContentRelationInput"];
	["LocaleUpsertBusinessPagesRelationInput"]: ValueTypes["LocaleUpsertBusinessPagesRelationInput"];
	["GenericPageLocaleUpsertLocaleRelationInput"]: ValueTypes["GenericPageLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertGenericPageRelationInput"]: ValueTypes["LinkableUpsertGenericPageRelationInput"];
	["LinkUpsertInternalLinkRelationInput"]: ValueTypes["LinkUpsertInternalLinkRelationInput"];
	["FooterLinkUpsertLinkRelationInput"]: ValueTypes["FooterLinkUpsertLinkRelationInput"];
	["FooterLocaleUpsertLinksFirstColumnRelationInput"]: ValueTypes["FooterLocaleUpsertLinksFirstColumnRelationInput"];
	["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"]: ValueTypes["FooterLocaleUpdateLinksSecondColumnEntityRelationInput"];
	["FooterLocaleUpdateLinksSecondColumnRelationInput"]: ValueTypes["FooterLocaleUpdateLinksSecondColumnRelationInput"];
	["FooterLocaleUpsertLinksSecondColumnRelationInput"]: ValueTypes["FooterLocaleUpsertLinksSecondColumnRelationInput"];
	["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"]: ValueTypes["FooterLocaleUpdateTermsAndConditionsEntityRelationInput"];
	["FooterLocaleUpsertTermsAndConditionsRelationInput"]: ValueTypes["FooterLocaleUpsertTermsAndConditionsRelationInput"];
	["FooterLocaleUpdateBannerImageEntityRelationInput"]: ValueTypes["FooterLocaleUpdateBannerImageEntityRelationInput"];
	["FooterLocaleUpsertBannerImageRelationInput"]: ValueTypes["FooterLocaleUpsertBannerImageRelationInput"];
	["FooterLocaleUpdateBannerLinkEntityRelationInput"]: ValueTypes["FooterLocaleUpdateBannerLinkEntityRelationInput"];
	["FooterLocaleUpsertBannerLinkRelationInput"]: ValueTypes["FooterLocaleUpsertBannerLinkRelationInput"];
	["FooterLocaleUpdateJobsFormEntityRelationInput"]: ValueTypes["FooterLocaleUpdateJobsFormEntityRelationInput"];
	["FooterLocaleUpsertJobsFormRelationInput"]: ValueTypes["FooterLocaleUpsertJobsFormRelationInput"];
	["FooterLocaleUpdateCopyrightLinkEntityRelationInput"]: ValueTypes["FooterLocaleUpdateCopyrightLinkEntityRelationInput"];
	["FooterLocaleUpsertCopyrightLinkRelationInput"]: ValueTypes["FooterLocaleUpsertCopyrightLinkRelationInput"];
	["FooterLocaleUpdateRecommendationFormEntityRelationInput"]: ValueTypes["FooterLocaleUpdateRecommendationFormEntityRelationInput"];
	["RecommendationFormLocaleUpdateInput"]: ValueTypes["RecommendationFormLocaleUpdateInput"];
	["RecommendationFormLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["RecommendationFormLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutRecommendationFormsUpdateInput"]: ValueTypes["LocaleWithoutRecommendationFormsUpdateInput"];
	["RecommendationFormLocaleUpsertLocaleRelationInput"]: ValueTypes["RecommendationFormLocaleUpsertLocaleRelationInput"];
	["FooterLocaleUpsertRecommendationFormRelationInput"]: ValueTypes["FooterLocaleUpsertRecommendationFormRelationInput"];
	["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"]: ValueTypes["FooterLocaleUpdateBannerSecondLinkEntityRelationInput"];
	["FooterLocaleUpsertBannerSecondLinkRelationInput"]: ValueTypes["FooterLocaleUpsertBannerSecondLinkRelationInput"];
	["FooterLocaleUpdateInstagramLinkEntityRelationInput"]: ValueTypes["FooterLocaleUpdateInstagramLinkEntityRelationInput"];
	["FooterLocaleUpsertInstagramLinkRelationInput"]: ValueTypes["FooterLocaleUpsertInstagramLinkRelationInput"];
	["LocaleUpsertFootersRelationInput"]: ValueTypes["LocaleUpsertFootersRelationInput"];
	["GeneralLocaleUpsertLocaleRelationInput"]: ValueTypes["GeneralLocaleUpsertLocaleRelationInput"];
	["GeneralUpsertLocalesRelationInput"]: ValueTypes["GeneralUpsertLocalesRelationInput"];
	["GenericPageCreateInput"]: ValueTypes["GenericPageCreateInput"];
	["GenericPageCreateLocalesEntityRelationInput"]: ValueTypes["GenericPageCreateLocalesEntityRelationInput"];
	["GenericPageLocaleWithoutRootCreateInput"]: ValueTypes["GenericPageLocaleWithoutRootCreateInput"];
	["GenericPageConnectOrCreateLocalesRelationInput"]: ValueTypes["GenericPageConnectOrCreateLocalesRelationInput"];
	["GenericPageUpdateInput"]: ValueTypes["GenericPageUpdateInput"];
	["GenericPageUpdateLocalesEntityRelationInput"]: ValueTypes["GenericPageUpdateLocalesEntityRelationInput"];
	["GenericPageUpdateLocalesRelationInput"]: ValueTypes["GenericPageUpdateLocalesRelationInput"];
	["GenericPageLocaleWithoutRootUpdateInput"]: ValueTypes["GenericPageLocaleWithoutRootUpdateInput"];
	["GenericPageUpsertLocalesRelationInput"]: ValueTypes["GenericPageUpsertLocalesRelationInput"];
	["ContentBlockCreateInput"]: ValueTypes["ContentBlockCreateInput"];
	["ContentBlockCreateContentEntityRelationInput"]: ValueTypes["ContentBlockCreateContentEntityRelationInput"];
	["ContentWithoutBlocksCreateInput"]: ValueTypes["ContentWithoutBlocksCreateInput"];
	["ContentBlockConnectOrCreateContentRelationInput"]: ValueTypes["ContentBlockConnectOrCreateContentRelationInput"];
	["ContentBlockUpdateInput"]: ValueTypes["ContentBlockUpdateInput"];
	["ContentBlockUpdateContentEntityRelationInput"]: ValueTypes["ContentBlockUpdateContentEntityRelationInput"];
	["ContentWithoutBlocksUpdateInput"]: ValueTypes["ContentWithoutBlocksUpdateInput"];
	["ContentBlockUpsertContentRelationInput"]: ValueTypes["ContentBlockUpsertContentRelationInput"];
	["ContentReferenceCreateInput"]: ValueTypes["ContentReferenceCreateInput"];
	["ContentReferenceCreateBlockEntityRelationInput"]: ValueTypes["ContentReferenceCreateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesCreateInput"]: ValueTypes["ContentBlockWithoutReferencesCreateInput"];
	["ContentReferenceConnectOrCreateBlockRelationInput"]: ValueTypes["ContentReferenceConnectOrCreateBlockRelationInput"];
	["ContentReferenceUpdateInput"]: ValueTypes["ContentReferenceUpdateInput"];
	["ContentReferenceUpdateBlockEntityRelationInput"]: ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesUpdateInput"]: ValueTypes["ContentBlockWithoutReferencesUpdateInput"];
	["ContentReferenceUpsertBlockRelationInput"]: ValueTypes["ContentReferenceUpsertBlockRelationInput"];
	["RedirectCreateInput"]: ValueTypes["RedirectCreateInput"];
	["RedirectCreateLinkEntityRelationInput"]: ValueTypes["RedirectCreateLinkEntityRelationInput"];
	["LinkableWithoutRedirectCreateInput"]: ValueTypes["LinkableWithoutRedirectCreateInput"];
	["RedirectConnectOrCreateLinkRelationInput"]: ValueTypes["RedirectConnectOrCreateLinkRelationInput"];
	["RedirectUpdateInput"]: ValueTypes["RedirectUpdateInput"];
	["RedirectUpdateLinkEntityRelationInput"]: ValueTypes["RedirectUpdateLinkEntityRelationInput"];
	["LinkableWithoutRedirectUpdateInput"]: ValueTypes["LinkableWithoutRedirectUpdateInput"];
	["RedirectUpsertLinkRelationInput"]: ValueTypes["RedirectUpsertLinkRelationInput"];
	["FooterCreateInput"]: ValueTypes["FooterCreateInput"];
	["FooterCreateLocalesEntityRelationInput"]: ValueTypes["FooterCreateLocalesEntityRelationInput"];
	["FooterLocaleWithoutRootCreateInput"]: ValueTypes["FooterLocaleWithoutRootCreateInput"];
	["FooterLocaleCreateLocaleEntityRelationInput"]: ValueTypes["FooterLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutFootersCreateInput"]: ValueTypes["LocaleWithoutFootersCreateInput"];
	["FooterLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["FooterLocaleConnectOrCreateLocaleRelationInput"];
	["FooterConnectOrCreateLocalesRelationInput"]: ValueTypes["FooterConnectOrCreateLocalesRelationInput"];
	["FooterUpdateInput"]: ValueTypes["FooterUpdateInput"];
	["FooterUpdateLocalesEntityRelationInput"]: ValueTypes["FooterUpdateLocalesEntityRelationInput"];
	["FooterUpdateLocalesRelationInput"]: ValueTypes["FooterUpdateLocalesRelationInput"];
	["FooterLocaleWithoutRootUpdateInput"]: ValueTypes["FooterLocaleWithoutRootUpdateInput"];
	["FooterLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["FooterLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutFootersUpdateInput"]: ValueTypes["LocaleWithoutFootersUpdateInput"];
	["FooterLocaleUpsertLocaleRelationInput"]: ValueTypes["FooterLocaleUpsertLocaleRelationInput"];
	["FooterUpsertLocalesRelationInput"]: ValueTypes["FooterUpsertLocalesRelationInput"];
	["FooterLocaleCreateInput"]: ValueTypes["FooterLocaleCreateInput"];
	["FooterLocaleUpdateInput"]: ValueTypes["FooterLocaleUpdateInput"];
	["GenericPageLocaleCreateInput"]: ValueTypes["GenericPageLocaleCreateInput"];
	["GenericPageLocaleUpdateInput"]: ValueTypes["GenericPageLocaleUpdateInput"];
	["HeaderCreateInput"]: ValueTypes["HeaderCreateInput"];
	["HeaderCreateLocalesEntityRelationInput"]: ValueTypes["HeaderCreateLocalesEntityRelationInput"];
	["HeaderLocaleWithoutRootCreateInput"]: ValueTypes["HeaderLocaleWithoutRootCreateInput"];
	["HeaderLocaleCreateLocaleEntityRelationInput"]: ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutHeadersCreateInput"]: ValueTypes["LocaleWithoutHeadersCreateInput"];
	["HeaderLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["HeaderLocaleConnectOrCreateLocaleRelationInput"];
	["HeaderConnectOrCreateLocalesRelationInput"]: ValueTypes["HeaderConnectOrCreateLocalesRelationInput"];
	["HeaderUpdateInput"]: ValueTypes["HeaderUpdateInput"];
	["HeaderUpdateLocalesEntityRelationInput"]: ValueTypes["HeaderUpdateLocalesEntityRelationInput"];
	["HeaderUpdateLocalesRelationInput"]: ValueTypes["HeaderUpdateLocalesRelationInput"];
	["HeaderLocaleWithoutRootUpdateInput"]: ValueTypes["HeaderLocaleWithoutRootUpdateInput"];
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutHeadersUpdateInput"]: ValueTypes["LocaleWithoutHeadersUpdateInput"];
	["HeaderLocaleUpsertLocaleRelationInput"]: ValueTypes["HeaderLocaleUpsertLocaleRelationInput"];
	["HeaderUpsertLocalesRelationInput"]: ValueTypes["HeaderUpsertLocalesRelationInput"];
	["HeaderLocaleCreateInput"]: ValueTypes["HeaderLocaleCreateInput"];
	["HeaderLocaleUpdateInput"]: ValueTypes["HeaderLocaleUpdateInput"];
	["LocaleCreateInput"]: ValueTypes["LocaleCreateInput"];
	["LocaleUpdateInput"]: ValueTypes["LocaleUpdateInput"];
	["SeoDefaultCreateInput"]: ValueTypes["SeoDefaultCreateInput"];
	["SeoDefaultCreateLocalesEntityRelationInput"]: ValueTypes["SeoDefaultCreateLocalesEntityRelationInput"];
	["SeoDefaultLocaleWithoutRootCreateInput"]: ValueTypes["SeoDefaultLocaleWithoutRootCreateInput"];
	["SeoDefaultLocaleCreateLocaleEntityRelationInput"]: ValueTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutSeoDefaultsCreateInput"]: ValueTypes["LocaleWithoutSeoDefaultsCreateInput"];
	["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["SeoDefaultLocaleConnectOrCreateLocaleRelationInput"];
	["SeoDefaultConnectOrCreateLocalesRelationInput"]: ValueTypes["SeoDefaultConnectOrCreateLocalesRelationInput"];
	["SeoDefaultUpdateInput"]: ValueTypes["SeoDefaultUpdateInput"];
	["SeoDefaultUpdateLocalesEntityRelationInput"]: ValueTypes["SeoDefaultUpdateLocalesEntityRelationInput"];
	["SeoDefaultUpdateLocalesRelationInput"]: ValueTypes["SeoDefaultUpdateLocalesRelationInput"];
	["SeoDefaultLocaleWithoutRootUpdateInput"]: ValueTypes["SeoDefaultLocaleWithoutRootUpdateInput"];
	["SeoDefaultLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutSeoDefaultsUpdateInput"]: ValueTypes["LocaleWithoutSeoDefaultsUpdateInput"];
	["SeoDefaultLocaleUpsertLocaleRelationInput"]: ValueTypes["SeoDefaultLocaleUpsertLocaleRelationInput"];
	["SeoDefaultUpsertLocalesRelationInput"]: ValueTypes["SeoDefaultUpsertLocalesRelationInput"];
	["SeoDefaultLocaleCreateInput"]: ValueTypes["SeoDefaultLocaleCreateInput"];
	["SeoDefaultLocaleUpdateInput"]: ValueTypes["SeoDefaultLocaleUpdateInput"];
	["BusinessPageLocaleCreateInput"]: ValueTypes["BusinessPageLocaleCreateInput"];
	["BusinessPageLocaleUpdateInput"]: ValueTypes["BusinessPageLocaleUpdateInput"];
	["JobPageCreateInput"]: ValueTypes["JobPageCreateInput"];
	["JobPageUpdateInput"]: ValueTypes["JobPageUpdateInput"];
	["JobPageLocaleCreateInput"]: ValueTypes["JobPageLocaleCreateInput"];
	["JobPageLocaleUpdateInput"]: ValueTypes["JobPageLocaleUpdateInput"];
	["KeyInfoItemCreateInput"]: ValueTypes["KeyInfoItemCreateInput"];
	["KeyInfoItemCreateListEntityRelationInput"]: ValueTypes["KeyInfoItemCreateListEntityRelationInput"];
	["KeyInfoListWithoutItemsCreateInput"]: ValueTypes["KeyInfoListWithoutItemsCreateInput"];
	["KeyInfoItemConnectOrCreateListRelationInput"]: ValueTypes["KeyInfoItemConnectOrCreateListRelationInput"];
	["KeyInfoItemUpdateInput"]: ValueTypes["KeyInfoItemUpdateInput"];
	["KeyInfoItemUpdateListEntityRelationInput"]: ValueTypes["KeyInfoItemUpdateListEntityRelationInput"];
	["KeyInfoListWithoutItemsUpdateInput"]: ValueTypes["KeyInfoListWithoutItemsUpdateInput"];
	["KeyInfoItemUpsertListRelationInput"]: ValueTypes["KeyInfoItemUpsertListRelationInput"];
	["ContractTypeLocaleCreateInput"]: ValueTypes["ContractTypeLocaleCreateInput"];
	["ContractTypeLocaleUpdateInput"]: ValueTypes["ContractTypeLocaleUpdateInput"];
	["JobCityLocaleCreateInput"]: ValueTypes["JobCityLocaleCreateInput"];
	["JobCityLocaleUpdateInput"]: ValueTypes["JobCityLocaleUpdateInput"];
	["JobPositionCreateInput"]: ValueTypes["JobPositionCreateInput"];
	["JobPositionUpdateInput"]: ValueTypes["JobPositionUpdateInput"];
	["JobPositionLocaleCreateInput"]: ValueTypes["JobPositionLocaleCreateInput"];
	["JobPositionLocaleUpdateInput"]: ValueTypes["JobPositionLocaleUpdateInput"];
	["HomePageCreateInput"]: ValueTypes["HomePageCreateInput"];
	["HomePageCreateLocalesEntityRelationInput"]: ValueTypes["HomePageCreateLocalesEntityRelationInput"];
	["HomePageLocaleWithoutRootCreateInput"]: ValueTypes["HomePageLocaleWithoutRootCreateInput"];
	["HomePageConnectOrCreateLocalesRelationInput"]: ValueTypes["HomePageConnectOrCreateLocalesRelationInput"];
	["HomePageUpdateInput"]: ValueTypes["HomePageUpdateInput"];
	["HomePageUpdateLocalesEntityRelationInput"]: ValueTypes["HomePageUpdateLocalesEntityRelationInput"];
	["HomePageUpdateLocalesRelationInput"]: ValueTypes["HomePageUpdateLocalesRelationInput"];
	["HomePageLocaleWithoutRootUpdateInput"]: ValueTypes["HomePageLocaleWithoutRootUpdateInput"];
	["HomePageUpsertLocalesRelationInput"]: ValueTypes["HomePageUpsertLocalesRelationInput"];
	["HomePageLocaleCreateInput"]: ValueTypes["HomePageLocaleCreateInput"];
	["HomePageLocaleUpdateInput"]: ValueTypes["HomePageLocaleUpdateInput"];
	["MediumItemCreateInput"]: ValueTypes["MediumItemCreateInput"];
	["MediumItemCreateListEntityRelationInput"]: ValueTypes["MediumItemCreateListEntityRelationInput"];
	["MediumListWithoutItemsCreateInput"]: ValueTypes["MediumListWithoutItemsCreateInput"];
	["MediumItemConnectOrCreateListRelationInput"]: ValueTypes["MediumItemConnectOrCreateListRelationInput"];
	["MediumItemUpdateInput"]: ValueTypes["MediumItemUpdateInput"];
	["MediumItemUpdateListEntityRelationInput"]: ValueTypes["MediumItemUpdateListEntityRelationInput"];
	["MediumListWithoutItemsUpdateInput"]: ValueTypes["MediumListWithoutItemsUpdateInput"];
	["MediumItemUpsertListRelationInput"]: ValueTypes["MediumItemUpsertListRelationInput"];
	["TextItemCreateInput"]: ValueTypes["TextItemCreateInput"];
	["TextItemCreateListEntityRelationInput"]: ValueTypes["TextItemCreateListEntityRelationInput"];
	["TextListWithoutItemsCreateInput"]: ValueTypes["TextListWithoutItemsCreateInput"];
	["TextItemConnectOrCreateListRelationInput"]: ValueTypes["TextItemConnectOrCreateListRelationInput"];
	["TextItemUpdateInput"]: ValueTypes["TextItemUpdateInput"];
	["TextItemUpdateListEntityRelationInput"]: ValueTypes["TextItemUpdateListEntityRelationInput"];
	["TextListWithoutItemsUpdateInput"]: ValueTypes["TextListWithoutItemsUpdateInput"];
	["TextItemUpsertListRelationInput"]: ValueTypes["TextItemUpsertListRelationInput"];
	["CarouselItemCreateInput"]: ValueTypes["CarouselItemCreateInput"];
	["CarouselItemCreateListEntityRelationInput"]: ValueTypes["CarouselItemCreateListEntityRelationInput"];
	["CarouselWithoutItemsCreateInput"]: ValueTypes["CarouselWithoutItemsCreateInput"];
	["CarouselItemConnectOrCreateListRelationInput"]: ValueTypes["CarouselItemConnectOrCreateListRelationInput"];
	["CarouselItemUpdateInput"]: ValueTypes["CarouselItemUpdateInput"];
	["CarouselItemUpdateListEntityRelationInput"]: ValueTypes["CarouselItemUpdateListEntityRelationInput"];
	["CarouselWithoutItemsUpdateInput"]: ValueTypes["CarouselWithoutItemsUpdateInput"];
	["CarouselItemUpsertListRelationInput"]: ValueTypes["CarouselItemUpsertListRelationInput"];
	["BonusBannerCreateInput"]: ValueTypes["BonusBannerCreateInput"];
	["BonusBannerCreateLocalesEntityRelationInput"]: ValueTypes["BonusBannerCreateLocalesEntityRelationInput"];
	["BonusBannerLocaleWithoutRootCreateInput"]: ValueTypes["BonusBannerLocaleWithoutRootCreateInput"];
	["BonusBannerConnectOrCreateLocalesRelationInput"]: ValueTypes["BonusBannerConnectOrCreateLocalesRelationInput"];
	["BonusBannerUpdateInput"]: ValueTypes["BonusBannerUpdateInput"];
	["BonusBannerUpdateLocalesEntityRelationInput"]: ValueTypes["BonusBannerUpdateLocalesEntityRelationInput"];
	["BonusBannerUpdateLocalesRelationInput"]: ValueTypes["BonusBannerUpdateLocalesRelationInput"];
	["BonusBannerLocaleWithoutRootUpdateInput"]: ValueTypes["BonusBannerLocaleWithoutRootUpdateInput"];
	["BonusBannerUpsertLocalesRelationInput"]: ValueTypes["BonusBannerUpsertLocalesRelationInput"];
	["TileCreateInput"]: ValueTypes["TileCreateInput"];
	["TileCreateBonusBannerEntityRelationInput"]: ValueTypes["TileCreateBonusBannerEntityRelationInput"];
	["BonusBannerLocaleWithoutTilesCreateInput"]: ValueTypes["BonusBannerLocaleWithoutTilesCreateInput"];
	["TileConnectOrCreateBonusBannerRelationInput"]: ValueTypes["TileConnectOrCreateBonusBannerRelationInput"];
	["TileUpdateInput"]: ValueTypes["TileUpdateInput"];
	["TileUpdateBonusBannerEntityRelationInput"]: ValueTypes["TileUpdateBonusBannerEntityRelationInput"];
	["BonusBannerLocaleWithoutTilesUpdateInput"]: ValueTypes["BonusBannerLocaleWithoutTilesUpdateInput"];
	["TileUpsertBonusBannerRelationInput"]: ValueTypes["TileUpsertBonusBannerRelationInput"];
	["SideBySideItemCreateInput"]: ValueTypes["SideBySideItemCreateInput"];
	["SideBySideItemCreateListEntityRelationInput"]: ValueTypes["SideBySideItemCreateListEntityRelationInput"];
	["SideBySideWithoutItemsCreateInput"]: ValueTypes["SideBySideWithoutItemsCreateInput"];
	["SideBySideItemConnectOrCreateListRelationInput"]: ValueTypes["SideBySideItemConnectOrCreateListRelationInput"];
	["SideBySideItemUpdateInput"]: ValueTypes["SideBySideItemUpdateInput"];
	["SideBySideItemUpdateListEntityRelationInput"]: ValueTypes["SideBySideItemUpdateListEntityRelationInput"];
	["SideBySideWithoutItemsUpdateInput"]: ValueTypes["SideBySideWithoutItemsUpdateInput"];
	["SideBySideItemUpsertListRelationInput"]: ValueTypes["SideBySideItemUpsertListRelationInput"];
	["HomePageLokalCreateInput"]: ValueTypes["HomePageLokalCreateInput"];
	["HomePageLokalCreateLocalesEntityRelationInput"]: ValueTypes["HomePageLokalCreateLocalesEntityRelationInput"];
	["HomePageLokalLocaleWithoutRootCreateInput"]: ValueTypes["HomePageLokalLocaleWithoutRootCreateInput"];
	["HomePageLokalConnectOrCreateLocalesRelationInput"]: ValueTypes["HomePageLokalConnectOrCreateLocalesRelationInput"];
	["HomePageLokalUpdateInput"]: ValueTypes["HomePageLokalUpdateInput"];
	["HomePageLokalUpdateLocalesEntityRelationInput"]: ValueTypes["HomePageLokalUpdateLocalesEntityRelationInput"];
	["HomePageLokalUpdateLocalesRelationInput"]: ValueTypes["HomePageLokalUpdateLocalesRelationInput"];
	["HomePageLokalLocaleWithoutRootUpdateInput"]: ValueTypes["HomePageLokalLocaleWithoutRootUpdateInput"];
	["HomePageLokalUpsertLocalesRelationInput"]: ValueTypes["HomePageLokalUpsertLocalesRelationInput"];
	["HomePageLokalLocaleCreateInput"]: ValueTypes["HomePageLokalLocaleCreateInput"];
	["HomePageLokalLocaleUpdateInput"]: ValueTypes["HomePageLokalLocaleUpdateInput"];
	["GalleryItemCreateInput"]: ValueTypes["GalleryItemCreateInput"];
	["GalleryItemCreateListEntityRelationInput"]: ValueTypes["GalleryItemCreateListEntityRelationInput"];
	["GalleryWithoutItemsCreateInput"]: ValueTypes["GalleryWithoutItemsCreateInput"];
	["GalleryItemConnectOrCreateListRelationInput"]: ValueTypes["GalleryItemConnectOrCreateListRelationInput"];
	["GalleryItemUpdateInput"]: ValueTypes["GalleryItemUpdateInput"];
	["GalleryItemUpdateListEntityRelationInput"]: ValueTypes["GalleryItemUpdateListEntityRelationInput"];
	["GalleryWithoutItemsUpdateInput"]: ValueTypes["GalleryWithoutItemsUpdateInput"];
	["GalleryItemUpsertListRelationInput"]: ValueTypes["GalleryItemUpsertListRelationInput"];
	["JobsFormCreateInput"]: ValueTypes["JobsFormCreateInput"];
	["JobsFormCreateLocalesEntityRelationInput"]: ValueTypes["JobsFormCreateLocalesEntityRelationInput"];
	["JobsFormLocaleWithoutRootCreateInput"]: ValueTypes["JobsFormLocaleWithoutRootCreateInput"];
	["JobsFormConnectOrCreateLocalesRelationInput"]: ValueTypes["JobsFormConnectOrCreateLocalesRelationInput"];
	["JobsFormUpdateInput"]: ValueTypes["JobsFormUpdateInput"];
	["JobsFormUpdateLocalesEntityRelationInput"]: ValueTypes["JobsFormUpdateLocalesEntityRelationInput"];
	["JobsFormUpdateLocalesRelationInput"]: ValueTypes["JobsFormUpdateLocalesRelationInput"];
	["JobsFormLocaleWithoutRootUpdateInput"]: ValueTypes["JobsFormLocaleWithoutRootUpdateInput"];
	["JobsFormUpsertLocalesRelationInput"]: ValueTypes["JobsFormUpsertLocalesRelationInput"];
	["ImageTextItemCreateInput"]: ValueTypes["ImageTextItemCreateInput"];
	["ImageTextItemCreateListEntityRelationInput"]: ValueTypes["ImageTextItemCreateListEntityRelationInput"];
	["ImageTextListWithoutItemsCreateInput"]: ValueTypes["ImageTextListWithoutItemsCreateInput"];
	["ImageTextItemConnectOrCreateListRelationInput"]: ValueTypes["ImageTextItemConnectOrCreateListRelationInput"];
	["ImageTextItemUpdateInput"]: ValueTypes["ImageTextItemUpdateInput"];
	["ImageTextItemUpdateListEntityRelationInput"]: ValueTypes["ImageTextItemUpdateListEntityRelationInput"];
	["ImageTextListWithoutItemsUpdateInput"]: ValueTypes["ImageTextListWithoutItemsUpdateInput"];
	["ImageTextItemUpsertListRelationInput"]: ValueTypes["ImageTextItemUpsertListRelationInput"];
	["JobsFilterCreateInput"]: ValueTypes["JobsFilterCreateInput"];
	["JobsFilterCreateLocalesEntityRelationInput"]: ValueTypes["JobsFilterCreateLocalesEntityRelationInput"];
	["JobsFilterLocaleWithoutRootCreateInput"]: ValueTypes["JobsFilterLocaleWithoutRootCreateInput"];
	["JobsFilterLocaleCreateLocaleEntityRelationInput"]: ValueTypes["JobsFilterLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutJobsFiltersCreateInput"]: ValueTypes["LocaleWithoutJobsFiltersCreateInput"];
	["JobsFilterLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["JobsFilterLocaleConnectOrCreateLocaleRelationInput"];
	["JobsFilterConnectOrCreateLocalesRelationInput"]: ValueTypes["JobsFilterConnectOrCreateLocalesRelationInput"];
	["JobsFilterUpdateInput"]: ValueTypes["JobsFilterUpdateInput"];
	["JobsFilterUpdateLocalesEntityRelationInput"]: ValueTypes["JobsFilterUpdateLocalesEntityRelationInput"];
	["JobsFilterUpdateLocalesRelationInput"]: ValueTypes["JobsFilterUpdateLocalesRelationInput"];
	["JobsFilterLocaleWithoutRootUpdateInput"]: ValueTypes["JobsFilterLocaleWithoutRootUpdateInput"];
	["JobsFilterLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["JobsFilterLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutJobsFiltersUpdateInput"]: ValueTypes["LocaleWithoutJobsFiltersUpdateInput"];
	["JobsFilterLocaleUpsertLocaleRelationInput"]: ValueTypes["JobsFilterLocaleUpsertLocaleRelationInput"];
	["JobsFilterUpsertLocalesRelationInput"]: ValueTypes["JobsFilterUpsertLocalesRelationInput"];
	["JobsFilterLocaleCreateInput"]: ValueTypes["JobsFilterLocaleCreateInput"];
	["JobsFilterLocaleUpdateInput"]: ValueTypes["JobsFilterLocaleUpdateInput"];
	["FileUniqueWhere"]: ValueTypes["FileUniqueWhere"];
	["FileWhere"]: ValueTypes["FileWhere"];
	["FileOrderBy"]: ValueTypes["FileOrderBy"];
	["FileCreateInput"]: ValueTypes["FileCreateInput"];
	["FileUpdateInput"]: ValueTypes["FileUpdateInput"];
	["JobFormSubscriptionStatusWhere"]: ValueTypes["JobFormSubscriptionStatusWhere"];
	["JobFormSubscriptionUniqueWhere"]: ValueTypes["JobFormSubscriptionUniqueWhere"];
	["JobFormSubscriptionWhere"]: ValueTypes["JobFormSubscriptionWhere"];
	["JobFormSubscriptionOrderBy"]: ValueTypes["JobFormSubscriptionOrderBy"];
	["JobFormSubscriptionStatusOrderBy"]: ValueTypes["JobFormSubscriptionStatusOrderBy"];
	["JobFormSubscriptionCreateInput"]: ValueTypes["JobFormSubscriptionCreateInput"];
	["JobFormSubscriptionCreateFileEntityRelationInput"]: ValueTypes["JobFormSubscriptionCreateFileEntityRelationInput"];
	["JobFormSubscriptionConnectOrCreateFileRelationInput"]: ValueTypes["JobFormSubscriptionConnectOrCreateFileRelationInput"];
	["JobFormSubscriptionCreateJobEntityRelationInput"]: ValueTypes["JobFormSubscriptionCreateJobEntityRelationInput"];
	["JobFormSubscriptionConnectOrCreateJobRelationInput"]: ValueTypes["JobFormSubscriptionConnectOrCreateJobRelationInput"];
	["JobFormSubscriptionCreateStatusEntityRelationInput"]: ValueTypes["JobFormSubscriptionCreateStatusEntityRelationInput"];
	["JobFormSubscriptionStatusUniqueWhere"]: ValueTypes["JobFormSubscriptionStatusUniqueWhere"];
	["JobFormSubscriptionStatusCreateInput"]: ValueTypes["JobFormSubscriptionStatusCreateInput"];
	["JobFormSubscriptionConnectOrCreateStatusRelationInput"]: ValueTypes["JobFormSubscriptionConnectOrCreateStatusRelationInput"];
	["JobFormSubscriptionUpdateInput"]: ValueTypes["JobFormSubscriptionUpdateInput"];
	["JobFormSubscriptionUpdateFileEntityRelationInput"]: ValueTypes["JobFormSubscriptionUpdateFileEntityRelationInput"];
	["JobFormSubscriptionUpsertFileRelationInput"]: ValueTypes["JobFormSubscriptionUpsertFileRelationInput"];
	["JobFormSubscriptionUpdateJobEntityRelationInput"]: ValueTypes["JobFormSubscriptionUpdateJobEntityRelationInput"];
	["JobFormSubscriptionUpsertJobRelationInput"]: ValueTypes["JobFormSubscriptionUpsertJobRelationInput"];
	["JobFormSubscriptionUpdateStatusEntityRelationInput"]: ValueTypes["JobFormSubscriptionUpdateStatusEntityRelationInput"];
	["JobFormSubscriptionStatusUpdateInput"]: ValueTypes["JobFormSubscriptionStatusUpdateInput"];
	["JobFormSubscriptionUpsertStatusRelationInput"]: ValueTypes["JobFormSubscriptionUpsertStatusRelationInput"];
	["ImageListWhere"]: ValueTypes["ImageListWhere"];
	["ImageListItemWhere"]: ValueTypes["ImageListItemWhere"];
	["ImageListItemOrderBy"]: ValueTypes["ImageListItemOrderBy"];
	["ImageListOrderBy"]: ValueTypes["ImageListOrderBy"];
	["ImageListItemsByImageUniqueWhere"]: ValueTypes["ImageListItemsByImageUniqueWhere"];
	["ImageListUniqueWhere"]: ValueTypes["ImageListUniqueWhere"];
	["ImageListItemUniqueWhere"]: ValueTypes["ImageListItemUniqueWhere"];
	["ImageListCreateInput"]: ValueTypes["ImageListCreateInput"];
	["ImageListCreateItemsEntityRelationInput"]: ValueTypes["ImageListCreateItemsEntityRelationInput"];
	["ImageListItemWithoutListCreateInput"]: ValueTypes["ImageListItemWithoutListCreateInput"];
	["ImageListItemCreateImageEntityRelationInput"]: ValueTypes["ImageListItemCreateImageEntityRelationInput"];
	["ImageListItemConnectOrCreateImageRelationInput"]: ValueTypes["ImageListItemConnectOrCreateImageRelationInput"];
	["ImageListConnectOrCreateItemsRelationInput"]: ValueTypes["ImageListConnectOrCreateItemsRelationInput"];
	["ImageListUpdateInput"]: ValueTypes["ImageListUpdateInput"];
	["ImageListUpdateItemsEntityRelationInput"]: ValueTypes["ImageListUpdateItemsEntityRelationInput"];
	["ImageListUpdateItemsRelationInput"]: ValueTypes["ImageListUpdateItemsRelationInput"];
	["ImageListItemWithoutListUpdateInput"]: ValueTypes["ImageListItemWithoutListUpdateInput"];
	["ImageListItemUpdateImageEntityRelationInput"]: ValueTypes["ImageListItemUpdateImageEntityRelationInput"];
	["ImageListItemUpsertImageRelationInput"]: ValueTypes["ImageListItemUpsertImageRelationInput"];
	["ImageListUpsertItemsRelationInput"]: ValueTypes["ImageListUpsertItemsRelationInput"];
	["ImageListItemCreateInput"]: ValueTypes["ImageListItemCreateInput"];
	["ImageListItemCreateListEntityRelationInput"]: ValueTypes["ImageListItemCreateListEntityRelationInput"];
	["ImageListWithoutItemsCreateInput"]: ValueTypes["ImageListWithoutItemsCreateInput"];
	["ImageListItemConnectOrCreateListRelationInput"]: ValueTypes["ImageListItemConnectOrCreateListRelationInput"];
	["ImageListItemUpdateInput"]: ValueTypes["ImageListItemUpdateInput"];
	["ImageListItemUpdateListEntityRelationInput"]: ValueTypes["ImageListItemUpdateListEntityRelationInput"];
	["ImageListWithoutItemsUpdateInput"]: ValueTypes["ImageListWithoutItemsUpdateInput"];
	["ImageListItemUpsertListRelationInput"]: ValueTypes["ImageListItemUpsertListRelationInput"];
	["GeneralLocaleCreateInput"]: ValueTypes["GeneralLocaleCreateInput"];
	["GeneralLocaleUpdateInput"]: ValueTypes["GeneralLocaleUpdateInput"];
	["RecommendationFormCreateInput"]: ValueTypes["RecommendationFormCreateInput"];
	["RecommendationFormCreateLocalesEntityRelationInput"]: ValueTypes["RecommendationFormCreateLocalesEntityRelationInput"];
	["RecommendationFormLocaleWithoutRootCreateInput"]: ValueTypes["RecommendationFormLocaleWithoutRootCreateInput"];
	["RecommendationFormConnectOrCreateLocalesRelationInput"]: ValueTypes["RecommendationFormConnectOrCreateLocalesRelationInput"];
	["RecommendationFormUpdateInput"]: ValueTypes["RecommendationFormUpdateInput"];
	["RecommendationFormUpdateLocalesEntityRelationInput"]: ValueTypes["RecommendationFormUpdateLocalesEntityRelationInput"];
	["RecommendationFormUpdateLocalesRelationInput"]: ValueTypes["RecommendationFormUpdateLocalesRelationInput"];
	["RecommendationFormLocaleWithoutRootUpdateInput"]: ValueTypes["RecommendationFormLocaleWithoutRootUpdateInput"];
	["RecommendationFormUpsertLocalesRelationInput"]: ValueTypes["RecommendationFormUpsertLocalesRelationInput"];
	["RecommendationFormSubscriptionUniqueWhere"]: ValueTypes["RecommendationFormSubscriptionUniqueWhere"];
	["RecommendationFormSubscriptionWhere"]: ValueTypes["RecommendationFormSubscriptionWhere"];
	["RecommendationFormSubscriptionOrderBy"]: ValueTypes["RecommendationFormSubscriptionOrderBy"];
	["RecommendationFormSubscriptionCreateInput"]: ValueTypes["RecommendationFormSubscriptionCreateInput"];
	["RecommendationFormSubscriptionUpdateInput"]: ValueTypes["RecommendationFormSubscriptionUpdateInput"];
	["InfoBoxLocaleCreateInput"]: ValueTypes["InfoBoxLocaleCreateInput"];
	["InfoBoxLocaleUpdateInput"]: ValueTypes["InfoBoxLocaleUpdateInput"];
	["TranslationCreateInput"]: ValueTypes["TranslationCreateInput"];
	["TranslationCreateLocalesEntityRelationInput"]: ValueTypes["TranslationCreateLocalesEntityRelationInput"];
	["TranslationLocaleWithoutRootCreateInput"]: ValueTypes["TranslationLocaleWithoutRootCreateInput"];
	["TranslationLocaleCreateLocaleEntityRelationInput"]: ValueTypes["TranslationLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutTranslationsCreateInput"]: ValueTypes["LocaleWithoutTranslationsCreateInput"];
	["TranslationLocaleConnectOrCreateLocaleRelationInput"]: ValueTypes["TranslationLocaleConnectOrCreateLocaleRelationInput"];
	["TranslationConnectOrCreateLocalesRelationInput"]: ValueTypes["TranslationConnectOrCreateLocalesRelationInput"];
	["TranslationUpdateInput"]: ValueTypes["TranslationUpdateInput"];
	["TranslationUpdateLocalesEntityRelationInput"]: ValueTypes["TranslationUpdateLocalesEntityRelationInput"];
	["TranslationUpdateLocalesRelationInput"]: ValueTypes["TranslationUpdateLocalesRelationInput"];
	["TranslationLocaleWithoutRootUpdateInput"]: ValueTypes["TranslationLocaleWithoutRootUpdateInput"];
	["TranslationLocaleUpdateLocaleEntityRelationInput"]: ValueTypes["TranslationLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutTranslationsUpdateInput"]: ValueTypes["LocaleWithoutTranslationsUpdateInput"];
	["TranslationLocaleUpsertLocaleRelationInput"]: ValueTypes["TranslationLocaleUpsertLocaleRelationInput"];
	["TranslationUpsertLocalesRelationInput"]: ValueTypes["TranslationUpsertLocalesRelationInput"];
	["TranslationLocaleCreateInput"]: ValueTypes["TranslationLocaleCreateInput"];
	["TranslationLocaleUpdateInput"]: ValueTypes["TranslationLocaleUpdateInput"];
	["S3GenerateSignedUploadInput"]: ValueTypes["S3GenerateSignedUploadInput"];
	["S33ContentDisposition"]: ValueTypes["S33ContentDisposition"];
	["S3Acl"]: ValueTypes["S3Acl"];
	["_MutationErrorType"]: ValueTypes["_MutationErrorType"];
	["MutationTransactionOptions"]: ValueTypes["MutationTransactionOptions"];
}